import * as React$1 from "react";
import React__default, { isValidElement, PureComponent, Component, forwardRef, useContext, useEffect as useEffect$1, createElement as createElement$1, createContext as createContext$1, useState as useState$1, useRef, Fragment, useCallback, useLayoutEffect, Children, cloneElement, useMemo, useReducer, lazy, Suspense, memo } from "react";
import * as IconsMaterial from "@mui/icons-material";
import { Add, AccessTime, ArrowDropDown, ArrowDropUp, CalendarMonth, Check, ArrowLeft, ArrowRight, EditOutlined, DeleteOutlined, Clear, InfoOutlined, Badge, BadgeOutlined, Business, CancelOutlined, CancelRounded, CheckCircleRounded, CheckOutlined, VisibilityOff, Visibility, StickyNote2Rounded, SearchRounded, RefreshOutlined, PersonAddAlt, MapOutlined, LocalShippingOutlined, LocalShipping, KeyboardArrowRight, KeyboardArrowDown, Inventory2Outlined, ChevronRight, Circle as Circle$2, CloseOutlined, Close as Close$1, Inventory, InsertInvitation, GroupAddOutlined, GroupAdd, FolderOutlined, FolderOpen, Folder, FlagOutlined, FileDownloadOutlined, ColorLensOutlined, DashboardCustomize, FavoriteOutlined, FavoriteBorderOutlined, Event as Event$1, Error as Error$1, Edit, DownloadForOfflineOutlined, DeleteRounded, Delete, DashboardCustomizeOutlined, ChevronLeftRounded, ChevronRightRounded, FirstPageRounded, LastPageRounded, ArrowBack, Login, LocationOn } from "@mui/icons-material";
import defaultDayjs from "dayjs";
import { useFormik } from "formik";
import { debounce as debounce$6, isEqual as isEqual$2, isNil, find as find$2, get as get$6, isEmpty as isEmpty$4, mergeWith as mergeWith$2, isArray as isArray$m, union, omit, keys as keys$8, random, set as set$1 } from "lodash";
import { FormattedMessage, useIntl, IntlProvider } from "react-intl";
import emStyled from "@emotion/styled";
import * as Mui from "@mui/material";
import { CacheProvider, Global as Global$1, ThemeContext as ThemeContext$2, css as css$1, keyframes as keyframes$1 } from "@emotion/react";
import { DataGridPro, GridFooterContainer, GridToolbarColumnsButton, GRID_CHECKBOX_SELECTION_COL_DEF, GRID_DETAIL_PANEL_TOGGLE_COL_DEF, useGridApiContext } from "@mui/x-data-grid-pro";
import { DateRangePicker, MobileDateTimePicker, DesktopDateTimePicker } from "@mui/x-date-pickers-pro";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { flushSync } from "react-dom";
import { QueryClient, QueryClientProvider, useQueryClient as useQueryClient$1 } from "@tanstack/react-query";
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(T) {
  return T && T.__esModule && Object.prototype.hasOwnProperty.call(T, "default") ? T.default : T;
}
function getAugmentedNamespace(T) {
  if (T.__esModule) return T;
  var S = T.default;
  if (typeof S == "function") {
    var R = function k() {
      return this instanceof k ? Reflect.construct(S, arguments, this.constructor) : S.apply(this, arguments);
    };
    R.prototype = S.prototype;
  } else R = {};
  return Object.defineProperty(R, "__esModule", {
    value: !0
  }), Object.keys(T).forEach(function(k) {
    var D = Object.getOwnPropertyDescriptor(T, k);
    Object.defineProperty(R, k, D.get ? D : {
      enumerable: !0,
      get: function() {
        return T[k];
      }
    });
  }), R;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production_min = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  var T = React__default, S = Symbol.for("react.element"), R = Symbol.for("react.fragment"), k = Object.prototype.hasOwnProperty, D = T.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, L = { key: !0, ref: !0, __self: !0, __source: !0 };
  function V(z, W, U) {
    var q, K = {}, Y = null, J = null;
    U !== void 0 && (Y = "" + U), W.key !== void 0 && (Y = "" + W.key), W.ref !== void 0 && (J = W.ref);
    for (q in W) k.call(W, q) && !L.hasOwnProperty(q) && (K[q] = W[q]);
    if (z && z.defaultProps) for (q in W = z.defaultProps, W) K[q] === void 0 && (K[q] = W[q]);
    return { $$typeof: S, type: z, key: Y, ref: J, props: K, _owner: D.current };
  }
  return reactJsxRuntime_production_min.Fragment = R, reactJsxRuntime_production_min.jsx = V, reactJsxRuntime_production_min.jsxs = V, reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {}, hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  var T = {};
  /**
   * @license React
   * react-jsx-runtime.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return T.NODE_ENV !== "production" && function() {
    var S = React__default, R = Symbol.for("react.element"), k = Symbol.for("react.portal"), D = Symbol.for("react.fragment"), L = Symbol.for("react.strict_mode"), V = Symbol.for("react.profiler"), z = Symbol.for("react.provider"), W = Symbol.for("react.context"), U = Symbol.for("react.forward_ref"), q = Symbol.for("react.suspense"), K = Symbol.for("react.suspense_list"), Y = Symbol.for("react.memo"), J = Symbol.for("react.lazy"), Z = Symbol.for("react.offscreen"), X = Symbol.iterator, ee = "@@iterator";
    function te(Ve) {
      if (Ve === null || typeof Ve != "object")
        return null;
      var rt = X && Ve[X] || Ve[ee];
      return typeof rt == "function" ? rt : null;
    }
    var re = S.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function Q(Ve) {
      {
        for (var rt = arguments.length, ot = new Array(rt > 1 ? rt - 1 : 0), pt = 1; pt < rt; pt++)
          ot[pt - 1] = arguments[pt];
        ne("error", Ve, ot);
      }
    }
    function ne(Ve, rt, ot) {
      {
        var pt = re.ReactDebugCurrentFrame, yt = pt.getStackAddendum();
        yt !== "" && (rt += "%s", ot = ot.concat([yt]));
        var Ct = ot.map(function(ht) {
          return String(ht);
        });
        Ct.unshift("Warning: " + rt), Function.prototype.apply.call(console[Ve], console, Ct);
      }
    }
    var oe = !1, ae = !1, se = !1, ie = !1, he = !1, xe;
    xe = Symbol.for("react.module.reference");
    function Pe(Ve) {
      return !!(typeof Ve == "string" || typeof Ve == "function" || Ve === D || Ve === V || he || Ve === L || Ve === q || Ve === K || ie || Ve === Z || oe || ae || se || typeof Ve == "object" && Ve !== null && (Ve.$$typeof === J || Ve.$$typeof === Y || Ve.$$typeof === z || Ve.$$typeof === W || Ve.$$typeof === U || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Ve.$$typeof === xe || Ve.getModuleId !== void 0));
    }
    function Re(Ve, rt, ot) {
      var pt = Ve.displayName;
      if (pt)
        return pt;
      var yt = rt.displayName || rt.name || "";
      return yt !== "" ? ot + "(" + yt + ")" : ot;
    }
    function ke(Ve) {
      return Ve.displayName || "Context";
    }
    function Te(Ve) {
      if (Ve == null)
        return null;
      if (typeof Ve.tag == "number" && Q("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof Ve == "function")
        return Ve.displayName || Ve.name || null;
      if (typeof Ve == "string")
        return Ve;
      switch (Ve) {
        case D:
          return "Fragment";
        case k:
          return "Portal";
        case V:
          return "Profiler";
        case L:
          return "StrictMode";
        case q:
          return "Suspense";
        case K:
          return "SuspenseList";
      }
      if (typeof Ve == "object")
        switch (Ve.$$typeof) {
          case W:
            var rt = Ve;
            return ke(rt) + ".Consumer";
          case z:
            var ot = Ve;
            return ke(ot._context) + ".Provider";
          case U:
            return Re(Ve, Ve.render, "ForwardRef");
          case Y:
            var pt = Ve.displayName || null;
            return pt !== null ? pt : Te(Ve.type) || "Memo";
          case J: {
            var yt = Ve, Ct = yt._payload, ht = yt._init;
            try {
              return Te(ht(Ct));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var fe = Object.assign, ue = 0, Ce, ce, pe, _e, ge, Ae, Ee;
    function ve() {
    }
    ve.__reactDisabledLog = !0;
    function le() {
      {
        if (ue === 0) {
          Ce = console.log, ce = console.info, pe = console.warn, _e = console.error, ge = console.group, Ae = console.groupCollapsed, Ee = console.groupEnd;
          var Ve = {
            configurable: !0,
            enumerable: !0,
            value: ve,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Ve,
            log: Ve,
            warn: Ve,
            error: Ve,
            group: Ve,
            groupCollapsed: Ve,
            groupEnd: Ve
          });
        }
        ue++;
      }
    }
    function me() {
      {
        if (ue--, ue === 0) {
          var Ve = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: fe({}, Ve, {
              value: Ce
            }),
            info: fe({}, Ve, {
              value: ce
            }),
            warn: fe({}, Ve, {
              value: pe
            }),
            error: fe({}, Ve, {
              value: _e
            }),
            group: fe({}, Ve, {
              value: ge
            }),
            groupCollapsed: fe({}, Ve, {
              value: Ae
            }),
            groupEnd: fe({}, Ve, {
              value: Ee
            })
          });
        }
        ue < 0 && Q("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Se = re.ReactCurrentDispatcher, ye;
    function be(Ve, rt, ot) {
      {
        if (ye === void 0)
          try {
            throw Error();
          } catch (yt) {
            var pt = yt.stack.trim().match(/\n( *(at )?)/);
            ye = pt && pt[1] || "";
          }
        return `
` + ye + Ve;
      }
    }
    var $e = !1, Oe;
    {
      var Ie = typeof WeakMap == "function" ? WeakMap : Map;
      Oe = new Ie();
    }
    function we(Ve, rt) {
      if (!Ve || $e)
        return "";
      {
        var ot = Oe.get(Ve);
        if (ot !== void 0)
          return ot;
      }
      var pt;
      $e = !0;
      var yt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ct;
      Ct = Se.current, Se.current = null, le();
      try {
        if (rt) {
          var ht = function() {
            throw Error();
          };
          if (Object.defineProperty(ht.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ht, []);
            } catch (ct) {
              pt = ct;
            }
            Reflect.construct(Ve, [], ht);
          } else {
            try {
              ht.call();
            } catch (ct) {
              pt = ct;
            }
            Ve.call(ht.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ct) {
            pt = ct;
          }
          Ve();
        }
      } catch (ct) {
        if (ct && pt && typeof ct.stack == "string") {
          for (var gt = ct.stack.split(`
`), je = pt.stack.split(`
`), Ue = gt.length - 1, Je = je.length - 1; Ue >= 1 && Je >= 0 && gt[Ue] !== je[Je]; )
            Je--;
          for (; Ue >= 1 && Je >= 0; Ue--, Je--)
            if (gt[Ue] !== je[Je]) {
              if (Ue !== 1 || Je !== 1)
                do
                  if (Ue--, Je--, Je < 0 || gt[Ue] !== je[Je]) {
                    var et = `
` + gt[Ue].replace(" at new ", " at ");
                    return Ve.displayName && et.includes("<anonymous>") && (et = et.replace("<anonymous>", Ve.displayName)), typeof Ve == "function" && Oe.set(Ve, et), et;
                  }
                while (Ue >= 1 && Je >= 0);
              break;
            }
        }
      } finally {
        $e = !1, Se.current = Ct, me(), Error.prepareStackTrace = yt;
      }
      var lt = Ve ? Ve.displayName || Ve.name : "", st = lt ? be(lt) : "";
      return typeof Ve == "function" && Oe.set(Ve, st), st;
    }
    function Fe(Ve, rt, ot) {
      return we(Ve, !1);
    }
    function De(Ve) {
      var rt = Ve.prototype;
      return !!(rt && rt.isReactComponent);
    }
    function Le(Ve, rt, ot) {
      if (Ve == null)
        return "";
      if (typeof Ve == "function")
        return we(Ve, De(Ve));
      if (typeof Ve == "string")
        return be(Ve);
      switch (Ve) {
        case q:
          return be("Suspense");
        case K:
          return be("SuspenseList");
      }
      if (typeof Ve == "object")
        switch (Ve.$$typeof) {
          case U:
            return Fe(Ve.render);
          case Y:
            return Le(Ve.type, rt, ot);
          case J: {
            var pt = Ve, yt = pt._payload, Ct = pt._init;
            try {
              return Le(Ct(yt), rt, ot);
            } catch {
            }
          }
        }
      return "";
    }
    var ze = Object.prototype.hasOwnProperty, We = {}, Be = re.ReactDebugCurrentFrame;
    function Ye(Ve) {
      if (Ve) {
        var rt = Ve._owner, ot = Le(Ve.type, Ve._source, rt ? rt.type : null);
        Be.setExtraStackFrame(ot);
      } else
        Be.setExtraStackFrame(null);
    }
    function Ge(Ve, rt, ot, pt, yt) {
      {
        var Ct = Function.call.bind(ze);
        for (var ht in Ve)
          if (Ct(Ve, ht)) {
            var gt = void 0;
            try {
              if (typeof Ve[ht] != "function") {
                var je = Error((pt || "React class") + ": " + ot + " type `" + ht + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Ve[ht] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw je.name = "Invariant Violation", je;
              }
              gt = Ve[ht](rt, ht, pt, ot, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ue) {
              gt = Ue;
            }
            gt && !(gt instanceof Error) && (Ye(yt), Q("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", pt || "React class", ot, ht, typeof gt), Ye(null)), gt instanceof Error && !(gt.message in We) && (We[gt.message] = !0, Ye(yt), Q("Failed %s type: %s", ot, gt.message), Ye(null));
          }
      }
    }
    var nt = Array.isArray;
    function Ze(Ve) {
      return nt(Ve);
    }
    function Me(Ve) {
      {
        var rt = typeof Symbol == "function" && Symbol.toStringTag, ot = rt && Ve[Symbol.toStringTag] || Ve.constructor.name || "Object";
        return ot;
      }
    }
    function Ne(Ve) {
      try {
        return He(Ve), !1;
      } catch {
        return !0;
      }
    }
    function He(Ve) {
      return "" + Ve;
    }
    function qe(Ve) {
      if (Ne(Ve))
        return Q("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Me(Ve)), He(Ve);
    }
    var Ke = re.ReactCurrentOwner, Xe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, tt, at, it;
    it = {};
    function mt(Ve) {
      if (ze.call(Ve, "ref")) {
        var rt = Object.getOwnPropertyDescriptor(Ve, "ref").get;
        if (rt && rt.isReactWarning)
          return !1;
      }
      return Ve.ref !== void 0;
    }
    function Qe(Ve) {
      if (ze.call(Ve, "key")) {
        var rt = Object.getOwnPropertyDescriptor(Ve, "key").get;
        if (rt && rt.isReactWarning)
          return !1;
      }
      return Ve.key !== void 0;
    }
    function ut(Ve, rt) {
      if (typeof Ve.ref == "string" && Ke.current && rt && Ke.current.stateNode !== rt) {
        var ot = Te(Ke.current.type);
        it[ot] || (Q('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Te(Ke.current.type), Ve.ref), it[ot] = !0);
      }
    }
    function ft(Ve, rt) {
      {
        var ot = function() {
          tt || (tt = !0, Q("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", rt));
        };
        ot.isReactWarning = !0, Object.defineProperty(Ve, "key", {
          get: ot,
          configurable: !0
        });
      }
    }
    function vt(Ve, rt) {
      {
        var ot = function() {
          at || (at = !0, Q("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", rt));
        };
        ot.isReactWarning = !0, Object.defineProperty(Ve, "ref", {
          get: ot,
          configurable: !0
        });
      }
    }
    var dt = function(Ve, rt, ot, pt, yt, Ct, ht) {
      var gt = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: R,
        // Built-in properties that belong on the element
        type: Ve,
        key: rt,
        ref: ot,
        props: ht,
        // Record the component responsible for creating this element.
        _owner: Ct
      };
      return gt._store = {}, Object.defineProperty(gt._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(gt, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: pt
      }), Object.defineProperty(gt, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: yt
      }), Object.freeze && (Object.freeze(gt.props), Object.freeze(gt)), gt;
    };
    function xt(Ve, rt, ot, pt, yt) {
      {
        var Ct, ht = {}, gt = null, je = null;
        ot !== void 0 && (qe(ot), gt = "" + ot), Qe(rt) && (qe(rt.key), gt = "" + rt.key), mt(rt) && (je = rt.ref, ut(rt, yt));
        for (Ct in rt)
          ze.call(rt, Ct) && !Xe.hasOwnProperty(Ct) && (ht[Ct] = rt[Ct]);
        if (Ve && Ve.defaultProps) {
          var Ue = Ve.defaultProps;
          for (Ct in Ue)
            ht[Ct] === void 0 && (ht[Ct] = Ue[Ct]);
        }
        if (gt || je) {
          var Je = typeof Ve == "function" ? Ve.displayName || Ve.name || "Unknown" : Ve;
          gt && ft(ht, Je), je && vt(ht, Je);
        }
        return dt(Ve, gt, je, yt, pt, Ke.current, ht);
      }
    }
    var Ot = re.ReactCurrentOwner, Rt = re.ReactDebugCurrentFrame;
    function Et(Ve) {
      if (Ve) {
        var rt = Ve._owner, ot = Le(Ve.type, Ve._source, rt ? rt.type : null);
        Rt.setExtraStackFrame(ot);
      } else
        Rt.setExtraStackFrame(null);
    }
    var Mt;
    Mt = !1;
    function Nt(Ve) {
      return typeof Ve == "object" && Ve !== null && Ve.$$typeof === R;
    }
    function jt() {
      {
        if (Ot.current) {
          var Ve = Te(Ot.current.type);
          if (Ve)
            return `

Check the render method of \`` + Ve + "`.";
        }
        return "";
      }
    }
    function Ft(Ve) {
      return "";
    }
    var Gt = {};
    function Vt(Ve) {
      {
        var rt = jt();
        if (!rt) {
          var ot = typeof Ve == "string" ? Ve : Ve.displayName || Ve.name;
          ot && (rt = `

Check the top-level render call using <` + ot + ">.");
        }
        return rt;
      }
    }
    function rr(Ve, rt) {
      {
        if (!Ve._store || Ve._store.validated || Ve.key != null)
          return;
        Ve._store.validated = !0;
        var ot = Vt(rt);
        if (Gt[ot])
          return;
        Gt[ot] = !0;
        var pt = "";
        Ve && Ve._owner && Ve._owner !== Ot.current && (pt = " It was passed a child from " + Te(Ve._owner.type) + "."), Et(Ve), Q('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ot, pt), Et(null);
      }
    }
    function nr(Ve, rt) {
      {
        if (typeof Ve != "object")
          return;
        if (Ze(Ve))
          for (var ot = 0; ot < Ve.length; ot++) {
            var pt = Ve[ot];
            Nt(pt) && rr(pt, rt);
          }
        else if (Nt(Ve))
          Ve._store && (Ve._store.validated = !0);
        else if (Ve) {
          var yt = te(Ve);
          if (typeof yt == "function" && yt !== Ve.entries)
            for (var Ct = yt.call(Ve), ht; !(ht = Ct.next()).done; )
              Nt(ht.value) && rr(ht.value, rt);
        }
      }
    }
    function yr(Ve) {
      {
        var rt = Ve.type;
        if (rt == null || typeof rt == "string")
          return;
        var ot;
        if (typeof rt == "function")
          ot = rt.propTypes;
        else if (typeof rt == "object" && (rt.$$typeof === U || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        rt.$$typeof === Y))
          ot = rt.propTypes;
        else
          return;
        if (ot) {
          var pt = Te(rt);
          Ge(ot, Ve.props, "prop", pt, Ve);
        } else if (rt.PropTypes !== void 0 && !Mt) {
          Mt = !0;
          var yt = Te(rt);
          Q("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", yt || "Unknown");
        }
        typeof rt.getDefaultProps == "function" && !rt.getDefaultProps.isReactClassApproved && Q("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Zt(Ve) {
      {
        for (var rt = Object.keys(Ve.props), ot = 0; ot < rt.length; ot++) {
          var pt = rt[ot];
          if (pt !== "children" && pt !== "key") {
            Et(Ve), Q("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", pt), Et(null);
            break;
          }
        }
        Ve.ref !== null && (Et(Ve), Q("Invalid attribute `ref` supplied to `React.Fragment`."), Et(null));
      }
    }
    var zt = {};
    function Qt(Ve, rt, ot, pt, yt, Ct) {
      {
        var ht = Pe(Ve);
        if (!ht) {
          var gt = "";
          (Ve === void 0 || typeof Ve == "object" && Ve !== null && Object.keys(Ve).length === 0) && (gt += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var je = Ft();
          je ? gt += je : gt += jt();
          var Ue;
          Ve === null ? Ue = "null" : Ze(Ve) ? Ue = "array" : Ve !== void 0 && Ve.$$typeof === R ? (Ue = "<" + (Te(Ve.type) || "Unknown") + " />", gt = " Did you accidentally export a JSX literal instead of a component?") : Ue = typeof Ve, Q("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ue, gt);
        }
        var Je = xt(Ve, rt, ot, yt, Ct);
        if (Je == null)
          return Je;
        if (ht) {
          var et = rt.children;
          if (et !== void 0)
            if (pt)
              if (Ze(et)) {
                for (var lt = 0; lt < et.length; lt++)
                  nr(et[lt], Ve);
                Object.freeze && Object.freeze(et);
              } else
                Q("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              nr(et, Ve);
        }
        if (ze.call(rt, "key")) {
          var st = Te(Ve), ct = Object.keys(rt).filter(function($t) {
            return $t !== "key";
          }), Tt = ct.length > 0 ? "{key: someKey, " + ct.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!zt[st + Tt]) {
            var St = ct.length > 0 ? "{" + ct.join(": ..., ") + ": ...}" : "{}";
            Q(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Tt, st, St, st), zt[st + Tt] = !0;
          }
        }
        return Ve === D ? Zt(Je) : yr(Je), Je;
      }
    }
    function sr(Ve, rt, ot) {
      return Qt(Ve, rt, ot, !0);
    }
    function ir(Ve, rt, ot) {
      return Qt(Ve, rt, ot, !1);
    }
    var Wt = ir, or = sr;
    reactJsxRuntime_development.Fragment = D, reactJsxRuntime_development.jsx = Wt, reactJsxRuntime_development.jsxs = or;
  }(), reactJsxRuntime_development;
}
var define_process_env_default$1W = {};
define_process_env_default$1W.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production_min() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports, r$1 = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, t = function(T) {
  return typeof T == "string" ? T.length > 0 : typeof T == "number";
}, n = function(T, S, R) {
  return S === void 0 && (S = 0), R === void 0 && (R = Math.pow(10, S)), Math.round(R * T) / R + 0;
}, e = function(T, S, R) {
  return S === void 0 && (S = 0), R === void 0 && (R = 1), T > R ? R : T > S ? T : S;
}, u$1 = function(T) {
  return (T = isFinite(T) ? T % 360 : 0) > 0 ? T : T + 360;
}, a = function(T) {
  return { r: e(T.r, 0, 255), g: e(T.g, 0, 255), b: e(T.b, 0, 255), a: e(T.a) };
}, o = function(T) {
  return { r: n(T.r), g: n(T.g), b: n(T.b), a: n(T.a, 3) };
}, i = /^#([0-9a-f]{3,8})$/i, s = function(T) {
  var S = T.toString(16);
  return S.length < 2 ? "0" + S : S;
}, h$2 = function(T) {
  var S = T.r, R = T.g, k = T.b, D = T.a, L = Math.max(S, R, k), V = L - Math.min(S, R, k), z = V ? L === S ? (R - k) / V : L === R ? 2 + (k - S) / V : 4 + (S - R) / V : 0;
  return { h: 60 * (z < 0 ? z + 6 : z), s: L ? V / L * 100 : 0, v: L / 255 * 100, a: D };
}, b = function(T) {
  var S = T.h, R = T.s, k = T.v, D = T.a;
  S = S / 360 * 6, R /= 100, k /= 100;
  var L = Math.floor(S), V = k * (1 - R), z = k * (1 - (S - L) * R), W = k * (1 - (1 - S + L) * R), U = L % 6;
  return { r: 255 * [k, z, V, V, W, k][U], g: 255 * [W, k, k, z, V, V][U], b: 255 * [V, V, W, k, k, z][U], a: D };
}, g$2 = function(T) {
  return { h: u$1(T.h), s: e(T.s, 0, 100), l: e(T.l, 0, 100), a: e(T.a) };
}, d = function(T) {
  return { h: n(T.h), s: n(T.s), l: n(T.l), a: n(T.a, 3) };
}, f = function(T) {
  return b((R = (S = T).s, { h: S.h, s: (R *= ((k = S.l) < 50 ? k : 100 - k) / 100) > 0 ? 2 * R / (k + R) * 100 : 0, v: k + R, a: S.a }));
  var S, R, k;
}, c = function(T) {
  return { h: (S = h$2(T)).h, s: (D = (200 - (R = S.s)) * (k = S.v) / 100) > 0 && D < 200 ? R * k / 100 / (D <= 100 ? D : 200 - D) * 100 : 0, l: D / 2, a: S.a };
  var S, R, k, D;
}, l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, v$2 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, m$1 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, y = { string: [[function(T) {
  var S = i.exec(T);
  return S ? (T = S[1]).length <= 4 ? { r: parseInt(T[0] + T[0], 16), g: parseInt(T[1] + T[1], 16), b: parseInt(T[2] + T[2], 16), a: T.length === 4 ? n(parseInt(T[3] + T[3], 16) / 255, 2) : 1 } : T.length === 6 || T.length === 8 ? { r: parseInt(T.substr(0, 2), 16), g: parseInt(T.substr(2, 2), 16), b: parseInt(T.substr(4, 2), 16), a: T.length === 8 ? n(parseInt(T.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(T) {
  var S = v$2.exec(T) || m$1.exec(T);
  return S ? S[2] !== S[4] || S[4] !== S[6] ? null : a({ r: Number(S[1]) / (S[2] ? 100 / 255 : 1), g: Number(S[3]) / (S[4] ? 100 / 255 : 1), b: Number(S[5]) / (S[6] ? 100 / 255 : 1), a: S[7] === void 0 ? 1 : Number(S[7]) / (S[8] ? 100 : 1) }) : null;
}, "rgb"], [function(T) {
  var S = l.exec(T) || p.exec(T);
  if (!S) return null;
  var R, k, D = g$2({ h: (R = S[1], k = S[2], k === void 0 && (k = "deg"), Number(R) * (r$1[k] || 1)), s: Number(S[3]), l: Number(S[4]), a: S[5] === void 0 ? 1 : Number(S[5]) / (S[6] ? 100 : 1) });
  return f(D);
}, "hsl"]], object: [[function(T) {
  var S = T.r, R = T.g, k = T.b, D = T.a, L = D === void 0 ? 1 : D;
  return t(S) && t(R) && t(k) ? a({ r: Number(S), g: Number(R), b: Number(k), a: Number(L) }) : null;
}, "rgb"], [function(T) {
  var S = T.h, R = T.s, k = T.l, D = T.a, L = D === void 0 ? 1 : D;
  if (!t(S) || !t(R) || !t(k)) return null;
  var V = g$2({ h: Number(S), s: Number(R), l: Number(k), a: Number(L) });
  return f(V);
}, "hsl"], [function(T) {
  var S = T.h, R = T.s, k = T.v, D = T.a, L = D === void 0 ? 1 : D;
  if (!t(S) || !t(R) || !t(k)) return null;
  var V = function(z) {
    return { h: u$1(z.h), s: e(z.s, 0, 100), v: e(z.v, 0, 100), a: e(z.a) };
  }({ h: Number(S), s: Number(R), v: Number(k), a: Number(L) });
  return b(V);
}, "hsv"]] }, N = function(T, S) {
  for (var R = 0; R < S.length; R++) {
    var k = S[R][0](T);
    if (k) return [k, S[R][1]];
  }
  return [null, void 0];
}, x$1 = function(T) {
  return typeof T == "string" ? N(T.trim(), y.string) : typeof T == "object" && T !== null ? N(T, y.object) : [null, void 0];
}, M = function(T, S) {
  var R = c(T);
  return { h: R.h, s: e(R.s + 100 * S, 0, 100), l: R.l, a: R.a };
}, H = function(T) {
  return (299 * T.r + 587 * T.g + 114 * T.b) / 1e3 / 255;
}, $ = function(T, S) {
  var R = c(T);
  return { h: R.h, s: R.s, l: e(R.l + 100 * S, 0, 100), a: R.a };
}, j = function() {
  function T(S) {
    this.parsed = x$1(S)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return T.prototype.isValid = function() {
    return this.parsed !== null;
  }, T.prototype.brightness = function() {
    return n(H(this.rgba), 2);
  }, T.prototype.isDark = function() {
    return H(this.rgba) < 0.5;
  }, T.prototype.isLight = function() {
    return H(this.rgba) >= 0.5;
  }, T.prototype.toHex = function() {
    return S = o(this.rgba), R = S.r, k = S.g, D = S.b, V = (L = S.a) < 1 ? s(n(255 * L)) : "", "#" + s(R) + s(k) + s(D) + V;
    var S, R, k, D, L, V;
  }, T.prototype.toRgb = function() {
    return o(this.rgba);
  }, T.prototype.toRgbString = function() {
    return S = o(this.rgba), R = S.r, k = S.g, D = S.b, (L = S.a) < 1 ? "rgba(" + R + ", " + k + ", " + D + ", " + L + ")" : "rgb(" + R + ", " + k + ", " + D + ")";
    var S, R, k, D, L;
  }, T.prototype.toHsl = function() {
    return d(c(this.rgba));
  }, T.prototype.toHslString = function() {
    return S = d(c(this.rgba)), R = S.h, k = S.s, D = S.l, (L = S.a) < 1 ? "hsla(" + R + ", " + k + "%, " + D + "%, " + L + ")" : "hsl(" + R + ", " + k + "%, " + D + "%)";
    var S, R, k, D, L;
  }, T.prototype.toHsv = function() {
    return S = h$2(this.rgba), { h: n(S.h), s: n(S.s), v: n(S.v), a: n(S.a, 3) };
    var S;
  }, T.prototype.invert = function() {
    return w$2({ r: 255 - (S = this.rgba).r, g: 255 - S.g, b: 255 - S.b, a: S.a });
    var S;
  }, T.prototype.saturate = function(S) {
    return S === void 0 && (S = 0.1), w$2(M(this.rgba, S));
  }, T.prototype.desaturate = function(S) {
    return S === void 0 && (S = 0.1), w$2(M(this.rgba, -S));
  }, T.prototype.grayscale = function() {
    return w$2(M(this.rgba, -1));
  }, T.prototype.lighten = function(S) {
    return S === void 0 && (S = 0.1), w$2($(this.rgba, S));
  }, T.prototype.darken = function(S) {
    return S === void 0 && (S = 0.1), w$2($(this.rgba, -S));
  }, T.prototype.rotate = function(S) {
    return S === void 0 && (S = 15), this.hue(this.hue() + S);
  }, T.prototype.alpha = function(S) {
    return typeof S == "number" ? w$2({ r: (R = this.rgba).r, g: R.g, b: R.b, a: S }) : n(this.rgba.a, 3);
    var R;
  }, T.prototype.hue = function(S) {
    var R = c(this.rgba);
    return typeof S == "number" ? w$2({ h: S, s: R.s, l: R.l, a: R.a }) : n(R.h);
  }, T.prototype.isEqual = function(S) {
    return this.toHex() === w$2(S).toHex();
  }, T;
}(), w$2 = function(T) {
  return T instanceof j ? T : new j(T);
}, de$1 = { exports: {} };
(function(T, S) {
  (function(R, k) {
    T.exports = k(defaultDayjs);
  })(commonjsGlobal, function(R) {
    function k(W) {
      return W && typeof W == "object" && "default" in W ? W : { default: W };
    }
    var D = k(R), L = { s: "ein paar Sekunden", m: ["eine Minute", "einer Minute"], mm: "%d Minuten", h: ["eine Stunde", "einer Stunde"], hh: "%d Stunden", d: ["ein Tag", "einem Tag"], dd: ["%d Tage", "%d Tagen"], M: ["ein Monat", "einem Monat"], MM: ["%d Monate", "%d Monaten"], y: ["ein Jahr", "einem Jahr"], yy: ["%d Jahre", "%d Jahren"] };
    function V(W, U, q) {
      var K = L[q];
      return Array.isArray(K) && (K = K[U ? 0 : 1]), K.replace("%d", W);
    }
    var z = { name: "de", weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"), weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"), weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"), months: "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"), monthsShort: "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.".split("_"), ordinal: function(W) {
      return W + ".";
    }, weekStart: 1, yearStart: 4, formats: { LTS: "HH:mm:ss", LT: "HH:mm", L: "DD.MM.YYYY", LL: "D. MMMM YYYY", LLL: "D. MMMM YYYY HH:mm", LLLL: "dddd, D. MMMM YYYY HH:mm" }, relativeTime: { future: "in %s", past: "vor %s", s: V, m: V, mm: V, h: V, hh: V, d: V, dd: V, M: V, MM: V, y: V, yy: V } };
    return D.default.locale(z, null, !0), z;
  });
})(de$1);
var deExports = de$1.exports;
const de = /* @__PURE__ */ getDefaultExportFromCjs(deExports);
var en$1 = { exports: {} };
(function(T, S) {
  (function(R, k) {
    T.exports = k();
  })(commonjsGlobal, function() {
    return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(R) {
      var k = ["th", "st", "nd", "rd"], D = R % 100;
      return "[" + R + (k[(D - 20) % 10] || k[D] || k[0]) + "]";
    } };
  });
})(en$1);
var enExports = en$1.exports;
const en = /* @__PURE__ */ getDefaultExportFromCjs(enExports);
var es$1 = { exports: {} };
(function(T, S) {
  (function(R, k) {
    T.exports = k(defaultDayjs);
  })(commonjsGlobal, function(R) {
    function k(V) {
      return V && typeof V == "object" && "default" in V ? V : { default: V };
    }
    var D = k(R), L = { name: "es", monthsShort: "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), weekdays: "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"), weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"), weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"), months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"), weekStart: 1, formats: { LT: "H:mm", LTS: "H:mm:ss", L: "DD/MM/YYYY", LL: "D [de] MMMM [de] YYYY", LLL: "D [de] MMMM [de] YYYY H:mm", LLLL: "dddd, D [de] MMMM [de] YYYY H:mm" }, relativeTime: { future: "en %s", past: "hace %s", s: "unos segundos", m: "un minuto", mm: "%d minutos", h: "una hora", hh: "%d horas", d: "un día", dd: "%d días", M: "un mes", MM: "%d meses", y: "un año", yy: "%d años" }, ordinal: function(V) {
      return V + "º";
    } };
    return D.default.locale(L, null, !0), L;
  });
})(es$1);
var esExports = es$1.exports;
const es = /* @__PURE__ */ getDefaultExportFromCjs(esExports);
var timezone$1 = { exports: {} };
(function(T, S) {
  (function(R, k) {
    T.exports = k();
  })(commonjsGlobal, function() {
    var R = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, k = {};
    return function(D, L, V) {
      var z, W = function(Y, J, Z) {
        Z === void 0 && (Z = {});
        var X = new Date(Y), ee = function(te, re) {
          re === void 0 && (re = {});
          var Q = re.timeZoneName || "short", ne = te + "|" + Q, oe = k[ne];
          return oe || (oe = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: te, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: Q }), k[ne] = oe), oe;
        }(J, Z);
        return ee.formatToParts(X);
      }, U = function(Y, J) {
        for (var Z = W(Y, J), X = [], ee = 0; ee < Z.length; ee += 1) {
          var te = Z[ee], re = te.type, Q = te.value, ne = R[re];
          ne >= 0 && (X[ne] = parseInt(Q, 10));
        }
        var oe = X[3], ae = oe === 24 ? 0 : oe, se = X[0] + "-" + X[1] + "-" + X[2] + " " + ae + ":" + X[4] + ":" + X[5] + ":000", ie = +Y;
        return (V.utc(se).valueOf() - (ie -= ie % 1e3)) / 6e4;
      }, q = L.prototype;
      q.tz = function(Y, J) {
        Y === void 0 && (Y = z);
        var Z = this.utcOffset(), X = this.toDate(), ee = X.toLocaleString("en-US", { timeZone: Y }), te = Math.round((X - new Date(ee)) / 1e3 / 60), re = V(ee, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(X.getTimezoneOffset() / 15) - te, !0);
        if (J) {
          var Q = re.utcOffset();
          re = re.add(Z - Q, "minute");
        }
        return re.$x.$timezone = Y, re;
      }, q.offsetName = function(Y) {
        var J = this.$x.$timezone || V.tz.guess(), Z = W(this.valueOf(), J, { timeZoneName: Y }).find(function(X) {
          return X.type.toLowerCase() === "timezonename";
        });
        return Z && Z.value;
      };
      var K = q.startOf;
      q.startOf = function(Y, J) {
        if (!this.$x || !this.$x.$timezone) return K.call(this, Y, J);
        var Z = V(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return K.call(Z, Y, J).tz(this.$x.$timezone, !0);
      }, V.tz = function(Y, J, Z) {
        var X = Z && J, ee = Z || J || z, te = U(+V(), ee);
        if (typeof Y != "string") return V(Y).tz(ee);
        var re = function(ae, se, ie) {
          var he = ae - 60 * se * 1e3, xe = U(he, ie);
          if (se === xe) return [he, se];
          var Pe = U(he -= 60 * (xe - se) * 1e3, ie);
          return xe === Pe ? [he, xe] : [ae - 60 * Math.min(xe, Pe) * 1e3, Math.max(xe, Pe)];
        }(V.utc(Y, X).valueOf(), te, ee), Q = re[0], ne = re[1], oe = V(Q).utcOffset(ne);
        return oe.$x.$timezone = ee, oe;
      }, V.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, V.tz.setDefault = function(Y) {
        z = Y;
      };
    };
  });
})(timezone$1);
var timezoneExports = timezone$1.exports;
const timezone = /* @__PURE__ */ getDefaultExportFromCjs(timezoneExports);
var utc$1 = { exports: {} };
(function(T, S) {
  (function(R, k) {
    T.exports = k();
  })(commonjsGlobal, function() {
    var R = "minute", k = /[+-]\d\d(?::?\d\d)?/g, D = /([+-]|\d\d)/g;
    return function(L, V, z) {
      var W = V.prototype;
      z.utc = function(X) {
        var ee = { date: X, utc: !0, args: arguments };
        return new V(ee);
      }, W.utc = function(X) {
        var ee = z(this.toDate(), { locale: this.$L, utc: !0 });
        return X ? ee.add(this.utcOffset(), R) : ee;
      }, W.local = function() {
        return z(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var U = W.parse;
      W.parse = function(X) {
        X.utc && (this.$u = !0), this.$utils().u(X.$offset) || (this.$offset = X.$offset), U.call(this, X);
      };
      var q = W.init;
      W.init = function() {
        if (this.$u) {
          var X = this.$d;
          this.$y = X.getUTCFullYear(), this.$M = X.getUTCMonth(), this.$D = X.getUTCDate(), this.$W = X.getUTCDay(), this.$H = X.getUTCHours(), this.$m = X.getUTCMinutes(), this.$s = X.getUTCSeconds(), this.$ms = X.getUTCMilliseconds();
        } else q.call(this);
      };
      var K = W.utcOffset;
      W.utcOffset = function(X, ee) {
        var te = this.$utils().u;
        if (te(X)) return this.$u ? 0 : te(this.$offset) ? K.call(this) : this.$offset;
        if (typeof X == "string" && (X = function(oe) {
          oe === void 0 && (oe = "");
          var ae = oe.match(k);
          if (!ae) return null;
          var se = ("" + ae[0]).match(D) || ["-", 0, 0], ie = se[0], he = 60 * +se[1] + +se[2];
          return he === 0 ? 0 : ie === "+" ? he : -he;
        }(X), X === null)) return this;
        var re = Math.abs(X) <= 16 ? 60 * X : X, Q = this;
        if (ee) return Q.$offset = re, Q.$u = X === 0, Q;
        if (X !== 0) {
          var ne = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (Q = this.local().add(re + ne, R)).$offset = re, Q.$x.$localOffset = ne;
        } else Q = this.utc();
        return Q;
      };
      var Y = W.format;
      W.format = function(X) {
        var ee = X || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return Y.call(this, ee);
      }, W.valueOf = function() {
        var X = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * X;
      }, W.isUTC = function() {
        return !!this.$u;
      }, W.toISOString = function() {
        return this.toDate().toISOString();
      }, W.toString = function() {
        return this.toDate().toUTCString();
      };
      var J = W.toDate;
      W.toDate = function(X) {
        return X === "s" && this.$offset ? z(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : J.call(this);
      };
      var Z = W.diff;
      W.diff = function(X, ee, te) {
        if (X && this.$u === X.$u) return Z.call(this, X, ee, te);
        var re = this.local(), Q = z(X).local();
        return Z.call(re, Q, ee, te);
      };
    };
  });
})(utc$1);
var utcExports = utc$1.exports;
const utc = /* @__PURE__ */ getDefaultExportFromCjs(utcExports);
var propTypes = { exports: {} }, reactIs$1 = { exports: {} }, reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var T = typeof Symbol == "function" && Symbol.for, S = T ? Symbol.for("react.element") : 60103, R = T ? Symbol.for("react.portal") : 60106, k = T ? Symbol.for("react.fragment") : 60107, D = T ? Symbol.for("react.strict_mode") : 60108, L = T ? Symbol.for("react.profiler") : 60114, V = T ? Symbol.for("react.provider") : 60109, z = T ? Symbol.for("react.context") : 60110, W = T ? Symbol.for("react.async_mode") : 60111, U = T ? Symbol.for("react.concurrent_mode") : 60111, q = T ? Symbol.for("react.forward_ref") : 60112, K = T ? Symbol.for("react.suspense") : 60113, Y = T ? Symbol.for("react.suspense_list") : 60120, J = T ? Symbol.for("react.memo") : 60115, Z = T ? Symbol.for("react.lazy") : 60116, X = T ? Symbol.for("react.block") : 60121, ee = T ? Symbol.for("react.fundamental") : 60117, te = T ? Symbol.for("react.responder") : 60118, re = T ? Symbol.for("react.scope") : 60119;
  function Q(oe) {
    if (typeof oe == "object" && oe !== null) {
      var ae = oe.$$typeof;
      switch (ae) {
        case S:
          switch (oe = oe.type, oe) {
            case W:
            case U:
            case k:
            case L:
            case D:
            case K:
              return oe;
            default:
              switch (oe = oe && oe.$$typeof, oe) {
                case z:
                case q:
                case Z:
                case J:
                case V:
                  return oe;
                default:
                  return ae;
              }
          }
        case R:
          return ae;
      }
    }
  }
  function ne(oe) {
    return Q(oe) === U;
  }
  return reactIs_production_min$1.AsyncMode = W, reactIs_production_min$1.ConcurrentMode = U, reactIs_production_min$1.ContextConsumer = z, reactIs_production_min$1.ContextProvider = V, reactIs_production_min$1.Element = S, reactIs_production_min$1.ForwardRef = q, reactIs_production_min$1.Fragment = k, reactIs_production_min$1.Lazy = Z, reactIs_production_min$1.Memo = J, reactIs_production_min$1.Portal = R, reactIs_production_min$1.Profiler = L, reactIs_production_min$1.StrictMode = D, reactIs_production_min$1.Suspense = K, reactIs_production_min$1.isAsyncMode = function(oe) {
    return ne(oe) || Q(oe) === W;
  }, reactIs_production_min$1.isConcurrentMode = ne, reactIs_production_min$1.isContextConsumer = function(oe) {
    return Q(oe) === z;
  }, reactIs_production_min$1.isContextProvider = function(oe) {
    return Q(oe) === V;
  }, reactIs_production_min$1.isElement = function(oe) {
    return typeof oe == "object" && oe !== null && oe.$$typeof === S;
  }, reactIs_production_min$1.isForwardRef = function(oe) {
    return Q(oe) === q;
  }, reactIs_production_min$1.isFragment = function(oe) {
    return Q(oe) === k;
  }, reactIs_production_min$1.isLazy = function(oe) {
    return Q(oe) === Z;
  }, reactIs_production_min$1.isMemo = function(oe) {
    return Q(oe) === J;
  }, reactIs_production_min$1.isPortal = function(oe) {
    return Q(oe) === R;
  }, reactIs_production_min$1.isProfiler = function(oe) {
    return Q(oe) === L;
  }, reactIs_production_min$1.isStrictMode = function(oe) {
    return Q(oe) === D;
  }, reactIs_production_min$1.isSuspense = function(oe) {
    return Q(oe) === K;
  }, reactIs_production_min$1.isValidElementType = function(oe) {
    return typeof oe == "string" || typeof oe == "function" || oe === k || oe === U || oe === L || oe === D || oe === K || oe === Y || typeof oe == "object" && oe !== null && (oe.$$typeof === Z || oe.$$typeof === J || oe.$$typeof === V || oe.$$typeof === z || oe.$$typeof === q || oe.$$typeof === ee || oe.$$typeof === te || oe.$$typeof === re || oe.$$typeof === X);
  }, reactIs_production_min$1.typeOf = Q, reactIs_production_min$1;
}
var reactIs_development$1 = {}, hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1) return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  var T = {};
  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return T.NODE_ENV !== "production" && function() {
    var S = typeof Symbol == "function" && Symbol.for, R = S ? Symbol.for("react.element") : 60103, k = S ? Symbol.for("react.portal") : 60106, D = S ? Symbol.for("react.fragment") : 60107, L = S ? Symbol.for("react.strict_mode") : 60108, V = S ? Symbol.for("react.profiler") : 60114, z = S ? Symbol.for("react.provider") : 60109, W = S ? Symbol.for("react.context") : 60110, U = S ? Symbol.for("react.async_mode") : 60111, q = S ? Symbol.for("react.concurrent_mode") : 60111, K = S ? Symbol.for("react.forward_ref") : 60112, Y = S ? Symbol.for("react.suspense") : 60113, J = S ? Symbol.for("react.suspense_list") : 60120, Z = S ? Symbol.for("react.memo") : 60115, X = S ? Symbol.for("react.lazy") : 60116, ee = S ? Symbol.for("react.block") : 60121, te = S ? Symbol.for("react.fundamental") : 60117, re = S ? Symbol.for("react.responder") : 60118, Q = S ? Symbol.for("react.scope") : 60119;
    function ne(we) {
      return typeof we == "string" || typeof we == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      we === D || we === q || we === V || we === L || we === Y || we === J || typeof we == "object" && we !== null && (we.$$typeof === X || we.$$typeof === Z || we.$$typeof === z || we.$$typeof === W || we.$$typeof === K || we.$$typeof === te || we.$$typeof === re || we.$$typeof === Q || we.$$typeof === ee);
    }
    function oe(we) {
      if (typeof we == "object" && we !== null) {
        var Fe = we.$$typeof;
        switch (Fe) {
          case R:
            var De = we.type;
            switch (De) {
              case U:
              case q:
              case D:
              case V:
              case L:
              case Y:
                return De;
              default:
                var Le = De && De.$$typeof;
                switch (Le) {
                  case W:
                  case K:
                  case X:
                  case Z:
                  case z:
                    return Le;
                  default:
                    return Fe;
                }
            }
          case k:
            return Fe;
        }
      }
    }
    var ae = U, se = q, ie = W, he = z, xe = R, Pe = K, Re = D, ke = X, Te = Z, fe = k, ue = V, Ce = L, ce = Y, pe = !1;
    function _e(we) {
      return pe || (pe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ge(we) || oe(we) === U;
    }
    function ge(we) {
      return oe(we) === q;
    }
    function Ae(we) {
      return oe(we) === W;
    }
    function Ee(we) {
      return oe(we) === z;
    }
    function ve(we) {
      return typeof we == "object" && we !== null && we.$$typeof === R;
    }
    function le(we) {
      return oe(we) === K;
    }
    function me(we) {
      return oe(we) === D;
    }
    function Se(we) {
      return oe(we) === X;
    }
    function ye(we) {
      return oe(we) === Z;
    }
    function be(we) {
      return oe(we) === k;
    }
    function $e(we) {
      return oe(we) === V;
    }
    function Oe(we) {
      return oe(we) === L;
    }
    function Ie(we) {
      return oe(we) === Y;
    }
    reactIs_development$1.AsyncMode = ae, reactIs_development$1.ConcurrentMode = se, reactIs_development$1.ContextConsumer = ie, reactIs_development$1.ContextProvider = he, reactIs_development$1.Element = xe, reactIs_development$1.ForwardRef = Pe, reactIs_development$1.Fragment = Re, reactIs_development$1.Lazy = ke, reactIs_development$1.Memo = Te, reactIs_development$1.Portal = fe, reactIs_development$1.Profiler = ue, reactIs_development$1.StrictMode = Ce, reactIs_development$1.Suspense = ce, reactIs_development$1.isAsyncMode = _e, reactIs_development$1.isConcurrentMode = ge, reactIs_development$1.isContextConsumer = Ae, reactIs_development$1.isContextProvider = Ee, reactIs_development$1.isElement = ve, reactIs_development$1.isForwardRef = le, reactIs_development$1.isFragment = me, reactIs_development$1.isLazy = Se, reactIs_development$1.isMemo = ye, reactIs_development$1.isPortal = be, reactIs_development$1.isProfiler = $e, reactIs_development$1.isStrictMode = Oe, reactIs_development$1.isSuspense = Ie, reactIs_development$1.isValidElementType = ne, reactIs_development$1.typeOf = oe;
  }(), reactIs_development$1;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs) return reactIs$1.exports;
  hasRequiredReactIs = 1;
  var T = {};
  return T.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production_min$1() : reactIs$1.exports = requireReactIs_development$1(), reactIs$1.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var T = Object.getOwnPropertySymbols, S = Object.prototype.hasOwnProperty, R = Object.prototype.propertyIsEnumerable;
  function k(L) {
    if (L == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(L);
  }
  function D() {
    try {
      if (!Object.assign)
        return !1;
      var L = new String("abc");
      if (L[5] = "de", Object.getOwnPropertyNames(L)[0] === "5")
        return !1;
      for (var V = {}, z = 0; z < 10; z++)
        V["_" + String.fromCharCode(z)] = z;
      var W = Object.getOwnPropertyNames(V).map(function(q) {
        return V[q];
      });
      if (W.join("") !== "0123456789")
        return !1;
      var U = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(q) {
        U[q] = q;
      }), Object.keys(Object.assign({}, U)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = D() ? Object.assign : function(L, V) {
    for (var z, W = k(L), U, q = 1; q < arguments.length; q++) {
      z = Object(arguments[q]);
      for (var K in z)
        S.call(z, K) && (W[K] = z[K]);
      if (T) {
        U = T(z);
        for (var Y = 0; Y < U.length; Y++)
          R.call(z, U[Y]) && (W[U[Y]] = z[U[Y]]);
      }
    }
    return W;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var T = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = T, ReactPropTypesSecret_1;
}
var has$6, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has$6 = Function.call.bind(Object.prototype.hasOwnProperty)), has$6;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var T = {}, S = function() {
  };
  if (T.NODE_ENV !== "production") {
    var R = requireReactPropTypesSecret(), k = {}, D = requireHas();
    S = function(V) {
      var z = "Warning: " + V;
      typeof console < "u" && console.error(z);
      try {
        throw new Error(z);
      } catch {
      }
    };
  }
  function L(V, z, W, U, q) {
    if (T.NODE_ENV !== "production") {
      for (var K in V)
        if (D(V, K)) {
          var Y;
          try {
            if (typeof V[K] != "function") {
              var J = Error(
                (U || "React class") + ": " + W + " type `" + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof V[K] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw J.name = "Invariant Violation", J;
            }
            Y = V[K](z, K, U, W, null, R);
          } catch (X) {
            Y = X;
          }
          if (Y && !(Y instanceof Error) && S(
            (U || "React class") + ": type specification of " + W + " `" + K + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof Y + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), Y instanceof Error && !(Y.message in k)) {
            k[Y.message] = !0;
            var Z = q ? q() : "";
            S(
              "Failed " + W + " type: " + Y.message + (Z ?? "")
            );
          }
        }
    }
  }
  return L.resetWarningCache = function() {
    T.NODE_ENV !== "production" && (k = {});
  }, checkPropTypes_1 = L, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var T = {}, S = requireReactIs(), R = requireObjectAssign(), k = requireReactPropTypesSecret(), D = requireHas(), L = requireCheckPropTypes(), V = function() {
  };
  T.NODE_ENV !== "production" && (V = function(W) {
    var U = "Warning: " + W;
    typeof console < "u" && console.error(U);
    try {
      throw new Error(U);
    } catch {
    }
  });
  function z() {
    return null;
  }
  return factoryWithTypeCheckers = function(W, U) {
    var q = typeof Symbol == "function" && Symbol.iterator, K = "@@iterator";
    function Y(ge) {
      var Ae = ge && (q && ge[q] || ge[K]);
      if (typeof Ae == "function")
        return Ae;
    }
    var J = "<<anonymous>>", Z = {
      array: re("array"),
      bigint: re("bigint"),
      bool: re("boolean"),
      func: re("function"),
      number: re("number"),
      object: re("object"),
      string: re("string"),
      symbol: re("symbol"),
      any: Q(),
      arrayOf: ne,
      element: oe(),
      elementType: ae(),
      instanceOf: se,
      node: Pe(),
      objectOf: he,
      oneOf: ie,
      oneOfType: xe,
      shape: ke,
      exact: Te
    };
    function X(ge, Ae) {
      return ge === Ae ? ge !== 0 || 1 / ge === 1 / Ae : ge !== ge && Ae !== Ae;
    }
    function ee(ge, Ae) {
      this.message = ge, this.data = Ae && typeof Ae == "object" ? Ae : {}, this.stack = "";
    }
    ee.prototype = Error.prototype;
    function te(ge) {
      if (T.NODE_ENV !== "production")
        var Ae = {}, Ee = 0;
      function ve(me, Se, ye, be, $e, Oe, Ie) {
        if (be = be || J, Oe = Oe || ye, Ie !== k) {
          if (U) {
            var we = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw we.name = "Invariant Violation", we;
          } else if (T.NODE_ENV !== "production" && typeof console < "u") {
            var Fe = be + ":" + ye;
            !Ae[Fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            Ee < 3 && (V(
              "You are manually calling a React.PropTypes validation function for the `" + Oe + "` prop on `" + be + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Ae[Fe] = !0, Ee++);
          }
        }
        return Se[ye] == null ? me ? Se[ye] === null ? new ee("The " + $e + " `" + Oe + "` is marked as required " + ("in `" + be + "`, but its value is `null`.")) : new ee("The " + $e + " `" + Oe + "` is marked as required in " + ("`" + be + "`, but its value is `undefined`.")) : null : ge(Se, ye, be, $e, Oe);
      }
      var le = ve.bind(null, !1);
      return le.isRequired = ve.bind(null, !0), le;
    }
    function re(ge) {
      function Ae(Ee, ve, le, me, Se, ye) {
        var be = Ee[ve], $e = Ce(be);
        if ($e !== ge) {
          var Oe = ce(be);
          return new ee(
            "Invalid " + me + " `" + Se + "` of type " + ("`" + Oe + "` supplied to `" + le + "`, expected ") + ("`" + ge + "`."),
            { expectedType: ge }
          );
        }
        return null;
      }
      return te(Ae);
    }
    function Q() {
      return te(z);
    }
    function ne(ge) {
      function Ae(Ee, ve, le, me, Se) {
        if (typeof ge != "function")
          return new ee("Property `" + Se + "` of component `" + le + "` has invalid PropType notation inside arrayOf.");
        var ye = Ee[ve];
        if (!Array.isArray(ye)) {
          var be = Ce(ye);
          return new ee("Invalid " + me + " `" + Se + "` of type " + ("`" + be + "` supplied to `" + le + "`, expected an array."));
        }
        for (var $e = 0; $e < ye.length; $e++) {
          var Oe = ge(ye, $e, le, me, Se + "[" + $e + "]", k);
          if (Oe instanceof Error)
            return Oe;
        }
        return null;
      }
      return te(Ae);
    }
    function oe() {
      function ge(Ae, Ee, ve, le, me) {
        var Se = Ae[Ee];
        if (!W(Se)) {
          var ye = Ce(Se);
          return new ee("Invalid " + le + " `" + me + "` of type " + ("`" + ye + "` supplied to `" + ve + "`, expected a single ReactElement."));
        }
        return null;
      }
      return te(ge);
    }
    function ae() {
      function ge(Ae, Ee, ve, le, me) {
        var Se = Ae[Ee];
        if (!S.isValidElementType(Se)) {
          var ye = Ce(Se);
          return new ee("Invalid " + le + " `" + me + "` of type " + ("`" + ye + "` supplied to `" + ve + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return te(ge);
    }
    function se(ge) {
      function Ae(Ee, ve, le, me, Se) {
        if (!(Ee[ve] instanceof ge)) {
          var ye = ge.name || J, be = _e(Ee[ve]);
          return new ee("Invalid " + me + " `" + Se + "` of type " + ("`" + be + "` supplied to `" + le + "`, expected ") + ("instance of `" + ye + "`."));
        }
        return null;
      }
      return te(Ae);
    }
    function ie(ge) {
      if (!Array.isArray(ge))
        return T.NODE_ENV !== "production" && (arguments.length > 1 ? V(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : V("Invalid argument supplied to oneOf, expected an array.")), z;
      function Ae(Ee, ve, le, me, Se) {
        for (var ye = Ee[ve], be = 0; be < ge.length; be++)
          if (X(ye, ge[be]))
            return null;
        var $e = JSON.stringify(ge, function(Ie, we) {
          var Fe = ce(we);
          return Fe === "symbol" ? String(we) : we;
        });
        return new ee("Invalid " + me + " `" + Se + "` of value `" + String(ye) + "` " + ("supplied to `" + le + "`, expected one of " + $e + "."));
      }
      return te(Ae);
    }
    function he(ge) {
      function Ae(Ee, ve, le, me, Se) {
        if (typeof ge != "function")
          return new ee("Property `" + Se + "` of component `" + le + "` has invalid PropType notation inside objectOf.");
        var ye = Ee[ve], be = Ce(ye);
        if (be !== "object")
          return new ee("Invalid " + me + " `" + Se + "` of type " + ("`" + be + "` supplied to `" + le + "`, expected an object."));
        for (var $e in ye)
          if (D(ye, $e)) {
            var Oe = ge(ye, $e, le, me, Se + "." + $e, k);
            if (Oe instanceof Error)
              return Oe;
          }
        return null;
      }
      return te(Ae);
    }
    function xe(ge) {
      if (!Array.isArray(ge))
        return T.NODE_ENV !== "production" && V("Invalid argument supplied to oneOfType, expected an instance of array."), z;
      for (var Ae = 0; Ae < ge.length; Ae++) {
        var Ee = ge[Ae];
        if (typeof Ee != "function")
          return V(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + pe(Ee) + " at index " + Ae + "."
          ), z;
      }
      function ve(le, me, Se, ye, be) {
        for (var $e = [], Oe = 0; Oe < ge.length; Oe++) {
          var Ie = ge[Oe], we = Ie(le, me, Se, ye, be, k);
          if (we == null)
            return null;
          we.data && D(we.data, "expectedType") && $e.push(we.data.expectedType);
        }
        var Fe = $e.length > 0 ? ", expected one of type [" + $e.join(", ") + "]" : "";
        return new ee("Invalid " + ye + " `" + be + "` supplied to " + ("`" + Se + "`" + Fe + "."));
      }
      return te(ve);
    }
    function Pe() {
      function ge(Ae, Ee, ve, le, me) {
        return fe(Ae[Ee]) ? null : new ee("Invalid " + le + " `" + me + "` supplied to " + ("`" + ve + "`, expected a ReactNode."));
      }
      return te(ge);
    }
    function Re(ge, Ae, Ee, ve, le) {
      return new ee(
        (ge || "React class") + ": " + Ae + " type `" + Ee + "." + ve + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + le + "`."
      );
    }
    function ke(ge) {
      function Ae(Ee, ve, le, me, Se) {
        var ye = Ee[ve], be = Ce(ye);
        if (be !== "object")
          return new ee("Invalid " + me + " `" + Se + "` of type `" + be + "` " + ("supplied to `" + le + "`, expected `object`."));
        for (var $e in ge) {
          var Oe = ge[$e];
          if (typeof Oe != "function")
            return Re(le, me, Se, $e, ce(Oe));
          var Ie = Oe(ye, $e, le, me, Se + "." + $e, k);
          if (Ie)
            return Ie;
        }
        return null;
      }
      return te(Ae);
    }
    function Te(ge) {
      function Ae(Ee, ve, le, me, Se) {
        var ye = Ee[ve], be = Ce(ye);
        if (be !== "object")
          return new ee("Invalid " + me + " `" + Se + "` of type `" + be + "` " + ("supplied to `" + le + "`, expected `object`."));
        var $e = R({}, Ee[ve], ge);
        for (var Oe in $e) {
          var Ie = ge[Oe];
          if (D(ge, Oe) && typeof Ie != "function")
            return Re(le, me, Se, Oe, ce(Ie));
          if (!Ie)
            return new ee(
              "Invalid " + me + " `" + Se + "` key `" + Oe + "` supplied to `" + le + "`.\nBad object: " + JSON.stringify(Ee[ve], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(ge), null, "  ")
            );
          var we = Ie(ye, Oe, le, me, Se + "." + Oe, k);
          if (we)
            return we;
        }
        return null;
      }
      return te(Ae);
    }
    function fe(ge) {
      switch (typeof ge) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !ge;
        case "object":
          if (Array.isArray(ge))
            return ge.every(fe);
          if (ge === null || W(ge))
            return !0;
          var Ae = Y(ge);
          if (Ae) {
            var Ee = Ae.call(ge), ve;
            if (Ae !== ge.entries) {
              for (; !(ve = Ee.next()).done; )
                if (!fe(ve.value))
                  return !1;
            } else
              for (; !(ve = Ee.next()).done; ) {
                var le = ve.value;
                if (le && !fe(le[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ue(ge, Ae) {
      return ge === "symbol" ? !0 : Ae ? Ae["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Ae instanceof Symbol : !1;
    }
    function Ce(ge) {
      var Ae = typeof ge;
      return Array.isArray(ge) ? "array" : ge instanceof RegExp ? "object" : ue(Ae, ge) ? "symbol" : Ae;
    }
    function ce(ge) {
      if (typeof ge > "u" || ge === null)
        return "" + ge;
      var Ae = Ce(ge);
      if (Ae === "object") {
        if (ge instanceof Date)
          return "date";
        if (ge instanceof RegExp)
          return "regexp";
      }
      return Ae;
    }
    function pe(ge) {
      var Ae = ce(ge);
      switch (Ae) {
        case "array":
        case "object":
          return "an " + Ae;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Ae;
        default:
          return Ae;
      }
    }
    function _e(ge) {
      return !ge.constructor || !ge.constructor.name ? J : ge.constructor.name;
    }
    return Z.checkPropTypes = L, Z.resetWarningCache = L.resetWarningCache, Z.PropTypes = Z, Z;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var T = requireReactPropTypesSecret();
  function S() {
  }
  function R() {
  }
  return R.resetWarningCache = S, factoryWithThrowingShims = function() {
    function k(V, z, W, U, q, K) {
      if (K !== T) {
        var Y = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw Y.name = "Invariant Violation", Y;
      }
    }
    k.isRequired = k;
    function D() {
      return k;
    }
    var L = {
      array: k,
      bigint: k,
      bool: k,
      func: k,
      number: k,
      object: k,
      string: k,
      symbol: k,
      any: k,
      arrayOf: D,
      element: k,
      elementType: k,
      instanceOf: D,
      node: k,
      objectOf: D,
      oneOf: D,
      oneOfType: D,
      shape: D,
      exact: D,
      checkPropTypes: R,
      resetWarningCache: S
    };
    return L.PropTypes = L, L;
  }, factoryWithThrowingShims;
}
var define_process_env_default$1V = {};
if (define_process_env_default$1V.NODE_ENV !== "production") {
  var ReactIs = requireReactIs(), throwOnDirectAccess = !0;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
var lib$2 = {}, flattenNames$1 = {}, freeGlobal$3 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$3, freeGlobal$2 = _freeGlobal, freeSelf$2 = typeof self == "object" && self && self.Object === Object && self, root$a = freeGlobal$2 || freeSelf$2 || Function("return this")(), _root = root$a, root$9 = _root, Symbol$8 = root$9.Symbol, _Symbol = Symbol$8, Symbol$7 = _Symbol, objectProto$w = Object.prototype, hasOwnProperty$r = objectProto$w.hasOwnProperty, nativeObjectToString$4 = objectProto$w.toString, symToStringTag$4 = Symbol$7 ? Symbol$7.toStringTag : void 0;
function getRawTag$3(T) {
  var S = hasOwnProperty$r.call(T, symToStringTag$4), R = T[symToStringTag$4];
  try {
    T[symToStringTag$4] = void 0;
    var k = !0;
  } catch {
  }
  var D = nativeObjectToString$4.call(T);
  return k && (S ? T[symToStringTag$4] = R : delete T[symToStringTag$4]), D;
}
var _getRawTag = getRawTag$3, objectProto$v = Object.prototype, nativeObjectToString$3 = objectProto$v.toString;
function objectToString$4(T) {
  return nativeObjectToString$3.call(T);
}
var _objectToString = objectToString$4, Symbol$6 = _Symbol, getRawTag$2 = _getRawTag, objectToString$3 = _objectToString, nullTag$2 = "[object Null]", undefinedTag$2 = "[object Undefined]", symToStringTag$3 = Symbol$6 ? Symbol$6.toStringTag : void 0;
function baseGetTag$9(T) {
  return T == null ? T === void 0 ? undefinedTag$2 : nullTag$2 : symToStringTag$3 && symToStringTag$3 in Object(T) ? getRawTag$2(T) : objectToString$3(T);
}
var _baseGetTag = baseGetTag$9, isArray$l = Array.isArray, isArray_1 = isArray$l;
function isObjectLike$c(T) {
  return T != null && typeof T == "object";
}
var isObjectLike_1 = isObjectLike$c, baseGetTag$8 = _baseGetTag, isArray$k = isArray_1, isObjectLike$b = isObjectLike_1, stringTag$6 = "[object String]";
function isString$1(T) {
  return typeof T == "string" || !isArray$k(T) && isObjectLike$b(T) && baseGetTag$8(T) == stringTag$6;
}
var isString_1 = isString$1;
function createBaseFor$2(T) {
  return function(S, R, k) {
    for (var D = -1, L = Object(S), V = k(S), z = V.length; z--; ) {
      var W = V[T ? z : ++D];
      if (R(L[W], W, L) === !1)
        break;
    }
    return S;
  };
}
var _createBaseFor = createBaseFor$2, createBaseFor$1 = _createBaseFor, baseFor$3 = createBaseFor$1(), _baseFor = baseFor$3;
function baseTimes$2(T, S) {
  for (var R = -1, k = Array(T); ++R < T; )
    k[R] = S(R);
  return k;
}
var _baseTimes = baseTimes$2, baseGetTag$7 = _baseGetTag, isObjectLike$a = isObjectLike_1, argsTag$6 = "[object Arguments]";
function baseIsArguments$2(T) {
  return isObjectLike$a(T) && baseGetTag$7(T) == argsTag$6;
}
var _baseIsArguments = baseIsArguments$2, baseIsArguments$1 = _baseIsArguments, isObjectLike$9 = isObjectLike_1, objectProto$u = Object.prototype, hasOwnProperty$q = objectProto$u.hasOwnProperty, propertyIsEnumerable$3 = objectProto$u.propertyIsEnumerable, isArguments$7 = baseIsArguments$1(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments$1 : function(T) {
  return isObjectLike$9(T) && hasOwnProperty$q.call(T, "callee") && !propertyIsEnumerable$3.call(T, "callee");
}, isArguments_1 = isArguments$7, isBuffer$6 = { exports: {} };
function stubFalse$1() {
  return !1;
}
var stubFalse_1 = stubFalse$1;
isBuffer$6.exports;
(function(T, S) {
  var R = _root, k = stubFalse_1, D = S && !S.nodeType && S, L = D && !0 && T && !T.nodeType && T, V = L && L.exports === D, z = V ? R.Buffer : void 0, W = z ? z.isBuffer : void 0, U = W || k;
  T.exports = U;
})(isBuffer$6, isBuffer$6.exports);
var isBufferExports = isBuffer$6.exports, MAX_SAFE_INTEGER$3 = 9007199254740991, reIsUint$1 = /^(?:0|[1-9]\d*)$/;
function isIndex$5(T, S) {
  var R = typeof T;
  return S = S ?? MAX_SAFE_INTEGER$3, !!S && (R == "number" || R != "symbol" && reIsUint$1.test(T)) && T > -1 && T % 1 == 0 && T < S;
}
var _isIndex = isIndex$5, MAX_SAFE_INTEGER$2 = 9007199254740991;
function isLength$4(T) {
  return typeof T == "number" && T > -1 && T % 1 == 0 && T <= MAX_SAFE_INTEGER$2;
}
var isLength_1 = isLength$4, baseGetTag$6 = _baseGetTag, isLength$3 = isLength_1, isObjectLike$8 = isObjectLike_1, argsTag$5 = "[object Arguments]", arrayTag$4 = "[object Array]", boolTag$5 = "[object Boolean]", dateTag$5 = "[object Date]", errorTag$4 = "[object Error]", funcTag$5 = "[object Function]", mapTag$8 = "[object Map]", numberTag$5 = "[object Number]", objectTag$8 = "[object Object]", regexpTag$5 = "[object RegExp]", setTag$8 = "[object Set]", stringTag$5 = "[object String]", weakMapTag$4 = "[object WeakMap]", arrayBufferTag$5 = "[object ArrayBuffer]", dataViewTag$7 = "[object DataView]", float32Tag$3 = "[object Float32Array]", float64Tag$3 = "[object Float64Array]", int8Tag$3 = "[object Int8Array]", int16Tag$3 = "[object Int16Array]", int32Tag$3 = "[object Int32Array]", uint8Tag$3 = "[object Uint8Array]", uint8ClampedTag$3 = "[object Uint8ClampedArray]", uint16Tag$3 = "[object Uint16Array]", uint32Tag$3 = "[object Uint32Array]", typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] = typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] = typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] = typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] = typedArrayTags$1[uint32Tag$3] = !0;
typedArrayTags$1[argsTag$5] = typedArrayTags$1[arrayTag$4] = typedArrayTags$1[arrayBufferTag$5] = typedArrayTags$1[boolTag$5] = typedArrayTags$1[dataViewTag$7] = typedArrayTags$1[dateTag$5] = typedArrayTags$1[errorTag$4] = typedArrayTags$1[funcTag$5] = typedArrayTags$1[mapTag$8] = typedArrayTags$1[numberTag$5] = typedArrayTags$1[objectTag$8] = typedArrayTags$1[regexpTag$5] = typedArrayTags$1[setTag$8] = typedArrayTags$1[stringTag$5] = typedArrayTags$1[weakMapTag$4] = !1;
function baseIsTypedArray$2(T) {
  return isObjectLike$8(T) && isLength$3(T.length) && !!typedArrayTags$1[baseGetTag$6(T)];
}
var _baseIsTypedArray = baseIsTypedArray$2;
function baseUnary$4(T) {
  return function(S) {
    return T(S);
  };
}
var _baseUnary = baseUnary$4, _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(T, S) {
  var R = _freeGlobal, k = S && !S.nodeType && S, D = k && !0 && T && !T.nodeType && T, L = D && D.exports === k, V = L && R.process, z = function() {
    try {
      var W = D && D.require && D.require("util").types;
      return W || V && V.binding && V.binding("util");
    } catch {
    }
  }();
  T.exports = z;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports, baseIsTypedArray$1 = _baseIsTypedArray, baseUnary$3 = _baseUnary, nodeUtil$3 = _nodeUtilExports, nodeIsTypedArray$1 = nodeUtil$3 && nodeUtil$3.isTypedArray, isTypedArray$5 = nodeIsTypedArray$1 ? baseUnary$3(nodeIsTypedArray$1) : baseIsTypedArray$1, isTypedArray_1 = isTypedArray$5, baseTimes$1 = _baseTimes, isArguments$6 = isArguments_1, isArray$j = isArray_1, isBuffer$5 = isBufferExports, isIndex$4 = _isIndex, isTypedArray$4 = isTypedArray_1, objectProto$t = Object.prototype, hasOwnProperty$p = objectProto$t.hasOwnProperty;
function arrayLikeKeys$3(T, S) {
  var R = isArray$j(T), k = !R && isArguments$6(T), D = !R && !k && isBuffer$5(T), L = !R && !k && !D && isTypedArray$4(T), V = R || k || D || L, z = V ? baseTimes$1(T.length, String) : [], W = z.length;
  for (var U in T)
    (S || hasOwnProperty$p.call(T, U)) && !(V && // Safari 9 has enumerable `arguments.length` in strict mode.
    (U == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    D && (U == "offset" || U == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    L && (U == "buffer" || U == "byteLength" || U == "byteOffset") || // Skip index properties.
    isIndex$4(U, W))) && z.push(U);
  return z;
}
var _arrayLikeKeys = arrayLikeKeys$3, objectProto$s = Object.prototype;
function isPrototype$4(T) {
  var S = T && T.constructor, R = typeof S == "function" && S.prototype || objectProto$s;
  return T === R;
}
var _isPrototype = isPrototype$4;
function overArg$3(T, S) {
  return function(R) {
    return T(S(R));
  };
}
var _overArg = overArg$3, overArg$2 = _overArg, nativeKeys$2 = overArg$2(Object.keys, Object), _nativeKeys = nativeKeys$2, isPrototype$3 = _isPrototype, nativeKeys$1 = _nativeKeys, objectProto$r = Object.prototype, hasOwnProperty$o = objectProto$r.hasOwnProperty;
function baseKeys$2(T) {
  if (!isPrototype$3(T))
    return nativeKeys$1(T);
  var S = [];
  for (var R in Object(T))
    hasOwnProperty$o.call(T, R) && R != "constructor" && S.push(R);
  return S;
}
var _baseKeys = baseKeys$2;
function isObject$g(T) {
  var S = typeof T;
  return T != null && (S == "object" || S == "function");
}
var isObject_1 = isObject$g, baseGetTag$5 = _baseGetTag, isObject$f = isObject_1, asyncTag$2 = "[object AsyncFunction]", funcTag$4 = "[object Function]", genTag$3 = "[object GeneratorFunction]", proxyTag$2 = "[object Proxy]";
function isFunction$5(T) {
  if (!isObject$f(T))
    return !1;
  var S = baseGetTag$5(T);
  return S == funcTag$4 || S == genTag$3 || S == asyncTag$2 || S == proxyTag$2;
}
var isFunction_1 = isFunction$5, isFunction$4 = isFunction_1, isLength$2 = isLength_1;
function isArrayLike$7(T) {
  return T != null && isLength$2(T.length) && !isFunction$4(T);
}
var isArrayLike_1 = isArrayLike$7, arrayLikeKeys$2 = _arrayLikeKeys, baseKeys$1 = _baseKeys, isArrayLike$6 = isArrayLike_1;
function keys$7(T) {
  return isArrayLike$6(T) ? arrayLikeKeys$2(T) : baseKeys$1(T);
}
var keys_1 = keys$7, baseFor$2 = _baseFor, keys$6 = keys_1;
function baseForOwn$4(T, S) {
  return T && baseFor$2(T, S, keys$6);
}
var _baseForOwn = baseForOwn$4;
function identity$5(T) {
  return T;
}
var identity_1 = identity$5, identity$4 = identity_1;
function castFunction$3(T) {
  return typeof T == "function" ? T : identity$4;
}
var _castFunction = castFunction$3, baseForOwn$3 = _baseForOwn, castFunction$2 = _castFunction;
function forOwn(T, S) {
  return T && baseForOwn$3(T, castFunction$2(S));
}
var forOwn_1 = forOwn, overArg$1 = _overArg, getPrototype$4 = overArg$1(Object.getPrototypeOf, Object), _getPrototype = getPrototype$4, baseGetTag$4 = _baseGetTag, getPrototype$3 = _getPrototype, isObjectLike$7 = isObjectLike_1, objectTag$7 = "[object Object]", funcProto$6 = Function.prototype, objectProto$q = Object.prototype, funcToString$6 = funcProto$6.toString, hasOwnProperty$n = objectProto$q.hasOwnProperty, objectCtorString$1 = funcToString$6.call(Object);
function isPlainObject$3(T) {
  if (!isObjectLike$7(T) || baseGetTag$4(T) != objectTag$7)
    return !1;
  var S = getPrototype$3(T);
  if (S === null)
    return !0;
  var R = hasOwnProperty$n.call(S, "constructor") && S.constructor;
  return typeof R == "function" && R instanceof R && funcToString$6.call(R) == objectCtorString$1;
}
var isPlainObject_1 = isPlainObject$3;
function arrayMap$4(T, S) {
  for (var R = -1, k = T == null ? 0 : T.length, D = Array(k); ++R < k; )
    D[R] = S(T[R], R, T);
  return D;
}
var _arrayMap = arrayMap$4;
function listCacheClear$3() {
  this.__data__ = [], this.size = 0;
}
var _listCacheClear = listCacheClear$3;
function eq$7(T, S) {
  return T === S || T !== T && S !== S;
}
var eq_1 = eq$7, eq$6 = eq_1;
function assocIndexOf$6(T, S) {
  for (var R = T.length; R--; )
    if (eq$6(T[R][0], S))
      return R;
  return -1;
}
var _assocIndexOf = assocIndexOf$6, assocIndexOf$5 = _assocIndexOf, arrayProto$2 = Array.prototype, splice$2 = arrayProto$2.splice;
function listCacheDelete$3(T) {
  var S = this.__data__, R = assocIndexOf$5(S, T);
  if (R < 0)
    return !1;
  var k = S.length - 1;
  return R == k ? S.pop() : splice$2.call(S, R, 1), --this.size, !0;
}
var _listCacheDelete = listCacheDelete$3, assocIndexOf$4 = _assocIndexOf;
function listCacheGet$3(T) {
  var S = this.__data__, R = assocIndexOf$4(S, T);
  return R < 0 ? void 0 : S[R][1];
}
var _listCacheGet = listCacheGet$3, assocIndexOf$3 = _assocIndexOf;
function listCacheHas$3(T) {
  return assocIndexOf$3(this.__data__, T) > -1;
}
var _listCacheHas = listCacheHas$3, assocIndexOf$2 = _assocIndexOf;
function listCacheSet$3(T, S) {
  var R = this.__data__, k = assocIndexOf$2(R, T);
  return k < 0 ? (++this.size, R.push([T, S])) : R[k][1] = S, this;
}
var _listCacheSet = listCacheSet$3, listCacheClear$2 = _listCacheClear, listCacheDelete$2 = _listCacheDelete, listCacheGet$2 = _listCacheGet, listCacheHas$2 = _listCacheHas, listCacheSet$2 = _listCacheSet;
function ListCache$6(T) {
  var S = -1, R = T == null ? 0 : T.length;
  for (this.clear(); ++S < R; ) {
    var k = T[S];
    this.set(k[0], k[1]);
  }
}
ListCache$6.prototype.clear = listCacheClear$2;
ListCache$6.prototype.delete = listCacheDelete$2;
ListCache$6.prototype.get = listCacheGet$2;
ListCache$6.prototype.has = listCacheHas$2;
ListCache$6.prototype.set = listCacheSet$2;
var _ListCache = ListCache$6, ListCache$5 = _ListCache;
function stackClear$2() {
  this.__data__ = new ListCache$5(), this.size = 0;
}
var _stackClear = stackClear$2;
function stackDelete$2(T) {
  var S = this.__data__, R = S.delete(T);
  return this.size = S.size, R;
}
var _stackDelete = stackDelete$2;
function stackGet$2(T) {
  return this.__data__.get(T);
}
var _stackGet = stackGet$2;
function stackHas$2(T) {
  return this.__data__.has(T);
}
var _stackHas = stackHas$2, root$8 = _root, coreJsData$3 = root$8["__core-js_shared__"], _coreJsData = coreJsData$3, coreJsData$2 = _coreJsData, maskSrcKey$2 = function() {
  var T = /[^.]+$/.exec(coreJsData$2 && coreJsData$2.keys && coreJsData$2.keys.IE_PROTO || "");
  return T ? "Symbol(src)_1." + T : "";
}();
function isMasked$3(T) {
  return !!maskSrcKey$2 && maskSrcKey$2 in T;
}
var _isMasked = isMasked$3, funcProto$5 = Function.prototype, funcToString$5 = funcProto$5.toString;
function toSource$4(T) {
  if (T != null) {
    try {
      return funcToString$5.call(T);
    } catch {
    }
    try {
      return T + "";
    } catch {
    }
  }
  return "";
}
var _toSource = toSource$4, isFunction$3 = isFunction_1, isMasked$2 = _isMasked, isObject$e = isObject_1, toSource$3 = _toSource, reRegExpChar$2 = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor$2 = /^\[object .+?Constructor\]$/, funcProto$4 = Function.prototype, objectProto$p = Object.prototype, funcToString$4 = funcProto$4.toString, hasOwnProperty$m = objectProto$p.hasOwnProperty, reIsNative$2 = RegExp(
  "^" + funcToString$4.call(hasOwnProperty$m).replace(reRegExpChar$2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$3(T) {
  if (!isObject$e(T) || isMasked$2(T))
    return !1;
  var S = isFunction$3(T) ? reIsNative$2 : reIsHostCtor$2;
  return S.test(toSource$3(T));
}
var _baseIsNative = baseIsNative$3;
function getValue$4(T, S) {
  return T?.[S];
}
var _getValue = getValue$4, baseIsNative$2 = _baseIsNative, getValue$3 = _getValue;
function getNative$9(T, S) {
  var R = getValue$3(T, S);
  return baseIsNative$2(R) ? R : void 0;
}
var _getNative = getNative$9, getNative$8 = _getNative, root$7 = _root, Map$5 = getNative$8(root$7, "Map"), _Map = Map$5, getNative$7 = _getNative, nativeCreate$6 = getNative$7(Object, "create"), _nativeCreate = nativeCreate$6, nativeCreate$5 = _nativeCreate;
function hashClear$3() {
  this.__data__ = nativeCreate$5 ? nativeCreate$5(null) : {}, this.size = 0;
}
var _hashClear = hashClear$3;
function hashDelete$3(T) {
  var S = this.has(T) && delete this.__data__[T];
  return this.size -= S ? 1 : 0, S;
}
var _hashDelete = hashDelete$3, nativeCreate$4 = _nativeCreate, HASH_UNDEFINED$6 = "__lodash_hash_undefined__", objectProto$o = Object.prototype, hasOwnProperty$l = objectProto$o.hasOwnProperty;
function hashGet$3(T) {
  var S = this.__data__;
  if (nativeCreate$4) {
    var R = S[T];
    return R === HASH_UNDEFINED$6 ? void 0 : R;
  }
  return hasOwnProperty$l.call(S, T) ? S[T] : void 0;
}
var _hashGet = hashGet$3, nativeCreate$3 = _nativeCreate, objectProto$n = Object.prototype, hasOwnProperty$k = objectProto$n.hasOwnProperty;
function hashHas$3(T) {
  var S = this.__data__;
  return nativeCreate$3 ? S[T] !== void 0 : hasOwnProperty$k.call(S, T);
}
var _hashHas = hashHas$3, nativeCreate$2 = _nativeCreate, HASH_UNDEFINED$5 = "__lodash_hash_undefined__";
function hashSet$3(T, S) {
  var R = this.__data__;
  return this.size += this.has(T) ? 0 : 1, R[T] = nativeCreate$2 && S === void 0 ? HASH_UNDEFINED$5 : S, this;
}
var _hashSet = hashSet$3, hashClear$2 = _hashClear, hashDelete$2 = _hashDelete, hashGet$2 = _hashGet, hashHas$2 = _hashHas, hashSet$2 = _hashSet;
function Hash$3(T) {
  var S = -1, R = T == null ? 0 : T.length;
  for (this.clear(); ++S < R; ) {
    var k = T[S];
    this.set(k[0], k[1]);
  }
}
Hash$3.prototype.clear = hashClear$2;
Hash$3.prototype.delete = hashDelete$2;
Hash$3.prototype.get = hashGet$2;
Hash$3.prototype.has = hashHas$2;
Hash$3.prototype.set = hashSet$2;
var _Hash = Hash$3, Hash$2 = _Hash, ListCache$4 = _ListCache, Map$4 = _Map;
function mapCacheClear$3() {
  this.size = 0, this.__data__ = {
    hash: new Hash$2(),
    map: new (Map$4 || ListCache$4)(),
    string: new Hash$2()
  };
}
var _mapCacheClear = mapCacheClear$3;
function isKeyable$3(T) {
  var S = typeof T;
  return S == "string" || S == "number" || S == "symbol" || S == "boolean" ? T !== "__proto__" : T === null;
}
var _isKeyable = isKeyable$3, isKeyable$2 = _isKeyable;
function getMapData$6(T, S) {
  var R = T.__data__;
  return isKeyable$2(S) ? R[typeof S == "string" ? "string" : "hash"] : R.map;
}
var _getMapData = getMapData$6, getMapData$5 = _getMapData;
function mapCacheDelete$3(T) {
  var S = getMapData$5(this, T).delete(T);
  return this.size -= S ? 1 : 0, S;
}
var _mapCacheDelete = mapCacheDelete$3, getMapData$4 = _getMapData;
function mapCacheGet$3(T) {
  return getMapData$4(this, T).get(T);
}
var _mapCacheGet = mapCacheGet$3, getMapData$3 = _getMapData;
function mapCacheHas$3(T) {
  return getMapData$3(this, T).has(T);
}
var _mapCacheHas = mapCacheHas$3, getMapData$2 = _getMapData;
function mapCacheSet$3(T, S) {
  var R = getMapData$2(this, T), k = R.size;
  return R.set(T, S), this.size += R.size == k ? 0 : 1, this;
}
var _mapCacheSet = mapCacheSet$3, mapCacheClear$2 = _mapCacheClear, mapCacheDelete$2 = _mapCacheDelete, mapCacheGet$2 = _mapCacheGet, mapCacheHas$2 = _mapCacheHas, mapCacheSet$2 = _mapCacheSet;
function MapCache$5(T) {
  var S = -1, R = T == null ? 0 : T.length;
  for (this.clear(); ++S < R; ) {
    var k = T[S];
    this.set(k[0], k[1]);
  }
}
MapCache$5.prototype.clear = mapCacheClear$2;
MapCache$5.prototype.delete = mapCacheDelete$2;
MapCache$5.prototype.get = mapCacheGet$2;
MapCache$5.prototype.has = mapCacheHas$2;
MapCache$5.prototype.set = mapCacheSet$2;
var _MapCache = MapCache$5, ListCache$3 = _ListCache, Map$3 = _Map, MapCache$4 = _MapCache, LARGE_ARRAY_SIZE$1 = 200;
function stackSet$2(T, S) {
  var R = this.__data__;
  if (R instanceof ListCache$3) {
    var k = R.__data__;
    if (!Map$3 || k.length < LARGE_ARRAY_SIZE$1 - 1)
      return k.push([T, S]), this.size = ++R.size, this;
    R = this.__data__ = new MapCache$4(k);
  }
  return R.set(T, S), this.size = R.size, this;
}
var _stackSet = stackSet$2, ListCache$2 = _ListCache, stackClear$1 = _stackClear, stackDelete$1 = _stackDelete, stackGet$1 = _stackGet, stackHas$1 = _stackHas, stackSet$1 = _stackSet;
function Stack$a(T) {
  var S = this.__data__ = new ListCache$2(T);
  this.size = S.size;
}
Stack$a.prototype.clear = stackClear$1;
Stack$a.prototype.delete = stackDelete$1;
Stack$a.prototype.get = stackGet$1;
Stack$a.prototype.has = stackHas$1;
Stack$a.prototype.set = stackSet$1;
var _Stack = Stack$a, HASH_UNDEFINED$4 = "__lodash_hash_undefined__";
function setCacheAdd$2(T) {
  return this.__data__.set(T, HASH_UNDEFINED$4), this;
}
var _setCacheAdd = setCacheAdd$2;
function setCacheHas$2(T) {
  return this.__data__.has(T);
}
var _setCacheHas = setCacheHas$2, MapCache$3 = _MapCache, setCacheAdd$1 = _setCacheAdd, setCacheHas$1 = _setCacheHas;
function SetCache$2(T) {
  var S = -1, R = T == null ? 0 : T.length;
  for (this.__data__ = new MapCache$3(); ++S < R; )
    this.add(T[S]);
}
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd$1;
SetCache$2.prototype.has = setCacheHas$1;
var _SetCache = SetCache$2;
function arraySome$2(T, S) {
  for (var R = -1, k = T == null ? 0 : T.length; ++R < k; )
    if (S(T[R], R, T))
      return !0;
  return !1;
}
var _arraySome = arraySome$2;
function cacheHas$2(T, S) {
  return T.has(S);
}
var _cacheHas = cacheHas$2, SetCache$1 = _SetCache, arraySome$1 = _arraySome, cacheHas$1 = _cacheHas, COMPARE_PARTIAL_FLAG$b = 1, COMPARE_UNORDERED_FLAG$7 = 2;
function equalArrays$3(T, S, R, k, D, L) {
  var V = R & COMPARE_PARTIAL_FLAG$b, z = T.length, W = S.length;
  if (z != W && !(V && W > z))
    return !1;
  var U = L.get(T), q = L.get(S);
  if (U && q)
    return U == S && q == T;
  var K = -1, Y = !0, J = R & COMPARE_UNORDERED_FLAG$7 ? new SetCache$1() : void 0;
  for (L.set(T, S), L.set(S, T); ++K < z; ) {
    var Z = T[K], X = S[K];
    if (k)
      var ee = V ? k(X, Z, K, S, T, L) : k(Z, X, K, T, S, L);
    if (ee !== void 0) {
      if (ee)
        continue;
      Y = !1;
      break;
    }
    if (J) {
      if (!arraySome$1(S, function(te, re) {
        if (!cacheHas$1(J, re) && (Z === te || D(Z, te, R, k, L)))
          return J.push(re);
      })) {
        Y = !1;
        break;
      }
    } else if (!(Z === X || D(Z, X, R, k, L))) {
      Y = !1;
      break;
    }
  }
  return L.delete(T), L.delete(S), Y;
}
var _equalArrays = equalArrays$3, root$6 = _root, Uint8Array$4 = root$6.Uint8Array, _Uint8Array = Uint8Array$4;
function mapToArray$2(T) {
  var S = -1, R = Array(T.size);
  return T.forEach(function(k, D) {
    R[++S] = [D, k];
  }), R;
}
var _mapToArray = mapToArray$2;
function setToArray$3(T) {
  var S = -1, R = Array(T.size);
  return T.forEach(function(k) {
    R[++S] = k;
  }), R;
}
var _setToArray = setToArray$3, Symbol$5 = _Symbol, Uint8Array$3 = _Uint8Array, eq$5 = eq_1, equalArrays$2 = _equalArrays, mapToArray$1 = _mapToArray, setToArray$2 = _setToArray, COMPARE_PARTIAL_FLAG$a = 1, COMPARE_UNORDERED_FLAG$6 = 2, boolTag$4 = "[object Boolean]", dateTag$4 = "[object Date]", errorTag$3 = "[object Error]", mapTag$7 = "[object Map]", numberTag$4 = "[object Number]", regexpTag$4 = "[object RegExp]", setTag$7 = "[object Set]", stringTag$4 = "[object String]", symbolTag$6 = "[object Symbol]", arrayBufferTag$4 = "[object ArrayBuffer]", dataViewTag$6 = "[object DataView]", symbolProto$5 = Symbol$5 ? Symbol$5.prototype : void 0, symbolValueOf$2 = symbolProto$5 ? symbolProto$5.valueOf : void 0;
function equalByTag$2(T, S, R, k, D, L, V) {
  switch (R) {
    case dataViewTag$6:
      if (T.byteLength != S.byteLength || T.byteOffset != S.byteOffset)
        return !1;
      T = T.buffer, S = S.buffer;
    case arrayBufferTag$4:
      return !(T.byteLength != S.byteLength || !L(new Uint8Array$3(T), new Uint8Array$3(S)));
    case boolTag$4:
    case dateTag$4:
    case numberTag$4:
      return eq$5(+T, +S);
    case errorTag$3:
      return T.name == S.name && T.message == S.message;
    case regexpTag$4:
    case stringTag$4:
      return T == S + "";
    case mapTag$7:
      var z = mapToArray$1;
    case setTag$7:
      var W = k & COMPARE_PARTIAL_FLAG$a;
      if (z || (z = setToArray$2), T.size != S.size && !W)
        return !1;
      var U = V.get(T);
      if (U)
        return U == S;
      k |= COMPARE_UNORDERED_FLAG$6, V.set(T, S);
      var q = equalArrays$2(z(T), z(S), k, D, L, V);
      return V.delete(T), q;
    case symbolTag$6:
      if (symbolValueOf$2)
        return symbolValueOf$2.call(T) == symbolValueOf$2.call(S);
  }
  return !1;
}
var _equalByTag = equalByTag$2;
function arrayPush$4(T, S) {
  for (var R = -1, k = S.length, D = T.length; ++R < k; )
    T[D + R] = S[R];
  return T;
}
var _arrayPush = arrayPush$4, arrayPush$3 = _arrayPush, isArray$i = isArray_1;
function baseGetAllKeys$3(T, S, R) {
  var k = S(T);
  return isArray$i(T) ? k : arrayPush$3(k, R(T));
}
var _baseGetAllKeys = baseGetAllKeys$3;
function arrayFilter$2(T, S) {
  for (var R = -1, k = T == null ? 0 : T.length, D = 0, L = []; ++R < k; ) {
    var V = T[R];
    S(V, R, T) && (L[D++] = V);
  }
  return L;
}
var _arrayFilter = arrayFilter$2;
function stubArray$3() {
  return [];
}
var stubArray_1 = stubArray$3, arrayFilter$1 = _arrayFilter, stubArray$2 = stubArray_1, objectProto$m = Object.prototype, propertyIsEnumerable$2 = objectProto$m.propertyIsEnumerable, nativeGetSymbols$2 = Object.getOwnPropertySymbols, getSymbols$4 = nativeGetSymbols$2 ? function(T) {
  return T == null ? [] : (T = Object(T), arrayFilter$1(nativeGetSymbols$2(T), function(S) {
    return propertyIsEnumerable$2.call(T, S);
  }));
} : stubArray$2, _getSymbols = getSymbols$4, baseGetAllKeys$2 = _baseGetAllKeys, getSymbols$3 = _getSymbols, keys$5 = keys_1;
function getAllKeys$3(T) {
  return baseGetAllKeys$2(T, keys$5, getSymbols$3);
}
var _getAllKeys = getAllKeys$3, getAllKeys$2 = _getAllKeys, COMPARE_PARTIAL_FLAG$9 = 1, objectProto$l = Object.prototype, hasOwnProperty$j = objectProto$l.hasOwnProperty;
function equalObjects$2(T, S, R, k, D, L) {
  var V = R & COMPARE_PARTIAL_FLAG$9, z = getAllKeys$2(T), W = z.length, U = getAllKeys$2(S), q = U.length;
  if (W != q && !V)
    return !1;
  for (var K = W; K--; ) {
    var Y = z[K];
    if (!(V ? Y in S : hasOwnProperty$j.call(S, Y)))
      return !1;
  }
  var J = L.get(T), Z = L.get(S);
  if (J && Z)
    return J == S && Z == T;
  var X = !0;
  L.set(T, S), L.set(S, T);
  for (var ee = V; ++K < W; ) {
    Y = z[K];
    var te = T[Y], re = S[Y];
    if (k)
      var Q = V ? k(re, te, Y, S, T, L) : k(te, re, Y, T, S, L);
    if (!(Q === void 0 ? te === re || D(te, re, R, k, L) : Q)) {
      X = !1;
      break;
    }
    ee || (ee = Y == "constructor");
  }
  if (X && !ee) {
    var ne = T.constructor, oe = S.constructor;
    ne != oe && "constructor" in T && "constructor" in S && !(typeof ne == "function" && ne instanceof ne && typeof oe == "function" && oe instanceof oe) && (X = !1);
  }
  return L.delete(T), L.delete(S), X;
}
var _equalObjects = equalObjects$2, getNative$6 = _getNative, root$5 = _root, DataView$3 = getNative$6(root$5, "DataView"), _DataView = DataView$3, getNative$5 = _getNative, root$4 = _root, Promise$3 = getNative$5(root$4, "Promise"), _Promise = Promise$3, getNative$4 = _getNative, root$3 = _root, Set$4 = getNative$4(root$3, "Set"), _Set = Set$4, getNative$3 = _getNative, root$2 = _root, WeakMap$3 = getNative$3(root$2, "WeakMap"), _WeakMap = WeakMap$3, DataView$2 = _DataView, Map$2 = _Map, Promise$2 = _Promise, Set$3 = _Set, WeakMap$2 = _WeakMap, baseGetTag$3 = _baseGetTag, toSource$2 = _toSource, mapTag$6 = "[object Map]", objectTag$6 = "[object Object]", promiseTag$1 = "[object Promise]", setTag$6 = "[object Set]", weakMapTag$3 = "[object WeakMap]", dataViewTag$5 = "[object DataView]", dataViewCtorString$1 = toSource$2(DataView$2), mapCtorString$1 = toSource$2(Map$2), promiseCtorString$1 = toSource$2(Promise$2), setCtorString$1 = toSource$2(Set$3), weakMapCtorString$1 = toSource$2(WeakMap$2), getTag$5 = baseGetTag$3;
(DataView$2 && getTag$5(new DataView$2(new ArrayBuffer(1))) != dataViewTag$5 || Map$2 && getTag$5(new Map$2()) != mapTag$6 || Promise$2 && getTag$5(Promise$2.resolve()) != promiseTag$1 || Set$3 && getTag$5(new Set$3()) != setTag$6 || WeakMap$2 && getTag$5(new WeakMap$2()) != weakMapTag$3) && (getTag$5 = function(T) {
  var S = baseGetTag$3(T), R = S == objectTag$6 ? T.constructor : void 0, k = R ? toSource$2(R) : "";
  if (k)
    switch (k) {
      case dataViewCtorString$1:
        return dataViewTag$5;
      case mapCtorString$1:
        return mapTag$6;
      case promiseCtorString$1:
        return promiseTag$1;
      case setCtorString$1:
        return setTag$6;
      case weakMapCtorString$1:
        return weakMapTag$3;
    }
  return S;
});
var _getTag = getTag$5, Stack$9 = _Stack, equalArrays$1 = _equalArrays, equalByTag$1 = _equalByTag, equalObjects$1 = _equalObjects, getTag$4 = _getTag, isArray$h = isArray_1, isBuffer$4 = isBufferExports, isTypedArray$3 = isTypedArray_1, COMPARE_PARTIAL_FLAG$8 = 1, argsTag$4 = "[object Arguments]", arrayTag$3 = "[object Array]", objectTag$5 = "[object Object]", objectProto$k = Object.prototype, hasOwnProperty$i = objectProto$k.hasOwnProperty;
function baseIsEqualDeep$2(T, S, R, k, D, L) {
  var V = isArray$h(T), z = isArray$h(S), W = V ? arrayTag$3 : getTag$4(T), U = z ? arrayTag$3 : getTag$4(S);
  W = W == argsTag$4 ? objectTag$5 : W, U = U == argsTag$4 ? objectTag$5 : U;
  var q = W == objectTag$5, K = U == objectTag$5, Y = W == U;
  if (Y && isBuffer$4(T)) {
    if (!isBuffer$4(S))
      return !1;
    V = !0, q = !1;
  }
  if (Y && !q)
    return L || (L = new Stack$9()), V || isTypedArray$3(T) ? equalArrays$1(T, S, R, k, D, L) : equalByTag$1(T, S, W, R, k, D, L);
  if (!(R & COMPARE_PARTIAL_FLAG$8)) {
    var J = q && hasOwnProperty$i.call(T, "__wrapped__"), Z = K && hasOwnProperty$i.call(S, "__wrapped__");
    if (J || Z) {
      var X = J ? T.value() : T, ee = Z ? S.value() : S;
      return L || (L = new Stack$9()), D(X, ee, R, k, L);
    }
  }
  return Y ? (L || (L = new Stack$9()), equalObjects$1(T, S, R, k, D, L)) : !1;
}
var _baseIsEqualDeep = baseIsEqualDeep$2, baseIsEqualDeep$1 = _baseIsEqualDeep, isObjectLike$6 = isObjectLike_1;
function baseIsEqual$4(T, S, R, k, D) {
  return T === S ? !0 : T == null || S == null || !isObjectLike$6(T) && !isObjectLike$6(S) ? T !== T && S !== S : baseIsEqualDeep$1(T, S, R, k, baseIsEqual$4, D);
}
var _baseIsEqual = baseIsEqual$4, Stack$8 = _Stack, baseIsEqual$3 = _baseIsEqual, COMPARE_PARTIAL_FLAG$7 = 1, COMPARE_UNORDERED_FLAG$5 = 2;
function baseIsMatch$2(T, S, R, k) {
  var D = R.length, L = D, V = !k;
  if (T == null)
    return !L;
  for (T = Object(T); D--; ) {
    var z = R[D];
    if (V && z[2] ? z[1] !== T[z[0]] : !(z[0] in T))
      return !1;
  }
  for (; ++D < L; ) {
    z = R[D];
    var W = z[0], U = T[W], q = z[1];
    if (V && z[2]) {
      if (U === void 0 && !(W in T))
        return !1;
    } else {
      var K = new Stack$8();
      if (k)
        var Y = k(U, q, W, T, S, K);
      if (!(Y === void 0 ? baseIsEqual$3(q, U, COMPARE_PARTIAL_FLAG$7 | COMPARE_UNORDERED_FLAG$5, k, K) : Y))
        return !1;
    }
  }
  return !0;
}
var _baseIsMatch = baseIsMatch$2, isObject$d = isObject_1;
function isStrictComparable$3(T) {
  return T === T && !isObject$d(T);
}
var _isStrictComparable = isStrictComparable$3, isStrictComparable$2 = _isStrictComparable, keys$4 = keys_1;
function getMatchData$2(T) {
  for (var S = keys$4(T), R = S.length; R--; ) {
    var k = S[R], D = T[k];
    S[R] = [k, D, isStrictComparable$2(D)];
  }
  return S;
}
var _getMatchData = getMatchData$2;
function matchesStrictComparable$3(T, S) {
  return function(R) {
    return R == null ? !1 : R[T] === S && (S !== void 0 || T in Object(R));
  };
}
var _matchesStrictComparable = matchesStrictComparable$3, baseIsMatch$1 = _baseIsMatch, getMatchData$1 = _getMatchData, matchesStrictComparable$2 = _matchesStrictComparable;
function baseMatches$2(T) {
  var S = getMatchData$1(T);
  return S.length == 1 && S[0][2] ? matchesStrictComparable$2(S[0][0], S[0][1]) : function(R) {
    return R === T || baseIsMatch$1(R, T, S);
  };
}
var _baseMatches = baseMatches$2, baseGetTag$2 = _baseGetTag, isObjectLike$5 = isObjectLike_1, symbolTag$5 = "[object Symbol]";
function isSymbol$7(T) {
  return typeof T == "symbol" || isObjectLike$5(T) && baseGetTag$2(T) == symbolTag$5;
}
var isSymbol_1 = isSymbol$7, isArray$g = isArray_1, isSymbol$6 = isSymbol_1, reIsDeepProp$2 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp$2 = /^\w*$/;
function isKey$5(T, S) {
  if (isArray$g(T))
    return !1;
  var R = typeof T;
  return R == "number" || R == "symbol" || R == "boolean" || T == null || isSymbol$6(T) ? !0 : reIsPlainProp$2.test(T) || !reIsDeepProp$2.test(T) || S != null && T in Object(S);
}
var _isKey = isKey$5, MapCache$2 = _MapCache, FUNC_ERROR_TEXT$6 = "Expected a function";
function memoize$6(T, S) {
  if (typeof T != "function" || S != null && typeof S != "function")
    throw new TypeError(FUNC_ERROR_TEXT$6);
  var R = function() {
    var k = arguments, D = S ? S.apply(this, k) : k[0], L = R.cache;
    if (L.has(D))
      return L.get(D);
    var V = T.apply(this, k);
    return R.cache = L.set(D, V) || L, V;
  };
  return R.cache = new (memoize$6.Cache || MapCache$2)(), R;
}
memoize$6.Cache = MapCache$2;
var memoize_1 = memoize$6, memoize$5 = memoize_1, MAX_MEMOIZE_SIZE$2 = 500;
function memoizeCapped$3(T) {
  var S = memoize$5(T, function(k) {
    return R.size === MAX_MEMOIZE_SIZE$2 && R.clear(), k;
  }), R = S.cache;
  return S;
}
var _memoizeCapped = memoizeCapped$3, memoizeCapped$2 = _memoizeCapped, rePropName$3 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar$3 = /\\(\\)?/g, stringToPath$4 = memoizeCapped$2(function(T) {
  var S = [];
  return T.charCodeAt(0) === 46 && S.push(""), T.replace(rePropName$3, function(R, k, D, L) {
    S.push(D ? L.replace(reEscapeChar$3, "$1") : k || R);
  }), S;
}), _stringToPath = stringToPath$4, Symbol$4 = _Symbol, arrayMap$3 = _arrayMap, isArray$f = isArray_1, isSymbol$5 = isSymbol_1, INFINITY$5 = 1 / 0, symbolProto$4 = Symbol$4 ? Symbol$4.prototype : void 0, symbolToString$3 = symbolProto$4 ? symbolProto$4.toString : void 0;
function baseToString$3(T) {
  if (typeof T == "string")
    return T;
  if (isArray$f(T))
    return arrayMap$3(T, baseToString$3) + "";
  if (isSymbol$5(T))
    return symbolToString$3 ? symbolToString$3.call(T) : "";
  var S = T + "";
  return S == "0" && 1 / T == -INFINITY$5 ? "-0" : S;
}
var _baseToString = baseToString$3, baseToString$2 = _baseToString;
function toString$4(T) {
  return T == null ? "" : baseToString$2(T);
}
var toString_1 = toString$4, isArray$e = isArray_1, isKey$4 = _isKey, stringToPath$3 = _stringToPath, toString$3 = toString_1;
function castPath$6(T, S) {
  return isArray$e(T) ? T : isKey$4(T, S) ? [T] : stringToPath$3(toString$3(T));
}
var _castPath = castPath$6, isSymbol$4 = isSymbol_1, INFINITY$4 = 1 / 0;
function toKey$7(T) {
  if (typeof T == "string" || isSymbol$4(T))
    return T;
  var S = T + "";
  return S == "0" && 1 / T == -INFINITY$4 ? "-0" : S;
}
var _toKey = toKey$7, castPath$5 = _castPath, toKey$6 = _toKey;
function baseGet$5(T, S) {
  S = castPath$5(S, T);
  for (var R = 0, k = S.length; T != null && R < k; )
    T = T[toKey$6(S[R++])];
  return R && R == k ? T : void 0;
}
var _baseGet = baseGet$5, baseGet$4 = _baseGet;
function get$5(T, S, R) {
  var k = T == null ? void 0 : baseGet$4(T, S);
  return k === void 0 ? R : k;
}
var get_1 = get$5;
function baseHasIn$2(T, S) {
  return T != null && S in Object(T);
}
var _baseHasIn = baseHasIn$2, castPath$4 = _castPath, isArguments$5 = isArguments_1, isArray$d = isArray_1, isIndex$3 = _isIndex, isLength$1 = isLength_1, toKey$5 = _toKey;
function hasPath$2(T, S, R) {
  S = castPath$4(S, T);
  for (var k = -1, D = S.length, L = !1; ++k < D; ) {
    var V = toKey$5(S[k]);
    if (!(L = T != null && R(T, V)))
      break;
    T = T[V];
  }
  return L || ++k != D ? L : (D = T == null ? 0 : T.length, !!D && isLength$1(D) && isIndex$3(V, D) && (isArray$d(T) || isArguments$5(T)));
}
var _hasPath = hasPath$2, baseHasIn$1 = _baseHasIn, hasPath$1 = _hasPath;
function hasIn$3(T, S) {
  return T != null && hasPath$1(T, S, baseHasIn$1);
}
var hasIn_1 = hasIn$3, baseIsEqual$2 = _baseIsEqual, get$4 = get_1, hasIn$2 = hasIn_1, isKey$3 = _isKey, isStrictComparable$1 = _isStrictComparable, matchesStrictComparable$1 = _matchesStrictComparable, toKey$4 = _toKey, COMPARE_PARTIAL_FLAG$6 = 1, COMPARE_UNORDERED_FLAG$4 = 2;
function baseMatchesProperty$2(T, S) {
  return isKey$3(T) && isStrictComparable$1(S) ? matchesStrictComparable$1(toKey$4(T), S) : function(R) {
    var k = get$4(R, T);
    return k === void 0 && k === S ? hasIn$2(R, T) : baseIsEqual$2(S, k, COMPARE_PARTIAL_FLAG$6 | COMPARE_UNORDERED_FLAG$4);
  };
}
var _baseMatchesProperty = baseMatchesProperty$2;
function baseProperty$2(T) {
  return function(S) {
    return S?.[T];
  };
}
var _baseProperty = baseProperty$2, baseGet$3 = _baseGet;
function basePropertyDeep$2(T) {
  return function(S) {
    return baseGet$3(S, T);
  };
}
var _basePropertyDeep = basePropertyDeep$2, baseProperty$1 = _baseProperty, basePropertyDeep$1 = _basePropertyDeep, isKey$2 = _isKey, toKey$3 = _toKey;
function property$2(T) {
  return isKey$2(T) ? baseProperty$1(toKey$3(T)) : basePropertyDeep$1(T);
}
var property_1 = property$2, baseMatches$1 = _baseMatches, baseMatchesProperty$1 = _baseMatchesProperty, identity$3 = identity_1, isArray$c = isArray_1, property$1 = property_1;
function baseIteratee$4(T) {
  return typeof T == "function" ? T : T == null ? identity$3 : typeof T == "object" ? isArray$c(T) ? baseMatchesProperty$1(T[0], T[1]) : baseMatches$1(T) : property$1(T);
}
var _baseIteratee = baseIteratee$4, isArrayLike$5 = isArrayLike_1;
function createBaseEach$2(T, S) {
  return function(R, k) {
    if (R == null)
      return R;
    if (!isArrayLike$5(R))
      return T(R, k);
    for (var D = R.length, L = S ? D : -1, V = Object(R); (S ? L-- : ++L < D) && k(V[L], L, V) !== !1; )
      ;
    return R;
  };
}
var _createBaseEach = createBaseEach$2, baseForOwn$2 = _baseForOwn, createBaseEach$1 = _createBaseEach, baseEach$4 = createBaseEach$1(baseForOwn$2), _baseEach = baseEach$4, baseEach$3 = _baseEach, isArrayLike$4 = isArrayLike_1;
function baseMap$2(T, S) {
  var R = -1, k = isArrayLike$4(T) ? Array(T.length) : [];
  return baseEach$3(T, function(D, L, V) {
    k[++R] = S(D, L, V);
  }), k;
}
var _baseMap = baseMap$2, arrayMap$2 = _arrayMap, baseIteratee$3 = _baseIteratee, baseMap$1 = _baseMap, isArray$b = isArray_1;
function map$2(T, S) {
  var R = isArray$b(T) ? arrayMap$2 : baseMap$1;
  return R(T, baseIteratee$3(S));
}
var map_1 = map$2;
Object.defineProperty(flattenNames$1, "__esModule", {
  value: !0
});
flattenNames$1.flattenNames = void 0;
var _isString2 = isString_1, _isString3 = _interopRequireDefault$j(_isString2), _forOwn2$2 = forOwn_1, _forOwn3$2 = _interopRequireDefault$j(_forOwn2$2), _isPlainObject2 = isPlainObject_1, _isPlainObject3 = _interopRequireDefault$j(_isPlainObject2), _map2 = map_1, _map3 = _interopRequireDefault$j(_map2);
function _interopRequireDefault$j(T) {
  return T && T.__esModule ? T : { default: T };
}
var flattenNames = flattenNames$1.flattenNames = function T() {
  var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], R = [];
  return (0, _map3.default)(S, function(k) {
    Array.isArray(k) ? T(k).map(function(D) {
      return R.push(D);
    }) : (0, _isPlainObject3.default)(k) ? (0, _forOwn3$2.default)(k, function(D, L) {
      D === !0 && R.push(L), R.push(L + "-" + D);
    }) : (0, _isString3.default)(k) && R.push(k);
  }), R;
};
flattenNames$1.default = flattenNames;
var mergeClasses$1 = {};
function arrayEach$3(T, S) {
  for (var R = -1, k = T == null ? 0 : T.length; ++R < k && S(T[R], R, T) !== !1; )
    ;
  return T;
}
var _arrayEach = arrayEach$3, getNative$2 = _getNative, defineProperty$3 = function() {
  try {
    var T = getNative$2(Object, "defineProperty");
    return T({}, "", {}), T;
  } catch {
  }
}(), _defineProperty$5 = defineProperty$3, defineProperty$2 = _defineProperty$5;
function baseAssignValue$6(T, S, R) {
  S == "__proto__" && defineProperty$2 ? defineProperty$2(T, S, {
    configurable: !0,
    enumerable: !0,
    value: R,
    writable: !0
  }) : T[S] = R;
}
var _baseAssignValue = baseAssignValue$6, baseAssignValue$5 = _baseAssignValue, eq$4 = eq_1, objectProto$j = Object.prototype, hasOwnProperty$h = objectProto$j.hasOwnProperty;
function assignValue$4(T, S, R) {
  var k = T[S];
  (!(hasOwnProperty$h.call(T, S) && eq$4(k, R)) || R === void 0 && !(S in T)) && baseAssignValue$5(T, S, R);
}
var _assignValue = assignValue$4, assignValue$3 = _assignValue, baseAssignValue$4 = _baseAssignValue;
function copyObject$6(T, S, R, k) {
  var D = !R;
  R || (R = {});
  for (var L = -1, V = S.length; ++L < V; ) {
    var z = S[L], W = k ? k(R[z], T[z], z, R, T) : void 0;
    W === void 0 && (W = T[z]), D ? baseAssignValue$4(R, z, W) : assignValue$3(R, z, W);
  }
  return R;
}
var _copyObject = copyObject$6, copyObject$5 = _copyObject, keys$3 = keys_1;
function baseAssign$1(T, S) {
  return T && copyObject$5(S, keys$3(S), T);
}
var _baseAssign = baseAssign$1;
function nativeKeysIn$2(T) {
  var S = [];
  if (T != null)
    for (var R in Object(T))
      S.push(R);
  return S;
}
var _nativeKeysIn = nativeKeysIn$2, isObject$c = isObject_1, isPrototype$2 = _isPrototype, nativeKeysIn$1 = _nativeKeysIn, objectProto$i = Object.prototype, hasOwnProperty$g = objectProto$i.hasOwnProperty;
function baseKeysIn$2(T) {
  if (!isObject$c(T))
    return nativeKeysIn$1(T);
  var S = isPrototype$2(T), R = [];
  for (var k in T)
    k == "constructor" && (S || !hasOwnProperty$g.call(T, k)) || R.push(k);
  return R;
}
var _baseKeysIn = baseKeysIn$2, arrayLikeKeys$1 = _arrayLikeKeys, baseKeysIn$1 = _baseKeysIn, isArrayLike$3 = isArrayLike_1;
function keysIn$6(T) {
  return isArrayLike$3(T) ? arrayLikeKeys$1(T, !0) : baseKeysIn$1(T);
}
var keysIn_1 = keysIn$6, copyObject$4 = _copyObject, keysIn$5 = keysIn_1;
function baseAssignIn$1(T, S) {
  return T && copyObject$4(S, keysIn$5(S), T);
}
var _baseAssignIn = baseAssignIn$1, _cloneBuffer = { exports: {} };
_cloneBuffer.exports;
(function(T, S) {
  var R = _root, k = S && !S.nodeType && S, D = k && !0 && T && !T.nodeType && T, L = D && D.exports === k, V = L ? R.Buffer : void 0, z = V ? V.allocUnsafe : void 0;
  function W(U, q) {
    if (q)
      return U.slice();
    var K = U.length, Y = z ? z(K) : new U.constructor(K);
    return U.copy(Y), Y;
  }
  T.exports = W;
})(_cloneBuffer, _cloneBuffer.exports);
var _cloneBufferExports = _cloneBuffer.exports;
function copyArray$3(T, S) {
  var R = -1, k = T.length;
  for (S || (S = Array(k)); ++R < k; )
    S[R] = T[R];
  return S;
}
var _copyArray = copyArray$3, copyObject$3 = _copyObject, getSymbols$2 = _getSymbols;
function copySymbols$1(T, S) {
  return copyObject$3(T, getSymbols$2(T), S);
}
var _copySymbols = copySymbols$1, arrayPush$2 = _arrayPush, getPrototype$2 = _getPrototype, getSymbols$1 = _getSymbols, stubArray$1 = stubArray_1, nativeGetSymbols$1 = Object.getOwnPropertySymbols, getSymbolsIn$2 = nativeGetSymbols$1 ? function(T) {
  for (var S = []; T; )
    arrayPush$2(S, getSymbols$1(T)), T = getPrototype$2(T);
  return S;
} : stubArray$1, _getSymbolsIn = getSymbolsIn$2, copyObject$2 = _copyObject, getSymbolsIn$1 = _getSymbolsIn;
function copySymbolsIn$1(T, S) {
  return copyObject$2(T, getSymbolsIn$1(T), S);
}
var _copySymbolsIn = copySymbolsIn$1, baseGetAllKeys$1 = _baseGetAllKeys, getSymbolsIn = _getSymbolsIn, keysIn$4 = keysIn_1;
function getAllKeysIn$1(T) {
  return baseGetAllKeys$1(T, keysIn$4, getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn$1, objectProto$h = Object.prototype, hasOwnProperty$f = objectProto$h.hasOwnProperty;
function initCloneArray$1(T) {
  var S = T.length, R = new T.constructor(S);
  return S && typeof T[0] == "string" && hasOwnProperty$f.call(T, "index") && (R.index = T.index, R.input = T.input), R;
}
var _initCloneArray = initCloneArray$1, Uint8Array$2 = _Uint8Array;
function cloneArrayBuffer$4(T) {
  var S = new T.constructor(T.byteLength);
  return new Uint8Array$2(S).set(new Uint8Array$2(T)), S;
}
var _cloneArrayBuffer = cloneArrayBuffer$4, cloneArrayBuffer$3 = _cloneArrayBuffer;
function cloneDataView$1(T, S) {
  var R = S ? cloneArrayBuffer$3(T.buffer) : T.buffer;
  return new T.constructor(R, T.byteOffset, T.byteLength);
}
var _cloneDataView = cloneDataView$1, reFlags = /\w*$/;
function cloneRegExp$1(T) {
  var S = new T.constructor(T.source, reFlags.exec(T));
  return S.lastIndex = T.lastIndex, S;
}
var _cloneRegExp = cloneRegExp$1, Symbol$3 = _Symbol, symbolProto$3 = Symbol$3 ? Symbol$3.prototype : void 0, symbolValueOf$1 = symbolProto$3 ? symbolProto$3.valueOf : void 0;
function cloneSymbol$1(T) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(T)) : {};
}
var _cloneSymbol = cloneSymbol$1, cloneArrayBuffer$2 = _cloneArrayBuffer;
function cloneTypedArray$3(T, S) {
  var R = S ? cloneArrayBuffer$2(T.buffer) : T.buffer;
  return new T.constructor(R, T.byteOffset, T.length);
}
var _cloneTypedArray = cloneTypedArray$3, cloneArrayBuffer$1 = _cloneArrayBuffer, cloneDataView = _cloneDataView, cloneRegExp = _cloneRegExp, cloneSymbol = _cloneSymbol, cloneTypedArray$2 = _cloneTypedArray, boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$3 = "[object String]", symbolTag$4 = "[object Symbol]", arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
function initCloneByTag$1(T, S, R) {
  var k = T.constructor;
  switch (S) {
    case arrayBufferTag$3:
      return cloneArrayBuffer$1(T);
    case boolTag$3:
    case dateTag$3:
      return new k(+T);
    case dataViewTag$4:
      return cloneDataView(T, R);
    case float32Tag$2:
    case float64Tag$2:
    case int8Tag$2:
    case int16Tag$2:
    case int32Tag$2:
    case uint8Tag$2:
    case uint8ClampedTag$2:
    case uint16Tag$2:
    case uint32Tag$2:
      return cloneTypedArray$2(T, R);
    case mapTag$5:
      return new k();
    case numberTag$3:
    case stringTag$3:
      return new k(T);
    case regexpTag$3:
      return cloneRegExp(T);
    case setTag$5:
      return new k();
    case symbolTag$4:
      return cloneSymbol(T);
  }
}
var _initCloneByTag = initCloneByTag$1, isObject$b = isObject_1, objectCreate$1 = Object.create, baseCreate$2 = /* @__PURE__ */ function() {
  function T() {
  }
  return function(S) {
    if (!isObject$b(S))
      return {};
    if (objectCreate$1)
      return objectCreate$1(S);
    T.prototype = S;
    var R = new T();
    return T.prototype = void 0, R;
  };
}(), _baseCreate = baseCreate$2, baseCreate$1 = _baseCreate, getPrototype$1 = _getPrototype, isPrototype$1 = _isPrototype;
function initCloneObject$3(T) {
  return typeof T.constructor == "function" && !isPrototype$1(T) ? baseCreate$1(getPrototype$1(T)) : {};
}
var _initCloneObject = initCloneObject$3, getTag$3 = _getTag, isObjectLike$4 = isObjectLike_1, mapTag$4 = "[object Map]";
function baseIsMap$1(T) {
  return isObjectLike$4(T) && getTag$3(T) == mapTag$4;
}
var _baseIsMap = baseIsMap$1, baseIsMap = _baseIsMap, baseUnary$2 = _baseUnary, nodeUtil$2 = _nodeUtilExports, nodeIsMap = nodeUtil$2 && nodeUtil$2.isMap, isMap$2 = nodeIsMap ? baseUnary$2(nodeIsMap) : baseIsMap, isMap_1 = isMap$2, getTag$2 = _getTag, isObjectLike$3 = isObjectLike_1, setTag$4 = "[object Set]";
function baseIsSet$1(T) {
  return isObjectLike$3(T) && getTag$2(T) == setTag$4;
}
var _baseIsSet = baseIsSet$1, baseIsSet = _baseIsSet, baseUnary$1 = _baseUnary, nodeUtil$1 = _nodeUtilExports, nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet, isSet$2 = nodeIsSet ? baseUnary$1(nodeIsSet) : baseIsSet, isSet_1 = isSet$2, Stack$7 = _Stack, arrayEach$2 = _arrayEach, assignValue$2 = _assignValue, baseAssign = _baseAssign, baseAssignIn = _baseAssignIn, cloneBuffer$2 = _cloneBufferExports, copyArray$2 = _copyArray, copySymbols = _copySymbols, copySymbolsIn = _copySymbolsIn, getAllKeys$1 = _getAllKeys, getAllKeysIn = _getAllKeysIn, getTag$1 = _getTag, initCloneArray = _initCloneArray, initCloneByTag = _initCloneByTag, initCloneObject$2 = _initCloneObject, isArray$a = isArray_1, isBuffer$3 = isBufferExports, isMap$1 = isMap_1, isObject$a = isObject_1, isSet$1 = isSet_1, keys$2 = keys_1, keysIn$3 = keysIn_1, CLONE_DEEP_FLAG$1 = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$1 = 4, argsTag$3 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", errorTag$2 = "[object Error]", funcTag$3 = "[object Function]", genTag$2 = "[object GeneratorFunction]", mapTag$3 = "[object Map]", numberTag$2 = "[object Number]", objectTag$4 = "[object Object]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$2 = "[object String]", symbolTag$3 = "[object Symbol]", weakMapTag$2 = "[object WeakMap]", arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$3 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]", cloneableTags = {};
cloneableTags[argsTag$3] = cloneableTags[arrayTag$2] = cloneableTags[arrayBufferTag$2] = cloneableTags[dataViewTag$3] = cloneableTags[boolTag$2] = cloneableTags[dateTag$2] = cloneableTags[float32Tag$1] = cloneableTags[float64Tag$1] = cloneableTags[int8Tag$1] = cloneableTags[int16Tag$1] = cloneableTags[int32Tag$1] = cloneableTags[mapTag$3] = cloneableTags[numberTag$2] = cloneableTags[objectTag$4] = cloneableTags[regexpTag$2] = cloneableTags[setTag$3] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$3] = cloneableTags[uint8Tag$1] = cloneableTags[uint8ClampedTag$1] = cloneableTags[uint16Tag$1] = cloneableTags[uint32Tag$1] = !0;
cloneableTags[errorTag$2] = cloneableTags[funcTag$3] = cloneableTags[weakMapTag$2] = !1;
function baseClone$1(T, S, R, k, D, L) {
  var V, z = S & CLONE_DEEP_FLAG$1, W = S & CLONE_FLAT_FLAG, U = S & CLONE_SYMBOLS_FLAG$1;
  if (R && (V = D ? R(T, k, D, L) : R(T)), V !== void 0)
    return V;
  if (!isObject$a(T))
    return T;
  var q = isArray$a(T);
  if (q) {
    if (V = initCloneArray(T), !z)
      return copyArray$2(T, V);
  } else {
    var K = getTag$1(T), Y = K == funcTag$3 || K == genTag$2;
    if (isBuffer$3(T))
      return cloneBuffer$2(T, z);
    if (K == objectTag$4 || K == argsTag$3 || Y && !D) {
      if (V = W || Y ? {} : initCloneObject$2(T), !z)
        return W ? copySymbolsIn(T, baseAssignIn(V, T)) : copySymbols(T, baseAssign(V, T));
    } else {
      if (!cloneableTags[K])
        return D ? T : {};
      V = initCloneByTag(T, K, z);
    }
  }
  L || (L = new Stack$7());
  var J = L.get(T);
  if (J)
    return J;
  L.set(T, V), isSet$1(T) ? T.forEach(function(ee) {
    V.add(baseClone$1(ee, S, R, ee, T, L));
  }) : isMap$1(T) && T.forEach(function(ee, te) {
    V.set(te, baseClone$1(ee, S, R, te, T, L));
  });
  var Z = U ? W ? getAllKeysIn : getAllKeys$1 : W ? keysIn$3 : keys$2, X = q ? void 0 : Z(T);
  return arrayEach$2(X || T, function(ee, te) {
    X && (te = ee, ee = T[te]), assignValue$2(V, te, baseClone$1(ee, S, R, te, T, L));
  }), V;
}
var _baseClone = baseClone$1, baseClone = _baseClone, CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
function cloneDeep(T) {
  return baseClone(T, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
var cloneDeep_1 = cloneDeep;
Object.defineProperty(mergeClasses$1, "__esModule", {
  value: !0
});
mergeClasses$1.mergeClasses = void 0;
var _forOwn2$1 = forOwn_1, _forOwn3$1 = _interopRequireDefault$i(_forOwn2$1), _cloneDeep2 = cloneDeep_1, _cloneDeep3 = _interopRequireDefault$i(_cloneDeep2), _extends$n = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
};
function _interopRequireDefault$i(T) {
  return T && T.__esModule ? T : { default: T };
}
var mergeClasses = mergeClasses$1.mergeClasses = function(S) {
  var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], k = S.default && (0, _cloneDeep3.default)(S.default) || {};
  return R.map(function(D) {
    var L = S[D];
    return L && (0, _forOwn3$1.default)(L, function(V, z) {
      k[z] || (k[z] = {}), k[z] = _extends$n({}, k[z], L[z]);
    }), D;
  }), k;
};
mergeClasses$1.default = mergeClasses;
var autoprefix$1 = {};
Object.defineProperty(autoprefix$1, "__esModule", {
  value: !0
});
autoprefix$1.autoprefix = void 0;
var _forOwn2 = forOwn_1, _forOwn3 = _interopRequireDefault$h(_forOwn2), _extends$m = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
};
function _interopRequireDefault$h(T) {
  return T && T.__esModule ? T : { default: T };
}
var transforms = {
  borderRadius: function(S) {
    return {
      msBorderRadius: S,
      MozBorderRadius: S,
      OBorderRadius: S,
      WebkitBorderRadius: S,
      borderRadius: S
    };
  },
  boxShadow: function(S) {
    return {
      msBoxShadow: S,
      MozBoxShadow: S,
      OBoxShadow: S,
      WebkitBoxShadow: S,
      boxShadow: S
    };
  },
  userSelect: function(S) {
    return {
      WebkitTouchCallout: S,
      KhtmlUserSelect: S,
      MozUserSelect: S,
      msUserSelect: S,
      WebkitUserSelect: S,
      userSelect: S
    };
  },
  flex: function(S) {
    return {
      WebkitBoxFlex: S,
      MozBoxFlex: S,
      WebkitFlex: S,
      msFlex: S,
      flex: S
    };
  },
  flexBasis: function(S) {
    return {
      WebkitFlexBasis: S,
      flexBasis: S
    };
  },
  justifyContent: function(S) {
    return {
      WebkitJustifyContent: S,
      justifyContent: S
    };
  },
  transition: function(S) {
    return {
      msTransition: S,
      MozTransition: S,
      OTransition: S,
      WebkitTransition: S,
      transition: S
    };
  },
  transform: function(S) {
    return {
      msTransform: S,
      MozTransform: S,
      OTransform: S,
      WebkitTransform: S,
      transform: S
    };
  },
  absolute: function(S) {
    var R = S && S.split(" ");
    return {
      position: "absolute",
      top: R && R[0],
      right: R && R[1],
      bottom: R && R[2],
      left: R && R[3]
    };
  },
  extend: function(S, R) {
    var k = R[S];
    return k || {
      extend: S
    };
  }
}, autoprefix = autoprefix$1.autoprefix = function(S) {
  var R = {};
  return (0, _forOwn3.default)(S, function(k, D) {
    var L = {};
    (0, _forOwn3.default)(k, function(V, z) {
      var W = transforms[z];
      W ? L = _extends$m({}, L, W(V)) : L[z] = V;
    }), R[D] = L;
  }), R;
};
autoprefix$1.default = autoprefix;
var hover$1 = {};
Object.defineProperty(hover$1, "__esModule", {
  value: !0
});
hover$1.hover = void 0;
var _extends$l = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, _react$c = React__default, _react2$c = _interopRequireDefault$g(_react$c);
function _interopRequireDefault$g(T) {
  return T && T.__esModule ? T : { default: T };
}
function _classCallCheck$f(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$f(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$f(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var hover = hover$1.hover = function(S) {
  var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(k) {
    _inherits$f(D, k);
    function D() {
      var L, V, z, W;
      _classCallCheck$f(this, D);
      for (var U = arguments.length, q = Array(U), K = 0; K < U; K++)
        q[K] = arguments[K];
      return W = (V = (z = _possibleConstructorReturn$f(this, (L = D.__proto__ || Object.getPrototypeOf(D)).call.apply(L, [this].concat(q))), z), z.state = { hover: !1 }, z.handleMouseOver = function() {
        return z.setState({ hover: !0 });
      }, z.handleMouseOut = function() {
        return z.setState({ hover: !1 });
      }, z.render = function() {
        return _react2$c.default.createElement(
          R,
          { onMouseOver: z.handleMouseOver, onMouseOut: z.handleMouseOut },
          _react2$c.default.createElement(S, _extends$l({}, z.props, z.state))
        );
      }, V), _possibleConstructorReturn$f(z, W);
    }
    return D;
  }(_react2$c.default.Component);
};
hover$1.default = hover;
var active$1 = {};
Object.defineProperty(active$1, "__esModule", {
  value: !0
});
active$1.active = void 0;
var _extends$k = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, _react$b = React__default, _react2$b = _interopRequireDefault$f(_react$b);
function _interopRequireDefault$f(T) {
  return T && T.__esModule ? T : { default: T };
}
function _classCallCheck$e(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$e(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$e(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var active = active$1.active = function(S) {
  var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(k) {
    _inherits$e(D, k);
    function D() {
      var L, V, z, W;
      _classCallCheck$e(this, D);
      for (var U = arguments.length, q = Array(U), K = 0; K < U; K++)
        q[K] = arguments[K];
      return W = (V = (z = _possibleConstructorReturn$e(this, (L = D.__proto__ || Object.getPrototypeOf(D)).call.apply(L, [this].concat(q))), z), z.state = { active: !1 }, z.handleMouseDown = function() {
        return z.setState({ active: !0 });
      }, z.handleMouseUp = function() {
        return z.setState({ active: !1 });
      }, z.render = function() {
        return _react2$b.default.createElement(
          R,
          { onMouseDown: z.handleMouseDown, onMouseUp: z.handleMouseUp },
          _react2$b.default.createElement(S, _extends$k({}, z.props, z.state))
        );
      }, V), _possibleConstructorReturn$e(z, W);
    }
    return D;
  }(_react2$b.default.Component);
};
active$1.default = active;
var loop = {};
Object.defineProperty(loop, "__esModule", {
  value: !0
});
var loopable = function(S, R) {
  var k = {}, D = function(V) {
    var z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    k[V] = z;
  };
  return S === 0 && D("first-child"), S === R - 1 && D("last-child"), (S === 0 || S % 2 === 0) && D("even"), Math.abs(S % 2) === 1 && D("odd"), D("nth-child", S), k;
};
loop.default = loopable;
Object.defineProperty(lib$2, "__esModule", {
  value: !0
});
lib$2.ReactCSS = lib$2.loop = lib$2.handleActive = handleHover = lib$2.handleHover = lib$2.hover = void 0;
var _flattenNames = flattenNames$1, _flattenNames2 = _interopRequireDefault$e(_flattenNames), _mergeClasses = mergeClasses$1, _mergeClasses2 = _interopRequireDefault$e(_mergeClasses), _autoprefix = autoprefix$1, _autoprefix2 = _interopRequireDefault$e(_autoprefix), _hover2 = hover$1, _hover3 = _interopRequireDefault$e(_hover2), _active = active$1, _active2 = _interopRequireDefault$e(_active), _loop2 = loop, _loop3 = _interopRequireDefault$e(_loop2);
function _interopRequireDefault$e(T) {
  return T && T.__esModule ? T : { default: T };
}
lib$2.hover = _hover3.default;
var handleHover = lib$2.handleHover = _hover3.default;
lib$2.handleActive = _active2.default;
lib$2.loop = _loop3.default;
var ReactCSS = lib$2.ReactCSS = function(S) {
  for (var R = arguments.length, k = Array(R > 1 ? R - 1 : 0), D = 1; D < R; D++)
    k[D - 1] = arguments[D];
  var L = (0, _flattenNames2.default)(k), V = (0, _mergeClasses2.default)(S, L);
  return (0, _autoprefix2.default)(V);
}, _default$3 = lib$2.default = ReactCSS, calculateChange$2 = function(S, R, k, D, L) {
  var V = L.clientWidth, z = L.clientHeight, W = typeof S.pageX == "number" ? S.pageX : S.touches[0].pageX, U = typeof S.pageY == "number" ? S.pageY : S.touches[0].pageY, q = W - (L.getBoundingClientRect().left + window.pageXOffset), K = U - (L.getBoundingClientRect().top + window.pageYOffset);
  if (k === "vertical") {
    var Y = void 0;
    if (K < 0 ? Y = 0 : K > z ? Y = 1 : Y = Math.round(K * 100 / z) / 100, R.a !== Y)
      return {
        h: R.h,
        s: R.s,
        l: R.l,
        a: Y,
        source: "rgb"
      };
  } else {
    var J = void 0;
    if (q < 0 ? J = 0 : q > V ? J = 1 : J = Math.round(q * 100 / V) / 100, D !== J)
      return {
        h: R.h,
        s: R.s,
        l: R.l,
        a: J,
        source: "rgb"
      };
  }
  return null;
}, checkboardCache$1 = {}, render$1 = function(S, R, k, D) {
  if (typeof document > "u" && !D)
    return null;
  var L = D ? new D() : document.createElement("canvas");
  L.width = k * 2, L.height = k * 2;
  var V = L.getContext("2d");
  return V ? (V.fillStyle = S, V.fillRect(0, 0, L.width, L.height), V.fillStyle = R, V.fillRect(0, 0, k, k), V.translate(k, k), V.fillRect(0, 0, k, k), L.toDataURL()) : null;
}, get$3 = function(S, R, k, D) {
  var L = S + "-" + R + "-" + k + (D ? "-server" : "");
  if (checkboardCache$1[L])
    return checkboardCache$1[L];
  var V = render$1(S, R, k, D);
  return checkboardCache$1[L] = V, V;
}, _extends$j = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, Checkboard$2 = function(S) {
  var R = S.white, k = S.grey, D = S.size, L = S.renderers, V = S.borderRadius, z = S.boxShadow, W = S.children, U = _default$3({
    default: {
      grid: {
        borderRadius: V,
        boxShadow: z,
        absolute: "0px 0px 0px 0px",
        background: "url(" + get$3(R, k, D, L.canvas) + ") center left"
      }
    }
  });
  return isValidElement(W) ? React__default.cloneElement(W, _extends$j({}, W.props, { style: _extends$j({}, W.props.style, U.grid) })) : React__default.createElement("div", { style: U.grid });
};
Checkboard$2.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
var _extends$i = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, _createClass$d = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}();
function _classCallCheck$d(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$d(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$d(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var Alpha$2 = function(T) {
  _inherits$d(S, T);
  function S() {
    var R, k, D, L;
    _classCallCheck$d(this, S);
    for (var V = arguments.length, z = Array(V), W = 0; W < V; W++)
      z[W] = arguments[W];
    return L = (k = (D = _possibleConstructorReturn$d(this, (R = S.__proto__ || Object.getPrototypeOf(S)).call.apply(R, [this].concat(z))), D), D.handleChange = function(U) {
      var q = calculateChange$2(U, D.props.hsl, D.props.direction, D.props.a, D.container);
      q && typeof D.props.onChange == "function" && D.props.onChange(q, U);
    }, D.handleMouseDown = function(U) {
      D.handleChange(U), window.addEventListener("mousemove", D.handleChange), window.addEventListener("mouseup", D.handleMouseUp);
    }, D.handleMouseUp = function() {
      D.unbindEventListeners();
    }, D.unbindEventListeners = function() {
      window.removeEventListener("mousemove", D.handleChange), window.removeEventListener("mouseup", D.handleMouseUp);
    }, k), _possibleConstructorReturn$d(D, L);
  }
  return _createClass$d(S, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function() {
      var k = this, D = this.props.rgb, L = _default$3({
        default: {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + D.r + "," + D.g + "," + D.b + `, 0) 0%,
           rgba(` + D.r + "," + D.g + "," + D.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: D.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + D.r + "," + D.g + "," + D.b + `, 0) 0%,
           rgba(` + D.r + "," + D.g + "," + D.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: D.a * 100 + "%"
          }
        },
        overwrite: _extends$i({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: !0
      });
      return React__default.createElement(
        "div",
        { style: L.alpha },
        React__default.createElement(
          "div",
          { style: L.checkboard },
          React__default.createElement(Checkboard$2, { renderers: this.props.renderers })
        ),
        React__default.createElement("div", { style: L.gradient }),
        React__default.createElement(
          "div",
          {
            style: L.container,
            ref: function(z) {
              return k.container = z;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          React__default.createElement(
            "div",
            { style: L.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement("div", { style: L.slider })
          )
        )
      );
    }
  }]), S;
}(PureComponent || Component), _createClass$c = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}();
function _defineProperty$4(T, S, R) {
  return S in T ? Object.defineProperty(T, S, { value: R, enumerable: !0, configurable: !0, writable: !0 }) : T[S] = R, T;
}
function _classCallCheck$c(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$c(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$c(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var DEFAULT_ARROW_OFFSET$1 = 1, UP_KEY_CODE$1 = 38, DOWN_KEY_CODE$1 = 40, VALID_KEY_CODES$1 = [UP_KEY_CODE$1, DOWN_KEY_CODE$1], isValidKeyCode$1 = function(S) {
  return VALID_KEY_CODES$1.indexOf(S) > -1;
}, getNumberValue$1 = function(S) {
  return Number(String(S).replace(/%/g, ""));
}, idCounter$2 = 1, EditableInput$2 = function(T) {
  _inherits$c(S, T);
  function S(R) {
    _classCallCheck$c(this, S);
    var k = _possibleConstructorReturn$c(this, (S.__proto__ || Object.getPrototypeOf(S)).call(this));
    return k.handleBlur = function() {
      k.state.blurValue && k.setState({ value: k.state.blurValue, blurValue: null });
    }, k.handleChange = function(D) {
      k.setUpdatedValue(D.target.value, D);
    }, k.handleKeyDown = function(D) {
      var L = getNumberValue$1(D.target.value);
      if (!isNaN(L) && isValidKeyCode$1(D.keyCode)) {
        var V = k.getArrowOffset(), z = D.keyCode === UP_KEY_CODE$1 ? L + V : L - V;
        k.setUpdatedValue(z, D);
      }
    }, k.handleDrag = function(D) {
      if (k.props.dragLabel) {
        var L = Math.round(k.props.value + D.movementX);
        L >= 0 && L <= k.props.dragMax && k.props.onChange && k.props.onChange(k.getValueObjectWithLabel(L), D);
      }
    }, k.handleMouseDown = function(D) {
      k.props.dragLabel && (D.preventDefault(), k.handleDrag(D), window.addEventListener("mousemove", k.handleDrag), window.addEventListener("mouseup", k.handleMouseUp));
    }, k.handleMouseUp = function() {
      k.unbindEventListeners();
    }, k.unbindEventListeners = function() {
      window.removeEventListener("mousemove", k.handleDrag), window.removeEventListener("mouseup", k.handleMouseUp);
    }, k.state = {
      value: String(R.value).toUpperCase(),
      blurValue: String(R.value).toUpperCase()
    }, k.inputId = "rc-editable-input-" + idCounter$2++, k;
  }
  return _createClass$c(S, [{
    key: "componentDidUpdate",
    value: function(k, D) {
      this.props.value !== this.state.value && (k.value !== this.props.value || D.value !== this.state.value) && (this.input === document.activeElement ? this.setState({ blurValue: String(this.props.value).toUpperCase() }) : this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function(k) {
      return _defineProperty$4({}, this.props.label, k);
    }
  }, {
    key: "getArrowOffset",
    value: function() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET$1;
    }
  }, {
    key: "setUpdatedValue",
    value: function(k, D) {
      var L = this.props.label ? this.getValueObjectWithLabel(k) : k;
      this.props.onChange && this.props.onChange(L, D), this.setState({ value: k });
    }
  }, {
    key: "render",
    value: function() {
      var k = this, D = _default$3({
        default: {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": !0
      }, this.props);
      return React__default.createElement(
        "div",
        { style: D.wrap },
        React__default.createElement("input", {
          id: this.inputId,
          style: D.input,
          ref: function(V) {
            return k.input = V;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: "false"
        }),
        this.props.label && !this.props.hideLabel ? React__default.createElement(
          "label",
          {
            htmlFor: this.inputId,
            style: D.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]), S;
}(PureComponent || Component), calculateChange$1 = function(S, R, k, D) {
  var L = D.clientWidth, V = D.clientHeight, z = typeof S.pageX == "number" ? S.pageX : S.touches[0].pageX, W = typeof S.pageY == "number" ? S.pageY : S.touches[0].pageY, U = z - (D.getBoundingClientRect().left + window.pageXOffset), q = W - (D.getBoundingClientRect().top + window.pageYOffset);
  if (R === "vertical") {
    var K = void 0;
    if (q < 0)
      K = 359;
    else if (q > V)
      K = 0;
    else {
      var Y = -(q * 100 / V) + 100;
      K = 360 * Y / 100;
    }
    if (k.h !== K)
      return {
        h: K,
        s: k.s,
        l: k.l,
        a: k.a,
        source: "hsl"
      };
  } else {
    var J = void 0;
    if (U < 0)
      J = 0;
    else if (U > L)
      J = 359;
    else {
      var Z = U * 100 / L;
      J = 360 * Z / 100;
    }
    if (k.h !== J)
      return {
        h: J,
        s: k.s,
        l: k.l,
        a: k.a,
        source: "hsl"
      };
  }
  return null;
}, _createClass$b = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}();
function _classCallCheck$b(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$b(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$b(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var Hue$2 = function(T) {
  _inherits$b(S, T);
  function S() {
    var R, k, D, L;
    _classCallCheck$b(this, S);
    for (var V = arguments.length, z = Array(V), W = 0; W < V; W++)
      z[W] = arguments[W];
    return L = (k = (D = _possibleConstructorReturn$b(this, (R = S.__proto__ || Object.getPrototypeOf(S)).call.apply(R, [this].concat(z))), D), D.handleChange = function(U) {
      var q = calculateChange$1(U, D.props.direction, D.props.hsl, D.container);
      q && typeof D.props.onChange == "function" && D.props.onChange(q, U);
    }, D.handleMouseDown = function(U) {
      D.handleChange(U), window.addEventListener("mousemove", D.handleChange), window.addEventListener("mouseup", D.handleMouseUp);
    }, D.handleMouseUp = function() {
      D.unbindEventListeners();
    }, k), _possibleConstructorReturn$b(D, L);
  }
  return _createClass$b(S, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var k = this, D = this.props.direction, L = D === void 0 ? "horizontal" : D, V = _default$3({
        default: {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, { vertical: L === "vertical" });
      return React__default.createElement(
        "div",
        { style: V.hue },
        React__default.createElement(
          "div",
          {
            className: "hue-" + L,
            style: V.container,
            ref: function(W) {
              return k.container = W;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          React__default.createElement(
            "style",
            null,
            `
            .hue-horizontal {
              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0
                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to right, #f00 0%, #ff0
                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }

            .hue-vertical {
              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,
                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,
                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }
          `
          ),
          React__default.createElement(
            "div",
            { style: V.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement("div", { style: V.slider })
          )
        )
      );
    }
  }]), S;
}(PureComponent || Component);
function listCacheClear$1() {
  this.__data__ = [], this.size = 0;
}
function eq$3(T, S) {
  return T === S || T !== T && S !== S;
}
function assocIndexOf$1(T, S) {
  for (var R = T.length; R--; )
    if (eq$3(T[R][0], S))
      return R;
  return -1;
}
var arrayProto$1 = Array.prototype, splice$1 = arrayProto$1.splice;
function listCacheDelete$1(T) {
  var S = this.__data__, R = assocIndexOf$1(S, T);
  if (R < 0)
    return !1;
  var k = S.length - 1;
  return R == k ? S.pop() : splice$1.call(S, R, 1), --this.size, !0;
}
function listCacheGet$1(T) {
  var S = this.__data__, R = assocIndexOf$1(S, T);
  return R < 0 ? void 0 : S[R][1];
}
function listCacheHas$1(T) {
  return assocIndexOf$1(this.__data__, T) > -1;
}
function listCacheSet$1(T, S) {
  var R = this.__data__, k = assocIndexOf$1(R, T);
  return k < 0 ? (++this.size, R.push([T, S])) : R[k][1] = S, this;
}
function ListCache$1(T) {
  var S = -1, R = T == null ? 0 : T.length;
  for (this.clear(); ++S < R; ) {
    var k = T[S];
    this.set(k[0], k[1]);
  }
}
ListCache$1.prototype.clear = listCacheClear$1;
ListCache$1.prototype.delete = listCacheDelete$1;
ListCache$1.prototype.get = listCacheGet$1;
ListCache$1.prototype.has = listCacheHas$1;
ListCache$1.prototype.set = listCacheSet$1;
function stackClear() {
  this.__data__ = new ListCache$1(), this.size = 0;
}
function stackDelete(T) {
  var S = this.__data__, R = S.delete(T);
  return this.size = S.size, R;
}
function stackGet(T) {
  return this.__data__.get(T);
}
function stackHas(T) {
  return this.__data__.has(T);
}
var freeGlobal$1 = typeof global == "object" && global && global.Object === Object && global, freeSelf$1 = typeof self == "object" && self && self.Object === Object && self, root$1 = freeGlobal$1 || freeSelf$1 || Function("return this")(), Symbol$2 = root$1.Symbol, objectProto$g = Object.prototype, hasOwnProperty$e = objectProto$g.hasOwnProperty, nativeObjectToString$2 = objectProto$g.toString, symToStringTag$2 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function getRawTag$1(T) {
  var S = hasOwnProperty$e.call(T, symToStringTag$2), R = T[symToStringTag$2];
  try {
    T[symToStringTag$2] = void 0;
    var k = !0;
  } catch {
  }
  var D = nativeObjectToString$2.call(T);
  return k && (S ? T[symToStringTag$2] = R : delete T[symToStringTag$2]), D;
}
var objectProto$f = Object.prototype, nativeObjectToString$1 = objectProto$f.toString;
function objectToString$2(T) {
  return nativeObjectToString$1.call(T);
}
var nullTag$1 = "[object Null]", undefinedTag$1 = "[object Undefined]", symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag$1(T) {
  return T == null ? T === void 0 ? undefinedTag$1 : nullTag$1 : symToStringTag$1 && symToStringTag$1 in Object(T) ? getRawTag$1(T) : objectToString$2(T);
}
function isObject$9(T) {
  var S = typeof T;
  return T != null && (S == "object" || S == "function");
}
var asyncTag$1 = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag$1 = "[object Proxy]";
function isFunction$2(T) {
  if (!isObject$9(T))
    return !1;
  var S = baseGetTag$1(T);
  return S == funcTag$2 || S == genTag$1 || S == asyncTag$1 || S == proxyTag$1;
}
var coreJsData$1 = root$1["__core-js_shared__"], maskSrcKey$1 = function() {
  var T = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return T ? "Symbol(src)_1." + T : "";
}();
function isMasked$1(T) {
  return !!maskSrcKey$1 && maskSrcKey$1 in T;
}
var funcProto$3 = Function.prototype, funcToString$3 = funcProto$3.toString;
function toSource$1(T) {
  if (T != null) {
    try {
      return funcToString$3.call(T);
    } catch {
    }
    try {
      return T + "";
    } catch {
    }
  }
  return "";
}
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor$1 = /^\[object .+?Constructor\]$/, funcProto$2 = Function.prototype, objectProto$e = Object.prototype, funcToString$2 = funcProto$2.toString, hasOwnProperty$d = objectProto$e.hasOwnProperty, reIsNative$1 = RegExp(
  "^" + funcToString$2.call(hasOwnProperty$d).replace(reRegExpChar$1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(T) {
  if (!isObject$9(T) || isMasked$1(T))
    return !1;
  var S = isFunction$2(T) ? reIsNative$1 : reIsHostCtor$1;
  return S.test(toSource$1(T));
}
function getValue$2(T, S) {
  return T?.[S];
}
function getNative$1(T, S) {
  var R = getValue$2(T, S);
  return baseIsNative$1(R) ? R : void 0;
}
var Map$1 = getNative$1(root$1, "Map"), nativeCreate$1 = getNative$1(Object, "create");
function hashClear$1() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {}, this.size = 0;
}
function hashDelete$1(T) {
  var S = this.has(T) && delete this.__data__[T];
  return this.size -= S ? 1 : 0, S;
}
var HASH_UNDEFINED$3 = "__lodash_hash_undefined__", objectProto$d = Object.prototype, hasOwnProperty$c = objectProto$d.hasOwnProperty;
function hashGet$1(T) {
  var S = this.__data__;
  if (nativeCreate$1) {
    var R = S[T];
    return R === HASH_UNDEFINED$3 ? void 0 : R;
  }
  return hasOwnProperty$c.call(S, T) ? S[T] : void 0;
}
var objectProto$c = Object.prototype, hasOwnProperty$b = objectProto$c.hasOwnProperty;
function hashHas$1(T) {
  var S = this.__data__;
  return nativeCreate$1 ? S[T] !== void 0 : hasOwnProperty$b.call(S, T);
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
function hashSet$1(T, S) {
  var R = this.__data__;
  return this.size += this.has(T) ? 0 : 1, R[T] = nativeCreate$1 && S === void 0 ? HASH_UNDEFINED$2 : S, this;
}
function Hash$1(T) {
  var S = -1, R = T == null ? 0 : T.length;
  for (this.clear(); ++S < R; ) {
    var k = T[S];
    this.set(k[0], k[1]);
  }
}
Hash$1.prototype.clear = hashClear$1;
Hash$1.prototype.delete = hashDelete$1;
Hash$1.prototype.get = hashGet$1;
Hash$1.prototype.has = hashHas$1;
Hash$1.prototype.set = hashSet$1;
function mapCacheClear$1() {
  this.size = 0, this.__data__ = {
    hash: new Hash$1(),
    map: new (Map$1 || ListCache$1)(),
    string: new Hash$1()
  };
}
function isKeyable$1(T) {
  var S = typeof T;
  return S == "string" || S == "number" || S == "symbol" || S == "boolean" ? T !== "__proto__" : T === null;
}
function getMapData$1(T, S) {
  var R = T.__data__;
  return isKeyable$1(S) ? R[typeof S == "string" ? "string" : "hash"] : R.map;
}
function mapCacheDelete$1(T) {
  var S = getMapData$1(this, T).delete(T);
  return this.size -= S ? 1 : 0, S;
}
function mapCacheGet$1(T) {
  return getMapData$1(this, T).get(T);
}
function mapCacheHas$1(T) {
  return getMapData$1(this, T).has(T);
}
function mapCacheSet$1(T, S) {
  var R = getMapData$1(this, T), k = R.size;
  return R.set(T, S), this.size += R.size == k ? 0 : 1, this;
}
function MapCache$1(T) {
  var S = -1, R = T == null ? 0 : T.length;
  for (this.clear(); ++S < R; ) {
    var k = T[S];
    this.set(k[0], k[1]);
  }
}
MapCache$1.prototype.clear = mapCacheClear$1;
MapCache$1.prototype.delete = mapCacheDelete$1;
MapCache$1.prototype.get = mapCacheGet$1;
MapCache$1.prototype.has = mapCacheHas$1;
MapCache$1.prototype.set = mapCacheSet$1;
var LARGE_ARRAY_SIZE = 200;
function stackSet(T, S) {
  var R = this.__data__;
  if (R instanceof ListCache$1) {
    var k = R.__data__;
    if (!Map$1 || k.length < LARGE_ARRAY_SIZE - 1)
      return k.push([T, S]), this.size = ++R.size, this;
    R = this.__data__ = new MapCache$1(k);
  }
  return R.set(T, S), this.size = R.size, this;
}
function Stack$6(T) {
  var S = this.__data__ = new ListCache$1(T);
  this.size = S.size;
}
Stack$6.prototype.clear = stackClear;
Stack$6.prototype.delete = stackDelete;
Stack$6.prototype.get = stackGet;
Stack$6.prototype.has = stackHas;
Stack$6.prototype.set = stackSet;
var defineProperty$1 = function() {
  try {
    var T = getNative$1(Object, "defineProperty");
    return T({}, "", {}), T;
  } catch {
  }
}();
function baseAssignValue$3(T, S, R) {
  S == "__proto__" && defineProperty$1 ? defineProperty$1(T, S, {
    configurable: !0,
    enumerable: !0,
    value: R,
    writable: !0
  }) : T[S] = R;
}
function assignMergeValue$3(T, S, R) {
  (R !== void 0 && !eq$3(T[S], R) || R === void 0 && !(S in T)) && baseAssignValue$3(T, S, R);
}
function createBaseFor(T) {
  return function(S, R, k) {
    for (var D = -1, L = Object(S), V = k(S), z = V.length; z--; ) {
      var W = V[++D];
      if (R(L[W], W, L) === !1)
        break;
    }
    return S;
  };
}
var baseFor$1 = createBaseFor(), freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module, moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2, Buffer$1 = moduleExports$2 ? root$1.Buffer : void 0;
Buffer$1 && Buffer$1.allocUnsafe;
function cloneBuffer$1(T, S) {
  return T.slice();
}
var Uint8Array$1 = root$1.Uint8Array;
function cloneArrayBuffer(T) {
  var S = new T.constructor(T.byteLength);
  return new Uint8Array$1(S).set(new Uint8Array$1(T)), S;
}
function cloneTypedArray$1(T, S) {
  var R = cloneArrayBuffer(T.buffer);
  return new T.constructor(R, T.byteOffset, T.length);
}
function copyArray$1(T, S) {
  var R = -1, k = T.length;
  for (S || (S = Array(k)); ++R < k; )
    S[R] = T[R];
  return S;
}
var objectCreate = Object.create, baseCreate = /* @__PURE__ */ function() {
  function T() {
  }
  return function(S) {
    if (!isObject$9(S))
      return {};
    if (objectCreate)
      return objectCreate(S);
    T.prototype = S;
    var R = new T();
    return T.prototype = void 0, R;
  };
}();
function overArg(T, S) {
  return function(R) {
    return T(S(R));
  };
}
var getPrototype = overArg(Object.getPrototypeOf, Object), objectProto$b = Object.prototype;
function isPrototype(T) {
  var S = T && T.constructor, R = typeof S == "function" && S.prototype || objectProto$b;
  return T === R;
}
function initCloneObject$1(T) {
  return typeof T.constructor == "function" && !isPrototype(T) ? baseCreate(getPrototype(T)) : {};
}
function isObjectLike$2(T) {
  return T != null && typeof T == "object";
}
var argsTag$2 = "[object Arguments]";
function baseIsArguments(T) {
  return isObjectLike$2(T) && baseGetTag$1(T) == argsTag$2;
}
var objectProto$a = Object.prototype, hasOwnProperty$a = objectProto$a.hasOwnProperty, propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable, isArguments$4 = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(T) {
  return isObjectLike$2(T) && hasOwnProperty$a.call(T, "callee") && !propertyIsEnumerable$1.call(T, "callee");
}, isArray$9 = Array.isArray, MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength(T) {
  return typeof T == "number" && T > -1 && T % 1 == 0 && T <= MAX_SAFE_INTEGER$1;
}
function isArrayLike$2(T) {
  return T != null && isLength(T.length) && !isFunction$2(T);
}
function isArrayLikeObject$2(T) {
  return isObjectLike$2(T) && isArrayLike$2(T);
}
function stubFalse() {
  return !1;
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module, moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1, Buffer = moduleExports$1 ? root$1.Buffer : void 0, nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0, isBuffer$2 = nativeIsBuffer || stubFalse, objectTag$3 = "[object Object]", funcProto$1 = Function.prototype, objectProto$9 = Object.prototype, funcToString$1 = funcProto$1.toString, hasOwnProperty$9 = objectProto$9.hasOwnProperty, objectCtorString = funcToString$1.call(Object);
function isPlainObject$2(T) {
  if (!isObjectLike$2(T) || baseGetTag$1(T) != objectTag$3)
    return !1;
  var S = getPrototype(T);
  if (S === null)
    return !0;
  var R = hasOwnProperty$9.call(S, "constructor") && S.constructor;
  return typeof R == "function" && R instanceof R && funcToString$1.call(R) == objectCtorString;
}
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag$1 = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$2 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag$1 = "[object WeakMap]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = !1;
function baseIsTypedArray(T) {
  return isObjectLike$2(T) && isLength(T.length) && !!typedArrayTags[baseGetTag$1(T)];
}
function baseUnary(T) {
  return function(S) {
    return T(S);
  };
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports, freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module, moduleExports = freeModule && freeModule.exports === freeExports, freeProcess = moduleExports && freeGlobal$1.process, nodeUtil = function() {
  try {
    var T = freeModule && freeModule.require && freeModule.require("util").types;
    return T || freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch {
  }
}(), nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
function safeGet$3(T, S) {
  if (!(S === "constructor" && typeof T[S] == "function") && S != "__proto__")
    return T[S];
}
var objectProto$8 = Object.prototype, hasOwnProperty$8 = objectProto$8.hasOwnProperty;
function assignValue$1(T, S, R) {
  var k = T[S];
  (!(hasOwnProperty$8.call(T, S) && eq$3(k, R)) || R === void 0 && !(S in T)) && baseAssignValue$3(T, S, R);
}
function copyObject$1(T, S, R, k) {
  var D = !R;
  R || (R = {});
  for (var L = -1, V = S.length; ++L < V; ) {
    var z = S[L], W = void 0;
    W === void 0 && (W = T[z]), D ? baseAssignValue$3(R, z, W) : assignValue$1(R, z, W);
  }
  return R;
}
function baseTimes(T, S) {
  for (var R = -1, k = Array(T); ++R < T; )
    k[R] = S(R);
  return k;
}
var MAX_SAFE_INTEGER = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$2(T, S) {
  var R = typeof T;
  return S = S ?? MAX_SAFE_INTEGER, !!S && (R == "number" || R != "symbol" && reIsUint.test(T)) && T > -1 && T % 1 == 0 && T < S;
}
var objectProto$7 = Object.prototype, hasOwnProperty$7 = objectProto$7.hasOwnProperty;
function arrayLikeKeys(T, S) {
  var R = isArray$9(T), k = !R && isArguments$4(T), D = !R && !k && isBuffer$2(T), L = !R && !k && !D && isTypedArray$2(T), V = R || k || D || L, z = V ? baseTimes(T.length, String) : [], W = z.length;
  for (var U in T)
    (S || hasOwnProperty$7.call(T, U)) && !(V && // Safari 9 has enumerable `arguments.length` in strict mode.
    (U == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    D && (U == "offset" || U == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    L && (U == "buffer" || U == "byteLength" || U == "byteOffset") || // Skip index properties.
    isIndex$2(U, W))) && z.push(U);
  return z;
}
function nativeKeysIn(T) {
  var S = [];
  if (T != null)
    for (var R in Object(T))
      S.push(R);
  return S;
}
var objectProto$6 = Object.prototype, hasOwnProperty$6 = objectProto$6.hasOwnProperty;
function baseKeysIn(T) {
  if (!isObject$9(T))
    return nativeKeysIn(T);
  var S = isPrototype(T), R = [];
  for (var k in T)
    k == "constructor" && (S || !hasOwnProperty$6.call(T, k)) || R.push(k);
  return R;
}
function keysIn$2(T) {
  return isArrayLike$2(T) ? arrayLikeKeys(T, !0) : baseKeysIn(T);
}
function toPlainObject$2(T) {
  return copyObject$1(T, keysIn$2(T));
}
function baseMergeDeep$2(T, S, R, k, D, L, V) {
  var z = safeGet$3(T, R), W = safeGet$3(S, R), U = V.get(W);
  if (U) {
    assignMergeValue$3(T, R, U);
    return;
  }
  var q = L ? L(z, W, R + "", T, S, V) : void 0, K = q === void 0;
  if (K) {
    var Y = isArray$9(W), J = !Y && isBuffer$2(W), Z = !Y && !J && isTypedArray$2(W);
    q = W, Y || J || Z ? isArray$9(z) ? q = z : isArrayLikeObject$2(z) ? q = copyArray$1(z) : J ? (K = !1, q = cloneBuffer$1(W)) : Z ? (K = !1, q = cloneTypedArray$1(W)) : q = [] : isPlainObject$2(W) || isArguments$4(W) ? (q = z, isArguments$4(z) ? q = toPlainObject$2(z) : (!isObject$9(z) || isFunction$2(z)) && (q = initCloneObject$1(W))) : K = !1;
  }
  K && (V.set(W, q), D(q, W, k, L, V), V.delete(W)), assignMergeValue$3(T, R, q);
}
function baseMerge$3(T, S, R, k, D) {
  T !== S && baseFor$1(S, function(L, V) {
    if (D || (D = new Stack$6()), isObject$9(L))
      baseMergeDeep$2(T, S, V, R, baseMerge$3, k, D);
    else {
      var z = k ? k(safeGet$3(T, V), L, V + "", T, S, D) : void 0;
      z === void 0 && (z = L), assignMergeValue$3(T, V, z);
    }
  }, keysIn$2);
}
function identity$2(T) {
  return T;
}
function apply$2(T, S, R) {
  switch (R.length) {
    case 0:
      return T.call(S);
    case 1:
      return T.call(S, R[0]);
    case 2:
      return T.call(S, R[0], R[1]);
    case 3:
      return T.call(S, R[0], R[1], R[2]);
  }
  return T.apply(S, R);
}
var nativeMax$3 = Math.max;
function overRest$3(T, S, R) {
  return S = nativeMax$3(S === void 0 ? T.length - 1 : S, 0), function() {
    for (var k = arguments, D = -1, L = nativeMax$3(k.length - S, 0), V = Array(L); ++D < L; )
      V[D] = k[S + D];
    D = -1;
    for (var z = Array(S + 1); ++D < S; )
      z[D] = k[D];
    return z[S] = R(V), apply$2(T, this, z);
  };
}
function constant$2(T) {
  return function() {
    return T;
  };
}
var baseSetToString$2 = defineProperty$1 ? function(T, S) {
  return defineProperty$1(T, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant$2(S),
    writable: !0
  });
} : identity$2, HOT_COUNT$1 = 800, HOT_SPAN$1 = 16, nativeNow$1 = Date.now;
function shortOut$2(T) {
  var S = 0, R = 0;
  return function() {
    var k = nativeNow$1(), D = HOT_SPAN$1 - (k - R);
    if (R = k, D > 0) {
      if (++S >= HOT_COUNT$1)
        return arguments[0];
    } else
      S = 0;
    return T.apply(void 0, arguments);
  };
}
var setToString$3 = shortOut$2(baseSetToString$2);
function baseRest$2(T, S) {
  return setToString$3(overRest$3(T, S, identity$2), T + "");
}
function isIterateeCall$2(T, S, R) {
  if (!isObject$9(R))
    return !1;
  var k = typeof S;
  return (k == "number" ? isArrayLike$2(R) && isIndex$2(S, R.length) : k == "string" && S in R) ? eq$3(R[S], T) : !1;
}
function createAssigner$3(T) {
  return baseRest$2(function(S, R) {
    var k = -1, D = R.length, L = D > 1 ? R[D - 1] : void 0, V = D > 2 ? R[2] : void 0;
    for (L = T.length > 3 && typeof L == "function" ? (D--, L) : void 0, V && isIterateeCall$2(R[0], R[1], V) && (L = D < 3 ? void 0 : L, D = 1), S = Object(S); ++k < D; ) {
      var z = R[k];
      z && T(S, z, k, L);
    }
    return S;
  });
}
var merge$4 = createAssigner$3(function(T, S, R) {
  baseMerge$3(T, S, R);
}), Raised$2 = function(S) {
  var R = S.zDepth, k = S.radius, D = S.background, L = S.children, V = S.styles, z = V === void 0 ? {} : V, W = _default$3(merge$4({
    default: {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + R + "px " + R * 4 + "px rgba(0,0,0,.24)",
        borderRadius: k,
        background: D
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    square: {
      bg: {
        borderRadius: "0"
      }
    },
    circle: {
      bg: {
        borderRadius: "50%"
      }
    }
  }, z), { "zDepth-1": R === 1 });
  return React__default.createElement(
    "div",
    { style: W.wrap },
    React__default.createElement("div", { style: W.bg }),
    React__default.createElement(
      "div",
      { style: W.content },
      L
    )
  );
};
Raised$2.propTypes = {
  background: PropTypes.string,
  zDepth: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
  radius: PropTypes.number,
  styles: PropTypes.object
};
Raised$2.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
var now$2 = function() {
  return root$1.Date.now();
}, reWhitespace$1 = /\s/;
function trimmedEndIndex$2(T) {
  for (var S = T.length; S-- && reWhitespace$1.test(T.charAt(S)); )
    ;
  return S;
}
var reTrimStart$1 = /^\s+/;
function baseTrim$2(T) {
  return T && T.slice(0, trimmedEndIndex$2(T) + 1).replace(reTrimStart$1, "");
}
var symbolTag$2 = "[object Symbol]";
function isSymbol$3(T) {
  return typeof T == "symbol" || isObjectLike$2(T) && baseGetTag$1(T) == symbolTag$2;
}
var NAN$1 = NaN, reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i, reIsBinary$1 = /^0b[01]+$/i, reIsOctal$1 = /^0o[0-7]+$/i, freeParseInt$1 = parseInt;
function toNumber$3(T) {
  if (typeof T == "number")
    return T;
  if (isSymbol$3(T))
    return NAN$1;
  if (isObject$9(T)) {
    var S = typeof T.valueOf == "function" ? T.valueOf() : T;
    T = isObject$9(S) ? S + "" : S;
  }
  if (typeof T != "string")
    return T === 0 ? T : +T;
  T = baseTrim$2(T);
  var R = reIsBinary$1.test(T);
  return R || reIsOctal$1.test(T) ? freeParseInt$1(T.slice(2), R ? 2 : 8) : reIsBadHex$1.test(T) ? NAN$1 : +T;
}
var FUNC_ERROR_TEXT$5 = "Expected a function", nativeMax$2 = Math.max, nativeMin$1 = Math.min;
function debounce$5(T, S, R) {
  var k, D, L, V, z, W, U = 0, q = !1, K = !1, Y = !0;
  if (typeof T != "function")
    throw new TypeError(FUNC_ERROR_TEXT$5);
  S = toNumber$3(S) || 0, isObject$9(R) && (q = !!R.leading, K = "maxWait" in R, L = K ? nativeMax$2(toNumber$3(R.maxWait) || 0, S) : L, Y = "trailing" in R ? !!R.trailing : Y);
  function J(ae) {
    var se = k, ie = D;
    return k = D = void 0, U = ae, V = T.apply(ie, se), V;
  }
  function Z(ae) {
    return U = ae, z = setTimeout(te, S), q ? J(ae) : V;
  }
  function X(ae) {
    var se = ae - W, ie = ae - U, he = S - se;
    return K ? nativeMin$1(he, L - ie) : he;
  }
  function ee(ae) {
    var se = ae - W, ie = ae - U;
    return W === void 0 || se >= S || se < 0 || K && ie >= L;
  }
  function te() {
    var ae = now$2();
    if (ee(ae))
      return re(ae);
    z = setTimeout(te, X(ae));
  }
  function re(ae) {
    return z = void 0, Y && k ? J(ae) : (k = D = void 0, V);
  }
  function Q() {
    z !== void 0 && clearTimeout(z), U = 0, k = W = D = z = void 0;
  }
  function ne() {
    return z === void 0 ? V : re(now$2());
  }
  function oe() {
    var ae = now$2(), se = ee(ae);
    if (k = arguments, D = this, W = ae, se) {
      if (z === void 0)
        return Z(W);
      if (K)
        return clearTimeout(z), z = setTimeout(te, S), J(W);
    }
    return z === void 0 && (z = setTimeout(te, S)), V;
  }
  return oe.cancel = Q, oe.flush = ne, oe;
}
var FUNC_ERROR_TEXT$4 = "Expected a function";
function throttle$2(T, S, R) {
  var k = !0, D = !0;
  if (typeof T != "function")
    throw new TypeError(FUNC_ERROR_TEXT$4);
  return isObject$9(R) && (k = "leading" in R ? !!R.leading : k, D = "trailing" in R ? !!R.trailing : D), debounce$5(T, S, {
    leading: k,
    maxWait: S,
    trailing: D
  });
}
var calculateChange = function(S, R, k) {
  var D = k.getBoundingClientRect(), L = D.width, V = D.height, z = typeof S.pageX == "number" ? S.pageX : S.touches[0].pageX, W = typeof S.pageY == "number" ? S.pageY : S.touches[0].pageY, U = z - (k.getBoundingClientRect().left + window.pageXOffset), q = W - (k.getBoundingClientRect().top + window.pageYOffset);
  U < 0 ? U = 0 : U > L && (U = L), q < 0 ? q = 0 : q > V && (q = V);
  var K = U / L, Y = 1 - q / V;
  return {
    h: R.h,
    s: K,
    v: Y,
    a: R.a,
    source: "hsv"
  };
}, _createClass$a = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}();
function _classCallCheck$a(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$a(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$a(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var Saturation$2 = function(T) {
  _inherits$a(S, T);
  function S(R) {
    _classCallCheck$a(this, S);
    var k = _possibleConstructorReturn$a(this, (S.__proto__ || Object.getPrototypeOf(S)).call(this, R));
    return k.handleChange = function(D) {
      typeof k.props.onChange == "function" && k.throttle(k.props.onChange, calculateChange(D, k.props.hsl, k.container), D);
    }, k.handleMouseDown = function(D) {
      k.handleChange(D);
      var L = k.getContainerRenderWindow();
      L.addEventListener("mousemove", k.handleChange), L.addEventListener("mouseup", k.handleMouseUp);
    }, k.handleMouseUp = function() {
      k.unbindEventListeners();
    }, k.throttle = throttle$2(function(D, L, V) {
      D(L, V);
    }, 50), k;
  }
  return _createClass$a(S, [{
    key: "componentWillUnmount",
    value: function() {
      this.throttle.cancel(), this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function() {
      for (var k = this.container, D = window; !D.document.contains(k) && D.parent !== D; )
        D = D.parent;
      return D;
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      var k = this.getContainerRenderWindow();
      k.removeEventListener("mousemove", this.handleChange), k.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var k = this, D = this.props.style || {}, L = D.color, V = D.white, z = D.black, W = D.pointer, U = D.circle, q = _default$3({
        default: {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: `0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),
            0 0 1px 2px rgba(0,0,0,.4)`,
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        custom: {
          color: L,
          white: V,
          black: z,
          pointer: W,
          circle: U
        }
      }, { custom: !!this.props.style });
      return React__default.createElement(
        "div",
        {
          style: q.color,
          ref: function(Y) {
            return k.container = Y;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        React__default.createElement(
          "style",
          null,
          `
          .saturation-white {
            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
            background: linear-gradient(to right, #fff, rgba(255,255,255,0));
          }
          .saturation-black {
            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));
            background: linear-gradient(to top, #000, rgba(0,0,0,0));
          }
        `
        ),
        React__default.createElement(
          "div",
          { style: q.white, className: "saturation-white" },
          React__default.createElement("div", { style: q.black, className: "saturation-black" }),
          React__default.createElement(
            "div",
            { style: q.pointer },
            this.props.pointer ? React__default.createElement(this.props.pointer, this.props) : React__default.createElement("div", { style: q.circle })
          )
        )
      );
    }
  }]), S;
}(PureComponent || Component);
function arrayEach$1(T, S) {
  for (var R = -1, k = T == null ? 0 : T.length; ++R < k && S(T[R], R, T) !== !1; )
    ;
  return T;
}
var nativeKeys = overArg(Object.keys, Object), objectProto$5 = Object.prototype, hasOwnProperty$5 = objectProto$5.hasOwnProperty;
function baseKeys(T) {
  if (!isPrototype(T))
    return nativeKeys(T);
  var S = [];
  for (var R in Object(T))
    hasOwnProperty$5.call(T, R) && R != "constructor" && S.push(R);
  return S;
}
function keys$1(T) {
  return isArrayLike$2(T) ? arrayLikeKeys(T) : baseKeys(T);
}
function baseForOwn$1(T, S) {
  return T && baseFor$1(T, S, keys$1);
}
function createBaseEach(T, S) {
  return function(R, k) {
    if (R == null)
      return R;
    if (!isArrayLike$2(R))
      return T(R, k);
    for (var D = R.length, L = -1, V = Object(R); ++L < D && k(V[L], L, V) !== !1; )
      ;
    return R;
  };
}
var baseEach$2 = createBaseEach(baseForOwn$1);
function castFunction$1(T) {
  return typeof T == "function" ? T : identity$2;
}
function forEach$4(T, S) {
  var R = isArray$9(T) ? arrayEach$1 : baseEach$2;
  return R(T, castFunction$1(S));
}
var tinycolor$1 = { exports: {} };
(function(T, S) {
  (function(R, k) {
    T.exports = k();
  })(commonjsGlobal, function() {
    function R(ye) {
      "@babel/helpers - typeof";
      return R = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(be) {
        return typeof be;
      } : function(be) {
        return be && typeof Symbol == "function" && be.constructor === Symbol && be !== Symbol.prototype ? "symbol" : typeof be;
      }, R(ye);
    }
    var k = /^\s+/, D = /\s+$/;
    function L(ye, be) {
      if (ye = ye || "", be = be || {}, ye instanceof L)
        return ye;
      if (!(this instanceof L))
        return new L(ye, be);
      var $e = V(ye);
      this._originalInput = ye, this._r = $e.r, this._g = $e.g, this._b = $e.b, this._a = $e.a, this._roundA = Math.round(100 * this._a) / 100, this._format = be.format || $e.format, this._gradientType = be.gradientType, this._r < 1 && (this._r = Math.round(this._r)), this._g < 1 && (this._g = Math.round(this._g)), this._b < 1 && (this._b = Math.round(this._b)), this._ok = $e.ok;
    }
    L.prototype = {
      isDark: function() {
        return this.getBrightness() < 128;
      },
      isLight: function() {
        return !this.isDark();
      },
      isValid: function() {
        return this._ok;
      },
      getOriginalInput: function() {
        return this._originalInput;
      },
      getFormat: function() {
        return this._format;
      },
      getAlpha: function() {
        return this._a;
      },
      getBrightness: function() {
        var be = this.toRgb();
        return (be.r * 299 + be.g * 587 + be.b * 114) / 1e3;
      },
      getLuminance: function() {
        var be = this.toRgb(), $e, Oe, Ie, we, Fe, De;
        return $e = be.r / 255, Oe = be.g / 255, Ie = be.b / 255, $e <= 0.03928 ? we = $e / 12.92 : we = Math.pow(($e + 0.055) / 1.055, 2.4), Oe <= 0.03928 ? Fe = Oe / 12.92 : Fe = Math.pow((Oe + 0.055) / 1.055, 2.4), Ie <= 0.03928 ? De = Ie / 12.92 : De = Math.pow((Ie + 0.055) / 1.055, 2.4), 0.2126 * we + 0.7152 * Fe + 0.0722 * De;
      },
      setAlpha: function(be) {
        return this._a = Te(be), this._roundA = Math.round(100 * this._a) / 100, this;
      },
      toHsv: function() {
        var be = q(this._r, this._g, this._b);
        return {
          h: be.h * 360,
          s: be.s,
          v: be.v,
          a: this._a
        };
      },
      toHsvString: function() {
        var be = q(this._r, this._g, this._b), $e = Math.round(be.h * 360), Oe = Math.round(be.s * 100), Ie = Math.round(be.v * 100);
        return this._a == 1 ? "hsv(" + $e + ", " + Oe + "%, " + Ie + "%)" : "hsva(" + $e + ", " + Oe + "%, " + Ie + "%, " + this._roundA + ")";
      },
      toHsl: function() {
        var be = W(this._r, this._g, this._b);
        return {
          h: be.h * 360,
          s: be.s,
          l: be.l,
          a: this._a
        };
      },
      toHslString: function() {
        var be = W(this._r, this._g, this._b), $e = Math.round(be.h * 360), Oe = Math.round(be.s * 100), Ie = Math.round(be.l * 100);
        return this._a == 1 ? "hsl(" + $e + ", " + Oe + "%, " + Ie + "%)" : "hsla(" + $e + ", " + Oe + "%, " + Ie + "%, " + this._roundA + ")";
      },
      toHex: function(be) {
        return Y(this._r, this._g, this._b, be);
      },
      toHexString: function(be) {
        return "#" + this.toHex(be);
      },
      toHex8: function(be) {
        return J(this._r, this._g, this._b, this._a, be);
      },
      toHex8String: function(be) {
        return "#" + this.toHex8(be);
      },
      toRgb: function() {
        return {
          r: Math.round(this._r),
          g: Math.round(this._g),
          b: Math.round(this._b),
          a: this._a
        };
      },
      toRgbString: function() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
      },
      toPercentageRgb: function() {
        return {
          r: Math.round(fe(this._r, 255) * 100) + "%",
          g: Math.round(fe(this._g, 255) * 100) + "%",
          b: Math.round(fe(this._b, 255) * 100) + "%",
          a: this._a
        };
      },
      toPercentageRgbString: function() {
        return this._a == 1 ? "rgb(" + Math.round(fe(this._r, 255) * 100) + "%, " + Math.round(fe(this._g, 255) * 100) + "%, " + Math.round(fe(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(fe(this._r, 255) * 100) + "%, " + Math.round(fe(this._g, 255) * 100) + "%, " + Math.round(fe(this._b, 255) * 100) + "%, " + this._roundA + ")";
      },
      toName: function() {
        return this._a === 0 ? "transparent" : this._a < 1 ? !1 : Re[Y(this._r, this._g, this._b, !0)] || !1;
      },
      toFilter: function(be) {
        var $e = "#" + Z(this._r, this._g, this._b, this._a), Oe = $e, Ie = this._gradientType ? "GradientType = 1, " : "";
        if (be) {
          var we = L(be);
          Oe = "#" + Z(we._r, we._g, we._b, we._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + Ie + "startColorstr=" + $e + ",endColorstr=" + Oe + ")";
      },
      toString: function(be) {
        var $e = !!be;
        be = be || this._format;
        var Oe = !1, Ie = this._a < 1 && this._a >= 0, we = !$e && Ie && (be === "hex" || be === "hex6" || be === "hex3" || be === "hex4" || be === "hex8" || be === "name");
        return we ? be === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (be === "rgb" && (Oe = this.toRgbString()), be === "prgb" && (Oe = this.toPercentageRgbString()), (be === "hex" || be === "hex6") && (Oe = this.toHexString()), be === "hex3" && (Oe = this.toHexString(!0)), be === "hex4" && (Oe = this.toHex8String(!0)), be === "hex8" && (Oe = this.toHex8String()), be === "name" && (Oe = this.toName()), be === "hsl" && (Oe = this.toHslString()), be === "hsv" && (Oe = this.toHsvString()), Oe || this.toHexString());
      },
      clone: function() {
        return L(this.toString());
      },
      _applyModification: function(be, $e) {
        var Oe = be.apply(null, [this].concat([].slice.call($e)));
        return this._r = Oe._r, this._g = Oe._g, this._b = Oe._b, this.setAlpha(Oe._a), this;
      },
      lighten: function() {
        return this._applyModification(re, arguments);
      },
      brighten: function() {
        return this._applyModification(Q, arguments);
      },
      darken: function() {
        return this._applyModification(ne, arguments);
      },
      desaturate: function() {
        return this._applyModification(X, arguments);
      },
      saturate: function() {
        return this._applyModification(ee, arguments);
      },
      greyscale: function() {
        return this._applyModification(te, arguments);
      },
      spin: function() {
        return this._applyModification(oe, arguments);
      },
      _applyCombination: function(be, $e) {
        return be.apply(null, [this].concat([].slice.call($e)));
      },
      analogous: function() {
        return this._applyCombination(he, arguments);
      },
      complement: function() {
        return this._applyCombination(ae, arguments);
      },
      monochromatic: function() {
        return this._applyCombination(xe, arguments);
      },
      splitcomplement: function() {
        return this._applyCombination(ie, arguments);
      },
      // Disabled until https://github.com/bgrins/TinyColor/issues/254
      // polyad: function (number) {
      //   return this._applyCombination(polyad, [number]);
      // },
      triad: function() {
        return this._applyCombination(se, [3]);
      },
      tetrad: function() {
        return this._applyCombination(se, [4]);
      }
    }, L.fromRatio = function(ye, be) {
      if (R(ye) == "object") {
        var $e = {};
        for (var Oe in ye)
          ye.hasOwnProperty(Oe) && (Oe === "a" ? $e[Oe] = ye[Oe] : $e[Oe] = ge(ye[Oe]));
        ye = $e;
      }
      return L(ye, be);
    };
    function V(ye) {
      var be = {
        r: 0,
        g: 0,
        b: 0
      }, $e = 1, Oe = null, Ie = null, we = null, Fe = !1, De = !1;
      return typeof ye == "string" && (ye = me(ye)), R(ye) == "object" && (le(ye.r) && le(ye.g) && le(ye.b) ? (be = z(ye.r, ye.g, ye.b), Fe = !0, De = String(ye.r).substr(-1) === "%" ? "prgb" : "rgb") : le(ye.h) && le(ye.s) && le(ye.v) ? (Oe = ge(ye.s), Ie = ge(ye.v), be = K(ye.h, Oe, Ie), Fe = !0, De = "hsv") : le(ye.h) && le(ye.s) && le(ye.l) && (Oe = ge(ye.s), we = ge(ye.l), be = U(ye.h, Oe, we), Fe = !0, De = "hsl"), ye.hasOwnProperty("a") && ($e = ye.a)), $e = Te($e), {
        ok: Fe,
        format: ye.format || De,
        r: Math.min(255, Math.max(be.r, 0)),
        g: Math.min(255, Math.max(be.g, 0)),
        b: Math.min(255, Math.max(be.b, 0)),
        a: $e
      };
    }
    function z(ye, be, $e) {
      return {
        r: fe(ye, 255) * 255,
        g: fe(be, 255) * 255,
        b: fe($e, 255) * 255
      };
    }
    function W(ye, be, $e) {
      ye = fe(ye, 255), be = fe(be, 255), $e = fe($e, 255);
      var Oe = Math.max(ye, be, $e), Ie = Math.min(ye, be, $e), we, Fe, De = (Oe + Ie) / 2;
      if (Oe == Ie)
        we = Fe = 0;
      else {
        var Le = Oe - Ie;
        switch (Fe = De > 0.5 ? Le / (2 - Oe - Ie) : Le / (Oe + Ie), Oe) {
          case ye:
            we = (be - $e) / Le + (be < $e ? 6 : 0);
            break;
          case be:
            we = ($e - ye) / Le + 2;
            break;
          case $e:
            we = (ye - be) / Le + 4;
            break;
        }
        we /= 6;
      }
      return {
        h: we,
        s: Fe,
        l: De
      };
    }
    function U(ye, be, $e) {
      var Oe, Ie, we;
      ye = fe(ye, 360), be = fe(be, 100), $e = fe($e, 100);
      function Fe(ze, We, Be) {
        return Be < 0 && (Be += 1), Be > 1 && (Be -= 1), Be < 1 / 6 ? ze + (We - ze) * 6 * Be : Be < 1 / 2 ? We : Be < 2 / 3 ? ze + (We - ze) * (2 / 3 - Be) * 6 : ze;
      }
      if (be === 0)
        Oe = Ie = we = $e;
      else {
        var De = $e < 0.5 ? $e * (1 + be) : $e + be - $e * be, Le = 2 * $e - De;
        Oe = Fe(Le, De, ye + 1 / 3), Ie = Fe(Le, De, ye), we = Fe(Le, De, ye - 1 / 3);
      }
      return {
        r: Oe * 255,
        g: Ie * 255,
        b: we * 255
      };
    }
    function q(ye, be, $e) {
      ye = fe(ye, 255), be = fe(be, 255), $e = fe($e, 255);
      var Oe = Math.max(ye, be, $e), Ie = Math.min(ye, be, $e), we, Fe, De = Oe, Le = Oe - Ie;
      if (Fe = Oe === 0 ? 0 : Le / Oe, Oe == Ie)
        we = 0;
      else {
        switch (Oe) {
          case ye:
            we = (be - $e) / Le + (be < $e ? 6 : 0);
            break;
          case be:
            we = ($e - ye) / Le + 2;
            break;
          case $e:
            we = (ye - be) / Le + 4;
            break;
        }
        we /= 6;
      }
      return {
        h: we,
        s: Fe,
        v: De
      };
    }
    function K(ye, be, $e) {
      ye = fe(ye, 360) * 6, be = fe(be, 100), $e = fe($e, 100);
      var Oe = Math.floor(ye), Ie = ye - Oe, we = $e * (1 - be), Fe = $e * (1 - Ie * be), De = $e * (1 - (1 - Ie) * be), Le = Oe % 6, ze = [$e, Fe, we, we, De, $e][Le], We = [De, $e, $e, Fe, we, we][Le], Be = [we, we, De, $e, $e, Fe][Le];
      return {
        r: ze * 255,
        g: We * 255,
        b: Be * 255
      };
    }
    function Y(ye, be, $e, Oe) {
      var Ie = [_e(Math.round(ye).toString(16)), _e(Math.round(be).toString(16)), _e(Math.round($e).toString(16))];
      return Oe && Ie[0].charAt(0) == Ie[0].charAt(1) && Ie[1].charAt(0) == Ie[1].charAt(1) && Ie[2].charAt(0) == Ie[2].charAt(1) ? Ie[0].charAt(0) + Ie[1].charAt(0) + Ie[2].charAt(0) : Ie.join("");
    }
    function J(ye, be, $e, Oe, Ie) {
      var we = [_e(Math.round(ye).toString(16)), _e(Math.round(be).toString(16)), _e(Math.round($e).toString(16)), _e(Ae(Oe))];
      return Ie && we[0].charAt(0) == we[0].charAt(1) && we[1].charAt(0) == we[1].charAt(1) && we[2].charAt(0) == we[2].charAt(1) && we[3].charAt(0) == we[3].charAt(1) ? we[0].charAt(0) + we[1].charAt(0) + we[2].charAt(0) + we[3].charAt(0) : we.join("");
    }
    function Z(ye, be, $e, Oe) {
      var Ie = [_e(Ae(Oe)), _e(Math.round(ye).toString(16)), _e(Math.round(be).toString(16)), _e(Math.round($e).toString(16))];
      return Ie.join("");
    }
    L.equals = function(ye, be) {
      return !ye || !be ? !1 : L(ye).toRgbString() == L(be).toRgbString();
    }, L.random = function() {
      return L.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
      });
    };
    function X(ye, be) {
      be = be === 0 ? 0 : be || 10;
      var $e = L(ye).toHsl();
      return $e.s -= be / 100, $e.s = ue($e.s), L($e);
    }
    function ee(ye, be) {
      be = be === 0 ? 0 : be || 10;
      var $e = L(ye).toHsl();
      return $e.s += be / 100, $e.s = ue($e.s), L($e);
    }
    function te(ye) {
      return L(ye).desaturate(100);
    }
    function re(ye, be) {
      be = be === 0 ? 0 : be || 10;
      var $e = L(ye).toHsl();
      return $e.l += be / 100, $e.l = ue($e.l), L($e);
    }
    function Q(ye, be) {
      be = be === 0 ? 0 : be || 10;
      var $e = L(ye).toRgb();
      return $e.r = Math.max(0, Math.min(255, $e.r - Math.round(255 * -(be / 100)))), $e.g = Math.max(0, Math.min(255, $e.g - Math.round(255 * -(be / 100)))), $e.b = Math.max(0, Math.min(255, $e.b - Math.round(255 * -(be / 100)))), L($e);
    }
    function ne(ye, be) {
      be = be === 0 ? 0 : be || 10;
      var $e = L(ye).toHsl();
      return $e.l -= be / 100, $e.l = ue($e.l), L($e);
    }
    function oe(ye, be) {
      var $e = L(ye).toHsl(), Oe = ($e.h + be) % 360;
      return $e.h = Oe < 0 ? 360 + Oe : Oe, L($e);
    }
    function ae(ye) {
      var be = L(ye).toHsl();
      return be.h = (be.h + 180) % 360, L(be);
    }
    function se(ye, be) {
      if (isNaN(be) || be <= 0)
        throw new Error("Argument to polyad must be a positive number");
      for (var $e = L(ye).toHsl(), Oe = [L(ye)], Ie = 360 / be, we = 1; we < be; we++)
        Oe.push(L({
          h: ($e.h + we * Ie) % 360,
          s: $e.s,
          l: $e.l
        }));
      return Oe;
    }
    function ie(ye) {
      var be = L(ye).toHsl(), $e = be.h;
      return [L(ye), L({
        h: ($e + 72) % 360,
        s: be.s,
        l: be.l
      }), L({
        h: ($e + 216) % 360,
        s: be.s,
        l: be.l
      })];
    }
    function he(ye, be, $e) {
      be = be || 6, $e = $e || 30;
      var Oe = L(ye).toHsl(), Ie = 360 / $e, we = [L(ye)];
      for (Oe.h = (Oe.h - (Ie * be >> 1) + 720) % 360; --be; )
        Oe.h = (Oe.h + Ie) % 360, we.push(L(Oe));
      return we;
    }
    function xe(ye, be) {
      be = be || 6;
      for (var $e = L(ye).toHsv(), Oe = $e.h, Ie = $e.s, we = $e.v, Fe = [], De = 1 / be; be--; )
        Fe.push(L({
          h: Oe,
          s: Ie,
          v: we
        })), we = (we + De) % 1;
      return Fe;
    }
    L.mix = function(ye, be, $e) {
      $e = $e === 0 ? 0 : $e || 50;
      var Oe = L(ye).toRgb(), Ie = L(be).toRgb(), we = $e / 100, Fe = {
        r: (Ie.r - Oe.r) * we + Oe.r,
        g: (Ie.g - Oe.g) * we + Oe.g,
        b: (Ie.b - Oe.b) * we + Oe.b,
        a: (Ie.a - Oe.a) * we + Oe.a
      };
      return L(Fe);
    }, L.readability = function(ye, be) {
      var $e = L(ye), Oe = L(be);
      return (Math.max($e.getLuminance(), Oe.getLuminance()) + 0.05) / (Math.min($e.getLuminance(), Oe.getLuminance()) + 0.05);
    }, L.isReadable = function(ye, be, $e) {
      var Oe = L.readability(ye, be), Ie, we;
      switch (we = !1, Ie = Se($e), Ie.level + Ie.size) {
        case "AAsmall":
        case "AAAlarge":
          we = Oe >= 4.5;
          break;
        case "AAlarge":
          we = Oe >= 3;
          break;
        case "AAAsmall":
          we = Oe >= 7;
          break;
      }
      return we;
    }, L.mostReadable = function(ye, be, $e) {
      var Oe = null, Ie = 0, we, Fe, De, Le;
      $e = $e || {}, Fe = $e.includeFallbackColors, De = $e.level, Le = $e.size;
      for (var ze = 0; ze < be.length; ze++)
        we = L.readability(ye, be[ze]), we > Ie && (Ie = we, Oe = L(be[ze]));
      return L.isReadable(ye, Oe, {
        level: De,
        size: Le
      }) || !Fe ? Oe : ($e.includeFallbackColors = !1, L.mostReadable(ye, ["#fff", "#000"], $e));
    };
    var Pe = L.names = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "0ff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "00f",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      burntsienna: "ea7e5d",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "0ff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "f0f",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
    }, Re = L.hexNames = ke(Pe);
    function ke(ye) {
      var be = {};
      for (var $e in ye)
        ye.hasOwnProperty($e) && (be[ye[$e]] = $e);
      return be;
    }
    function Te(ye) {
      return ye = parseFloat(ye), (isNaN(ye) || ye < 0 || ye > 1) && (ye = 1), ye;
    }
    function fe(ye, be) {
      ce(ye) && (ye = "100%");
      var $e = pe(ye);
      return ye = Math.min(be, Math.max(0, parseFloat(ye))), $e && (ye = parseInt(ye * be, 10) / 100), Math.abs(ye - be) < 1e-6 ? 1 : ye % be / parseFloat(be);
    }
    function ue(ye) {
      return Math.min(1, Math.max(0, ye));
    }
    function Ce(ye) {
      return parseInt(ye, 16);
    }
    function ce(ye) {
      return typeof ye == "string" && ye.indexOf(".") != -1 && parseFloat(ye) === 1;
    }
    function pe(ye) {
      return typeof ye == "string" && ye.indexOf("%") != -1;
    }
    function _e(ye) {
      return ye.length == 1 ? "0" + ye : "" + ye;
    }
    function ge(ye) {
      return ye <= 1 && (ye = ye * 100 + "%"), ye;
    }
    function Ae(ye) {
      return Math.round(parseFloat(ye) * 255).toString(16);
    }
    function Ee(ye) {
      return Ce(ye) / 255;
    }
    var ve = function() {
      var ye = "[-\\+]?\\d+%?", be = "[-\\+]?\\d*\\.\\d+%?", $e = "(?:" + be + ")|(?:" + ye + ")", Oe = "[\\s|\\(]+(" + $e + ")[,|\\s]+(" + $e + ")[,|\\s]+(" + $e + ")\\s*\\)?", Ie = "[\\s|\\(]+(" + $e + ")[,|\\s]+(" + $e + ")[,|\\s]+(" + $e + ")[,|\\s]+(" + $e + ")\\s*\\)?";
      return {
        CSS_UNIT: new RegExp($e),
        rgb: new RegExp("rgb" + Oe),
        rgba: new RegExp("rgba" + Ie),
        hsl: new RegExp("hsl" + Oe),
        hsla: new RegExp("hsla" + Ie),
        hsv: new RegExp("hsv" + Oe),
        hsva: new RegExp("hsva" + Ie),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
      };
    }();
    function le(ye) {
      return !!ve.CSS_UNIT.exec(ye);
    }
    function me(ye) {
      ye = ye.replace(k, "").replace(D, "").toLowerCase();
      var be = !1;
      if (Pe[ye])
        ye = Pe[ye], be = !0;
      else if (ye == "transparent")
        return {
          r: 0,
          g: 0,
          b: 0,
          a: 0,
          format: "name"
        };
      var $e;
      return ($e = ve.rgb.exec(ye)) ? {
        r: $e[1],
        g: $e[2],
        b: $e[3]
      } : ($e = ve.rgba.exec(ye)) ? {
        r: $e[1],
        g: $e[2],
        b: $e[3],
        a: $e[4]
      } : ($e = ve.hsl.exec(ye)) ? {
        h: $e[1],
        s: $e[2],
        l: $e[3]
      } : ($e = ve.hsla.exec(ye)) ? {
        h: $e[1],
        s: $e[2],
        l: $e[3],
        a: $e[4]
      } : ($e = ve.hsv.exec(ye)) ? {
        h: $e[1],
        s: $e[2],
        v: $e[3]
      } : ($e = ve.hsva.exec(ye)) ? {
        h: $e[1],
        s: $e[2],
        v: $e[3],
        a: $e[4]
      } : ($e = ve.hex8.exec(ye)) ? {
        r: Ce($e[1]),
        g: Ce($e[2]),
        b: Ce($e[3]),
        a: Ee($e[4]),
        format: be ? "name" : "hex8"
      } : ($e = ve.hex6.exec(ye)) ? {
        r: Ce($e[1]),
        g: Ce($e[2]),
        b: Ce($e[3]),
        format: be ? "name" : "hex"
      } : ($e = ve.hex4.exec(ye)) ? {
        r: Ce($e[1] + "" + $e[1]),
        g: Ce($e[2] + "" + $e[2]),
        b: Ce($e[3] + "" + $e[3]),
        a: Ee($e[4] + "" + $e[4]),
        format: be ? "name" : "hex8"
      } : ($e = ve.hex3.exec(ye)) ? {
        r: Ce($e[1] + "" + $e[1]),
        g: Ce($e[2] + "" + $e[2]),
        b: Ce($e[3] + "" + $e[3]),
        format: be ? "name" : "hex"
      } : !1;
    }
    function Se(ye) {
      var be, $e;
      return ye = ye || {
        level: "AA",
        size: "small"
      }, be = (ye.level || "AA").toUpperCase(), $e = (ye.size || "small").toLowerCase(), be !== "AA" && be !== "AAA" && (be = "AA"), $e !== "small" && $e !== "large" && ($e = "small"), {
        level: be,
        size: $e
      };
    }
    return L;
  });
})(tinycolor$1);
var tinycolorExports = tinycolor$1.exports;
const tinycolor = /* @__PURE__ */ getDefaultExportFromCjs(tinycolorExports);
var simpleCheckForValidColor = function(S) {
  var R = ["r", "g", "b", "a", "h", "s", "l", "v"], k = 0, D = 0;
  return forEach$4(R, function(L) {
    if (S[L] && (k += 1, isNaN(S[L]) || (D += 1), L === "s" || L === "l")) {
      var V = /^\d+%$/;
      V.test(S[L]) && (D += 1);
    }
  }), k === D ? S : !1;
}, toState$1 = function(S, R) {
  var k = S.hex ? tinycolor(S.hex) : tinycolor(S), D = k.toHsl(), L = k.toHsv(), V = k.toRgb(), z = k.toHex();
  D.s === 0 && (D.h = R || 0, L.h = R || 0);
  var W = z === "000000" && V.a === 0;
  return {
    hsl: D,
    hex: W ? "transparent" : "#" + z,
    rgb: V,
    hsv: L,
    oldHue: S.h || R || D.h,
    source: S.source
  };
}, isValidHex = function(S) {
  if (S === "transparent")
    return !0;
  var R = String(S).charAt(0) === "#" ? 1 : 0;
  return S.length !== 4 + R && S.length < 7 + R && tinycolor(S).isValid();
}, getContrastingColor = function(S) {
  if (!S)
    return "#fff";
  var R = toState$1(S);
  if (R.hex === "transparent")
    return "rgba(0,0,0,0.4)";
  var k = (R.rgb.r * 299 + R.rgb.g * 587 + R.rgb.b * 114) / 1e3;
  return k >= 128 ? "#000" : "#fff";
}, isvalidColorString = function(S, R) {
  var k = S.replace("°", "");
  return tinycolor(R + " (" + k + ")")._ok;
}, _extends$h = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, _createClass$9 = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}();
function _classCallCheck$9(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$9(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$9(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var ColorWrap$2 = function(S) {
  var R = function(k) {
    _inherits$9(D, k);
    function D(L) {
      _classCallCheck$9(this, D);
      var V = _possibleConstructorReturn$9(this, (D.__proto__ || Object.getPrototypeOf(D)).call(this));
      return V.handleChange = function(z, W) {
        var U = simpleCheckForValidColor(z);
        if (U) {
          var q = toState$1(z, z.h || V.state.oldHue);
          V.setState(q), V.props.onChangeComplete && V.debounce(V.props.onChangeComplete, q, W), V.props.onChange && V.props.onChange(q, W);
        }
      }, V.handleSwatchHover = function(z, W) {
        var U = simpleCheckForValidColor(z);
        if (U) {
          var q = toState$1(z, z.h || V.state.oldHue);
          V.props.onSwatchHover && V.props.onSwatchHover(q, W);
        }
      }, V.state = _extends$h({}, toState$1(L.color, 0)), V.debounce = debounce$5(function(z, W, U) {
        z(W, U);
      }, 100), V;
    }
    return _createClass$9(D, [{
      key: "render",
      value: function() {
        var V = {};
        return this.props.onSwatchHover && (V.onSwatchHover = this.handleSwatchHover), React__default.createElement(S, _extends$h({}, this.props, this.state, {
          onChange: this.handleChange
        }, V));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(V, z) {
        return _extends$h({}, toState$1(V.color, z.oldHue));
      }
    }]), D;
  }(PureComponent || Component);
  return R.propTypes = _extends$h({}, S.propTypes), R.defaultProps = _extends$h({}, S.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  }), R;
}, _extends$g = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, _createClass$8 = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}();
function _classCallCheck$8(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$8(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$8(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var handleFocus = function(S) {
  var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(k) {
    _inherits$8(D, k);
    function D() {
      var L, V, z, W;
      _classCallCheck$8(this, D);
      for (var U = arguments.length, q = Array(U), K = 0; K < U; K++)
        q[K] = arguments[K];
      return W = (V = (z = _possibleConstructorReturn$8(this, (L = D.__proto__ || Object.getPrototypeOf(D)).call.apply(L, [this].concat(q))), z), z.state = { focus: !1 }, z.handleFocus = function() {
        return z.setState({ focus: !0 });
      }, z.handleBlur = function() {
        return z.setState({ focus: !1 });
      }, V), _possibleConstructorReturn$8(z, W);
    }
    return _createClass$8(D, [{
      key: "render",
      value: function() {
        return React__default.createElement(
          R,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          React__default.createElement(S, _extends$g({}, this.props, this.state))
        );
      }
    }]), D;
  }(React__default.Component);
}, _extends$f = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, ENTER$1 = 13, Swatch$2 = function(S) {
  var R = S.color, k = S.style, D = S.onClick, L = D === void 0 ? function() {
  } : D, V = S.onHover, z = S.title, W = z === void 0 ? R : z, U = S.children, q = S.focus, K = S.focusStyle, Y = K === void 0 ? {} : K, J = R === "transparent", Z = _default$3({
    default: {
      swatch: _extends$f({
        background: R,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, k, q ? Y : {})
    }
  }), X = function(ne) {
    return L(R, ne);
  }, ee = function(ne) {
    return ne.keyCode === ENTER$1 && L(R, ne);
  }, te = function(ne) {
    return V(R, ne);
  }, re = {};
  return V && (re.onMouseOver = te), React__default.createElement(
    "div",
    _extends$f({
      style: Z.swatch,
      onClick: X,
      title: W,
      tabIndex: 0,
      onKeyDown: ee
    }, re),
    U,
    J && React__default.createElement(Checkboard$2, {
      borderRadius: Z.swatch.borderRadius,
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    })
  );
};
const Swatch$3 = handleFocus(Swatch$2);
var AlphaPointer = function(S) {
  var R = S.direction, k = _default$3({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: R === "vertical" });
  return React__default.createElement("div", { style: k.picker });
}, _extends$e = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, AlphaPicker = function(S) {
  var R = S.rgb, k = S.hsl, D = S.width, L = S.height, V = S.onChange, z = S.direction, W = S.style, U = S.renderers, q = S.pointer, K = S.className, Y = K === void 0 ? "" : K, J = _default$3({
    default: {
      picker: {
        position: "relative",
        width: D,
        height: L
      },
      alpha: {
        radius: "2px",
        style: W
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: J.picker, className: "alpha-picker " + Y },
    React__default.createElement(Alpha$2, _extends$e({}, J.alpha, {
      rgb: R,
      hsl: k,
      pointer: q,
      renderers: U,
      onChange: V,
      direction: z
    }))
  );
};
AlphaPicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: AlphaPointer
};
ColorWrap$2(AlphaPicker);
function arrayMap$1(T, S) {
  for (var R = -1, k = T == null ? 0 : T.length, D = Array(k); ++R < k; )
    D[R] = S(T[R], R, T);
  return D;
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function setCacheAdd(T) {
  return this.__data__.set(T, HASH_UNDEFINED$1), this;
}
function setCacheHas(T) {
  return this.__data__.has(T);
}
function SetCache(T) {
  var S = -1, R = T == null ? 0 : T.length;
  for (this.__data__ = new MapCache$1(); ++S < R; )
    this.add(T[S]);
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(T, S) {
  for (var R = -1, k = T == null ? 0 : T.length; ++R < k; )
    if (S(T[R], R, T))
      return !0;
  return !1;
}
function cacheHas(T, S) {
  return T.has(S);
}
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays(T, S, R, k, D, L) {
  var V = R & COMPARE_PARTIAL_FLAG$5, z = T.length, W = S.length;
  if (z != W && !(V && W > z))
    return !1;
  var U = L.get(T), q = L.get(S);
  if (U && q)
    return U == S && q == T;
  var K = -1, Y = !0, J = R & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  for (L.set(T, S), L.set(S, T); ++K < z; ) {
    var Z = T[K], X = S[K];
    if (k)
      var ee = V ? k(X, Z, K, S, T, L) : k(Z, X, K, T, S, L);
    if (ee !== void 0) {
      if (ee)
        continue;
      Y = !1;
      break;
    }
    if (J) {
      if (!arraySome(S, function(te, re) {
        if (!cacheHas(J, re) && (Z === te || D(Z, te, R, k, L)))
          return J.push(re);
      })) {
        Y = !1;
        break;
      }
    } else if (!(Z === X || D(Z, X, R, k, L))) {
      Y = !1;
      break;
    }
  }
  return L.delete(T), L.delete(S), Y;
}
function mapToArray(T) {
  var S = -1, R = Array(T.size);
  return T.forEach(function(k, D) {
    R[++S] = [D, k];
  }), R;
}
function setToArray$1(T) {
  var S = -1, R = Array(T.size);
  return T.forEach(function(k) {
    R[++S] = k;
  }), R;
}
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", symbolTag$1 = "[object Symbol]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", symbolProto$2 = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function equalByTag(T, S, R, k, D, L, V) {
  switch (R) {
    case dataViewTag$1:
      if (T.byteLength != S.byteLength || T.byteOffset != S.byteOffset)
        return !1;
      T = T.buffer, S = S.buffer;
    case arrayBufferTag:
      return !(T.byteLength != S.byteLength || !L(new Uint8Array$1(T), new Uint8Array$1(S)));
    case boolTag:
    case dateTag:
    case numberTag:
      return eq$3(+T, +S);
    case errorTag:
      return T.name == S.name && T.message == S.message;
    case regexpTag:
    case stringTag:
      return T == S + "";
    case mapTag$1:
      var z = mapToArray;
    case setTag$1:
      var W = k & COMPARE_PARTIAL_FLAG$4;
      if (z || (z = setToArray$1), T.size != S.size && !W)
        return !1;
      var U = V.get(T);
      if (U)
        return U == S;
      k |= COMPARE_UNORDERED_FLAG$2, V.set(T, S);
      var q = equalArrays(z(T), z(S), k, D, L, V);
      return V.delete(T), q;
    case symbolTag$1:
      if (symbolValueOf)
        return symbolValueOf.call(T) == symbolValueOf.call(S);
  }
  return !1;
}
function arrayPush$1(T, S) {
  for (var R = -1, k = S.length, D = T.length; ++R < k; )
    T[D + R] = S[R];
  return T;
}
function baseGetAllKeys(T, S, R) {
  var k = S(T);
  return isArray$9(T) ? k : arrayPush$1(k, R(T));
}
function arrayFilter(T, S) {
  for (var R = -1, k = T == null ? 0 : T.length, D = 0, L = []; ++R < k; ) {
    var V = T[R];
    S(V, R, T) && (L[D++] = V);
  }
  return L;
}
function stubArray() {
  return [];
}
var objectProto$4 = Object.prototype, propertyIsEnumerable = objectProto$4.propertyIsEnumerable, nativeGetSymbols = Object.getOwnPropertySymbols, getSymbols = nativeGetSymbols ? function(T) {
  return T == null ? [] : (T = Object(T), arrayFilter(nativeGetSymbols(T), function(S) {
    return propertyIsEnumerable.call(T, S);
  }));
} : stubArray;
function getAllKeys(T) {
  return baseGetAllKeys(T, keys$1, getSymbols);
}
var COMPARE_PARTIAL_FLAG$3 = 1, objectProto$3 = Object.prototype, hasOwnProperty$4 = objectProto$3.hasOwnProperty;
function equalObjects(T, S, R, k, D, L) {
  var V = R & COMPARE_PARTIAL_FLAG$3, z = getAllKeys(T), W = z.length, U = getAllKeys(S), q = U.length;
  if (W != q && !V)
    return !1;
  for (var K = W; K--; ) {
    var Y = z[K];
    if (!(V ? Y in S : hasOwnProperty$4.call(S, Y)))
      return !1;
  }
  var J = L.get(T), Z = L.get(S);
  if (J && Z)
    return J == S && Z == T;
  var X = !0;
  L.set(T, S), L.set(S, T);
  for (var ee = V; ++K < W; ) {
    Y = z[K];
    var te = T[Y], re = S[Y];
    if (k)
      var Q = V ? k(re, te, Y, S, T, L) : k(te, re, Y, T, S, L);
    if (!(Q === void 0 ? te === re || D(te, re, R, k, L) : Q)) {
      X = !1;
      break;
    }
    ee || (ee = Y == "constructor");
  }
  if (X && !ee) {
    var ne = T.constructor, oe = S.constructor;
    ne != oe && "constructor" in T && "constructor" in S && !(typeof ne == "function" && ne instanceof ne && typeof oe == "function" && oe instanceof oe) && (X = !1);
  }
  return L.delete(T), L.delete(S), X;
}
var DataView$1 = getNative$1(root$1, "DataView"), Promise$1 = getNative$1(root$1, "Promise"), Set$2 = getNative$1(root$1, "Set"), WeakMap$1 = getNative$1(root$1, "WeakMap"), mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]", dataViewTag = "[object DataView]", dataViewCtorString = toSource$1(DataView$1), mapCtorString = toSource$1(Map$1), promiseCtorString = toSource$1(Promise$1), setCtorString = toSource$1(Set$2), weakMapCtorString = toSource$1(WeakMap$1), getTag = baseGetTag$1;
(DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag(new Map$1()) != mapTag || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$2 && getTag(new Set$2()) != setTag || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag) && (getTag = function(T) {
  var S = baseGetTag$1(T), R = S == objectTag$1 ? T.constructor : void 0, k = R ? toSource$1(R) : "";
  if (k)
    switch (k) {
      case dataViewCtorString:
        return dataViewTag;
      case mapCtorString:
        return mapTag;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag;
      case weakMapCtorString:
        return weakMapTag;
    }
  return S;
});
var COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]", objectProto$2 = Object.prototype, hasOwnProperty$3 = objectProto$2.hasOwnProperty;
function baseIsEqualDeep(T, S, R, k, D, L) {
  var V = isArray$9(T), z = isArray$9(S), W = V ? arrayTag : getTag(T), U = z ? arrayTag : getTag(S);
  W = W == argsTag ? objectTag : W, U = U == argsTag ? objectTag : U;
  var q = W == objectTag, K = U == objectTag, Y = W == U;
  if (Y && isBuffer$2(T)) {
    if (!isBuffer$2(S))
      return !1;
    V = !0, q = !1;
  }
  if (Y && !q)
    return L || (L = new Stack$6()), V || isTypedArray$2(T) ? equalArrays(T, S, R, k, D, L) : equalByTag(T, S, W, R, k, D, L);
  if (!(R & COMPARE_PARTIAL_FLAG$2)) {
    var J = q && hasOwnProperty$3.call(T, "__wrapped__"), Z = K && hasOwnProperty$3.call(S, "__wrapped__");
    if (J || Z) {
      var X = J ? T.value() : T, ee = Z ? S.value() : S;
      return L || (L = new Stack$6()), D(X, ee, R, k, L);
    }
  }
  return Y ? (L || (L = new Stack$6()), equalObjects(T, S, R, k, D, L)) : !1;
}
function baseIsEqual$1(T, S, R, k, D) {
  return T === S ? !0 : T == null || S == null || !isObjectLike$2(T) && !isObjectLike$2(S) ? T !== T && S !== S : baseIsEqualDeep(T, S, R, k, baseIsEqual$1, D);
}
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch(T, S, R, k) {
  var D = R.length, L = D;
  if (T == null)
    return !L;
  for (T = Object(T); D--; ) {
    var V = R[D];
    if (V[2] ? V[1] !== T[V[0]] : !(V[0] in T))
      return !1;
  }
  for (; ++D < L; ) {
    V = R[D];
    var z = V[0], W = T[z], U = V[1];
    if (V[2]) {
      if (W === void 0 && !(z in T))
        return !1;
    } else {
      var q = new Stack$6(), K;
      if (!(K === void 0 ? baseIsEqual$1(U, W, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, k, q) : K))
        return !1;
    }
  }
  return !0;
}
function isStrictComparable(T) {
  return T === T && !isObject$9(T);
}
function getMatchData(T) {
  for (var S = keys$1(T), R = S.length; R--; ) {
    var k = S[R], D = T[k];
    S[R] = [k, D, isStrictComparable(D)];
  }
  return S;
}
function matchesStrictComparable(T, S) {
  return function(R) {
    return R == null ? !1 : R[T] === S && (S !== void 0 || T in Object(R));
  };
}
function baseMatches(T) {
  var S = getMatchData(T);
  return S.length == 1 && S[0][2] ? matchesStrictComparable(S[0][0], S[0][1]) : function(R) {
    return R === T || baseIsMatch(R, T, S);
  };
}
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp$1 = /^\w*$/;
function isKey$1(T, S) {
  if (isArray$9(T))
    return !1;
  var R = typeof T;
  return R == "number" || R == "symbol" || R == "boolean" || T == null || isSymbol$3(T) ? !0 : reIsPlainProp$1.test(T) || !reIsDeepProp$1.test(T) || S != null && T in Object(S);
}
var FUNC_ERROR_TEXT$3 = "Expected a function";
function memoize$4(T, S) {
  if (typeof T != "function" || S != null && typeof S != "function")
    throw new TypeError(FUNC_ERROR_TEXT$3);
  var R = function() {
    var k = arguments, D = S ? S.apply(this, k) : k[0], L = R.cache;
    if (L.has(D))
      return L.get(D);
    var V = T.apply(this, k);
    return R.cache = L.set(D, V) || L, V;
  };
  return R.cache = new (memoize$4.Cache || MapCache$1)(), R;
}
memoize$4.Cache = MapCache$1;
var MAX_MEMOIZE_SIZE$1 = 500;
function memoizeCapped$1(T) {
  var S = memoize$4(T, function(k) {
    return R.size === MAX_MEMOIZE_SIZE$1 && R.clear(), k;
  }), R = S.cache;
  return S;
}
var rePropName$2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar$2 = /\\(\\)?/g, stringToPath$2 = memoizeCapped$1(function(T) {
  var S = [];
  return T.charCodeAt(0) === 46 && S.push(""), T.replace(rePropName$2, function(R, k, D, L) {
    S.push(D ? L.replace(reEscapeChar$2, "$1") : k || R);
  }), S;
}), INFINITY$3 = 1 / 0, symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString$2 = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(T) {
  if (typeof T == "string")
    return T;
  if (isArray$9(T))
    return arrayMap$1(T, baseToString$1) + "";
  if (isSymbol$3(T))
    return symbolToString$2 ? symbolToString$2.call(T) : "";
  var S = T + "";
  return S == "0" && 1 / T == -INFINITY$3 ? "-0" : S;
}
function toString$2(T) {
  return T == null ? "" : baseToString$1(T);
}
function castPath$3(T, S) {
  return isArray$9(T) ? T : isKey$1(T, S) ? [T] : stringToPath$2(toString$2(T));
}
var INFINITY$2 = 1 / 0;
function toKey$2(T) {
  if (typeof T == "string" || isSymbol$3(T))
    return T;
  var S = T + "";
  return S == "0" && 1 / T == -INFINITY$2 ? "-0" : S;
}
function baseGet$2(T, S) {
  S = castPath$3(S, T);
  for (var R = 0, k = S.length; T != null && R < k; )
    T = T[toKey$2(S[R++])];
  return R && R == k ? T : void 0;
}
function get$2(T, S, R) {
  var k = T == null ? void 0 : baseGet$2(T, S);
  return k === void 0 ? R : k;
}
function baseHasIn(T, S) {
  return T != null && S in Object(T);
}
function hasPath(T, S, R) {
  S = castPath$3(S, T);
  for (var k = -1, D = S.length, L = !1; ++k < D; ) {
    var V = toKey$2(S[k]);
    if (!(L = T != null && R(T, V)))
      break;
    T = T[V];
  }
  return L || ++k != D ? L : (D = T == null ? 0 : T.length, !!D && isLength(D) && isIndex$2(V, D) && (isArray$9(T) || isArguments$4(T)));
}
function hasIn$1(T, S) {
  return T != null && hasPath(T, S, baseHasIn);
}
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty(T, S) {
  return isKey$1(T) && isStrictComparable(S) ? matchesStrictComparable(toKey$2(T), S) : function(R) {
    var k = get$2(R, T);
    return k === void 0 && k === S ? hasIn$1(R, T) : baseIsEqual$1(S, k, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
function baseProperty(T) {
  return function(S) {
    return S?.[T];
  };
}
function basePropertyDeep(T) {
  return function(S) {
    return baseGet$2(S, T);
  };
}
function property(T) {
  return isKey$1(T) ? baseProperty(toKey$2(T)) : basePropertyDeep(T);
}
function baseIteratee$2(T) {
  return typeof T == "function" ? T : T == null ? identity$2 : typeof T == "object" ? isArray$9(T) ? baseMatchesProperty(T[0], T[1]) : baseMatches(T) : property(T);
}
function baseMap(T, S) {
  var R = -1, k = isArrayLike$2(T) ? Array(T.length) : [];
  return baseEach$2(T, function(D, L, V) {
    k[++R] = S(D, L, V);
  }), k;
}
function map$1(T, S) {
  var R = isArray$9(T) ? arrayMap$1 : baseMap;
  return R(T, baseIteratee$2(S));
}
var BlockSwatches = function(S) {
  var R = S.colors, k = S.onClick, D = S.onSwatchHover, L = _default$3({
    default: {
      swatches: {
        marginRight: "-10px"
      },
      swatch: {
        width: "22px",
        height: "22px",
        float: "left",
        marginRight: "10px",
        marginBottom: "10px",
        borderRadius: "4px"
      },
      clear: {
        clear: "both"
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: L.swatches },
    map$1(R, function(V) {
      return React__default.createElement(Swatch$3, {
        key: V,
        color: V,
        style: L.swatch,
        onClick: k,
        onHover: D,
        focusStyle: {
          boxShadow: "0 0 4px " + V
        }
      });
    }),
    React__default.createElement("div", { style: L.clear })
  );
}, Block = function(S) {
  var R = S.onChange, k = S.onSwatchHover, D = S.hex, L = S.colors, V = S.width, z = S.triangle, W = S.styles, U = W === void 0 ? {} : W, q = S.className, K = q === void 0 ? "" : q, Y = D === "transparent", J = function(ee, te) {
    isValidHex(ee) && R({
      hex: ee,
      source: "hex"
    }, te);
  }, Z = _default$3(merge$4({
    default: {
      card: {
        width: V,
        background: "#fff",
        boxShadow: "0 1px rgba(0,0,0,.1)",
        borderRadius: "6px",
        position: "relative"
      },
      head: {
        height: "110px",
        background: D,
        borderRadius: "6px 6px 0 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative"
      },
      body: {
        padding: "10px"
      },
      label: {
        fontSize: "18px",
        color: getContrastingColor(D),
        position: "relative"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 10px 10px 10px",
        borderColor: "transparent transparent " + D + " transparent",
        position: "absolute",
        top: "-10px",
        left: "50%",
        marginLeft: "-10px"
      },
      input: {
        width: "100%",
        fontSize: "12px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "22px",
        boxShadow: "inset 0 0 0 1px #ddd",
        borderRadius: "4px",
        padding: "0 7px",
        boxSizing: "border-box"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      }
    }
  }, U), { "hide-triangle": z === "hide" });
  return React__default.createElement(
    "div",
    { style: Z.card, className: "block-picker " + K },
    React__default.createElement("div", { style: Z.triangle }),
    React__default.createElement(
      "div",
      { style: Z.head },
      Y && React__default.createElement(Checkboard$2, { borderRadius: "6px 6px 0 0" }),
      React__default.createElement(
        "div",
        { style: Z.label },
        D
      )
    ),
    React__default.createElement(
      "div",
      { style: Z.body },
      React__default.createElement(BlockSwatches, { colors: L, onClick: J, onSwatchHover: k }),
      React__default.createElement(EditableInput$2, {
        style: { input: Z.input },
        value: D,
        onChange: J
      })
    )
  );
};
Block.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(["top", "hide"]),
  styles: PropTypes.object
};
Block.defaultProps = {
  width: 170,
  colors: ["#D9E3F0", "#F47373", "#697689", "#37D67A", "#2CCCE4", "#555555", "#dce775", "#ff8a65", "#ba68c8"],
  triangle: "top",
  styles: {}
};
ColorWrap$2(Block);
var red$2 = { 50: "#ffebee", 100: "#ffcdd2", 200: "#ef9a9a", 300: "#e57373", 400: "#ef5350", 500: "#f44336", 600: "#e53935", 700: "#d32f2f", 800: "#c62828", 900: "#b71c1c", a100: "#ff8a80", a200: "#ff5252", a400: "#ff1744", a700: "#d50000" }, pink = { 50: "#fce4ec", 100: "#f8bbd0", 200: "#f48fb1", 300: "#f06292", 400: "#ec407a", 500: "#e91e63", 600: "#d81b60", 700: "#c2185b", 800: "#ad1457", 900: "#880e4f", a100: "#ff80ab", a200: "#ff4081", a400: "#f50057", a700: "#c51162" }, purple$2 = { 50: "#f3e5f5", 100: "#e1bee7", 200: "#ce93d8", 300: "#ba68c8", 400: "#ab47bc", 500: "#9c27b0", 600: "#8e24aa", 700: "#7b1fa2", 800: "#6a1b9a", 900: "#4a148c", a100: "#ea80fc", a200: "#e040fb", a400: "#d500f9", a700: "#aa00ff" }, deepPurple = { 50: "#ede7f6", 100: "#d1c4e9", 200: "#b39ddb", 300: "#9575cd", 400: "#7e57c2", 500: "#673ab7", 600: "#5e35b1", 700: "#512da8", 800: "#4527a0", 900: "#311b92", a100: "#b388ff", a200: "#7c4dff", a400: "#651fff", a700: "#6200ea" }, indigo = { 50: "#e8eaf6", 100: "#c5cae9", 200: "#9fa8da", 300: "#7986cb", 400: "#5c6bc0", 500: "#3f51b5", 600: "#3949ab", 700: "#303f9f", 800: "#283593", 900: "#1a237e", a100: "#8c9eff", a200: "#536dfe", a400: "#3d5afe", a700: "#304ffe" }, blue$2 = { 50: "#e3f2fd", 100: "#bbdefb", 200: "#90caf9", 300: "#64b5f6", 400: "#42a5f5", 500: "#2196f3", 600: "#1e88e5", 700: "#1976d2", 800: "#1565c0", 900: "#0d47a1", a100: "#82b1ff", a200: "#448aff", a400: "#2979ff", a700: "#2962ff" }, lightBlue$1 = { 50: "#e1f5fe", 100: "#b3e5fc", 200: "#81d4fa", 300: "#4fc3f7", 400: "#29b6f6", 500: "#03a9f4", 600: "#039be5", 700: "#0288d1", 800: "#0277bd", 900: "#01579b", a100: "#80d8ff", a200: "#40c4ff", a400: "#00b0ff", a700: "#0091ea" }, cyan = { 50: "#e0f7fa", 100: "#b2ebf2", 200: "#80deea", 300: "#4dd0e1", 400: "#26c6da", 500: "#00bcd4", 600: "#00acc1", 700: "#0097a7", 800: "#00838f", 900: "#006064", a100: "#84ffff", a200: "#18ffff", a400: "#00e5ff", a700: "#00b8d4" }, teal = { 50: "#e0f2f1", 100: "#b2dfdb", 200: "#80cbc4", 300: "#4db6ac", 400: "#26a69a", 500: "#009688", 600: "#00897b", 700: "#00796b", 800: "#00695c", 900: "#004d40", a100: "#a7ffeb", a200: "#64ffda", a400: "#1de9b6", a700: "#00bfa5" }, green$2 = { 50: "#e8f5e9", 100: "#c8e6c9", 200: "#a5d6a7", 300: "#81c784", 400: "#66bb6a", 500: "#4caf50", 600: "#43a047", 700: "#388e3c", 800: "#2e7d32", 900: "#1b5e20", a100: "#b9f6ca", a200: "#69f0ae", a400: "#00e676", a700: "#00c853" }, lightGreen = { 50: "#f1f8e9", 100: "#dcedc8", 200: "#c5e1a5", 300: "#aed581", 400: "#9ccc65", 500: "#8bc34a", 600: "#7cb342", 700: "#689f38", 800: "#558b2f", 900: "#33691e", a100: "#ccff90", a200: "#b2ff59", a400: "#76ff03", a700: "#64dd17" }, lime = { 50: "#f9fbe7", 100: "#f0f4c3", 200: "#e6ee9c", 300: "#dce775", 400: "#d4e157", 500: "#cddc39", 600: "#c0ca33", 700: "#afb42b", 800: "#9e9d24", 900: "#827717", a100: "#f4ff81", a200: "#eeff41", a400: "#c6ff00", a700: "#aeea00" }, yellow$1 = { 50: "#fffde7", 100: "#fff9c4", 200: "#fff59d", 300: "#fff176", 400: "#ffee58", 500: "#ffeb3b", 600: "#fdd835", 700: "#fbc02d", 800: "#f9a825", 900: "#f57f17", a100: "#ffff8d", a200: "#ffff00", a400: "#ffea00", a700: "#ffd600" }, amber = { 50: "#fff8e1", 100: "#ffecb3", 200: "#ffe082", 300: "#ffd54f", 400: "#ffca28", 500: "#ffc107", 600: "#ffb300", 700: "#ffa000", 800: "#ff8f00", 900: "#ff6f00", a100: "#ffe57f", a200: "#ffd740", a400: "#ffc400", a700: "#ffab00" }, orange$2 = { 50: "#fff3e0", 100: "#ffe0b2", 200: "#ffcc80", 300: "#ffb74d", 400: "#ffa726", 500: "#ff9800", 600: "#fb8c00", 700: "#f57c00", 800: "#ef6c00", 900: "#e65100", a100: "#ffd180", a200: "#ffab40", a400: "#ff9100", a700: "#ff6d00" }, deepOrange = { 50: "#fbe9e7", 100: "#ffccbc", 200: "#ffab91", 300: "#ff8a65", 400: "#ff7043", 500: "#ff5722", 600: "#f4511e", 700: "#e64a19", 800: "#d84315", 900: "#bf360c", a100: "#ff9e80", a200: "#ff6e40", a400: "#ff3d00", a700: "#dd2c00" }, brown = { 50: "#efebe9", 100: "#d7ccc8", 200: "#bcaaa4", 300: "#a1887f", 400: "#8d6e63", 500: "#795548", 600: "#6d4c41", 700: "#5d4037", 800: "#4e342e", 900: "#3e2723" }, blueGrey = { 50: "#eceff1", 100: "#cfd8dc", 200: "#b0bec5", 300: "#90a4ae", 400: "#78909c", 500: "#607d8b", 600: "#546e7a", 700: "#455a64", 800: "#37474f", 900: "#263238" }, CircleSwatch = function(S) {
  var R = S.color, k = S.onClick, D = S.onSwatchHover, L = S.hover, V = S.active, z = S.circleSize, W = S.circleSpacing, U = _default$3({
    default: {
      swatch: {
        width: z,
        height: z,
        marginRight: W,
        marginBottom: W,
        transform: "scale(1)",
        transition: "100ms transform ease"
      },
      Swatch: {
        borderRadius: "50%",
        background: "transparent",
        boxShadow: "inset 0 0 0 " + (z / 2 + 1) + "px " + R,
        transition: "100ms box-shadow ease"
      }
    },
    hover: {
      swatch: {
        transform: "scale(1.2)"
      }
    },
    active: {
      Swatch: {
        boxShadow: "inset 0 0 0 3px " + R
      }
    }
  }, { hover: L, active: V });
  return React__default.createElement(
    "div",
    { style: U.swatch },
    React__default.createElement(Swatch$3, {
      style: U.Swatch,
      color: R,
      onClick: k,
      onHover: D,
      focusStyle: { boxShadow: U.Swatch.boxShadow + ", 0 0 5px " + R }
    })
  );
};
CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};
const CircleSwatch$1 = handleHover(CircleSwatch);
var Circle$1 = function(S) {
  var R = S.width, k = S.onChange, D = S.onSwatchHover, L = S.colors, V = S.hex, z = S.circleSize, W = S.styles, U = W === void 0 ? {} : W, q = S.circleSpacing, K = S.className, Y = K === void 0 ? "" : K, J = _default$3(merge$4({
    default: {
      card: {
        width: R,
        display: "flex",
        flexWrap: "wrap",
        marginRight: -q,
        marginBottom: -q
      }
    }
  }, U)), Z = function(ee, te) {
    return k({ hex: ee, source: "hex" }, te);
  };
  return React__default.createElement(
    "div",
    { style: J.card, className: "circle-picker " + Y },
    map$1(L, function(X) {
      return React__default.createElement(CircleSwatch$1, {
        key: X,
        color: X,
        onClick: Z,
        onSwatchHover: D,
        active: V === X.toLowerCase(),
        circleSize: z,
        circleSpacing: q
      });
    })
  );
};
Circle$1.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  circleSize: PropTypes.number,
  circleSpacing: PropTypes.number,
  styles: PropTypes.object
};
Circle$1.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [red$2[500], pink[500], purple$2[500], deepPurple[500], indigo[500], blue$2[500], lightBlue$1[500], cyan[500], teal[500], green$2[500], lightGreen[500], lime[500], yellow$1[500], amber[500], orange$2[500], deepOrange[500], brown[500], blueGrey[500]],
  styles: {}
};
ColorWrap$2(Circle$1);
function isUndefined(T) {
  return T === void 0;
}
var UnfoldMoreHorizontalIcon = {};
Object.defineProperty(UnfoldMoreHorizontalIcon, "__esModule", {
  value: !0
});
var _extends$d = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, _react$a = React__default, _react2$a = _interopRequireDefault$d(_react$a);
function _interopRequireDefault$d(T) {
  return T && T.__esModule ? T : { default: T };
}
function _objectWithoutProperties$3(T, S) {
  var R = {};
  for (var k in T)
    S.indexOf(k) >= 0 || Object.prototype.hasOwnProperty.call(T, k) && (R[k] = T[k]);
  return R;
}
var DEFAULT_SIZE$1 = 24, _default$2 = UnfoldMoreHorizontalIcon.default = function(T) {
  var S = T.fill, R = S === void 0 ? "currentColor" : S, k = T.width, D = k === void 0 ? DEFAULT_SIZE$1 : k, L = T.height, V = L === void 0 ? DEFAULT_SIZE$1 : L, z = T.style, W = z === void 0 ? {} : z, U = _objectWithoutProperties$3(T, ["fill", "width", "height", "style"]);
  return _react2$a.default.createElement(
    "svg",
    _extends$d({
      viewBox: "0 0 " + DEFAULT_SIZE$1 + " " + DEFAULT_SIZE$1,
      style: _extends$d({ fill: R, width: D, height: V }, W)
    }, U),
    _react2$a.default.createElement("path", { d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z" })
  );
}, _createClass$7 = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}();
function _classCallCheck$7(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$7(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$7(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var ChromeFields = function(T) {
  _inherits$7(S, T);
  function S(R) {
    _classCallCheck$7(this, S);
    var k = _possibleConstructorReturn$7(this, (S.__proto__ || Object.getPrototypeOf(S)).call(this));
    return k.toggleViews = function() {
      k.state.view === "hex" ? k.setState({ view: "rgb" }) : k.state.view === "rgb" ? k.setState({ view: "hsl" }) : k.state.view === "hsl" && (k.props.hsl.a === 1 ? k.setState({ view: "hex" }) : k.setState({ view: "rgb" }));
    }, k.handleChange = function(D, L) {
      D.hex ? isValidHex(D.hex) && k.props.onChange({
        hex: D.hex,
        source: "hex"
      }, L) : D.r || D.g || D.b ? k.props.onChange({
        r: D.r || k.props.rgb.r,
        g: D.g || k.props.rgb.g,
        b: D.b || k.props.rgb.b,
        source: "rgb"
      }, L) : D.a ? (D.a < 0 ? D.a = 0 : D.a > 1 && (D.a = 1), k.props.onChange({
        h: k.props.hsl.h,
        s: k.props.hsl.s,
        l: k.props.hsl.l,
        a: Math.round(D.a * 100) / 100,
        source: "rgb"
      }, L)) : (D.h || D.s || D.l) && (typeof D.s == "string" && D.s.includes("%") && (D.s = D.s.replace("%", "")), typeof D.l == "string" && D.l.includes("%") && (D.l = D.l.replace("%", "")), D.s == 1 ? D.s = 0.01 : D.l == 1 && (D.l = 0.01), k.props.onChange({
        h: D.h || k.props.hsl.h,
        s: Number(isUndefined(D.s) ? k.props.hsl.s : D.s),
        l: Number(isUndefined(D.l) ? k.props.hsl.l : D.l),
        source: "hsl"
      }, L));
    }, k.showHighlight = function(D) {
      D.currentTarget.style.background = "#eee";
    }, k.hideHighlight = function(D) {
      D.currentTarget.style.background = "transparent";
    }, R.hsl.a !== 1 && R.view === "hex" ? k.state = {
      view: "rgb"
    } : k.state = {
      view: R.view
    }, k;
  }
  return _createClass$7(S, [{
    key: "render",
    value: function() {
      var k = this, D = _default$3({
        default: {
          wrap: {
            paddingTop: "16px",
            display: "flex"
          },
          fields: {
            flex: "1",
            display: "flex",
            marginLeft: "-6px"
          },
          field: {
            paddingLeft: "6px",
            width: "100%"
          },
          alpha: {
            paddingLeft: "6px",
            width: "100%"
          },
          toggle: {
            width: "32px",
            textAlign: "right",
            position: "relative"
          },
          icon: {
            marginRight: "-4px",
            marginTop: "12px",
            cursor: "pointer",
            position: "relative"
          },
          iconHighlight: {
            position: "absolute",
            width: "24px",
            height: "28px",
            background: "#eee",
            borderRadius: "4px",
            top: "10px",
            left: "12px",
            display: "none"
          },
          input: {
            fontSize: "11px",
            color: "#333",
            width: "100%",
            borderRadius: "2px",
            border: "none",
            boxShadow: "inset 0 0 0 1px #dadada",
            height: "21px",
            textAlign: "center"
          },
          label: {
            textTransform: "uppercase",
            fontSize: "11px",
            lineHeight: "11px",
            color: "#969696",
            textAlign: "center",
            display: "block",
            marginTop: "12px"
          },
          svg: {
            fill: "#333",
            width: "24px",
            height: "24px",
            border: "1px transparent solid",
            borderRadius: "5px"
          }
        },
        disableAlpha: {
          alpha: {
            display: "none"
          }
        }
      }, this.props, this.state), L = void 0;
      return this.state.view === "hex" ? L = React__default.createElement(
        "div",
        { style: D.fields, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: D.field },
          React__default.createElement(EditableInput$2, {
            style: { input: D.input, label: D.label },
            label: "hex",
            value: this.props.hex,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "rgb" ? L = React__default.createElement(
        "div",
        { style: D.fields, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: D.field },
          React__default.createElement(EditableInput$2, {
            style: { input: D.input, label: D.label },
            label: "r",
            value: this.props.rgb.r,
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: D.field },
          React__default.createElement(EditableInput$2, {
            style: { input: D.input, label: D.label },
            label: "g",
            value: this.props.rgb.g,
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: D.field },
          React__default.createElement(EditableInput$2, {
            style: { input: D.input, label: D.label },
            label: "b",
            value: this.props.rgb.b,
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: D.alpha },
          React__default.createElement(EditableInput$2, {
            style: { input: D.input, label: D.label },
            label: "a",
            value: this.props.rgb.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      ) : this.state.view === "hsl" && (L = React__default.createElement(
        "div",
        { style: D.fields, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: D.field },
          React__default.createElement(EditableInput$2, {
            style: { input: D.input, label: D.label },
            label: "h",
            value: Math.round(this.props.hsl.h),
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: D.field },
          React__default.createElement(EditableInput$2, {
            style: { input: D.input, label: D.label },
            label: "s",
            value: Math.round(this.props.hsl.s * 100) + "%",
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: D.field },
          React__default.createElement(EditableInput$2, {
            style: { input: D.input, label: D.label },
            label: "l",
            value: Math.round(this.props.hsl.l * 100) + "%",
            onChange: this.handleChange
          })
        ),
        React__default.createElement(
          "div",
          { style: D.alpha },
          React__default.createElement(EditableInput$2, {
            style: { input: D.input, label: D.label },
            label: "a",
            value: this.props.hsl.a,
            arrowOffset: 0.01,
            onChange: this.handleChange
          })
        )
      )), React__default.createElement(
        "div",
        { style: D.wrap, className: "flexbox-fix" },
        L,
        React__default.createElement(
          "div",
          { style: D.toggle },
          React__default.createElement(
            "div",
            { style: D.icon, onClick: this.toggleViews, ref: function(z) {
              return k.icon = z;
            } },
            React__default.createElement(_default$2, {
              style: D.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(k, D) {
      return k.hsl.a !== 1 && D.view === "hex" ? { view: "rgb" } : null;
    }
  }]), S;
}(React__default.Component);
ChromeFields.defaultProps = {
  view: "hex"
};
var ChromePointer = function() {
  var S = _default$3({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        transform: "translate(-6px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return React__default.createElement("div", { style: S.picker });
}, ChromePointerCircle = function() {
  var S = _default$3({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    }
  });
  return React__default.createElement("div", { style: S.picker });
}, Chrome = function(S) {
  var R = S.width, k = S.onChange, D = S.disableAlpha, L = S.rgb, V = S.hsl, z = S.hsv, W = S.hex, U = S.renderers, q = S.styles, K = q === void 0 ? {} : q, Y = S.className, J = Y === void 0 ? "" : Y, Z = S.defaultView, X = _default$3(merge$4({
    default: {
      picker: {
        width: R,
        background: "#fff",
        borderRadius: "2px",
        boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
        boxSizing: "initial",
        fontFamily: "Menlo"
      },
      saturation: {
        width: "100%",
        paddingBottom: "55%",
        position: "relative",
        borderRadius: "2px 2px 0 0",
        overflow: "hidden"
      },
      Saturation: {
        radius: "2px 2px 0 0"
      },
      body: {
        padding: "16px 16px 12px"
      },
      controls: {
        display: "flex"
      },
      color: {
        width: "32px"
      },
      swatch: {
        marginTop: "6px",
        width: "16px",
        height: "16px",
        borderRadius: "8px",
        position: "relative",
        overflow: "hidden"
      },
      active: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "8px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
        background: "rgba(" + L.r + ", " + L.g + ", " + L.b + ", " + L.a + ")",
        zIndex: "2"
      },
      toggles: {
        flex: "1"
      },
      hue: {
        height: "10px",
        position: "relative",
        marginBottom: "8px"
      },
      Hue: {
        radius: "2px"
      },
      alpha: {
        height: "10px",
        position: "relative"
      },
      Alpha: {
        radius: "2px"
      }
    },
    disableAlpha: {
      color: {
        width: "22px"
      },
      alpha: {
        display: "none"
      },
      hue: {
        marginBottom: "0px"
      },
      swatch: {
        width: "10px",
        height: "10px",
        marginTop: "0px"
      }
    }
  }, K), { disableAlpha: D });
  return React__default.createElement(
    "div",
    { style: X.picker, className: "chrome-picker " + J },
    React__default.createElement(
      "div",
      { style: X.saturation },
      React__default.createElement(Saturation$2, {
        style: X.Saturation,
        hsl: V,
        hsv: z,
        pointer: ChromePointerCircle,
        onChange: k
      })
    ),
    React__default.createElement(
      "div",
      { style: X.body },
      React__default.createElement(
        "div",
        { style: X.controls, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: X.color },
          React__default.createElement(
            "div",
            { style: X.swatch },
            React__default.createElement("div", { style: X.active }),
            React__default.createElement(Checkboard$2, { renderers: U })
          )
        ),
        React__default.createElement(
          "div",
          { style: X.toggles },
          React__default.createElement(
            "div",
            { style: X.hue },
            React__default.createElement(Hue$2, {
              style: X.Hue,
              hsl: V,
              pointer: ChromePointer,
              onChange: k
            })
          ),
          React__default.createElement(
            "div",
            { style: X.alpha },
            React__default.createElement(Alpha$2, {
              style: X.Alpha,
              rgb: L,
              hsl: V,
              pointer: ChromePointer,
              renderers: U,
              onChange: k
            })
          )
        )
      ),
      React__default.createElement(ChromeFields, {
        rgb: L,
        hsl: V,
        hex: W,
        view: Z,
        onChange: k,
        disableAlpha: D
      })
    )
  );
};
Chrome.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disableAlpha: PropTypes.bool,
  styles: PropTypes.object,
  defaultView: PropTypes.oneOf(["hex", "rgb", "hsl"])
};
Chrome.defaultProps = {
  width: 225,
  disableAlpha: !1,
  styles: {}
};
ColorWrap$2(Chrome);
var CompactColor = function(S) {
  var R = S.color, k = S.onClick, D = k === void 0 ? function() {
  } : k, L = S.onSwatchHover, V = S.active, z = _default$3({
    default: {
      color: {
        background: R,
        width: "15px",
        height: "15px",
        float: "left",
        marginRight: "5px",
        marginBottom: "5px",
        position: "relative",
        cursor: "pointer"
      },
      dot: {
        absolute: "5px 5px 5px 5px",
        background: getContrastingColor(R),
        borderRadius: "50%",
        opacity: "0"
      }
    },
    active: {
      dot: {
        opacity: "1"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      dot: {
        background: "#000"
      }
    },
    transparent: {
      dot: {
        background: "#000"
      }
    }
  }, { active: V, "color-#FFFFFF": R === "#FFFFFF", transparent: R === "transparent" });
  return React__default.createElement(
    Swatch$3,
    {
      style: z.color,
      color: R,
      onClick: D,
      onHover: L,
      focusStyle: { boxShadow: "0 0 4px " + R }
    },
    React__default.createElement("div", { style: z.dot })
  );
}, CompactFields = function(S) {
  var R = S.hex, k = S.rgb, D = S.onChange, L = _default$3({
    default: {
      fields: {
        display: "flex",
        paddingBottom: "6px",
        paddingRight: "5px",
        position: "relative"
      },
      active: {
        position: "absolute",
        top: "6px",
        left: "5px",
        height: "9px",
        width: "9px",
        background: R
      },
      HEXwrap: {
        flex: "6",
        position: "relative"
      },
      HEXinput: {
        width: "80%",
        padding: "0px",
        paddingLeft: "20%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      HEXlabel: {
        display: "none"
      },
      RGBwrap: {
        flex: "3",
        position: "relative"
      },
      RGBinput: {
        width: "70%",
        padding: "0px",
        paddingLeft: "30%",
        border: "none",
        outline: "none",
        background: "none",
        fontSize: "12px",
        color: "#333",
        height: "16px"
      },
      RGBlabel: {
        position: "absolute",
        top: "3px",
        left: "0px",
        lineHeight: "16px",
        textTransform: "uppercase",
        fontSize: "12px",
        color: "#999"
      }
    }
  }), V = function(W, U) {
    W.r || W.g || W.b ? D({
      r: W.r || k.r,
      g: W.g || k.g,
      b: W.b || k.b,
      source: "rgb"
    }, U) : D({
      hex: W.hex,
      source: "hex"
    }, U);
  };
  return React__default.createElement(
    "div",
    { style: L.fields, className: "flexbox-fix" },
    React__default.createElement("div", { style: L.active }),
    React__default.createElement(EditableInput$2, {
      style: { wrap: L.HEXwrap, input: L.HEXinput, label: L.HEXlabel },
      label: "hex",
      value: R,
      onChange: V
    }),
    React__default.createElement(EditableInput$2, {
      style: { wrap: L.RGBwrap, input: L.RGBinput, label: L.RGBlabel },
      label: "r",
      value: k.r,
      onChange: V
    }),
    React__default.createElement(EditableInput$2, {
      style: { wrap: L.RGBwrap, input: L.RGBinput, label: L.RGBlabel },
      label: "g",
      value: k.g,
      onChange: V
    }),
    React__default.createElement(EditableInput$2, {
      style: { wrap: L.RGBwrap, input: L.RGBinput, label: L.RGBlabel },
      label: "b",
      value: k.b,
      onChange: V
    })
  );
}, Compact = function(S) {
  var R = S.onChange, k = S.onSwatchHover, D = S.colors, L = S.hex, V = S.rgb, z = S.styles, W = z === void 0 ? {} : z, U = S.className, q = U === void 0 ? "" : U, K = _default$3(merge$4({
    default: {
      Compact: {
        background: "#f6f6f6",
        radius: "4px"
      },
      compact: {
        paddingTop: "5px",
        paddingLeft: "5px",
        boxSizing: "initial",
        width: "240px"
      },
      clear: {
        clear: "both"
      }
    }
  }, W)), Y = function(Z, X) {
    Z.hex ? isValidHex(Z.hex) && R({
      hex: Z.hex,
      source: "hex"
    }, X) : R(Z, X);
  };
  return React__default.createElement(
    Raised$2,
    { style: K.Compact, styles: W },
    React__default.createElement(
      "div",
      { style: K.compact, className: "compact-picker " + q },
      React__default.createElement(
        "div",
        null,
        map$1(D, function(J) {
          return React__default.createElement(CompactColor, {
            key: J,
            color: J,
            active: J.toLowerCase() === L,
            onClick: Y,
            onSwatchHover: k
          });
        }),
        React__default.createElement("div", { style: K.clear })
      ),
      React__default.createElement(CompactFields, { hex: L, rgb: V, onChange: Y })
    )
  );
};
Compact.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};
Compact.defaultProps = {
  colors: ["#4D4D4D", "#999999", "#FFFFFF", "#F44E3B", "#FE9200", "#FCDC00", "#DBDF00", "#A4DD00", "#68CCCA", "#73D8FF", "#AEA1FF", "#FDA1FF", "#333333", "#808080", "#cccccc", "#D33115", "#E27300", "#FCC400", "#B0BC00", "#68BC00", "#16A5A5", "#009CE0", "#7B64FF", "#FA28FF", "#000000", "#666666", "#B3B3B3", "#9F0500", "#C45100", "#FB9E00", "#808900", "#194D33", "#0C797D", "#0062B1", "#653294", "#AB149E"],
  styles: {}
};
ColorWrap$2(Compact);
var GithubSwatch = function(S) {
  var R = S.hover, k = S.color, D = S.onClick, L = S.onSwatchHover, V = {
    position: "relative",
    zIndex: "2",
    outline: "2px solid #fff",
    boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
  }, z = _default$3({
    default: {
      swatch: {
        width: "25px",
        height: "25px",
        fontSize: "0"
      }
    },
    hover: {
      swatch: V
    }
  }, { hover: R });
  return React__default.createElement(
    "div",
    { style: z.swatch },
    React__default.createElement(Swatch$3, {
      color: k,
      onClick: D,
      onHover: L,
      focusStyle: V
    })
  );
};
const GithubSwatch$1 = handleHover(GithubSwatch);
var Github = function(S) {
  var R = S.width, k = S.colors, D = S.onChange, L = S.onSwatchHover, V = S.triangle, z = S.styles, W = z === void 0 ? {} : z, U = S.className, q = U === void 0 ? "" : U, K = _default$3(merge$4({
    default: {
      card: {
        width: R,
        background: "#fff",
        border: "1px solid rgba(0,0,0,0.2)",
        boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
        borderRadius: "4px",
        position: "relative",
        padding: "5px",
        display: "flex",
        flexWrap: "wrap"
      },
      triangle: {
        position: "absolute",
        border: "7px solid transparent",
        borderBottomColor: "#fff"
      },
      triangleShadow: {
        position: "absolute",
        border: "8px solid transparent",
        borderBottomColor: "rgba(0,0,0,0.15)"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-14px",
        left: "10px"
      },
      triangleShadow: {
        top: "-16px",
        left: "9px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-14px",
        right: "10px"
      },
      triangleShadow: {
        top: "-16px",
        right: "9px"
      }
    },
    "bottom-left-triangle": {
      triangle: {
        top: "35px",
        left: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        left: "9px",
        transform: "rotate(180deg)"
      }
    },
    "bottom-right-triangle": {
      triangle: {
        top: "35px",
        right: "10px",
        transform: "rotate(180deg)"
      },
      triangleShadow: {
        top: "37px",
        right: "9px",
        transform: "rotate(180deg)"
      }
    }
  }, W), {
    "hide-triangle": V === "hide",
    "top-left-triangle": V === "top-left",
    "top-right-triangle": V === "top-right",
    "bottom-left-triangle": V === "bottom-left",
    "bottom-right-triangle": V === "bottom-right"
  }), Y = function(Z, X) {
    return D({ hex: Z, source: "hex" }, X);
  };
  return React__default.createElement(
    "div",
    { style: K.card, className: "github-picker " + q },
    React__default.createElement("div", { style: K.triangleShadow }),
    React__default.createElement("div", { style: K.triangle }),
    map$1(k, function(J) {
      return React__default.createElement(GithubSwatch$1, {
        color: J,
        key: J,
        onClick: Y,
        onSwatchHover: L
      });
    })
  );
};
Github.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.string),
  triangle: PropTypes.oneOf(["hide", "top-left", "top-right", "bottom-left", "bottom-right"]),
  styles: PropTypes.object
};
Github.defaultProps = {
  width: 200,
  colors: ["#B80000", "#DB3E00", "#FCCB00", "#008B02", "#006B76", "#1273DE", "#004DCF", "#5300EB", "#EB9694", "#FAD0C3", "#FEF3BD", "#C1E1C5", "#BEDADC", "#C4DEF6", "#BED3F3", "#D4C4FB"],
  triangle: "top-left",
  styles: {}
};
ColorWrap$2(Github);
var SliderPointer$1 = function(S) {
  var R = S.direction, k = _default$3({
    default: {
      picker: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        transform: "translate(-9px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    },
    vertical: {
      picker: {
        transform: "translate(-3px, -9px)"
      }
    }
  }, { vertical: R === "vertical" });
  return React__default.createElement("div", { style: k.picker });
}, _extends$c = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, HuePicker = function(S) {
  var R = S.width, k = S.height, D = S.onChange, L = S.hsl, V = S.direction, z = S.pointer, W = S.styles, U = W === void 0 ? {} : W, q = S.className, K = q === void 0 ? "" : q, Y = _default$3(merge$4({
    default: {
      picker: {
        position: "relative",
        width: R,
        height: k
      },
      hue: {
        radius: "2px"
      }
    }
  }, U)), J = function(X) {
    return D({ a: 1, h: X.h, l: 0.5, s: 1 });
  };
  return React__default.createElement(
    "div",
    { style: Y.picker, className: "hue-picker " + K },
    React__default.createElement(Hue$2, _extends$c({}, Y.hue, {
      hsl: L,
      pointer: z,
      onChange: J,
      direction: V
    }))
  );
};
HuePicker.propTypes = {
  styles: PropTypes.object
};
HuePicker.defaultProps = {
  width: "316px",
  height: "16px",
  direction: "horizontal",
  pointer: SliderPointer$1,
  styles: {}
};
ColorWrap$2(HuePicker);
var Material = function(S) {
  var R = S.onChange, k = S.hex, D = S.rgb, L = S.styles, V = L === void 0 ? {} : L, z = S.className, W = z === void 0 ? "" : z, U = _default$3(merge$4({
    default: {
      material: {
        width: "98px",
        height: "98px",
        padding: "16px",
        fontFamily: "Roboto"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "2px solid " + k,
        outline: "none",
        height: "30px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        width: "100%",
        marginTop: "12px",
        fontSize: "15px",
        color: "#333",
        padding: "0px",
        border: "0px",
        borderBottom: "1px solid #eee",
        outline: "none",
        height: "30px"
      },
      RGBlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        fontSize: "11px",
        color: "#999999",
        textTransform: "capitalize"
      },
      split: {
        display: "flex",
        marginRight: "-10px",
        paddingTop: "11px"
      },
      third: {
        flex: "1",
        paddingRight: "10px"
      }
    }
  }, V)), q = function(Y, J) {
    Y.hex ? isValidHex(Y.hex) && R({
      hex: Y.hex,
      source: "hex"
    }, J) : (Y.r || Y.g || Y.b) && R({
      r: Y.r || D.r,
      g: Y.g || D.g,
      b: Y.b || D.b,
      source: "rgb"
    }, J);
  };
  return React__default.createElement(
    Raised$2,
    { styles: V },
    React__default.createElement(
      "div",
      { style: U.material, className: "material-picker " + W },
      React__default.createElement(EditableInput$2, {
        style: { wrap: U.HEXwrap, input: U.HEXinput, label: U.HEXlabel },
        label: "hex",
        value: k,
        onChange: q
      }),
      React__default.createElement(
        "div",
        { style: U.split, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: U.third },
          React__default.createElement(EditableInput$2, {
            style: { wrap: U.RGBwrap, input: U.RGBinput, label: U.RGBlabel },
            label: "r",
            value: D.r,
            onChange: q
          })
        ),
        React__default.createElement(
          "div",
          { style: U.third },
          React__default.createElement(EditableInput$2, {
            style: { wrap: U.RGBwrap, input: U.RGBinput, label: U.RGBlabel },
            label: "g",
            value: D.g,
            onChange: q
          })
        ),
        React__default.createElement(
          "div",
          { style: U.third },
          React__default.createElement(EditableInput$2, {
            style: { wrap: U.RGBwrap, input: U.RGBinput, label: U.RGBlabel },
            label: "b",
            value: D.b,
            onChange: q
          })
        )
      )
    )
  );
};
ColorWrap$2(Material);
var PhotoshopPicker = function(S) {
  var R = S.onChange, k = S.rgb, D = S.hsv, L = S.hex, V = _default$3({
    default: {
      fields: {
        paddingTop: "5px",
        paddingBottom: "9px",
        width: "80px",
        position: "relative"
      },
      divider: {
        height: "5px"
      },
      RGBwrap: {
        position: "relative"
      },
      RGBinput: {
        marginLeft: "40%",
        width: "40%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "5px",
        fontSize: "13px",
        paddingLeft: "3px",
        marginRight: "10px"
      },
      RGBlabel: {
        left: "0px",
        top: "0px",
        width: "34px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px",
        position: "absolute"
      },
      HEXwrap: {
        position: "relative"
      },
      HEXinput: {
        marginLeft: "20%",
        width: "80%",
        height: "18px",
        border: "1px solid #888888",
        boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
        marginBottom: "6px",
        fontSize: "13px",
        paddingLeft: "3px"
      },
      HEXlabel: {
        position: "absolute",
        top: "0px",
        left: "0px",
        width: "14px",
        textTransform: "uppercase",
        fontSize: "13px",
        height: "18px",
        lineHeight: "22px"
      },
      fieldSymbols: {
        position: "absolute",
        top: "5px",
        right: "-7px",
        fontSize: "13px"
      },
      symbol: {
        height: "20px",
        lineHeight: "22px",
        paddingBottom: "7px"
      }
    }
  }), z = function(U, q) {
    U["#"] ? isValidHex(U["#"]) && R({
      hex: U["#"],
      source: "hex"
    }, q) : U.r || U.g || U.b ? R({
      r: U.r || k.r,
      g: U.g || k.g,
      b: U.b || k.b,
      source: "rgb"
    }, q) : (U.h || U.s || U.v) && R({
      h: U.h || D.h,
      s: U.s || D.s,
      v: U.v || D.v,
      source: "hsv"
    }, q);
  };
  return React__default.createElement(
    "div",
    { style: V.fields },
    React__default.createElement(EditableInput$2, {
      style: { wrap: V.RGBwrap, input: V.RGBinput, label: V.RGBlabel },
      label: "h",
      value: Math.round(D.h),
      onChange: z
    }),
    React__default.createElement(EditableInput$2, {
      style: { wrap: V.RGBwrap, input: V.RGBinput, label: V.RGBlabel },
      label: "s",
      value: Math.round(D.s * 100),
      onChange: z
    }),
    React__default.createElement(EditableInput$2, {
      style: { wrap: V.RGBwrap, input: V.RGBinput, label: V.RGBlabel },
      label: "v",
      value: Math.round(D.v * 100),
      onChange: z
    }),
    React__default.createElement("div", { style: V.divider }),
    React__default.createElement(EditableInput$2, {
      style: { wrap: V.RGBwrap, input: V.RGBinput, label: V.RGBlabel },
      label: "r",
      value: k.r,
      onChange: z
    }),
    React__default.createElement(EditableInput$2, {
      style: { wrap: V.RGBwrap, input: V.RGBinput, label: V.RGBlabel },
      label: "g",
      value: k.g,
      onChange: z
    }),
    React__default.createElement(EditableInput$2, {
      style: { wrap: V.RGBwrap, input: V.RGBinput, label: V.RGBlabel },
      label: "b",
      value: k.b,
      onChange: z
    }),
    React__default.createElement("div", { style: V.divider }),
    React__default.createElement(EditableInput$2, {
      style: { wrap: V.HEXwrap, input: V.HEXinput, label: V.HEXlabel },
      label: "#",
      value: L.replace("#", ""),
      onChange: z
    }),
    React__default.createElement(
      "div",
      { style: V.fieldSymbols },
      React__default.createElement(
        "div",
        { style: V.symbol },
        "°"
      ),
      React__default.createElement(
        "div",
        { style: V.symbol },
        "%"
      ),
      React__default.createElement(
        "div",
        { style: V.symbol },
        "%"
      )
    )
  );
}, PhotoshopPointerCircle$1 = function(S) {
  var R = S.hsl, k = _default$3({
    default: {
      picker: {
        width: "12px",
        height: "12px",
        borderRadius: "6px",
        boxShadow: "inset 0 0 0 1px #fff",
        transform: "translate(-6px, -6px)"
      }
    },
    "black-outline": {
      picker: {
        boxShadow: "inset 0 0 0 1px #000"
      }
    }
  }, { "black-outline": R.l > 0.5 });
  return React__default.createElement("div", { style: k.picker });
}, PhotoshopPointerCircle = function() {
  var S = _default$3({
    default: {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "4px 0 4px 6px",
        borderColor: "transparent transparent transparent #fff",
        position: "absolute",
        top: "1px",
        left: "1px"
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: "solid",
        borderWidth: "5px 0 5px 8px",
        borderColor: "transparent transparent transparent #555"
      },
      left: {
        Extend: "triangleBorder",
        transform: "translate(-13px, -4px)"
      },
      leftInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      },
      right: {
        Extend: "triangleBorder",
        transform: "translate(20px, -14px) rotate(180deg)"
      },
      rightInside: {
        Extend: "triangle",
        transform: "translate(-8px, -5px)"
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: S.pointer },
    React__default.createElement(
      "div",
      { style: S.left },
      React__default.createElement("div", { style: S.leftInside })
    ),
    React__default.createElement(
      "div",
      { style: S.right },
      React__default.createElement("div", { style: S.rightInside })
    )
  );
}, PhotoshopButton = function(S) {
  var R = S.onClick, k = S.label, D = S.children, L = S.active, V = _default$3({
    default: {
      button: {
        backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
        border: "1px solid #878787",
        borderRadius: "2px",
        height: "20px",
        boxShadow: "0 1px 0 0 #EAEAEA",
        fontSize: "14px",
        color: "#000",
        lineHeight: "20px",
        textAlign: "center",
        marginBottom: "10px",
        cursor: "pointer"
      }
    },
    active: {
      button: {
        boxShadow: "0 0 0 1px #878787"
      }
    }
  }, { active: L });
  return React__default.createElement(
    "div",
    { style: V.button, onClick: R },
    k || D
  );
}, PhotoshopPreviews = function(S) {
  var R = S.rgb, k = S.currentColor, D = _default$3({
    default: {
      swatches: {
        border: "1px solid #B3B3B3",
        borderBottom: "1px solid #F0F0F0",
        marginBottom: "2px",
        marginTop: "1px"
      },
      new: {
        height: "34px",
        background: "rgb(" + R.r + "," + R.g + ", " + R.b + ")",
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
      },
      current: {
        height: "34px",
        background: k,
        boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
      },
      label: {
        fontSize: "14px",
        color: "#000",
        textAlign: "center"
      }
    }
  });
  return React__default.createElement(
    "div",
    null,
    React__default.createElement(
      "div",
      { style: D.label },
      "new"
    ),
    React__default.createElement(
      "div",
      { style: D.swatches },
      React__default.createElement("div", { style: D.new }),
      React__default.createElement("div", { style: D.current })
    ),
    React__default.createElement(
      "div",
      { style: D.label },
      "current"
    )
  );
}, _createClass$6 = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}();
function _classCallCheck$6(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$6(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$6(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var Photoshop = function(T) {
  _inherits$6(S, T);
  function S(R) {
    _classCallCheck$6(this, S);
    var k = _possibleConstructorReturn$6(this, (S.__proto__ || Object.getPrototypeOf(S)).call(this));
    return k.state = {
      currentColor: R.hex
    }, k;
  }
  return _createClass$6(S, [{
    key: "render",
    value: function() {
      var k = this.props, D = k.styles, L = D === void 0 ? {} : D, V = k.className, z = V === void 0 ? "" : V, W = _default$3(merge$4({
        default: {
          picker: {
            background: "#DCDCDC",
            borderRadius: "4px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
            boxSizing: "initial",
            width: "513px"
          },
          head: {
            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
            borderBottom: "1px solid #B1B1B1",
            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
            height: "23px",
            lineHeight: "24px",
            borderRadius: "4px 4px 0 0",
            fontSize: "13px",
            color: "#4D4D4D",
            textAlign: "center"
          },
          body: {
            padding: "15px 15px 0",
            display: "flex"
          },
          saturation: {
            width: "256px",
            height: "256px",
            position: "relative",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0",
            overflow: "hidden"
          },
          hue: {
            position: "relative",
            height: "256px",
            width: "19px",
            marginLeft: "10px",
            border: "2px solid #B3B3B3",
            borderBottom: "2px solid #F0F0F0"
          },
          controls: {
            width: "180px",
            marginLeft: "10px"
          },
          top: {
            display: "flex"
          },
          previews: {
            width: "60px"
          },
          actions: {
            flex: "1",
            marginLeft: "20px"
          }
        }
      }, L));
      return React__default.createElement(
        "div",
        { style: W.picker, className: "photoshop-picker " + z },
        React__default.createElement(
          "div",
          { style: W.head },
          this.props.header
        ),
        React__default.createElement(
          "div",
          { style: W.body, className: "flexbox-fix" },
          React__default.createElement(
            "div",
            { style: W.saturation },
            React__default.createElement(Saturation$2, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: PhotoshopPointerCircle$1,
              onChange: this.props.onChange
            })
          ),
          React__default.createElement(
            "div",
            { style: W.hue },
            React__default.createElement(Hue$2, {
              direction: "vertical",
              hsl: this.props.hsl,
              pointer: PhotoshopPointerCircle,
              onChange: this.props.onChange
            })
          ),
          React__default.createElement(
            "div",
            { style: W.controls },
            React__default.createElement(
              "div",
              { style: W.top, className: "flexbox-fix" },
              React__default.createElement(
                "div",
                { style: W.previews },
                React__default.createElement(PhotoshopPreviews, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              React__default.createElement(
                "div",
                { style: W.actions },
                React__default.createElement(PhotoshopButton, { label: "OK", onClick: this.props.onAccept, active: !0 }),
                React__default.createElement(PhotoshopButton, { label: "Cancel", onClick: this.props.onCancel }),
                React__default.createElement(PhotoshopPicker, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]), S;
}(React__default.Component);
Photoshop.propTypes = {
  header: PropTypes.string,
  styles: PropTypes.object
};
Photoshop.defaultProps = {
  header: "Color Picker",
  styles: {}
};
ColorWrap$2(Photoshop);
var SketchFields = function(S) {
  var R = S.onChange, k = S.rgb, D = S.hsl, L = S.hex, V = S.disableAlpha, z = _default$3({
    default: {
      fields: {
        display: "flex",
        paddingTop: "4px"
      },
      single: {
        flex: "1",
        paddingLeft: "6px"
      },
      alpha: {
        flex: "1",
        paddingLeft: "6px"
      },
      double: {
        flex: "2"
      },
      input: {
        width: "80%",
        padding: "4px 10% 3px",
        border: "none",
        boxShadow: "inset 0 0 0 1px #ccc",
        fontSize: "11px"
      },
      label: {
        display: "block",
        textAlign: "center",
        fontSize: "11px",
        color: "#222",
        paddingTop: "3px",
        paddingBottom: "4px",
        textTransform: "capitalize"
      }
    },
    disableAlpha: {
      alpha: {
        display: "none"
      }
    }
  }, { disableAlpha: V }), W = function(q, K) {
    q.hex ? isValidHex(q.hex) && R({
      hex: q.hex,
      source: "hex"
    }, K) : q.r || q.g || q.b ? R({
      r: q.r || k.r,
      g: q.g || k.g,
      b: q.b || k.b,
      a: k.a,
      source: "rgb"
    }, K) : q.a && (q.a < 0 ? q.a = 0 : q.a > 100 && (q.a = 100), q.a /= 100, R({
      h: D.h,
      s: D.s,
      l: D.l,
      a: q.a,
      source: "rgb"
    }, K));
  };
  return React__default.createElement(
    "div",
    { style: z.fields, className: "flexbox-fix" },
    React__default.createElement(
      "div",
      { style: z.double },
      React__default.createElement(EditableInput$2, {
        style: { input: z.input, label: z.label },
        label: "hex",
        value: L.replace("#", ""),
        onChange: W
      })
    ),
    React__default.createElement(
      "div",
      { style: z.single },
      React__default.createElement(EditableInput$2, {
        style: { input: z.input, label: z.label },
        label: "r",
        value: k.r,
        onChange: W,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    React__default.createElement(
      "div",
      { style: z.single },
      React__default.createElement(EditableInput$2, {
        style: { input: z.input, label: z.label },
        label: "g",
        value: k.g,
        onChange: W,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    React__default.createElement(
      "div",
      { style: z.single },
      React__default.createElement(EditableInput$2, {
        style: { input: z.input, label: z.label },
        label: "b",
        value: k.b,
        onChange: W,
        dragLabel: "true",
        dragMax: "255"
      })
    ),
    React__default.createElement(
      "div",
      { style: z.alpha },
      React__default.createElement(EditableInput$2, {
        style: { input: z.input, label: z.label },
        label: "a",
        value: Math.round(k.a * 100),
        onChange: W,
        dragLabel: "true",
        dragMax: "100"
      })
    )
  );
}, _extends$b = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, SketchPresetColors = function(S) {
  var R = S.colors, k = S.onClick, D = k === void 0 ? function() {
  } : k, L = S.onSwatchHover, V = _default$3({
    default: {
      colors: {
        margin: "0 -10px",
        padding: "10px 0 0 10px",
        borderTop: "1px solid #eee",
        display: "flex",
        flexWrap: "wrap",
        position: "relative"
      },
      swatchWrap: {
        width: "16px",
        height: "16px",
        margin: "0 10px 10px 0"
      },
      swatch: {
        borderRadius: "3px",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
      }
    },
    "no-presets": {
      colors: {
        display: "none"
      }
    }
  }, {
    "no-presets": !R || !R.length
  }), z = function(U, q) {
    D({
      hex: U,
      source: "hex"
    }, q);
  };
  return React__default.createElement(
    "div",
    { style: V.colors, className: "flexbox-fix" },
    R.map(function(W) {
      var U = typeof W == "string" ? { color: W } : W, q = "" + U.color + (U.title || "");
      return React__default.createElement(
        "div",
        { key: q, style: V.swatchWrap },
        React__default.createElement(Swatch$3, _extends$b({}, U, {
          style: V.swatch,
          onClick: z,
          onHover: L,
          focusStyle: {
            boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + U.color
          }
        }))
      );
    })
  );
};
SketchPresetColors.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    color: PropTypes.string,
    title: PropTypes.string
  })])).isRequired
};
var _extends$a = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, Sketch = function(S) {
  var R = S.width, k = S.rgb, D = S.hex, L = S.hsv, V = S.hsl, z = S.onChange, W = S.onSwatchHover, U = S.disableAlpha, q = S.presetColors, K = S.renderers, Y = S.styles, J = Y === void 0 ? {} : Y, Z = S.className, X = Z === void 0 ? "" : Z, ee = _default$3(merge$4({
    default: _extends$a({
      picker: {
        width: R,
        padding: "10px 10px 0",
        boxSizing: "initial",
        background: "#fff",
        borderRadius: "4px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
      },
      saturation: {
        width: "100%",
        paddingBottom: "75%",
        position: "relative",
        overflow: "hidden"
      },
      Saturation: {
        radius: "3px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      controls: {
        display: "flex"
      },
      sliders: {
        padding: "4px 0",
        flex: "1"
      },
      color: {
        width: "24px",
        height: "24px",
        position: "relative",
        marginTop: "4px",
        marginLeft: "4px",
        borderRadius: "3px"
      },
      activeColor: {
        absolute: "0px 0px 0px 0px",
        borderRadius: "2px",
        background: "rgba(" + k.r + "," + k.g + "," + k.b + "," + k.a + ")",
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      hue: {
        position: "relative",
        height: "10px",
        overflow: "hidden"
      },
      Hue: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      },
      alpha: {
        position: "relative",
        height: "10px",
        marginTop: "4px",
        overflow: "hidden"
      },
      Alpha: {
        radius: "2px",
        shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
      }
    }, J),
    disableAlpha: {
      color: {
        height: "10px"
      },
      hue: {
        height: "10px"
      },
      alpha: {
        display: "none"
      }
    }
  }, J), { disableAlpha: U });
  return React__default.createElement(
    "div",
    { style: ee.picker, className: "sketch-picker " + X },
    React__default.createElement(
      "div",
      { style: ee.saturation },
      React__default.createElement(Saturation$2, {
        style: ee.Saturation,
        hsl: V,
        hsv: L,
        onChange: z
      })
    ),
    React__default.createElement(
      "div",
      { style: ee.controls, className: "flexbox-fix" },
      React__default.createElement(
        "div",
        { style: ee.sliders },
        React__default.createElement(
          "div",
          { style: ee.hue },
          React__default.createElement(Hue$2, {
            style: ee.Hue,
            hsl: V,
            onChange: z
          })
        ),
        React__default.createElement(
          "div",
          { style: ee.alpha },
          React__default.createElement(Alpha$2, {
            style: ee.Alpha,
            rgb: k,
            hsl: V,
            renderers: K,
            onChange: z
          })
        )
      ),
      React__default.createElement(
        "div",
        { style: ee.color },
        React__default.createElement(Checkboard$2, null),
        React__default.createElement("div", { style: ee.activeColor })
      )
    ),
    React__default.createElement(SketchFields, {
      rgb: k,
      hsl: V,
      hex: D,
      onChange: z,
      disableAlpha: U
    }),
    React__default.createElement(SketchPresetColors, {
      colors: q,
      onClick: z,
      onSwatchHover: W
    })
  );
};
Sketch.propTypes = {
  disableAlpha: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object
};
Sketch.defaultProps = {
  disableAlpha: !1,
  width: 200,
  styles: {},
  presetColors: ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"]
};
ColorWrap$2(Sketch);
var SliderSwatch = function(S) {
  var R = S.hsl, k = S.offset, D = S.onClick, L = D === void 0 ? function() {
  } : D, V = S.active, z = S.first, W = S.last, U = _default$3({
    default: {
      swatch: {
        height: "12px",
        background: "hsl(" + R.h + ", 50%, " + k * 100 + "%)",
        cursor: "pointer"
      }
    },
    first: {
      swatch: {
        borderRadius: "2px 0 0 2px"
      }
    },
    last: {
      swatch: {
        borderRadius: "0 2px 2px 0"
      }
    },
    active: {
      swatch: {
        transform: "scaleY(1.8)",
        borderRadius: "3.6px/2px"
      }
    }
  }, { active: V, first: z, last: W }), q = function(Y) {
    return L({
      h: R.h,
      s: 0.5,
      l: k,
      source: "hsl"
    }, Y);
  };
  return React__default.createElement("div", { style: U.swatch, onClick: q });
}, SliderSwatches = function(S) {
  var R = S.onClick, k = S.hsl, D = _default$3({
    default: {
      swatches: {
        marginTop: "20px"
      },
      swatch: {
        boxSizing: "border-box",
        width: "20%",
        paddingRight: "1px",
        float: "left"
      },
      clear: {
        clear: "both"
      }
    }
  }), L = 0.1;
  return React__default.createElement(
    "div",
    { style: D.swatches },
    React__default.createElement(
      "div",
      { style: D.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: k,
        offset: ".80",
        active: Math.abs(k.l - 0.8) < L && Math.abs(k.s - 0.5) < L,
        onClick: R,
        first: !0
      })
    ),
    React__default.createElement(
      "div",
      { style: D.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: k,
        offset: ".65",
        active: Math.abs(k.l - 0.65) < L && Math.abs(k.s - 0.5) < L,
        onClick: R
      })
    ),
    React__default.createElement(
      "div",
      { style: D.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: k,
        offset: ".50",
        active: Math.abs(k.l - 0.5) < L && Math.abs(k.s - 0.5) < L,
        onClick: R
      })
    ),
    React__default.createElement(
      "div",
      { style: D.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: k,
        offset: ".35",
        active: Math.abs(k.l - 0.35) < L && Math.abs(k.s - 0.5) < L,
        onClick: R
      })
    ),
    React__default.createElement(
      "div",
      { style: D.swatch },
      React__default.createElement(SliderSwatch, {
        hsl: k,
        offset: ".20",
        active: Math.abs(k.l - 0.2) < L && Math.abs(k.s - 0.5) < L,
        onClick: R,
        last: !0
      })
    ),
    React__default.createElement("div", { style: D.clear })
  );
}, SliderPointer = function() {
  var S = _default$3({
    default: {
      picker: {
        width: "14px",
        height: "14px",
        borderRadius: "6px",
        transform: "translate(-7px, -1px)",
        backgroundColor: "rgb(248, 248, 248)",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
      }
    }
  });
  return React__default.createElement("div", { style: S.picker });
}, Slider = function(S) {
  var R = S.hsl, k = S.onChange, D = S.pointer, L = S.styles, V = L === void 0 ? {} : L, z = S.className, W = z === void 0 ? "" : z, U = _default$3(merge$4({
    default: {
      hue: {
        height: "12px",
        position: "relative"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, V));
  return React__default.createElement(
    "div",
    { style: U.wrap || {}, className: "slider-picker " + W },
    React__default.createElement(
      "div",
      { style: U.hue },
      React__default.createElement(Hue$2, {
        style: U.Hue,
        hsl: R,
        pointer: D,
        onChange: k
      })
    ),
    React__default.createElement(
      "div",
      { style: U.swatches },
      React__default.createElement(SliderSwatches, { hsl: R, onClick: k })
    )
  );
};
Slider.propTypes = {
  styles: PropTypes.object
};
Slider.defaultProps = {
  pointer: SliderPointer,
  styles: {}
};
ColorWrap$2(Slider);
var CheckIcon = {};
Object.defineProperty(CheckIcon, "__esModule", {
  value: !0
});
var _extends$9 = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, _react$9 = React__default, _react2$9 = _interopRequireDefault$c(_react$9);
function _interopRequireDefault$c(T) {
  return T && T.__esModule ? T : { default: T };
}
function _objectWithoutProperties$2(T, S) {
  var R = {};
  for (var k in T)
    S.indexOf(k) >= 0 || Object.prototype.hasOwnProperty.call(T, k) && (R[k] = T[k]);
  return R;
}
var DEFAULT_SIZE = 24, _default$1 = CheckIcon.default = function(T) {
  var S = T.fill, R = S === void 0 ? "currentColor" : S, k = T.width, D = k === void 0 ? DEFAULT_SIZE : k, L = T.height, V = L === void 0 ? DEFAULT_SIZE : L, z = T.style, W = z === void 0 ? {} : z, U = _objectWithoutProperties$2(T, ["fill", "width", "height", "style"]);
  return _react2$9.default.createElement(
    "svg",
    _extends$9({
      viewBox: "0 0 " + DEFAULT_SIZE + " " + DEFAULT_SIZE,
      style: _extends$9({ fill: R, width: D, height: V }, W)
    }, U),
    _react2$9.default.createElement("path", { d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" })
  );
}, SwatchesColor = function(S) {
  var R = S.color, k = S.onClick, D = k === void 0 ? function() {
  } : k, L = S.onSwatchHover, V = S.first, z = S.last, W = S.active, U = _default$3({
    default: {
      color: {
        width: "40px",
        height: "24px",
        cursor: "pointer",
        background: R,
        marginBottom: "1px"
      },
      check: {
        color: getContrastingColor(R),
        marginLeft: "8px",
        display: "none"
      }
    },
    first: {
      color: {
        overflow: "hidden",
        borderRadius: "2px 2px 0 0"
      }
    },
    last: {
      color: {
        overflow: "hidden",
        borderRadius: "0 0 2px 2px"
      }
    },
    active: {
      check: {
        display: "block"
      }
    },
    "color-#FFFFFF": {
      color: {
        boxShadow: "inset 0 0 0 1px #ddd"
      },
      check: {
        color: "#333"
      }
    },
    transparent: {
      check: {
        color: "#333"
      }
    }
  }, {
    first: V,
    last: z,
    active: W,
    "color-#FFFFFF": R === "#FFFFFF",
    transparent: R === "transparent"
  });
  return React__default.createElement(
    Swatch$3,
    {
      color: R,
      style: U.color,
      onClick: D,
      onHover: L,
      focusStyle: { boxShadow: "0 0 4px " + R }
    },
    React__default.createElement(
      "div",
      { style: U.check },
      React__default.createElement(_default$1, null)
    )
  );
}, SwatchesGroup = function(S) {
  var R = S.onClick, k = S.onSwatchHover, D = S.group, L = S.active, V = _default$3({
    default: {
      group: {
        paddingBottom: "10px",
        width: "40px",
        float: "left",
        marginRight: "10px"
      }
    }
  });
  return React__default.createElement(
    "div",
    { style: V.group },
    map$1(D, function(z, W) {
      return React__default.createElement(SwatchesColor, {
        key: z,
        color: z,
        active: z.toLowerCase() === L,
        first: W === 0,
        last: W === D.length - 1,
        onClick: R,
        onSwatchHover: k
      });
    })
  );
}, Swatches = function(S) {
  var R = S.width, k = S.height, D = S.onChange, L = S.onSwatchHover, V = S.colors, z = S.hex, W = S.styles, U = W === void 0 ? {} : W, q = S.className, K = q === void 0 ? "" : q, Y = _default$3(merge$4({
    default: {
      picker: {
        width: R,
        height: k
      },
      overflow: {
        height: k,
        overflowY: "scroll"
      },
      body: {
        padding: "16px 0 6px 16px"
      },
      clear: {
        clear: "both"
      }
    }
  }, U)), J = function(X, ee) {
    return D({ hex: X, source: "hex" }, ee);
  };
  return React__default.createElement(
    "div",
    { style: Y.picker, className: "swatches-picker " + K },
    React__default.createElement(
      Raised$2,
      null,
      React__default.createElement(
        "div",
        { style: Y.overflow },
        React__default.createElement(
          "div",
          { style: Y.body },
          map$1(V, function(Z) {
            return React__default.createElement(SwatchesGroup, {
              key: Z.toString(),
              group: Z,
              active: z,
              onClick: J,
              onSwatchHover: L
            });
          }),
          React__default.createElement("div", { style: Y.clear })
        )
      )
    )
  );
};
Swatches.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colors: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  styles: PropTypes.object
  /* eslint-disable max-len */
};
Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[red$2[900], red$2[700], red$2[500], red$2[300], red$2[100]], [pink[900], pink[700], pink[500], pink[300], pink[100]], [purple$2[900], purple$2[700], purple$2[500], purple$2[300], purple$2[100]], [deepPurple[900], deepPurple[700], deepPurple[500], deepPurple[300], deepPurple[100]], [indigo[900], indigo[700], indigo[500], indigo[300], indigo[100]], [blue$2[900], blue$2[700], blue$2[500], blue$2[300], blue$2[100]], [lightBlue$1[900], lightBlue$1[700], lightBlue$1[500], lightBlue$1[300], lightBlue$1[100]], [cyan[900], cyan[700], cyan[500], cyan[300], cyan[100]], [teal[900], teal[700], teal[500], teal[300], teal[100]], ["#194D33", green$2[700], green$2[500], green$2[300], green$2[100]], [lightGreen[900], lightGreen[700], lightGreen[500], lightGreen[300], lightGreen[100]], [lime[900], lime[700], lime[500], lime[300], lime[100]], [yellow$1[900], yellow$1[700], yellow$1[500], yellow$1[300], yellow$1[100]], [amber[900], amber[700], amber[500], amber[300], amber[100]], [orange$2[900], orange$2[700], orange$2[500], orange$2[300], orange$2[100]], [deepOrange[900], deepOrange[700], deepOrange[500], deepOrange[300], deepOrange[100]], [brown[900], brown[700], brown[500], brown[300], brown[100]], [blueGrey[900], blueGrey[700], blueGrey[500], blueGrey[300], blueGrey[100]], ["#000000", "#525252", "#969696", "#D9D9D9", "#FFFFFF"]],
  styles: {}
};
ColorWrap$2(Swatches);
var Twitter = function(S) {
  var R = S.onChange, k = S.onSwatchHover, D = S.hex, L = S.colors, V = S.width, z = S.triangle, W = S.styles, U = W === void 0 ? {} : W, q = S.className, K = q === void 0 ? "" : q, Y = _default$3(merge$4({
    default: {
      card: {
        width: V,
        background: "#fff",
        border: "0 solid rgba(0,0,0,0.25)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
        borderRadius: "4px",
        position: "relative"
      },
      body: {
        padding: "15px 9px 9px 15px"
      },
      label: {
        fontSize: "18px",
        color: "#fff"
      },
      triangle: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent #fff transparent",
        position: "absolute"
      },
      triangleShadow: {
        width: "0px",
        height: "0px",
        borderStyle: "solid",
        borderWidth: "0 9px 10px 9px",
        borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
        position: "absolute"
      },
      hash: {
        background: "#F0F0F0",
        height: "30px",
        width: "30px",
        borderRadius: "4px 0 0 4px",
        float: "left",
        color: "#98A1A4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      input: {
        width: "100px",
        fontSize: "14px",
        color: "#666",
        border: "0px",
        outline: "none",
        height: "28px",
        boxShadow: "inset 0 0 0 1px #F0F0F0",
        boxSizing: "content-box",
        borderRadius: "0 4px 4px 0",
        float: "left",
        paddingLeft: "8px"
      },
      swatch: {
        width: "30px",
        height: "30px",
        float: "left",
        borderRadius: "4px",
        margin: "0 6px 6px 0"
      },
      clear: {
        clear: "both"
      }
    },
    "hide-triangle": {
      triangle: {
        display: "none"
      },
      triangleShadow: {
        display: "none"
      }
    },
    "top-left-triangle": {
      triangle: {
        top: "-10px",
        left: "12px"
      },
      triangleShadow: {
        top: "-11px",
        left: "12px"
      }
    },
    "top-right-triangle": {
      triangle: {
        top: "-10px",
        right: "12px"
      },
      triangleShadow: {
        top: "-11px",
        right: "12px"
      }
    }
  }, U), {
    "hide-triangle": z === "hide",
    "top-left-triangle": z === "top-left",
    "top-right-triangle": z === "top-right"
  }), J = function(X, ee) {
    isValidHex(X) && R({
      hex: X,
      source: "hex"
    }, ee);
  };
  return React__default.createElement(
    "div",
    { style: Y.card, className: "twitter-picker " + K },
    React__default.createElement("div", { style: Y.triangleShadow }),
    React__default.createElement("div", { style: Y.triangle }),
    React__default.createElement(
      "div",
      { style: Y.body },
      map$1(L, function(Z, X) {
        return React__default.createElement(Swatch$3, {
          key: X,
          color: Z,
          hex: Z,
          style: Y.swatch,
          onClick: J,
          onHover: k,
          focusStyle: {
            boxShadow: "0 0 4px " + Z
          }
        });
      }),
      React__default.createElement(
        "div",
        { style: Y.hash },
        "#"
      ),
      React__default.createElement(EditableInput$2, {
        label: null,
        style: { input: Y.input },
        value: D.replace("#", ""),
        onChange: J
      }),
      React__default.createElement("div", { style: Y.clear })
    )
  );
};
Twitter.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  triangle: PropTypes.oneOf(["hide", "top-left", "top-right"]),
  colors: PropTypes.arrayOf(PropTypes.string),
  styles: PropTypes.object
};
Twitter.defaultProps = {
  width: 276,
  colors: ["#FF6900", "#FCB900", "#7BDCB5", "#00D084", "#8ED1FC", "#0693E3", "#ABB8C3", "#EB144C", "#F78DA7", "#9900EF"],
  triangle: "top-left",
  styles: {}
};
ColorWrap$2(Twitter);
var GooglePointerCircle = function(S) {
  var R = _default$3({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        border: "2px #fff solid",
        transform: "translate(-12px, -13px)",
        background: "hsl(" + Math.round(S.hsl.h) + ", " + Math.round(S.hsl.s * 100) + "%, " + Math.round(S.hsl.l * 100) + "%)"
      }
    }
  });
  return React__default.createElement("div", { style: R.picker });
};
GooglePointerCircle.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};
GooglePointerCircle.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var GooglePointer = function(S) {
  var R = _default$3({
    default: {
      picker: {
        width: "20px",
        height: "20px",
        borderRadius: "22px",
        transform: "translate(-10px, -7px)",
        background: "hsl(" + Math.round(S.hsl.h) + ", 100%, 50%)",
        border: "2px white solid"
      }
    }
  });
  return React__default.createElement("div", { style: R.picker });
};
GooglePointer.propTypes = {
  hsl: PropTypes.shape({
    h: PropTypes.number,
    s: PropTypes.number,
    l: PropTypes.number,
    a: PropTypes.number
  })
};
GooglePointer.defaultProps = {
  hsl: { a: 1, h: 249.94, l: 0.2, s: 0.5 }
};
var GoogleFields = function(S) {
  var R = S.onChange, k = S.rgb, D = S.hsl, L = S.hex, V = S.hsv, z = function(J, Z) {
    if (J.hex)
      isValidHex(J.hex) && R({
        hex: J.hex,
        source: "hex"
      }, Z);
    else if (J.rgb) {
      var X = J.rgb.split(",");
      isvalidColorString(J.rgb, "rgb") && R({
        r: X[0],
        g: X[1],
        b: X[2],
        a: 1,
        source: "rgb"
      }, Z);
    } else if (J.hsv) {
      var ee = J.hsv.split(",");
      isvalidColorString(J.hsv, "hsv") && (ee[2] = ee[2].replace("%", ""), ee[1] = ee[1].replace("%", ""), ee[0] = ee[0].replace("°", ""), ee[1] == 1 ? ee[1] = 0.01 : ee[2] == 1 && (ee[2] = 0.01), R({
        h: Number(ee[0]),
        s: Number(ee[1]),
        v: Number(ee[2]),
        source: "hsv"
      }, Z));
    } else if (J.hsl) {
      var te = J.hsl.split(",");
      isvalidColorString(J.hsl, "hsl") && (te[2] = te[2].replace("%", ""), te[1] = te[1].replace("%", ""), te[0] = te[0].replace("°", ""), K[1] == 1 ? K[1] = 0.01 : K[2] == 1 && (K[2] = 0.01), R({
        h: Number(te[0]),
        s: Number(te[1]),
        v: Number(te[2]),
        source: "hsl"
      }, Z));
    }
  }, W = _default$3({
    default: {
      wrap: {
        display: "flex",
        height: "100px",
        marginTop: "4px"
      },
      fields: {
        width: "100%"
      },
      column: {
        paddingTop: "10px",
        display: "flex",
        justifyContent: "space-between"
      },
      double: {
        padding: "0px 4.4px",
        boxSizing: "border-box"
      },
      input: {
        width: "100%",
        height: "38px",
        boxSizing: "border-box",
        padding: "4px 10% 3px",
        textAlign: "center",
        border: "1px solid #dadce0",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      input2: {
        height: "38px",
        width: "100%",
        border: "1px solid #dadce0",
        boxSizing: "border-box",
        fontSize: "11px",
        textTransform: "lowercase",
        borderRadius: "5px",
        outline: "none",
        paddingLeft: "10px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label: {
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "35px",
        top: "-6px",
        left: "0",
        right: "0",
        marginLeft: "auto",
        marginRight: "auto",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      label2: {
        left: "10px",
        textAlign: "center",
        fontSize: "12px",
        background: "#fff",
        position: "absolute",
        textTransform: "uppercase",
        color: "#3c4043",
        width: "32px",
        top: "-6px",
        fontFamily: "Roboto,Arial,sans-serif"
      },
      single: {
        flexGrow: "1",
        margin: "0px 4.4px"
      }
    }
  }), U = k.r + ", " + k.g + ", " + k.b, q = Math.round(D.h) + "°, " + Math.round(D.s * 100) + "%, " + Math.round(D.l * 100) + "%", K = Math.round(V.h) + "°, " + Math.round(V.s * 100) + "%, " + Math.round(V.v * 100) + "%";
  return React__default.createElement(
    "div",
    { style: W.wrap, className: "flexbox-fix" },
    React__default.createElement(
      "div",
      { style: W.fields },
      React__default.createElement(
        "div",
        { style: W.double },
        React__default.createElement(EditableInput$2, {
          style: { input: W.input, label: W.label },
          label: "hex",
          value: L,
          onChange: z
        })
      ),
      React__default.createElement(
        "div",
        { style: W.column },
        React__default.createElement(
          "div",
          { style: W.single },
          React__default.createElement(EditableInput$2, {
            style: { input: W.input2, label: W.label2 },
            label: "rgb",
            value: U,
            onChange: z
          })
        ),
        React__default.createElement(
          "div",
          { style: W.single },
          React__default.createElement(EditableInput$2, {
            style: { input: W.input2, label: W.label2 },
            label: "hsv",
            value: K,
            onChange: z
          })
        ),
        React__default.createElement(
          "div",
          { style: W.single },
          React__default.createElement(EditableInput$2, {
            style: { input: W.input2, label: W.label2 },
            label: "hsl",
            value: q,
            onChange: z
          })
        )
      )
    )
  );
}, Google = function(S) {
  var R = S.width, k = S.onChange, D = S.rgb, L = S.hsl, V = S.hsv, z = S.hex, W = S.header, U = S.styles, q = U === void 0 ? {} : U, K = S.className, Y = K === void 0 ? "" : K, J = _default$3(merge$4({
    default: {
      picker: {
        width: R,
        background: "#fff",
        border: "1px solid #dfe1e5",
        boxSizing: "initial",
        display: "flex",
        flexWrap: "wrap",
        borderRadius: "8px 8px 0px 0px"
      },
      head: {
        height: "57px",
        width: "100%",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "16px",
        fontSize: "20px",
        boxSizing: "border-box",
        fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
      },
      saturation: {
        width: "70%",
        padding: "0px",
        position: "relative",
        overflow: "hidden"
      },
      swatch: {
        width: "30%",
        height: "228px",
        padding: "0px",
        background: "rgba(" + D.r + ", " + D.g + ", " + D.b + ", 1)",
        position: "relative",
        overflow: "hidden"
      },
      body: {
        margin: "auto",
        width: "95%"
      },
      controls: {
        display: "flex",
        boxSizing: "border-box",
        height: "52px",
        paddingTop: "22px"
      },
      color: {
        width: "32px"
      },
      hue: {
        height: "8px",
        position: "relative",
        margin: "0px 16px 0px 16px",
        width: "100%"
      },
      Hue: {
        radius: "2px"
      }
    }
  }, q));
  return React__default.createElement(
    "div",
    { style: J.picker, className: "google-picker " + Y },
    React__default.createElement(
      "div",
      { style: J.head },
      W
    ),
    React__default.createElement("div", { style: J.swatch }),
    React__default.createElement(
      "div",
      { style: J.saturation },
      React__default.createElement(Saturation$2, {
        hsl: L,
        hsv: V,
        pointer: GooglePointerCircle,
        onChange: k
      })
    ),
    React__default.createElement(
      "div",
      { style: J.body },
      React__default.createElement(
        "div",
        { style: J.controls, className: "flexbox-fix" },
        React__default.createElement(
          "div",
          { style: J.hue },
          React__default.createElement(Hue$2, {
            style: J.Hue,
            hsl: L,
            radius: "4px",
            pointer: GooglePointer,
            onChange: k
          })
        )
      ),
      React__default.createElement(GoogleFields, {
        rgb: D,
        hsl: L,
        hex: z,
        hsv: V,
        onChange: k
      })
    )
  );
};
Google.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  styles: PropTypes.object,
  header: PropTypes.string
};
Google.defaultProps = {
  width: 652,
  styles: {},
  header: "Color picker"
};
ColorWrap$2(Google);
var common$1 = {}, Alpha$1 = {}, alpha$3 = {};
Object.defineProperty(alpha$3, "__esModule", {
  value: !0
});
alpha$3.calculateChange = function(S, R, k, D, L) {
  var V = L.clientWidth, z = L.clientHeight, W = typeof S.pageX == "number" ? S.pageX : S.touches[0].pageX, U = typeof S.pageY == "number" ? S.pageY : S.touches[0].pageY, q = W - (L.getBoundingClientRect().left + window.pageXOffset), K = U - (L.getBoundingClientRect().top + window.pageYOffset);
  if (k === "vertical") {
    var Y = void 0;
    if (K < 0 ? Y = 0 : K > z ? Y = 1 : Y = Math.round(K * 100 / z) / 100, R.a !== Y)
      return {
        h: R.h,
        s: R.s,
        l: R.l,
        a: Y,
        source: "rgb"
      };
  } else {
    var J = void 0;
    if (q < 0 ? J = 0 : q > V ? J = 1 : J = Math.round(q * 100 / V) / 100, D !== J)
      return {
        h: R.h,
        s: R.s,
        l: R.l,
        a: J,
        source: "rgb"
      };
  }
  return null;
};
var Checkboard$1 = {}, checkboard$1 = {};
Object.defineProperty(checkboard$1, "__esModule", {
  value: !0
});
var checkboardCache = {}, render = checkboard$1.render = function(S, R, k, D) {
  if (typeof document > "u" && !D)
    return null;
  var L = D ? new D() : document.createElement("canvas");
  L.width = k * 2, L.height = k * 2;
  var V = L.getContext("2d");
  return V ? (V.fillStyle = S, V.fillRect(0, 0, L.width, L.height), V.fillStyle = R, V.fillRect(0, 0, k, k), V.translate(k, k), V.fillRect(0, 0, k, k), L.toDataURL()) : null;
};
checkboard$1.get = function(S, R, k, D) {
  var L = S + "-" + R + "-" + k + (D ? "-server" : "");
  if (checkboardCache[L])
    return checkboardCache[L];
  var V = render(S, R, k, D);
  return checkboardCache[L] = V, V;
};
Object.defineProperty(Checkboard$1, "__esModule", {
  value: !0
});
Checkboard$1.Checkboard = void 0;
var _extends$8 = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, _react$8 = React__default, _react2$8 = _interopRequireDefault$b(_react$8), _reactcss$6 = lib$2, _reactcss2$6 = _interopRequireDefault$b(_reactcss$6), _checkboard = checkboard$1, checkboard = _interopRequireWildcard$6(_checkboard);
function _interopRequireWildcard$6(T) {
  if (T && T.__esModule)
    return T;
  var S = {};
  if (T != null)
    for (var R in T)
      Object.prototype.hasOwnProperty.call(T, R) && (S[R] = T[R]);
  return S.default = T, S;
}
function _interopRequireDefault$b(T) {
  return T && T.__esModule ? T : { default: T };
}
var Checkboard = Checkboard$1.Checkboard = function(S) {
  var R = S.white, k = S.grey, D = S.size, L = S.renderers, V = S.borderRadius, z = S.boxShadow, W = S.children, U = (0, _reactcss2$6.default)({
    default: {
      grid: {
        borderRadius: V,
        boxShadow: z,
        absolute: "0px 0px 0px 0px",
        background: "url(" + checkboard.get(R, k, D, L.canvas) + ") center left"
      }
    }
  });
  return (0, _react$8.isValidElement)(W) ? _react2$8.default.cloneElement(W, _extends$8({}, W.props, { style: _extends$8({}, W.props.style, U.grid) })) : _react2$8.default.createElement("div", { style: U.grid });
};
Checkboard.defaultProps = {
  size: 8,
  white: "transparent",
  grey: "rgba(0,0,0,.08)",
  renderers: {}
};
Checkboard$1.default = Checkboard;
Object.defineProperty(Alpha$1, "__esModule", {
  value: !0
});
Alpha$1.Alpha = void 0;
var _extends$7 = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, _createClass$5 = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}(), _react$7 = React__default, _react2$7 = _interopRequireDefault$a(_react$7), _reactcss$5 = lib$2, _reactcss2$5 = _interopRequireDefault$a(_reactcss$5), _alpha = alpha$3, alpha$2 = _interopRequireWildcard$5(_alpha), _Checkboard$1 = Checkboard$1, _Checkboard2$1 = _interopRequireDefault$a(_Checkboard$1);
function _interopRequireWildcard$5(T) {
  if (T && T.__esModule)
    return T;
  var S = {};
  if (T != null)
    for (var R in T)
      Object.prototype.hasOwnProperty.call(T, R) && (S[R] = T[R]);
  return S.default = T, S;
}
function _interopRequireDefault$a(T) {
  return T && T.__esModule ? T : { default: T };
}
function _classCallCheck$5(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$5(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$5(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var Alpha = Alpha$1.Alpha = function(T) {
  _inherits$5(S, T);
  function S() {
    var R, k, D, L;
    _classCallCheck$5(this, S);
    for (var V = arguments.length, z = Array(V), W = 0; W < V; W++)
      z[W] = arguments[W];
    return L = (k = (D = _possibleConstructorReturn$5(this, (R = S.__proto__ || Object.getPrototypeOf(S)).call.apply(R, [this].concat(z))), D), D.handleChange = function(U) {
      var q = alpha$2.calculateChange(U, D.props.hsl, D.props.direction, D.props.a, D.container);
      q && typeof D.props.onChange == "function" && D.props.onChange(q, U);
    }, D.handleMouseDown = function(U) {
      D.handleChange(U), window.addEventListener("mousemove", D.handleChange), window.addEventListener("mouseup", D.handleMouseUp);
    }, D.handleMouseUp = function() {
      D.unbindEventListeners();
    }, D.unbindEventListeners = function() {
      window.removeEventListener("mousemove", D.handleChange), window.removeEventListener("mouseup", D.handleMouseUp);
    }, k), _possibleConstructorReturn$5(D, L);
  }
  return _createClass$5(S, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "render",
    value: function() {
      var k = this, D = this.props.rgb, L = (0, _reactcss2$5.default)({
        default: {
          alpha: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: "0px 0px 0px 0px",
            overflow: "hidden",
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: "0px 0px 0px 0px",
            background: "linear-gradient(to right, rgba(" + D.r + "," + D.g + "," + D.b + `, 0) 0%,
           rgba(` + D.r + "," + D.g + "," + D.b + ", 1) 100%)",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: "relative",
            height: "100%",
            margin: "0 3px"
          },
          pointer: {
            position: "absolute",
            left: D.a * 100 + "%"
          },
          slider: {
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            marginTop: "1px",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          gradient: {
            background: "linear-gradient(to bottom, rgba(" + D.r + "," + D.g + "," + D.b + `, 0) 0%,
           rgba(` + D.r + "," + D.g + "," + D.b + ", 1) 100%)"
          },
          pointer: {
            left: 0,
            top: D.a * 100 + "%"
          }
        },
        overwrite: _extends$7({}, this.props.style)
      }, {
        vertical: this.props.direction === "vertical",
        overwrite: !0
      });
      return _react2$7.default.createElement(
        "div",
        { style: L.alpha },
        _react2$7.default.createElement(
          "div",
          { style: L.checkboard },
          _react2$7.default.createElement(_Checkboard2$1.default, { renderers: this.props.renderers })
        ),
        _react2$7.default.createElement("div", { style: L.gradient }),
        _react2$7.default.createElement(
          "div",
          {
            style: L.container,
            ref: function(z) {
              return k.container = z;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2$7.default.createElement(
            "div",
            { style: L.pointer },
            this.props.pointer ? _react2$7.default.createElement(this.props.pointer, this.props) : _react2$7.default.createElement("div", { style: L.slider })
          )
        )
      );
    }
  }]), S;
}(_react$7.PureComponent || _react$7.Component);
Alpha$1.default = Alpha;
var EditableInput$1 = {};
Object.defineProperty(EditableInput$1, "__esModule", {
  value: !0
});
EditableInput$1.EditableInput = void 0;
var _createClass$4 = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}(), _react$6 = React__default, _react2$6 = _interopRequireDefault$9(_react$6), _reactcss$4 = lib$2, _reactcss2$4 = _interopRequireDefault$9(_reactcss$4);
function _interopRequireDefault$9(T) {
  return T && T.__esModule ? T : { default: T };
}
function _defineProperty$3(T, S, R) {
  return S in T ? Object.defineProperty(T, S, { value: R, enumerable: !0, configurable: !0, writable: !0 }) : T[S] = R, T;
}
function _classCallCheck$4(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$4(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$4(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var DEFAULT_ARROW_OFFSET = 1, UP_KEY_CODE = 38, DOWN_KEY_CODE = 40, VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE], isValidKeyCode = function(S) {
  return VALID_KEY_CODES.indexOf(S) > -1;
}, getNumberValue = function(S) {
  return Number(String(S).replace(/%/g, ""));
}, idCounter$1 = 1, EditableInput = EditableInput$1.EditableInput = function(T) {
  _inherits$4(S, T);
  function S(R) {
    _classCallCheck$4(this, S);
    var k = _possibleConstructorReturn$4(this, (S.__proto__ || Object.getPrototypeOf(S)).call(this));
    return k.handleBlur = function() {
      k.state.blurValue && k.setState({ value: k.state.blurValue, blurValue: null });
    }, k.handleChange = function(D) {
      k.setUpdatedValue(D.target.value, D);
    }, k.handleKeyDown = function(D) {
      var L = getNumberValue(D.target.value);
      if (!isNaN(L) && isValidKeyCode(D.keyCode)) {
        var V = k.getArrowOffset(), z = D.keyCode === UP_KEY_CODE ? L + V : L - V;
        k.setUpdatedValue(z, D);
      }
    }, k.handleDrag = function(D) {
      if (k.props.dragLabel) {
        var L = Math.round(k.props.value + D.movementX);
        L >= 0 && L <= k.props.dragMax && k.props.onChange && k.props.onChange(k.getValueObjectWithLabel(L), D);
      }
    }, k.handleMouseDown = function(D) {
      k.props.dragLabel && (D.preventDefault(), k.handleDrag(D), window.addEventListener("mousemove", k.handleDrag), window.addEventListener("mouseup", k.handleMouseUp));
    }, k.handleMouseUp = function() {
      k.unbindEventListeners();
    }, k.unbindEventListeners = function() {
      window.removeEventListener("mousemove", k.handleDrag), window.removeEventListener("mouseup", k.handleMouseUp);
    }, k.state = {
      value: String(R.value).toUpperCase(),
      blurValue: String(R.value).toUpperCase()
    }, k.inputId = "rc-editable-input-" + idCounter$1++, k;
  }
  return _createClass$4(S, [{
    key: "componentDidUpdate",
    value: function(k, D) {
      this.props.value !== this.state.value && (k.value !== this.props.value || D.value !== this.state.value) && (this.input === document.activeElement ? this.setState({ blurValue: String(this.props.value).toUpperCase() }) : this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() }));
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "getValueObjectWithLabel",
    value: function(k) {
      return _defineProperty$3({}, this.props.label, k);
    }
  }, {
    key: "getArrowOffset",
    value: function() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: "setUpdatedValue",
    value: function(k, D) {
      var L = this.props.label ? this.getValueObjectWithLabel(k) : k;
      this.props.onChange && this.props.onChange(L, D), this.setState({ value: k });
    }
  }, {
    key: "render",
    value: function() {
      var k = this, D = (0, _reactcss2$4.default)({
        default: {
          wrap: {
            position: "relative"
          }
        },
        "user-override": {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        "dragLabel-true": {
          label: {
            cursor: "ew-resize"
          }
        }
      }, {
        "user-override": !0
      }, this.props);
      return _react2$6.default.createElement(
        "div",
        { style: D.wrap },
        _react2$6.default.createElement("input", {
          id: this.inputId,
          style: D.input,
          ref: function(V) {
            return k.input = V;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: "false"
        }),
        this.props.label && !this.props.hideLabel ? _react2$6.default.createElement(
          "label",
          {
            htmlFor: this.inputId,
            style: D.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]), S;
}(_react$6.PureComponent || _react$6.Component);
EditableInput$1.default = EditableInput;
var Hue$1 = {}, hue$1 = {};
Object.defineProperty(hue$1, "__esModule", {
  value: !0
});
hue$1.calculateChange = function(S, R, k, D) {
  var L = D.clientWidth, V = D.clientHeight, z = typeof S.pageX == "number" ? S.pageX : S.touches[0].pageX, W = typeof S.pageY == "number" ? S.pageY : S.touches[0].pageY, U = z - (D.getBoundingClientRect().left + window.pageXOffset), q = W - (D.getBoundingClientRect().top + window.pageYOffset);
  if (R === "vertical") {
    var K = void 0;
    if (q < 0)
      K = 359;
    else if (q > V)
      K = 0;
    else {
      var Y = -(q * 100 / V) + 100;
      K = 360 * Y / 100;
    }
    if (k.h !== K)
      return {
        h: K,
        s: k.s,
        l: k.l,
        a: k.a,
        source: "hsl"
      };
  } else {
    var J = void 0;
    if (U < 0)
      J = 0;
    else if (U > L)
      J = 359;
    else {
      var Z = U * 100 / L;
      J = 360 * Z / 100;
    }
    if (k.h !== J)
      return {
        h: J,
        s: k.s,
        l: k.l,
        a: k.a,
        source: "hsl"
      };
  }
  return null;
};
Object.defineProperty(Hue$1, "__esModule", {
  value: !0
});
Hue$1.Hue = void 0;
var _createClass$3 = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}(), _react$5 = React__default, _react2$5 = _interopRequireDefault$8(_react$5), _reactcss$3 = lib$2, _reactcss2$3 = _interopRequireDefault$8(_reactcss$3), _hue = hue$1, hue = _interopRequireWildcard$4(_hue);
function _interopRequireWildcard$4(T) {
  if (T && T.__esModule)
    return T;
  var S = {};
  if (T != null)
    for (var R in T)
      Object.prototype.hasOwnProperty.call(T, R) && (S[R] = T[R]);
  return S.default = T, S;
}
function _interopRequireDefault$8(T) {
  return T && T.__esModule ? T : { default: T };
}
function _classCallCheck$3(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$3(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$3(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var Hue = Hue$1.Hue = function(T) {
  _inherits$3(S, T);
  function S() {
    var R, k, D, L;
    _classCallCheck$3(this, S);
    for (var V = arguments.length, z = Array(V), W = 0; W < V; W++)
      z[W] = arguments[W];
    return L = (k = (D = _possibleConstructorReturn$3(this, (R = S.__proto__ || Object.getPrototypeOf(S)).call.apply(R, [this].concat(z))), D), D.handleChange = function(U) {
      var q = hue.calculateChange(U, D.props.direction, D.props.hsl, D.container);
      q && typeof D.props.onChange == "function" && D.props.onChange(q, U);
    }, D.handleMouseDown = function(U) {
      D.handleChange(U), window.addEventListener("mousemove", D.handleChange), window.addEventListener("mouseup", D.handleMouseUp);
    }, D.handleMouseUp = function() {
      D.unbindEventListeners();
    }, k), _possibleConstructorReturn$3(D, L);
  }
  return _createClass$3(S, [{
    key: "componentWillUnmount",
    value: function() {
      this.unbindEventListeners();
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      window.removeEventListener("mousemove", this.handleChange), window.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var k = this, D = this.props.direction, L = D === void 0 ? "horizontal" : D, V = (0, _reactcss2$3.default)({
        default: {
          hue: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: "0 2px",
            position: "relative",
            height: "100%",
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            left: this.props.hsl.h * 100 / 360 + "%"
          },
          slider: {
            marginTop: "1px",
            width: "4px",
            borderRadius: "1px",
            height: "8px",
            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
            background: "#fff",
            transform: "translateX(-2px)"
          }
        },
        vertical: {
          pointer: {
            left: "0px",
            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
          }
        }
      }, { vertical: L === "vertical" });
      return _react2$5.default.createElement(
        "div",
        { style: V.hue },
        _react2$5.default.createElement(
          "div",
          {
            className: "hue-" + L,
            style: V.container,
            ref: function(W) {
              return k.container = W;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2$5.default.createElement(
            "style",
            null,
            `
            .hue-horizontal {
              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0
                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to right, #f00 0%, #ff0
                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }

            .hue-vertical {
              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,
                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,
                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);
            }
          `
          ),
          _react2$5.default.createElement(
            "div",
            { style: V.pointer },
            this.props.pointer ? _react2$5.default.createElement(this.props.pointer, this.props) : _react2$5.default.createElement("div", { style: V.slider })
          )
        )
      );
    }
  }]), S;
}(_react$5.PureComponent || _react$5.Component);
Hue$1.default = Hue;
var Raised$1 = {}, baseAssignValue$2 = _baseAssignValue, eq$2 = eq_1;
function assignMergeValue$2(T, S, R) {
  (R !== void 0 && !eq$2(T[S], R) || R === void 0 && !(S in T)) && baseAssignValue$2(T, S, R);
}
var _assignMergeValue = assignMergeValue$2, isArrayLike$1 = isArrayLike_1, isObjectLike$1 = isObjectLike_1;
function isArrayLikeObject$1(T) {
  return isObjectLike$1(T) && isArrayLike$1(T);
}
var isArrayLikeObject_1 = isArrayLikeObject$1;
function safeGet$2(T, S) {
  if (!(S === "constructor" && typeof T[S] == "function") && S != "__proto__")
    return T[S];
}
var _safeGet = safeGet$2, copyObject = _copyObject, keysIn$1 = keysIn_1;
function toPlainObject$1(T) {
  return copyObject(T, keysIn$1(T));
}
var toPlainObject_1 = toPlainObject$1, assignMergeValue$1 = _assignMergeValue, cloneBuffer = _cloneBufferExports, cloneTypedArray = _cloneTypedArray, copyArray = _copyArray, initCloneObject = _initCloneObject, isArguments$3 = isArguments_1, isArray$8 = isArray_1, isArrayLikeObject = isArrayLikeObject_1, isBuffer$1 = isBufferExports, isFunction$1 = isFunction_1, isObject$8 = isObject_1, isPlainObject$1 = isPlainObject_1, isTypedArray$1 = isTypedArray_1, safeGet$1 = _safeGet, toPlainObject = toPlainObject_1;
function baseMergeDeep$1(T, S, R, k, D, L, V) {
  var z = safeGet$1(T, R), W = safeGet$1(S, R), U = V.get(W);
  if (U) {
    assignMergeValue$1(T, R, U);
    return;
  }
  var q = L ? L(z, W, R + "", T, S, V) : void 0, K = q === void 0;
  if (K) {
    var Y = isArray$8(W), J = !Y && isBuffer$1(W), Z = !Y && !J && isTypedArray$1(W);
    q = W, Y || J || Z ? isArray$8(z) ? q = z : isArrayLikeObject(z) ? q = copyArray(z) : J ? (K = !1, q = cloneBuffer(W, !0)) : Z ? (K = !1, q = cloneTypedArray(W, !0)) : q = [] : isPlainObject$1(W) || isArguments$3(W) ? (q = z, isArguments$3(z) ? q = toPlainObject(z) : (!isObject$8(z) || isFunction$1(z)) && (q = initCloneObject(W))) : K = !1;
  }
  K && (V.set(W, q), D(q, W, k, L, V), V.delete(W)), assignMergeValue$1(T, R, q);
}
var _baseMergeDeep = baseMergeDeep$1, Stack$5 = _Stack, assignMergeValue = _assignMergeValue, baseFor = _baseFor, baseMergeDeep = _baseMergeDeep, isObject$7 = isObject_1, keysIn = keysIn_1, safeGet = _safeGet;
function baseMerge$2(T, S, R, k, D) {
  T !== S && baseFor(S, function(L, V) {
    if (D || (D = new Stack$5()), isObject$7(L))
      baseMergeDeep(T, S, V, R, baseMerge$2, k, D);
    else {
      var z = k ? k(safeGet(T, V), L, V + "", T, S, D) : void 0;
      z === void 0 && (z = L), assignMergeValue(T, V, z);
    }
  }, keysIn);
}
var _baseMerge = baseMerge$2;
function apply$1(T, S, R) {
  switch (R.length) {
    case 0:
      return T.call(S);
    case 1:
      return T.call(S, R[0]);
    case 2:
      return T.call(S, R[0], R[1]);
    case 3:
      return T.call(S, R[0], R[1], R[2]);
  }
  return T.apply(S, R);
}
var _apply = apply$1, apply = _apply, nativeMax$1 = Math.max;
function overRest$2(T, S, R) {
  return S = nativeMax$1(S === void 0 ? T.length - 1 : S, 0), function() {
    for (var k = arguments, D = -1, L = nativeMax$1(k.length - S, 0), V = Array(L); ++D < L; )
      V[D] = k[S + D];
    D = -1;
    for (var z = Array(S + 1); ++D < S; )
      z[D] = k[D];
    return z[S] = R(V), apply(T, this, z);
  };
}
var _overRest = overRest$2;
function constant$1(T) {
  return function() {
    return T;
  };
}
var constant_1 = constant$1, constant = constant_1, defineProperty = _defineProperty$5, identity$1 = identity_1, baseSetToString$1 = defineProperty ? function(T, S) {
  return defineProperty(T, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant(S),
    writable: !0
  });
} : identity$1, _baseSetToString = baseSetToString$1, HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
function shortOut$1(T) {
  var S = 0, R = 0;
  return function() {
    var k = nativeNow(), D = HOT_SPAN - (k - R);
    if (R = k, D > 0) {
      if (++S >= HOT_COUNT)
        return arguments[0];
    } else
      S = 0;
    return T.apply(void 0, arguments);
  };
}
var _shortOut = shortOut$1, baseSetToString = _baseSetToString, shortOut = _shortOut, setToString$2 = shortOut(baseSetToString), _setToString = setToString$2, identity = identity_1, overRest$1 = _overRest, setToString$1 = _setToString;
function baseRest$1(T, S) {
  return setToString$1(overRest$1(T, S, identity), T + "");
}
var _baseRest = baseRest$1, eq$1 = eq_1, isArrayLike = isArrayLike_1, isIndex$1 = _isIndex, isObject$6 = isObject_1;
function isIterateeCall$1(T, S, R) {
  if (!isObject$6(R))
    return !1;
  var k = typeof S;
  return (k == "number" ? isArrayLike(R) && isIndex$1(S, R.length) : k == "string" && S in R) ? eq$1(R[S], T) : !1;
}
var _isIterateeCall = isIterateeCall$1, baseRest = _baseRest, isIterateeCall = _isIterateeCall;
function createAssigner$2(T) {
  return baseRest(function(S, R) {
    var k = -1, D = R.length, L = D > 1 ? R[D - 1] : void 0, V = D > 2 ? R[2] : void 0;
    for (L = T.length > 3 && typeof L == "function" ? (D--, L) : void 0, V && isIterateeCall(R[0], R[1], V) && (L = D < 3 ? void 0 : L, D = 1), S = Object(S); ++k < D; ) {
      var z = R[k];
      z && T(S, z, k, L);
    }
    return S;
  });
}
var _createAssigner = createAssigner$2, baseMerge$1 = _baseMerge, createAssigner$1 = _createAssigner, merge$3 = createAssigner$1(function(T, S, R) {
  baseMerge$1(T, S, R);
}), merge_1 = merge$3;
Object.defineProperty(Raised$1, "__esModule", {
  value: !0
});
Raised$1.Raised = void 0;
var _react$4 = React__default, _react2$4 = _interopRequireDefault$7(_react$4), _propTypes = propTypesExports, _propTypes2 = _interopRequireDefault$7(_propTypes), _reactcss$2 = lib$2, _reactcss2$2 = _interopRequireDefault$7(_reactcss$2), _merge = merge_1, _merge2 = _interopRequireDefault$7(_merge);
function _interopRequireDefault$7(T) {
  return T && T.__esModule ? T : { default: T };
}
var Raised = Raised$1.Raised = function(S) {
  var R = S.zDepth, k = S.radius, D = S.background, L = S.children, V = S.styles, z = V === void 0 ? {} : V, W = (0, _reactcss2$2.default)((0, _merge2.default)({
    default: {
      wrap: {
        position: "relative",
        display: "inline-block"
      },
      content: {
        position: "relative"
      },
      bg: {
        absolute: "0px 0px 0px 0px",
        boxShadow: "0 " + R + "px " + R * 4 + "px rgba(0,0,0,.24)",
        borderRadius: k,
        background: D
      }
    },
    "zDepth-0": {
      bg: {
        boxShadow: "none"
      }
    },
    "zDepth-1": {
      bg: {
        boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
      }
    },
    "zDepth-2": {
      bg: {
        boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
      }
    },
    "zDepth-3": {
      bg: {
        boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
      }
    },
    "zDepth-4": {
      bg: {
        boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
      }
    },
    "zDepth-5": {
      bg: {
        boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
      }
    },
    square: {
      bg: {
        borderRadius: "0"
      }
    },
    circle: {
      bg: {
        borderRadius: "50%"
      }
    }
  }, z), { "zDepth-1": R === 1 });
  return _react2$4.default.createElement(
    "div",
    { style: W.wrap },
    _react2$4.default.createElement("div", { style: W.bg }),
    _react2$4.default.createElement(
      "div",
      { style: W.content },
      L
    )
  );
};
Raised.propTypes = {
  background: _propTypes2.default.string,
  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
  radius: _propTypes2.default.number,
  styles: _propTypes2.default.object
};
Raised.defaultProps = {
  background: "#fff",
  zDepth: 1,
  radius: 2,
  styles: {}
};
Raised$1.default = Raised;
var Saturation$1 = {}, root = _root, now$1 = function() {
  return root.Date.now();
}, now_1 = now$1, reWhitespace = /\s/;
function trimmedEndIndex$1(T) {
  for (var S = T.length; S-- && reWhitespace.test(T.charAt(S)); )
    ;
  return S;
}
var _trimmedEndIndex = trimmedEndIndex$1, trimmedEndIndex = _trimmedEndIndex, reTrimStart = /^\s+/;
function baseTrim$1(T) {
  return T && T.slice(0, trimmedEndIndex(T) + 1).replace(reTrimStart, "");
}
var _baseTrim = baseTrim$1, baseTrim = _baseTrim, isObject$5 = isObject_1, isSymbol$2 = isSymbol_1, NAN = NaN, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
function toNumber$2(T) {
  if (typeof T == "number")
    return T;
  if (isSymbol$2(T))
    return NAN;
  if (isObject$5(T)) {
    var S = typeof T.valueOf == "function" ? T.valueOf() : T;
    T = isObject$5(S) ? S + "" : S;
  }
  if (typeof T != "string")
    return T === 0 ? T : +T;
  T = baseTrim(T);
  var R = reIsBinary.test(T);
  return R || reIsOctal.test(T) ? freeParseInt(T.slice(2), R ? 2 : 8) : reIsBadHex.test(T) ? NAN : +T;
}
var toNumber_1 = toNumber$2, isObject$4 = isObject_1, now = now_1, toNumber$1 = toNumber_1, FUNC_ERROR_TEXT$2 = "Expected a function", nativeMax = Math.max, nativeMin = Math.min;
function debounce$4(T, S, R) {
  var k, D, L, V, z, W, U = 0, q = !1, K = !1, Y = !0;
  if (typeof T != "function")
    throw new TypeError(FUNC_ERROR_TEXT$2);
  S = toNumber$1(S) || 0, isObject$4(R) && (q = !!R.leading, K = "maxWait" in R, L = K ? nativeMax(toNumber$1(R.maxWait) || 0, S) : L, Y = "trailing" in R ? !!R.trailing : Y);
  function J(ae) {
    var se = k, ie = D;
    return k = D = void 0, U = ae, V = T.apply(ie, se), V;
  }
  function Z(ae) {
    return U = ae, z = setTimeout(te, S), q ? J(ae) : V;
  }
  function X(ae) {
    var se = ae - W, ie = ae - U, he = S - se;
    return K ? nativeMin(he, L - ie) : he;
  }
  function ee(ae) {
    var se = ae - W, ie = ae - U;
    return W === void 0 || se >= S || se < 0 || K && ie >= L;
  }
  function te() {
    var ae = now();
    if (ee(ae))
      return re(ae);
    z = setTimeout(te, X(ae));
  }
  function re(ae) {
    return z = void 0, Y && k ? J(ae) : (k = D = void 0, V);
  }
  function Q() {
    z !== void 0 && clearTimeout(z), U = 0, k = W = D = z = void 0;
  }
  function ne() {
    return z === void 0 ? V : re(now());
  }
  function oe() {
    var ae = now(), se = ee(ae);
    if (k = arguments, D = this, W = ae, se) {
      if (z === void 0)
        return Z(W);
      if (K)
        return clearTimeout(z), z = setTimeout(te, S), J(W);
    }
    return z === void 0 && (z = setTimeout(te, S)), V;
  }
  return oe.cancel = Q, oe.flush = ne, oe;
}
var debounce_1 = debounce$4, debounce$3 = debounce_1, isObject$3 = isObject_1, FUNC_ERROR_TEXT$1 = "Expected a function";
function throttle(T, S, R) {
  var k = !0, D = !0;
  if (typeof T != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  return isObject$3(R) && (k = "leading" in R ? !!R.leading : k, D = "trailing" in R ? !!R.trailing : D), debounce$3(T, S, {
    leading: k,
    maxWait: S,
    trailing: D
  });
}
var throttle_1 = throttle;
const throttle$1 = /* @__PURE__ */ getDefaultExportFromCjs(throttle_1);
var saturation$1 = {};
Object.defineProperty(saturation$1, "__esModule", {
  value: !0
});
saturation$1.calculateChange = function(S, R, k) {
  var D = k.getBoundingClientRect(), L = D.width, V = D.height, z = typeof S.pageX == "number" ? S.pageX : S.touches[0].pageX, W = typeof S.pageY == "number" ? S.pageY : S.touches[0].pageY, U = z - (k.getBoundingClientRect().left + window.pageXOffset), q = W - (k.getBoundingClientRect().top + window.pageYOffset);
  U < 0 ? U = 0 : U > L && (U = L), q < 0 ? q = 0 : q > V && (q = V);
  var K = U / L, Y = 1 - q / V;
  return {
    h: R.h,
    s: K,
    v: Y,
    a: R.a,
    source: "hsv"
  };
};
Object.defineProperty(Saturation$1, "__esModule", {
  value: !0
});
Saturation$1.Saturation = void 0;
var _createClass$2 = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}(), _react$3 = React__default, _react2$3 = _interopRequireDefault$6(_react$3), _reactcss$1 = lib$2, _reactcss2$1 = _interopRequireDefault$6(_reactcss$1), _throttle = throttle_1, _throttle2 = _interopRequireDefault$6(_throttle), _saturation = saturation$1, saturation = _interopRequireWildcard$3(_saturation);
function _interopRequireWildcard$3(T) {
  if (T && T.__esModule)
    return T;
  var S = {};
  if (T != null)
    for (var R in T)
      Object.prototype.hasOwnProperty.call(T, R) && (S[R] = T[R]);
  return S.default = T, S;
}
function _interopRequireDefault$6(T) {
  return T && T.__esModule ? T : { default: T };
}
function _classCallCheck$2(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$2(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$2(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var Saturation = Saturation$1.Saturation = function(T) {
  _inherits$2(S, T);
  function S(R) {
    _classCallCheck$2(this, S);
    var k = _possibleConstructorReturn$2(this, (S.__proto__ || Object.getPrototypeOf(S)).call(this, R));
    return k.handleChange = function(D) {
      typeof k.props.onChange == "function" && k.throttle(k.props.onChange, saturation.calculateChange(D, k.props.hsl, k.container), D);
    }, k.handleMouseDown = function(D) {
      k.handleChange(D);
      var L = k.getContainerRenderWindow();
      L.addEventListener("mousemove", k.handleChange), L.addEventListener("mouseup", k.handleMouseUp);
    }, k.handleMouseUp = function() {
      k.unbindEventListeners();
    }, k.throttle = (0, _throttle2.default)(function(D, L, V) {
      D(L, V);
    }, 50), k;
  }
  return _createClass$2(S, [{
    key: "componentWillUnmount",
    value: function() {
      this.throttle.cancel(), this.unbindEventListeners();
    }
  }, {
    key: "getContainerRenderWindow",
    value: function() {
      for (var k = this.container, D = window; !D.document.contains(k) && D.parent !== D; )
        D = D.parent;
      return D;
    }
  }, {
    key: "unbindEventListeners",
    value: function() {
      var k = this.getContainerRenderWindow();
      k.removeEventListener("mousemove", this.handleChange), k.removeEventListener("mouseup", this.handleMouseUp);
    }
  }, {
    key: "render",
    value: function() {
      var k = this, D = this.props.style || {}, L = D.color, V = D.white, z = D.black, W = D.pointer, U = D.circle, q = (0, _reactcss2$1.default)({
        default: {
          color: {
            absolute: "0px 0px 0px 0px",
            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
            borderRadius: this.props.radius
          },
          white: {
            absolute: "0px 0px 0px 0px",
            borderRadius: this.props.radius
          },
          black: {
            absolute: "0px 0px 0px 0px",
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: "absolute",
            top: -(this.props.hsv.v * 100) + 100 + "%",
            left: this.props.hsv.s * 100 + "%",
            cursor: "default"
          },
          circle: {
            width: "4px",
            height: "4px",
            boxShadow: `0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),
            0 0 1px 2px rgba(0,0,0,.4)`,
            borderRadius: "50%",
            cursor: "hand",
            transform: "translate(-2px, -2px)"
          }
        },
        custom: {
          color: L,
          white: V,
          black: z,
          pointer: W,
          circle: U
        }
      }, { custom: !!this.props.style });
      return _react2$3.default.createElement(
        "div",
        {
          style: q.color,
          ref: function(Y) {
            return k.container = Y;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        _react2$3.default.createElement(
          "style",
          null,
          `
          .saturation-white {
            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));
            background: linear-gradient(to right, #fff, rgba(255,255,255,0));
          }
          .saturation-black {
            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));
            background: linear-gradient(to top, #000, rgba(0,0,0,0));
          }
        `
        ),
        _react2$3.default.createElement(
          "div",
          { style: q.white, className: "saturation-white" },
          _react2$3.default.createElement("div", { style: q.black, className: "saturation-black" }),
          _react2$3.default.createElement(
            "div",
            { style: q.pointer },
            this.props.pointer ? _react2$3.default.createElement(this.props.pointer, this.props) : _react2$3.default.createElement("div", { style: q.circle })
          )
        )
      );
    }
  }]), S;
}(_react$3.PureComponent || _react$3.Component);
Saturation$1.default = Saturation;
var ColorWrap$1 = {}, color$3 = {}, arrayEach = _arrayEach, baseEach$1 = _baseEach, castFunction = _castFunction, isArray$7 = isArray_1;
function forEach$3(T, S) {
  var R = isArray$7(T) ? arrayEach : baseEach$1;
  return R(T, castFunction(S));
}
var forEach_1$1 = forEach$3, each = forEach_1$1;
Object.defineProperty(color$3, "__esModule", {
  value: !0
});
color$3.isvalidColorString = color$3.red = color$3.getContrastingColor = color$3.isValidHex = color$3.toState = color$3.simpleCheckForValidColor = void 0;
var _each = each, _each2 = _interopRequireDefault$5(_each), _tinycolor = tinycolorExports, _tinycolor2 = _interopRequireDefault$5(_tinycolor);
function _interopRequireDefault$5(T) {
  return T && T.__esModule ? T : { default: T };
}
color$3.simpleCheckForValidColor = function(S) {
  var R = ["r", "g", "b", "a", "h", "s", "l", "v"], k = 0, D = 0;
  return (0, _each2.default)(R, function(L) {
    if (S[L] && (k += 1, isNaN(S[L]) || (D += 1), L === "s" || L === "l")) {
      var V = /^\d+%$/;
      V.test(S[L]) && (D += 1);
    }
  }), k === D ? S : !1;
};
var toState = color$3.toState = function(S, R) {
  var k = S.hex ? (0, _tinycolor2.default)(S.hex) : (0, _tinycolor2.default)(S), D = k.toHsl(), L = k.toHsv(), V = k.toRgb(), z = k.toHex();
  D.s === 0 && (D.h = R || 0, L.h = R || 0);
  var W = z === "000000" && V.a === 0;
  return {
    hsl: D,
    hex: W ? "transparent" : "#" + z,
    rgb: V,
    hsv: L,
    oldHue: S.h || R || D.h,
    source: S.source
  };
};
color$3.isValidHex = function(S) {
  if (S === "transparent")
    return !0;
  var R = String(S).charAt(0) === "#" ? 1 : 0;
  return S.length !== 4 + R && S.length < 7 + R && (0, _tinycolor2.default)(S).isValid();
};
color$3.getContrastingColor = function(S) {
  if (!S)
    return "#fff";
  var R = toState(S);
  if (R.hex === "transparent")
    return "rgba(0,0,0,0.4)";
  var k = (R.rgb.r * 299 + R.rgb.g * 587 + R.rgb.b * 114) / 1e3;
  return k >= 128 ? "#000" : "#fff";
};
color$3.red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: "#ff0000",
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};
color$3.isvalidColorString = function(S, R) {
  var k = S.replace("°", "");
  return (0, _tinycolor2.default)(R + " (" + k + ")")._ok;
};
Object.defineProperty(ColorWrap$1, "__esModule", {
  value: !0
});
ColorWrap$1.ColorWrap = void 0;
var _extends$6 = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, _createClass$1 = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}(), _react$2 = React__default, _react2$2 = _interopRequireDefault$4(_react$2), _debounce = debounce_1, _debounce2 = _interopRequireDefault$4(_debounce), _color = color$3, color$2 = _interopRequireWildcard$2(_color);
function _interopRequireWildcard$2(T) {
  if (T && T.__esModule)
    return T;
  var S = {};
  if (T != null)
    for (var R in T)
      Object.prototype.hasOwnProperty.call(T, R) && (S[R] = T[R]);
  return S.default = T, S;
}
function _interopRequireDefault$4(T) {
  return T && T.__esModule ? T : { default: T };
}
function _classCallCheck$1(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn$1(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits$1(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
var ColorWrap = ColorWrap$1.ColorWrap = function(S) {
  var R = function(k) {
    _inherits$1(D, k);
    function D(L) {
      _classCallCheck$1(this, D);
      var V = _possibleConstructorReturn$1(this, (D.__proto__ || Object.getPrototypeOf(D)).call(this));
      return V.handleChange = function(z, W) {
        var U = color$2.simpleCheckForValidColor(z);
        if (U) {
          var q = color$2.toState(z, z.h || V.state.oldHue);
          V.setState(q), V.props.onChangeComplete && V.debounce(V.props.onChangeComplete, q, W), V.props.onChange && V.props.onChange(q, W);
        }
      }, V.handleSwatchHover = function(z, W) {
        var U = color$2.simpleCheckForValidColor(z);
        if (U) {
          var q = color$2.toState(z, z.h || V.state.oldHue);
          V.props.onSwatchHover && V.props.onSwatchHover(q, W);
        }
      }, V.state = _extends$6({}, color$2.toState(L.color, 0)), V.debounce = (0, _debounce2.default)(function(z, W, U) {
        z(W, U);
      }, 100), V;
    }
    return _createClass$1(D, [{
      key: "render",
      value: function() {
        var V = {};
        return this.props.onSwatchHover && (V.onSwatchHover = this.handleSwatchHover), _react2$2.default.createElement(S, _extends$6({}, this.props, this.state, {
          onChange: this.handleChange
        }, V));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(V, z) {
        return _extends$6({}, color$2.toState(V.color, z.oldHue));
      }
    }]), D;
  }(_react$2.PureComponent || _react$2.Component);
  return R.propTypes = _extends$6({}, S.propTypes), R.defaultProps = _extends$6({}, S.defaultProps, {
    color: {
      h: 250,
      s: 0.5,
      l: 0.2,
      a: 1
    }
  }), R;
};
ColorWrap$1.default = ColorWrap;
var Swatch$1 = {}, interaction = {};
Object.defineProperty(interaction, "__esModule", {
  value: !0
});
interaction.handleFocus = void 0;
var _extends$5 = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, _createClass = /* @__PURE__ */ function() {
  function T(S, R) {
    for (var k = 0; k < R.length; k++) {
      var D = R[k];
      D.enumerable = D.enumerable || !1, D.configurable = !0, "value" in D && (D.writable = !0), Object.defineProperty(S, D.key, D);
    }
  }
  return function(S, R, k) {
    return R && T(S.prototype, R), k && T(S, k), S;
  };
}(), _react$1 = React__default, _react2$1 = _interopRequireDefault$3(_react$1);
function _interopRequireDefault$3(T) {
  return T && T.__esModule ? T : { default: T };
}
function _classCallCheck(T, S) {
  if (!(T instanceof S))
    throw new TypeError("Cannot call a class as a function");
}
function _possibleConstructorReturn(T, S) {
  if (!T)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return S && (typeof S == "object" || typeof S == "function") ? S : T;
}
function _inherits(T, S) {
  if (typeof S != "function" && S !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof S);
  T.prototype = Object.create(S && S.prototype, { constructor: { value: T, enumerable: !1, writable: !0, configurable: !0 } }), S && (Object.setPrototypeOf ? Object.setPrototypeOf(T, S) : T.__proto__ = S);
}
interaction.handleFocus = function(S) {
  var R = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "span";
  return function(k) {
    _inherits(D, k);
    function D() {
      var L, V, z, W;
      _classCallCheck(this, D);
      for (var U = arguments.length, q = Array(U), K = 0; K < U; K++)
        q[K] = arguments[K];
      return W = (V = (z = _possibleConstructorReturn(this, (L = D.__proto__ || Object.getPrototypeOf(D)).call.apply(L, [this].concat(q))), z), z.state = { focus: !1 }, z.handleFocus = function() {
        return z.setState({ focus: !0 });
      }, z.handleBlur = function() {
        return z.setState({ focus: !1 });
      }, V), _possibleConstructorReturn(z, W);
    }
    return _createClass(D, [{
      key: "render",
      value: function() {
        return _react2$1.default.createElement(
          R,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          _react2$1.default.createElement(S, _extends$5({}, this.props, this.state))
        );
      }
    }]), D;
  }(_react2$1.default.Component);
};
Object.defineProperty(Swatch$1, "__esModule", {
  value: !0
});
Swatch$1.Swatch = void 0;
var _extends$4 = Object.assign || function(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S];
    for (var k in R)
      Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
  }
  return T;
}, _react = React__default, _react2 = _interopRequireDefault$2(_react), _reactcss = lib$2, _reactcss2 = _interopRequireDefault$2(_reactcss), _interaction = interaction, _Checkboard = Checkboard$1, _Checkboard2 = _interopRequireDefault$2(_Checkboard);
function _interopRequireDefault$2(T) {
  return T && T.__esModule ? T : { default: T };
}
var ENTER = 13, Swatch = Swatch$1.Swatch = function(S) {
  var R = S.color, k = S.style, D = S.onClick, L = D === void 0 ? function() {
  } : D, V = S.onHover, z = S.title, W = z === void 0 ? R : z, U = S.children, q = S.focus, K = S.focusStyle, Y = K === void 0 ? {} : K, J = R === "transparent", Z = (0, _reactcss2.default)({
    default: {
      swatch: _extends$4({
        background: R,
        height: "100%",
        width: "100%",
        cursor: "pointer",
        position: "relative",
        outline: "none"
      }, k, q ? Y : {})
    }
  }), X = function(ne) {
    return L(R, ne);
  }, ee = function(ne) {
    return ne.keyCode === ENTER && L(R, ne);
  }, te = function(ne) {
    return V(R, ne);
  }, re = {};
  return V && (re.onMouseOver = te), _react2.default.createElement(
    "div",
    _extends$4({
      style: Z.swatch,
      onClick: X,
      title: W,
      tabIndex: 0,
      onKeyDown: ee
    }, re),
    U,
    J && _react2.default.createElement(_Checkboard2.default, {
      borderRadius: Z.swatch.borderRadius,
      boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    })
  );
};
Swatch$1.default = (0, _interaction.handleFocus)(Swatch);
(function(T) {
  Object.defineProperty(T, "__esModule", {
    value: !0
  });
  var S = Alpha$1;
  Object.defineProperty(T, "Alpha", {
    enumerable: !0,
    get: function() {
      return U(S).default;
    }
  });
  var R = Checkboard$1;
  Object.defineProperty(T, "Checkboard", {
    enumerable: !0,
    get: function() {
      return U(R).default;
    }
  });
  var k = EditableInput$1;
  Object.defineProperty(T, "EditableInput", {
    enumerable: !0,
    get: function() {
      return U(k).default;
    }
  });
  var D = Hue$1;
  Object.defineProperty(T, "Hue", {
    enumerable: !0,
    get: function() {
      return U(D).default;
    }
  });
  var L = Raised$1;
  Object.defineProperty(T, "Raised", {
    enumerable: !0,
    get: function() {
      return U(L).default;
    }
  });
  var V = Saturation$1;
  Object.defineProperty(T, "Saturation", {
    enumerable: !0,
    get: function() {
      return U(V).default;
    }
  });
  var z = ColorWrap$1;
  Object.defineProperty(T, "ColorWrap", {
    enumerable: !0,
    get: function() {
      return U(z).default;
    }
  });
  var W = Swatch$1;
  Object.defineProperty(T, "Swatch", {
    enumerable: !0,
    get: function() {
      return U(W).default;
    }
  });
  function U(q) {
    return q && q.__esModule ? q : { default: q };
  }
})(common$1);
var lib$1 = function(T) {
  var S = {};
  function R(k) {
    if (S[k]) return S[k].exports;
    var D = S[k] = { i: k, l: !1, exports: {} };
    return T[k].call(D.exports, D, D.exports, R), D.l = !0, D.exports;
  }
  return R.m = T, R.c = S, R.d = function(k, D, L) {
    R.o(k, D) || Object.defineProperty(k, D, { enumerable: !0, get: L });
  }, R.r = function(k) {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(k, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(k, "__esModule", { value: !0 });
  }, R.t = function(k, D) {
    if (1 & D && (k = R(k)), 8 & D || 4 & D && typeof k == "object" && k && k.__esModule) return k;
    var L = /* @__PURE__ */ Object.create(null);
    if (R.r(L), Object.defineProperty(L, "default", { enumerable: !0, value: k }), 2 & D && typeof k != "string") for (var V in k) R.d(L, V, function(z) {
      return k[z];
    }.bind(null, V));
    return L;
  }, R.n = function(k) {
    var D = k && k.__esModule ? function() {
      return k.default;
    } : function() {
      return k;
    };
    return R.d(D, "a", D), D;
  }, R.o = function(k, D) {
    return Object.prototype.hasOwnProperty.call(k, D);
  }, R.p = "", R(R.s = 9);
}([function(T, S) {
  T.exports = React__default;
}, function(T, S, R) {
  var k;
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  (function() {
    var D = {}.hasOwnProperty;
    function L() {
      for (var V = [], z = 0; z < arguments.length; z++) {
        var W = arguments[z];
        if (W) {
          var U = typeof W;
          if (U === "string" || U === "number") V.push(W);
          else if (Array.isArray(W) && W.length) {
            var q = L.apply(null, W);
            q && V.push(q);
          } else if (U === "object") for (var K in W) D.call(W, K) && W[K] && V.push(K);
        }
      }
      return V.join(" ");
    }
    T.exports ? (L.default = L, T.exports = L) : (k = function() {
      return L;
    }.apply(S, [])) === void 0 || (T.exports = k);
  })();
}, function(T, S, R) {
  (function(k) {
    var D = /^\s+|\s+$/g, L = /^[-+]0x[0-9a-f]+$/i, V = /^0b[01]+$/i, z = /^0o[0-7]+$/i, W = parseInt, U = typeof k == "object" && k && k.Object === Object && k, q = typeof self == "object" && self && self.Object === Object && self, K = U || q || Function("return this")(), Y = Object.prototype.toString, J = K.Symbol, Z = J ? J.prototype : void 0, X = Z ? Z.toString : void 0;
    function ee(ne) {
      if (typeof ne == "string") return ne;
      if (re(ne)) return X ? X.call(ne) : "";
      var oe = ne + "";
      return oe == "0" && 1 / ne == -1 / 0 ? "-0" : oe;
    }
    function te(ne) {
      var oe = typeof ne;
      return !!ne && (oe == "object" || oe == "function");
    }
    function re(ne) {
      return typeof ne == "symbol" || /* @__PURE__ */ function(oe) {
        return !!oe && typeof oe == "object";
      }(ne) && Y.call(ne) == "[object Symbol]";
    }
    function Q(ne) {
      return ne ? (ne = function(oe) {
        if (typeof oe == "number") return oe;
        if (re(oe)) return NaN;
        if (te(oe)) {
          var ae = typeof oe.valueOf == "function" ? oe.valueOf() : oe;
          oe = te(ae) ? ae + "" : ae;
        }
        if (typeof oe != "string") return oe === 0 ? oe : +oe;
        oe = oe.replace(D, "");
        var se = V.test(oe);
        return se || z.test(oe) ? W(oe.slice(2), se ? 2 : 8) : L.test(oe) ? NaN : +oe;
      }(ne)) === 1 / 0 || ne === -1 / 0 ? 17976931348623157e292 * (ne < 0 ? -1 : 1) : ne == ne ? ne : 0 : ne === 0 ? ne : 0;
    }
    T.exports = function(ne, oe, ae) {
      var se, ie, he, xe;
      return ne = (se = ne) == null ? "" : ee(se), ie = function(Pe) {
        var Re = Q(Pe), ke = Re % 1;
        return Re == Re ? ke ? Re - ke : Re : 0;
      }(ae), he = 0, xe = ne.length, ie == ie && (xe !== void 0 && (ie = ie <= xe ? ie : xe), he !== void 0 && (ie = ie >= he ? ie : he)), ae = ie, oe = ee(oe), ne.slice(ae, ae + oe.length) == oe;
    };
  }).call(this, R(3));
}, function(T, S) {
  var R;
  R = /* @__PURE__ */ function() {
    return this;
  }();
  try {
    R = R || new Function("return this")();
  } catch {
    typeof window == "object" && (R = window);
  }
  T.exports = R;
}, function(T, S, R) {
  (function(k) {
    var D = /^\[object .+?Constructor\]$/, L = typeof k == "object" && k && k.Object === Object && k, V = typeof self == "object" && self && self.Object === Object && self, z = L || V || Function("return this")(), W, U = Array.prototype, q = Function.prototype, K = Object.prototype, Y = z["__core-js_shared__"], J = (W = /[^.]+$/.exec(Y && Y.keys && Y.keys.IE_PROTO || "")) ? "Symbol(src)_1." + W : "", Z = q.toString, X = K.hasOwnProperty, ee = K.toString, te = RegExp("^" + Z.call(X).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), re = U.splice, Q = Pe(z, "Map"), ne = Pe(Object, "create");
    function oe(Te) {
      var fe = -1, ue = Te ? Te.length : 0;
      for (this.clear(); ++fe < ue; ) {
        var Ce = Te[fe];
        this.set(Ce[0], Ce[1]);
      }
    }
    function ae(Te) {
      var fe = -1, ue = Te ? Te.length : 0;
      for (this.clear(); ++fe < ue; ) {
        var Ce = Te[fe];
        this.set(Ce[0], Ce[1]);
      }
    }
    function se(Te) {
      var fe = -1, ue = Te ? Te.length : 0;
      for (this.clear(); ++fe < ue; ) {
        var Ce = Te[fe];
        this.set(Ce[0], Ce[1]);
      }
    }
    function ie(Te, fe) {
      for (var ue, Ce, ce = Te.length; ce--; ) if ((ue = Te[ce][0]) === (Ce = fe) || ue != ue && Ce != Ce) return ce;
      return -1;
    }
    function he(Te) {
      return !(!ke(Te) || (fe = Te, J && J in fe)) && (function(ue) {
        var Ce = ke(ue) ? ee.call(ue) : "";
        return Ce == "[object Function]" || Ce == "[object GeneratorFunction]";
      }(Te) || function(ue) {
        var Ce = !1;
        if (ue != null && typeof ue.toString != "function") try {
          Ce = !!(ue + "");
        } catch {
        }
        return Ce;
      }(Te) ? te : D).test(function(ue) {
        if (ue != null) {
          try {
            return Z.call(ue);
          } catch {
          }
          try {
            return ue + "";
          } catch {
          }
        }
        return "";
      }(Te));
      var fe;
    }
    function xe(Te, fe) {
      var ue, Ce, ce = Te.__data__;
      return ((Ce = typeof (ue = fe)) == "string" || Ce == "number" || Ce == "symbol" || Ce == "boolean" ? ue !== "__proto__" : ue === null) ? ce[typeof fe == "string" ? "string" : "hash"] : ce.map;
    }
    function Pe(Te, fe) {
      var ue = function(Ce, ce) {
        return Ce?.[ce];
      }(Te, fe);
      return he(ue) ? ue : void 0;
    }
    function Re(Te, fe) {
      if (typeof Te != "function" || fe && typeof fe != "function") throw new TypeError("Expected a function");
      var ue = function() {
        var Ce = arguments, ce = fe ? fe.apply(this, Ce) : Ce[0], pe = ue.cache;
        if (pe.has(ce)) return pe.get(ce);
        var _e = Te.apply(this, Ce);
        return ue.cache = pe.set(ce, _e), _e;
      };
      return ue.cache = new (Re.Cache || se)(), ue;
    }
    function ke(Te) {
      var fe = typeof Te;
      return !!Te && (fe == "object" || fe == "function");
    }
    oe.prototype.clear = function() {
      this.__data__ = ne ? ne(null) : {};
    }, oe.prototype.delete = function(Te) {
      return this.has(Te) && delete this.__data__[Te];
    }, oe.prototype.get = function(Te) {
      var fe = this.__data__;
      if (ne) {
        var ue = fe[Te];
        return ue === "__lodash_hash_undefined__" ? void 0 : ue;
      }
      return X.call(fe, Te) ? fe[Te] : void 0;
    }, oe.prototype.has = function(Te) {
      var fe = this.__data__;
      return ne ? fe[Te] !== void 0 : X.call(fe, Te);
    }, oe.prototype.set = function(Te, fe) {
      return this.__data__[Te] = ne && fe === void 0 ? "__lodash_hash_undefined__" : fe, this;
    }, ae.prototype.clear = function() {
      this.__data__ = [];
    }, ae.prototype.delete = function(Te) {
      var fe = this.__data__, ue = ie(fe, Te);
      return !(ue < 0) && (ue == fe.length - 1 ? fe.pop() : re.call(fe, ue, 1), !0);
    }, ae.prototype.get = function(Te) {
      var fe = this.__data__, ue = ie(fe, Te);
      return ue < 0 ? void 0 : fe[ue][1];
    }, ae.prototype.has = function(Te) {
      return ie(this.__data__, Te) > -1;
    }, ae.prototype.set = function(Te, fe) {
      var ue = this.__data__, Ce = ie(ue, Te);
      return Ce < 0 ? ue.push([Te, fe]) : ue[Ce][1] = fe, this;
    }, se.prototype.clear = function() {
      this.__data__ = { hash: new oe(), map: new (Q || ae)(), string: new oe() };
    }, se.prototype.delete = function(Te) {
      return xe(this, Te).delete(Te);
    }, se.prototype.get = function(Te) {
      return xe(this, Te).get(Te);
    }, se.prototype.has = function(Te) {
      return xe(this, Te).has(Te);
    }, se.prototype.set = function(Te, fe) {
      return xe(this, Te).set(Te, fe), this;
    }, Re.Cache = se, T.exports = Re;
  }).call(this, R(3));
}, function(T, S, R) {
  (function(k) {
    var D = /^\s+|\s+$/g, L = /^[-+]0x[0-9a-f]+$/i, V = /^0b[01]+$/i, z = /^0o[0-7]+$/i, W = parseInt, U = typeof k == "object" && k && k.Object === Object && k, q = typeof self == "object" && self && self.Object === Object && self, K = U || q || Function("return this")(), Y = Object.prototype.toString, J = Math.max, Z = Math.min, X = function() {
      return K.Date.now();
    };
    function ee(re) {
      var Q = typeof re;
      return !!re && (Q == "object" || Q == "function");
    }
    function te(re) {
      if (typeof re == "number") return re;
      if (function(oe) {
        return typeof oe == "symbol" || /* @__PURE__ */ function(ae) {
          return !!ae && typeof ae == "object";
        }(oe) && Y.call(oe) == "[object Symbol]";
      }(re)) return NaN;
      if (ee(re)) {
        var Q = typeof re.valueOf == "function" ? re.valueOf() : re;
        re = ee(Q) ? Q + "" : Q;
      }
      if (typeof re != "string") return re === 0 ? re : +re;
      re = re.replace(D, "");
      var ne = V.test(re);
      return ne || z.test(re) ? W(re.slice(2), ne ? 2 : 8) : L.test(re) ? NaN : +re;
    }
    T.exports = function(re, Q, ne) {
      var oe, ae, se, ie, he, xe, Pe = 0, Re = !1, ke = !1, Te = !0;
      if (typeof re != "function") throw new TypeError("Expected a function");
      function fe(ge) {
        var Ae = oe, Ee = ae;
        return oe = ae = void 0, Pe = ge, ie = re.apply(Ee, Ae);
      }
      function ue(ge) {
        return Pe = ge, he = setTimeout(ce, Q), Re ? fe(ge) : ie;
      }
      function Ce(ge) {
        var Ae = ge - xe;
        return xe === void 0 || Ae >= Q || Ae < 0 || ke && ge - Pe >= se;
      }
      function ce() {
        var ge = X();
        if (Ce(ge)) return pe(ge);
        he = setTimeout(ce, function(Ae) {
          var Ee = Q - (Ae - xe);
          return ke ? Z(Ee, se - (Ae - Pe)) : Ee;
        }(ge));
      }
      function pe(ge) {
        return he = void 0, Te && oe ? fe(ge) : (oe = ae = void 0, ie);
      }
      function _e() {
        var ge = X(), Ae = Ce(ge);
        if (oe = arguments, ae = this, xe = ge, Ae) {
          if (he === void 0) return ue(xe);
          if (ke) return he = setTimeout(ce, Q), fe(xe);
        }
        return he === void 0 && (he = setTimeout(ce, Q)), ie;
      }
      return Q = te(Q) || 0, ee(ne) && (Re = !!ne.leading, se = (ke = "maxWait" in ne) ? J(te(ne.maxWait) || 0, Q) : se, Te = "trailing" in ne ? !!ne.trailing : Te), _e.cancel = function() {
        he !== void 0 && clearTimeout(he), Pe = 0, oe = xe = ae = he = void 0;
      }, _e.flush = function() {
        return he === void 0 ? ie : pe(X());
      }, _e;
    };
  }).call(this, R(3));
}, function(T, S, R) {
  (function(k, D) {
    var L = "[object Arguments]", V = "[object Map]", z = "[object Object]", W = "[object Set]", U = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, q = /^\w*$/, K = /^\./, Y = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, J = /\\(\\)?/g, Z = /^\[object .+?Constructor\]$/, X = /^(?:0|[1-9]\d*)$/, ee = {};
    ee["[object Float32Array]"] = ee["[object Float64Array]"] = ee["[object Int8Array]"] = ee["[object Int16Array]"] = ee["[object Int32Array]"] = ee["[object Uint8Array]"] = ee["[object Uint8ClampedArray]"] = ee["[object Uint16Array]"] = ee["[object Uint32Array]"] = !0, ee[L] = ee["[object Array]"] = ee["[object ArrayBuffer]"] = ee["[object Boolean]"] = ee["[object DataView]"] = ee["[object Date]"] = ee["[object Error]"] = ee["[object Function]"] = ee[V] = ee["[object Number]"] = ee[z] = ee["[object RegExp]"] = ee[W] = ee["[object String]"] = ee["[object WeakMap]"] = !1;
    var te = typeof k == "object" && k && k.Object === Object && k, re = typeof self == "object" && self && self.Object === Object && self, Q = te || re || Function("return this")(), ne = S && !S.nodeType && S, oe = ne && typeof D == "object" && D && !D.nodeType && D, ae = oe && oe.exports === ne && te.process, se = function() {
      try {
        return ae && ae.binding("util");
      } catch {
      }
    }(), ie = se && se.isTypedArray;
    function he(je, Ue, Je, et) {
      var lt = -1, st = je ? je.length : 0;
      for (et && st && (Je = je[++lt]); ++lt < st; ) Je = Ue(Je, je[lt], lt, je);
      return Je;
    }
    function xe(je, Ue) {
      for (var Je = -1, et = je ? je.length : 0; ++Je < et; ) if (Ue(je[Je], Je, je)) return !0;
      return !1;
    }
    function Pe(je, Ue, Je, et, lt) {
      return lt(je, function(st, ct, Tt) {
        Je = et ? (et = !1, st) : Ue(Je, st, ct, Tt);
      }), Je;
    }
    function Re(je) {
      var Ue = !1;
      if (je != null && typeof je.toString != "function") try {
        Ue = !!(je + "");
      } catch {
      }
      return Ue;
    }
    function ke(je) {
      var Ue = -1, Je = Array(je.size);
      return je.forEach(function(et, lt) {
        Je[++Ue] = [lt, et];
      }), Je;
    }
    function Te(je) {
      var Ue = -1, Je = Array(je.size);
      return je.forEach(function(et) {
        Je[++Ue] = et;
      }), Je;
    }
    var fe, ue, Ce, ce = Array.prototype, pe = Function.prototype, _e = Object.prototype, ge = Q["__core-js_shared__"], Ae = (fe = /[^.]+$/.exec(ge && ge.keys && ge.keys.IE_PROTO || "")) ? "Symbol(src)_1." + fe : "", Ee = pe.toString, ve = _e.hasOwnProperty, le = _e.toString, me = RegExp("^" + Ee.call(ve).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Se = Q.Symbol, ye = Q.Uint8Array, be = _e.propertyIsEnumerable, $e = ce.splice, Oe = (ue = Object.keys, Ce = Object, function(je) {
      return ue(Ce(je));
    }), Ie = jt(Q, "DataView"), we = jt(Q, "Map"), Fe = jt(Q, "Promise"), De = jt(Q, "Set"), Le = jt(Q, "WeakMap"), ze = jt(Object, "create"), We = zt(Ie), Be = zt(we), Ye = zt(Fe), Ge = zt(De), nt = zt(Le), Ze = Se ? Se.prototype : void 0, Me = Ze ? Ze.valueOf : void 0, Ne = Ze ? Ze.toString : void 0;
    function He(je) {
      var Ue = -1, Je = je ? je.length : 0;
      for (this.clear(); ++Ue < Je; ) {
        var et = je[Ue];
        this.set(et[0], et[1]);
      }
    }
    function qe(je) {
      var Ue = -1, Je = je ? je.length : 0;
      for (this.clear(); ++Ue < Je; ) {
        var et = je[Ue];
        this.set(et[0], et[1]);
      }
    }
    function Ke(je) {
      var Ue = -1, Je = je ? je.length : 0;
      for (this.clear(); ++Ue < Je; ) {
        var et = je[Ue];
        this.set(et[0], et[1]);
      }
    }
    function Xe(je) {
      var Ue = -1, Je = je ? je.length : 0;
      for (this.__data__ = new Ke(); ++Ue < Je; ) this.add(je[Ue]);
    }
    function tt(je) {
      this.__data__ = new qe(je);
    }
    function at(je, Ue) {
      var Je = Wt(je) || ir(je) ? function(ct, Tt) {
        for (var St = -1, $t = Array(ct); ++St < ct; ) $t[St] = Tt(St);
        return $t;
      }(je.length, String) : [], et = Je.length, lt = !!et;
      for (var st in je) !ve.call(je, st) || lt && (st == "length" || Gt(st, et)) || Je.push(st);
      return Je;
    }
    function it(je, Ue) {
      for (var Je = je.length; Je--; ) if (sr(je[Je][0], Ue)) return Je;
      return -1;
    }
    He.prototype.clear = function() {
      this.__data__ = ze ? ze(null) : {};
    }, He.prototype.delete = function(je) {
      return this.has(je) && delete this.__data__[je];
    }, He.prototype.get = function(je) {
      var Ue = this.__data__;
      if (ze) {
        var Je = Ue[je];
        return Je === "__lodash_hash_undefined__" ? void 0 : Je;
      }
      return ve.call(Ue, je) ? Ue[je] : void 0;
    }, He.prototype.has = function(je) {
      var Ue = this.__data__;
      return ze ? Ue[je] !== void 0 : ve.call(Ue, je);
    }, He.prototype.set = function(je, Ue) {
      return this.__data__[je] = ze && Ue === void 0 ? "__lodash_hash_undefined__" : Ue, this;
    }, qe.prototype.clear = function() {
      this.__data__ = [];
    }, qe.prototype.delete = function(je) {
      var Ue = this.__data__, Je = it(Ue, je);
      return !(Je < 0) && (Je == Ue.length - 1 ? Ue.pop() : $e.call(Ue, Je, 1), !0);
    }, qe.prototype.get = function(je) {
      var Ue = this.__data__, Je = it(Ue, je);
      return Je < 0 ? void 0 : Ue[Je][1];
    }, qe.prototype.has = function(je) {
      return it(this.__data__, je) > -1;
    }, qe.prototype.set = function(je, Ue) {
      var Je = this.__data__, et = it(Je, je);
      return et < 0 ? Je.push([je, Ue]) : Je[et][1] = Ue, this;
    }, Ke.prototype.clear = function() {
      this.__data__ = { hash: new He(), map: new (we || qe)(), string: new He() };
    }, Ke.prototype.delete = function(je) {
      return Nt(this, je).delete(je);
    }, Ke.prototype.get = function(je) {
      return Nt(this, je).get(je);
    }, Ke.prototype.has = function(je) {
      return Nt(this, je).has(je);
    }, Ke.prototype.set = function(je, Ue) {
      return Nt(this, je).set(je, Ue), this;
    }, Xe.prototype.add = Xe.prototype.push = function(je) {
      return this.__data__.set(je, "__lodash_hash_undefined__"), this;
    }, Xe.prototype.has = function(je) {
      return this.__data__.has(je);
    }, tt.prototype.clear = function() {
      this.__data__ = new qe();
    }, tt.prototype.delete = function(je) {
      return this.__data__.delete(je);
    }, tt.prototype.get = function(je) {
      return this.__data__.get(je);
    }, tt.prototype.has = function(je) {
      return this.__data__.has(je);
    }, tt.prototype.set = function(je, Ue) {
      var Je = this.__data__;
      if (Je instanceof qe) {
        var et = Je.__data__;
        if (!we || et.length < 199) return et.push([je, Ue]), this;
        Je = this.__data__ = new Ke(et);
      }
      return Je.set(je, Ue), this;
    };
    var mt, Qe = (mt = function(je, Ue) {
      return je && ut(je, Ue, ht);
    }, function(je, Ue) {
      if (je == null) return je;
      if (!or(je)) return mt(je, Ue);
      for (var Je = je.length, et = -1, lt = Object(je); ++et < Je && Ue(lt[et], et, lt) !== !1; ) ;
      return je;
    }), ut = /* @__PURE__ */ function(je) {
      return function(Ue, Je, et) {
        for (var lt = -1, st = Object(Ue), ct = et(Ue), Tt = ct.length; Tt--; ) {
          var St = ct[++lt];
          if (Je(st[St], St, st) === !1) break;
        }
        return Ue;
      };
    }();
    function ft(je, Ue) {
      for (var Je = 0, et = (Ue = Vt(Ue, je) ? [Ue] : Et(Ue)).length; je != null && Je < et; ) je = je[Zt(Ue[Je++])];
      return Je && Je == et ? je : void 0;
    }
    function vt(je, Ue) {
      return je != null && Ue in Object(je);
    }
    function dt(je, Ue, Je, et, lt) {
      return je === Ue || (je == null || Ue == null || !ot(je) && !pt(Ue) ? je != je && Ue != Ue : function(st, ct, Tt, St, $t, bt) {
        var Bt = Wt(st), Dt = Wt(ct), At = "[object Array]", kt = "[object Array]";
        Bt || (At = (At = Ft(st)) == L ? z : At), Dt || (kt = (kt = Ft(ct)) == L ? z : kt);
        var Lt = At == z && !Re(st), er = kt == z && !Re(ct), Yt = At == kt;
        if (Yt && !Lt) return bt || (bt = new tt()), Bt || Ct(st) ? Mt(st, ct, Tt, St, $t, bt) : function(wt, Pt, br, Jt, lr, It, qt) {
          switch (br) {
            case "[object DataView]":
              if (wt.byteLength != Pt.byteLength || wt.byteOffset != Pt.byteOffset) return !1;
              wt = wt.buffer, Pt = Pt.buffer;
            case "[object ArrayBuffer]":
              return !(wt.byteLength != Pt.byteLength || !Jt(new ye(wt), new ye(Pt)));
            case "[object Boolean]":
            case "[object Date]":
            case "[object Number]":
              return sr(+wt, +Pt);
            case "[object Error]":
              return wt.name == Pt.name && wt.message == Pt.message;
            case "[object RegExp]":
            case "[object String]":
              return wt == Pt + "";
            case V:
              var Kt = ke;
            case W:
              var ar = 2 & It;
              if (Kt || (Kt = Te), wt.size != Pt.size && !ar) return !1;
              var ur = qt.get(wt);
              if (ur) return ur == Pt;
              It |= 1, qt.set(wt, Pt);
              var tr = Mt(Kt(wt), Kt(Pt), Jt, lr, It, qt);
              return qt.delete(wt), tr;
            case "[object Symbol]":
              if (Me) return Me.call(wt) == Me.call(Pt);
          }
          return !1;
        }(st, ct, At, Tt, St, $t, bt);
        if (!(2 & $t)) {
          var $r = Lt && ve.call(st, "__wrapped__"), Cr = er && ve.call(ct, "__wrapped__");
          if ($r || Cr) {
            var Pr = $r ? st.value() : st, Er = Cr ? ct.value() : ct;
            return bt || (bt = new tt()), Tt(Pr, Er, St, $t, bt);
          }
        }
        return Yt ? (bt || (bt = new tt()), function(wt, Pt, br, Jt, lr, It) {
          var qt = 2 & lr, Kt = ht(wt), ar = Kt.length, ur = ht(Pt).length;
          if (ar != ur && !qt) return !1;
          for (var tr = ar; tr--; ) {
            var Xt = Kt[tr];
            if (!(qt ? Xt in Pt : ve.call(Pt, Xt))) return !1;
          }
          var _r = It.get(wt);
          if (_r && It.get(Pt)) return _r == Pt;
          var cr = !0;
          It.set(wt, Pt), It.set(Pt, wt);
          for (var vr = qt; ++tr < ar; ) {
            Xt = Kt[tr];
            var pr = wt[Xt], dr = Pt[Xt];
            if (Jt) var Tr = qt ? Jt(dr, pr, Xt, Pt, wt, It) : Jt(pr, dr, Xt, wt, Pt, It);
            if (!(Tr === void 0 ? pr === dr || br(pr, dr, Jt, lr, It) : Tr)) {
              cr = !1;
              break;
            }
            vr || (vr = Xt == "constructor");
          }
          if (cr && !vr) {
            var hr = wt.constructor, mr = Pt.constructor;
            hr == mr || !("constructor" in wt) || !("constructor" in Pt) || typeof hr == "function" && hr instanceof hr && typeof mr == "function" && mr instanceof mr || (cr = !1);
          }
          return It.delete(wt), It.delete(Pt), cr;
        }(st, ct, Tt, St, $t, bt)) : !1;
      }(je, Ue, dt, Je, et, lt));
    }
    function xt(je) {
      return !(!ot(je) || function(Ue) {
        return !!Ae && Ae in Ue;
      }(je)) && (Ve(je) || Re(je) ? me : Z).test(zt(je));
    }
    function Ot(je) {
      return typeof je == "function" ? je : je == null ? gt : typeof je == "object" ? Wt(je) ? function(et, lt) {
        return Vt(et) && rr(lt) ? nr(Zt(et), lt) : function(st) {
          var ct = function(Tt, St, $t) {
            var bt = Tt == null ? void 0 : ft(Tt, St);
            return bt === void 0 ? $t : bt;
          }(st, et);
          return ct === void 0 && ct === lt ? function(Tt, St) {
            return Tt != null && function($t, bt, Bt) {
              bt = Vt(bt, $t) ? [bt] : Et(bt);
              for (var Dt, At = -1, kt = bt.length; ++At < kt; ) {
                var Lt = Zt(bt[At]);
                if (!(Dt = $t != null && Bt($t, Lt))) break;
                $t = $t[Lt];
              }
              return Dt || !!(kt = $t ? $t.length : 0) && rt(kt) && Gt(Lt, kt) && (Wt($t) || ir($t));
            }(Tt, St, vt);
          }(st, et) : dt(lt, ct, void 0, 3);
        };
      }(je[0], je[1]) : function(et) {
        var lt = function(st) {
          for (var ct = ht(st), Tt = ct.length; Tt--; ) {
            var St = ct[Tt], $t = st[St];
            ct[Tt] = [St, $t, rr($t)];
          }
          return ct;
        }(et);
        return lt.length == 1 && lt[0][2] ? nr(lt[0][0], lt[0][1]) : function(st) {
          return st === et || function(ct, Tt, St, $t) {
            var bt = St.length, Bt = bt;
            if (ct == null) return !Bt;
            for (ct = Object(ct); bt--; ) {
              var Dt = St[bt];
              if (Dt[2] ? Dt[1] !== ct[Dt[0]] : !(Dt[0] in ct)) return !1;
            }
            for (; ++bt < Bt; ) {
              var At = (Dt = St[bt])[0], kt = ct[At], Lt = Dt[1];
              if (Dt[2]) {
                if (kt === void 0 && !(At in ct)) return !1;
              } else {
                var er = new tt(), Yt;
                if (!(Yt === void 0 ? dt(Lt, kt, $t, 3, er) : Yt)) return !1;
              }
            }
            return !0;
          }(st, et, lt);
        };
      }(je) : Vt(Ue = je) ? (Je = Zt(Ue), function(et) {
        return et?.[Je];
      }) : /* @__PURE__ */ function(et) {
        return function(lt) {
          return ft(lt, et);
        };
      }(Ue);
      var Ue, Je;
    }
    function Rt(je) {
      if (Je = (Ue = je) && Ue.constructor, et = typeof Je == "function" && Je.prototype || _e, Ue !== et) return Oe(je);
      var Ue, Je, et, lt = [];
      for (var st in Object(je)) ve.call(je, st) && st != "constructor" && lt.push(st);
      return lt;
    }
    function Et(je) {
      return Wt(je) ? je : yr(je);
    }
    function Mt(je, Ue, Je, et, lt, st) {
      var ct = 2 & lt, Tt = je.length, St = Ue.length;
      if (Tt != St && !(ct && St > Tt)) return !1;
      var $t = st.get(je);
      if ($t && st.get(Ue)) return $t == Ue;
      var bt = -1, Bt = !0, Dt = 1 & lt ? new Xe() : void 0;
      for (st.set(je, Ue), st.set(Ue, je); ++bt < Tt; ) {
        var At = je[bt], kt = Ue[bt];
        if (et) var Lt = ct ? et(kt, At, bt, Ue, je, st) : et(At, kt, bt, je, Ue, st);
        if (Lt !== void 0) {
          if (Lt) continue;
          Bt = !1;
          break;
        }
        if (Dt) {
          if (!xe(Ue, function(er, Yt) {
            if (!Dt.has(Yt) && (At === er || Je(At, er, et, lt, st))) return Dt.add(Yt);
          })) {
            Bt = !1;
            break;
          }
        } else if (At !== kt && !Je(At, kt, et, lt, st)) {
          Bt = !1;
          break;
        }
      }
      return st.delete(je), st.delete(Ue), Bt;
    }
    function Nt(je, Ue) {
      var Je, et, lt = je.__data__;
      return ((et = typeof (Je = Ue)) == "string" || et == "number" || et == "symbol" || et == "boolean" ? Je !== "__proto__" : Je === null) ? lt[typeof Ue == "string" ? "string" : "hash"] : lt.map;
    }
    function jt(je, Ue) {
      var Je = function(et, lt) {
        return et?.[lt];
      }(je, Ue);
      return xt(Je) ? Je : void 0;
    }
    var Ft = function(je) {
      return le.call(je);
    };
    function Gt(je, Ue) {
      return !!(Ue = Ue ?? 9007199254740991) && (typeof je == "number" || X.test(je)) && je > -1 && je % 1 == 0 && je < Ue;
    }
    function Vt(je, Ue) {
      if (Wt(je)) return !1;
      var Je = typeof je;
      return !(Je != "number" && Je != "symbol" && Je != "boolean" && je != null && !yt(je)) || q.test(je) || !U.test(je) || Ue != null && je in Object(Ue);
    }
    function rr(je) {
      return je == je && !ot(je);
    }
    function nr(je, Ue) {
      return function(Je) {
        return Je != null && Je[je] === Ue && (Ue !== void 0 || je in Object(Je));
      };
    }
    (Ie && Ft(new Ie(new ArrayBuffer(1))) != "[object DataView]" || we && Ft(new we()) != V || Fe && Ft(Fe.resolve()) != "[object Promise]" || De && Ft(new De()) != W || Le && Ft(new Le()) != "[object WeakMap]") && (Ft = function(je) {
      var Ue = le.call(je), Je = Ue == z ? je.constructor : void 0, et = Je ? zt(Je) : void 0;
      if (et) switch (et) {
        case We:
          return "[object DataView]";
        case Be:
          return V;
        case Ye:
          return "[object Promise]";
        case Ge:
          return W;
        case nt:
          return "[object WeakMap]";
      }
      return Ue;
    });
    var yr = Qt(function(je) {
      var Ue;
      je = (Ue = je) == null ? "" : function(et) {
        if (typeof et == "string") return et;
        if (yt(et)) return Ne ? Ne.call(et) : "";
        var lt = et + "";
        return lt == "0" && 1 / et == -1 / 0 ? "-0" : lt;
      }(Ue);
      var Je = [];
      return K.test(je) && Je.push(""), je.replace(Y, function(et, lt, st, ct) {
        Je.push(st ? ct.replace(J, "$1") : lt || et);
      }), Je;
    });
    function Zt(je) {
      if (typeof je == "string" || yt(je)) return je;
      var Ue = je + "";
      return Ue == "0" && 1 / je == -1 / 0 ? "-0" : Ue;
    }
    function zt(je) {
      if (je != null) {
        try {
          return Ee.call(je);
        } catch {
        }
        try {
          return je + "";
        } catch {
        }
      }
      return "";
    }
    function Qt(je, Ue) {
      if (typeof je != "function" || Ue && typeof Ue != "function") throw new TypeError("Expected a function");
      var Je = function() {
        var et = arguments, lt = Ue ? Ue.apply(this, et) : et[0], st = Je.cache;
        if (st.has(lt)) return st.get(lt);
        var ct = je.apply(this, et);
        return Je.cache = st.set(lt, ct), ct;
      };
      return Je.cache = new (Qt.Cache || Ke)(), Je;
    }
    function sr(je, Ue) {
      return je === Ue || je != je && Ue != Ue;
    }
    function ir(je) {
      return function(Ue) {
        return pt(Ue) && or(Ue);
      }(je) && ve.call(je, "callee") && (!be.call(je, "callee") || le.call(je) == L);
    }
    Qt.Cache = Ke;
    var Wt = Array.isArray;
    function or(je) {
      return je != null && rt(je.length) && !Ve(je);
    }
    function Ve(je) {
      var Ue = ot(je) ? le.call(je) : "";
      return Ue == "[object Function]" || Ue == "[object GeneratorFunction]";
    }
    function rt(je) {
      return typeof je == "number" && je > -1 && je % 1 == 0 && je <= 9007199254740991;
    }
    function ot(je) {
      var Ue = typeof je;
      return !!je && (Ue == "object" || Ue == "function");
    }
    function pt(je) {
      return !!je && typeof je == "object";
    }
    function yt(je) {
      return typeof je == "symbol" || pt(je) && le.call(je) == "[object Symbol]";
    }
    var Ct = ie ? /* @__PURE__ */ function(je) {
      return function(Ue) {
        return je(Ue);
      };
    }(ie) : function(je) {
      return pt(je) && rt(je.length) && !!ee[le.call(je)];
    };
    function ht(je) {
      return or(je) ? at(je) : Rt(je);
    }
    function gt(je) {
      return je;
    }
    D.exports = function(je, Ue, Je) {
      var et = Wt(je) ? he : Pe, lt = arguments.length < 3;
      return et(je, Ot(Ue), Je, lt, Qe);
    };
  }).call(this, R(3), R(7)(T));
}, function(T, S) {
  T.exports = function(R) {
    return R.webpackPolyfill || (R.deprecate = function() {
    }, R.paths = [], R.children || (R.children = []), Object.defineProperty(R, "loaded", { enumerable: !0, get: function() {
      return R.l;
    } }), Object.defineProperty(R, "id", { enumerable: !0, get: function() {
      return R.i;
    } }), R.webpackPolyfill = 1), R;
  };
}, function(T, S) {
  String.prototype.padEnd || (String.prototype.padEnd = function(R, k) {
    return R >>= 0, k = String(k !== void 0 ? k : " "), this.length > R ? String(this) : ((R -= this.length) > k.length && (k += k.repeat(R / k.length)), String(this) + k.slice(0, R));
  });
}, function(T, S, R) {
  function k(_e, ge, Ae) {
    return ge in _e ? Object.defineProperty(_e, ge, { value: Ae, enumerable: !0, configurable: !0, writable: !0 }) : _e[ge] = Ae, _e;
  }
  function D(_e) {
    if (Symbol.iterator in Object(_e) || Object.prototype.toString.call(_e) === "[object Arguments]") return Array.from(_e);
  }
  function L(_e) {
    return function(ge) {
      if (Array.isArray(ge)) {
        for (var Ae = 0, Ee = new Array(ge.length); Ae < ge.length; Ae++) Ee[Ae] = ge[Ae];
        return Ee;
      }
    }(_e) || D(_e) || function() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }
  function V(_e) {
    if (Array.isArray(_e)) return _e;
  }
  function z() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
  function W(_e, ge) {
    if (!(_e instanceof ge)) throw new TypeError("Cannot call a class as a function");
  }
  function U(_e, ge) {
    for (var Ae = 0; Ae < ge.length; Ae++) {
      var Ee = ge[Ae];
      Ee.enumerable = Ee.enumerable || !1, Ee.configurable = !0, "value" in Ee && (Ee.writable = !0), Object.defineProperty(_e, Ee.key, Ee);
    }
  }
  function q(_e) {
    return (q = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(ge) {
      return typeof ge;
    } : function(ge) {
      return ge && typeof Symbol == "function" && ge.constructor === Symbol && ge !== Symbol.prototype ? "symbol" : typeof ge;
    })(_e);
  }
  function K(_e) {
    return (K = typeof Symbol == "function" && q(Symbol.iterator) === "symbol" ? function(ge) {
      return q(ge);
    } : function(ge) {
      return ge && typeof Symbol == "function" && ge.constructor === Symbol && ge !== Symbol.prototype ? "symbol" : q(ge);
    })(_e);
  }
  function Y(_e) {
    if (_e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return _e;
  }
  function J(_e) {
    return (J = Object.setPrototypeOf ? Object.getPrototypeOf : function(ge) {
      return ge.__proto__ || Object.getPrototypeOf(ge);
    })(_e);
  }
  function Z(_e, ge) {
    return (Z = Object.setPrototypeOf || function(Ae, Ee) {
      return Ae.__proto__ = Ee, Ae;
    })(_e, ge);
  }
  R.r(S);
  var X = R(0), ee = R.n(X), te = R(5), re = R.n(te), Q = R(4), ne = R.n(Q), oe = R(6), ae = R.n(oe), se = R(2), ie = R.n(se), he = R(1), xe = R.n(he);
  R(8);
  function Pe(_e, ge) {
    return V(_e) || function(Ae, Ee) {
      var ve = [], le = !0, me = !1, Se = void 0;
      try {
        for (var ye, be = Ae[Symbol.iterator](); !(le = (ye = be.next()).done) && (ve.push(ye.value), !Ee || ve.length !== Ee); le = !0) ;
      } catch ($e) {
        me = !0, Se = $e;
      } finally {
        try {
          le || be.return == null || be.return();
        } finally {
          if (me) throw Se;
        }
      }
      return ve;
    }(_e, ge) || z();
  }
  var Re = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "(..) ........", 0, ["11", "221", "223", "261", "264", "2652", "280", "2905", "291", "2920", "2966", "299", "341", "342", "343", "351", "376", "379", "381", "3833", "385", "387", "388"]], ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "(..) .... ....", 0, ["2", "3", "4", "7", "8", "02", "03", "04", "07", "08"]], ["Austria", ["europe", "eu-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."], ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "eu-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "(...) ...-....", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "..-........."], ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."], ["Côte d’Ivoire", ["africa"], "ci", "225", ".. .. .. .."], ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Curaçao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"], ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."], ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2, ["809", "829", "849"]], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."], ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"], ["Ghana", ["africa"], "gh", "233"], ["Greece", ["europe", "eu-union"], "gr", "30"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", ".... ...."], ["Hungary", ["europe", "eu-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "... ...."], ["India", ["asia"], "in", "91", ".....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98", "... ... ...."], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."], ["Israel", ["middle-east"], "il", "972", "... ... ...."], ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", ".. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "... ...-..-..", 1, ["310", "311", "312", "313", "315", "318", "321", "324", "325", "326", "327", "336", "7172", "73622"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kosovo", ["europe", "ex-yugos"], "xk", "383"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"], ["Luxembourg", ["europe", "eu-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe", "ex-yugos"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "eu-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52", "... ... ....", 0, ["55", "81", "33", "656", "664", "998", "774", "229"]], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe", "ex-yugos"], "me", "382"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["North Korea", ["asia"], "kp", "850"], ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", ".... ......."], ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."], ["Portugal", ["europe", "eu-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]], ["Qatar", ["middle-east"], "qa", "974"], ["Réunion", ["africa"], "re", "262"], ["Romania", ["europe", "eu-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 0], ["Rwanda", ["africa"], "rw", "250"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["São Tomé and Príncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe", "ex-yugos"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "....-...."], ["Slovakia", ["europe", "eu-union"], "sk", "421"], ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."], ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Tuvalu", ["asia"], "tv", "688"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"], ["United States", ["america", "north-america"], "us", "1", "(...) ...-....", 0, ["907", "205", "251", "256", "334", "479", "501", "870", "480", "520", "602", "623", "928", "209", "213", "310", "323", "408", "415", "510", "530", "559", "562", "619", "626", "650", "661", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951", "303", "719", "970", "203", "860", "202", "302", "239", "305", "321", "352", "386", "407", "561", "727", "772", "813", "850", "863", "904", "941", "954", "229", "404", "478", "706", "770", "912", "808", "319", "515", "563", "641", "712", "208", "217", "309", "312", "618", "630", "708", "773", "815", "847", "219", "260", "317", "574", "765", "812", "316", "620", "785", "913", "270", "502", "606", "859", "225", "318", "337", "504", "985", "413", "508", "617", "781", "978", "301", "410", "207", "231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "989", "218", "320", "507", "612", "651", "763", "952", "314", "417", "573", "636", "660", "816", "228", "601", "662", "406", "252", "336", "704", "828", "910", "919", "701", "308", "402", "603", "201", "609", "732", "856", "908", "973", "505", "575", "702", "775", "212", "315", "516", "518", "585", "607", "631", "716", "718", "845", "914", "216", "330", "419", "440", "513", "614", "740", "937", "405", "580", "918", "503", "541", "215", "412", "570", "610", "717", "724", "814", "401", "803", "843", "864", "605", "423", "615", "731", "865", "901", "931", "210", "214", "254", "281", "325", "361", "409", "432", "512", "713", "806", "817", "830", "903", "915", "936", "940", "956", "972", "979", "435", "801", "276", "434", "540", "703", "757", "804", "802", "206", "253", "360", "425", "509", "262", "414", "608", "715", "920", "304", "307"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]], ke = [["American Samoa", ["oceania"], "as", "1684"], ["Anguilla", ["america", "carribean"], "ai", "1264"], ["Bermuda", ["america", "north-america"], "bm", "1441"], ["British Virgin Islands", ["america", "carribean"], "vg", "1284"], ["Cayman Islands", ["america", "carribean"], "ky", "1345"], ["Cook Islands", ["oceania"], "ck", "682"], ["Falkland Islands", ["america", "south-america"], "fk", "500"], ["Faroe Islands", ["europe"], "fo", "298"], ["Gibraltar", ["europe"], "gi", "350"], ["Greenland", ["america"], "gl", "299"], ["Jersey", ["europe", "eu-union"], "je", "44", ".... ......"], ["Montserrat", ["america", "carribean"], "ms", "1664"], ["Niue", ["asia"], "nu", "683"], ["Norfolk Island", ["oceania"], "nf", "672"], ["Northern Mariana Islands", ["oceania"], "mp", "1670"], ["Saint Barthélemy", ["america", "carribean"], "bl", "590", "", 1], ["Saint Helena", ["africa"], "sh", "290"], ["Saint Martin", ["america", "carribean"], "mf", "590", "", 2], ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"], ["Sint Maarten", ["america", "carribean"], "sx", "1721"], ["Tokelau", ["oceania"], "tk", "690"], ["Turks and Caicos Islands", ["america", "carribean"], "tc", "1649"], ["U.S. Virgin Islands", ["america", "carribean"], "vi", "1340"], ["Wallis and Futuna", ["oceania"], "wf", "681"]];
  function Te(_e, ge, Ae, Ee, ve) {
    return !Ae || ve ? _e + "".padEnd(ge.length, ".") + " " + Ee : _e + "".padEnd(ge.length, ".") + " " + Ae;
  }
  function fe(_e, ge, Ae, Ee, ve) {
    var le, me, Se = [];
    return me = ge === !0, [(le = []).concat.apply(le, L(_e.map(function(ye) {
      var be = { name: ye[0], regions: ye[1], iso2: ye[2], countryCode: ye[3], dialCode: ye[3], format: Te(Ae, ye[3], ye[4], Ee, ve), priority: ye[5] || 0 }, $e = [];
      return ye[6] && ye[6].map(function(Oe) {
        var Ie = function(we) {
          for (var Fe = 1; Fe < arguments.length; Fe++) {
            var De = arguments[Fe] != null ? arguments[Fe] : {}, Le = Object.keys(De);
            typeof Object.getOwnPropertySymbols == "function" && (Le = Le.concat(Object.getOwnPropertySymbols(De).filter(function(ze) {
              return Object.getOwnPropertyDescriptor(De, ze).enumerable;
            }))), Le.forEach(function(ze) {
              k(we, ze, De[ze]);
            });
          }
          return we;
        }({}, be);
        Ie.dialCode = ye[3] + Oe, Ie.isAreaCode = !0, Ie.areaCodeLength = Oe.length, $e.push(Ie);
      }), $e.length > 0 ? (be.mainCode = !0, me || ge.constructor.name === "Array" && ge.includes(ye[2]) ? (be.hasAreaCodes = !0, [be].concat($e)) : (Se = Se.concat($e), [be])) : [be];
    }))), Se];
  }
  function ue(_e, ge, Ae, Ee) {
    if (Ae !== null) {
      var ve = Object.keys(Ae), le = Object.values(Ae);
      ve.forEach(function(me, Se) {
        if (Ee) return _e.push([me, le[Se]]);
        var ye = _e.findIndex(function($e) {
          return $e[0] === me;
        });
        if (ye === -1) {
          var be = [me];
          be[ge] = le[Se], _e.push(be);
        } else _e[ye][ge] = le[Se];
      });
    }
  }
  function Ce(_e, ge) {
    return ge.length === 0 ? _e : _e.map(function(Ae) {
      var Ee = ge.findIndex(function(le) {
        return le[0] === Ae[2];
      });
      if (Ee === -1) return Ae;
      var ve = ge[Ee];
      return ve[1] && (Ae[4] = ve[1]), ve[3] && (Ae[5] = ve[3]), ve[2] && (Ae[6] = ve[2]), Ae;
    });
  }
  var ce = function _e(ge, Ae, Ee, ve, le, me, Se, ye, be, $e, Oe, Ie, we, Fe) {
    W(this, _e), this.filterRegions = function(Ze, Me) {
      if (typeof Ze == "string") {
        var Ne = Ze;
        return Me.filter(function(He) {
          return He.regions.some(function(qe) {
            return qe === Ne;
          });
        });
      }
      return Me.filter(function(He) {
        return Ze.map(function(qe) {
          return He.regions.some(function(Ke) {
            return Ke === qe;
          });
        }).some(function(qe) {
          return qe;
        });
      });
    }, this.sortTerritories = function(Ze, Me) {
      var Ne = [].concat(L(Ze), L(Me));
      return Ne.sort(function(He, qe) {
        return He.name < qe.name ? -1 : He.name > qe.name ? 1 : 0;
      }), Ne;
    }, this.getFilteredCountryList = function(Ze, Me, Ne) {
      return Ze.length === 0 ? Me : Ne ? Ze.map(function(He) {
        var qe = Me.find(function(Ke) {
          return Ke.iso2 === He;
        });
        if (qe) return qe;
      }).filter(function(He) {
        return He;
      }) : Me.filter(function(He) {
        return Ze.some(function(qe) {
          return qe === He.iso2;
        });
      });
    }, this.localizeCountries = function(Ze, Me, Ne) {
      for (var He = 0; He < Ze.length; He++) Me[Ze[He].iso2] !== void 0 ? Ze[He].localName = Me[Ze[He].iso2] : Me[Ze[He].name] !== void 0 && (Ze[He].localName = Me[Ze[He].name]);
      return Ne || Ze.sort(function(qe, Ke) {
        return qe.localName < Ke.localName ? -1 : qe.localName > Ke.localName ? 1 : 0;
      }), Ze;
    }, this.getCustomAreas = function(Ze, Me) {
      for (var Ne = [], He = 0; He < Me.length; He++) {
        var qe = JSON.parse(JSON.stringify(Ze));
        qe.dialCode += Me[He], Ne.push(qe);
      }
      return Ne;
    }, this.excludeCountries = function(Ze, Me) {
      return Me.length === 0 ? Ze : Ze.filter(function(Ne) {
        return !Me.includes(Ne.iso2);
      });
    };
    var De = function(Ze, Me, Ne) {
      var He = [];
      return ue(He, 1, Ze, !0), ue(He, 3, Me), ue(He, 2, Ne), He;
    }(ye, be, $e), Le = Ce(JSON.parse(JSON.stringify(Re)), De), ze = Ce(JSON.parse(JSON.stringify(ke)), De), We = Pe(fe(Le, ge, Ie, we, Fe), 2), Be = We[0], Ye = We[1];
    if (Ae) {
      var Ge = Pe(fe(ze, ge, Ie, we, Fe), 2), nt = Ge[0];
      Ge[1], Be = this.sortTerritories(nt, Be);
    }
    Ee && (Be = this.filterRegions(Ee, Be)), this.onlyCountries = this.localizeCountries(this.excludeCountries(this.getFilteredCountryList(ve, Be, Se.includes("onlyCountries")), me), Oe, Se.includes("onlyCountries")), this.preferredCountries = le.length === 0 ? [] : this.localizeCountries(this.getFilteredCountryList(le, Be, Se.includes("preferredCountries")), Oe, Se.includes("preferredCountries")), this.hiddenAreaCodes = this.excludeCountries(this.getFilteredCountryList(ve, Ye), me);
  }, pe = function(_e) {
    function ge(ve) {
      var le;
      W(this, ge), (le = function(De, Le) {
        return !Le || K(Le) !== "object" && typeof Le != "function" ? Y(De) : Le;
      }(this, J(ge).call(this, ve))).getProbableCandidate = ne()(function(De) {
        return De && De.length !== 0 ? le.state.onlyCountries.filter(function(Le) {
          return ie()(Le.name.toLowerCase(), De.toLowerCase());
        }, Y(Y(le)))[0] : null;
      }), le.guessSelectedCountry = ne()(function(De, Le, ze, We) {
        var Be;
        if (le.props.enableAreaCodes === !1 && (We.some(function(nt) {
          if (ie()(De, nt.dialCode)) return ze.some(function(Ze) {
            if (nt.iso2 === Ze.iso2 && Ze.mainCode) return Be = Ze, !0;
          }), !0;
        }), Be)) return Be;
        var Ye = ze.find(function(nt) {
          return nt.iso2 == Le;
        });
        if (De.trim() === "") return Ye;
        var Ge = ze.reduce(function(nt, Ze) {
          return ie()(De, Ze.dialCode) && (Ze.dialCode.length > nt.dialCode.length || Ze.dialCode.length === nt.dialCode.length && Ze.priority < nt.priority) ? Ze : nt;
        }, { dialCode: "", priority: 10001 }, Y(Y(le)));
        return Ge.name ? Ge : Ye;
      }), le.updateCountry = function(De) {
        var Le, ze = le.state.onlyCountries;
        (Le = De.indexOf(0) >= "0" && De.indexOf(0) <= "9" ? ze.find(function(We) {
          return We.dialCode == +De;
        }) : ze.find(function(We) {
          return We.iso2 == De;
        })) && Le.dialCode && le.setState({ selectedCountry: Le, formattedNumber: le.props.disableCountryCode ? "" : le.formatNumber(Le.dialCode, Le) });
      }, le.scrollTo = function(De, Le) {
        if (De) {
          var ze = le.dropdownRef;
          if (ze && document.body) {
            var We = ze.offsetHeight, Be = ze.getBoundingClientRect().top + document.body.scrollTop, Ye = Be + We, Ge = De, nt = Ge.getBoundingClientRect(), Ze = Ge.offsetHeight, Me = nt.top + document.body.scrollTop, Ne = Me + Ze, He = Me - Be + ze.scrollTop, qe = We / 2 - Ze / 2;
            if (le.props.enableSearch ? Me < Be + 32 : Me < Be) Le && (He -= qe), ze.scrollTop = He;
            else if (Ne > Ye) {
              Le && (He += qe);
              var Ke = We - Ze;
              ze.scrollTop = He - Ke;
            }
          }
        }
      }, le.scrollToTop = function() {
        var De = le.dropdownRef;
        De && document.body && (De.scrollTop = 0);
      }, le.formatNumber = function(De, Le) {
        if (!Le) return De;
        var ze, We = Le.format, Be = le.props, Ye = Be.disableCountryCode, Ge = Be.enableAreaCodeStretch, nt = Be.enableLongNumbers, Ze = Be.autoFormat;
        if (Ye ? ((ze = We.split(" ")).shift(), ze = ze.join(" ")) : Ge && Le.isAreaCode ? ((ze = We.split(" "))[1] = ze[1].replace(/\.+/, "".padEnd(Le.areaCodeLength, ".")), ze = ze.join(" ")) : ze = We, !De || De.length === 0) return Ye ? "" : le.props.prefix;
        if (De && De.length < 2 || !ze || !Ze) return Ye ? De : le.props.prefix + De;
        var Me, Ne = ae()(ze, function(He, qe) {
          if (He.remainingText.length === 0) return He;
          if (qe !== ".") return { formattedText: He.formattedText + qe, remainingText: He.remainingText };
          var Ke, Xe = V(Ke = He.remainingText) || D(Ke) || z(), tt = Xe[0], at = Xe.slice(1);
          return { formattedText: He.formattedText + tt, remainingText: at };
        }, { formattedText: "", remainingText: De.split("") });
        return (Me = nt ? Ne.formattedText + Ne.remainingText.join("") : Ne.formattedText).includes("(") && !Me.includes(")") && (Me += ")"), Me;
      }, le.cursorToEnd = function() {
        var De = le.numberInputRef;
        if (document.activeElement === De) {
          De.focus();
          var Le = De.value.length;
          De.value.charAt(Le - 1) === ")" && (Le -= 1), De.setSelectionRange(Le, Le);
        }
      }, le.getElement = function(De) {
        return le["flag_no_".concat(De)];
      }, le.getCountryData = function() {
        return le.state.selectedCountry ? { name: le.state.selectedCountry.name || "", dialCode: le.state.selectedCountry.dialCode || "", countryCode: le.state.selectedCountry.iso2 || "", format: le.state.selectedCountry.format || "" } : {};
      }, le.handleFlagDropdownClick = function(De) {
        if (De.preventDefault(), le.state.showDropdown || !le.props.disabled) {
          var Le = le.state, ze = Le.preferredCountries, We = Le.onlyCountries, Be = Le.selectedCountry, Ye = le.concatPreferredCountries(ze, We).findIndex(function(Ge) {
            return Ge.dialCode === Be.dialCode && Ge.iso2 === Be.iso2;
          });
          le.setState({ showDropdown: !le.state.showDropdown, highlightCountryIndex: Ye }, function() {
            le.state.showDropdown && le.scrollTo(le.getElement(le.state.highlightCountryIndex));
          });
        }
      }, le.handleInput = function(De) {
        var Le = De.target.value, ze = le.props, We = ze.prefix, Be = ze.onChange, Ye = le.props.disableCountryCode ? "" : We, Ge = le.state.selectedCountry, nt = le.state.freezeSelection;
        if (!le.props.countryCodeEditable) {
          var Ze = We + (Ge.hasAreaCodes ? le.state.onlyCountries.find(function(Qe) {
            return Qe.iso2 === Ge.iso2 && Qe.mainCode;
          }).dialCode : Ge.dialCode);
          if (Le.slice(0, Ze.length) !== Ze) return;
        }
        if (Le === We) return Be && Be("", le.getCountryData(), De, ""), le.setState({ formattedNumber: "" });
        if (!(Le.replace(/\D/g, "").length > 15 && (le.props.enableLongNumbers === !1 || typeof le.props.enableLongNumbers == "number" && Le.replace(/\D/g, "").length > le.props.enableLongNumbers)) && Le !== le.state.formattedNumber) {
          De.preventDefault ? De.preventDefault() : De.returnValue = !1;
          var Me = le.props.country, Ne = le.state, He = Ne.onlyCountries, qe = Ne.selectedCountry, Ke = Ne.hiddenAreaCodes;
          if (Be && De.persist(), Le.length > 0) {
            var Xe = Le.replace(/\D/g, "");
            (!le.state.freezeSelection || qe && qe.dialCode.length > Xe.length) && (Ge = le.props.disableCountryGuess ? qe : le.guessSelectedCountry(Xe.substring(0, 6), Me, He, Ke) || qe, nt = !1), Ye = le.formatNumber(Xe, Ge), Ge = Ge.dialCode ? Ge : qe;
          }
          var tt = De.target.selectionStart, at = De.target.selectionStart, it = le.state.formattedNumber, mt = Ye.length - it.length;
          le.setState({ formattedNumber: Ye, freezeSelection: nt, selectedCountry: Ge }, function() {
            mt > 0 && (at -= mt), Ye.charAt(Ye.length - 1) == ")" ? le.numberInputRef.setSelectionRange(Ye.length - 1, Ye.length - 1) : at > 0 && it.length >= Ye.length ? le.numberInputRef.setSelectionRange(at, at) : tt < it.length && le.numberInputRef.setSelectionRange(tt, tt), Be && Be(Ye.replace(/[^0-9]+/g, ""), le.getCountryData(), De, Ye);
          });
        }
      }, le.handleInputClick = function(De) {
        le.setState({ showDropdown: !1 }), le.props.onClick && le.props.onClick(De, le.getCountryData());
      }, le.handleDoubleClick = function(De) {
        var Le = De.target.value.length;
        De.target.setSelectionRange(0, Le);
      }, le.handleFlagItemClick = function(De, Le) {
        var ze = le.state.selectedCountry, We = le.state.onlyCountries.find(function(nt) {
          return nt == De;
        });
        if (We) {
          var Be = le.state.formattedNumber.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""), Ye = Be.length > 1 ? Be.replace(ze.dialCode, We.dialCode) : We.dialCode, Ge = le.formatNumber(Ye.replace(/\D/g, ""), We);
          le.setState({ showDropdown: !1, selectedCountry: We, freezeSelection: !0, formattedNumber: Ge, searchValue: "" }, function() {
            le.cursorToEnd(), le.props.onChange && le.props.onChange(Ge.replace(/[^0-9]+/g, ""), le.getCountryData(), Le, Ge);
          });
        }
      }, le.handleInputFocus = function(De) {
        le.numberInputRef && le.numberInputRef.value === le.props.prefix && le.state.selectedCountry && !le.props.disableCountryCode && le.setState({ formattedNumber: le.props.prefix + le.state.selectedCountry.dialCode }, function() {
          le.props.jumpCursorToEnd && setTimeout(le.cursorToEnd, 0);
        }), le.setState({ placeholder: "" }), le.props.onFocus && le.props.onFocus(De, le.getCountryData()), le.props.jumpCursorToEnd && setTimeout(le.cursorToEnd, 0);
      }, le.handleInputBlur = function(De) {
        De.target.value || le.setState({ placeholder: le.props.placeholder }), le.props.onBlur && le.props.onBlur(De, le.getCountryData());
      }, le.handleInputCopy = function(De) {
        if (le.props.copyNumbersOnly) {
          var Le = window.getSelection().toString().replace(/[^0-9]+/g, "");
          De.clipboardData.setData("text/plain", Le), De.preventDefault();
        }
      }, le.getHighlightCountryIndex = function(De) {
        var Le = le.state.highlightCountryIndex + De;
        return Le < 0 || Le >= le.state.onlyCountries.length + le.state.preferredCountries.length ? Le - De : le.props.enableSearch && Le > le.getSearchFilteredCountries().length ? 0 : Le;
      }, le.searchCountry = function() {
        var De = le.getProbableCandidate(le.state.queryString) || le.state.onlyCountries[0], Le = le.state.onlyCountries.findIndex(function(ze) {
          return ze == De;
        }) + le.state.preferredCountries.length;
        le.scrollTo(le.getElement(Le), !0), le.setState({ queryString: "", highlightCountryIndex: Le });
      }, le.handleKeydown = function(De) {
        var Le = le.props.keys, ze = De.target.className;
        if (ze.includes("selected-flag") && De.which === Le.ENTER && !le.state.showDropdown) return le.handleFlagDropdownClick(De);
        if (ze.includes("form-control") && (De.which === Le.ENTER || De.which === Le.ESC)) return De.target.blur();
        if (le.state.showDropdown && !le.props.disabled && (!ze.includes("search-box") || De.which === Le.UP || De.which === Le.DOWN || De.which === Le.ENTER || De.which === Le.ESC && De.target.value === "")) {
          De.preventDefault ? De.preventDefault() : De.returnValue = !1;
          var We = function(Be) {
            le.setState({ highlightCountryIndex: le.getHighlightCountryIndex(Be) }, function() {
              le.scrollTo(le.getElement(le.state.highlightCountryIndex), !0);
            });
          };
          switch (De.which) {
            case Le.DOWN:
              We(1);
              break;
            case Le.UP:
              We(-1);
              break;
            case Le.ENTER:
              le.props.enableSearch ? le.handleFlagItemClick(le.getSearchFilteredCountries()[le.state.highlightCountryIndex] || le.getSearchFilteredCountries()[0], De) : le.handleFlagItemClick([].concat(L(le.state.preferredCountries), L(le.state.onlyCountries))[le.state.highlightCountryIndex], De);
              break;
            case Le.ESC:
            case Le.TAB:
              le.setState({ showDropdown: !1 }, le.cursorToEnd);
              break;
            default:
              (De.which >= Le.A && De.which <= Le.Z || De.which === Le.SPACE) && le.setState({ queryString: le.state.queryString + String.fromCharCode(De.which) }, le.state.debouncedQueryStingSearcher);
          }
        }
      }, le.handleInputKeyDown = function(De) {
        var Le = le.props, ze = Le.keys, We = Le.onEnterKeyPress, Be = Le.onKeyDown;
        De.which === ze.ENTER && We && We(De), Be && Be(De);
      }, le.handleClickOutside = function(De) {
        le.dropdownRef && !le.dropdownContainerRef.contains(De.target) && le.state.showDropdown && le.setState({ showDropdown: !1 });
      }, le.handleSearchChange = function(De) {
        var Le = De.currentTarget.value, ze = le.state, We = ze.preferredCountries, Be = ze.selectedCountry, Ye = 0;
        if (Le === "" && Be) {
          var Ge = le.state.onlyCountries;
          Ye = le.concatPreferredCountries(We, Ge).findIndex(function(nt) {
            return nt == Be;
          }), setTimeout(function() {
            return le.scrollTo(le.getElement(Ye));
          }, 100);
        }
        le.setState({ searchValue: Le, highlightCountryIndex: Ye });
      }, le.concatPreferredCountries = function(De, Le) {
        return De.length > 0 ? L(new Set(De.concat(Le))) : Le;
      }, le.getDropdownCountryName = function(De) {
        return De.localName || De.name;
      }, le.getSearchFilteredCountries = function() {
        var De = le.state, Le = De.preferredCountries, ze = De.onlyCountries, We = De.searchValue, Be = le.props.enableSearch, Ye = le.concatPreferredCountries(Le, ze), Ge = We.trim().toLowerCase().replace("+", "");
        if (Be && Ge) {
          if (/^\d+$/.test(Ge)) return Ye.filter(function(Me) {
            var Ne = Me.dialCode;
            return ["".concat(Ne)].some(function(He) {
              return He.toLowerCase().includes(Ge);
            });
          });
          var nt = Ye.filter(function(Me) {
            var Ne = Me.iso2;
            return ["".concat(Ne)].some(function(He) {
              return He.toLowerCase().includes(Ge);
            });
          }), Ze = Ye.filter(function(Me) {
            var Ne = Me.name, He = Me.localName;
            return Me.iso2, ["".concat(Ne), "".concat(He || "")].some(function(qe) {
              return qe.toLowerCase().includes(Ge);
            });
          });
          return le.scrollToTop(), L(new Set([].concat(nt, Ze)));
        }
        return Ye;
      }, le.getCountryDropdownList = function() {
        var De = le.state, Le = De.preferredCountries, ze = De.highlightCountryIndex, We = De.showDropdown, Be = De.searchValue, Ye = le.props, Ge = Ye.disableDropdown, nt = Ye.prefix, Ze = le.props, Me = Ze.enableSearch, Ne = Ze.searchNotFound, He = Ze.disableSearchIcon, qe = Ze.searchClass, Ke = Ze.searchStyle, Xe = Ze.searchPlaceholder, tt = Ze.autocompleteSearch, at = le.getSearchFilteredCountries().map(function(Qe, ut) {
          var ft = ze === ut, vt = xe()({ country: !0, preferred: Qe.iso2 === "us" || Qe.iso2 === "gb", active: Qe.iso2 === "us", highlight: ft }), dt = "flag ".concat(Qe.iso2);
          return ee.a.createElement("li", Object.assign({ ref: function(xt) {
            return le["flag_no_".concat(ut)] = xt;
          }, key: "flag_no_".concat(ut), "data-flag-key": "flag_no_".concat(ut), className: vt, "data-dial-code": "1", tabIndex: Ge ? "-1" : "0", "data-country-code": Qe.iso2, onClick: function(xt) {
            return le.handleFlagItemClick(Qe, xt);
          }, role: "option" }, ft ? { "aria-selected": !0 } : {}), ee.a.createElement("div", { className: dt }), ee.a.createElement("span", { className: "country-name" }, le.getDropdownCountryName(Qe)), ee.a.createElement("span", { className: "dial-code" }, Qe.format ? le.formatNumber(Qe.dialCode, Qe) : nt + Qe.dialCode));
        }), it = ee.a.createElement("li", { key: "dashes", className: "divider" });
        Le.length > 0 && (!Me || Me && !Be.trim()) && at.splice(Le.length, 0, it);
        var mt = xe()(k({ "country-list": !0, hide: !We }, le.props.dropdownClass, !0));
        return ee.a.createElement("ul", { ref: function(Qe) {
          return !Me && Qe && Qe.focus(), le.dropdownRef = Qe;
        }, className: mt, style: le.props.dropdownStyle, role: "listbox", tabIndex: "0" }, Me && ee.a.createElement("li", { className: xe()(k({ search: !0 }, qe, qe)) }, !He && ee.a.createElement("span", { className: xe()(k({ "search-emoji": !0 }, "".concat(qe, "-emoji"), qe)), role: "img", "aria-label": "Magnifying glass" }, "🔎"), ee.a.createElement("input", { className: xe()(k({ "search-box": !0 }, "".concat(qe, "-box"), qe)), style: Ke, type: "search", placeholder: Xe, autoFocus: !0, autoComplete: tt ? "on" : "off", value: Be, onChange: le.handleSearchChange })), at.length > 0 ? at : ee.a.createElement("li", { className: "no-entries-message" }, ee.a.createElement("span", null, Ne)));
      };
      var me, Se = new ce(ve.enableAreaCodes, ve.enableTerritories, ve.regions, ve.onlyCountries, ve.preferredCountries, ve.excludeCountries, ve.preserveOrder, ve.masks, ve.priority, ve.areaCodes, ve.localization, ve.prefix, ve.defaultMask, ve.alwaysDefaultMask), ye = Se.onlyCountries, be = Se.preferredCountries, $e = Se.hiddenAreaCodes, Oe = ve.value ? ve.value.replace(/\D/g, "") : "";
      me = ve.disableInitialCountryGuess ? 0 : Oe.length > 1 ? le.guessSelectedCountry(Oe.substring(0, 6), ve.country, ye, $e) || 0 : ve.country && ye.find(function(De) {
        return De.iso2 == ve.country;
      }) || 0;
      var Ie, we = Oe.length < 2 && me && !ie()(Oe, me.dialCode) ? me.dialCode : "";
      Ie = Oe === "" && me === 0 ? "" : le.formatNumber((ve.disableCountryCode ? "" : we) + Oe, me.name ? me : void 0);
      var Fe = ye.findIndex(function(De) {
        return De == me;
      });
      return le.state = { showDropdown: ve.showDropdown, formattedNumber: Ie, onlyCountries: ye, preferredCountries: be, hiddenAreaCodes: $e, selectedCountry: me, highlightCountryIndex: Fe, queryString: "", freezeSelection: !1, debouncedQueryStingSearcher: re()(le.searchCountry, 250), searchValue: "" }, le;
    }
    var Ae, Ee;
    return function(ve, le) {
      if (typeof le != "function" && le !== null) throw new TypeError("Super expression must either be null or a function");
      ve.prototype = Object.create(le && le.prototype, { constructor: { value: ve, writable: !0, configurable: !0 } }), le && Z(ve, le);
    }(ge, _e), Ae = ge, (Ee = [{ key: "componentDidMount", value: function() {
      document.addEventListener && this.props.enableClickOutside && document.addEventListener("mousedown", this.handleClickOutside), this.props.onMount && this.props.onMount(this.state.formattedNumber.replace(/[^0-9]+/g, ""), this.getCountryData(), this.state.formattedNumber);
    } }, { key: "componentWillUnmount", value: function() {
      document.removeEventListener && this.props.enableClickOutside && document.removeEventListener("mousedown", this.handleClickOutside);
    } }, { key: "componentDidUpdate", value: function(ve, le, me) {
      ve.country !== this.props.country ? this.updateCountry(this.props.country) : ve.value !== this.props.value && this.updateFormattedNumber(this.props.value);
    } }, { key: "updateFormattedNumber", value: function(ve) {
      if (ve === null) return this.setState({ selectedCountry: 0, formattedNumber: "" });
      var le = this.state, me = le.onlyCountries, Se = le.selectedCountry, ye = le.hiddenAreaCodes, be = this.props, $e = be.country, Oe = be.prefix;
      if (ve === "") return this.setState({ selectedCountry: Se, formattedNumber: "" });
      var Ie, we, Fe = ve.replace(/\D/g, "");
      if (Se && ie()(ve, Oe + Se.dialCode)) we = this.formatNumber(Fe, Se), this.setState({ formattedNumber: we });
      else {
        var De = (Ie = this.props.disableCountryGuess ? Se : this.guessSelectedCountry(Fe.substring(0, 6), $e, me, ye) || Se) && ie()(Fe, Oe + Ie.dialCode) ? Ie.dialCode : "";
        we = this.formatNumber((this.props.disableCountryCode ? "" : De) + Fe, Ie || void 0), this.setState({ selectedCountry: Ie, formattedNumber: we });
      }
    } }, { key: "render", value: function() {
      var ve, le, me, Se = this, ye = this.state, be = ye.onlyCountries, $e = ye.selectedCountry, Oe = ye.showDropdown, Ie = ye.formattedNumber, we = ye.hiddenAreaCodes, Fe = this.props, De = Fe.disableDropdown, Le = Fe.renderStringAsFlag, ze = Fe.isValid, We = Fe.defaultErrorMessage, Be = Fe.specialLabel;
      if (typeof ze == "boolean") le = ze;
      else {
        var Ye = ze(Ie.replace(/\D/g, ""), $e, be, we);
        typeof Ye == "boolean" ? (le = Ye) === !1 && (me = We) : (le = !1, me = Ye);
      }
      var Ge = xe()((k(ve = {}, this.props.containerClass, !0), k(ve, "react-tel-input", !0), ve)), nt = xe()({ arrow: !0, up: Oe }), Ze = xe()(k({ "form-control": !0, "invalid-number": !le, open: Oe }, this.props.inputClass, !0)), Me = xe()({ "selected-flag": !0, open: Oe }), Ne = xe()(k({ "flag-dropdown": !0, "invalid-number": !le, open: Oe }, this.props.buttonClass, !0)), He = "flag ".concat($e && $e.iso2);
      return ee.a.createElement("div", { className: "".concat(Ge, " ").concat(this.props.className), style: this.props.style || this.props.containerStyle, onKeyDown: this.handleKeydown }, Be && ee.a.createElement("div", { className: "special-label" }, Be), me && ee.a.createElement("div", { className: "invalid-number-message" }, me), ee.a.createElement("input", Object.assign({ className: Ze, style: this.props.inputStyle, onChange: this.handleInput, onClick: this.handleInputClick, onDoubleClick: this.handleDoubleClick, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, onCopy: this.handleInputCopy, value: Ie, onKeyDown: this.handleInputKeyDown, placeholder: this.props.placeholder, disabled: this.props.disabled, type: "tel" }, this.props.inputProps, { ref: function(qe) {
        Se.numberInputRef = qe, typeof Se.props.inputProps.ref == "function" ? Se.props.inputProps.ref(qe) : typeof Se.props.inputProps.ref == "object" && (Se.props.inputProps.ref.current = qe);
      } })), ee.a.createElement("div", { className: Ne, style: this.props.buttonStyle, ref: function(qe) {
        return Se.dropdownContainerRef = qe;
      } }, Le ? ee.a.createElement("div", { className: Me }, Le) : ee.a.createElement("div", { onClick: De ? void 0 : this.handleFlagDropdownClick, className: Me, title: $e ? "".concat($e.localName || $e.name, ": + ").concat($e.dialCode) : "", tabIndex: De ? "-1" : "0", role: "button", "aria-haspopup": "listbox", "aria-expanded": !!Oe || void 0 }, ee.a.createElement("div", { className: He }, !De && ee.a.createElement("div", { className: nt }))), Oe && this.getCountryDropdownList()));
    } }]) && U(Ae.prototype, Ee), ge;
  }(ee.a.Component);
  pe.defaultProps = { country: "", value: "", onlyCountries: [], preferredCountries: [], excludeCountries: [], placeholder: "1 (702) 123-4567", searchPlaceholder: "search", searchNotFound: "No entries to show", flagsImagePath: "./flags.png", disabled: !1, containerStyle: {}, inputStyle: {}, buttonStyle: {}, dropdownStyle: {}, searchStyle: {}, containerClass: "", inputClass: "", buttonClass: "", dropdownClass: "", searchClass: "", className: "", autoFormat: !0, enableAreaCodes: !1, enableTerritories: !1, disableCountryCode: !1, disableDropdown: !1, enableLongNumbers: !1, countryCodeEditable: !0, enableSearch: !1, disableSearchIcon: !1, disableInitialCountryGuess: !1, disableCountryGuess: !1, regions: "", inputProps: {}, localization: {}, masks: null, priority: null, areaCodes: null, preserveOrder: [], defaultMask: "... ... ... ... ..", alwaysDefaultMask: !1, prefix: "+", copyNumbersOnly: !0, renderStringAsFlag: "", autocompleteSearch: !1, jumpCursorToEnd: !0, enableAreaCodeStretch: !1, enableClickOutside: !0, showDropdown: !1, isValid: !0, defaultErrorMessage: "", specialLabel: "Phone", onEnterKeyPress: null, keys: { UP: 38, DOWN: 40, RIGHT: 39, LEFT: 37, ENTER: 13, ESC: 27, PLUS: 43, A: 65, Z: 90, SPACE: 32, TAB: 9 } }, S.default = pe;
}]);
const PhoneInput = /* @__PURE__ */ getDefaultExportFromCjs(lib$1);
var scope = (() => {
  let T;
  return typeof window < "u" ? T = window : typeof globalThis < "u" ? T = globalThis : typeof global < "u" ? T = global : typeof self < "u" ? T = self : T = {}, T;
})(), events = ((T) => (T.CHANNEL_WS_DISCONNECT = "channelWSDisconnect", T.CHANNEL_CREATED = "channelCreated", T.CONFIG_ERROR = "configError", T.STORY_INDEX_INVALIDATED = "storyIndexInvalidated", T.STORY_SPECIFIED = "storySpecified", T.SET_CONFIG = "setConfig", T.SET_STORIES = "setStories", T.SET_INDEX = "setIndex", T.SET_CURRENT_STORY = "setCurrentStory", T.CURRENT_STORY_WAS_SET = "currentStoryWasSet", T.FORCE_RE_RENDER = "forceReRender", T.FORCE_REMOUNT = "forceRemount", T.PRELOAD_ENTRIES = "preloadStories", T.STORY_PREPARED = "storyPrepared", T.DOCS_PREPARED = "docsPrepared", T.STORY_CHANGED = "storyChanged", T.STORY_UNCHANGED = "storyUnchanged", T.STORY_RENDERED = "storyRendered", T.STORY_MISSING = "storyMissing", T.STORY_ERRORED = "storyErrored", T.STORY_THREW_EXCEPTION = "storyThrewException", T.STORY_RENDER_PHASE_CHANGED = "storyRenderPhaseChanged", T.PLAY_FUNCTION_THREW_EXCEPTION = "playFunctionThrewException", T.UNHANDLED_ERRORS_WHILE_PLAYING = "unhandledErrorsWhilePlaying", T.UPDATE_STORY_ARGS = "updateStoryArgs", T.STORY_ARGS_UPDATED = "storyArgsUpdated", T.RESET_STORY_ARGS = "resetStoryArgs", T.SET_GLOBALS = "setGlobals", T.UPDATE_GLOBALS = "updateGlobals", T.GLOBALS_UPDATED = "globalsUpdated", T.REGISTER_SUBSCRIPTION = "registerSubscription", T.PREVIEW_KEYDOWN = "previewKeydown", T.PREVIEW_BUILDER_PROGRESS = "preview_builder_progress", T.SELECT_STORY = "selectStory", T.STORIES_COLLAPSE_ALL = "storiesCollapseAll", T.STORIES_EXPAND_ALL = "storiesExpandAll", T.DOCS_RENDERED = "docsRendered", T.SHARED_STATE_CHANGED = "sharedStateChanged", T.SHARED_STATE_SET = "sharedStateSet", T.NAVIGATE_URL = "navigateUrl", T.UPDATE_QUERY_PARAMS = "updateQueryParams", T.REQUEST_WHATS_NEW_DATA = "requestWhatsNewData", T.RESULT_WHATS_NEW_DATA = "resultWhatsNewData", T.SET_WHATS_NEW_CACHE = "setWhatsNewCache", T.TOGGLE_WHATS_NEW_NOTIFICATIONS = "toggleWhatsNewNotifications", T.TELEMETRY_ERROR = "telemetryError", T.FILE_COMPONENT_SEARCH_REQUEST = "fileComponentSearchRequest", T.FILE_COMPONENT_SEARCH_RESPONSE = "fileComponentSearchResponse", T.SAVE_STORY_REQUEST = "saveStoryRequest", T.SAVE_STORY_RESPONSE = "saveStoryResponse", T.ARGTYPES_INFO_REQUEST = "argtypesInfoRequest", T.ARGTYPES_INFO_RESPONSE = "argtypesInfoResponse", T.CREATE_NEW_STORYFILE_REQUEST = "createNewStoryfileRequest", T.CREATE_NEW_STORYFILE_RESPONSE = "createNewStoryfileResponse", T))(events || {}), { CHANNEL_WS_DISCONNECT, CHANNEL_CREATED, CONFIG_ERROR, CREATE_NEW_STORYFILE_REQUEST, CREATE_NEW_STORYFILE_RESPONSE, CURRENT_STORY_WAS_SET, DOCS_PREPARED, DOCS_RENDERED, FILE_COMPONENT_SEARCH_REQUEST, FILE_COMPONENT_SEARCH_RESPONSE, FORCE_RE_RENDER, FORCE_REMOUNT, GLOBALS_UPDATED, NAVIGATE_URL, PLAY_FUNCTION_THREW_EXCEPTION, UNHANDLED_ERRORS_WHILE_PLAYING, PRELOAD_ENTRIES, PREVIEW_BUILDER_PROGRESS, PREVIEW_KEYDOWN, REGISTER_SUBSCRIPTION, RESET_STORY_ARGS, SELECT_STORY, SET_CONFIG, SET_CURRENT_STORY, SET_GLOBALS, SET_INDEX, SET_STORIES, SHARED_STATE_CHANGED, SHARED_STATE_SET, STORIES_COLLAPSE_ALL, STORIES_EXPAND_ALL, STORY_ARGS_UPDATED, STORY_CHANGED, STORY_ERRORED, STORY_INDEX_INVALIDATED, STORY_MISSING, STORY_PREPARED, STORY_RENDER_PHASE_CHANGED, STORY_RENDERED, STORY_SPECIFIED, STORY_THREW_EXCEPTION, STORY_UNCHANGED, UPDATE_GLOBALS, UPDATE_QUERY_PARAMS, UPDATE_STORY_ARGS, REQUEST_WHATS_NEW_DATA, RESULT_WHATS_NEW_DATA, SET_WHATS_NEW_CACHE, TOGGLE_WHATS_NEW_NOTIFICATIONS, TELEMETRY_ERROR, SAVE_STORY_REQUEST, SAVE_STORY_RESPONSE, ARGTYPES_INFO_REQUEST, ARGTYPES_INFO_RESPONSE } = events, { LOGLEVEL } = scope, levels = { trace: 1, debug: 2, info: 3, warn: 4, error: 5, silent: 10 }, currentLogLevelString = LOGLEVEL, currentLogLevelNumber = levels[currentLogLevelString] || levels.info, logger = { trace: (T, ...S) => {
  currentLogLevelNumber <= levels.trace && console.trace(T, ...S);
}, debug: (T, ...S) => {
  currentLogLevelNumber <= levels.debug && console.debug(T, ...S);
}, info: (T, ...S) => {
  currentLogLevelNumber <= levels.info && console.info(T, ...S);
}, warn: (T, ...S) => {
  currentLogLevelNumber <= levels.warn && console.warn(T, ...S);
}, error: (T, ...S) => {
  currentLogLevelNumber <= levels.error && console.error(T, ...S);
}, log: (T, ...S) => {
  currentLogLevelNumber < levels.silent && console.log(T, ...S);
} }, logged = /* @__PURE__ */ new Set(), once = (T) => (S, ...R) => {
  if (!logged.has(S)) return logged.add(S), logger[T](S, ...R);
};
once.clear = () => logged.clear();
once.trace = once("trace");
once.debug = once("debug");
once.info = once("info");
once.warn = once("warn");
once.error = once("error");
once.log = once("log");
var deprecate$2 = once("warn"), __create$5 = Object.create, __defProp$5 = Object.defineProperty, __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor, __getOwnPropNames$5 = Object.getOwnPropertyNames, __getProtoOf$5 = Object.getPrototypeOf, __hasOwnProp$5 = Object.prototype.hasOwnProperty, __commonJS$5 = (T, S) => function() {
  return S || (0, T[__getOwnPropNames$5(T)[0]])((S = { exports: {} }).exports, S), S.exports;
}, __copyProps$5 = (T, S, R, k) => {
  if (S && typeof S == "object" || typeof S == "function")
    for (let D of __getOwnPropNames$5(S))
      !__hasOwnProp$5.call(T, D) && D !== R && __defProp$5(T, D, { get: () => S[D], enumerable: !(k = __getOwnPropDesc$5(S, D)) || k.enumerable });
  return T;
}, __toESM$5 = (T, S, R) => (R = T != null ? __create$5(__getProtoOf$5(T)) : {}, __copyProps$5(
  !T || !T.__esModule ? __defProp$5(R, "default", { value: T, enumerable: !0 }) : R,
  T
)), eventProperties = [
  "bubbles",
  "cancelBubble",
  "cancelable",
  "composed",
  "currentTarget",
  "defaultPrevented",
  "eventPhase",
  "isTrusted",
  "returnValue",
  "srcElement",
  "target",
  "timeStamp",
  "type"
], customEventSpecificProperties = ["detail"];
function extractEventHiddenProperties(T) {
  const S = eventProperties.filter((R) => T[R] !== void 0).reduce((R, k) => ({ ...R, [k]: T[k] }), {});
  return T instanceof CustomEvent && customEventSpecificProperties.filter((R) => T[R] !== void 0).forEach((R) => {
    S[R] = T[R];
  }), S;
}
function commonjsRequire(T) {
  throw new Error('Could not dynamically require "' + T + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var memoizerific = { exports: {} };
(function(T, S) {
  (function(R) {
    T.exports = R();
  })(function() {
    return function R(k, D, L) {
      function V(U, q) {
        if (!D[U]) {
          if (!k[U]) {
            var K = typeof commonjsRequire == "function" && commonjsRequire;
            if (!q && K) return K(U, !0);
            if (z) return z(U, !0);
            var Y = new Error("Cannot find module '" + U + "'");
            throw Y.code = "MODULE_NOT_FOUND", Y;
          }
          var J = D[U] = { exports: {} };
          k[U][0].call(J.exports, function(Z) {
            var X = k[U][1][Z];
            return V(X || Z);
          }, J, J.exports, R, k, D, L);
        }
        return D[U].exports;
      }
      for (var z = typeof commonjsRequire == "function" && commonjsRequire, W = 0; W < L.length; W++) V(L[W]);
      return V;
    }({ 1: [function(R, k, D) {
      k.exports = function(L) {
        if (typeof Map != "function" || L) {
          var V = R("./similar");
          return new V();
        } else
          return /* @__PURE__ */ new Map();
      };
    }, { "./similar": 2 }], 2: [function(R, k, D) {
      function L() {
        return this.list = [], this.lastItem = void 0, this.size = 0, this;
      }
      L.prototype.get = function(V) {
        var z;
        if (this.lastItem && this.isEqual(this.lastItem.key, V))
          return this.lastItem.val;
        if (z = this.indexOf(V), z >= 0)
          return this.lastItem = this.list[z], this.list[z].val;
      }, L.prototype.set = function(V, z) {
        var W;
        return this.lastItem && this.isEqual(this.lastItem.key, V) ? (this.lastItem.val = z, this) : (W = this.indexOf(V), W >= 0 ? (this.lastItem = this.list[W], this.list[W].val = z, this) : (this.lastItem = { key: V, val: z }, this.list.push(this.lastItem), this.size++, this));
      }, L.prototype.delete = function(V) {
        var z;
        if (this.lastItem && this.isEqual(this.lastItem.key, V) && (this.lastItem = void 0), z = this.indexOf(V), z >= 0)
          return this.size--, this.list.splice(z, 1)[0];
      }, L.prototype.has = function(V) {
        var z;
        return this.lastItem && this.isEqual(this.lastItem.key, V) ? !0 : (z = this.indexOf(V), z >= 0 ? (this.lastItem = this.list[z], !0) : !1);
      }, L.prototype.forEach = function(V, z) {
        var W;
        for (W = 0; W < this.size; W++)
          V.call(z || this, this.list[W].val, this.list[W].key, this);
      }, L.prototype.indexOf = function(V) {
        var z;
        for (z = 0; z < this.size; z++)
          if (this.isEqual(this.list[z].key, V))
            return z;
        return -1;
      }, L.prototype.isEqual = function(V, z) {
        return V === z || V !== V && z !== z;
      }, k.exports = L;
    }, {}], 3: [function(R, k, D) {
      var L = R("map-or-similar");
      k.exports = function(U) {
        var q = new L(!1), K = [];
        return function(Y) {
          var J = function() {
            var Z = q, X, ee, te = arguments.length - 1, re = Array(te + 1), Q = !0, ne;
            if ((J.numArgs || J.numArgs === 0) && J.numArgs !== te + 1)
              throw new Error("Memoizerific functions should always be called with the same number of arguments");
            for (ne = 0; ne < te; ne++) {
              if (re[ne] = {
                cacheItem: Z,
                arg: arguments[ne]
              }, Z.has(arguments[ne])) {
                Z = Z.get(arguments[ne]);
                continue;
              }
              Q = !1, X = new L(!1), Z.set(arguments[ne], X), Z = X;
            }
            return Q && (Z.has(arguments[te]) ? ee = Z.get(arguments[te]) : Q = !1), Q || (ee = Y.apply(null, arguments), Z.set(arguments[te], ee)), U > 0 && (re[te] = {
              cacheItem: Z,
              arg: arguments[te]
            }, Q ? V(K, re) : K.push(re), K.length > U && z(K.shift())), J.wasMemoized = Q, J.numArgs = te + 1, ee;
          };
          return J.limit = U, J.wasMemoized = !1, J.cache = q, J.lru = K, J;
        };
      };
      function V(U, q) {
        var K = U.length, Y = q.length, J, Z, X;
        for (Z = 0; Z < K; Z++) {
          for (J = !0, X = 0; X < Y; X++)
            if (!W(U[Z][X].arg, q[X].arg)) {
              J = !1;
              break;
            }
          if (J)
            break;
        }
        U.push(U.splice(Z, 1)[0]);
      }
      function z(U) {
        var q = U.length, K = U[q - 1], Y, J;
        for (K.cacheItem.delete(K.arg), J = q - 2; J >= 0 && (K = U[J], Y = K.cacheItem.get(K.arg), !Y || !Y.size); J--)
          K.cacheItem.delete(K.arg);
      }
      function W(U, q) {
        return U === q || U !== U && q !== q;
      }
    }, { "map-or-similar": 1 }] }, {}, [3])(3);
  });
})(memoizerific);
var memoizerificExports = memoizerific.exports;
const memoize$3 = /* @__PURE__ */ getDefaultExportFromCjs(memoizerificExports);
var require_shams = __commonJS$5({
  "node_modules/has-symbols/shams.js"(T, S) {
    S.exports = function() {
      if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
        return !1;
      if (typeof Symbol.iterator == "symbol")
        return !0;
      var k = {}, D = Symbol("test"), L = Object(D);
      if (typeof D == "string" || Object.prototype.toString.call(D) !== "[object Symbol]" || Object.prototype.toString.call(L) !== "[object Symbol]")
        return !1;
      var V = 42;
      k[D] = V;
      for (D in k)
        return !1;
      if (typeof Object.keys == "function" && Object.keys(k).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(k).length !== 0)
        return !1;
      var z = Object.getOwnPropertySymbols(k);
      if (z.length !== 1 || z[0] !== D || !Object.prototype.propertyIsEnumerable.call(k, D))
        return !1;
      if (typeof Object.getOwnPropertyDescriptor == "function") {
        var W = Object.getOwnPropertyDescriptor(k, D);
        if (W.value !== V || W.enumerable !== !0)
          return !1;
      }
      return !0;
    };
  }
}), require_has_symbols = __commonJS$5({
  "node_modules/has-symbols/index.js"(T, S) {
    var R = typeof Symbol < "u" && Symbol, k = require_shams();
    S.exports = function() {
      return typeof R != "function" || typeof Symbol != "function" || typeof R("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : k();
    };
  }
}), require_implementation = __commonJS$5({
  "node_modules/function-bind/implementation.js"(T, S) {
    var R = "Function.prototype.bind called on incompatible ", k = Array.prototype.slice, D = Object.prototype.toString, L = "[object Function]";
    S.exports = function(z) {
      var W = this;
      if (typeof W != "function" || D.call(W) !== L)
        throw new TypeError(R + W);
      for (var U = k.call(arguments, 1), q, K = function() {
        if (this instanceof q) {
          var ee = W.apply(
            this,
            U.concat(k.call(arguments))
          );
          return Object(ee) === ee ? ee : this;
        } else
          return W.apply(
            z,
            U.concat(k.call(arguments))
          );
      }, Y = Math.max(0, W.length - U.length), J = [], Z = 0; Z < Y; Z++)
        J.push("$" + Z);
      if (q = Function("binder", "return function (" + J.join(",") + "){ return binder.apply(this,arguments); }")(K), W.prototype) {
        var X = function() {
        };
        X.prototype = W.prototype, q.prototype = new X(), X.prototype = null;
      }
      return q;
    };
  }
}), require_function_bind = __commonJS$5({
  "node_modules/function-bind/index.js"(T, S) {
    var R = require_implementation();
    S.exports = Function.prototype.bind || R;
  }
}), require_src = __commonJS$5({
  "node_modules/has/src/index.js"(T, S) {
    var R = require_function_bind();
    S.exports = R.call(Function.call, Object.prototype.hasOwnProperty);
  }
}), require_get_intrinsic = __commonJS$5({
  "node_modules/get-intrinsic/index.js"(T, S) {
    var R, k = SyntaxError, D = Function, L = TypeError, V = function(Re) {
      try {
        return D('"use strict"; return (' + Re + ").constructor;")();
      } catch {
      }
    }, z = Object.getOwnPropertyDescriptor;
    if (z)
      try {
        z({}, "");
      } catch {
        z = null;
      }
    var W = function() {
      throw new L();
    }, U = z ? function() {
      try {
        return arguments.callee, W;
      } catch {
        try {
          return z(arguments, "callee").get;
        } catch {
          return W;
        }
      }
    }() : W, q = require_has_symbols()(), K = Object.getPrototypeOf || function(Re) {
      return Re.__proto__;
    }, Y = {}, J = typeof Uint8Array > "u" ? R : K(Uint8Array), Z = {
      "%AggregateError%": typeof AggregateError > "u" ? R : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer > "u" ? R : ArrayBuffer,
      "%ArrayIteratorPrototype%": q ? K([][Symbol.iterator]()) : R,
      "%AsyncFromSyncIteratorPrototype%": R,
      "%AsyncFunction%": Y,
      "%AsyncGenerator%": Y,
      "%AsyncGeneratorFunction%": Y,
      "%AsyncIteratorPrototype%": Y,
      "%Atomics%": typeof Atomics > "u" ? R : Atomics,
      "%BigInt%": typeof BigInt > "u" ? R : BigInt,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView > "u" ? R : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%eval%": eval,
      "%EvalError%": EvalError,
      "%Float32Array%": typeof Float32Array > "u" ? R : Float32Array,
      "%Float64Array%": typeof Float64Array > "u" ? R : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? R : FinalizationRegistry,
      "%Function%": D,
      "%GeneratorFunction%": Y,
      "%Int8Array%": typeof Int8Array > "u" ? R : Int8Array,
      "%Int16Array%": typeof Int16Array > "u" ? R : Int16Array,
      "%Int32Array%": typeof Int32Array > "u" ? R : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": q ? K(K([][Symbol.iterator]())) : R,
      "%JSON%": typeof JSON == "object" ? JSON : R,
      "%Map%": typeof Map > "u" ? R : Map,
      "%MapIteratorPrototype%": typeof Map > "u" || !q ? R : K((/* @__PURE__ */ new Map())[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise > "u" ? R : Promise,
      "%Proxy%": typeof Proxy > "u" ? R : Proxy,
      "%RangeError%": RangeError,
      "%ReferenceError%": ReferenceError,
      "%Reflect%": typeof Reflect > "u" ? R : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set > "u" ? R : Set,
      "%SetIteratorPrototype%": typeof Set > "u" || !q ? R : K((/* @__PURE__ */ new Set())[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? R : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": q ? K(""[Symbol.iterator]()) : R,
      "%Symbol%": q ? Symbol : R,
      "%SyntaxError%": k,
      "%ThrowTypeError%": U,
      "%TypedArray%": J,
      "%TypeError%": L,
      "%Uint8Array%": typeof Uint8Array > "u" ? R : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? R : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array > "u" ? R : Uint16Array,
      "%Uint32Array%": typeof Uint32Array > "u" ? R : Uint32Array,
      "%URIError%": URIError,
      "%WeakMap%": typeof WeakMap > "u" ? R : WeakMap,
      "%WeakRef%": typeof WeakRef > "u" ? R : WeakRef,
      "%WeakSet%": typeof WeakSet > "u" ? R : WeakSet
    }, X = function Re(ke) {
      var Te;
      if (ke === "%AsyncFunction%")
        Te = V("async function () {}");
      else if (ke === "%GeneratorFunction%")
        Te = V("function* () {}");
      else if (ke === "%AsyncGeneratorFunction%")
        Te = V("async function* () {}");
      else if (ke === "%AsyncGenerator%") {
        var fe = Re("%AsyncGeneratorFunction%");
        fe && (Te = fe.prototype);
      } else if (ke === "%AsyncIteratorPrototype%") {
        var ue = Re("%AsyncGenerator%");
        ue && (Te = K(ue.prototype));
      }
      return Z[ke] = Te, Te;
    }, ee = {
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    }, te = require_function_bind(), re = require_src(), Q = te.call(Function.call, Array.prototype.concat), ne = te.call(Function.apply, Array.prototype.splice), oe = te.call(Function.call, String.prototype.replace), ae = te.call(Function.call, String.prototype.slice), se = te.call(Function.call, RegExp.prototype.exec), ie = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, he = /\\(\\)?/g, xe = function(ke) {
      var Te = ae(ke, 0, 1), fe = ae(ke, -1);
      if (Te === "%" && fe !== "%")
        throw new k("invalid intrinsic syntax, expected closing `%`");
      if (fe === "%" && Te !== "%")
        throw new k("invalid intrinsic syntax, expected opening `%`");
      var ue = [];
      return oe(ke, ie, function(Ce, ce, pe, _e) {
        ue[ue.length] = pe ? oe(_e, he, "$1") : ce || Ce;
      }), ue;
    }, Pe = function(ke, Te) {
      var fe = ke, ue;
      if (re(ee, fe) && (ue = ee[fe], fe = "%" + ue[0] + "%"), re(Z, fe)) {
        var Ce = Z[fe];
        if (Ce === Y && (Ce = X(fe)), typeof Ce > "u" && !Te)
          throw new L("intrinsic " + ke + " exists, but is not available. Please file an issue!");
        return {
          alias: ue,
          name: fe,
          value: Ce
        };
      }
      throw new k("intrinsic " + ke + " does not exist!");
    };
    S.exports = function(ke, Te) {
      if (typeof ke != "string" || ke.length === 0)
        throw new L("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && typeof Te != "boolean")
        throw new L('"allowMissing" argument must be a boolean');
      if (se(/^%?[^%]*%?$/, ke) === null)
        throw new k("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      var fe = xe(ke), ue = fe.length > 0 ? fe[0] : "", Ce = Pe("%" + ue + "%", Te), ce = Ce.name, pe = Ce.value, _e = !1, ge = Ce.alias;
      ge && (ue = ge[0], ne(fe, Q([0, 1], ge)));
      for (var Ae = 1, Ee = !0; Ae < fe.length; Ae += 1) {
        var ve = fe[Ae], le = ae(ve, 0, 1), me = ae(ve, -1);
        if ((le === '"' || le === "'" || le === "`" || me === '"' || me === "'" || me === "`") && le !== me)
          throw new k("property names with quotes must have matching quotes");
        if ((ve === "constructor" || !Ee) && (_e = !0), ue += "." + ve, ce = "%" + ue + "%", re(Z, ce))
          pe = Z[ce];
        else if (pe != null) {
          if (!(ve in pe)) {
            if (!Te)
              throw new L("base intrinsic for " + ke + " exists, but the property is not available.");
            return;
          }
          if (z && Ae + 1 >= fe.length) {
            var Se = z(pe, ve);
            Ee = !!Se, Ee && "get" in Se && !("originalValue" in Se.get) ? pe = Se.get : pe = pe[ve];
          } else
            Ee = re(pe, ve), pe = pe[ve];
          Ee && !_e && (Z[ce] = pe);
        }
      }
      return pe;
    };
  }
}), require_call_bind = __commonJS$5({
  "node_modules/call-bind/index.js"(T, S) {
    var R = require_function_bind(), k = require_get_intrinsic(), D = k("%Function.prototype.apply%"), L = k("%Function.prototype.call%"), V = k("%Reflect.apply%", !0) || R.call(L, D), z = k("%Object.getOwnPropertyDescriptor%", !0), W = k("%Object.defineProperty%", !0), U = k("%Math.max%");
    if (W)
      try {
        W({}, "a", { value: 1 });
      } catch {
        W = null;
      }
    S.exports = function(Y) {
      var J = V(R, L, arguments);
      if (z && W) {
        var Z = z(J, "length");
        Z.configurable && W(
          J,
          "length",
          { value: 1 + U(0, Y.length - (arguments.length - 1)) }
        );
      }
      return J;
    };
    var q = function() {
      return V(R, D, arguments);
    };
    W ? W(S.exports, "apply", { value: q }) : S.exports.apply = q;
  }
}), require_callBound = __commonJS$5({
  "node_modules/call-bind/callBound.js"(T, S) {
    var R = require_get_intrinsic(), k = require_call_bind(), D = k(R("String.prototype.indexOf"));
    S.exports = function(V, z) {
      var W = R(V, !!z);
      return typeof W == "function" && D(V, ".prototype.") > -1 ? k(W) : W;
    };
  }
}), require_shams2 = __commonJS$5({
  "node_modules/has-tostringtag/shams.js"(T, S) {
    var R = require_shams();
    S.exports = function() {
      return R() && !!Symbol.toStringTag;
    };
  }
}), require_is_regex = __commonJS$5({
  "node_modules/is-regex/index.js"(T, S) {
    var R = require_callBound(), k = require_shams2()(), D, L, V, z;
    k && (D = R("Object.prototype.hasOwnProperty"), L = R("RegExp.prototype.exec"), V = {}, W = function() {
      throw V;
    }, z = {
      toString: W,
      valueOf: W
    }, typeof Symbol.toPrimitive == "symbol" && (z[Symbol.toPrimitive] = W));
    var W, U = R("Object.prototype.toString"), q = Object.getOwnPropertyDescriptor, K = "[object RegExp]";
    S.exports = k ? function(J) {
      if (!J || typeof J != "object")
        return !1;
      var Z = q(J, "lastIndex"), X = Z && D(Z, "value");
      if (!X)
        return !1;
      try {
        L(J, z);
      } catch (ee) {
        return ee === V;
      }
    } : function(J) {
      return !J || typeof J != "object" && typeof J != "function" ? !1 : U(J) === K;
    };
  }
}), require_is_function = __commonJS$5({
  "node_modules/is-function/index.js"(T, S) {
    S.exports = k;
    var R = Object.prototype.toString;
    function k(D) {
      if (!D)
        return !1;
      var L = R.call(D);
      return L === "[object Function]" || typeof D == "function" && L !== "[object RegExp]" || typeof window < "u" && (D === window.setTimeout || D === window.alert || D === window.confirm || D === window.prompt);
    }
  }
}), require_is_symbol = __commonJS$5({
  "node_modules/is-symbol/index.js"(T, S) {
    var R = Object.prototype.toString, k = require_has_symbols()();
    k ? (D = Symbol.prototype.toString, L = /^Symbol\(.*\)$/, V = function(W) {
      return typeof W.valueOf() != "symbol" ? !1 : L.test(D.call(W));
    }, S.exports = function(W) {
      if (typeof W == "symbol")
        return !0;
      if (R.call(W) !== "[object Symbol]")
        return !1;
      try {
        return V(W);
      } catch {
        return !1;
      }
    }) : S.exports = function(W) {
      return !1;
    };
    var D, L, V;
  }
}), import_is_regex = __toESM$5(require_is_regex()), import_is_function = __toESM$5(require_is_function()), import_is_symbol = __toESM$5(require_is_symbol());
function isObject$2(T) {
  return T != null && typeof T == "object" && Array.isArray(T) === !1;
}
var freeGlobal = typeof global == "object" && global && global.Object === Object && global, freeGlobal_default = freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root2 = freeGlobal_default || freeSelf || Function("return this")(), root_default = root2, Symbol2 = root_default.Symbol, Symbol_default = Symbol2, objectProto$1 = Object.prototype, hasOwnProperty$2 = objectProto$1.hasOwnProperty, nativeObjectToString = objectProto$1.toString, symToStringTag = Symbol_default ? Symbol_default.toStringTag : void 0;
function getRawTag(T) {
  var S = hasOwnProperty$2.call(T, symToStringTag), R = T[symToStringTag];
  try {
    T[symToStringTag] = void 0;
    var k = !0;
  } catch {
  }
  var D = nativeObjectToString.call(T);
  return k && (S ? T[symToStringTag] = R : delete T[symToStringTag]), D;
}
var getRawTag_default = getRawTag, objectProto2 = Object.prototype, nativeObjectToString2 = objectProto2.toString;
function objectToString$1(T) {
  return nativeObjectToString2.call(T);
}
var objectToString_default = objectToString$1, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag2 = Symbol_default ? Symbol_default.toStringTag : void 0;
function baseGetTag(T) {
  return T == null ? T === void 0 ? undefinedTag : nullTag : symToStringTag2 && symToStringTag2 in Object(T) ? getRawTag_default(T) : objectToString_default(T);
}
var baseGetTag_default = baseGetTag;
function isObjectLike(T) {
  return T != null && typeof T == "object";
}
var isObjectLike_default = isObjectLike, symbolTag = "[object Symbol]";
function isSymbol$1(T) {
  return typeof T == "symbol" || isObjectLike_default(T) && baseGetTag_default(T) == symbolTag;
}
var isSymbol_default = isSymbol$1;
function arrayMap(T, S) {
  for (var R = -1, k = T == null ? 0 : T.length, D = Array(k); ++R < k; )
    D[R] = S(T[R], R, T);
  return D;
}
var arrayMap_default = arrayMap, isArray$6 = Array.isArray, isArray_default = isArray$6, INFINITY$1 = 1 / 0, symbolProto = Symbol_default ? Symbol_default.prototype : void 0, symbolToString$1 = symbolProto ? symbolProto.toString : void 0;
function baseToString(T) {
  if (typeof T == "string")
    return T;
  if (isArray_default(T))
    return arrayMap_default(T, baseToString) + "";
  if (isSymbol_default(T))
    return symbolToString$1 ? symbolToString$1.call(T) : "";
  var S = T + "";
  return S == "0" && 1 / T == -INFINITY$1 ? "-0" : S;
}
var baseToString_default = baseToString;
function isObject2(T) {
  var S = typeof T;
  return T != null && (S == "object" || S == "function");
}
var isObject_default = isObject2, asyncTag = "[object AsyncFunction]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction(T) {
  if (!isObject_default(T))
    return !1;
  var S = baseGetTag_default(T);
  return S == funcTag || S == genTag || S == asyncTag || S == proxyTag;
}
var isFunction_default = isFunction, coreJsData = root_default["__core-js_shared__"], coreJsData_default = coreJsData, maskSrcKey = function() {
  var T = /[^.]+$/.exec(coreJsData_default && coreJsData_default.keys && coreJsData_default.keys.IE_PROTO || "");
  return T ? "Symbol(src)_1." + T : "";
}();
function isMasked(T) {
  return !!maskSrcKey && maskSrcKey in T;
}
var isMasked_default = isMasked, funcProto = Function.prototype, funcToString = funcProto.toString;
function toSource(T) {
  if (T != null) {
    try {
      return funcToString.call(T);
    } catch {
    }
    try {
      return T + "";
    } catch {
    }
  }
  return "";
}
var toSource_default = toSource, reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto2 = Function.prototype, objectProto3 = Object.prototype, funcToString2 = funcProto2.toString, hasOwnProperty2 = objectProto3.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(T) {
  if (!isObject_default(T) || isMasked_default(T))
    return !1;
  var S = isFunction_default(T) ? reIsNative : reIsHostCtor;
  return S.test(toSource_default(T));
}
var baseIsNative_default = baseIsNative;
function getValue$1(T, S) {
  return T?.[S];
}
var getValue_default = getValue$1;
function getNative(T, S) {
  var R = getValue_default(T, S);
  return baseIsNative_default(R) ? R : void 0;
}
var getNative_default = getNative;
function eq(T, S) {
  return T === S || T !== T && S !== S;
}
var eq_default = eq, reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey(T, S) {
  if (isArray_default(T))
    return !1;
  var R = typeof T;
  return R == "number" || R == "symbol" || R == "boolean" || T == null || isSymbol_default(T) ? !0 : reIsPlainProp.test(T) || !reIsDeepProp.test(T) || S != null && T in Object(S);
}
var isKey_default = isKey, nativeCreate = getNative_default(Object, "create"), nativeCreate_default = nativeCreate;
function hashClear() {
  this.__data__ = nativeCreate_default ? nativeCreate_default(null) : {}, this.size = 0;
}
var hashClear_default = hashClear;
function hashDelete(T) {
  var S = this.has(T) && delete this.__data__[T];
  return this.size -= S ? 1 : 0, S;
}
var hashDelete_default = hashDelete, HASH_UNDEFINED = "__lodash_hash_undefined__", objectProto4 = Object.prototype, hasOwnProperty3 = objectProto4.hasOwnProperty;
function hashGet(T) {
  var S = this.__data__;
  if (nativeCreate_default) {
    var R = S[T];
    return R === HASH_UNDEFINED ? void 0 : R;
  }
  return hasOwnProperty3.call(S, T) ? S[T] : void 0;
}
var hashGet_default = hashGet, objectProto5 = Object.prototype, hasOwnProperty4 = objectProto5.hasOwnProperty;
function hashHas(T) {
  var S = this.__data__;
  return nativeCreate_default ? S[T] !== void 0 : hasOwnProperty4.call(S, T);
}
var hashHas_default = hashHas, HASH_UNDEFINED2 = "__lodash_hash_undefined__";
function hashSet(T, S) {
  var R = this.__data__;
  return this.size += this.has(T) ? 0 : 1, R[T] = nativeCreate_default && S === void 0 ? HASH_UNDEFINED2 : S, this;
}
var hashSet_default = hashSet;
function Hash(T) {
  var S = -1, R = T == null ? 0 : T.length;
  for (this.clear(); ++S < R; ) {
    var k = T[S];
    this.set(k[0], k[1]);
  }
}
Hash.prototype.clear = hashClear_default;
Hash.prototype.delete = hashDelete_default;
Hash.prototype.get = hashGet_default;
Hash.prototype.has = hashHas_default;
Hash.prototype.set = hashSet_default;
var Hash_default = Hash;
function listCacheClear() {
  this.__data__ = [], this.size = 0;
}
var listCacheClear_default = listCacheClear;
function assocIndexOf(T, S) {
  for (var R = T.length; R--; )
    if (eq_default(T[R][0], S))
      return R;
  return -1;
}
var assocIndexOf_default = assocIndexOf, arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete(T) {
  var S = this.__data__, R = assocIndexOf_default(S, T);
  if (R < 0)
    return !1;
  var k = S.length - 1;
  return R == k ? S.pop() : splice.call(S, R, 1), --this.size, !0;
}
var listCacheDelete_default = listCacheDelete;
function listCacheGet(T) {
  var S = this.__data__, R = assocIndexOf_default(S, T);
  return R < 0 ? void 0 : S[R][1];
}
var listCacheGet_default = listCacheGet;
function listCacheHas(T) {
  return assocIndexOf_default(this.__data__, T) > -1;
}
var listCacheHas_default = listCacheHas;
function listCacheSet(T, S) {
  var R = this.__data__, k = assocIndexOf_default(R, T);
  return k < 0 ? (++this.size, R.push([T, S])) : R[k][1] = S, this;
}
var listCacheSet_default = listCacheSet;
function ListCache(T) {
  var S = -1, R = T == null ? 0 : T.length;
  for (this.clear(); ++S < R; ) {
    var k = T[S];
    this.set(k[0], k[1]);
  }
}
ListCache.prototype.clear = listCacheClear_default;
ListCache.prototype.delete = listCacheDelete_default;
ListCache.prototype.get = listCacheGet_default;
ListCache.prototype.has = listCacheHas_default;
ListCache.prototype.set = listCacheSet_default;
var ListCache_default = ListCache, Map2 = getNative_default(root_default, "Map"), Map_default = Map2;
function mapCacheClear() {
  this.size = 0, this.__data__ = {
    hash: new Hash_default(),
    map: new (Map_default || ListCache_default)(),
    string: new Hash_default()
  };
}
var mapCacheClear_default = mapCacheClear;
function isKeyable(T) {
  var S = typeof T;
  return S == "string" || S == "number" || S == "symbol" || S == "boolean" ? T !== "__proto__" : T === null;
}
var isKeyable_default = isKeyable;
function getMapData(T, S) {
  var R = T.__data__;
  return isKeyable_default(S) ? R[typeof S == "string" ? "string" : "hash"] : R.map;
}
var getMapData_default = getMapData;
function mapCacheDelete(T) {
  var S = getMapData_default(this, T).delete(T);
  return this.size -= S ? 1 : 0, S;
}
var mapCacheDelete_default = mapCacheDelete;
function mapCacheGet(T) {
  return getMapData_default(this, T).get(T);
}
var mapCacheGet_default = mapCacheGet;
function mapCacheHas(T) {
  return getMapData_default(this, T).has(T);
}
var mapCacheHas_default = mapCacheHas;
function mapCacheSet(T, S) {
  var R = getMapData_default(this, T), k = R.size;
  return R.set(T, S), this.size += R.size == k ? 0 : 1, this;
}
var mapCacheSet_default = mapCacheSet;
function MapCache(T) {
  var S = -1, R = T == null ? 0 : T.length;
  for (this.clear(); ++S < R; ) {
    var k = T[S];
    this.set(k[0], k[1]);
  }
}
MapCache.prototype.clear = mapCacheClear_default;
MapCache.prototype.delete = mapCacheDelete_default;
MapCache.prototype.get = mapCacheGet_default;
MapCache.prototype.has = mapCacheHas_default;
MapCache.prototype.set = mapCacheSet_default;
var MapCache_default = MapCache, FUNC_ERROR_TEXT = "Expected a function";
function memoize$2(T, S) {
  if (typeof T != "function" || S != null && typeof S != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  var R = function() {
    var k = arguments, D = S ? S.apply(this, k) : k[0], L = R.cache;
    if (L.has(D))
      return L.get(D);
    var V = T.apply(this, k);
    return R.cache = L.set(D, V) || L, V;
  };
  return R.cache = new (memoize$2.Cache || MapCache_default)(), R;
}
memoize$2.Cache = MapCache_default;
var memoize_default = memoize$2, MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(T) {
  var S = memoize_default(T, function(k) {
    return R.size === MAX_MEMOIZE_SIZE && R.clear(), k;
  }), R = S.cache;
  return S;
}
var memoizeCapped_default = memoizeCapped, rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar$1 = /\\(\\)?/g, stringToPath$1 = memoizeCapped_default(function(T) {
  var S = [];
  return T.charCodeAt(0) === 46 && S.push(""), T.replace(rePropName$1, function(R, k, D, L) {
    S.push(D ? L.replace(reEscapeChar$1, "$1") : k || R);
  }), S;
}), stringToPath_default = stringToPath$1;
function toString$1(T) {
  return T == null ? "" : baseToString_default(T);
}
var toString_default = toString$1;
function castPath$2(T, S) {
  return isArray_default(T) ? T : isKey_default(T, S) ? [T] : stringToPath_default(toString_default(T));
}
var castPath_default = castPath$2, INFINITY2 = 1 / 0;
function toKey$1(T) {
  if (typeof T == "string" || isSymbol_default(T))
    return T;
  var S = T + "";
  return S == "0" && 1 / T == -INFINITY2 ? "-0" : S;
}
var toKey_default = toKey$1;
function baseGet$1(T, S) {
  S = castPath_default(S, T);
  for (var R = 0, k = S.length; T != null && R < k; )
    T = T[toKey_default(S[R++])];
  return R && R == k ? T : void 0;
}
var baseGet_default = baseGet$1;
function get$1(T, S, R) {
  var k = T == null ? void 0 : baseGet_default(T, S);
  return k === void 0 ? R : k;
}
var get_default = get$1, isObject3 = isObject$2, removeCodeComments = (T) => {
  let S = null, R = !1, k = !1, D = !1, L = "";
  if (T.indexOf("//") >= 0 || T.indexOf("/*") >= 0)
    for (let V = 0; V < T.length; V += 1)
      !S && !R && !k && !D ? T[V] === '"' || T[V] === "'" || T[V] === "`" ? S = T[V] : T[V] === "/" && T[V + 1] === "*" ? R = !0 : T[V] === "/" && T[V + 1] === "/" ? k = !0 : T[V] === "/" && T[V + 1] !== "/" && (D = !0) : (S && (T[V] === S && T[V - 1] !== "\\" || T[V] === `
` && S !== "`") && (S = null), D && (T[V] === "/" && T[V - 1] !== "\\" || T[V] === `
`) && (D = !1), R && T[V - 1] === "/" && T[V - 2] === "*" && (R = !1), k && T[V] === `
` && (k = !1)), !R && !k && (L += T[V]);
  else
    L = T;
  return L;
}, cleanCode = memoize$3(1e4)(
  (T) => removeCodeComments(T).replace(/\n\s*/g, "").trim()
), convertShorthandMethods = function(S, R) {
  const k = R.slice(0, R.indexOf("{")), D = R.slice(R.indexOf("{"));
  if (k.includes("=>") || k.includes("function"))
    return R;
  let L = k;
  return L = L.replace(S, "function"), L + D;
}, dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/, isJSON = (T) => T.match(/^[\[\{\"\}].*[\]\}\"]$/);
function convertUnconventionalData(T) {
  if (!isObject3(T))
    return T;
  let S = T, R = !1;
  return typeof Event < "u" && T instanceof Event && (S = extractEventHiddenProperties(S), R = !0), S = Object.keys(S).reduce((k, D) => {
    try {
      S[D] && S[D].toJSON, k[D] = S[D];
    } catch {
      R = !0;
    }
    return k;
  }, {}), R ? S : T;
}
var replacer = function(S) {
  let R, k, D, L;
  return function(z, W) {
    try {
      if (z === "")
        return L = [], R = /* @__PURE__ */ new Map([[W, "[]"]]), k = /* @__PURE__ */ new Map(), D = [], W;
      const U = k.get(this) || this;
      for (; D.length && U !== D[0]; )
        D.shift(), L.pop();
      if (typeof W == "boolean")
        return W;
      if (W === void 0)
        return S.allowUndefined ? "_undefined_" : void 0;
      if (W === null)
        return null;
      if (typeof W == "number")
        return W === -1 / 0 ? "_-Infinity_" : W === 1 / 0 ? "_Infinity_" : Number.isNaN(W) ? "_NaN_" : W;
      if (typeof W == "bigint")
        return `_bigint_${W.toString()}`;
      if (typeof W == "string")
        return dateFormat.test(W) ? S.allowDate ? `_date_${W}` : void 0 : W;
      if ((0, import_is_regex.default)(W))
        return S.allowRegExp ? `_regexp_${W.flags}|${W.source}` : void 0;
      if ((0, import_is_function.default)(W)) {
        if (!S.allowFunction)
          return;
        const { name: K } = W, Y = W.toString();
        return Y.match(
          /(\[native code\]|WEBPACK_IMPORTED_MODULE|__webpack_exports__|__webpack_require__)/
        ) ? `_function_${K}|${(() => {
        }).toString()}` : `_function_${K}|${cleanCode(convertShorthandMethods(z, Y))}`;
      }
      if ((0, import_is_symbol.default)(W)) {
        if (!S.allowSymbol)
          return;
        const K = Symbol.keyFor(W);
        return K !== void 0 ? `_gsymbol_${K}` : `_symbol_${W.toString().slice(7, -1)}`;
      }
      if (D.length >= S.maxDepth)
        return Array.isArray(W) ? `[Array(${W.length})]` : "[Object]";
      if (W === this)
        return `_duplicate_${JSON.stringify(L)}`;
      if (W instanceof Error && S.allowError)
        return {
          __isConvertedError__: !0,
          errorProperties: {
            ...W.cause ? { cause: W.cause } : {},
            ...W,
            name: W.name,
            message: W.message,
            stack: W.stack,
            "_constructor-name_": W.constructor.name
          }
        };
      if (W.constructor && W.constructor.name && W.constructor.name !== "Object" && !Array.isArray(W) && !S.allowClass)
        return;
      const q = R.get(W);
      if (!q) {
        const K = Array.isArray(W) ? W : convertUnconventionalData(W);
        if (W.constructor && W.constructor.name && W.constructor.name !== "Object" && !Array.isArray(W) && S.allowClass)
          try {
            Object.assign(K, { "_constructor-name_": W.constructor.name });
          } catch {
          }
        return L.push(z), D.unshift(K), R.set(W, JSON.stringify(L)), W !== K && k.set(W, K), K;
      }
      return `_duplicate_${q}`;
    } catch {
      return;
    }
  };
}, reviver2 = function reviver(options) {
  const refs = [];
  let root;
  return function revive(key, value) {
    if (key === "" && (root = value, refs.forEach(({ target: T, container: S, replacement: R }) => {
      const k = isJSON(R) ? JSON.parse(R) : R.split(".");
      k.length === 0 ? S[T] = root : S[T] = get_default(root, k);
    })), key === "_constructor-name_")
      return value;
    if (isObject3(value) && value.__isConvertedError__) {
      const { message: T, ...S } = value.errorProperties, R = new Error(T);
      return Object.assign(R, S), R;
    }
    if (isObject3(value) && value["_constructor-name_"] && options.allowFunction) {
      const T = value["_constructor-name_"];
      if (T !== "Object") {
        const S = new Function(`return function ${T.replace(/[^a-zA-Z0-9$_]+/g, "")}(){}`)();
        Object.setPrototypeOf(value, new S());
      }
      return delete value["_constructor-name_"], value;
    }
    if (typeof value == "string" && value.startsWith("_function_") && options.allowFunction) {
      const [, name, source] = value.match(/_function_([^|]*)\|(.*)/) || [], sourceSanitized = source.replace(/[(\(\))|\\| |\]|`]*$/, "");
      if (!options.lazyEval)
        return eval(`(${sourceSanitized})`);
      const result = (...args) => {
        const f = eval(`(${sourceSanitized})`);
        return f(...args);
      };
      return Object.defineProperty(result, "toString", {
        value: () => sourceSanitized
      }), Object.defineProperty(result, "name", {
        value: name
      }), result;
    }
    if (typeof value == "string" && value.startsWith("_regexp_") && options.allowRegExp) {
      const [, T, S] = value.match(/_regexp_([^|]*)\|(.*)/) || [];
      return new RegExp(S, T);
    }
    return typeof value == "string" && value.startsWith("_date_") && options.allowDate ? new Date(value.replace("_date_", "")) : typeof value == "string" && value.startsWith("_duplicate_") ? (refs.push({ target: key, container: this, replacement: value.replace(/^_duplicate_/, "") }), null) : typeof value == "string" && value.startsWith("_symbol_") && options.allowSymbol ? Symbol(value.replace("_symbol_", "")) : typeof value == "string" && value.startsWith("_gsymbol_") && options.allowSymbol ? Symbol.for(value.replace("_gsymbol_", "")) : typeof value == "string" && value === "_-Infinity_" ? -1 / 0 : typeof value == "string" && value === "_Infinity_" ? 1 / 0 : typeof value == "string" && value === "_NaN_" ? NaN : typeof value == "string" && value.startsWith("_bigint_") && typeof BigInt == "function" ? BigInt(value.replace("_bigint_", "")) : value;
  };
}, defaultOptions = {
  maxDepth: 10,
  space: void 0,
  allowFunction: !0,
  allowRegExp: !0,
  allowDate: !0,
  allowClass: !0,
  allowError: !0,
  allowUndefined: !0,
  allowSymbol: !0,
  lazyEval: !0
}, stringify$4 = (T, S = {}) => {
  const R = { ...defaultOptions, ...S };
  return JSON.stringify(convertUnconventionalData(T), replacer(R), S.space);
}, mutator = () => {
  const T = /* @__PURE__ */ new Map();
  return function S(R) {
    isObject3(R) && Object.entries(R).forEach(([k, D]) => {
      D === "_undefined_" ? R[k] = void 0 : T.get(D) || (T.set(D, !0), S(D));
    }), Array.isArray(R) && R.forEach((k, D) => {
      k === "_undefined_" ? (T.set(k, !0), R[D] = void 0) : T.get(k) || (T.set(k, !0), S(k));
    });
  };
}, parse$5 = (T, S = {}) => {
  const R = { ...defaultOptions, ...S }, k = JSON.parse(T, reviver2(R));
  return mutator()(k), k;
};
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
/**
 * @license
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="es" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var isMulti = (T) => T.transports !== void 0, generateRandomId = () => Math.random().toString(16).slice(2), Channel = class {
  constructor(T = {}) {
    this.sender = generateRandomId(), this.events = {}, this.data = {}, this.transports = [], this.isAsync = T.async || !1, isMulti(T) ? (this.transports = T.transports || [], this.transports.forEach((S) => {
      S.setHandler((R) => this.handleEvent(R));
    })) : this.transports = T.transport ? [T.transport] : [], this.transports.forEach((S) => {
      S.setHandler((R) => this.handleEvent(R));
    });
  }
  get hasTransport() {
    return this.transports.length > 0;
  }
  addListener(T, S) {
    this.events[T] = this.events[T] || [], this.events[T].push(S);
  }
  emit(T, ...S) {
    let R = { type: T, args: S, from: this.sender }, k = {};
    S.length >= 1 && S[0] && S[0].options && (k = S[0].options);
    let D = () => {
      this.transports.forEach((L) => {
        L.send(R, k);
      }), this.handleEvent(R);
    };
    this.isAsync ? setImmediate(D) : D();
  }
  last(T) {
    return this.data[T];
  }
  eventNames() {
    return Object.keys(this.events);
  }
  listenerCount(T) {
    let S = this.listeners(T);
    return S ? S.length : 0;
  }
  listeners(T) {
    return this.events[T] || void 0;
  }
  once(T, S) {
    let R = this.onceListener(T, S);
    this.addListener(T, R);
  }
  removeAllListeners(T) {
    T ? this.events[T] && delete this.events[T] : this.events = {};
  }
  removeListener(T, S) {
    let R = this.listeners(T);
    R && (this.events[T] = R.filter((k) => k !== S));
  }
  on(T, S) {
    this.addListener(T, S);
  }
  off(T, S) {
    this.removeListener(T, S);
  }
  handleEvent(T) {
    let S = this.listeners(T.type);
    S && S.length && S.forEach((R) => {
      R.apply(T, T.args);
    }), this.data[T.type] = T.args;
  }
  onceListener(T, S) {
    let R = (...k) => (this.removeListener(T, R), S(...k));
    return R;
  }
}, baseAssignValue$1 = _baseAssignValue, baseForOwn = _baseForOwn, baseIteratee$1 = _baseIteratee;
function mapValues(T, S) {
  var R = {};
  return S = baseIteratee$1(S), baseForOwn(T, function(k, D, L) {
    baseAssignValue$1(R, D, S(k, D, L));
  }), R;
}
var mapValues_1 = mapValues;
const mapValues$1 = /* @__PURE__ */ getDefaultExportFromCjs(mapValues_1);
var assignValue = _assignValue, castPath$1 = _castPath, isIndex = _isIndex, isObject$1 = isObject_1, toKey = _toKey;
function baseSet$1(T, S, R, k) {
  if (!isObject$1(T))
    return T;
  S = castPath$1(S, T);
  for (var D = -1, L = S.length, V = L - 1, z = T; z != null && ++D < L; ) {
    var W = toKey(S[D]), U = R;
    if (W === "__proto__" || W === "constructor" || W === "prototype")
      return T;
    if (D != V) {
      var q = z[W];
      U = k ? k(q, W, z) : void 0, U === void 0 && (U = isObject$1(q) ? q : isIndex(S[D + 1]) ? [] : {});
    }
    assignValue(z, W, U), z = z[W];
  }
  return T;
}
var _baseSet = baseSet$1, baseGet = _baseGet, baseSet = _baseSet, castPath = _castPath;
function basePickBy$1(T, S, R) {
  for (var k = -1, D = S.length, L = {}; ++k < D; ) {
    var V = S[k], z = baseGet(T, V);
    R(z, V) && baseSet(L, castPath(V, T), z);
  }
  return L;
}
var _basePickBy = basePickBy$1, basePickBy = _basePickBy, hasIn = hasIn_1;
function basePick$1(T, S) {
  return basePickBy(T, S, function(R, k) {
    return hasIn(T, k);
  });
}
var _basePick = basePick$1, Symbol$1 = _Symbol, isArguments$2 = isArguments_1, isArray$5 = isArray_1, spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable$1(T) {
  return isArray$5(T) || isArguments$2(T) || !!(spreadableSymbol && T && T[spreadableSymbol]);
}
var _isFlattenable = isFlattenable$1, arrayPush = _arrayPush, isFlattenable = _isFlattenable;
function baseFlatten$1(T, S, R, k, D) {
  var L = -1, V = T.length;
  for (R || (R = isFlattenable), D || (D = []); ++L < V; ) {
    var z = T[L];
    S > 0 && R(z) ? S > 1 ? baseFlatten$1(z, S - 1, R, k, D) : arrayPush(D, z) : k || (D[D.length] = z);
  }
  return D;
}
var _baseFlatten = baseFlatten$1, baseFlatten = _baseFlatten;
function flatten$1(T) {
  var S = T == null ? 0 : T.length;
  return S ? baseFlatten(T, 1) : [];
}
var flatten_1 = flatten$1, flatten = flatten_1, overRest = _overRest, setToString = _setToString;
function flatRest$1(T) {
  return setToString(overRest(T, void 0, flatten), T + "");
}
var _flatRest = flatRest$1, basePick = _basePick, flatRest = _flatRest, pick$1 = flatRest(function(T, S) {
  return T == null ? {} : basePick(T, S);
}), pick_1 = pick$1;
const pick$2 = /* @__PURE__ */ getDefaultExportFromCjs(pick_1);
function dedent$1(T) {
  for (var S = [], R = 1; R < arguments.length; R++)
    S[R - 1] = arguments[R];
  var k = Array.from(typeof T == "string" ? [T] : T);
  k[k.length - 1] = k[k.length - 1].replace(/\r?\n([\t ]*)$/, "");
  var D = k.reduce(function(z, W) {
    var U = W.match(/\n([\t ]+|(?!\s).)/g);
    return U ? z.concat(U.map(function(q) {
      var K, Y;
      return (Y = (K = q.match(/[\t ]/g)) === null || K === void 0 ? void 0 : K.length) !== null && Y !== void 0 ? Y : 0;
    })) : z;
  }, []);
  if (D.length) {
    var L = new RegExp(`
[	 ]{` + Math.min.apply(Math, D) + "}", "g");
    k = k.map(function(z) {
      return z.replace(L, `
`);
    });
  }
  k[0] = k[0].replace(/^\r?\n/, "");
  var V = k[0];
  return S.forEach(function(z, W) {
    var U = V.match(/(?:^|\n)( *)$/), q = U ? U[1] : "", K = z;
    typeof z == "string" && z.includes(`
`) && (K = String(z).split(`
`).map(function(Y, J) {
      return J === 0 ? Y : "" + q + Y;
    }).join(`
`)), V += K + k[W + 1];
  }), V;
}
var has$5 = Object.prototype.hasOwnProperty;
function find$1(T, S, R) {
  for (R of T.keys())
    if (dequal$1(R, S)) return R;
}
function dequal$1(T, S) {
  var R, k, D;
  if (T === S) return !0;
  if (T && S && (R = T.constructor) === S.constructor) {
    if (R === Date) return T.getTime() === S.getTime();
    if (R === RegExp) return T.toString() === S.toString();
    if (R === Array) {
      if ((k = T.length) === S.length)
        for (; k-- && dequal$1(T[k], S[k]); ) ;
      return k === -1;
    }
    if (R === Set) {
      if (T.size !== S.size)
        return !1;
      for (k of T)
        if (D = k, D && typeof D == "object" && (D = find$1(S, D), !D) || !S.has(D)) return !1;
      return !0;
    }
    if (R === Map) {
      if (T.size !== S.size)
        return !1;
      for (k of T)
        if (D = k[0], D && typeof D == "object" && (D = find$1(S, D), !D) || !dequal$1(k[1], S.get(D)))
          return !1;
      return !0;
    }
    if (R === ArrayBuffer)
      T = new Uint8Array(T), S = new Uint8Array(S);
    else if (R === DataView) {
      if ((k = T.byteLength) === S.byteLength)
        for (; k-- && T.getInt8(k) === S.getInt8(k); ) ;
      return k === -1;
    }
    if (ArrayBuffer.isView(T)) {
      if ((k = T.byteLength) === S.byteLength)
        for (; k-- && T[k] === S[k]; ) ;
      return k === -1;
    }
    if (!R || typeof T == "object") {
      k = 0;
      for (R in T)
        if (has$5.call(T, R) && ++k && !has$5.call(S, R) || !(R in S) || !dequal$1(T[R], S[R])) return !1;
      return Object.keys(S).length === k;
    }
  }
  return T !== T && S !== S;
}
var C = Object.create, u = Object.defineProperty, B = Object.getOwnPropertyDescriptor, F = Object.getOwnPropertyNames, h$1 = Object.getPrototypeOf, w$1 = Object.prototype.hasOwnProperty, v$1 = (T, S) => () => (S || T((S = { exports: {} }).exports, S), S.exports), E = (T, S, R, k) => {
  if (S && typeof S == "object" || typeof S == "function") for (let D of F(S)) !w$1.call(T, D) && D !== R && u(T, D, { get: () => S[D], enumerable: !(k = B(S, D)) || k.enumerable });
  return T;
}, I = (T, S, R) => (R = T != null ? C(h$1(T)) : {}, E(!T || !T.__esModule ? u(R, "default", { value: T, enumerable: !0 }) : R, T)), x = v$1((T) => {
  Object.defineProperty(T, "__esModule", { value: !0 }), T.isEqual = /* @__PURE__ */ function() {
    var S = Object.prototype.toString, R = Object.getPrototypeOf, k = Object.getOwnPropertySymbols ? function(D) {
      return Object.keys(D).concat(Object.getOwnPropertySymbols(D));
    } : Object.keys;
    return function(D, L) {
      return function V(z, W, U) {
        var q, K, Y, J = S.call(z), Z = S.call(W);
        if (z === W) return !0;
        if (z == null || W == null) return !1;
        if (U.indexOf(z) > -1 && U.indexOf(W) > -1) return !0;
        if (U.push(z, W), J != Z || (q = k(z), K = k(W), q.length != K.length || q.some(function(X) {
          return !V(z[X], W[X], U);
        }))) return !1;
        switch (J.slice(8, -1)) {
          case "Symbol":
            return z.valueOf() == W.valueOf();
          case "Date":
          case "Number":
            return +z == +W || +z != +z && +W != +W;
          case "RegExp":
          case "Function":
          case "String":
          case "Boolean":
            return "" + z == "" + W;
          case "Set":
          case "Map":
            q = z.entries(), K = W.entries();
            do
              if (!V((Y = q.next()).value, K.next().value, U)) return !1;
            while (!Y.done);
            return !0;
          case "ArrayBuffer":
            z = new Uint8Array(z), W = new Uint8Array(W);
          case "DataView":
            z = new Uint8Array(z.buffer), W = new Uint8Array(W.buffer);
          case "Float32Array":
          case "Float64Array":
          case "Int8Array":
          case "Int16Array":
          case "Int32Array":
          case "Uint8Array":
          case "Uint16Array":
          case "Uint32Array":
          case "Uint8ClampedArray":
          case "Arguments":
          case "Array":
            if (z.length != W.length) return !1;
            for (Y = 0; Y < z.length; Y++) if ((Y in z || Y in W) && (Y in z != Y in W || !V(z[Y], W[Y], U))) return !1;
            return !0;
          case "Object":
            return V(R(z), R(W), U);
          default:
            return !1;
        }
      }(D, L, []);
    };
  }();
});
I(x());
var O = (T) => T.toLowerCase().replace(/[ ’–—―′¿'`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "-").replace(/-+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), m = (T, S) => {
  let R = O(T);
  if (R === "") throw new Error(`Invalid ${S} '${T}', must include alphanumeric characters`);
  return R;
}, G = (T, S) => `${m(T, "kind")}${S ? `--${m(S, "name")}` : ""}`, browser = deprecate;
function deprecate(T, S) {
  if (config$2("noDeprecation"))
    return T;
  var R = !1;
  function k() {
    if (!R) {
      if (config$2("throwDeprecation"))
        throw new Error(S);
      config$2("traceDeprecation") ? console.trace(S) : console.warn(S), R = !0;
    }
    return T.apply(this, arguments);
  }
  return k;
}
function config$2(T) {
  try {
    if (!commonjsGlobal.localStorage) return !1;
  } catch {
    return !1;
  }
  var S = commonjsGlobal.localStorage[T];
  return S == null ? !1 : String(S).toLowerCase() === "true";
}
const deprecate$1 = /* @__PURE__ */ getDefaultExportFromCjs(browser);
var esErrors = Error, _eval = EvalError, range = RangeError, ref = ReferenceError, syntax = SyntaxError, type = TypeError, uri = URIError, shams$1 = function T() {
  if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
    return !1;
  if (typeof Symbol.iterator == "symbol")
    return !0;
  var S = {}, R = Symbol("test"), k = Object(R);
  if (typeof R == "string" || Object.prototype.toString.call(R) !== "[object Symbol]" || Object.prototype.toString.call(k) !== "[object Symbol]")
    return !1;
  var D = 42;
  S[R] = D;
  for (R in S)
    return !1;
  if (typeof Object.keys == "function" && Object.keys(S).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(S).length !== 0)
    return !1;
  var L = Object.getOwnPropertySymbols(S);
  if (L.length !== 1 || L[0] !== R || !Object.prototype.propertyIsEnumerable.call(S, R))
    return !1;
  if (typeof Object.getOwnPropertyDescriptor == "function") {
    var V = Object.getOwnPropertyDescriptor(S, R);
    if (V.value !== D || V.enumerable !== !0)
      return !1;
  }
  return !0;
}, origSymbol = typeof Symbol < "u" && Symbol, hasSymbolSham = shams$1, hasSymbols$3 = function T() {
  return typeof origSymbol != "function" || typeof Symbol != "function" || typeof origSymbol("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : hasSymbolSham();
}, test = {
  __proto__: null,
  foo: {}
}, $Object = Object, hasProto$1 = function T() {
  return { __proto__: test }.foo === test.foo && !(test instanceof $Object);
}, ERROR_MESSAGE = "Function.prototype.bind called on incompatible ", toStr$5 = Object.prototype.toString, max$2 = Math.max, funcType = "[object Function]", concatty = function T(S, R) {
  for (var k = [], D = 0; D < S.length; D += 1)
    k[D] = S[D];
  for (var L = 0; L < R.length; L += 1)
    k[L + S.length] = R[L];
  return k;
}, slicy = function T(S, R) {
  for (var k = [], D = R, L = 0; D < S.length; D += 1, L += 1)
    k[L] = S[D];
  return k;
}, joiny = function(T, S) {
  for (var R = "", k = 0; k < T.length; k += 1)
    R += T[k], k + 1 < T.length && (R += S);
  return R;
}, implementation$7 = function T(S) {
  var R = this;
  if (typeof R != "function" || toStr$5.apply(R) !== funcType)
    throw new TypeError(ERROR_MESSAGE + R);
  for (var k = slicy(arguments, 1), D, L = function() {
    if (this instanceof D) {
      var q = R.apply(
        this,
        concatty(k, arguments)
      );
      return Object(q) === q ? q : this;
    }
    return R.apply(
      S,
      concatty(k, arguments)
    );
  }, V = max$2(0, R.length - k.length), z = [], W = 0; W < V; W++)
    z[W] = "$" + W;
  if (D = Function("binder", "return function (" + joiny(z, ",") + "){ return binder.apply(this,arguments); }")(L), R.prototype) {
    var U = function() {
    };
    U.prototype = R.prototype, D.prototype = new U(), U.prototype = null;
  }
  return D;
}, implementation$6 = implementation$7, functionBind = Function.prototype.bind || implementation$6, call = Function.prototype.call, $hasOwn = Object.prototype.hasOwnProperty, bind$1 = functionBind, hasown = bind$1.call(call, $hasOwn), undefined$1, $Error = esErrors, $EvalError = _eval, $RangeError = range, $ReferenceError = ref, $SyntaxError$1 = syntax, $TypeError$3 = type, $URIError = uri, $Function = Function, getEvalledConstructor = function(T) {
  try {
    return $Function('"use strict"; return (' + T + ").constructor;")();
  } catch {
  }
}, $gOPD$1 = Object.getOwnPropertyDescriptor;
if ($gOPD$1)
  try {
    $gOPD$1({}, "");
  } catch {
    $gOPD$1 = null;
  }
var throwTypeError = function() {
  throw new $TypeError$3();
}, ThrowTypeError = $gOPD$1 ? function() {
  try {
    return arguments.callee, throwTypeError;
  } catch {
    try {
      return $gOPD$1(arguments, "callee").get;
    } catch {
      return throwTypeError;
    }
  }
}() : throwTypeError, hasSymbols$2 = hasSymbols$3(), hasProto = hasProto$1(), getProto$1 = Object.getPrototypeOf || (hasProto ? function(T) {
  return T.__proto__;
} : null), needsEval = {}, TypedArray = typeof Uint8Array > "u" || !getProto$1 ? undefined$1 : getProto$1(Uint8Array), INTRINSICS = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols$2 && getProto$1 ? getProto$1([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics > "u" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt > "u" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": $Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": $EvalError,
  "%Float32Array%": typeof Float32Array > "u" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array > "u" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols$2 && getProto$1 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON == "object" ? JSON : undefined$1,
  "%Map%": typeof Map > "u" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !hasSymbols$2 || !getProto$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy > "u" ? undefined$1 : Proxy,
  "%RangeError%": $RangeError,
  "%ReferenceError%": $ReferenceError,
  "%Reflect%": typeof Reflect > "u" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !hasSymbols$2 || !getProto$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols$2 && getProto$1 ? getProto$1(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols$2 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError$1,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$3,
  "%Uint8Array%": typeof Uint8Array > "u" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? undefined$1 : Uint32Array,
  "%URIError%": $URIError,
  "%WeakMap%": typeof WeakMap > "u" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? undefined$1 : WeakSet
};
if (getProto$1)
  try {
    null.error;
  } catch (T) {
    var errorProto = getProto$1(getProto$1(T));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
var doEval = function T(S) {
  var R;
  if (S === "%AsyncFunction%")
    R = getEvalledConstructor("async function () {}");
  else if (S === "%GeneratorFunction%")
    R = getEvalledConstructor("function* () {}");
  else if (S === "%AsyncGeneratorFunction%")
    R = getEvalledConstructor("async function* () {}");
  else if (S === "%AsyncGenerator%") {
    var k = T("%AsyncGeneratorFunction%");
    k && (R = k.prototype);
  } else if (S === "%AsyncIteratorPrototype%") {
    var D = T("%AsyncGenerator%");
    D && getProto$1 && (R = getProto$1(D.prototype));
  }
  return INTRINSICS[S] = R, R;
}, LEGACY_ALIASES = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, bind = functionBind, hasOwn$2 = hasown, $concat$1 = bind.call(Function.call, Array.prototype.concat), $spliceApply = bind.call(Function.apply, Array.prototype.splice), $replace$1 = bind.call(Function.call, String.prototype.replace), $strSlice = bind.call(Function.call, String.prototype.slice), $exec = bind.call(Function.call, RegExp.prototype.exec), rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, reEscapeChar = /\\(\\)?/g, stringToPath = function T(S) {
  var R = $strSlice(S, 0, 1), k = $strSlice(S, -1);
  if (R === "%" && k !== "%")
    throw new $SyntaxError$1("invalid intrinsic syntax, expected closing `%`");
  if (k === "%" && R !== "%")
    throw new $SyntaxError$1("invalid intrinsic syntax, expected opening `%`");
  var D = [];
  return $replace$1(S, rePropName, function(L, V, z, W) {
    D[D.length] = z ? $replace$1(W, reEscapeChar, "$1") : V || L;
  }), D;
}, getBaseIntrinsic = function T(S, R) {
  var k = S, D;
  if (hasOwn$2(LEGACY_ALIASES, k) && (D = LEGACY_ALIASES[k], k = "%" + D[0] + "%"), hasOwn$2(INTRINSICS, k)) {
    var L = INTRINSICS[k];
    if (L === needsEval && (L = doEval(k)), typeof L > "u" && !R)
      throw new $TypeError$3("intrinsic " + S + " exists, but is not available. Please file an issue!");
    return {
      alias: D,
      name: k,
      value: L
    };
  }
  throw new $SyntaxError$1("intrinsic " + S + " does not exist!");
}, getIntrinsic = function T(S, R) {
  if (typeof S != "string" || S.length === 0)
    throw new $TypeError$3("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof R != "boolean")
    throw new $TypeError$3('"allowMissing" argument must be a boolean');
  if ($exec(/^%?[^%]*%?$/, S) === null)
    throw new $SyntaxError$1("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var k = stringToPath(S), D = k.length > 0 ? k[0] : "", L = getBaseIntrinsic("%" + D + "%", R), V = L.name, z = L.value, W = !1, U = L.alias;
  U && (D = U[0], $spliceApply(k, $concat$1([0, 1], U)));
  for (var q = 1, K = !0; q < k.length; q += 1) {
    var Y = k[q], J = $strSlice(Y, 0, 1), Z = $strSlice(Y, -1);
    if ((J === '"' || J === "'" || J === "`" || Z === '"' || Z === "'" || Z === "`") && J !== Z)
      throw new $SyntaxError$1("property names with quotes must have matching quotes");
    if ((Y === "constructor" || !K) && (W = !0), D += "." + Y, V = "%" + D + "%", hasOwn$2(INTRINSICS, V))
      z = INTRINSICS[V];
    else if (z != null) {
      if (!(Y in z)) {
        if (!R)
          throw new $TypeError$3("base intrinsic for " + S + " exists, but the property is not available.");
        return;
      }
      if ($gOPD$1 && q + 1 >= k.length) {
        var X = $gOPD$1(z, Y);
        K = !!X, K && "get" in X && !("originalValue" in X.get) ? z = X.get : z = z[Y];
      } else
        K = hasOwn$2(z, Y), z = z[Y];
      K && !W && (INTRINSICS[V] = z);
    }
  }
  return z;
}, callBind$2 = { exports: {} }, esDefineProperty, hasRequiredEsDefineProperty;
function requireEsDefineProperty() {
  if (hasRequiredEsDefineProperty) return esDefineProperty;
  hasRequiredEsDefineProperty = 1;
  var T = getIntrinsic, S = T("%Object.defineProperty%", !0) || !1;
  if (S)
    try {
      S({}, "a", { value: 1 });
    } catch {
      S = !1;
    }
  return esDefineProperty = S, esDefineProperty;
}
var GetIntrinsic$3 = getIntrinsic, $gOPD = GetIntrinsic$3("%Object.getOwnPropertyDescriptor%", !0);
if ($gOPD)
  try {
    $gOPD([], "length");
  } catch {
    $gOPD = null;
  }
var gopd$1 = $gOPD, $defineProperty$1 = requireEsDefineProperty(), $SyntaxError = syntax, $TypeError$2 = type, gopd = gopd$1, defineDataProperty = function T(S, R, k) {
  if (!S || typeof S != "object" && typeof S != "function")
    throw new $TypeError$2("`obj` must be an object or a function`");
  if (typeof R != "string" && typeof R != "symbol")
    throw new $TypeError$2("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new $TypeError$2("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new $TypeError$2("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new $TypeError$2("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new $TypeError$2("`loose`, if provided, must be a boolean");
  var D = arguments.length > 3 ? arguments[3] : null, L = arguments.length > 4 ? arguments[4] : null, V = arguments.length > 5 ? arguments[5] : null, z = arguments.length > 6 ? arguments[6] : !1, W = !!gopd && gopd(S, R);
  if ($defineProperty$1)
    $defineProperty$1(S, R, {
      configurable: V === null && W ? W.configurable : !V,
      enumerable: D === null && W ? W.enumerable : !D,
      value: k,
      writable: L === null && W ? W.writable : !L
    });
  else if (z || !D && !L && !V)
    S[R] = k;
  else
    throw new $SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, $defineProperty = requireEsDefineProperty(), hasPropertyDescriptors = function T() {
  return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function T() {
  if (!$defineProperty)
    return null;
  try {
    return $defineProperty([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors, GetIntrinsic$2 = getIntrinsic, define = defineDataProperty, hasDescriptors = hasPropertyDescriptors_1(), gOPD$1 = gopd$1, $TypeError$1 = type, $floor$1 = GetIntrinsic$2("%Math.floor%"), setFunctionLength = function T(S, R) {
  if (typeof S != "function")
    throw new $TypeError$1("`fn` is not a function");
  if (typeof R != "number" || R < 0 || R > 4294967295 || $floor$1(R) !== R)
    throw new $TypeError$1("`length` must be a positive 32-bit integer");
  var k = arguments.length > 2 && !!arguments[2], D = !0, L = !0;
  if ("length" in S && gOPD$1) {
    var V = gOPD$1(S, "length");
    V && !V.configurable && (D = !1), V && !V.writable && (L = !1);
  }
  return (D || L || !k) && (hasDescriptors ? define(
    /** @type {Parameters<define>[0]} */
    S,
    "length",
    R,
    !0,
    !0
  ) : define(
    /** @type {Parameters<define>[0]} */
    S,
    "length",
    R
  )), S;
};
(function(T) {
  var S = functionBind, R = getIntrinsic, k = setFunctionLength, D = type, L = R("%Function.prototype.apply%"), V = R("%Function.prototype.call%"), z = R("%Reflect.apply%", !0) || S.call(V, L), W = requireEsDefineProperty(), U = R("%Math.max%");
  T.exports = function(Y) {
    if (typeof Y != "function")
      throw new D("a function is required");
    var J = z(S, V, arguments);
    return k(
      J,
      1 + U(0, Y.length - (arguments.length - 1)),
      !0
    );
  };
  var q = function() {
    return z(S, L, arguments);
  };
  W ? W(T.exports, "apply", { value: q }) : T.exports.apply = q;
})(callBind$2);
var callBindExports = callBind$2.exports, GetIntrinsic$1 = getIntrinsic, callBind$1 = callBindExports, $indexOf$1 = callBind$1(GetIntrinsic$1("String.prototype.indexOf")), callBound$4 = function T(S, R) {
  var k = GetIntrinsic$1(S, !!R);
  return typeof k == "function" && $indexOf$1(S, ".prototype.") > -1 ? callBind$1(k) : k;
};
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$0$1 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasMap = typeof Map == "function" && Map.prototype, mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get == "function" ? mapSizeDescriptor.get : null, mapForEach = hasMap && Map.prototype.forEach, hasSet = typeof Set == "function" && Set.prototype, setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get == "function" ? setSizeDescriptor.get : null, setForEach = hasSet && Set.prototype.forEach, hasWeakMap = typeof WeakMap == "function" && WeakMap.prototype, weakMapHas = hasWeakMap ? WeakMap.prototype.has : null, hasWeakSet = typeof WeakSet == "function" && WeakSet.prototype, weakSetHas = hasWeakSet ? WeakSet.prototype.has : null, hasWeakRef = typeof WeakRef == "function" && WeakRef.prototype, weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null, booleanValueOf = Boolean.prototype.valueOf, objectToString = Object.prototype.toString, functionToString = Function.prototype.toString, $match = String.prototype.match, $slice$1 = String.prototype.slice, $replace = String.prototype.replace, $toUpperCase = String.prototype.toUpperCase, $toLowerCase = String.prototype.toLowerCase, $test = RegExp.prototype.test, $concat = Array.prototype.concat, $join = Array.prototype.join, $arrSlice = Array.prototype.slice, $floor = Math.floor, bigIntValueOf = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, gOPS = Object.getOwnPropertySymbols, symToString = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, hasShammedSymbols = typeof Symbol == "function" && typeof Symbol.iterator == "object", toStringTag = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols || !0) ? Symbol.toStringTag : null, isEnumerable = Object.prototype.propertyIsEnumerable, gPO = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(T) {
  return T.__proto__;
} : null);
function addNumericSeparator(T, S) {
  if (T === 1 / 0 || T === -1 / 0 || T !== T || T && T > -1e3 && T < 1e3 || $test.call(/e/, S))
    return S;
  var R = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof T == "number") {
    var k = T < 0 ? -$floor(-T) : $floor(T);
    if (k !== T) {
      var D = String(k), L = $slice$1.call(S, D.length + 1);
      return $replace.call(D, R, "$&_") + "." + $replace.call($replace.call(L, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return $replace.call(S, R, "$&_");
}
var utilInspect = require$$0$1, inspectCustom = utilInspect.custom, inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null, objectInspect = function T(S, R, k, D) {
  var L = R || {};
  if (has$4(L, "quoteStyle") && L.quoteStyle !== "single" && L.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (has$4(L, "maxStringLength") && (typeof L.maxStringLength == "number" ? L.maxStringLength < 0 && L.maxStringLength !== 1 / 0 : L.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var V = has$4(L, "customInspect") ? L.customInspect : !0;
  if (typeof V != "boolean" && V !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (has$4(L, "indent") && L.indent !== null && L.indent !== "	" && !(parseInt(L.indent, 10) === L.indent && L.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (has$4(L, "numericSeparator") && typeof L.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var z = L.numericSeparator;
  if (typeof S > "u")
    return "undefined";
  if (S === null)
    return "null";
  if (typeof S == "boolean")
    return S ? "true" : "false";
  if (typeof S == "string")
    return inspectString(S, L);
  if (typeof S == "number") {
    if (S === 0)
      return 1 / 0 / S > 0 ? "0" : "-0";
    var W = String(S);
    return z ? addNumericSeparator(S, W) : W;
  }
  if (typeof S == "bigint") {
    var U = String(S) + "n";
    return z ? addNumericSeparator(S, U) : U;
  }
  var q = typeof L.depth > "u" ? 5 : L.depth;
  if (typeof k > "u" && (k = 0), k >= q && q > 0 && typeof S == "object")
    return isArray$4(S) ? "[Array]" : "[Object]";
  var K = getIndent(L, k);
  if (typeof D > "u")
    D = [];
  else if (indexOf(D, S) >= 0)
    return "[Circular]";
  function Y(ke, Te, fe) {
    if (Te && (D = $arrSlice.call(D), D.push(Te)), fe) {
      var ue = {
        depth: L.depth
      };
      return has$4(L, "quoteStyle") && (ue.quoteStyle = L.quoteStyle), T(ke, ue, k + 1, D);
    }
    return T(ke, L, k + 1, D);
  }
  if (typeof S == "function" && !isRegExp$1(S)) {
    var J = nameOf(S), Z = arrObjKeys(S, Y);
    return "[Function" + (J ? ": " + J : " (anonymous)") + "]" + (Z.length > 0 ? " { " + $join.call(Z, ", ") + " }" : "");
  }
  if (isSymbol(S)) {
    var X = hasShammedSymbols ? $replace.call(String(S), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(S);
    return typeof S == "object" && !hasShammedSymbols ? markBoxed(X) : X;
  }
  if (isElement$2(S)) {
    for (var ee = "<" + $toLowerCase.call(String(S.nodeName)), te = S.attributes || [], re = 0; re < te.length; re++)
      ee += " " + te[re].name + "=" + wrapQuotes(quote(te[re].value), "double", L);
    return ee += ">", S.childNodes && S.childNodes.length && (ee += "..."), ee += "</" + $toLowerCase.call(String(S.nodeName)) + ">", ee;
  }
  if (isArray$4(S)) {
    if (S.length === 0)
      return "[]";
    var Q = arrObjKeys(S, Y);
    return K && !singleLineValues(Q) ? "[" + indentedJoin(Q, K) + "]" : "[ " + $join.call(Q, ", ") + " ]";
  }
  if (isError(S)) {
    var ne = arrObjKeys(S, Y);
    return !("cause" in Error.prototype) && "cause" in S && !isEnumerable.call(S, "cause") ? "{ [" + String(S) + "] " + $join.call($concat.call("[cause]: " + Y(S.cause), ne), ", ") + " }" : ne.length === 0 ? "[" + String(S) + "]" : "{ [" + String(S) + "] " + $join.call(ne, ", ") + " }";
  }
  if (typeof S == "object" && V) {
    if (inspectSymbol && typeof S[inspectSymbol] == "function" && utilInspect)
      return utilInspect(S, { depth: q - k });
    if (V !== "symbol" && typeof S.inspect == "function")
      return S.inspect();
  }
  if (isMap(S)) {
    var oe = [];
    return mapForEach && mapForEach.call(S, function(ke, Te) {
      oe.push(Y(Te, S, !0) + " => " + Y(ke, S));
    }), collectionOf("Map", mapSize.call(S), oe, K);
  }
  if (isSet(S)) {
    var ae = [];
    return setForEach && setForEach.call(S, function(ke) {
      ae.push(Y(ke, S));
    }), collectionOf("Set", setSize.call(S), ae, K);
  }
  if (isWeakMap(S))
    return weakCollectionOf("WeakMap");
  if (isWeakSet(S))
    return weakCollectionOf("WeakSet");
  if (isWeakRef(S))
    return weakCollectionOf("WeakRef");
  if (isNumber(S))
    return markBoxed(Y(Number(S)));
  if (isBigInt(S))
    return markBoxed(Y(bigIntValueOf.call(S)));
  if (isBoolean(S))
    return markBoxed(booleanValueOf.call(S));
  if (isString(S))
    return markBoxed(Y(String(S)));
  if (typeof window < "u" && S === window)
    return "{ [object Window] }";
  if (typeof globalThis < "u" && S === globalThis || typeof commonjsGlobal < "u" && S === commonjsGlobal)
    return "{ [object globalThis] }";
  if (!isDate$1(S) && !isRegExp$1(S)) {
    var se = arrObjKeys(S, Y), ie = gPO ? gPO(S) === Object.prototype : S instanceof Object || S.constructor === Object, he = S instanceof Object ? "" : "null prototype", xe = !ie && toStringTag && Object(S) === S && toStringTag in S ? $slice$1.call(toStr$4(S), 8, -1) : he ? "Object" : "", Pe = ie || typeof S.constructor != "function" ? "" : S.constructor.name ? S.constructor.name + " " : "", Re = Pe + (xe || he ? "[" + $join.call($concat.call([], xe || [], he || []), ": ") + "] " : "");
    return se.length === 0 ? Re + "{}" : K ? Re + "{" + indentedJoin(se, K) + "}" : Re + "{ " + $join.call(se, ", ") + " }";
  }
  return String(S);
};
function wrapQuotes(T, S, R) {
  var k = (R.quoteStyle || S) === "double" ? '"' : "'";
  return k + T + k;
}
function quote(T) {
  return $replace.call(String(T), /"/g, "&quot;");
}
function isArray$4(T) {
  return toStr$4(T) === "[object Array]" && (!toStringTag || !(typeof T == "object" && toStringTag in T));
}
function isDate$1(T) {
  return toStr$4(T) === "[object Date]" && (!toStringTag || !(typeof T == "object" && toStringTag in T));
}
function isRegExp$1(T) {
  return toStr$4(T) === "[object RegExp]" && (!toStringTag || !(typeof T == "object" && toStringTag in T));
}
function isError(T) {
  return toStr$4(T) === "[object Error]" && (!toStringTag || !(typeof T == "object" && toStringTag in T));
}
function isString(T) {
  return toStr$4(T) === "[object String]" && (!toStringTag || !(typeof T == "object" && toStringTag in T));
}
function isNumber(T) {
  return toStr$4(T) === "[object Number]" && (!toStringTag || !(typeof T == "object" && toStringTag in T));
}
function isBoolean(T) {
  return toStr$4(T) === "[object Boolean]" && (!toStringTag || !(typeof T == "object" && toStringTag in T));
}
function isSymbol(T) {
  if (hasShammedSymbols)
    return T && typeof T == "object" && T instanceof Symbol;
  if (typeof T == "symbol")
    return !0;
  if (!T || typeof T != "object" || !symToString)
    return !1;
  try {
    return symToString.call(T), !0;
  } catch {
  }
  return !1;
}
function isBigInt(T) {
  if (!T || typeof T != "object" || !bigIntValueOf)
    return !1;
  try {
    return bigIntValueOf.call(T), !0;
  } catch {
  }
  return !1;
}
var hasOwn$1 = Object.prototype.hasOwnProperty || function(T) {
  return T in this;
};
function has$4(T, S) {
  return hasOwn$1.call(T, S);
}
function toStr$4(T) {
  return objectToString.call(T);
}
function nameOf(T) {
  if (T.name)
    return T.name;
  var S = $match.call(functionToString.call(T), /^function\s*([\w$]+)/);
  return S ? S[1] : null;
}
function indexOf(T, S) {
  if (T.indexOf)
    return T.indexOf(S);
  for (var R = 0, k = T.length; R < k; R++)
    if (T[R] === S)
      return R;
  return -1;
}
function isMap(T) {
  if (!mapSize || !T || typeof T != "object")
    return !1;
  try {
    mapSize.call(T);
    try {
      setSize.call(T);
    } catch {
      return !0;
    }
    return T instanceof Map;
  } catch {
  }
  return !1;
}
function isWeakMap(T) {
  if (!weakMapHas || !T || typeof T != "object")
    return !1;
  try {
    weakMapHas.call(T, weakMapHas);
    try {
      weakSetHas.call(T, weakSetHas);
    } catch {
      return !0;
    }
    return T instanceof WeakMap;
  } catch {
  }
  return !1;
}
function isWeakRef(T) {
  if (!weakRefDeref || !T || typeof T != "object")
    return !1;
  try {
    return weakRefDeref.call(T), !0;
  } catch {
  }
  return !1;
}
function isSet(T) {
  if (!setSize || !T || typeof T != "object")
    return !1;
  try {
    setSize.call(T);
    try {
      mapSize.call(T);
    } catch {
      return !0;
    }
    return T instanceof Set;
  } catch {
  }
  return !1;
}
function isWeakSet(T) {
  if (!weakSetHas || !T || typeof T != "object")
    return !1;
  try {
    weakSetHas.call(T, weakSetHas);
    try {
      weakMapHas.call(T, weakMapHas);
    } catch {
      return !0;
    }
    return T instanceof WeakSet;
  } catch {
  }
  return !1;
}
function isElement$2(T) {
  return !T || typeof T != "object" ? !1 : typeof HTMLElement < "u" && T instanceof HTMLElement ? !0 : typeof T.nodeName == "string" && typeof T.getAttribute == "function";
}
function inspectString(T, S) {
  if (T.length > S.maxStringLength) {
    var R = T.length - S.maxStringLength, k = "... " + R + " more character" + (R > 1 ? "s" : "");
    return inspectString($slice$1.call(T, 0, S.maxStringLength), S) + k;
  }
  var D = $replace.call($replace.call(T, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(D, "single", S);
}
function lowbyte(T) {
  var S = T.charCodeAt(0), R = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[S];
  return R ? "\\" + R : "\\x" + (S < 16 ? "0" : "") + $toUpperCase.call(S.toString(16));
}
function markBoxed(T) {
  return "Object(" + T + ")";
}
function weakCollectionOf(T) {
  return T + " { ? }";
}
function collectionOf(T, S, R, k) {
  var D = k ? indentedJoin(R, k) : $join.call(R, ", ");
  return T + " (" + S + ") {" + D + "}";
}
function singleLineValues(T) {
  for (var S = 0; S < T.length; S++)
    if (indexOf(T[S], `
`) >= 0)
      return !1;
  return !0;
}
function getIndent(T, S) {
  var R;
  if (T.indent === "	")
    R = "	";
  else if (typeof T.indent == "number" && T.indent > 0)
    R = $join.call(Array(T.indent + 1), " ");
  else
    return null;
  return {
    base: R,
    prev: $join.call(Array(S + 1), R)
  };
}
function indentedJoin(T, S) {
  if (T.length === 0)
    return "";
  var R = `
` + S.prev + S.base;
  return R + $join.call(T, "," + R) + `
` + S.prev;
}
function arrObjKeys(T, S) {
  var R = isArray$4(T), k = [];
  if (R) {
    k.length = T.length;
    for (var D = 0; D < T.length; D++)
      k[D] = has$4(T, D) ? S(T[D], T) : "";
  }
  var L = typeof gOPS == "function" ? gOPS(T) : [], V;
  if (hasShammedSymbols) {
    V = {};
    for (var z = 0; z < L.length; z++)
      V["$" + L[z]] = L[z];
  }
  for (var W in T)
    has$4(T, W) && (R && String(Number(W)) === W && W < T.length || hasShammedSymbols && V["$" + W] instanceof Symbol || ($test.call(/[^\w$]/, W) ? k.push(S(W, T) + ": " + S(T[W], T)) : k.push(W + ": " + S(T[W], T))));
  if (typeof gOPS == "function")
    for (var U = 0; U < L.length; U++)
      isEnumerable.call(T, L[U]) && k.push("[" + S(L[U]) + "]: " + S(T[L[U]], T));
  return k;
}
var GetIntrinsic = getIntrinsic, callBound$3 = callBound$4, inspect = objectInspect, $TypeError = type, $WeakMap = GetIntrinsic("%WeakMap%", !0), $Map = GetIntrinsic("%Map%", !0), $weakMapGet = callBound$3("WeakMap.prototype.get", !0), $weakMapSet = callBound$3("WeakMap.prototype.set", !0), $weakMapHas = callBound$3("WeakMap.prototype.has", !0), $mapGet = callBound$3("Map.prototype.get", !0), $mapSet = callBound$3("Map.prototype.set", !0), $mapHas = callBound$3("Map.prototype.has", !0), listGetNode = function(T, S) {
  for (var R = T, k; (k = R.next) !== null; R = k)
    if (k.key === S)
      return R.next = k.next, k.next = /** @type {NonNullable<typeof list.next>} */
      T.next, T.next = k, k;
}, listGet = function(T, S) {
  var R = listGetNode(T, S);
  return R && R.value;
}, listSet = function(T, S, R) {
  var k = listGetNode(T, S);
  k ? k.value = R : T.next = /** @type {import('.').ListNode<typeof value>} */
  {
    // eslint-disable-line no-param-reassign, no-extra-parens
    key: S,
    next: T.next,
    value: R
  };
}, listHas = function(T, S) {
  return !!listGetNode(T, S);
}, sideChannel = function T() {
  var S, R, k, D = {
    assert: function(L) {
      if (!D.has(L))
        throw new $TypeError("Side channel does not contain " + inspect(L));
    },
    get: function(L) {
      if ($WeakMap && L && (typeof L == "object" || typeof L == "function")) {
        if (S)
          return $weakMapGet(S, L);
      } else if ($Map) {
        if (R)
          return $mapGet(R, L);
      } else if (k)
        return listGet(k, L);
    },
    has: function(L) {
      if ($WeakMap && L && (typeof L == "object" || typeof L == "function")) {
        if (S)
          return $weakMapHas(S, L);
      } else if ($Map) {
        if (R)
          return $mapHas(R, L);
      } else if (k)
        return listHas(k, L);
      return !1;
    },
    set: function(L, V) {
      $WeakMap && L && (typeof L == "object" || typeof L == "function") ? (S || (S = new $WeakMap()), $weakMapSet(S, L, V)) : $Map ? (R || (R = new $Map()), $mapSet(R, L, V)) : (k || (k = { key: {}, next: null }), listSet(k, L, V));
    }
  };
  return D;
}, replace$2 = String.prototype.replace, percentTwenties = /%20/g, Format = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, formats$3 = {
  default: Format.RFC3986,
  formatters: {
    RFC1738: function(T) {
      return replace$2.call(T, percentTwenties, "+");
    },
    RFC3986: function(T) {
      return String(T);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
}, formats$2 = formats$3, has$3 = Object.prototype.hasOwnProperty, isArray$3 = Array.isArray, hexTable = function() {
  for (var T = [], S = 0; S < 256; ++S)
    T.push("%" + ((S < 16 ? "0" : "") + S.toString(16)).toUpperCase());
  return T;
}(), compactQueue = function T(S) {
  for (; S.length > 1; ) {
    var R = S.pop(), k = R.obj[R.prop];
    if (isArray$3(k)) {
      for (var D = [], L = 0; L < k.length; ++L)
        typeof k[L] < "u" && D.push(k[L]);
      R.obj[R.prop] = D;
    }
  }
}, arrayToObject = function T(S, R) {
  for (var k = R && R.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, D = 0; D < S.length; ++D)
    typeof S[D] < "u" && (k[D] = S[D]);
  return k;
}, merge$2 = function T(S, R, k) {
  if (!R)
    return S;
  if (typeof R != "object") {
    if (isArray$3(S))
      S.push(R);
    else if (S && typeof S == "object")
      (k && (k.plainObjects || k.allowPrototypes) || !has$3.call(Object.prototype, R)) && (S[R] = !0);
    else
      return [S, R];
    return S;
  }
  if (!S || typeof S != "object")
    return [S].concat(R);
  var D = S;
  return isArray$3(S) && !isArray$3(R) && (D = arrayToObject(S, k)), isArray$3(S) && isArray$3(R) ? (R.forEach(function(L, V) {
    if (has$3.call(S, V)) {
      var z = S[V];
      z && typeof z == "object" && L && typeof L == "object" ? S[V] = T(z, L, k) : S.push(L);
    } else
      S[V] = L;
  }), S) : Object.keys(R).reduce(function(L, V) {
    var z = R[V];
    return has$3.call(L, V) ? L[V] = T(L[V], z, k) : L[V] = z, L;
  }, D);
}, assign$2 = function T(S, R) {
  return Object.keys(R).reduce(function(k, D) {
    return k[D] = R[D], k;
  }, S);
}, decode = function(T, S, R) {
  var k = T.replace(/\+/g, " ");
  if (R === "iso-8859-1")
    return k.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(k);
  } catch {
    return k;
  }
}, limit = 1024, encode = function T(S, R, k, D, L) {
  if (S.length === 0)
    return S;
  var V = S;
  if (typeof S == "symbol" ? V = Symbol.prototype.toString.call(S) : typeof S != "string" && (V = String(S)), k === "iso-8859-1")
    return escape(V).replace(/%u[0-9a-f]{4}/gi, function(J) {
      return "%26%23" + parseInt(J.slice(2), 16) + "%3B";
    });
  for (var z = "", W = 0; W < V.length; W += limit) {
    for (var U = V.length >= limit ? V.slice(W, W + limit) : V, q = [], K = 0; K < U.length; ++K) {
      var Y = U.charCodeAt(K);
      if (Y === 45 || Y === 46 || Y === 95 || Y === 126 || Y >= 48 && Y <= 57 || Y >= 65 && Y <= 90 || Y >= 97 && Y <= 122 || L === formats$2.RFC1738 && (Y === 40 || Y === 41)) {
        q[q.length] = U.charAt(K);
        continue;
      }
      if (Y < 128) {
        q[q.length] = hexTable[Y];
        continue;
      }
      if (Y < 2048) {
        q[q.length] = hexTable[192 | Y >> 6] + hexTable[128 | Y & 63];
        continue;
      }
      if (Y < 55296 || Y >= 57344) {
        q[q.length] = hexTable[224 | Y >> 12] + hexTable[128 | Y >> 6 & 63] + hexTable[128 | Y & 63];
        continue;
      }
      K += 1, Y = 65536 + ((Y & 1023) << 10 | U.charCodeAt(K) & 1023), q[q.length] = hexTable[240 | Y >> 18] + hexTable[128 | Y >> 12 & 63] + hexTable[128 | Y >> 6 & 63] + hexTable[128 | Y & 63];
    }
    z += q.join("");
  }
  return z;
}, compact = function T(S) {
  for (var R = [{ obj: { o: S }, prop: "o" }], k = [], D = 0; D < R.length; ++D)
    for (var L = R[D], V = L.obj[L.prop], z = Object.keys(V), W = 0; W < z.length; ++W) {
      var U = z[W], q = V[U];
      typeof q == "object" && q !== null && k.indexOf(q) === -1 && (R.push({ obj: V, prop: U }), k.push(q));
    }
  return compactQueue(R), S;
}, isRegExp = function T(S) {
  return Object.prototype.toString.call(S) === "[object RegExp]";
}, isBuffer = function T(S) {
  return !S || typeof S != "object" ? !1 : !!(S.constructor && S.constructor.isBuffer && S.constructor.isBuffer(S));
}, combine$2 = function T(S, R) {
  return [].concat(S, R);
}, maybeMap = function T(S, R) {
  if (isArray$3(S)) {
    for (var k = [], D = 0; D < S.length; D += 1)
      k.push(R(S[D]));
    return k;
  }
  return R(S);
}, utils$3 = {
  arrayToObject,
  assign: assign$2,
  combine: combine$2,
  compact,
  decode,
  encode,
  isBuffer,
  isRegExp,
  maybeMap,
  merge: merge$2
}, getSideChannel = sideChannel, utils$2 = utils$3, formats$1 = formats$3, has$2 = Object.prototype.hasOwnProperty, arrayPrefixGenerators = {
  brackets: function T(S) {
    return S + "[]";
  },
  comma: "comma",
  indices: function T(S, R) {
    return S + "[" + R + "]";
  },
  repeat: function T(S) {
    return S;
  }
}, isArray$2 = Array.isArray, push = Array.prototype.push, pushToArray = function(T, S) {
  push.apply(T, isArray$2(S) ? S : [S]);
}, toISO = Date.prototype.toISOString, defaultFormat = formats$1.default, defaults$1 = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: utils$2.encode,
  encodeValuesOnly: !1,
  format: defaultFormat,
  formatter: formats$1.formatters[defaultFormat],
  // deprecated
  indices: !1,
  serializeDate: function T(S) {
    return toISO.call(S);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, isNonNullishPrimitive = function T(S) {
  return typeof S == "string" || typeof S == "number" || typeof S == "boolean" || typeof S == "symbol" || typeof S == "bigint";
}, sentinel = {}, stringify$3 = function T(S, R, k, D, L, V, z, W, U, q, K, Y, J, Z, X, ee, te, re) {
  for (var Q = S, ne = re, oe = 0, ae = !1; (ne = ne.get(sentinel)) !== void 0 && !ae; ) {
    var se = ne.get(S);
    if (oe += 1, typeof se < "u") {
      if (se === oe)
        throw new RangeError("Cyclic object value");
      ae = !0;
    }
    typeof ne.get(sentinel) > "u" && (oe = 0);
  }
  if (typeof q == "function" ? Q = q(R, Q) : Q instanceof Date ? Q = J(Q) : k === "comma" && isArray$2(Q) && (Q = utils$2.maybeMap(Q, function(_e) {
    return _e instanceof Date ? J(_e) : _e;
  })), Q === null) {
    if (V)
      return U && !ee ? U(R, defaults$1.encoder, te, "key", Z) : R;
    Q = "";
  }
  if (isNonNullishPrimitive(Q) || utils$2.isBuffer(Q)) {
    if (U) {
      var ie = ee ? R : U(R, defaults$1.encoder, te, "key", Z);
      return [X(ie) + "=" + X(U(Q, defaults$1.encoder, te, "value", Z))];
    }
    return [X(R) + "=" + X(String(Q))];
  }
  var he = [];
  if (typeof Q > "u")
    return he;
  var xe;
  if (k === "comma" && isArray$2(Q))
    ee && U && (Q = utils$2.maybeMap(Q, U)), xe = [{ value: Q.length > 0 ? Q.join(",") || null : void 0 }];
  else if (isArray$2(q))
    xe = q;
  else {
    var Pe = Object.keys(Q);
    xe = K ? Pe.sort(K) : Pe;
  }
  var Re = W ? R.replace(/\./g, "%2E") : R, ke = D && isArray$2(Q) && Q.length === 1 ? Re + "[]" : Re;
  if (L && isArray$2(Q) && Q.length === 0)
    return ke + "[]";
  for (var Te = 0; Te < xe.length; ++Te) {
    var fe = xe[Te], ue = typeof fe == "object" && typeof fe.value < "u" ? fe.value : Q[fe];
    if (!(z && ue === null)) {
      var Ce = Y && W ? fe.replace(/\./g, "%2E") : fe, ce = isArray$2(Q) ? typeof k == "function" ? k(ke, Ce) : ke : ke + (Y ? "." + Ce : "[" + Ce + "]");
      re.set(S, oe);
      var pe = getSideChannel();
      pe.set(sentinel, re), pushToArray(he, T(
        ue,
        ce,
        k,
        D,
        L,
        V,
        z,
        W,
        k === "comma" && ee && isArray$2(Q) ? null : U,
        q,
        K,
        Y,
        J,
        Z,
        X,
        ee,
        te,
        pe
      ));
    }
  }
  return he;
}, normalizeStringifyOptions = function T(S) {
  if (!S)
    return defaults$1;
  if (typeof S.allowEmptyArrays < "u" && typeof S.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof S.encodeDotInKeys < "u" && typeof S.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (S.encoder !== null && typeof S.encoder < "u" && typeof S.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var R = S.charset || defaults$1.charset;
  if (typeof S.charset < "u" && S.charset !== "utf-8" && S.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var k = formats$1.default;
  if (typeof S.format < "u") {
    if (!has$2.call(formats$1.formatters, S.format))
      throw new TypeError("Unknown format option provided.");
    k = S.format;
  }
  var D = formats$1.formatters[k], L = defaults$1.filter;
  (typeof S.filter == "function" || isArray$2(S.filter)) && (L = S.filter);
  var V;
  if (S.arrayFormat in arrayPrefixGenerators ? V = S.arrayFormat : "indices" in S ? V = S.indices ? "indices" : "repeat" : V = defaults$1.arrayFormat, "commaRoundTrip" in S && typeof S.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var z = typeof S.allowDots > "u" ? S.encodeDotInKeys === !0 ? !0 : defaults$1.allowDots : !!S.allowDots;
  return {
    addQueryPrefix: typeof S.addQueryPrefix == "boolean" ? S.addQueryPrefix : defaults$1.addQueryPrefix,
    allowDots: z,
    allowEmptyArrays: typeof S.allowEmptyArrays == "boolean" ? !!S.allowEmptyArrays : defaults$1.allowEmptyArrays,
    arrayFormat: V,
    charset: R,
    charsetSentinel: typeof S.charsetSentinel == "boolean" ? S.charsetSentinel : defaults$1.charsetSentinel,
    commaRoundTrip: S.commaRoundTrip,
    delimiter: typeof S.delimiter > "u" ? defaults$1.delimiter : S.delimiter,
    encode: typeof S.encode == "boolean" ? S.encode : defaults$1.encode,
    encodeDotInKeys: typeof S.encodeDotInKeys == "boolean" ? S.encodeDotInKeys : defaults$1.encodeDotInKeys,
    encoder: typeof S.encoder == "function" ? S.encoder : defaults$1.encoder,
    encodeValuesOnly: typeof S.encodeValuesOnly == "boolean" ? S.encodeValuesOnly : defaults$1.encodeValuesOnly,
    filter: L,
    format: k,
    formatter: D,
    serializeDate: typeof S.serializeDate == "function" ? S.serializeDate : defaults$1.serializeDate,
    skipNulls: typeof S.skipNulls == "boolean" ? S.skipNulls : defaults$1.skipNulls,
    sort: typeof S.sort == "function" ? S.sort : null,
    strictNullHandling: typeof S.strictNullHandling == "boolean" ? S.strictNullHandling : defaults$1.strictNullHandling
  };
}, stringify_1 = function(T, S) {
  var R = T, k = normalizeStringifyOptions(S), D, L;
  typeof k.filter == "function" ? (L = k.filter, R = L("", R)) : isArray$2(k.filter) && (L = k.filter, D = L);
  var V = [];
  if (typeof R != "object" || R === null)
    return "";
  var z = arrayPrefixGenerators[k.arrayFormat], W = z === "comma" && k.commaRoundTrip;
  D || (D = Object.keys(R)), k.sort && D.sort(k.sort);
  for (var U = getSideChannel(), q = 0; q < D.length; ++q) {
    var K = D[q];
    k.skipNulls && R[K] === null || pushToArray(V, stringify$3(
      R[K],
      K,
      z,
      W,
      k.allowEmptyArrays,
      k.strictNullHandling,
      k.skipNulls,
      k.encodeDotInKeys,
      k.encode ? k.encoder : null,
      k.filter,
      k.sort,
      k.allowDots,
      k.serializeDate,
      k.format,
      k.formatter,
      k.encodeValuesOnly,
      k.charset,
      U
    ));
  }
  var Y = V.join(k.delimiter), J = k.addQueryPrefix === !0 ? "?" : "";
  return k.charsetSentinel && (k.charset === "iso-8859-1" ? J += "utf8=%26%2310003%3B&" : J += "utf8=%E2%9C%93&"), Y.length > 0 ? J + Y : "";
}, utils$1 = utils$3, has$1 = Object.prototype.hasOwnProperty, isArray$1 = Array.isArray, defaults = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !1,
  decoder: utils$1.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, interpretNumericEntities = function(T) {
  return T.replace(/&#(\d+);/g, function(S, R) {
    return String.fromCharCode(parseInt(R, 10));
  });
}, parseArrayValue = function(T, S) {
  return T && typeof T == "string" && S.comma && T.indexOf(",") > -1 ? T.split(",") : T;
}, isoSentinel = "utf8=%26%2310003%3B", charsetSentinel = "utf8=%E2%9C%93", parseValues = function T(S, R) {
  var k = { __proto__: null }, D = R.ignoreQueryPrefix ? S.replace(/^\?/, "") : S;
  D = D.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  var L = R.parameterLimit === 1 / 0 ? void 0 : R.parameterLimit, V = D.split(R.delimiter, L), z = -1, W, U = R.charset;
  if (R.charsetSentinel)
    for (W = 0; W < V.length; ++W)
      V[W].indexOf("utf8=") === 0 && (V[W] === charsetSentinel ? U = "utf-8" : V[W] === isoSentinel && (U = "iso-8859-1"), z = W, W = V.length);
  for (W = 0; W < V.length; ++W)
    if (W !== z) {
      var q = V[W], K = q.indexOf("]="), Y = K === -1 ? q.indexOf("=") : K + 1, J, Z;
      Y === -1 ? (J = R.decoder(q, defaults.decoder, U, "key"), Z = R.strictNullHandling ? null : "") : (J = R.decoder(q.slice(0, Y), defaults.decoder, U, "key"), Z = utils$1.maybeMap(
        parseArrayValue(q.slice(Y + 1), R),
        function(ee) {
          return R.decoder(ee, defaults.decoder, U, "value");
        }
      )), Z && R.interpretNumericEntities && U === "iso-8859-1" && (Z = interpretNumericEntities(Z)), q.indexOf("[]=") > -1 && (Z = isArray$1(Z) ? [Z] : Z);
      var X = has$1.call(k, J);
      X && R.duplicates === "combine" ? k[J] = utils$1.combine(k[J], Z) : (!X || R.duplicates === "last") && (k[J] = Z);
    }
  return k;
}, parseObject = function(T, S, R, k) {
  for (var D = k ? S : parseArrayValue(S, R), L = T.length - 1; L >= 0; --L) {
    var V, z = T[L];
    if (z === "[]" && R.parseArrays)
      V = R.allowEmptyArrays && (D === "" || R.strictNullHandling && D === null) ? [] : [].concat(D);
    else {
      V = R.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var W = z.charAt(0) === "[" && z.charAt(z.length - 1) === "]" ? z.slice(1, -1) : z, U = R.decodeDotInKeys ? W.replace(/%2E/g, ".") : W, q = parseInt(U, 10);
      !R.parseArrays && U === "" ? V = { 0: D } : !isNaN(q) && z !== U && String(q) === U && q >= 0 && R.parseArrays && q <= R.arrayLimit ? (V = [], V[q] = D) : U !== "__proto__" && (V[U] = D);
    }
    D = V;
  }
  return D;
}, parseKeys = function T(S, R, k, D) {
  if (S) {
    var L = k.allowDots ? S.replace(/\.([^.[]+)/g, "[$1]") : S, V = /(\[[^[\]]*])/, z = /(\[[^[\]]*])/g, W = k.depth > 0 && V.exec(L), U = W ? L.slice(0, W.index) : L, q = [];
    if (U) {
      if (!k.plainObjects && has$1.call(Object.prototype, U) && !k.allowPrototypes)
        return;
      q.push(U);
    }
    for (var K = 0; k.depth > 0 && (W = z.exec(L)) !== null && K < k.depth; ) {
      if (K += 1, !k.plainObjects && has$1.call(Object.prototype, W[1].slice(1, -1)) && !k.allowPrototypes)
        return;
      q.push(W[1]);
    }
    return W && q.push("[" + L.slice(W.index) + "]"), parseObject(q, R, k, D);
  }
}, normalizeParseOptions = function T(S) {
  if (!S)
    return defaults;
  if (typeof S.allowEmptyArrays < "u" && typeof S.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof S.decodeDotInKeys < "u" && typeof S.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (S.decoder !== null && typeof S.decoder < "u" && typeof S.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof S.charset < "u" && S.charset !== "utf-8" && S.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var R = typeof S.charset > "u" ? defaults.charset : S.charset, k = typeof S.duplicates > "u" ? defaults.duplicates : S.duplicates;
  if (k !== "combine" && k !== "first" && k !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var D = typeof S.allowDots > "u" ? S.decodeDotInKeys === !0 ? !0 : defaults.allowDots : !!S.allowDots;
  return {
    allowDots: D,
    allowEmptyArrays: typeof S.allowEmptyArrays == "boolean" ? !!S.allowEmptyArrays : defaults.allowEmptyArrays,
    allowPrototypes: typeof S.allowPrototypes == "boolean" ? S.allowPrototypes : defaults.allowPrototypes,
    allowSparse: typeof S.allowSparse == "boolean" ? S.allowSparse : defaults.allowSparse,
    arrayLimit: typeof S.arrayLimit == "number" ? S.arrayLimit : defaults.arrayLimit,
    charset: R,
    charsetSentinel: typeof S.charsetSentinel == "boolean" ? S.charsetSentinel : defaults.charsetSentinel,
    comma: typeof S.comma == "boolean" ? S.comma : defaults.comma,
    decodeDotInKeys: typeof S.decodeDotInKeys == "boolean" ? S.decodeDotInKeys : defaults.decodeDotInKeys,
    decoder: typeof S.decoder == "function" ? S.decoder : defaults.decoder,
    delimiter: typeof S.delimiter == "string" || utils$1.isRegExp(S.delimiter) ? S.delimiter : defaults.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof S.depth == "number" || S.depth === !1 ? +S.depth : defaults.depth,
    duplicates: k,
    ignoreQueryPrefix: S.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof S.interpretNumericEntities == "boolean" ? S.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof S.parameterLimit == "number" ? S.parameterLimit : defaults.parameterLimit,
    parseArrays: S.parseArrays !== !1,
    plainObjects: typeof S.plainObjects == "boolean" ? S.plainObjects : defaults.plainObjects,
    strictNullHandling: typeof S.strictNullHandling == "boolean" ? S.strictNullHandling : defaults.strictNullHandling
  };
}, parse$4 = function(T, S) {
  var R = normalizeParseOptions(S);
  if (T === "" || T === null || typeof T > "u")
    return R.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var k = typeof T == "string" ? parseValues(T, R) : T, D = R.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, L = Object.keys(k), V = 0; V < L.length; ++V) {
    var z = L[V], W = parseKeys(z, k[z], R, typeof T == "string");
    D = utils$1.merge(D, W, R);
  }
  return R.allowSparse === !0 ? D : utils$1.compact(D);
}, stringify$2 = stringify_1, parse$3 = parse$4, formats = formats$3, lib = {
  formats,
  parse: parse$3,
  stringify: stringify$2
};
const qs = /* @__PURE__ */ getDefaultExportFromCjs(lib);
var __create$4 = Object.create, __defProp$4 = Object.defineProperty, __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor, __getOwnPropNames$4 = Object.getOwnPropertyNames, __getProtoOf$4 = Object.getPrototypeOf, __hasOwnProp$4 = Object.prototype.hasOwnProperty, __commonJS$4 = (T, S) => function() {
  return S || (0, T[__getOwnPropNames$4(T)[0]])((S = { exports: {} }).exports, S), S.exports;
}, __copyProps$4 = (T, S, R, k) => {
  if (S && typeof S == "object" || typeof S == "function") for (let D of __getOwnPropNames$4(S)) !__hasOwnProp$4.call(T, D) && D !== R && __defProp$4(T, D, { get: () => S[D], enumerable: !(k = __getOwnPropDesc$4(S, D)) || k.enumerable });
  return T;
}, __toESM$4 = (T, S, R) => (R = T != null ? __create$4(__getProtoOf$4(T)) : {}, __copyProps$4(!T || !T.__esModule ? __defProp$4(R, "default", { value: T, enumerable: !0 }) : R, T)), require_entities = __commonJS$4({ "../../node_modules/ansi-to-html/node_modules/entities/lib/maps/entities.json"(T, S) {
  S.exports = { Aacute: "Á", aacute: "á", Abreve: "Ă", abreve: "ă", ac: "∾", acd: "∿", acE: "∾̳", Acirc: "Â", acirc: "â", acute: "´", Acy: "А", acy: "а", AElig: "Æ", aelig: "æ", af: "⁡", Afr: "𝔄", afr: "𝔞", Agrave: "À", agrave: "à", alefsym: "ℵ", aleph: "ℵ", Alpha: "Α", alpha: "α", Amacr: "Ā", amacr: "ā", amalg: "⨿", amp: "&", AMP: "&", andand: "⩕", And: "⩓", and: "∧", andd: "⩜", andslope: "⩘", andv: "⩚", ang: "∠", ange: "⦤", angle: "∠", angmsdaa: "⦨", angmsdab: "⦩", angmsdac: "⦪", angmsdad: "⦫", angmsdae: "⦬", angmsdaf: "⦭", angmsdag: "⦮", angmsdah: "⦯", angmsd: "∡", angrt: "∟", angrtvb: "⊾", angrtvbd: "⦝", angsph: "∢", angst: "Å", angzarr: "⍼", Aogon: "Ą", aogon: "ą", Aopf: "𝔸", aopf: "𝕒", apacir: "⩯", ap: "≈", apE: "⩰", ape: "≊", apid: "≋", apos: "'", ApplyFunction: "⁡", approx: "≈", approxeq: "≊", Aring: "Å", aring: "å", Ascr: "𝒜", ascr: "𝒶", Assign: "≔", ast: "*", asymp: "≈", asympeq: "≍", Atilde: "Ã", atilde: "ã", Auml: "Ä", auml: "ä", awconint: "∳", awint: "⨑", backcong: "≌", backepsilon: "϶", backprime: "‵", backsim: "∽", backsimeq: "⋍", Backslash: "∖", Barv: "⫧", barvee: "⊽", barwed: "⌅", Barwed: "⌆", barwedge: "⌅", bbrk: "⎵", bbrktbrk: "⎶", bcong: "≌", Bcy: "Б", bcy: "б", bdquo: "„", becaus: "∵", because: "∵", Because: "∵", bemptyv: "⦰", bepsi: "϶", bernou: "ℬ", Bernoullis: "ℬ", Beta: "Β", beta: "β", beth: "ℶ", between: "≬", Bfr: "𝔅", bfr: "𝔟", bigcap: "⋂", bigcirc: "◯", bigcup: "⋃", bigodot: "⨀", bigoplus: "⨁", bigotimes: "⨂", bigsqcup: "⨆", bigstar: "★", bigtriangledown: "▽", bigtriangleup: "△", biguplus: "⨄", bigvee: "⋁", bigwedge: "⋀", bkarow: "⤍", blacklozenge: "⧫", blacksquare: "▪", blacktriangle: "▴", blacktriangledown: "▾", blacktriangleleft: "◂", blacktriangleright: "▸", blank: "␣", blk12: "▒", blk14: "░", blk34: "▓", block: "█", bne: "=⃥", bnequiv: "≡⃥", bNot: "⫭", bnot: "⌐", Bopf: "𝔹", bopf: "𝕓", bot: "⊥", bottom: "⊥", bowtie: "⋈", boxbox: "⧉", boxdl: "┐", boxdL: "╕", boxDl: "╖", boxDL: "╗", boxdr: "┌", boxdR: "╒", boxDr: "╓", boxDR: "╔", boxh: "─", boxH: "═", boxhd: "┬", boxHd: "╤", boxhD: "╥", boxHD: "╦", boxhu: "┴", boxHu: "╧", boxhU: "╨", boxHU: "╩", boxminus: "⊟", boxplus: "⊞", boxtimes: "⊠", boxul: "┘", boxuL: "╛", boxUl: "╜", boxUL: "╝", boxur: "└", boxuR: "╘", boxUr: "╙", boxUR: "╚", boxv: "│", boxV: "║", boxvh: "┼", boxvH: "╪", boxVh: "╫", boxVH: "╬", boxvl: "┤", boxvL: "╡", boxVl: "╢", boxVL: "╣", boxvr: "├", boxvR: "╞", boxVr: "╟", boxVR: "╠", bprime: "‵", breve: "˘", Breve: "˘", brvbar: "¦", bscr: "𝒷", Bscr: "ℬ", bsemi: "⁏", bsim: "∽", bsime: "⋍", bsolb: "⧅", bsol: "\\", bsolhsub: "⟈", bull: "•", bullet: "•", bump: "≎", bumpE: "⪮", bumpe: "≏", Bumpeq: "≎", bumpeq: "≏", Cacute: "Ć", cacute: "ć", capand: "⩄", capbrcup: "⩉", capcap: "⩋", cap: "∩", Cap: "⋒", capcup: "⩇", capdot: "⩀", CapitalDifferentialD: "ⅅ", caps: "∩︀", caret: "⁁", caron: "ˇ", Cayleys: "ℭ", ccaps: "⩍", Ccaron: "Č", ccaron: "č", Ccedil: "Ç", ccedil: "ç", Ccirc: "Ĉ", ccirc: "ĉ", Cconint: "∰", ccups: "⩌", ccupssm: "⩐", Cdot: "Ċ", cdot: "ċ", cedil: "¸", Cedilla: "¸", cemptyv: "⦲", cent: "¢", centerdot: "·", CenterDot: "·", cfr: "𝔠", Cfr: "ℭ", CHcy: "Ч", chcy: "ч", check: "✓", checkmark: "✓", Chi: "Χ", chi: "χ", circ: "ˆ", circeq: "≗", circlearrowleft: "↺", circlearrowright: "↻", circledast: "⊛", circledcirc: "⊚", circleddash: "⊝", CircleDot: "⊙", circledR: "®", circledS: "Ⓢ", CircleMinus: "⊖", CirclePlus: "⊕", CircleTimes: "⊗", cir: "○", cirE: "⧃", cire: "≗", cirfnint: "⨐", cirmid: "⫯", cirscir: "⧂", ClockwiseContourIntegral: "∲", CloseCurlyDoubleQuote: "”", CloseCurlyQuote: "’", clubs: "♣", clubsuit: "♣", colon: ":", Colon: "∷", Colone: "⩴", colone: "≔", coloneq: "≔", comma: ",", commat: "@", comp: "∁", compfn: "∘", complement: "∁", complexes: "ℂ", cong: "≅", congdot: "⩭", Congruent: "≡", conint: "∮", Conint: "∯", ContourIntegral: "∮", copf: "𝕔", Copf: "ℂ", coprod: "∐", Coproduct: "∐", copy: "©", COPY: "©", copysr: "℗", CounterClockwiseContourIntegral: "∳", crarr: "↵", cross: "✗", Cross: "⨯", Cscr: "𝒞", cscr: "𝒸", csub: "⫏", csube: "⫑", csup: "⫐", csupe: "⫒", ctdot: "⋯", cudarrl: "⤸", cudarrr: "⤵", cuepr: "⋞", cuesc: "⋟", cularr: "↶", cularrp: "⤽", cupbrcap: "⩈", cupcap: "⩆", CupCap: "≍", cup: "∪", Cup: "⋓", cupcup: "⩊", cupdot: "⊍", cupor: "⩅", cups: "∪︀", curarr: "↷", curarrm: "⤼", curlyeqprec: "⋞", curlyeqsucc: "⋟", curlyvee: "⋎", curlywedge: "⋏", curren: "¤", curvearrowleft: "↶", curvearrowright: "↷", cuvee: "⋎", cuwed: "⋏", cwconint: "∲", cwint: "∱", cylcty: "⌭", dagger: "†", Dagger: "‡", daleth: "ℸ", darr: "↓", Darr: "↡", dArr: "⇓", dash: "‐", Dashv: "⫤", dashv: "⊣", dbkarow: "⤏", dblac: "˝", Dcaron: "Ď", dcaron: "ď", Dcy: "Д", dcy: "д", ddagger: "‡", ddarr: "⇊", DD: "ⅅ", dd: "ⅆ", DDotrahd: "⤑", ddotseq: "⩷", deg: "°", Del: "∇", Delta: "Δ", delta: "δ", demptyv: "⦱", dfisht: "⥿", Dfr: "𝔇", dfr: "𝔡", dHar: "⥥", dharl: "⇃", dharr: "⇂", DiacriticalAcute: "´", DiacriticalDot: "˙", DiacriticalDoubleAcute: "˝", DiacriticalGrave: "`", DiacriticalTilde: "˜", diam: "⋄", diamond: "⋄", Diamond: "⋄", diamondsuit: "♦", diams: "♦", die: "¨", DifferentialD: "ⅆ", digamma: "ϝ", disin: "⋲", div: "÷", divide: "÷", divideontimes: "⋇", divonx: "⋇", DJcy: "Ђ", djcy: "ђ", dlcorn: "⌞", dlcrop: "⌍", dollar: "$", Dopf: "𝔻", dopf: "𝕕", Dot: "¨", dot: "˙", DotDot: "⃜", doteq: "≐", doteqdot: "≑", DotEqual: "≐", dotminus: "∸", dotplus: "∔", dotsquare: "⊡", doublebarwedge: "⌆", DoubleContourIntegral: "∯", DoubleDot: "¨", DoubleDownArrow: "⇓", DoubleLeftArrow: "⇐", DoubleLeftRightArrow: "⇔", DoubleLeftTee: "⫤", DoubleLongLeftArrow: "⟸", DoubleLongLeftRightArrow: "⟺", DoubleLongRightArrow: "⟹", DoubleRightArrow: "⇒", DoubleRightTee: "⊨", DoubleUpArrow: "⇑", DoubleUpDownArrow: "⇕", DoubleVerticalBar: "∥", DownArrowBar: "⤓", downarrow: "↓", DownArrow: "↓", Downarrow: "⇓", DownArrowUpArrow: "⇵", DownBreve: "̑", downdownarrows: "⇊", downharpoonleft: "⇃", downharpoonright: "⇂", DownLeftRightVector: "⥐", DownLeftTeeVector: "⥞", DownLeftVectorBar: "⥖", DownLeftVector: "↽", DownRightTeeVector: "⥟", DownRightVectorBar: "⥗", DownRightVector: "⇁", DownTeeArrow: "↧", DownTee: "⊤", drbkarow: "⤐", drcorn: "⌟", drcrop: "⌌", Dscr: "𝒟", dscr: "𝒹", DScy: "Ѕ", dscy: "ѕ", dsol: "⧶", Dstrok: "Đ", dstrok: "đ", dtdot: "⋱", dtri: "▿", dtrif: "▾", duarr: "⇵", duhar: "⥯", dwangle: "⦦", DZcy: "Џ", dzcy: "џ", dzigrarr: "⟿", Eacute: "É", eacute: "é", easter: "⩮", Ecaron: "Ě", ecaron: "ě", Ecirc: "Ê", ecirc: "ê", ecir: "≖", ecolon: "≕", Ecy: "Э", ecy: "э", eDDot: "⩷", Edot: "Ė", edot: "ė", eDot: "≑", ee: "ⅇ", efDot: "≒", Efr: "𝔈", efr: "𝔢", eg: "⪚", Egrave: "È", egrave: "è", egs: "⪖", egsdot: "⪘", el: "⪙", Element: "∈", elinters: "⏧", ell: "ℓ", els: "⪕", elsdot: "⪗", Emacr: "Ē", emacr: "ē", empty: "∅", emptyset: "∅", EmptySmallSquare: "◻", emptyv: "∅", EmptyVerySmallSquare: "▫", emsp13: " ", emsp14: " ", emsp: " ", ENG: "Ŋ", eng: "ŋ", ensp: " ", Eogon: "Ę", eogon: "ę", Eopf: "𝔼", eopf: "𝕖", epar: "⋕", eparsl: "⧣", eplus: "⩱", epsi: "ε", Epsilon: "Ε", epsilon: "ε", epsiv: "ϵ", eqcirc: "≖", eqcolon: "≕", eqsim: "≂", eqslantgtr: "⪖", eqslantless: "⪕", Equal: "⩵", equals: "=", EqualTilde: "≂", equest: "≟", Equilibrium: "⇌", equiv: "≡", equivDD: "⩸", eqvparsl: "⧥", erarr: "⥱", erDot: "≓", escr: "ℯ", Escr: "ℰ", esdot: "≐", Esim: "⩳", esim: "≂", Eta: "Η", eta: "η", ETH: "Ð", eth: "ð", Euml: "Ë", euml: "ë", euro: "€", excl: "!", exist: "∃", Exists: "∃", expectation: "ℰ", exponentiale: "ⅇ", ExponentialE: "ⅇ", fallingdotseq: "≒", Fcy: "Ф", fcy: "ф", female: "♀", ffilig: "ﬃ", fflig: "ﬀ", ffllig: "ﬄ", Ffr: "𝔉", ffr: "𝔣", filig: "ﬁ", FilledSmallSquare: "◼", FilledVerySmallSquare: "▪", fjlig: "fj", flat: "♭", fllig: "ﬂ", fltns: "▱", fnof: "ƒ", Fopf: "𝔽", fopf: "𝕗", forall: "∀", ForAll: "∀", fork: "⋔", forkv: "⫙", Fouriertrf: "ℱ", fpartint: "⨍", frac12: "½", frac13: "⅓", frac14: "¼", frac15: "⅕", frac16: "⅙", frac18: "⅛", frac23: "⅔", frac25: "⅖", frac34: "¾", frac35: "⅗", frac38: "⅜", frac45: "⅘", frac56: "⅚", frac58: "⅝", frac78: "⅞", frasl: "⁄", frown: "⌢", fscr: "𝒻", Fscr: "ℱ", gacute: "ǵ", Gamma: "Γ", gamma: "γ", Gammad: "Ϝ", gammad: "ϝ", gap: "⪆", Gbreve: "Ğ", gbreve: "ğ", Gcedil: "Ģ", Gcirc: "Ĝ", gcirc: "ĝ", Gcy: "Г", gcy: "г", Gdot: "Ġ", gdot: "ġ", ge: "≥", gE: "≧", gEl: "⪌", gel: "⋛", geq: "≥", geqq: "≧", geqslant: "⩾", gescc: "⪩", ges: "⩾", gesdot: "⪀", gesdoto: "⪂", gesdotol: "⪄", gesl: "⋛︀", gesles: "⪔", Gfr: "𝔊", gfr: "𝔤", gg: "≫", Gg: "⋙", ggg: "⋙", gimel: "ℷ", GJcy: "Ѓ", gjcy: "ѓ", gla: "⪥", gl: "≷", glE: "⪒", glj: "⪤", gnap: "⪊", gnapprox: "⪊", gne: "⪈", gnE: "≩", gneq: "⪈", gneqq: "≩", gnsim: "⋧", Gopf: "𝔾", gopf: "𝕘", grave: "`", GreaterEqual: "≥", GreaterEqualLess: "⋛", GreaterFullEqual: "≧", GreaterGreater: "⪢", GreaterLess: "≷", GreaterSlantEqual: "⩾", GreaterTilde: "≳", Gscr: "𝒢", gscr: "ℊ", gsim: "≳", gsime: "⪎", gsiml: "⪐", gtcc: "⪧", gtcir: "⩺", gt: ">", GT: ">", Gt: "≫", gtdot: "⋗", gtlPar: "⦕", gtquest: "⩼", gtrapprox: "⪆", gtrarr: "⥸", gtrdot: "⋗", gtreqless: "⋛", gtreqqless: "⪌", gtrless: "≷", gtrsim: "≳", gvertneqq: "≩︀", gvnE: "≩︀", Hacek: "ˇ", hairsp: " ", half: "½", hamilt: "ℋ", HARDcy: "Ъ", hardcy: "ъ", harrcir: "⥈", harr: "↔", hArr: "⇔", harrw: "↭", Hat: "^", hbar: "ℏ", Hcirc: "Ĥ", hcirc: "ĥ", hearts: "♥", heartsuit: "♥", hellip: "…", hercon: "⊹", hfr: "𝔥", Hfr: "ℌ", HilbertSpace: "ℋ", hksearow: "⤥", hkswarow: "⤦", hoarr: "⇿", homtht: "∻", hookleftarrow: "↩", hookrightarrow: "↪", hopf: "𝕙", Hopf: "ℍ", horbar: "―", HorizontalLine: "─", hscr: "𝒽", Hscr: "ℋ", hslash: "ℏ", Hstrok: "Ħ", hstrok: "ħ", HumpDownHump: "≎", HumpEqual: "≏", hybull: "⁃", hyphen: "‐", Iacute: "Í", iacute: "í", ic: "⁣", Icirc: "Î", icirc: "î", Icy: "И", icy: "и", Idot: "İ", IEcy: "Е", iecy: "е", iexcl: "¡", iff: "⇔", ifr: "𝔦", Ifr: "ℑ", Igrave: "Ì", igrave: "ì", ii: "ⅈ", iiiint: "⨌", iiint: "∭", iinfin: "⧜", iiota: "℩", IJlig: "Ĳ", ijlig: "ĳ", Imacr: "Ī", imacr: "ī", image: "ℑ", ImaginaryI: "ⅈ", imagline: "ℐ", imagpart: "ℑ", imath: "ı", Im: "ℑ", imof: "⊷", imped: "Ƶ", Implies: "⇒", incare: "℅", in: "∈", infin: "∞", infintie: "⧝", inodot: "ı", intcal: "⊺", int: "∫", Int: "∬", integers: "ℤ", Integral: "∫", intercal: "⊺", Intersection: "⋂", intlarhk: "⨗", intprod: "⨼", InvisibleComma: "⁣", InvisibleTimes: "⁢", IOcy: "Ё", iocy: "ё", Iogon: "Į", iogon: "į", Iopf: "𝕀", iopf: "𝕚", Iota: "Ι", iota: "ι", iprod: "⨼", iquest: "¿", iscr: "𝒾", Iscr: "ℐ", isin: "∈", isindot: "⋵", isinE: "⋹", isins: "⋴", isinsv: "⋳", isinv: "∈", it: "⁢", Itilde: "Ĩ", itilde: "ĩ", Iukcy: "І", iukcy: "і", Iuml: "Ï", iuml: "ï", Jcirc: "Ĵ", jcirc: "ĵ", Jcy: "Й", jcy: "й", Jfr: "𝔍", jfr: "𝔧", jmath: "ȷ", Jopf: "𝕁", jopf: "𝕛", Jscr: "𝒥", jscr: "𝒿", Jsercy: "Ј", jsercy: "ј", Jukcy: "Є", jukcy: "є", Kappa: "Κ", kappa: "κ", kappav: "ϰ", Kcedil: "Ķ", kcedil: "ķ", Kcy: "К", kcy: "к", Kfr: "𝔎", kfr: "𝔨", kgreen: "ĸ", KHcy: "Х", khcy: "х", KJcy: "Ќ", kjcy: "ќ", Kopf: "𝕂", kopf: "𝕜", Kscr: "𝒦", kscr: "𝓀", lAarr: "⇚", Lacute: "Ĺ", lacute: "ĺ", laemptyv: "⦴", lagran: "ℒ", Lambda: "Λ", lambda: "λ", lang: "⟨", Lang: "⟪", langd: "⦑", langle: "⟨", lap: "⪅", Laplacetrf: "ℒ", laquo: "«", larrb: "⇤", larrbfs: "⤟", larr: "←", Larr: "↞", lArr: "⇐", larrfs: "⤝", larrhk: "↩", larrlp: "↫", larrpl: "⤹", larrsim: "⥳", larrtl: "↢", latail: "⤙", lAtail: "⤛", lat: "⪫", late: "⪭", lates: "⪭︀", lbarr: "⤌", lBarr: "⤎", lbbrk: "❲", lbrace: "{", lbrack: "[", lbrke: "⦋", lbrksld: "⦏", lbrkslu: "⦍", Lcaron: "Ľ", lcaron: "ľ", Lcedil: "Ļ", lcedil: "ļ", lceil: "⌈", lcub: "{", Lcy: "Л", lcy: "л", ldca: "⤶", ldquo: "“", ldquor: "„", ldrdhar: "⥧", ldrushar: "⥋", ldsh: "↲", le: "≤", lE: "≦", LeftAngleBracket: "⟨", LeftArrowBar: "⇤", leftarrow: "←", LeftArrow: "←", Leftarrow: "⇐", LeftArrowRightArrow: "⇆", leftarrowtail: "↢", LeftCeiling: "⌈", LeftDoubleBracket: "⟦", LeftDownTeeVector: "⥡", LeftDownVectorBar: "⥙", LeftDownVector: "⇃", LeftFloor: "⌊", leftharpoondown: "↽", leftharpoonup: "↼", leftleftarrows: "⇇", leftrightarrow: "↔", LeftRightArrow: "↔", Leftrightarrow: "⇔", leftrightarrows: "⇆", leftrightharpoons: "⇋", leftrightsquigarrow: "↭", LeftRightVector: "⥎", LeftTeeArrow: "↤", LeftTee: "⊣", LeftTeeVector: "⥚", leftthreetimes: "⋋", LeftTriangleBar: "⧏", LeftTriangle: "⊲", LeftTriangleEqual: "⊴", LeftUpDownVector: "⥑", LeftUpTeeVector: "⥠", LeftUpVectorBar: "⥘", LeftUpVector: "↿", LeftVectorBar: "⥒", LeftVector: "↼", lEg: "⪋", leg: "⋚", leq: "≤", leqq: "≦", leqslant: "⩽", lescc: "⪨", les: "⩽", lesdot: "⩿", lesdoto: "⪁", lesdotor: "⪃", lesg: "⋚︀", lesges: "⪓", lessapprox: "⪅", lessdot: "⋖", lesseqgtr: "⋚", lesseqqgtr: "⪋", LessEqualGreater: "⋚", LessFullEqual: "≦", LessGreater: "≶", lessgtr: "≶", LessLess: "⪡", lesssim: "≲", LessSlantEqual: "⩽", LessTilde: "≲", lfisht: "⥼", lfloor: "⌊", Lfr: "𝔏", lfr: "𝔩", lg: "≶", lgE: "⪑", lHar: "⥢", lhard: "↽", lharu: "↼", lharul: "⥪", lhblk: "▄", LJcy: "Љ", ljcy: "љ", llarr: "⇇", ll: "≪", Ll: "⋘", llcorner: "⌞", Lleftarrow: "⇚", llhard: "⥫", lltri: "◺", Lmidot: "Ŀ", lmidot: "ŀ", lmoustache: "⎰", lmoust: "⎰", lnap: "⪉", lnapprox: "⪉", lne: "⪇", lnE: "≨", lneq: "⪇", lneqq: "≨", lnsim: "⋦", loang: "⟬", loarr: "⇽", lobrk: "⟦", longleftarrow: "⟵", LongLeftArrow: "⟵", Longleftarrow: "⟸", longleftrightarrow: "⟷", LongLeftRightArrow: "⟷", Longleftrightarrow: "⟺", longmapsto: "⟼", longrightarrow: "⟶", LongRightArrow: "⟶", Longrightarrow: "⟹", looparrowleft: "↫", looparrowright: "↬", lopar: "⦅", Lopf: "𝕃", lopf: "𝕝", loplus: "⨭", lotimes: "⨴", lowast: "∗", lowbar: "_", LowerLeftArrow: "↙", LowerRightArrow: "↘", loz: "◊", lozenge: "◊", lozf: "⧫", lpar: "(", lparlt: "⦓", lrarr: "⇆", lrcorner: "⌟", lrhar: "⇋", lrhard: "⥭", lrm: "‎", lrtri: "⊿", lsaquo: "‹", lscr: "𝓁", Lscr: "ℒ", lsh: "↰", Lsh: "↰", lsim: "≲", lsime: "⪍", lsimg: "⪏", lsqb: "[", lsquo: "‘", lsquor: "‚", Lstrok: "Ł", lstrok: "ł", ltcc: "⪦", ltcir: "⩹", lt: "<", LT: "<", Lt: "≪", ltdot: "⋖", lthree: "⋋", ltimes: "⋉", ltlarr: "⥶", ltquest: "⩻", ltri: "◃", ltrie: "⊴", ltrif: "◂", ltrPar: "⦖", lurdshar: "⥊", luruhar: "⥦", lvertneqq: "≨︀", lvnE: "≨︀", macr: "¯", male: "♂", malt: "✠", maltese: "✠", Map: "⤅", map: "↦", mapsto: "↦", mapstodown: "↧", mapstoleft: "↤", mapstoup: "↥", marker: "▮", mcomma: "⨩", Mcy: "М", mcy: "м", mdash: "—", mDDot: "∺", measuredangle: "∡", MediumSpace: " ", Mellintrf: "ℳ", Mfr: "𝔐", mfr: "𝔪", mho: "℧", micro: "µ", midast: "*", midcir: "⫰", mid: "∣", middot: "·", minusb: "⊟", minus: "−", minusd: "∸", minusdu: "⨪", MinusPlus: "∓", mlcp: "⫛", mldr: "…", mnplus: "∓", models: "⊧", Mopf: "𝕄", mopf: "𝕞", mp: "∓", mscr: "𝓂", Mscr: "ℳ", mstpos: "∾", Mu: "Μ", mu: "μ", multimap: "⊸", mumap: "⊸", nabla: "∇", Nacute: "Ń", nacute: "ń", nang: "∠⃒", nap: "≉", napE: "⩰̸", napid: "≋̸", napos: "ŉ", napprox: "≉", natural: "♮", naturals: "ℕ", natur: "♮", nbsp: " ", nbump: "≎̸", nbumpe: "≏̸", ncap: "⩃", Ncaron: "Ň", ncaron: "ň", Ncedil: "Ņ", ncedil: "ņ", ncong: "≇", ncongdot: "⩭̸", ncup: "⩂", Ncy: "Н", ncy: "н", ndash: "–", nearhk: "⤤", nearr: "↗", neArr: "⇗", nearrow: "↗", ne: "≠", nedot: "≐̸", NegativeMediumSpace: "​", NegativeThickSpace: "​", NegativeThinSpace: "​", NegativeVeryThinSpace: "​", nequiv: "≢", nesear: "⤨", nesim: "≂̸", NestedGreaterGreater: "≫", NestedLessLess: "≪", NewLine: `
`, nexist: "∄", nexists: "∄", Nfr: "𝔑", nfr: "𝔫", ngE: "≧̸", nge: "≱", ngeq: "≱", ngeqq: "≧̸", ngeqslant: "⩾̸", nges: "⩾̸", nGg: "⋙̸", ngsim: "≵", nGt: "≫⃒", ngt: "≯", ngtr: "≯", nGtv: "≫̸", nharr: "↮", nhArr: "⇎", nhpar: "⫲", ni: "∋", nis: "⋼", nisd: "⋺", niv: "∋", NJcy: "Њ", njcy: "њ", nlarr: "↚", nlArr: "⇍", nldr: "‥", nlE: "≦̸", nle: "≰", nleftarrow: "↚", nLeftarrow: "⇍", nleftrightarrow: "↮", nLeftrightarrow: "⇎", nleq: "≰", nleqq: "≦̸", nleqslant: "⩽̸", nles: "⩽̸", nless: "≮", nLl: "⋘̸", nlsim: "≴", nLt: "≪⃒", nlt: "≮", nltri: "⋪", nltrie: "⋬", nLtv: "≪̸", nmid: "∤", NoBreak: "⁠", NonBreakingSpace: " ", nopf: "𝕟", Nopf: "ℕ", Not: "⫬", not: "¬", NotCongruent: "≢", NotCupCap: "≭", NotDoubleVerticalBar: "∦", NotElement: "∉", NotEqual: "≠", NotEqualTilde: "≂̸", NotExists: "∄", NotGreater: "≯", NotGreaterEqual: "≱", NotGreaterFullEqual: "≧̸", NotGreaterGreater: "≫̸", NotGreaterLess: "≹", NotGreaterSlantEqual: "⩾̸", NotGreaterTilde: "≵", NotHumpDownHump: "≎̸", NotHumpEqual: "≏̸", notin: "∉", notindot: "⋵̸", notinE: "⋹̸", notinva: "∉", notinvb: "⋷", notinvc: "⋶", NotLeftTriangleBar: "⧏̸", NotLeftTriangle: "⋪", NotLeftTriangleEqual: "⋬", NotLess: "≮", NotLessEqual: "≰", NotLessGreater: "≸", NotLessLess: "≪̸", NotLessSlantEqual: "⩽̸", NotLessTilde: "≴", NotNestedGreaterGreater: "⪢̸", NotNestedLessLess: "⪡̸", notni: "∌", notniva: "∌", notnivb: "⋾", notnivc: "⋽", NotPrecedes: "⊀", NotPrecedesEqual: "⪯̸", NotPrecedesSlantEqual: "⋠", NotReverseElement: "∌", NotRightTriangleBar: "⧐̸", NotRightTriangle: "⋫", NotRightTriangleEqual: "⋭", NotSquareSubset: "⊏̸", NotSquareSubsetEqual: "⋢", NotSquareSuperset: "⊐̸", NotSquareSupersetEqual: "⋣", NotSubset: "⊂⃒", NotSubsetEqual: "⊈", NotSucceeds: "⊁", NotSucceedsEqual: "⪰̸", NotSucceedsSlantEqual: "⋡", NotSucceedsTilde: "≿̸", NotSuperset: "⊃⃒", NotSupersetEqual: "⊉", NotTilde: "≁", NotTildeEqual: "≄", NotTildeFullEqual: "≇", NotTildeTilde: "≉", NotVerticalBar: "∤", nparallel: "∦", npar: "∦", nparsl: "⫽⃥", npart: "∂̸", npolint: "⨔", npr: "⊀", nprcue: "⋠", nprec: "⊀", npreceq: "⪯̸", npre: "⪯̸", nrarrc: "⤳̸", nrarr: "↛", nrArr: "⇏", nrarrw: "↝̸", nrightarrow: "↛", nRightarrow: "⇏", nrtri: "⋫", nrtrie: "⋭", nsc: "⊁", nsccue: "⋡", nsce: "⪰̸", Nscr: "𝒩", nscr: "𝓃", nshortmid: "∤", nshortparallel: "∦", nsim: "≁", nsime: "≄", nsimeq: "≄", nsmid: "∤", nspar: "∦", nsqsube: "⋢", nsqsupe: "⋣", nsub: "⊄", nsubE: "⫅̸", nsube: "⊈", nsubset: "⊂⃒", nsubseteq: "⊈", nsubseteqq: "⫅̸", nsucc: "⊁", nsucceq: "⪰̸", nsup: "⊅", nsupE: "⫆̸", nsupe: "⊉", nsupset: "⊃⃒", nsupseteq: "⊉", nsupseteqq: "⫆̸", ntgl: "≹", Ntilde: "Ñ", ntilde: "ñ", ntlg: "≸", ntriangleleft: "⋪", ntrianglelefteq: "⋬", ntriangleright: "⋫", ntrianglerighteq: "⋭", Nu: "Ν", nu: "ν", num: "#", numero: "№", numsp: " ", nvap: "≍⃒", nvdash: "⊬", nvDash: "⊭", nVdash: "⊮", nVDash: "⊯", nvge: "≥⃒", nvgt: ">⃒", nvHarr: "⤄", nvinfin: "⧞", nvlArr: "⤂", nvle: "≤⃒", nvlt: "<⃒", nvltrie: "⊴⃒", nvrArr: "⤃", nvrtrie: "⊵⃒", nvsim: "∼⃒", nwarhk: "⤣", nwarr: "↖", nwArr: "⇖", nwarrow: "↖", nwnear: "⤧", Oacute: "Ó", oacute: "ó", oast: "⊛", Ocirc: "Ô", ocirc: "ô", ocir: "⊚", Ocy: "О", ocy: "о", odash: "⊝", Odblac: "Ő", odblac: "ő", odiv: "⨸", odot: "⊙", odsold: "⦼", OElig: "Œ", oelig: "œ", ofcir: "⦿", Ofr: "𝔒", ofr: "𝔬", ogon: "˛", Ograve: "Ò", ograve: "ò", ogt: "⧁", ohbar: "⦵", ohm: "Ω", oint: "∮", olarr: "↺", olcir: "⦾", olcross: "⦻", oline: "‾", olt: "⧀", Omacr: "Ō", omacr: "ō", Omega: "Ω", omega: "ω", Omicron: "Ο", omicron: "ο", omid: "⦶", ominus: "⊖", Oopf: "𝕆", oopf: "𝕠", opar: "⦷", OpenCurlyDoubleQuote: "“", OpenCurlyQuote: "‘", operp: "⦹", oplus: "⊕", orarr: "↻", Or: "⩔", or: "∨", ord: "⩝", order: "ℴ", orderof: "ℴ", ordf: "ª", ordm: "º", origof: "⊶", oror: "⩖", orslope: "⩗", orv: "⩛", oS: "Ⓢ", Oscr: "𝒪", oscr: "ℴ", Oslash: "Ø", oslash: "ø", osol: "⊘", Otilde: "Õ", otilde: "õ", otimesas: "⨶", Otimes: "⨷", otimes: "⊗", Ouml: "Ö", ouml: "ö", ovbar: "⌽", OverBar: "‾", OverBrace: "⏞", OverBracket: "⎴", OverParenthesis: "⏜", para: "¶", parallel: "∥", par: "∥", parsim: "⫳", parsl: "⫽", part: "∂", PartialD: "∂", Pcy: "П", pcy: "п", percnt: "%", period: ".", permil: "‰", perp: "⊥", pertenk: "‱", Pfr: "𝔓", pfr: "𝔭", Phi: "Φ", phi: "φ", phiv: "ϕ", phmmat: "ℳ", phone: "☎", Pi: "Π", pi: "π", pitchfork: "⋔", piv: "ϖ", planck: "ℏ", planckh: "ℎ", plankv: "ℏ", plusacir: "⨣", plusb: "⊞", pluscir: "⨢", plus: "+", plusdo: "∔", plusdu: "⨥", pluse: "⩲", PlusMinus: "±", plusmn: "±", plussim: "⨦", plustwo: "⨧", pm: "±", Poincareplane: "ℌ", pointint: "⨕", popf: "𝕡", Popf: "ℙ", pound: "£", prap: "⪷", Pr: "⪻", pr: "≺", prcue: "≼", precapprox: "⪷", prec: "≺", preccurlyeq: "≼", Precedes: "≺", PrecedesEqual: "⪯", PrecedesSlantEqual: "≼", PrecedesTilde: "≾", preceq: "⪯", precnapprox: "⪹", precneqq: "⪵", precnsim: "⋨", pre: "⪯", prE: "⪳", precsim: "≾", prime: "′", Prime: "″", primes: "ℙ", prnap: "⪹", prnE: "⪵", prnsim: "⋨", prod: "∏", Product: "∏", profalar: "⌮", profline: "⌒", profsurf: "⌓", prop: "∝", Proportional: "∝", Proportion: "∷", propto: "∝", prsim: "≾", prurel: "⊰", Pscr: "𝒫", pscr: "𝓅", Psi: "Ψ", psi: "ψ", puncsp: " ", Qfr: "𝔔", qfr: "𝔮", qint: "⨌", qopf: "𝕢", Qopf: "ℚ", qprime: "⁗", Qscr: "𝒬", qscr: "𝓆", quaternions: "ℍ", quatint: "⨖", quest: "?", questeq: "≟", quot: '"', QUOT: '"', rAarr: "⇛", race: "∽̱", Racute: "Ŕ", racute: "ŕ", radic: "√", raemptyv: "⦳", rang: "⟩", Rang: "⟫", rangd: "⦒", range: "⦥", rangle: "⟩", raquo: "»", rarrap: "⥵", rarrb: "⇥", rarrbfs: "⤠", rarrc: "⤳", rarr: "→", Rarr: "↠", rArr: "⇒", rarrfs: "⤞", rarrhk: "↪", rarrlp: "↬", rarrpl: "⥅", rarrsim: "⥴", Rarrtl: "⤖", rarrtl: "↣", rarrw: "↝", ratail: "⤚", rAtail: "⤜", ratio: "∶", rationals: "ℚ", rbarr: "⤍", rBarr: "⤏", RBarr: "⤐", rbbrk: "❳", rbrace: "}", rbrack: "]", rbrke: "⦌", rbrksld: "⦎", rbrkslu: "⦐", Rcaron: "Ř", rcaron: "ř", Rcedil: "Ŗ", rcedil: "ŗ", rceil: "⌉", rcub: "}", Rcy: "Р", rcy: "р", rdca: "⤷", rdldhar: "⥩", rdquo: "”", rdquor: "”", rdsh: "↳", real: "ℜ", realine: "ℛ", realpart: "ℜ", reals: "ℝ", Re: "ℜ", rect: "▭", reg: "®", REG: "®", ReverseElement: "∋", ReverseEquilibrium: "⇋", ReverseUpEquilibrium: "⥯", rfisht: "⥽", rfloor: "⌋", rfr: "𝔯", Rfr: "ℜ", rHar: "⥤", rhard: "⇁", rharu: "⇀", rharul: "⥬", Rho: "Ρ", rho: "ρ", rhov: "ϱ", RightAngleBracket: "⟩", RightArrowBar: "⇥", rightarrow: "→", RightArrow: "→", Rightarrow: "⇒", RightArrowLeftArrow: "⇄", rightarrowtail: "↣", RightCeiling: "⌉", RightDoubleBracket: "⟧", RightDownTeeVector: "⥝", RightDownVectorBar: "⥕", RightDownVector: "⇂", RightFloor: "⌋", rightharpoondown: "⇁", rightharpoonup: "⇀", rightleftarrows: "⇄", rightleftharpoons: "⇌", rightrightarrows: "⇉", rightsquigarrow: "↝", RightTeeArrow: "↦", RightTee: "⊢", RightTeeVector: "⥛", rightthreetimes: "⋌", RightTriangleBar: "⧐", RightTriangle: "⊳", RightTriangleEqual: "⊵", RightUpDownVector: "⥏", RightUpTeeVector: "⥜", RightUpVectorBar: "⥔", RightUpVector: "↾", RightVectorBar: "⥓", RightVector: "⇀", ring: "˚", risingdotseq: "≓", rlarr: "⇄", rlhar: "⇌", rlm: "‏", rmoustache: "⎱", rmoust: "⎱", rnmid: "⫮", roang: "⟭", roarr: "⇾", robrk: "⟧", ropar: "⦆", ropf: "𝕣", Ropf: "ℝ", roplus: "⨮", rotimes: "⨵", RoundImplies: "⥰", rpar: ")", rpargt: "⦔", rppolint: "⨒", rrarr: "⇉", Rrightarrow: "⇛", rsaquo: "›", rscr: "𝓇", Rscr: "ℛ", rsh: "↱", Rsh: "↱", rsqb: "]", rsquo: "’", rsquor: "’", rthree: "⋌", rtimes: "⋊", rtri: "▹", rtrie: "⊵", rtrif: "▸", rtriltri: "⧎", RuleDelayed: "⧴", ruluhar: "⥨", rx: "℞", Sacute: "Ś", sacute: "ś", sbquo: "‚", scap: "⪸", Scaron: "Š", scaron: "š", Sc: "⪼", sc: "≻", sccue: "≽", sce: "⪰", scE: "⪴", Scedil: "Ş", scedil: "ş", Scirc: "Ŝ", scirc: "ŝ", scnap: "⪺", scnE: "⪶", scnsim: "⋩", scpolint: "⨓", scsim: "≿", Scy: "С", scy: "с", sdotb: "⊡", sdot: "⋅", sdote: "⩦", searhk: "⤥", searr: "↘", seArr: "⇘", searrow: "↘", sect: "§", semi: ";", seswar: "⤩", setminus: "∖", setmn: "∖", sext: "✶", Sfr: "𝔖", sfr: "𝔰", sfrown: "⌢", sharp: "♯", SHCHcy: "Щ", shchcy: "щ", SHcy: "Ш", shcy: "ш", ShortDownArrow: "↓", ShortLeftArrow: "←", shortmid: "∣", shortparallel: "∥", ShortRightArrow: "→", ShortUpArrow: "↑", shy: "­", Sigma: "Σ", sigma: "σ", sigmaf: "ς", sigmav: "ς", sim: "∼", simdot: "⩪", sime: "≃", simeq: "≃", simg: "⪞", simgE: "⪠", siml: "⪝", simlE: "⪟", simne: "≆", simplus: "⨤", simrarr: "⥲", slarr: "←", SmallCircle: "∘", smallsetminus: "∖", smashp: "⨳", smeparsl: "⧤", smid: "∣", smile: "⌣", smt: "⪪", smte: "⪬", smtes: "⪬︀", SOFTcy: "Ь", softcy: "ь", solbar: "⌿", solb: "⧄", sol: "/", Sopf: "𝕊", sopf: "𝕤", spades: "♠", spadesuit: "♠", spar: "∥", sqcap: "⊓", sqcaps: "⊓︀", sqcup: "⊔", sqcups: "⊔︀", Sqrt: "√", sqsub: "⊏", sqsube: "⊑", sqsubset: "⊏", sqsubseteq: "⊑", sqsup: "⊐", sqsupe: "⊒", sqsupset: "⊐", sqsupseteq: "⊒", square: "□", Square: "□", SquareIntersection: "⊓", SquareSubset: "⊏", SquareSubsetEqual: "⊑", SquareSuperset: "⊐", SquareSupersetEqual: "⊒", SquareUnion: "⊔", squarf: "▪", squ: "□", squf: "▪", srarr: "→", Sscr: "𝒮", sscr: "𝓈", ssetmn: "∖", ssmile: "⌣", sstarf: "⋆", Star: "⋆", star: "☆", starf: "★", straightepsilon: "ϵ", straightphi: "ϕ", strns: "¯", sub: "⊂", Sub: "⋐", subdot: "⪽", subE: "⫅", sube: "⊆", subedot: "⫃", submult: "⫁", subnE: "⫋", subne: "⊊", subplus: "⪿", subrarr: "⥹", subset: "⊂", Subset: "⋐", subseteq: "⊆", subseteqq: "⫅", SubsetEqual: "⊆", subsetneq: "⊊", subsetneqq: "⫋", subsim: "⫇", subsub: "⫕", subsup: "⫓", succapprox: "⪸", succ: "≻", succcurlyeq: "≽", Succeeds: "≻", SucceedsEqual: "⪰", SucceedsSlantEqual: "≽", SucceedsTilde: "≿", succeq: "⪰", succnapprox: "⪺", succneqq: "⪶", succnsim: "⋩", succsim: "≿", SuchThat: "∋", sum: "∑", Sum: "∑", sung: "♪", sup1: "¹", sup2: "²", sup3: "³", sup: "⊃", Sup: "⋑", supdot: "⪾", supdsub: "⫘", supE: "⫆", supe: "⊇", supedot: "⫄", Superset: "⊃", SupersetEqual: "⊇", suphsol: "⟉", suphsub: "⫗", suplarr: "⥻", supmult: "⫂", supnE: "⫌", supne: "⊋", supplus: "⫀", supset: "⊃", Supset: "⋑", supseteq: "⊇", supseteqq: "⫆", supsetneq: "⊋", supsetneqq: "⫌", supsim: "⫈", supsub: "⫔", supsup: "⫖", swarhk: "⤦", swarr: "↙", swArr: "⇙", swarrow: "↙", swnwar: "⤪", szlig: "ß", Tab: "	", target: "⌖", Tau: "Τ", tau: "τ", tbrk: "⎴", Tcaron: "Ť", tcaron: "ť", Tcedil: "Ţ", tcedil: "ţ", Tcy: "Т", tcy: "т", tdot: "⃛", telrec: "⌕", Tfr: "𝔗", tfr: "𝔱", there4: "∴", therefore: "∴", Therefore: "∴", Theta: "Θ", theta: "θ", thetasym: "ϑ", thetav: "ϑ", thickapprox: "≈", thicksim: "∼", ThickSpace: "  ", ThinSpace: " ", thinsp: " ", thkap: "≈", thksim: "∼", THORN: "Þ", thorn: "þ", tilde: "˜", Tilde: "∼", TildeEqual: "≃", TildeFullEqual: "≅", TildeTilde: "≈", timesbar: "⨱", timesb: "⊠", times: "×", timesd: "⨰", tint: "∭", toea: "⤨", topbot: "⌶", topcir: "⫱", top: "⊤", Topf: "𝕋", topf: "𝕥", topfork: "⫚", tosa: "⤩", tprime: "‴", trade: "™", TRADE: "™", triangle: "▵", triangledown: "▿", triangleleft: "◃", trianglelefteq: "⊴", triangleq: "≜", triangleright: "▹", trianglerighteq: "⊵", tridot: "◬", trie: "≜", triminus: "⨺", TripleDot: "⃛", triplus: "⨹", trisb: "⧍", tritime: "⨻", trpezium: "⏢", Tscr: "𝒯", tscr: "𝓉", TScy: "Ц", tscy: "ц", TSHcy: "Ћ", tshcy: "ћ", Tstrok: "Ŧ", tstrok: "ŧ", twixt: "≬", twoheadleftarrow: "↞", twoheadrightarrow: "↠", Uacute: "Ú", uacute: "ú", uarr: "↑", Uarr: "↟", uArr: "⇑", Uarrocir: "⥉", Ubrcy: "Ў", ubrcy: "ў", Ubreve: "Ŭ", ubreve: "ŭ", Ucirc: "Û", ucirc: "û", Ucy: "У", ucy: "у", udarr: "⇅", Udblac: "Ű", udblac: "ű", udhar: "⥮", ufisht: "⥾", Ufr: "𝔘", ufr: "𝔲", Ugrave: "Ù", ugrave: "ù", uHar: "⥣", uharl: "↿", uharr: "↾", uhblk: "▀", ulcorn: "⌜", ulcorner: "⌜", ulcrop: "⌏", ultri: "◸", Umacr: "Ū", umacr: "ū", uml: "¨", UnderBar: "_", UnderBrace: "⏟", UnderBracket: "⎵", UnderParenthesis: "⏝", Union: "⋃", UnionPlus: "⊎", Uogon: "Ų", uogon: "ų", Uopf: "𝕌", uopf: "𝕦", UpArrowBar: "⤒", uparrow: "↑", UpArrow: "↑", Uparrow: "⇑", UpArrowDownArrow: "⇅", updownarrow: "↕", UpDownArrow: "↕", Updownarrow: "⇕", UpEquilibrium: "⥮", upharpoonleft: "↿", upharpoonright: "↾", uplus: "⊎", UpperLeftArrow: "↖", UpperRightArrow: "↗", upsi: "υ", Upsi: "ϒ", upsih: "ϒ", Upsilon: "Υ", upsilon: "υ", UpTeeArrow: "↥", UpTee: "⊥", upuparrows: "⇈", urcorn: "⌝", urcorner: "⌝", urcrop: "⌎", Uring: "Ů", uring: "ů", urtri: "◹", Uscr: "𝒰", uscr: "𝓊", utdot: "⋰", Utilde: "Ũ", utilde: "ũ", utri: "▵", utrif: "▴", uuarr: "⇈", Uuml: "Ü", uuml: "ü", uwangle: "⦧", vangrt: "⦜", varepsilon: "ϵ", varkappa: "ϰ", varnothing: "∅", varphi: "ϕ", varpi: "ϖ", varpropto: "∝", varr: "↕", vArr: "⇕", varrho: "ϱ", varsigma: "ς", varsubsetneq: "⊊︀", varsubsetneqq: "⫋︀", varsupsetneq: "⊋︀", varsupsetneqq: "⫌︀", vartheta: "ϑ", vartriangleleft: "⊲", vartriangleright: "⊳", vBar: "⫨", Vbar: "⫫", vBarv: "⫩", Vcy: "В", vcy: "в", vdash: "⊢", vDash: "⊨", Vdash: "⊩", VDash: "⊫", Vdashl: "⫦", veebar: "⊻", vee: "∨", Vee: "⋁", veeeq: "≚", vellip: "⋮", verbar: "|", Verbar: "‖", vert: "|", Vert: "‖", VerticalBar: "∣", VerticalLine: "|", VerticalSeparator: "❘", VerticalTilde: "≀", VeryThinSpace: " ", Vfr: "𝔙", vfr: "𝔳", vltri: "⊲", vnsub: "⊂⃒", vnsup: "⊃⃒", Vopf: "𝕍", vopf: "𝕧", vprop: "∝", vrtri: "⊳", Vscr: "𝒱", vscr: "𝓋", vsubnE: "⫋︀", vsubne: "⊊︀", vsupnE: "⫌︀", vsupne: "⊋︀", Vvdash: "⊪", vzigzag: "⦚", Wcirc: "Ŵ", wcirc: "ŵ", wedbar: "⩟", wedge: "∧", Wedge: "⋀", wedgeq: "≙", weierp: "℘", Wfr: "𝔚", wfr: "𝔴", Wopf: "𝕎", wopf: "𝕨", wp: "℘", wr: "≀", wreath: "≀", Wscr: "𝒲", wscr: "𝓌", xcap: "⋂", xcirc: "◯", xcup: "⋃", xdtri: "▽", Xfr: "𝔛", xfr: "𝔵", xharr: "⟷", xhArr: "⟺", Xi: "Ξ", xi: "ξ", xlarr: "⟵", xlArr: "⟸", xmap: "⟼", xnis: "⋻", xodot: "⨀", Xopf: "𝕏", xopf: "𝕩", xoplus: "⨁", xotime: "⨂", xrarr: "⟶", xrArr: "⟹", Xscr: "𝒳", xscr: "𝓍", xsqcup: "⨆", xuplus: "⨄", xutri: "△", xvee: "⋁", xwedge: "⋀", Yacute: "Ý", yacute: "ý", YAcy: "Я", yacy: "я", Ycirc: "Ŷ", ycirc: "ŷ", Ycy: "Ы", ycy: "ы", yen: "¥", Yfr: "𝔜", yfr: "𝔶", YIcy: "Ї", yicy: "ї", Yopf: "𝕐", yopf: "𝕪", Yscr: "𝒴", yscr: "𝓎", YUcy: "Ю", yucy: "ю", yuml: "ÿ", Yuml: "Ÿ", Zacute: "Ź", zacute: "ź", Zcaron: "Ž", zcaron: "ž", Zcy: "З", zcy: "з", Zdot: "Ż", zdot: "ż", zeetrf: "ℨ", ZeroWidthSpace: "​", Zeta: "Ζ", zeta: "ζ", zfr: "𝔷", Zfr: "ℨ", ZHcy: "Ж", zhcy: "ж", zigrarr: "⇝", zopf: "𝕫", Zopf: "ℤ", Zscr: "𝒵", zscr: "𝓏", zwj: "‍", zwnj: "‌" };
} }), require_legacy = __commonJS$4({ "../../node_modules/ansi-to-html/node_modules/entities/lib/maps/legacy.json"(T, S) {
  S.exports = { Aacute: "Á", aacute: "á", Acirc: "Â", acirc: "â", acute: "´", AElig: "Æ", aelig: "æ", Agrave: "À", agrave: "à", amp: "&", AMP: "&", Aring: "Å", aring: "å", Atilde: "Ã", atilde: "ã", Auml: "Ä", auml: "ä", brvbar: "¦", Ccedil: "Ç", ccedil: "ç", cedil: "¸", cent: "¢", copy: "©", COPY: "©", curren: "¤", deg: "°", divide: "÷", Eacute: "É", eacute: "é", Ecirc: "Ê", ecirc: "ê", Egrave: "È", egrave: "è", ETH: "Ð", eth: "ð", Euml: "Ë", euml: "ë", frac12: "½", frac14: "¼", frac34: "¾", gt: ">", GT: ">", Iacute: "Í", iacute: "í", Icirc: "Î", icirc: "î", iexcl: "¡", Igrave: "Ì", igrave: "ì", iquest: "¿", Iuml: "Ï", iuml: "ï", laquo: "«", lt: "<", LT: "<", macr: "¯", micro: "µ", middot: "·", nbsp: " ", not: "¬", Ntilde: "Ñ", ntilde: "ñ", Oacute: "Ó", oacute: "ó", Ocirc: "Ô", ocirc: "ô", Ograve: "Ò", ograve: "ò", ordf: "ª", ordm: "º", Oslash: "Ø", oslash: "ø", Otilde: "Õ", otilde: "õ", Ouml: "Ö", ouml: "ö", para: "¶", plusmn: "±", pound: "£", quot: '"', QUOT: '"', raquo: "»", reg: "®", REG: "®", sect: "§", shy: "­", sup1: "¹", sup2: "²", sup3: "³", szlig: "ß", THORN: "Þ", thorn: "þ", times: "×", Uacute: "Ú", uacute: "ú", Ucirc: "Û", ucirc: "û", Ugrave: "Ù", ugrave: "ù", uml: "¨", Uuml: "Ü", uuml: "ü", Yacute: "Ý", yacute: "ý", yen: "¥", yuml: "ÿ" };
} }), require_xml$1 = __commonJS$4({ "../../node_modules/ansi-to-html/node_modules/entities/lib/maps/xml.json"(T, S) {
  S.exports = { amp: "&", apos: "'", gt: ">", lt: "<", quot: '"' };
} }), require_decode = __commonJS$4({ "../../node_modules/ansi-to-html/node_modules/entities/lib/maps/decode.json"(T, S) {
  S.exports = { 0: 65533, 128: 8364, 130: 8218, 131: 402, 132: 8222, 133: 8230, 134: 8224, 135: 8225, 136: 710, 137: 8240, 138: 352, 139: 8249, 140: 338, 142: 381, 145: 8216, 146: 8217, 147: 8220, 148: 8221, 149: 8226, 150: 8211, 151: 8212, 152: 732, 153: 8482, 154: 353, 155: 8250, 156: 339, 158: 382, 159: 376 };
} }), require_decode_codepoint = __commonJS$4({ "../../node_modules/ansi-to-html/node_modules/entities/lib/decode_codepoint.js"(T) {
  var S = T && T.__importDefault || function(L) {
    return L && L.__esModule ? L : { default: L };
  };
  Object.defineProperty(T, "__esModule", { value: !0 });
  var R = S(require_decode()), k = String.fromCodePoint || function(L) {
    var V = "";
    return L > 65535 && (L -= 65536, V += String.fromCharCode(L >>> 10 & 1023 | 55296), L = 56320 | L & 1023), V += String.fromCharCode(L), V;
  };
  function D(L) {
    return L >= 55296 && L <= 57343 || L > 1114111 ? "�" : (L in R.default && (L = R.default[L]), k(L));
  }
  T.default = D;
} }), require_decode2 = __commonJS$4({ "../../node_modules/ansi-to-html/node_modules/entities/lib/decode.js"(T) {
  var S = T && T.__importDefault || function(q) {
    return q && q.__esModule ? q : { default: q };
  };
  Object.defineProperty(T, "__esModule", { value: !0 }), T.decodeHTML = T.decodeHTMLStrict = T.decodeXML = void 0;
  var R = S(require_entities()), k = S(require_legacy()), D = S(require_xml$1()), L = S(require_decode_codepoint()), V = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
  T.decodeXML = z(D.default), T.decodeHTMLStrict = z(R.default);
  function z(q) {
    var K = U(q);
    return function(Y) {
      return String(Y).replace(V, K);
    };
  }
  var W = function(q, K) {
    return q < K ? 1 : -1;
  };
  T.decodeHTML = function() {
    for (var q = Object.keys(k.default).sort(W), K = Object.keys(R.default).sort(W), Y = 0, J = 0; Y < K.length; Y++) q[J] === K[Y] ? (K[Y] += ";?", J++) : K[Y] += ";";
    var Z = new RegExp("&(?:" + K.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"), X = U(R.default);
    function ee(te) {
      return te.substr(-1) !== ";" && (te += ";"), X(te);
    }
    return function(te) {
      return String(te).replace(Z, ee);
    };
  }();
  function U(q) {
    return function(K) {
      if (K.charAt(1) === "#") {
        var Y = K.charAt(2);
        return Y === "X" || Y === "x" ? L.default(parseInt(K.substr(3), 16)) : L.default(parseInt(K.substr(2), 10));
      }
      return q[K.slice(1, -1)] || K;
    };
  }
} }), require_encode = __commonJS$4({ "../../node_modules/ansi-to-html/node_modules/entities/lib/encode.js"(T) {
  var S = T && T.__importDefault || function(re) {
    return re && re.__esModule ? re : { default: re };
  };
  Object.defineProperty(T, "__esModule", { value: !0 }), T.escapeUTF8 = T.escape = T.encodeNonAsciiHTML = T.encodeHTML = T.encodeXML = void 0;
  var R = S(require_xml$1()), k = W(R.default), D = U(k);
  T.encodeXML = te(k);
  var L = S(require_entities()), V = W(L.default), z = U(V);
  T.encodeHTML = J(V, z), T.encodeNonAsciiHTML = te(V);
  function W(re) {
    return Object.keys(re).sort().reduce(function(Q, ne) {
      return Q[re[ne]] = "&" + ne + ";", Q;
    }, {});
  }
  function U(re) {
    for (var Q = [], ne = [], oe = 0, ae = Object.keys(re); oe < ae.length; oe++) {
      var se = ae[oe];
      se.length === 1 ? Q.push("\\" + se) : ne.push(se);
    }
    Q.sort();
    for (var ie = 0; ie < Q.length - 1; ie++) {
      for (var he = ie; he < Q.length - 1 && Q[he].charCodeAt(1) + 1 === Q[he + 1].charCodeAt(1); ) he += 1;
      var xe = 1 + he - ie;
      xe < 3 || Q.splice(ie, xe, Q[ie] + "-" + Q[he]);
    }
    return ne.unshift("[" + Q.join("") + "]"), new RegExp(ne.join("|"), "g");
  }
  var q = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, K = String.prototype.codePointAt != null ? function(re) {
    return re.codePointAt(0);
  } : function(re) {
    return (re.charCodeAt(0) - 55296) * 1024 + re.charCodeAt(1) - 56320 + 65536;
  };
  function Y(re) {
    return "&#x" + (re.length > 1 ? K(re) : re.charCodeAt(0)).toString(16).toUpperCase() + ";";
  }
  function J(re, Q) {
    return function(ne) {
      return ne.replace(Q, function(oe) {
        return re[oe];
      }).replace(q, Y);
    };
  }
  var Z = new RegExp(D.source + "|" + q.source, "g");
  function X(re) {
    return re.replace(Z, Y);
  }
  T.escape = X;
  function ee(re) {
    return re.replace(D, Y);
  }
  T.escapeUTF8 = ee;
  function te(re) {
    return function(Q) {
      return Q.replace(Z, function(ne) {
        return re[ne] || Y(ne);
      });
    };
  }
} }), require_lib = __commonJS$4({ "../../node_modules/ansi-to-html/node_modules/entities/lib/index.js"(T) {
  Object.defineProperty(T, "__esModule", { value: !0 }), T.decodeXMLStrict = T.decodeHTML5Strict = T.decodeHTML4Strict = T.decodeHTML5 = T.decodeHTML4 = T.decodeHTMLStrict = T.decodeHTML = T.decodeXML = T.encodeHTML5 = T.encodeHTML4 = T.escapeUTF8 = T.escape = T.encodeNonAsciiHTML = T.encodeHTML = T.encodeXML = T.encode = T.decodeStrict = T.decode = void 0;
  var S = require_decode2(), R = require_encode();
  function k(W, U) {
    return (!U || U <= 0 ? S.decodeXML : S.decodeHTML)(W);
  }
  T.decode = k;
  function D(W, U) {
    return (!U || U <= 0 ? S.decodeXML : S.decodeHTMLStrict)(W);
  }
  T.decodeStrict = D;
  function L(W, U) {
    return (!U || U <= 0 ? R.encodeXML : R.encodeHTML)(W);
  }
  T.encode = L;
  var V = require_encode();
  Object.defineProperty(T, "encodeXML", { enumerable: !0, get: function() {
    return V.encodeXML;
  } }), Object.defineProperty(T, "encodeHTML", { enumerable: !0, get: function() {
    return V.encodeHTML;
  } }), Object.defineProperty(T, "encodeNonAsciiHTML", { enumerable: !0, get: function() {
    return V.encodeNonAsciiHTML;
  } }), Object.defineProperty(T, "escape", { enumerable: !0, get: function() {
    return V.escape;
  } }), Object.defineProperty(T, "escapeUTF8", { enumerable: !0, get: function() {
    return V.escapeUTF8;
  } }), Object.defineProperty(T, "encodeHTML4", { enumerable: !0, get: function() {
    return V.encodeHTML;
  } }), Object.defineProperty(T, "encodeHTML5", { enumerable: !0, get: function() {
    return V.encodeHTML;
  } });
  var z = require_decode2();
  Object.defineProperty(T, "decodeXML", { enumerable: !0, get: function() {
    return z.decodeXML;
  } }), Object.defineProperty(T, "decodeHTML", { enumerable: !0, get: function() {
    return z.decodeHTML;
  } }), Object.defineProperty(T, "decodeHTMLStrict", { enumerable: !0, get: function() {
    return z.decodeHTMLStrict;
  } }), Object.defineProperty(T, "decodeHTML4", { enumerable: !0, get: function() {
    return z.decodeHTML;
  } }), Object.defineProperty(T, "decodeHTML5", { enumerable: !0, get: function() {
    return z.decodeHTML;
  } }), Object.defineProperty(T, "decodeHTML4Strict", { enumerable: !0, get: function() {
    return z.decodeHTMLStrict;
  } }), Object.defineProperty(T, "decodeHTML5Strict", { enumerable: !0, get: function() {
    return z.decodeHTMLStrict;
  } }), Object.defineProperty(T, "decodeXMLStrict", { enumerable: !0, get: function() {
    return z.decodeXML;
  } });
} }), require_ansi_to_html = __commonJS$4({ "../../node_modules/ansi-to-html/lib/ansi_to_html.js"(T, S) {
  function R(Te, fe) {
    if (!(Te instanceof fe)) throw new TypeError("Cannot call a class as a function");
  }
  function k(Te, fe) {
    for (var ue = 0; ue < fe.length; ue++) {
      var Ce = fe[ue];
      Ce.enumerable = Ce.enumerable || !1, Ce.configurable = !0, "value" in Ce && (Ce.writable = !0), Object.defineProperty(Te, Ce.key, Ce);
    }
  }
  function D(Te, fe, ue) {
    return fe && k(Te.prototype, fe), Te;
  }
  function L(Te) {
    if (typeof Symbol > "u" || Te[Symbol.iterator] == null) {
      if (Array.isArray(Te) || (Te = V(Te))) {
        var fe = 0, ue = function() {
        };
        return { s: ue, n: function() {
          return fe >= Te.length ? { done: !0 } : { done: !1, value: Te[fe++] };
        }, e: function(ge) {
          throw ge;
        }, f: ue };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var Ce, ce = !0, pe = !1, _e;
    return { s: function() {
      Ce = Te[Symbol.iterator]();
    }, n: function() {
      var ge = Ce.next();
      return ce = ge.done, ge;
    }, e: function(ge) {
      pe = !0, _e = ge;
    }, f: function() {
      try {
        !ce && Ce.return != null && Ce.return();
      } finally {
        if (pe) throw _e;
      }
    } };
  }
  function V(Te, fe) {
    if (Te) {
      if (typeof Te == "string") return z(Te, fe);
      var ue = Object.prototype.toString.call(Te).slice(8, -1);
      if (ue === "Object" && Te.constructor && (ue = Te.constructor.name), ue === "Map" || ue === "Set") return Array.from(ue);
      if (ue === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ue)) return z(Te, fe);
    }
  }
  function z(Te, fe) {
    (fe == null || fe > Te.length) && (fe = Te.length);
    for (var ue = 0, Ce = new Array(fe); ue < fe; ue++) Ce[ue] = Te[ue];
    return Ce;
  }
  var W = require_lib(), U = { fg: "#FFF", bg: "#000", newline: !1, escapeXML: !1, stream: !1, colors: q() };
  function q() {
    var Te = { 0: "#000", 1: "#A00", 2: "#0A0", 3: "#A50", 4: "#00A", 5: "#A0A", 6: "#0AA", 7: "#AAA", 8: "#555", 9: "#F55", 10: "#5F5", 11: "#FF5", 12: "#55F", 13: "#F5F", 14: "#5FF", 15: "#FFF" };
    return re(0, 5).forEach(function(fe) {
      re(0, 5).forEach(function(ue) {
        re(0, 5).forEach(function(Ce) {
          return K(fe, ue, Ce, Te);
        });
      });
    }), re(0, 23).forEach(function(fe) {
      var ue = fe + 232, Ce = Y(fe * 10 + 8);
      Te[ue] = "#" + Ce + Ce + Ce;
    }), Te;
  }
  function K(Te, fe, ue, Ce) {
    var ce = 16 + Te * 36 + fe * 6 + ue, pe = Te > 0 ? Te * 40 + 55 : 0, _e = fe > 0 ? fe * 40 + 55 : 0, ge = ue > 0 ? ue * 40 + 55 : 0;
    Ce[ce] = J([pe, _e, ge]);
  }
  function Y(Te) {
    for (var fe = Te.toString(16); fe.length < 2; ) fe = "0" + fe;
    return fe;
  }
  function J(Te) {
    var fe = [], ue = L(Te), Ce;
    try {
      for (ue.s(); !(Ce = ue.n()).done; ) {
        var ce = Ce.value;
        fe.push(Y(ce));
      }
    } catch (pe) {
      ue.e(pe);
    } finally {
      ue.f();
    }
    return "#" + fe.join("");
  }
  function Z(Te, fe, ue, Ce) {
    var ce;
    return fe === "text" ? ce = oe(ue, Ce) : fe === "display" ? ce = ee(Te, ue, Ce) : fe === "xterm256" ? ce = ie(Te, Ce.colors[ue]) : fe === "rgb" && (ce = X(Te, ue)), ce;
  }
  function X(Te, fe) {
    fe = fe.substring(2).slice(0, -1);
    var ue = +fe.substr(0, 2), Ce = fe.substring(5).split(";"), ce = Ce.map(function(pe) {
      return ("0" + Number(pe).toString(16)).substr(-2);
    }).join("");
    return se(Te, (ue === 38 ? "color:#" : "background-color:#") + ce);
  }
  function ee(Te, fe, ue) {
    fe = parseInt(fe, 10);
    var Ce = { "-1": function() {
      return "<br/>";
    }, 0: function() {
      return Te.length && te(Te);
    }, 1: function() {
      return ae(Te, "b");
    }, 3: function() {
      return ae(Te, "i");
    }, 4: function() {
      return ae(Te, "u");
    }, 8: function() {
      return se(Te, "display:none");
    }, 9: function() {
      return ae(Te, "strike");
    }, 22: function() {
      return se(Te, "font-weight:normal;text-decoration:none;font-style:normal");
    }, 23: function() {
      return xe(Te, "i");
    }, 24: function() {
      return xe(Te, "u");
    }, 39: function() {
      return ie(Te, ue.fg);
    }, 49: function() {
      return he(Te, ue.bg);
    }, 53: function() {
      return se(Te, "text-decoration:overline");
    } }, ce;
    return Ce[fe] ? ce = Ce[fe]() : 4 < fe && fe < 7 ? ce = ae(Te, "blink") : 29 < fe && fe < 38 ? ce = ie(Te, ue.colors[fe - 30]) : 39 < fe && fe < 48 ? ce = he(Te, ue.colors[fe - 40]) : 89 < fe && fe < 98 ? ce = ie(Te, ue.colors[8 + (fe - 90)]) : 99 < fe && fe < 108 && (ce = he(Te, ue.colors[8 + (fe - 100)])), ce;
  }
  function te(Te) {
    var fe = Te.slice(0);
    return Te.length = 0, fe.reverse().map(function(ue) {
      return "</" + ue + ">";
    }).join("");
  }
  function re(Te, fe) {
    for (var ue = [], Ce = Te; Ce <= fe; Ce++) ue.push(Ce);
    return ue;
  }
  function Q(Te) {
    return function(fe) {
      return (Te === null || fe.category !== Te) && Te !== "all";
    };
  }
  function ne(Te) {
    Te = parseInt(Te, 10);
    var fe = null;
    return Te === 0 ? fe = "all" : Te === 1 ? fe = "bold" : 2 < Te && Te < 5 ? fe = "underline" : 4 < Te && Te < 7 ? fe = "blink" : Te === 8 ? fe = "hide" : Te === 9 ? fe = "strike" : 29 < Te && Te < 38 || Te === 39 || 89 < Te && Te < 98 ? fe = "foreground-color" : (39 < Te && Te < 48 || Te === 49 || 99 < Te && Te < 108) && (fe = "background-color"), fe;
  }
  function oe(Te, fe) {
    return fe.escapeXML ? W.encodeXML(Te) : Te;
  }
  function ae(Te, fe, ue) {
    return ue || (ue = ""), Te.push(fe), "<".concat(fe).concat(ue ? ' style="'.concat(ue, '"') : "", ">");
  }
  function se(Te, fe) {
    return ae(Te, "span", fe);
  }
  function ie(Te, fe) {
    return ae(Te, "span", "color:" + fe);
  }
  function he(Te, fe) {
    return ae(Te, "span", "background-color:" + fe);
  }
  function xe(Te, fe) {
    var ue;
    if (Te.slice(-1)[0] === fe && (ue = Te.pop()), ue) return "</" + fe + ">";
  }
  function Pe(Te, fe, ue) {
    var Ce = !1, ce = 3;
    function pe() {
      return "";
    }
    function _e(Fe, De) {
      return ue("xterm256", De), "";
    }
    function ge(Fe) {
      return fe.newline ? ue("display", -1) : ue("text", Fe), "";
    }
    function Ae(Fe, De) {
      Ce = !0, De.trim().length === 0 && (De = "0"), De = De.trimRight(";").split(";");
      var Le = L(De), ze;
      try {
        for (Le.s(); !(ze = Le.n()).done; ) {
          var We = ze.value;
          ue("display", We);
        }
      } catch (Be) {
        Le.e(Be);
      } finally {
        Le.f();
      }
      return "";
    }
    function Ee(Fe) {
      return ue("text", Fe), "";
    }
    function ve(Fe) {
      return ue("rgb", Fe), "";
    }
    var le = [{ pattern: /^\x08+/, sub: pe }, { pattern: /^\x1b\[[012]?K/, sub: pe }, { pattern: /^\x1b\[\(B/, sub: pe }, { pattern: /^\x1b\[[34]8;2;\d+;\d+;\d+m/, sub: ve }, { pattern: /^\x1b\[38;5;(\d+)m/, sub: _e }, { pattern: /^\n/, sub: ge }, { pattern: /^\r+\n/, sub: ge }, { pattern: /^\x1b\[((?:\d{1,3};?)+|)m/, sub: Ae }, { pattern: /^\x1b\[\d?J/, sub: pe }, { pattern: /^\x1b\[\d{0,3};\d{0,3}f/, sub: pe }, { pattern: /^\x1b\[?[\d;]{0,3}/, sub: pe }, { pattern: /^(([^\x1b\x08\r\n])+)/, sub: Ee }];
    function me(Fe, De) {
      De > ce && Ce || (Ce = !1, Te = Te.replace(Fe.pattern, Fe.sub));
    }
    var Se = [], ye = Te, be = ye.length;
    e: for (; be > 0; ) {
      for (var $e = 0, Oe = 0, Ie = le.length; Oe < Ie; $e = ++Oe) {
        var we = le[$e];
        if (me(we, $e), Te.length !== be) {
          be = Te.length;
          continue e;
        }
      }
      if (Te.length === be) break;
      Se.push(0), be = Te.length;
    }
    return Se;
  }
  function Re(Te, fe, ue) {
    return fe !== "text" && (Te = Te.filter(Q(ne(ue))), Te.push({ token: fe, data: ue, category: ne(ue) })), Te;
  }
  var ke = function() {
    function Te(fe) {
      R(this, Te), fe = fe || {}, fe.colors && (fe.colors = Object.assign({}, U.colors, fe.colors)), this.options = Object.assign({}, U, fe), this.stack = [], this.stickyStack = [];
    }
    return D(Te, [{ key: "toHtml", value: function(fe) {
      var ue = this;
      fe = typeof fe == "string" ? [fe] : fe;
      var Ce = this.stack, ce = this.options, pe = [];
      return this.stickyStack.forEach(function(_e) {
        var ge = Z(Ce, _e.token, _e.data, ce);
        ge && pe.push(ge);
      }), Pe(fe.join(""), ce, function(_e, ge) {
        var Ae = Z(Ce, _e, ge, ce);
        Ae && pe.push(Ae), ce.stream && (ue.stickyStack = Re(ue.stickyStack, _e, ge));
      }), Ce.length && pe.push(te(Ce)), pe.join("");
    } }]), Te;
  }();
  S.exports = ke;
} });
function mockChannel$1() {
  let T = { setHandler: () => {
  }, send: () => {
  } };
  return new Channel({ transport: T });
}
var AddonStore$1 = class {
  constructor() {
    this.getChannel = () => {
      if (!this.channel) {
        let S = mockChannel$1();
        return this.setChannel(S), S;
      }
      return this.channel;
    }, this.ready = () => this.promise, this.hasChannel = () => !!this.channel, this.setChannel = (S) => {
      this.channel = S, this.resolve();
    }, this.promise = new Promise((S) => {
      this.resolve = () => S(this.getChannel());
    });
  }
}, KEY$2 = "__STORYBOOK_ADDONS_PREVIEW";
function getAddonsStore$1() {
  return scope[KEY$2] || (scope[KEY$2] = new AddonStore$1()), scope[KEY$2];
}
var addons = getAddonsStore$1(), areDepsEqual = (T, S) => T.length === S.length && T.every((R, k) => R === S[k]), invalidHooksError = () => new Error("Storybook preview hooks can only be called inside decorators and story functions.");
function getHooksContextOrNull() {
  return scope.STORYBOOK_HOOKS_CONTEXT || null;
}
function getHooksContextOrThrow() {
  let T = getHooksContextOrNull();
  if (T == null) throw invalidHooksError();
  return T;
}
function useHook(T, S, R) {
  let k = getHooksContextOrThrow();
  if (k.currentPhase === "MOUNT") {
    R != null && !Array.isArray(R) && logger.warn(`${T} received a final argument that is not an array (instead, received ${R}). When specified, the final argument must be an array.`);
    let D = { name: T, deps: R };
    return k.currentHooks.push(D), S(D), D;
  }
  if (k.currentPhase === "UPDATE") {
    let D = k.getNextHook();
    if (D == null) throw new Error("Rendered more hooks than during the previous render.");
    return D.name !== T && logger.warn(`Storybook has detected a change in the order of Hooks${k.currentDecoratorName ? ` called by ${k.currentDecoratorName}` : ""}. This will lead to bugs and errors if not fixed.`), R != null && D.deps == null && logger.warn(`${T} received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.`), R != null && D.deps != null && R.length !== D.deps.length && logger.warn(`The final argument passed to ${T} changed size between renders. The order and size of this array must remain constant.
Previous: ${D.deps}
Incoming: ${R}`), (R == null || D.deps == null || !areDepsEqual(R, D.deps)) && (S(D), D.deps = R), D;
  }
  throw invalidHooksError();
}
function useMemoLike(T, S, R) {
  let { memoizedState: k } = useHook(T, (D) => {
    D.memoizedState = S();
  }, R);
  return k;
}
function useRefLike(T, S) {
  return useMemoLike(T, () => ({ current: S }), []);
}
function triggerUpdate() {
  let T = getHooksContextOrNull();
  if (T != null && T.currentPhase !== "NONE") T.hasUpdates = !0;
  else try {
    addons.getChannel().emit(FORCE_RE_RENDER);
  } catch {
    logger.warn("State updates of Storybook preview hooks work only in browser");
  }
}
function useStateLike(T, S) {
  let R = useRefLike(T, typeof S == "function" ? S() : S), k = (D) => {
    R.current = typeof D == "function" ? D(R.current) : D, triggerUpdate();
  };
  return [R.current, k];
}
function useState(T) {
  return useStateLike("useState", T);
}
function useEffect(T, S) {
  let R = getHooksContextOrThrow(), k = useMemoLike("useEffect", () => ({ create: T }), S);
  R.currentEffects.includes(k) || R.currentEffects.push(k);
}
memoize$3(1)((T) => Object.values(T).reduce((S, R) => (S[R.importPath] = S[R.importPath] || R, S), {}));
var deprecatedStoryAnnotation = dedent$1`
CSF .story annotations deprecated; annotate story functions directly:
- StoryFn.story.name => StoryFn.storyName
- StoryFn.story.(parameters|decorators) => StoryFn.(parameters|decorators)
See https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#hoisted-csf-annotations for details and codemod.
`;
deprecate$1(() => {
}, deprecatedStoryAnnotation);
var import_ansi_to_html = __toESM$4(require_ansi_to_html()), Mode = ((T) => (T.MAIN = "MAIN", T.NOPREVIEW = "NOPREVIEW", T.PREPARING_STORY = "PREPARING_STORY", T.PREPARING_DOCS = "PREPARING_DOCS", T.ERROR = "ERROR", T))(Mode || {});
new import_ansi_to_html.default({ escapeXML: !0 });
var DARK_MODE_EVENT_NAME = "DARK_MODE", __create$3 = Object.create, __defProp$3 = Object.defineProperty, __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor, __getOwnPropNames$3 = Object.getOwnPropertyNames, __getProtoOf$3 = Object.getPrototypeOf, __hasOwnProp$3 = Object.prototype.hasOwnProperty, __commonJS$3 = (T, S) => function() {
  return S || (0, T[__getOwnPropNames$3(T)[0]])((S = { exports: {} }).exports, S), S.exports;
}, __copyProps$3 = (T, S, R, k) => {
  if (S && typeof S == "object" || typeof S == "function") for (let D of __getOwnPropNames$3(S)) !__hasOwnProp$3.call(T, D) && D !== R && __defProp$3(T, D, { get: () => S[D], enumerable: !(k = __getOwnPropDesc$3(S, D)) || k.enumerable });
  return T;
}, __toESM$3 = (T, S, R) => (R = T != null ? __create$3(__getProtoOf$3(T)) : {}, __copyProps$3(!T || !T.__esModule ? __defProp$3(R, "default", { value: T, enumerable: !0 }) : R, T));
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(T) {
    for (var S = 1; S < arguments.length; S++) {
      var R = arguments[S];
      for (var k in R) Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
    }
    return T;
  }, _extends$3.apply(this, arguments);
}
function _assertThisInitialized$2(T) {
  if (T === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return T;
}
function _setPrototypeOf$2(T, S) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(R, k) {
    return R.__proto__ = k, R;
  }, _setPrototypeOf$2(T, S);
}
function _inheritsLoose$2(T, S) {
  T.prototype = Object.create(S.prototype), T.prototype.constructor = T, _setPrototypeOf$2(T, S);
}
function _getPrototypeOf$2(T) {
  return _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(S) {
    return S.__proto__ || Object.getPrototypeOf(S);
  }, _getPrototypeOf$2(T);
}
function _isNativeFunction$2(T) {
  try {
    return Function.toString.call(T).indexOf("[native code]") !== -1;
  } catch {
    return typeof T == "function";
  }
}
function _isNativeReflectConstruct$2() {
  try {
    var T = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$2 = function() {
    return !!T;
  })();
}
function _construct$2(T, S, R) {
  if (_isNativeReflectConstruct$2()) return Reflect.construct.apply(null, arguments);
  var k = [null];
  k.push.apply(k, S);
  var D = new (T.bind.apply(T, k))();
  return R && _setPrototypeOf$2(D, R.prototype), D;
}
function _wrapNativeSuper$2(T) {
  var S = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper$2 = function(R) {
    if (R === null || !_isNativeFunction$2(R)) return R;
    if (typeof R != "function") throw new TypeError("Super expression must either be null or a function");
    if (typeof S < "u") {
      if (S.has(R)) return S.get(R);
      S.set(R, k);
    }
    function k() {
      return _construct$2(R, arguments, _getPrototypeOf$2(this).constructor);
    }
    return k.prototype = Object.create(R.prototype, { constructor: { value: k, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf$2(k, R);
  }, _wrapNativeSuper$2(T);
}
var ERRORS$2 = { 1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`, 2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`, 3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`, 4: `Couldn't generate valid rgb string from %s, it returned %s.

`, 5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`, 6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`, 7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`, 8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`, 9: `Please provide a number of steps to the modularScale helper.

`, 10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`, 11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`, 12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`, 13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`, 14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`, 15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`, 16: `You must provide a template to this method.

`, 17: `You passed an unsupported selector state to this method.

`, 18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`, 19: `fromSize and toSize must be provided as stringified numbers with the same units.

`, 20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`, 21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n", 22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n", 23: `fontFace expects a name of a font-family.

`, 24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`, 25: `fontFace expects localFonts to be an array.

`, 26: `fontFace expects fileFormats to be an array.

`, 27: `radialGradient requries at least 2 color-stops to properly render.

`, 28: `Please supply a filename to retinaImage() as the first argument.

`, 29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`, 30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n", 31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`, 32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`, 33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`, 34: `borderRadius expects a radius value as a string or number as the second argument.

`, 35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`, 36: `Property must be a string value.

`, 37: `Syntax Error at %s.

`, 38: `Formula contains a function that needs parentheses at %s.

`, 39: `Formula is missing closing parenthesis at %s.

`, 40: `Formula has too many closing parentheses at %s.

`, 41: `All values in a formula must have the same unit or be unitless.

`, 42: `Please provide a number of steps to the modularScale helper.

`, 43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`, 44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`, 45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`, 46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`, 47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`, 48: `fromSize and toSize must be provided as stringified numbers with the same units.

`, 49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`, 50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`, 51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`, 52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`, 53: `fontFace expects localFonts to be an array.

`, 54: `fontFace expects fileFormats to be an array.

`, 55: `fontFace expects a name of a font-family.

`, 56: `linearGradient requries at least 2 color-stops to properly render.

`, 57: `radialGradient requries at least 2 color-stops to properly render.

`, 58: `Please supply a filename to retinaImage() as the first argument.

`, 59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`, 60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n", 61: `Property must be a string value.

`, 62: `borderRadius expects a radius value as a string or number as the second argument.

`, 63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`, 64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`, 65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`, 66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`, 67: `You must provide a template to this method.

`, 68: `You passed an unsupported selector state to this method.

`, 69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`, 70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`, 71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`, 72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`, 73: `Please provide a valid CSS variable.

`, 74: `CSS variable not found and no default was provided.

`, 75: `important requires a valid style object, got a %s instead.

`, 76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`, 77: `remToPx expects a value in "rem" but you provided it in "%s".

`, 78: `base must be set in "px" or "%" but you set it in "%s".
` };
function format$2() {
  for (var T = arguments.length, S = new Array(T), R = 0; R < T; R++) S[R] = arguments[R];
  var k = S[0], D = [], L;
  for (L = 1; L < S.length; L += 1) D.push(S[L]);
  return D.forEach(function(V) {
    k = k.replace(/%[a-z]/, V);
  }), k;
}
var PolishedError$2 = function(T) {
  _inheritsLoose$2(S, T);
  function S(R) {
    for (var k, D = arguments.length, L = new Array(D > 1 ? D - 1 : 0), V = 1; V < D; V++) L[V - 1] = arguments[V];
    return k = T.call(this, format$2.apply(void 0, [ERRORS$2[R]].concat(L))) || this, _assertThisInitialized$2(k);
  }
  return S;
}(_wrapNativeSuper$2(Error));
function colorToInt$2(T) {
  return Math.round(T * 255);
}
function convertToInt$2(T, S, R) {
  return colorToInt$2(T) + "," + colorToInt$2(S) + "," + colorToInt$2(R);
}
function hslToRgb$3(T, S, R, k) {
  if (k === void 0 && (k = convertToInt$2), S === 0) return k(R, R, R);
  var D = (T % 360 + 360) % 360 / 60, L = (1 - Math.abs(2 * R - 1)) * S, V = L * (1 - Math.abs(D % 2 - 1)), z = 0, W = 0, U = 0;
  D >= 0 && D < 1 ? (z = L, W = V) : D >= 1 && D < 2 ? (z = V, W = L) : D >= 2 && D < 3 ? (W = L, U = V) : D >= 3 && D < 4 ? (W = V, U = L) : D >= 4 && D < 5 ? (z = V, U = L) : D >= 5 && D < 6 && (z = L, U = V);
  var q = R - L / 2, K = z + q, Y = W + q, J = U + q;
  return k(K, Y, J);
}
var namedColorMap$2 = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkgrey: "a9a9a9", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", grey: "808080", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3", lightgreen: "90ee90", lightgrey: "d3d3d3", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslategray: "789", lightslategrey: "789", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "0f0", limegreen: "32cd32", linen: "faf0e6", magenta: "f0f", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370db", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "db7093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", rebeccapurple: "639", red: "f00", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", slategrey: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", wheat: "f5deb3", white: "fff", whitesmoke: "f5f5f5", yellow: "ff0", yellowgreen: "9acd32" };
function nameToHex$2(T) {
  if (typeof T != "string") return T;
  var S = T.toLowerCase();
  return namedColorMap$2[S] ? "#" + namedColorMap$2[S] : T;
}
var hexRegex$2 = /^#[a-fA-F0-9]{6}$/, hexRgbaRegex$2 = /^#[a-fA-F0-9]{8}$/, reducedHexRegex$2 = /^#[a-fA-F0-9]{3}$/, reducedRgbaHexRegex$2 = /^#[a-fA-F0-9]{4}$/, rgbRegex$2 = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, rgbaRegex$2 = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, hslRegex$2 = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, hslaRegex$2 = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function parseToRgb$2(T) {
  if (typeof T != "string") throw new PolishedError$2(3);
  var S = nameToHex$2(T);
  if (S.match(hexRegex$2)) return { red: parseInt("" + S[1] + S[2], 16), green: parseInt("" + S[3] + S[4], 16), blue: parseInt("" + S[5] + S[6], 16) };
  if (S.match(hexRgbaRegex$2)) {
    var R = parseFloat((parseInt("" + S[7] + S[8], 16) / 255).toFixed(2));
    return { red: parseInt("" + S[1] + S[2], 16), green: parseInt("" + S[3] + S[4], 16), blue: parseInt("" + S[5] + S[6], 16), alpha: R };
  }
  if (S.match(reducedHexRegex$2)) return { red: parseInt("" + S[1] + S[1], 16), green: parseInt("" + S[2] + S[2], 16), blue: parseInt("" + S[3] + S[3], 16) };
  if (S.match(reducedRgbaHexRegex$2)) {
    var k = parseFloat((parseInt("" + S[4] + S[4], 16) / 255).toFixed(2));
    return { red: parseInt("" + S[1] + S[1], 16), green: parseInt("" + S[2] + S[2], 16), blue: parseInt("" + S[3] + S[3], 16), alpha: k };
  }
  var D = rgbRegex$2.exec(S);
  if (D) return { red: parseInt("" + D[1], 10), green: parseInt("" + D[2], 10), blue: parseInt("" + D[3], 10) };
  var L = rgbaRegex$2.exec(S.substring(0, 50));
  if (L) return { red: parseInt("" + L[1], 10), green: parseInt("" + L[2], 10), blue: parseInt("" + L[3], 10), alpha: parseFloat("" + L[4]) > 1 ? parseFloat("" + L[4]) / 100 : parseFloat("" + L[4]) };
  var V = hslRegex$2.exec(S);
  if (V) {
    var z = parseInt("" + V[1], 10), W = parseInt("" + V[2], 10) / 100, U = parseInt("" + V[3], 10) / 100, q = "rgb(" + hslToRgb$3(z, W, U) + ")", K = rgbRegex$2.exec(q);
    if (!K) throw new PolishedError$2(4, S, q);
    return { red: parseInt("" + K[1], 10), green: parseInt("" + K[2], 10), blue: parseInt("" + K[3], 10) };
  }
  var Y = hslaRegex$2.exec(S.substring(0, 50));
  if (Y) {
    var J = parseInt("" + Y[1], 10), Z = parseInt("" + Y[2], 10) / 100, X = parseInt("" + Y[3], 10) / 100, ee = "rgb(" + hslToRgb$3(J, Z, X) + ")", te = rgbRegex$2.exec(ee);
    if (!te) throw new PolishedError$2(4, S, ee);
    return { red: parseInt("" + te[1], 10), green: parseInt("" + te[2], 10), blue: parseInt("" + te[3], 10), alpha: parseFloat("" + Y[4]) > 1 ? parseFloat("" + Y[4]) / 100 : parseFloat("" + Y[4]) };
  }
  throw new PolishedError$2(5);
}
function rgbToHsl$2(T) {
  var S = T.red / 255, R = T.green / 255, k = T.blue / 255, D = Math.max(S, R, k), L = Math.min(S, R, k), V = (D + L) / 2;
  if (D === L) return T.alpha !== void 0 ? { hue: 0, saturation: 0, lightness: V, alpha: T.alpha } : { hue: 0, saturation: 0, lightness: V };
  var z, W = D - L, U = V > 0.5 ? W / (2 - D - L) : W / (D + L);
  switch (D) {
    case S:
      z = (R - k) / W + (R < k ? 6 : 0);
      break;
    case R:
      z = (k - S) / W + 2;
      break;
    default:
      z = (S - R) / W + 4;
      break;
  }
  return z *= 60, T.alpha !== void 0 ? { hue: z, saturation: U, lightness: V, alpha: T.alpha } : { hue: z, saturation: U, lightness: V };
}
function parseToHsl$2(T) {
  return rgbToHsl$2(parseToRgb$2(T));
}
var reduceHexValue$3 = function(T) {
  return T.length === 7 && T[1] === T[2] && T[3] === T[4] && T[5] === T[6] ? "#" + T[1] + T[3] + T[5] : T;
}, reduceHexValue$1$2 = reduceHexValue$3;
function numberToHex$2(T) {
  var S = T.toString(16);
  return S.length === 1 ? "0" + S : S;
}
function colorToHex$2(T) {
  return numberToHex$2(Math.round(T * 255));
}
function convertToHex$2(T, S, R) {
  return reduceHexValue$1$2("#" + colorToHex$2(T) + colorToHex$2(S) + colorToHex$2(R));
}
function hslToHex$2(T, S, R) {
  return hslToRgb$3(T, S, R, convertToHex$2);
}
function hsl$2(T, S, R) {
  if (typeof T == "number" && typeof S == "number" && typeof R == "number") return hslToHex$2(T, S, R);
  if (typeof T == "object" && S === void 0 && R === void 0) return hslToHex$2(T.hue, T.saturation, T.lightness);
  throw new PolishedError$2(1);
}
function hsla$2(T, S, R, k) {
  if (typeof T == "number" && typeof S == "number" && typeof R == "number" && typeof k == "number") return "rgba(" + hslToRgb$3(T, S, R) + "," + k + ")";
  if (typeof T == "object" && S === void 0 && R === void 0 && k === void 0) return T.alpha >= 1 ? hslToHex$2(T.hue, T.saturation, T.lightness) : "rgba(" + hslToRgb$3(T.hue, T.saturation, T.lightness) + "," + T.alpha + ")";
  throw new PolishedError$2(2);
}
function rgb$3(T, S, R) {
  if (typeof T == "number" && typeof S == "number" && typeof R == "number") return reduceHexValue$1$2("#" + numberToHex$2(T) + numberToHex$2(S) + numberToHex$2(R));
  if (typeof T == "object" && S === void 0 && R === void 0) return reduceHexValue$1$2("#" + numberToHex$2(T.red) + numberToHex$2(T.green) + numberToHex$2(T.blue));
  throw new PolishedError$2(6);
}
function rgba$3(T, S, R, k) {
  if (typeof T == "string" && typeof S == "number") {
    var D = parseToRgb$2(T);
    return "rgba(" + D.red + "," + D.green + "," + D.blue + "," + S + ")";
  } else {
    if (typeof T == "number" && typeof S == "number" && typeof R == "number" && typeof k == "number") return "rgba(" + T + "," + S + "," + R + "," + k + ")";
    if (typeof T == "object" && S === void 0 && R === void 0 && k === void 0) return T.alpha >= 1 ? rgb$3(T.red, T.green, T.blue) : "rgba(" + T.red + "," + T.green + "," + T.blue + "," + T.alpha + ")";
  }
  throw new PolishedError$2(7);
}
var isRgb$2 = function(T) {
  return typeof T.red == "number" && typeof T.green == "number" && typeof T.blue == "number" && (typeof T.alpha != "number" || typeof T.alpha > "u");
}, isRgba$2 = function(T) {
  return typeof T.red == "number" && typeof T.green == "number" && typeof T.blue == "number" && typeof T.alpha == "number";
}, isHsl$2 = function(T) {
  return typeof T.hue == "number" && typeof T.saturation == "number" && typeof T.lightness == "number" && (typeof T.alpha != "number" || typeof T.alpha > "u");
}, isHsla$2 = function(T) {
  return typeof T.hue == "number" && typeof T.saturation == "number" && typeof T.lightness == "number" && typeof T.alpha == "number";
};
function toColorString$2(T) {
  if (typeof T != "object") throw new PolishedError$2(8);
  if (isRgba$2(T)) return rgba$3(T);
  if (isRgb$2(T)) return rgb$3(T);
  if (isHsla$2(T)) return hsla$2(T);
  if (isHsl$2(T)) return hsl$2(T);
  throw new PolishedError$2(8);
}
function curried$2(T, S, R) {
  return function() {
    var k = R.concat(Array.prototype.slice.call(arguments));
    return k.length >= S ? T.apply(this, k) : curried$2(T, S, k);
  };
}
function curry$2(T) {
  return curried$2(T, T.length, []);
}
function guard$2(T, S, R) {
  return Math.max(T, Math.min(S, R));
}
function darken$3(T, S) {
  if (S === "transparent") return S;
  var R = parseToHsl$2(S);
  return toColorString$2(_extends$3({}, R, { lightness: guard$2(0, 1, R.lightness - parseFloat(T)) }));
}
var curriedDarken$3 = curry$2(darken$3), curriedDarken$1$2 = curriedDarken$3;
function lighten$3(T, S) {
  if (S === "transparent") return S;
  var R = parseToHsl$2(S);
  return toColorString$2(_extends$3({}, R, { lightness: guard$2(0, 1, R.lightness + parseFloat(T)) }));
}
var curriedLighten$3 = curry$2(lighten$3), curriedLighten$1$2 = curriedLighten$3;
function opacify$1(T, S) {
  if (S === "transparent") return S;
  var R = parseToRgb$2(S), k = typeof R.alpha == "number" ? R.alpha : 1, D = _extends$3({}, R, { alpha: guard$2(0, 1, (k * 100 + parseFloat(T) * 100) / 100) });
  return rgba$3(D);
}
var curriedOpacify$2 = curry$2(opacify$1), curriedOpacify$1$1 = curriedOpacify$2;
function transparentize$2(T, S) {
  if (S === "transparent") return S;
  var R = parseToRgb$2(S), k = typeof R.alpha == "number" ? R.alpha : 1, D = _extends$3({}, R, { alpha: guard$2(0, 1, +(k * 100 - parseFloat(T) * 100).toFixed(2) / 100) });
  return rgba$3(D);
}
var curriedTransparentize$3 = curry$2(transparentize$2), curriedTransparentize$1$2 = curriedTransparentize$3, color$1 = { primary: "#FF4785", secondary: "#029CFD", tertiary: "#FAFBFC", ancillary: "#22a699", orange: "#FC521F", gold: "#FFAE00", green: "#66BF3C", seafoam: "#37D5D3", purple: "#6F2CAC", ultraviolet: "#2A0481", lightest: "#FFFFFF", lighter: "#F7FAFC", light: "#EEF3F6", mediumlight: "#ECF4F9", medium: "#D9E8F2", mediumdark: "#73828C", dark: "#5C6870", darker: "#454E54", darkest: "#2E3438", border: "hsla(203, 50%, 30%, 0.15)", positive: "#66BF3C", negative: "#FF4400", warning: "#E69D00", critical: "#FFFFFF", defaultText: "#2E3438", inverseText: "#FFFFFF", positiveText: "#448028", negativeText: "#D43900", warningText: "#A15C20" }, background$1 = { app: "#F6F9FC", bar: color$1.lightest, content: color$1.lightest, preview: color$1.lightest, gridCellSize: 10, hoverable: curriedTransparentize$1$2(0.9, color$1.secondary), positive: "#E1FFD4", negative: "#FEDED2", warning: "#FFF5CF", critical: "#FF4400" }, typography$1 = { fonts: { base: ['"Nunito Sans"', "-apple-system", '".SFNSText-Regular"', '"San Francisco"', "BlinkMacSystemFont", '"Segoe UI"', '"Helvetica Neue"', "Helvetica", "Arial", "sans-serif"].join(", "), mono: ["ui-monospace", "Menlo", "Monaco", '"Roboto Mono"', '"Oxygen Mono"', '"Ubuntu Monospace"', '"Source Code Pro"', '"Droid Sans Mono"', '"Courier New"', "monospace"].join(", ") }, weight: { regular: 400, bold: 700 }, size: { s1: 12, s2: 14, s3: 16, m1: 20, m2: 24, m3: 28, l1: 32, l2: 40, l3: 48, code: 90 } }, theme = { base: "light", colorPrimary: "#FF4785", colorSecondary: "#029CFD", appBg: background$1.app, appContentBg: color$1.lightest, appPreviewBg: color$1.lightest, appBorderColor: color$1.border, appBorderRadius: 4, fontBase: typography$1.fonts.base, fontCode: typography$1.fonts.mono, textColor: color$1.darkest, textInverseColor: color$1.lightest, textMutedColor: color$1.dark, barTextColor: color$1.mediumdark, barHoverColor: color$1.secondary, barSelectedColor: color$1.secondary, barBg: color$1.lightest, buttonBg: background$1.app, buttonBorder: color$1.medium, booleanBg: color$1.mediumlight, booleanSelectedBg: color$1.lightest, inputBg: color$1.lightest, inputBorder: color$1.border, inputTextColor: color$1.darkest, inputBorderRadius: 4 }, light_default = theme, theme2 = { base: "dark", colorPrimary: "#FF4785", colorSecondary: "#029CFD", appBg: "#222425", appContentBg: "#1B1C1D", appPreviewBg: color$1.lightest, appBorderColor: "rgba(255,255,255,.1)", appBorderRadius: 4, fontBase: typography$1.fonts.base, fontCode: typography$1.fonts.mono, textColor: "#C9CDCF", textInverseColor: "#222425", textMutedColor: "#798186", barTextColor: color$1.mediumdark, barHoverColor: color$1.secondary, barSelectedColor: color$1.secondary, barBg: "#292C2E", buttonBg: "#222425", buttonBorder: "rgba(255,255,255,.1)", booleanBg: "#222425", booleanSelectedBg: "#2E3438", inputBg: "#1B1C1D", inputBorder: "rgba(255,255,255,.1)", inputTextColor: color$1.lightest, inputBorderRadius: 4 }, dark_default = theme2, { window: globalWindow$2 } = scope, mkColor = (T) => ({ color: T }), isColorString = (T) => typeof T != "string" ? (logger.warn(`Color passed to theme object should be a string. Instead ${T}(${typeof T}) was passed.`), !1) : !0, isValidColorForPolished = (T) => !/(gradient|var|calc)/.test(T), applyPolished = (T, S) => T === "darken" ? rgba$3(`${curriedDarken$1$2(1, S)}`, 0.95) : T === "lighten" ? rgba$3(`${curriedLighten$1$2(1, S)}`, 0.95) : S, colorFactory = (T) => (S) => {
  if (!isColorString(S) || !isValidColorForPolished(S)) return S;
  try {
    return applyPolished(T, S);
  } catch {
    return S;
  }
}, lightenColor = colorFactory("lighten"), getPreferredColorScheme = () => !globalWindow$2 || !globalWindow$2.matchMedia ? "light" : globalWindow$2.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light", themes = { light: light_default, dark: dark_default, normal: light_default }, preferredColorScheme = getPreferredColorScheme(), create$a = (T = { base: preferredColorScheme }, S) => {
  let R = { ...themes[preferredColorScheme], ...themes[T.base] || {}, ...T, base: themes[T.base] ? T.base : preferredColorScheme };
  return { ...S, ...R, barSelectedColor: T.barSelectedColor || R.colorSecondary };
}, syncFallback = function T(S) {
  return S();
}, useInsertionEffect = React$1.useInsertionEffect ? React$1.useInsertionEffect : !1, useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback, useInsertionEffectWithLayoutFallback = useInsertionEffect || React$1.useLayoutEffect, require_react_is_development = __commonJS$3({ "../../node_modules/react-is/cjs/react-is.development.js"(T) {
  (function() {
    var S = typeof Symbol == "function" && Symbol.for, R = S ? Symbol.for("react.element") : 60103, k = S ? Symbol.for("react.portal") : 60106, D = S ? Symbol.for("react.fragment") : 60107, L = S ? Symbol.for("react.strict_mode") : 60108, V = S ? Symbol.for("react.profiler") : 60114, z = S ? Symbol.for("react.provider") : 60109, W = S ? Symbol.for("react.context") : 60110, U = S ? Symbol.for("react.async_mode") : 60111, q = S ? Symbol.for("react.concurrent_mode") : 60111, K = S ? Symbol.for("react.forward_ref") : 60112, Y = S ? Symbol.for("react.suspense") : 60113, J = S ? Symbol.for("react.suspense_list") : 60120, Z = S ? Symbol.for("react.memo") : 60115, X = S ? Symbol.for("react.lazy") : 60116, ee = S ? Symbol.for("react.block") : 60121, te = S ? Symbol.for("react.fundamental") : 60117, re = S ? Symbol.for("react.responder") : 60118, Q = S ? Symbol.for("react.scope") : 60119;
    function ne(we) {
      return typeof we == "string" || typeof we == "function" || we === D || we === q || we === V || we === L || we === Y || we === J || typeof we == "object" && we !== null && (we.$$typeof === X || we.$$typeof === Z || we.$$typeof === z || we.$$typeof === W || we.$$typeof === K || we.$$typeof === te || we.$$typeof === re || we.$$typeof === Q || we.$$typeof === ee);
    }
    function oe(we) {
      if (typeof we == "object" && we !== null) {
        var Fe = we.$$typeof;
        switch (Fe) {
          case R:
            var De = we.type;
            switch (De) {
              case U:
              case q:
              case D:
              case V:
              case L:
              case Y:
                return De;
              default:
                var Le = De && De.$$typeof;
                switch (Le) {
                  case W:
                  case K:
                  case X:
                  case Z:
                  case z:
                    return Le;
                  default:
                    return Fe;
                }
            }
          case k:
            return Fe;
        }
      }
    }
    var ae = U, se = q, ie = W, he = z, xe = R, Pe = K, Re = D, ke = X, Te = Z, fe = k, ue = V, Ce = L, ce = Y, pe = !1;
    function _e(we) {
      return pe || (pe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ge(we) || oe(we) === U;
    }
    function ge(we) {
      return oe(we) === q;
    }
    function Ae(we) {
      return oe(we) === W;
    }
    function Ee(we) {
      return oe(we) === z;
    }
    function ve(we) {
      return typeof we == "object" && we !== null && we.$$typeof === R;
    }
    function le(we) {
      return oe(we) === K;
    }
    function me(we) {
      return oe(we) === D;
    }
    function Se(we) {
      return oe(we) === X;
    }
    function ye(we) {
      return oe(we) === Z;
    }
    function be(we) {
      return oe(we) === k;
    }
    function $e(we) {
      return oe(we) === V;
    }
    function Oe(we) {
      return oe(we) === L;
    }
    function Ie(we) {
      return oe(we) === Y;
    }
    T.AsyncMode = ae, T.ConcurrentMode = se, T.ContextConsumer = ie, T.ContextProvider = he, T.Element = xe, T.ForwardRef = Pe, T.Fragment = Re, T.Lazy = ke, T.Memo = Te, T.Portal = fe, T.Profiler = ue, T.StrictMode = Ce, T.Suspense = ce, T.isAsyncMode = _e, T.isConcurrentMode = ge, T.isContextConsumer = Ae, T.isContextProvider = Ee, T.isElement = ve, T.isForwardRef = le, T.isFragment = me, T.isLazy = Se, T.isMemo = ye, T.isPortal = be, T.isProfiler = $e, T.isStrictMode = Oe, T.isSuspense = Ie, T.isValidElementType = ne, T.typeOf = oe;
  })();
} }), require_react_is = __commonJS$3({ "../../node_modules/react-is/index.js"(T, S) {
  S.exports = require_react_is_development();
} }), require_hoist_non_react_statics_cjs = __commonJS$3({ "../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js"(T, S) {
  var R = require_react_is(), k = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, D = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, L = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, V = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, z = {};
  z[R.ForwardRef] = L, z[R.Memo] = V;
  function W(ee) {
    return R.isMemo(ee) ? V : z[ee.$$typeof] || k;
  }
  var U = Object.defineProperty, q = Object.getOwnPropertyNames, K = Object.getOwnPropertySymbols, Y = Object.getOwnPropertyDescriptor, J = Object.getPrototypeOf, Z = Object.prototype;
  function X(ee, te, re) {
    if (typeof te != "string") {
      if (Z) {
        var Q = J(te);
        Q && Q !== Z && X(ee, Q, re);
      }
      var ne = q(te);
      K && (ne = ne.concat(K(te)));
      for (var oe = W(ee), ae = W(te), se = 0; se < ne.length; ++se) {
        var ie = ne[se];
        if (!D[ie] && !(re && re[ie]) && !(ae && ae[ie]) && !(oe && oe[ie])) {
          var he = Y(te, ie);
          try {
            U(ee, ie, he);
          } catch {
          }
        }
      }
    }
    return ee;
  }
  S.exports = X;
} });
function memoize$1(T) {
  var S = /* @__PURE__ */ Object.create(null);
  return function(R) {
    return S[R] === void 0 && (S[R] = T(R)), S[R];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = memoize$1(function(T) {
  return reactPropsRegex.test(T) || T.charCodeAt(0) === 111 && T.charCodeAt(1) === 110 && T.charCodeAt(2) < 91;
});
function sheetForTag$1(T) {
  if (T.sheet) return T.sheet;
  for (var S = 0; S < document.styleSheets.length; S++) if (document.styleSheets[S].ownerNode === T) return document.styleSheets[S];
}
function createStyleElement$1(T) {
  var S = document.createElement("style");
  return S.setAttribute("data-emotion", T.key), T.nonce !== void 0 && S.setAttribute("nonce", T.nonce), S.appendChild(document.createTextNode("")), S.setAttribute("data-s", ""), S;
}
var StyleSheet$1 = function() {
  function T(R) {
    var k = this;
    this._insertTag = function(D) {
      var L;
      k.tags.length === 0 ? k.insertionPoint ? L = k.insertionPoint.nextSibling : k.prepend ? L = k.container.firstChild : L = k.before : L = k.tags[k.tags.length - 1].nextSibling, k.container.insertBefore(D, L), k.tags.push(D);
    }, this.isSpeedy = R.speedy === void 0 ? !1 : R.speedy, this.tags = [], this.ctr = 0, this.nonce = R.nonce, this.key = R.key, this.container = R.container, this.prepend = R.prepend, this.insertionPoint = R.insertionPoint, this.before = null;
  }
  var S = T.prototype;
  return S.hydrate = function(R) {
    R.forEach(this._insertTag);
  }, S.insert = function(R) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement$1(this));
    var k = this.tags[this.tags.length - 1], D = R.charCodeAt(0) === 64 && R.charCodeAt(1) === 105;
    if (D && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + R + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !D, this.isSpeedy) {
      var L = sheetForTag$1(k);
      try {
        L.insertRule(R, L.cssRules.length);
      } catch (V) {
        /:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(R) || console.error('There was a problem inserting the following rule: "' + R + '"', V);
      }
    } else k.appendChild(document.createTextNode(R));
    this.ctr++;
  }, S.flush = function() {
    this.tags.forEach(function(R) {
      return R.parentNode && R.parentNode.removeChild(R);
    }), this.tags = [], this.ctr = 0, this._alreadyInsertedOrderInsensitiveRule = !1;
  }, T;
}(), MS$1 = "-ms-", MOZ$1 = "-moz-", WEBKIT$1 = "-webkit-", COMMENT$1 = "comm", RULESET$1 = "rule", DECLARATION$1 = "decl", IMPORT$1 = "@import", KEYFRAMES$1 = "@keyframes", LAYER$1 = "@layer", abs$1 = Math.abs, from$1 = String.fromCharCode, assign$1 = Object.assign;
function hash$4(T, S) {
  return charat$1(T, 0) ^ 45 ? (((S << 2 ^ charat$1(T, 0)) << 2 ^ charat$1(T, 1)) << 2 ^ charat$1(T, 2)) << 2 ^ charat$1(T, 3) : 0;
}
function trim$1(T) {
  return T.trim();
}
function match$2(T, S) {
  return (T = S.exec(T)) ? T[0] : T;
}
function replace$1(T, S, R) {
  return T.replace(S, R);
}
function indexof$1(T, S) {
  return T.indexOf(S);
}
function charat$1(T, S) {
  return T.charCodeAt(S) | 0;
}
function substr$1(T, S, R) {
  return T.slice(S, R);
}
function strlen$1(T) {
  return T.length;
}
function sizeof$1(T) {
  return T.length;
}
function append$1(T, S) {
  return S.push(T), T;
}
function combine$1(T, S) {
  return T.map(S).join("");
}
var line$1 = 1, column$1 = 1, length$1 = 0, position$1 = 0, character$1 = 0, characters$1 = "";
function node$1(T, S, R, k, D, L, V) {
  return { value: T, root: S, parent: R, type: k, props: D, children: L, line: line$1, column: column$1, length: V, return: "" };
}
function copy$1(T, S) {
  return assign$1(node$1("", null, null, "", null, null, 0), T, { length: -T.length }, S);
}
function char$1() {
  return character$1;
}
function prev$1() {
  return character$1 = position$1 > 0 ? charat$1(characters$1, --position$1) : 0, column$1--, character$1 === 10 && (column$1 = 1, line$1--), character$1;
}
function next$1() {
  return character$1 = position$1 < length$1 ? charat$1(characters$1, position$1++) : 0, column$1++, character$1 === 10 && (column$1 = 1, line$1++), character$1;
}
function peek$1() {
  return charat$1(characters$1, position$1);
}
function caret$1() {
  return position$1;
}
function slice$2(T, S) {
  return substr$1(characters$1, T, S);
}
function token$1(T) {
  switch (T) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc$1(T) {
  return line$1 = column$1 = 1, length$1 = strlen$1(characters$1 = T), position$1 = 0, [];
}
function dealloc$1(T) {
  return characters$1 = "", T;
}
function delimit$1(T) {
  return trim$1(slice$2(position$1 - 1, delimiter$1(T === 91 ? T + 2 : T === 40 ? T + 1 : T)));
}
function whitespace$1(T) {
  for (; (character$1 = peek$1()) && character$1 < 33; ) next$1();
  return token$1(T) > 2 || token$1(character$1) > 3 ? "" : " ";
}
function escaping$1(T, S) {
  for (; --S && next$1() && !(character$1 < 48 || character$1 > 102 || character$1 > 57 && character$1 < 65 || character$1 > 70 && character$1 < 97); ) ;
  return slice$2(T, caret$1() + (S < 6 && peek$1() == 32 && next$1() == 32));
}
function delimiter$1(T) {
  for (; next$1(); ) switch (character$1) {
    case T:
      return position$1;
    case 34:
    case 39:
      T !== 34 && T !== 39 && delimiter$1(character$1);
      break;
    case 40:
      T === 41 && delimiter$1(T);
      break;
    case 92:
      next$1();
      break;
  }
  return position$1;
}
function commenter$1(T, S) {
  for (; next$1() && T + character$1 !== 57 && !(T + character$1 === 84 && peek$1() === 47); ) ;
  return "/*" + slice$2(S, position$1 - 1) + "*" + from$1(T === 47 ? T : next$1());
}
function identifier$1(T) {
  for (; !token$1(peek$1()); ) next$1();
  return slice$2(T, position$1);
}
function compile$1(T) {
  return dealloc$1(parse$2("", null, null, null, [""], T = alloc$1(T), 0, [0], T));
}
function parse$2(T, S, R, k, D, L, V, z, W) {
  for (var U = 0, q = 0, K = V, Y = 0, J = 0, Z = 0, X = 1, ee = 1, te = 1, re = 0, Q = "", ne = D, oe = L, ae = k, se = Q; ee; ) switch (Z = re, re = next$1()) {
    case 40:
      if (Z != 108 && charat$1(se, K - 1) == 58) {
        indexof$1(se += replace$1(delimit$1(re), "&", "&\f"), "&\f") != -1 && (te = -1);
        break;
      }
    case 34:
    case 39:
    case 91:
      se += delimit$1(re);
      break;
    case 9:
    case 10:
    case 13:
    case 32:
      se += whitespace$1(Z);
      break;
    case 92:
      se += escaping$1(caret$1() - 1, 7);
      continue;
    case 47:
      switch (peek$1()) {
        case 42:
        case 47:
          append$1(comment$1(commenter$1(next$1(), caret$1()), S, R), W);
          break;
        default:
          se += "/";
      }
      break;
    case 123 * X:
      z[U++] = strlen$1(se) * te;
    case 125 * X:
    case 59:
    case 0:
      switch (re) {
        case 0:
        case 125:
          ee = 0;
        case 59 + q:
          te == -1 && (se = replace$1(se, /\f/g, "")), J > 0 && strlen$1(se) - K && append$1(J > 32 ? declaration$1(se + ";", k, R, K - 1) : declaration$1(replace$1(se, " ", "") + ";", k, R, K - 2), W);
          break;
        case 59:
          se += ";";
        default:
          if (append$1(ae = ruleset$1(se, S, R, U, q, D, z, Q, ne = [], oe = [], K), L), re === 123) if (q === 0) parse$2(se, S, ae, ae, ne, L, K, z, oe);
          else switch (Y === 99 && charat$1(se, 3) === 110 ? 100 : Y) {
            case 100:
            case 108:
            case 109:
            case 115:
              parse$2(T, ae, ae, k && append$1(ruleset$1(T, ae, ae, 0, 0, D, z, Q, D, ne = [], K), oe), D, oe, K, z, k ? ne : oe);
              break;
            default:
              parse$2(se, ae, ae, ae, [""], oe, 0, z, oe);
          }
      }
      U = q = J = 0, X = te = 1, Q = se = "", K = V;
      break;
    case 58:
      K = 1 + strlen$1(se), J = Z;
    default:
      if (X < 1) {
        if (re == 123) --X;
        else if (re == 125 && X++ == 0 && prev$1() == 125) continue;
      }
      switch (se += from$1(re), re * X) {
        case 38:
          te = q > 0 ? 1 : (se += "\f", -1);
          break;
        case 44:
          z[U++] = (strlen$1(se) - 1) * te, te = 1;
          break;
        case 64:
          peek$1() === 45 && (se += delimit$1(next$1())), Y = peek$1(), q = K = strlen$1(Q = se += identifier$1(caret$1())), re++;
          break;
        case 45:
          Z === 45 && strlen$1(se) == 2 && (X = 0);
      }
  }
  return L;
}
function ruleset$1(T, S, R, k, D, L, V, z, W, U, q) {
  for (var K = D - 1, Y = D === 0 ? L : [""], J = sizeof$1(Y), Z = 0, X = 0, ee = 0; Z < k; ++Z) for (var te = 0, re = substr$1(T, K + 1, K = abs$1(X = V[Z])), Q = T; te < J; ++te) (Q = trim$1(X > 0 ? Y[te] + " " + re : replace$1(re, /&\f/g, Y[te]))) && (W[ee++] = Q);
  return node$1(T, S, R, D === 0 ? RULESET$1 : z, W, U, q);
}
function comment$1(T, S, R) {
  return node$1(T, S, R, COMMENT$1, from$1(char$1()), substr$1(T, 2, -2), 0);
}
function declaration$1(T, S, R, k) {
  return node$1(T, S, R, DECLARATION$1, substr$1(T, 0, k), substr$1(T, k + 1, -1), k);
}
function serialize$1(T, S) {
  for (var R = "", k = sizeof$1(T), D = 0; D < k; D++) R += S(T[D], D, T, S) || "";
  return R;
}
function stringify$1(T, S, R, k) {
  switch (T.type) {
    case LAYER$1:
      if (T.children.length) break;
    case IMPORT$1:
    case DECLARATION$1:
      return T.return = T.return || T.value;
    case COMMENT$1:
      return "";
    case KEYFRAMES$1:
      return T.return = T.value + "{" + serialize$1(T.children, k) + "}";
    case RULESET$1:
      T.value = T.props.join(",");
  }
  return strlen$1(R = serialize$1(T.children, k)) ? T.return = T.value + "{" + R + "}" : "";
}
function middleware$1(T) {
  var S = sizeof$1(T);
  return function(R, k, D, L) {
    for (var V = "", z = 0; z < S; z++) V += T[z](R, k, D, L) || "";
    return V;
  };
}
var weakMemoize = function(T) {
  var S = /* @__PURE__ */ new WeakMap();
  return function(R) {
    if (S.has(R)) return S.get(R);
    var k = T(R);
    return S.set(R, k), k;
  };
}, identifierWithPointTracking$1 = function(T, S, R) {
  for (var k = 0, D = 0; k = D, D = peek$1(), k === 38 && D === 12 && (S[R] = 1), !token$1(D); ) next$1();
  return slice$2(T, position$1);
}, toRules$1 = function(T, S) {
  var R = -1, k = 44;
  do
    switch (token$1(k)) {
      case 0:
        k === 38 && peek$1() === 12 && (S[R] = 1), T[R] += identifierWithPointTracking$1(position$1 - 1, S, R);
        break;
      case 2:
        T[R] += delimit$1(k);
        break;
      case 4:
        if (k === 44) {
          T[++R] = peek$1() === 58 ? "&\f" : "", S[R] = T[R].length;
          break;
        }
      default:
        T[R] += from$1(k);
    }
  while (k = next$1());
  return T;
}, getRules$1 = function(T, S) {
  return dealloc$1(toRules$1(alloc$1(T), S));
}, fixedElements$1 = /* @__PURE__ */ new WeakMap(), compat$1 = function(T) {
  if (!(T.type !== "rule" || !T.parent || T.length < 1)) {
    for (var S = T.value, R = T.parent, k = T.column === R.column && T.line === R.line; R.type !== "rule"; ) if (R = R.parent, !R) return;
    if (!(T.props.length === 1 && S.charCodeAt(0) !== 58 && !fixedElements$1.get(R)) && !k) {
      fixedElements$1.set(T, !0);
      for (var D = [], L = getRules$1(S, D), V = R.props, z = 0, W = 0; z < L.length; z++) for (var U = 0; U < V.length; U++, W++) T.props[W] = D[z] ? L[z].replace(/&\f/g, V[U]) : V[U] + " " + L[z];
    }
  }
}, removeLabel$1 = function(T) {
  if (T.type === "decl") {
    var S = T.value;
    S.charCodeAt(0) === 108 && S.charCodeAt(2) === 98 && (T.return = "", T.value = "");
  }
}, ignoreFlag$1 = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", isIgnoringComment$1 = function(T) {
  return T.type === "comm" && T.children.indexOf(ignoreFlag$1) > -1;
}, createUnsafeSelectorsAlarm$1 = function(T) {
  return function(S, R, k) {
    if (!(S.type !== "rule" || T.compat)) {
      var D = S.value.match(/(:first|:nth|:nth-last)-child/g);
      if (D) {
        for (var L = !!S.parent, V = L ? S.parent.children : k, z = V.length - 1; z >= 0; z--) {
          var W = V[z];
          if (W.line < S.line) break;
          if (W.column < S.column) {
            if (isIgnoringComment$1(W)) return;
            break;
          }
        }
        D.forEach(function(U) {
          console.error('The pseudo class "' + U + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + U.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, isImportRule$1 = function(T) {
  return T.type.charCodeAt(1) === 105 && T.type.charCodeAt(0) === 64;
}, isPrependedWithRegularRules$1 = function(T, S) {
  for (var R = T - 1; R >= 0; R--) if (!isImportRule$1(S[R])) return !0;
  return !1;
}, nullifyElement$1 = function(T) {
  T.type = "", T.value = "", T.return = "", T.children = "", T.props = "";
}, incorrectImportAlarm$1 = function(T, S, R) {
  isImportRule$1(T) && (T.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), nullifyElement$1(T)) : isPrependedWithRegularRules$1(S, R) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), nullifyElement$1(T)));
};
function prefix$1(T, S) {
  switch (hash$4(T, S)) {
    case 5103:
      return WEBKIT$1 + "print-" + T + T;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT$1 + T + T;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT$1 + T + MOZ$1 + T + MS$1 + T + T;
    case 6828:
    case 4268:
      return WEBKIT$1 + T + MS$1 + T + T;
    case 6165:
      return WEBKIT$1 + T + MS$1 + "flex-" + T + T;
    case 5187:
      return WEBKIT$1 + T + replace$1(T, /(\w+).+(:[^]+)/, WEBKIT$1 + "box-$1$2" + MS$1 + "flex-$1$2") + T;
    case 5443:
      return WEBKIT$1 + T + MS$1 + "flex-item-" + replace$1(T, /flex-|-self/, "") + T;
    case 4675:
      return WEBKIT$1 + T + MS$1 + "flex-line-pack" + replace$1(T, /align-content|flex-|-self/, "") + T;
    case 5548:
      return WEBKIT$1 + T + MS$1 + replace$1(T, "shrink", "negative") + T;
    case 5292:
      return WEBKIT$1 + T + MS$1 + replace$1(T, "basis", "preferred-size") + T;
    case 6060:
      return WEBKIT$1 + "box-" + replace$1(T, "-grow", "") + WEBKIT$1 + T + MS$1 + replace$1(T, "grow", "positive") + T;
    case 4554:
      return WEBKIT$1 + replace$1(T, /([^-])(transform)/g, "$1" + WEBKIT$1 + "$2") + T;
    case 6187:
      return replace$1(replace$1(replace$1(T, /(zoom-|grab)/, WEBKIT$1 + "$1"), /(image-set)/, WEBKIT$1 + "$1"), T, "") + T;
    case 5495:
    case 3959:
      return replace$1(T, /(image-set\([^]*)/, WEBKIT$1 + "$1$`$1");
    case 4968:
      return replace$1(replace$1(T, /(.+:)(flex-)?(.*)/, WEBKIT$1 + "box-pack:$3" + MS$1 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT$1 + T + T;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace$1(T, /(.+)-inline(.+)/, WEBKIT$1 + "$1$2") + T;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen$1(T) - 1 - S > 6) switch (charat$1(T, S + 1)) {
        case 109:
          if (charat$1(T, S + 4) !== 45) break;
        case 102:
          return replace$1(T, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT$1 + "$2-$3$1" + MOZ$1 + (charat$1(T, S + 3) == 108 ? "$3" : "$2-$3")) + T;
        case 115:
          return ~indexof$1(T, "stretch") ? prefix$1(replace$1(T, "stretch", "fill-available"), S) + T : T;
      }
      break;
    case 4949:
      if (charat$1(T, S + 1) !== 115) break;
    case 6444:
      switch (charat$1(T, strlen$1(T) - 3 - (~indexof$1(T, "!important") && 10))) {
        case 107:
          return replace$1(T, ":", ":" + WEBKIT$1) + T;
        case 101:
          return replace$1(T, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT$1 + (charat$1(T, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT$1 + "$2$3$1" + MS$1 + "$2box$3") + T;
      }
      break;
    case 5936:
      switch (charat$1(T, S + 11)) {
        case 114:
          return WEBKIT$1 + T + MS$1 + replace$1(T, /[svh]\w+-[tblr]{2}/, "tb") + T;
        case 108:
          return WEBKIT$1 + T + MS$1 + replace$1(T, /[svh]\w+-[tblr]{2}/, "tb-rl") + T;
        case 45:
          return WEBKIT$1 + T + MS$1 + replace$1(T, /[svh]\w+-[tblr]{2}/, "lr") + T;
      }
      return WEBKIT$1 + T + MS$1 + T + T;
  }
  return T;
}
var prefixer$1 = function(T, S, R, k) {
  if (T.length > -1 && !T.return) switch (T.type) {
    case DECLARATION$1:
      T.return = prefix$1(T.value, T.length);
      break;
    case KEYFRAMES$1:
      return serialize$1([copy$1(T, { value: replace$1(T.value, "@", "@" + WEBKIT$1) })], k);
    case RULESET$1:
      if (T.length) return combine$1(T.props, function(D) {
        switch (match$2(D, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return serialize$1([copy$1(T, { props: [replace$1(D, /:(read-\w+)/, ":" + MOZ$1 + "$1")] })], k);
          case "::placeholder":
            return serialize$1([copy$1(T, { props: [replace$1(D, /:(plac\w+)/, ":" + WEBKIT$1 + "input-$1")] }), copy$1(T, { props: [replace$1(D, /:(plac\w+)/, ":" + MOZ$1 + "$1")] }), copy$1(T, { props: [replace$1(D, /:(plac\w+)/, MS$1 + "input-$1")] })], k);
        }
        return "";
      });
  }
}, defaultStylisPlugins$1 = [prefixer$1], createCache$1 = function(T) {
  var S = T.key;
  if (!S) throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (S === "css") {
    var R = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(R, function(Z) {
      var X = Z.getAttribute("data-emotion");
      X.indexOf(" ") !== -1 && (document.head.appendChild(Z), Z.setAttribute("data-s", ""));
    });
  }
  var k = T.stylisPlugins || defaultStylisPlugins$1;
  if (/[^a-z-]/.test(S)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + S + '" was passed');
  var D = {}, L, V = [];
  L = T.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + S + ' "]'), function(Z) {
    for (var X = Z.getAttribute("data-emotion").split(" "), ee = 1; ee < X.length; ee++) D[X[ee]] = !0;
    V.push(Z);
  });
  var z, W = [compat$1, removeLabel$1];
  W.push(createUnsafeSelectorsAlarm$1({ get compat() {
    return J.compat;
  } }), incorrectImportAlarm$1);
  {
    var U, q = [stringify$1, function(Z) {
      Z.root || (Z.return ? U.insert(Z.return) : Z.value && Z.type !== COMMENT$1 && U.insert(Z.value + "{}"));
    }], K = middleware$1(W.concat(k, q)), Y = function(Z) {
      return serialize$1(compile$1(Z), K);
    };
    z = function(Z, X, ee, te) {
      U = ee, X.map !== void 0 && (U = { insert: function(re) {
        ee.insert(re + X.map);
      } }), Y(Z ? Z + "{" + X.styles + "}" : X.styles), te && (J.inserted[X.name] = !0);
    };
  }
  var J = { key: S, sheet: new StyleSheet$1({ key: S, container: L, nonce: T.nonce, speedy: T.speedy, prepend: T.prepend, insertionPoint: T.insertionPoint }), nonce: T.nonce, inserted: D, registered: {}, insert: z };
  return J.sheet.hydrate(V), J;
};
__toESM$3(require_hoist_non_react_statics_cjs());
var isBrowser = !0;
function getRegisteredStyles(T, S, R) {
  var k = "";
  return R.split(" ").forEach(function(D) {
    T[D] !== void 0 ? S.push(T[D] + ";") : k += D + " ";
  }), k;
}
var registerStyles = function(T, S, R) {
  var k = T.key + "-" + S.name;
  (R === !1 || isBrowser === !1) && T.registered[k] === void 0 && (T.registered[k] = S.styles);
}, insertStyles = function(T, S, R) {
  registerStyles(T, S, R);
  var k = T.key + "-" + S.name;
  if (T.inserted[S.name] === void 0) {
    var D = S;
    do
      T.insert(S === D ? "." + k : "", D, T.sheet, !0), D = D.next;
    while (D !== void 0);
  }
};
function murmur2(T) {
  for (var S = 0, R, k = 0, D = T.length; D >= 4; ++k, D -= 4) R = T.charCodeAt(k) & 255 | (T.charCodeAt(++k) & 255) << 8 | (T.charCodeAt(++k) & 255) << 16 | (T.charCodeAt(++k) & 255) << 24, R = (R & 65535) * 1540483477 + ((R >>> 16) * 59797 << 16), R ^= R >>> 24, S = (R & 65535) * 1540483477 + ((R >>> 16) * 59797 << 16) ^ (S & 65535) * 1540483477 + ((S >>> 16) * 59797 << 16);
  switch (D) {
    case 3:
      S ^= (T.charCodeAt(k + 2) & 255) << 16;
    case 2:
      S ^= (T.charCodeAt(k + 1) & 255) << 8;
    case 1:
      S ^= T.charCodeAt(k) & 255, S = (S & 65535) * 1540483477 + ((S >>> 16) * 59797 << 16);
  }
  return S ^= S >>> 13, S = (S & 65535) * 1540483477 + ((S >>> 16) * 59797 << 16), ((S ^ S >>> 15) >>> 0).toString(36);
}
var unitlessKeys = { animationIterationCount: 1, aspectRatio: 1, borderImageOutset: 1, borderImageSlice: 1, borderImageWidth: 1, boxFlex: 1, boxFlexGroup: 1, boxOrdinalGroup: 1, columnCount: 1, columns: 1, flex: 1, flexGrow: 1, flexPositive: 1, flexShrink: 1, flexNegative: 1, flexOrder: 1, gridRow: 1, gridRowEnd: 1, gridRowSpan: 1, gridRowStart: 1, gridColumn: 1, gridColumnEnd: 1, gridColumnSpan: 1, gridColumnStart: 1, msGridRow: 1, msGridRowSpan: 1, msGridColumn: 1, msGridColumnSpan: 1, fontWeight: 1, lineHeight: 1, opacity: 1, order: 1, orphans: 1, tabSize: 1, widows: 1, zIndex: 1, zoom: 1, WebkitLineClamp: 1, fillOpacity: 1, floodOpacity: 1, stopOpacity: 1, strokeDasharray: 1, strokeDashoffset: 1, strokeMiterlimit: 1, strokeOpacity: 1, strokeWidth: 1 }, ILLEGAL_ESCAPE_SEQUENCE_ERROR = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function(T) {
  return T.charCodeAt(1) === 45;
}, isProcessableValue = function(T) {
  return T != null && typeof T != "boolean";
}, processStyleName = memoize$1(function(T) {
  return isCustomProperty(T) ? T : T.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function(T, S) {
  switch (T) {
    case "animation":
    case "animationName":
      if (typeof S == "string") return S.replace(animationRegex, function(R, k, D) {
        return cursor = { name: k, styles: D, next: cursor }, k;
      });
  }
  return unitlessKeys[T] !== 1 && !isCustomProperty(T) && typeof S == "number" && S !== 0 ? S + "px" : S;
};
contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, contentValues = ["normal", "none", "initial", "inherit", "unset"], oldProcessStyleValue = processStyleValue, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, hyphenatedCache = {}, processStyleValue = function(T, S) {
  if (T === "content" && (typeof S != "string" || contentValues.indexOf(S) === -1 && !contentValuePattern.test(S) && (S.charAt(0) !== S.charAt(S.length - 1) || S.charAt(0) !== '"' && S.charAt(0) !== "'"))) throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + S + "\"'`");
  var R = oldProcessStyleValue(T, S);
  return R !== "" && !isCustomProperty(T) && T.indexOf("-") !== -1 && hyphenatedCache[T] === void 0 && (hyphenatedCache[T] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + T.replace(msPattern, "ms-").replace(hyphenPattern, function(k, D) {
    return D.toUpperCase();
  }) + "?")), R;
};
var contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache, noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(T, S, R) {
  if (R == null) return "";
  if (R.__emotion_styles !== void 0) {
    if (R.toString() === "NO_COMPONENT_SELECTOR") throw new Error(noComponentSelectorMessage);
    return R;
  }
  switch (typeof R) {
    case "boolean":
      return "";
    case "object": {
      if (R.anim === 1) return cursor = { name: R.name, styles: R.styles, next: cursor }, R.name;
      if (R.styles !== void 0) {
        var k = R.next;
        if (k !== void 0) for (; k !== void 0; ) cursor = { name: k.name, styles: k.styles, next: cursor }, k = k.next;
        var D = R.styles + ";";
        return R.map !== void 0 && (D += R.map), D;
      }
      return createStringFromObject(T, S, R);
    }
    case "function": {
      if (T !== void 0) {
        var L = cursor, V = R(T);
        return cursor = L, handleInterpolation(T, S, V);
      } else console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      var z = [], W = R.replace(animationRegex, function(q, K, Y) {
        var J = "animation" + z.length;
        return z.push("const " + J + " = keyframes`" + Y.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + J + "}";
      });
      z.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(z, ["`" + W + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + W + "`"));
      break;
  }
  if (S == null) return R;
  var U = S[R];
  return U !== void 0 ? U : R;
}
function createStringFromObject(T, S, R) {
  var k = "";
  if (Array.isArray(R)) for (var D = 0; D < R.length; D++) k += handleInterpolation(T, S, R[D]) + ";";
  else for (var L in R) {
    var V = R[L];
    if (typeof V != "object") S != null && S[V] !== void 0 ? k += L + "{" + S[V] + "}" : isProcessableValue(V) && (k += processStyleName(L) + ":" + processStyleValue(L, V) + ";");
    else {
      if (L === "NO_COMPONENT_SELECTOR") throw new Error(noComponentSelectorMessage);
      if (Array.isArray(V) && typeof V[0] == "string" && (S == null || S[V[0]] === void 0)) for (var z = 0; z < V.length; z++) isProcessableValue(V[z]) && (k += processStyleName(L) + ":" + processStyleValue(L, V[z]) + ";");
      else {
        var W = handleInterpolation(T, S, V);
        switch (L) {
          case "animation":
          case "animationName": {
            k += processStyleName(L) + ":" + W + ";";
            break;
          }
          default:
            L === "undefined" && console.error(UNDEFINED_AS_OBJECT_KEY_ERROR), k += L + "{" + W + "}";
        }
      }
    }
  }
  return k;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g, sourceMapPattern;
sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
var cursor, serializeStyles = function(T, S, R) {
  if (T.length === 1 && typeof T[0] == "object" && T[0] !== null && T[0].styles !== void 0) return T[0];
  var k = !0, D = "";
  cursor = void 0;
  var L = T[0];
  L == null || L.raw === void 0 ? (k = !1, D += handleInterpolation(R, S, L)) : (L[0] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR), D += L[0]);
  for (var V = 1; V < T.length; V++) D += handleInterpolation(R, S, T[V]), k && (L[V] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR), D += L[V]);
  var z;
  D = D.replace(sourceMapPattern, function(K) {
    return z = K, "";
  }), labelPattern.lastIndex = 0;
  for (var W = "", U; (U = labelPattern.exec(D)) !== null; ) W += "-" + U[1];
  var q = murmur2(D) + W;
  return { name: q, styles: D, map: z, next: cursor, toString: function() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
  } };
}, hasOwn = {}.hasOwnProperty, EmotionCacheContext = React$1.createContext(typeof HTMLElement < "u" ? createCache$1({ key: "css" }) : null);
EmotionCacheContext.displayName = "EmotionCacheContext";
EmotionCacheContext.Provider;
var withEmotionCache = function(T) {
  return forwardRef(function(S, R) {
    var k = useContext(EmotionCacheContext);
    return T(S, k, R);
  });
}, ThemeContext$1 = React$1.createContext({});
ThemeContext$1.displayName = "EmotionThemeContext";
var useTheme$5 = function() {
  return React$1.useContext(ThemeContext$1);
}, getTheme = function(T, S) {
  if (typeof S == "function") {
    var R = S(T);
    if (R == null || typeof R != "object" || Array.isArray(R)) throw new Error("[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!");
    return R;
  }
  if (S == null || typeof S != "object" || Array.isArray(S)) throw new Error("[ThemeProvider] Please make your theme prop a plain object");
  return _extends$3({}, T, S);
}, createCacheWithTheme = weakMemoize(function(T) {
  return weakMemoize(function(S) {
    return getTheme(T, S);
  });
}), ThemeProvider$4 = function(T) {
  var S = React$1.useContext(ThemeContext$1);
  return T.theme !== S && (S = createCacheWithTheme(S)(T.theme)), React$1.createElement(ThemeContext$1.Provider, { value: S }, T.children);
}, typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Insertion = function(T) {
  var S = T.cache, R = T.serialized, k = T.isStringTag;
  return registerStyles(S, R, k), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(S, R, k);
  }), null;
}, Emotion = withEmotionCache(function(T, S, R) {
  var k = T.css;
  typeof k == "string" && S.registered[k] !== void 0 && (k = S.registered[k]);
  var D = T[typePropName], L = [k], V = "";
  typeof T.className == "string" ? V = getRegisteredStyles(S.registered, L, T.className) : T.className != null && (V = T.className + " ");
  var z = serializeStyles(L, void 0, React$1.useContext(ThemeContext$1));
  if (z.name.indexOf("-") === -1) {
    var W = T[labelPropName];
    W && (z = serializeStyles([z, "label:" + W + ";"]));
  }
  V += S.key + "-" + z.name;
  var U = {};
  for (var q in T) hasOwn.call(T, q) && q !== "css" && q !== typePropName && q !== labelPropName && (U[q] = T[q]);
  return U.ref = R, U.className = V, React$1.createElement(React$1.Fragment, null, React$1.createElement(Insertion, { cache: S, serialized: z, isStringTag: typeof D == "string" }), React$1.createElement(D, U));
});
Emotion.displayName = "EmotionCssPropInternal";
__toESM$3(require_hoist_non_react_statics_cjs());
var pkg = { name: "@emotion/react", version: "11.11.4", main: "dist/emotion-react.cjs.js", module: "dist/emotion-react.esm.js", browser: { "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js" }, exports: { ".": { module: { worker: "./dist/emotion-react.worker.esm.js", browser: "./dist/emotion-react.browser.esm.js", default: "./dist/emotion-react.esm.js" }, import: "./dist/emotion-react.cjs.mjs", default: "./dist/emotion-react.cjs.js" }, "./jsx-runtime": { module: { worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js", browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js", default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js" }, import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs", default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js" }, "./_isolated-hnrs": { module: { worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js", browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js", default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js" }, import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs", default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js" }, "./jsx-dev-runtime": { module: { worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js", browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js", default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js" }, import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs", default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js" }, "./package.json": "./package.json", "./types/css-prop": "./types/css-prop.d.ts", "./macro": { types: { import: "./macro.d.mts", default: "./macro.d.ts" }, default: "./macro.js" } }, types: "types/index.d.ts", files: ["src", "dist", "jsx-runtime", "jsx-dev-runtime", "_isolated-hnrs", "types/*.d.ts", "macro.*"], sideEffects: !1, author: "Emotion Contributors", license: "MIT", scripts: { "test:typescript": "dtslint types" }, dependencies: { "@babel/runtime": "^7.18.3", "@emotion/babel-plugin": "^11.11.0", "@emotion/cache": "^11.11.0", "@emotion/serialize": "^1.1.3", "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1", "@emotion/utils": "^1.2.1", "@emotion/weak-memoize": "^0.3.1", "hoist-non-react-statics": "^3.3.1" }, peerDependencies: { react: ">=16.8.0" }, peerDependenciesMeta: { "@types/react": { optional: !0 } }, devDependencies: { "@definitelytyped/dtslint": "0.0.112", "@emotion/css": "11.11.2", "@emotion/css-prettifier": "1.1.3", "@emotion/server": "11.11.0", "@emotion/styled": "11.11.0", "html-tag-names": "^1.1.2", react: "16.14.0", "svg-tag-names": "^1.1.1", typescript: "^4.5.5" }, repository: "https://github.com/emotion-js/emotion/tree/main/packages/react", publishConfig: { access: "public" }, "umd:main": "dist/emotion-react.umd.min.js", preconstruct: { entrypoints: ["./index.js", "./jsx-runtime.js", "./jsx-dev-runtime.js", "./_isolated-hnrs.js"], umdName: "emotionReact", exports: { envConditions: ["browser", "worker"], extra: { "./types/css-prop": "./types/css-prop.d.ts", "./macro": { types: { import: "./macro.d.mts", default: "./macro.d.ts" }, default: "./macro.js" } } } } }, warnedAboutCssPropForGlobal = !1, Global = withEmotionCache(function(T, S) {
  !warnedAboutCssPropForGlobal && (T.className || T.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), warnedAboutCssPropForGlobal = !0);
  var R = T.styles, k = serializeStyles([R], void 0, React$1.useContext(ThemeContext$1)), D = React$1.useRef();
  return useInsertionEffectWithLayoutFallback(function() {
    var L = S.key + "-global", V = new S.sheet.constructor({ key: L, nonce: S.sheet.nonce, container: S.sheet.container, speedy: S.sheet.isSpeedy }), z = !1, W = document.querySelector('style[data-emotion="' + L + " " + k.name + '"]');
    return S.sheet.tags.length && (V.before = S.sheet.tags[0]), W !== null && (z = !0, W.setAttribute("data-emotion", L), V.hydrate([W])), D.current = [V, z], function() {
      V.flush();
    };
  }, [S]), useInsertionEffectWithLayoutFallback(function() {
    var L = D.current, V = L[0], z = L[1];
    if (z) {
      L[1] = !1;
      return;
    }
    if (k.next !== void 0 && insertStyles(S, k.next, !0), V.tags.length) {
      var W = V.tags[V.tags.length - 1].nextElementSibling;
      V.before = W, V.flush();
    }
    S.insert("", k, V, !1);
  }, [S, k.name]), null;
});
Global.displayName = "EmotionGlobal";
function css() {
  for (var T = arguments.length, S = new Array(T), R = 0; R < T; R++) S[R] = arguments[R];
  return serializeStyles(S);
}
var keyframes = function() {
  var T = css.apply(void 0, arguments), S = "animation-" + T.name;
  return { name: S, styles: "@keyframes " + S + "{" + T.styles + "}", anim: 1, toString: function() {
    return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
  } };
}, classnames = function T(S) {
  for (var R = S.length, k = 0, D = ""; k < R; k++) {
    var L = S[k];
    if (L != null) {
      var V = void 0;
      switch (typeof L) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(L)) V = T(L);
          else {
            L.styles !== void 0 && L.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), V = "";
            for (var z in L) L[z] && z && (V && (V += " "), V += z);
          }
          break;
        }
        default:
          V = L;
      }
      V && (D && (D += " "), D += V);
    }
  }
  return D;
};
function merge$1(T, S, R) {
  var k = [], D = getRegisteredStyles(T, k, R);
  return k.length < 2 ? R : D + S(k);
}
var Insertion3 = function(T) {
  var S = T.cache, R = T.serializedArr;
  return useInsertionEffectAlwaysWithSyncFallback(function() {
    for (var k = 0; k < R.length; k++) insertStyles(S, R[k], !1);
  }), null;
}, ClassNames = withEmotionCache(function(T, S) {
  var R = !1, k = [], D = function() {
    if (R) throw new Error("css can only be used during render");
    for (var W = arguments.length, U = new Array(W), q = 0; q < W; q++) U[q] = arguments[q];
    var K = serializeStyles(U, S.registered);
    return k.push(K), registerStyles(S, K, !1), S.key + "-" + K.name;
  }, L = function() {
    if (R) throw new Error("cx can only be used during render");
    for (var W = arguments.length, U = new Array(W), q = 0; q < W; q++) U[q] = arguments[q];
    return merge$1(S.registered, D, classnames(U));
  }, V = { css: D, cx: L, theme: React$1.useContext(ThemeContext$1) }, z = T.children(V);
  return R = !0, React$1.createElement(React$1.Fragment, null, React$1.createElement(Insertion3, { cache: S, serializedArr: k }), z);
});
ClassNames.displayName = "EmotionClassNames";
isBrowser3 = !0, isTestEnv = typeof jest < "u" || typeof vi < "u", isBrowser3 && !isTestEnv && (globalContext = typeof globalThis < "u" ? globalThis : isBrowser3 ? window : global, globalKey = "__EMOTION_REACT_" + pkg.version.split(".")[0] + "__", globalContext[globalKey] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), globalContext[globalKey] = !0);
var isBrowser3, isTestEnv, globalContext, globalKey, testOmitPropsOnStringTag = isPropValid, testOmitPropsOnComponent = function(T) {
  return T !== "theme";
}, getDefaultShouldForwardProp = function(T) {
  return typeof T == "string" && T.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
}, composeShouldForwardProps = function(T, S, R) {
  var k;
  if (S) {
    var D = S.shouldForwardProp;
    k = T.__emotion_forwardProp && D ? function(L) {
      return T.__emotion_forwardProp(L) && D(L);
    } : D;
  }
  return typeof k != "function" && R && (k = T.__emotion_forwardProp), k;
}, ILLEGAL_ESCAPE_SEQUENCE_ERROR2 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Insertion5 = function(T) {
  var S = T.cache, R = T.serialized, k = T.isStringTag;
  return registerStyles(S, R, k), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(S, R, k);
  }), null;
}, createStyled$2 = function T(S, R) {
  if (S === void 0) throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
  var k = S.__emotion_real === S, D = k && S.__emotion_base || S, L, V;
  R !== void 0 && (L = R.label, V = R.target);
  var z = composeShouldForwardProps(S, R, k), W = z || getDefaultShouldForwardProp(D), U = !W("as");
  return function() {
    var q = arguments, K = k && S.__emotion_styles !== void 0 ? S.__emotion_styles.slice(0) : [];
    if (L !== void 0 && K.push("label:" + L + ";"), q[0] == null || q[0].raw === void 0) K.push.apply(K, q);
    else {
      q[0][0] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR2), K.push(q[0][0]);
      for (var Y = q.length, J = 1; J < Y; J++) q[0][J] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR2), K.push(q[J], q[0][J]);
    }
    var Z = withEmotionCache(function(X, ee, te) {
      var re = U && X.as || D, Q = "", ne = [], oe = X;
      if (X.theme == null) {
        oe = {};
        for (var ae in X) oe[ae] = X[ae];
        oe.theme = React$1.useContext(ThemeContext$1);
      }
      typeof X.className == "string" ? Q = getRegisteredStyles(ee.registered, ne, X.className) : X.className != null && (Q = X.className + " ");
      var se = serializeStyles(K.concat(ne), ee.registered, oe);
      Q += ee.key + "-" + se.name, V !== void 0 && (Q += " " + V);
      var ie = U && z === void 0 ? getDefaultShouldForwardProp(re) : W, he = {};
      for (var xe in X) U && xe === "as" || ie(xe) && (he[xe] = X[xe]);
      return he.className = Q, he.ref = te, React$1.createElement(React$1.Fragment, null, React$1.createElement(Insertion5, { cache: ee, serialized: se, isStringTag: typeof re == "string" }), React$1.createElement(re, he));
    });
    return Z.displayName = L !== void 0 ? L : "Styled(" + (typeof D == "string" ? D : D.displayName || D.name || "Component") + ")", Z.defaultProps = S.defaultProps, Z.__emotion_real = Z, Z.__emotion_base = D, Z.__emotion_styles = K, Z.__emotion_forwardProp = z, Object.defineProperty(Z, "toString", { value: function() {
      return V === void 0 ? "NO_COMPONENT_SELECTOR" : "." + V;
    } }), Z.withComponent = function(X, ee) {
      return T(X, _extends$3({}, R, ee, { shouldForwardProp: composeShouldForwardProps(Z, ee, !0) })).apply(void 0, K);
    }, Z;
  };
}, tags = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"], newStyled = createStyled$2.bind();
tags.forEach(function(T) {
  newStyled[T] = newStyled(T);
});
var createReset = memoize$3(1)(({ typography: T }) => ({ body: { fontFamily: T.fonts.base, fontSize: T.size.s3, margin: 0, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale", WebkitTapHighlightColor: "rgba(0, 0, 0, 0)", WebkitOverflowScrolling: "touch" }, "*": { boxSizing: "border-box" }, "h1, h2, h3, h4, h5, h6": { fontWeight: T.weight.regular, margin: 0, padding: 0 }, "button, input, textarea, select": { fontFamily: "inherit", fontSize: "inherit", boxSizing: "border-box" }, sub: { fontSize: "0.8em", bottom: "-0.2em" }, sup: { fontSize: "0.8em", top: "-0.2em" }, "b, strong": { fontWeight: T.weight.bold }, hr: { border: "none", borderTop: "1px solid silver", clear: "both", marginBottom: "1.25rem" }, code: { fontFamily: T.fonts.mono, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale", display: "inline-block", paddingLeft: 2, paddingRight: 2, verticalAlign: "baseline", color: "inherit" }, pre: { fontFamily: T.fonts.mono, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale", lineHeight: "18px", padding: "11px 1rem", whiteSpace: "pre-wrap", color: "inherit", borderRadius: 3, margin: "1rem 0" } }));
memoize$3(1)(({ color: T, background: S, typography: R }) => {
  let k = createReset({ typography: R });
  return { ...k, body: { ...k.body, color: T.defaultText, background: S.app, overflow: "hidden" }, hr: { ...k.hr, borderTop: `1px solid ${T.border}` } };
});
var easing$1 = { rubber: "cubic-bezier(0.175, 0.885, 0.335, 1.05)" }, rotate360$1 = keyframes`
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
`, glow = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: .4; }
`, float = keyframes`
  0% { transform: translateY(1px); }
  25% { transform: translateY(0px); }
  50% { transform: translateY(-3px); }
  100% { transform: translateY(1px); }
`, jiggle = keyframes`
  0%, 100% { transform:translate3d(0,0,0); }
  12.5%, 62.5% { transform:translate3d(-4px,0,0); }
  37.5%, 87.5% {  transform: translate3d(4px,0,0);  }
`, inlineGlow = css`
  animation: ${glow} 1.5s ease-in-out infinite;
  color: transparent;
  cursor: progress;
`, hoverable = css`
  transition: all 150ms ease-out;
  transform: translate3d(0, 0, 0);

  &:hover {
    transform: translate3d(0, -2px, 0);
  }

  &:active {
    transform: translate3d(0, 0, 0);
  }
`, animation$1 = { rotate360: rotate360$1, glow, float, jiggle, inlineGlow, hoverable }, chromeDark = { BASE_FONT_FAMILY: "Menlo, monospace", BASE_FONT_SIZE: "11px", BASE_LINE_HEIGHT: 1.2, BASE_BACKGROUND_COLOR: "rgb(36, 36, 36)", BASE_COLOR: "rgb(213, 213, 213)", OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES: 10, OBJECT_PREVIEW_OBJECT_MAX_PROPERTIES: 5, OBJECT_NAME_COLOR: "rgb(227, 110, 236)", OBJECT_VALUE_NULL_COLOR: "rgb(127, 127, 127)", OBJECT_VALUE_UNDEFINED_COLOR: "rgb(127, 127, 127)", OBJECT_VALUE_REGEXP_COLOR: "rgb(233, 63, 59)", OBJECT_VALUE_STRING_COLOR: "rgb(233, 63, 59)", OBJECT_VALUE_SYMBOL_COLOR: "rgb(233, 63, 59)", OBJECT_VALUE_NUMBER_COLOR: "hsl(252, 100%, 75%)", OBJECT_VALUE_BOOLEAN_COLOR: "hsl(252, 100%, 75%)", OBJECT_VALUE_FUNCTION_PREFIX_COLOR: "rgb(85, 106, 242)", HTML_TAG_COLOR: "rgb(93, 176, 215)", HTML_TAGNAME_COLOR: "rgb(93, 176, 215)", HTML_TAGNAME_TEXT_TRANSFORM: "lowercase", HTML_ATTRIBUTE_NAME_COLOR: "rgb(155, 187, 220)", HTML_ATTRIBUTE_VALUE_COLOR: "rgb(242, 151, 102)", HTML_COMMENT_COLOR: "rgb(137, 137, 137)", HTML_DOCTYPE_COLOR: "rgb(192, 192, 192)", ARROW_COLOR: "rgb(145, 145, 145)", ARROW_MARGIN_RIGHT: 3, ARROW_FONT_SIZE: 12, ARROW_ANIMATION_DURATION: "0", TREENODE_FONT_FAMILY: "Menlo, monospace", TREENODE_FONT_SIZE: "11px", TREENODE_LINE_HEIGHT: 1.2, TREENODE_PADDING_LEFT: 12, TABLE_BORDER_COLOR: "rgb(85, 85, 85)", TABLE_TH_BACKGROUND_COLOR: "rgb(44, 44, 44)", TABLE_TH_HOVER_COLOR: "rgb(48, 48, 48)", TABLE_SORT_ICON_COLOR: "black", TABLE_DATA_BACKGROUND_IMAGE: "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 50%, rgba(51, 139, 255, 0.0980392) 50%, rgba(51, 139, 255, 0.0980392))", TABLE_DATA_BACKGROUND_SIZE: "128px 32px" }, chromeLight = { BASE_FONT_FAMILY: "Menlo, monospace", BASE_FONT_SIZE: "11px", BASE_LINE_HEIGHT: 1.2, BASE_BACKGROUND_COLOR: "white", BASE_COLOR: "black", OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES: 10, OBJECT_PREVIEW_OBJECT_MAX_PROPERTIES: 5, OBJECT_NAME_COLOR: "rgb(136, 19, 145)", OBJECT_VALUE_NULL_COLOR: "rgb(128, 128, 128)", OBJECT_VALUE_UNDEFINED_COLOR: "rgb(128, 128, 128)", OBJECT_VALUE_REGEXP_COLOR: "rgb(196, 26, 22)", OBJECT_VALUE_STRING_COLOR: "rgb(196, 26, 22)", OBJECT_VALUE_SYMBOL_COLOR: "rgb(196, 26, 22)", OBJECT_VALUE_NUMBER_COLOR: "rgb(28, 0, 207)", OBJECT_VALUE_BOOLEAN_COLOR: "rgb(28, 0, 207)", OBJECT_VALUE_FUNCTION_PREFIX_COLOR: "rgb(13, 34, 170)", HTML_TAG_COLOR: "rgb(168, 148, 166)", HTML_TAGNAME_COLOR: "rgb(136, 18, 128)", HTML_TAGNAME_TEXT_TRANSFORM: "lowercase", HTML_ATTRIBUTE_NAME_COLOR: "rgb(153, 69, 0)", HTML_ATTRIBUTE_VALUE_COLOR: "rgb(26, 26, 166)", HTML_COMMENT_COLOR: "rgb(35, 110, 37)", HTML_DOCTYPE_COLOR: "rgb(192, 192, 192)", ARROW_COLOR: "#6e6e6e", ARROW_MARGIN_RIGHT: 3, ARROW_FONT_SIZE: 12, ARROW_ANIMATION_DURATION: "0", TREENODE_FONT_FAMILY: "Menlo, monospace", TREENODE_FONT_SIZE: "11px", TREENODE_LINE_HEIGHT: 1.2, TREENODE_PADDING_LEFT: 12, TABLE_BORDER_COLOR: "#aaa", TABLE_TH_BACKGROUND_COLOR: "#eee", TABLE_TH_HOVER_COLOR: "hsla(0, 0%, 90%, 1)", TABLE_SORT_ICON_COLOR: "#6e6e6e", TABLE_DATA_BACKGROUND_IMAGE: "linear-gradient(to bottom, white, white 50%, rgb(234, 243, 255) 50%, rgb(234, 243, 255))", TABLE_DATA_BACKGROUND_SIZE: "128px 32px" }, convertColors = (T) => Object.entries(T).reduce((S, [R, k]) => ({ ...S, [R]: mkColor(k) }), {}), create2 = ({ colors: T, mono: S }) => {
  let R = convertColors(T);
  return { token: { fontFamily: S, WebkitFontSmoothing: "antialiased", "&.tag": R.red3, "&.comment": { ...R.green1, fontStyle: "italic" }, "&.prolog": { ...R.green1, fontStyle: "italic" }, "&.doctype": { ...R.green1, fontStyle: "italic" }, "&.cdata": { ...R.green1, fontStyle: "italic" }, "&.string": R.red1, "&.url": R.cyan1, "&.symbol": R.cyan1, "&.number": R.cyan1, "&.boolean": R.cyan1, "&.variable": R.cyan1, "&.constant": R.cyan1, "&.inserted": R.cyan1, "&.atrule": R.blue1, "&.keyword": R.blue1, "&.attr-value": R.blue1, "&.punctuation": R.gray1, "&.operator": R.gray1, "&.function": R.gray1, "&.deleted": R.red2, "&.important": { fontWeight: "bold" }, "&.bold": { fontWeight: "bold" }, "&.italic": { fontStyle: "italic" }, "&.class-name": R.cyan2, "&.selector": R.red3, "&.attr-name": R.red4, "&.property": R.red4, "&.regex": R.red4, "&.entity": R.red4, "&.directive.tag .tag": { background: "#ffff00", ...R.gray1 } }, "language-json .token.boolean": R.blue1, "language-json .token.number": R.blue1, "language-json .token.property": R.cyan2, namespace: { opacity: 0.7 } };
}, lightSyntaxColors = { green1: "#008000", red1: "#A31515", red2: "#9a050f", red3: "#800000", red4: "#ff0000", gray1: "#393A34", cyan1: "#36acaa", cyan2: "#2B91AF", blue1: "#0000ff", blue2: "#00009f" }, darkSyntaxColors = { green1: "#7C7C7C", red1: "#92C379", red2: "#9a050f", red3: "#A8FF60", red4: "#96CBFE", gray1: "#EDEDED", cyan1: "#C6C5FE", cyan2: "#FFFFB6", blue1: "#B474DD", blue2: "#00009f" }, createColors = (T) => ({ primary: T.colorPrimary, secondary: T.colorSecondary, tertiary: color$1.tertiary, ancillary: color$1.ancillary, orange: color$1.orange, gold: color$1.gold, green: color$1.green, seafoam: color$1.seafoam, purple: color$1.purple, ultraviolet: color$1.ultraviolet, lightest: color$1.lightest, lighter: color$1.lighter, light: color$1.light, mediumlight: color$1.mediumlight, medium: color$1.medium, mediumdark: color$1.mediumdark, dark: color$1.dark, darker: color$1.darker, darkest: color$1.darkest, border: color$1.border, positive: color$1.positive, negative: color$1.negative, warning: color$1.warning, critical: color$1.critical, defaultText: T.textColor || color$1.darkest, inverseText: T.textInverseColor || color$1.lightest, positiveText: color$1.positiveText, negativeText: color$1.negativeText, warningText: color$1.warningText }), convert = (T = themes[getPreferredColorScheme()]) => {
  let { base: S, colorPrimary: R, colorSecondary: k, appBg: D, appContentBg: L, appPreviewBg: V, appBorderColor: z, appBorderRadius: W, fontBase: U, fontCode: q, textColor: K, textInverseColor: Y, barTextColor: J, barHoverColor: Z, barSelectedColor: X, barBg: ee, buttonBg: te, buttonBorder: re, booleanBg: Q, booleanSelectedBg: ne, inputBg: oe, inputBorder: ae, inputTextColor: se, inputBorderRadius: ie, brandTitle: he, brandUrl: xe, brandImage: Pe, brandTarget: Re, gridCellSize: ke, ...Te } = T;
  return { ...Te, base: S, color: createColors(T), background: { app: D, bar: ee, content: L, preview: V, gridCellSize: ke || background$1.gridCellSize, hoverable: background$1.hoverable, positive: background$1.positive, negative: background$1.negative, warning: background$1.warning, critical: background$1.critical }, typography: { fonts: { base: U, mono: q }, weight: typography$1.weight, size: typography$1.size }, animation: animation$1, easing: easing$1, input: { background: oe, border: ae, borderRadius: ie, color: se }, button: { background: te || oe, border: re || ae }, boolean: { background: Q || ae, selectedBackground: ne || oe }, layoutMargin: 10, appBorderColor: z, appBorderRadius: W, barTextColor: J, barHoverColor: Z || k, barSelectedColor: X || k, barBg: ee, brand: { title: he, url: xe, image: Pe || (he ? null : void 0), target: Re }, code: create2({ colors: S === "light" ? lightSyntaxColors : darkSyntaxColors, mono: q }), addonActionsTheme: { ...S === "light" ? chromeLight : chromeDark, BASE_FONT_FAMILY: q, BASE_FONT_SIZE: typography$1.size.s2 - 1, BASE_LINE_HEIGHT: "18px", BASE_BACKGROUND_COLOR: "transparent", BASE_COLOR: K, ARROW_COLOR: curriedOpacify$1$1(0.2, z), ARROW_MARGIN_RIGHT: 4, ARROW_FONT_SIZE: 8, TREENODE_FONT_FAMILY: q, TREENODE_FONT_SIZE: typography$1.size.s2 - 1, TREENODE_LINE_HEIGHT: "18px", TREENODE_PADDING_LEFT: 12 } };
}, ignoreSsrWarning = "/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */";
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(T) {
    for (var S = 1; S < arguments.length; S++) {
      var R = arguments[S];
      for (var k in R) Object.prototype.hasOwnProperty.call(R, k) && (T[k] = R[k]);
    }
    return T;
  }, _extends$2.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$2(T, S) {
  if (T == null) return {};
  var R = {}, k = Object.keys(T), D, L;
  for (L = 0; L < k.length; L++) D = k[L], !(S.indexOf(D) >= 0) && (R[D] = T[D]);
  return R;
}
var __create$2 = Object.create, __defProp$2 = Object.defineProperty, __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor, __getOwnPropNames$2 = Object.getOwnPropertyNames, __getProtoOf$2 = Object.getPrototypeOf, __hasOwnProp$2 = Object.prototype.hasOwnProperty, __commonJS$2 = (T, S) => function() {
  return S || (0, T[__getOwnPropNames$2(T)[0]])((S = { exports: {} }).exports, S), S.exports;
}, __export$1 = (T, S) => {
  for (var R in S) __defProp$2(T, R, { get: S[R], enumerable: !0 });
}, __copyProps$2 = (T, S, R, k) => {
  if (S && typeof S == "object" || typeof S == "function") for (let D of __getOwnPropNames$2(S)) !__hasOwnProp$2.call(T, D) && D !== R && __defProp$2(T, D, { get: () => S[D], enumerable: !(k = __getOwnPropDesc$2(S, D)) || k.enumerable });
  return T;
}, __toESM$2 = (T, S, R) => (R = T != null ? __create$2(__getProtoOf$2(T)) : {}, __copyProps$2(!T || !T.__esModule ? __defProp$2(R, "default", { value: T, enumerable: !0 }) : R, T)), require_markdown = __commonJS$2({ "../../node_modules/refractor/lang/markdown.js"(T, S) {
  S.exports = R, R.displayName = "markdown", R.aliases = ["md"];
  function R(k) {
    (function(D) {
      var L = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
      function V(Z) {
        return Z = Z.replace(/<inner>/g, function() {
          return L;
        }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + Z + ")");
      }
      var z = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, W = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
        return z;
      }), U = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
      D.languages.markdown = D.languages.extend("markup", {}), D.languages.insertBefore("markdown", "prolog", { "front-matter-block": { pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/, lookbehind: !0, greedy: !0, inside: { punctuation: /^---|---$/, "front-matter": { pattern: /\S+(?:\s+\S+)*/, alias: ["yaml", "language-yaml"], inside: D.languages.yaml } } }, blockquote: { pattern: /^>(?:[\t ]*>)*/m, alias: "punctuation" }, table: { pattern: RegExp("^" + W + U + "(?:" + W + ")*", "m"), inside: { "table-data-rows": { pattern: RegExp("^(" + W + U + ")(?:" + W + ")*$"), lookbehind: !0, inside: { "table-data": { pattern: RegExp(z), inside: D.languages.markdown }, punctuation: /\|/ } }, "table-line": { pattern: RegExp("^(" + W + ")" + U + "$"), lookbehind: !0, inside: { punctuation: /\||:?-{3,}:?/ } }, "table-header-row": { pattern: RegExp("^" + W + "$"), inside: { "table-header": { pattern: RegExp(z), alias: "important", inside: D.languages.markdown }, punctuation: /\|/ } } } }, code: [{ pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/, lookbehind: !0, alias: "keyword" }, { pattern: /^```[\s\S]*?^```$/m, greedy: !0, inside: { "code-block": { pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m, lookbehind: !0 }, "code-language": { pattern: /^(```).+/, lookbehind: !0 }, punctuation: /```/ } }], title: [{ pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m, alias: "important", inside: { punctuation: /==+$|--+$/ } }, { pattern: /(^\s*)#.+/m, lookbehind: !0, alias: "important", inside: { punctuation: /^#+|#+$/ } }], hr: { pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m, lookbehind: !0, alias: "punctuation" }, list: { pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m, lookbehind: !0, alias: "punctuation" }, "url-reference": { pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/, inside: { variable: { pattern: /^(!?\[)[^\]]+/, lookbehind: !0 }, string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/, punctuation: /^[\[\]!:]|[<>]/ }, alias: "url" }, bold: { pattern: V(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source), lookbehind: !0, greedy: !0, inside: { content: { pattern: /(^..)[\s\S]+(?=..$)/, lookbehind: !0, inside: {} }, punctuation: /\*\*|__/ } }, italic: { pattern: V(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source), lookbehind: !0, greedy: !0, inside: { content: { pattern: /(^.)[\s\S]+(?=.$)/, lookbehind: !0, inside: {} }, punctuation: /[*_]/ } }, strike: { pattern: V(/(~~?)(?:(?!~)<inner>)+\2/.source), lookbehind: !0, greedy: !0, inside: { content: { pattern: /(^~~?)[\s\S]+(?=\1$)/, lookbehind: !0, inside: {} }, punctuation: /~~?/ } }, "code-snippet": { pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/, lookbehind: !0, greedy: !0, alias: ["code", "keyword"] }, url: { pattern: V(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source), lookbehind: !0, greedy: !0, inside: { operator: /^!/, content: { pattern: /(^\[)[^\]]+(?=\])/, lookbehind: !0, inside: {} }, variable: { pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/, lookbehind: !0 }, url: { pattern: /(^\]\()[^\s)]+/, lookbehind: !0 }, string: { pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/, lookbehind: !0 } } } }), ["url", "bold", "italic", "strike"].forEach(function(Z) {
        ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(X) {
          Z !== X && (D.languages.markdown[Z].inside.content.inside[X] = D.languages.markdown[X]);
        });
      }), D.hooks.add("after-tokenize", function(Z) {
        if (Z.language !== "markdown" && Z.language !== "md") return;
        function X(ee) {
          if (!(!ee || typeof ee == "string")) for (var te = 0, re = ee.length; te < re; te++) {
            var Q = ee[te];
            if (Q.type !== "code") {
              X(Q.content);
              continue;
            }
            var ne = Q.content[1], oe = Q.content[3];
            if (ne && oe && ne.type === "code-language" && oe.type === "code-block" && typeof ne.content == "string") {
              var ae = ne.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
              ae = (/[a-z][\w-]*/i.exec(ae) || [""])[0].toLowerCase();
              var se = "language-" + ae;
              oe.alias ? typeof oe.alias == "string" ? oe.alias = [oe.alias, se] : oe.alias.push(se) : oe.alias = [se];
            }
          }
        }
        X(Z.tokens);
      }), D.hooks.add("wrap", function(Z) {
        if (Z.type === "code-block") {
          for (var X = "", ee = 0, te = Z.classes.length; ee < te; ee++) {
            var re = Z.classes[ee], Q = /language-(.+)/.exec(re);
            if (Q) {
              X = Q[1];
              break;
            }
          }
          var ne = D.languages[X];
          if (ne) Z.content = D.highlight(J(Z.content.value), ne, X);
          else if (X && X !== "none" && D.plugins.autoloader) {
            var oe = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
            Z.attributes.id = oe, D.plugins.autoloader.loadLanguages(X, function() {
              var ae = document.getElementById(oe);
              ae && (ae.innerHTML = D.highlight(ae.textContent, D.languages[X], X));
            });
          }
        }
      });
      var q = RegExp(D.languages.markup.tag.pattern.source, "gi"), K = { amp: "&", lt: "<", gt: ">", quot: '"' }, Y = String.fromCodePoint || String.fromCharCode;
      function J(Z) {
        var X = Z.replace(q, "");
        return X = X.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(ee, te) {
          if (te = te.toLowerCase(), te[0] === "#") {
            var re;
            return te[1] === "x" ? re = parseInt(te.slice(2), 16) : re = Number(te.slice(1)), Y(re);
          } else {
            var Q = K[te];
            return Q || ee;
          }
        }), X;
      }
      D.languages.md = D.languages.markdown;
    })(k);
  }
} }), require_yaml = __commonJS$2({ "../../node_modules/refractor/lang/yaml.js"(T, S) {
  S.exports = R, R.displayName = "yaml", R.aliases = ["yml"];
  function R(k) {
    (function(D) {
      var L = /[*&][^\s[\]{},]+/, V = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, z = "(?:" + V.source + "(?:[ 	]+" + L.source + ")?|" + L.source + "(?:[ 	]+" + V.source + ")?)", W = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
        return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
      }), U = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
      function q(K, Y) {
        Y = (Y || "").replace(/m/g, "") + "m";
        var J = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
          return z;
        }).replace(/<<value>>/g, function() {
          return K;
        });
        return RegExp(J, Y);
      }
      D.languages.yaml = { scalar: { pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
        return z;
      })), lookbehind: !0, alias: "string" }, comment: /#.*/, key: { pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
        return z;
      }).replace(/<<key>>/g, function() {
        return "(?:" + W + "|" + U + ")";
      })), lookbehind: !0, greedy: !0, alias: "atrule" }, directive: { pattern: /(^[ \t]*)%.+/m, lookbehind: !0, alias: "important" }, datetime: { pattern: q(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source), lookbehind: !0, alias: "number" }, boolean: { pattern: q(/false|true/.source, "i"), lookbehind: !0, alias: "important" }, null: { pattern: q(/null|~/.source, "i"), lookbehind: !0, alias: "important" }, string: { pattern: q(U), lookbehind: !0, greedy: !0 }, number: { pattern: q(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"), lookbehind: !0 }, tag: V, important: L, punctuation: /---|[:[\]{}\-,|>?]|\.\.\./ }, D.languages.yml = D.languages.yaml;
    })(k);
  }
} }), require_typescript = __commonJS$2({ "../../node_modules/refractor/lang/typescript.js"(T, S) {
  S.exports = R, R.displayName = "typescript", R.aliases = ["ts"];
  function R(k) {
    (function(D) {
      D.languages.typescript = D.languages.extend("javascript", { "class-name": { pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/, lookbehind: !0, greedy: !0, inside: null }, builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/ }), D.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/), delete D.languages.typescript.parameter, delete D.languages.typescript["literal-property"];
      var L = D.languages.extend("typescript", {});
      delete L["class-name"], D.languages.typescript["class-name"].inside = L, D.languages.insertBefore("typescript", "function", { decorator: { pattern: /@[$\w\xA0-\uFFFF]+/, inside: { at: { pattern: /^@/, alias: "operator" }, function: /^[\s\S]+/ } }, "generic-function": { pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/, greedy: !0, inside: { function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/, generic: { pattern: /<[\s\S]+/, alias: "class-name", inside: L } } } }), D.languages.ts = D.languages.typescript;
    })(k);
  }
} }), require_jsx = __commonJS$2({ "../../node_modules/refractor/lang/jsx.js"(T, S) {
  S.exports = R, R.displayName = "jsx", R.aliases = [];
  function R(k) {
    (function(D) {
      var L = D.util.clone(D.languages.javascript), V = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, z = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, W = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
      function U(Y, J) {
        return Y = Y.replace(/<S>/g, function() {
          return V;
        }).replace(/<BRACES>/g, function() {
          return z;
        }).replace(/<SPREAD>/g, function() {
          return W;
        }), RegExp(Y, J);
      }
      W = U(W).source, D.languages.jsx = D.languages.extend("markup", L), D.languages.jsx.tag.pattern = U(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), D.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, D.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, D.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, D.languages.jsx.tag.inside.comment = L.comment, D.languages.insertBefore("inside", "attr-name", { spread: { pattern: U(/<SPREAD>/.source), inside: D.languages.jsx } }, D.languages.jsx.tag), D.languages.insertBefore("inside", "special-attr", { script: { pattern: U(/=<BRACES>/.source), alias: "language-javascript", inside: { "script-punctuation": { pattern: /^=(?=\{)/, alias: "punctuation" }, rest: D.languages.jsx } } }, D.languages.jsx.tag);
      var q = function(Y) {
        return Y ? typeof Y == "string" ? Y : typeof Y.content == "string" ? Y.content : Y.content.map(q).join("") : "";
      }, K = function(Y) {
        for (var J = [], Z = 0; Z < Y.length; Z++) {
          var X = Y[Z], ee = !1;
          if (typeof X != "string" && (X.type === "tag" && X.content[0] && X.content[0].type === "tag" ? X.content[0].content[0].content === "</" ? J.length > 0 && J[J.length - 1].tagName === q(X.content[0].content[1]) && J.pop() : X.content[X.content.length - 1].content === "/>" || J.push({ tagName: q(X.content[0].content[1]), openedBraces: 0 }) : J.length > 0 && X.type === "punctuation" && X.content === "{" ? J[J.length - 1].openedBraces++ : J.length > 0 && J[J.length - 1].openedBraces > 0 && X.type === "punctuation" && X.content === "}" ? J[J.length - 1].openedBraces-- : ee = !0), (ee || typeof X == "string") && J.length > 0 && J[J.length - 1].openedBraces === 0) {
            var te = q(X);
            Z < Y.length - 1 && (typeof Y[Z + 1] == "string" || Y[Z + 1].type === "plain-text") && (te += q(Y[Z + 1]), Y.splice(Z + 1, 1)), Z > 0 && (typeof Y[Z - 1] == "string" || Y[Z - 1].type === "plain-text") && (te = q(Y[Z - 1]) + te, Y.splice(Z - 1, 1), Z--), Y[Z] = new D.Token("plain-text", te, null, te);
          }
          X.content && typeof X.content != "string" && K(X.content);
        }
      };
      D.hooks.add("after-tokenize", function(Y) {
        Y.language !== "jsx" && Y.language !== "tsx" || K(Y.tokens);
      });
    })(k);
  }
} }), require_tsx = __commonJS$2({ "../../node_modules/refractor/lang/tsx.js"(T, S) {
  var R = require_jsx(), k = require_typescript();
  S.exports = D, D.displayName = "tsx", D.aliases = [];
  function D(L) {
    L.register(R), L.register(k), function(V) {
      var z = V.util.clone(V.languages.typescript);
      V.languages.tsx = V.languages.extend("jsx", z), delete V.languages.tsx.parameter, delete V.languages.tsx["literal-property"];
      var W = V.languages.tsx.tag;
      W.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + W.pattern.source + ")", W.pattern.flags), W.lookbehind = !0;
    }(L);
  }
} }), require_clike = __commonJS$2({ "../../node_modules/refractor/lang/clike.js"(T, S) {
  S.exports = R, R.displayName = "clike", R.aliases = [];
  function R(k) {
    k.languages.clike = { comment: [{ pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/, lookbehind: !0, greedy: !0 }, { pattern: /(^|[^\\:])\/\/.*/, lookbehind: !0, greedy: !0 }], string: { pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, greedy: !0 }, "class-name": { pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i, lookbehind: !0, inside: { punctuation: /[.\\]/ } }, keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/, boolean: /\b(?:false|true)\b/, function: /\b\w+(?=\()/, number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i, operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/, punctuation: /[{}[\];(),.:]/ };
  }
} }), require_javascript = __commonJS$2({ "../../node_modules/refractor/lang/javascript.js"(T, S) {
  S.exports = R, R.displayName = "javascript", R.aliases = ["js"];
  function R(k) {
    k.languages.javascript = k.languages.extend("clike", { "class-name": [k.languages.clike["class-name"], { pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/, lookbehind: !0 }], keyword: [{ pattern: /((?:^|\})\s*)catch\b/, lookbehind: !0 }, { pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/, lookbehind: !0 }], function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/, number: { pattern: RegExp(/(^|[^\w$])/.source + "(?:" + (/NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source), lookbehind: !0 }, operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/ }), k.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, k.languages.insertBefore("javascript", "keyword", { regex: { pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/, lookbehind: !0, greedy: !0, inside: { "regex-source": { pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/, lookbehind: !0, alias: "language-regex", inside: k.languages.regex }, "regex-delimiter": /^\/|\/$/, "regex-flags": /^[a-z]+$/ } }, "function-variable": { pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/, alias: "function" }, parameter: [{ pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/, lookbehind: !0, inside: k.languages.javascript }, { pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i, lookbehind: !0, inside: k.languages.javascript }, { pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/, lookbehind: !0, inside: k.languages.javascript }, { pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/, lookbehind: !0, inside: k.languages.javascript }], constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/ }), k.languages.insertBefore("javascript", "string", { hashbang: { pattern: /^#!.*/, greedy: !0, alias: "comment" }, "template-string": { pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/, greedy: !0, inside: { "template-punctuation": { pattern: /^`|`$/, alias: "string" }, interpolation: { pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/, lookbehind: !0, inside: { "interpolation-punctuation": { pattern: /^\$\{|\}$/, alias: "punctuation" }, rest: k.languages.javascript } }, string: /[\s\S]+/ } }, "string-property": { pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m, lookbehind: !0, greedy: !0, alias: "property" } }), k.languages.insertBefore("javascript", "operator", { "literal-property": { pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m, lookbehind: !0, alias: "property" } }), k.languages.markup && (k.languages.markup.tag.addInlined("script", "javascript"), k.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), k.languages.js = k.languages.javascript;
  }
} }), require_css = __commonJS$2({ "../../node_modules/refractor/lang/css.js"(T, S) {
  S.exports = R, R.displayName = "css", R.aliases = [];
  function R(k) {
    (function(D) {
      var L = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
      D.languages.css = { comment: /\/\*[\s\S]*?\*\//, atrule: { pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/, inside: { rule: /^@[\w-]+/, "selector-function-argument": { pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/, lookbehind: !0, alias: "selector" }, keyword: { pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/, lookbehind: !0 } } }, url: { pattern: RegExp("\\burl\\((?:" + L.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"), greedy: !0, inside: { function: /^url/i, punctuation: /^\(|\)$/, string: { pattern: RegExp("^" + L.source + "$"), alias: "url" } } }, selector: { pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + L.source + ")*(?=\\s*\\{)"), lookbehind: !0 }, string: { pattern: L, greedy: !0 }, property: { pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i, lookbehind: !0 }, important: /!important\b/i, function: { pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i, lookbehind: !0 }, punctuation: /[(){};:,]/ }, D.languages.css.atrule.inside.rest = D.languages.css;
      var V = D.languages.markup;
      V && (V.tag.addInlined("style", "css"), V.tag.addAttribute("style", "css"));
    })(k);
  }
} }), require_markup = __commonJS$2({ "../../node_modules/refractor/lang/markup.js"(T, S) {
  S.exports = R, R.displayName = "markup", R.aliases = ["html", "mathml", "svg", "xml", "ssml", "atom", "rss"];
  function R(k) {
    k.languages.markup = { comment: { pattern: /<!--(?:(?!<!--)[\s\S])*?-->/, greedy: !0 }, prolog: { pattern: /<\?[\s\S]+?\?>/, greedy: !0 }, doctype: { pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i, greedy: !0, inside: { "internal-subset": { pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/, lookbehind: !0, greedy: !0, inside: null }, string: { pattern: /"[^"]*"|'[^']*'/, greedy: !0 }, punctuation: /^<!|>$|[[\]]/, "doctype-tag": /^DOCTYPE/i, name: /[^\s<>'"]+/ } }, cdata: { pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i, greedy: !0 }, tag: { pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/, greedy: !0, inside: { tag: { pattern: /^<\/?[^\s>\/]+/, inside: { punctuation: /^<\/?/, namespace: /^[^\s>\/:]+:/ } }, "special-attr": [], "attr-value": { pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/, inside: { punctuation: [{ pattern: /^=/, alias: "attr-equals" }, /"|'/] } }, punctuation: /\/?>/, "attr-name": { pattern: /[^\s>\/]+/, inside: { namespace: /^[^\s>\/:]+:/ } } } }, entity: [{ pattern: /&[\da-z]{1,8};/i, alias: "named-entity" }, /&#x?[\da-f]{1,8};/i] }, k.languages.markup.tag.inside["attr-value"].inside.entity = k.languages.markup.entity, k.languages.markup.doctype.inside["internal-subset"].inside = k.languages.markup, k.hooks.add("wrap", function(D) {
      D.type === "entity" && (D.attributes.title = D.content.value.replace(/&amp;/, "&"));
    }), Object.defineProperty(k.languages.markup.tag, "addInlined", { value: function(D, L) {
      var V = {};
      V["language-" + L] = { pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i, lookbehind: !0, inside: k.languages[L] }, V.cdata = /^<!\[CDATA\[|\]\]>$/i;
      var z = { "included-cdata": { pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i, inside: V } };
      z["language-" + L] = { pattern: /[\s\S]+/, inside: k.languages[L] };
      var W = {};
      W[D] = { pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
        return D;
      }), "i"), lookbehind: !0, greedy: !0, inside: z }, k.languages.insertBefore("markup", "cdata", W);
    } }), Object.defineProperty(k.languages.markup.tag, "addAttribute", { value: function(D, L) {
      k.languages.markup.tag.inside["special-attr"].push({ pattern: RegExp(/(^|["'\s])/.source + "(?:" + D + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"), lookbehind: !0, inside: { "attr-name": /^[^\s=]+/, "attr-value": { pattern: /=[\s\S]+/, inside: { value: { pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/, lookbehind: !0, alias: [L, "language-" + L], inside: k.languages[L] }, punctuation: [{ pattern: /^=/, alias: "attr-equals" }, /"|'/] } } } });
    } }), k.languages.html = k.languages.markup, k.languages.mathml = k.languages.markup, k.languages.svg = k.languages.markup, k.languages.xml = k.languages.extend("markup", {}), k.languages.ssml = k.languages.xml, k.languages.atom = k.languages.xml, k.languages.rss = k.languages.xml;
  }
} }), require_immutable = __commonJS$2({ "../../node_modules/xtend/immutable.js"(T, S) {
  S.exports = k;
  var R = Object.prototype.hasOwnProperty;
  function k() {
    for (var D = {}, L = 0; L < arguments.length; L++) {
      var V = arguments[L];
      for (var z in V) R.call(V, z) && (D[z] = V[z]);
    }
    return D;
  }
} }), require_schema = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/util/schema.js"(T, S) {
  S.exports = k;
  var R = k.prototype;
  R.space = null, R.normal = {}, R.property = {};
  function k(D, L, V) {
    this.property = D, this.normal = L, V && (this.space = V);
  }
} }), require_merge = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/util/merge.js"(T, S) {
  var R = require_immutable(), k = require_schema();
  S.exports = D;
  function D(L) {
    for (var V = L.length, z = [], W = [], U = -1, q, K; ++U < V; ) q = L[U], z.push(q.property), W.push(q.normal), K = q.space;
    return new k(R.apply(null, z), R.apply(null, W), K);
  }
} }), require_normalize = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/normalize.js"(T, S) {
  S.exports = R;
  function R(k) {
    return k.toLowerCase();
  }
} }), require_info = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/util/info.js"(T, S) {
  S.exports = k;
  var R = k.prototype;
  R.space = null, R.attribute = null, R.property = null, R.boolean = !1, R.booleanish = !1, R.overloadedBoolean = !1, R.number = !1, R.commaSeparated = !1, R.spaceSeparated = !1, R.commaOrSpaceSeparated = !1, R.mustUseProperty = !1, R.defined = !1;
  function k(D, L) {
    this.property = D, this.attribute = L;
  }
} }), require_types = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/util/types.js"(T) {
  var S = 0;
  T.boolean = R(), T.booleanish = R(), T.overloadedBoolean = R(), T.number = R(), T.spaceSeparated = R(), T.commaSeparated = R(), T.commaOrSpaceSeparated = R();
  function R() {
    return Math.pow(2, ++S);
  }
} }), require_defined_info = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/util/defined-info.js"(T, S) {
  var R = require_info(), k = require_types();
  S.exports = V, V.prototype = new R(), V.prototype.defined = !0;
  var D = ["boolean", "booleanish", "overloadedBoolean", "number", "commaSeparated", "spaceSeparated", "commaOrSpaceSeparated"], L = D.length;
  function V(W, U, q, K) {
    var Y = -1, J;
    for (z(this, "space", K), R.call(this, W, U); ++Y < L; ) J = D[Y], z(this, J, (q & k[J]) === k[J]);
  }
  function z(W, U, q) {
    q && (W[U] = q);
  }
} }), require_create = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/util/create.js"(T, S) {
  var R = require_normalize(), k = require_schema(), D = require_defined_info();
  S.exports = L;
  function L(V) {
    var z = V.space, W = V.mustUseProperty || [], U = V.attributes || {}, q = V.properties, K = V.transform, Y = {}, J = {}, Z, X;
    for (Z in q) X = new D(Z, K(U, Z), q[Z], z), W.indexOf(Z) !== -1 && (X.mustUseProperty = !0), Y[Z] = X, J[R(Z)] = Z, J[R(X.attribute)] = Z;
    return new k(Y, J, z);
  }
} }), require_xlink = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/xlink.js"(T, S) {
  var R = require_create();
  S.exports = R({ space: "xlink", transform: k, properties: { xLinkActuate: null, xLinkArcRole: null, xLinkHref: null, xLinkRole: null, xLinkShow: null, xLinkTitle: null, xLinkType: null } });
  function k(D, L) {
    return "xlink:" + L.slice(5).toLowerCase();
  }
} }), require_xml = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/xml.js"(T, S) {
  var R = require_create();
  S.exports = R({ space: "xml", transform: k, properties: { xmlLang: null, xmlBase: null, xmlSpace: null } });
  function k(D, L) {
    return "xml:" + L.slice(3).toLowerCase();
  }
} }), require_case_sensitive_transform = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/util/case-sensitive-transform.js"(T, S) {
  S.exports = R;
  function R(k, D) {
    return D in k ? k[D] : D;
  }
} }), require_case_insensitive_transform = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/util/case-insensitive-transform.js"(T, S) {
  var R = require_case_sensitive_transform();
  S.exports = k;
  function k(D, L) {
    return R(D, L.toLowerCase());
  }
} }), require_xmlns = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/xmlns.js"(T, S) {
  var R = require_create(), k = require_case_insensitive_transform();
  S.exports = R({ space: "xmlns", attributes: { xmlnsxlink: "xmlns:xlink" }, transform: k, properties: { xmlns: null, xmlnsXLink: null } });
} }), require_aria = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/aria.js"(T, S) {
  var R = require_types(), k = require_create(), D = R.booleanish, L = R.number, V = R.spaceSeparated;
  S.exports = k({ transform: z, properties: { ariaActiveDescendant: null, ariaAtomic: D, ariaAutoComplete: null, ariaBusy: D, ariaChecked: D, ariaColCount: L, ariaColIndex: L, ariaColSpan: L, ariaControls: V, ariaCurrent: null, ariaDescribedBy: V, ariaDetails: null, ariaDisabled: D, ariaDropEffect: V, ariaErrorMessage: null, ariaExpanded: D, ariaFlowTo: V, ariaGrabbed: D, ariaHasPopup: null, ariaHidden: D, ariaInvalid: null, ariaKeyShortcuts: null, ariaLabel: null, ariaLabelledBy: V, ariaLevel: L, ariaLive: null, ariaModal: D, ariaMultiLine: D, ariaMultiSelectable: D, ariaOrientation: null, ariaOwns: V, ariaPlaceholder: null, ariaPosInSet: L, ariaPressed: D, ariaReadOnly: D, ariaRelevant: null, ariaRequired: D, ariaRoleDescription: V, ariaRowCount: L, ariaRowIndex: L, ariaRowSpan: L, ariaSelected: D, ariaSetSize: L, ariaSort: null, ariaValueMax: L, ariaValueMin: L, ariaValueNow: L, ariaValueText: null, role: null } });
  function z(W, U) {
    return U === "role" ? U : "aria-" + U.slice(4).toLowerCase();
  }
} }), require_html = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/lib/html.js"(T, S) {
  var R = require_types(), k = require_create(), D = require_case_insensitive_transform(), L = R.boolean, V = R.overloadedBoolean, z = R.booleanish, W = R.number, U = R.spaceSeparated, q = R.commaSeparated;
  S.exports = k({ space: "html", attributes: { acceptcharset: "accept-charset", classname: "class", htmlfor: "for", httpequiv: "http-equiv" }, transform: D, mustUseProperty: ["checked", "multiple", "muted", "selected"], properties: { abbr: null, accept: q, acceptCharset: U, accessKey: U, action: null, allow: null, allowFullScreen: L, allowPaymentRequest: L, allowUserMedia: L, alt: null, as: null, async: L, autoCapitalize: null, autoComplete: U, autoFocus: L, autoPlay: L, capture: L, charSet: null, checked: L, cite: null, className: U, cols: W, colSpan: null, content: null, contentEditable: z, controls: L, controlsList: U, coords: W | q, crossOrigin: null, data: null, dateTime: null, decoding: null, default: L, defer: L, dir: null, dirName: null, disabled: L, download: V, draggable: z, encType: null, enterKeyHint: null, form: null, formAction: null, formEncType: null, formMethod: null, formNoValidate: L, formTarget: null, headers: U, height: W, hidden: L, high: W, href: null, hrefLang: null, htmlFor: U, httpEquiv: U, id: null, imageSizes: null, imageSrcSet: q, inputMode: null, integrity: null, is: null, isMap: L, itemId: null, itemProp: U, itemRef: U, itemScope: L, itemType: U, kind: null, label: null, lang: null, language: null, list: null, loading: null, loop: L, low: W, manifest: null, max: null, maxLength: W, media: null, method: null, min: null, minLength: W, multiple: L, muted: L, name: null, nonce: null, noModule: L, noValidate: L, onAbort: null, onAfterPrint: null, onAuxClick: null, onBeforePrint: null, onBeforeUnload: null, onBlur: null, onCancel: null, onCanPlay: null, onCanPlayThrough: null, onChange: null, onClick: null, onClose: null, onContextMenu: null, onCopy: null, onCueChange: null, onCut: null, onDblClick: null, onDrag: null, onDragEnd: null, onDragEnter: null, onDragExit: null, onDragLeave: null, onDragOver: null, onDragStart: null, onDrop: null, onDurationChange: null, onEmptied: null, onEnded: null, onError: null, onFocus: null, onFormData: null, onHashChange: null, onInput: null, onInvalid: null, onKeyDown: null, onKeyPress: null, onKeyUp: null, onLanguageChange: null, onLoad: null, onLoadedData: null, onLoadedMetadata: null, onLoadEnd: null, onLoadStart: null, onMessage: null, onMessageError: null, onMouseDown: null, onMouseEnter: null, onMouseLeave: null, onMouseMove: null, onMouseOut: null, onMouseOver: null, onMouseUp: null, onOffline: null, onOnline: null, onPageHide: null, onPageShow: null, onPaste: null, onPause: null, onPlay: null, onPlaying: null, onPopState: null, onProgress: null, onRateChange: null, onRejectionHandled: null, onReset: null, onResize: null, onScroll: null, onSecurityPolicyViolation: null, onSeeked: null, onSeeking: null, onSelect: null, onSlotChange: null, onStalled: null, onStorage: null, onSubmit: null, onSuspend: null, onTimeUpdate: null, onToggle: null, onUnhandledRejection: null, onUnload: null, onVolumeChange: null, onWaiting: null, onWheel: null, open: L, optimum: W, pattern: null, ping: U, placeholder: null, playsInline: L, poster: null, preload: null, readOnly: L, referrerPolicy: null, rel: U, required: L, reversed: L, rows: W, rowSpan: W, sandbox: U, scope: null, scoped: L, seamless: L, selected: L, shape: null, size: W, sizes: null, slot: null, span: W, spellCheck: z, src: null, srcDoc: null, srcLang: null, srcSet: q, start: W, step: null, style: null, tabIndex: W, target: null, title: null, translate: null, type: null, typeMustMatch: L, useMap: null, value: z, width: W, wrap: null, align: null, aLink: null, archive: U, axis: null, background: null, bgColor: null, border: W, borderColor: null, bottomMargin: W, cellPadding: null, cellSpacing: null, char: null, charOff: null, classId: null, clear: null, code: null, codeBase: null, codeType: null, color: null, compact: L, declare: L, event: null, face: null, frame: null, frameBorder: null, hSpace: W, leftMargin: W, link: null, longDesc: null, lowSrc: null, marginHeight: W, marginWidth: W, noResize: L, noHref: L, noShade: L, noWrap: L, object: null, profile: null, prompt: null, rev: null, rightMargin: W, rules: null, scheme: null, scrolling: z, standby: null, summary: null, text: null, topMargin: W, valueType: null, version: null, vAlign: null, vLink: null, vSpace: W, allowTransparency: null, autoCorrect: null, autoSave: null, disablePictureInPicture: L, disableRemotePlayback: L, prefix: null, property: null, results: W, security: null, unselectable: null } });
} }), require_html2 = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/html.js"(T, S) {
  var R = require_merge(), k = require_xlink(), D = require_xml(), L = require_xmlns(), V = require_aria(), z = require_html();
  S.exports = R([D, k, L, V, z]);
} }), require_find = __commonJS$2({ "../../node_modules/hastscript/node_modules/property-information/find.js"(T, S) {
  var R = require_normalize(), k = require_defined_info(), D = require_info(), L = "data";
  S.exports = U;
  var V = /^data[-\w.:]+$/i, z = /-[a-z]/g, W = /[A-Z]/g;
  function U(Z, X) {
    var ee = R(X), te = X, re = D;
    return ee in Z.normal ? Z.property[Z.normal[ee]] : (ee.length > 4 && ee.slice(0, 4) === L && V.test(X) && (X.charAt(4) === "-" ? te = q(X) : X = K(X), re = k), new re(te, X));
  }
  function q(Z) {
    var X = Z.slice(5).replace(z, J);
    return L + X.charAt(0).toUpperCase() + X.slice(1);
  }
  function K(Z) {
    var X = Z.slice(4);
    return z.test(X) ? Z : (X = X.replace(W, Y), X.charAt(0) !== "-" && (X = "-" + X), L + X);
  }
  function Y(Z) {
    return "-" + Z.toLowerCase();
  }
  function J(Z) {
    return Z.charAt(1).toUpperCase();
  }
} }), require_hast_util_parse_selector = __commonJS$2({ "../../node_modules/hast-util-parse-selector/index.js"(T, S) {
  S.exports = k;
  var R = /[#.]/g;
  function k(D, L) {
    for (var V = D || "", z = L || "div", W = {}, U = 0, q, K, Y; U < V.length; ) R.lastIndex = U, Y = R.exec(V), q = V.slice(U, Y ? Y.index : V.length), q && (K ? K === "#" ? W.id = q : W.className ? W.className.push(q) : W.className = [q] : z = q, U += q.length), Y && (K = Y[0], U++);
    return { type: "element", tagName: z, properties: W, children: [] };
  }
} }), require_space_separated_tokens = __commonJS$2({ "../../node_modules/hastscript/node_modules/space-separated-tokens/index.js"(T) {
  T.parse = D, T.stringify = L;
  var S = "", R = " ", k = /[ \t\n\r\f]+/g;
  function D(V) {
    var z = String(V || S).trim();
    return z === S ? [] : z.split(k);
  }
  function L(V) {
    return V.join(R).trim();
  }
} }), require_comma_separated_tokens = __commonJS$2({ "../../node_modules/hastscript/node_modules/comma-separated-tokens/index.js"(T) {
  T.parse = D, T.stringify = L;
  var S = ",", R = " ", k = "";
  function D(V) {
    for (var z = [], W = String(V || k), U = W.indexOf(S), q = 0, K = !1, Y; !K; ) U === -1 && (U = W.length, K = !0), Y = W.slice(q, U).trim(), (Y || !K) && z.push(Y), q = U + 1, U = W.indexOf(S, q);
    return z;
  }
  function L(V, z) {
    var W = z || {}, U = W.padLeft === !1 ? k : R, q = W.padRight ? R : k;
    return V[V.length - 1] === k && (V = V.concat(k)), V.join(q + S + U).trim();
  }
} }), require_factory = __commonJS$2({ "../../node_modules/hastscript/factory.js"(T, S) {
  var R = require_find(), k = require_normalize(), D = require_hast_util_parse_selector(), L = require_space_separated_tokens().parse, V = require_comma_separated_tokens().parse;
  S.exports = W;
  var z = {}.hasOwnProperty;
  function W(ee, te, re) {
    var Q = re ? X(re) : null;
    return ne;
    function ne(ae, se) {
      var ie = D(ae, te), he = Array.prototype.slice.call(arguments, 2), xe = ie.tagName.toLowerCase(), Pe;
      if (ie.tagName = Q && z.call(Q, xe) ? Q[xe] : xe, se && U(se, ie) && (he.unshift(se), se = null), se) for (Pe in se) oe(ie.properties, Pe, se[Pe]);
      return K(ie.children, he), ie.tagName === "template" && (ie.content = { type: "root", children: ie.children }, ie.children = []), ie;
    }
    function oe(ae, se, ie) {
      var he, xe, Pe;
      ie == null || ie !== ie || (he = R(ee, se), xe = he.property, Pe = ie, typeof Pe == "string" && (he.spaceSeparated ? Pe = L(Pe) : he.commaSeparated ? Pe = V(Pe) : he.commaOrSpaceSeparated && (Pe = L(V(Pe).join(" ")))), xe === "style" && typeof ie != "string" && (Pe = Z(Pe)), xe === "className" && ae.className && (Pe = ae.className.concat(Pe)), ae[xe] = Y(he, xe, Pe));
    }
  }
  function U(ee, te) {
    return typeof ee == "string" || "length" in ee || q(te.tagName, ee);
  }
  function q(ee, te) {
    var re = te.type;
    return ee === "input" || !re || typeof re != "string" ? !1 : typeof te.children == "object" && "length" in te.children ? !0 : (re = re.toLowerCase(), ee === "button" ? re !== "menu" && re !== "submit" && re !== "reset" && re !== "button" : "value" in te);
  }
  function K(ee, te) {
    var re, Q;
    if (typeof te == "string" || typeof te == "number") {
      ee.push({ type: "text", value: String(te) });
      return;
    }
    if (typeof te == "object" && "length" in te) {
      for (re = -1, Q = te.length; ++re < Q; ) K(ee, te[re]);
      return;
    }
    if (typeof te != "object" || !("type" in te)) throw new Error("Expected node, nodes, or string, got `" + te + "`");
    ee.push(te);
  }
  function Y(ee, te, re) {
    var Q, ne, oe;
    if (typeof re != "object" || !("length" in re)) return J(ee, te, re);
    for (ne = re.length, Q = -1, oe = []; ++Q < ne; ) oe[Q] = J(ee, te, re[Q]);
    return oe;
  }
  function J(ee, te, re) {
    var Q = re;
    return ee.number || ee.positiveNumber ? !isNaN(Q) && Q !== "" && (Q = Number(Q)) : (ee.boolean || ee.overloadedBoolean) && typeof Q == "string" && (Q === "" || k(re) === k(te)) && (Q = !0), Q;
  }
  function Z(ee) {
    var te = [], re;
    for (re in ee) te.push([re, ee[re]].join(": "));
    return te.join("; ");
  }
  function X(ee) {
    for (var te = ee.length, re = -1, Q = {}, ne; ++re < te; ) ne = ee[re], Q[ne.toLowerCase()] = ne;
    return Q;
  }
} }), require_html3 = __commonJS$2({ "../../node_modules/hastscript/html.js"(T, S) {
  var R = require_html2(), k = require_factory(), D = k(R, "div");
  D.displayName = "html", S.exports = D;
} }), require_hastscript = __commonJS$2({ "../../node_modules/hastscript/index.js"(T, S) {
  S.exports = require_html3();
} }), require_character_entities_legacy = __commonJS$2({ "../../node_modules/refractor/node_modules/character-entities-legacy/index.json"(T, S) {
  S.exports = { AElig: "Æ", AMP: "&", Aacute: "Á", Acirc: "Â", Agrave: "À", Aring: "Å", Atilde: "Ã", Auml: "Ä", COPY: "©", Ccedil: "Ç", ETH: "Ð", Eacute: "É", Ecirc: "Ê", Egrave: "È", Euml: "Ë", GT: ">", Iacute: "Í", Icirc: "Î", Igrave: "Ì", Iuml: "Ï", LT: "<", Ntilde: "Ñ", Oacute: "Ó", Ocirc: "Ô", Ograve: "Ò", Oslash: "Ø", Otilde: "Õ", Ouml: "Ö", QUOT: '"', REG: "®", THORN: "Þ", Uacute: "Ú", Ucirc: "Û", Ugrave: "Ù", Uuml: "Ü", Yacute: "Ý", aacute: "á", acirc: "â", acute: "´", aelig: "æ", agrave: "à", amp: "&", aring: "å", atilde: "ã", auml: "ä", brvbar: "¦", ccedil: "ç", cedil: "¸", cent: "¢", copy: "©", curren: "¤", deg: "°", divide: "÷", eacute: "é", ecirc: "ê", egrave: "è", eth: "ð", euml: "ë", frac12: "½", frac14: "¼", frac34: "¾", gt: ">", iacute: "í", icirc: "î", iexcl: "¡", igrave: "ì", iquest: "¿", iuml: "ï", laquo: "«", lt: "<", macr: "¯", micro: "µ", middot: "·", nbsp: " ", not: "¬", ntilde: "ñ", oacute: "ó", ocirc: "ô", ograve: "ò", ordf: "ª", ordm: "º", oslash: "ø", otilde: "õ", ouml: "ö", para: "¶", plusmn: "±", pound: "£", quot: '"', raquo: "»", reg: "®", sect: "§", shy: "­", sup1: "¹", sup2: "²", sup3: "³", szlig: "ß", thorn: "þ", times: "×", uacute: "ú", ucirc: "û", ugrave: "ù", uml: "¨", uuml: "ü", yacute: "ý", yen: "¥", yuml: "ÿ" };
} }), require_character_reference_invalid = __commonJS$2({ "../../node_modules/refractor/node_modules/character-reference-invalid/index.json"(T, S) {
  S.exports = { 0: "�", 128: "€", 130: "‚", 131: "ƒ", 132: "„", 133: "…", 134: "†", 135: "‡", 136: "ˆ", 137: "‰", 138: "Š", 139: "‹", 140: "Œ", 142: "Ž", 145: "‘", 146: "’", 147: "“", 148: "”", 149: "•", 150: "–", 151: "—", 152: "˜", 153: "™", 154: "š", 155: "›", 156: "œ", 158: "ž", 159: "Ÿ" };
} }), require_is_decimal = __commonJS$2({ "../../node_modules/refractor/node_modules/is-decimal/index.js"(T, S) {
  S.exports = R;
  function R(k) {
    var D = typeof k == "string" ? k.charCodeAt(0) : k;
    return D >= 48 && D <= 57;
  }
} }), require_is_hexadecimal = __commonJS$2({ "../../node_modules/refractor/node_modules/is-hexadecimal/index.js"(T, S) {
  S.exports = R;
  function R(k) {
    var D = typeof k == "string" ? k.charCodeAt(0) : k;
    return D >= 97 && D <= 102 || D >= 65 && D <= 70 || D >= 48 && D <= 57;
  }
} }), require_is_alphabetical = __commonJS$2({ "../../node_modules/refractor/node_modules/is-alphabetical/index.js"(T, S) {
  S.exports = R;
  function R(k) {
    var D = typeof k == "string" ? k.charCodeAt(0) : k;
    return D >= 97 && D <= 122 || D >= 65 && D <= 90;
  }
} }), require_is_alphanumerical = __commonJS$2({ "../../node_modules/refractor/node_modules/is-alphanumerical/index.js"(T, S) {
  var R = require_is_alphabetical(), k = require_is_decimal();
  S.exports = D;
  function D(L) {
    return R(L) || k(L);
  }
} }), require_decode_entity_browser = __commonJS$2({ "../../node_modules/refractor/node_modules/parse-entities/decode-entity.browser.js"(T, S) {
  var R, k = 59;
  S.exports = D;
  function D(L) {
    var V = "&" + L + ";", z;
    return R = R || document.createElement("i"), R.innerHTML = V, z = R.textContent, z.charCodeAt(z.length - 1) === k && L !== "semi" || z === V ? !1 : z;
  }
} }), require_parse_entities = __commonJS$2({ "../../node_modules/refractor/node_modules/parse-entities/index.js"(T, S) {
  var R = require_character_entities_legacy(), k = require_character_reference_invalid(), D = require_is_decimal(), L = require_is_hexadecimal(), V = require_is_alphanumerical(), z = require_decode_entity_browser();
  S.exports = ge;
  var W = {}.hasOwnProperty, U = String.fromCharCode, q = Function.prototype, K = { warning: null, reference: null, text: null, warningContext: null, referenceContext: null, textContext: null, position: {}, additional: null, attribute: !1, nonTerminated: !0 }, Y = 9, J = 10, Z = 12, X = 32, ee = 38, te = 59, re = 60, Q = 61, ne = 35, oe = 88, ae = 120, se = 65533, ie = "named", he = "hexadecimal", xe = "decimal", Pe = {};
  Pe[he] = 16, Pe[xe] = 10;
  var Re = {};
  Re[ie] = V, Re[xe] = D, Re[he] = L;
  var ke = 1, Te = 2, fe = 3, ue = 4, Ce = 5, ce = 6, pe = 7, _e = {};
  _e[ke] = "Named character references must be terminated by a semicolon", _e[Te] = "Numeric character references must be terminated by a semicolon", _e[fe] = "Named character references cannot be empty", _e[ue] = "Numeric character references cannot be empty", _e[Ce] = "Named character references must be known", _e[ce] = "Numeric character references cannot be disallowed", _e[pe] = "Numeric character references cannot be outside the permissible Unicode range";
  function ge(le, me) {
    var Se = {}, ye, be;
    me || (me = {});
    for (be in K) ye = me[be], Se[be] = ye ?? K[be];
    return (Se.position.indent || Se.position.start) && (Se.indent = Se.position.indent || [], Se.position = Se.position.start), Ae(le, Se);
  }
  function Ae(le, me) {
    var Se = me.additional, ye = me.nonTerminated, be = me.text, $e = me.reference, Oe = me.warning, Ie = me.textContext, we = me.referenceContext, Fe = me.warningContext, De = me.position, Le = me.indent || [], ze = le.length, We = 0, Be = -1, Ye = De.column || 1, Ge = De.line || 1, nt = "", Ze = [], Me, Ne, He, qe, Ke, Xe, tt, at, it, mt, Qe, ut, ft, vt, dt, xt, Ot, Rt, Et;
    for (typeof Se == "string" && (Se = Se.charCodeAt(0)), xt = Mt(), at = Oe ? Nt : q, We--, ze++; ++We < ze; ) if (Ke === J && (Ye = Le[Be] || 1), Ke = le.charCodeAt(We), Ke === ee) {
      if (tt = le.charCodeAt(We + 1), tt === Y || tt === J || tt === Z || tt === X || tt === ee || tt === re || tt !== tt || Se && tt === Se) {
        nt += U(Ke), Ye++;
        continue;
      }
      for (ft = We + 1, ut = ft, Et = ft, tt === ne ? (Et = ++ut, tt = le.charCodeAt(Et), tt === oe || tt === ae ? (vt = he, Et = ++ut) : vt = xe) : vt = ie, Me = "", Qe = "", qe = "", dt = Re[vt], Et--; ++Et < ze && (tt = le.charCodeAt(Et), !!dt(tt)); ) qe += U(tt), vt === ie && W.call(R, qe) && (Me = qe, Qe = R[qe]);
      He = le.charCodeAt(Et) === te, He && (Et++, Ne = vt === ie ? z(qe) : !1, Ne && (Me = qe, Qe = Ne)), Rt = 1 + Et - ft, !He && !ye || (qe ? vt === ie ? (He && !Qe ? at(Ce, 1) : (Me !== qe && (Et = ut + Me.length, Rt = 1 + Et - ut, He = !1), He || (it = Me ? ke : fe, me.attribute ? (tt = le.charCodeAt(Et), tt === Q ? (at(it, Rt), Qe = null) : V(tt) ? Qe = null : at(it, Rt)) : at(it, Rt))), Xe = Qe) : (He || at(Te, Rt), Xe = parseInt(qe, Pe[vt]), Ee(Xe) ? (at(pe, Rt), Xe = U(se)) : Xe in k ? (at(ce, Rt), Xe = k[Xe]) : (mt = "", ve(Xe) && at(ce, Rt), Xe > 65535 && (Xe -= 65536, mt += U(Xe >>> 10 | 55296), Xe = 56320 | Xe & 1023), Xe = mt + U(Xe))) : vt !== ie && at(ue, Rt)), Xe ? (jt(), xt = Mt(), We = Et - 1, Ye += Et - ft + 1, Ze.push(Xe), Ot = Mt(), Ot.offset++, $e && $e.call(we, Xe, { start: xt, end: Ot }, le.slice(ft - 1, Et)), xt = Ot) : (qe = le.slice(ft - 1, Et), nt += qe, Ye += qe.length, We = Et - 1);
    } else Ke === 10 && (Ge++, Be++, Ye = 0), Ke === Ke ? (nt += U(Ke), Ye++) : jt();
    return Ze.join("");
    function Mt() {
      return { line: Ge, column: Ye, offset: We + (De.offset || 0) };
    }
    function Nt(Ft, Gt) {
      var Vt = Mt();
      Vt.column += Gt, Vt.offset += Gt, Oe.call(Fe, _e[Ft], Vt, Ft);
    }
    function jt() {
      nt && (Ze.push(nt), be && be.call(Ie, nt, { start: xt, end: Mt() }), nt = "");
    }
  }
  function Ee(le) {
    return le >= 55296 && le <= 57343 || le > 1114111;
  }
  function ve(le) {
    return le >= 1 && le <= 8 || le === 11 || le >= 13 && le <= 31 || le >= 127 && le <= 159 || le >= 64976 && le <= 65007 || (le & 65535) === 65535 || (le & 65535) === 65534;
  }
} }), require_prism_core = __commonJS$2({ "../../node_modules/refractor/node_modules/prismjs/components/prism-core.js"(T, S) {
  var R = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {}, k = function(D) {
    var L = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, V = 0, z = {}, W = { manual: D.Prism && D.Prism.manual, disableWorkerMessageHandler: D.Prism && D.Prism.disableWorkerMessageHandler, util: { encode: function Q(ne) {
      return ne instanceof U ? new U(ne.type, Q(ne.content), ne.alias) : Array.isArray(ne) ? ne.map(Q) : ne.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
    }, type: function(Q) {
      return Object.prototype.toString.call(Q).slice(8, -1);
    }, objId: function(Q) {
      return Q.__id || Object.defineProperty(Q, "__id", { value: ++V }), Q.__id;
    }, clone: function Q(ne, oe) {
      oe = oe || {};
      var ae, se;
      switch (W.util.type(ne)) {
        case "Object":
          if (se = W.util.objId(ne), oe[se]) return oe[se];
          ae = {}, oe[se] = ae;
          for (var ie in ne) ne.hasOwnProperty(ie) && (ae[ie] = Q(ne[ie], oe));
          return ae;
        case "Array":
          return se = W.util.objId(ne), oe[se] ? oe[se] : (ae = [], oe[se] = ae, ne.forEach(function(he, xe) {
            ae[xe] = Q(he, oe);
          }), ae);
        default:
          return ne;
      }
    }, getLanguage: function(Q) {
      for (; Q; ) {
        var ne = L.exec(Q.className);
        if (ne) return ne[1].toLowerCase();
        Q = Q.parentElement;
      }
      return "none";
    }, setLanguage: function(Q, ne) {
      Q.className = Q.className.replace(RegExp(L, "gi"), ""), Q.classList.add("language-" + ne);
    }, currentScript: function() {
      if (typeof document > "u") return null;
      if ("currentScript" in document) return document.currentScript;
      try {
        throw new Error();
      } catch (ae) {
        var Q = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(ae.stack) || [])[1];
        if (Q) {
          var ne = document.getElementsByTagName("script");
          for (var oe in ne) if (ne[oe].src == Q) return ne[oe];
        }
        return null;
      }
    }, isActive: function(Q, ne, oe) {
      for (var ae = "no-" + ne; Q; ) {
        var se = Q.classList;
        if (se.contains(ne)) return !0;
        if (se.contains(ae)) return !1;
        Q = Q.parentElement;
      }
      return !!oe;
    } }, languages: { plain: z, plaintext: z, text: z, txt: z, extend: function(Q, ne) {
      var oe = W.util.clone(W.languages[Q]);
      for (var ae in ne) oe[ae] = ne[ae];
      return oe;
    }, insertBefore: function(Q, ne, oe, ae) {
      ae = ae || W.languages;
      var se = ae[Q], ie = {};
      for (var he in se) if (se.hasOwnProperty(he)) {
        if (he == ne) for (var xe in oe) oe.hasOwnProperty(xe) && (ie[xe] = oe[xe]);
        oe.hasOwnProperty(he) || (ie[he] = se[he]);
      }
      var Pe = ae[Q];
      return ae[Q] = ie, W.languages.DFS(W.languages, function(Re, ke) {
        ke === Pe && Re != Q && (this[Re] = ie);
      }), ie;
    }, DFS: function Q(ne, oe, ae, se) {
      se = se || {};
      var ie = W.util.objId;
      for (var he in ne) if (ne.hasOwnProperty(he)) {
        oe.call(ne, he, ne[he], ae || he);
        var xe = ne[he], Pe = W.util.type(xe);
        Pe === "Object" && !se[ie(xe)] ? (se[ie(xe)] = !0, Q(xe, oe, null, se)) : Pe === "Array" && !se[ie(xe)] && (se[ie(xe)] = !0, Q(xe, oe, he, se));
      }
    } }, plugins: {}, highlightAll: function(Q, ne) {
      W.highlightAllUnder(document, Q, ne);
    }, highlightAllUnder: function(Q, ne, oe) {
      var ae = { callback: oe, container: Q, selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code' };
      W.hooks.run("before-highlightall", ae), ae.elements = Array.prototype.slice.apply(ae.container.querySelectorAll(ae.selector)), W.hooks.run("before-all-elements-highlight", ae);
      for (var se = 0, ie; ie = ae.elements[se++]; ) W.highlightElement(ie, ne === !0, ae.callback);
    }, highlightElement: function(Q, ne, oe) {
      var ae = W.util.getLanguage(Q), se = W.languages[ae];
      W.util.setLanguage(Q, ae);
      var ie = Q.parentElement;
      ie && ie.nodeName.toLowerCase() === "pre" && W.util.setLanguage(ie, ae);
      var he = Q.textContent, xe = { element: Q, language: ae, grammar: se, code: he };
      function Pe(ke) {
        xe.highlightedCode = ke, W.hooks.run("before-insert", xe), xe.element.innerHTML = xe.highlightedCode, W.hooks.run("after-highlight", xe), W.hooks.run("complete", xe), oe && oe.call(xe.element);
      }
      if (W.hooks.run("before-sanity-check", xe), ie = xe.element.parentElement, ie && ie.nodeName.toLowerCase() === "pre" && !ie.hasAttribute("tabindex") && ie.setAttribute("tabindex", "0"), !xe.code) {
        W.hooks.run("complete", xe), oe && oe.call(xe.element);
        return;
      }
      if (W.hooks.run("before-highlight", xe), !xe.grammar) {
        Pe(W.util.encode(xe.code));
        return;
      }
      if (ne && D.Worker) {
        var Re = new Worker(W.filename);
        Re.onmessage = function(ke) {
          Pe(ke.data);
        }, Re.postMessage(JSON.stringify({ language: xe.language, code: xe.code, immediateClose: !0 }));
      } else Pe(W.highlight(xe.code, xe.grammar, xe.language));
    }, highlight: function(Q, ne, oe) {
      var ae = { code: Q, grammar: ne, language: oe };
      if (W.hooks.run("before-tokenize", ae), !ae.grammar) throw new Error('The language "' + ae.language + '" has no grammar.');
      return ae.tokens = W.tokenize(ae.code, ae.grammar), W.hooks.run("after-tokenize", ae), U.stringify(W.util.encode(ae.tokens), ae.language);
    }, tokenize: function(Q, ne) {
      var oe = ne.rest;
      if (oe) {
        for (var ae in oe) ne[ae] = oe[ae];
        delete ne.rest;
      }
      var se = new Y();
      return J(se, se.head, Q), K(Q, se, ne, se.head, 0), X(se);
    }, hooks: { all: {}, add: function(Q, ne) {
      var oe = W.hooks.all;
      oe[Q] = oe[Q] || [], oe[Q].push(ne);
    }, run: function(Q, ne) {
      var oe = W.hooks.all[Q];
      if (!(!oe || !oe.length)) for (var ae = 0, se; se = oe[ae++]; ) se(ne);
    } }, Token: U };
    D.Prism = W;
    function U(Q, ne, oe, ae) {
      this.type = Q, this.content = ne, this.alias = oe, this.length = (ae || "").length | 0;
    }
    U.stringify = function Q(ne, oe) {
      if (typeof ne == "string") return ne;
      if (Array.isArray(ne)) {
        var ae = "";
        return ne.forEach(function(Pe) {
          ae += Q(Pe, oe);
        }), ae;
      }
      var se = { type: ne.type, content: Q(ne.content, oe), tag: "span", classes: ["token", ne.type], attributes: {}, language: oe }, ie = ne.alias;
      ie && (Array.isArray(ie) ? Array.prototype.push.apply(se.classes, ie) : se.classes.push(ie)), W.hooks.run("wrap", se);
      var he = "";
      for (var xe in se.attributes) he += " " + xe + '="' + (se.attributes[xe] || "").replace(/"/g, "&quot;") + '"';
      return "<" + se.tag + ' class="' + se.classes.join(" ") + '"' + he + ">" + se.content + "</" + se.tag + ">";
    };
    function q(Q, ne, oe, ae) {
      Q.lastIndex = ne;
      var se = Q.exec(oe);
      if (se && ae && se[1]) {
        var ie = se[1].length;
        se.index += ie, se[0] = se[0].slice(ie);
      }
      return se;
    }
    function K(Q, ne, oe, ae, se, ie) {
      for (var he in oe) if (!(!oe.hasOwnProperty(he) || !oe[he])) {
        var xe = oe[he];
        xe = Array.isArray(xe) ? xe : [xe];
        for (var Pe = 0; Pe < xe.length; ++Pe) {
          if (ie && ie.cause == he + "," + Pe) return;
          var Re = xe[Pe], ke = Re.inside, Te = !!Re.lookbehind, fe = !!Re.greedy, ue = Re.alias;
          if (fe && !Re.pattern.global) {
            var Ce = Re.pattern.toString().match(/[imsuy]*$/)[0];
            Re.pattern = RegExp(Re.pattern.source, Ce + "g");
          }
          for (var ce = Re.pattern || Re, pe = ae.next, _e = se; pe !== ne.tail && !(ie && _e >= ie.reach); _e += pe.value.length, pe = pe.next) {
            var ge = pe.value;
            if (ne.length > Q.length) return;
            if (!(ge instanceof U)) {
              var Ae = 1, Ee;
              if (fe) {
                if (Ee = q(ce, _e, Q, Te), !Ee || Ee.index >= Q.length) break;
                var Se = Ee.index, ve = Ee.index + Ee[0].length, le = _e;
                for (le += pe.value.length; Se >= le; ) pe = pe.next, le += pe.value.length;
                if (le -= pe.value.length, _e = le, pe.value instanceof U) continue;
                for (var me = pe; me !== ne.tail && (le < ve || typeof me.value == "string"); me = me.next) Ae++, le += me.value.length;
                Ae--, ge = Q.slice(_e, le), Ee.index -= _e;
              } else if (Ee = q(ce, 0, ge, Te), !Ee) continue;
              var Se = Ee.index, ye = Ee[0], be = ge.slice(0, Se), $e = ge.slice(Se + ye.length), Oe = _e + ge.length;
              ie && Oe > ie.reach && (ie.reach = Oe);
              var Ie = pe.prev;
              be && (Ie = J(ne, Ie, be), _e += be.length), Z(ne, Ie, Ae);
              var we = new U(he, ke ? W.tokenize(ye, ke) : ye, ue, ye);
              if (pe = J(ne, Ie, we), $e && J(ne, pe, $e), Ae > 1) {
                var Fe = { cause: he + "," + Pe, reach: Oe };
                K(Q, ne, oe, pe.prev, _e, Fe), ie && Fe.reach > ie.reach && (ie.reach = Fe.reach);
              }
            }
          }
        }
      }
    }
    function Y() {
      var Q = { value: null, prev: null, next: null }, ne = { value: null, prev: Q, next: null };
      Q.next = ne, this.head = Q, this.tail = ne, this.length = 0;
    }
    function J(Q, ne, oe) {
      var ae = ne.next, se = { value: oe, prev: ne, next: ae };
      return ne.next = se, ae.prev = se, Q.length++, se;
    }
    function Z(Q, ne, oe) {
      for (var ae = ne.next, se = 0; se < oe && ae !== Q.tail; se++) ae = ae.next;
      ne.next = ae, ae.prev = ne, Q.length -= se;
    }
    function X(Q) {
      for (var ne = [], oe = Q.head.next; oe !== Q.tail; ) ne.push(oe.value), oe = oe.next;
      return ne;
    }
    if (!D.document) return D.addEventListener && (W.disableWorkerMessageHandler || D.addEventListener("message", function(Q) {
      var ne = JSON.parse(Q.data), oe = ne.language, ae = ne.code, se = ne.immediateClose;
      D.postMessage(W.highlight(ae, W.languages[oe], oe)), se && D.close();
    }, !1)), W;
    var ee = W.util.currentScript();
    ee && (W.filename = ee.src, ee.hasAttribute("data-manual") && (W.manual = !0));
    function te() {
      W.manual || W.highlightAll();
    }
    if (!W.manual) {
      var re = document.readyState;
      re === "loading" || re === "interactive" && ee && ee.defer ? document.addEventListener("DOMContentLoaded", te) : window.requestAnimationFrame ? window.requestAnimationFrame(te) : window.setTimeout(te, 16);
    }
    return W;
  }(R);
  typeof S < "u" && S.exports && (S.exports = k), typeof global < "u" && (global.Prism = k);
} }), require_core = __commonJS$2({ "../../node_modules/refractor/core.js"(T, S) {
  var R = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, k = se();
  R.Prism = { manual: !0, disableWorkerMessageHandler: !0 };
  var D = require_hastscript(), L = require_parse_entities(), V = require_prism_core(), z = require_markup(), W = require_css(), U = require_clike(), q = require_javascript();
  k();
  var K = {}.hasOwnProperty;
  function Y() {
  }
  Y.prototype = V;
  var J = new Y();
  S.exports = J, J.highlight = ee, J.register = Z, J.alias = X, J.registered = te, J.listLanguages = re, Z(z), Z(W), Z(U), Z(q), J.util.encode = oe, J.Token.stringify = Q;
  function Z(ie) {
    if (typeof ie != "function" || !ie.displayName) throw new Error("Expected `function` for `grammar`, got `" + ie + "`");
    J.languages[ie.displayName] === void 0 && ie(J);
  }
  function X(ie, he) {
    var xe = J.languages, Pe = ie, Re, ke, Te, fe;
    he && (Pe = {}, Pe[ie] = he);
    for (Re in Pe) for (ke = Pe[Re], ke = typeof ke == "string" ? [ke] : ke, Te = ke.length, fe = -1; ++fe < Te; ) xe[ke[fe]] = xe[Re];
  }
  function ee(ie, he) {
    var xe = V.highlight, Pe;
    if (typeof ie != "string") throw new Error("Expected `string` for `value`, got `" + ie + "`");
    if (J.util.type(he) === "Object") Pe = he, he = null;
    else {
      if (typeof he != "string") throw new Error("Expected `string` for `name`, got `" + he + "`");
      if (K.call(J.languages, he)) Pe = J.languages[he];
      else throw new Error("Unknown language: `" + he + "` is not registered");
    }
    return xe.call(this, ie, Pe, he);
  }
  function te(ie) {
    if (typeof ie != "string") throw new Error("Expected `string` for `language`, got `" + ie + "`");
    return K.call(J.languages, ie);
  }
  function re() {
    var ie = J.languages, he = [], xe;
    for (xe in ie) K.call(ie, xe) && typeof ie[xe] == "object" && he.push(xe);
    return he;
  }
  function Q(ie, he, xe) {
    var Pe;
    return typeof ie == "string" ? { type: "text", value: ie } : J.util.type(ie) === "Array" ? ne(ie, he) : (Pe = { type: ie.type, content: J.Token.stringify(ie.content, he, xe), tag: "span", classes: ["token", ie.type], attributes: {}, language: he, parent: xe }, ie.alias && (Pe.classes = Pe.classes.concat(ie.alias)), J.hooks.run("wrap", Pe), D(Pe.tag + "." + Pe.classes.join("."), ae(Pe.attributes), Pe.content));
  }
  function ne(ie, he) {
    for (var xe = [], Pe = ie.length, Re = -1, ke; ++Re < Pe; ) ke = ie[Re], ke !== "" && ke !== null && ke !== void 0 && xe.push(ke);
    for (Re = -1, Pe = xe.length; ++Re < Pe; ) ke = xe[Re], xe[Re] = J.Token.stringify(ke, he, xe);
    return xe;
  }
  function oe(ie) {
    return ie;
  }
  function ae(ie) {
    var he;
    for (he in ie) ie[he] = L(ie[he]);
    return ie;
  }
  function se() {
    var ie = "Prism" in R, he = ie ? R.Prism : void 0;
    return xe;
    function xe() {
      ie ? R.Prism = he : delete R.Prism, ie = void 0, he = void 0;
    }
  }
} }), require_bash = __commonJS$2({ "../../node_modules/refractor/lang/bash.js"(T, S) {
  S.exports = R, R.displayName = "bash", R.aliases = ["shell"];
  function R(k) {
    (function(D) {
      var L = "\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b", V = { pattern: /(^(["']?)\w+\2)[ \t]+\S.*/, lookbehind: !0, alias: "punctuation", inside: null }, z = { bash: V, environment: { pattern: RegExp("\\$" + L), alias: "constant" }, variable: [{ pattern: /\$?\(\([\s\S]+?\)\)/, greedy: !0, inside: { variable: [{ pattern: /(^\$\(\([\s\S]+)\)\)/, lookbehind: !0 }, /^\$\(\(/], number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/, operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/, punctuation: /\(\(?|\)\)?|,|;/ } }, { pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/, greedy: !0, inside: { variable: /^\$\(|^`|\)$|`$/ } }, { pattern: /\$\{[^}]+\}/, greedy: !0, inside: { operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/, punctuation: /[\[\]]/, environment: { pattern: RegExp("(\\{)" + L), lookbehind: !0, alias: "constant" } } }, /\$(?:\w+|[#?*!@$])/], entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/ };
      D.languages.bash = { shebang: { pattern: /^#!\s*\/.*/, alias: "important" }, comment: { pattern: /(^|[^"{\\$])#.*/, lookbehind: !0 }, "function-name": [{ pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/, lookbehind: !0, alias: "function" }, { pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/, alias: "function" }], "for-or-select": { pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/, alias: "variable", lookbehind: !0 }, "assign-left": { pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/, inside: { environment: { pattern: RegExp("(^|[\\s;|&]|[<>]\\()" + L), lookbehind: !0, alias: "constant" } }, alias: "variable", lookbehind: !0 }, string: [{ pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/, lookbehind: !0, greedy: !0, inside: z }, { pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/, lookbehind: !0, greedy: !0, inside: { bash: V } }, { pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/, lookbehind: !0, greedy: !0, inside: z }, { pattern: /(^|[^$\\])'[^']*'/, lookbehind: !0, greedy: !0 }, { pattern: /\$'(?:[^'\\]|\\[\s\S])*'/, greedy: !0, inside: { entity: z.entity } }], environment: { pattern: RegExp("\\$?" + L), alias: "constant" }, variable: z.variable, function: { pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/, lookbehind: !0 }, keyword: { pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/, lookbehind: !0 }, builtin: { pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/, lookbehind: !0, alias: "class-name" }, boolean: { pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/, lookbehind: !0 }, "file-descriptor": { pattern: /\B&\d\b/, alias: "important" }, operator: { pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/, inside: { "file-descriptor": { pattern: /^\d/, alias: "important" } } }, punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/, number: { pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/, lookbehind: !0 } }, V.inside = D.languages.bash;
      for (var W = ["comment", "function-name", "for-or-select", "assign-left", "string", "environment", "function", "keyword", "builtin", "boolean", "file-descriptor", "operator", "punctuation", "number"], U = z.variable[1].inside, q = 0; q < W.length; q++) U[W[q]] = D.languages.bash[W[q]];
      D.languages.shell = D.languages.bash;
    })(k);
  }
} }), require_js_extras = __commonJS$2({ "../../node_modules/refractor/lang/js-extras.js"(T, S) {
  S.exports = R, R.displayName = "jsExtras", R.aliases = [];
  function R(k) {
    (function(D) {
      D.languages.insertBefore("javascript", "function-variable", { "method-variable": { pattern: RegExp("(\\.\\s*)" + D.languages.javascript["function-variable"].pattern.source), lookbehind: !0, alias: ["function-variable", "method", "function", "property-access"] } }), D.languages.insertBefore("javascript", "function", { method: { pattern: RegExp("(\\.\\s*)" + D.languages.javascript.function.source), lookbehind: !0, alias: ["function", "property-access"] } }), D.languages.insertBefore("javascript", "constant", { "known-class-name": [{ pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/, alias: "class-name" }, { pattern: /\b(?:[A-Z]\w*)Error\b/, alias: "class-name" }] });
      function L(K, Y) {
        return RegExp(K.replace(/<ID>/g, function() {
          return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
        }), Y);
      }
      D.languages.insertBefore("javascript", "keyword", { imports: { pattern: L(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source), lookbehind: !0, inside: D.languages.javascript }, exports: { pattern: L(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source), lookbehind: !0, inside: D.languages.javascript } }), D.languages.javascript.keyword.unshift({ pattern: /\b(?:as|default|export|from|import)\b/, alias: "module" }, { pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/, alias: "control-flow" }, { pattern: /\bnull\b/, alias: ["null", "nil"] }, { pattern: /\bundefined\b/, alias: "nil" }), D.languages.insertBefore("javascript", "operator", { spread: { pattern: /\.{3}/, alias: "operator" }, arrow: { pattern: /=>/, alias: "operator" } }), D.languages.insertBefore("javascript", "punctuation", { "property-access": { pattern: L(/(\.\s*)#?<ID>/.source), lookbehind: !0 }, "maybe-class-name": { pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/, lookbehind: !0 }, dom: { pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/, alias: "variable" }, console: { pattern: /\bconsole(?=\s*\.)/, alias: "class-name" } });
      for (var V = ["function", "function-variable", "method", "method-variable", "property-access"], z = 0; z < V.length; z++) {
        var W = V[z], U = D.languages.javascript[W];
        D.util.type(U) === "RegExp" && (U = D.languages.javascript[W] = { pattern: U });
        var q = U.inside || {};
        U.inside = q, q["maybe-class-name"] = /^[A-Z][\s\S]*/;
      }
    })(k);
  }
} }), require_json = __commonJS$2({ "../../node_modules/refractor/lang/json.js"(T, S) {
  S.exports = R, R.displayName = "json", R.aliases = ["webmanifest"];
  function R(k) {
    k.languages.json = { property: { pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/, lookbehind: !0, greedy: !0 }, string: { pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/, lookbehind: !0, greedy: !0 }, comment: { pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/, greedy: !0 }, number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i, punctuation: /[{}[\],]/, operator: /:/, boolean: /\b(?:false|true)\b/, null: { pattern: /\bnull\b/, alias: "keyword" } }, k.languages.webmanifest = k.languages.json;
  }
} }), require_graphql = __commonJS$2({ "../../node_modules/refractor/lang/graphql.js"(T, S) {
  S.exports = R, R.displayName = "graphql", R.aliases = [];
  function R(k) {
    k.languages.graphql = { comment: /#.*/, description: { pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i, greedy: !0, alias: "string", inside: { "language-markdown": { pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/, lookbehind: !0, inside: k.languages.markdown } } }, string: { pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/, greedy: !0 }, number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i, boolean: /\b(?:false|true)\b/, variable: /\$[a-z_]\w*/i, directive: { pattern: /@[a-z_]\w*/i, alias: "function" }, "attr-name": { pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i, greedy: !0 }, "atom-input": { pattern: /\b[A-Z]\w*Input\b/, alias: "class-name" }, scalar: /\b(?:Boolean|Float|ID|Int|String)\b/, constant: /\b[A-Z][A-Z_\d]*\b/, "class-name": { pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/, lookbehind: !0 }, fragment: { pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/, lookbehind: !0, alias: "function" }, "definition-mutation": { pattern: /(\bmutation\s+)[a-zA-Z_]\w*/, lookbehind: !0, alias: "function" }, "definition-query": { pattern: /(\bquery\s+)[a-zA-Z_]\w*/, lookbehind: !0, alias: "function" }, keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/, operator: /[!=|&]|\.{3}/, "property-query": /\w+(?=\s*\()/, object: /\w+(?=\s*\{)/, punctuation: /[!(){}\[\]:=,]/, property: /\w+/ }, k.hooks.add("after-tokenize", function(D) {
      if (D.language !== "graphql") return;
      var L = D.tokens.filter(function(re) {
        return typeof re != "string" && re.type !== "comment" && re.type !== "scalar";
      }), V = 0;
      function z(re) {
        return L[V + re];
      }
      function W(re, Q) {
        Q = Q || 0;
        for (var ne = 0; ne < re.length; ne++) {
          var oe = z(ne + Q);
          if (!oe || oe.type !== re[ne]) return !1;
        }
        return !0;
      }
      function U(re, Q) {
        for (var ne = 1, oe = V; oe < L.length; oe++) {
          var ae = L[oe], se = ae.content;
          if (ae.type === "punctuation" && typeof se == "string") {
            if (re.test(se)) ne++;
            else if (Q.test(se) && (ne--, ne === 0)) return oe;
          }
        }
        return -1;
      }
      function q(re, Q) {
        var ne = re.alias;
        ne ? Array.isArray(ne) || (re.alias = ne = [ne]) : re.alias = ne = [], ne.push(Q);
      }
      for (; V < L.length; ) {
        var K = L[V++];
        if (K.type === "keyword" && K.content === "mutation") {
          var Y = [];
          if (W(["definition-mutation", "punctuation"]) && z(1).content === "(") {
            V += 2;
            var J = U(/^\($/, /^\)$/);
            if (J === -1) continue;
            for (; V < J; V++) {
              var Z = z(0);
              Z.type === "variable" && (q(Z, "variable-input"), Y.push(Z.content));
            }
            V = J + 1;
          }
          if (W(["punctuation", "property-query"]) && z(0).content === "{" && (V++, q(z(0), "property-mutation"), Y.length > 0)) {
            var X = U(/^\{$/, /^\}$/);
            if (X === -1) continue;
            for (var ee = V; ee < X; ee++) {
              var te = L[ee];
              te.type === "variable" && Y.indexOf(te.content) >= 0 && q(te, "variable-input");
            }
          }
        }
      }
    });
  }
} });
function setRef$1(T, S) {
  typeof T == "function" ? T(S) : T != null && (T.current = S);
}
function composeRefs(...T) {
  return (S) => T.forEach((R) => setRef$1(R, S));
}
function useComposedRefs(...T) {
  return React$1.useCallback(composeRefs(...T), T);
}
var Slot = React$1.forwardRef((T, S) => {
  const { children: R, ...k } = T, D = React$1.Children.toArray(R), L = D.find(isSlottable);
  if (L) {
    const V = L.props.children, z = D.map((W) => W === L ? React$1.Children.count(V) > 1 ? React$1.Children.only(null) : React$1.isValidElement(V) ? V.props.children : null : W);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SlotClone, { ...k, ref: S, children: React$1.isValidElement(V) ? React$1.cloneElement(V, void 0, z) : null });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SlotClone, { ...k, ref: S, children: R });
});
Slot.displayName = "Slot";
var SlotClone = React$1.forwardRef((T, S) => {
  const { children: R, ...k } = T;
  if (React$1.isValidElement(R)) {
    const D = getElementRef$1(R);
    return React$1.cloneElement(R, {
      ...mergeProps(k, R.props),
      // @ts-ignore
      ref: S ? composeRefs(S, D) : D
    });
  }
  return React$1.Children.count(R) > 1 ? React$1.Children.only(null) : null;
});
SlotClone.displayName = "SlotClone";
var Slottable = ({ children: T }) => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: T });
function isSlottable(T) {
  return React$1.isValidElement(T) && T.type === Slottable;
}
function mergeProps(T, S) {
  const R = { ...S };
  for (const k in S) {
    const D = T[k], L = S[k];
    /^on[A-Z]/.test(k) ? D && L ? R[k] = (...z) => {
      L(...z), D(...z);
    } : D && (R[k] = D) : k === "style" ? R[k] = { ...D, ...L } : k === "className" && (R[k] = [D, L].filter(Boolean).join(" "));
  }
  return { ...T, ...R };
}
function getElementRef$1(T) {
  let S = Object.getOwnPropertyDescriptor(T.props, "ref")?.get, R = S && "isReactWarning" in S && S.isReactWarning;
  return R ? T.ref : (S = Object.getOwnPropertyDescriptor(T, "ref")?.get, R = S && "isReactWarning" in S && S.isReactWarning, R ? T.props.ref : T.props.ref || T.ref);
}
var import_jsx = __toESM$2(require_jsx()), jsx_default = import_jsx.default, import_bash = __toESM$2(require_bash()), bash_default = import_bash.default, import_css = __toESM$2(require_css()), css_default = import_css.default, import_js_extras = __toESM$2(require_js_extras()), js_extras_default = import_js_extras.default, import_json = __toESM$2(require_json()), json_default = import_json.default, import_graphql = __toESM$2(require_graphql()), graphql_default = import_graphql.default, import_markup = __toESM$2(require_markup()), markup_default = import_markup.default, import_markdown = __toESM$2(require_markdown()), markdown_default = import_markdown.default, import_yaml = __toESM$2(require_yaml()), yaml_default = import_yaml.default, import_tsx = __toESM$2(require_tsx()), tsx_default = import_tsx.default, import_typescript = __toESM$2(require_typescript()), typescript_default = import_typescript.default;
function _objectWithoutProperties$1(T, S) {
  if (T == null) return {};
  var R = _objectWithoutPropertiesLoose$2(T, S), k, D;
  if (Object.getOwnPropertySymbols) {
    var L = Object.getOwnPropertySymbols(T);
    for (D = 0; D < L.length; D++) k = L[D], !(S.indexOf(k) >= 0) && Object.prototype.propertyIsEnumerable.call(T, k) && (R[k] = T[k]);
  }
  return R;
}
function _arrayLikeToArray$3(T, S) {
  (S == null || S > T.length) && (S = T.length);
  for (var R = 0, k = new Array(S); R < S; R++) k[R] = T[R];
  return k;
}
function _arrayWithoutHoles$1(T) {
  if (Array.isArray(T)) return _arrayLikeToArray$3(T);
}
function _iterableToArray$1(T) {
  if (typeof Symbol < "u" && T[Symbol.iterator] != null || T["@@iterator"] != null) return Array.from(T);
}
function _unsupportedIterableToArray$3(T, S) {
  if (T) {
    if (typeof T == "string") return _arrayLikeToArray$3(T, S);
    var R = Object.prototype.toString.call(T).slice(8, -1);
    if (R === "Object" && T.constructor && (R = T.constructor.name), R === "Map" || R === "Set") return Array.from(T);
    if (R === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(R)) return _arrayLikeToArray$3(T, S);
  }
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toConsumableArray$1(T) {
  return _arrayWithoutHoles$1(T) || _iterableToArray$1(T) || _unsupportedIterableToArray$3(T) || _nonIterableSpread$1();
}
function _typeof$1(T) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(S) {
    return typeof S;
  } : function(S) {
    return S && typeof Symbol == "function" && S.constructor === Symbol && S !== Symbol.prototype ? "symbol" : typeof S;
  }, _typeof$1(T);
}
function toPrimitive(T, S) {
  if (_typeof$1(T) != "object" || !T) return T;
  var R = T[Symbol.toPrimitive];
  if (R !== void 0) {
    var k = R.call(T, S || "default");
    if (_typeof$1(k) != "object") return k;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (S === "string" ? String : Number)(T);
}
function toPropertyKey(T) {
  var S = toPrimitive(T, "string");
  return _typeof$1(S) == "symbol" ? S : S + "";
}
function _defineProperty$2(T, S, R) {
  return S = toPropertyKey(S), S in T ? Object.defineProperty(T, S, { value: R, enumerable: !0, configurable: !0, writable: !0 }) : T[S] = R, T;
}
function ownKeys$2(T, S) {
  var R = Object.keys(T);
  if (Object.getOwnPropertySymbols) {
    var k = Object.getOwnPropertySymbols(T);
    S && (k = k.filter(function(D) {
      return Object.getOwnPropertyDescriptor(T, D).enumerable;
    })), R.push.apply(R, k);
  }
  return R;
}
function _objectSpread$1(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S] != null ? arguments[S] : {};
    S % 2 ? ownKeys$2(Object(R), !0).forEach(function(k) {
      _defineProperty$2(T, k, R[k]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(T, Object.getOwnPropertyDescriptors(R)) : ownKeys$2(Object(R)).forEach(function(k) {
      Object.defineProperty(T, k, Object.getOwnPropertyDescriptor(R, k));
    });
  }
  return T;
}
function powerSetPermutations(T) {
  var S = T.length;
  if (S === 0 || S === 1) return T;
  if (S === 2) return [T[0], T[1], "".concat(T[0], ".").concat(T[1]), "".concat(T[1], ".").concat(T[0])];
  if (S === 3) return [T[0], T[1], T[2], "".concat(T[0], ".").concat(T[1]), "".concat(T[0], ".").concat(T[2]), "".concat(T[1], ".").concat(T[0]), "".concat(T[1], ".").concat(T[2]), "".concat(T[2], ".").concat(T[0]), "".concat(T[2], ".").concat(T[1]), "".concat(T[0], ".").concat(T[1], ".").concat(T[2]), "".concat(T[0], ".").concat(T[2], ".").concat(T[1]), "".concat(T[1], ".").concat(T[0], ".").concat(T[2]), "".concat(T[1], ".").concat(T[2], ".").concat(T[0]), "".concat(T[2], ".").concat(T[0], ".").concat(T[1]), "".concat(T[2], ".").concat(T[1], ".").concat(T[0])];
  if (S >= 4) return [T[0], T[1], T[2], T[3], "".concat(T[0], ".").concat(T[1]), "".concat(T[0], ".").concat(T[2]), "".concat(T[0], ".").concat(T[3]), "".concat(T[1], ".").concat(T[0]), "".concat(T[1], ".").concat(T[2]), "".concat(T[1], ".").concat(T[3]), "".concat(T[2], ".").concat(T[0]), "".concat(T[2], ".").concat(T[1]), "".concat(T[2], ".").concat(T[3]), "".concat(T[3], ".").concat(T[0]), "".concat(T[3], ".").concat(T[1]), "".concat(T[3], ".").concat(T[2]), "".concat(T[0], ".").concat(T[1], ".").concat(T[2]), "".concat(T[0], ".").concat(T[1], ".").concat(T[3]), "".concat(T[0], ".").concat(T[2], ".").concat(T[1]), "".concat(T[0], ".").concat(T[2], ".").concat(T[3]), "".concat(T[0], ".").concat(T[3], ".").concat(T[1]), "".concat(T[0], ".").concat(T[3], ".").concat(T[2]), "".concat(T[1], ".").concat(T[0], ".").concat(T[2]), "".concat(T[1], ".").concat(T[0], ".").concat(T[3]), "".concat(T[1], ".").concat(T[2], ".").concat(T[0]), "".concat(T[1], ".").concat(T[2], ".").concat(T[3]), "".concat(T[1], ".").concat(T[3], ".").concat(T[0]), "".concat(T[1], ".").concat(T[3], ".").concat(T[2]), "".concat(T[2], ".").concat(T[0], ".").concat(T[1]), "".concat(T[2], ".").concat(T[0], ".").concat(T[3]), "".concat(T[2], ".").concat(T[1], ".").concat(T[0]), "".concat(T[2], ".").concat(T[1], ".").concat(T[3]), "".concat(T[2], ".").concat(T[3], ".").concat(T[0]), "".concat(T[2], ".").concat(T[3], ".").concat(T[1]), "".concat(T[3], ".").concat(T[0], ".").concat(T[1]), "".concat(T[3], ".").concat(T[0], ".").concat(T[2]), "".concat(T[3], ".").concat(T[1], ".").concat(T[0]), "".concat(T[3], ".").concat(T[1], ".").concat(T[2]), "".concat(T[3], ".").concat(T[2], ".").concat(T[0]), "".concat(T[3], ".").concat(T[2], ".").concat(T[1]), "".concat(T[0], ".").concat(T[1], ".").concat(T[2], ".").concat(T[3]), "".concat(T[0], ".").concat(T[1], ".").concat(T[3], ".").concat(T[2]), "".concat(T[0], ".").concat(T[2], ".").concat(T[1], ".").concat(T[3]), "".concat(T[0], ".").concat(T[2], ".").concat(T[3], ".").concat(T[1]), "".concat(T[0], ".").concat(T[3], ".").concat(T[1], ".").concat(T[2]), "".concat(T[0], ".").concat(T[3], ".").concat(T[2], ".").concat(T[1]), "".concat(T[1], ".").concat(T[0], ".").concat(T[2], ".").concat(T[3]), "".concat(T[1], ".").concat(T[0], ".").concat(T[3], ".").concat(T[2]), "".concat(T[1], ".").concat(T[2], ".").concat(T[0], ".").concat(T[3]), "".concat(T[1], ".").concat(T[2], ".").concat(T[3], ".").concat(T[0]), "".concat(T[1], ".").concat(T[3], ".").concat(T[0], ".").concat(T[2]), "".concat(T[1], ".").concat(T[3], ".").concat(T[2], ".").concat(T[0]), "".concat(T[2], ".").concat(T[0], ".").concat(T[1], ".").concat(T[3]), "".concat(T[2], ".").concat(T[0], ".").concat(T[3], ".").concat(T[1]), "".concat(T[2], ".").concat(T[1], ".").concat(T[0], ".").concat(T[3]), "".concat(T[2], ".").concat(T[1], ".").concat(T[3], ".").concat(T[0]), "".concat(T[2], ".").concat(T[3], ".").concat(T[0], ".").concat(T[1]), "".concat(T[2], ".").concat(T[3], ".").concat(T[1], ".").concat(T[0]), "".concat(T[3], ".").concat(T[0], ".").concat(T[1], ".").concat(T[2]), "".concat(T[3], ".").concat(T[0], ".").concat(T[2], ".").concat(T[1]), "".concat(T[3], ".").concat(T[1], ".").concat(T[0], ".").concat(T[2]), "".concat(T[3], ".").concat(T[1], ".").concat(T[2], ".").concat(T[0]), "".concat(T[3], ".").concat(T[2], ".").concat(T[0], ".").concat(T[1]), "".concat(T[3], ".").concat(T[2], ".").concat(T[1], ".").concat(T[0])];
}
var classNameCombinations = {};
function getClassNameCombinations(T) {
  if (T.length === 0 || T.length === 1) return T;
  var S = T.join(".");
  return classNameCombinations[S] || (classNameCombinations[S] = powerSetPermutations(T)), classNameCombinations[S];
}
function createStyleObject(T) {
  var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, R = arguments.length > 2 ? arguments[2] : void 0, k = T.filter(function(L) {
    return L !== "token";
  }), D = getClassNameCombinations(k);
  return D.reduce(function(L, V) {
    return _objectSpread$1(_objectSpread$1({}, L), R[V]);
  }, S);
}
function createClassNameString(T) {
  return T.join(" ");
}
function createChildren(T, S) {
  var R = 0;
  return function(k) {
    return R += 1, k.map(function(D, L) {
      return createElement({ node: D, stylesheet: T, useInlineStyles: S, key: "code-segment-".concat(R, "-").concat(L) });
    });
  };
}
function createElement(T) {
  var S = T.node, R = T.stylesheet, k = T.style, D = k === void 0 ? {} : k, L = T.useInlineStyles, V = T.key, z = S.properties, W = S.type, U = S.tagName, q = S.value;
  if (W === "text") return q;
  if (U) {
    var K = createChildren(R, L), Y;
    if (!L) Y = _objectSpread$1(_objectSpread$1({}, z), {}, { className: createClassNameString(z.className) });
    else {
      var J = Object.keys(R).reduce(function(te, re) {
        return re.split(".").forEach(function(Q) {
          te.includes(Q) || te.push(Q);
        }), te;
      }, []), Z = z.className && z.className.includes("token") ? ["token"] : [], X = z.className && Z.concat(z.className.filter(function(te) {
        return !J.includes(te);
      }));
      Y = _objectSpread$1(_objectSpread$1({}, z), {}, { className: createClassNameString(X) || void 0, style: createStyleObject(z.className, Object.assign({}, z.style, D), R) });
    }
    var ee = K(S.children);
    return React__default.createElement(U, _extends$2({ key: V }, Y), ee);
  }
}
var checkForListedLanguage_default = function(T, S) {
  var R = T.listLanguages();
  return R.indexOf(S) !== -1;
}, _excluded$1w = ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "wrapLongLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"];
function ownKeys2(T, S) {
  var R = Object.keys(T);
  if (Object.getOwnPropertySymbols) {
    var k = Object.getOwnPropertySymbols(T);
    S && (k = k.filter(function(D) {
      return Object.getOwnPropertyDescriptor(T, D).enumerable;
    })), R.push.apply(R, k);
  }
  return R;
}
function _objectSpread2$1(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S] != null ? arguments[S] : {};
    S % 2 ? ownKeys2(Object(R), !0).forEach(function(k) {
      _defineProperty$2(T, k, R[k]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(T, Object.getOwnPropertyDescriptors(R)) : ownKeys2(Object(R)).forEach(function(k) {
      Object.defineProperty(T, k, Object.getOwnPropertyDescriptor(R, k));
    });
  }
  return T;
}
var newLineRegex = /\n/g;
function getNewLines(T) {
  return T.match(newLineRegex);
}
function getAllLineNumbers(T) {
  var S = T.lines, R = T.startingLineNumber, k = T.style;
  return S.map(function(D, L) {
    var V = L + R;
    return React__default.createElement("span", { key: "line-".concat(L), className: "react-syntax-highlighter-line-number", style: typeof k == "function" ? k(V) : k }, "".concat(V, `
`));
  });
}
function AllLineNumbers(T) {
  var S = T.codeString, R = T.codeStyle, k = T.containerStyle, D = k === void 0 ? { float: "left", paddingRight: "10px" } : k, L = T.numberStyle, V = L === void 0 ? {} : L, z = T.startingLineNumber;
  return React__default.createElement("code", { style: Object.assign({}, R, D) }, getAllLineNumbers({ lines: S.replace(/\n$/, "").split(`
`), style: V, startingLineNumber: z }));
}
function getEmWidthOfNumber(T) {
  return "".concat(T.toString().length, ".25em");
}
function getInlineLineNumber(T, S) {
  return { type: "element", tagName: "span", properties: { key: "line-number--".concat(T), className: ["comment", "linenumber", "react-syntax-highlighter-line-number"], style: S }, children: [{ type: "text", value: T }] };
}
function assembleLineNumberStyles(T, S, R) {
  var k = { display: "inline-block", minWidth: getEmWidthOfNumber(R), paddingRight: "1em", textAlign: "right", userSelect: "none" }, D = typeof T == "function" ? T(S) : T, L = _objectSpread2$1(_objectSpread2$1({}, k), D);
  return L;
}
function createLineElement(T) {
  var S = T.children, R = T.lineNumber, k = T.lineNumberStyle, D = T.largestLineNumber, L = T.showInlineLineNumbers, V = T.lineProps, z = V === void 0 ? {} : V, W = T.className, U = W === void 0 ? [] : W, q = T.showLineNumbers, K = T.wrapLongLines, Y = typeof z == "function" ? z(R) : z;
  if (Y.className = U, R && L) {
    var J = assembleLineNumberStyles(k, R, D);
    S.unshift(getInlineLineNumber(R, J));
  }
  return K & q && (Y.style = _objectSpread2$1(_objectSpread2$1({}, Y.style), {}, { display: "flex" })), { type: "element", tagName: "span", properties: Y, children: S };
}
function flattenCodeTree(T) {
  for (var S = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], R = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], k = 0; k < T.length; k++) {
    var D = T[k];
    if (D.type === "text") R.push(createLineElement({ children: [D], className: _toConsumableArray$1(new Set(S)) }));
    else if (D.children) {
      var L = S.concat(D.properties.className);
      flattenCodeTree(D.children, L).forEach(function(V) {
        return R.push(V);
      });
    }
  }
  return R;
}
function processLines(T, S, R, k, D, L, V, z, W) {
  var U, q = flattenCodeTree(T.value), K = [], Y = -1, J = 0;
  function Z(oe, ae) {
    var se = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return createLineElement({ children: oe, lineNumber: ae, lineNumberStyle: z, largestLineNumber: V, showInlineLineNumbers: D, lineProps: R, className: se, showLineNumbers: k, wrapLongLines: W });
  }
  function X(oe, ae) {
    if (k && ae && D) {
      var se = assembleLineNumberStyles(z, ae, V);
      oe.unshift(getInlineLineNumber(ae, se));
    }
    return oe;
  }
  function ee(oe, ae) {
    var se = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return S || se.length > 0 ? Z(oe, ae, se) : X(oe, ae);
  }
  for (var te = function() {
    var oe = q[J], ae = oe.children[0].value, se = getNewLines(ae);
    if (se) {
      var ie = ae.split(`
`);
      ie.forEach(function(he, xe) {
        var Pe = k && K.length + L, Re = { type: "text", value: "".concat(he, `
`) };
        if (xe === 0) {
          var ke = q.slice(Y + 1, J).concat(createLineElement({ children: [Re], className: oe.properties.className })), Te = ee(ke, Pe);
          K.push(Te);
        } else if (xe === ie.length - 1) {
          var fe = q[J + 1] && q[J + 1].children && q[J + 1].children[0], ue = { type: "text", value: "".concat(he) };
          if (fe) {
            var Ce = createLineElement({ children: [ue], className: oe.properties.className });
            q.splice(J + 1, 0, Ce);
          } else {
            var ce = [ue], pe = ee(ce, Pe, oe.properties.className);
            K.push(pe);
          }
        } else {
          var _e = [Re], ge = ee(_e, Pe, oe.properties.className);
          K.push(ge);
        }
      }), Y = J;
    }
    J++;
  }; J < q.length; ) te();
  if (Y !== q.length - 1) {
    var re = q.slice(Y + 1, q.length);
    if (re && re.length) {
      var Q = k && K.length + L, ne = ee(re, Q);
      K.push(ne);
    }
  }
  return S ? K : (U = []).concat.apply(U, K);
}
function defaultRenderer(T) {
  var S = T.rows, R = T.stylesheet, k = T.useInlineStyles;
  return S.map(function(D, L) {
    return createElement({ node: D, stylesheet: R, useInlineStyles: k, key: "code-segement".concat(L) });
  });
}
function isHighlightJs(T) {
  return T && typeof T.highlightAuto < "u";
}
function getCodeTree(T) {
  var S = T.astGenerator, R = T.language, k = T.code, D = T.defaultCodeValue;
  if (isHighlightJs(S)) {
    var L = checkForListedLanguage_default(S, R);
    return R === "text" ? { value: D, language: "text" } : L ? S.highlight(R, k) : S.highlightAuto(k);
  }
  try {
    return R && R !== "text" ? { value: S.highlight(k, R) } : { value: D };
  } catch {
    return { value: D };
  }
}
function highlight_default(T, S) {
  return function(R) {
    var k = R.language, D = R.children, L = R.style, V = L === void 0 ? S : L, z = R.customStyle, W = z === void 0 ? {} : z, U = R.codeTagProps, q = U === void 0 ? { className: k ? "language-".concat(k) : void 0, style: _objectSpread2$1(_objectSpread2$1({}, V['code[class*="language-"]']), V['code[class*="language-'.concat(k, '"]')]) } : U, K = R.useInlineStyles, Y = K === void 0 ? !0 : K, J = R.showLineNumbers, Z = J === void 0 ? !1 : J, X = R.showInlineLineNumbers, ee = X === void 0 ? !0 : X, te = R.startingLineNumber, re = te === void 0 ? 1 : te, Q = R.lineNumberContainerStyle, ne = R.lineNumberStyle, oe = ne === void 0 ? {} : ne, ae = R.wrapLines, se = R.wrapLongLines, ie = se === void 0 ? !1 : se, he = R.lineProps, xe = he === void 0 ? {} : he, Pe = R.renderer, Re = R.PreTag, ke = Re === void 0 ? "pre" : Re, Te = R.CodeTag, fe = Te === void 0 ? "code" : Te, ue = R.code, Ce = ue === void 0 ? (Array.isArray(D) ? D[0] : D) || "" : ue, ce = R.astGenerator, pe = _objectWithoutProperties$1(R, _excluded$1w);
    ce = ce || T;
    var _e = Z ? React__default.createElement(AllLineNumbers, { containerStyle: Q, codeStyle: q.style || {}, numberStyle: oe, startingLineNumber: re, codeString: Ce }) : null, ge = V.hljs || V['pre[class*="language-"]'] || { backgroundColor: "#fff" }, Ae = isHighlightJs(ce) ? "hljs" : "prismjs", Ee = Y ? Object.assign({}, pe, { style: Object.assign({}, ge, W) }) : Object.assign({}, pe, { className: pe.className ? "".concat(Ae, " ").concat(pe.className) : Ae, style: Object.assign({}, W) });
    if (ie ? q.style = _objectSpread2$1(_objectSpread2$1({}, q.style), {}, { whiteSpace: "pre-wrap" }) : q.style = _objectSpread2$1(_objectSpread2$1({}, q.style), {}, { whiteSpace: "pre" }), !ce) return React__default.createElement(ke, Ee, _e, React__default.createElement(fe, q, Ce));
    (ae === void 0 && Pe || ie) && (ae = !0), Pe = Pe || defaultRenderer;
    var ve = [{ type: "text", value: Ce }], le = getCodeTree({ astGenerator: ce, language: k, code: Ce, defaultCodeValue: ve });
    le.language === null && (le.value = ve);
    var me = le.value.length + re, Se = processLines(le, ae, xe, Z, ee, re, me, oe, ie);
    return React__default.createElement(ke, Ee, React__default.createElement(fe, q, !ee && _e, Pe({ rows: Se, stylesheet: V, useInlineStyles: Y })));
  };
}
var import_core = __toESM$2(require_core()), SyntaxHighlighter = highlight_default(import_core.default, {});
SyntaxHighlighter.registerLanguage = function(T, S) {
  return import_core.default.register(S);
};
SyntaxHighlighter.alias = function(T, S) {
  return import_core.default.alias(T, S);
};
var prism_light_default = SyntaxHighlighter, Container$4 = newStyled.div(({ theme: T }) => ({ position: "absolute", bottom: 0, right: 0, maxWidth: "100%", display: "flex", background: T.background.content, zIndex: 1 })), ActionButton = newStyled.button(({ theme: T }) => ({ margin: 0, border: "0 none", padding: "4px 10px", cursor: "pointer", display: "flex", alignItems: "center", color: T.color.defaultText, background: T.background.content, fontSize: 12, lineHeight: "16px", fontFamily: T.typography.fonts.base, fontWeight: T.typography.weight.bold, borderTop: `1px solid ${T.appBorderColor}`, borderLeft: `1px solid ${T.appBorderColor}`, marginLeft: -1, borderRadius: "4px 0 0 0", "&:not(:last-child)": { borderRight: `1px solid ${T.appBorderColor}` }, "& + *": { borderLeft: `1px solid ${T.appBorderColor}`, borderRadius: 0 }, "&:focus": { boxShadow: `${T.color.secondary} 0 -3px 0 0 inset`, outline: "0 none" } }), ({ disabled: T }) => T && { cursor: "not-allowed", opacity: 0.5 });
ActionButton.displayName = "ActionButton";
var ActionBar = ({ actionItems: T, ...S }) => React__default.createElement(Container$4, { ...S }, T.map(({ title: R, className: k, onClick: D, disabled: L }, V) => React__default.createElement(ActionButton, { key: V, className: k, onClick: D, disabled: L }, R))), $8927f6f2acc4f386$var$NODES = ["a", "button", "div", "form", "h2", "h3", "img", "input", "label", "li", "nav", "ol", "p", "span", "svg", "ul"], $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((T, S) => {
  let R = forwardRef((k, D) => {
    let { asChild: L, ...V } = k, z = L ? Slot : S;
    return useEffect$1(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), createElement$1(z, _extends$2({}, V, { ref: D }));
  });
  return R.displayName = `Primitive.${S}`, { ...T, [S]: R };
}, {});
function $6ed0406888f73fc4$var$setRef(T, S) {
  typeof T == "function" ? T(S) : T != null && (T.current = S);
}
function $6ed0406888f73fc4$export$43e446d32b3d21af(...T) {
  return (S) => T.forEach((R) => $6ed0406888f73fc4$var$setRef(R, S));
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...T) {
  return useCallback($6ed0406888f73fc4$export$43e446d32b3d21af(...T), T);
}
var $9f79659886946c16$export$e5c5a5f917a5871c = globalThis?.document ? useLayoutEffect : () => {
};
function $fe963b355347cc68$export$3e6543de14f8614f(T, S) {
  return useReducer((R, k) => S[R][k] ?? R, T);
}
var $921a889cee6df7e8$export$99c2b779aa4e8b8b = (T) => {
  let { present: S, children: R } = T, k = $921a889cee6df7e8$var$usePresence(S), D = typeof R == "function" ? R({ present: k.isPresent }) : Children.only(R), L = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(k.ref, D.ref);
  return typeof R == "function" || k.isPresent ? cloneElement(D, { ref: L }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = "Presence";
function $921a889cee6df7e8$var$usePresence(T) {
  let [S, R] = useState$1(), k = useRef({}), D = useRef(T), L = useRef("none"), V = T ? "mounted" : "unmounted", [z, W] = $fe963b355347cc68$export$3e6543de14f8614f(V, { mounted: { UNMOUNT: "unmounted", ANIMATION_OUT: "unmountSuspended" }, unmountSuspended: { MOUNT: "mounted", ANIMATION_END: "unmounted" }, unmounted: { MOUNT: "mounted" } });
  return useEffect$1(() => {
    let U = $921a889cee6df7e8$var$getAnimationName(k.current);
    L.current = z === "mounted" ? U : "none";
  }, [z]), $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    let U = k.current, q = D.current;
    if (q !== T) {
      let K = L.current, Y = $921a889cee6df7e8$var$getAnimationName(U);
      T ? W("MOUNT") : Y === "none" || U?.display === "none" ? W("UNMOUNT") : W(q && K !== Y ? "ANIMATION_OUT" : "UNMOUNT"), D.current = T;
    }
  }, [T, W]), $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    if (S) {
      let U = (K) => {
        let Y = $921a889cee6df7e8$var$getAnimationName(k.current).includes(K.animationName);
        K.target === S && Y && flushSync(() => W("ANIMATION_END"));
      }, q = (K) => {
        K.target === S && (L.current = $921a889cee6df7e8$var$getAnimationName(k.current));
      };
      return S.addEventListener("animationstart", q), S.addEventListener("animationcancel", U), S.addEventListener("animationend", U), () => {
        S.removeEventListener("animationstart", q), S.removeEventListener("animationcancel", U), S.removeEventListener("animationend", U);
      };
    } else W("ANIMATION_END");
  }, [S, W]), { isPresent: ["mounted", "unmountSuspended"].includes(z), ref: useCallback((U) => {
    U && (k.current = getComputedStyle(U)), R(U);
  }, []) };
}
function $921a889cee6df7e8$var$getAnimationName(T) {
  return T?.animationName || "none";
}
function $c512c27ab02ef895$export$50c7b4e9d9f19c1(T, S = []) {
  let R = [];
  function k(L, V) {
    let z = createContext$1(V), W = R.length;
    R = [...R, V];
    function U(K) {
      let { scope: Y, children: J, ...Z } = K, X = Y?.[T][W] || z, ee = useMemo(() => Z, Object.values(Z));
      return createElement$1(X.Provider, { value: ee }, J);
    }
    function q(K, Y) {
      let J = Y?.[T][W] || z, Z = useContext(J);
      if (Z) return Z;
      if (V !== void 0) return V;
      throw new Error(`\`${K}\` must be used within \`${L}\``);
    }
    return U.displayName = L + "Provider", [U, q];
  }
  let D = () => {
    let L = R.map((V) => createContext$1(V));
    return function(V) {
      let z = V?.[T] || L;
      return useMemo(() => ({ [`__scope${T}`]: { ...V, [T]: z } }), [V, z]);
    };
  };
  return D.scopeName = T, [k, $c512c27ab02ef895$var$composeContextScopes(D, ...S)];
}
function $c512c27ab02ef895$var$composeContextScopes(...T) {
  let S = T[0];
  if (T.length === 1) return S;
  let R = () => {
    let k = T.map((D) => ({ useScope: D(), scopeName: D.scopeName }));
    return function(D) {
      let L = k.reduce((V, { useScope: z, scopeName: W }) => {
        let U = z(D)[`__scope${W}`];
        return { ...V, ...U };
      }, {});
      return useMemo(() => ({ [`__scope${S.scopeName}`]: L }), [L]);
    };
  };
  return R.scopeName = S.scopeName, R;
}
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(T) {
  let S = useRef(T);
  return useEffect$1(() => {
    S.current = T;
  }), useMemo(() => (...R) => {
    var k;
    return (k = S.current) === null || k === void 0 ? void 0 : k.call(S, ...R);
  }, []);
}
var $f631663db3294ace$var$DirectionContext = createContext$1(void 0);
function $f631663db3294ace$export$b39126d51d94e6f3(T) {
  let S = useContext($f631663db3294ace$var$DirectionContext);
  return T || S || "ltr";
}
function $ae6933e535247d3d$export$7d15b64cf5a3a4c4(T, [S, R]) {
  return Math.min(R, Math.max(S, T));
}
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(T, S, { checkForDefaultPrevented: R = !0 } = {}) {
  return function(k) {
    if (T?.(k), R === !1 || !k.defaultPrevented) return S?.(k);
  };
}
function $6c2e24571c90391f$export$3e6543de14f8614f(T, S) {
  return useReducer((R, k) => S[R][k] ?? R, T);
}
var $57acba87d6e25586$var$SCROLL_AREA_NAME = "ScrollArea", [$57acba87d6e25586$var$createScrollAreaContext, $57acba87d6e25586$export$488468afe3a6f2b1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($57acba87d6e25586$var$SCROLL_AREA_NAME), [$57acba87d6e25586$var$ScrollAreaProvider, $57acba87d6e25586$var$useScrollAreaContext] = $57acba87d6e25586$var$createScrollAreaContext($57acba87d6e25586$var$SCROLL_AREA_NAME), $57acba87d6e25586$export$ccf8d8d7bbf3c2cc = forwardRef((T, S) => {
  let { __scopeScrollArea: R, type: k = "hover", dir: D, scrollHideDelay: L = 600, ...V } = T, [z, W] = useState$1(null), [U, q] = useState$1(null), [K, Y] = useState$1(null), [J, Z] = useState$1(null), [X, ee] = useState$1(null), [te, re] = useState$1(0), [Q, ne] = useState$1(0), [oe, ae] = useState$1(!1), [se, ie] = useState$1(!1), he = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(S, (Pe) => W(Pe)), xe = $f631663db3294ace$export$b39126d51d94e6f3(D);
  return createElement$1($57acba87d6e25586$var$ScrollAreaProvider, { scope: R, type: k, dir: xe, scrollHideDelay: L, scrollArea: z, viewport: U, onViewportChange: q, content: K, onContentChange: Y, scrollbarX: J, onScrollbarXChange: Z, scrollbarXEnabled: oe, onScrollbarXEnabledChange: ae, scrollbarY: X, onScrollbarYChange: ee, scrollbarYEnabled: se, onScrollbarYEnabledChange: ie, onCornerWidthChange: re, onCornerHeightChange: ne }, createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$2({ dir: xe }, V, { ref: he, style: { position: "relative", "--radix-scroll-area-corner-width": te + "px", "--radix-scroll-area-corner-height": Q + "px", ...T.style } })));
}), $57acba87d6e25586$var$VIEWPORT_NAME = "ScrollAreaViewport", $57acba87d6e25586$export$a21cbf9f11fca853 = forwardRef((T, S) => {
  let { __scopeScrollArea: R, children: k, ...D } = T, L = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$VIEWPORT_NAME, R), V = useRef(null), z = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(S, V, L.onViewportChange);
  return createElement$1(Fragment, null, createElement$1("style", { dangerouslySetInnerHTML: { __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}" } }), createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$2({ "data-radix-scroll-area-viewport": "" }, D, { ref: z, style: { overflowX: L.scrollbarXEnabled ? "scroll" : "hidden", overflowY: L.scrollbarYEnabled ? "scroll" : "hidden", ...T.style } }), createElement$1("div", { ref: L.onContentChange, style: { minWidth: "100%", display: "table" } }, k)));
}), $57acba87d6e25586$var$SCROLLBAR_NAME = "ScrollAreaScrollbar", $57acba87d6e25586$export$2fabd85d0eba3c57 = forwardRef((T, S) => {
  let { forceMount: R, ...k } = T, D = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, T.__scopeScrollArea), { onScrollbarXEnabledChange: L, onScrollbarYEnabledChange: V } = D, z = T.orientation === "horizontal";
  return useEffect$1(() => (z ? L(!0) : V(!0), () => {
    z ? L(!1) : V(!1);
  }), [z, L, V]), D.type === "hover" ? createElement$1($57acba87d6e25586$var$ScrollAreaScrollbarHover, _extends$2({}, k, { ref: S, forceMount: R })) : D.type === "scroll" ? createElement$1($57acba87d6e25586$var$ScrollAreaScrollbarScroll, _extends$2({}, k, { ref: S, forceMount: R })) : D.type === "auto" ? createElement$1($57acba87d6e25586$var$ScrollAreaScrollbarAuto, _extends$2({}, k, { ref: S, forceMount: R })) : D.type === "always" ? createElement$1($57acba87d6e25586$var$ScrollAreaScrollbarVisible, _extends$2({}, k, { ref: S })) : null;
}), $57acba87d6e25586$var$ScrollAreaScrollbarHover = forwardRef((T, S) => {
  let { forceMount: R, ...k } = T, D = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, T.__scopeScrollArea), [L, V] = useState$1(!1);
  return useEffect$1(() => {
    let z = D.scrollArea, W = 0;
    if (z) {
      let U = () => {
        window.clearTimeout(W), V(!0);
      }, q = () => {
        W = window.setTimeout(() => V(!1), D.scrollHideDelay);
      };
      return z.addEventListener("pointerenter", U), z.addEventListener("pointerleave", q), () => {
        window.clearTimeout(W), z.removeEventListener("pointerenter", U), z.removeEventListener("pointerleave", q);
      };
    }
  }, [D.scrollArea, D.scrollHideDelay]), createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, { present: R || L }, createElement$1($57acba87d6e25586$var$ScrollAreaScrollbarAuto, _extends$2({ "data-state": L ? "visible" : "hidden" }, k, { ref: S })));
}), $57acba87d6e25586$var$ScrollAreaScrollbarScroll = forwardRef((T, S) => {
  let { forceMount: R, ...k } = T, D = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, T.__scopeScrollArea), L = T.orientation === "horizontal", V = $57acba87d6e25586$var$useDebounceCallback(() => W("SCROLL_END"), 100), [z, W] = $6c2e24571c90391f$export$3e6543de14f8614f("hidden", { hidden: { SCROLL: "scrolling" }, scrolling: { SCROLL_END: "idle", POINTER_ENTER: "interacting" }, interacting: { SCROLL: "interacting", POINTER_LEAVE: "idle" }, idle: { HIDE: "hidden", SCROLL: "scrolling", POINTER_ENTER: "interacting" } });
  return useEffect$1(() => {
    if (z === "idle") {
      let U = window.setTimeout(() => W("HIDE"), D.scrollHideDelay);
      return () => window.clearTimeout(U);
    }
  }, [z, D.scrollHideDelay, W]), useEffect$1(() => {
    let U = D.viewport, q = L ? "scrollLeft" : "scrollTop";
    if (U) {
      let K = U[q], Y = () => {
        let J = U[q];
        K !== J && (W("SCROLL"), V()), K = J;
      };
      return U.addEventListener("scroll", Y), () => U.removeEventListener("scroll", Y);
    }
  }, [D.viewport, L, W, V]), createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, { present: R || z !== "hidden" }, createElement$1($57acba87d6e25586$var$ScrollAreaScrollbarVisible, _extends$2({ "data-state": z === "hidden" ? "hidden" : "visible" }, k, { ref: S, onPointerEnter: $e42e1063c40fb3ef$export$b9ecd428b558ff10(T.onPointerEnter, () => W("POINTER_ENTER")), onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(T.onPointerLeave, () => W("POINTER_LEAVE")) })));
}), $57acba87d6e25586$var$ScrollAreaScrollbarAuto = forwardRef((T, S) => {
  let R = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, T.__scopeScrollArea), { forceMount: k, ...D } = T, [L, V] = useState$1(!1), z = T.orientation === "horizontal", W = $57acba87d6e25586$var$useDebounceCallback(() => {
    if (R.viewport) {
      let U = R.viewport.offsetWidth < R.viewport.scrollWidth, q = R.viewport.offsetHeight < R.viewport.scrollHeight;
      V(z ? U : q);
    }
  }, 10);
  return $57acba87d6e25586$var$useResizeObserver(R.viewport, W), $57acba87d6e25586$var$useResizeObserver(R.content, W), createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, { present: k || L }, createElement$1($57acba87d6e25586$var$ScrollAreaScrollbarVisible, _extends$2({ "data-state": L ? "visible" : "hidden" }, D, { ref: S })));
}), $57acba87d6e25586$var$ScrollAreaScrollbarVisible = forwardRef((T, S) => {
  let { orientation: R = "vertical", ...k } = T, D = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, T.__scopeScrollArea), L = useRef(null), V = useRef(0), [z, W] = useState$1({ content: 0, viewport: 0, scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 } }), U = $57acba87d6e25586$var$getThumbRatio(z.viewport, z.content), q = { ...k, sizes: z, onSizesChange: W, hasThumb: U > 0 && U < 1, onThumbChange: (Y) => L.current = Y, onThumbPointerUp: () => V.current = 0, onThumbPointerDown: (Y) => V.current = Y };
  function K(Y, J) {
    return $57acba87d6e25586$var$getScrollPositionFromPointer(Y, V.current, z, J);
  }
  return R === "horizontal" ? createElement$1($57acba87d6e25586$var$ScrollAreaScrollbarX, _extends$2({}, q, { ref: S, onThumbPositionChange: () => {
    if (D.viewport && L.current) {
      let Y = D.viewport.scrollLeft, J = $57acba87d6e25586$var$getThumbOffsetFromScroll(Y, z, D.dir);
      L.current.style.transform = `translate3d(${J}px, 0, 0)`;
    }
  }, onWheelScroll: (Y) => {
    D.viewport && (D.viewport.scrollLeft = Y);
  }, onDragScroll: (Y) => {
    D.viewport && (D.viewport.scrollLeft = K(Y, D.dir));
  } })) : R === "vertical" ? createElement$1($57acba87d6e25586$var$ScrollAreaScrollbarY, _extends$2({}, q, { ref: S, onThumbPositionChange: () => {
    if (D.viewport && L.current) {
      let Y = D.viewport.scrollTop, J = $57acba87d6e25586$var$getThumbOffsetFromScroll(Y, z);
      L.current.style.transform = `translate3d(0, ${J}px, 0)`;
    }
  }, onWheelScroll: (Y) => {
    D.viewport && (D.viewport.scrollTop = Y);
  }, onDragScroll: (Y) => {
    D.viewport && (D.viewport.scrollTop = K(Y));
  } })) : null;
}), $57acba87d6e25586$var$ScrollAreaScrollbarX = forwardRef((T, S) => {
  let { sizes: R, onSizesChange: k, ...D } = T, L = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, T.__scopeScrollArea), [V, z] = useState$1(), W = useRef(null), U = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(S, W, L.onScrollbarXChange);
  return useEffect$1(() => {
    W.current && z(getComputedStyle(W.current));
  }, [W]), createElement$1($57acba87d6e25586$var$ScrollAreaScrollbarImpl, _extends$2({ "data-orientation": "horizontal" }, D, { ref: U, sizes: R, style: { bottom: 0, left: L.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0, right: L.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0, "--radix-scroll-area-thumb-width": $57acba87d6e25586$var$getThumbSize(R) + "px", ...T.style }, onThumbPointerDown: (q) => T.onThumbPointerDown(q.x), onDragScroll: (q) => T.onDragScroll(q.x), onWheelScroll: (q, K) => {
    if (L.viewport) {
      let Y = L.viewport.scrollLeft + q.deltaX;
      T.onWheelScroll(Y), $57acba87d6e25586$var$isScrollingWithinScrollbarBounds(Y, K) && q.preventDefault();
    }
  }, onResize: () => {
    W.current && L.viewport && V && k({ content: L.viewport.scrollWidth, viewport: L.viewport.offsetWidth, scrollbar: { size: W.current.clientWidth, paddingStart: $57acba87d6e25586$var$toInt(V.paddingLeft), paddingEnd: $57acba87d6e25586$var$toInt(V.paddingRight) } });
  } }));
}), $57acba87d6e25586$var$ScrollAreaScrollbarY = forwardRef((T, S) => {
  let { sizes: R, onSizesChange: k, ...D } = T, L = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, T.__scopeScrollArea), [V, z] = useState$1(), W = useRef(null), U = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(S, W, L.onScrollbarYChange);
  return useEffect$1(() => {
    W.current && z(getComputedStyle(W.current));
  }, [W]), createElement$1($57acba87d6e25586$var$ScrollAreaScrollbarImpl, _extends$2({ "data-orientation": "vertical" }, D, { ref: U, sizes: R, style: { top: 0, right: L.dir === "ltr" ? 0 : void 0, left: L.dir === "rtl" ? 0 : void 0, bottom: "var(--radix-scroll-area-corner-height)", "--radix-scroll-area-thumb-height": $57acba87d6e25586$var$getThumbSize(R) + "px", ...T.style }, onThumbPointerDown: (q) => T.onThumbPointerDown(q.y), onDragScroll: (q) => T.onDragScroll(q.y), onWheelScroll: (q, K) => {
    if (L.viewport) {
      let Y = L.viewport.scrollTop + q.deltaY;
      T.onWheelScroll(Y), $57acba87d6e25586$var$isScrollingWithinScrollbarBounds(Y, K) && q.preventDefault();
    }
  }, onResize: () => {
    W.current && L.viewport && V && k({ content: L.viewport.scrollHeight, viewport: L.viewport.offsetHeight, scrollbar: { size: W.current.clientHeight, paddingStart: $57acba87d6e25586$var$toInt(V.paddingTop), paddingEnd: $57acba87d6e25586$var$toInt(V.paddingBottom) } });
  } }));
}), [$57acba87d6e25586$var$ScrollbarProvider, $57acba87d6e25586$var$useScrollbarContext] = $57acba87d6e25586$var$createScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME), $57acba87d6e25586$var$ScrollAreaScrollbarImpl = forwardRef((T, S) => {
  let { __scopeScrollArea: R, sizes: k, hasThumb: D, onThumbChange: L, onThumbPointerUp: V, onThumbPointerDown: z, onThumbPositionChange: W, onDragScroll: U, onWheelScroll: q, onResize: K, ...Y } = T, J = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, R), [Z, X] = useState$1(null), ee = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(S, (he) => X(he)), te = useRef(null), re = useRef(""), Q = J.viewport, ne = k.content - k.viewport, oe = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(q), ae = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(W), se = $57acba87d6e25586$var$useDebounceCallback(K, 10);
  function ie(he) {
    if (te.current) {
      let xe = he.clientX - te.current.left, Pe = he.clientY - te.current.top;
      U({ x: xe, y: Pe });
    }
  }
  return useEffect$1(() => {
    let he = (xe) => {
      let Pe = xe.target;
      Z?.contains(Pe) && oe(xe, ne);
    };
    return document.addEventListener("wheel", he, { passive: !1 }), () => document.removeEventListener("wheel", he, { passive: !1 });
  }, [Q, Z, ne, oe]), useEffect$1(ae, [k, ae]), $57acba87d6e25586$var$useResizeObserver(Z, se), $57acba87d6e25586$var$useResizeObserver(J.content, se), createElement$1($57acba87d6e25586$var$ScrollbarProvider, { scope: R, scrollbar: Z, hasThumb: D, onThumbChange: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(L), onThumbPointerUp: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(V), onThumbPositionChange: ae, onThumbPointerDown: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(z) }, createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$2({}, Y, { ref: ee, style: { position: "absolute", ...Y.style }, onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(T.onPointerDown, (he) => {
    he.button === 0 && (he.target.setPointerCapture(he.pointerId), te.current = Z.getBoundingClientRect(), re.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", J.viewport && (J.viewport.style.scrollBehavior = "auto"), ie(he));
  }), onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(T.onPointerMove, ie), onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(T.onPointerUp, (he) => {
    let xe = he.target;
    xe.hasPointerCapture(he.pointerId) && xe.releasePointerCapture(he.pointerId), document.body.style.webkitUserSelect = re.current, J.viewport && (J.viewport.style.scrollBehavior = ""), te.current = null;
  }) })));
}), $57acba87d6e25586$var$THUMB_NAME = "ScrollAreaThumb", $57acba87d6e25586$export$9fba1154677d7cd2 = forwardRef((T, S) => {
  let { forceMount: R, ...k } = T, D = $57acba87d6e25586$var$useScrollbarContext($57acba87d6e25586$var$THUMB_NAME, T.__scopeScrollArea);
  return createElement$1($921a889cee6df7e8$export$99c2b779aa4e8b8b, { present: R || D.hasThumb }, createElement$1($57acba87d6e25586$var$ScrollAreaThumbImpl, _extends$2({ ref: S }, k)));
}), $57acba87d6e25586$var$ScrollAreaThumbImpl = forwardRef((T, S) => {
  let { __scopeScrollArea: R, style: k, ...D } = T, L = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$THUMB_NAME, R), V = $57acba87d6e25586$var$useScrollbarContext($57acba87d6e25586$var$THUMB_NAME, R), { onThumbPositionChange: z } = V, W = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(S, (K) => V.onThumbChange(K)), U = useRef(), q = $57acba87d6e25586$var$useDebounceCallback(() => {
    U.current && (U.current(), U.current = void 0);
  }, 100);
  return useEffect$1(() => {
    let K = L.viewport;
    if (K) {
      let Y = () => {
        if (q(), !U.current) {
          let J = $57acba87d6e25586$var$addUnlinkedScrollListener(K, z);
          U.current = J, z();
        }
      };
      return z(), K.addEventListener("scroll", Y), () => K.removeEventListener("scroll", Y);
    }
  }, [L.viewport, q, z]), createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$2({ "data-state": V.hasThumb ? "visible" : "hidden" }, D, { ref: W, style: { width: "var(--radix-scroll-area-thumb-width)", height: "var(--radix-scroll-area-thumb-height)", ...k }, onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(T.onPointerDownCapture, (K) => {
    let Y = K.target.getBoundingClientRect(), J = K.clientX - Y.left, Z = K.clientY - Y.top;
    V.onThumbPointerDown({ x: J, y: Z });
  }), onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(T.onPointerUp, V.onThumbPointerUp) }));
}), $57acba87d6e25586$var$CORNER_NAME = "ScrollAreaCorner", $57acba87d6e25586$export$56969d565df7cc4b = forwardRef((T, S) => {
  let R = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$CORNER_NAME, T.__scopeScrollArea), k = !!(R.scrollbarX && R.scrollbarY);
  return R.type !== "scroll" && k ? createElement$1($57acba87d6e25586$var$ScrollAreaCornerImpl, _extends$2({}, T, { ref: S })) : null;
}), $57acba87d6e25586$var$ScrollAreaCornerImpl = forwardRef((T, S) => {
  let { __scopeScrollArea: R, ...k } = T, D = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$CORNER_NAME, R), [L, V] = useState$1(0), [z, W] = useState$1(0), U = !!(L && z);
  return $57acba87d6e25586$var$useResizeObserver(D.scrollbarX, () => {
    var q;
    let K = ((q = D.scrollbarX) === null || q === void 0 ? void 0 : q.offsetHeight) || 0;
    D.onCornerHeightChange(K), W(K);
  }), $57acba87d6e25586$var$useResizeObserver(D.scrollbarY, () => {
    var q;
    let K = ((q = D.scrollbarY) === null || q === void 0 ? void 0 : q.offsetWidth) || 0;
    D.onCornerWidthChange(K), V(K);
  }), U ? createElement$1($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends$2({}, k, { ref: S, style: { width: L, height: z, position: "absolute", right: D.dir === "ltr" ? 0 : void 0, left: D.dir === "rtl" ? 0 : void 0, bottom: 0, ...T.style } })) : null;
});
function $57acba87d6e25586$var$toInt(T) {
  return T ? parseInt(T, 10) : 0;
}
function $57acba87d6e25586$var$getThumbRatio(T, S) {
  let R = T / S;
  return isNaN(R) ? 0 : R;
}
function $57acba87d6e25586$var$getThumbSize(T) {
  let S = $57acba87d6e25586$var$getThumbRatio(T.viewport, T.content), R = T.scrollbar.paddingStart + T.scrollbar.paddingEnd, k = (T.scrollbar.size - R) * S;
  return Math.max(k, 18);
}
function $57acba87d6e25586$var$getScrollPositionFromPointer(T, S, R, k = "ltr") {
  let D = $57acba87d6e25586$var$getThumbSize(R), L = D / 2, V = S || L, z = D - V, W = R.scrollbar.paddingStart + V, U = R.scrollbar.size - R.scrollbar.paddingEnd - z, q = R.content - R.viewport, K = k === "ltr" ? [0, q] : [q * -1, 0];
  return $57acba87d6e25586$var$linearScale([W, U], K)(T);
}
function $57acba87d6e25586$var$getThumbOffsetFromScroll(T, S, R = "ltr") {
  let k = $57acba87d6e25586$var$getThumbSize(S), D = S.scrollbar.paddingStart + S.scrollbar.paddingEnd, L = S.scrollbar.size - D, V = S.content - S.viewport, z = L - k, W = R === "ltr" ? [0, V] : [V * -1, 0], U = $ae6933e535247d3d$export$7d15b64cf5a3a4c4(T, W);
  return $57acba87d6e25586$var$linearScale([0, V], [0, z])(U);
}
function $57acba87d6e25586$var$linearScale(T, S) {
  return (R) => {
    if (T[0] === T[1] || S[0] === S[1]) return S[0];
    let k = (S[1] - S[0]) / (T[1] - T[0]);
    return S[0] + k * (R - T[0]);
  };
}
function $57acba87d6e25586$var$isScrollingWithinScrollbarBounds(T, S) {
  return T > 0 && T < S;
}
var $57acba87d6e25586$var$addUnlinkedScrollListener = (T, S = () => {
}) => {
  let R = { left: T.scrollLeft, top: T.scrollTop }, k = 0;
  return function D() {
    let L = { left: T.scrollLeft, top: T.scrollTop }, V = R.left !== L.left, z = R.top !== L.top;
    (V || z) && S(), R = L, k = window.requestAnimationFrame(D);
  }(), () => window.cancelAnimationFrame(k);
};
function $57acba87d6e25586$var$useDebounceCallback(T, S) {
  let R = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(T), k = useRef(0);
  return useEffect$1(() => () => window.clearTimeout(k.current), []), useCallback(() => {
    window.clearTimeout(k.current), k.current = window.setTimeout(R, S);
  }, [R, S]);
}
function $57acba87d6e25586$var$useResizeObserver(T, S) {
  let R = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(S);
  $9f79659886946c16$export$e5c5a5f917a5871c(() => {
    let k = 0;
    if (T) {
      let D = new ResizeObserver(() => {
        cancelAnimationFrame(k), k = window.requestAnimationFrame(R);
      });
      return D.observe(T), () => {
        window.cancelAnimationFrame(k), D.unobserve(T);
      };
    }
  }, [T, R]);
}
var $57acba87d6e25586$export$be92b6f5f03c0fe9 = $57acba87d6e25586$export$ccf8d8d7bbf3c2cc, $57acba87d6e25586$export$d5c6c08dc2d3ca7 = $57acba87d6e25586$export$a21cbf9f11fca853, $57acba87d6e25586$export$9a4e88b92edfce6b = $57acba87d6e25586$export$2fabd85d0eba3c57, $57acba87d6e25586$export$6521433ed15a34db = $57acba87d6e25586$export$9fba1154677d7cd2, $57acba87d6e25586$export$ac61190d9fc311a9 = $57acba87d6e25586$export$56969d565df7cc4b, ScrollAreaRoot = newStyled($57acba87d6e25586$export$be92b6f5f03c0fe9)(({ scrollbarsize: T, offset: S }) => ({ width: "100%", height: "100%", overflow: "hidden", "--scrollbar-size": `${T + S}px`, "--radix-scroll-area-thumb-width": `${T}px` })), ScrollAreaViewport = newStyled($57acba87d6e25586$export$d5c6c08dc2d3ca7)({ width: "100%", height: "100%" }), ScrollAreaScrollbar = newStyled($57acba87d6e25586$export$9a4e88b92edfce6b)(({ offset: T, horizontal: S, vertical: R }) => ({ display: "flex", userSelect: "none", touchAction: "none", background: "transparent", transition: "all 0.2s ease-out", borderRadius: "var(--scrollbar-size)", '&[data-orientation="vertical"]': { width: "var(--scrollbar-size)", paddingRight: T, marginTop: T, marginBottom: S === "true" && R === "true" ? 0 : T }, '&[data-orientation="horizontal"]': { flexDirection: "column", height: "var(--scrollbar-size)", paddingBottom: T, marginLeft: T, marginRight: S === "true" && R === "true" ? 0 : T } })), ScrollAreaThumb = newStyled($57acba87d6e25586$export$6521433ed15a34db)(({ theme: T }) => ({ flex: 1, background: T.textMutedColor, opacity: 0.5, borderRadius: "var(--scrollbar-size)", position: "relative", transition: "opacity 0.2s ease-out", "&:hover": { opacity: 0.8 }, "::before": { content: '""', position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", width: "100%", height: "100%" } })), ScrollArea = forwardRef(({ children: T, horizontal: S = !1, vertical: R = !1, offset: k = 2, scrollbarSize: D = 6, className: L }, V) => React__default.createElement(ScrollAreaRoot, { scrollbarsize: D, offset: k, className: L }, React__default.createElement(ScrollAreaViewport, { ref: V }, T), S && React__default.createElement(ScrollAreaScrollbar, { orientation: "horizontal", offset: k, horizontal: S.toString(), vertical: R.toString() }, React__default.createElement(ScrollAreaThumb, null)), R && React__default.createElement(ScrollAreaScrollbar, { orientation: "vertical", offset: k, horizontal: S.toString(), vertical: R.toString() }, React__default.createElement(ScrollAreaThumb, null)), S && R && React__default.createElement($57acba87d6e25586$export$ac61190d9fc311a9, null)));
ScrollArea.displayName = "ScrollArea";
var { navigator: navigator$1, document: document2$3, window: globalWindow$1 } = scope, supportedLanguages = { jsextra: js_extras_default, jsx: jsx_default, json: json_default, yml: yaml_default, md: markdown_default, bash: bash_default, css: css_default, html: markup_default, tsx: tsx_default, typescript: typescript_default, graphql: graphql_default };
Object.entries(supportedLanguages).forEach(([T, S]) => {
  prism_light_default.registerLanguage(T, S);
});
var themedSyntax = memoize$3(2)((T) => Object.entries(T.code || {}).reduce((S, [R, k]) => ({ ...S, [`* .${R}`]: k }), {})), copyToClipboard = createCopyToClipboardFunction();
function createCopyToClipboardFunction() {
  return navigator$1?.clipboard ? (T) => navigator$1.clipboard.writeText(T) : async (T) => {
    let S = document2$3.createElement("TEXTAREA"), R = document2$3.activeElement;
    S.value = T, document2$3.body.appendChild(S), S.select(), document2$3.execCommand("copy"), document2$3.body.removeChild(S), R.focus();
  };
}
var Wrapper$4 = newStyled.div(({ theme: T }) => ({ position: "relative", overflow: "hidden", color: T.color.defaultText }), ({ theme: T, bordered: S }) => S ? { border: `1px solid ${T.appBorderColor}`, borderRadius: T.borderRadius, background: T.background.content } : {}, ({ showLineNumbers: T }) => T ? { ".react-syntax-highlighter-line-number::before": { content: "attr(data-line-number)" } } : {}), UnstyledScroller = ({ children: T, className: S }) => React__default.createElement(ScrollArea, { horizontal: !0, vertical: !0, className: S }, T), Scroller = newStyled(UnstyledScroller)({ position: "relative" }, ({ theme: T }) => themedSyntax(T)), Pre$1 = newStyled.pre(({ theme: T, padded: S }) => ({ display: "flex", justifyContent: "flex-start", margin: 0, padding: S ? T.layoutMargin : 0 })), Code$1 = newStyled.div(({ theme: T }) => ({ flex: 1, paddingLeft: 2, paddingRight: T.layoutMargin, opacity: 1, fontFamily: T.typography.fonts.mono })), processLineNumber = (T) => {
  let S = [...T.children], R = S[0], k = R.children[0].value, D = { ...R, children: [], properties: { ...R.properties, "data-line-number": k, style: { ...R.properties.style, userSelect: "auto" } } };
  return S[0] = D, { ...T, children: S };
}, defaultRenderer2 = ({ rows: T, stylesheet: S, useInlineStyles: R }) => T.map((k, D) => createElement({ node: processLineNumber(k), stylesheet: S, useInlineStyles: R, key: `code-segement${D}` })), wrapRenderer = (T, S) => S ? T ? ({ rows: R, ...k }) => T({ rows: R.map((D) => processLineNumber(D)), ...k }) : defaultRenderer2 : T, SyntaxHighlighter2$1 = ({ children: T, language: S = "jsx", copyable: R = !1, bordered: k = !1, padded: D = !1, format: L = !0, formatter: V = null, className: z = null, showLineNumbers: W = !1, ...U }) => {
  if (typeof T != "string" || !T.trim()) return null;
  let [q, K] = useState$1("");
  useEffect$1(() => {
    V ? V(L, T).then(K) : K(T.trim());
  }, [T, L, V]);
  let [Y, J] = useState$1(!1), Z = useCallback((ee) => {
    ee.preventDefault(), copyToClipboard(q).then(() => {
      J(!0), globalWindow$1.setTimeout(() => J(!1), 1500);
    }).catch(logger.error);
  }, [q]), X = wrapRenderer(U.renderer, W);
  return React__default.createElement(Wrapper$4, { bordered: k, padded: D, showLineNumbers: W, className: z }, React__default.createElement(Scroller, null, React__default.createElement(prism_light_default, { padded: D || k, language: S, showLineNumbers: W, showInlineLineNumbers: W, useInlineStyles: !1, PreTag: Pre$1, CodeTag: Code$1, lineNumberContainerStyle: {}, ...U, renderer: X }, q)), R ? React__default.createElement(ActionBar, { actionItems: [{ title: Y ? "Copied" : "Copy", onClick: Z }] }) : null);
};
SyntaxHighlighter2$1.registerLanguage = (...T) => prism_light_default.registerLanguage(...T);
var syntaxhighlighter_default = SyntaxHighlighter2$1, require_react_fast_compare = __commonJS$2({ "../../node_modules/react-fast-compare/index.js"(T, S) {
  var R = typeof Element < "u", k = typeof Map == "function", D = typeof Set == "function", L = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
  function V(z, W) {
    if (z === W) return !0;
    if (z && W && typeof z == "object" && typeof W == "object") {
      if (z.constructor !== W.constructor) return !1;
      var U, q, K;
      if (Array.isArray(z)) {
        if (U = z.length, U != W.length) return !1;
        for (q = U; q-- !== 0; ) if (!V(z[q], W[q])) return !1;
        return !0;
      }
      var Y;
      if (k && z instanceof Map && W instanceof Map) {
        if (z.size !== W.size) return !1;
        for (Y = z.entries(); !(q = Y.next()).done; ) if (!W.has(q.value[0])) return !1;
        for (Y = z.entries(); !(q = Y.next()).done; ) if (!V(q.value[1], W.get(q.value[0]))) return !1;
        return !0;
      }
      if (D && z instanceof Set && W instanceof Set) {
        if (z.size !== W.size) return !1;
        for (Y = z.entries(); !(q = Y.next()).done; ) if (!W.has(q.value[0])) return !1;
        return !0;
      }
      if (L && ArrayBuffer.isView(z) && ArrayBuffer.isView(W)) {
        if (U = z.length, U != W.length) return !1;
        for (q = U; q-- !== 0; ) if (z[q] !== W[q]) return !1;
        return !0;
      }
      if (z.constructor === RegExp) return z.source === W.source && z.flags === W.flags;
      if (z.valueOf !== Object.prototype.valueOf && typeof z.valueOf == "function" && typeof W.valueOf == "function") return z.valueOf() === W.valueOf();
      if (z.toString !== Object.prototype.toString && typeof z.toString == "function" && typeof W.toString == "function") return z.toString() === W.toString();
      if (K = Object.keys(z), U = K.length, U !== Object.keys(W).length) return !1;
      for (q = U; q-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(W, K[q])) return !1;
      if (R && z instanceof Element) return !1;
      for (q = U; q-- !== 0; ) if (!((K[q] === "_owner" || K[q] === "__v" || K[q] === "__o") && z.$$typeof) && !V(z[K[q]], W[K[q]])) return !1;
      return !0;
    }
    return z !== z && W !== W;
  }
  S.exports = function(z, W) {
    try {
      return V(z, W);
    } catch (U) {
      if ((U.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw U;
    }
  };
} }), fromEntries = function(T) {
  return T.reduce(function(S, R) {
    var k = R[0], D = R[1];
    return S[k] = D, S;
  }, {});
}, useIsomorphicLayoutEffect$1 = typeof window < "u" && window.document && window.document.createElement ? React$1.useLayoutEffect : React$1.useEffect, top$1 = "top", bottom$1 = "bottom", right$1 = "right", left$1 = "left", auto$1 = "auto", basePlacements$1 = [top$1, bottom$1, right$1, left$1], start$1 = "start", end$1 = "end", clippingParents$1 = "clippingParents", viewport$1 = "viewport", popper$1 = "popper", reference$1 = "reference", variationPlacements$1 = basePlacements$1.reduce(function(T, S) {
  return T.concat([S + "-" + start$1, S + "-" + end$1]);
}, []), placements$1 = [].concat(basePlacements$1, [auto$1]).reduce(function(T, S) {
  return T.concat([S, S + "-" + start$1, S + "-" + end$1]);
}, []), beforeRead$1 = "beforeRead", read$1 = "read", afterRead$1 = "afterRead", beforeMain$1 = "beforeMain", main$3 = "main", afterMain$1 = "afterMain", beforeWrite$1 = "beforeWrite", write$1 = "write", afterWrite$1 = "afterWrite", modifierPhases$1 = [beforeRead$1, read$1, afterRead$1, beforeMain$1, main$3, afterMain$1, beforeWrite$1, write$1, afterWrite$1];
function getNodeName$1(T) {
  return T ? (T.nodeName || "").toLowerCase() : null;
}
function getWindow$1(T) {
  if (T == null) return window;
  if (T.toString() !== "[object Window]") {
    var S = T.ownerDocument;
    return S && S.defaultView || window;
  }
  return T;
}
function isElement$1(T) {
  var S = getWindow$1(T).Element;
  return T instanceof S || T instanceof Element;
}
function isHTMLElement$2(T) {
  var S = getWindow$1(T).HTMLElement;
  return T instanceof S || T instanceof HTMLElement;
}
function isShadowRoot$1(T) {
  if (typeof ShadowRoot > "u") return !1;
  var S = getWindow$1(T).ShadowRoot;
  return T instanceof S || T instanceof ShadowRoot;
}
function applyStyles$3(T) {
  var S = T.state;
  Object.keys(S.elements).forEach(function(R) {
    var k = S.styles[R] || {}, D = S.attributes[R] || {}, L = S.elements[R];
    !isHTMLElement$2(L) || !getNodeName$1(L) || (Object.assign(L.style, k), Object.keys(D).forEach(function(V) {
      var z = D[V];
      z === !1 ? L.removeAttribute(V) : L.setAttribute(V, z === !0 ? "" : z);
    }));
  });
}
function effect$3(T) {
  var S = T.state, R = { popper: { position: S.options.strategy, left: "0", top: "0", margin: "0" }, arrow: { position: "absolute" }, reference: {} };
  return Object.assign(S.elements.popper.style, R.popper), S.styles = R, S.elements.arrow && Object.assign(S.elements.arrow.style, R.arrow), function() {
    Object.keys(S.elements).forEach(function(k) {
      var D = S.elements[k], L = S.attributes[k] || {}, V = Object.keys(S.styles.hasOwnProperty(k) ? S.styles[k] : R[k]), z = V.reduce(function(W, U) {
        return W[U] = "", W;
      }, {});
      !isHTMLElement$2(D) || !getNodeName$1(D) || (Object.assign(D.style, z), Object.keys(L).forEach(function(W) {
        D.removeAttribute(W);
      }));
    });
  };
}
var applyStyles_default = { name: "applyStyles", enabled: !0, phase: "write", fn: applyStyles$3, effect: effect$3, requires: ["computeStyles"] };
function getBasePlacement$1(T) {
  return T.split("-")[0];
}
var max$1 = Math.max, min$1 = Math.min, round$3 = Math.round;
function getUAString$1() {
  var T = navigator.userAgentData;
  return T != null && T.brands && Array.isArray(T.brands) ? T.brands.map(function(S) {
    return S.brand + "/" + S.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport$1() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString$1());
}
function getBoundingClientRect$1(T, S, R) {
  S === void 0 && (S = !1), R === void 0 && (R = !1);
  var k = T.getBoundingClientRect(), D = 1, L = 1;
  S && isHTMLElement$2(T) && (D = T.offsetWidth > 0 && round$3(k.width) / T.offsetWidth || 1, L = T.offsetHeight > 0 && round$3(k.height) / T.offsetHeight || 1);
  var V = isElement$1(T) ? getWindow$1(T) : window, z = V.visualViewport, W = !isLayoutViewport$1() && R, U = (k.left + (W && z ? z.offsetLeft : 0)) / D, q = (k.top + (W && z ? z.offsetTop : 0)) / L, K = k.width / D, Y = k.height / L;
  return { width: K, height: Y, top: q, right: U + K, bottom: q + Y, left: U, x: U, y: q };
}
function getLayoutRect$1(T) {
  var S = getBoundingClientRect$1(T), R = T.offsetWidth, k = T.offsetHeight;
  return Math.abs(S.width - R) <= 1 && (R = S.width), Math.abs(S.height - k) <= 1 && (k = S.height), { x: T.offsetLeft, y: T.offsetTop, width: R, height: k };
}
function contains$1(T, S) {
  var R = S.getRootNode && S.getRootNode();
  if (T.contains(S)) return !0;
  if (R && isShadowRoot$1(R)) {
    var k = S;
    do {
      if (k && T.isSameNode(k)) return !0;
      k = k.parentNode || k.host;
    } while (k);
  }
  return !1;
}
function getComputedStyle$2(T) {
  return getWindow$1(T).getComputedStyle(T);
}
function isTableElement$1(T) {
  return ["table", "td", "th"].indexOf(getNodeName$1(T)) >= 0;
}
function getDocumentElement$1(T) {
  return ((isElement$1(T) ? T.ownerDocument : T.document) || window.document).documentElement;
}
function getParentNode$1(T) {
  return getNodeName$1(T) === "html" ? T : T.assignedSlot || T.parentNode || (isShadowRoot$1(T) ? T.host : null) || getDocumentElement$1(T);
}
function getTrueOffsetParent$1(T) {
  return !isHTMLElement$2(T) || getComputedStyle$2(T).position === "fixed" ? null : T.offsetParent;
}
function getContainingBlock$1(T) {
  var S = /firefox/i.test(getUAString$1()), R = /Trident/i.test(getUAString$1());
  if (R && isHTMLElement$2(T)) {
    var k = getComputedStyle$2(T);
    if (k.position === "fixed") return null;
  }
  var D = getParentNode$1(T);
  for (isShadowRoot$1(D) && (D = D.host); isHTMLElement$2(D) && ["html", "body"].indexOf(getNodeName$1(D)) < 0; ) {
    var L = getComputedStyle$2(D);
    if (L.transform !== "none" || L.perspective !== "none" || L.contain === "paint" || ["transform", "perspective"].indexOf(L.willChange) !== -1 || S && L.willChange === "filter" || S && L.filter && L.filter !== "none") return D;
    D = D.parentNode;
  }
  return null;
}
function getOffsetParent$1(T) {
  for (var S = getWindow$1(T), R = getTrueOffsetParent$1(T); R && isTableElement$1(R) && getComputedStyle$2(R).position === "static"; ) R = getTrueOffsetParent$1(R);
  return R && (getNodeName$1(R) === "html" || getNodeName$1(R) === "body" && getComputedStyle$2(R).position === "static") ? S : R || getContainingBlock$1(T) || S;
}
function getMainAxisFromPlacement$1(T) {
  return ["top", "bottom"].indexOf(T) >= 0 ? "x" : "y";
}
function within$1(T, S, R) {
  return max$1(T, min$1(S, R));
}
function withinMaxClamp$1(T, S, R) {
  var k = within$1(T, S, R);
  return k > R ? R : k;
}
function getFreshSideObject$1() {
  return { top: 0, right: 0, bottom: 0, left: 0 };
}
function mergePaddingObject$1(T) {
  return Object.assign({}, getFreshSideObject$1(), T);
}
function expandToHashMap$1(T, S) {
  return S.reduce(function(R, k) {
    return R[k] = T, R;
  }, {});
}
var toPaddingObject$1 = function(T, S) {
  return T = typeof T == "function" ? T(Object.assign({}, S.rects, { placement: S.placement })) : T, mergePaddingObject$1(typeof T != "number" ? T : expandToHashMap$1(T, basePlacements$1));
};
function arrow$2(T) {
  var S, R = T.state, k = T.name, D = T.options, L = R.elements.arrow, V = R.modifiersData.popperOffsets, z = getBasePlacement$1(R.placement), W = getMainAxisFromPlacement$1(z), U = [left$1, right$1].indexOf(z) >= 0, q = U ? "height" : "width";
  if (!(!L || !V)) {
    var K = toPaddingObject$1(D.padding, R), Y = getLayoutRect$1(L), J = W === "y" ? top$1 : left$1, Z = W === "y" ? bottom$1 : right$1, X = R.rects.reference[q] + R.rects.reference[W] - V[W] - R.rects.popper[q], ee = V[W] - R.rects.reference[W], te = getOffsetParent$1(L), re = te ? W === "y" ? te.clientHeight || 0 : te.clientWidth || 0 : 0, Q = X / 2 - ee / 2, ne = K[J], oe = re - Y[q] - K[Z], ae = re / 2 - Y[q] / 2 + Q, se = within$1(ne, ae, oe), ie = W;
    R.modifiersData[k] = (S = {}, S[ie] = se, S.centerOffset = se - ae, S);
  }
}
function effect2(T) {
  var S = T.state, R = T.options, k = R.element, D = k === void 0 ? "[data-popper-arrow]" : k;
  D != null && (typeof D == "string" && (D = S.elements.popper.querySelector(D), !D) || contains$1(S.elements.popper, D) && (S.elements.arrow = D));
}
var arrow_default = { name: "arrow", enabled: !0, phase: "main", fn: arrow$2, effect: effect2, requires: ["popperOffsets"], requiresIfExists: ["preventOverflow"] };
function getVariation$1(T) {
  return T.split("-")[1];
}
var unsetSides$1 = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
function roundOffsetsByDPR$1(T, S) {
  var R = T.x, k = T.y, D = S.devicePixelRatio || 1;
  return { x: round$3(R * D) / D || 0, y: round$3(k * D) / D || 0 };
}
function mapToStyles$1(T) {
  var S, R = T.popper, k = T.popperRect, D = T.placement, L = T.variation, V = T.offsets, z = T.position, W = T.gpuAcceleration, U = T.adaptive, q = T.roundOffsets, K = T.isFixed, Y = V.x, J = Y === void 0 ? 0 : Y, Z = V.y, X = Z === void 0 ? 0 : Z, ee = typeof q == "function" ? q({ x: J, y: X }) : { x: J, y: X };
  J = ee.x, X = ee.y;
  var te = V.hasOwnProperty("x"), re = V.hasOwnProperty("y"), Q = left$1, ne = top$1, oe = window;
  if (U) {
    var ae = getOffsetParent$1(R), se = "clientHeight", ie = "clientWidth";
    if (ae === getWindow$1(R) && (ae = getDocumentElement$1(R), getComputedStyle$2(ae).position !== "static" && z === "absolute" && (se = "scrollHeight", ie = "scrollWidth")), ae = ae, D === top$1 || (D === left$1 || D === right$1) && L === end$1) {
      ne = bottom$1;
      var he = K && ae === oe && oe.visualViewport ? oe.visualViewport.height : ae[se];
      X -= he - k.height, X *= W ? 1 : -1;
    }
    if (D === left$1 || (D === top$1 || D === bottom$1) && L === end$1) {
      Q = right$1;
      var xe = K && ae === oe && oe.visualViewport ? oe.visualViewport.width : ae[ie];
      J -= xe - k.width, J *= W ? 1 : -1;
    }
  }
  var Pe = Object.assign({ position: z }, U && unsetSides$1), Re = q === !0 ? roundOffsetsByDPR$1({ x: J, y: X }, getWindow$1(R)) : { x: J, y: X };
  if (J = Re.x, X = Re.y, W) {
    var ke;
    return Object.assign({}, Pe, (ke = {}, ke[ne] = re ? "0" : "", ke[Q] = te ? "0" : "", ke.transform = (oe.devicePixelRatio || 1) <= 1 ? "translate(" + J + "px, " + X + "px)" : "translate3d(" + J + "px, " + X + "px, 0)", ke));
  }
  return Object.assign({}, Pe, (S = {}, S[ne] = re ? X + "px" : "", S[Q] = te ? J + "px" : "", S.transform = "", S));
}
function computeStyles$2(T) {
  var S = T.state, R = T.options, k = R.gpuAcceleration, D = k === void 0 ? !0 : k, L = R.adaptive, V = L === void 0 ? !0 : L, z = R.roundOffsets, W = z === void 0 ? !0 : z, U = { placement: getBasePlacement$1(S.placement), variation: getVariation$1(S.placement), popper: S.elements.popper, popperRect: S.rects.popper, gpuAcceleration: D, isFixed: S.options.strategy === "fixed" };
  S.modifiersData.popperOffsets != null && (S.styles.popper = Object.assign({}, S.styles.popper, mapToStyles$1(Object.assign({}, U, { offsets: S.modifiersData.popperOffsets, position: S.options.strategy, adaptive: V, roundOffsets: W })))), S.modifiersData.arrow != null && (S.styles.arrow = Object.assign({}, S.styles.arrow, mapToStyles$1(Object.assign({}, U, { offsets: S.modifiersData.arrow, position: "absolute", adaptive: !1, roundOffsets: W })))), S.attributes.popper = Object.assign({}, S.attributes.popper, { "data-popper-placement": S.placement });
}
var computeStyles_default = { name: "computeStyles", enabled: !0, phase: "beforeWrite", fn: computeStyles$2, data: {} }, passive$1 = { passive: !0 };
function effect3(T) {
  var S = T.state, R = T.instance, k = T.options, D = k.scroll, L = D === void 0 ? !0 : D, V = k.resize, z = V === void 0 ? !0 : V, W = getWindow$1(S.elements.popper), U = [].concat(S.scrollParents.reference, S.scrollParents.popper);
  return L && U.forEach(function(q) {
    q.addEventListener("scroll", R.update, passive$1);
  }), z && W.addEventListener("resize", R.update, passive$1), function() {
    L && U.forEach(function(q) {
      q.removeEventListener("scroll", R.update, passive$1);
    }), z && W.removeEventListener("resize", R.update, passive$1);
  };
}
var eventListeners_default = { name: "eventListeners", enabled: !0, phase: "write", fn: function() {
}, effect: effect3, data: {} }, hash$3 = { left: "right", right: "left", bottom: "top", top: "bottom" };
function getOppositePlacement$1(T) {
  return T.replace(/left|right|bottom|top/g, function(S) {
    return hash$3[S];
  });
}
var hash2 = { start: "end", end: "start" };
function getOppositeVariationPlacement$1(T) {
  return T.replace(/start|end/g, function(S) {
    return hash2[S];
  });
}
function getWindowScroll$1(T) {
  var S = getWindow$1(T), R = S.pageXOffset, k = S.pageYOffset;
  return { scrollLeft: R, scrollTop: k };
}
function getWindowScrollBarX$1(T) {
  return getBoundingClientRect$1(getDocumentElement$1(T)).left + getWindowScroll$1(T).scrollLeft;
}
function getViewportRect$1(T, S) {
  var R = getWindow$1(T), k = getDocumentElement$1(T), D = R.visualViewport, L = k.clientWidth, V = k.clientHeight, z = 0, W = 0;
  if (D) {
    L = D.width, V = D.height;
    var U = isLayoutViewport$1();
    (U || !U && S === "fixed") && (z = D.offsetLeft, W = D.offsetTop);
  }
  return { width: L, height: V, x: z + getWindowScrollBarX$1(T), y: W };
}
function getDocumentRect$1(T) {
  var S, R = getDocumentElement$1(T), k = getWindowScroll$1(T), D = (S = T.ownerDocument) == null ? void 0 : S.body, L = max$1(R.scrollWidth, R.clientWidth, D ? D.scrollWidth : 0, D ? D.clientWidth : 0), V = max$1(R.scrollHeight, R.clientHeight, D ? D.scrollHeight : 0, D ? D.clientHeight : 0), z = -k.scrollLeft + getWindowScrollBarX$1(T), W = -k.scrollTop;
  return getComputedStyle$2(D || R).direction === "rtl" && (z += max$1(R.clientWidth, D ? D.clientWidth : 0) - L), { width: L, height: V, x: z, y: W };
}
function isScrollParent$1(T) {
  var S = getComputedStyle$2(T), R = S.overflow, k = S.overflowX, D = S.overflowY;
  return /auto|scroll|overlay|hidden/.test(R + D + k);
}
function getScrollParent$1(T) {
  return ["html", "body", "#document"].indexOf(getNodeName$1(T)) >= 0 ? T.ownerDocument.body : isHTMLElement$2(T) && isScrollParent$1(T) ? T : getScrollParent$1(getParentNode$1(T));
}
function listScrollParents$1(T, S) {
  var R;
  S === void 0 && (S = []);
  var k = getScrollParent$1(T), D = k === ((R = T.ownerDocument) == null ? void 0 : R.body), L = getWindow$1(k), V = D ? [L].concat(L.visualViewport || [], isScrollParent$1(k) ? k : []) : k, z = S.concat(V);
  return D ? z : z.concat(listScrollParents$1(getParentNode$1(V)));
}
function rectToClientRect$1(T) {
  return Object.assign({}, T, { left: T.x, top: T.y, right: T.x + T.width, bottom: T.y + T.height });
}
function getInnerBoundingClientRect$1(T, S) {
  var R = getBoundingClientRect$1(T, !1, S === "fixed");
  return R.top = R.top + T.clientTop, R.left = R.left + T.clientLeft, R.bottom = R.top + T.clientHeight, R.right = R.left + T.clientWidth, R.width = T.clientWidth, R.height = T.clientHeight, R.x = R.left, R.y = R.top, R;
}
function getClientRectFromMixedType$1(T, S, R) {
  return S === viewport$1 ? rectToClientRect$1(getViewportRect$1(T, R)) : isElement$1(S) ? getInnerBoundingClientRect$1(S, R) : rectToClientRect$1(getDocumentRect$1(getDocumentElement$1(T)));
}
function getClippingParents$1(T) {
  var S = listScrollParents$1(getParentNode$1(T)), R = ["absolute", "fixed"].indexOf(getComputedStyle$2(T).position) >= 0, k = R && isHTMLElement$2(T) ? getOffsetParent$1(T) : T;
  return isElement$1(k) ? S.filter(function(D) {
    return isElement$1(D) && contains$1(D, k) && getNodeName$1(D) !== "body";
  }) : [];
}
function getClippingRect$1(T, S, R, k) {
  var D = S === "clippingParents" ? getClippingParents$1(T) : [].concat(S), L = [].concat(D, [R]), V = L[0], z = L.reduce(function(W, U) {
    var q = getClientRectFromMixedType$1(T, U, k);
    return W.top = max$1(q.top, W.top), W.right = min$1(q.right, W.right), W.bottom = min$1(q.bottom, W.bottom), W.left = max$1(q.left, W.left), W;
  }, getClientRectFromMixedType$1(T, V, k));
  return z.width = z.right - z.left, z.height = z.bottom - z.top, z.x = z.left, z.y = z.top, z;
}
function computeOffsets$1(T) {
  var S = T.reference, R = T.element, k = T.placement, D = k ? getBasePlacement$1(k) : null, L = k ? getVariation$1(k) : null, V = S.x + S.width / 2 - R.width / 2, z = S.y + S.height / 2 - R.height / 2, W;
  switch (D) {
    case top$1:
      W = { x: V, y: S.y - R.height };
      break;
    case bottom$1:
      W = { x: V, y: S.y + S.height };
      break;
    case right$1:
      W = { x: S.x + S.width, y: z };
      break;
    case left$1:
      W = { x: S.x - R.width, y: z };
      break;
    default:
      W = { x: S.x, y: S.y };
  }
  var U = D ? getMainAxisFromPlacement$1(D) : null;
  if (U != null) {
    var q = U === "y" ? "height" : "width";
    switch (L) {
      case start$1:
        W[U] = W[U] - (S[q] / 2 - R[q] / 2);
        break;
      case end$1:
        W[U] = W[U] + (S[q] / 2 - R[q] / 2);
        break;
    }
  }
  return W;
}
function detectOverflow$1(T, S) {
  S === void 0 && (S = {});
  var R = S, k = R.placement, D = k === void 0 ? T.placement : k, L = R.strategy, V = L === void 0 ? T.strategy : L, z = R.boundary, W = z === void 0 ? clippingParents$1 : z, U = R.rootBoundary, q = U === void 0 ? viewport$1 : U, K = R.elementContext, Y = K === void 0 ? popper$1 : K, J = R.altBoundary, Z = J === void 0 ? !1 : J, X = R.padding, ee = X === void 0 ? 0 : X, te = mergePaddingObject$1(typeof ee != "number" ? ee : expandToHashMap$1(ee, basePlacements$1)), re = Y === popper$1 ? reference$1 : popper$1, Q = T.rects.popper, ne = T.elements[Z ? re : Y], oe = getClippingRect$1(isElement$1(ne) ? ne : ne.contextElement || getDocumentElement$1(T.elements.popper), W, q, V), ae = getBoundingClientRect$1(T.elements.reference), se = computeOffsets$1({ reference: ae, element: Q, strategy: "absolute", placement: D }), ie = rectToClientRect$1(Object.assign({}, Q, se)), he = Y === popper$1 ? ie : ae, xe = { top: oe.top - he.top + te.top, bottom: he.bottom - oe.bottom + te.bottom, left: oe.left - he.left + te.left, right: he.right - oe.right + te.right }, Pe = T.modifiersData.offset;
  if (Y === popper$1 && Pe) {
    var Re = Pe[D];
    Object.keys(xe).forEach(function(ke) {
      var Te = [right$1, bottom$1].indexOf(ke) >= 0 ? 1 : -1, fe = [top$1, bottom$1].indexOf(ke) >= 0 ? "y" : "x";
      xe[ke] += Re[fe] * Te;
    });
  }
  return xe;
}
function computeAutoPlacement$1(T, S) {
  S === void 0 && (S = {});
  var R = S, k = R.placement, D = R.boundary, L = R.rootBoundary, V = R.padding, z = R.flipVariations, W = R.allowedAutoPlacements, U = W === void 0 ? placements$1 : W, q = getVariation$1(k), K = q ? z ? variationPlacements$1 : variationPlacements$1.filter(function(Z) {
    return getVariation$1(Z) === q;
  }) : basePlacements$1, Y = K.filter(function(Z) {
    return U.indexOf(Z) >= 0;
  });
  Y.length === 0 && (Y = K);
  var J = Y.reduce(function(Z, X) {
    return Z[X] = detectOverflow$1(T, { placement: X, boundary: D, rootBoundary: L, padding: V })[getBasePlacement$1(X)], Z;
  }, {});
  return Object.keys(J).sort(function(Z, X) {
    return J[Z] - J[X];
  });
}
function getExpandedFallbackPlacements$1(T) {
  if (getBasePlacement$1(T) === auto$1) return [];
  var S = getOppositePlacement$1(T);
  return [getOppositeVariationPlacement$1(T), S, getOppositeVariationPlacement$1(S)];
}
function flip$2(T) {
  var S = T.state, R = T.options, k = T.name;
  if (!S.modifiersData[k]._skip) {
    for (var D = R.mainAxis, L = D === void 0 ? !0 : D, V = R.altAxis, z = V === void 0 ? !0 : V, W = R.fallbackPlacements, U = R.padding, q = R.boundary, K = R.rootBoundary, Y = R.altBoundary, J = R.flipVariations, Z = J === void 0 ? !0 : J, X = R.allowedAutoPlacements, ee = S.options.placement, te = getBasePlacement$1(ee), re = te === ee, Q = W || (re || !Z ? [getOppositePlacement$1(ee)] : getExpandedFallbackPlacements$1(ee)), ne = [ee].concat(Q).reduce(function(ve, le) {
      return ve.concat(getBasePlacement$1(le) === auto$1 ? computeAutoPlacement$1(S, { placement: le, boundary: q, rootBoundary: K, padding: U, flipVariations: Z, allowedAutoPlacements: X }) : le);
    }, []), oe = S.rects.reference, ae = S.rects.popper, se = /* @__PURE__ */ new Map(), ie = !0, he = ne[0], xe = 0; xe < ne.length; xe++) {
      var Pe = ne[xe], Re = getBasePlacement$1(Pe), ke = getVariation$1(Pe) === start$1, Te = [top$1, bottom$1].indexOf(Re) >= 0, fe = Te ? "width" : "height", ue = detectOverflow$1(S, { placement: Pe, boundary: q, rootBoundary: K, altBoundary: Y, padding: U }), Ce = Te ? ke ? right$1 : left$1 : ke ? bottom$1 : top$1;
      oe[fe] > ae[fe] && (Ce = getOppositePlacement$1(Ce));
      var ce = getOppositePlacement$1(Ce), pe = [];
      if (L && pe.push(ue[Re] <= 0), z && pe.push(ue[Ce] <= 0, ue[ce] <= 0), pe.every(function(ve) {
        return ve;
      })) {
        he = Pe, ie = !1;
        break;
      }
      se.set(Pe, pe);
    }
    if (ie) for (var _e = Z ? 3 : 1, ge = function(ve) {
      var le = ne.find(function(me) {
        var Se = se.get(me);
        if (Se) return Se.slice(0, ve).every(function(ye) {
          return ye;
        });
      });
      if (le) return he = le, "break";
    }, Ae = _e; Ae > 0; Ae--) {
      var Ee = ge(Ae);
      if (Ee === "break") break;
    }
    S.placement !== he && (S.modifiersData[k]._skip = !0, S.placement = he, S.reset = !0);
  }
}
var flip_default = { name: "flip", enabled: !0, phase: "main", fn: flip$2, requiresIfExists: ["offset"], data: { _skip: !1 } };
function getSideOffsets$1(T, S, R) {
  return R === void 0 && (R = { x: 0, y: 0 }), { top: T.top - S.height - R.y, right: T.right - S.width + R.x, bottom: T.bottom - S.height + R.y, left: T.left - S.width - R.x };
}
function isAnySideFullyClipped$1(T) {
  return [top$1, right$1, bottom$1, left$1].some(function(S) {
    return T[S] >= 0;
  });
}
function hide$2(T) {
  var S = T.state, R = T.name, k = S.rects.reference, D = S.rects.popper, L = S.modifiersData.preventOverflow, V = detectOverflow$1(S, { elementContext: "reference" }), z = detectOverflow$1(S, { altBoundary: !0 }), W = getSideOffsets$1(V, k), U = getSideOffsets$1(z, D, L), q = isAnySideFullyClipped$1(W), K = isAnySideFullyClipped$1(U);
  S.modifiersData[R] = { referenceClippingOffsets: W, popperEscapeOffsets: U, isReferenceHidden: q, hasPopperEscaped: K }, S.attributes.popper = Object.assign({}, S.attributes.popper, { "data-popper-reference-hidden": q, "data-popper-escaped": K });
}
var hide_default = { name: "hide", enabled: !0, phase: "main", requiresIfExists: ["preventOverflow"], fn: hide$2 };
function distanceAndSkiddingToXY$1(T, S, R) {
  var k = getBasePlacement$1(T), D = [left$1, top$1].indexOf(k) >= 0 ? -1 : 1, L = typeof R == "function" ? R(Object.assign({}, S, { placement: T })) : R, V = L[0], z = L[1];
  return V = V || 0, z = (z || 0) * D, [left$1, right$1].indexOf(k) >= 0 ? { x: z, y: V } : { x: V, y: z };
}
function offset$2(T) {
  var S = T.state, R = T.options, k = T.name, D = R.offset, L = D === void 0 ? [0, 0] : D, V = placements$1.reduce(function(q, K) {
    return q[K] = distanceAndSkiddingToXY$1(K, S.rects, L), q;
  }, {}), z = V[S.placement], W = z.x, U = z.y;
  S.modifiersData.popperOffsets != null && (S.modifiersData.popperOffsets.x += W, S.modifiersData.popperOffsets.y += U), S.modifiersData[k] = V;
}
var offset_default = { name: "offset", enabled: !0, phase: "main", requires: ["popperOffsets"], fn: offset$2 };
function popperOffsets$2(T) {
  var S = T.state, R = T.name;
  S.modifiersData[R] = computeOffsets$1({ reference: S.rects.reference, element: S.rects.popper, strategy: "absolute", placement: S.placement });
}
var popperOffsets_default = { name: "popperOffsets", enabled: !0, phase: "read", fn: popperOffsets$2, data: {} };
function getAltAxis$1(T) {
  return T === "x" ? "y" : "x";
}
function preventOverflow$2(T) {
  var S = T.state, R = T.options, k = T.name, D = R.mainAxis, L = D === void 0 ? !0 : D, V = R.altAxis, z = V === void 0 ? !1 : V, W = R.boundary, U = R.rootBoundary, q = R.altBoundary, K = R.padding, Y = R.tether, J = Y === void 0 ? !0 : Y, Z = R.tetherOffset, X = Z === void 0 ? 0 : Z, ee = detectOverflow$1(S, { boundary: W, rootBoundary: U, padding: K, altBoundary: q }), te = getBasePlacement$1(S.placement), re = getVariation$1(S.placement), Q = !re, ne = getMainAxisFromPlacement$1(te), oe = getAltAxis$1(ne), ae = S.modifiersData.popperOffsets, se = S.rects.reference, ie = S.rects.popper, he = typeof X == "function" ? X(Object.assign({}, S.rects, { placement: S.placement })) : X, xe = typeof he == "number" ? { mainAxis: he, altAxis: he } : Object.assign({ mainAxis: 0, altAxis: 0 }, he), Pe = S.modifiersData.offset ? S.modifiersData.offset[S.placement] : null, Re = { x: 0, y: 0 };
  if (ae) {
    if (L) {
      var ke, Te = ne === "y" ? top$1 : left$1, fe = ne === "y" ? bottom$1 : right$1, ue = ne === "y" ? "height" : "width", Ce = ae[ne], ce = Ce + ee[Te], pe = Ce - ee[fe], _e = J ? -ie[ue] / 2 : 0, ge = re === start$1 ? se[ue] : ie[ue], Ae = re === start$1 ? -ie[ue] : -se[ue], Ee = S.elements.arrow, ve = J && Ee ? getLayoutRect$1(Ee) : { width: 0, height: 0 }, le = S.modifiersData["arrow#persistent"] ? S.modifiersData["arrow#persistent"].padding : getFreshSideObject$1(), me = le[Te], Se = le[fe], ye = within$1(0, se[ue], ve[ue]), be = Q ? se[ue] / 2 - _e - ye - me - xe.mainAxis : ge - ye - me - xe.mainAxis, $e = Q ? -se[ue] / 2 + _e + ye + Se + xe.mainAxis : Ae + ye + Se + xe.mainAxis, Oe = S.elements.arrow && getOffsetParent$1(S.elements.arrow), Ie = Oe ? ne === "y" ? Oe.clientTop || 0 : Oe.clientLeft || 0 : 0, we = (ke = Pe?.[ne]) != null ? ke : 0, Fe = Ce + be - we - Ie, De = Ce + $e - we, Le = within$1(J ? min$1(ce, Fe) : ce, Ce, J ? max$1(pe, De) : pe);
      ae[ne] = Le, Re[ne] = Le - Ce;
    }
    if (z) {
      var ze, We = ne === "x" ? top$1 : left$1, Be = ne === "x" ? bottom$1 : right$1, Ye = ae[oe], Ge = oe === "y" ? "height" : "width", nt = Ye + ee[We], Ze = Ye - ee[Be], Me = [top$1, left$1].indexOf(te) !== -1, Ne = (ze = Pe?.[oe]) != null ? ze : 0, He = Me ? nt : Ye - se[Ge] - ie[Ge] - Ne + xe.altAxis, qe = Me ? Ye + se[Ge] + ie[Ge] - Ne - xe.altAxis : Ze, Ke = J && Me ? withinMaxClamp$1(He, Ye, qe) : within$1(J ? He : nt, Ye, J ? qe : Ze);
      ae[oe] = Ke, Re[oe] = Ke - Ye;
    }
    S.modifiersData[k] = Re;
  }
}
var preventOverflow_default = { name: "preventOverflow", enabled: !0, phase: "main", fn: preventOverflow$2, requiresIfExists: ["offset"] };
function getHTMLElementScroll$1(T) {
  return { scrollLeft: T.scrollLeft, scrollTop: T.scrollTop };
}
function getNodeScroll$1(T) {
  return T === getWindow$1(T) || !isHTMLElement$2(T) ? getWindowScroll$1(T) : getHTMLElementScroll$1(T);
}
function isElementScaled$1(T) {
  var S = T.getBoundingClientRect(), R = round$3(S.width) / T.offsetWidth || 1, k = round$3(S.height) / T.offsetHeight || 1;
  return R !== 1 || k !== 1;
}
function getCompositeRect$1(T, S, R) {
  R === void 0 && (R = !1);
  var k = isHTMLElement$2(S), D = isHTMLElement$2(S) && isElementScaled$1(S), L = getDocumentElement$1(S), V = getBoundingClientRect$1(T, D, R), z = { scrollLeft: 0, scrollTop: 0 }, W = { x: 0, y: 0 };
  return (k || !k && !R) && ((getNodeName$1(S) !== "body" || isScrollParent$1(L)) && (z = getNodeScroll$1(S)), isHTMLElement$2(S) ? (W = getBoundingClientRect$1(S, !0), W.x += S.clientLeft, W.y += S.clientTop) : L && (W.x = getWindowScrollBarX$1(L))), { x: V.left + z.scrollLeft - W.x, y: V.top + z.scrollTop - W.y, width: V.width, height: V.height };
}
function order$1(T) {
  var S = /* @__PURE__ */ new Map(), R = /* @__PURE__ */ new Set(), k = [];
  T.forEach(function(L) {
    S.set(L.name, L);
  });
  function D(L) {
    R.add(L.name);
    var V = [].concat(L.requires || [], L.requiresIfExists || []);
    V.forEach(function(z) {
      if (!R.has(z)) {
        var W = S.get(z);
        W && D(W);
      }
    }), k.push(L);
  }
  return T.forEach(function(L) {
    R.has(L.name) || D(L);
  }), k;
}
function orderModifiers$1(T) {
  var S = order$1(T);
  return modifierPhases$1.reduce(function(R, k) {
    return R.concat(S.filter(function(D) {
      return D.phase === k;
    }));
  }, []);
}
function debounce$2(T) {
  var S;
  return function() {
    return S || (S = new Promise(function(R) {
      Promise.resolve().then(function() {
        S = void 0, R(T());
      });
    })), S;
  };
}
function mergeByName$1(T) {
  var S = T.reduce(function(R, k) {
    var D = R[k.name];
    return R[k.name] = D ? Object.assign({}, D, k, { options: Object.assign({}, D.options, k.options), data: Object.assign({}, D.data, k.data) }) : k, R;
  }, {});
  return Object.keys(S).map(function(R) {
    return S[R];
  });
}
var DEFAULT_OPTIONS$1 = { placement: "bottom", modifiers: [], strategy: "absolute" };
function areValidElements$1() {
  for (var T = arguments.length, S = new Array(T), R = 0; R < T; R++) S[R] = arguments[R];
  return !S.some(function(k) {
    return !(k && typeof k.getBoundingClientRect == "function");
  });
}
function popperGenerator$1(T) {
  T === void 0 && (T = {});
  var S = T, R = S.defaultModifiers, k = R === void 0 ? [] : R, D = S.defaultOptions, L = D === void 0 ? DEFAULT_OPTIONS$1 : D;
  return function(V, z, W) {
    W === void 0 && (W = L);
    var U = { placement: "bottom", orderedModifiers: [], options: Object.assign({}, DEFAULT_OPTIONS$1, L), modifiersData: {}, elements: { reference: V, popper: z }, attributes: {}, styles: {} }, q = [], K = !1, Y = { state: U, setOptions: function(X) {
      var ee = typeof X == "function" ? X(U.options) : X;
      Z(), U.options = Object.assign({}, L, U.options, ee), U.scrollParents = { reference: isElement$1(V) ? listScrollParents$1(V) : V.contextElement ? listScrollParents$1(V.contextElement) : [], popper: listScrollParents$1(z) };
      var te = orderModifiers$1(mergeByName$1([].concat(k, U.options.modifiers)));
      return U.orderedModifiers = te.filter(function(re) {
        return re.enabled;
      }), J(), Y.update();
    }, forceUpdate: function() {
      if (!K) {
        var X = U.elements, ee = X.reference, te = X.popper;
        if (areValidElements$1(ee, te)) {
          U.rects = { reference: getCompositeRect$1(ee, getOffsetParent$1(te), U.options.strategy === "fixed"), popper: getLayoutRect$1(te) }, U.reset = !1, U.placement = U.options.placement, U.orderedModifiers.forEach(function(ie) {
            return U.modifiersData[ie.name] = Object.assign({}, ie.data);
          });
          for (var re = 0; re < U.orderedModifiers.length; re++) {
            if (U.reset === !0) {
              U.reset = !1, re = -1;
              continue;
            }
            var Q = U.orderedModifiers[re], ne = Q.fn, oe = Q.options, ae = oe === void 0 ? {} : oe, se = Q.name;
            typeof ne == "function" && (U = ne({ state: U, options: ae, name: se, instance: Y }) || U);
          }
        }
      }
    }, update: debounce$2(function() {
      return new Promise(function(X) {
        Y.forceUpdate(), X(U);
      });
    }), destroy: function() {
      Z(), K = !0;
    } };
    if (!areValidElements$1(V, z)) return Y;
    Y.setOptions(W).then(function(X) {
      !K && W.onFirstUpdate && W.onFirstUpdate(X);
    });
    function J() {
      U.orderedModifiers.forEach(function(X) {
        var ee = X.name, te = X.options, re = te === void 0 ? {} : te, Q = X.effect;
        if (typeof Q == "function") {
          var ne = Q({ state: U, name: ee, instance: Y, options: re }), oe = function() {
          };
          q.push(ne || oe);
        }
      });
    }
    function Z() {
      q.forEach(function(X) {
        return X();
      }), q = [];
    }
    return Y;
  };
}
var defaultModifiers$1 = [eventListeners_default, popperOffsets_default, computeStyles_default, applyStyles_default, offset_default, flip_default, preventOverflow_default, arrow_default, hide_default], createPopper$1 = popperGenerator$1({ defaultModifiers: defaultModifiers$1 }), import_react_fast_compare = __toESM$2(require_react_fast_compare()), EMPTY_MODIFIERS = [], usePopper = function(T, S, R) {
  R === void 0 && (R = {});
  var k = React$1.useRef(null), D = { onFirstUpdate: R.onFirstUpdate, placement: R.placement || "bottom", strategy: R.strategy || "absolute", modifiers: R.modifiers || EMPTY_MODIFIERS }, L = React$1.useState({ styles: { popper: { position: D.strategy, left: "0", top: "0" }, arrow: { position: "absolute" } }, attributes: {} }), V = L[0], z = L[1], W = React$1.useMemo(function() {
    return { name: "updateState", enabled: !0, phase: "write", fn: function(K) {
      var Y = K.state, J = Object.keys(Y.elements);
      ReactDOM.flushSync(function() {
        z({ styles: fromEntries(J.map(function(Z) {
          return [Z, Y.styles[Z] || {}];
        })), attributes: fromEntries(J.map(function(Z) {
          return [Z, Y.attributes[Z]];
        })) });
      });
    }, requires: ["computeStyles"] };
  }, []), U = React$1.useMemo(function() {
    var K = { onFirstUpdate: D.onFirstUpdate, placement: D.placement, strategy: D.strategy, modifiers: [].concat(D.modifiers, [W, { name: "applyStyles", enabled: !1 }]) };
    return (0, import_react_fast_compare.default)(k.current, K) ? k.current || K : (k.current = K, K);
  }, [D.onFirstUpdate, D.placement, D.strategy, D.modifiers, W]), q = React$1.useRef();
  return useIsomorphicLayoutEffect$1(function() {
    q.current && q.current.setOptions(U);
  }, [U]), useIsomorphicLayoutEffect$1(function() {
    if (!(T == null || S == null)) {
      var K = R.createPopper || createPopper$1, Y = K(T, S, U);
      return q.current = Y, function() {
        Y.destroy(), q.current = null;
      };
    }
  }, [T, S, R.createPopper]), { state: q.current ? q.current.state : null, styles: V.styles, attributes: V.attributes, update: q.current ? q.current.update : null, forceUpdate: q.current ? q.current.forceUpdate : null };
};
function useGetLatest(T) {
  var S = React$1.useRef(T);
  return S.current = T, React$1.useCallback(function() {
    return S.current;
  }, []);
}
var noop$5 = function() {
};
function useControlledState(T) {
  var S = T.initial, R = T.value, k = T.onChange, D = k === void 0 ? noop$5 : k;
  if (S === void 0 && R === void 0) throw new TypeError('Either "value" or "initial" variable must be set. Now both are undefined');
  var L = React$1.useState(S), V = L[0], z = L[1], W = useGetLatest(V), U = React$1.useCallback(function(K) {
    var Y = W(), J = typeof K == "function" ? K(Y) : K;
    typeof J.persist == "function" && J.persist(), z(J), typeof D == "function" && D(J);
  }, [W, D]), q = R !== void 0;
  return [q ? R : V, q ? D : U];
}
function generateBoundingClientRect(T, S) {
  return T === void 0 && (T = 0), S === void 0 && (S = 0), function() {
    return { width: 0, height: 0, top: S, right: T, bottom: S, left: T, x: 0, y: 0, toJSON: function() {
      return null;
    } };
  };
}
var _excluded$1v = ["styles", "attributes"], virtualElement = { getBoundingClientRect: generateBoundingClientRect() }, defaultConfig = { closeOnOutsideClick: !0, closeOnTriggerHidden: !1, defaultVisible: !1, delayHide: 0, delayShow: 0, followCursor: !1, interactive: !1, mutationObserverOptions: { attributes: !0, childList: !0, subtree: !0 }, offset: [0, 6], trigger: "hover" };
function usePopperTooltip(T, S) {
  var R, k, D;
  T === void 0 && (T = {}), S === void 0 && (S = {});
  var L = Object.keys(defaultConfig).reduce(function(fe, ue) {
    var Ce;
    return _extends$2({}, fe, (Ce = {}, Ce[ue] = fe[ue] !== void 0 ? fe[ue] : defaultConfig[ue], Ce));
  }, T), V = React$1.useMemo(function() {
    return [{ name: "offset", options: { offset: L.offset } }];
  }, Array.isArray(L.offset) ? L.offset : []), z = _extends$2({}, S, { placement: S.placement || L.placement, modifiers: S.modifiers || V }), W = React$1.useState(null), U = W[0], q = W[1], K = React$1.useState(null), Y = K[0], J = K[1], Z = useControlledState({ initial: L.defaultVisible, value: L.visible, onChange: L.onVisibleChange }), X = Z[0], ee = Z[1], te = React$1.useRef();
  React$1.useEffect(function() {
    return function() {
      return clearTimeout(te.current);
    };
  }, []);
  var re = usePopper(L.followCursor ? virtualElement : U, Y, z), Q = re.styles, ne = re.attributes, oe = _objectWithoutPropertiesLoose$2(re, _excluded$1v), ae = oe.update, se = useGetLatest({ visible: X, triggerRef: U, tooltipRef: Y, finalConfig: L }), ie = React$1.useCallback(function(fe) {
    return Array.isArray(L.trigger) ? L.trigger.includes(fe) : L.trigger === fe;
  }, Array.isArray(L.trigger) ? L.trigger : [L.trigger]), he = React$1.useCallback(function() {
    clearTimeout(te.current), te.current = window.setTimeout(function() {
      return ee(!1);
    }, L.delayHide);
  }, [L.delayHide, ee]), xe = React$1.useCallback(function() {
    clearTimeout(te.current), te.current = window.setTimeout(function() {
      return ee(!0);
    }, L.delayShow);
  }, [L.delayShow, ee]), Pe = React$1.useCallback(function() {
    se().visible ? he() : xe();
  }, [se, he, xe]);
  React$1.useEffect(function() {
    if (se().finalConfig.closeOnOutsideClick) {
      var fe = function(ue) {
        var Ce, ce = se(), pe = ce.tooltipRef, _e = ce.triggerRef, ge = (ue.composedPath == null || (Ce = ue.composedPath()) == null ? void 0 : Ce[0]) || ue.target;
        ge instanceof Node && pe != null && _e != null && !pe.contains(ge) && !_e.contains(ge) && he();
      };
      return document.addEventListener("mousedown", fe), function() {
        return document.removeEventListener("mousedown", fe);
      };
    }
  }, [se, he]), React$1.useEffect(function() {
    if (!(U == null || !ie("click"))) return U.addEventListener("click", Pe), function() {
      return U.removeEventListener("click", Pe);
    };
  }, [U, ie, Pe]), React$1.useEffect(function() {
    if (!(U == null || !ie("double-click"))) return U.addEventListener("dblclick", Pe), function() {
      return U.removeEventListener("dblclick", Pe);
    };
  }, [U, ie, Pe]), React$1.useEffect(function() {
    if (!(U == null || !ie("right-click"))) {
      var fe = function(ue) {
        ue.preventDefault(), Pe();
      };
      return U.addEventListener("contextmenu", fe), function() {
        return U.removeEventListener("contextmenu", fe);
      };
    }
  }, [U, ie, Pe]), React$1.useEffect(function() {
    if (!(U == null || !ie("focus"))) return U.addEventListener("focus", xe), U.addEventListener("blur", he), function() {
      U.removeEventListener("focus", xe), U.removeEventListener("blur", he);
    };
  }, [U, ie, xe, he]), React$1.useEffect(function() {
    if (!(U == null || !ie("hover"))) return U.addEventListener("mouseenter", xe), U.addEventListener("mouseleave", he), function() {
      U.removeEventListener("mouseenter", xe), U.removeEventListener("mouseleave", he);
    };
  }, [U, ie, xe, he]), React$1.useEffect(function() {
    if (!(Y == null || !ie("hover") || !se().finalConfig.interactive)) return Y.addEventListener("mouseenter", xe), Y.addEventListener("mouseleave", he), function() {
      Y.removeEventListener("mouseenter", xe), Y.removeEventListener("mouseleave", he);
    };
  }, [Y, ie, xe, he, se]);
  var Re = oe == null || (R = oe.state) == null || (k = R.modifiersData) == null || (D = k.hide) == null ? void 0 : D.isReferenceHidden;
  React$1.useEffect(function() {
    L.closeOnTriggerHidden && Re && he();
  }, [L.closeOnTriggerHidden, he, Re]), React$1.useEffect(function() {
    if (!L.followCursor || U == null) return;
    function fe(ue) {
      var Ce = ue.clientX, ce = ue.clientY;
      virtualElement.getBoundingClientRect = generateBoundingClientRect(Ce, ce), ae?.();
    }
    return U.addEventListener("mousemove", fe), function() {
      return U.removeEventListener("mousemove", fe);
    };
  }, [L.followCursor, U, ae]), React$1.useEffect(function() {
    if (!(Y == null || ae == null || L.mutationObserverOptions == null)) {
      var fe = new MutationObserver(ae);
      return fe.observe(Y, L.mutationObserverOptions), function() {
        return fe.disconnect();
      };
    }
  }, [L.mutationObserverOptions, Y, ae]);
  var ke = function(fe) {
    return fe === void 0 && (fe = {}), _extends$2({}, fe, { style: _extends$2({}, fe.style, Q.popper) }, ne.popper, { "data-popper-interactive": L.interactive });
  }, Te = function(fe) {
    return fe === void 0 && (fe = {}), _extends$2({}, fe, ne.arrow, { style: _extends$2({}, fe.style, Q.arrow), "data-popper-arrow": !0 });
  };
  return _extends$2({ getArrowProps: Te, getTooltipProps: ke, setTooltipRef: J, setTriggerRef: q, tooltipRef: Y, triggerRef: U, visible: X }, oe);
}
var match$1 = memoize$3(1e3)((T, S, R, k = 0) => S.split("-")[0] === T ? R : k), ArrowSpacing = 8, Arrow = newStyled.div({ position: "absolute", borderStyle: "solid" }, ({ placement: T }) => {
  let S = 0, R = 0;
  switch (!0) {
    case (T.startsWith("left") || T.startsWith("right")): {
      R = 8;
      break;
    }
    case (T.startsWith("top") || T.startsWith("bottom")): {
      S = 8;
      break;
    }
  }
  return { transform: `translate3d(${S}px, ${R}px, 0px)` };
}, ({ theme: T, color: S, placement: R }) => ({ bottom: `${match$1("top", R, `${ArrowSpacing * -1}px`, "auto")}`, top: `${match$1("bottom", R, `${ArrowSpacing * -1}px`, "auto")}`, right: `${match$1("left", R, `${ArrowSpacing * -1}px`, "auto")}`, left: `${match$1("right", R, `${ArrowSpacing * -1}px`, "auto")}`, borderBottomWidth: `${match$1("top", R, "0", ArrowSpacing)}px`, borderTopWidth: `${match$1("bottom", R, "0", ArrowSpacing)}px`, borderRightWidth: `${match$1("left", R, "0", ArrowSpacing)}px`, borderLeftWidth: `${match$1("right", R, "0", ArrowSpacing)}px`, borderTopColor: match$1("top", R, T.color[S] || S || T.base === "light" ? lightenColor(T.background.app) : T.background.app, "transparent"), borderBottomColor: match$1("bottom", R, T.color[S] || S || T.base === "light" ? lightenColor(T.background.app) : T.background.app, "transparent"), borderLeftColor: match$1("left", R, T.color[S] || S || T.base === "light" ? lightenColor(T.background.app) : T.background.app, "transparent"), borderRightColor: match$1("right", R, T.color[S] || S || T.base === "light" ? lightenColor(T.background.app) : T.background.app, "transparent") })), Wrapper$3 = newStyled.div(({ hidden: T }) => ({ display: T ? "none" : "inline-block", zIndex: 2147483647 }), ({ theme: T, color: S, hasChrome: R }) => R ? { background: T.color[S] || S || T.base === "light" ? lightenColor(T.background.app) : T.background.app, filter: `
            drop-shadow(0px 5px 5px rgba(0,0,0,0.05))
            drop-shadow(0 1px 3px rgba(0,0,0,0.1))
          `, borderRadius: T.appBorderRadius, fontSize: T.typography.size.s1 } : {}), Tooltip$1 = React__default.forwardRef(({ placement: T = "top", hasChrome: S = !0, children: R, arrowProps: k = {}, tooltipRef: D, color: L, withArrows: V, ...z }, W) => React__default.createElement(Wrapper$3, { "data-testid": "tooltip", hasChrome: S, ref: W, ...z, color: L }, S && V && React__default.createElement(Arrow, { placement: T, ...k, color: L }), R));
Tooltip$1.displayName = "Tooltip";
var { document: document2$2 } = scope, TargetContainer = newStyled.div`
  display: inline-block;
  cursor: ${(T) => T.trigger === "hover" || T.trigger.includes("hover") ? "default" : "pointer"};
`, TargetSvgContainer = newStyled.g`
  cursor: ${(T) => T.trigger === "hover" || T.trigger.includes("hover") ? "default" : "pointer"};
`, WithTooltipPure = ({ svg: T = !1, trigger: S = "click", closeOnOutsideClick: R = !1, placement: k = "top", modifiers: D = [{ name: "preventOverflow", options: { padding: 8 } }, { name: "offset", options: { offset: [8, 8] } }, { name: "arrow", options: { padding: 8 } }], hasChrome: L = !0, defaultVisible: V = !1, withArrows: z, offset: W, tooltip: U, children: q, closeOnTriggerHidden: K, mutationObserverOptions: Y, delayHide: J, visible: Z, interactive: X, delayShow: ee, strategy: te, followCursor: re, onVisibleChange: Q, ...ne }) => {
  let oe = T ? TargetSvgContainer : TargetContainer, { getArrowProps: ae, getTooltipProps: se, setTooltipRef: ie, setTriggerRef: he, visible: xe, state: Pe } = usePopperTooltip({ trigger: S, placement: k, defaultVisible: V, delayHide: J, interactive: X, closeOnOutsideClick: R, closeOnTriggerHidden: K, onVisibleChange: Q, delayShow: ee, followCursor: re, mutationObserverOptions: Y, visible: Z, offset: W }, { modifiers: D, strategy: te }), Re = React__default.createElement(Tooltip$1, { placement: Pe?.placement, ref: ie, hasChrome: L, arrowProps: ae(), withArrows: z, ...se() }, typeof U == "function" ? U({ onHide: () => Q(!1) }) : U);
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(oe, { trigger: S, ref: he, ...ne }, q), xe && ReactDOM__default.createPortal(Re, document2$2.body));
}, WithToolTipState = ({ startOpen: T = !1, onVisibleChange: S, ...R }) => {
  let [k, D] = useState$1(T), L = useCallback((V) => {
    S && S(V) === !1 || D(V);
  }, [S]);
  return useEffect$1(() => {
    let V = () => L(!1);
    document2$2.addEventListener("keydown", V, !1);
    let z = Array.from(document2$2.getElementsByTagName("iframe")), W = [];
    return z.forEach((U) => {
      let q = () => {
        try {
          U.contentWindow.document && (U.contentWindow.document.addEventListener("click", V), W.push(() => {
            try {
              U.contentWindow.document.removeEventListener("click", V);
            } catch {
            }
          }));
        } catch {
        }
      };
      q(), U.addEventListener("load", q), W.push(() => {
        U.removeEventListener("load", q);
      });
    }), () => {
      document2$2.removeEventListener("keydown", V), W.forEach((U) => {
        U();
      });
    };
  }), React__default.createElement(WithTooltipPure, { ...R, visible: k, onVisibleChange: L });
}, ZoomIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      d: "M6 3.5a.5.5 0 01.5.5v1.5H8a.5.5 0 010 1H6.5V8a.5.5 0 01-1 0V6.5H4a.5.5 0 010-1h1.5V4a.5.5 0 01.5-.5z",
      fill: T
    }
  ),
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.544 10.206a5.5 5.5 0 11.662-.662.5.5 0 01.148.102l3 3a.5.5 0 01-.708.708l-3-3a.5.5 0 01-.102-.148zM10.5 6a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
      fill: T
    }
  )
)), ZoomOutIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement("path", { d: "M4 5.5a.5.5 0 000 1h4a.5.5 0 000-1H4z", fill: T }),
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6 11.5c1.35 0 2.587-.487 3.544-1.294a.5.5 0 00.102.148l3 3a.5.5 0 00.708-.708l-3-3a.5.5 0 00-.148-.102A5.5 5.5 0 106 11.5zm0-1a4.5 4.5 0 100-9 4.5 4.5 0 000 9z",
      fill: T
    }
  )
)), ZoomResetIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      d: "M1.5 2.837V1.5a.5.5 0 00-1 0V4a.5.5 0 00.5.5h2.5a.5.5 0 000-1H2.258a4.5 4.5 0 11-.496 4.016.5.5 0 10-.942.337 5.502 5.502 0 008.724 2.353.5.5 0 00.102.148l3 3a.5.5 0 00.708-.708l-3-3a.5.5 0 00-.148-.102A5.5 5.5 0 101.5 2.837z",
      fill: T
    }
  )
)), LightningOffIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      d: "M10.139 8.725l1.36-1.323a.568.568 0 00.151-.54.534.534 0 00-.377-.396l-2.705-.708 2.22-4.976a.568.568 0 00-.15-.666.497.497 0 00-.648.008L5.464 4.05l.708.71 2.848-2.47-1.64 3.677.697.697 2.164.567-.81.787.708.708zM2.523 6.6a.566.566 0 00-.177.544.534.534 0 00.382.41l2.782.721-1.494 5.013a.563.563 0 00.217.627.496.496 0 00.629-.06l3.843-3.736-.708-.707-2.51 2.44 1.137-3.814-.685-.685-2.125-.55.844-.731-.71-.71L2.524 6.6zM1.854 1.146a.5.5 0 10-.708.708l11 11a.5.5 0 00.708-.708l-11-11z",
      fill: T
    }
  )
)), MarkupIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      d: "M8.982 1.632a.5.5 0 00-.964-.263l-3 11a.5.5 0 10.964.263l3-11zM3.32 3.616a.5.5 0 01.064.704L1.151 7l2.233 2.68a.5.5 0 11-.768.64l-2.5-3a.5.5 0 010-.64l2.5-3a.5.5 0 01.704-.064zM10.68 3.616a.5.5 0 00-.064.704L12.849 7l-2.233 2.68a.5.5 0 00.768.64l2.5-3a.5.5 0 000-.64l-2.5-3a.5.5 0 00-.704-.064z",
      fill: T
    }
  )
)), StorybookIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.042.616a.704.704 0 00-.66.729L1.816 12.9c.014.367.306.66.672.677l9.395.422h.032a.704.704 0 00.704-.703V.704c0-.015 0-.03-.002-.044a.704.704 0 00-.746-.659l-.773.049.057 1.615a.105.105 0 01-.17.086l-.52-.41-.617.468a.105.105 0 01-.168-.088L9.746.134 2.042.616zm8.003 4.747c-.247.192-2.092.324-2.092.05.04-1.045-.429-1.091-.689-1.091-.247 0-.662.075-.662.634 0 .57.607.893 1.32 1.27 1.014.538 2.24 1.188 2.24 2.823 0 1.568-1.273 2.433-2.898 2.433-1.676 0-3.141-.678-2.976-3.03.065-.275 2.197-.21 2.197 0-.026.971.195 1.256.753 1.256.43 0 .624-.236.624-.634 0-.602-.633-.958-1.361-1.367-.987-.554-2.148-1.205-2.148-2.7 0-1.494 1.027-2.489 2.86-2.489 1.832 0 2.832.98 2.832 2.845z",
      fill: T
    }
  )
)), CrossIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      d: "M1.854 1.146a.5.5 0 10-.708.708L6.293 7l-5.147 5.146a.5.5 0 00.708.708L7 7.707l5.146 5.147a.5.5 0 00.708-.708L7.707 7l5.147-5.146a.5.5 0 00-.708-.708L7 6.293 1.854 1.146z",
      fill: T
    }
  )
)), AddIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      d: "M7 3a.5.5 0 01.5.5v3h3a.5.5 0 010 1h-3v3a.5.5 0 01-1 0v-3h-3a.5.5 0 010-1h3v-3A.5.5 0 017 3z",
      fill: T
    }
  ),
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 14A7 7 0 107 0a7 7 0 000 14zm0-1A6 6 0 107 1a6 6 0 000 12z",
      fill: T
    }
  )
)), SubtractIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement("path", { d: "M3.5 6.5a.5.5 0 000 1h7a.5.5 0 000-1h-7z", fill: T }),
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14 7A7 7 0 110 7a7 7 0 0114 0zm-1 0A6 6 0 111 7a6 6 0 0112 0z",
      fill: T
    }
  )
)), LinkIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      d: "M11.841 2.159a2.25 2.25 0 00-3.182 0l-2.5 2.5a2.25 2.25 0 000 3.182.5.5 0 01-.707.707 3.25 3.25 0 010-4.596l2.5-2.5a3.25 3.25 0 014.596 4.596l-2.063 2.063a4.27 4.27 0 00-.094-1.32l1.45-1.45a2.25 2.25 0 000-3.182z",
      fill: T
    }
  ),
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      d: "M3.61 7.21c-.1-.434-.132-.88-.095-1.321L1.452 7.952a3.25 3.25 0 104.596 4.596l2.5-2.5a3.25 3.25 0 000-4.596.5.5 0 00-.707.707 2.25 2.25 0 010 3.182l-2.5 2.5A2.25 2.25 0 112.159 8.66l1.45-1.45z",
      fill: T
    }
  )
)), ChevronDownIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      d: "M1.146 4.604l5.5 5.5a.5.5 0 00.708 0l5.5-5.5a.5.5 0 00-.708-.708L7 9.043 1.854 3.896a.5.5 0 10-.708.708z",
      fill: T
    }
  )
)), ChevronRightIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      d: "M11.104 7.354l-5.5 5.5a.5.5 0 01-.708-.708L10.043 7 4.896 1.854a.5.5 0 11.708-.708l5.5 5.5a.5.5 0 010 .708z",
      fill: T
    }
  )
)), ChevronSmallUpIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      d: "M3.854 9.104a.5.5 0 11-.708-.708l3.5-3.5a.5.5 0 01.708 0l3.5 3.5a.5.5 0 01-.708.708L7 5.957 3.854 9.104z",
      fill: T
    }
  )
)), ChevronSmallDownIcon = /* @__PURE__ */ React$1.forwardRef(({ color: T = "currentColor", size: S = 14, ...R }, k) => /* @__PURE__ */ React$1.createElement(
  "svg",
  {
    width: S,
    height: S,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: k,
    ...R
  },
  /* @__PURE__ */ React$1.createElement(
    "path",
    {
      d: "M3.854 4.896a.5.5 0 10-.708.708l3.5 3.5a.5.5 0 00.708 0l3.5-3.5a.5.5 0 00-.708-.708L7 8.043 3.854 4.896z",
      fill: T
    }
  )
));
function composeEventHandlers(T, S, { checkForDefaultPrevented: R = !0 } = {}) {
  return function(D) {
    if (T?.(D), R === !1 || !D.defaultPrevented)
      return S?.(D);
  };
}
function createContext2(T, S) {
  const R = React$1.createContext(S);
  function k(L) {
    const { children: V, ...z } = L, W = React$1.useMemo(() => z, Object.values(z));
    return /* @__PURE__ */ jsxRuntimeExports.jsx(R.Provider, { value: W, children: V });
  }
  function D(L) {
    const V = React$1.useContext(R);
    if (V) return V;
    if (S !== void 0) return S;
    throw new Error(`\`${L}\` must be used within \`${T}\``);
  }
  return k.displayName = T + "Provider", [k, D];
}
function createContextScope(T, S = []) {
  let R = [];
  function k(L, V) {
    const z = React$1.createContext(V), W = R.length;
    R = [...R, V];
    function U(K) {
      const { scope: Y, children: J, ...Z } = K, X = Y?.[T][W] || z, ee = React$1.useMemo(() => Z, Object.values(Z));
      return /* @__PURE__ */ jsxRuntimeExports.jsx(X.Provider, { value: ee, children: J });
    }
    function q(K, Y) {
      const J = Y?.[T][W] || z, Z = React$1.useContext(J);
      if (Z) return Z;
      if (V !== void 0) return V;
      throw new Error(`\`${K}\` must be used within \`${L}\``);
    }
    return U.displayName = L + "Provider", [U, q];
  }
  const D = () => {
    const L = R.map((V) => React$1.createContext(V));
    return function(z) {
      const W = z?.[T] || L;
      return React$1.useMemo(
        () => ({ [`__scope${T}`]: { ...z, [T]: W } }),
        [z, W]
      );
    };
  };
  return D.scopeName = T, [k, composeContextScopes(D, ...S)];
}
function composeContextScopes(...T) {
  const S = T[0];
  if (T.length === 1) return S;
  const R = () => {
    const k = T.map((D) => ({
      useScope: D(),
      scopeName: D.scopeName
    }));
    return function(L) {
      const V = k.reduce((z, { useScope: W, scopeName: U }) => {
        const K = W(L)[`__scope${U}`];
        return { ...z, ...K };
      }, {});
      return React$1.useMemo(() => ({ [`__scope${S.scopeName}`]: V }), [V]);
    };
  };
  return R.scopeName = S.scopeName, R;
}
var useLayoutEffect2 = globalThis?.document ? React$1.useLayoutEffect : () => {
}, useReactId = React$1.useId || (() => {
}), count$1 = 0;
function useId$1(T) {
  const [S, R] = React$1.useState(useReactId());
  return useLayoutEffect2(() => {
    T || R((k) => k ?? String(count$1++));
  }, [T]), T || (S ? `radix-${S}` : "");
}
function useCallbackRef$1(T) {
  const S = React$1.useRef(T);
  return React$1.useEffect(() => {
    S.current = T;
  }), React$1.useMemo(() => (...R) => S.current?.(...R), []);
}
function useControllableState({
  prop: T,
  defaultProp: S,
  onChange: R = () => {
  }
}) {
  const [k, D] = useUncontrolledState({ defaultProp: S, onChange: R }), L = T !== void 0, V = L ? T : k, z = useCallbackRef$1(R), W = React$1.useCallback(
    (U) => {
      if (L) {
        const K = typeof U == "function" ? U(T) : U;
        K !== T && z(K);
      } else
        D(U);
    },
    [L, T, D, z]
  );
  return [V, W];
}
function useUncontrolledState({
  defaultProp: T,
  onChange: S
}) {
  const R = React$1.useState(T), [k] = R, D = React$1.useRef(k), L = useCallbackRef$1(S);
  return React$1.useEffect(() => {
    D.current !== k && (L(k), D.current = k);
  }, [k, D, L]), R;
}
var NODES = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Primitive = NODES.reduce((T, S) => {
  const R = React$1.forwardRef((k, D) => {
    const { asChild: L, ...V } = k, z = L ? Slot : S;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ jsxRuntimeExports.jsx(z, { ...V, ref: D });
  });
  return R.displayName = `Primitive.${S}`, { ...T, [S]: R };
}, {});
function dispatchDiscreteCustomEvent(T, S) {
  T && ReactDOM.flushSync(() => T.dispatchEvent(S));
}
function useEscapeKeydown(T, S = globalThis?.document) {
  const R = useCallbackRef$1(T);
  React$1.useEffect(() => {
    const k = (D) => {
      D.key === "Escape" && R(D);
    };
    return S.addEventListener("keydown", k, { capture: !0 }), () => S.removeEventListener("keydown", k, { capture: !0 });
  }, [R, S]);
}
var DISMISSABLE_LAYER_NAME = "DismissableLayer", CONTEXT_UPDATE = "dismissableLayer.update", POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside", FOCUS_OUTSIDE = "dismissableLayer.focusOutside", originalBodyPointerEvents, DismissableLayerContext = React$1.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), DismissableLayer = React$1.forwardRef(
  (T, S) => {
    const {
      disableOutsidePointerEvents: R = !1,
      onEscapeKeyDown: k,
      onPointerDownOutside: D,
      onFocusOutside: L,
      onInteractOutside: V,
      onDismiss: z,
      ...W
    } = T, U = React$1.useContext(DismissableLayerContext), [q, K] = React$1.useState(null), Y = q?.ownerDocument ?? globalThis?.document, [, J] = React$1.useState({}), Z = useComposedRefs(S, (se) => K(se)), X = Array.from(U.layers), [ee] = [...U.layersWithOutsidePointerEventsDisabled].slice(-1), te = X.indexOf(ee), re = q ? X.indexOf(q) : -1, Q = U.layersWithOutsidePointerEventsDisabled.size > 0, ne = re >= te, oe = usePointerDownOutside((se) => {
      const ie = se.target, he = [...U.branches].some((xe) => xe.contains(ie));
      !ne || he || (D?.(se), V?.(se), se.defaultPrevented || z?.());
    }, Y), ae = useFocusOutside((se) => {
      const ie = se.target;
      [...U.branches].some((xe) => xe.contains(ie)) || (L?.(se), V?.(se), se.defaultPrevented || z?.());
    }, Y);
    return useEscapeKeydown((se) => {
      re === U.layers.size - 1 && (k?.(se), !se.defaultPrevented && z && (se.preventDefault(), z()));
    }, Y), React$1.useEffect(() => {
      if (q)
        return R && (U.layersWithOutsidePointerEventsDisabled.size === 0 && (originalBodyPointerEvents = Y.body.style.pointerEvents, Y.body.style.pointerEvents = "none"), U.layersWithOutsidePointerEventsDisabled.add(q)), U.layers.add(q), dispatchUpdate(), () => {
          R && U.layersWithOutsidePointerEventsDisabled.size === 1 && (Y.body.style.pointerEvents = originalBodyPointerEvents);
        };
    }, [q, Y, R, U]), React$1.useEffect(() => () => {
      q && (U.layers.delete(q), U.layersWithOutsidePointerEventsDisabled.delete(q), dispatchUpdate());
    }, [q, U]), React$1.useEffect(() => {
      const se = () => J({});
      return document.addEventListener(CONTEXT_UPDATE, se), () => document.removeEventListener(CONTEXT_UPDATE, se);
    }, []), /* @__PURE__ */ jsxRuntimeExports.jsx(
      Primitive.div,
      {
        ...W,
        ref: Z,
        style: {
          pointerEvents: Q ? ne ? "auto" : "none" : void 0,
          ...T.style
        },
        onFocusCapture: composeEventHandlers(T.onFocusCapture, ae.onFocusCapture),
        onBlurCapture: composeEventHandlers(T.onBlurCapture, ae.onBlurCapture),
        onPointerDownCapture: composeEventHandlers(
          T.onPointerDownCapture,
          oe.onPointerDownCapture
        )
      }
    );
  }
);
DismissableLayer.displayName = DISMISSABLE_LAYER_NAME;
var BRANCH_NAME = "DismissableLayerBranch", DismissableLayerBranch = React$1.forwardRef((T, S) => {
  const R = React$1.useContext(DismissableLayerContext), k = React$1.useRef(null), D = useComposedRefs(S, k);
  return React$1.useEffect(() => {
    const L = k.current;
    if (L)
      return R.branches.add(L), () => {
        R.branches.delete(L);
      };
  }, [R.branches]), /* @__PURE__ */ jsxRuntimeExports.jsx(Primitive.div, { ...T, ref: D });
});
DismissableLayerBranch.displayName = BRANCH_NAME;
function usePointerDownOutside(T, S = globalThis?.document) {
  const R = useCallbackRef$1(T), k = React$1.useRef(!1), D = React$1.useRef(() => {
  });
  return React$1.useEffect(() => {
    const L = (z) => {
      if (z.target && !k.current) {
        let W = function() {
          handleAndDispatchCustomEvent(
            POINTER_DOWN_OUTSIDE,
            R,
            U,
            { discrete: !0 }
          );
        };
        const U = { originalEvent: z };
        z.pointerType === "touch" ? (S.removeEventListener("click", D.current), D.current = W, S.addEventListener("click", D.current, { once: !0 })) : W();
      } else
        S.removeEventListener("click", D.current);
      k.current = !1;
    }, V = window.setTimeout(() => {
      S.addEventListener("pointerdown", L);
    }, 0);
    return () => {
      window.clearTimeout(V), S.removeEventListener("pointerdown", L), S.removeEventListener("click", D.current);
    };
  }, [S, R]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => k.current = !0
  };
}
function useFocusOutside(T, S = globalThis?.document) {
  const R = useCallbackRef$1(T), k = React$1.useRef(!1);
  return React$1.useEffect(() => {
    const D = (L) => {
      L.target && !k.current && handleAndDispatchCustomEvent(FOCUS_OUTSIDE, R, { originalEvent: L }, {
        discrete: !1
      });
    };
    return S.addEventListener("focusin", D), () => S.removeEventListener("focusin", D);
  }, [S, R]), {
    onFocusCapture: () => k.current = !0,
    onBlurCapture: () => k.current = !1
  };
}
function dispatchUpdate() {
  const T = new CustomEvent(CONTEXT_UPDATE);
  document.dispatchEvent(T);
}
function handleAndDispatchCustomEvent(T, S, R, { discrete: k }) {
  const D = R.originalEvent.target, L = new CustomEvent(T, { bubbles: !1, cancelable: !0, detail: R });
  S && D.addEventListener(T, S, { once: !0 }), k ? dispatchDiscreteCustomEvent(D, L) : D.dispatchEvent(L);
}
var AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount", AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount", EVENT_OPTIONS = { bubbles: !1, cancelable: !0 }, FOCUS_SCOPE_NAME = "FocusScope", FocusScope = React$1.forwardRef((T, S) => {
  const {
    loop: R = !1,
    trapped: k = !1,
    onMountAutoFocus: D,
    onUnmountAutoFocus: L,
    ...V
  } = T, [z, W] = React$1.useState(null), U = useCallbackRef$1(D), q = useCallbackRef$1(L), K = React$1.useRef(null), Y = useComposedRefs(S, (X) => W(X)), J = React$1.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  React$1.useEffect(() => {
    if (k) {
      let X = function(Q) {
        if (J.paused || !z) return;
        const ne = Q.target;
        z.contains(ne) ? K.current = ne : focus(K.current, { select: !0 });
      }, ee = function(Q) {
        if (J.paused || !z) return;
        const ne = Q.relatedTarget;
        ne !== null && (z.contains(ne) || focus(K.current, { select: !0 }));
      }, te = function(Q) {
        if (document.activeElement === document.body)
          for (const oe of Q)
            oe.removedNodes.length > 0 && focus(z);
      };
      document.addEventListener("focusin", X), document.addEventListener("focusout", ee);
      const re = new MutationObserver(te);
      return z && re.observe(z, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", X), document.removeEventListener("focusout", ee), re.disconnect();
      };
    }
  }, [k, z, J.paused]), React$1.useEffect(() => {
    if (z) {
      focusScopesStack.add(J);
      const X = document.activeElement;
      if (!z.contains(X)) {
        const te = new CustomEvent(AUTOFOCUS_ON_MOUNT, EVENT_OPTIONS);
        z.addEventListener(AUTOFOCUS_ON_MOUNT, U), z.dispatchEvent(te), te.defaultPrevented || (focusFirst(removeLinks(getTabbableCandidates(z)), { select: !0 }), document.activeElement === X && focus(z));
      }
      return () => {
        z.removeEventListener(AUTOFOCUS_ON_MOUNT, U), setTimeout(() => {
          const te = new CustomEvent(AUTOFOCUS_ON_UNMOUNT, EVENT_OPTIONS);
          z.addEventListener(AUTOFOCUS_ON_UNMOUNT, q), z.dispatchEvent(te), te.defaultPrevented || focus(X ?? document.body, { select: !0 }), z.removeEventListener(AUTOFOCUS_ON_UNMOUNT, q), focusScopesStack.remove(J);
        }, 0);
      };
    }
  }, [z, U, q, J]);
  const Z = React$1.useCallback(
    (X) => {
      if (!R && !k || J.paused) return;
      const ee = X.key === "Tab" && !X.altKey && !X.ctrlKey && !X.metaKey, te = document.activeElement;
      if (ee && te) {
        const re = X.currentTarget, [Q, ne] = getTabbableEdges(re);
        Q && ne ? !X.shiftKey && te === ne ? (X.preventDefault(), R && focus(Q, { select: !0 })) : X.shiftKey && te === Q && (X.preventDefault(), R && focus(ne, { select: !0 })) : te === re && X.preventDefault();
      }
    },
    [R, k, J.paused]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Primitive.div, { tabIndex: -1, ...V, ref: Y, onKeyDown: Z });
});
FocusScope.displayName = FOCUS_SCOPE_NAME;
function focusFirst(T, { select: S = !1 } = {}) {
  const R = document.activeElement;
  for (const k of T)
    if (focus(k, { select: S }), document.activeElement !== R) return;
}
function getTabbableEdges(T) {
  const S = getTabbableCandidates(T), R = findVisible(S, T), k = findVisible(S.reverse(), T);
  return [R, k];
}
function getTabbableCandidates(T) {
  const S = [], R = document.createTreeWalker(T, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (k) => {
      const D = k.tagName === "INPUT" && k.type === "hidden";
      return k.disabled || k.hidden || D ? NodeFilter.FILTER_SKIP : k.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; R.nextNode(); ) S.push(R.currentNode);
  return S;
}
function findVisible(T, S) {
  for (const R of T)
    if (!isHidden(R, { upTo: S })) return R;
}
function isHidden(T, { upTo: S }) {
  if (getComputedStyle(T).visibility === "hidden") return !0;
  for (; T; ) {
    if (S !== void 0 && T === S) return !1;
    if (getComputedStyle(T).display === "none") return !0;
    T = T.parentElement;
  }
  return !1;
}
function isSelectableInput(T) {
  return T instanceof HTMLInputElement && "select" in T;
}
function focus(T, { select: S = !1 } = {}) {
  if (T && T.focus) {
    const R = document.activeElement;
    T.focus({ preventScroll: !0 }), T !== R && isSelectableInput(T) && S && T.select();
  }
}
var focusScopesStack = createFocusScopesStack();
function createFocusScopesStack() {
  let T = [];
  return {
    add(S) {
      const R = T[0];
      S !== R && R?.pause(), T = arrayRemove(T, S), T.unshift(S);
    },
    remove(S) {
      T = arrayRemove(T, S), T[0]?.resume();
    }
  };
}
function arrayRemove(T, S) {
  const R = [...T], k = R.indexOf(S);
  return k !== -1 && R.splice(k, 1), R;
}
function removeLinks(T) {
  return T.filter((S) => S.tagName !== "A");
}
var PORTAL_NAME$1 = "Portal", Portal$2 = React$1.forwardRef((T, S) => {
  const { container: R, ...k } = T, [D, L] = React$1.useState(!1);
  useLayoutEffect2(() => L(!0), []);
  const V = R || D && globalThis?.document?.body;
  return V ? ReactDOM__default.createPortal(/* @__PURE__ */ jsxRuntimeExports.jsx(Primitive.div, { ...k, ref: S }), V) : null;
});
Portal$2.displayName = PORTAL_NAME$1;
function useStateMachine(T, S) {
  return React$1.useReducer((R, k) => S[R][k] ?? R, T);
}
var Presence = (T) => {
  const { present: S, children: R } = T, k = usePresence(S), D = typeof R == "function" ? R({ present: k.isPresent }) : React$1.Children.only(R), L = useComposedRefs(k.ref, getElementRef(D));
  return typeof R == "function" || k.isPresent ? React$1.cloneElement(D, { ref: L }) : null;
};
Presence.displayName = "Presence";
function usePresence(T) {
  const [S, R] = React$1.useState(), k = React$1.useRef({}), D = React$1.useRef(T), L = React$1.useRef("none"), V = T ? "mounted" : "unmounted", [z, W] = useStateMachine(V, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return React$1.useEffect(() => {
    const U = getAnimationName(k.current);
    L.current = z === "mounted" ? U : "none";
  }, [z]), useLayoutEffect2(() => {
    const U = k.current, q = D.current;
    if (q !== T) {
      const Y = L.current, J = getAnimationName(U);
      T ? W("MOUNT") : J === "none" || U?.display === "none" ? W("UNMOUNT") : W(q && Y !== J ? "ANIMATION_OUT" : "UNMOUNT"), D.current = T;
    }
  }, [T, W]), useLayoutEffect2(() => {
    if (S) {
      const U = (K) => {
        const J = getAnimationName(k.current).includes(K.animationName);
        K.target === S && J && ReactDOM.flushSync(() => W("ANIMATION_END"));
      }, q = (K) => {
        K.target === S && (L.current = getAnimationName(k.current));
      };
      return S.addEventListener("animationstart", q), S.addEventListener("animationcancel", U), S.addEventListener("animationend", U), () => {
        S.removeEventListener("animationstart", q), S.removeEventListener("animationcancel", U), S.removeEventListener("animationend", U);
      };
    } else
      W("ANIMATION_END");
  }, [S, W]), {
    isPresent: ["mounted", "unmountSuspended"].includes(z),
    ref: React$1.useCallback((U) => {
      U && (k.current = getComputedStyle(U)), R(U);
    }, [])
  };
}
function getAnimationName(T) {
  return T?.animationName || "none";
}
function getElementRef(T) {
  let S = Object.getOwnPropertyDescriptor(T.props, "ref")?.get, R = S && "isReactWarning" in S && S.isReactWarning;
  return R ? T.ref : (S = Object.getOwnPropertyDescriptor(T, "ref")?.get, R = S && "isReactWarning" in S && S.isReactWarning, R ? T.props.ref : T.props.ref || T.ref);
}
var count = 0;
function useFocusGuards() {
  React$1.useEffect(() => {
    const T = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", T[0] ?? createFocusGuard()), document.body.insertAdjacentElement("beforeend", T[1] ?? createFocusGuard()), count++, () => {
      count === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((S) => S.remove()), count--;
    };
  }, []);
}
function createFocusGuard() {
  const T = document.createElement("span");
  return T.setAttribute("data-radix-focus-guard", ""), T.tabIndex = 0, T.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", T;
}
var __assign$1 = function() {
  return __assign$1 = Object.assign || function(S) {
    for (var R, k = 1, D = arguments.length; k < D; k++) {
      R = arguments[k];
      for (var L in R) Object.prototype.hasOwnProperty.call(R, L) && (S[L] = R[L]);
    }
    return S;
  }, __assign$1.apply(this, arguments);
};
function __rest$1(T, S) {
  var R = {};
  for (var k in T) Object.prototype.hasOwnProperty.call(T, k) && S.indexOf(k) < 0 && (R[k] = T[k]);
  if (T != null && typeof Object.getOwnPropertySymbols == "function")
    for (var D = 0, k = Object.getOwnPropertySymbols(T); D < k.length; D++)
      S.indexOf(k[D]) < 0 && Object.prototype.propertyIsEnumerable.call(T, k[D]) && (R[k[D]] = T[k[D]]);
  return R;
}
function __spreadArray(T, S, R) {
  if (R || arguments.length === 2) for (var k = 0, D = S.length, L; k < D; k++)
    (L || !(k in S)) && (L || (L = Array.prototype.slice.call(S, 0, k)), L[k] = S[k]);
  return T.concat(L || Array.prototype.slice.call(S));
}
typeof SuppressedError == "function" && SuppressedError;
var zeroRightClassName = "right-scroll-bar-position", fullWidthClassName = "width-before-scroll-bar", noScrollbarsClassName = "with-scroll-bars-hidden", removedBarSizeVariable = "--removed-body-scroll-bar-size";
function assignRef(T, S) {
  return typeof T == "function" ? T(S) : T && (T.current = S), T;
}
function useCallbackRef(T, S) {
  var R = useState$1(function() {
    return {
      // value
      value: T,
      // last callback
      callback: S,
      // "memoized" public interface
      facade: {
        get current() {
          return R.value;
        },
        set current(k) {
          var D = R.value;
          D !== k && (R.value = k, R.callback(k, D));
        }
      }
    };
  })[0];
  return R.callback = S, R.facade;
}
var useIsomorphicLayoutEffect = typeof window < "u" ? React$1.useLayoutEffect : React$1.useEffect, currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(T, S) {
  var R = useCallbackRef(null, function(k) {
    return T.forEach(function(D) {
      return assignRef(D, k);
    });
  });
  return useIsomorphicLayoutEffect(function() {
    var k = currentValues.get(R);
    if (k) {
      var D = new Set(k), L = new Set(T), V = R.current;
      D.forEach(function(z) {
        L.has(z) || assignRef(z, null);
      }), L.forEach(function(z) {
        D.has(z) || assignRef(z, V);
      });
    }
    currentValues.set(R, T);
  }, [T]), R;
}
var __assign = function() {
  return __assign = Object.assign || function(S) {
    for (var R, k = 1, D = arguments.length; k < D; k++) {
      R = arguments[k];
      for (var L in R) Object.prototype.hasOwnProperty.call(R, L) && (S[L] = R[L]);
    }
    return S;
  }, __assign.apply(this, arguments);
};
function __rest(T, S) {
  var R = {};
  for (var k in T) Object.prototype.hasOwnProperty.call(T, k) && S.indexOf(k) < 0 && (R[k] = T[k]);
  if (T != null && typeof Object.getOwnPropertySymbols == "function")
    for (var D = 0, k = Object.getOwnPropertySymbols(T); D < k.length; D++)
      S.indexOf(k[D]) < 0 && Object.prototype.propertyIsEnumerable.call(T, k[D]) && (R[k[D]] = T[k[D]]);
  return R;
}
typeof SuppressedError == "function" && SuppressedError;
function ItoI(T) {
  return T;
}
function innerCreateMedium(T, S) {
  S === void 0 && (S = ItoI);
  var R = [], k = !1, D = {
    read: function() {
      if (k)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return R.length ? R[R.length - 1] : T;
    },
    useMedium: function(L) {
      var V = S(L, k);
      return R.push(V), function() {
        R = R.filter(function(z) {
          return z !== V;
        });
      };
    },
    assignSyncMedium: function(L) {
      for (k = !0; R.length; ) {
        var V = R;
        R = [], V.forEach(L);
      }
      R = {
        push: function(z) {
          return L(z);
        },
        filter: function() {
          return R;
        }
      };
    },
    assignMedium: function(L) {
      k = !0;
      var V = [];
      if (R.length) {
        var z = R;
        R = [], z.forEach(L), V = R;
      }
      var W = function() {
        var q = V;
        V = [], q.forEach(L);
      }, U = function() {
        return Promise.resolve().then(W);
      };
      U(), R = {
        push: function(q) {
          V.push(q), U();
        },
        filter: function(q) {
          return V = V.filter(q), R;
        }
      };
    }
  };
  return D;
}
function createSidecarMedium(T) {
  T === void 0 && (T = {});
  var S = innerCreateMedium(null);
  return S.options = __assign({ async: !0, ssr: !1 }, T), S;
}
var SideCar$1 = function(T) {
  var S = T.sideCar, R = __rest(T, ["sideCar"]);
  if (!S)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var k = S.read();
  if (!k)
    throw new Error("Sidecar medium not found");
  return React$1.createElement(k, __assign({}, R));
};
SideCar$1.isSideCarExport = !0;
function exportSidecar(T, S) {
  return T.useMedium(S), SideCar$1;
}
var effectCar = createSidecarMedium(), nothing = function() {
}, RemoveScroll = React$1.forwardRef(function(T, S) {
  var R = React$1.useRef(null), k = React$1.useState({
    onScrollCapture: nothing,
    onWheelCapture: nothing,
    onTouchMoveCapture: nothing
  }), D = k[0], L = k[1], V = T.forwardProps, z = T.children, W = T.className, U = T.removeScrollBar, q = T.enabled, K = T.shards, Y = T.sideCar, J = T.noIsolation, Z = T.inert, X = T.allowPinchZoom, ee = T.as, te = ee === void 0 ? "div" : ee, re = T.gapMode, Q = __rest$1(T, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), ne = Y, oe = useMergeRefs([R, S]), ae = __assign$1(__assign$1({}, Q), D);
  return React$1.createElement(
    React$1.Fragment,
    null,
    q && React$1.createElement(ne, { sideCar: effectCar, removeScrollBar: U, shards: K, noIsolation: J, inert: Z, setCallbacks: L, allowPinchZoom: !!X, lockRef: R, gapMode: re }),
    V ? React$1.cloneElement(React$1.Children.only(z), __assign$1(__assign$1({}, ae), { ref: oe })) : React$1.createElement(te, __assign$1({}, ae, { className: W, ref: oe }), z)
  );
});
RemoveScroll.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
RemoveScroll.classNames = {
  fullWidth: fullWidthClassName,
  zeroRight: zeroRightClassName
};
var getNonce = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function makeStyleTag() {
  if (!document)
    return null;
  var T = document.createElement("style");
  T.type = "text/css";
  var S = getNonce();
  return S && T.setAttribute("nonce", S), T;
}
function injectStyles(T, S) {
  T.styleSheet ? T.styleSheet.cssText = S : T.appendChild(document.createTextNode(S));
}
function insertStyleTag(T) {
  var S = document.head || document.getElementsByTagName("head")[0];
  S.appendChild(T);
}
var stylesheetSingleton = function() {
  var T = 0, S = null;
  return {
    add: function(R) {
      T == 0 && (S = makeStyleTag()) && (injectStyles(S, R), insertStyleTag(S)), T++;
    },
    remove: function() {
      T--, !T && S && (S.parentNode && S.parentNode.removeChild(S), S = null);
    }
  };
}, styleHookSingleton = function() {
  var T = stylesheetSingleton();
  return function(S, R) {
    React$1.useEffect(function() {
      return T.add(S), function() {
        T.remove();
      };
    }, [S && R]);
  };
}, styleSingleton = function() {
  var T = styleHookSingleton(), S = function(R) {
    var k = R.styles, D = R.dynamic;
    return T(k, D), null;
  };
  return S;
}, zeroGap = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, parse$1 = function(T) {
  return parseInt(T || "", 10) || 0;
}, getOffset = function(T) {
  var S = window.getComputedStyle(document.body), R = S[T === "padding" ? "paddingLeft" : "marginLeft"], k = S[T === "padding" ? "paddingTop" : "marginTop"], D = S[T === "padding" ? "paddingRight" : "marginRight"];
  return [parse$1(R), parse$1(k), parse$1(D)];
}, getGapWidth = function(T) {
  if (T === void 0 && (T = "margin"), typeof window > "u")
    return zeroGap;
  var S = getOffset(T), R = document.documentElement.clientWidth, k = window.innerWidth;
  return {
    left: S[0],
    top: S[1],
    right: S[2],
    gap: Math.max(0, k - R + S[2] - S[0])
  };
}, Style = styleSingleton(), lockAttribute = "data-scroll-locked", getStyles = function(T, S, R, k) {
  var D = T.left, L = T.top, V = T.right, z = T.gap;
  return R === void 0 && (R = "margin"), `
  .`.concat(noScrollbarsClassName, ` {
   overflow: hidden `).concat(k, `;
   padding-right: `).concat(z, "px ").concat(k, `;
  }
  body[`).concat(lockAttribute, `] {
    overflow: hidden `).concat(k, `;
    overscroll-behavior: contain;
    `).concat([
    S && "position: relative ".concat(k, ";"),
    R === "margin" && `
    padding-left: `.concat(D, `px;
    padding-top: `).concat(L, `px;
    padding-right: `).concat(V, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(z, "px ").concat(k, `;
    `),
    R === "padding" && "padding-right: ".concat(z, "px ").concat(k, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(zeroRightClassName, ` {
    right: `).concat(z, "px ").concat(k, `;
  }
  
  .`).concat(fullWidthClassName, ` {
    margin-right: `).concat(z, "px ").concat(k, `;
  }
  
  .`).concat(zeroRightClassName, " .").concat(zeroRightClassName, ` {
    right: 0 `).concat(k, `;
  }
  
  .`).concat(fullWidthClassName, " .").concat(fullWidthClassName, ` {
    margin-right: 0 `).concat(k, `;
  }
  
  body[`).concat(lockAttribute, `] {
    `).concat(removedBarSizeVariable, ": ").concat(z, `px;
  }
`);
}, getCurrentUseCounter = function() {
  var T = parseInt(document.body.getAttribute(lockAttribute) || "0", 10);
  return isFinite(T) ? T : 0;
}, useLockAttribute = function() {
  React$1.useEffect(function() {
    return document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString()), function() {
      var T = getCurrentUseCounter() - 1;
      T <= 0 ? document.body.removeAttribute(lockAttribute) : document.body.setAttribute(lockAttribute, T.toString());
    };
  }, []);
}, RemoveScrollBar = function(T) {
  var S = T.noRelative, R = T.noImportant, k = T.gapMode, D = k === void 0 ? "margin" : k;
  useLockAttribute();
  var L = React$1.useMemo(function() {
    return getGapWidth(D);
  }, [D]);
  return React$1.createElement(Style, { styles: getStyles(L, !S, D, R ? "" : "!important") });
}, passiveSupported = !1;
if (typeof window < "u")
  try {
    var options = Object.defineProperty({}, "passive", {
      get: function() {
        return passiveSupported = !0, !0;
      }
    });
    window.addEventListener("test", options, options), window.removeEventListener("test", options, options);
  } catch {
    passiveSupported = !1;
  }
var nonPassive = passiveSupported ? { passive: !1 } : !1, alwaysContainsScroll = function(T) {
  return T.tagName === "TEXTAREA";
}, elementCanBeScrolled = function(T, S) {
  var R = window.getComputedStyle(T);
  return (
    // not-not-scrollable
    R[S] !== "hidden" && // contains scroll inside self
    !(R.overflowY === R.overflowX && !alwaysContainsScroll(T) && R[S] === "visible")
  );
}, elementCouldBeVScrolled = function(T) {
  return elementCanBeScrolled(T, "overflowY");
}, elementCouldBeHScrolled = function(T) {
  return elementCanBeScrolled(T, "overflowX");
}, locationCouldBeScrolled = function(T, S) {
  var R = S.ownerDocument, k = S;
  do {
    typeof ShadowRoot < "u" && k instanceof ShadowRoot && (k = k.host);
    var D = elementCouldBeScrolled(T, k);
    if (D) {
      var L = getScrollVariables(T, k), V = L[1], z = L[2];
      if (V > z)
        return !0;
    }
    k = k.parentNode;
  } while (k && k !== R.body);
  return !1;
}, getVScrollVariables = function(T) {
  var S = T.scrollTop, R = T.scrollHeight, k = T.clientHeight;
  return [
    S,
    R,
    k
  ];
}, getHScrollVariables = function(T) {
  var S = T.scrollLeft, R = T.scrollWidth, k = T.clientWidth;
  return [
    S,
    R,
    k
  ];
}, elementCouldBeScrolled = function(T, S) {
  return T === "v" ? elementCouldBeVScrolled(S) : elementCouldBeHScrolled(S);
}, getScrollVariables = function(T, S) {
  return T === "v" ? getVScrollVariables(S) : getHScrollVariables(S);
}, getDirectionFactor = function(T, S) {
  return T === "h" && S === "rtl" ? -1 : 1;
}, handleScroll = function(T, S, R, k, D) {
  var L = getDirectionFactor(T, window.getComputedStyle(S).direction), V = L * k, z = R.target, W = S.contains(z), U = !1, q = V > 0, K = 0, Y = 0;
  do {
    var J = getScrollVariables(T, z), Z = J[0], X = J[1], ee = J[2], te = X - ee - L * Z;
    (Z || te) && elementCouldBeScrolled(T, z) && (K += te, Y += Z), z instanceof ShadowRoot ? z = z.host : z = z.parentNode;
  } while (
    // portaled content
    !W && z !== document.body || // self content
    W && (S.contains(z) || S === z)
  );
  return (q && (Math.abs(K) < 1 || !D) || !q && (Math.abs(Y) < 1 || !D)) && (U = !0), U;
}, getTouchXY = function(T) {
  return "changedTouches" in T ? [T.changedTouches[0].clientX, T.changedTouches[0].clientY] : [0, 0];
}, getDeltaXY = function(T) {
  return [T.deltaX, T.deltaY];
}, extractRef = function(T) {
  return T && "current" in T ? T.current : T;
}, deltaCompare = function(T, S) {
  return T[0] === S[0] && T[1] === S[1];
}, generateStyle = function(T) {
  return `
  .block-interactivity-`.concat(T, ` {pointer-events: none;}
  .allow-interactivity-`).concat(T, ` {pointer-events: all;}
`);
}, idCounter = 0, lockStack = [];
function RemoveScrollSideCar(T) {
  var S = React$1.useRef([]), R = React$1.useRef([0, 0]), k = React$1.useRef(), D = React$1.useState(idCounter++)[0], L = React$1.useState(styleSingleton)[0], V = React$1.useRef(T);
  React$1.useEffect(function() {
    V.current = T;
  }, [T]), React$1.useEffect(function() {
    if (T.inert) {
      document.body.classList.add("block-interactivity-".concat(D));
      var X = __spreadArray([T.lockRef.current], (T.shards || []).map(extractRef), !0).filter(Boolean);
      return X.forEach(function(ee) {
        return ee.classList.add("allow-interactivity-".concat(D));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(D)), X.forEach(function(ee) {
          return ee.classList.remove("allow-interactivity-".concat(D));
        });
      };
    }
  }, [T.inert, T.lockRef.current, T.shards]);
  var z = React$1.useCallback(function(X, ee) {
    if ("touches" in X && X.touches.length === 2)
      return !V.current.allowPinchZoom;
    var te = getTouchXY(X), re = R.current, Q = "deltaX" in X ? X.deltaX : re[0] - te[0], ne = "deltaY" in X ? X.deltaY : re[1] - te[1], oe, ae = X.target, se = Math.abs(Q) > Math.abs(ne) ? "h" : "v";
    if ("touches" in X && se === "h" && ae.type === "range")
      return !1;
    var ie = locationCouldBeScrolled(se, ae);
    if (!ie)
      return !0;
    if (ie ? oe = se : (oe = se === "v" ? "h" : "v", ie = locationCouldBeScrolled(se, ae)), !ie)
      return !1;
    if (!k.current && "changedTouches" in X && (Q || ne) && (k.current = oe), !oe)
      return !0;
    var he = k.current || oe;
    return handleScroll(he, ee, X, he === "h" ? Q : ne, !0);
  }, []), W = React$1.useCallback(function(X) {
    var ee = X;
    if (!(!lockStack.length || lockStack[lockStack.length - 1] !== L)) {
      var te = "deltaY" in ee ? getDeltaXY(ee) : getTouchXY(ee), re = S.current.filter(function(oe) {
        return oe.name === ee.type && (oe.target === ee.target || ee.target === oe.shadowParent) && deltaCompare(oe.delta, te);
      })[0];
      if (re && re.should) {
        ee.cancelable && ee.preventDefault();
        return;
      }
      if (!re) {
        var Q = (V.current.shards || []).map(extractRef).filter(Boolean).filter(function(oe) {
          return oe.contains(ee.target);
        }), ne = Q.length > 0 ? z(ee, Q[0]) : !V.current.noIsolation;
        ne && ee.cancelable && ee.preventDefault();
      }
    }
  }, []), U = React$1.useCallback(function(X, ee, te, re) {
    var Q = { name: X, delta: ee, target: te, should: re, shadowParent: getOutermostShadowParent(te) };
    S.current.push(Q), setTimeout(function() {
      S.current = S.current.filter(function(ne) {
        return ne !== Q;
      });
    }, 1);
  }, []), q = React$1.useCallback(function(X) {
    R.current = getTouchXY(X), k.current = void 0;
  }, []), K = React$1.useCallback(function(X) {
    U(X.type, getDeltaXY(X), X.target, z(X, T.lockRef.current));
  }, []), Y = React$1.useCallback(function(X) {
    U(X.type, getTouchXY(X), X.target, z(X, T.lockRef.current));
  }, []);
  React$1.useEffect(function() {
    return lockStack.push(L), T.setCallbacks({
      onScrollCapture: K,
      onWheelCapture: K,
      onTouchMoveCapture: Y
    }), document.addEventListener("wheel", W, nonPassive), document.addEventListener("touchmove", W, nonPassive), document.addEventListener("touchstart", q, nonPassive), function() {
      lockStack = lockStack.filter(function(X) {
        return X !== L;
      }), document.removeEventListener("wheel", W, nonPassive), document.removeEventListener("touchmove", W, nonPassive), document.removeEventListener("touchstart", q, nonPassive);
    };
  }, []);
  var J = T.removeScrollBar, Z = T.inert;
  return React$1.createElement(
    React$1.Fragment,
    null,
    Z ? React$1.createElement(L, { styles: generateStyle(D) }) : null,
    J ? React$1.createElement(RemoveScrollBar, { gapMode: T.gapMode }) : null
  );
}
function getOutermostShadowParent(T) {
  for (var S = null; T !== null; )
    T instanceof ShadowRoot && (S = T.host, T = T.host), T = T.parentNode;
  return S;
}
const SideCar = exportSidecar(effectCar, RemoveScrollSideCar);
var ReactRemoveScroll = React$1.forwardRef(function(T, S) {
  return React$1.createElement(RemoveScroll, __assign$1({}, T, { ref: S, sideCar: SideCar }));
});
ReactRemoveScroll.classNames = RemoveScroll.classNames;
var getDefaultParent = function(T) {
  if (typeof document > "u")
    return null;
  var S = Array.isArray(T) ? T[0] : T;
  return S.ownerDocument.body;
}, counterMap = /* @__PURE__ */ new WeakMap(), uncontrolledNodes = /* @__PURE__ */ new WeakMap(), markerMap = {}, lockCount = 0, unwrapHost = function(T) {
  return T && (T.host || unwrapHost(T.parentNode));
}, correctTargets = function(T, S) {
  return S.map(function(R) {
    if (T.contains(R))
      return R;
    var k = unwrapHost(R);
    return k && T.contains(k) ? k : (console.error("aria-hidden", R, "in not contained inside", T, ". Doing nothing"), null);
  }).filter(function(R) {
    return !!R;
  });
}, applyAttributeToOthers = function(T, S, R, k) {
  var D = correctTargets(S, Array.isArray(T) ? T : [T]);
  markerMap[R] || (markerMap[R] = /* @__PURE__ */ new WeakMap());
  var L = markerMap[R], V = [], z = /* @__PURE__ */ new Set(), W = new Set(D), U = function(K) {
    !K || z.has(K) || (z.add(K), U(K.parentNode));
  };
  D.forEach(U);
  var q = function(K) {
    !K || W.has(K) || Array.prototype.forEach.call(K.children, function(Y) {
      if (z.has(Y))
        q(Y);
      else
        try {
          var J = Y.getAttribute(k), Z = J !== null && J !== "false", X = (counterMap.get(Y) || 0) + 1, ee = (L.get(Y) || 0) + 1;
          counterMap.set(Y, X), L.set(Y, ee), V.push(Y), X === 1 && Z && uncontrolledNodes.set(Y, !0), ee === 1 && Y.setAttribute(R, "true"), Z || Y.setAttribute(k, "true");
        } catch (te) {
          console.error("aria-hidden: cannot operate on ", Y, te);
        }
    });
  };
  return q(S), z.clear(), lockCount++, function() {
    V.forEach(function(K) {
      var Y = counterMap.get(K) - 1, J = L.get(K) - 1;
      counterMap.set(K, Y), L.set(K, J), Y || (uncontrolledNodes.has(K) || K.removeAttribute(k), uncontrolledNodes.delete(K)), J || K.removeAttribute(R);
    }), lockCount--, lockCount || (counterMap = /* @__PURE__ */ new WeakMap(), counterMap = /* @__PURE__ */ new WeakMap(), uncontrolledNodes = /* @__PURE__ */ new WeakMap(), markerMap = {});
  };
}, hideOthers = function(T, S, R) {
  R === void 0 && (R = "data-aria-hidden");
  var k = Array.from(Array.isArray(T) ? T : [T]), D = getDefaultParent(T);
  return D ? (k.push.apply(k, Array.from(D.querySelectorAll("[aria-live]"))), applyAttributeToOthers(k, D, R, "aria-hidden")) : function() {
    return null;
  };
}, DIALOG_NAME = "Dialog", [createDialogContext, createDialogScope] = createContextScope(DIALOG_NAME), [DialogProvider, useDialogContext] = createDialogContext(DIALOG_NAME), Dialog$1 = (T) => {
  const {
    __scopeDialog: S,
    children: R,
    open: k,
    defaultOpen: D,
    onOpenChange: L,
    modal: V = !0
  } = T, z = React$1.useRef(null), W = React$1.useRef(null), [U = !1, q] = useControllableState({
    prop: k,
    defaultProp: D,
    onChange: L
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    DialogProvider,
    {
      scope: S,
      triggerRef: z,
      contentRef: W,
      contentId: useId$1(),
      titleId: useId$1(),
      descriptionId: useId$1(),
      open: U,
      onOpenChange: q,
      onOpenToggle: React$1.useCallback(() => q((K) => !K), [q]),
      modal: V,
      children: R
    }
  );
};
Dialog$1.displayName = DIALOG_NAME;
var TRIGGER_NAME = "DialogTrigger", DialogTrigger = React$1.forwardRef(
  (T, S) => {
    const { __scopeDialog: R, ...k } = T, D = useDialogContext(TRIGGER_NAME, R), L = useComposedRefs(S, D.triggerRef);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Primitive.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": D.open,
        "aria-controls": D.contentId,
        "data-state": getState(D.open),
        ...k,
        ref: L,
        onClick: composeEventHandlers(T.onClick, D.onOpenToggle)
      }
    );
  }
);
DialogTrigger.displayName = TRIGGER_NAME;
var PORTAL_NAME = "DialogPortal", [PortalProvider, usePortalContext] = createDialogContext(PORTAL_NAME, {
  forceMount: void 0
}), DialogPortal = (T) => {
  const { __scopeDialog: S, forceMount: R, children: k, container: D } = T, L = useDialogContext(PORTAL_NAME, S);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PortalProvider, { scope: S, forceMount: R, children: React$1.Children.map(k, (V) => /* @__PURE__ */ jsxRuntimeExports.jsx(Presence, { present: R || L.open, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Portal$2, { asChild: !0, container: D, children: V }) })) });
};
DialogPortal.displayName = PORTAL_NAME;
var OVERLAY_NAME = "DialogOverlay", DialogOverlay = React$1.forwardRef(
  (T, S) => {
    const R = usePortalContext(OVERLAY_NAME, T.__scopeDialog), { forceMount: k = R.forceMount, ...D } = T, L = useDialogContext(OVERLAY_NAME, T.__scopeDialog);
    return L.modal ? /* @__PURE__ */ jsxRuntimeExports.jsx(Presence, { present: k || L.open, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogOverlayImpl, { ...D, ref: S }) }) : null;
  }
);
DialogOverlay.displayName = OVERLAY_NAME;
var DialogOverlayImpl = React$1.forwardRef(
  (T, S) => {
    const { __scopeDialog: R, ...k } = T, D = useDialogContext(OVERLAY_NAME, R);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ jsxRuntimeExports.jsx(ReactRemoveScroll, { as: Slot, allowPinchZoom: !0, shards: [D.contentRef], children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Primitive.div,
        {
          "data-state": getState(D.open),
          ...k,
          ref: S,
          style: { pointerEvents: "auto", ...k.style }
        }
      ) })
    );
  }
), CONTENT_NAME = "DialogContent", DialogContent$1 = React$1.forwardRef(
  (T, S) => {
    const R = usePortalContext(CONTENT_NAME, T.__scopeDialog), { forceMount: k = R.forceMount, ...D } = T, L = useDialogContext(CONTENT_NAME, T.__scopeDialog);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Presence, { present: k || L.open, children: L.modal ? /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContentModal, { ...D, ref: S }) : /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContentNonModal, { ...D, ref: S }) });
  }
);
DialogContent$1.displayName = CONTENT_NAME;
var DialogContentModal = React$1.forwardRef(
  (T, S) => {
    const R = useDialogContext(CONTENT_NAME, T.__scopeDialog), k = React$1.useRef(null), D = useComposedRefs(S, R.contentRef, k);
    return React$1.useEffect(() => {
      const L = k.current;
      if (L) return hideOthers(L);
    }, []), /* @__PURE__ */ jsxRuntimeExports.jsx(
      DialogContentImpl,
      {
        ...T,
        ref: D,
        trapFocus: R.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: composeEventHandlers(T.onCloseAutoFocus, (L) => {
          L.preventDefault(), R.triggerRef.current?.focus();
        }),
        onPointerDownOutside: composeEventHandlers(T.onPointerDownOutside, (L) => {
          const V = L.detail.originalEvent, z = V.button === 0 && V.ctrlKey === !0;
          (V.button === 2 || z) && L.preventDefault();
        }),
        onFocusOutside: composeEventHandlers(
          T.onFocusOutside,
          (L) => L.preventDefault()
        )
      }
    );
  }
), DialogContentNonModal = React$1.forwardRef(
  (T, S) => {
    const R = useDialogContext(CONTENT_NAME, T.__scopeDialog), k = React$1.useRef(!1), D = React$1.useRef(!1);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      DialogContentImpl,
      {
        ...T,
        ref: S,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (L) => {
          T.onCloseAutoFocus?.(L), L.defaultPrevented || (k.current || R.triggerRef.current?.focus(), L.preventDefault()), k.current = !1, D.current = !1;
        },
        onInteractOutside: (L) => {
          T.onInteractOutside?.(L), L.defaultPrevented || (k.current = !0, L.detail.originalEvent.type === "pointerdown" && (D.current = !0));
          const V = L.target;
          R.triggerRef.current?.contains(V) && L.preventDefault(), L.detail.originalEvent.type === "focusin" && D.current && L.preventDefault();
        }
      }
    );
  }
), DialogContentImpl = React$1.forwardRef(
  (T, S) => {
    const { __scopeDialog: R, trapFocus: k, onOpenAutoFocus: D, onCloseAutoFocus: L, ...V } = T, z = useDialogContext(CONTENT_NAME, R), W = React$1.useRef(null), U = useComposedRefs(S, W);
    return useFocusGuards(), /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        FocusScope,
        {
          asChild: !0,
          loop: !0,
          trapped: k,
          onMountAutoFocus: D,
          onUnmountAutoFocus: L,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            DismissableLayer,
            {
              role: "dialog",
              id: z.contentId,
              "aria-describedby": z.descriptionId,
              "aria-labelledby": z.titleId,
              "data-state": getState(z.open),
              ...V,
              ref: U,
              onDismiss: () => z.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(TitleWarning, { titleId: z.titleId }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DescriptionWarning, { contentRef: W, descriptionId: z.descriptionId })
      ] })
    ] });
  }
), TITLE_NAME = "DialogTitle", DialogTitle = React$1.forwardRef(
  (T, S) => {
    const { __scopeDialog: R, ...k } = T, D = useDialogContext(TITLE_NAME, R);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Primitive.h2, { id: D.titleId, ...k, ref: S });
  }
);
DialogTitle.displayName = TITLE_NAME;
var DESCRIPTION_NAME = "DialogDescription", DialogDescription = React$1.forwardRef(
  (T, S) => {
    const { __scopeDialog: R, ...k } = T, D = useDialogContext(DESCRIPTION_NAME, R);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Primitive.p, { id: D.descriptionId, ...k, ref: S });
  }
);
DialogDescription.displayName = DESCRIPTION_NAME;
var CLOSE_NAME = "DialogClose", DialogClose = React$1.forwardRef(
  (T, S) => {
    const { __scopeDialog: R, ...k } = T, D = useDialogContext(CLOSE_NAME, R);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Primitive.button,
      {
        type: "button",
        ...k,
        ref: S,
        onClick: composeEventHandlers(T.onClick, () => D.onOpenChange(!1))
      }
    );
  }
);
DialogClose.displayName = CLOSE_NAME;
function getState(T) {
  return T ? "open" : "closed";
}
var TITLE_WARNING_NAME = "DialogTitleWarning", [WarningProvider, useWarningContext] = createContext2(TITLE_WARNING_NAME, {
  contentName: CONTENT_NAME,
  titleName: TITLE_NAME,
  docsSlug: "dialog"
}), TitleWarning = ({ titleId: T }) => {
  const S = useWarningContext(TITLE_WARNING_NAME), R = `\`${S.contentName}\` requires a \`${S.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${S.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${S.docsSlug}`;
  return React$1.useEffect(() => {
    T && (document.getElementById(T) || console.error(R));
  }, [R, T]), null;
}, DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning", DescriptionWarning = ({ contentRef: T, descriptionId: S }) => {
  const k = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${useWarningContext(DESCRIPTION_WARNING_NAME).contentName}}.`;
  return React$1.useEffect(() => {
    const D = T.current?.getAttribute("aria-describedby");
    S && D && (document.getElementById(S) || console.warn(k));
  }, [k, T, S]), null;
}, Root = Dialog$1, Trigger = DialogTrigger, Portal$1 = DialogPortal, Overlay$1 = DialogOverlay, Content$3 = DialogContent$1, Title = DialogTitle, Description = DialogDescription, Close = DialogClose;
const Dialog2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Close,
  Content: Content$3,
  Description,
  Dialog: Dialog$1,
  DialogClose,
  DialogContent: DialogContent$1,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
  Overlay: Overlay$1,
  Portal: Portal$1,
  Root,
  Title,
  Trigger,
  WarningProvider,
  createDialogScope
}, Symbol.toStringTag, { value: "Module" }));
var nameSpaceClassNames = ({ ...T }, S) => {
  let R = [T.class, T.className];
  return delete T.class, T.className = ["sbdocs", `sbdocs-${S}`, ...R].filter(Boolean).join(" "), T;
};
function _assertThisInitialized$1(T) {
  if (T === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return T;
}
function _setPrototypeOf$1(T, S) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(R, k) {
    return R.__proto__ = k, R;
  }, _setPrototypeOf$1(T, S);
}
function _inheritsLoose$1(T, S) {
  T.prototype = Object.create(S.prototype), T.prototype.constructor = T, _setPrototypeOf$1(T, S);
}
function _getPrototypeOf$1(T) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(S) {
    return S.__proto__ || Object.getPrototypeOf(S);
  }, _getPrototypeOf$1(T);
}
function _isNativeFunction$1(T) {
  try {
    return Function.toString.call(T).indexOf("[native code]") !== -1;
  } catch {
    return typeof T == "function";
  }
}
function _isNativeReflectConstruct$1() {
  try {
    var T = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$1 = function() {
    return !!T;
  })();
}
function _construct$1(T, S, R) {
  if (_isNativeReflectConstruct$1()) return Reflect.construct.apply(null, arguments);
  var k = [null];
  k.push.apply(k, S);
  var D = new (T.bind.apply(T, k))();
  return R && _setPrototypeOf$1(D, R.prototype), D;
}
function _wrapNativeSuper$1(T) {
  var S = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper$1 = function(R) {
    if (R === null || !_isNativeFunction$1(R)) return R;
    if (typeof R != "function") throw new TypeError("Super expression must either be null or a function");
    if (typeof S < "u") {
      if (S.has(R)) return S.get(R);
      S.set(R, k);
    }
    function k() {
      return _construct$1(R, arguments, _getPrototypeOf$1(this).constructor);
    }
    return k.prototype = Object.create(R.prototype, { constructor: { value: k, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf$1(k, R);
  }, _wrapNativeSuper$1(T);
}
var ERRORS$1 = { 1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`, 2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`, 3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`, 4: `Couldn't generate valid rgb string from %s, it returned %s.

`, 5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`, 6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`, 7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`, 8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`, 9: `Please provide a number of steps to the modularScale helper.

`, 10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`, 11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`, 12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`, 13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`, 14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`, 15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`, 16: `You must provide a template to this method.

`, 17: `You passed an unsupported selector state to this method.

`, 18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`, 19: `fromSize and toSize must be provided as stringified numbers with the same units.

`, 20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`, 21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n", 22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n", 23: `fontFace expects a name of a font-family.

`, 24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`, 25: `fontFace expects localFonts to be an array.

`, 26: `fontFace expects fileFormats to be an array.

`, 27: `radialGradient requries at least 2 color-stops to properly render.

`, 28: `Please supply a filename to retinaImage() as the first argument.

`, 29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`, 30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n", 31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`, 32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`, 33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`, 34: `borderRadius expects a radius value as a string or number as the second argument.

`, 35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`, 36: `Property must be a string value.

`, 37: `Syntax Error at %s.

`, 38: `Formula contains a function that needs parentheses at %s.

`, 39: `Formula is missing closing parenthesis at %s.

`, 40: `Formula has too many closing parentheses at %s.

`, 41: `All values in a formula must have the same unit or be unitless.

`, 42: `Please provide a number of steps to the modularScale helper.

`, 43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`, 44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`, 45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`, 46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`, 47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`, 48: `fromSize and toSize must be provided as stringified numbers with the same units.

`, 49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`, 50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`, 51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`, 52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`, 53: `fontFace expects localFonts to be an array.

`, 54: `fontFace expects fileFormats to be an array.

`, 55: `fontFace expects a name of a font-family.

`, 56: `linearGradient requries at least 2 color-stops to properly render.

`, 57: `radialGradient requries at least 2 color-stops to properly render.

`, 58: `Please supply a filename to retinaImage() as the first argument.

`, 59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`, 60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n", 61: `Property must be a string value.

`, 62: `borderRadius expects a radius value as a string or number as the second argument.

`, 63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`, 64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`, 65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`, 66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`, 67: `You must provide a template to this method.

`, 68: `You passed an unsupported selector state to this method.

`, 69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`, 70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`, 71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`, 72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`, 73: `Please provide a valid CSS variable.

`, 74: `CSS variable not found and no default was provided.

`, 75: `important requires a valid style object, got a %s instead.

`, 76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`, 77: `remToPx expects a value in "rem" but you provided it in "%s".

`, 78: `base must be set in "px" or "%" but you set it in "%s".
` };
function format$1() {
  for (var T = arguments.length, S = new Array(T), R = 0; R < T; R++) S[R] = arguments[R];
  var k = S[0], D = [], L;
  for (L = 1; L < S.length; L += 1) D.push(S[L]);
  return D.forEach(function(V) {
    k = k.replace(/%[a-z]/, V);
  }), k;
}
var PolishedError$1 = function(T) {
  _inheritsLoose$1(S, T);
  function S(R) {
    for (var k, D = arguments.length, L = new Array(D > 1 ? D - 1 : 0), V = 1; V < D; V++) L[V - 1] = arguments[V];
    return k = T.call(this, format$1.apply(void 0, [ERRORS$1[R]].concat(L))) || this, _assertThisInitialized$1(k);
  }
  return S;
}(_wrapNativeSuper$1(Error));
function colorToInt$1(T) {
  return Math.round(T * 255);
}
function convertToInt$1(T, S, R) {
  return colorToInt$1(T) + "," + colorToInt$1(S) + "," + colorToInt$1(R);
}
function hslToRgb$2(T, S, R, k) {
  if (k === void 0 && (k = convertToInt$1), S === 0) return k(R, R, R);
  var D = (T % 360 + 360) % 360 / 60, L = (1 - Math.abs(2 * R - 1)) * S, V = L * (1 - Math.abs(D % 2 - 1)), z = 0, W = 0, U = 0;
  D >= 0 && D < 1 ? (z = L, W = V) : D >= 1 && D < 2 ? (z = V, W = L) : D >= 2 && D < 3 ? (W = L, U = V) : D >= 3 && D < 4 ? (W = V, U = L) : D >= 4 && D < 5 ? (z = V, U = L) : D >= 5 && D < 6 && (z = L, U = V);
  var q = R - L / 2, K = z + q, Y = W + q, J = U + q;
  return k(K, Y, J);
}
var namedColorMap$1 = { aliceblue: "f0f8ff", antiquewhite: "faebd7", aqua: "00ffff", aquamarine: "7fffd4", azure: "f0ffff", beige: "f5f5dc", bisque: "ffe4c4", black: "000", blanchedalmond: "ffebcd", blue: "0000ff", blueviolet: "8a2be2", brown: "a52a2a", burlywood: "deb887", cadetblue: "5f9ea0", chartreuse: "7fff00", chocolate: "d2691e", coral: "ff7f50", cornflowerblue: "6495ed", cornsilk: "fff8dc", crimson: "dc143c", cyan: "00ffff", darkblue: "00008b", darkcyan: "008b8b", darkgoldenrod: "b8860b", darkgray: "a9a9a9", darkgreen: "006400", darkgrey: "a9a9a9", darkkhaki: "bdb76b", darkmagenta: "8b008b", darkolivegreen: "556b2f", darkorange: "ff8c00", darkorchid: "9932cc", darkred: "8b0000", darksalmon: "e9967a", darkseagreen: "8fbc8f", darkslateblue: "483d8b", darkslategray: "2f4f4f", darkslategrey: "2f4f4f", darkturquoise: "00ced1", darkviolet: "9400d3", deeppink: "ff1493", deepskyblue: "00bfff", dimgray: "696969", dimgrey: "696969", dodgerblue: "1e90ff", firebrick: "b22222", floralwhite: "fffaf0", forestgreen: "228b22", fuchsia: "ff00ff", gainsboro: "dcdcdc", ghostwhite: "f8f8ff", gold: "ffd700", goldenrod: "daa520", gray: "808080", green: "008000", greenyellow: "adff2f", grey: "808080", honeydew: "f0fff0", hotpink: "ff69b4", indianred: "cd5c5c", indigo: "4b0082", ivory: "fffff0", khaki: "f0e68c", lavender: "e6e6fa", lavenderblush: "fff0f5", lawngreen: "7cfc00", lemonchiffon: "fffacd", lightblue: "add8e6", lightcoral: "f08080", lightcyan: "e0ffff", lightgoldenrodyellow: "fafad2", lightgray: "d3d3d3", lightgreen: "90ee90", lightgrey: "d3d3d3", lightpink: "ffb6c1", lightsalmon: "ffa07a", lightseagreen: "20b2aa", lightskyblue: "87cefa", lightslategray: "789", lightslategrey: "789", lightsteelblue: "b0c4de", lightyellow: "ffffe0", lime: "0f0", limegreen: "32cd32", linen: "faf0e6", magenta: "f0f", maroon: "800000", mediumaquamarine: "66cdaa", mediumblue: "0000cd", mediumorchid: "ba55d3", mediumpurple: "9370db", mediumseagreen: "3cb371", mediumslateblue: "7b68ee", mediumspringgreen: "00fa9a", mediumturquoise: "48d1cc", mediumvioletred: "c71585", midnightblue: "191970", mintcream: "f5fffa", mistyrose: "ffe4e1", moccasin: "ffe4b5", navajowhite: "ffdead", navy: "000080", oldlace: "fdf5e6", olive: "808000", olivedrab: "6b8e23", orange: "ffa500", orangered: "ff4500", orchid: "da70d6", palegoldenrod: "eee8aa", palegreen: "98fb98", paleturquoise: "afeeee", palevioletred: "db7093", papayawhip: "ffefd5", peachpuff: "ffdab9", peru: "cd853f", pink: "ffc0cb", plum: "dda0dd", powderblue: "b0e0e6", purple: "800080", rebeccapurple: "639", red: "f00", rosybrown: "bc8f8f", royalblue: "4169e1", saddlebrown: "8b4513", salmon: "fa8072", sandybrown: "f4a460", seagreen: "2e8b57", seashell: "fff5ee", sienna: "a0522d", silver: "c0c0c0", skyblue: "87ceeb", slateblue: "6a5acd", slategray: "708090", slategrey: "708090", snow: "fffafa", springgreen: "00ff7f", steelblue: "4682b4", tan: "d2b48c", teal: "008080", thistle: "d8bfd8", tomato: "ff6347", turquoise: "40e0d0", violet: "ee82ee", wheat: "f5deb3", white: "fff", whitesmoke: "f5f5f5", yellow: "ff0", yellowgreen: "9acd32" };
function nameToHex$1(T) {
  if (typeof T != "string") return T;
  var S = T.toLowerCase();
  return namedColorMap$1[S] ? "#" + namedColorMap$1[S] : T;
}
var hexRegex$1 = /^#[a-fA-F0-9]{6}$/, hexRgbaRegex$1 = /^#[a-fA-F0-9]{8}$/, reducedHexRegex$1 = /^#[a-fA-F0-9]{3}$/, reducedRgbaHexRegex$1 = /^#[a-fA-F0-9]{4}$/, rgbRegex$1 = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, rgbaRegex$1 = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, hslRegex$1 = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, hslaRegex$1 = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function parseToRgb$1(T) {
  if (typeof T != "string") throw new PolishedError$1(3);
  var S = nameToHex$1(T);
  if (S.match(hexRegex$1)) return { red: parseInt("" + S[1] + S[2], 16), green: parseInt("" + S[3] + S[4], 16), blue: parseInt("" + S[5] + S[6], 16) };
  if (S.match(hexRgbaRegex$1)) {
    var R = parseFloat((parseInt("" + S[7] + S[8], 16) / 255).toFixed(2));
    return { red: parseInt("" + S[1] + S[2], 16), green: parseInt("" + S[3] + S[4], 16), blue: parseInt("" + S[5] + S[6], 16), alpha: R };
  }
  if (S.match(reducedHexRegex$1)) return { red: parseInt("" + S[1] + S[1], 16), green: parseInt("" + S[2] + S[2], 16), blue: parseInt("" + S[3] + S[3], 16) };
  if (S.match(reducedRgbaHexRegex$1)) {
    var k = parseFloat((parseInt("" + S[4] + S[4], 16) / 255).toFixed(2));
    return { red: parseInt("" + S[1] + S[1], 16), green: parseInt("" + S[2] + S[2], 16), blue: parseInt("" + S[3] + S[3], 16), alpha: k };
  }
  var D = rgbRegex$1.exec(S);
  if (D) return { red: parseInt("" + D[1], 10), green: parseInt("" + D[2], 10), blue: parseInt("" + D[3], 10) };
  var L = rgbaRegex$1.exec(S.substring(0, 50));
  if (L) return { red: parseInt("" + L[1], 10), green: parseInt("" + L[2], 10), blue: parseInt("" + L[3], 10), alpha: parseFloat("" + L[4]) > 1 ? parseFloat("" + L[4]) / 100 : parseFloat("" + L[4]) };
  var V = hslRegex$1.exec(S);
  if (V) {
    var z = parseInt("" + V[1], 10), W = parseInt("" + V[2], 10) / 100, U = parseInt("" + V[3], 10) / 100, q = "rgb(" + hslToRgb$2(z, W, U) + ")", K = rgbRegex$1.exec(q);
    if (!K) throw new PolishedError$1(4, S, q);
    return { red: parseInt("" + K[1], 10), green: parseInt("" + K[2], 10), blue: parseInt("" + K[3], 10) };
  }
  var Y = hslaRegex$1.exec(S.substring(0, 50));
  if (Y) {
    var J = parseInt("" + Y[1], 10), Z = parseInt("" + Y[2], 10) / 100, X = parseInt("" + Y[3], 10) / 100, ee = "rgb(" + hslToRgb$2(J, Z, X) + ")", te = rgbRegex$1.exec(ee);
    if (!te) throw new PolishedError$1(4, S, ee);
    return { red: parseInt("" + te[1], 10), green: parseInt("" + te[2], 10), blue: parseInt("" + te[3], 10), alpha: parseFloat("" + Y[4]) > 1 ? parseFloat("" + Y[4]) / 100 : parseFloat("" + Y[4]) };
  }
  throw new PolishedError$1(5);
}
function rgbToHsl$1(T) {
  var S = T.red / 255, R = T.green / 255, k = T.blue / 255, D = Math.max(S, R, k), L = Math.min(S, R, k), V = (D + L) / 2;
  if (D === L) return T.alpha !== void 0 ? { hue: 0, saturation: 0, lightness: V, alpha: T.alpha } : { hue: 0, saturation: 0, lightness: V };
  var z, W = D - L, U = V > 0.5 ? W / (2 - D - L) : W / (D + L);
  switch (D) {
    case S:
      z = (R - k) / W + (R < k ? 6 : 0);
      break;
    case R:
      z = (k - S) / W + 2;
      break;
    default:
      z = (S - R) / W + 4;
      break;
  }
  return z *= 60, T.alpha !== void 0 ? { hue: z, saturation: U, lightness: V, alpha: T.alpha } : { hue: z, saturation: U, lightness: V };
}
function parseToHsl$1(T) {
  return rgbToHsl$1(parseToRgb$1(T));
}
var reduceHexValue$2 = function(T) {
  return T.length === 7 && T[1] === T[2] && T[3] === T[4] && T[5] === T[6] ? "#" + T[1] + T[3] + T[5] : T;
}, reduceHexValue$1$1 = reduceHexValue$2;
function numberToHex$1(T) {
  var S = T.toString(16);
  return S.length === 1 ? "0" + S : S;
}
function colorToHex$1(T) {
  return numberToHex$1(Math.round(T * 255));
}
function convertToHex$1(T, S, R) {
  return reduceHexValue$1$1("#" + colorToHex$1(T) + colorToHex$1(S) + colorToHex$1(R));
}
function hslToHex$1(T, S, R) {
  return hslToRgb$2(T, S, R, convertToHex$1);
}
function hsl$1(T, S, R) {
  if (typeof T == "number" && typeof S == "number" && typeof R == "number") return hslToHex$1(T, S, R);
  if (typeof T == "object" && S === void 0 && R === void 0) return hslToHex$1(T.hue, T.saturation, T.lightness);
  throw new PolishedError$1(1);
}
function hsla$1(T, S, R, k) {
  if (typeof T == "number" && typeof S == "number" && typeof R == "number" && typeof k == "number") return k >= 1 ? hslToHex$1(T, S, R) : "rgba(" + hslToRgb$2(T, S, R) + "," + k + ")";
  if (typeof T == "object" && S === void 0 && R === void 0 && k === void 0) return T.alpha >= 1 ? hslToHex$1(T.hue, T.saturation, T.lightness) : "rgba(" + hslToRgb$2(T.hue, T.saturation, T.lightness) + "," + T.alpha + ")";
  throw new PolishedError$1(2);
}
function rgb$2(T, S, R) {
  if (typeof T == "number" && typeof S == "number" && typeof R == "number") return reduceHexValue$1$1("#" + numberToHex$1(T) + numberToHex$1(S) + numberToHex$1(R));
  if (typeof T == "object" && S === void 0 && R === void 0) return reduceHexValue$1$1("#" + numberToHex$1(T.red) + numberToHex$1(T.green) + numberToHex$1(T.blue));
  throw new PolishedError$1(6);
}
function rgba$2(T, S, R, k) {
  if (typeof T == "string" && typeof S == "number") {
    var D = parseToRgb$1(T);
    return "rgba(" + D.red + "," + D.green + "," + D.blue + "," + S + ")";
  } else {
    if (typeof T == "number" && typeof S == "number" && typeof R == "number" && typeof k == "number") return k >= 1 ? rgb$2(T, S, R) : "rgba(" + T + "," + S + "," + R + "," + k + ")";
    if (typeof T == "object" && S === void 0 && R === void 0 && k === void 0) return T.alpha >= 1 ? rgb$2(T.red, T.green, T.blue) : "rgba(" + T.red + "," + T.green + "," + T.blue + "," + T.alpha + ")";
  }
  throw new PolishedError$1(7);
}
var isRgb$1 = function(T) {
  return typeof T.red == "number" && typeof T.green == "number" && typeof T.blue == "number" && (typeof T.alpha != "number" || typeof T.alpha > "u");
}, isRgba$1 = function(T) {
  return typeof T.red == "number" && typeof T.green == "number" && typeof T.blue == "number" && typeof T.alpha == "number";
}, isHsl$1 = function(T) {
  return typeof T.hue == "number" && typeof T.saturation == "number" && typeof T.lightness == "number" && (typeof T.alpha != "number" || typeof T.alpha > "u");
}, isHsla$1 = function(T) {
  return typeof T.hue == "number" && typeof T.saturation == "number" && typeof T.lightness == "number" && typeof T.alpha == "number";
};
function toColorString$1(T) {
  if (typeof T != "object") throw new PolishedError$1(8);
  if (isRgba$1(T)) return rgba$2(T);
  if (isRgb$1(T)) return rgb$2(T);
  if (isHsla$1(T)) return hsla$1(T);
  if (isHsl$1(T)) return hsl$1(T);
  throw new PolishedError$1(8);
}
function curried$1(T, S, R) {
  return function() {
    var k = R.concat(Array.prototype.slice.call(arguments));
    return k.length >= S ? T.apply(this, k) : curried$1(T, S, k);
  };
}
function curry$1(T) {
  return curried$1(T, T.length, []);
}
function guard$1(T, S, R) {
  return Math.max(T, Math.min(S, R));
}
function darken$2(T, S) {
  if (S === "transparent") return S;
  var R = parseToHsl$1(S);
  return toColorString$1(_extends$2({}, R, { lightness: guard$1(0, 1, R.lightness - parseFloat(T)) }));
}
var curriedDarken$2 = curry$1(darken$2), curriedDarken$1$1 = curriedDarken$2;
function lighten$2(T, S) {
  if (S === "transparent") return S;
  var R = parseToHsl$1(S);
  return toColorString$1(_extends$2({}, R, { lightness: guard$1(0, 1, R.lightness + parseFloat(T)) }));
}
var curriedLighten$2 = curry$1(lighten$2), curriedLighten$1$1 = curriedLighten$2;
function transparentize$1(T, S) {
  if (S === "transparent") return S;
  var R = parseToRgb$1(S), k = typeof R.alpha == "number" ? R.alpha : 1, D = _extends$2({}, R, { alpha: guard$1(0, 1, +(k * 100 - parseFloat(T) * 100).toFixed(2) / 100) });
  return rgba$2(D);
}
var curriedTransparentize$2 = curry$1(transparentize$1), curriedTransparentize$1$1 = curriedTransparentize$2, headerCommon = ({ theme: T }) => ({ margin: "20px 0 8px", padding: 0, cursor: "text", position: "relative", color: T.color.defaultText, "&:first-of-type": { marginTop: 0, paddingTop: 0 }, "&:hover a.anchor": { textDecoration: "none" }, "& tt, & code": { fontSize: "inherit" } }), codeCommon = ({ theme: T }) => ({ lineHeight: 1, margin: "0 2px", padding: "3px 5px", whiteSpace: "nowrap", borderRadius: 3, fontSize: T.typography.size.s2 - 1, border: T.base === "light" ? `1px solid ${T.color.mediumlight}` : `1px solid ${T.color.darker}`, color: T.base === "light" ? curriedTransparentize$1$1(0.1, T.color.defaultText) : curriedTransparentize$1$1(0.3, T.color.defaultText), backgroundColor: T.base === "light" ? T.color.lighter : T.color.border }), withReset = ({ theme: T }) => ({ fontFamily: T.typography.fonts.base, fontSize: T.typography.size.s3, margin: 0, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale", WebkitTapHighlightColor: "rgba(0, 0, 0, 0)", WebkitOverflowScrolling: "touch" }), withMargin = { margin: "16px 0" }, Link$1 = ({ href: T, ...S }) => {
  let R = /^\//.test(T) ? `./?path=${T}` : T, k = /^#.*/.test(T) ? "_self" : "_top";
  return React__default.createElement("a", { href: R, target: k, ...S });
}, A = newStyled(Link$1)(withReset, ({ theme: T }) => ({ fontSize: "inherit", lineHeight: "24px", color: T.color.secondary, textDecoration: "none", "&.absent": { color: "#cc0000" }, "&.anchor": { display: "block", paddingLeft: 30, marginLeft: -30, cursor: "pointer", position: "absolute", top: 0, left: 0, bottom: 0 } })), Blockquote = newStyled.blockquote(withReset, withMargin, ({ theme: T }) => ({ borderLeft: `4px solid ${T.color.medium}`, padding: "0 15px", color: T.color.dark, "& > :first-of-type": { marginTop: 0 }, "& > :last-child": { marginBottom: 0 } })), isReactChildString = (T) => typeof T == "string", isInlineCodeRegex = /[\n\r]/g, DefaultCodeBlock = newStyled.code(({ theme: T }) => ({ fontFamily: T.typography.fonts.mono, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale", display: "inline-block", paddingLeft: 2, paddingRight: 2, verticalAlign: "baseline", color: "inherit" }), codeCommon), StyledSyntaxHighlighter$1 = newStyled(SyntaxHighlighter2$1)(({ theme: T }) => ({ fontFamily: T.typography.fonts.mono, fontSize: `${T.typography.size.s2 - 1}px`, lineHeight: "19px", margin: "25px 0 40px", borderRadius: T.appBorderRadius, boxShadow: T.base === "light" ? "rgba(0, 0, 0, 0.10) 0 1px 3px 0" : "rgba(0, 0, 0, 0.20) 0 2px 5px 0", "pre.prismjs": { padding: 20, background: "inherit" } })), Code = ({ className: T, children: S, ...R }) => {
  let k = (T || "").match(/lang-(\S+)/), D = Children.toArray(S);
  return D.filter(isReactChildString).some((L) => L.match(isInlineCodeRegex)) ? React__default.createElement(StyledSyntaxHighlighter$1, { bordered: !0, copyable: !0, language: k?.[1] ?? "text", format: !1, ...R }, S) : React__default.createElement(DefaultCodeBlock, { ...R, className: T }, D);
}, Div = newStyled.div(withReset), DL = newStyled.dl(withReset, withMargin, { padding: 0, "& dt": { fontSize: "14px", fontWeight: "bold", fontStyle: "italic", padding: 0, margin: "16px 0 4px" }, "& dt:first-of-type": { padding: 0 }, "& dt > :first-of-type": { marginTop: 0 }, "& dt > :last-child": { marginBottom: 0 }, "& dd": { margin: "0 0 16px", padding: "0 15px" }, "& dd > :first-of-type": { marginTop: 0 }, "& dd > :last-child": { marginBottom: 0 } }), H1 = newStyled.h1(withReset, headerCommon, ({ theme: T }) => ({ fontSize: `${T.typography.size.l1}px`, fontWeight: T.typography.weight.bold })), H2 = newStyled.h2(withReset, headerCommon, ({ theme: T }) => ({ fontSize: `${T.typography.size.m2}px`, paddingBottom: 4, borderBottom: `1px solid ${T.appBorderColor}` })), H3 = newStyled.h3(withReset, headerCommon, ({ theme: T }) => ({ fontSize: `${T.typography.size.m1}px` })), H4 = newStyled.h4(withReset, headerCommon, ({ theme: T }) => ({ fontSize: `${T.typography.size.s3}px` })), H5 = newStyled.h5(withReset, headerCommon, ({ theme: T }) => ({ fontSize: `${T.typography.size.s2}px` })), H6 = newStyled.h6(withReset, headerCommon, ({ theme: T }) => ({ fontSize: `${T.typography.size.s2}px`, color: T.color.dark })), HR = newStyled.hr(({ theme: T }) => ({ border: "0 none", borderTop: `1px solid ${T.appBorderColor}`, height: 4, padding: 0 })), Img = newStyled.img({ maxWidth: "100%" }), LI = newStyled.li(withReset, ({ theme: T }) => ({ fontSize: T.typography.size.s2, color: T.color.defaultText, lineHeight: "24px", "& + li": { marginTop: ".25em" }, "& ul, & ol": { marginTop: ".25em", marginBottom: 0 }, "& code": codeCommon({ theme: T }) })), listCommon = { paddingLeft: 30, "& :first-of-type": { marginTop: 0 }, "& :last-child": { marginBottom: 0 } }, OL = newStyled.ol(withReset, withMargin, listCommon, { listStyle: "decimal" }), P = newStyled.p(withReset, withMargin, ({ theme: T }) => ({ fontSize: T.typography.size.s2, lineHeight: "24px", color: T.color.defaultText, "& code": codeCommon({ theme: T }) })), Pre = newStyled.pre(withReset, withMargin, ({ theme: T }) => ({ fontFamily: T.typography.fonts.mono, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale", lineHeight: "18px", padding: "11px 1rem", whiteSpace: "pre-wrap", color: "inherit", borderRadius: 3, margin: "1rem 0", "&:not(.prismjs)": { background: "transparent", border: "none", borderRadius: 0, padding: 0, margin: 0 }, "& pre, &.prismjs": { padding: 15, margin: 0, whiteSpace: "pre-wrap", color: "inherit", fontSize: "13px", lineHeight: "19px", code: { color: "inherit", fontSize: "inherit" } }, "& code": { whiteSpace: "pre" }, "& code, & tt": { border: "none" } })), Span = newStyled.span(withReset, ({ theme: T }) => ({ "&.frame": { display: "block", overflow: "hidden", "& > span": { border: `1px solid ${T.color.medium}`, display: "block", float: "left", overflow: "hidden", margin: "13px 0 0", padding: 7, width: "auto" }, "& span img": { display: "block", float: "left" }, "& span span": { clear: "both", color: T.color.darkest, display: "block", padding: "5px 0 0" } }, "&.align-center": { display: "block", overflow: "hidden", clear: "both", "& > span": { display: "block", overflow: "hidden", margin: "13px auto 0", textAlign: "center" }, "& span img": { margin: "0 auto", textAlign: "center" } }, "&.align-right": { display: "block", overflow: "hidden", clear: "both", "& > span": { display: "block", overflow: "hidden", margin: "13px 0 0", textAlign: "right" }, "& span img": { margin: 0, textAlign: "right" } }, "&.float-left": { display: "block", marginRight: 13, overflow: "hidden", float: "left", "& span": { margin: "13px 0 0" } }, "&.float-right": { display: "block", marginLeft: 13, overflow: "hidden", float: "right", "& > span": { display: "block", overflow: "hidden", margin: "13px auto 0", textAlign: "right" } } })), Table = newStyled.table(withReset, withMargin, ({ theme: T }) => ({ fontSize: T.typography.size.s2, lineHeight: "24px", padding: 0, borderCollapse: "collapse", "& tr": { borderTop: `1px solid ${T.appBorderColor}`, backgroundColor: T.appContentBg, margin: 0, padding: 0 }, "& tr:nth-of-type(2n)": { backgroundColor: T.base === "dark" ? T.color.darker : T.color.lighter }, "& tr th": { fontWeight: "bold", color: T.color.defaultText, border: `1px solid ${T.appBorderColor}`, margin: 0, padding: "6px 13px" }, "& tr td": { border: `1px solid ${T.appBorderColor}`, color: T.color.defaultText, margin: 0, padding: "6px 13px" }, "& tr th :first-of-type, & tr td :first-of-type": { marginTop: 0 }, "& tr th :last-child, & tr td :last-child": { marginBottom: 0 } })), TT = newStyled.title(codeCommon), listCommon2 = { paddingLeft: 30, "& :first-of-type": { marginTop: 0 }, "& :last-child": { marginBottom: 0 } }, UL = newStyled.ul(withReset, withMargin, listCommon2, { listStyle: "disc" }), ResetWrapper = newStyled.div(withReset), components$1 = { h1: (T) => React__default.createElement(H1, { ...nameSpaceClassNames(T, "h1") }), h2: (T) => React__default.createElement(H2, { ...nameSpaceClassNames(T, "h2") }), h3: (T) => React__default.createElement(H3, { ...nameSpaceClassNames(T, "h3") }), h4: (T) => React__default.createElement(H4, { ...nameSpaceClassNames(T, "h4") }), h5: (T) => React__default.createElement(H5, { ...nameSpaceClassNames(T, "h5") }), h6: (T) => React__default.createElement(H6, { ...nameSpaceClassNames(T, "h6") }), pre: (T) => React__default.createElement(Pre, { ...nameSpaceClassNames(T, "pre") }), a: (T) => React__default.createElement(A, { ...nameSpaceClassNames(T, "a") }), hr: (T) => React__default.createElement(HR, { ...nameSpaceClassNames(T, "hr") }), dl: (T) => React__default.createElement(DL, { ...nameSpaceClassNames(T, "dl") }), blockquote: (T) => React__default.createElement(Blockquote, { ...nameSpaceClassNames(T, "blockquote") }), table: (T) => React__default.createElement(Table, { ...nameSpaceClassNames(T, "table") }), img: (T) => React__default.createElement(Img, { ...nameSpaceClassNames(T, "img") }), div: (T) => React__default.createElement(Div, { ...nameSpaceClassNames(T, "div") }), span: (T) => React__default.createElement(Span, { ...nameSpaceClassNames(T, "span") }), li: (T) => React__default.createElement(LI, { ...nameSpaceClassNames(T, "li") }), ul: (T) => React__default.createElement(UL, { ...nameSpaceClassNames(T, "ul") }), ol: (T) => React__default.createElement(OL, { ...nameSpaceClassNames(T, "ol") }), p: (T) => React__default.createElement(P, { ...nameSpaceClassNames(T, "p") }), code: (T) => React__default.createElement(Code, { ...nameSpaceClassNames(T, "code") }), tt: (T) => React__default.createElement(TT, { ...nameSpaceClassNames(T, "tt") }), resetwrapper: (T) => React__default.createElement(ResetWrapper, { ...nameSpaceClassNames(T, "resetwrapper") }) };
newStyled.div(({ theme: T }) => ({ display: "inline-block", fontSize: 11, lineHeight: "12px", alignSelf: "center", padding: "4px 12px", borderRadius: "3em", fontWeight: T.typography.weight.bold }), { svg: { height: 12, width: 12, marginRight: 4, marginTop: -2, path: { fill: "currentColor" } } }, ({ theme: T, status: S }) => {
  switch (S) {
    case "critical":
      return { color: T.color.critical, background: T.background.critical };
    case "negative":
      return { color: T.color.negativeText, background: T.background.negative, boxShadow: T.base === "light" ? `inset 0 0 0 1px ${curriedTransparentize$1$1(0.9, T.color.negativeText)}` : "none" };
    case "warning":
      return { color: T.color.warningText, background: T.background.warning, boxShadow: T.base === "light" ? `inset 0 0 0 1px ${curriedTransparentize$1$1(0.9, T.color.warningText)}` : "none" };
    case "neutral":
      return { color: T.color.dark, background: T.color.mediumlight, boxShadow: T.base === "light" ? `inset 0 0 0 1px ${curriedTransparentize$1$1(0.9, T.color.dark)}` : "none" };
    case "positive":
      return { color: T.color.positiveText, background: T.background.positive, boxShadow: T.base === "light" ? `inset 0 0 0 1px ${curriedTransparentize$1$1(0.9, T.color.positiveText)}` : "none" };
    default:
      return {};
  }
});
newStyled.span(({ withArrow: T }) => T ? { "> svg:last-of-type": { height: "0.7em", width: "0.7em", marginRight: 0, marginLeft: "0.25em", bottom: "auto", verticalAlign: "inherit" } } : {}, ({ containsIcon: T }) => T ? { svg: { height: "1em", width: "1em", verticalAlign: "middle", position: "relative", bottom: 0, marginRight: 0 } } : {});
newStyled.a(({ theme: T }) => ({ display: "inline-block", transition: "all 150ms ease-out", textDecoration: "none", color: T.color.secondary, "&:hover, &:focus": { cursor: "pointer", color: curriedDarken$1$1(0.07, T.color.secondary), "svg path:not([fill])": { fill: curriedDarken$1$1(0.07, T.color.secondary) } }, "&:active": { color: curriedDarken$1$1(0.1, T.color.secondary), "svg path:not([fill])": { fill: curriedDarken$1$1(0.1, T.color.secondary) } }, svg: { display: "inline-block", height: "1em", width: "1em", verticalAlign: "text-top", position: "relative", bottom: "-0.125em", marginRight: "0.4em", "& path": { fill: T.color.secondary } } }), ({ theme: T, secondary: S, tertiary: R }) => {
  let k;
  return S && (k = [T.textMutedColor, T.color.dark, T.color.darker]), R && (k = [T.color.dark, T.color.darkest, T.textMutedColor]), k ? { color: k[0], "svg path:not([fill])": { fill: k[0] }, "&:hover": { color: k[1], "svg path:not([fill])": { fill: k[1] } }, "&:active": { color: k[2], "svg path:not([fill])": { fill: k[2] } } } : {};
}, ({ nochrome: T }) => T ? { color: "inherit", "&:hover, &:active": { color: "inherit", textDecoration: "underline" } } : {}, ({ theme: T, inverse: S }) => S ? { color: T.color.lightest, ":not([fill])": { fill: T.color.lightest }, "&:hover": { color: T.color.lighter, "svg path:not([fill])": { fill: T.color.lighter } }, "&:active": { color: T.color.light, "svg path:not([fill])": { fill: T.color.light } } } : {}, ({ isButton: T }) => T ? { border: 0, borderRadius: 0, background: "none", padding: 0, fontSize: "inherit" } : {});
newStyled.div(({ theme: T }) => ({ fontSize: `${T.typography.size.s2}px`, lineHeight: "1.6", h1: { fontSize: `${T.typography.size.l1}px`, fontWeight: T.typography.weight.bold }, h2: { fontSize: `${T.typography.size.m2}px`, borderBottom: `1px solid ${T.appBorderColor}` }, h3: { fontSize: `${T.typography.size.m1}px` }, h4: { fontSize: `${T.typography.size.s3}px` }, h5: { fontSize: `${T.typography.size.s2}px` }, h6: { fontSize: `${T.typography.size.s2}px`, color: T.color.dark }, "pre:not(.prismjs)": { background: "transparent", border: "none", borderRadius: 0, padding: 0, margin: 0 }, "pre pre, pre.prismjs": { padding: 15, margin: 0, whiteSpace: "pre-wrap", color: "inherit", fontSize: "13px", lineHeight: "19px" }, "pre pre code, pre.prismjs code": { color: "inherit", fontSize: "inherit" }, "pre code": { margin: 0, padding: 0, whiteSpace: "pre", border: "none", background: "transparent" }, "pre code, pre tt": { backgroundColor: "transparent", border: "none" }, "body > *:first-of-type": { marginTop: "0 !important" }, "body > *:last-child": { marginBottom: "0 !important" }, a: { color: T.color.secondary, textDecoration: "none" }, "a.absent": { color: "#cc0000" }, "a.anchor": { display: "block", paddingLeft: 30, marginLeft: -30, cursor: "pointer", position: "absolute", top: 0, left: 0, bottom: 0 }, "h1, h2, h3, h4, h5, h6": { margin: "20px 0 10px", padding: 0, cursor: "text", position: "relative", "&:first-of-type": { marginTop: 0, paddingTop: 0 }, "&:hover a.anchor": { textDecoration: "none" }, "& tt, & code": { fontSize: "inherit" } }, "h1:first-of-type + h2": { marginTop: 0, paddingTop: 0 }, "p, blockquote, ul, ol, dl, li, table, pre": { margin: "15px 0" }, hr: { border: "0 none", borderTop: `1px solid ${T.appBorderColor}`, height: 4, padding: 0 }, "body > h1:first-of-type, body > h2:first-of-type, body > h3:first-of-type, body > h4:first-of-type, body > h5:first-of-type, body > h6:first-of-type": { marginTop: 0, paddingTop: 0 }, "body > h1:first-of-type + h2": { marginTop: 0, paddingTop: 0 }, "a:first-of-type h1, a:first-of-type h2, a:first-of-type h3, a:first-of-type h4, a:first-of-type h5, a:first-of-type h6": { marginTop: 0, paddingTop: 0 }, "h1 p, h2 p, h3 p, h4 p, h5 p, h6 p": { marginTop: 0 }, "li p.first": { display: "inline-block" }, "ul, ol": { paddingLeft: 30, "& :first-of-type": { marginTop: 0 }, "& :last-child": { marginBottom: 0 } }, dl: { padding: 0 }, "dl dt": { fontSize: "14px", fontWeight: "bold", fontStyle: "italic", margin: "0 0 15px", padding: "0 15px", "&:first-of-type": { padding: 0 }, "& > :first-of-type": { marginTop: 0 }, "& > :last-child": { marginBottom: 0 } }, blockquote: { borderLeft: `4px solid ${T.color.medium}`, padding: "0 15px", color: T.color.dark, "& > :first-of-type": { marginTop: 0 }, "& > :last-child": { marginBottom: 0 } }, table: { padding: 0, borderCollapse: "collapse", "& tr": { borderTop: `1px solid ${T.appBorderColor}`, backgroundColor: "white", margin: 0, padding: 0, "& th": { fontWeight: "bold", border: `1px solid ${T.appBorderColor}`, textAlign: "left", margin: 0, padding: "6px 13px" }, "& td": { border: `1px solid ${T.appBorderColor}`, textAlign: "left", margin: 0, padding: "6px 13px" }, "&:nth-of-type(2n)": { backgroundColor: T.color.lighter }, "& th :first-of-type, & td :first-of-type": { marginTop: 0 }, "& th :last-child, & td :last-child": { marginBottom: 0 } } }, img: { maxWidth: "100%" }, "span.frame": { display: "block", overflow: "hidden", "& > span": { border: `1px solid ${T.color.medium}`, display: "block", float: "left", overflow: "hidden", margin: "13px 0 0", padding: 7, width: "auto" }, "& span img": { display: "block", float: "left" }, "& span span": { clear: "both", color: T.color.darkest, display: "block", padding: "5px 0 0" } }, "span.align-center": { display: "block", overflow: "hidden", clear: "both", "& > span": { display: "block", overflow: "hidden", margin: "13px auto 0", textAlign: "center" }, "& span img": { margin: "0 auto", textAlign: "center" } }, "span.align-right": { display: "block", overflow: "hidden", clear: "both", "& > span": { display: "block", overflow: "hidden", margin: "13px 0 0", textAlign: "right" }, "& span img": { margin: 0, textAlign: "right" } }, "span.float-left": { display: "block", marginRight: 13, overflow: "hidden", float: "left", "& span": { margin: "13px 0 0" } }, "span.float-right": { display: "block", marginLeft: 13, overflow: "hidden", float: "right", "& > span": { display: "block", overflow: "hidden", margin: "13px auto 0", textAlign: "right" } }, "code, tt": { margin: "0 2px", padding: "0 5px", whiteSpace: "nowrap", border: `1px solid ${T.color.mediumlight}`, backgroundColor: T.color.lighter, borderRadius: 3, color: T.base === "dark" && T.color.darkest } }));
var languages = [], Comp = null, LazySyntaxHighlighter = lazy(async () => {
  let { SyntaxHighlighter: T } = await import("./syntaxhighlighter-BP7B2CQK-DWxixIh8.js");
  return languages.length > 0 && (languages.forEach((S) => {
    T.registerLanguage(...S);
  }), languages = []), Comp === null && (Comp = T), { default: (S) => React__default.createElement(T, { ...S }) };
}), LazySyntaxHighlighterWithFormatter = lazy(async () => {
  let [{ SyntaxHighlighter: T }, { formatter: S }] = await Promise.all([import("./syntaxhighlighter-BP7B2CQK-DWxixIh8.js"), import("./formatter-2WMMO6ZP-B8IuvnSg.js")]);
  return languages.length > 0 && (languages.forEach((R) => {
    T.registerLanguage(...R);
  }), languages = []), Comp === null && (Comp = T), { default: (R) => React__default.createElement(T, { ...R, formatter: S }) };
}), SyntaxHighlighter2 = (T) => React__default.createElement(Suspense, { fallback: React__default.createElement("div", null) }, T.format !== !1 ? React__default.createElement(LazySyntaxHighlighterWithFormatter, { ...T }) : React__default.createElement(LazySyntaxHighlighter, { ...T }));
SyntaxHighlighter2.registerLanguage = (...T) => {
  if (Comp !== null) {
    Comp.registerLanguage(...T);
    return;
  }
  languages.push(T);
};
var Modal_styled_exports = {};
__export$1(Modal_styled_exports, { Actions: () => Actions, CloseButton: () => CloseButton, Col: () => Col, Container: () => Container$3, Content: () => Content$2, Description: () => Description2, Error: () => Error2, ErrorWrapper: () => ErrorWrapper, Header: () => Header$1, Overlay: () => Overlay, Row: () => Row, Title: () => Title2 });
var Button$3 = forwardRef(({ asChild: T = !1, animation: S = "none", size: R = "small", variant: k = "outline", padding: D = "medium", disabled: L = !1, active: V = !1, onClick: z, ...W }, U) => {
  let q = "button";
  W.isLink && (q = "a"), T && (q = Slot);
  let K = k, Y = R, [J, Z] = useState$1(!1), X = (ee) => {
    z && z(ee), S !== "none" && Z(!0);
  };
  if (useEffect$1(() => {
    let ee = setTimeout(() => {
      J && Z(!1);
    }, 1e3);
    return () => clearTimeout(ee);
  }, [J]), W.primary && (K = "solid", Y = "medium"), (W.secondary || W.tertiary || W.gray || W.outline || W.inForm) && (K = "outline", Y = "medium"), W.small || W.isLink || W.primary || W.secondary || W.tertiary || W.gray || W.outline || W.inForm || W.containsIcon) {
    let ee = React__default.Children.toArray(W.children).filter((te) => typeof te == "string" && te !== "");
    deprecate$2(`Use of deprecated props in the button ${ee.length > 0 ? `"${ee.join(" ")}"` : "component"} detected, see the migration notes at https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#new-ui-and-props-for-button-and-iconbutton-components`);
  }
  return React__default.createElement(StyledButton, { as: q, ref: U, variant: K, size: Y, padding: D, disabled: L, active: V, animating: J, animation: S, onClick: X, ...W });
});
Button$3.displayName = "Button";
var StyledButton = newStyled("button", { shouldForwardProp: (T) => isPropValid(T) })(({ theme: T, variant: S, size: R, disabled: k, active: D, animating: L, animation: V, padding: z }) => ({ border: 0, cursor: k ? "not-allowed" : "pointer", display: "inline-flex", gap: "6px", alignItems: "center", justifyContent: "center", overflow: "hidden", padding: z === "small" && R === "small" ? "0 7px" : z === "small" && R === "medium" ? "0 9px" : R === "small" ? "0 10px" : R === "medium" ? "0 12px" : 0, height: R === "small" ? "28px" : "32px", position: "relative", textAlign: "center", textDecoration: "none", transitionProperty: "background, box-shadow", transitionDuration: "150ms", transitionTimingFunction: "ease-out", verticalAlign: "top", whiteSpace: "nowrap", userSelect: "none", opacity: k ? 0.5 : 1, margin: 0, fontSize: `${T.typography.size.s1}px`, fontWeight: T.typography.weight.bold, lineHeight: "1", background: S === "solid" ? T.color.secondary : S === "outline" ? T.button.background : S === "ghost" && D ? T.background.hoverable : "transparent", ...S === "ghost" ? { ".sb-bar &": { background: D ? curriedTransparentize$1$1(0.9, T.barTextColor) : "transparent", color: D ? T.barSelectedColor : T.barTextColor, "&:hover": { color: T.barHoverColor, background: curriedTransparentize$1$1(0.86, T.barHoverColor) }, "&:active": { color: T.barSelectedColor, background: curriedTransparentize$1$1(0.9, T.barSelectedColor) }, "&:focus": { boxShadow: `${rgba$2(T.barHoverColor, 1)} 0 0 0 1px inset`, outline: "none" } } } : {}, color: S === "solid" ? T.color.lightest : S === "outline" ? T.input.color : S === "ghost" && D ? T.color.secondary : S === "ghost" ? T.color.mediumdark : T.input.color, boxShadow: S === "outline" ? `${T.button.border} 0 0 0 1px inset` : "none", borderRadius: T.input.borderRadius, flexShrink: 0, "&:hover": { color: S === "ghost" ? T.color.secondary : null, background: (() => {
  let W = T.color.secondary;
  return S === "solid" && (W = T.color.secondary), S === "outline" && (W = T.button.background), S === "ghost" ? curriedTransparentize$1$1(0.86, T.color.secondary) : T.base === "light" ? curriedDarken$1$1(0.02, W) : curriedLighten$1$1(0.03, W);
})() }, "&:active": { color: S === "ghost" ? T.color.secondary : null, background: (() => {
  let W = T.color.secondary;
  return S === "solid" && (W = T.color.secondary), S === "outline" && (W = T.button.background), S === "ghost" ? T.background.hoverable : T.base === "light" ? curriedDarken$1$1(0.02, W) : curriedLighten$1$1(0.03, W);
})() }, "&:focus": { boxShadow: `${rgba$2(T.color.secondary, 1)} 0 0 0 1px inset`, outline: "none" }, "> svg": { animation: L && V !== "none" ? `${T.animation[V]} 1000ms ease-out` : "" } })), IconButton$1 = forwardRef(({ padding: T = "small", variant: S = "ghost", ...R }, k) => React__default.createElement(Button$3, { padding: T, variant: S, ref: k, ...R }));
IconButton$1.displayName = "IconButton";
var fadeIn = keyframes({ from: { opacity: 0 }, to: { opacity: 1 } }), expand = keyframes({ from: { maxHeight: 0 }, to: {} }), zoomIn = keyframes({ from: { opacity: 0, transform: "translate(-50%, -50%) scale(0.9)" }, to: { opacity: 1, transform: "translate(-50%, -50%) scale(1)" } }), Overlay = newStyled.div({ backgroundColor: "rgba(27, 28, 29, 0.2)", position: "fixed", inset: 0, width: "100%", height: "100%", zIndex: 10, animation: `${fadeIn} 200ms` }), Container$3 = newStyled.div(({ theme: T, width: S, height: R }) => ({ backgroundColor: T.background.bar, borderRadius: 6, boxShadow: "rgba(255, 255, 255, 0.05) 0 0 0 1px inset, rgba(14, 18, 22, 0.35) 0px 10px 38px -10px", position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: S ?? 740, height: R ?? "auto", maxWidth: "calc(100% - 40px)", maxHeight: "85vh", overflow: "hidden", zIndex: 11, animation: `${zoomIn} 200ms`, "&:focus-visible": { outline: "none" } })), CloseButton = (T) => React__default.createElement(Close, { asChild: !0 }, React__default.createElement(IconButton$1, { ...T }, React__default.createElement(CrossIcon, null))), Content$2 = newStyled.div({ display: "flex", flexDirection: "column", margin: 16, gap: 16 }), Row = newStyled.div({ display: "flex", justifyContent: "space-between", gap: 16 }), Col = newStyled.div({ display: "flex", flexDirection: "column", gap: 4 }), Header$1 = (T) => React__default.createElement(Row, null, React__default.createElement(Col, { ...T }), React__default.createElement(CloseButton, null)), Title2 = newStyled(Title)(({ theme: T }) => ({ margin: 0, fontSize: T.typography.size.s3, fontWeight: T.typography.weight.bold })), Description2 = newStyled(Description)(({ theme: T }) => ({ position: "relative", zIndex: 1, margin: 0, fontSize: T.typography.size.s2 })), Actions = newStyled.div({ display: "flex", flexDirection: "row-reverse", gap: 8 }), ErrorWrapper = newStyled.div(({ theme: T }) => ({ maxHeight: 100, overflow: "auto", animation: `${expand} 300ms, ${fadeIn} 300ms`, backgroundColor: T.background.critical, color: T.color.lightest, fontSize: T.typography.size.s2, "& > div": { position: "relative", padding: "8px 16px" } })), Error2 = ({ children: T, ...S }) => React__default.createElement(ErrorWrapper, { ...S }, React__default.createElement("div", null, T));
function BaseModal$1({ children: T, width: S, height: R, onEscapeKeyDown: k, onInteractOutside: D = (W) => W.preventDefault(), className: L, container: V, ...z }) {
  return React__default.createElement(Root, { ...z }, React__default.createElement(Portal$1, { container: V }, React__default.createElement(Overlay$1, { asChild: !0 }, React__default.createElement(Overlay, null)), React__default.createElement(Content$3, { asChild: !0, onInteractOutside: D, onEscapeKeyDown: k }, React__default.createElement(Container$3, { className: L, width: S, height: R }, T))));
}
Object.assign(BaseModal$1, Modal_styled_exports, { Dialog: Dialog2 });
newStyled.div(({ theme: T, col: S, row: R = 1 }) => S ? { display: "inline-block", verticalAlign: "inherit", "& > *": { marginLeft: S * T.layoutMargin, verticalAlign: "inherit" }, [`& > *:first-child${ignoreSsrWarning}`]: { marginLeft: 0 } } : { "& > *": { marginTop: R * T.layoutMargin }, [`& > *:first-child${ignoreSsrWarning}`]: { marginTop: 0 } }, ({ theme: T, outer: S, col: R, row: k }) => {
  switch (!0) {
    case !!(S && R):
      return { marginLeft: S * T.layoutMargin, marginRight: S * T.layoutMargin };
    case !!(S && k):
      return { marginTop: S * T.layoutMargin, marginBottom: S * T.layoutMargin };
    default:
      return {};
  }
});
newStyled.div(({ theme: T }) => ({ fontWeight: T.typography.weight.bold }));
newStyled.div();
newStyled.div(({ theme: T }) => ({ padding: 30, textAlign: "center", color: T.color.defaultText, fontSize: T.typography.size.s2 - 1 }));
function useResolvedElement(T, S) {
  var R = useRef(null), k = useRef(null);
  k.current = S;
  var D = useRef(null);
  useEffect$1(function() {
    L();
  });
  var L = useCallback(function() {
    var V = D.current, z = k.current, W = V || (z ? z instanceof Element ? z : z.current : null);
    R.current && R.current.element === W && R.current.subscriber === T || (R.current && R.current.cleanup && R.current.cleanup(), R.current = { element: W, subscriber: T, cleanup: W ? T(W) : void 0 });
  }, [T]);
  return useEffect$1(function() {
    return function() {
      R.current && R.current.cleanup && (R.current.cleanup(), R.current = null);
    };
  }, []), useCallback(function(V) {
    D.current = V, L();
  }, [L]);
}
function extractSize(T, S, R) {
  return T[S] ? T[S][0] ? T[S][0][R] : T[S][R] : S === "contentBoxSize" ? T.contentRect[R === "inlineSize" ? "width" : "height"] : void 0;
}
function useResizeObserver(T) {
  T === void 0 && (T = {});
  var S = T.onResize, R = useRef(void 0);
  R.current = S;
  var k = T.round || Math.round, D = useRef(), L = useState$1({ width: void 0, height: void 0 }), V = L[0], z = L[1], W = useRef(!1);
  useEffect$1(function() {
    return W.current = !1, function() {
      W.current = !0;
    };
  }, []);
  var U = useRef({ width: void 0, height: void 0 }), q = useResolvedElement(useCallback(function(K) {
    return (!D.current || D.current.box !== T.box || D.current.round !== k) && (D.current = { box: T.box, round: k, instance: new ResizeObserver(function(Y) {
      var J = Y[0], Z = T.box === "border-box" ? "borderBoxSize" : T.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", X = extractSize(J, Z, "inlineSize"), ee = extractSize(J, Z, "blockSize"), te = X ? k(X) : void 0, re = ee ? k(ee) : void 0;
      if (U.current.width !== te || U.current.height !== re) {
        var Q = { width: te, height: re };
        U.current.width = te, U.current.height = re, R.current ? R.current(Q) : W.current || z(Q);
      }
    }) }), D.current.instance.observe(K, { box: T.box }), function() {
      D.current && D.current.instance.unobserve(K);
    };
  }, [T.box, k]), T.ref);
  return useMemo(function() {
    return { ref: q, width: V.width, height: V.height };
  }, [q, V.width, V.height]);
}
var ZoomElementWrapper = newStyled.div(({ scale: T = 1, elementHeight: S }) => ({ height: S || "auto", transformOrigin: "top left", transform: `scale(${1 / T})` }));
function ZoomElement({ scale: T, children: S }) {
  let R = useRef(null), [k, D] = useState$1(0), L = useCallback(({ height: V }) => {
    V && D(V / T);
  }, [T]);
  return useEffect$1(() => {
    R.current && D(R.current.getBoundingClientRect().height);
  }, [T]), useResizeObserver({ ref: R, onResize: L }), React__default.createElement(ZoomElementWrapper, { scale: T, elementHeight: k }, React__default.createElement("div", { ref: R, className: "innerZoomElementWrapper" }, S));
}
var ZoomIFrame = class extends Component {
  constructor() {
    super(...arguments), this.iframe = null;
  }
  componentDidMount() {
    let { iFrameRef: T } = this.props;
    this.iframe = T.current;
  }
  shouldComponentUpdate(T) {
    let { scale: S, active: R } = this.props;
    return S !== T.scale && this.setIframeInnerZoom(T.scale), R !== T.active && this.iframe.setAttribute("data-is-storybook", T.active ? "true" : "false"), T.children.props.src !== this.props.children.props.src;
  }
  setIframeInnerZoom(T) {
    try {
      Object.assign(this.iframe.contentDocument.body.style, { width: `${T * 100}%`, height: `${T * 100}%`, transform: `scale(${1 / T})`, transformOrigin: "top left" });
    } catch {
      this.setIframeZoom(T);
    }
  }
  setIframeZoom(T) {
    Object.assign(this.iframe.style, { width: `${T * 100}%`, height: `${T * 100}%`, transform: `scale(${1 / T})`, transformOrigin: "top left" });
  }
  render() {
    let { children: T } = this.props;
    return React__default.createElement(React__default.Fragment, null, T);
  }
}, Zoom = { Element: ZoomElement, IFrame: ZoomIFrame };
newStyled.strong(({ theme: T }) => ({ color: T.color.orange }));
newStyled.strong(({ theme: T }) => ({ color: T.color.ancillary, textDecoration: "underline" }));
newStyled.em(({ theme: T }) => ({ color: T.textMutedColor }));
var Wrapper$2 = newStyled.label(({ theme: T }) => ({ display: "flex", borderBottom: `1px solid ${T.appBorderColor}`, margin: "0 15px", padding: "8px 0", "&:last-child": { marginBottom: "3rem" } })), Label$1 = newStyled.span(({ theme: T }) => ({ minWidth: 100, fontWeight: T.typography.weight.bold, marginRight: 15, display: "flex", justifyContent: "flex-start", alignItems: "center", lineHeight: "16px" })), Field = ({ label: T, children: S, ...R }) => React__default.createElement(Wrapper$2, { ...R }, T ? React__default.createElement(Label$1, null, React__default.createElement("span", null, T)) : null, S), index$3 = useLayoutEffect, use_isomorphic_layout_effect_browser_esm_default = index$3, useLatest = function(T) {
  var S = React$1.useRef(T);
  return use_isomorphic_layout_effect_browser_esm_default(function() {
    S.current = T;
  }), S;
}, updateRef = function(T, S) {
  if (typeof T == "function") {
    T(S);
    return;
  }
  T.current = S;
}, useComposedRef = function(T, S) {
  var R = useRef();
  return useCallback(function(k) {
    T.current = k, R.current && updateRef(R.current, null), R.current = S, S && updateRef(S, k);
  }, [S]);
}, use_composed_ref_esm_default = useComposedRef, HIDDEN_TEXTAREA_STYLE = { "min-height": "0", "max-height": "none", height: "0", visibility: "hidden", overflow: "hidden", position: "absolute", "z-index": "-1000", top: "0", right: "0" }, forceHiddenStyles = function(T) {
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function(S) {
    T.style.setProperty(S, HIDDEN_TEXTAREA_STYLE[S], "important");
  });
}, forceHiddenStyles$1 = forceHiddenStyles, hiddenTextarea = null, getHeight = function(T, S) {
  var R = T.scrollHeight;
  return S.sizingStyle.boxSizing === "border-box" ? R + S.borderSize : R - S.paddingSize;
};
function calculateNodeHeight(T, S, R, k) {
  R === void 0 && (R = 1), k === void 0 && (k = 1 / 0), hiddenTextarea || (hiddenTextarea = document.createElement("textarea"), hiddenTextarea.setAttribute("tabindex", "-1"), hiddenTextarea.setAttribute("aria-hidden", "true"), forceHiddenStyles$1(hiddenTextarea)), hiddenTextarea.parentNode === null && document.body.appendChild(hiddenTextarea);
  var D = T.paddingSize, L = T.borderSize, V = T.sizingStyle, z = V.boxSizing;
  Object.keys(V).forEach(function(Y) {
    var J = Y;
    hiddenTextarea.style[J] = V[J];
  }), forceHiddenStyles$1(hiddenTextarea), hiddenTextarea.value = S;
  var W = getHeight(hiddenTextarea, T);
  hiddenTextarea.value = S, W = getHeight(hiddenTextarea, T), hiddenTextarea.value = "x";
  var U = hiddenTextarea.scrollHeight - D, q = U * R;
  z === "border-box" && (q = q + D + L), W = Math.max(q, W);
  var K = U * k;
  return z === "border-box" && (K = K + D + L), W = Math.min(K, W), [W, U];
}
var noop$4 = function() {
}, pick = function(T, S) {
  return T.reduce(function(R, k) {
    return R[k] = S[k], R;
  }, {});
}, SIZING_STYLE = ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "boxSizing", "fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "lineHeight", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "tabSize", "textIndent", "textRendering", "textTransform", "width", "wordBreak"], isIE = !!document.documentElement.currentStyle, getSizingData = function(T) {
  var S = window.getComputedStyle(T);
  if (S === null) return null;
  var R = pick(SIZING_STYLE, S), k = R.boxSizing;
  if (k === "") return null;
  isIE && k === "border-box" && (R.width = parseFloat(R.width) + parseFloat(R.borderRightWidth) + parseFloat(R.borderLeftWidth) + parseFloat(R.paddingRight) + parseFloat(R.paddingLeft) + "px");
  var D = parseFloat(R.paddingBottom) + parseFloat(R.paddingTop), L = parseFloat(R.borderBottomWidth) + parseFloat(R.borderTopWidth);
  return { sizingStyle: R, paddingSize: D, borderSize: L };
}, getSizingData$1 = getSizingData;
function useListener(T, S, R) {
  var k = useLatest(R);
  React$1.useLayoutEffect(function() {
    var D = function(L) {
      return k.current(L);
    };
    if (T) return T.addEventListener(S, D), function() {
      return T.removeEventListener(S, D);
    };
  }, []);
}
var useWindowResizeListener = function(T) {
  useListener(window, "resize", T);
}, useFontsLoadedListener = function(T) {
  useListener(document.fonts, "loadingdone", T);
}, _excluded$1u = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], TextareaAutosize$1 = function(T, S) {
  var R = T.cacheMeasurements, k = T.maxRows, D = T.minRows, L = T.onChange, V = L === void 0 ? noop$4 : L, z = T.onHeightChange, W = z === void 0 ? noop$4 : z, U = _objectWithoutPropertiesLoose$2(T, _excluded$1u), q = U.value !== void 0, K = React$1.useRef(null), Y = use_composed_ref_esm_default(K, S), J = React$1.useRef(0), Z = React$1.useRef(), X = function() {
    var te = K.current, re = R && Z.current ? Z.current : getSizingData$1(te);
    if (re) {
      Z.current = re;
      var Q = calculateNodeHeight(re, te.value || te.placeholder || "x", D, k), ne = Q[0], oe = Q[1];
      J.current !== ne && (J.current = ne, te.style.setProperty("height", ne + "px", "important"), W(ne, { rowHeight: oe }));
    }
  }, ee = function(te) {
    q || X(), V(te);
  };
  return React$1.useLayoutEffect(X), useWindowResizeListener(X), useFontsLoadedListener(X), React$1.createElement("textarea", _extends$2({}, U, { onChange: ee, ref: Y }));
}, index2 = React$1.forwardRef(TextareaAutosize$1), styleResets$1 = { appearance: "none", border: "0 none", boxSizing: "inherit", display: " block", margin: " 0", background: "transparent", padding: 0, fontSize: "inherit", position: "relative" }, styles$3 = ({ theme: T }) => ({ ...styleResets$1, transition: "box-shadow 200ms ease-out, opacity 200ms ease-out", color: T.input.color || "inherit", background: T.input.background, boxShadow: `${T.input.border} 0 0 0 1px inset`, borderRadius: T.input.borderRadius, fontSize: T.typography.size.s2 - 1, lineHeight: "20px", padding: "6px 10px", boxSizing: "border-box", height: 32, '&[type="file"]': { height: "auto" }, "&:focus": { boxShadow: `${T.color.secondary} 0 0 0 1px inset`, outline: "none" }, "&[disabled]": { cursor: "not-allowed", opacity: 0.5 }, "&:-webkit-autofill": { WebkitBoxShadow: `0 0 0 3em ${T.color.lightest} inset` }, "&::placeholder": { color: T.textMutedColor, opacity: 1 } }), sizes = ({ size: T }) => {
  switch (T) {
    case "100%":
      return { width: "100%" };
    case "flex":
      return { flex: 1 };
    case "auto":
    default:
      return { display: "inline" };
  }
}, alignment = ({ align: T }) => {
  switch (T) {
    case "end":
      return { textAlign: "right" };
    case "center":
      return { textAlign: "center" };
    case "start":
    default:
      return { textAlign: "left" };
  }
}, validation = ({ valid: T, theme: S }) => {
  switch (T) {
    case "valid":
      return { boxShadow: `${S.color.positive} 0 0 0 1px inset !important` };
    case "error":
      return { boxShadow: `${S.color.negative} 0 0 0 1px inset !important` };
    case "warn":
      return { boxShadow: `${S.color.warning} 0 0 0 1px inset` };
    case void 0:
    case null:
    default:
      return {};
  }
}, Input$1 = Object.assign(newStyled(forwardRef(function({ size: T, valid: S, align: R, ...k }, D) {
  return React__default.createElement("input", { ...k, ref: D });
}))(styles$3, sizes, alignment, validation, { minHeight: 32 }), { displayName: "Input" }), Select$1 = Object.assign(newStyled(forwardRef(function({ size: T, valid: S, align: R, ...k }, D) {
  return React__default.createElement("select", { ...k, ref: D });
}))(styles$3, sizes, validation, { height: 32, userSelect: "none", paddingRight: 20, appearance: "menulist" }), { displayName: "Select" }), Textarea = Object.assign(newStyled(forwardRef(function({ size: T, valid: S, align: R, ...k }, D) {
  return React__default.createElement(index2, { ...k, ref: D });
}))(styles$3, sizes, alignment, validation, ({ height: T = 400 }) => ({ overflow: "visible", maxHeight: T })), { displayName: "Textarea" }), Form = Object.assign(newStyled.form({ boxSizing: "border-box", width: "100%" }), { Field, Input: Input$1, Select: Select$1, Textarea, Button: Button$3 }), LazyWithTooltip = lazy(() => import("./WithTooltip-KJL26V4Q-DVRiFJeK.js").then((T) => ({ default: T.WithTooltip }))), WithTooltip = (T) => React__default.createElement(Suspense, { fallback: React__default.createElement("div", null) }, React__default.createElement(LazyWithTooltip, { ...T }));
lazy(() => import("./WithTooltip-KJL26V4Q-DVRiFJeK.js").then((T) => ({ default: T.WithTooltipPure })));
newStyled.div(({ theme: T }) => ({ fontWeight: T.typography.weight.bold }));
newStyled.span();
newStyled.div(({ theme: T }) => ({ marginTop: 8, textAlign: "center", "> *": { margin: "0 8px", fontWeight: T.typography.weight.bold } }));
newStyled.div(({ theme: T }) => ({ color: T.color.defaultText, lineHeight: "18px" }));
newStyled.div({ padding: 15, width: 280, boxSizing: "border-box" });
var Note = newStyled.div(({ theme: T }) => ({ padding: "2px 6px", lineHeight: "16px", fontSize: 10, fontWeight: T.typography.weight.bold, color: T.color.lightest, boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)", borderRadius: 4, whiteSpace: "nowrap", pointerEvents: "none", zIndex: -1, background: T.base === "light" ? "rgba(60, 60, 60, 0.9)" : "rgba(0, 0, 0, 0.95)", margin: 6 })), TooltipNote = ({ note: T, ...S }) => React__default.createElement(Note, { ...S }, T), Title5 = newStyled(({ active: T, loading: S, disabled: R, ...k }) => React__default.createElement("span", { ...k }))(({ theme: T }) => ({ color: T.color.defaultText, fontWeight: T.typography.weight.regular }), ({ active: T, theme: S }) => T ? { color: S.color.secondary, fontWeight: S.typography.weight.bold } : {}, ({ loading: T, theme: S }) => T ? { display: "inline-block", flex: "none", ...S.animation.inlineGlow } : {}, ({ disabled: T, theme: S }) => T ? { color: curriedTransparentize$1$1(0.7, S.color.defaultText) } : {}), Right = newStyled.span({ display: "flex", "& svg": { height: 12, width: 12, margin: "3px 0", verticalAlign: "top" }, "& path": { fill: "inherit" } }), Center = newStyled.span({ flex: 1, textAlign: "left", display: "flex", flexDirection: "column" }, ({ isIndented: T }) => T ? { marginLeft: 24 } : {}), CenterText = newStyled.span(({ theme: T }) => ({ fontSize: "11px", lineHeight: "14px" }), ({ active: T, theme: S }) => T ? { color: S.color.secondary } : {}, ({ theme: T, disabled: S }) => S ? { color: T.textMutedColor } : {}), Left = newStyled.span(({ active: T, theme: S }) => T ? { color: S.color.secondary } : {}, () => ({ display: "flex", maxWidth: 14 })), Item = newStyled.a(({ theme: T }) => ({ fontSize: T.typography.size.s1, transition: "all 150ms ease-out", color: T.color.dark, textDecoration: "none", cursor: "pointer", justifyContent: "space-between", lineHeight: "18px", padding: "7px 10px", display: "flex", alignItems: "center", "& > * + *": { paddingLeft: 10 }, "&:hover": { background: T.background.hoverable }, "&:hover svg": { opacity: 1 } }), ({ disabled: T }) => T ? { cursor: "not-allowed" } : {}), getItemProps = memoize$3(100)((T, S, R) => {
  let k = {};
  return T && Object.assign(k, { onClick: T }), S && Object.assign(k, { href: S }), R && S && Object.assign(k, { to: S, as: R }), k;
}), ListItem$1 = ({ loading: T = !1, title: S = React__default.createElement("span", null, "Loading state"), center: R = null, right: k = null, active: D = !1, disabled: L = !1, isIndented: V, href: z = null, onClick: W = null, icon: U, LinkWrapper: q = null, ...K }) => {
  let Y = getItemProps(W, z, q), J = { active: D, disabled: L };
  return React__default.createElement(Item, { ...J, ...K, ...Y }, U && React__default.createElement(Left, { ...J }, U), S || R ? React__default.createElement(Center, { isIndented: !U && V }, S && React__default.createElement(Title5, { ...J, loading: T }, S), R && React__default.createElement(CenterText, { ...J }, R)) : null, k && React__default.createElement(Right, { ...J }, k));
}, ListItem_default = ListItem$1, List$1 = newStyled.div({ minWidth: 180, overflow: "hidden", overflowY: "auto", maxHeight: 15.5 * 32 }, ({ theme: T }) => ({ borderRadius: T.appBorderRadius })), Item2 = (T) => {
  let { LinkWrapper: S, onClick: R, id: k, isIndented: D, ...L } = T, { title: V, href: z, active: W } = L, U = useCallback((K) => {
    R(K, L);
  }, [R]), q = !!R;
  return React__default.createElement(ListItem_default, { title: V, active: W, href: z, id: `list-item-${k}`, LinkWrapper: S, isIndented: D, ...L, ...q ? { onClick: U } : {} });
}, TooltipLinkList = ({ links: T, LinkWrapper: S = null }) => {
  let R = T.some((k) => k.icon);
  return React__default.createElement(List$1, null, T.map(({ isGatsby: k, ...D }) => React__default.createElement(Item2, { key: D.id, LinkWrapper: k ? S : null, isIndented: R, ...D })));
}, isLink = (T) => typeof T.props.href == "string", isButton = (T) => typeof T.props.href != "string";
function ForwardRefFunction({ children: T, ...S }, R) {
  let k = { props: S, ref: R };
  if (isLink(k)) return React__default.createElement("a", { ref: k.ref, ...k.props }, T);
  if (isButton(k)) return React__default.createElement("button", { ref: k.ref, type: "button", ...k.props }, T);
  throw new Error("invalid props");
}
var ButtonOrLink = forwardRef(ForwardRefFunction);
ButtonOrLink.displayName = "ButtonOrLink";
var TabButton = newStyled(ButtonOrLink, { shouldForwardProp: isPropValid })({ whiteSpace: "normal", display: "inline-flex", overflow: "hidden", verticalAlign: "top", justifyContent: "center", alignItems: "center", textAlign: "center", textDecoration: "none", "&:empty": { display: "none" }, "&[hidden]": { display: "none" } }, ({ theme: T }) => ({ padding: "0 15px", transition: "color 0.2s linear, border-bottom-color 0.2s linear", height: 40, lineHeight: "12px", cursor: "pointer", background: "transparent", border: "0 solid transparent", borderTop: "3px solid transparent", borderBottom: "3px solid transparent", fontWeight: "bold", fontSize: 13, "&:focus": { outline: "0 none", borderBottomColor: T.barSelectedColor } }), ({ active: T, textColor: S, theme: R }) => T ? { color: S || R.barSelectedColor, borderBottomColor: R.barSelectedColor } : { color: S || R.barTextColor, borderBottomColor: "transparent", "&:hover": { color: R.barHoverColor } });
TabButton.displayName = "TabButton";
newStyled.div(({ theme: T }) => ({ width: 14, height: 14, backgroundColor: T.appBorderColor, animation: `${T.animation.glow} 1.5s ease-in-out infinite` }));
newStyled.div(() => ({ marginTop: 6, padding: 7, height: 28 }));
var Side = newStyled.div({ display: "flex", whiteSpace: "nowrap", flexBasis: "auto", marginLeft: 3, marginRight: 3 }, ({ scrollable: T }) => T ? { flexShrink: 0 } : {}, ({ left: T }) => T ? { "& > *": { marginLeft: 4 } } : {}, ({ right: T }) => T ? { marginLeft: 30, "& > *": { marginRight: 4 } } : {});
Side.displayName = "Side";
var UnstyledBar = ({ children: T, className: S, scrollable: R }) => R ? React__default.createElement(ScrollArea, { vertical: !1, className: S }, T) : React__default.createElement("div", { className: S }, T), Bar$1 = newStyled(UnstyledBar)(({ theme: T, scrollable: S = !0 }) => ({ color: T.barTextColor, width: "100%", height: 40, flexShrink: 0, overflow: S ? "auto" : "hidden", overflowY: "hidden" }), ({ theme: T, border: S = !1 }) => S ? { boxShadow: `${T.appBorderColor}  0 -1px 0 0 inset`, background: T.barBg } : {});
Bar$1.displayName = "Bar";
var BarInner = newStyled.div(({ bgColor: T }) => ({ display: "flex", justifyContent: "space-between", position: "relative", flexWrap: "nowrap", flexShrink: 0, height: 40, backgroundColor: T || "" })), FlexBar = ({ children: T, backgroundColor: S, className: R, ...k }) => {
  let [D, L] = Children.toArray(T);
  return React__default.createElement(Bar$1, { className: `sb-bar ${R}`, ...k }, React__default.createElement(BarInner, { bgColor: S }, React__default.createElement(Side, { scrollable: k.scrollable, left: !0 }, D), L ? React__default.createElement(Side, { right: !0 }, L) : null));
};
FlexBar.displayName = "FlexBar";
var VisuallyHidden = newStyled.div(({ active: T }) => T ? { display: "block" } : { display: "none" }), childrenToList = (T) => Children.toArray(T).map(({ props: { title: S, id: R, color: k, children: D } }) => {
  let L = Array.isArray(D) ? D[0] : D;
  return { title: S, id: R, ...k ? { color: k } : {}, render: typeof L == "function" ? L : ({ active: V }) => React__default.createElement(VisuallyHidden, { active: V, role: "tabpanel" }, L) };
}), CollapseIcon = newStyled.span(({ theme: T, isActive: S }) => ({ display: "inline-block", width: 0, height: 0, marginLeft: 8, color: S ? T.color.secondary : T.color.mediumdark, borderRight: "3px solid transparent", borderLeft: "3px solid transparent", borderTop: "3px solid", transition: "transform .1s ease-out" })), AddonButton = newStyled(TabButton)(({ active: T, theme: S, preActive: R }) => `
    color: ${R || T ? S.barSelectedColor : S.barTextColor};
    .addon-collapsible-icon {
      color: ${R || T ? S.barSelectedColor : S.barTextColor};
    }
    &:hover {
      color: ${S.barHoverColor};
      .addon-collapsible-icon {
        color: ${S.barHoverColor};
      }
    }
  `);
function useList(T) {
  let S = useRef(), R = useRef(), k = useRef(/* @__PURE__ */ new Map()), { width: D = 1 } = useResizeObserver({ ref: S }), [L, V] = useState$1(T), [z, W] = useState$1([]), U = useRef(T), q = useCallback(({ menuName: Y, actions: J }) => {
    let Z = z.some(({ active: te }) => te), [X, ee] = useState$1(!1);
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(WithToolTipState, { interactive: !0, visible: X, onVisibleChange: ee, placement: "bottom", delayHide: 100, tooltip: React__default.createElement(TooltipLinkList, { links: z.map(({ title: te, id: re, color: Q, active: ne }) => ({ id: re, title: te, color: Q, active: ne, onClick: (oe) => {
      oe.preventDefault(), J.onSelect(re);
    } })) }) }, React__default.createElement(AddonButton, { ref: R, active: Z, preActive: X, style: { visibility: z.length ? "visible" : "hidden" }, "aria-hidden": !z.length, className: "tabbutton", type: "button", role: "tab" }, Y, React__default.createElement(CollapseIcon, { className: "addon-collapsible-icon", isActive: Z || X }))), z.map(({ title: te, id: re, color: Q }, ne) => {
      let oe = `index-${ne}`;
      return React__default.createElement(TabButton, { id: `tabbutton-${O(re) ?? oe}`, style: { visibility: "hidden" }, "aria-hidden": !0, tabIndex: -1, ref: (ae) => {
        k.current.set(re, ae);
      }, className: "tabbutton", type: "button", key: re, textColor: Q, role: "tab" }, te);
    }));
  }, [z]), K = useCallback(() => {
    if (!S.current || !R.current) return;
    let { x: Y, width: J } = S.current.getBoundingClientRect(), { width: Z } = R.current.getBoundingClientRect(), X = z.length ? Y + J - Z : Y + J, ee = [], te = 0, re = T.filter((Q) => {
      let { id: ne } = Q, oe = k.current.get(ne), { width: ae = 0 } = oe?.getBoundingClientRect() || {}, se = Y + te + ae > X;
      return (!se || !oe) && ee.push(Q), te += ae, se;
    });
    (ee.length !== L.length || U.current !== T) && (V(ee), W(re), U.current = T);
  }, [z.length, T, L]);
  return useLayoutEffect(K, [K, D]), { tabRefs: k, addonsRef: R, tabBarRef: S, visibleList: L, invisibleList: z, AddonTab: q };
}
var Wrapper2$1 = newStyled.div(({ theme: T }) => ({ height: "100%", display: "flex", padding: 30, alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 15, background: T.background.content })), Content3 = newStyled.div({ display: "flex", flexDirection: "column", gap: 4, maxWidth: 415 }), Title6 = newStyled.div(({ theme: T }) => ({ fontWeight: T.typography.weight.bold, fontSize: T.typography.size.s2 - 1, textAlign: "center", color: T.textColor })), Description3 = newStyled.div(({ theme: T }) => ({ fontWeight: T.typography.weight.regular, fontSize: T.typography.size.s2 - 1, textAlign: "center", color: T.textMutedColor })), EmptyTabContent = ({ title: T, description: S, footer: R }) => React__default.createElement(Wrapper2$1, null, React__default.createElement(Content3, null, React__default.createElement(Title6, null, T), S && React__default.createElement(Description3, null, S)), R), ignoreSsrWarning2 = "/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */", Wrapper3 = newStyled.div(({ theme: T, bordered: S }) => S ? { backgroundClip: "padding-box", border: `1px solid ${T.appBorderColor}`, borderRadius: T.appBorderRadius, overflow: "hidden", boxSizing: "border-box" } : {}, ({ absolute: T }) => T ? { width: "100%", height: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column" } : { display: "block" }), TabBar = newStyled.div({ overflow: "hidden", "&:first-of-type": { marginLeft: -3 }, whiteSpace: "nowrap", flexGrow: 1 });
TabBar.displayName = "TabBar";
var Content4 = newStyled.div({ display: "block", position: "relative" }, ({ theme: T }) => ({ fontSize: T.typography.size.s2 - 1, background: T.background.content }), ({ bordered: T, theme: S }) => T ? { borderRadius: `0 0 ${S.appBorderRadius - 1}px ${S.appBorderRadius - 1}px` } : {}, ({ absolute: T, bordered: S }) => T ? { height: `calc(100% - ${S ? 42 : 40}px)`, position: "absolute", left: 0 + (S ? 1 : 0), right: 0 + (S ? 1 : 0), bottom: 0 + (S ? 1 : 0), top: 40 + (S ? 1 : 0), overflow: "auto", [`& > *:first-child${ignoreSsrWarning2}`]: { position: "absolute", left: 0 + (S ? 1 : 0), right: 0 + (S ? 1 : 0), bottom: 0 + (S ? 1 : 0), top: 0 + (S ? 1 : 0), height: `calc(100% - ${S ? 2 : 0}px)`, overflow: "auto" } } : {}), Tabs = memo(({ children: T, selected: S = null, actions: R, absolute: k = !1, bordered: D = !1, tools: L = null, backgroundColor: V, id: z = null, menuName: W = "Tabs", emptyState: U, showToolsWhenEmpty: q }) => {
  let K = useMemo(() => childrenToList(T).map((te, re) => ({ ...te, active: S ? te.id === S : re === 0 })), [T, S]), { visibleList: Y, tabBarRef: J, tabRefs: Z, AddonTab: X } = useList(K), ee = U ?? React__default.createElement(EmptyTabContent, { title: "Nothing found" });
  return !q && K.length === 0 ? ee : React__default.createElement(Wrapper3, { absolute: k, bordered: D, id: z }, React__default.createElement(FlexBar, { scrollable: !1, border: !0, backgroundColor: V }, React__default.createElement(TabBar, { style: { whiteSpace: "normal" }, ref: J, role: "tablist" }, Y.map(({ title: te, id: re, active: Q, color: ne }, oe) => {
    let ae = `index-${oe}`;
    return React__default.createElement(TabButton, { id: `tabbutton-${O(re) ?? ae}`, ref: (se) => {
      Z.current.set(re, se);
    }, className: `tabbutton ${Q ? "tabbutton-active" : ""}`, type: "button", key: re, active: Q, textColor: ne, onClick: (se) => {
      se.preventDefault(), R.onSelect(re);
    }, role: "tab" }, typeof te == "function" ? React__default.createElement("title", null) : te);
  }), React__default.createElement(X, { menuName: W, actions: R })), L), React__default.createElement(Content4, { id: "panel-tab-content", bordered: D, absolute: k }, K.length ? K.map(({ id: te, active: re, render: Q }) => React__default.createElement(Q, { key: te, active: re }, null)) : ee));
});
Tabs.displayName = "Tabs";
var TabsState = class extends Component {
  constructor(T) {
    super(T), this.handlers = { onSelect: (S) => this.setState({ selected: S }) }, this.state = { selected: T.initial };
  }
  render() {
    let { bordered: T = !1, absolute: S = !1, children: R, backgroundColor: k, menuName: D } = this.props, { selected: L } = this.state;
    return React__default.createElement(Tabs, { bordered: T, absolute: S, selected: L, backgroundColor: k, menuName: D, actions: this.handlers }, R);
  }
};
TabsState.defaultProps = { children: [], initial: null, absolute: !1, bordered: !1, backgroundColor: "", menuName: void 0 };
var Separator = newStyled.span(({ theme: T }) => ({ width: 1, height: 20, background: T.appBorderColor, marginLeft: 2, marginRight: 2 }), ({ force: T }) => T ? {} : { "& + &": { display: "none" } });
Separator.displayName = "Separator";
var Svg = newStyled.svg`
  display: inline-block;
  shape-rendering: inherit;
  vertical-align: middle;
  fill: currentColor;
  path {
    fill: currentColor;
  }
`;
memo(function({ icons: T = Object.keys(icons) }) {
  return React__default.createElement(Svg, { viewBox: "0 0 14 14", style: { position: "absolute", width: 0, height: 0 }, "data-chromatic": "ignore" }, T.map((S) => React__default.createElement("symbol", { id: `icon--${S}`, key: S }, icons[S])));
});
var icons = { user: "UserIcon", useralt: "UserAltIcon", useradd: "UserAddIcon", users: "UsersIcon", profile: "ProfileIcon", facehappy: "FaceHappyIcon", faceneutral: "FaceNeutralIcon", facesad: "FaceSadIcon", accessibility: "AccessibilityIcon", accessibilityalt: "AccessibilityAltIcon", arrowup: "ChevronUpIcon", arrowdown: "ChevronDownIcon", arrowleft: "ChevronLeftIcon", arrowright: "ChevronRightIcon", arrowupalt: "ArrowUpIcon", arrowdownalt: "ArrowDownIcon", arrowleftalt: "ArrowLeftIcon", arrowrightalt: "ArrowRightIcon", expandalt: "ExpandAltIcon", collapse: "CollapseIcon", expand: "ExpandIcon", unfold: "UnfoldIcon", transfer: "TransferIcon", redirect: "RedirectIcon", undo: "UndoIcon", reply: "ReplyIcon", sync: "SyncIcon", upload: "UploadIcon", download: "DownloadIcon", back: "BackIcon", proceed: "ProceedIcon", refresh: "RefreshIcon", globe: "GlobeIcon", compass: "CompassIcon", location: "LocationIcon", pin: "PinIcon", time: "TimeIcon", dashboard: "DashboardIcon", timer: "TimerIcon", home: "HomeIcon", admin: "AdminIcon", info: "InfoIcon", question: "QuestionIcon", support: "SupportIcon", alert: "AlertIcon", email: "EmailIcon", phone: "PhoneIcon", link: "LinkIcon", unlink: "LinkBrokenIcon", bell: "BellIcon", rss: "RSSIcon", sharealt: "ShareAltIcon", share: "ShareIcon", circle: "CircleIcon", circlehollow: "CircleHollowIcon", bookmarkhollow: "BookmarkHollowIcon", bookmark: "BookmarkIcon", hearthollow: "HeartHollowIcon", heart: "HeartIcon", starhollow: "StarHollowIcon", star: "StarIcon", certificate: "CertificateIcon", verified: "VerifiedIcon", thumbsup: "ThumbsUpIcon", shield: "ShieldIcon", basket: "BasketIcon", beaker: "BeakerIcon", hourglass: "HourglassIcon", flag: "FlagIcon", cloudhollow: "CloudHollowIcon", edit: "EditIcon", cog: "CogIcon", nut: "NutIcon", wrench: "WrenchIcon", ellipsis: "EllipsisIcon", check: "CheckIcon", form: "FormIcon", batchdeny: "BatchDenyIcon", batchaccept: "BatchAcceptIcon", controls: "ControlsIcon", plus: "PlusIcon", closeAlt: "CloseAltIcon", cross: "CrossIcon", trash: "TrashIcon", pinalt: "PinAltIcon", unpin: "UnpinIcon", add: "AddIcon", subtract: "SubtractIcon", close: "CloseIcon", delete: "DeleteIcon", passed: "PassedIcon", changed: "ChangedIcon", failed: "FailedIcon", clear: "ClearIcon", comment: "CommentIcon", commentadd: "CommentAddIcon", requestchange: "RequestChangeIcon", comments: "CommentsIcon", lock: "LockIcon", unlock: "UnlockIcon", key: "KeyIcon", outbox: "OutboxIcon", credit: "CreditIcon", button: "ButtonIcon", type: "TypeIcon", pointerdefault: "PointerDefaultIcon", pointerhand: "PointerHandIcon", browser: "BrowserIcon", tablet: "TabletIcon", mobile: "MobileIcon", watch: "WatchIcon", sidebar: "SidebarIcon", sidebaralt: "SidebarAltIcon", sidebaralttoggle: "SidebarAltToggleIcon", sidebartoggle: "SidebarToggleIcon", bottombar: "BottomBarIcon", bottombartoggle: "BottomBarToggleIcon", cpu: "CPUIcon", database: "DatabaseIcon", memory: "MemoryIcon", structure: "StructureIcon", box: "BoxIcon", power: "PowerIcon", photo: "PhotoIcon", component: "ComponentIcon", grid: "GridIcon", outline: "OutlineIcon", photodrag: "PhotoDragIcon", search: "SearchIcon", zoom: "ZoomIcon", zoomout: "ZoomOutIcon", zoomreset: "ZoomResetIcon", eye: "EyeIcon", eyeclose: "EyeCloseIcon", lightning: "LightningIcon", lightningoff: "LightningOffIcon", contrast: "ContrastIcon", switchalt: "SwitchAltIcon", mirror: "MirrorIcon", grow: "GrowIcon", paintbrush: "PaintBrushIcon", ruler: "RulerIcon", stop: "StopIcon", camera: "CameraIcon", video: "VideoIcon", speaker: "SpeakerIcon", play: "PlayIcon", playback: "PlayBackIcon", playnext: "PlayNextIcon", rewind: "RewindIcon", fastforward: "FastForwardIcon", stopalt: "StopAltIcon", sidebyside: "SideBySideIcon", stacked: "StackedIcon", sun: "SunIcon", moon: "MoonIcon", book: "BookIcon", document: "DocumentIcon", copy: "CopyIcon", category: "CategoryIcon", folder: "FolderIcon", print: "PrintIcon", graphline: "GraphLineIcon", calendar: "CalendarIcon", graphbar: "GraphBarIcon", menu: "MenuIcon", menualt: "MenuIcon", filter: "FilterIcon", docchart: "DocChartIcon", doclist: "DocListIcon", markup: "MarkupIcon", bold: "BoldIcon", paperclip: "PaperClipIcon", listordered: "ListOrderedIcon", listunordered: "ListUnorderedIcon", paragraph: "ParagraphIcon", markdown: "MarkdownIcon", repository: "RepoIcon", commit: "CommitIcon", branch: "BranchIcon", pullrequest: "PullRequestIcon", merge: "MergeIcon", apple: "AppleIcon", linux: "LinuxIcon", ubuntu: "UbuntuIcon", windows: "WindowsIcon", storybook: "StorybookIcon", azuredevops: "AzureDevOpsIcon", bitbucket: "BitbucketIcon", chrome: "ChromeIcon", chromatic: "ChromaticIcon", componentdriven: "ComponentDrivenIcon", discord: "DiscordIcon", facebook: "FacebookIcon", figma: "FigmaIcon", gdrive: "GDriveIcon", github: "GithubIcon", gitlab: "GitlabIcon", google: "GoogleIcon", graphql: "GraphqlIcon", medium: "MediumIcon", redux: "ReduxIcon", twitter: "TwitterIcon", youtube: "YoutubeIcon", vscode: "VSCodeIcon" }, rotate360 = keyframes`
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
`;
newStyled.div(({ size: T = 32 }) => ({ borderRadius: "50%", cursor: "progress", display: "inline-block", overflow: "hidden", position: "absolute", transition: "all 200ms ease-out", verticalAlign: "top", top: "50%", left: "50%", marginTop: -(T / 2), marginLeft: -(T / 2), height: T, width: T, zIndex: 4, borderWidth: 2, borderStyle: "solid", borderColor: "rgba(97, 97, 97, 0.29)", borderTopColor: "rgb(100,100,100)", animation: `${rotate360} 0.7s linear infinite`, mixBlendMode: "difference" }));
newStyled.div({ position: "absolute", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" });
newStyled.div(({ theme: T }) => ({ position: "relative", width: "80%", marginBottom: "0.75rem", maxWidth: 300, height: 5, borderRadius: 5, background: curriedTransparentize$1$1(0.8, T.color.secondary), overflow: "hidden", cursor: "progress" }));
newStyled.div(({ theme: T }) => ({ position: "absolute", top: 0, left: 0, height: "100%", background: T.color.secondary }));
newStyled.div(({ theme: T }) => ({ minHeight: "2em", fontSize: `${T.typography.size.s1}px`, color: T.barTextColor }));
newStyled(LightningOffIcon)(({ theme: T }) => ({ width: 20, height: 20, marginBottom: "0.5rem", color: T.textMutedColor }));
var ellipsis = keyframes`
  from { content: "..." }
  33% { content: "." }
  66% { content: ".." }
  to { content: "..." }
`;
newStyled.span({ "&::after": { content: "'...'", animation: `${ellipsis} 1s linear infinite`, animationDelay: "1s", display: "inline-block", width: "1em", height: "auto" } });
newStyled.pre`
  line-height: 18px;
  padding: 11px 1rem;
  white-space: pre-wrap;
  background: rgba(0, 0, 0, 0.05);
  color: ${color$1.darkest};
  border-radius: 3px;
  margin: 1rem 0;
  width: 100%;
  display: block;
  overflow: hidden;
  font-family: ${typography$1.fonts.mono};
  font-size: ${typography$1.size.s2 - 1}px;
`;
var components2 = components$1;
Object.keys(components$1).forEach((T) => {
  forwardRef((S, R) => createElement$1(T, { ...S, ref: R }));
});
const index$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  A,
  ActionBar,
  Bar: Bar$1,
  Blockquote,
  Button: Button$3,
  Code,
  DL,
  Div,
  EmptyTabContent,
  FlexBar,
  Form,
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  HR,
  IconButton: IconButton$1,
  Img,
  LI,
  ListItem: ListItem_default,
  OL,
  P,
  Pre,
  ResetWrapper,
  ScrollArea,
  Separator,
  Span,
  SyntaxHighlighter: SyntaxHighlighter2,
  TT,
  TabBar,
  TabButton,
  Table,
  Tabs,
  TabsState,
  TooltipLinkList,
  TooltipNote,
  UL,
  WithTooltip,
  Zoom,
  codeCommon,
  components: components2,
  createCopyToClipboardFunction,
  icons,
  nameSpaceClassNames,
  withReset
}, Symbol.toStringTag, { value: "Module" }));
var baseMerge = _baseMerge, createAssigner = _createAssigner, mergeWith = createAssigner(function(T, S, R, k) {
  baseMerge(T, S, R, k);
}), mergeWith_1 = mergeWith;
const mergeWith$1 = /* @__PURE__ */ getDefaultExportFromCjs(mergeWith_1);
var store2 = { exports: {} };
/*! store2 - v2.14.3 - 2024-02-14
* Copyright (c) 2024 Nathan Bubna; Licensed MIT */
(function(T) {
  (function(S, R) {
    var k = {
      version: "2.14.3",
      areas: {},
      apis: {},
      nsdelim: ".",
      // utilities
      inherit: function(L, V) {
        for (var z in L)
          V.hasOwnProperty(z) || Object.defineProperty(V, z, Object.getOwnPropertyDescriptor(L, z));
        return V;
      },
      stringify: function(L, V) {
        return L === void 0 || typeof L == "function" ? L + "" : JSON.stringify(L, V || k.replace);
      },
      parse: function(L, V) {
        try {
          return JSON.parse(L, V || k.revive);
        } catch {
          return L;
        }
      },
      // extension hooks
      fn: function(L, V) {
        k.storeAPI[L] = V;
        for (var z in k.apis)
          k.apis[z][L] = V;
      },
      get: function(L, V) {
        return L.getItem(V);
      },
      set: function(L, V, z) {
        L.setItem(V, z);
      },
      remove: function(L, V) {
        L.removeItem(V);
      },
      key: function(L, V) {
        return L.key(V);
      },
      length: function(L) {
        return L.length;
      },
      clear: function(L) {
        L.clear();
      },
      // core functions
      Store: function(L, V, z) {
        var W = k.inherit(k.storeAPI, function(q, K, Y) {
          return arguments.length === 0 ? W.getAll() : typeof K == "function" ? W.transact(q, K, Y) : K !== void 0 ? W.set(q, K, Y) : typeof q == "string" || typeof q == "number" ? W.get(q) : typeof q == "function" ? W.each(q) : q ? W.setAll(q, K) : W.clear();
        });
        W._id = L;
        try {
          var U = "__store2_test";
          V.setItem(U, "ok"), W._area = V, V.removeItem(U);
        } catch {
          W._area = k.storage("fake");
        }
        return W._ns = z || "", k.areas[L] || (k.areas[L] = W._area), k.apis[W._ns + W._id] || (k.apis[W._ns + W._id] = W), W;
      },
      storeAPI: {
        // admin functions
        area: function(L, V) {
          var z = this[L];
          return (!z || !z.area) && (z = k.Store(L, V, this._ns), this[L] || (this[L] = z)), z;
        },
        namespace: function(L, V, z) {
          if (z = z || this._delim || k.nsdelim, !L)
            return this._ns ? this._ns.substring(0, this._ns.length - z.length) : "";
          var W = L, U = this[W];
          if ((!U || !U.namespace) && (U = k.Store(this._id, this._area, this._ns + W + z), U._delim = z, this[W] || (this[W] = U), !V))
            for (var q in k.areas)
              U.area(q, k.areas[q]);
          return U;
        },
        isFake: function(L) {
          return L ? (this._real = this._area, this._area = k.storage("fake")) : L === !1 && (this._area = this._real || this._area), this._area.name === "fake";
        },
        toString: function() {
          return "store" + (this._ns ? "." + this.namespace() : "") + "[" + this._id + "]";
        },
        // storage functions
        has: function(L) {
          return this._area.has ? this._area.has(this._in(L)) : this._in(L) in this._area;
        },
        size: function() {
          return this.keys().length;
        },
        each: function(L, V) {
          for (var z = 0, W = k.length(this._area); z < W; z++) {
            var U = this._out(k.key(this._area, z));
            if (U !== void 0 && L.call(this, U, this.get(U), V) === !1)
              break;
            W > k.length(this._area) && (W--, z--);
          }
          return V || this;
        },
        keys: function(L) {
          return this.each(function(V, z, W) {
            W.push(V);
          }, L || []);
        },
        get: function(L, V) {
          var z = k.get(this._area, this._in(L)), W;
          return typeof V == "function" && (W = V, V = null), z !== null ? k.parse(z, W) : V ?? z;
        },
        getAll: function(L) {
          return this.each(function(V, z, W) {
            W[V] = z;
          }, L || {});
        },
        transact: function(L, V, z) {
          var W = this.get(L, z), U = V(W);
          return this.set(L, U === void 0 ? W : U), this;
        },
        set: function(L, V, z) {
          var W = this.get(L), U;
          return W != null && z === !1 ? V : (typeof z == "function" && (U = z, z = void 0), k.set(this._area, this._in(L), k.stringify(V, U), z) || W);
        },
        setAll: function(L, V) {
          var z, W;
          for (var U in L)
            W = L[U], this.set(U, W, V) !== W && (z = !0);
          return z;
        },
        add: function(L, V, z) {
          var W = this.get(L);
          if (W instanceof Array)
            V = W.concat(V);
          else if (W !== null) {
            var U = typeof W;
            if (U === typeof V && U === "object") {
              for (var q in V)
                W[q] = V[q];
              V = W;
            } else
              V = W + V;
          }
          return k.set(this._area, this._in(L), k.stringify(V, z)), V;
        },
        remove: function(L, V) {
          var z = this.get(L, V);
          return k.remove(this._area, this._in(L)), z;
        },
        clear: function() {
          return this._ns ? this.each(function(L) {
            k.remove(this._area, this._in(L));
          }, 1) : k.clear(this._area), this;
        },
        clearAll: function() {
          var L = this._area;
          for (var V in k.areas)
            k.areas.hasOwnProperty(V) && (this._area = k.areas[V], this.clear());
          return this._area = L, this;
        },
        // internal use functions
        _in: function(L) {
          return typeof L != "string" && (L = k.stringify(L)), this._ns ? this._ns + L : L;
        },
        _out: function(L) {
          return this._ns ? L && L.indexOf(this._ns) === 0 ? L.substring(this._ns.length) : void 0 : (
            // so each() knows to skip it
            L
          );
        }
      },
      // end _.storeAPI
      storage: function(L) {
        return k.inherit(k.storageAPI, { items: {}, name: L });
      },
      storageAPI: {
        length: 0,
        has: function(L) {
          return this.items.hasOwnProperty(L);
        },
        key: function(L) {
          var V = 0;
          for (var z in this.items)
            if (this.has(z) && L === V++)
              return z;
        },
        setItem: function(L, V) {
          this.has(L) || this.length++, this.items[L] = V;
        },
        removeItem: function(L) {
          this.has(L) && (delete this.items[L], this.length--);
        },
        getItem: function(L) {
          return this.has(L) ? this.items[L] : null;
        },
        clear: function() {
          for (var L in this.items)
            this.removeItem(L);
        }
      }
      // end _.storageAPI
    }, D = (
      // safely set this up (throws error in IE10/32bit mode for local files)
      k.Store("local", function() {
        try {
          return localStorage;
        } catch {
        }
      }())
    );
    D.local = D, D._ = k, D.area("session", function() {
      try {
        return sessionStorage;
      } catch {
      }
    }()), D.area("page", k.storage("page")), typeof R == "function" && R.amd !== void 0 ? R("store2", [], function() {
      return D;
    }) : T.exports ? T.exports = D : (S.store && (k.conflict = S.store), S.store = D);
  })(commonjsGlobal, commonjsGlobal && commonjsGlobal.define);
})(store2);
var store2Exports = store2.exports;
const store$1 = /* @__PURE__ */ getDefaultExportFromCjs(store2Exports);
var baseIsEqual = _baseIsEqual;
function isEqual(T, S) {
  return baseIsEqual(T, S);
}
var isEqual_1 = isEqual;
const isEqual$1 = /* @__PURE__ */ getDefaultExportFromCjs(isEqual_1);
var Addon_TypesEnum = ((T) => (T.TAB = "tab", T.PANEL = "panel", T.TOOL = "tool", T.TOOLEXTRA = "toolextra", T.PREVIEW = "preview", T.experimental_PAGE = "page", T.experimental_SIDEBAR_BOTTOM = "sidebar-bottom", T.experimental_SIDEBAR_TOP = "sidebar-top", T))(Addon_TypesEnum || {});
function arrayAggregator$1(T, S, R, k) {
  for (var D = -1, L = T == null ? 0 : T.length; ++D < L; ) {
    var V = T[D];
    S(k, V, R(V), T);
  }
  return k;
}
var _arrayAggregator = arrayAggregator$1, baseEach = _baseEach;
function baseAggregator$1(T, S, R, k) {
  return baseEach(T, function(D, L, V) {
    S(k, D, R(D), V);
  }), k;
}
var _baseAggregator = baseAggregator$1, arrayAggregator = _arrayAggregator, baseAggregator = _baseAggregator, baseIteratee = _baseIteratee, isArray = isArray_1;
function createAggregator$2(T, S) {
  return function(R, k) {
    var D = isArray(R) ? arrayAggregator : baseAggregator, L = S ? S() : {};
    return D(R, T, baseIteratee(k), L);
  };
}
var _createAggregator = createAggregator$2, createAggregator$1 = _createAggregator, partition = createAggregator$1(function(T, S, R) {
  T[R ? 0 : 1].push(S);
}, function() {
  return [[], []];
}), partition_1 = partition;
const partition$1 = /* @__PURE__ */ getDefaultExportFromCjs(partition_1);
var baseAssignValue = _baseAssignValue, createAggregator = _createAggregator, objectProto = Object.prototype, hasOwnProperty$1 = objectProto.hasOwnProperty, countBy = createAggregator(function(T, S, R) {
  hasOwnProperty$1.call(T, R) ? ++T[R] : baseAssignValue(T, R, 1);
}), countBy_1 = countBy;
const countBy$1 = /* @__PURE__ */ getDefaultExportFromCjs(countBy_1);
var __create$1 = Object.create, __defProp$1 = Object.defineProperty, __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor, __getOwnPropNames$1 = Object.getOwnPropertyNames, __getProtoOf$1 = Object.getPrototypeOf, __hasOwnProp$1 = Object.prototype.hasOwnProperty, __commonJS$1 = (T, S) => function() {
  return S || (0, T[__getOwnPropNames$1(T)[0]])((S = { exports: {} }).exports, S), S.exports;
}, __copyProps$1 = (T, S, R, k) => {
  if (S && typeof S == "object" || typeof S == "function") for (let D of __getOwnPropNames$1(S)) !__hasOwnProp$1.call(T, D) && D !== R && __defProp$1(T, D, { get: () => S[D], enumerable: !(k = __getOwnPropDesc$1(S, D)) || k.enumerable });
  return T;
}, __toESM$1 = (T, S, R) => (R = T != null ? __create$1(__getProtoOf$1(T)) : {}, __copyProps$1(!T || !T.__esModule ? __defProp$1(R, "default", { value: T, enumerable: !0 }) : R, T)), require_freeGlobal = __commonJS$1({ "../../node_modules/lodash/_freeGlobal.js"(T, S) {
  var R = typeof global == "object" && global && global.Object === Object && global;
  S.exports = R;
} }), require_root = __commonJS$1({ "../../node_modules/lodash/_root.js"(T, S) {
  var R = require_freeGlobal(), k = typeof self == "object" && self && self.Object === Object && self, D = R || k || Function("return this")();
  S.exports = D;
} }), require_Symbol = __commonJS$1({ "../../node_modules/lodash/_Symbol.js"(T, S) {
  var R = require_root(), k = R.Symbol;
  S.exports = k;
} }), require_getRawTag = __commonJS$1({ "../../node_modules/lodash/_getRawTag.js"(T, S) {
  var R = require_Symbol(), k = Object.prototype, D = k.hasOwnProperty, L = k.toString, V = R ? R.toStringTag : void 0;
  function z(W) {
    var U = D.call(W, V), q = W[V];
    try {
      W[V] = void 0;
      var K = !0;
    } catch {
    }
    var Y = L.call(W);
    return K && (U ? W[V] = q : delete W[V]), Y;
  }
  S.exports = z;
} }), require_objectToString = __commonJS$1({ "../../node_modules/lodash/_objectToString.js"(T, S) {
  var R = Object.prototype, k = R.toString;
  function D(L) {
    return k.call(L);
  }
  S.exports = D;
} }), require_baseGetTag = __commonJS$1({ "../../node_modules/lodash/_baseGetTag.js"(T, S) {
  var R = require_Symbol(), k = require_getRawTag(), D = require_objectToString(), L = "[object Null]", V = "[object Undefined]", z = R ? R.toStringTag : void 0;
  function W(U) {
    return U == null ? U === void 0 ? V : L : z && z in Object(U) ? k(U) : D(U);
  }
  S.exports = W;
} }), require_overArg = __commonJS$1({ "../../node_modules/lodash/_overArg.js"(T, S) {
  function R(k, D) {
    return function(L) {
      return k(D(L));
    };
  }
  S.exports = R;
} }), require_getPrototype = __commonJS$1({ "../../node_modules/lodash/_getPrototype.js"(T, S) {
  var R = require_overArg(), k = R(Object.getPrototypeOf, Object);
  S.exports = k;
} }), require_isObjectLike = __commonJS$1({ "../../node_modules/lodash/isObjectLike.js"(T, S) {
  function R(k) {
    return k != null && typeof k == "object";
  }
  S.exports = R;
} }), require_isPlainObject = __commonJS$1({ "../../node_modules/lodash/isPlainObject.js"(T, S) {
  var R = require_baseGetTag(), k = require_getPrototype(), D = require_isObjectLike(), L = "[object Object]", V = Function.prototype, z = Object.prototype, W = V.toString, U = z.hasOwnProperty, q = W.call(Object);
  function K(Y) {
    if (!D(Y) || R(Y) != L) return !1;
    var J = k(Y);
    if (J === null) return !0;
    var Z = U.call(J, "constructor") && J.constructor;
    return typeof Z == "function" && Z instanceof Z && W.call(Z) == q;
  }
  S.exports = K;
} }), has = Object.prototype.hasOwnProperty;
function find(T, S, R) {
  for (R of T.keys()) if (dequal(R, S)) return R;
}
function dequal(T, S) {
  var R, k, D;
  if (T === S) return !0;
  if (T && S && (R = T.constructor) === S.constructor) {
    if (R === Date) return T.getTime() === S.getTime();
    if (R === RegExp) return T.toString() === S.toString();
    if (R === Array) {
      if ((k = T.length) === S.length) for (; k-- && dequal(T[k], S[k]); ) ;
      return k === -1;
    }
    if (R === Set) {
      if (T.size !== S.size) return !1;
      for (k of T) if (D = k, D && typeof D == "object" && (D = find(S, D), !D) || !S.has(D)) return !1;
      return !0;
    }
    if (R === Map) {
      if (T.size !== S.size) return !1;
      for (k of T) if (D = k[0], D && typeof D == "object" && (D = find(S, D), !D) || !dequal(k[1], S.get(D))) return !1;
      return !0;
    }
    if (R === ArrayBuffer) T = new Uint8Array(T), S = new Uint8Array(S);
    else if (R === DataView) {
      if ((k = T.byteLength) === S.byteLength) for (; k-- && T.getInt8(k) === S.getInt8(k); ) ;
      return k === -1;
    }
    if (ArrayBuffer.isView(T)) {
      if ((k = T.byteLength) === S.byteLength) for (; k-- && T[k] === S[k]; ) ;
      return k === -1;
    }
    if (!R || typeof T == "object") {
      k = 0;
      for (R in T) if (has.call(T, R) && ++k && !has.call(S, R) || !(R in S) || !dequal(T[R], S[R])) return !1;
      return Object.keys(S).length === k;
    }
  }
  return T !== T && S !== S;
}
var import_isPlainObject = __toESM$1(require_isPlainObject());
function dedent(T) {
  for (var S = [], R = 1; R < arguments.length; R++) S[R - 1] = arguments[R];
  var k = Array.from(typeof T == "string" ? [T] : T);
  k[k.length - 1] = k[k.length - 1].replace(/\r?\n([\t ]*)$/, "");
  var D = k.reduce(function(z, W) {
    var U = W.match(/\n([\t ]+|(?!\s).)/g);
    return U ? z.concat(U.map(function(q) {
      var K, Y;
      return (Y = (K = q.match(/[\t ]/g)) === null || K === void 0 ? void 0 : K.length) !== null && Y !== void 0 ? Y : 0;
    })) : z;
  }, []);
  if (D.length) {
    var L = new RegExp(`
[	 ]{` + Math.min.apply(Math, D) + "}", "g");
    k = k.map(function(z) {
      return z.replace(L, `
`);
    });
  }
  k[0] = k[0].replace(/^\r?\n/, "");
  var V = k[0];
  return S.forEach(function(z, W) {
    var U = V.match(/(?:^|\n)( *)$/), q = U ? U[1] : "", K = z;
    typeof z == "string" && z.includes(`
`) && (K = String(z).split(`
`).map(function(Y, J) {
      return J === 0 ? Y : "" + q + Y;
    }).join(`
`)), V += K + k[W + 1];
  }), V;
}
var splitPathRegex = /\/([^/]+)\/(?:(.*)_)?([^/]+)?/;
memoize$3(1e3)((T) => {
  let S = { viewMode: void 0, storyId: void 0, refId: void 0 };
  if (T) {
    let [, R, k, D] = T.toLowerCase().match(splitPathRegex) || [];
    R && Object.assign(S, { viewMode: R, storyId: D, refId: k });
  }
  return S;
});
var DEEPLY_EQUAL = Symbol("Deeply equal"), deepDiff = (T, S) => {
  if (typeof T != typeof S) return S;
  if (dequal(T, S)) return DEEPLY_EQUAL;
  if (Array.isArray(T) && Array.isArray(S)) {
    let R = S.reduce((k, D, L) => {
      let V = deepDiff(T[L], D);
      return V !== DEEPLY_EQUAL && (k[L] = V), k;
    }, new Array(S.length));
    return S.length >= T.length ? R : R.concat(new Array(T.length - S.length).fill(void 0));
  }
  return (0, import_isPlainObject.default)(T) && (0, import_isPlainObject.default)(S) ? Object.keys({ ...T, ...S }).reduce((R, k) => {
    let D = deepDiff(T?.[k], S?.[k]);
    return D === DEEPLY_EQUAL ? R : Object.assign(R, { [k]: D });
  }, {}) : S;
}, VALIDATION_REGEXP = /^[a-zA-Z0-9 _-]*$/, NUMBER_REGEXP = /^-?[0-9]+(\.[0-9]+)?$/, HEX_REGEXP = /^#([a-f0-9]{3,4}|[a-f0-9]{6}|[a-f0-9]{8})$/i, COLOR_REGEXP = /^(rgba?|hsla?)\(([0-9]{1,3}),\s?([0-9]{1,3})%?,\s?([0-9]{1,3})%?,?\s?([0-9](\.[0-9]{1,2})?)?\)$/i, validateArgs = (T = "", S) => T === null || T === "" || !VALIDATION_REGEXP.test(T) ? !1 : S == null || S instanceof Date || typeof S == "number" || typeof S == "boolean" ? !0 : typeof S == "string" ? VALIDATION_REGEXP.test(S) || NUMBER_REGEXP.test(S) || HEX_REGEXP.test(S) || COLOR_REGEXP.test(S) : Array.isArray(S) ? S.every((R) => validateArgs(T, R)) : (0, import_isPlainObject.default)(S) ? Object.entries(S).every(([R, k]) => validateArgs(R, k)) : !1, encodeSpecialValues = (T) => T === void 0 ? "!undefined" : T === null ? "!null" : typeof T == "string" ? HEX_REGEXP.test(T) ? `!hex(${T.slice(1)})` : COLOR_REGEXP.test(T) ? `!${T.replace(/[\s%]/g, "")}` : T : typeof T == "boolean" ? `!${T}` : Array.isArray(T) ? T.map(encodeSpecialValues) : (0, import_isPlainObject.default)(T) ? Object.entries(T).reduce((S, [R, k]) => Object.assign(S, { [R]: encodeSpecialValues(k) }), {}) : T, QS_OPTIONS = { encode: !1, delimiter: ";", allowDots: !0, format: "RFC1738", serializeDate: (T) => `!date(${T.toISOString()})` }, buildArgsParam = (T, S) => {
  let R = deepDiff(T, S);
  if (!R || R === DEEPLY_EQUAL) return "";
  let k = Object.entries(R).reduce((D, [L, V]) => validateArgs(L, V) ? Object.assign(D, { [L]: V }) : (once.warn(dedent`
      Omitted potentially unsafe URL args.

      More info: https://storybook.js.org/docs/react/writing-stories/args#setting-args-through-the-url
    `), D), {});
  return qs.stringify(encodeSpecialValues(k), QS_OPTIONS).replace(/ /g, "+").split(";").map((D) => D.replace("=", ":")).join(";");
}, queryFromString = memoize$3(1e3)((T) => T !== void 0 ? qs.parse(T, { ignoreQueryPrefix: !0 }) : {}), queryFromLocation = (T) => queryFromString(T.search);
memoize$3(1e3)((T, S, R = !0) => {
  if (R) {
    if (typeof S != "string") throw new Error("startsWith only works with string targets");
    return T && T.startsWith(S) ? { path: T } : null;
  }
  let k = typeof S == "string" && T === S, D = T && S && T.match(S);
  return k || D ? { path: T } : null;
});
var define_process_env_default$1U = {}, __create = Object.create, __defProp = Object.defineProperty, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __getOwnPropNames = Object.getOwnPropertyNames, __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty, __commonJS = (T, S) => function() {
  return S || (0, T[__getOwnPropNames(T)[0]])((S = { exports: {} }).exports, S), S.exports;
}, __export = (T, S) => {
  for (var R in S) __defProp(T, R, { get: S[R], enumerable: !0 });
}, __copyProps = (T, S, R, k) => {
  if (S && typeof S == "object" || typeof S == "function") for (let D of __getOwnPropNames(S)) !__hasOwnProp.call(T, D) && D !== R && __defProp(T, D, { get: () => S[D], enumerable: !(k = __getOwnPropDesc(S, D)) || k.enumerable });
  return T;
}, __toESM = (T, S, R) => (R = T != null ? __create(__getProtoOf(T)) : {}, __copyProps(!T || !T.__esModule ? __defProp(R, "default", { value: T, enumerable: !0 }) : R, T)), require_constants = __commonJS({ "../../node_modules/semver/internal/constants.js"(T, S) {
  var R = "2.0.0", k = Number.MAX_SAFE_INTEGER || 9007199254740991, D = 16, L = 250, V = ["major", "premajor", "minor", "preminor", "patch", "prepatch", "prerelease"];
  S.exports = { MAX_LENGTH: 256, MAX_SAFE_COMPONENT_LENGTH: D, MAX_SAFE_BUILD_LENGTH: L, MAX_SAFE_INTEGER: k, RELEASE_TYPES: V, SEMVER_SPEC_VERSION: R, FLAG_INCLUDE_PRERELEASE: 1, FLAG_LOOSE: 2 };
} }), require_debug = __commonJS({ "../../node_modules/semver/internal/debug.js"(T, S) {
  var R = typeof process == "object" && define_process_env_default$1U && define_process_env_default$1U.NODE_DEBUG && /\bsemver\b/i.test(define_process_env_default$1U.NODE_DEBUG) ? (...k) => console.error("SEMVER", ...k) : () => {
  };
  S.exports = R;
} }), require_re = __commonJS({ "../../node_modules/semver/internal/re.js"(T, S) {
  var { MAX_SAFE_COMPONENT_LENGTH: R, MAX_SAFE_BUILD_LENGTH: k, MAX_LENGTH: D } = require_constants(), L = require_debug();
  T = S.exports = {};
  var V = T.re = [], z = T.safeRe = [], W = T.src = [], U = T.t = {}, q = 0, K = "[a-zA-Z0-9-]", Y = [["\\s", 1], ["\\d", D], [K, k]], J = (X) => {
    for (let [ee, te] of Y) X = X.split(`${ee}*`).join(`${ee}{0,${te}}`).split(`${ee}+`).join(`${ee}{1,${te}}`);
    return X;
  }, Z = (X, ee, te) => {
    let re = J(ee), Q = q++;
    L(X, Q, ee), U[X] = Q, W[Q] = ee, V[Q] = new RegExp(ee, te ? "g" : void 0), z[Q] = new RegExp(re, te ? "g" : void 0);
  };
  Z("NUMERICIDENTIFIER", "0|[1-9]\\d*"), Z("NUMERICIDENTIFIERLOOSE", "\\d+"), Z("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${K}*`), Z("MAINVERSION", `(${W[U.NUMERICIDENTIFIER]})\\.(${W[U.NUMERICIDENTIFIER]})\\.(${W[U.NUMERICIDENTIFIER]})`), Z("MAINVERSIONLOOSE", `(${W[U.NUMERICIDENTIFIERLOOSE]})\\.(${W[U.NUMERICIDENTIFIERLOOSE]})\\.(${W[U.NUMERICIDENTIFIERLOOSE]})`), Z("PRERELEASEIDENTIFIER", `(?:${W[U.NUMERICIDENTIFIER]}|${W[U.NONNUMERICIDENTIFIER]})`), Z("PRERELEASEIDENTIFIERLOOSE", `(?:${W[U.NUMERICIDENTIFIERLOOSE]}|${W[U.NONNUMERICIDENTIFIER]})`), Z("PRERELEASE", `(?:-(${W[U.PRERELEASEIDENTIFIER]}(?:\\.${W[U.PRERELEASEIDENTIFIER]})*))`), Z("PRERELEASELOOSE", `(?:-?(${W[U.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${W[U.PRERELEASEIDENTIFIERLOOSE]})*))`), Z("BUILDIDENTIFIER", `${K}+`), Z("BUILD", `(?:\\+(${W[U.BUILDIDENTIFIER]}(?:\\.${W[U.BUILDIDENTIFIER]})*))`), Z("FULLPLAIN", `v?${W[U.MAINVERSION]}${W[U.PRERELEASE]}?${W[U.BUILD]}?`), Z("FULL", `^${W[U.FULLPLAIN]}$`), Z("LOOSEPLAIN", `[v=\\s]*${W[U.MAINVERSIONLOOSE]}${W[U.PRERELEASELOOSE]}?${W[U.BUILD]}?`), Z("LOOSE", `^${W[U.LOOSEPLAIN]}$`), Z("GTLT", "((?:<|>)?=?)"), Z("XRANGEIDENTIFIERLOOSE", `${W[U.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`), Z("XRANGEIDENTIFIER", `${W[U.NUMERICIDENTIFIER]}|x|X|\\*`), Z("XRANGEPLAIN", `[v=\\s]*(${W[U.XRANGEIDENTIFIER]})(?:\\.(${W[U.XRANGEIDENTIFIER]})(?:\\.(${W[U.XRANGEIDENTIFIER]})(?:${W[U.PRERELEASE]})?${W[U.BUILD]}?)?)?`), Z("XRANGEPLAINLOOSE", `[v=\\s]*(${W[U.XRANGEIDENTIFIERLOOSE]})(?:\\.(${W[U.XRANGEIDENTIFIERLOOSE]})(?:\\.(${W[U.XRANGEIDENTIFIERLOOSE]})(?:${W[U.PRERELEASELOOSE]})?${W[U.BUILD]}?)?)?`), Z("XRANGE", `^${W[U.GTLT]}\\s*${W[U.XRANGEPLAIN]}$`), Z("XRANGELOOSE", `^${W[U.GTLT]}\\s*${W[U.XRANGEPLAINLOOSE]}$`), Z("COERCEPLAIN", `(^|[^\\d])(\\d{1,${R}})(?:\\.(\\d{1,${R}}))?(?:\\.(\\d{1,${R}}))?`), Z("COERCE", `${W[U.COERCEPLAIN]}(?:$|[^\\d])`), Z("COERCEFULL", W[U.COERCEPLAIN] + `(?:${W[U.PRERELEASE]})?(?:${W[U.BUILD]})?(?:$|[^\\d])`), Z("COERCERTL", W[U.COERCE], !0), Z("COERCERTLFULL", W[U.COERCEFULL], !0), Z("LONETILDE", "(?:~>?)"), Z("TILDETRIM", `(\\s*)${W[U.LONETILDE]}\\s+`, !0), T.tildeTrimReplace = "$1~", Z("TILDE", `^${W[U.LONETILDE]}${W[U.XRANGEPLAIN]}$`), Z("TILDELOOSE", `^${W[U.LONETILDE]}${W[U.XRANGEPLAINLOOSE]}$`), Z("LONECARET", "(?:\\^)"), Z("CARETTRIM", `(\\s*)${W[U.LONECARET]}\\s+`, !0), T.caretTrimReplace = "$1^", Z("CARET", `^${W[U.LONECARET]}${W[U.XRANGEPLAIN]}$`), Z("CARETLOOSE", `^${W[U.LONECARET]}${W[U.XRANGEPLAINLOOSE]}$`), Z("COMPARATORLOOSE", `^${W[U.GTLT]}\\s*(${W[U.LOOSEPLAIN]})$|^$`), Z("COMPARATOR", `^${W[U.GTLT]}\\s*(${W[U.FULLPLAIN]})$|^$`), Z("COMPARATORTRIM", `(\\s*)${W[U.GTLT]}\\s*(${W[U.LOOSEPLAIN]}|${W[U.XRANGEPLAIN]})`, !0), T.comparatorTrimReplace = "$1$2$3", Z("HYPHENRANGE", `^\\s*(${W[U.XRANGEPLAIN]})\\s+-\\s+(${W[U.XRANGEPLAIN]})\\s*$`), Z("HYPHENRANGELOOSE", `^\\s*(${W[U.XRANGEPLAINLOOSE]})\\s+-\\s+(${W[U.XRANGEPLAINLOOSE]})\\s*$`), Z("STAR", "(<|>)?=?\\s*\\*"), Z("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$"), Z("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
} }), require_parse_options = __commonJS({ "../../node_modules/semver/internal/parse-options.js"(T, S) {
  var R = Object.freeze({ loose: !0 }), k = Object.freeze({}), D = (L) => L ? typeof L != "object" ? R : L : k;
  S.exports = D;
} }), require_identifiers = __commonJS({ "../../node_modules/semver/internal/identifiers.js"(T, S) {
  var R = /^[0-9]+$/, k = (L, V) => {
    let z = R.test(L), W = R.test(V);
    return z && W && (L = +L, V = +V), L === V ? 0 : z && !W ? -1 : W && !z ? 1 : L < V ? -1 : 1;
  }, D = (L, V) => k(V, L);
  S.exports = { compareIdentifiers: k, rcompareIdentifiers: D };
} }), require_semver = __commonJS({ "../../node_modules/semver/classes/semver.js"(T, S) {
  var R = require_debug(), { MAX_LENGTH: k, MAX_SAFE_INTEGER: D } = require_constants(), { safeRe: L, t: V } = require_re(), z = require_parse_options(), { compareIdentifiers: W } = require_identifiers(), U = class Ut {
    constructor(K, Y) {
      if (Y = z(Y), K instanceof Ut) {
        if (K.loose === !!Y.loose && K.includePrerelease === !!Y.includePrerelease) return K;
        K = K.version;
      } else if (typeof K != "string") throw new TypeError(`Invalid version. Must be a string. Got type "${typeof K}".`);
      if (K.length > k) throw new TypeError(`version is longer than ${k} characters`);
      R("SemVer", K, Y), this.options = Y, this.loose = !!Y.loose, this.includePrerelease = !!Y.includePrerelease;
      let J = K.trim().match(Y.loose ? L[V.LOOSE] : L[V.FULL]);
      if (!J) throw new TypeError(`Invalid Version: ${K}`);
      if (this.raw = K, this.major = +J[1], this.minor = +J[2], this.patch = +J[3], this.major > D || this.major < 0) throw new TypeError("Invalid major version");
      if (this.minor > D || this.minor < 0) throw new TypeError("Invalid minor version");
      if (this.patch > D || this.patch < 0) throw new TypeError("Invalid patch version");
      J[4] ? this.prerelease = J[4].split(".").map((Z) => {
        if (/^[0-9]+$/.test(Z)) {
          let X = +Z;
          if (X >= 0 && X < D) return X;
        }
        return Z;
      }) : this.prerelease = [], this.build = J[5] ? J[5].split(".") : [], this.format();
    }
    format() {
      return this.version = `${this.major}.${this.minor}.${this.patch}`, this.prerelease.length && (this.version += `-${this.prerelease.join(".")}`), this.version;
    }
    toString() {
      return this.version;
    }
    compare(K) {
      if (R("SemVer.compare", this.version, this.options, K), !(K instanceof Ut)) {
        if (typeof K == "string" && K === this.version) return 0;
        K = new Ut(K, this.options);
      }
      return K.version === this.version ? 0 : this.compareMain(K) || this.comparePre(K);
    }
    compareMain(K) {
      return K instanceof Ut || (K = new Ut(K, this.options)), W(this.major, K.major) || W(this.minor, K.minor) || W(this.patch, K.patch);
    }
    comparePre(K) {
      if (K instanceof Ut || (K = new Ut(K, this.options)), this.prerelease.length && !K.prerelease.length) return -1;
      if (!this.prerelease.length && K.prerelease.length) return 1;
      if (!this.prerelease.length && !K.prerelease.length) return 0;
      let Y = 0;
      do {
        let J = this.prerelease[Y], Z = K.prerelease[Y];
        if (R("prerelease compare", Y, J, Z), J === void 0 && Z === void 0) return 0;
        if (Z === void 0) return 1;
        if (J === void 0) return -1;
        if (J !== Z)
          return W(J, Z);
      } while (++Y);
    }
    compareBuild(K) {
      K instanceof Ut || (K = new Ut(K, this.options));
      let Y = 0;
      do {
        let J = this.build[Y], Z = K.build[Y];
        if (R("prerelease compare", Y, J, Z), J === void 0 && Z === void 0) return 0;
        if (Z === void 0) return 1;
        if (J === void 0) return -1;
        if (J !== Z)
          return W(J, Z);
      } while (++Y);
    }
    inc(K, Y, J) {
      switch (K) {
        case "premajor":
          this.prerelease.length = 0, this.patch = 0, this.minor = 0, this.major++, this.inc("pre", Y, J);
          break;
        case "preminor":
          this.prerelease.length = 0, this.patch = 0, this.minor++, this.inc("pre", Y, J);
          break;
        case "prepatch":
          this.prerelease.length = 0, this.inc("patch", Y, J), this.inc("pre", Y, J);
          break;
        case "prerelease":
          this.prerelease.length === 0 && this.inc("patch", Y, J), this.inc("pre", Y, J);
          break;
        case "major":
          (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) && this.major++, this.minor = 0, this.patch = 0, this.prerelease = [];
          break;
        case "minor":
          (this.patch !== 0 || this.prerelease.length === 0) && this.minor++, this.patch = 0, this.prerelease = [];
          break;
        case "patch":
          this.prerelease.length === 0 && this.patch++, this.prerelease = [];
          break;
        case "pre": {
          let Z = Number(J) ? 1 : 0;
          if (!Y && J === !1) throw new Error("invalid increment argument: identifier is empty");
          if (this.prerelease.length === 0) this.prerelease = [Z];
          else {
            let X = this.prerelease.length;
            for (; --X >= 0; ) typeof this.prerelease[X] == "number" && (this.prerelease[X]++, X = -2);
            if (X === -1) {
              if (Y === this.prerelease.join(".") && J === !1) throw new Error("invalid increment argument: identifier already exists");
              this.prerelease.push(Z);
            }
          }
          if (Y) {
            let X = [Y, Z];
            J === !1 && (X = [Y]), W(this.prerelease[0], Y) === 0 ? isNaN(this.prerelease[1]) && (this.prerelease = X) : this.prerelease = X;
          }
          break;
        }
        default:
          throw new Error(`invalid increment argument: ${K}`);
      }
      return this.raw = this.format(), this.build.length && (this.raw += `+${this.build.join(".")}`), this;
    }
  };
  S.exports = U;
} }), require_parse = __commonJS({ "../../node_modules/semver/functions/parse.js"(T, S) {
  var R = require_semver(), k = (D, L, V = !1) => {
    if (D instanceof R) return D;
    try {
      return new R(D, L);
    } catch (z) {
      if (!V) return null;
      throw z;
    }
  };
  S.exports = k;
} }), require_valid = __commonJS({ "../../node_modules/semver/functions/valid.js"(T, S) {
  var R = require_parse(), k = (D, L) => {
    let V = R(D, L);
    return V ? V.version : null;
  };
  S.exports = k;
} }), require_clean = __commonJS({ "../../node_modules/semver/functions/clean.js"(T, S) {
  var R = require_parse(), k = (D, L) => {
    let V = R(D.trim().replace(/^[=v]+/, ""), L);
    return V ? V.version : null;
  };
  S.exports = k;
} }), require_inc = __commonJS({ "../../node_modules/semver/functions/inc.js"(T, S) {
  var R = require_semver(), k = (D, L, V, z, W) => {
    typeof V == "string" && (W = z, z = V, V = void 0);
    try {
      return new R(D instanceof R ? D.version : D, V).inc(L, z, W).version;
    } catch {
      return null;
    }
  };
  S.exports = k;
} }), require_diff = __commonJS({ "../../node_modules/semver/functions/diff.js"(T, S) {
  var R = require_parse(), k = (D, L) => {
    let V = R(D, null, !0), z = R(L, null, !0), W = V.compare(z);
    if (W === 0) return null;
    let U = W > 0, q = U ? V : z, K = U ? z : V, Y = !!q.prerelease.length;
    if (K.prerelease.length && !Y) return !K.patch && !K.minor ? "major" : q.patch ? "patch" : q.minor ? "minor" : "major";
    let J = Y ? "pre" : "";
    return V.major !== z.major ? J + "major" : V.minor !== z.minor ? J + "minor" : V.patch !== z.patch ? J + "patch" : "prerelease";
  };
  S.exports = k;
} }), require_major = __commonJS({ "../../node_modules/semver/functions/major.js"(T, S) {
  var R = require_semver(), k = (D, L) => new R(D, L).major;
  S.exports = k;
} }), require_minor = __commonJS({ "../../node_modules/semver/functions/minor.js"(T, S) {
  var R = require_semver(), k = (D, L) => new R(D, L).minor;
  S.exports = k;
} }), require_patch = __commonJS({ "../../node_modules/semver/functions/patch.js"(T, S) {
  var R = require_semver(), k = (D, L) => new R(D, L).patch;
  S.exports = k;
} }), require_prerelease = __commonJS({ "../../node_modules/semver/functions/prerelease.js"(T, S) {
  var R = require_parse(), k = (D, L) => {
    let V = R(D, L);
    return V && V.prerelease.length ? V.prerelease : null;
  };
  S.exports = k;
} }), require_compare = __commonJS({ "../../node_modules/semver/functions/compare.js"(T, S) {
  var R = require_semver(), k = (D, L, V) => new R(D, V).compare(new R(L, V));
  S.exports = k;
} }), require_rcompare = __commonJS({ "../../node_modules/semver/functions/rcompare.js"(T, S) {
  var R = require_compare(), k = (D, L, V) => R(L, D, V);
  S.exports = k;
} }), require_compare_loose = __commonJS({ "../../node_modules/semver/functions/compare-loose.js"(T, S) {
  var R = require_compare(), k = (D, L) => R(D, L, !0);
  S.exports = k;
} }), require_compare_build = __commonJS({ "../../node_modules/semver/functions/compare-build.js"(T, S) {
  var R = require_semver(), k = (D, L, V) => {
    let z = new R(D, V), W = new R(L, V);
    return z.compare(W) || z.compareBuild(W);
  };
  S.exports = k;
} }), require_sort = __commonJS({ "../../node_modules/semver/functions/sort.js"(T, S) {
  var R = require_compare_build(), k = (D, L) => D.sort((V, z) => R(V, z, L));
  S.exports = k;
} }), require_rsort = __commonJS({ "../../node_modules/semver/functions/rsort.js"(T, S) {
  var R = require_compare_build(), k = (D, L) => D.sort((V, z) => R(z, V, L));
  S.exports = k;
} }), require_gt = __commonJS({ "../../node_modules/semver/functions/gt.js"(T, S) {
  var R = require_compare(), k = (D, L, V) => R(D, L, V) > 0;
  S.exports = k;
} }), require_lt = __commonJS({ "../../node_modules/semver/functions/lt.js"(T, S) {
  var R = require_compare(), k = (D, L, V) => R(D, L, V) < 0;
  S.exports = k;
} }), require_eq = __commonJS({ "../../node_modules/semver/functions/eq.js"(T, S) {
  var R = require_compare(), k = (D, L, V) => R(D, L, V) === 0;
  S.exports = k;
} }), require_neq = __commonJS({ "../../node_modules/semver/functions/neq.js"(T, S) {
  var R = require_compare(), k = (D, L, V) => R(D, L, V) !== 0;
  S.exports = k;
} }), require_gte = __commonJS({ "../../node_modules/semver/functions/gte.js"(T, S) {
  var R = require_compare(), k = (D, L, V) => R(D, L, V) >= 0;
  S.exports = k;
} }), require_lte = __commonJS({ "../../node_modules/semver/functions/lte.js"(T, S) {
  var R = require_compare(), k = (D, L, V) => R(D, L, V) <= 0;
  S.exports = k;
} }), require_cmp = __commonJS({ "../../node_modules/semver/functions/cmp.js"(T, S) {
  var R = require_eq(), k = require_neq(), D = require_gt(), L = require_gte(), V = require_lt(), z = require_lte(), W = (U, q, K, Y) => {
    switch (q) {
      case "===":
        return typeof U == "object" && (U = U.version), typeof K == "object" && (K = K.version), U === K;
      case "!==":
        return typeof U == "object" && (U = U.version), typeof K == "object" && (K = K.version), U !== K;
      case "":
      case "=":
      case "==":
        return R(U, K, Y);
      case "!=":
        return k(U, K, Y);
      case ">":
        return D(U, K, Y);
      case ">=":
        return L(U, K, Y);
      case "<":
        return V(U, K, Y);
      case "<=":
        return z(U, K, Y);
      default:
        throw new TypeError(`Invalid operator: ${q}`);
    }
  };
  S.exports = W;
} }), require_coerce = __commonJS({ "../../node_modules/semver/functions/coerce.js"(T, S) {
  var R = require_semver(), k = require_parse(), { safeRe: D, t: L } = require_re(), V = (z, W) => {
    if (z instanceof R) return z;
    if (typeof z == "number" && (z = String(z)), typeof z != "string") return null;
    W = W || {};
    let U = null;
    if (!W.rtl) U = z.match(W.includePrerelease ? D[L.COERCEFULL] : D[L.COERCE]);
    else {
      let X = W.includePrerelease ? D[L.COERCERTLFULL] : D[L.COERCERTL], ee;
      for (; (ee = X.exec(z)) && (!U || U.index + U[0].length !== z.length); ) (!U || ee.index + ee[0].length !== U.index + U[0].length) && (U = ee), X.lastIndex = ee.index + ee[1].length + ee[2].length;
      X.lastIndex = -1;
    }
    if (U === null) return null;
    let q = U[2], K = U[3] || "0", Y = U[4] || "0", J = W.includePrerelease && U[5] ? `-${U[5]}` : "", Z = W.includePrerelease && U[6] ? `+${U[6]}` : "";
    return k(`${q}.${K}.${Y}${J}${Z}`, W);
  };
  S.exports = V;
} }), require_iterator = __commonJS({ "../../node_modules/yallist/iterator.js"(T, S) {
  S.exports = function(R) {
    R.prototype[Symbol.iterator] = function* () {
      for (let k = this.head; k; k = k.next) yield k.value;
    };
  };
} }), require_yallist = __commonJS({ "../../node_modules/yallist/yallist.js"(T, S) {
  S.exports = R, R.Node = V, R.create = R;
  function R(z) {
    var W = this;
    if (W instanceof R || (W = new R()), W.tail = null, W.head = null, W.length = 0, z && typeof z.forEach == "function") z.forEach(function(K) {
      W.push(K);
    });
    else if (arguments.length > 0) for (var U = 0, q = arguments.length; U < q; U++) W.push(arguments[U]);
    return W;
  }
  R.prototype.removeNode = function(z) {
    if (z.list !== this) throw new Error("removing node which does not belong to this list");
    var W = z.next, U = z.prev;
    return W && (W.prev = U), U && (U.next = W), z === this.head && (this.head = W), z === this.tail && (this.tail = U), z.list.length--, z.next = null, z.prev = null, z.list = null, W;
  }, R.prototype.unshiftNode = function(z) {
    if (z !== this.head) {
      z.list && z.list.removeNode(z);
      var W = this.head;
      z.list = this, z.next = W, W && (W.prev = z), this.head = z, this.tail || (this.tail = z), this.length++;
    }
  }, R.prototype.pushNode = function(z) {
    if (z !== this.tail) {
      z.list && z.list.removeNode(z);
      var W = this.tail;
      z.list = this, z.prev = W, W && (W.next = z), this.tail = z, this.head || (this.head = z), this.length++;
    }
  }, R.prototype.push = function() {
    for (var z = 0, W = arguments.length; z < W; z++) D(this, arguments[z]);
    return this.length;
  }, R.prototype.unshift = function() {
    for (var z = 0, W = arguments.length; z < W; z++) L(this, arguments[z]);
    return this.length;
  }, R.prototype.pop = function() {
    if (this.tail) {
      var z = this.tail.value;
      return this.tail = this.tail.prev, this.tail ? this.tail.next = null : this.head = null, this.length--, z;
    }
  }, R.prototype.shift = function() {
    if (this.head) {
      var z = this.head.value;
      return this.head = this.head.next, this.head ? this.head.prev = null : this.tail = null, this.length--, z;
    }
  }, R.prototype.forEach = function(z, W) {
    W = W || this;
    for (var U = this.head, q = 0; U !== null; q++) z.call(W, U.value, q, this), U = U.next;
  }, R.prototype.forEachReverse = function(z, W) {
    W = W || this;
    for (var U = this.tail, q = this.length - 1; U !== null; q--) z.call(W, U.value, q, this), U = U.prev;
  }, R.prototype.get = function(z) {
    for (var W = 0, U = this.head; U !== null && W < z; W++) U = U.next;
    if (W === z && U !== null) return U.value;
  }, R.prototype.getReverse = function(z) {
    for (var W = 0, U = this.tail; U !== null && W < z; W++) U = U.prev;
    if (W === z && U !== null) return U.value;
  }, R.prototype.map = function(z, W) {
    W = W || this;
    for (var U = new R(), q = this.head; q !== null; ) U.push(z.call(W, q.value, this)), q = q.next;
    return U;
  }, R.prototype.mapReverse = function(z, W) {
    W = W || this;
    for (var U = new R(), q = this.tail; q !== null; ) U.push(z.call(W, q.value, this)), q = q.prev;
    return U;
  }, R.prototype.reduce = function(z, W) {
    var U, q = this.head;
    if (arguments.length > 1) U = W;
    else if (this.head) q = this.head.next, U = this.head.value;
    else throw new TypeError("Reduce of empty list with no initial value");
    for (var K = 0; q !== null; K++) U = z(U, q.value, K), q = q.next;
    return U;
  }, R.prototype.reduceReverse = function(z, W) {
    var U, q = this.tail;
    if (arguments.length > 1) U = W;
    else if (this.tail) q = this.tail.prev, U = this.tail.value;
    else throw new TypeError("Reduce of empty list with no initial value");
    for (var K = this.length - 1; q !== null; K--) U = z(U, q.value, K), q = q.prev;
    return U;
  }, R.prototype.toArray = function() {
    for (var z = new Array(this.length), W = 0, U = this.head; U !== null; W++) z[W] = U.value, U = U.next;
    return z;
  }, R.prototype.toArrayReverse = function() {
    for (var z = new Array(this.length), W = 0, U = this.tail; U !== null; W++) z[W] = U.value, U = U.prev;
    return z;
  }, R.prototype.slice = function(z, W) {
    W = W || this.length, W < 0 && (W += this.length), z = z || 0, z < 0 && (z += this.length);
    var U = new R();
    if (W < z || W < 0) return U;
    z < 0 && (z = 0), W > this.length && (W = this.length);
    for (var q = 0, K = this.head; K !== null && q < z; q++) K = K.next;
    for (; K !== null && q < W; q++, K = K.next) U.push(K.value);
    return U;
  }, R.prototype.sliceReverse = function(z, W) {
    W = W || this.length, W < 0 && (W += this.length), z = z || 0, z < 0 && (z += this.length);
    var U = new R();
    if (W < z || W < 0) return U;
    z < 0 && (z = 0), W > this.length && (W = this.length);
    for (var q = this.length, K = this.tail; K !== null && q > W; q--) K = K.prev;
    for (; K !== null && q > z; q--, K = K.prev) U.push(K.value);
    return U;
  }, R.prototype.splice = function(z, W, ...U) {
    z > this.length && (z = this.length - 1), z < 0 && (z = this.length + z);
    for (var q = 0, K = this.head; K !== null && q < z; q++) K = K.next;
    for (var Y = [], q = 0; K && q < W; q++) Y.push(K.value), K = this.removeNode(K);
    K === null && (K = this.tail), K !== this.head && K !== this.tail && (K = K.prev);
    for (var q = 0; q < U.length; q++) K = k(this, K, U[q]);
    return Y;
  }, R.prototype.reverse = function() {
    for (var z = this.head, W = this.tail, U = z; U !== null; U = U.prev) {
      var q = U.prev;
      U.prev = U.next, U.next = q;
    }
    return this.head = W, this.tail = z, this;
  };
  function k(z, W, U) {
    var q = W === z.head ? new V(U, null, W, z) : new V(U, W, W.next, z);
    return q.next === null && (z.tail = q), q.prev === null && (z.head = q), z.length++, q;
  }
  function D(z, W) {
    z.tail = new V(W, z.tail, null, z), z.head || (z.head = z.tail), z.length++;
  }
  function L(z, W) {
    z.head = new V(W, null, z.head, z), z.tail || (z.tail = z.head), z.length++;
  }
  function V(z, W, U, q) {
    if (!(this instanceof V)) return new V(z, W, U, q);
    this.list = q, this.value = z, W ? (W.next = this, this.prev = W) : this.prev = null, U ? (U.prev = this, this.next = U) : this.next = null;
  }
  try {
    require_iterator()(R);
  } catch {
  }
} }), require_lru_cache = __commonJS({ "../../node_modules/semver/node_modules/lru-cache/index.js"(T, S) {
  var R = require_yallist(), k = Symbol("max"), D = Symbol("length"), L = Symbol("lengthCalculator"), V = Symbol("allowStale"), z = Symbol("maxAge"), W = Symbol("dispose"), U = Symbol("noDisposeOnSet"), q = Symbol("lruList"), K = Symbol("cache"), Y = Symbol("updateAgeOnGet"), J = () => 1, Z = class {
    constructor(oe) {
      if (typeof oe == "number" && (oe = { max: oe }), oe || (oe = {}), oe.max && (typeof oe.max != "number" || oe.max < 0)) throw new TypeError("max must be a non-negative number");
      this[k] = oe.max || 1 / 0;
      let ae = oe.length || J;
      if (this[L] = typeof ae != "function" ? J : ae, this[V] = oe.stale || !1, oe.maxAge && typeof oe.maxAge != "number") throw new TypeError("maxAge must be a number");
      this[z] = oe.maxAge || 0, this[W] = oe.dispose, this[U] = oe.noDisposeOnSet || !1, this[Y] = oe.updateAgeOnGet || !1, this.reset();
    }
    set max(oe) {
      if (typeof oe != "number" || oe < 0) throw new TypeError("max must be a non-negative number");
      this[k] = oe || 1 / 0, te(this);
    }
    get max() {
      return this[k];
    }
    set allowStale(oe) {
      this[V] = !!oe;
    }
    get allowStale() {
      return this[V];
    }
    set maxAge(oe) {
      if (typeof oe != "number") throw new TypeError("maxAge must be a non-negative number");
      this[z] = oe, te(this);
    }
    get maxAge() {
      return this[z];
    }
    set lengthCalculator(oe) {
      typeof oe != "function" && (oe = J), oe !== this[L] && (this[L] = oe, this[D] = 0, this[q].forEach((ae) => {
        ae.length = this[L](ae.value, ae.key), this[D] += ae.length;
      })), te(this);
    }
    get lengthCalculator() {
      return this[L];
    }
    get length() {
      return this[D];
    }
    get itemCount() {
      return this[q].length;
    }
    rforEach(oe, ae) {
      ae = ae || this;
      for (let se = this[q].tail; se !== null; ) {
        let ie = se.prev;
        ne(this, oe, se, ae), se = ie;
      }
    }
    forEach(oe, ae) {
      ae = ae || this;
      for (let se = this[q].head; se !== null; ) {
        let ie = se.next;
        ne(this, oe, se, ae), se = ie;
      }
    }
    keys() {
      return this[q].toArray().map((oe) => oe.key);
    }
    values() {
      return this[q].toArray().map((oe) => oe.value);
    }
    reset() {
      this[W] && this[q] && this[q].length && this[q].forEach((oe) => this[W](oe.key, oe.value)), this[K] = /* @__PURE__ */ new Map(), this[q] = new R(), this[D] = 0;
    }
    dump() {
      return this[q].map((oe) => ee(this, oe) ? !1 : { k: oe.key, v: oe.value, e: oe.now + (oe.maxAge || 0) }).toArray().filter((oe) => oe);
    }
    dumpLru() {
      return this[q];
    }
    set(oe, ae, se) {
      if (se = se || this[z], se && typeof se != "number") throw new TypeError("maxAge must be a number");
      let ie = se ? Date.now() : 0, he = this[L](ae, oe);
      if (this[K].has(oe)) {
        if (he > this[k]) return re(this, this[K].get(oe)), !1;
        let Pe = this[K].get(oe).value;
        return this[W] && (this[U] || this[W](oe, Pe.value)), Pe.now = ie, Pe.maxAge = se, Pe.value = ae, this[D] += he - Pe.length, Pe.length = he, this.get(oe), te(this), !0;
      }
      let xe = new Q(oe, ae, he, ie, se);
      return xe.length > this[k] ? (this[W] && this[W](oe, ae), !1) : (this[D] += xe.length, this[q].unshift(xe), this[K].set(oe, this[q].head), te(this), !0);
    }
    has(oe) {
      if (!this[K].has(oe)) return !1;
      let ae = this[K].get(oe).value;
      return !ee(this, ae);
    }
    get(oe) {
      return X(this, oe, !0);
    }
    peek(oe) {
      return X(this, oe, !1);
    }
    pop() {
      let oe = this[q].tail;
      return oe ? (re(this, oe), oe.value) : null;
    }
    del(oe) {
      re(this, this[K].get(oe));
    }
    load(oe) {
      this.reset();
      let ae = Date.now();
      for (let se = oe.length - 1; se >= 0; se--) {
        let ie = oe[se], he = ie.e || 0;
        if (he === 0) this.set(ie.k, ie.v);
        else {
          let xe = he - ae;
          xe > 0 && this.set(ie.k, ie.v, xe);
        }
      }
    }
    prune() {
      this[K].forEach((oe, ae) => X(this, ae, !1));
    }
  }, X = (oe, ae, se) => {
    let ie = oe[K].get(ae);
    if (ie) {
      let he = ie.value;
      if (ee(oe, he)) {
        if (re(oe, ie), !oe[V]) return;
      } else se && (oe[Y] && (ie.value.now = Date.now()), oe[q].unshiftNode(ie));
      return he.value;
    }
  }, ee = (oe, ae) => {
    if (!ae || !ae.maxAge && !oe[z]) return !1;
    let se = Date.now() - ae.now;
    return ae.maxAge ? se > ae.maxAge : oe[z] && se > oe[z];
  }, te = (oe) => {
    if (oe[D] > oe[k]) for (let ae = oe[q].tail; oe[D] > oe[k] && ae !== null; ) {
      let se = ae.prev;
      re(oe, ae), ae = se;
    }
  }, re = (oe, ae) => {
    if (ae) {
      let se = ae.value;
      oe[W] && oe[W](se.key, se.value), oe[D] -= se.length, oe[K].delete(se.key), oe[q].removeNode(ae);
    }
  }, Q = class {
    constructor(oe, ae, se, ie, he) {
      this.key = oe, this.value = ae, this.length = se, this.now = ie, this.maxAge = he || 0;
    }
  }, ne = (oe, ae, se, ie) => {
    let he = se.value;
    ee(oe, he) && (re(oe, se), oe[V] || (he = void 0)), he && ae.call(ie, he.value, he.key, oe);
  };
  S.exports = Z;
} }), require_range = __commonJS({ "../../node_modules/semver/classes/range.js"(T, S) {
  var R = class gr {
    constructor(ue, Ce) {
      if (Ce = L(Ce), ue instanceof gr) return ue.loose === !!Ce.loose && ue.includePrerelease === !!Ce.includePrerelease ? ue : new gr(ue.raw, Ce);
      if (ue instanceof V) return this.raw = ue.value, this.set = [[ue]], this.format(), this;
      if (this.options = Ce, this.loose = !!Ce.loose, this.includePrerelease = !!Ce.includePrerelease, this.raw = ue.trim().split(/\s+/).join(" "), this.set = this.raw.split("||").map((ce) => this.parseRange(ce.trim())).filter((ce) => ce.length), !this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
      if (this.set.length > 1) {
        let ce = this.set[0];
        if (this.set = this.set.filter((pe) => !ee(pe[0])), this.set.length === 0) this.set = [ce];
        else if (this.set.length > 1) {
          for (let pe of this.set) if (pe.length === 1 && te(pe[0])) {
            this.set = [pe];
            break;
          }
        }
      }
      this.format();
    }
    format() {
      return this.range = this.set.map((ue) => ue.join(" ").trim()).join("||").trim(), this.range;
    }
    toString() {
      return this.range;
    }
    parseRange(ue) {
      let Ce = ((this.options.includePrerelease && Z) | (this.options.loose && X)) + ":" + ue, ce = D.get(Ce);
      if (ce) return ce;
      let pe = this.options.loose, _e = pe ? U[q.HYPHENRANGELOOSE] : U[q.HYPHENRANGE];
      ue = ue.replace(_e, ke(this.options.includePrerelease)), z("hyphen replace", ue), ue = ue.replace(U[q.COMPARATORTRIM], K), z("comparator trim", ue), ue = ue.replace(U[q.TILDETRIM], Y), z("tilde trim", ue), ue = ue.replace(U[q.CARETTRIM], J), z("caret trim", ue);
      let ge = ue.split(" ").map((le) => Q(le, this.options)).join(" ").split(/\s+/).map((le) => Re(le, this.options));
      pe && (ge = ge.filter((le) => (z("loose invalid filter", le, this.options), !!le.match(U[q.COMPARATORLOOSE])))), z("range list", ge);
      let Ae = /* @__PURE__ */ new Map(), Ee = ge.map((le) => new V(le, this.options));
      for (let le of Ee) {
        if (ee(le)) return [le];
        Ae.set(le.value, le);
      }
      Ae.size > 1 && Ae.has("") && Ae.delete("");
      let ve = [...Ae.values()];
      return D.set(Ce, ve), ve;
    }
    intersects(ue, Ce) {
      if (!(ue instanceof gr)) throw new TypeError("a Range is required");
      return this.set.some((ce) => re(ce, Ce) && ue.set.some((pe) => re(pe, Ce) && ce.every((_e) => pe.every((ge) => _e.intersects(ge, Ce)))));
    }
    test(ue) {
      if (!ue) return !1;
      if (typeof ue == "string") try {
        ue = new W(ue, this.options);
      } catch {
        return !1;
      }
      for (let Ce = 0; Ce < this.set.length; Ce++) if (Te(this.set[Ce], ue, this.options)) return !0;
      return !1;
    }
  };
  S.exports = R;
  var k = require_lru_cache(), D = new k({ max: 1e3 }), L = require_parse_options(), V = require_comparator(), z = require_debug(), W = require_semver(), { safeRe: U, t: q, comparatorTrimReplace: K, tildeTrimReplace: Y, caretTrimReplace: J } = require_re(), { FLAG_INCLUDE_PRERELEASE: Z, FLAG_LOOSE: X } = require_constants(), ee = (fe) => fe.value === "<0.0.0-0", te = (fe) => fe.value === "", re = (fe, ue) => {
    let Ce = !0, ce = fe.slice(), pe = ce.pop();
    for (; Ce && ce.length; ) Ce = ce.every((_e) => pe.intersects(_e, ue)), pe = ce.pop();
    return Ce;
  }, Q = (fe, ue) => (z("comp", fe, ue), fe = se(fe, ue), z("caret", fe), fe = oe(fe, ue), z("tildes", fe), fe = he(fe, ue), z("xrange", fe), fe = Pe(fe, ue), z("stars", fe), fe), ne = (fe) => !fe || fe.toLowerCase() === "x" || fe === "*", oe = (fe, ue) => fe.trim().split(/\s+/).map((Ce) => ae(Ce, ue)).join(" "), ae = (fe, ue) => {
    let Ce = ue.loose ? U[q.TILDELOOSE] : U[q.TILDE];
    return fe.replace(Ce, (ce, pe, _e, ge, Ae) => {
      z("tilde", fe, ce, pe, _e, ge, Ae);
      let Ee;
      return ne(pe) ? Ee = "" : ne(_e) ? Ee = `>=${pe}.0.0 <${+pe + 1}.0.0-0` : ne(ge) ? Ee = `>=${pe}.${_e}.0 <${pe}.${+_e + 1}.0-0` : Ae ? (z("replaceTilde pr", Ae), Ee = `>=${pe}.${_e}.${ge}-${Ae} <${pe}.${+_e + 1}.0-0`) : Ee = `>=${pe}.${_e}.${ge} <${pe}.${+_e + 1}.0-0`, z("tilde return", Ee), Ee;
    });
  }, se = (fe, ue) => fe.trim().split(/\s+/).map((Ce) => ie(Ce, ue)).join(" "), ie = (fe, ue) => {
    z("caret", fe, ue);
    let Ce = ue.loose ? U[q.CARETLOOSE] : U[q.CARET], ce = ue.includePrerelease ? "-0" : "";
    return fe.replace(Ce, (pe, _e, ge, Ae, Ee) => {
      z("caret", fe, pe, _e, ge, Ae, Ee);
      let ve;
      return ne(_e) ? ve = "" : ne(ge) ? ve = `>=${_e}.0.0${ce} <${+_e + 1}.0.0-0` : ne(Ae) ? _e === "0" ? ve = `>=${_e}.${ge}.0${ce} <${_e}.${+ge + 1}.0-0` : ve = `>=${_e}.${ge}.0${ce} <${+_e + 1}.0.0-0` : Ee ? (z("replaceCaret pr", Ee), _e === "0" ? ge === "0" ? ve = `>=${_e}.${ge}.${Ae}-${Ee} <${_e}.${ge}.${+Ae + 1}-0` : ve = `>=${_e}.${ge}.${Ae}-${Ee} <${_e}.${+ge + 1}.0-0` : ve = `>=${_e}.${ge}.${Ae}-${Ee} <${+_e + 1}.0.0-0`) : (z("no pr"), _e === "0" ? ge === "0" ? ve = `>=${_e}.${ge}.${Ae}${ce} <${_e}.${ge}.${+Ae + 1}-0` : ve = `>=${_e}.${ge}.${Ae}${ce} <${_e}.${+ge + 1}.0-0` : ve = `>=${_e}.${ge}.${Ae} <${+_e + 1}.0.0-0`), z("caret return", ve), ve;
    });
  }, he = (fe, ue) => (z("replaceXRanges", fe, ue), fe.split(/\s+/).map((Ce) => xe(Ce, ue)).join(" ")), xe = (fe, ue) => {
    fe = fe.trim();
    let Ce = ue.loose ? U[q.XRANGELOOSE] : U[q.XRANGE];
    return fe.replace(Ce, (ce, pe, _e, ge, Ae, Ee) => {
      z("xRange", fe, ce, pe, _e, ge, Ae, Ee);
      let ve = ne(_e), le = ve || ne(ge), me = le || ne(Ae), Se = me;
      return pe === "=" && Se && (pe = ""), Ee = ue.includePrerelease ? "-0" : "", ve ? pe === ">" || pe === "<" ? ce = "<0.0.0-0" : ce = "*" : pe && Se ? (le && (ge = 0), Ae = 0, pe === ">" ? (pe = ">=", le ? (_e = +_e + 1, ge = 0, Ae = 0) : (ge = +ge + 1, Ae = 0)) : pe === "<=" && (pe = "<", le ? _e = +_e + 1 : ge = +ge + 1), pe === "<" && (Ee = "-0"), ce = `${pe + _e}.${ge}.${Ae}${Ee}`) : le ? ce = `>=${_e}.0.0${Ee} <${+_e + 1}.0.0-0` : me && (ce = `>=${_e}.${ge}.0${Ee} <${_e}.${+ge + 1}.0-0`), z("xRange return", ce), ce;
    });
  }, Pe = (fe, ue) => (z("replaceStars", fe, ue), fe.trim().replace(U[q.STAR], "")), Re = (fe, ue) => (z("replaceGTE0", fe, ue), fe.trim().replace(U[ue.includePrerelease ? q.GTE0PRE : q.GTE0], "")), ke = (fe) => (ue, Ce, ce, pe, _e, ge, Ae, Ee, ve, le, me, Se, ye) => (ne(ce) ? Ce = "" : ne(pe) ? Ce = `>=${ce}.0.0${fe ? "-0" : ""}` : ne(_e) ? Ce = `>=${ce}.${pe}.0${fe ? "-0" : ""}` : ge ? Ce = `>=${Ce}` : Ce = `>=${Ce}${fe ? "-0" : ""}`, ne(ve) ? Ee = "" : ne(le) ? Ee = `<${+ve + 1}.0.0-0` : ne(me) ? Ee = `<${ve}.${+le + 1}.0-0` : Se ? Ee = `<=${ve}.${le}.${me}-${Se}` : fe ? Ee = `<${ve}.${le}.${+me + 1}-0` : Ee = `<=${Ee}`, `${Ce} ${Ee}`.trim()), Te = (fe, ue, Ce) => {
    for (let ce = 0; ce < fe.length; ce++) if (!fe[ce].test(ue)) return !1;
    if (ue.prerelease.length && !Ce.includePrerelease) {
      for (let ce = 0; ce < fe.length; ce++) if (z(fe[ce].semver), fe[ce].semver !== V.ANY && fe[ce].semver.prerelease.length > 0) {
        let pe = fe[ce].semver;
        if (pe.major === ue.major && pe.minor === ue.minor && pe.patch === ue.patch) return !0;
      }
      return !1;
    }
    return !0;
  };
} }), require_comparator = __commonJS({ "../../node_modules/semver/classes/comparator.js"(T, S) {
  var R = Symbol("SemVer ANY"), k = class xr {
    static get ANY() {
      return R;
    }
    constructor(Y, J) {
      if (J = D(J), Y instanceof xr) {
        if (Y.loose === !!J.loose) return Y;
        Y = Y.value;
      }
      Y = Y.trim().split(/\s+/).join(" "), W("comparator", Y, J), this.options = J, this.loose = !!J.loose, this.parse(Y), this.semver === R ? this.value = "" : this.value = this.operator + this.semver.version, W("comp", this);
    }
    parse(Y) {
      let J = this.options.loose ? L[V.COMPARATORLOOSE] : L[V.COMPARATOR], Z = Y.match(J);
      if (!Z) throw new TypeError(`Invalid comparator: ${Y}`);
      this.operator = Z[1] !== void 0 ? Z[1] : "", this.operator === "=" && (this.operator = ""), Z[2] ? this.semver = new U(Z[2], this.options.loose) : this.semver = R;
    }
    toString() {
      return this.value;
    }
    test(Y) {
      if (W("Comparator.test", Y, this.options.loose), this.semver === R || Y === R) return !0;
      if (typeof Y == "string") try {
        Y = new U(Y, this.options);
      } catch {
        return !1;
      }
      return z(Y, this.operator, this.semver, this.options);
    }
    intersects(Y, J) {
      if (!(Y instanceof xr)) throw new TypeError("a Comparator is required");
      return this.operator === "" ? this.value === "" ? !0 : new q(Y.value, J).test(this.value) : Y.operator === "" ? Y.value === "" ? !0 : new q(this.value, J).test(Y.semver) : (J = D(J), J.includePrerelease && (this.value === "<0.0.0-0" || Y.value === "<0.0.0-0") || !J.includePrerelease && (this.value.startsWith("<0.0.0") || Y.value.startsWith("<0.0.0")) ? !1 : !!(this.operator.startsWith(">") && Y.operator.startsWith(">") || this.operator.startsWith("<") && Y.operator.startsWith("<") || this.semver.version === Y.semver.version && this.operator.includes("=") && Y.operator.includes("=") || z(this.semver, "<", Y.semver, J) && this.operator.startsWith(">") && Y.operator.startsWith("<") || z(this.semver, ">", Y.semver, J) && this.operator.startsWith("<") && Y.operator.startsWith(">")));
    }
  };
  S.exports = k;
  var D = require_parse_options(), { safeRe: L, t: V } = require_re(), z = require_cmp(), W = require_debug(), U = require_semver(), q = require_range();
} }), require_satisfies = __commonJS({ "../../node_modules/semver/functions/satisfies.js"(T, S) {
  var R = require_range(), k = (D, L, V) => {
    try {
      L = new R(L, V);
    } catch {
      return !1;
    }
    return L.test(D);
  };
  S.exports = k;
} }), require_to_comparators = __commonJS({ "../../node_modules/semver/ranges/to-comparators.js"(T, S) {
  var R = require_range(), k = (D, L) => new R(D, L).set.map((V) => V.map((z) => z.value).join(" ").trim().split(" "));
  S.exports = k;
} }), require_max_satisfying = __commonJS({ "../../node_modules/semver/ranges/max-satisfying.js"(T, S) {
  var R = require_semver(), k = require_range(), D = (L, V, z) => {
    let W = null, U = null, q = null;
    try {
      q = new k(V, z);
    } catch {
      return null;
    }
    return L.forEach((K) => {
      q.test(K) && (!W || U.compare(K) === -1) && (W = K, U = new R(W, z));
    }), W;
  };
  S.exports = D;
} }), require_min_satisfying = __commonJS({ "../../node_modules/semver/ranges/min-satisfying.js"(T, S) {
  var R = require_semver(), k = require_range(), D = (L, V, z) => {
    let W = null, U = null, q = null;
    try {
      q = new k(V, z);
    } catch {
      return null;
    }
    return L.forEach((K) => {
      q.test(K) && (!W || U.compare(K) === 1) && (W = K, U = new R(W, z));
    }), W;
  };
  S.exports = D;
} }), require_min_version = __commonJS({ "../../node_modules/semver/ranges/min-version.js"(T, S) {
  var R = require_semver(), k = require_range(), D = require_gt(), L = (V, z) => {
    V = new k(V, z);
    let W = new R("0.0.0");
    if (V.test(W) || (W = new R("0.0.0-0"), V.test(W))) return W;
    W = null;
    for (let U = 0; U < V.set.length; ++U) {
      let q = V.set[U], K = null;
      q.forEach((Y) => {
        let J = new R(Y.semver.version);
        switch (Y.operator) {
          case ">":
            J.prerelease.length === 0 ? J.patch++ : J.prerelease.push(0), J.raw = J.format();
          case "":
          case ">=":
            (!K || D(J, K)) && (K = J);
            break;
          case "<":
          case "<=":
            break;
          default:
            throw new Error(`Unexpected operation: ${Y.operator}`);
        }
      }), K && (!W || D(W, K)) && (W = K);
    }
    return W && V.test(W) ? W : null;
  };
  S.exports = L;
} }), require_valid2 = __commonJS({ "../../node_modules/semver/ranges/valid.js"(T, S) {
  var R = require_range(), k = (D, L) => {
    try {
      return new R(D, L).range || "*";
    } catch {
      return null;
    }
  };
  S.exports = k;
} }), require_outside = __commonJS({ "../../node_modules/semver/ranges/outside.js"(T, S) {
  var R = require_semver(), k = require_comparator(), { ANY: D } = k, L = require_range(), V = require_satisfies(), z = require_gt(), W = require_lt(), U = require_lte(), q = require_gte(), K = (Y, J, Z, X) => {
    Y = new R(Y, X), J = new L(J, X);
    let ee, te, re, Q, ne;
    switch (Z) {
      case ">":
        ee = z, te = U, re = W, Q = ">", ne = ">=";
        break;
      case "<":
        ee = W, te = q, re = z, Q = "<", ne = "<=";
        break;
      default:
        throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    if (V(Y, J, X)) return !1;
    for (let oe = 0; oe < J.set.length; ++oe) {
      let ae = J.set[oe], se = null, ie = null;
      if (ae.forEach((he) => {
        he.semver === D && (he = new k(">=0.0.0")), se = se || he, ie = ie || he, ee(he.semver, se.semver, X) ? se = he : re(he.semver, ie.semver, X) && (ie = he);
      }), se.operator === Q || se.operator === ne || (!ie.operator || ie.operator === Q) && te(Y, ie.semver) || ie.operator === ne && re(Y, ie.semver)) return !1;
    }
    return !0;
  };
  S.exports = K;
} }), require_gtr = __commonJS({ "../../node_modules/semver/ranges/gtr.js"(T, S) {
  var R = require_outside(), k = (D, L, V) => R(D, L, ">", V);
  S.exports = k;
} }), require_ltr = __commonJS({ "../../node_modules/semver/ranges/ltr.js"(T, S) {
  var R = require_outside(), k = (D, L, V) => R(D, L, "<", V);
  S.exports = k;
} }), require_intersects = __commonJS({ "../../node_modules/semver/ranges/intersects.js"(T, S) {
  var R = require_range(), k = (D, L, V) => (D = new R(D, V), L = new R(L, V), D.intersects(L, V));
  S.exports = k;
} }), require_simplify = __commonJS({ "../../node_modules/semver/ranges/simplify.js"(T, S) {
  var R = require_satisfies(), k = require_compare();
  S.exports = (D, L, V) => {
    let z = [], W = null, U = null, q = D.sort((Z, X) => k(Z, X, V));
    for (let Z of q) R(Z, L, V) ? (U = Z, W || (W = Z)) : (U && z.push([W, U]), U = null, W = null);
    W && z.push([W, null]);
    let K = [];
    for (let [Z, X] of z) Z === X ? K.push(Z) : !X && Z === q[0] ? K.push("*") : X ? Z === q[0] ? K.push(`<=${X}`) : K.push(`${Z} - ${X}`) : K.push(`>=${Z}`);
    let Y = K.join(" || "), J = typeof L.raw == "string" ? L.raw : String(L);
    return Y.length < J.length ? Y : L;
  };
} }), require_subset = __commonJS({ "../../node_modules/semver/ranges/subset.js"(T, S) {
  var R = require_range(), k = require_comparator(), { ANY: D } = k, L = require_satisfies(), V = require_compare(), z = (J, Z, X = {}) => {
    if (J === Z) return !0;
    J = new R(J, X), Z = new R(Z, X);
    let ee = !1;
    e: for (let te of J.set) {
      for (let re of Z.set) {
        let Q = q(te, re, X);
        if (ee = ee || Q !== null, Q) continue e;
      }
      if (ee) return !1;
    }
    return !0;
  }, W = [new k(">=0.0.0-0")], U = [new k(">=0.0.0")], q = (J, Z, X) => {
    if (J === Z) return !0;
    if (J.length === 1 && J[0].semver === D) {
      if (Z.length === 1 && Z[0].semver === D) return !0;
      X.includePrerelease ? J = W : J = U;
    }
    if (Z.length === 1 && Z[0].semver === D) {
      if (X.includePrerelease) return !0;
      Z = U;
    }
    let ee = /* @__PURE__ */ new Set(), te, re;
    for (let xe of J) xe.operator === ">" || xe.operator === ">=" ? te = K(te, xe, X) : xe.operator === "<" || xe.operator === "<=" ? re = Y(re, xe, X) : ee.add(xe.semver);
    if (ee.size > 1) return null;
    let Q;
    if (te && re && (Q = V(te.semver, re.semver, X), Q > 0 || Q === 0 && (te.operator !== ">=" || re.operator !== "<=")))
      return null;
    for (let xe of ee) {
      if (te && !L(xe, String(te), X) || re && !L(xe, String(re), X)) return null;
      for (let Pe of Z) if (!L(xe, String(Pe), X)) return !1;
      return !0;
    }
    let ne, oe, ae, se, ie = re && !X.includePrerelease && re.semver.prerelease.length ? re.semver : !1, he = te && !X.includePrerelease && te.semver.prerelease.length ? te.semver : !1;
    ie && ie.prerelease.length === 1 && re.operator === "<" && ie.prerelease[0] === 0 && (ie = !1);
    for (let xe of Z) {
      if (se = se || xe.operator === ">" || xe.operator === ">=", ae = ae || xe.operator === "<" || xe.operator === "<=", te) {
        if (he && xe.semver.prerelease && xe.semver.prerelease.length && xe.semver.major === he.major && xe.semver.minor === he.minor && xe.semver.patch === he.patch && (he = !1), xe.operator === ">" || xe.operator === ">=") {
          if (ne = K(te, xe, X), ne === xe && ne !== te) return !1;
        } else if (te.operator === ">=" && !L(te.semver, String(xe), X)) return !1;
      }
      if (re) {
        if (ie && xe.semver.prerelease && xe.semver.prerelease.length && xe.semver.major === ie.major && xe.semver.minor === ie.minor && xe.semver.patch === ie.patch && (ie = !1), xe.operator === "<" || xe.operator === "<=") {
          if (oe = Y(re, xe, X), oe === xe && oe !== re) return !1;
        } else if (re.operator === "<=" && !L(re.semver, String(xe), X)) return !1;
      }
      if (!xe.operator && (re || te) && Q !== 0) return !1;
    }
    return !(te && ae && !re && Q !== 0 || re && se && !te && Q !== 0 || he || ie);
  }, K = (J, Z, X) => {
    if (!J) return Z;
    let ee = V(J.semver, Z.semver, X);
    return ee > 0 ? J : ee < 0 || Z.operator === ">" && J.operator === ">=" ? Z : J;
  }, Y = (J, Z, X) => {
    if (!J) return Z;
    let ee = V(J.semver, Z.semver, X);
    return ee < 0 ? J : ee > 0 || Z.operator === "<" && J.operator === "<=" ? Z : J;
  };
  S.exports = z;
} }), require_semver2 = __commonJS({ "../../node_modules/semver/index.js"(T, S) {
  var R = require_re(), k = require_constants(), D = require_semver(), L = require_identifiers(), V = require_parse(), z = require_valid(), W = require_clean(), U = require_inc(), q = require_diff(), K = require_major(), Y = require_minor(), J = require_patch(), Z = require_prerelease(), X = require_compare(), ee = require_rcompare(), te = require_compare_loose(), re = require_compare_build(), Q = require_sort(), ne = require_rsort(), oe = require_gt(), ae = require_lt(), se = require_eq(), ie = require_neq(), he = require_gte(), xe = require_lte(), Pe = require_cmp(), Re = require_coerce(), ke = require_comparator(), Te = require_range(), fe = require_satisfies(), ue = require_to_comparators(), Ce = require_max_satisfying(), ce = require_min_satisfying(), pe = require_min_version(), _e = require_valid2(), ge = require_outside(), Ae = require_gtr(), Ee = require_ltr(), ve = require_intersects(), le = require_simplify(), me = require_subset();
  S.exports = { parse: V, valid: z, clean: W, inc: U, diff: q, major: K, minor: Y, patch: J, prerelease: Z, compare: X, rcompare: ee, compareLoose: te, compareBuild: re, sort: Q, rsort: ne, gt: oe, lt: ae, eq: se, neq: ie, gte: he, lte: xe, cmp: Pe, coerce: Re, Comparator: ke, Range: Te, satisfies: fe, toComparators: ue, maxSatisfying: Ce, minSatisfying: ce, minVersion: pe, validRange: _e, outside: ge, gtr: Ae, ltr: Ee, intersects: ve, simplifyRange: le, subset: me, SemVer: D, re: R.re, src: R.src, tokens: R.t, SEMVER_SPEC_VERSION: k.SEMVER_SPEC_VERSION, RELEASE_TYPES: k.RELEASE_TYPES, compareIdentifiers: L.compareIdentifiers, rcompareIdentifiers: L.rcompareIdentifiers };
} }), createContext = ({ api: T, state: S }) => createContext$1({ api: T, state: S }), store_setup_default = (T) => {
  T.fn("set", function(S, R) {
    return T.set(this._area, this._in(S), stringify$4(R, { maxDepth: 50 }));
  }), T.fn("get", function(S, R) {
    let k = T.get(this._area, this._in(S));
    return k !== null ? parse$5(k) : R || k;
  });
};
store_setup_default(store$1._);
var STORAGE_KEY$1 = "@storybook/manager/store";
function get(T) {
  return T.get(STORAGE_KEY$1) || {};
}
function set(T, S) {
  return T.set(STORAGE_KEY$1, S);
}
function update(T, S) {
  let R = get(T);
  return set(T, { ...R, ...S });
}
var Store = class {
  constructor({ setState: T, getState: S }) {
    this.upstreamSetState = T, this.upstreamGetState = S;
  }
  getInitialState(T) {
    return { ...T, ...get(store$1.local), ...get(store$1.session) };
  }
  getState() {
    return this.upstreamGetState();
  }
  async setState(T, S, R) {
    let k, D;
    typeof S == "function" ? (k = S, D = R) : D = S;
    let { persistence: L = "none" } = D || {}, V = {}, z = {};
    typeof T == "function" ? V = (U) => (z = T(U), z) : (V = T, z = V);
    let W = await new Promise((U) => {
      this.upstreamSetState(V, () => {
        U(this.getState());
      });
    });
    if (L !== "none") {
      let U = L === "session" ? store$1.session : store$1.local;
      await update(U, z);
    }
    return k && k(W), W;
  }
}, merge_default = (T, S) => mergeWith$1({}, T, S, (R, k) => {
  if (Array.isArray(k) && Array.isArray(R)) return k.forEach((D) => {
    R.find((L) => L === D || isEqual$1(L, D)) || R.push(D);
  }), R;
  if (Array.isArray(R)) return logger.log(["the types mismatch, picking", R]), R;
}), main$2 = (...T) => T.reduce((S, R) => merge_default(S, R), {}), initial_state_default = main$2, provider_exports = {};
__export(provider_exports, { init: () => init });
var init = ({ provider: T, fullAPI: S }) => ({ api: T.renderPreview ? { renderPreview: T.renderPreview } : {}, state: {}, init: () => {
  T.handleAPI(S);
} }), addons_exports = {};
__export(addons_exports, { ensurePanel: () => ensurePanel, init: () => init2 });
function ensurePanel(T, S, R) {
  let k = Object.keys(T);
  return k.indexOf(S) >= 0 ? S : k.length ? k[0] : R;
}
var init2 = ({ provider: T, store: S, fullAPI: R }) => {
  let k = { getElements: (D) => T.getElements(D), getSelectedPanel: () => {
    let { selectedPanel: D } = S.getState();
    return ensurePanel(k.getElements(Addon_TypesEnum.PANEL), D, D);
  }, setSelectedPanel: (D) => {
    S.setState({ selectedPanel: D }, { persistence: "session" });
  }, setAddonState(D, L, V) {
    let z = typeof L == "function" ? L : () => L;
    return S.setState((W) => ({ ...W, addons: { ...W.addons, [D]: z(W.addons[D]) } }), V).then(() => k.getAddonState(D));
  }, getAddonState: (D) => S.getState().addons[D] || globalThis?.STORYBOOK_ADDON_STATE[D] };
  return { api: k, state: { selectedPanel: ensurePanel(k.getElements(Addon_TypesEnum.PANEL), S.getState().selectedPanel), addons: {} } };
}, channel_exports = {};
__export(channel_exports, { init: () => init3 });
var init3 = ({ provider: T }) => ({ api: { getChannel: () => T.channel, on: (S, R) => (T.channel?.on(S, R), () => T.channel?.off(S, R)), off: (S, R) => T.channel?.off(S, R), once: (S, R) => T.channel?.once(S, R), emit: (S, R, ...k) => {
  R?.options?.target && R.options.target !== "storybook-preview-iframe" && !R.options.target.startsWith("storybook-ref-") && (R.options.target = R.options.target !== "storybook_internal" ? `storybook-ref-${R.options.target}` : "storybook-preview-iframe"), T.channel?.emit(S, R, ...k);
} }, state: {} }), notifications_exports = {};
__export(notifications_exports, { init: () => init4 });
var init4 = ({ store: T }) => ({ api: { addNotification: (S) => {
  T.setState(({ notifications: R }) => {
    let [k, D] = partition$1(R, (L) => L.id === S.id);
    return k.forEach((L) => {
      L.onClear && L.onClear({ dismissed: !1, timeout: !1 });
    }), { notifications: [...D, S] };
  });
}, clearNotification: (S) => {
  T.setState(({ notifications: R }) => {
    let [k, D] = partition$1(R, (L) => L.id === S);
    return k.forEach((L) => {
      L.onClear && L.onClear({ dismissed: !1, timeout: !1 });
    }), { notifications: D };
  });
} }, state: { notifications: [] } }), settings_exports = {};
__export(settings_exports, { init: () => init5 });
var init5 = ({ store: T, navigate: S, fullAPI: R }) => ({ state: { settings: { lastTrackedStoryId: null } }, api: { closeSettings: () => {
  let { settings: { lastTrackedStoryId: k } } = T.getState();
  k ? R.selectStory(k) : R.selectFirstStory();
}, changeSettingsTab: (k) => {
  S(`/settings/${k}`);
}, isSettingsScreenActive: () => {
  let { path: k } = R.getUrlState();
  return !!(k || "").match(/^\/settings/);
}, retrieveSelection() {
  let { settings: k } = T.getState();
  return k.lastTrackedStoryId;
}, storeSelection: async () => {
  let { storyId: k, settings: D } = T.getState();
  await T.setState({ settings: { ...D, lastTrackedStoryId: k } });
} } }), stories_exports = {};
__export(stories_exports, { init: () => init7 });
var refs_exports = {};
__export(refs_exports, { defaultStoryMapper: () => defaultStoryMapper, getSourceType: () => getSourceType, init: () => init6 });
var TITLE_PATH_SEPARATOR = /\s*\/\s*/, denormalizeStoryParameters = ({ globalParameters: T, kindParameters: S, stories: R }) => mapValues$1(R, (k) => ({ ...k, parameters: combineParameters(T, S[k.kind], k.parameters) })), transformSetStoriesStoryDataToPreparedStoryIndex = (T) => ({ v: 5, entries: Object.entries(T).reduce((S, [R, k]) => {
  if (!k) return S;
  let { docsOnly: D, fileName: L, ...V } = k.parameters, z = { title: k.kind, id: R, name: k.name, importPath: L };
  if (D) S[R] = { type: "docs", tags: ["stories-mdx"], storiesImports: [], ...z };
  else {
    let { argTypes: W, args: U, initialArgs: q } = k;
    S[R] = { type: "story", ...z, parameters: V, argTypes: W, args: U, initialArgs: q };
  }
  return S;
}, {}) }), transformStoryIndexV2toV3 = (T) => ({ v: 3, stories: Object.values(T.stories).reduce((S, R) => (S[R.id] = { ...R, title: R.kind, name: R.name || R.story, importPath: R.parameters.fileName || "" }, S), {}) }), transformStoryIndexV3toV4 = (T) => {
  let S = countBy$1(Object.values(T.stories), "title");
  return { v: 4, entries: Object.values(T.stories).reduce((R, k) => {
    let D = "story";
    return (k.parameters?.docsOnly || k.name === "Page" && S[k.title] === 1) && (D = "docs"), R[k.id] = { type: D, ...D === "docs" && { tags: ["stories-mdx"], storiesImports: [] }, ...k }, delete R[k.id].story, delete R[k.id].kind, R;
  }, {}) };
}, transformStoryIndexV4toV5 = (T) => ({ v: 5, entries: Object.values(T.entries).reduce((S, R) => (S[R.id] = { ...R, tags: R.tags ? ["dev", "test", ...R.tags] : ["dev"] }, S), {}) }), transformStoryIndexToStoriesHash = (T, { provider: S, docsOptions: R, filters: k, status: D }) => {
  if (!T.v) throw new Error("Composition: Missing stories.json version");
  let L = T;
  L = L.v === 2 ? transformStoryIndexV2toV3(L) : L, L = L.v === 3 ? transformStoryIndexV3toV4(L) : L, L = L.v === 4 ? transformStoryIndexV4toV5(L) : L, L = L;
  let V = Object.values(L.entries).filter((X) => {
    let ee = !0;
    return Object.values(k).forEach((te) => {
      ee !== !1 && (ee = te({ ...X, status: D[X.id] }));
    }), ee;
  }), { sidebar: z = {} } = S.getConfig(), { showRoots: W, collapsedRoots: U = [], renderLabel: q } = z, K = typeof W < "u", Y = V.reduce((X, ee) => {
    if (R.docsMode && ee.type !== "docs") return X;
    let { title: te } = ee, re = te.trim().split(TITLE_PATH_SEPARATOR), Q = (!K || W) && re.length > 1 ? [re.shift()] : [], ne = [...Q, ...re], oe = ne.reduce((ae, se, ie) => {
      let he = ie > 0 && ae[ie - 1], xe = O(he ? `${he}-${se}` : se);
      if (he === xe) throw new Error(dedent$1`
          Invalid part '${se}', leading to id === parentId ('${xe}'), inside title '${te}'
          
          Did you create a path that uses the separator char accidentally, such as 'Vue <docs/>' where '/' is a separator char? See https://github.com/storybookjs/storybook/issues/6128
          `);
      return ae.push(xe), ae;
    }, []);
    return oe.forEach((ae, se) => {
      let ie = oe[se + 1] || ee.id;
      Q.length && se === 0 ? X[ae] = merge_default(X[ae] || {}, { type: "root", id: ae, name: ne[se], depth: se, renderLabel: q, startCollapsed: U.includes(ae), children: [ie] }) : (!X[ae] || X[ae].type === "component") && se === oe.length - 1 ? X[ae] = merge_default(X[ae] || {}, { type: "component", id: ae, name: ne[se], parent: oe[se - 1], depth: se, renderLabel: q, ...ie && { children: [ie] } }) : X[ae] = merge_default(X[ae] || {}, { type: "group", id: ae, name: ne[se], parent: oe[se - 1], depth: se, renderLabel: q, ...ie && { children: [ie] } });
    }), X[ee.id] = { type: "story", ...ee, depth: oe.length, parent: oe[oe.length - 1], renderLabel: q, prepared: !!ee.parameters }, X;
  }, {});
  function J(X, ee) {
    return X[ee.id] || (X[ee.id] = ee, (ee.type === "root" || ee.type === "group" || ee.type === "component") && ee.children.forEach((te) => J(X, Y[te]))), X;
  }
  let Z = Object.values(Y).filter((X) => X.type !== "root" && !X.parent).reduce(J, {});
  return Object.values(Y).filter((X) => X.type === "root").reduce(J, Z);
}, addPreparedStories = (T, S) => S ? Object.fromEntries(Object.entries(T).map(([R, k]) => {
  let D = S[R];
  return k.type === "story" && D?.type === "story" && D.prepared ? [R, { ...D, ...k, prepared: !0 }] : [R, k];
})) : T, getComponentLookupList = memoize$3(1)((T) => Object.entries(T).reduce((S, R) => {
  let k = R[1];
  return k.type === "component" && S.push([...k.children]), S;
}, [])), getStoriesLookupList = memoize$3(1)((T) => Object.keys(T).filter((S) => ["story", "docs"].includes(T[S].type))), { location, fetch } = scope, getSourceType = (T, S) => {
  let { origin: R, pathname: k } = location, { origin: D, pathname: L } = new URL(T), V = `${R + k}`.replace("/iframe.html", "").replace(/\/$/, ""), z = `${D + L}`.replace("/iframe.html", "").replace(/\/$/, "");
  return V === z ? ["local", z] : S || T ? ["external", z] : [null, null];
}, defaultStoryMapper = (T, S) => ({ ...S, kind: S.kind.replace("|", "/") }), addRefIds = (T, S) => Object.entries(T).reduce((R, [k, D]) => ({ ...R, [k]: { ...D, refId: S.id } }), {});
async function handleRequest(T) {
  if (!T) return {};
  try {
    let S = await T;
    if (S === !1 || S === !0) throw new Error("Unexpected boolean response");
    if (!S.ok) throw new Error(`Unexpected response not OK: ${S.statusText}`);
    let R = await S.json();
    return R.entries || R.stories ? { storyIndex: R } : R;
  } catch (S) {
    return { indexError: S };
  }
}
var parseUrl = (T) => {
  let S = /https?:\/\/(.+:.+)@/, R = T, k, [, D] = T.match(S) || [];
  return D && (R = T.replace(`${D}@`, ""), k = btoa(`${D}`)), { url: R, authorization: k };
}, map = (T, S, R) => {
  let { storyMapper: k } = R;
  return k ? Object.entries(T).reduce((D, [L, V]) => ({ ...D, [L]: k(S, V) }), {}) : T;
}, init6 = ({ store: T, provider: S, singleStory: R, docsOptions: k = {} }, { runCheck: D = !0 } = {}) => {
  let L = { findRef: (W) => {
    let U = L.getRefs();
    return Object.values(U).find(({ url: q }) => q.match(W));
  }, changeRefVersion: async (W, U) => {
    let { versions: q, title: K } = L.getRefs()[W], Y = { id: W, url: U, versions: q, title: K, index: {}, expanded: !0 };
    await L.setRef(W, { ...Y, type: "unknown" }, !1), await L.checkRef(Y);
  }, changeRefState: (W, U) => {
    let { [W]: q, ...K } = L.getRefs();
    K[W] = { ...q, previewInitialized: U }, T.setState({ refs: K });
  }, checkRef: async (W) => {
    let { id: U, url: q, version: K, type: Y } = W, J = Y === "server-checked", Z = {}, X = K ? `?version=${K}` : "", ee = J ? "omit" : "include", te = parseUrl(q), re = { Accept: "application/json" };
    te.authorization && Object.assign(re, { Authorization: `Basic ${te.authorization}` });
    let [Q, ne] = await Promise.all(["index.json", "stories.json"].map(async (ae) => handleRequest(fetch(`${te.url}/${ae}${X}`, { headers: re, credentials: ee }))));
    if (!Q.indexError || !ne.indexError) {
      let ae = await handleRequest(fetch(`${te.url}/metadata.json${X}`, { headers: re, credentials: ee, cache: "no-cache" }).catch(() => !1));
      Object.assign(Z, { ...Q.indexError ? ne : Q, ...!ae.indexError && ae });
    } else J || (Z.indexError = { message: dedent$1`
            Error: Loading of ref failed
              at fetch (lib/api/src/modules/refs.ts)

            URL: ${te.url}

            We weren't able to load the above URL,
            it's possible a CORS error happened.

            Please check your dev-tools network tab.
          ` });
    let oe = W.versions && Object.keys(W.versions).length ? W.versions : Z.versions;
    await L.setRef(U, { id: U, url: te.url, ...Z, ...oe ? { versions: oe } : {}, type: Z.storyIndex ? "lazy" : "auto-inject" });
  }, getRefs: () => {
    let { refs: W = {} } = T.getState();
    return W;
  }, setRef: async (W, { storyIndex: U, setStoriesData: q, ...K }, Y = !1) => {
    if (R) return;
    let J, Z, { filters: X } = T.getState(), { storyMapper: ee = defaultStoryMapper } = S.getConfig(), te = L.getRefs()[W];
    (U || q) && (J = q ? transformSetStoriesStoryDataToPreparedStoryIndex(map(q, te, { storyMapper: ee })) : U, Z = transformStoryIndexToStoriesHash(U, { provider: S, docsOptions: k, filters: X, status: {} })), Z && (Z = addRefIds(Z, te)), await L.updateRef(W, { ...te, ...K, index: Z, internal_index: J });
  }, updateRef: async (W, U) => {
    let { [W]: q, ...K } = L.getRefs();
    K[W] = { ...q, ...U };
    let Y = Object.keys(z).reduce((J, Z) => (J[Z] = K[Z], J), {});
    await T.setState({ refs: Y });
  } }, V = !R && scope.REFS || {}, z = V;
  return D && new Promise(async (W) => {
    for (let U of Object.values(V)) await L.checkRef({ ...U, stories: {} });
    W(void 0);
  }), { api: L, state: { refs: z } };
}, getEventMetadata = (T, S) => {
  let { source: R, refId: k, type: D } = T, [L, V] = getSourceType(R, k), z;
  (k || L === "external") && (z = k && S.getRefs()[k] ? S.getRefs()[k] : S.findRef(V));
  let W = { source: R, sourceType: L, sourceLocation: V, refId: k, ref: z, type: D };
  switch (!0) {
    case typeof k == "string":
    case L === "local":
    case L === "external":
      return W;
    default:
      return logger.warn(`Received a ${D} frame that was not configured as a ref`), null;
  }
}, { fetch: fetch2 } = scope, STORY_INDEX_PATH = "./index.json", removedOptions = ["enableShortcuts", "theme", "showRoots"];
function removeRemovedOptions(T) {
  if (!T || typeof T == "string") return T;
  let S = { ...T };
  return removedOptions.forEach((R) => {
    R in S && delete S[R];
  }), S;
}
var init7 = ({ fullAPI: T, store: S, navigate: R, provider: k, storyId: D, viewMode: L, docsOptions: V = {} }) => {
  let z = { storyId: G, getData: (U, q) => {
    let K = z.resolveStory(U, q);
    if (K?.type === "story" || K?.type === "docs") return K;
  }, isPrepared: (U, q) => {
    let K = z.getData(U, q);
    return K ? K.type === "story" ? K.prepared : !0 : !1;
  }, resolveStory: (U, q) => {
    let { refs: K, index: Y } = S.getState();
    if (!(q && !K[q])) return q ? K[q].index ? K[q].index[U] : void 0 : Y ? Y[U] : void 0;
  }, getCurrentStoryData: () => {
    let { storyId: U, refId: q } = S.getState();
    return z.getData(U, q);
  }, getParameters: (U, q) => {
    let { storyId: K, refId: Y } = typeof U == "string" ? { storyId: U, refId: void 0 } : U, J = z.getData(K, Y);
    if (["story", "docs"].includes(J?.type)) {
      let { parameters: Z } = J;
      if (Z) return q ? Z[q] : Z;
    }
    return null;
  }, getCurrentParameter: (U) => {
    let { storyId: q, refId: K } = S.getState();
    return z.getParameters({ storyId: q, refId: K }, U) || void 0;
  }, jumpToComponent: (U) => {
    let { index: q, storyId: K, refs: Y, refId: J } = S.getState();
    if (!z.getData(K, J)) return;
    let Z = J ? Y[J].index || {} : q;
    if (!Z) return;
    let X = z.findSiblingStoryId(K, Z, U, !0);
    X && z.selectStory(X, void 0, { ref: J });
  }, jumpToStory: (U) => {
    let { index: q, storyId: K, refs: Y, refId: J } = S.getState(), Z = z.getData(K, J);
    if (!Z) return;
    let X = Z.refId ? Y[Z.refId].index : q;
    if (!X) return;
    let ee = z.findSiblingStoryId(K, X, U, !1);
    ee && z.selectStory(ee, void 0, { ref: J });
  }, selectFirstStory: () => {
    let { index: U } = S.getState();
    if (!U) return;
    let q = Object.keys(U).find((K) => U[K].type === "story");
    if (q) {
      z.selectStory(q);
      return;
    }
    R("/");
  }, selectStory: (U = void 0, q = void 0, K = {}) => {
    let { ref: Y } = K, { storyId: J, index: Z, refs: X } = S.getState(), ee = Y ? X[Y].index : Z, te = J?.split("--", 2)[0];
    if (ee) if (q) if (U) {
      let re = Y ? `${Y}_${G(U, q)}` : G(U, q);
      if (ee[re]) z.selectStory(re, void 0, K);
      else {
        let Q = ee[O(U)];
        if (Q?.type === "component") {
          let ne = Q.children.find((oe) => ee[oe].name === q);
          ne && z.selectStory(ne, void 0, K);
        }
      }
    } else {
      let re = G(te, q);
      z.selectStory(re, void 0, K);
    }
    else {
      let re = U ? ee[U] || ee[O(U)] : ee[te];
      if (!re) throw new Error(`Unknown id or title: '${U}'`);
      S.setState({ settings: { ...S.getState().settings, lastTrackedStoryId: re.id } });
      let Q = z.findLeafEntry(ee, re.id), ne = Q.refId ? `${Q.refId}_${Q.id}` : Q.id;
      R(`/${Q.type}/${ne}`);
    }
  }, findLeafEntry(U, q) {
    let K = U[q];
    if (K.type === "docs" || K.type === "story") return K;
    let Y = K.children[0];
    return z.findLeafEntry(U, Y);
  }, findLeafStoryId(U, q) {
    return z.findLeafEntry(U, q)?.id;
  }, findSiblingStoryId(U, q, K, Y) {
    if (Y) {
      let X = getComponentLookupList(q), ee = X.findIndex((te) => te.includes(U));
      return ee === X.length - 1 && K > 0 || ee === 0 && K < 0 ? void 0 : X[ee + K] ? X[ee + K][0] : void 0;
    }
    let J = getStoriesLookupList(q), Z = J.indexOf(U);
    if (!(Z === J.length - 1 && K > 0) && !(Z === 0 && K < 0)) return J[Z + K];
  }, updateStoryArgs: (U, q) => {
    let { id: K, refId: Y } = U;
    k.channel?.emit(UPDATE_STORY_ARGS, { storyId: K, updatedArgs: q, options: { target: Y } });
  }, resetStoryArgs: (U, q) => {
    let { id: K, refId: Y } = U;
    k.channel?.emit(RESET_STORY_ARGS, { storyId: K, argNames: q, options: { target: Y } });
  }, fetchIndex: async () => {
    try {
      let U = await fetch2(STORY_INDEX_PATH);
      if (U.status !== 200) throw new Error(await U.text());
      let q = await U.json();
      if (q.v < 3) {
        logger.warn(`Skipping story index with version v${q.v}, awaiting SET_STORIES.`);
        return;
      }
      await z.setIndex(q);
    } catch (U) {
      await S.setState({ indexError: U });
    }
  }, setIndex: async (U) => {
    let { index: q, status: K, filters: Y } = S.getState(), J = transformStoryIndexToStoriesHash(U, { provider: k, docsOptions: V, status: K, filters: Y }), Z = addPreparedStories(J, q);
    await S.setState({ internal_index: U, index: Z, indexError: void 0 });
  }, updateStory: async (U, q, K) => {
    if (K) {
      let { id: Y, index: J } = K;
      J[U] = { ...J[U], ...q }, await T.updateRef(Y, { index: J });
    } else {
      let { index: Y } = S.getState();
      if (!Y) return;
      Y[U] = { ...Y[U], ...q }, await S.setState({ index: Y });
    }
  }, updateDocs: async (U, q, K) => {
    if (K) {
      let { id: Y, index: J } = K;
      J[U] = { ...J[U], ...q }, await T.updateRef(Y, { index: J });
    } else {
      let { index: Y } = S.getState();
      if (!Y) return;
      Y[U] = { ...Y[U], ...q }, await S.setState({ index: Y });
    }
  }, setPreviewInitialized: async (U) => {
    U ? T.updateRef(U.id, { previewInitialized: !0 }) : S.setState({ previewInitialized: !0 });
  }, experimental_updateStatus: async (U, q) => {
    let { status: K, internal_index: Y } = S.getState(), J = { ...K }, Z = typeof q == "function" ? q(K) : q;
    if (Object.keys(Z).length !== 0 && (Object.entries(Z).forEach(([X, ee]) => {
      J[X] = { ...J[X] || {} }, ee === null ? delete J[X][U] : J[X][U] = ee, Object.keys(J[X]).length === 0 && delete J[X];
    }), await S.setState({ status: J }, { persistence: "session" }), Y)) {
      await z.setIndex(Y);
      let X = await T.getRefs();
      Object.entries(X).forEach(([ee, { internal_index: te, ...re }]) => {
        T.setRef(ee, { ...re, storyIndex: te }, !0);
      });
    }
  }, experimental_setFilter: async (U, q) => {
    await S.setState({ filters: { ...S.getState().filters, [U]: q } });
    let { internal_index: K } = S.getState();
    if (!K) return;
    await z.setIndex(K);
    let Y = await T.getRefs();
    Object.entries(Y).forEach(([J, { internal_index: Z, ...X }]) => {
      T.setRef(J, { ...X, storyIndex: Z }, !0);
    });
  } };
  k.channel?.on(STORY_SPECIFIED, function({ storyId: U, viewMode: q }) {
    let { sourceType: K } = getEventMetadata(this, T);
    if (K === "local") {
      let Y = S.getState(), J = Y.path === "/" || Y.viewMode === "story" || Y.viewMode === "docs", Z = Y.viewMode && Y.storyId, X = Y.viewMode !== q || Y.storyId !== U, { type: ee } = Y.index?.[Y.storyId] || {};
      J && (Z && X && !(ee === "root" || ee === "component" || ee === "group") ? k.channel?.emit(SET_CURRENT_STORY, { storyId: Y.storyId, viewMode: Y.viewMode }) : X && R(`/${q}/${U}`));
    }
  }), k.channel?.on(CURRENT_STORY_WAS_SET, function() {
    let { ref: U } = getEventMetadata(this, T);
    z.setPreviewInitialized(U);
  }), k.channel?.on(STORY_CHANGED, function() {
    let { sourceType: U } = getEventMetadata(this, T);
    if (U === "local") {
      let q = z.getCurrentParameter("options");
      q && T.setOptions(removeRemovedOptions(q));
    }
  }), k.channel?.on(STORY_PREPARED, function({ id: U, ...q }) {
    let { ref: K, sourceType: Y } = getEventMetadata(this, T);
    if (z.updateStory(U, { ...q, prepared: !0 }, K), !K && !S.getState().hasCalledSetOptions) {
      let { options: J } = q.parameters;
      T.setOptions(removeRemovedOptions(J)), S.setState({ hasCalledSetOptions: !0 });
    }
    if (Y === "local") {
      let { storyId: J, index: Z, refId: X } = S.getState();
      if (!Z) return;
      let ee = Array.from(/* @__PURE__ */ new Set([z.findSiblingStoryId(J, Z, 1, !0), z.findSiblingStoryId(J, Z, -1, !0)])).filter(Boolean);
      k.channel?.emit(PRELOAD_ENTRIES, { ids: ee, options: { target: X } });
    }
  }), k.channel?.on(DOCS_PREPARED, function({ id: U, ...q }) {
    let { ref: K } = getEventMetadata(this, T);
    z.updateStory(U, { ...q, prepared: !0 }, K);
  }), k.channel?.on(SET_INDEX, function(U) {
    let { ref: q } = getEventMetadata(this, T);
    if (q) T.setRef(q.id, { ...q, storyIndex: U }, !0);
    else {
      z.setIndex(U);
      let K = z.getCurrentParameter("options");
      T.setOptions(removeRemovedOptions(K));
    }
  }), k.channel?.on(SET_STORIES, function(U) {
    let { ref: q } = getEventMetadata(this, T), K = U.v ? denormalizeStoryParameters(U) : U.stories;
    if (q) T.setRef(q.id, { ...q, setStoriesData: K }, !0);
    else throw new Error("Cannot call SET_STORIES for local frame");
  }), k.channel?.on(SELECT_STORY, function({ kind: U, title: q = U, story: K, name: Y = K, storyId: J, ...Z }) {
    let { ref: X } = getEventMetadata(this, T);
    X ? T.selectStory(J || q, Y, { ...Z, ref: X.id }) : T.selectStory(J || q, Y, Z);
  }), k.channel?.on(STORY_ARGS_UPDATED, function({ storyId: U, args: q }) {
    let { ref: K } = getEventMetadata(this, T);
    z.updateStory(U, { args: q }, K);
  }), k.channel?.on(CONFIG_ERROR, function(U) {
    let { ref: q } = getEventMetadata(this, T);
    z.setPreviewInitialized(q);
  }), k.channel?.on(STORY_MISSING, function(U) {
    let { ref: q } = getEventMetadata(this, T);
    z.setPreviewInitialized(q);
  }), k.channel?.on(SET_CONFIG, () => {
    let U = k.getConfig();
    U?.sidebar?.filters && S.setState({ filters: { ...S.getState().filters, ...U?.sidebar?.filters } });
  });
  let W = k.getConfig();
  return { api: z, state: { storyId: D, viewMode: L, hasCalledSetOptions: !1, previewInitialized: !1, status: {}, filters: W?.sidebar?.filters || {} }, init: async () => {
    k.channel?.on(STORY_INDEX_INVALIDATED, () => z.fetchIndex()), await z.fetchIndex();
  } };
}, layout_exports = {};
__export(layout_exports, { ActiveTabs: () => ActiveTabs, defaultLayoutState: () => defaultLayoutState, focusableUIElements: () => focusableUIElements, init: () => init8 });
var { document: document$2 } = scope, ActiveTabs = { SIDEBAR: "sidebar", CANVAS: "canvas", ADDONS: "addons" }, defaultLayoutState = { ui: { enableShortcuts: !0 }, layout: { initialActive: ActiveTabs.CANVAS, showToolbar: !0, navSize: 300, bottomPanelHeight: 300, rightPanelWidth: 400, recentVisibleSizes: { navSize: 300, bottomPanelHeight: 300, rightPanelWidth: 400 }, panelPosition: "bottom", showTabs: !0 }, selectedPanel: void 0, theme: create$a() }, focusableUIElements = { storySearchField: "storybook-explorer-searchfield", storyListMenu: "storybook-explorer-menu", storyPanelRoot: "storybook-panel-root" }, getIsNavShown = (T) => T.layout.navSize > 0, getIsPanelShown = (T) => {
  let { bottomPanelHeight: S, rightPanelWidth: R, panelPosition: k } = T.layout;
  return k === "bottom" && S > 0 || k === "right" && R > 0;
}, getIsFullscreen = (T) => !getIsNavShown(T) && !getIsPanelShown(T), getRecentVisibleSizes = (T) => ({ navSize: T.navSize > 0 ? T.navSize : T.recentVisibleSizes.navSize, bottomPanelHeight: T.bottomPanelHeight > 0 ? T.bottomPanelHeight : T.recentVisibleSizes.bottomPanelHeight, rightPanelWidth: T.rightPanelWidth > 0 ? T.rightPanelWidth : T.recentVisibleSizes.rightPanelWidth }), init8 = ({ store: T, provider: S, singleStory: R }) => {
  let k = { toggleFullscreen(L) {
    return T.setState((V) => {
      let z = getIsFullscreen(V), W = typeof L == "boolean" ? L : !z;
      return W === z ? { layout: V.layout } : W ? { layout: { ...V.layout, navSize: 0, bottomPanelHeight: 0, rightPanelWidth: 0, recentVisibleSizes: getRecentVisibleSizes(V.layout) } } : { layout: { ...V.layout, navSize: V.singleStory ? 0 : V.layout.recentVisibleSizes.navSize, bottomPanelHeight: V.layout.recentVisibleSizes.bottomPanelHeight, rightPanelWidth: V.layout.recentVisibleSizes.rightPanelWidth } };
    }, { persistence: "session" });
  }, togglePanel(L) {
    return T.setState((V) => {
      let z = getIsPanelShown(V), W = typeof L == "boolean" ? L : !z;
      return W === z ? { layout: V.layout } : W ? { layout: { ...V.layout, bottomPanelHeight: V.layout.recentVisibleSizes.bottomPanelHeight, rightPanelWidth: V.layout.recentVisibleSizes.rightPanelWidth } } : { layout: { ...V.layout, bottomPanelHeight: 0, rightPanelWidth: 0, recentVisibleSizes: getRecentVisibleSizes(V.layout) } };
    }, { persistence: "session" });
  }, togglePanelPosition(L) {
    return T.setState((V) => {
      let z = L || (V.layout.panelPosition === "right" ? "bottom" : "right");
      return { layout: { ...V.layout, panelPosition: z, bottomPanelHeight: V.layout.recentVisibleSizes.bottomPanelHeight, rightPanelWidth: V.layout.recentVisibleSizes.rightPanelWidth } };
    }, { persistence: "permanent" });
  }, toggleNav(L) {
    return T.setState((V) => {
      if (V.singleStory) return { layout: V.layout };
      let z = getIsNavShown(V), W = typeof L == "boolean" ? L : !z;
      return W === z ? { layout: V.layout } : W ? { layout: { ...V.layout, navSize: V.layout.recentVisibleSizes.navSize } } : { layout: { ...V.layout, navSize: 0, recentVisibleSizes: getRecentVisibleSizes(V.layout) } };
    }, { persistence: "session" });
  }, toggleToolbar(L) {
    return T.setState((V) => {
      let z = typeof L < "u" ? L : !V.layout.showToolbar;
      return { layout: { ...V.layout, showToolbar: z } };
    }, { persistence: "session" });
  }, setSizes({ navSize: L, bottomPanelHeight: V, rightPanelWidth: z }) {
    return T.setState((W) => {
      let U = { ...W.layout, navSize: L ?? W.layout.navSize, bottomPanelHeight: V ?? W.layout.bottomPanelHeight, rightPanelWidth: z ?? W.layout.rightPanelWidth };
      return { layout: { ...U, recentVisibleSizes: getRecentVisibleSizes(U) } };
    }, { persistence: "session" });
  }, focusOnUIElement(L, V) {
    if (!L) return;
    let z = document$2.getElementById(L);
    z && (z.focus(), V && z.select());
  }, getInitialOptions() {
    let { theme: L, selectedPanel: V, ...z } = S.getConfig();
    return { ...defaultLayoutState, layout: { ...defaultLayoutState.layout, ...pick$2(z, Object.keys(defaultLayoutState.layout)), ...R && { navSize: 0 } }, ui: { ...defaultLayoutState.ui, ...pick$2(z, Object.keys(defaultLayoutState.ui)) }, selectedPanel: V || defaultLayoutState.selectedPanel, theme: L || defaultLayoutState.theme };
  }, getIsFullscreen() {
    return getIsFullscreen(T.getState());
  }, getIsPanelShown() {
    return getIsPanelShown(T.getState());
  }, getIsNavShown() {
    return getIsNavShown(T.getState());
  }, setOptions: (L) => {
    let { layout: V, ui: z, selectedPanel: W, theme: U } = T.getState();
    if (!L) return;
    let q = { ...V, ...L.layout, ...pick$2(L, Object.keys(V)), ...R && { navSize: 0 } }, K = { ...z, ...L.ui, ...pick$2(L, Object.keys(z)) }, Y = { ...U, ...L.theme }, J = {};
    dequal$1(z, K) || (J.ui = K), dequal$1(V, q) || (J.layout = q), L.selectedPanel && !dequal$1(W, L.selectedPanel) && (J.selectedPanel = L.selectedPanel), Object.keys(J).length && T.setState(J, { persistence: "permanent" }), dequal$1(U, Y) || T.setState({ theme: Y });
  } }, D = pick$2(T.getState(), "layout", "selectedPanel");
  return S.channel?.on(SET_CONFIG, () => {
    k.setOptions(merge_default(k.getInitialOptions(), D));
  }), { api: k, state: merge_default(k.getInitialOptions(), D) };
}, shortcuts_exports = {};
__export(shortcuts_exports, { controlOrMetaKey: () => controlOrMetaKey2, defaultShortcuts: () => defaultShortcuts, init: () => init9, isMacLike: () => isMacLike2, keys: () => keys });
var eventToShortcut = (T) => {
  if (["Meta", "Alt", "Control", "Shift"].includes(T.key)) return null;
  let S = [];
  if (T.altKey && S.push("alt"), T.ctrlKey && S.push("control"), T.metaKey && S.push("meta"), T.shiftKey && S.push("shift"), T.key && T.key.length === 1 && T.key !== " ") {
    let R = T.key.toUpperCase(), k = T.code?.toUpperCase().replace("KEY", "").replace("DIGIT", "");
    k && k.length === 1 && k !== R ? S.push([R, k]) : S.push(R);
  }
  return T.key === " " && S.push("space"), T.key === "Escape" && S.push("escape"), T.key === "ArrowRight" && S.push("ArrowRight"), T.key === "ArrowDown" && S.push("ArrowDown"), T.key === "ArrowUp" && S.push("ArrowUp"), T.key === "ArrowLeft" && S.push("ArrowLeft"), S.length > 0 ? S : null;
}, shortcutMatchesShortcut = (T, S) => !T || !S || (T.join("").startsWith("shift/") && T.shift(), T.length !== S.length) ? !1 : !T.find((R, k) => Array.isArray(R) ? !R.includes(S[k]) : R !== S[k]), { navigator: navigator2, document: document2$1 } = scope, isMacLike2 = () => navigator2 && navigator2.platform ? !!navigator2.platform.match(/(Mac|iPhone|iPod|iPad)/i) : !1, controlOrMetaKey2 = () => isMacLike2() ? "meta" : "control";
function keys(T) {
  return Object.keys(T);
}
var defaultShortcuts = Object.freeze({ fullScreen: ["alt", "F"], togglePanel: ["alt", "A"], panelPosition: ["alt", "D"], toggleNav: ["alt", "S"], toolbar: ["alt", "T"], search: [controlOrMetaKey2(), "K"], focusNav: ["1"], focusIframe: ["2"], focusPanel: ["3"], prevComponent: ["alt", "ArrowUp"], nextComponent: ["alt", "ArrowDown"], prevStory: ["alt", "ArrowLeft"], nextStory: ["alt", "ArrowRight"], shortcutsPage: [controlOrMetaKey2(), "shift", ","], aboutPage: [controlOrMetaKey2(), ","], escape: ["escape"], collapseAll: [controlOrMetaKey2(), "shift", "ArrowUp"], expandAll: [controlOrMetaKey2(), "shift", "ArrowDown"], remount: ["alt", "R"] }), addonsShortcuts = {};
function focusInInput(T) {
  let S = T.target;
  return /input|textarea/i.test(S.tagName) || S.getAttribute("contenteditable") !== null;
}
var init9 = ({ store: T, fullAPI: S, provider: R }) => {
  let k = { getShortcutKeys() {
    return T.getState().shortcuts;
  }, getDefaultShortcuts() {
    return { ...defaultShortcuts, ...k.getAddonsShortcutDefaults() };
  }, getAddonsShortcuts() {
    return addonsShortcuts;
  }, getAddonsShortcutLabels() {
    let V = {};
    return Object.entries(k.getAddonsShortcuts()).forEach(([z, { label: W }]) => {
      V[z] = W;
    }), V;
  }, getAddonsShortcutDefaults() {
    let V = {};
    return Object.entries(k.getAddonsShortcuts()).forEach(([z, { defaultShortcut: W }]) => {
      V[z] = W;
    }), V;
  }, async setShortcuts(V) {
    return await T.setState({ shortcuts: V }, { persistence: "permanent" }), V;
  }, async restoreAllDefaultShortcuts() {
    return k.setShortcuts(k.getDefaultShortcuts());
  }, async setShortcut(V, z) {
    let W = k.getShortcutKeys();
    return await k.setShortcuts({ ...W, [V]: z }), z;
  }, async setAddonShortcut(V, z) {
    let W = k.getShortcutKeys();
    return await k.setShortcuts({ ...W, [`${V}-${z.actionName}`]: z.defaultShortcut }), addonsShortcuts[`${V}-${z.actionName}`] = z, z;
  }, async restoreDefaultShortcut(V) {
    let z = k.getDefaultShortcuts()[V];
    return k.setShortcut(V, z);
  }, handleKeydownEvent(V) {
    let z = eventToShortcut(V), W = k.getShortcutKeys(), U = keys(W).find((q) => shortcutMatchesShortcut(z, W[q]));
    U && k.handleShortcutFeature(U, V);
  }, handleShortcutFeature(V, z) {
    let { ui: { enableShortcuts: W }, storyId: U } = T.getState();
    if (W) switch (z?.preventDefault && z.preventDefault(), V) {
      case "escape": {
        S.getIsFullscreen() ? S.toggleFullscreen(!1) : S.getIsNavShown() && S.toggleNav(!0);
        break;
      }
      case "focusNav": {
        S.getIsFullscreen() && S.toggleFullscreen(!1), S.getIsNavShown() || S.toggleNav(!0), S.focusOnUIElement(focusableUIElements.storyListMenu);
        break;
      }
      case "search": {
        S.getIsFullscreen() && S.toggleFullscreen(!1), S.getIsNavShown() || S.toggleNav(!0), setTimeout(() => {
          S.focusOnUIElement(focusableUIElements.storySearchField, !0);
        }, 0);
        break;
      }
      case "focusIframe": {
        let q = document2$1.getElementById("storybook-preview-iframe");
        if (q) try {
          q.contentWindow.focus();
        } catch {
        }
        break;
      }
      case "focusPanel": {
        S.getIsFullscreen() && S.toggleFullscreen(!1), S.getIsPanelShown() || S.togglePanel(!0), S.focusOnUIElement(focusableUIElements.storyPanelRoot);
        break;
      }
      case "nextStory": {
        S.jumpToStory(1);
        break;
      }
      case "prevStory": {
        S.jumpToStory(-1);
        break;
      }
      case "nextComponent": {
        S.jumpToComponent(1);
        break;
      }
      case "prevComponent": {
        S.jumpToComponent(-1);
        break;
      }
      case "fullScreen": {
        S.toggleFullscreen();
        break;
      }
      case "togglePanel": {
        S.togglePanel();
        break;
      }
      case "toggleNav": {
        S.toggleNav();
        break;
      }
      case "toolbar": {
        S.toggleToolbar();
        break;
      }
      case "panelPosition": {
        S.getIsFullscreen() && S.toggleFullscreen(!1), S.getIsPanelShown() || S.togglePanel(!0), S.togglePanelPosition();
        break;
      }
      case "aboutPage": {
        S.navigate("/settings/about");
        break;
      }
      case "shortcutsPage": {
        S.navigate("/settings/shortcuts");
        break;
      }
      case "collapseAll": {
        S.collapseAll();
        break;
      }
      case "expandAll": {
        S.expandAll();
        break;
      }
      case "remount": {
        S.emit(FORCE_REMOUNT, { storyId: U });
        break;
      }
      default:
        addonsShortcuts[V].action();
        break;
    }
  } }, { shortcuts: D = defaultShortcuts } = T.getState(), L = { shortcuts: keys(defaultShortcuts).reduce((V, z) => ({ ...V, [z]: D[z] || defaultShortcuts[z] }), defaultShortcuts) };
  return { api: k, state: L, init: () => {
    document2$1.addEventListener("keydown", (V) => {
      focusInInput(V) || k.handleKeydownEvent(V);
    }), R.channel?.on(PREVIEW_KEYDOWN, (V) => {
      k.handleKeydownEvent(V.event);
    });
  } };
}, url_exports = {};
__export(url_exports, { init: () => init10 });
var { window: globalWindow } = scope, parseBoolean = (T) => {
  if (T === "true" || T === "1") return !0;
  if (T === "false" || T === "0") return !1;
}, prevParams, initialUrlSupport = ({ state: { location: T, path: S, viewMode: R, storyId: k }, singleStory: D }) => {
  let { full: L, panel: V, nav: z, shortcuts: W, addonPanel: U, tabs: q, path: K, ...Y } = queryFromLocation(T), J, Z, X;
  parseBoolean(L) === !0 ? (J = 0, Z = 0, X = 0) : parseBoolean(L) === !1 && (J = defaultLayoutState.layout.navSize, Z = defaultLayoutState.layout.bottomPanelHeight, X = defaultLayoutState.layout.rightPanelWidth), D || (parseBoolean(z) === !0 && (J = defaultLayoutState.layout.navSize), parseBoolean(z) === !1 && (J = 0)), parseBoolean(V) === !1 && (Z = 0, X = 0);
  let ee = { navSize: J, bottomPanelHeight: Z, rightPanelWidth: X, panelPosition: ["right", "bottom"].includes(V) ? V : void 0, showTabs: parseBoolean(q) }, te = { enableShortcuts: parseBoolean(W) }, re = U || void 0, Q = k, ne = dequal$1(prevParams, Y) ? prevParams : Y;
  return prevParams = ne, { viewMode: R, layout: ee, ui: te, selectedPanel: re, location: T, path: S, customQueryParams: ne, storyId: Q };
}, init10 = (T) => {
  let { store: S, navigate: R, provider: k, fullAPI: D } = T, L = (U, q = {}, K = {}) => {
    let Y = Object.entries(q).filter(([, Z]) => Z).sort(([Z], [X]) => Z < X ? -1 : 1).map(([Z, X]) => `${Z}=${X}`), J = [U, ...Y].join("&");
    return R(J, K);
  }, V = { getQueryParam(U) {
    let { customQueryParams: q } = S.getState();
    return q ? q[U] : void 0;
  }, getUrlState() {
    let { path: U, customQueryParams: q, storyId: K, url: Y, viewMode: J } = S.getState();
    return { path: U, queryParams: q, storyId: K, url: Y, viewMode: J };
  }, setQueryParams(U) {
    let { customQueryParams: q } = S.getState(), K = {}, Y = { ...q, ...Object.entries(U).reduce((J, [Z, X]) => (X !== null && (J[Z] = X), J), K) };
    dequal$1(q, Y) || (S.setState({ customQueryParams: Y }), k.channel?.emit(UPDATE_QUERY_PARAMS, Y));
  }, applyQueryParams(U) {
    let { path: q, queryParams: K } = V.getUrlState();
    L(q, { ...K, ...U }), V.setQueryParams(U);
  }, navigateUrl(U, q) {
    R(U, { plain: !0, ...q });
  } }, z = () => {
    let { path: U, queryParams: q, viewMode: K } = V.getUrlState();
    if (K !== "story") return;
    let Y = D.getCurrentStoryData();
    if (Y?.type !== "story") return;
    let { args: J, initialArgs: Z } = Y, X = buildArgsParam(Z, J);
    L(U, { ...q, args: X }, { replace: !0 }), V.setQueryParams({ args: X });
  };
  k.channel?.on(SET_CURRENT_STORY, () => z());
  let W;
  return k.channel?.on(STORY_ARGS_UPDATED, () => {
    "requestIdleCallback" in globalWindow ? (W && globalWindow.cancelIdleCallback(W), W = globalWindow.requestIdleCallback(z, { timeout: 1e3 })) : (W && clearTimeout(W), setTimeout(z, 100));
  }), k.channel?.on(GLOBALS_UPDATED, ({ globals: U, initialGlobals: q }) => {
    let { path: K, queryParams: Y } = V.getUrlState(), J = buildArgsParam(q, U);
    L(K, { ...Y, globals: J }, { replace: !0 }), V.setQueryParams({ globals: J });
  }), k.channel?.on(NAVIGATE_URL, (U, q) => {
    V.navigateUrl(U, q);
  }), { api: V, state: initialUrlSupport(T) };
}, versions_exports = {};
__export(versions_exports, { init: () => init11 });
var import_semver = __toESM(require_semver2()), version$1 = "8.1.11", { VERSIONCHECK } = scope, getVersionCheckData = memoize$3(1)(() => {
  try {
    return { ...JSON.parse(VERSIONCHECK).data || {} };
  } catch {
    return {};
  }
}), normalizeRendererName = (T) => T.includes("vue") ? "vue" : T, init11 = ({ store: T }) => {
  let { dismissedVersionNotification: S } = T.getState(), R = { versions: { current: { version: version$1 }, ...getVersionCheckData() }, dismissedVersionNotification: S }, k = { getCurrentVersion: () => {
    let { versions: { current: D } } = T.getState();
    return D;
  }, getLatestVersion: () => {
    let { versions: { latest: D, next: L, current: V } } = T.getState();
    return V && import_semver.default.prerelease(V.version) && L ? D && import_semver.default.gt(D.version, L.version) ? D : L : D;
  }, getDocsUrl: ({ subpath: D, versioned: L, renderer: V }) => {
    let { versions: { latest: z, current: W } } = T.getState(), U = "https://storybook.js.org/docs/";
    if (L && W?.version && z?.version) {
      let q = import_semver.default.diff(z.version, W.version);
      q === "patch" || q === null || (U += `${import_semver.default.major(W.version)}.${import_semver.default.minor(W.version)}/`);
    }
    if (D && (U += `${D}/`), V && typeof scope.STORYBOOK_RENDERER < "u") {
      let q = scope.STORYBOOK_RENDERER;
      q && (U += `?renderer=${normalizeRendererName(q)}`);
    }
    return U;
  }, versionUpdateAvailable: () => {
    let D = k.getLatestVersion(), L = k.getCurrentVersion();
    if (D) {
      if (!D.version || !L.version) return !0;
      let V = import_semver.default.prerelease(L.version) ? `${import_semver.default.major(L.version)}.${import_semver.default.minor(L.version)}.${import_semver.default.patch(L.version)}` : L.version, z = import_semver.default.diff(V, D.version);
      return import_semver.default.gt(D.version, V) && z !== "patch" && !z.includes("pre");
    }
    return !1;
  } };
  return { init: async () => {
    let { versions: D = {} } = T.getState(), { latest: L, next: V } = getVersionCheckData();
    await T.setState({ versions: { ...D, latest: L, next: V } });
  }, state: R, api: k };
}, whatsnew_exports = {};
__export(whatsnew_exports, { init: () => init12 });
var WHATS_NEW_NOTIFICATION_ID = "whats-new", init12 = ({ fullAPI: T, store: S, provider: R }) => {
  let k = { whatsNewData: void 0 };
  function D(W) {
    S.setState({ whatsNewData: W }), k.whatsNewData = W;
  }
  let L = { isWhatsNewUnread() {
    return k.whatsNewData?.status === "SUCCESS" && !k.whatsNewData.postIsRead;
  }, whatsNewHasBeenRead() {
    k.whatsNewData?.status === "SUCCESS" && (z({ lastReadPost: k.whatsNewData.url }), D({ ...k.whatsNewData, postIsRead: !0 }), T.clearNotification(WHATS_NEW_NOTIFICATION_ID));
  }, toggleWhatsNewNotifications() {
    k.whatsNewData?.status === "SUCCESS" && (D({ ...k.whatsNewData, disableWhatsNewNotifications: !k.whatsNewData.disableWhatsNewNotifications }), R.channel?.emit(TOGGLE_WHATS_NEW_NOTIFICATIONS, { disableWhatsNewNotifications: k.whatsNewData.disableWhatsNewNotifications }));
  } };
  function V() {
    return R.channel?.emit(REQUEST_WHATS_NEW_DATA), new Promise((W) => R.channel?.once(RESULT_WHATS_NEW_DATA, ({ data: U }) => W(U)));
  }
  function z(W) {
    R.channel?.emit(SET_WHATS_NEW_CACHE, W);
  }
  return { init: async () => {
    if (scope.CONFIG_TYPE !== "DEVELOPMENT") return;
    let W = await V();
    D(W);
    let U = T.getUrlState();
    !(U?.path === "/onboarding" || U.queryParams?.onboarding === "true") && W.status === "SUCCESS" && !W.disableWhatsNewNotifications && W.showNotification && T.addNotification({ id: WHATS_NEW_NOTIFICATION_ID, link: "/settings/whats-new", content: { headline: W.title, subHeadline: "Learn what's new in Storybook" }, icon: React__default.createElement(StorybookIcon, null), onClear({ dismissed: q }) {
      q && z({ lastDismissedPost: W.url });
    } });
  }, state: k, api: L };
}, globals_exports = {};
__export(globals_exports, { init: () => init13 });
var init13 = ({ store: T, fullAPI: S, provider: R }) => {
  let k = { getGlobals() {
    return T.getState().globals;
  }, getGlobalTypes() {
    return T.getState().globalTypes;
  }, updateGlobals(V) {
    R.channel?.emit(UPDATE_GLOBALS, { globals: V, options: { target: "storybook-preview-iframe" } });
  } }, D = { globals: {}, globalTypes: {} }, L = (V) => {
    let z = T.getState()?.globals;
    dequal$1(V, z) || T.setState({ globals: V });
  };
  return R.channel?.on(GLOBALS_UPDATED, function({ globals: V }) {
    let { ref: z } = getEventMetadata(this, S);
    z ? logger.warn("received a GLOBALS_UPDATED from a non-local ref. This is not currently supported.") : L(V);
  }), R.channel?.on(SET_GLOBALS, function({ globals: V, globalTypes: z }) {
    let { ref: W } = getEventMetadata(this, S), U = T.getState()?.globals;
    W ? Object.keys(V).length > 0 && logger.warn("received globals from a non-local ref. This is not currently supported.") : T.setState({ globals: V, globalTypes: z }), U && Object.keys(U).length !== 0 && !dequal$1(V, U) && k.updateGlobals(U);
  }), { api: k, state: D };
};
function mockChannel() {
  let T = { setHandler: () => {
  }, send: () => {
  } };
  return new Channel({ transport: T });
}
var AddonStore = class {
  constructor() {
    this.loaders = {}, this.elements = {}, this.config = {}, this.getChannel = () => (this.channel || this.setChannel(mockChannel()), this.channel), this.ready = () => this.promise, this.hasChannel = () => !!this.channel, this.setChannel = (T) => {
      this.channel = T, this.resolve();
    }, this.setConfig = (T) => {
      Object.assign(this.config, T), this.hasChannel() ? this.getChannel().emit(SET_CONFIG, this.config) : this.ready().then((S) => {
        S.emit(SET_CONFIG, this.config);
      });
    }, this.getConfig = () => this.config, this.register = (T, S) => {
      this.loaders[T] && logger.warn(`${T} was loaded twice, this could have bad side-effects`), this.loaders[T] = S;
    }, this.loadAddons = (T) => {
      Object.values(this.loaders).forEach((S) => S(T));
    }, this.promise = new Promise((T) => {
      this.resolve = () => T(this.getChannel());
    });
  }
  getElements(T) {
    return this.elements[T] || (this.elements[T] = {}), this.elements[T];
  }
  add(T, S) {
    let { type: R } = S, k = this.getElements(R);
    k[T] = { ...S, id: T };
  }
}, KEY$1 = "__STORYBOOK_ADDONS_MANAGER";
function getAddonsStore() {
  return scope[KEY$1] || (scope[KEY$1] = new AddonStore()), scope[KEY$1];
}
getAddonsStore();
var ManagerContext = createContext({ api: void 0, state: initial_state_default({}) }), combineParameters = (...T) => mergeWith$1({}, ...T, (S, R) => {
  if (Array.isArray(R)) return R;
}), ManagerProvider = class extends Component {
  constructor(T) {
    super(T), this.api = {}, this.initModules = () => {
      this.modules.forEach((X) => {
        "init" in X && X.init();
      });
    };
    let { location: S, path: R, refId: k, viewMode: D = T.docsOptions.docsMode ? "docs" : T.viewMode, singleStory: L, storyId: V, docsOptions: z, navigate: W } = T, U = new Store({ getState: () => this.state, setState: (X, ee) => (this.setState(X, () => ee(this.state)), this.state) }), q = { location: S, path: R, viewMode: D, singleStory: L, storyId: V, refId: k }, K = { docsOptions: z };
    this.state = U.getInitialState(initial_state_default({ ...q, ...K }));
    let Y = { navigate: W, store: U, provider: T.provider };
    this.modules = [provider_exports, channel_exports, addons_exports, layout_exports, notifications_exports, settings_exports, shortcuts_exports, stories_exports, refs_exports, globals_exports, url_exports, versions_exports, whatsnew_exports].map((X) => X.init({ ...q, ...K, ...Y, state: this.state, fullAPI: this.api }));
    let J = initial_state_default(this.state, ...this.modules.map((X) => X.state)), Z = Object.assign(this.api, { navigate: W }, ...this.modules.map((X) => X.api));
    this.state = J, this.api = Z;
  }
  static getDerivedStateFromProps(T, S) {
    return S.path !== T.path ? { ...S, location: T.location, path: T.path, refId: T.refId, viewMode: T.viewMode, storyId: T.storyId } : null;
  }
  shouldComponentUpdate(T, S) {
    let R = this.state, k = this.props;
    return R !== S || k.path !== T.path;
  }
  render() {
    let { children: T } = this.props, S = { state: this.state, api: this.api };
    return React__default.createElement(EffectOnMount, { effect: this.initModules }, React__default.createElement(ManagerContext.Provider, { value: S }, React__default.createElement(ManagerConsumer, null, T)));
  }
};
ManagerProvider.displayName = "Manager";
var EffectOnMount = ({ children: T, effect: S }) => (React__default.useEffect(S, []), T), defaultFilter = (T) => T;
function ManagerConsumer({ filter: T = defaultFilter, children: S }) {
  let R = useContext(ManagerContext), k = useRef(S), D = useRef(T);
  if (typeof k.current != "function") return React__default.createElement(Fragment, null, k.current);
  let L = D.current(R), V = useMemo(() => [...Object.entries(L).reduce((z, W) => z.concat(W), [])], [R.state]);
  return useMemo(() => {
    let z = k.current;
    return React__default.createElement(z, { ...L });
  }, V);
}
globalThis.STORYBOOK_ADDON_STATE = {};
var fastDeepEqual = function T(S, R) {
  if (S === R) return !0;
  if (S && R && typeof S == "object" && typeof R == "object") {
    if (S.constructor !== R.constructor) return !1;
    var k, D, L;
    if (Array.isArray(S)) {
      if (k = S.length, k != R.length) return !1;
      for (D = k; D-- !== 0; )
        if (!T(S[D], R[D])) return !1;
      return !0;
    }
    if (S.constructor === RegExp) return S.source === R.source && S.flags === R.flags;
    if (S.valueOf !== Object.prototype.valueOf) return S.valueOf() === R.valueOf();
    if (S.toString !== Object.prototype.toString) return S.toString() === R.toString();
    if (L = Object.keys(S), k = L.length, k !== Object.keys(R).length) return !1;
    for (D = k; D-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(R, L[D])) return !1;
    for (D = k; D-- !== 0; ) {
      var V = L[D];
      if (!T(S[V], R[V])) return !1;
    }
    return !0;
  }
  return S !== S && R !== R;
};
const equal = /* @__PURE__ */ getDefaultExportFromCjs(fastDeepEqual);
function _typeof(T) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(S) {
    return typeof S;
  } : function(S) {
    return S && typeof Symbol == "function" && S.constructor === Symbol && S !== Symbol.prototype ? "symbol" : typeof S;
  }, _typeof(T);
}
var _window$matchMedia;
function ownKeys$1(T, S) {
  var R = Object.keys(T);
  if (Object.getOwnPropertySymbols) {
    var k = Object.getOwnPropertySymbols(T);
    S && (k = k.filter(function(D) {
      return Object.getOwnPropertyDescriptor(T, D).enumerable;
    })), R.push.apply(R, k);
  }
  return R;
}
function _objectSpread(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S] != null ? arguments[S] : {};
    S % 2 ? ownKeys$1(Object(R), !0).forEach(function(k) {
      _defineProperty$1(T, k, R[k]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(T, Object.getOwnPropertyDescriptors(R)) : ownKeys$1(Object(R)).forEach(function(k) {
      Object.defineProperty(T, k, Object.getOwnPropertyDescriptor(R, k));
    });
  }
  return T;
}
function _defineProperty$1(T, S, R) {
  return S = _toPropertyKey$1(S), S in T ? Object.defineProperty(T, S, { value: R, enumerable: !0, configurable: !0, writable: !0 }) : T[S] = R, T;
}
function _toPropertyKey$1(T) {
  var S = _toPrimitive$1(T, "string");
  return _typeof(S) === "symbol" ? S : String(S);
}
function _toPrimitive$1(T, S) {
  if (_typeof(T) !== "object" || T === null) return T;
  var R = T[Symbol.toPrimitive];
  if (R !== void 0) {
    var k = R.call(T, S || "default");
    if (_typeof(k) !== "object") return k;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (S === "string" ? String : Number)(T);
}
function _toConsumableArray(T) {
  return _arrayWithoutHoles(T) || _iterableToArray(T) || _unsupportedIterableToArray$2(T) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$2(T, S) {
  if (T) {
    if (typeof T == "string") return _arrayLikeToArray$2(T, S);
    var R = Object.prototype.toString.call(T).slice(8, -1);
    if (R === "Object" && T.constructor && (R = T.constructor.name), R === "Map" || R === "Set") return Array.from(T);
    if (R === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(R)) return _arrayLikeToArray$2(T, S);
  }
}
function _iterableToArray(T) {
  if (typeof Symbol < "u" && T[Symbol.iterator] != null || T["@@iterator"] != null) return Array.from(T);
}
function _arrayWithoutHoles(T) {
  if (Array.isArray(T)) return _arrayLikeToArray$2(T);
}
function _arrayLikeToArray$2(T, S) {
  (S == null || S > T.length) && (S = T.length);
  for (var R = 0, k = new Array(S); R < S; R++)
    k[R] = T[R];
  return k;
}
var _ref = scope, document$1 = _ref.document, window$1 = _ref.window, STORAGE_KEY = "sb-addon-themes-3";
(_window$matchMedia = window$1.matchMedia) === null || _window$matchMedia === void 0 || _window$matchMedia.call(window$1, "(prefers-color-scheme: dark)");
var defaultParams = {
  classTarget: "body",
  dark: themes.dark,
  darkClass: ["dark"],
  light: themes.light,
  lightClass: ["light"],
  stylePreview: !1,
  userHasExplicitlySetTheTheme: !1
}, updateStore = function T(S) {
  window$1.localStorage.setItem(STORAGE_KEY, JSON.stringify(S));
}, toggleDarkClass = function T(S, R) {
  var k = R.current, D = R.darkClass, L = D === void 0 ? defaultParams.darkClass : D, V = R.lightClass, z = V === void 0 ? defaultParams.lightClass : V;
  if (k === "dark") {
    var W, U;
    (W = S.classList).remove.apply(W, _toConsumableArray(arrayify(z))), (U = S.classList).add.apply(U, _toConsumableArray(arrayify(L)));
  } else {
    var q, K;
    (q = S.classList).remove.apply(q, _toConsumableArray(arrayify(L))), (K = S.classList).add.apply(K, _toConsumableArray(arrayify(z)));
  }
}, arrayify = function T(S) {
  var R = [];
  return R.concat(S).map(function(k) {
    return k;
  });
}, updateManager = function T(S) {
  var R = document$1.querySelector(S.classTarget);
  R && toggleDarkClass(R, S);
}, store = function T() {
  var S = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, R = window$1.localStorage.getItem(STORAGE_KEY);
  if (typeof R == "string") {
    var k = JSON.parse(R);
    return S && (S.dark && !equal(k.dark, S.dark) && (k.dark = S.dark, updateStore(k)), S.light && !equal(k.light, S.light) && (k.light = S.light, updateStore(k))), k;
  }
  return _objectSpread(_objectSpread({}, defaultParams), S);
};
updateManager(store());
function _slicedToArray$1(T, S) {
  return _arrayWithHoles$1(T) || _iterableToArrayLimit$1(T, S) || _unsupportedIterableToArray$1(T, S) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(T, S) {
  if (T) {
    if (typeof T == "string") return _arrayLikeToArray$1(T, S);
    var R = Object.prototype.toString.call(T).slice(8, -1);
    if (R === "Object" && T.constructor && (R = T.constructor.name), R === "Map" || R === "Set") return Array.from(T);
    if (R === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(R)) return _arrayLikeToArray$1(T, S);
  }
}
function _arrayLikeToArray$1(T, S) {
  (S == null || S > T.length) && (S = T.length);
  for (var R = 0, k = new Array(S); R < S; R++)
    k[R] = T[R];
  return k;
}
function _iterableToArrayLimit$1(T, S) {
  var R = T == null ? null : typeof Symbol < "u" && T[Symbol.iterator] || T["@@iterator"];
  if (R != null) {
    var k, D, L, V, z = [], W = !0, U = !1;
    try {
      if (L = (R = R.call(T)).next, S !== 0) for (; !(W = (k = L.call(R)).done) && (z.push(k.value), z.length !== S); W = !0)
        ;
    } catch (q) {
      U = !0, D = q;
    } finally {
      try {
        if (!W && R.return != null && (V = R.return(), Object(V) !== V)) return;
      } finally {
        if (U) throw D;
      }
    }
    return z;
  }
}
function _arrayWithHoles$1(T) {
  if (Array.isArray(T)) return T;
}
function useDarkMode() {
  var T = useState(store().current === "dark"), S = _slicedToArray$1(T, 2), R = S[0], k = S[1];
  return useEffect(function() {
    var D = addons.getChannel();
    return D.on(DARK_MODE_EVENT_NAME, k), function() {
      return D.off(DARK_MODE_EVENT_NAME, k);
    };
  }, []), R;
}
function Cache(T) {
  this._maxSize = T, this.clear();
}
Cache.prototype.clear = function() {
  this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
};
Cache.prototype.get = function(T) {
  return this._values[T];
};
Cache.prototype.set = function(T, S) {
  return this._size >= this._maxSize && this.clear(), T in this._values || this._size++, this._values[T] = S;
};
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, DIGIT_REGEX = /^\d+$/, LEAD_DIGIT_REGEX = /^\d/, SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, MAX_CACHE_SIZE = 512, pathCache = new Cache(MAX_CACHE_SIZE), setCache = new Cache(MAX_CACHE_SIZE), getCache = new Cache(MAX_CACHE_SIZE), propertyExpr = {
  Cache,
  split,
  normalizePath,
  setter: function(T) {
    var S = normalizePath(T);
    return setCache.get(T) || setCache.set(T, function(k, D) {
      for (var L = 0, V = S.length, z = k; L < V - 1; ) {
        var W = S[L];
        if (W === "__proto__" || W === "constructor" || W === "prototype")
          return k;
        z = z[S[L++]];
      }
      z[S[L]] = D;
    });
  },
  getter: function(T, S) {
    var R = normalizePath(T);
    return getCache.get(T) || getCache.set(T, function(D) {
      for (var L = 0, V = R.length; L < V; )
        if (D != null || !S) D = D[R[L++]];
        else return;
      return D;
    });
  },
  join: function(T) {
    return T.reduce(function(S, R) {
      return S + (isQuoted(R) || DIGIT_REGEX.test(R) ? "[" + R + "]" : (S ? "." : "") + R);
    }, "");
  },
  forEach: function(T, S, R) {
    forEach$2(Array.isArray(T) ? T : split(T), S, R);
  }
};
function normalizePath(T) {
  return pathCache.get(T) || pathCache.set(
    T,
    split(T).map(function(S) {
      return S.replace(CLEAN_QUOTES_REGEX, "$2");
    })
  );
}
function split(T) {
  return T.match(SPLIT_REGEX) || [""];
}
function forEach$2(T, S, R) {
  var k = T.length, D, L, V, z;
  for (L = 0; L < k; L++)
    D = T[L], D && (shouldBeQuoted(D) && (D = '"' + D + '"'), z = isQuoted(D), V = !z && /^\d+$/.test(D), S.call(R, D, z, V, L, T));
}
function isQuoted(T) {
  return typeof T == "string" && T && ["'", '"'].indexOf(T.charAt(0)) !== -1;
}
function hasLeadingNumber(T) {
  return T.match(LEAD_DIGIT_REGEX) && !T.match(DIGIT_REGEX);
}
function hasSpecialChars(T) {
  return SPEC_CHAR_REGEX.test(T);
}
function shouldBeQuoted(T) {
  return !isQuoted(T) && (hasLeadingNumber(T) || hasSpecialChars(T));
}
const reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g, words = (T) => T.match(reWords) || [], upperFirst = (T) => T[0].toUpperCase() + T.slice(1), join = (T, S) => words(T).join(S).toLowerCase(), camelCase = (T) => words(T).reduce(
  (S, R) => `${S}${S ? R[0].toUpperCase() + R.slice(1).toLowerCase() : R.toLowerCase()}`,
  ""
), pascalCase = (T) => upperFirst(camelCase(T)), snakeCase = (T) => join(T, "_"), kebabCase = (T) => join(T, "-"), sentenceCase = (T) => upperFirst(join(T, " ")), titleCase = (T) => words(T).map(upperFirst).join(" ");
var tinyCase = {
  words,
  upperFirst,
  camelCase,
  pascalCase,
  snakeCase,
  kebabCase,
  sentenceCase,
  titleCase
}, toposort$2 = { exports: {} };
toposort$2.exports = function(T) {
  return toposort(uniqueNodes(T), T);
};
toposort$2.exports.array = toposort;
function toposort(T, S) {
  var R = T.length, k = new Array(R), D = {}, L = R, V = makeOutgoingEdges(S), z = makeNodesHash(T);
  for (S.forEach(function(U) {
    if (!z.has(U[0]) || !z.has(U[1]))
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
  }); L--; )
    D[L] || W(T[L], L, /* @__PURE__ */ new Set());
  return k;
  function W(U, q, K) {
    if (K.has(U)) {
      var Y;
      try {
        Y = ", node was:" + JSON.stringify(U);
      } catch {
        Y = "";
      }
      throw new Error("Cyclic dependency" + Y);
    }
    if (!z.has(U))
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(U));
    if (!D[q]) {
      D[q] = !0;
      var J = V.get(U) || /* @__PURE__ */ new Set();
      if (J = Array.from(J), q = J.length) {
        K.add(U);
        do {
          var Z = J[--q];
          W(Z, z.get(Z), K);
        } while (q);
        K.delete(U);
      }
      k[--R] = U;
    }
  }
}
function uniqueNodes(T) {
  for (var S = /* @__PURE__ */ new Set(), R = 0, k = T.length; R < k; R++) {
    var D = T[R];
    S.add(D[0]), S.add(D[1]);
  }
  return Array.from(S);
}
function makeOutgoingEdges(T) {
  for (var S = /* @__PURE__ */ new Map(), R = 0, k = T.length; R < k; R++) {
    var D = T[R];
    S.has(D[0]) || S.set(D[0], /* @__PURE__ */ new Set()), S.has(D[1]) || S.set(D[1], /* @__PURE__ */ new Set()), S.get(D[0]).add(D[1]);
  }
  return S;
}
function makeNodesHash(T) {
  for (var S = /* @__PURE__ */ new Map(), R = 0, k = T.length; R < k; R++)
    S.set(T[R], R);
  return S;
}
var toposortExports = toposort$2.exports;
const toposort$1 = /* @__PURE__ */ getDefaultExportFromCjs(toposortExports), toString = Object.prototype.toString, errorToString = Error.prototype.toString, regExpToString = RegExp.prototype.toString, symbolToString = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(T) {
  return T != +T ? "NaN" : T === 0 && 1 / T < 0 ? "-0" : "" + T;
}
function printSimpleValue(T, S = !1) {
  if (T == null || T === !0 || T === !1) return "" + T;
  const R = typeof T;
  if (R === "number") return printNumber(T);
  if (R === "string") return S ? `"${T}"` : T;
  if (R === "function") return "[Function " + (T.name || "anonymous") + "]";
  if (R === "symbol") return symbolToString.call(T).replace(SYMBOL_REGEXP, "Symbol($1)");
  const k = toString.call(T).slice(8, -1);
  return k === "Date" ? isNaN(T.getTime()) ? "" + T : T.toISOString(T) : k === "Error" || T instanceof Error ? "[" + errorToString.call(T) + "]" : k === "RegExp" ? regExpToString.call(T) : null;
}
function printValue(T, S) {
  let R = printSimpleValue(T, S);
  return R !== null ? R : JSON.stringify(T, function(k, D) {
    let L = printSimpleValue(this[k], S);
    return L !== null ? L : D;
  }, 2);
}
function toArray(T) {
  return T == null ? [] : [].concat(T);
}
let _Symbol$toStringTag, _Symbol$hasInstance, _Symbol$toStringTag2, strReg = /\$\{\s*(\w+)\s*\}/g;
_Symbol$toStringTag = Symbol.toStringTag;
class ValidationErrorNoStack {
  constructor(S, R, k, D) {
    this.name = void 0, this.message = void 0, this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = void 0, this.inner = void 0, this[_Symbol$toStringTag] = "Error", this.name = "ValidationError", this.value = R, this.path = k, this.type = D, this.errors = [], this.inner = [], toArray(S).forEach((L) => {
      if (ValidationError.isError(L)) {
        this.errors.push(...L.errors);
        const V = L.inner.length ? L.inner : [L];
        this.inner.push(...V);
      } else
        this.errors.push(L);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
_Symbol$hasInstance = Symbol.hasInstance;
_Symbol$toStringTag2 = Symbol.toStringTag;
class ValidationError extends Error {
  static formatError(S, R) {
    const k = R.label || R.path || "this";
    return k !== R.path && (R = Object.assign({}, R, {
      path: k
    })), typeof S == "string" ? S.replace(strReg, (D, L) => printValue(R[L])) : typeof S == "function" ? S(R) : S;
  }
  static isError(S) {
    return S && S.name === "ValidationError";
  }
  constructor(S, R, k, D, L) {
    const V = new ValidationErrorNoStack(S, R, k, D);
    if (L)
      return V;
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.params = void 0, this.errors = [], this.inner = [], this[_Symbol$toStringTag2] = "Error", this.name = V.name, this.message = V.message, this.type = V.type, this.value = V.value, this.path = V.path, this.errors = V.errors, this.inner = V.inner, Error.captureStackTrace && Error.captureStackTrace(this, ValidationError);
  }
  static [_Symbol$hasInstance](S) {
    return ValidationErrorNoStack[Symbol.hasInstance](S) || super[Symbol.hasInstance](S);
  }
}
let mixed = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: T,
    type: S,
    value: R,
    originalValue: k
  }) => {
    const D = k != null && k !== R ? ` (cast from the value \`${printValue(k, !0)}\`).` : ".";
    return S !== "mixed" ? `${T} must be a \`${S}\` type, but the final value was: \`${printValue(R, !0)}\`` + D : `${T} must match the configured type. The validated value was: \`${printValue(R, !0)}\`` + D;
  }
}, string = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, number = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, date = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, boolean = {
  isValue: "${path} field must be ${value}"
}, object$1 = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, array$1 = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
}, tuple = {
  notType: (T) => {
    const {
      path: S,
      value: R,
      spec: k
    } = T, D = k.types.length;
    if (Array.isArray(R)) {
      if (R.length < D) return `${S} tuple value has too few items, expected a length of ${D} but got ${R.length} for value: \`${printValue(R, !0)}\``;
      if (R.length > D) return `${S} tuple value has too many items, expected a length of ${D} but got ${R.length} for value: \`${printValue(R, !0)}\``;
    }
    return ValidationError.formatError(mixed.notType, T);
  }
};
var locale = Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed,
  string,
  number,
  date,
  object: object$1,
  array: array$1,
  boolean,
  tuple
});
const isSchema = (T) => T && T.__isYupSchema__;
class Condition {
  static fromOptions(S, R) {
    if (!R.then && !R.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: k,
      then: D,
      otherwise: L
    } = R, V = typeof k == "function" ? k : (...z) => z.every((W) => W === k);
    return new Condition(S, (z, W) => {
      var U;
      let q = V(...z) ? D : L;
      return (U = q?.(W)) != null ? U : W;
    });
  }
  constructor(S, R) {
    this.fn = void 0, this.refs = S, this.refs = S, this.fn = R;
  }
  resolve(S, R) {
    let k = this.refs.map((L) => (
      // TODO: ? operator here?
      L.getValue(R?.value, R?.parent, R?.context)
    )), D = this.fn(k, S, R);
    if (D === void 0 || // @ts-ignore this can be base
    D === S)
      return S;
    if (!isSchema(D)) throw new TypeError("conditions must return a schema object");
    return D.resolve(R);
  }
}
const prefixes = {
  context: "$",
  value: "."
};
function create$9(T, S) {
  return new Reference(T, S);
}
class Reference {
  constructor(S, R = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof S != "string") throw new TypeError("ref must be a string, got: " + S);
    if (this.key = S.trim(), S === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === prefixes.context, this.isValue = this.key[0] === prefixes.value, this.isSibling = !this.isContext && !this.isValue;
    let k = this.isContext ? prefixes.context : this.isValue ? prefixes.value : "";
    this.path = this.key.slice(k.length), this.getter = this.path && propertyExpr.getter(this.path, !0), this.map = R.map;
  }
  getValue(S, R, k) {
    let D = this.isContext ? k : this.isValue ? S : R;
    return this.getter && (D = this.getter(D || {})), this.map && (D = this.map(D)), D;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(S, R) {
    return this.getValue(S, R?.parent, R?.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(S) {
    return S && S.__isYupRef;
  }
}
Reference.prototype.__isYupRef = !0;
const isAbsent = (T) => T == null;
function createValidation(T) {
  function S({
    value: R,
    path: k = "",
    options: D,
    originalValue: L,
    schema: V
  }, z, W) {
    const {
      name: U,
      test: q,
      params: K,
      message: Y,
      skipAbsent: J
    } = T;
    let {
      parent: Z,
      context: X,
      abortEarly: ee = V.spec.abortEarly,
      disableStackTrace: te = V.spec.disableStackTrace
    } = D;
    function re(Pe) {
      return Reference.isRef(Pe) ? Pe.getValue(R, Z, X) : Pe;
    }
    function Q(Pe = {}) {
      const Re = Object.assign({
        value: R,
        originalValue: L,
        label: V.spec.label,
        path: Pe.path || k,
        spec: V.spec,
        disableStackTrace: Pe.disableStackTrace || te
      }, K, Pe.params);
      for (const Te of Object.keys(Re)) Re[Te] = re(Re[Te]);
      const ke = new ValidationError(ValidationError.formatError(Pe.message || Y, Re), R, Re.path, Pe.type || U, Re.disableStackTrace);
      return ke.params = Re, ke;
    }
    const ne = ee ? z : W;
    let oe = {
      path: k,
      parent: Z,
      type: U,
      from: D.from,
      createError: Q,
      resolve: re,
      options: D,
      originalValue: L,
      schema: V
    };
    const ae = (Pe) => {
      ValidationError.isError(Pe) ? ne(Pe) : Pe ? W(null) : ne(Q());
    }, se = (Pe) => {
      ValidationError.isError(Pe) ? ne(Pe) : z(Pe);
    };
    if (J && isAbsent(R))
      return ae(!0);
    let he;
    try {
      var xe;
      if (he = q.call(oe, R, oe), typeof ((xe = he) == null ? void 0 : xe.then) == "function") {
        if (D.sync)
          throw new Error(`Validation test of type: "${oe.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        return Promise.resolve(he).then(ae, se);
      }
    } catch (Pe) {
      se(Pe);
      return;
    }
    ae(he);
  }
  return S.OPTIONS = T, S;
}
function getIn(T, S, R, k = R) {
  let D, L, V;
  return S ? (propertyExpr.forEach(S, (z, W, U) => {
    let q = W ? z.slice(1, z.length - 1) : z;
    T = T.resolve({
      context: k,
      parent: D,
      value: R
    });
    let K = T.type === "tuple", Y = U ? parseInt(q, 10) : 0;
    if (T.innerType || K) {
      if (K && !U) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${V}" must contain an index to the tuple element, e.g. "${V}[0]"`);
      if (R && Y >= R.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${z}, in the path: ${S}. because there is no value at that index. `);
      D = R, R = R && R[Y], T = K ? T.spec.types[Y] : T.innerType;
    }
    if (!U) {
      if (!T.fields || !T.fields[q]) throw new Error(`The schema does not contain the path: ${S}. (failed at: ${V} which is a type: "${T.type}")`);
      D = R, R = R && R[q], T = T.fields[q];
    }
    L = q, V = W ? "[" + z + "]" : "." + z;
  }), {
    schema: T,
    parent: D,
    parentPath: L
  }) : {
    parent: D,
    parentPath: S,
    schema: T
  };
}
function reach(T, S, R, k) {
  return getIn(T, S, R, k).schema;
}
class ReferenceSet extends Set {
  describe() {
    const S = [];
    for (const R of this.values())
      S.push(Reference.isRef(R) ? R.describe() : R);
    return S;
  }
  resolveAll(S) {
    let R = [];
    for (const k of this.values())
      R.push(S(k));
    return R;
  }
  clone() {
    return new ReferenceSet(this.values());
  }
  merge(S, R) {
    const k = this.clone();
    return S.forEach((D) => k.add(D)), R.forEach((D) => k.delete(D)), k;
  }
}
function clone(T, S = /* @__PURE__ */ new Map()) {
  if (isSchema(T) || !T || typeof T != "object") return T;
  if (S.has(T)) return S.get(T);
  let R;
  if (T instanceof Date)
    R = new Date(T.getTime()), S.set(T, R);
  else if (T instanceof RegExp)
    R = new RegExp(T), S.set(T, R);
  else if (Array.isArray(T)) {
    R = new Array(T.length), S.set(T, R);
    for (let k = 0; k < T.length; k++) R[k] = clone(T[k], S);
  } else if (T instanceof Map) {
    R = /* @__PURE__ */ new Map(), S.set(T, R);
    for (const [k, D] of T.entries()) R.set(k, clone(D, S));
  } else if (T instanceof Set) {
    R = /* @__PURE__ */ new Set(), S.set(T, R);
    for (const k of T) R.add(clone(k, S));
  } else if (T instanceof Object) {
    R = {}, S.set(T, R);
    for (const [k, D] of Object.entries(T)) R[k] = clone(D, S);
  } else
    throw Error(`Unable to clone ${T}`);
  return R;
}
class Schema {
  constructor(S) {
    this.type = void 0, this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this.internalTests = {}, this._whitelist = new ReferenceSet(), this._blacklist = new ReferenceSet(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this._typeCheck = void 0, this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(mixed.notType);
    }), this.type = S.type, this._typeCheck = S.check, this.spec = Object.assign({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      disableStackTrace: !1,
      nullable: !1,
      optional: !0,
      coerce: !0
    }, S?.spec), this.withMutation((R) => {
      R.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(S) {
    if (this._mutate)
      return S && Object.assign(this.spec, S), this;
    const R = Object.create(Object.getPrototypeOf(this));
    return R.type = this.type, R._typeCheck = this._typeCheck, R._whitelist = this._whitelist.clone(), R._blacklist = this._blacklist.clone(), R.internalTests = Object.assign({}, this.internalTests), R.exclusiveTests = Object.assign({}, this.exclusiveTests), R.deps = [...this.deps], R.conditions = [...this.conditions], R.tests = [...this.tests], R.transforms = [...this.transforms], R.spec = clone(Object.assign({}, this.spec, S)), R;
  }
  label(S) {
    let R = this.clone();
    return R.spec.label = S, R;
  }
  meta(...S) {
    if (S.length === 0) return this.spec.meta;
    let R = this.clone();
    return R.spec.meta = Object.assign(R.spec.meta || {}, S[0]), R;
  }
  withMutation(S) {
    let R = this._mutate;
    this._mutate = !0;
    let k = S(this);
    return this._mutate = R, k;
  }
  concat(S) {
    if (!S || S === this) return this;
    if (S.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${S.type}`);
    let R = this, k = S.clone();
    const D = Object.assign({}, R.spec, k.spec);
    return k.spec = D, k.internalTests = Object.assign({}, R.internalTests, k.internalTests), k._whitelist = R._whitelist.merge(S._whitelist, S._blacklist), k._blacklist = R._blacklist.merge(S._blacklist, S._whitelist), k.tests = R.tests, k.exclusiveTests = R.exclusiveTests, k.withMutation((L) => {
      S.tests.forEach((V) => {
        L.test(V.OPTIONS);
      });
    }), k.transforms = [...R.transforms, ...k.transforms], k;
  }
  isType(S) {
    return S == null ? !!(this.spec.nullable && S === null || this.spec.optional && S === void 0) : this._typeCheck(S);
  }
  resolve(S) {
    let R = this;
    if (R.conditions.length) {
      let k = R.conditions;
      R = R.clone(), R.conditions = [], R = k.reduce((D, L) => L.resolve(D, S), R), R = R.resolve(S);
    }
    return R;
  }
  resolveOptions(S) {
    var R, k, D, L;
    return Object.assign({}, S, {
      from: S.from || [],
      strict: (R = S.strict) != null ? R : this.spec.strict,
      abortEarly: (k = S.abortEarly) != null ? k : this.spec.abortEarly,
      recursive: (D = S.recursive) != null ? D : this.spec.recursive,
      disableStackTrace: (L = S.disableStackTrace) != null ? L : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(S, R = {}) {
    let k = this.resolve(Object.assign({
      value: S
    }, R)), D = R.assert === "ignore-optionality", L = k._cast(S, R);
    if (R.assert !== !1 && !k.isType(L)) {
      if (D && isAbsent(L))
        return L;
      let V = printValue(S), z = printValue(L);
      throw new TypeError(`The value of ${R.path || "field"} could not be cast to a value that satisfies the schema type: "${k.type}". 

attempted value: ${V} 
` + (z !== V ? `result of cast: ${z}` : ""));
    }
    return L;
  }
  _cast(S, R) {
    let k = S === void 0 ? S : this.transforms.reduce((D, L) => L.call(this, D, S, this), S);
    return k === void 0 && (k = this.getDefault(R)), k;
  }
  _validate(S, R = {}, k, D) {
    let {
      path: L,
      originalValue: V = S,
      strict: z = this.spec.strict
    } = R, W = S;
    z || (W = this._cast(W, Object.assign({
      assert: !1
    }, R)));
    let U = [];
    for (let q of Object.values(this.internalTests))
      q && U.push(q);
    this.runTests({
      path: L,
      value: W,
      originalValue: V,
      options: R,
      tests: U
    }, k, (q) => {
      if (q.length)
        return D(q, W);
      this.runTests({
        path: L,
        value: W,
        originalValue: V,
        options: R,
        tests: this.tests
      }, k, D);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(S, R, k) {
    let D = !1, {
      tests: L,
      value: V,
      originalValue: z,
      path: W,
      options: U
    } = S, q = (X) => {
      D || (D = !0, R(X, V));
    }, K = (X) => {
      D || (D = !0, k(X, V));
    }, Y = L.length, J = [];
    if (!Y) return K([]);
    let Z = {
      value: V,
      originalValue: z,
      path: W,
      options: U,
      schema: this
    };
    for (let X = 0; X < L.length; X++) {
      const ee = L[X];
      ee(Z, q, function(re) {
        re && (Array.isArray(re) ? J.push(...re) : J.push(re)), --Y <= 0 && K(J);
      });
    }
  }
  asNestedTest({
    key: S,
    index: R,
    parent: k,
    parentPath: D,
    originalParent: L,
    options: V
  }) {
    const z = S ?? R;
    if (z == null)
      throw TypeError("Must include `key` or `index` for nested validations");
    const W = typeof z == "number";
    let U = k[z];
    const q = Object.assign({}, V, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: !0,
      parent: k,
      value: U,
      originalValue: L[z],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [W ? "index" : "key"]: z,
      path: W || z.includes(".") ? `${D || ""}[${W ? z : `"${z}"`}]` : (D ? `${D}.` : "") + S
    });
    return (K, Y, J) => this.resolve(q)._validate(U, q, Y, J);
  }
  validate(S, R) {
    var k;
    let D = this.resolve(Object.assign({}, R, {
      value: S
    })), L = (k = R?.disableStackTrace) != null ? k : D.spec.disableStackTrace;
    return new Promise((V, z) => D._validate(S, R, (W, U) => {
      ValidationError.isError(W) && (W.value = U), z(W);
    }, (W, U) => {
      W.length ? z(new ValidationError(W, U, void 0, void 0, L)) : V(U);
    }));
  }
  validateSync(S, R) {
    var k;
    let D = this.resolve(Object.assign({}, R, {
      value: S
    })), L, V = (k = R?.disableStackTrace) != null ? k : D.spec.disableStackTrace;
    return D._validate(S, Object.assign({}, R, {
      sync: !0
    }), (z, W) => {
      throw ValidationError.isError(z) && (z.value = W), z;
    }, (z, W) => {
      if (z.length) throw new ValidationError(z, S, void 0, void 0, V);
      L = W;
    }), L;
  }
  isValid(S, R) {
    return this.validate(S, R).then(() => !0, (k) => {
      if (ValidationError.isError(k)) return !1;
      throw k;
    });
  }
  isValidSync(S, R) {
    try {
      return this.validateSync(S, R), !0;
    } catch (k) {
      if (ValidationError.isError(k)) return !1;
      throw k;
    }
  }
  _getDefault(S) {
    let R = this.spec.default;
    return R == null ? R : typeof R == "function" ? R.call(this, S) : clone(R);
  }
  getDefault(S) {
    return this.resolve(S || {})._getDefault(S);
  }
  default(S) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: S
    });
  }
  strict(S = !0) {
    return this.clone({
      strict: S
    });
  }
  nullability(S, R) {
    const k = this.clone({
      nullable: S
    });
    return k.internalTests.nullable = createValidation({
      message: R,
      name: "nullable",
      test(D) {
        return D === null ? this.schema.spec.nullable : !0;
      }
    }), k;
  }
  optionality(S, R) {
    const k = this.clone({
      optional: S
    });
    return k.internalTests.optionality = createValidation({
      message: R,
      name: "optionality",
      test(D) {
        return D === void 0 ? this.schema.spec.optional : !0;
      }
    }), k;
  }
  optional() {
    return this.optionality(!0);
  }
  defined(S = mixed.defined) {
    return this.optionality(!1, S);
  }
  nullable() {
    return this.nullability(!0);
  }
  nonNullable(S = mixed.notNull) {
    return this.nullability(!1, S);
  }
  required(S = mixed.required) {
    return this.clone().withMutation((R) => R.nonNullable(S).defined(S));
  }
  notRequired() {
    return this.clone().withMutation((S) => S.nullable().optional());
  }
  transform(S) {
    let R = this.clone();
    return R.transforms.push(S), R;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...S) {
    let R;
    if (S.length === 1 ? typeof S[0] == "function" ? R = {
      test: S[0]
    } : R = S[0] : S.length === 2 ? R = {
      name: S[0],
      test: S[1]
    } : R = {
      name: S[0],
      message: S[1],
      test: S[2]
    }, R.message === void 0 && (R.message = mixed.default), typeof R.test != "function") throw new TypeError("`test` is a required parameters");
    let k = this.clone(), D = createValidation(R), L = R.exclusive || R.name && k.exclusiveTests[R.name] === !0;
    if (R.exclusive && !R.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return R.name && (k.exclusiveTests[R.name] = !!R.exclusive), k.tests = k.tests.filter((V) => !(V.OPTIONS.name === R.name && (L || V.OPTIONS.test === D.OPTIONS.test))), k.tests.push(D), k;
  }
  when(S, R) {
    !Array.isArray(S) && typeof S != "string" && (R = S, S = ".");
    let k = this.clone(), D = toArray(S).map((L) => new Reference(L));
    return D.forEach((L) => {
      L.isSibling && k.deps.push(L.key);
    }), k.conditions.push(typeof R == "function" ? new Condition(D, R) : Condition.fromOptions(D, R)), k;
  }
  typeError(S) {
    let R = this.clone();
    return R.internalTests.typeError = createValidation({
      message: S,
      name: "typeError",
      skipAbsent: !0,
      test(k) {
        return this.schema._typeCheck(k) ? !0 : this.createError({
          params: {
            type: this.schema.type
          }
        });
      }
    }), R;
  }
  oneOf(S, R = mixed.oneOf) {
    let k = this.clone();
    return S.forEach((D) => {
      k._whitelist.add(D), k._blacklist.delete(D);
    }), k.internalTests.whiteList = createValidation({
      message: R,
      name: "oneOf",
      skipAbsent: !0,
      test(D) {
        let L = this.schema._whitelist, V = L.resolveAll(this.resolve);
        return V.includes(D) ? !0 : this.createError({
          params: {
            values: Array.from(L).join(", "),
            resolved: V
          }
        });
      }
    }), k;
  }
  notOneOf(S, R = mixed.notOneOf) {
    let k = this.clone();
    return S.forEach((D) => {
      k._blacklist.add(D), k._whitelist.delete(D);
    }), k.internalTests.blacklist = createValidation({
      message: R,
      name: "notOneOf",
      test(D) {
        let L = this.schema._blacklist, V = L.resolveAll(this.resolve);
        return V.includes(D) ? this.createError({
          params: {
            values: Array.from(L).join(", "),
            resolved: V
          }
        }) : !0;
      }
    }), k;
  }
  strip(S = !0) {
    let R = this.clone();
    return R.spec.strip = S, R;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(S) {
    const R = (S ? this.resolve(S) : this).clone(), {
      label: k,
      meta: D,
      optional: L,
      nullable: V
    } = R.spec;
    return {
      meta: D,
      label: k,
      optional: L,
      nullable: V,
      default: R.getDefault(S),
      type: R.type,
      oneOf: R._whitelist.describe(),
      notOneOf: R._blacklist.describe(),
      tests: R.tests.map((W) => ({
        name: W.OPTIONS.name,
        params: W.OPTIONS.params
      })).filter((W, U, q) => q.findIndex((K) => K.name === W.name) === U)
    };
  }
}
Schema.prototype.__isYupSchema__ = !0;
for (const T of ["validate", "validateSync"]) Schema.prototype[`${T}At`] = function(S, R, k = {}) {
  const {
    parent: D,
    parentPath: L,
    schema: V
  } = getIn(this, S, R, k.context);
  return V[T](D && D[L], Object.assign({}, k, {
    parent: D,
    path: S
  }));
};
for (const T of ["equals", "is"]) Schema.prototype[T] = Schema.prototype.oneOf;
for (const T of ["not", "nope"]) Schema.prototype[T] = Schema.prototype.notOneOf;
const returnsTrue = () => !0;
function create$8(T) {
  return new MixedSchema(T);
}
class MixedSchema extends Schema {
  constructor(S) {
    super(typeof S == "function" ? {
      type: "mixed",
      check: S
    } : Object.assign({
      type: "mixed",
      check: returnsTrue
    }, S));
  }
}
create$8.prototype = MixedSchema.prototype;
function create$7() {
  return new BooleanSchema();
}
class BooleanSchema extends Schema {
  constructor() {
    super({
      type: "boolean",
      check(S) {
        return S instanceof Boolean && (S = S.valueOf()), typeof S == "boolean";
      }
    }), this.withMutation(() => {
      this.transform((S, R, k) => {
        if (k.spec.coerce && !k.isType(S)) {
          if (/^(true|1)$/i.test(String(S))) return !0;
          if (/^(false|0)$/i.test(String(S))) return !1;
        }
        return S;
      });
    });
  }
  isTrue(S = boolean.isValue) {
    return this.test({
      message: S,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "true"
      },
      test(R) {
        return isAbsent(R) || R === !0;
      }
    });
  }
  isFalse(S = boolean.isValue) {
    return this.test({
      message: S,
      name: "is-value",
      exclusive: !0,
      params: {
        value: "false"
      },
      test(R) {
        return isAbsent(R) || R === !1;
      }
    });
  }
  default(S) {
    return super.default(S);
  }
  defined(S) {
    return super.defined(S);
  }
  optional() {
    return super.optional();
  }
  required(S) {
    return super.required(S);
  }
  notRequired() {
    return super.notRequired();
  }
  nullable() {
    return super.nullable();
  }
  nonNullable(S) {
    return super.nonNullable(S);
  }
  strip(S) {
    return super.strip(S);
  }
}
create$7.prototype = BooleanSchema.prototype;
const isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(T) {
  const S = parseDateStruct(T);
  if (!S) return Date.parse ? Date.parse(T) : Number.NaN;
  if (S.z === void 0 && S.plusMinus === void 0)
    return new Date(S.year, S.month, S.day, S.hour, S.minute, S.second, S.millisecond).valueOf();
  let R = 0;
  return S.z !== "Z" && S.plusMinus !== void 0 && (R = S.hourOffset * 60 + S.minuteOffset, S.plusMinus === "+" && (R = 0 - R)), Date.UTC(S.year, S.month, S.day, S.hour, S.minute + R, S.second, S.millisecond);
}
function parseDateStruct(T) {
  var S, R;
  const k = isoReg.exec(T);
  return k ? {
    year: toNumber(k[1]),
    month: toNumber(k[2], 1) - 1,
    day: toNumber(k[3], 1),
    hour: toNumber(k[4]),
    minute: toNumber(k[5]),
    second: toNumber(k[6]),
    millisecond: k[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      toNumber(k[7].substring(0, 3))
    ) : 0,
    precision: (S = (R = k[7]) == null ? void 0 : R.length) != null ? S : void 0,
    z: k[8] || void 0,
    plusMinus: k[9] || void 0,
    hourOffset: toNumber(k[10]),
    minuteOffset: toNumber(k[11])
  } : null;
}
function toNumber(T, S = 0) {
  return Number(T) || S;
}
let rEmail = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
), rUrl = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
), rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}", hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}", zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)", rIsoDateTime = new RegExp(`${yearMonthDay}T${hourMinuteSecond}(\\.\\d+)?${zOrOffset}$`), isTrimmed = (T) => isAbsent(T) || T === T.trim(), objStringTag = {}.toString();
function create$6() {
  return new StringSchema();
}
class StringSchema extends Schema {
  constructor() {
    super({
      type: "string",
      check(S) {
        return S instanceof String && (S = S.valueOf()), typeof S == "string";
      }
    }), this.withMutation(() => {
      this.transform((S, R, k) => {
        if (!k.spec.coerce || k.isType(S) || Array.isArray(S)) return S;
        const D = S != null && S.toString ? S.toString() : S;
        return D === objStringTag ? S : D;
      });
    });
  }
  required(S) {
    return super.required(S).withMutation((R) => R.test({
      message: S || mixed.required,
      name: "required",
      skipAbsent: !0,
      test: (k) => !!k.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((S) => (S.tests = S.tests.filter((R) => R.OPTIONS.name !== "required"), S));
  }
  length(S, R = string.length) {
    return this.test({
      message: R,
      name: "length",
      exclusive: !0,
      params: {
        length: S
      },
      skipAbsent: !0,
      test(k) {
        return k.length === this.resolve(S);
      }
    });
  }
  min(S, R = string.min) {
    return this.test({
      message: R,
      name: "min",
      exclusive: !0,
      params: {
        min: S
      },
      skipAbsent: !0,
      test(k) {
        return k.length >= this.resolve(S);
      }
    });
  }
  max(S, R = string.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: R,
      params: {
        max: S
      },
      skipAbsent: !0,
      test(k) {
        return k.length <= this.resolve(S);
      }
    });
  }
  matches(S, R) {
    let k = !1, D, L;
    return R && (typeof R == "object" ? {
      excludeEmptyString: k = !1,
      message: D,
      name: L
    } = R : D = R), this.test({
      name: L || "matches",
      message: D || string.matches,
      params: {
        regex: S
      },
      skipAbsent: !0,
      test: (V) => V === "" && k || V.search(S) !== -1
    });
  }
  email(S = string.email) {
    return this.matches(rEmail, {
      name: "email",
      message: S,
      excludeEmptyString: !0
    });
  }
  url(S = string.url) {
    return this.matches(rUrl, {
      name: "url",
      message: S,
      excludeEmptyString: !0
    });
  }
  uuid(S = string.uuid) {
    return this.matches(rUUID, {
      name: "uuid",
      message: S,
      excludeEmptyString: !1
    });
  }
  datetime(S) {
    let R = "", k, D;
    return S && (typeof S == "object" ? {
      message: R = "",
      allowOffset: k = !1,
      precision: D = void 0
    } = S : R = S), this.matches(rIsoDateTime, {
      name: "datetime",
      message: R || string.datetime,
      excludeEmptyString: !0
    }).test({
      name: "datetime_offset",
      message: R || string.datetime_offset,
      params: {
        allowOffset: k
      },
      skipAbsent: !0,
      test: (L) => {
        if (!L || k) return !0;
        const V = parseDateStruct(L);
        return V ? !!V.z : !1;
      }
    }).test({
      name: "datetime_precision",
      message: R || string.datetime_precision,
      params: {
        precision: D
      },
      skipAbsent: !0,
      test: (L) => {
        if (!L || D == null) return !0;
        const V = parseDateStruct(L);
        return V ? V.precision === D : !1;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((S) => S === null ? "" : S);
  }
  trim(S = string.trim) {
    return this.transform((R) => R != null ? R.trim() : R).test({
      message: S,
      name: "trim",
      test: isTrimmed
    });
  }
  lowercase(S = string.lowercase) {
    return this.transform((R) => isAbsent(R) ? R : R.toLowerCase()).test({
      message: S,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (R) => isAbsent(R) || R === R.toLowerCase()
    });
  }
  uppercase(S = string.uppercase) {
    return this.transform((R) => isAbsent(R) ? R : R.toUpperCase()).test({
      message: S,
      name: "string_case",
      exclusive: !0,
      skipAbsent: !0,
      test: (R) => isAbsent(R) || R === R.toUpperCase()
    });
  }
}
create$6.prototype = StringSchema.prototype;
let isNaN$1 = (T) => T != +T;
function create$5() {
  return new NumberSchema();
}
class NumberSchema extends Schema {
  constructor() {
    super({
      type: "number",
      check(S) {
        return S instanceof Number && (S = S.valueOf()), typeof S == "number" && !isNaN$1(S);
      }
    }), this.withMutation(() => {
      this.transform((S, R, k) => {
        if (!k.spec.coerce) return S;
        let D = S;
        if (typeof D == "string") {
          if (D = D.replace(/\s/g, ""), D === "") return NaN;
          D = +D;
        }
        return k.isType(D) || D === null ? D : parseFloat(D);
      });
    });
  }
  min(S, R = number.min) {
    return this.test({
      message: R,
      name: "min",
      exclusive: !0,
      params: {
        min: S
      },
      skipAbsent: !0,
      test(k) {
        return k >= this.resolve(S);
      }
    });
  }
  max(S, R = number.max) {
    return this.test({
      message: R,
      name: "max",
      exclusive: !0,
      params: {
        max: S
      },
      skipAbsent: !0,
      test(k) {
        return k <= this.resolve(S);
      }
    });
  }
  lessThan(S, R = number.lessThan) {
    return this.test({
      message: R,
      name: "max",
      exclusive: !0,
      params: {
        less: S
      },
      skipAbsent: !0,
      test(k) {
        return k < this.resolve(S);
      }
    });
  }
  moreThan(S, R = number.moreThan) {
    return this.test({
      message: R,
      name: "min",
      exclusive: !0,
      params: {
        more: S
      },
      skipAbsent: !0,
      test(k) {
        return k > this.resolve(S);
      }
    });
  }
  positive(S = number.positive) {
    return this.moreThan(0, S);
  }
  negative(S = number.negative) {
    return this.lessThan(0, S);
  }
  integer(S = number.integer) {
    return this.test({
      name: "integer",
      message: S,
      skipAbsent: !0,
      test: (R) => Number.isInteger(R)
    });
  }
  truncate() {
    return this.transform((S) => isAbsent(S) ? S : S | 0);
  }
  round(S) {
    var R;
    let k = ["ceil", "floor", "round", "trunc"];
    if (S = ((R = S) == null ? void 0 : R.toLowerCase()) || "round", S === "trunc") return this.truncate();
    if (k.indexOf(S.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + k.join(", "));
    return this.transform((D) => isAbsent(D) ? D : Math[S](D));
  }
}
create$5.prototype = NumberSchema.prototype;
let invalidDate = /* @__PURE__ */ new Date(""), isDate = (T) => Object.prototype.toString.call(T) === "[object Date]";
function create$4() {
  return new DateSchema();
}
class DateSchema extends Schema {
  constructor() {
    super({
      type: "date",
      check(S) {
        return isDate(S) && !isNaN(S.getTime());
      }
    }), this.withMutation(() => {
      this.transform((S, R, k) => !k.spec.coerce || k.isType(S) || S === null ? S : (S = parseIsoDate(S), isNaN(S) ? DateSchema.INVALID_DATE : new Date(S)));
    });
  }
  prepareParam(S, R) {
    let k;
    if (Reference.isRef(S))
      k = S;
    else {
      let D = this.cast(S);
      if (!this._typeCheck(D)) throw new TypeError(`\`${R}\` must be a Date or a value that can be \`cast()\` to a Date`);
      k = D;
    }
    return k;
  }
  min(S, R = date.min) {
    let k = this.prepareParam(S, "min");
    return this.test({
      message: R,
      name: "min",
      exclusive: !0,
      params: {
        min: S
      },
      skipAbsent: !0,
      test(D) {
        return D >= this.resolve(k);
      }
    });
  }
  max(S, R = date.max) {
    let k = this.prepareParam(S, "max");
    return this.test({
      message: R,
      name: "max",
      exclusive: !0,
      params: {
        max: S
      },
      skipAbsent: !0,
      test(D) {
        return D <= this.resolve(k);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;
create$4.prototype = DateSchema.prototype;
create$4.INVALID_DATE = invalidDate;
function sortFields(T, S = []) {
  let R = [], k = /* @__PURE__ */ new Set(), D = new Set(S.map(([V, z]) => `${V}-${z}`));
  function L(V, z) {
    let W = propertyExpr.split(V)[0];
    k.add(W), D.has(`${z}-${W}`) || R.push([z, W]);
  }
  for (const V of Object.keys(T)) {
    let z = T[V];
    k.add(V), Reference.isRef(z) && z.isSibling ? L(z.path, V) : isSchema(z) && "deps" in z && z.deps.forEach((W) => L(W, V));
  }
  return toposort$1.array(Array.from(k), R).reverse();
}
function findIndex(T, S) {
  let R = 1 / 0;
  return T.some((k, D) => {
    var L;
    if ((L = S.path) != null && L.includes(k))
      return R = D, !0;
  }), R;
}
function sortByKeyOrder(T) {
  return (S, R) => findIndex(T, S) - findIndex(T, R);
}
const parseJson = (T, S, R) => {
  if (typeof T != "string")
    return T;
  let k = T;
  try {
    k = JSON.parse(T);
  } catch {
  }
  return R.isType(k) ? k : T;
};
function deepPartial(T) {
  if ("fields" in T) {
    const S = {};
    for (const [R, k] of Object.entries(T.fields))
      S[R] = deepPartial(k);
    return T.setFields(S);
  }
  if (T.type === "array") {
    const S = T.optional();
    return S.innerType && (S.innerType = deepPartial(S.innerType)), S;
  }
  return T.type === "tuple" ? T.optional().clone({
    types: T.spec.types.map(deepPartial)
  }) : "optional" in T ? T.optional() : T;
}
const deepHas = (T, S) => {
  const R = [...propertyExpr.normalizePath(S)];
  if (R.length === 1) return R[0] in T;
  let k = R.pop(), D = propertyExpr.getter(propertyExpr.join(R), !0)(T);
  return !!(D && k in D);
};
let isObject = (T) => Object.prototype.toString.call(T) === "[object Object]";
function unknown(T, S) {
  let R = Object.keys(T.fields);
  return Object.keys(S).filter((k) => R.indexOf(k) === -1);
}
const defaultSort = sortByKeyOrder([]);
function create$3(T) {
  return new ObjectSchema(T);
}
class ObjectSchema extends Schema {
  constructor(S) {
    super({
      type: "object",
      check(R) {
        return isObject(R) || typeof R == "function";
      }
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = defaultSort, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      S && this.shape(S);
    });
  }
  _cast(S, R = {}) {
    var k;
    let D = super._cast(S, R);
    if (D === void 0) return this.getDefault(R);
    if (!this._typeCheck(D)) return D;
    let L = this.fields, V = (k = R.stripUnknown) != null ? k : this.spec.noUnknown, z = [].concat(this._nodes, Object.keys(D).filter((K) => !this._nodes.includes(K))), W = {}, U = Object.assign({}, R, {
      parent: W,
      __validating: R.__validating || !1
    }), q = !1;
    for (const K of z) {
      let Y = L[K], J = K in D;
      if (Y) {
        let Z, X = D[K];
        U.path = (R.path ? `${R.path}.` : "") + K, Y = Y.resolve({
          value: X,
          context: R.context,
          parent: W
        });
        let ee = Y instanceof Schema ? Y.spec : void 0, te = ee?.strict;
        if (ee != null && ee.strip) {
          q = q || K in D;
          continue;
        }
        Z = !R.__validating || !te ? (
          // TODO: use _cast, this is double resolving
          Y.cast(D[K], U)
        ) : D[K], Z !== void 0 && (W[K] = Z);
      } else J && !V && (W[K] = D[K]);
      (J !== K in W || W[K] !== D[K]) && (q = !0);
    }
    return q ? W : D;
  }
  _validate(S, R = {}, k, D) {
    let {
      from: L = [],
      originalValue: V = S,
      recursive: z = this.spec.recursive
    } = R;
    R.from = [{
      schema: this,
      value: V
    }, ...L], R.__validating = !0, R.originalValue = V, super._validate(S, R, k, (W, U) => {
      if (!z || !isObject(U)) {
        D(W, U);
        return;
      }
      V = V || U;
      let q = [];
      for (let K of this._nodes) {
        let Y = this.fields[K];
        !Y || Reference.isRef(Y) || q.push(Y.asNestedTest({
          options: R,
          key: K,
          parent: U,
          parentPath: R.path,
          originalParent: V
        }));
      }
      this.runTests({
        tests: q,
        value: U,
        originalValue: V,
        options: R
      }, k, (K) => {
        D(K.sort(this._sortErrors).concat(W), U);
      });
    });
  }
  clone(S) {
    const R = super.clone(S);
    return R.fields = Object.assign({}, this.fields), R._nodes = this._nodes, R._excludedEdges = this._excludedEdges, R._sortErrors = this._sortErrors, R;
  }
  concat(S) {
    let R = super.concat(S), k = R.fields;
    for (let [D, L] of Object.entries(this.fields)) {
      const V = k[D];
      k[D] = V === void 0 ? L : V;
    }
    return R.withMutation((D) => (
      // XXX: excludes here is wrong
      D.setFields(k, [...this._excludedEdges, ...S._excludedEdges])
    ));
  }
  _getDefault(S) {
    if ("default" in this.spec)
      return super._getDefault(S);
    if (!this._nodes.length)
      return;
    let R = {};
    return this._nodes.forEach((k) => {
      var D;
      const L = this.fields[k];
      let V = S;
      (D = V) != null && D.value && (V = Object.assign({}, V, {
        parent: V.value,
        value: V.value[k]
      })), R[k] = L && "getDefault" in L ? L.getDefault(V) : void 0;
    }), R;
  }
  setFields(S, R) {
    let k = this.clone();
    return k.fields = S, k._nodes = sortFields(S, R), k._sortErrors = sortByKeyOrder(Object.keys(S)), R && (k._excludedEdges = R), k;
  }
  shape(S, R = []) {
    return this.clone().withMutation((k) => {
      let D = k._excludedEdges;
      return R.length && (Array.isArray(R[0]) || (R = [R]), D = [...k._excludedEdges, ...R]), k.setFields(Object.assign(k.fields, S), D);
    });
  }
  partial() {
    const S = {};
    for (const [R, k] of Object.entries(this.fields))
      S[R] = "optional" in k && k.optional instanceof Function ? k.optional() : k;
    return this.setFields(S);
  }
  deepPartial() {
    return deepPartial(this);
  }
  pick(S) {
    const R = {};
    for (const k of S)
      this.fields[k] && (R[k] = this.fields[k]);
    return this.setFields(R, this._excludedEdges.filter(([k, D]) => S.includes(k) && S.includes(D)));
  }
  omit(S) {
    const R = [];
    for (const k of Object.keys(this.fields))
      S.includes(k) || R.push(k);
    return this.pick(R);
  }
  from(S, R, k) {
    let D = propertyExpr.getter(S, !0);
    return this.transform((L) => {
      if (!L) return L;
      let V = L;
      return deepHas(L, S) && (V = Object.assign({}, L), k || delete V[S], V[R] = D(L)), V;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }
  noUnknown(S = !0, R = object$1.noUnknown) {
    typeof S != "boolean" && (R = S, S = !0);
    let k = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: R,
      test(D) {
        if (D == null) return !0;
        const L = unknown(this.schema, D);
        return !S || L.length === 0 || this.createError({
          params: {
            unknown: L.join(", ")
          }
        });
      }
    });
    return k.spec.noUnknown = S, k;
  }
  unknown(S = !0, R = object$1.noUnknown) {
    return this.noUnknown(!S, R);
  }
  transformKeys(S) {
    return this.transform((R) => {
      if (!R) return R;
      const k = {};
      for (const D of Object.keys(R)) k[S(D)] = R[D];
      return k;
    });
  }
  camelCase() {
    return this.transformKeys(tinyCase.camelCase);
  }
  snakeCase() {
    return this.transformKeys(tinyCase.snakeCase);
  }
  constantCase() {
    return this.transformKeys((S) => tinyCase.snakeCase(S).toUpperCase());
  }
  describe(S) {
    const R = (S ? this.resolve(S) : this).clone(), k = super.describe(S);
    k.fields = {};
    for (const [L, V] of Object.entries(R.fields)) {
      var D;
      let z = S;
      (D = z) != null && D.value && (z = Object.assign({}, z, {
        parent: z.value,
        value: z.value[L]
      })), k.fields[L] = V.describe(z);
    }
    return k;
  }
}
create$3.prototype = ObjectSchema.prototype;
function create$2(T) {
  return new ArraySchema(T);
}
class ArraySchema extends Schema {
  constructor(S) {
    super({
      type: "array",
      spec: {
        types: S
      },
      check(R) {
        return Array.isArray(R);
      }
    }), this.innerType = void 0, this.innerType = S;
  }
  _cast(S, R) {
    const k = super._cast(S, R);
    if (!this._typeCheck(k) || !this.innerType)
      return k;
    let D = !1;
    const L = k.map((V, z) => {
      const W = this.innerType.cast(V, Object.assign({}, R, {
        path: `${R.path || ""}[${z}]`
      }));
      return W !== V && (D = !0), W;
    });
    return D ? L : k;
  }
  _validate(S, R = {}, k, D) {
    var L;
    let V = this.innerType, z = (L = R.recursive) != null ? L : this.spec.recursive;
    R.originalValue != null && R.originalValue, super._validate(S, R, k, (W, U) => {
      var q;
      if (!z || !V || !this._typeCheck(U)) {
        D(W, U);
        return;
      }
      let K = new Array(U.length);
      for (let J = 0; J < U.length; J++) {
        var Y;
        K[J] = V.asNestedTest({
          options: R,
          index: J,
          parent: U,
          parentPath: R.path,
          originalParent: (Y = R.originalValue) != null ? Y : S
        });
      }
      this.runTests({
        value: U,
        tests: K,
        originalValue: (q = R.originalValue) != null ? q : S,
        options: R
      }, k, (J) => D(J.concat(W), U));
    });
  }
  clone(S) {
    const R = super.clone(S);
    return R.innerType = this.innerType, R;
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }
  concat(S) {
    let R = super.concat(S);
    return R.innerType = this.innerType, S.innerType && (R.innerType = R.innerType ? (
      // @ts-expect-error Lazy doesn't have concat and will break
      R.innerType.concat(S.innerType)
    ) : S.innerType), R;
  }
  of(S) {
    let R = this.clone();
    if (!isSchema(S)) throw new TypeError("`array.of()` sub-schema must be a valid yup schema not: " + printValue(S));
    return R.innerType = S, R.spec = Object.assign({}, R.spec, {
      types: S
    }), R;
  }
  length(S, R = array$1.length) {
    return this.test({
      message: R,
      name: "length",
      exclusive: !0,
      params: {
        length: S
      },
      skipAbsent: !0,
      test(k) {
        return k.length === this.resolve(S);
      }
    });
  }
  min(S, R) {
    return R = R || array$1.min, this.test({
      message: R,
      name: "min",
      exclusive: !0,
      params: {
        min: S
      },
      skipAbsent: !0,
      // FIXME(ts): Array<typeof T>
      test(k) {
        return k.length >= this.resolve(S);
      }
    });
  }
  max(S, R) {
    return R = R || array$1.max, this.test({
      message: R,
      name: "max",
      exclusive: !0,
      params: {
        max: S
      },
      skipAbsent: !0,
      test(k) {
        return k.length <= this.resolve(S);
      }
    });
  }
  ensure() {
    return this.default(() => []).transform((S, R) => this._typeCheck(S) ? S : R == null ? [] : [].concat(R));
  }
  compact(S) {
    let R = S ? (k, D, L) => !S(k, D, L) : (k) => !!k;
    return this.transform((k) => k != null ? k.filter(R) : k);
  }
  describe(S) {
    const R = (S ? this.resolve(S) : this).clone(), k = super.describe(S);
    if (R.innerType) {
      var D;
      let L = S;
      (D = L) != null && D.value && (L = Object.assign({}, L, {
        parent: L.value,
        value: L.value[0]
      })), k.innerType = R.innerType.describe(L);
    }
    return k;
  }
}
create$2.prototype = ArraySchema.prototype;
function create$1(T) {
  return new TupleSchema(T);
}
class TupleSchema extends Schema {
  constructor(S) {
    super({
      type: "tuple",
      spec: {
        types: S
      },
      check(R) {
        const k = this.spec.types;
        return Array.isArray(R) && R.length === k.length;
      }
    }), this.withMutation(() => {
      this.typeError(tuple.notType);
    });
  }
  _cast(S, R) {
    const {
      types: k
    } = this.spec, D = super._cast(S, R);
    if (!this._typeCheck(D))
      return D;
    let L = !1;
    const V = k.map((z, W) => {
      const U = z.cast(D[W], Object.assign({}, R, {
        path: `${R.path || ""}[${W}]`
      }));
      return U !== D[W] && (L = !0), U;
    });
    return L ? V : D;
  }
  _validate(S, R = {}, k, D) {
    let L = this.spec.types;
    super._validate(S, R, k, (V, z) => {
      var W;
      if (!this._typeCheck(z)) {
        D(V, z);
        return;
      }
      let U = [];
      for (let [K, Y] of L.entries()) {
        var q;
        U[K] = Y.asNestedTest({
          options: R,
          index: K,
          parent: z,
          parentPath: R.path,
          originalParent: (q = R.originalValue) != null ? q : S
        });
      }
      this.runTests({
        value: z,
        tests: U,
        originalValue: (W = R.originalValue) != null ? W : S,
        options: R
      }, k, (K) => D(K.concat(V), z));
    });
  }
  describe(S) {
    const R = (S ? this.resolve(S) : this).clone(), k = super.describe(S);
    return k.innerType = R.spec.types.map((D, L) => {
      var V;
      let z = S;
      return (V = z) != null && V.value && (z = Object.assign({}, z, {
        parent: z.value,
        value: z.value[L]
      })), D.describe(z);
    }), k;
  }
}
create$1.prototype = TupleSchema.prototype;
function create(T) {
  return new Lazy(T);
}
class Lazy {
  constructor(S) {
    this.type = "lazy", this.__isYupSchema__ = !0, this.spec = void 0, this._resolve = (R, k = {}) => {
      let D = this.builder(R, k);
      if (!isSchema(D)) throw new TypeError("lazy() functions must return a valid schema");
      return this.spec.optional && (D = D.optional()), D.resolve(k);
    }, this.builder = S, this.spec = {
      meta: void 0,
      optional: !1
    };
  }
  clone(S) {
    const R = new Lazy(this.builder);
    return R.spec = Object.assign({}, this.spec, S), R;
  }
  optionality(S) {
    return this.clone({
      optional: S
    });
  }
  optional() {
    return this.optionality(!0);
  }
  resolve(S) {
    return this._resolve(S.value, S);
  }
  cast(S, R) {
    return this._resolve(S, R).cast(S, R);
  }
  asNestedTest(S) {
    let {
      key: R,
      index: k,
      parent: D,
      options: L
    } = S, V = D[k ?? R];
    return this._resolve(V, Object.assign({}, L, {
      value: V,
      parent: D
    })).asNestedTest(S);
  }
  validate(S, R) {
    return this._resolve(S, R).validate(S, R);
  }
  validateSync(S, R) {
    return this._resolve(S, R).validateSync(S, R);
  }
  validateAt(S, R, k) {
    return this._resolve(R, k).validateAt(S, R, k);
  }
  validateSyncAt(S, R, k) {
    return this._resolve(R, k).validateSyncAt(S, R, k);
  }
  isValid(S, R) {
    return this._resolve(S, R).isValid(S, R);
  }
  isValidSync(S, R) {
    return this._resolve(S, R).isValidSync(S, R);
  }
  describe(S) {
    return S ? this.resolve(S).describe(S) : {
      type: "lazy",
      meta: this.spec.meta,
      label: void 0
    };
  }
  meta(...S) {
    if (S.length === 0) return this.spec.meta;
    let R = this.clone();
    return R.spec.meta = Object.assign(R.spec.meta || {}, S[0]), R;
  }
}
function setLocale(T) {
  Object.keys(T).forEach((S) => {
    Object.keys(T[S]).forEach((R) => {
      locale[S][R] = T[S][R];
    });
  });
}
function addMethod(T, S, R) {
  if (!T || !isSchema(T.prototype)) throw new TypeError("You must provide a yup schema constructor function");
  if (typeof S != "string") throw new TypeError("A Method name must be provided");
  if (typeof R != "function") throw new TypeError("Method function must be provided");
  T.prototype[S] = R;
}
const yup = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ArraySchema,
  BooleanSchema,
  DateSchema,
  MixedSchema,
  NumberSchema,
  ObjectSchema,
  Schema,
  StringSchema,
  TupleSchema,
  ValidationError,
  addMethod,
  array: create$2,
  bool: create$7,
  boolean: create$7,
  date: create$4,
  defaultLocale: locale,
  getIn,
  isSchema,
  lazy: create,
  mixed: create$8,
  number: create$5,
  object: create$3,
  printValue,
  reach,
  ref: create$9,
  setLocale,
  string: create$6,
  tuple: create$1
}, Symbol.toStringTag, { value: "Module" }));
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(T) {
    for (var S = 1; S < arguments.length; S++) {
      var R = arguments[S];
      for (var k in R) ({}).hasOwnProperty.call(R, k) && (T[k] = R[k]);
    }
    return T;
  }, _extends$1.apply(null, arguments);
}
function _objectWithoutPropertiesLoose$1(T, S) {
  if (T == null) return {};
  var R = {};
  for (var k in T) if ({}.hasOwnProperty.call(T, k)) {
    if (S.includes(k)) continue;
    R[k] = T[k];
  }
  return R;
}
var define_process_env_default$1T = {};
function chainPropTypes(T, S) {
  return define_process_env_default$1T.NODE_ENV === "production" ? () => null : function(...k) {
    return T(...k) || S(...k);
  };
}
function isPlainObject(T) {
  if (typeof T != "object" || T === null)
    return !1;
  const S = Object.getPrototypeOf(T);
  return (S === null || S === Object.prototype || Object.getPrototypeOf(S) === null) && !(Symbol.toStringTag in T) && !(Symbol.iterator in T);
}
function deepClone(T) {
  if (!isPlainObject(T))
    return T;
  const S = {};
  return Object.keys(T).forEach((R) => {
    S[R] = deepClone(T[R]);
  }), S;
}
function deepmerge$1(T, S, R = {
  clone: !0
}) {
  const k = R.clone ? _extends$1({}, T) : T;
  return isPlainObject(T) && isPlainObject(S) && Object.keys(S).forEach((D) => {
    isPlainObject(S[D]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(T, D) && isPlainObject(T[D]) ? k[D] = deepmerge$1(T[D], S[D], R) : R.clone ? k[D] = isPlainObject(S[D]) ? deepClone(S[D]) : S[D] : k[D] = S[D];
  }), k;
}
const deepmerge = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: deepmerge$1,
  isPlainObject
}, Symbol.toStringTag, { value: "Module" }));
function isClassComponent$1(T) {
  const {
    prototype: S = {}
  } = T;
  return !!S.isReactComponent;
}
function acceptingRef(T, S, R, k, D) {
  const L = T[S], V = D || S;
  if (L == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let z;
  const W = L.type;
  return typeof W == "function" && !isClassComponent$1(W) && (z = "Did you accidentally use a plain function component for an element instead?"), z !== void 0 ? new Error(`Invalid ${k} \`${V}\` supplied to \`${R}\`. Expected an element that can hold a ref. ${z} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
function isClassComponent(T) {
  const {
    prototype: S = {}
  } = T;
  return !!S.isReactComponent;
}
function elementTypeAcceptingRef(T, S, R, k, D) {
  const L = T[S], V = D || S;
  if (L == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let z;
  return typeof L == "function" && !isClassComponent(L) && (z = "Did you accidentally provide a plain function component instead?"), z !== void 0 ? new Error(`Invalid ${k} \`${V}\` supplied to \`${R}\`. Expected an element type that can hold a ref. ${z} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef);
var define_process_env_default$1S = {};
const specialProperty = "exact-prop: ​";
function exactProp(T) {
  return define_process_env_default$1S.NODE_ENV === "production" ? T : _extends$1({}, T, {
    [specialProperty]: (S) => {
      const R = Object.keys(S).filter((k) => !T.hasOwnProperty(k));
      return R.length > 0 ? new Error(`The following props are not supported: ${R.map((k) => `\`${k}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function formatMuiErrorMessage$1(T) {
  let S = "https://mui.com/production-error/?code=" + T;
  for (let R = 1; R < arguments.length; R += 1)
    S += "&args[]=" + encodeURIComponent(arguments[R]);
  return "Minified MUI error #" + T + "; visit " + S + " for the full message.";
}
const formatMuiErrorMessage = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: formatMuiErrorMessage$1
}, Symbol.toStringTag, { value: "Module" }));
var reactIs = { exports: {} }, reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var T = Symbol.for("react.element"), S = Symbol.for("react.portal"), R = Symbol.for("react.fragment"), k = Symbol.for("react.strict_mode"), D = Symbol.for("react.profiler"), L = Symbol.for("react.provider"), V = Symbol.for("react.context"), z = Symbol.for("react.server_context"), W = Symbol.for("react.forward_ref"), U = Symbol.for("react.suspense"), q = Symbol.for("react.suspense_list"), K = Symbol.for("react.memo"), Y = Symbol.for("react.lazy"), J = Symbol.for("react.offscreen"), Z;
  Z = Symbol.for("react.module.reference");
  function X(ee) {
    if (typeof ee == "object" && ee !== null) {
      var te = ee.$$typeof;
      switch (te) {
        case T:
          switch (ee = ee.type, ee) {
            case R:
            case D:
            case k:
            case U:
            case q:
              return ee;
            default:
              switch (ee = ee && ee.$$typeof, ee) {
                case z:
                case V:
                case W:
                case Y:
                case K:
                case L:
                  return ee;
                default:
                  return te;
              }
          }
        case S:
          return te;
      }
    }
  }
  return reactIs_production_min.ContextConsumer = V, reactIs_production_min.ContextProvider = L, reactIs_production_min.Element = T, reactIs_production_min.ForwardRef = W, reactIs_production_min.Fragment = R, reactIs_production_min.Lazy = Y, reactIs_production_min.Memo = K, reactIs_production_min.Portal = S, reactIs_production_min.Profiler = D, reactIs_production_min.StrictMode = k, reactIs_production_min.Suspense = U, reactIs_production_min.SuspenseList = q, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(ee) {
    return X(ee) === V;
  }, reactIs_production_min.isContextProvider = function(ee) {
    return X(ee) === L;
  }, reactIs_production_min.isElement = function(ee) {
    return typeof ee == "object" && ee !== null && ee.$$typeof === T;
  }, reactIs_production_min.isForwardRef = function(ee) {
    return X(ee) === W;
  }, reactIs_production_min.isFragment = function(ee) {
    return X(ee) === R;
  }, reactIs_production_min.isLazy = function(ee) {
    return X(ee) === Y;
  }, reactIs_production_min.isMemo = function(ee) {
    return X(ee) === K;
  }, reactIs_production_min.isPortal = function(ee) {
    return X(ee) === S;
  }, reactIs_production_min.isProfiler = function(ee) {
    return X(ee) === D;
  }, reactIs_production_min.isStrictMode = function(ee) {
    return X(ee) === k;
  }, reactIs_production_min.isSuspense = function(ee) {
    return X(ee) === U;
  }, reactIs_production_min.isSuspenseList = function(ee) {
    return X(ee) === q;
  }, reactIs_production_min.isValidElementType = function(ee) {
    return typeof ee == "string" || typeof ee == "function" || ee === R || ee === D || ee === k || ee === U || ee === q || ee === J || typeof ee == "object" && ee !== null && (ee.$$typeof === Y || ee.$$typeof === K || ee.$$typeof === L || ee.$$typeof === V || ee.$$typeof === W || ee.$$typeof === Z || ee.getModuleId !== void 0);
  }, reactIs_production_min.typeOf = X, reactIs_production_min;
}
var reactIs_development = {}, hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development) return reactIs_development;
  hasRequiredReactIs_development = 1;
  var T = {};
  /**
   * @license React
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  return T.NODE_ENV !== "production" && function() {
    var S = Symbol.for("react.element"), R = Symbol.for("react.portal"), k = Symbol.for("react.fragment"), D = Symbol.for("react.strict_mode"), L = Symbol.for("react.profiler"), V = Symbol.for("react.provider"), z = Symbol.for("react.context"), W = Symbol.for("react.server_context"), U = Symbol.for("react.forward_ref"), q = Symbol.for("react.suspense"), K = Symbol.for("react.suspense_list"), Y = Symbol.for("react.memo"), J = Symbol.for("react.lazy"), Z = Symbol.for("react.offscreen"), X = !1, ee = !1, te = !1, re = !1, Q = !1, ne;
    ne = Symbol.for("react.module.reference");
    function oe(De) {
      return !!(typeof De == "string" || typeof De == "function" || De === k || De === L || Q || De === D || De === q || De === K || re || De === Z || X || ee || te || typeof De == "object" && De !== null && (De.$$typeof === J || De.$$typeof === Y || De.$$typeof === V || De.$$typeof === z || De.$$typeof === U || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      De.$$typeof === ne || De.getModuleId !== void 0));
    }
    function ae(De) {
      if (typeof De == "object" && De !== null) {
        var Le = De.$$typeof;
        switch (Le) {
          case S:
            var ze = De.type;
            switch (ze) {
              case k:
              case L:
              case D:
              case q:
              case K:
                return ze;
              default:
                var We = ze && ze.$$typeof;
                switch (We) {
                  case W:
                  case z:
                  case U:
                  case J:
                  case Y:
                  case V:
                    return We;
                  default:
                    return Le;
                }
            }
          case R:
            return Le;
        }
      }
    }
    var se = z, ie = V, he = S, xe = U, Pe = k, Re = J, ke = Y, Te = R, fe = L, ue = D, Ce = q, ce = K, pe = !1, _e = !1;
    function ge(De) {
      return pe || (pe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Ae(De) {
      return _e || (_e = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Ee(De) {
      return ae(De) === z;
    }
    function ve(De) {
      return ae(De) === V;
    }
    function le(De) {
      return typeof De == "object" && De !== null && De.$$typeof === S;
    }
    function me(De) {
      return ae(De) === U;
    }
    function Se(De) {
      return ae(De) === k;
    }
    function ye(De) {
      return ae(De) === J;
    }
    function be(De) {
      return ae(De) === Y;
    }
    function $e(De) {
      return ae(De) === R;
    }
    function Oe(De) {
      return ae(De) === L;
    }
    function Ie(De) {
      return ae(De) === D;
    }
    function we(De) {
      return ae(De) === q;
    }
    function Fe(De) {
      return ae(De) === K;
    }
    reactIs_development.ContextConsumer = se, reactIs_development.ContextProvider = ie, reactIs_development.Element = he, reactIs_development.ForwardRef = xe, reactIs_development.Fragment = Pe, reactIs_development.Lazy = Re, reactIs_development.Memo = ke, reactIs_development.Portal = Te, reactIs_development.Profiler = fe, reactIs_development.StrictMode = ue, reactIs_development.Suspense = Ce, reactIs_development.SuspenseList = ce, reactIs_development.isAsyncMode = ge, reactIs_development.isConcurrentMode = Ae, reactIs_development.isContextConsumer = Ee, reactIs_development.isContextProvider = ve, reactIs_development.isElement = le, reactIs_development.isForwardRef = me, reactIs_development.isFragment = Se, reactIs_development.isLazy = ye, reactIs_development.isMemo = be, reactIs_development.isPortal = $e, reactIs_development.isProfiler = Oe, reactIs_development.isStrictMode = Ie, reactIs_development.isSuspense = we, reactIs_development.isSuspenseList = Fe, reactIs_development.isValidElementType = oe, reactIs_development.typeOf = ae;
  }(), reactIs_development;
}
var define_process_env_default$1R = {};
define_process_env_default$1R.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development();
var reactIsExports = reactIs.exports;
const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(T) {
  const S = `${T}`.match(fnNameMatchRegex);
  return S && S[1] || "";
}
function getFunctionComponentName(T, S = "") {
  return T.displayName || T.name || getFunctionName(T) || S;
}
function getWrappedName(T, S, R) {
  const k = getFunctionComponentName(S);
  return T.displayName || (k !== "" ? `${R}(${k})` : R);
}
function getDisplayName$1(T) {
  if (T != null) {
    if (typeof T == "string")
      return T;
    if (typeof T == "function")
      return getFunctionComponentName(T, "Component");
    if (typeof T == "object")
      switch (T.$$typeof) {
        case reactIsExports.ForwardRef:
          return getWrappedName(T, T.render, "ForwardRef");
        case reactIsExports.Memo:
          return getWrappedName(T, T.type, "memo");
        default:
          return;
      }
  }
}
const getDisplayName = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: getDisplayName$1,
  getFunctionName
}, Symbol.toStringTag, { value: "Module" }));
var define_process_env_default$1Q = {};
function HTMLElementType(T, S, R, k, D) {
  if (define_process_env_default$1Q.NODE_ENV === "production")
    return null;
  const L = T[S], V = D || S;
  return L == null ? null : L && L.nodeType !== 1 ? new Error(`Invalid ${k} \`${V}\` supplied to \`${R}\`. Expected an HTMLElement.`) : null;
}
const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
var define_process_env_default$1P = {};
function capitalize$1(T) {
  if (typeof T != "string")
    throw new Error(define_process_env_default$1P.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage$1(7));
  return T.charAt(0).toUpperCase() + T.slice(1);
}
const capitalize = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: capitalize$1
}, Symbol.toStringTag, { value: "Module" }));
function createChainedFunction(...T) {
  return T.reduce((S, R) => R == null ? S : function(...D) {
    S.apply(this, D), R.apply(this, D);
  }, () => {
  });
}
function debounce$1(T, S = 166) {
  let R;
  function k(...D) {
    const L = () => {
      T.apply(this, D);
    };
    clearTimeout(R), R = setTimeout(L, S);
  }
  return k.clear = () => {
    clearTimeout(R);
  }, k;
}
function isMuiElement(T, S) {
  var R, k;
  return /* @__PURE__ */ React$1.isValidElement(T) && S.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (R = T.type.muiName) != null ? R : (k = T.type) == null || (k = k._payload) == null || (k = k.value) == null ? void 0 : k.muiName
  ) !== -1;
}
function ownerDocument(T) {
  return T && T.ownerDocument || document;
}
function ownerWindow(T) {
  return ownerDocument(T).defaultView || window;
}
function setRef(T, S) {
  typeof T == "function" ? T(S) : T && (T.current = S);
}
const useEnhancedEffect = typeof window < "u" ? React$1.useLayoutEffect : React$1.useEffect;
let globalId = 0;
function useGlobalId(T) {
  const [S, R] = React$1.useState(T), k = T || S;
  return React$1.useEffect(() => {
    S == null && (globalId += 1, R(`mui-${globalId}`));
  }, [S]), k;
}
const maybeReactUseId = React$1.useId;
function useId(T) {
  if (maybeReactUseId !== void 0) {
    const S = maybeReactUseId();
    return T ?? S;
  }
  return useGlobalId(T);
}
var define_process_env_default$1O = {};
function unsupportedProp(T, S, R, k, D) {
  if (define_process_env_default$1O.NODE_ENV === "production")
    return null;
  const L = D || S;
  return typeof T[S] < "u" ? new Error(`The prop \`${L}\` is not supported. Please remove it.`) : null;
}
var define_process_env_default$1N = {};
function useControlled({
  controlled: T,
  default: S,
  name: R,
  state: k = "value"
}) {
  const {
    current: D
  } = React$1.useRef(T !== void 0), [L, V] = React$1.useState(S), z = D ? T : L;
  if (define_process_env_default$1N.NODE_ENV !== "production") {
    React$1.useEffect(() => {
      D !== (T !== void 0) && console.error([`MUI: A component is changing the ${D ? "" : "un"}controlled ${k} state of ${R} to be ${D ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${R} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [k, R, T]);
    const {
      current: U
    } = React$1.useRef(S);
    React$1.useEffect(() => {
      !D && !Object.is(U, S) && console.error([`MUI: A component is changing the default ${k} state of an uncontrolled ${R} after being initialized. To suppress this warning opt to use a controlled ${R}.`].join(`
`));
    }, [JSON.stringify(S)]);
  }
  const W = React$1.useCallback((U) => {
    D || V(U);
  }, []);
  return [z, W];
}
function useEventCallback(T) {
  const S = React$1.useRef(T);
  return useEnhancedEffect(() => {
    S.current = T;
  }), React$1.useRef((...R) => (
    // @ts-expect-error hide `this`
    (0, S.current)(...R)
  )).current;
}
function useForkRef(...T) {
  return React$1.useMemo(() => T.every((S) => S == null) ? null : (S) => {
    T.forEach((R) => {
      setRef(R, S);
    });
  }, T);
}
const UNINITIALIZED = {};
function useLazyRef(T, S) {
  const R = React$1.useRef(UNINITIALIZED);
  return R.current === UNINITIALIZED && (R.current = T(S)), R;
}
const EMPTY = [];
function useOnMount(T) {
  React$1.useEffect(T, EMPTY);
}
class Timeout {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new Timeout();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(S, R) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, R();
    }, S);
  }
}
function useTimeout() {
  const T = useLazyRef(Timeout.create).current;
  return useOnMount(T.disposeEffect), T;
}
let hadKeyboardEvent = !0, hadFocusVisibleRecently = !1;
const hadFocusVisibleRecentlyTimeout = new Timeout(), inputTypesWhitelist = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function focusTriggersKeyboardModality(T) {
  const {
    type: S,
    tagName: R
  } = T;
  return !!(R === "INPUT" && inputTypesWhitelist[S] && !T.readOnly || R === "TEXTAREA" && !T.readOnly || T.isContentEditable);
}
function handleKeyDown(T) {
  T.metaKey || T.altKey || T.ctrlKey || (hadKeyboardEvent = !0);
}
function handlePointerDown() {
  hadKeyboardEvent = !1;
}
function handleVisibilityChange() {
  this.visibilityState === "hidden" && hadFocusVisibleRecently && (hadKeyboardEvent = !0);
}
function prepare(T) {
  T.addEventListener("keydown", handleKeyDown, !0), T.addEventListener("mousedown", handlePointerDown, !0), T.addEventListener("pointerdown", handlePointerDown, !0), T.addEventListener("touchstart", handlePointerDown, !0), T.addEventListener("visibilitychange", handleVisibilityChange, !0);
}
function isFocusVisible(T) {
  const {
    target: S
  } = T;
  try {
    return S.matches(":focus-visible");
  } catch {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(S);
}
function useIsFocusVisible() {
  const T = React$1.useCallback((D) => {
    D != null && prepare(D.ownerDocument);
  }, []), S = React$1.useRef(!1);
  function R() {
    return S.current ? (hadFocusVisibleRecently = !0, hadFocusVisibleRecentlyTimeout.start(100, () => {
      hadFocusVisibleRecently = !1;
    }), S.current = !1, !0) : !1;
  }
  function k(D) {
    return isFocusVisible(D) ? (S.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: S,
    onFocus: k,
    onBlur: R,
    ref: T
  };
}
function getScrollbarSize(T) {
  const S = T.documentElement.clientWidth;
  return Math.abs(window.innerWidth - S);
}
const visuallyHidden = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
var define_process_env_default$1M = {};
function getTypeByValue(T) {
  const S = typeof T;
  switch (S) {
    case "number":
      return Number.isNaN(T) ? "NaN" : Number.isFinite(T) ? T !== Math.floor(T) ? "float" : "number" : "Infinity";
    case "object":
      return T === null ? "null" : T.constructor.name;
    default:
      return S;
  }
}
function ponyfillIsInteger(T) {
  return typeof T == "number" && isFinite(T) && Math.floor(T) === T;
}
const isInteger = Number.isInteger || ponyfillIsInteger;
function requiredInteger(T, S, R, k) {
  const D = T[S];
  if (D == null || !isInteger(D)) {
    const L = getTypeByValue(D);
    return new RangeError(`Invalid ${k} \`${S}\` of type \`${L}\` supplied to \`${R}\`, expected \`integer\`.`);
  }
  return null;
}
function validator(T, S, ...R) {
  return T[S] === void 0 ? null : requiredInteger(T, S, ...R);
}
function validatorNoop() {
  return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
const integerPropType = define_process_env_default$1M.NODE_ENV === "production" ? validatorNoop : validator;
function resolveProps(T, S) {
  const R = _extends$1({}, S);
  return Object.keys(T).forEach((k) => {
    if (k.toString().match(/^(components|slots)$/))
      R[k] = _extends$1({}, T[k], R[k]);
    else if (k.toString().match(/^(componentsProps|slotProps)$/)) {
      const D = T[k] || {}, L = S[k];
      R[k] = {}, !L || !Object.keys(L) ? R[k] = D : !D || !Object.keys(D) ? R[k] = L : (R[k] = _extends$1({}, L), Object.keys(D).forEach((V) => {
        R[k][V] = resolveProps(D[V], L[V]);
      }));
    } else R[k] === void 0 && (R[k] = T[k]);
  }), R;
}
function composeClasses(T, S, R = void 0) {
  const k = {};
  return Object.keys(T).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (D) => {
      k[D] = T[D].reduce((L, V) => {
        if (V) {
          const z = S(V);
          z !== "" && L.push(z), R && R[V] && L.push(R[V]);
        }
        return L;
      }, []).join(" ");
    }
  ), k;
}
const defaultGenerator = (T) => T, createClassNameGenerator = () => {
  let T = defaultGenerator;
  return {
    configure(S) {
      T = S;
    },
    generate(S) {
      return T(S);
    },
    reset() {
      T = defaultGenerator;
    }
  };
}, ClassNameGenerator = createClassNameGenerator(), globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass$1(T, S, R = "Mui") {
  const k = globalStateClasses[S];
  return k ? `${R}-${k}` : `${ClassNameGenerator.generate(T)}-${S}`;
}
function generateUtilityClasses$1(T, S, R = "Mui") {
  const k = {};
  return S.forEach((D) => {
    k[D] = generateUtilityClass$1(T, D, R);
  }), k;
}
function clamp$1(T, S = Number.MIN_SAFE_INTEGER, R = Number.MAX_SAFE_INTEGER) {
  return Math.max(S, Math.min(T, R));
}
const clamp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: clamp$1
}, Symbol.toStringTag, { value: "Module" }));
function isHostComponent(T) {
  return typeof T == "string";
}
function appendOwnerState(T, S, R) {
  return T === void 0 || isHostComponent(T) ? S : _extends$1({}, S, {
    ownerState: _extends$1({}, S.ownerState, R)
  });
}
var define_process_env_default$1L = {};
const defaultContextValue = {
  disableDefaultClasses: !1
}, ClassNameConfiguratorContext = /* @__PURE__ */ React$1.createContext(defaultContextValue);
define_process_env_default$1L.NODE_ENV !== "production" && (ClassNameConfiguratorContext.displayName = "ClassNameConfiguratorContext");
function useClassNamesOverride(T) {
  const {
    disableDefaultClasses: S
  } = React$1.useContext(ClassNameConfiguratorContext);
  return (R) => S ? "" : T(R);
}
function extractEventHandlers(T, S = []) {
  if (T === void 0)
    return {};
  const R = {};
  return Object.keys(T).filter((k) => k.match(/^on[A-Z]/) && typeof T[k] == "function" && !S.includes(k)).forEach((k) => {
    R[k] = T[k];
  }), R;
}
function resolveComponentProps(T, S, R) {
  return typeof T == "function" ? T(S, R) : T;
}
function r(T) {
  var S, R, k = "";
  if (typeof T == "string" || typeof T == "number") k += T;
  else if (typeof T == "object") if (Array.isArray(T)) {
    var D = T.length;
    for (S = 0; S < D; S++) T[S] && (R = r(T[S])) && (k && (k += " "), k += R);
  } else for (R in T) T[R] && (k && (k += " "), k += R);
  return k;
}
function clsx() {
  for (var T, S, R = 0, k = "", D = arguments.length; R < D; R++) (T = arguments[R]) && (S = r(T)) && (k && (k += " "), k += S);
  return k;
}
function omitEventHandlers(T) {
  if (T === void 0)
    return {};
  const S = {};
  return Object.keys(T).filter((R) => !(R.match(/^on[A-Z]/) && typeof T[R] == "function")).forEach((R) => {
    S[R] = T[R];
  }), S;
}
function mergeSlotProps(T) {
  const {
    getSlotProps: S,
    additionalProps: R,
    externalSlotProps: k,
    externalForwardedProps: D,
    className: L
  } = T;
  if (!S) {
    const J = clsx(R?.className, L, D?.className, k?.className), Z = _extends$1({}, R?.style, D?.style, k?.style), X = _extends$1({}, R, D, k);
    return J.length > 0 && (X.className = J), Object.keys(Z).length > 0 && (X.style = Z), {
      props: X,
      internalRef: void 0
    };
  }
  const V = extractEventHandlers(_extends$1({}, D, k)), z = omitEventHandlers(k), W = omitEventHandlers(D), U = S(V), q = clsx(U?.className, R?.className, L, D?.className, k?.className), K = _extends$1({}, U?.style, R?.style, D?.style, k?.style), Y = _extends$1({}, U, R, W, z);
  return q.length > 0 && (Y.className = q), Object.keys(K).length > 0 && (Y.style = K), {
    props: Y,
    internalRef: U.ref
  };
}
const _excluded$1t = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function useSlotProps(T) {
  var S;
  const {
    elementType: R,
    externalSlotProps: k,
    ownerState: D,
    skipResolvingSlotProps: L = !1
  } = T, V = _objectWithoutPropertiesLoose$1(T, _excluded$1t), z = L ? {} : resolveComponentProps(k, D), {
    props: W,
    internalRef: U
  } = mergeSlotProps(_extends$1({}, V, {
    externalSlotProps: z
  })), q = useForkRef(U, z?.ref, (S = T.additionalProps) == null ? void 0 : S.ref);
  return appendOwnerState(R, _extends$1({}, W, {
    ref: q
  }), D);
}
const _excluded$1s = ["count", "getItemAriaLabel", "onPageChange", "page", "rowsPerPage", "showFirstButton", "showLastButton", "direction", "ownerState", "slotProps", "slots"];
var _span$4, _span2, _span3, _span4;
function LastPageIconDefault() {
  return _span$4 || (_span$4 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    children: "⇾|"
  }));
}
function FirstPageIconDefault() {
  return _span2 || (_span2 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    children: "|⇽"
  }));
}
function NextPageIconDefault() {
  return _span3 || (_span3 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    children: "⇾"
  }));
}
function BackPageIconDefault() {
  return _span4 || (_span4 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    children: "⇽"
  }));
}
function defaultGetAriaLabel$1(T) {
  return `Go to ${T} page`;
}
const TablePaginationActions = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k, D, L, V, z, W, U, q, K;
  const {
    count: Y,
    getItemAriaLabel: J = defaultGetAriaLabel$1,
    onPageChange: Z,
    page: X,
    rowsPerPage: ee,
    showFirstButton: te = !1,
    showLastButton: re = !1,
    direction: Q,
    slotProps: ne = {},
    slots: oe = {}
  } = S, ae = _objectWithoutPropertiesLoose$1(S, _excluded$1s), se = S, ie = (me) => {
    Z(me, 0);
  }, he = (me) => {
    Z(me, X - 1);
  }, xe = (me) => {
    Z(me, X + 1);
  }, Pe = (me) => {
    Z(me, Math.max(0, Math.ceil(Y / ee) - 1));
  }, Re = (k = oe.root) != null ? k : "div", ke = useSlotProps({
    elementType: Re,
    externalSlotProps: ne.root,
    externalForwardedProps: ae,
    additionalProps: {
      ref: R
    },
    ownerState: se
  }), Te = (D = oe.firstButton) != null ? D : "button", fe = useSlotProps({
    elementType: Te,
    externalSlotProps: ne.firstButton,
    additionalProps: {
      onClick: ie,
      disabled: X === 0,
      "aria-label": J("first", X),
      title: J("first", X)
    },
    ownerState: se
  }), ue = (L = oe.lastButton) != null ? L : "button", Ce = useSlotProps({
    elementType: ue,
    externalSlotProps: ne.lastButton,
    additionalProps: {
      onClick: Pe,
      disabled: X >= Math.ceil(Y / ee) - 1,
      "aria-label": J("last", X),
      title: J("last", X)
    },
    ownerState: se
  }), ce = (V = oe.nextButton) != null ? V : "button", pe = useSlotProps({
    elementType: ce,
    externalSlotProps: ne.nextButton,
    additionalProps: {
      onClick: xe,
      disabled: Y !== -1 ? X >= Math.ceil(Y / ee) - 1 : !1,
      "aria-label": J("next", X),
      title: J("next", X)
    },
    ownerState: se
  }), _e = (z = oe.backButton) != null ? z : "button", ge = useSlotProps({
    elementType: _e,
    externalSlotProps: ne.backButton,
    additionalProps: {
      onClick: he,
      disabled: X === 0,
      "aria-label": J("previous", X),
      title: J("previous", X)
    },
    ownerState: se
  }), Ae = (W = oe.lastPageIcon) != null ? W : LastPageIconDefault, Ee = (U = oe.firstPageIcon) != null ? U : FirstPageIconDefault, ve = (q = oe.nextPageIcon) != null ? q : NextPageIconDefault, le = (K = oe.backPageIcon) != null ? K : BackPageIconDefault;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Re, _extends$1({}, ke, {
    children: [te && /* @__PURE__ */ jsxRuntimeExports.jsx(Te, _extends$1({}, fe, {
      children: Q === "rtl" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Ae, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(Ee, {})
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(_e, _extends$1({}, ge, {
      children: Q === "rtl" ? /* @__PURE__ */ jsxRuntimeExports.jsx(ve, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(le, {})
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(ce, _extends$1({}, pe, {
      children: Q === "rtl" ? /* @__PURE__ */ jsxRuntimeExports.jsx(le, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(ve, {})
    })), re && /* @__PURE__ */ jsxRuntimeExports.jsx(ue, _extends$1({}, Ce, {
      children: Q === "rtl" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Ee, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(Ae, {})
    }))]
  }));
}), GLOBAL_CLASS_PREFIX = "base";
function buildStateClass(T) {
  return `${GLOBAL_CLASS_PREFIX}--${T}`;
}
function buildSlotClass(T, S) {
  return `${GLOBAL_CLASS_PREFIX}-${T}-${S}`;
}
function generateUtilityClass(T, S) {
  const R = globalStateClasses[S];
  return R ? buildStateClass(R) : buildSlotClass(T, S);
}
function generateUtilityClasses(T, S) {
  const R = {};
  return S.forEach((k) => {
    R[k] = generateUtilityClass(T, k);
  }), R;
}
const COMPONENT_NAME$1 = "TablePagination";
function getTablePaginationUtilityClass(T) {
  return generateUtilityClass(COMPONENT_NAME$1, T);
}
const tablePaginationClasses = generateUtilityClasses(COMPONENT_NAME$1, ["root", "toolbar", "spacer", "selectLabel", "selectRoot", "select", "selectIcon", "input", "menuItem", "displayedRows", "actions"]);
var define_process_env_default$1K = {};
const _excluded$1r = ["colSpan", "count", "getItemAriaLabel", "labelDisplayedRows", "labelId", "labelRowsPerPage", "onPageChange", "onRowsPerPageChange", "page", "rowsPerPage", "rowsPerPageOptions", "selectId", "slotProps", "slots"];
function defaultLabelDisplayedRows({
  from: T,
  to: S,
  count: R
}) {
  return `${T}–${S} of ${R !== -1 ? R : `more than ${S}`}`;
}
function defaultGetAriaLabel(T) {
  return `Go to ${T} page`;
}
const useUtilityClasses$10 = () => composeClasses({
  root: ["root"],
  toolbar: ["toolbar"],
  spacer: ["spacer"],
  selectLabel: ["selectLabel"],
  select: ["select"],
  input: ["input"],
  selectIcon: ["selectIcon"],
  menuItem: ["menuItem"],
  displayedRows: ["displayedRows"],
  actions: ["actions"]
}, useClassNamesOverride(getTablePaginationUtilityClass)), TablePagination$1 = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k, D, L, V, z, W, U, q;
  const {
    colSpan: K,
    count: Y,
    getItemAriaLabel: J = defaultGetAriaLabel,
    labelDisplayedRows: Z = defaultLabelDisplayedRows,
    labelId: X,
    labelRowsPerPage: ee = "Rows per page:",
    onPageChange: te,
    onRowsPerPageChange: re,
    page: Q,
    rowsPerPage: ne,
    rowsPerPageOptions: oe = [10, 25, 50, 100],
    selectId: ae,
    slotProps: se = {},
    slots: ie = {}
  } = S, he = _objectWithoutPropertiesLoose$1(S, _excluded$1r), xe = S, Pe = useUtilityClasses$10();
  let Re;
  const ke = (k = ie.root) != null ? k : "td";
  (ke === "td" || !isHostComponent(ke)) && (Re = K || 1e3);
  const Te = () => Y === -1 ? (Q + 1) * ne : ne === -1 ? Y : Math.min(Y, (Q + 1) * ne), fe = useId(ae), ue = useId(X), Ce = useSlotProps({
    elementType: ke,
    externalSlotProps: se.root,
    externalForwardedProps: he,
    additionalProps: {
      colSpan: Re,
      ref: R
    },
    ownerState: xe,
    className: Pe.root
  }), ce = (D = ie.select) != null ? D : "select", pe = useSlotProps({
    elementType: ce,
    externalSlotProps: se.select,
    additionalProps: {
      value: ne,
      id: fe,
      onChange: (Ie) => re && re(Ie),
      "aria-label": ne.toString(),
      "aria-labelledby": [ue, fe].filter(Boolean).join(" ") || void 0
    },
    ownerState: xe,
    className: Pe.select
  }), _e = (L = ie.actions) != null ? L : TablePaginationActions, ge = useSlotProps({
    elementType: _e,
    externalSlotProps: se.actions,
    additionalProps: {
      page: Q,
      rowsPerPage: ne,
      count: Y,
      onPageChange: te,
      getItemAriaLabel: J
    },
    ownerState: xe,
    className: Pe.actions
  }), Ae = (V = ie.menuItem) != null ? V : "option", Ee = useSlotProps({
    elementType: Ae,
    externalSlotProps: se.menuItem,
    additionalProps: {
      value: void 0
    },
    ownerState: xe,
    className: Pe.menuItem
  }), ve = (z = ie.selectLabel) != null ? z : "p", le = useSlotProps({
    elementType: ve,
    externalSlotProps: se.selectLabel,
    additionalProps: {
      id: ue
    },
    ownerState: xe,
    className: Pe.selectLabel
  }), me = (W = ie.displayedRows) != null ? W : "p", Se = useSlotProps({
    elementType: me,
    externalSlotProps: se.displayedRows,
    ownerState: xe,
    className: Pe.displayedRows
  }), ye = (U = ie.toolbar) != null ? U : "div", be = useSlotProps({
    elementType: ye,
    externalSlotProps: se.toolbar,
    ownerState: xe,
    className: Pe.toolbar
  }), $e = (q = ie.spacer) != null ? q : "div", Oe = useSlotProps({
    elementType: $e,
    externalSlotProps: se.spacer,
    ownerState: xe,
    className: Pe.spacer
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ke, _extends$1({}, Ce, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ye, _extends$1({}, be, {
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx($e, _extends$1({}, Oe)), oe.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(ve, _extends$1({}, le, {
        children: ee
      })), oe.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(ce, _extends$1({}, pe, {
        children: oe.map((Ie) => /* @__PURE__ */ createElement$1(Ae, _extends$1({}, Ee, {
          key: typeof Ie != "number" && Ie.label ? Ie.label : Ie,
          value: typeof Ie != "number" && Ie.value ? Ie.value : Ie
        }), typeof Ie != "number" && Ie.label ? Ie.label : Ie))
      })), /* @__PURE__ */ jsxRuntimeExports.jsx(me, _extends$1({}, Se, {
        children: Z({
          from: Y === 0 ? 0 : Q * ne + 1,
          to: Te(),
          count: Y === -1 ? -1 : Y,
          page: Q
        })
      })), /* @__PURE__ */ jsxRuntimeExports.jsx(_e, _extends$1({}, ge))]
    }))
  }));
});
define_process_env_default$1K.NODE_ENV !== "production" && (TablePagination$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  colSpan: PropTypes.number,
  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: PropTypes.number.isRequired,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type: ItemAriaLabelType) {
   *   return `Go to ${type} page`;
   * }
   */
  getItemAriaLabel: PropTypes.func,
  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }: LabelDisplayedRowsArgs) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */
  labelDisplayedRows: PropTypes.func,
  /**
   * Id of the label element within the pagination.
   */
  labelId: PropTypes.string,
  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */
  labelRowsPerPage: PropTypes.node,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: PropTypes.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */
  onRowsPerPageChange: PropTypes.func,
  /**
   * The zero-based index of the current page.
   */
  page: chainPropTypes(integerPropType.isRequired, (T) => {
    const {
      count: S,
      page: R,
      rowsPerPage: k
    } = T;
    if (S === -1)
      return null;
    const D = Math.max(0, Math.ceil(S / k) - 1);
    return R < 0 || R > D ? new Error(`MUI: The page prop of a TablePagination is out of range (0 to ${D}, but page is ${R}).`) : null;
  }),
  /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */
  rowsPerPage: integerPropType.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })]).isRequired),
  /**
   * Id of the select element within the pagination.
   */
  selectId: PropTypes.string,
  /**
   * The props used for each slot inside the TablePagination.
   * @default {}
   */
  slotProps: PropTypes.shape({
    actions: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    displayedRows: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    menuItem: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    select: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    selectLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    spacer: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    toolbar: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the TablePagination.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    actions: PropTypes.elementType,
    displayedRows: PropTypes.elementType,
    menuItem: PropTypes.elementType,
    root: PropTypes.elementType,
    select: PropTypes.elementType,
    selectLabel: PropTypes.elementType,
    spacer: PropTypes.elementType,
    toolbar: PropTypes.elementType
  })
});
const THEME_ID = "$$material";
var define_process_env_default$1J = {};
function sheetForTag(T) {
  if (T.sheet)
    return T.sheet;
  for (var S = 0; S < document.styleSheets.length; S++)
    if (document.styleSheets[S].ownerNode === T)
      return document.styleSheets[S];
}
function createStyleElement(T) {
  var S = document.createElement("style");
  return S.setAttribute("data-emotion", T.key), T.nonce !== void 0 && S.setAttribute("nonce", T.nonce), S.appendChild(document.createTextNode("")), S.setAttribute("data-s", ""), S;
}
var StyleSheet = /* @__PURE__ */ function() {
  function T(R) {
    var k = this;
    this._insertTag = function(D) {
      var L;
      k.tags.length === 0 ? k.insertionPoint ? L = k.insertionPoint.nextSibling : k.prepend ? L = k.container.firstChild : L = k.before : L = k.tags[k.tags.length - 1].nextSibling, k.container.insertBefore(D, L), k.tags.push(D);
    }, this.isSpeedy = R.speedy === void 0 ? define_process_env_default$1J.NODE_ENV === "production" : R.speedy, this.tags = [], this.ctr = 0, this.nonce = R.nonce, this.key = R.key, this.container = R.container, this.prepend = R.prepend, this.insertionPoint = R.insertionPoint, this.before = null;
  }
  var S = T.prototype;
  return S.hydrate = function(k) {
    k.forEach(this._insertTag);
  }, S.insert = function(k) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var D = this.tags[this.tags.length - 1];
    if (define_process_env_default$1J.NODE_ENV !== "production") {
      var L = k.charCodeAt(0) === 64 && k.charCodeAt(1) === 105;
      L && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + k + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !L;
    }
    if (this.isSpeedy) {
      var V = sheetForTag(D);
      try {
        V.insertRule(k, V.cssRules.length);
      } catch (z) {
        define_process_env_default$1J.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(k) && console.error('There was a problem inserting the following rule: "' + k + '"', z);
      }
    } else
      D.appendChild(document.createTextNode(k));
    this.ctr++;
  }, S.flush = function() {
    this.tags.forEach(function(k) {
      return k.parentNode && k.parentNode.removeChild(k);
    }), this.tags = [], this.ctr = 0, define_process_env_default$1J.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, T;
}(), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs = Math.abs, from = String.fromCharCode, assign = Object.assign;
function hash$2(T, S) {
  return charat(T, 0) ^ 45 ? (((S << 2 ^ charat(T, 0)) << 2 ^ charat(T, 1)) << 2 ^ charat(T, 2)) << 2 ^ charat(T, 3) : 0;
}
function trim(T) {
  return T.trim();
}
function match(T, S) {
  return (T = S.exec(T)) ? T[0] : T;
}
function replace(T, S, R) {
  return T.replace(S, R);
}
function indexof(T, S) {
  return T.indexOf(S);
}
function charat(T, S) {
  return T.charCodeAt(S) | 0;
}
function substr(T, S, R) {
  return T.slice(S, R);
}
function strlen(T) {
  return T.length;
}
function sizeof(T) {
  return T.length;
}
function append(T, S) {
  return S.push(T), T;
}
function combine(T, S) {
  return T.map(S).join("");
}
var line = 1, column = 1, length = 0, position = 0, character = 0, characters = "";
function node(T, S, R, k, D, L, V) {
  return { value: T, root: S, parent: R, type: k, props: D, children: L, line, column, length: V, return: "" };
}
function copy(T, S) {
  return assign(node("", null, null, "", null, null, 0), T, { length: -T.length }, S);
}
function char() {
  return character;
}
function prev() {
  return character = position > 0 ? charat(characters, --position) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position < length ? charat(characters, position++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice$1(T, S) {
  return substr(characters, T, S);
}
function token(T) {
  switch (T) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(T) {
  return line = column = 1, length = strlen(characters = T), position = 0, [];
}
function dealloc(T) {
  return characters = "", T;
}
function delimit(T) {
  return trim(slice$1(position - 1, delimiter(T === 91 ? T + 2 : T === 40 ? T + 1 : T)));
}
function whitespace(T) {
  for (; (character = peek()) && character < 33; )
    next();
  return token(T) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(T, S) {
  for (; --S && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice$1(T, caret() + (S < 6 && peek() == 32 && next() == 32));
}
function delimiter(T) {
  for (; next(); )
    switch (character) {
      case T:
        return position;
      case 34:
      case 39:
        T !== 34 && T !== 39 && delimiter(character);
        break;
      case 40:
        T === 41 && delimiter(T);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(T, S) {
  for (; next() && T + character !== 57; )
    if (T + character === 84 && peek() === 47)
      break;
  return "/*" + slice$1(S, position - 1) + "*" + from(T === 47 ? T : next());
}
function identifier(T) {
  for (; !token(peek()); )
    next();
  return slice$1(T, position);
}
function compile(T) {
  return dealloc(parse("", null, null, null, [""], T = alloc(T), 0, [0], T));
}
function parse(T, S, R, k, D, L, V, z, W) {
  for (var U = 0, q = 0, K = V, Y = 0, J = 0, Z = 0, X = 1, ee = 1, te = 1, re = 0, Q = "", ne = D, oe = L, ae = k, se = Q; ee; )
    switch (Z = re, re = next()) {
      case 40:
        if (Z != 108 && charat(se, K - 1) == 58) {
          indexof(se += replace(delimit(re), "&", "&\f"), "&\f") != -1 && (te = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        se += delimit(re);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        se += whitespace(Z);
        break;
      case 92:
        se += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), S, R), W);
            break;
          default:
            se += "/";
        }
        break;
      case 123 * X:
        z[U++] = strlen(se) * te;
      case 125 * X:
      case 59:
      case 0:
        switch (re) {
          case 0:
          case 125:
            ee = 0;
          case 59 + q:
            te == -1 && (se = replace(se, /\f/g, "")), J > 0 && strlen(se) - K && append(J > 32 ? declaration(se + ";", k, R, K - 1) : declaration(replace(se, " ", "") + ";", k, R, K - 2), W);
            break;
          case 59:
            se += ";";
          default:
            if (append(ae = ruleset(se, S, R, U, q, D, z, Q, ne = [], oe = [], K), L), re === 123)
              if (q === 0)
                parse(se, S, ae, ae, ne, L, K, z, oe);
              else
                switch (Y === 99 && charat(se, 3) === 110 ? 100 : Y) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse(T, ae, ae, k && append(ruleset(T, ae, ae, 0, 0, D, z, Q, D, ne = [], K), oe), D, oe, K, z, k ? ne : oe);
                    break;
                  default:
                    parse(se, ae, ae, ae, [""], oe, 0, z, oe);
                }
        }
        U = q = J = 0, X = te = 1, Q = se = "", K = V;
        break;
      case 58:
        K = 1 + strlen(se), J = Z;
      default:
        if (X < 1) {
          if (re == 123)
            --X;
          else if (re == 125 && X++ == 0 && prev() == 125)
            continue;
        }
        switch (se += from(re), re * X) {
          case 38:
            te = q > 0 ? 1 : (se += "\f", -1);
            break;
          case 44:
            z[U++] = (strlen(se) - 1) * te, te = 1;
            break;
          case 64:
            peek() === 45 && (se += delimit(next())), Y = peek(), q = K = strlen(Q = se += identifier(caret())), re++;
            break;
          case 45:
            Z === 45 && strlen(se) == 2 && (X = 0);
        }
    }
  return L;
}
function ruleset(T, S, R, k, D, L, V, z, W, U, q) {
  for (var K = D - 1, Y = D === 0 ? L : [""], J = sizeof(Y), Z = 0, X = 0, ee = 0; Z < k; ++Z)
    for (var te = 0, re = substr(T, K + 1, K = abs(X = V[Z])), Q = T; te < J; ++te)
      (Q = trim(X > 0 ? Y[te] + " " + re : replace(re, /&\f/g, Y[te]))) && (W[ee++] = Q);
  return node(T, S, R, D === 0 ? RULESET : z, W, U, q);
}
function comment(T, S, R) {
  return node(T, S, R, COMMENT, from(char()), substr(T, 2, -2), 0);
}
function declaration(T, S, R, k) {
  return node(T, S, R, DECLARATION, substr(T, 0, k), substr(T, k + 1, -1), k);
}
function serialize(T, S) {
  for (var R = "", k = sizeof(T), D = 0; D < k; D++)
    R += S(T[D], D, T, S) || "";
  return R;
}
function stringify(T, S, R, k) {
  switch (T.type) {
    case LAYER:
      if (T.children.length) break;
    case IMPORT:
    case DECLARATION:
      return T.return = T.return || T.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return T.return = T.value + "{" + serialize(T.children, k) + "}";
    case RULESET:
      T.value = T.props.join(",");
  }
  return strlen(R = serialize(T.children, k)) ? T.return = T.value + "{" + R + "}" : "";
}
function middleware(T) {
  var S = sizeof(T);
  return function(R, k, D, L) {
    for (var V = "", z = 0; z < S; z++)
      V += T[z](R, k, D, L) || "";
    return V;
  };
}
function rulesheet(T) {
  return function(S) {
    S.root || (S = S.return) && T(S);
  };
}
var define_process_env_default$1I = {}, identifierWithPointTracking = function T(S, R, k) {
  for (var D = 0, L = 0; D = L, L = peek(), D === 38 && L === 12 && (R[k] = 1), !token(L); )
    next();
  return slice$1(S, position);
}, toRules = function T(S, R) {
  var k = -1, D = 44;
  do
    switch (token(D)) {
      case 0:
        D === 38 && peek() === 12 && (R[k] = 1), S[k] += identifierWithPointTracking(position - 1, R, k);
        break;
      case 2:
        S[k] += delimit(D);
        break;
      case 4:
        if (D === 44) {
          S[++k] = peek() === 58 ? "&\f" : "", R[k] = S[k].length;
          break;
        }
      default:
        S[k] += from(D);
    }
  while (D = next());
  return S;
}, getRules = function T(S, R) {
  return dealloc(toRules(alloc(S), R));
}, fixedElements = /* @__PURE__ */ new WeakMap(), compat = function T(S) {
  if (!(S.type !== "rule" || !S.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  S.length < 1)) {
    for (var R = S.value, k = S.parent, D = S.column === k.column && S.line === k.line; k.type !== "rule"; )
      if (k = k.parent, !k) return;
    if (!(S.props.length === 1 && R.charCodeAt(0) !== 58 && !fixedElements.get(k)) && !D) {
      fixedElements.set(S, !0);
      for (var L = [], V = getRules(R, L), z = k.props, W = 0, U = 0; W < V.length; W++)
        for (var q = 0; q < z.length; q++, U++)
          S.props[U] = L[W] ? V[W].replace(/&\f/g, z[q]) : z[q] + " " + V[W];
    }
  }
}, removeLabel = function T(S) {
  if (S.type === "decl") {
    var R = S.value;
    // charcode for l
    R.charCodeAt(0) === 108 && // charcode for b
    R.charCodeAt(2) === 98 && (S.return = "", S.value = "");
  }
}, ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", isIgnoringComment = function T(S) {
  return S.type === "comm" && S.children.indexOf(ignoreFlag) > -1;
}, createUnsafeSelectorsAlarm = function T(S) {
  return function(R, k, D) {
    if (!(R.type !== "rule" || S.compat)) {
      var L = R.value.match(/(:first|:nth|:nth-last)-child/g);
      if (L) {
        for (var V = !!R.parent, z = V ? R.parent.children : (
          // global rule at the root level
          D
        ), W = z.length - 1; W >= 0; W--) {
          var U = z[W];
          if (U.line < R.line)
            break;
          if (U.column < R.column) {
            if (isIgnoringComment(U))
              return;
            break;
          }
        }
        L.forEach(function(q) {
          console.error('The pseudo class "' + q + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + q.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, isImportRule = function T(S) {
  return S.type.charCodeAt(1) === 105 && S.type.charCodeAt(0) === 64;
}, isPrependedWithRegularRules = function T(S, R) {
  for (var k = S - 1; k >= 0; k--)
    if (!isImportRule(R[k]))
      return !0;
  return !1;
}, nullifyElement = function T(S) {
  S.type = "", S.value = "", S.return = "", S.children = "", S.props = "";
}, incorrectImportAlarm = function T(S, R, k) {
  isImportRule(S) && (S.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), nullifyElement(S)) : isPrependedWithRegularRules(R, k) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), nullifyElement(S)));
};
function prefix(T, S) {
  switch (hash$2(T, S)) {
    case 5103:
      return WEBKIT + "print-" + T + T;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + T + T;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + T + MOZ + T + MS + T + T;
    case 6828:
    case 4268:
      return WEBKIT + T + MS + T + T;
    case 6165:
      return WEBKIT + T + MS + "flex-" + T + T;
    case 5187:
      return WEBKIT + T + replace(T, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + T;
    case 5443:
      return WEBKIT + T + MS + "flex-item-" + replace(T, /flex-|-self/, "") + T;
    case 4675:
      return WEBKIT + T + MS + "flex-line-pack" + replace(T, /align-content|flex-|-self/, "") + T;
    case 5548:
      return WEBKIT + T + MS + replace(T, "shrink", "negative") + T;
    case 5292:
      return WEBKIT + T + MS + replace(T, "basis", "preferred-size") + T;
    case 6060:
      return WEBKIT + "box-" + replace(T, "-grow", "") + WEBKIT + T + MS + replace(T, "grow", "positive") + T;
    case 4554:
      return WEBKIT + replace(T, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + T;
    case 6187:
      return replace(replace(replace(T, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), T, "") + T;
    case 5495:
    case 3959:
      return replace(T, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(T, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + T + T;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(T, /(.+)-inline(.+)/, WEBKIT + "$1$2") + T;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(T) - 1 - S > 6) switch (charat(T, S + 1)) {
        case 109:
          if (charat(T, S + 4) !== 45) break;
        case 102:
          return replace(T, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(T, S + 3) == 108 ? "$3" : "$2-$3")) + T;
        case 115:
          return ~indexof(T, "stretch") ? prefix(replace(T, "stretch", "fill-available"), S) + T : T;
      }
      break;
    case 4949:
      if (charat(T, S + 1) !== 115) break;
    case 6444:
      switch (charat(T, strlen(T) - 3 - (~indexof(T, "!important") && 10))) {
        case 107:
          return replace(T, ":", ":" + WEBKIT) + T;
        case 101:
          return replace(T, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(T, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + T;
      }
      break;
    case 5936:
      switch (charat(T, S + 11)) {
        case 114:
          return WEBKIT + T + MS + replace(T, /[svh]\w+-[tblr]{2}/, "tb") + T;
        case 108:
          return WEBKIT + T + MS + replace(T, /[svh]\w+-[tblr]{2}/, "tb-rl") + T;
        case 45:
          return WEBKIT + T + MS + replace(T, /[svh]\w+-[tblr]{2}/, "lr") + T;
      }
      return WEBKIT + T + MS + T + T;
  }
  return T;
}
var prefixer = function T(S, R, k, D) {
  if (S.length > -1 && !S.return)
    switch (S.type) {
      case DECLARATION:
        S.return = prefix(S.value, S.length);
        break;
      case KEYFRAMES:
        return serialize([copy(S, {
          value: replace(S.value, "@", "@" + WEBKIT)
        })], D);
      case RULESET:
        if (S.length) return combine(S.props, function(L) {
          switch (match(L, /(::plac\w+|:read-\w+)/)) {
            case ":read-only":
            case ":read-write":
              return serialize([copy(S, {
                props: [replace(L, /:(read-\w+)/, ":" + MOZ + "$1")]
              })], D);
            case "::placeholder":
              return serialize([copy(S, {
                props: [replace(L, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
              }), copy(S, {
                props: [replace(L, /:(plac\w+)/, ":" + MOZ + "$1")]
              }), copy(S, {
                props: [replace(L, /:(plac\w+)/, MS + "input-$1")]
              })], D);
          }
          return "";
        });
    }
}, defaultStylisPlugins = [prefixer], createCache = function T(S) {
  var R = S.key;
  if (define_process_env_default$1I.NODE_ENV !== "production" && !R)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (R === "css") {
    var k = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(k, function(X) {
      var ee = X.getAttribute("data-emotion");
      ee.indexOf(" ") !== -1 && (document.head.appendChild(X), X.setAttribute("data-s", ""));
    });
  }
  var D = S.stylisPlugins || defaultStylisPlugins;
  if (define_process_env_default$1I.NODE_ENV !== "production" && /[^a-z-]/.test(R))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + R + '" was passed');
  var L = {}, V, z = [];
  V = S.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + R + ' "]'),
    function(X) {
      for (var ee = X.getAttribute("data-emotion").split(" "), te = 1; te < ee.length; te++)
        L[ee[te]] = !0;
      z.push(X);
    }
  );
  var W, U = [compat, removeLabel];
  define_process_env_default$1I.NODE_ENV !== "production" && U.push(createUnsafeSelectorsAlarm({
    get compat() {
      return Z.compat;
    }
  }), incorrectImportAlarm);
  {
    var q, K = [stringify, define_process_env_default$1I.NODE_ENV !== "production" ? function(X) {
      X.root || (X.return ? q.insert(X.return) : X.value && X.type !== COMMENT && q.insert(X.value + "{}"));
    } : rulesheet(function(X) {
      q.insert(X);
    })], Y = middleware(U.concat(D, K)), J = function(ee) {
      return serialize(compile(ee), Y);
    };
    W = function(ee, te, re, Q) {
      q = re, define_process_env_default$1I.NODE_ENV !== "production" && te.map !== void 0 && (q = {
        insert: function(oe) {
          re.insert(oe + te.map);
        }
      }), J(ee ? ee + "{" + te.styles + "}" : te.styles), Q && (Z.inserted[te.name] = !0);
    };
  }
  var Z = {
    key: R,
    sheet: new StyleSheet({
      key: R,
      container: V,
      nonce: S.nonce,
      speedy: S.speedy,
      prepend: S.prepend,
      insertionPoint: S.insertionPoint
    }),
    nonce: S.nonce,
    inserted: L,
    registered: {},
    insert: W
  };
  return Z.sheet.hydrate(z), Z;
}, define_process_env_default$1H = {};
let cache$1;
typeof document == "object" && (cache$1 = createCache({
  key: "css",
  prepend: !0
}));
function StyledEngineProvider(T) {
  const {
    injectFirst: S,
    children: R
  } = T;
  return S && cache$1 ? /* @__PURE__ */ jsxRuntimeExports.jsx(CacheProvider, {
    value: cache$1,
    children: R
  }) : R;
}
define_process_env_default$1H.NODE_ENV !== "production" && (StyledEngineProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: PropTypes.bool
});
var define_process_env_default$1G = {};
function isEmpty$3(T) {
  return T == null || Object.keys(T).length === 0;
}
function GlobalStyles$2(T) {
  const {
    styles: S,
    defaultTheme: R = {}
  } = T, k = typeof S == "function" ? (D) => S(isEmpty$3(D) ? R : D) : S;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Global$1, {
    styles: k
  });
}
define_process_env_default$1G.NODE_ENV !== "production" && (GlobalStyles$2.propTypes = {
  defaultTheme: PropTypes.object,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object, PropTypes.func])
});
var define_process_env_default$1F = {};
function styled$1(T, S) {
  const R = emStyled(T, S);
  return define_process_env_default$1F.NODE_ENV !== "production" ? (...k) => {
    const D = typeof T == "string" ? `"${T}"` : "component";
    return k.length === 0 ? console.error([`MUI: Seems like you called \`styled(${D})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : k.some((L) => L === void 0) && console.error(`MUI: the styled(${D})(...args) API requires all its args to be defined.`), R(...k);
  } : R;
}
const internal_processStyles = (T, S) => {
  Array.isArray(T.__emotion_styles) && (T.__emotion_styles = S(T.__emotion_styles));
}, styledEngine = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: GlobalStyles$2,
  StyledEngineProvider,
  ThemeContext: ThemeContext$2,
  css: css$1,
  default: styled$1,
  internal_processStyles,
  keyframes: keyframes$1
}, Symbol.toStringTag, { value: "Module" })), _excluded$1q = ["values", "unit", "step"], sortBreakpointsValues = (T) => {
  const S = Object.keys(T).map((R) => ({
    key: R,
    val: T[R]
  })) || [];
  return S.sort((R, k) => R.val - k.val), S.reduce((R, k) => _extends$1({}, R, {
    [k.key]: k.val
  }), {});
};
function createBreakpoints(T) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: S = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: R = "px",
    step: k = 5
  } = T, D = _objectWithoutPropertiesLoose$1(T, _excluded$1q), L = sortBreakpointsValues(S), V = Object.keys(L);
  function z(Y) {
    return `@media (min-width:${typeof S[Y] == "number" ? S[Y] : Y}${R})`;
  }
  function W(Y) {
    return `@media (max-width:${(typeof S[Y] == "number" ? S[Y] : Y) - k / 100}${R})`;
  }
  function U(Y, J) {
    const Z = V.indexOf(J);
    return `@media (min-width:${typeof S[Y] == "number" ? S[Y] : Y}${R}) and (max-width:${(Z !== -1 && typeof S[V[Z]] == "number" ? S[V[Z]] : J) - k / 100}${R})`;
  }
  function q(Y) {
    return V.indexOf(Y) + 1 < V.length ? U(Y, V[V.indexOf(Y) + 1]) : z(Y);
  }
  function K(Y) {
    const J = V.indexOf(Y);
    return J === 0 ? z(V[1]) : J === V.length - 1 ? W(V[J]) : U(Y, V[V.indexOf(Y) + 1]).replace("@media", "@media not all and");
  }
  return _extends$1({
    keys: V,
    values: L,
    up: z,
    down: W,
    between: U,
    only: q,
    not: K,
    unit: R
  }, D);
}
const shape = {
  borderRadius: 4
};
var define_process_env_default$1E = {};
const responsivePropType = define_process_env_default$1E.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
function merge(T, S) {
  return S ? deepmerge$1(T, S, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : T;
}
const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (T) => `@media (min-width:${values$1[T]}px)`
};
function handleBreakpoints(T, S, R) {
  const k = T.theme || {};
  if (Array.isArray(S)) {
    const L = k.breakpoints || defaultBreakpoints;
    return S.reduce((V, z, W) => (V[L.up(L.keys[W])] = R(S[W]), V), {});
  }
  if (typeof S == "object") {
    const L = k.breakpoints || defaultBreakpoints;
    return Object.keys(S).reduce((V, z) => {
      if (Object.keys(L.values || values$1).indexOf(z) !== -1) {
        const W = L.up(z);
        V[W] = R(S[z], z);
      } else {
        const W = z;
        V[W] = S[W];
      }
      return V;
    }, {});
  }
  return R(S);
}
function createEmptyBreakpointObject(T = {}) {
  var S;
  return ((S = T.keys) == null ? void 0 : S.reduce((k, D) => {
    const L = T.up(D);
    return k[L] = {}, k;
  }, {})) || {};
}
function removeUnusedBreakpoints(T, S) {
  return T.reduce((R, k) => {
    const D = R[k];
    return (!D || Object.keys(D).length === 0) && delete R[k], R;
  }, S);
}
var define_process_env_default$1D = {};
function getPath(T, S, R = !0) {
  if (!S || typeof S != "string")
    return null;
  if (T && T.vars && R) {
    const k = `vars.${S}`.split(".").reduce((D, L) => D && D[L] ? D[L] : null, T);
    if (k != null)
      return k;
  }
  return S.split(".").reduce((k, D) => k && k[D] != null ? k[D] : null, T);
}
function getStyleValue$1(T, S, R, k = R) {
  let D;
  return typeof T == "function" ? D = T(R) : Array.isArray(T) ? D = T[R] || k : D = getPath(T, R) || k, S && (D = S(D, k, T)), D;
}
function style$1(T) {
  const {
    prop: S,
    cssProperty: R = T.prop,
    themeKey: k,
    transform: D
  } = T, L = (V) => {
    if (V[S] == null)
      return null;
    const z = V[S], W = V.theme, U = getPath(W, k) || {};
    return handleBreakpoints(V, z, (K) => {
      let Y = getStyleValue$1(U, D, K);
      return K === Y && typeof K == "string" && (Y = getStyleValue$1(U, D, `${S}${K === "default" ? "" : capitalize$1(K)}`, K)), R === !1 ? Y : {
        [R]: Y
      };
    });
  };
  return L.propTypes = define_process_env_default$1D.NODE_ENV !== "production" ? {
    [S]: responsivePropType
  } : {}, L.filterProps = [S], L;
}
function memoize(T) {
  const S = {};
  return (R) => (S[R] === void 0 && (S[R] = T(R)), S[R]);
}
var define_process_env_default$1C = {};
const properties = {
  m: "margin",
  p: "padding"
}, directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, getCssProperties = memoize((T) => {
  if (T.length > 2)
    if (aliases[T])
      T = aliases[T];
    else
      return [T];
  const [S, R] = T.split(""), k = properties[S], D = directions[R] || "";
  return Array.isArray(D) ? D.map((L) => k + L) : [k + D];
}), marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(T, S, R, k) {
  var D;
  const L = (D = getPath(T, S, !1)) != null ? D : R;
  return typeof L == "number" ? (V) => typeof V == "string" ? V : (define_process_env_default$1C.NODE_ENV !== "production" && typeof V != "number" && console.error(`MUI: Expected ${k} argument to be a number or a string, got ${V}.`), L * V) : Array.isArray(L) ? (V) => typeof V == "string" ? V : (define_process_env_default$1C.NODE_ENV !== "production" && (Number.isInteger(V) ? V > L.length - 1 && console.error([`MUI: The value provided (${V}) overflows.`, `The supported values are: ${JSON.stringify(L)}.`, `${V} > ${L.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${S}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${S}\` as a number.`].join(`
`))), L[V]) : typeof L == "function" ? L : (define_process_env_default$1C.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${S}\` value (${L}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function createUnarySpacing(T) {
  return createUnaryUnit(T, "spacing", 8, "spacing");
}
function getValue(T, S) {
  if (typeof S == "string" || S == null)
    return S;
  const R = Math.abs(S), k = T(R);
  return S >= 0 ? k : typeof k == "number" ? -k : `-${k}`;
}
function getStyleFromPropValue(T, S) {
  return (R) => T.reduce((k, D) => (k[D] = getValue(S, R), k), {});
}
function resolveCssProperty(T, S, R, k) {
  if (S.indexOf(R) === -1)
    return null;
  const D = getCssProperties(R), L = getStyleFromPropValue(D, k), V = T[R];
  return handleBreakpoints(T, V, L);
}
function style(T, S) {
  const R = createUnarySpacing(T.theme);
  return Object.keys(T).map((k) => resolveCssProperty(T, S, k, R)).reduce(merge, {});
}
function margin(T) {
  return style(T, marginKeys);
}
margin.propTypes = define_process_env_default$1C.NODE_ENV !== "production" ? marginKeys.reduce((T, S) => (T[S] = responsivePropType, T), {}) : {};
margin.filterProps = marginKeys;
function padding(T) {
  return style(T, paddingKeys);
}
padding.propTypes = define_process_env_default$1C.NODE_ENV !== "production" ? paddingKeys.reduce((T, S) => (T[S] = responsivePropType, T), {}) : {};
padding.filterProps = paddingKeys;
define_process_env_default$1C.NODE_ENV !== "production" && spacingKeys.reduce((T, S) => (T[S] = responsivePropType, T), {});
var define_process_env_default$1B = {};
function createSpacing(T = 8) {
  if (T.mui)
    return T;
  const S = createUnarySpacing({
    spacing: T
  }), R = (...k) => (define_process_env_default$1B.NODE_ENV !== "production" && (k.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${k.length}`)), (k.length === 0 ? [1] : k).map((L) => {
    const V = S(L);
    return typeof V == "number" ? `${V}px` : V;
  }).join(" "));
  return R.mui = !0, R;
}
var define_process_env_default$1A = {};
function compose(...T) {
  const S = T.reduce((k, D) => (D.filterProps.forEach((L) => {
    k[L] = D;
  }), k), {}), R = (k) => Object.keys(k).reduce((D, L) => S[L] ? merge(D, S[L](k)) : D, {});
  return R.propTypes = define_process_env_default$1A.NODE_ENV !== "production" ? T.reduce((k, D) => Object.assign(k, D.propTypes), {}) : {}, R.filterProps = T.reduce((k, D) => k.concat(D.filterProps), []), R;
}
var define_process_env_default$1z = {};
function borderTransform(T) {
  return typeof T != "number" ? T : `${T}px solid`;
}
function createBorderStyle(T, S) {
  return style$1({
    prop: T,
    themeKey: "borders",
    transform: S
  });
}
const border = createBorderStyle("border", borderTransform), borderTop = createBorderStyle("borderTop", borderTransform), borderRight = createBorderStyle("borderRight", borderTransform), borderBottom = createBorderStyle("borderBottom", borderTransform), borderLeft = createBorderStyle("borderLeft", borderTransform), borderColor = createBorderStyle("borderColor"), borderTopColor = createBorderStyle("borderTopColor"), borderRightColor = createBorderStyle("borderRightColor"), borderBottomColor = createBorderStyle("borderBottomColor"), borderLeftColor = createBorderStyle("borderLeftColor"), outline = createBorderStyle("outline", borderTransform), outlineColor = createBorderStyle("outlineColor"), borderRadius = (T) => {
  if (T.borderRadius !== void 0 && T.borderRadius !== null) {
    const S = createUnaryUnit(T.theme, "shape.borderRadius", 4, "borderRadius"), R = (k) => ({
      borderRadius: getValue(S, k)
    });
    return handleBreakpoints(T, T.borderRadius, R);
  }
  return null;
};
borderRadius.propTypes = define_process_env_default$1z.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType
} : {};
borderRadius.filterProps = ["borderRadius"];
compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
var define_process_env_default$1y = {};
const gap = (T) => {
  if (T.gap !== void 0 && T.gap !== null) {
    const S = createUnaryUnit(T.theme, "spacing", 8, "gap"), R = (k) => ({
      gap: getValue(S, k)
    });
    return handleBreakpoints(T, T.gap, R);
  }
  return null;
};
gap.propTypes = define_process_env_default$1y.NODE_ENV !== "production" ? {
  gap: responsivePropType
} : {};
gap.filterProps = ["gap"];
const columnGap = (T) => {
  if (T.columnGap !== void 0 && T.columnGap !== null) {
    const S = createUnaryUnit(T.theme, "spacing", 8, "columnGap"), R = (k) => ({
      columnGap: getValue(S, k)
    });
    return handleBreakpoints(T, T.columnGap, R);
  }
  return null;
};
columnGap.propTypes = define_process_env_default$1y.NODE_ENV !== "production" ? {
  columnGap: responsivePropType
} : {};
columnGap.filterProps = ["columnGap"];
const rowGap = (T) => {
  if (T.rowGap !== void 0 && T.rowGap !== null) {
    const S = createUnaryUnit(T.theme, "spacing", 8, "rowGap"), R = (k) => ({
      rowGap: getValue(S, k)
    });
    return handleBreakpoints(T, T.rowGap, R);
  }
  return null;
};
rowGap.propTypes = define_process_env_default$1y.NODE_ENV !== "production" ? {
  rowGap: responsivePropType
} : {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$1({
  prop: "gridColumn"
}), gridRow = style$1({
  prop: "gridRow"
}), gridAutoFlow = style$1({
  prop: "gridAutoFlow"
}), gridAutoColumns = style$1({
  prop: "gridAutoColumns"
}), gridAutoRows = style$1({
  prop: "gridAutoRows"
}), gridTemplateColumns = style$1({
  prop: "gridTemplateColumns"
}), gridTemplateRows = style$1({
  prop: "gridTemplateRows"
}), gridTemplateAreas = style$1({
  prop: "gridTemplateAreas"
}), gridArea = style$1({
  prop: "gridArea"
});
compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(T, S) {
  return S === "grey" ? S : T;
}
const color = style$1({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
}), bgcolor = style$1({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
}), backgroundColor = style$1({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose(color, bgcolor, backgroundColor);
function sizingTransform(T) {
  return T <= 1 && T !== 0 ? `${T * 100}%` : T;
}
const width = style$1({
  prop: "width",
  transform: sizingTransform
}), maxWidth = (T) => {
  if (T.maxWidth !== void 0 && T.maxWidth !== null) {
    const S = (R) => {
      var k, D;
      const L = ((k = T.theme) == null || (k = k.breakpoints) == null || (k = k.values) == null ? void 0 : k[R]) || values$1[R];
      return L ? ((D = T.theme) == null || (D = D.breakpoints) == null ? void 0 : D.unit) !== "px" ? {
        maxWidth: `${L}${T.theme.breakpoints.unit}`
      } : {
        maxWidth: L
      } : {
        maxWidth: sizingTransform(R)
      };
    };
    return handleBreakpoints(T, T.maxWidth, S);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$1({
  prop: "minWidth",
  transform: sizingTransform
}), height = style$1({
  prop: "height",
  transform: sizingTransform
}), maxHeight = style$1({
  prop: "maxHeight",
  transform: sizingTransform
}), minHeight = style$1({
  prop: "minHeight",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$1({
  prop: "boxSizing"
});
compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (T) => ({
      "@media print": {
        display: T
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function objectsHaveSameKeys(...T) {
  const S = T.reduce((k, D) => k.concat(Object.keys(D)), []), R = new Set(S);
  return T.every((k) => R.size === Object.keys(k).length);
}
function callIfFn(T, S) {
  return typeof T == "function" ? T(S) : T;
}
function unstable_createStyleFunctionSx() {
  function T(R, k, D, L) {
    const V = {
      [R]: k,
      theme: D
    }, z = L[R];
    if (!z)
      return {
        [R]: k
      };
    const {
      cssProperty: W = R,
      themeKey: U,
      transform: q,
      style: K
    } = z;
    if (k == null)
      return null;
    if (U === "typography" && k === "inherit")
      return {
        [R]: k
      };
    const Y = getPath(D, U) || {};
    return K ? K(V) : handleBreakpoints(V, k, (Z) => {
      let X = getStyleValue$1(Y, q, Z);
      return Z === X && typeof Z == "string" && (X = getStyleValue$1(Y, q, `${R}${Z === "default" ? "" : capitalize$1(Z)}`, Z)), W === !1 ? X : {
        [W]: X
      };
    });
  }
  function S(R) {
    var k;
    const {
      sx: D,
      theme: L = {}
    } = R || {};
    if (!D)
      return null;
    const V = (k = L.unstable_sxConfig) != null ? k : defaultSxConfig;
    function z(W) {
      let U = W;
      if (typeof W == "function")
        U = W(L);
      else if (typeof W != "object")
        return W;
      if (!U)
        return null;
      const q = createEmptyBreakpointObject(L.breakpoints), K = Object.keys(q);
      let Y = q;
      return Object.keys(U).forEach((J) => {
        const Z = callIfFn(U[J], L);
        if (Z != null)
          if (typeof Z == "object")
            if (V[J])
              Y = merge(Y, T(J, Z, L, V));
            else {
              const X = handleBreakpoints({
                theme: L
              }, Z, (ee) => ({
                [J]: ee
              }));
              objectsHaveSameKeys(X, Z) ? Y[J] = S({
                sx: Z,
                theme: L
              }) : Y = merge(Y, X);
            }
          else
            Y = merge(Y, T(J, Z, L, V));
      }), removeUnusedBreakpoints(K, Y);
    }
    return Array.isArray(D) ? D.map(z) : z(D);
  }
  return S;
}
const styleFunctionSx$1 = unstable_createStyleFunctionSx();
styleFunctionSx$1.filterProps = ["sx"];
function applyStyles$2(T, S) {
  const R = this;
  return R.vars && typeof R.getColorSchemeSelector == "function" ? {
    [R.getColorSchemeSelector(T).replace(/(\[[^\]]+\])/, "*:where($1)")]: S
  } : R.palette.mode === T ? S : {};
}
const _excluded$1p = ["breakpoints", "palette", "spacing", "shape"];
function createTheme$2(T = {}, ...S) {
  const {
    breakpoints: R = {},
    palette: k = {},
    spacing: D,
    shape: L = {}
  } = T, V = _objectWithoutPropertiesLoose$1(T, _excluded$1p), z = createBreakpoints(R), W = createSpacing(D);
  let U = deepmerge$1({
    breakpoints: z,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: _extends$1({
      mode: "light"
    }, k),
    spacing: W,
    shape: _extends$1({}, shape, L)
  }, V);
  return U.applyStyles = applyStyles$2, U = S.reduce((q, K) => deepmerge$1(q, K), U), U.unstable_sxConfig = _extends$1({}, defaultSxConfig, V?.unstable_sxConfig), U.unstable_sx = function(K) {
    return styleFunctionSx$1({
      sx: K,
      theme: this
    });
  }, U;
}
const createTheme$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: createTheme$2,
  private_createBreakpoints: createBreakpoints,
  unstable_applyStyles: applyStyles$2
}, Symbol.toStringTag, { value: "Module" }));
function isObjectEmpty$2(T) {
  return Object.keys(T).length === 0;
}
function useTheme$4(T = null) {
  const S = React$1.useContext(ThemeContext$2);
  return !S || isObjectEmpty$2(S) ? T : S;
}
const systemDefaultTheme$1 = createTheme$2();
function useTheme$3(T = systemDefaultTheme$1) {
  return useTheme$4(T);
}
var define_process_env_default$1x = {};
function GlobalStyles$1({
  styles: T,
  themeId: S,
  defaultTheme: R = {}
}) {
  const k = useTheme$3(R), D = typeof T == "function" ? T(S && k[S] || k) : T;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$2, {
    styles: D
  });
}
define_process_env_default$1x.NODE_ENV !== "production" && (GlobalStyles$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: PropTypes.object,
  /**
   * @ignore
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool]),
  /**
   * @ignore
   */
  themeId: PropTypes.string
});
const _excluded$1o = ["sx"], splitProps = (T) => {
  var S, R;
  const k = {
    systemProps: {},
    otherProps: {}
  }, D = (S = T == null || (R = T.theme) == null ? void 0 : R.unstable_sxConfig) != null ? S : defaultSxConfig;
  return Object.keys(T).forEach((L) => {
    D[L] ? k.systemProps[L] = T[L] : k.otherProps[L] = T[L];
  }), k;
};
function extendSxProp(T) {
  const {
    sx: S
  } = T, R = _objectWithoutPropertiesLoose$1(T, _excluded$1o), {
    systemProps: k,
    otherProps: D
  } = splitProps(R);
  let L;
  return Array.isArray(S) ? L = [k, ...S] : typeof S == "function" ? L = (...V) => {
    const z = S(...V);
    return isPlainObject(z) ? _extends$1({}, k, z) : k;
  } : L = _extends$1({}, k, S), _extends$1({}, D, {
    sx: L
  });
}
const styleFunctionSx = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: styleFunctionSx$1,
  extendSxProp,
  unstable_createStyleFunctionSx,
  unstable_defaultSxConfig: defaultSxConfig
}, Symbol.toStringTag, { value: "Module" }));
function shouldForwardProp$1(T) {
  return T !== "ownerState" && T !== "theme" && T !== "sx" && T !== "as";
}
createTheme$2();
function getThemeProps$1(T) {
  const {
    theme: S,
    name: R,
    props: k
  } = T;
  return !S || !S.components || !S.components[R] || !S.components[R].defaultProps ? k : resolveProps(S.components[R].defaultProps, k);
}
function useThemeProps$1({
  props: T,
  name: S,
  defaultTheme: R,
  themeId: k
}) {
  let D = useTheme$3(R);
  return k && (D = D[k] || D), getThemeProps$1({
    theme: D,
    name: S,
    props: T
  });
}
var define_process_env_default$1w = {};
function useMediaQueryOld(T, S, R, k, D) {
  const [L, V] = React$1.useState(() => D && R ? R(T).matches : k ? k(T).matches : S);
  return useEnhancedEffect(() => {
    let z = !0;
    if (!R)
      return;
    const W = R(T), U = () => {
      z && V(W.matches);
    };
    return U(), W.addListener(U), () => {
      z = !1, W.removeListener(U);
    };
  }, [T, R]), L;
}
const maybeReactUseSyncExternalStore = React$1.useSyncExternalStore;
function useMediaQueryNew(T, S, R, k, D) {
  const L = React$1.useCallback(() => S, [S]), V = React$1.useMemo(() => {
    if (D && R)
      return () => R(T).matches;
    if (k !== null) {
      const {
        matches: q
      } = k(T);
      return () => q;
    }
    return L;
  }, [L, T, k, D, R]), [z, W] = React$1.useMemo(() => {
    if (R === null)
      return [L, () => () => {
      }];
    const q = R(T);
    return [() => q.matches, (K) => (q.addListener(K), () => {
      q.removeListener(K);
    })];
  }, [L, R, T]);
  return maybeReactUseSyncExternalStore(W, z, V);
}
function useMediaQuery(T, S = {}) {
  const R = useTheme$4(), k = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: D = !1,
    matchMedia: L = k ? window.matchMedia : null,
    ssrMatchMedia: V = null,
    noSsr: z = !1
  } = getThemeProps$1({
    name: "MuiUseMediaQuery",
    props: S,
    theme: R
  });
  define_process_env_default$1w.NODE_ENV;
  let W = T;
  W = W.replace(/^@media( ?)/m, "");
  const q = (maybeReactUseSyncExternalStore !== void 0 ? useMediaQueryNew : useMediaQueryOld)(W, D, L, V, z);
  return define_process_env_default$1w.NODE_ENV !== "production" && React$1.useDebugValue({
    query: W,
    match: q
  }), q;
}
var define_process_env_default$1v = {};
function clampWrapper$1(T, S = 0, R = 1) {
  return define_process_env_default$1v.NODE_ENV !== "production" && (T < S || T > R) && console.error(`MUI: The value provided ${T} is out of range [${S}, ${R}].`), clamp$1(T, S, R);
}
function hexToRgb$1(T) {
  T = T.slice(1);
  const S = new RegExp(`.{1,${T.length >= 6 ? 2 : 1}}`, "g");
  let R = T.match(S);
  return R && R[0].length === 1 && (R = R.map((k) => k + k)), R ? `rgb${R.length === 4 ? "a" : ""}(${R.map((k, D) => D < 3 ? parseInt(k, 16) : Math.round(parseInt(k, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function decomposeColor$1(T) {
  if (T.type)
    return T;
  if (T.charAt(0) === "#")
    return decomposeColor$1(hexToRgb$1(T));
  const S = T.indexOf("("), R = T.substring(0, S);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(R) === -1)
    throw new Error(define_process_env_default$1v.NODE_ENV !== "production" ? `MUI: Unsupported \`${T}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : formatMuiErrorMessage$1(9, T));
  let k = T.substring(S + 1, T.length - 1), D;
  if (R === "color") {
    if (k = k.split(" "), D = k.shift(), k.length === 4 && k[3].charAt(0) === "/" && (k[3] = k[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(D) === -1)
      throw new Error(define_process_env_default$1v.NODE_ENV !== "production" ? `MUI: unsupported \`${D}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : formatMuiErrorMessage$1(10, D));
  } else
    k = k.split(",");
  return k = k.map((L) => parseFloat(L)), {
    type: R,
    values: k,
    colorSpace: D
  };
}
function recomposeColor$1(T) {
  const {
    type: S,
    colorSpace: R
  } = T;
  let {
    values: k
  } = T;
  return S.indexOf("rgb") !== -1 ? k = k.map((D, L) => L < 3 ? parseInt(D, 10) : D) : S.indexOf("hsl") !== -1 && (k[1] = `${k[1]}%`, k[2] = `${k[2]}%`), S.indexOf("color") !== -1 ? k = `${R} ${k.join(" ")}` : k = `${k.join(", ")}`, `${S}(${k})`;
}
function alpha$1(T, S) {
  return T = decomposeColor$1(T), S = clampWrapper$1(S), (T.type === "rgb" || T.type === "hsl") && (T.type += "a"), T.type === "color" ? T.values[3] = `/${S}` : T.values[3] = S, recomposeColor$1(T);
}
var define_process_env_default$1u = {};
const ThemeContext = /* @__PURE__ */ React$1.createContext(null);
define_process_env_default$1u.NODE_ENV !== "production" && (ThemeContext.displayName = "ThemeContext");
var define_process_env_default$1t = {};
function useTheme$2() {
  const T = React$1.useContext(ThemeContext);
  return define_process_env_default$1t.NODE_ENV !== "production" && React$1.useDebugValue(T), T;
}
const hasSymbol = typeof Symbol == "function" && Symbol.for, nested = hasSymbol ? Symbol.for("mui.nested") : "__THEME_NESTED__";
var define_process_env_default$1s = {};
function mergeOuterLocalTheme(T, S) {
  if (typeof S == "function") {
    const R = S(T);
    return define_process_env_default$1s.NODE_ENV !== "production" && (R || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), R;
  }
  return _extends$1({}, T, S);
}
function ThemeProvider$3(T) {
  const {
    children: S,
    theme: R
  } = T, k = useTheme$2();
  define_process_env_default$1s.NODE_ENV !== "production" && k === null && typeof R == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const D = React$1.useMemo(() => {
    const L = k === null ? R : mergeOuterLocalTheme(k, R);
    return L != null && (L[nested] = k !== null), L;
  }, [R, k]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext.Provider, {
    value: D,
    children: S
  });
}
define_process_env_default$1s.NODE_ENV !== "production" && (ThemeProvider$3.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
});
define_process_env_default$1s.NODE_ENV !== "production" && define_process_env_default$1s.NODE_ENV !== "production" && (ThemeProvider$3.propTypes = exactProp(ThemeProvider$3.propTypes));
var define_process_env_default$1r = {};
const _excluded$1n = ["value"], RtlContext = /* @__PURE__ */ React$1.createContext();
function RtlProvider(T) {
  let {
    value: S
  } = T, R = _objectWithoutPropertiesLoose$1(T, _excluded$1n);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RtlContext.Provider, _extends$1({
    value: S ?? !0
  }, R));
}
define_process_env_default$1r.NODE_ENV !== "production" && (RtlProvider.propTypes = {
  children: PropTypes.node,
  value: PropTypes.bool
});
const useRtl = () => {
  const T = React$1.useContext(RtlContext);
  return T ?? !1;
};
var define_process_env_default$1q = {};
const PropsContext = /* @__PURE__ */ React$1.createContext(void 0);
function DefaultPropsProvider({
  value: T,
  children: S
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PropsContext.Provider, {
    value: T,
    children: S
  });
}
define_process_env_default$1q.NODE_ENV !== "production" && (DefaultPropsProvider.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  value: PropTypes.object
});
function getThemeProps(T) {
  const {
    theme: S,
    name: R,
    props: k
  } = T;
  if (!S || !S.components || !S.components[R])
    return k;
  const D = S.components[R];
  return D.defaultProps ? resolveProps(D.defaultProps, k) : !D.styleOverrides && !D.variants ? resolveProps(D, k) : k;
}
function useDefaultProps$1({
  props: T,
  name: S
}) {
  const R = React$1.useContext(PropsContext);
  return getThemeProps({
    props: T,
    name: S,
    theme: {
      components: R
    }
  });
}
var define_process_env_default$1p = {};
const EMPTY_THEME = {};
function useThemeScoping(T, S, R, k = !1) {
  return React$1.useMemo(() => {
    const D = T && S[T] || S;
    if (typeof R == "function") {
      const L = R(D), V = T ? _extends$1({}, S, {
        [T]: L
      }) : L;
      return k ? () => V : V;
    }
    return T ? _extends$1({}, S, {
      [T]: R
    }) : _extends$1({}, S, R);
  }, [T, S, R, k]);
}
function ThemeProvider$2(T) {
  const {
    children: S,
    theme: R,
    themeId: k
  } = T, D = useTheme$4(EMPTY_THEME), L = useTheme$2() || EMPTY_THEME;
  define_process_env_default$1p.NODE_ENV !== "production" && (D === null && typeof R == "function" || k && D && !D[k] && typeof R == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const V = useThemeScoping(k, D, R), z = useThemeScoping(k, L, R, !0), W = V.direction === "rtl";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$3, {
    theme: z,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeContext$2.Provider, {
      value: V,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(RtlProvider, {
        value: W,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultPropsProvider, {
          value: V?.components,
          children: S
        })
      })
    })
  });
}
define_process_env_default$1p.NODE_ENV !== "production" && (ThemeProvider$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: PropTypes.string
});
define_process_env_default$1p.NODE_ENV !== "production" && define_process_env_default$1p.NODE_ENV !== "production" && (ThemeProvider$2.propTypes = exactProp(ThemeProvider$2.propTypes));
function createMixins(T, S) {
  return _extends$1({
    toolbar: {
      minHeight: 56,
      [T.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [T.up("sm")]: {
        minHeight: 64
      }
    }
  }, S);
}
var colorManipulator = {}, interopRequireDefault = { exports: {} };
(function(T) {
  function S(R) {
    return R && R.__esModule ? R : {
      default: R
    };
  }
  T.exports = S, T.exports.__esModule = !0, T.exports.default = T.exports;
})(interopRequireDefault);
var interopRequireDefaultExports = interopRequireDefault.exports;
const require$$1$1 = /* @__PURE__ */ getAugmentedNamespace(formatMuiErrorMessage), require$$2 = /* @__PURE__ */ getAugmentedNamespace(clamp);
var define_process_env_default$1o = {}, _interopRequireDefault$1 = interopRequireDefaultExports;
Object.defineProperty(colorManipulator, "__esModule", {
  value: !0
});
var alpha_1 = colorManipulator.alpha = alpha;
colorManipulator.blend = blend;
colorManipulator.colorChannel = void 0;
var darken_1 = colorManipulator.darken = darken$1;
colorManipulator.decomposeColor = decomposeColor;
colorManipulator.emphasize = emphasize;
var getContrastRatio_1 = colorManipulator.getContrastRatio = getContrastRatio;
colorManipulator.getLuminance = getLuminance;
colorManipulator.hexToRgb = hexToRgb;
colorManipulator.hslToRgb = hslToRgb$1;
var lighten_1 = colorManipulator.lighten = lighten$1;
colorManipulator.private_safeAlpha = private_safeAlpha;
colorManipulator.private_safeColorChannel = void 0;
colorManipulator.private_safeDarken = private_safeDarken;
colorManipulator.private_safeEmphasize = private_safeEmphasize;
colorManipulator.private_safeLighten = private_safeLighten;
colorManipulator.recomposeColor = recomposeColor;
colorManipulator.rgbToHex = rgbToHex;
var _formatMuiErrorMessage2 = _interopRequireDefault$1(require$$1$1), _clamp = _interopRequireDefault$1(require$$2);
function clampWrapper(T, S = 0, R = 1) {
  return define_process_env_default$1o.NODE_ENV !== "production" && (T < S || T > R) && console.error(`MUI: The value provided ${T} is out of range [${S}, ${R}].`), (0, _clamp.default)(T, S, R);
}
function hexToRgb(T) {
  T = T.slice(1);
  const S = new RegExp(`.{1,${T.length >= 6 ? 2 : 1}}`, "g");
  let R = T.match(S);
  return R && R[0].length === 1 && (R = R.map((k) => k + k)), R ? `rgb${R.length === 4 ? "a" : ""}(${R.map((k, D) => D < 3 ? parseInt(k, 16) : Math.round(parseInt(k, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function intToHex(T) {
  const S = T.toString(16);
  return S.length === 1 ? `0${S}` : S;
}
function decomposeColor(T) {
  if (T.type)
    return T;
  if (T.charAt(0) === "#")
    return decomposeColor(hexToRgb(T));
  const S = T.indexOf("("), R = T.substring(0, S);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(R) === -1)
    throw new Error(define_process_env_default$1o.NODE_ENV !== "production" ? `MUI: Unsupported \`${T}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, _formatMuiErrorMessage2.default)(9, T));
  let k = T.substring(S + 1, T.length - 1), D;
  if (R === "color") {
    if (k = k.split(" "), D = k.shift(), k.length === 4 && k[3].charAt(0) === "/" && (k[3] = k[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(D) === -1)
      throw new Error(define_process_env_default$1o.NODE_ENV !== "production" ? `MUI: unsupported \`${D}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, _formatMuiErrorMessage2.default)(10, D));
  } else
    k = k.split(",");
  return k = k.map((L) => parseFloat(L)), {
    type: R,
    values: k,
    colorSpace: D
  };
}
const colorChannel = (T) => {
  const S = decomposeColor(T);
  return S.values.slice(0, 3).map((R, k) => S.type.indexOf("hsl") !== -1 && k !== 0 ? `${R}%` : R).join(" ");
};
colorManipulator.colorChannel = colorChannel;
const private_safeColorChannel = (T, S) => {
  try {
    return colorChannel(T);
  } catch {
    return S && define_process_env_default$1o.NODE_ENV !== "production" && console.warn(S), T;
  }
};
colorManipulator.private_safeColorChannel = private_safeColorChannel;
function recomposeColor(T) {
  const {
    type: S,
    colorSpace: R
  } = T;
  let {
    values: k
  } = T;
  return S.indexOf("rgb") !== -1 ? k = k.map((D, L) => L < 3 ? parseInt(D, 10) : D) : S.indexOf("hsl") !== -1 && (k[1] = `${k[1]}%`, k[2] = `${k[2]}%`), S.indexOf("color") !== -1 ? k = `${R} ${k.join(" ")}` : k = `${k.join(", ")}`, `${S}(${k})`;
}
function rgbToHex(T) {
  if (T.indexOf("#") === 0)
    return T;
  const {
    values: S
  } = decomposeColor(T);
  return `#${S.map((R, k) => intToHex(k === 3 ? Math.round(255 * R) : R)).join("")}`;
}
function hslToRgb$1(T) {
  T = decomposeColor(T);
  const {
    values: S
  } = T, R = S[0], k = S[1] / 100, D = S[2] / 100, L = k * Math.min(D, 1 - D), V = (U, q = (U + R / 30) % 12) => D - L * Math.max(Math.min(q - 3, 9 - q, 1), -1);
  let z = "rgb";
  const W = [Math.round(V(0) * 255), Math.round(V(8) * 255), Math.round(V(4) * 255)];
  return T.type === "hsla" && (z += "a", W.push(S[3])), recomposeColor({
    type: z,
    values: W
  });
}
function getLuminance(T) {
  T = decomposeColor(T);
  let S = T.type === "hsl" || T.type === "hsla" ? decomposeColor(hslToRgb$1(T)).values : T.values;
  return S = S.map((R) => (T.type !== "color" && (R /= 255), R <= 0.03928 ? R / 12.92 : ((R + 0.055) / 1.055) ** 2.4)), Number((0.2126 * S[0] + 0.7152 * S[1] + 0.0722 * S[2]).toFixed(3));
}
function getContrastRatio(T, S) {
  const R = getLuminance(T), k = getLuminance(S);
  return (Math.max(R, k) + 0.05) / (Math.min(R, k) + 0.05);
}
function alpha(T, S) {
  return T = decomposeColor(T), S = clampWrapper(S), (T.type === "rgb" || T.type === "hsl") && (T.type += "a"), T.type === "color" ? T.values[3] = `/${S}` : T.values[3] = S, recomposeColor(T);
}
function private_safeAlpha(T, S, R) {
  try {
    return alpha(T, S);
  } catch {
    return R && define_process_env_default$1o.NODE_ENV !== "production" && console.warn(R), T;
  }
}
function darken$1(T, S) {
  if (T = decomposeColor(T), S = clampWrapper(S), T.type.indexOf("hsl") !== -1)
    T.values[2] *= 1 - S;
  else if (T.type.indexOf("rgb") !== -1 || T.type.indexOf("color") !== -1)
    for (let R = 0; R < 3; R += 1)
      T.values[R] *= 1 - S;
  return recomposeColor(T);
}
function private_safeDarken(T, S, R) {
  try {
    return darken$1(T, S);
  } catch {
    return R && define_process_env_default$1o.NODE_ENV !== "production" && console.warn(R), T;
  }
}
function lighten$1(T, S) {
  if (T = decomposeColor(T), S = clampWrapper(S), T.type.indexOf("hsl") !== -1)
    T.values[2] += (100 - T.values[2]) * S;
  else if (T.type.indexOf("rgb") !== -1)
    for (let R = 0; R < 3; R += 1)
      T.values[R] += (255 - T.values[R]) * S;
  else if (T.type.indexOf("color") !== -1)
    for (let R = 0; R < 3; R += 1)
      T.values[R] += (1 - T.values[R]) * S;
  return recomposeColor(T);
}
function private_safeLighten(T, S, R) {
  try {
    return lighten$1(T, S);
  } catch {
    return R && define_process_env_default$1o.NODE_ENV !== "production" && console.warn(R), T;
  }
}
function emphasize(T, S = 0.15) {
  return getLuminance(T) > 0.5 ? darken$1(T, S) : lighten$1(T, S);
}
function private_safeEmphasize(T, S, R) {
  try {
    return emphasize(T, S);
  } catch {
    return R && define_process_env_default$1o.NODE_ENV !== "production" && console.warn(R), T;
  }
}
function blend(T, S, R, k = 1) {
  const D = (W, U) => Math.round((W ** (1 / k) * (1 - R) + U ** (1 / k) * R) ** k), L = decomposeColor(T), V = decomposeColor(S), z = [D(L.values[0], V.values[0]), D(L.values[1], V.values[1]), D(L.values[2], V.values[2])];
  return recomposeColor({
    type: "rgb",
    values: z
  });
}
const common = {
  black: "#000",
  white: "#fff"
}, grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, purple$1 = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, red$1 = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, orange$1 = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, blue$1 = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, lightBlue = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, green$1 = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
var define_process_env_default$1n = {};
const _excluded$1m = ["mode", "contrastThreshold", "tonalOffset"], light$o = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common.white,
    default: common.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, dark$o = {
  text: {
    primary: common.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: common.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(T, S, R, k) {
  const D = k.light || k, L = k.dark || k * 1.5;
  T[S] || (T.hasOwnProperty(R) ? T[S] = T[R] : S === "light" ? T.light = lighten_1(T.main, D) : S === "dark" && (T.dark = darken_1(T.main, L)));
}
function getDefaultPrimary(T = "light") {
  return T === "dark" ? {
    main: blue$1[200],
    light: blue$1[50],
    dark: blue$1[400]
  } : {
    main: blue$1[700],
    light: blue$1[400],
    dark: blue$1[800]
  };
}
function getDefaultSecondary(T = "light") {
  return T === "dark" ? {
    main: purple$1[200],
    light: purple$1[50],
    dark: purple$1[400]
  } : {
    main: purple$1[500],
    light: purple$1[300],
    dark: purple$1[700]
  };
}
function getDefaultError(T = "light") {
  return T === "dark" ? {
    main: red$1[500],
    light: red$1[300],
    dark: red$1[700]
  } : {
    main: red$1[700],
    light: red$1[400],
    dark: red$1[800]
  };
}
function getDefaultInfo(T = "light") {
  return T === "dark" ? {
    main: lightBlue[400],
    light: lightBlue[300],
    dark: lightBlue[700]
  } : {
    main: lightBlue[700],
    light: lightBlue[500],
    dark: lightBlue[900]
  };
}
function getDefaultSuccess(T = "light") {
  return T === "dark" ? {
    main: green$1[400],
    light: green$1[300],
    dark: green$1[700]
  } : {
    main: green$1[800],
    light: green$1[500],
    dark: green$1[900]
  };
}
function getDefaultWarning(T = "light") {
  return T === "dark" ? {
    main: orange$1[400],
    light: orange$1[300],
    dark: orange$1[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange$1[500],
    dark: orange$1[900]
  };
}
function createPalette(T) {
  const {
    mode: S = "light",
    contrastThreshold: R = 3,
    tonalOffset: k = 0.2
  } = T, D = _objectWithoutPropertiesLoose$1(T, _excluded$1m), L = T.primary || getDefaultPrimary(S), V = T.secondary || getDefaultSecondary(S), z = T.error || getDefaultError(S), W = T.info || getDefaultInfo(S), U = T.success || getDefaultSuccess(S), q = T.warning || getDefaultWarning(S);
  function K(X) {
    const ee = getContrastRatio_1(X, dark$o.text.primary) >= R ? dark$o.text.primary : light$o.text.primary;
    if (define_process_env_default$1n.NODE_ENV !== "production") {
      const te = getContrastRatio_1(X, ee);
      te < 3 && console.error([`MUI: The contrast ratio of ${te}:1 for ${ee} on ${X}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return ee;
  }
  const Y = ({
    color: X,
    name: ee,
    mainShade: te = 500,
    lightShade: re = 300,
    darkShade: Q = 700
  }) => {
    if (X = _extends$1({}, X), !X.main && X[te] && (X.main = X[te]), !X.hasOwnProperty("main"))
      throw new Error(define_process_env_default$1n.NODE_ENV !== "production" ? `MUI: The color${ee ? ` (${ee})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${te}\` property.` : formatMuiErrorMessage$1(11, ee ? ` (${ee})` : "", te));
    if (typeof X.main != "string")
      throw new Error(define_process_env_default$1n.NODE_ENV !== "production" ? `MUI: The color${ee ? ` (${ee})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(X.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage$1(12, ee ? ` (${ee})` : "", JSON.stringify(X.main)));
    return addLightOrDark(X, "light", re, k), addLightOrDark(X, "dark", Q, k), X.contrastText || (X.contrastText = K(X.main)), X;
  }, J = {
    dark: dark$o,
    light: light$o
  };
  return define_process_env_default$1n.NODE_ENV !== "production" && (J[S] || console.error(`MUI: The palette mode \`${S}\` is not supported.`)), deepmerge$1(_extends$1({
    // A collection of common colors.
    common: _extends$1({}, common),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: S,
    // The colors used to represent primary interface elements for a user.
    primary: Y({
      color: L,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: Y({
      color: V,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: Y({
      color: z,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: Y({
      color: q,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: Y({
      color: W,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: Y({
      color: U,
      name: "success"
    }),
    // The grey colors.
    grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: R,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: K,
    // Generate a rich color object.
    augmentColor: Y,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: k
  }, J[S]), D);
}
var define_process_env_default$1m = {};
const _excluded$1l = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function round$2(T) {
  return Math.round(T * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
}, defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(T, S) {
  const R = typeof S == "function" ? S(T) : S, {
    fontFamily: k = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize: D = 14,
    // px
    fontWeightLight: L = 300,
    fontWeightRegular: V = 400,
    fontWeightMedium: z = 500,
    fontWeightBold: W = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: U = 16,
    // Apply the CSS properties to all the variants.
    allVariants: q,
    pxToRem: K
  } = R, Y = _objectWithoutPropertiesLoose$1(R, _excluded$1l);
  define_process_env_default$1m.NODE_ENV !== "production" && (typeof D != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof U != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const J = D / 14, Z = K || ((te) => `${te / U * J}rem`), X = (te, re, Q, ne, oe) => _extends$1({
    fontFamily: k,
    fontWeight: te,
    fontSize: Z(re),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: Q
  }, k === defaultFontFamily ? {
    letterSpacing: `${round$2(ne / re)}em`
  } : {}, oe, q), ee = {
    h1: X(L, 96, 1.167, -1.5),
    h2: X(L, 60, 1.2, -0.5),
    h3: X(V, 48, 1.167, 0),
    h4: X(V, 34, 1.235, 0.25),
    h5: X(V, 24, 1.334, 0),
    h6: X(z, 20, 1.6, 0.15),
    subtitle1: X(V, 16, 1.75, 0.15),
    subtitle2: X(z, 14, 1.57, 0.1),
    body1: X(V, 16, 1.5, 0.15),
    body2: X(V, 14, 1.43, 0.15),
    button: X(z, 14, 1.75, 0.4, caseAllCaps),
    caption: X(V, 12, 1.66, 0.4),
    overline: X(V, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge$1(_extends$1({
    htmlFontSize: U,
    pxToRem: Z,
    fontFamily: k,
    fontSize: D,
    fontWeightLight: L,
    fontWeightRegular: V,
    fontWeightMedium: z,
    fontWeightBold: W
  }, ee), Y, {
    clone: !1
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2, shadowKeyPenumbraOpacity = 0.14, shadowAmbientShadowOpacity = 0.12;
function createShadow(...T) {
  return [`${T[0]}px ${T[1]}px ${T[2]}px ${T[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${T[4]}px ${T[5]}px ${T[6]}px ${T[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${T[8]}px ${T[9]}px ${T[10]}px ${T[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var define_process_env_default$1l = {};
const _excluded$1k = ["duration", "easing", "delay"], easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(T) {
  return `${Math.round(T)}ms`;
}
function getAutoHeightDuration(T) {
  if (!T)
    return 0;
  const S = T / 36;
  return Math.round((4 + 15 * S ** 0.25 + S / 5) * 10);
}
function createTransitions(T) {
  const S = _extends$1({}, easing, T.easing), R = _extends$1({}, duration, T.duration);
  return _extends$1({
    getAutoHeightDuration,
    create: (D = ["all"], L = {}) => {
      const {
        duration: V = R.standard,
        easing: z = S.easeInOut,
        delay: W = 0
      } = L, U = _objectWithoutPropertiesLoose$1(L, _excluded$1k);
      if (define_process_env_default$1l.NODE_ENV !== "production") {
        const q = (Y) => typeof Y == "string", K = (Y) => !isNaN(parseFloat(Y));
        !q(D) && !Array.isArray(D) && console.error('MUI: Argument "props" must be a string or Array.'), !K(V) && !q(V) && console.error(`MUI: Argument "duration" must be a number or a string but found ${V}.`), q(z) || console.error('MUI: Argument "easing" must be a string.'), !K(W) && !q(W) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof L != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(U).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(U).join(",")}].`);
      }
      return (Array.isArray(D) ? D : [D]).map((q) => `${q} ${typeof V == "string" ? V : formatMs(V)} ${z} ${typeof W == "string" ? W : formatMs(W)}`).join(",");
    }
  }, T, {
    easing: S,
    duration: R
  });
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var define_process_env_default$1k = {};
const _excluded$1j = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function createTheme(T = {}, ...S) {
  const {
    mixins: R = {},
    palette: k = {},
    transitions: D = {},
    typography: L = {}
  } = T, V = _objectWithoutPropertiesLoose$1(T, _excluded$1j);
  if (T.vars)
    throw new Error(define_process_env_default$1k.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : formatMuiErrorMessage$1(18));
  const z = createPalette(k), W = createTheme$2(T);
  let U = deepmerge$1(W, {
    mixins: createMixins(W.breakpoints, R),
    palette: z,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows.slice(),
    typography: createTypography(z, L),
    transitions: createTransitions(D),
    zIndex: _extends$1({}, zIndex)
  });
  if (U = deepmerge$1(U, V), U = S.reduce((q, K) => deepmerge$1(q, K), U), define_process_env_default$1k.NODE_ENV !== "production") {
    const q = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], K = (Y, J) => {
      let Z;
      for (Z in Y) {
        const X = Y[Z];
        if (q.indexOf(Z) !== -1 && Object.keys(X).length > 0) {
          if (define_process_env_default$1k.NODE_ENV !== "production") {
            const ee = generateUtilityClass$1("", Z);
            console.error([`MUI: The \`${J}\` component increases the CSS specificity of the \`${Z}\` internal state.`, "You can not override it like this: ", JSON.stringify(Y, null, 2), "", `Instead, you need to use the '&.${ee}' syntax:`, JSON.stringify({
              root: {
                [`&.${ee}`]: X
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          Y[Z] = {};
        }
      }
    };
    Object.keys(U.components).forEach((Y) => {
      const J = U.components[Y].styleOverrides;
      J && Y.indexOf("Mui") === 0 && K(J, Y);
    });
  }
  return U.unstable_sxConfig = _extends$1({}, defaultSxConfig, V?.unstable_sxConfig), U.unstable_sx = function(K) {
    return styleFunctionSx$1({
      sx: K,
      theme: this
    });
  }, U;
}
const defaultTheme = createTheme();
var define_process_env_default$1j = {};
function useTheme$1() {
  const T = useTheme$3(defaultTheme);
  return define_process_env_default$1j.NODE_ENV !== "production" && React$1.useDebugValue(T), T[THEME_ID] || T;
}
function useThemeProps({
  props: T,
  name: S
}) {
  return useThemeProps$1({
    props: T,
    name: S,
    defaultTheme,
    themeId: THEME_ID
  });
}
var createStyled$1 = {}, _extends = { exports: {} }, hasRequired_extends;
function require_extends() {
  return hasRequired_extends || (hasRequired_extends = 1, function(T) {
    function S() {
      return T.exports = S = Object.assign ? Object.assign.bind() : function(R) {
        for (var k = 1; k < arguments.length; k++) {
          var D = arguments[k];
          for (var L in D) ({}).hasOwnProperty.call(D, L) && (R[L] = D[L]);
        }
        return R;
      }, T.exports.__esModule = !0, T.exports.default = T.exports, S.apply(null, arguments);
    }
    T.exports = S, T.exports.__esModule = !0, T.exports.default = T.exports;
  }(_extends)), _extends.exports;
}
var objectWithoutPropertiesLoose = { exports: {} }, hasRequiredObjectWithoutPropertiesLoose;
function requireObjectWithoutPropertiesLoose() {
  return hasRequiredObjectWithoutPropertiesLoose || (hasRequiredObjectWithoutPropertiesLoose = 1, function(T) {
    function S(R, k) {
      if (R == null) return {};
      var D = {};
      for (var L in R) if ({}.hasOwnProperty.call(R, L)) {
        if (k.includes(L)) continue;
        D[L] = R[L];
      }
      return D;
    }
    T.exports = S, T.exports.__esModule = !0, T.exports.default = T.exports;
  }(objectWithoutPropertiesLoose)), objectWithoutPropertiesLoose.exports;
}
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(styledEngine), require$$4 = /* @__PURE__ */ getAugmentedNamespace(deepmerge), require$$5 = /* @__PURE__ */ getAugmentedNamespace(capitalize), require$$6 = /* @__PURE__ */ getAugmentedNamespace(getDisplayName), require$$7 = /* @__PURE__ */ getAugmentedNamespace(createTheme$1), require$$8 = /* @__PURE__ */ getAugmentedNamespace(styleFunctionSx);
var define_process_env_default$1i = {}, _interopRequireDefault = interopRequireDefaultExports;
Object.defineProperty(createStyled$1, "__esModule", {
  value: !0
});
var _default = createStyled$1.default = createStyled;
createStyled$1.shouldForwardProp = shouldForwardProp;
createStyled$1.systemDefaultTheme = void 0;
var _extends2 = _interopRequireDefault(require_extends()), _objectWithoutPropertiesLoose2 = _interopRequireDefault(requireObjectWithoutPropertiesLoose()), _styledEngine$1 = _interopRequireWildcard$1(require$$1), _deepmerge = require$$4, _capitalize = _interopRequireDefault(require$$5), _getDisplayName = _interopRequireDefault(require$$6), _createTheme = _interopRequireDefault(require$$7), _styleFunctionSx = _interopRequireDefault(require$$8);
const _excluded$1i = ["ownerState"], _excluded2$c = ["variants"], _excluded3$4 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function _getRequireWildcardCache$1(T) {
  if (typeof WeakMap != "function") return null;
  var S = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache$1 = function(k) {
    return k ? R : S;
  })(T);
}
function _interopRequireWildcard$1(T, S) {
  if (T && T.__esModule) return T;
  if (T === null || typeof T != "object" && typeof T != "function") return { default: T };
  var R = _getRequireWildcardCache$1(S);
  if (R && R.has(T)) return R.get(T);
  var k = { __proto__: null }, D = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var L in T) if (L !== "default" && Object.prototype.hasOwnProperty.call(T, L)) {
    var V = D ? Object.getOwnPropertyDescriptor(T, L) : null;
    V && (V.get || V.set) ? Object.defineProperty(k, L, V) : k[L] = T[L];
  }
  return k.default = T, R && R.set(T, k), k;
}
function isEmpty$2(T) {
  return Object.keys(T).length === 0;
}
function isStringTag(T) {
  return typeof T == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  T.charCodeAt(0) > 96;
}
function shouldForwardProp(T) {
  return T !== "ownerState" && T !== "theme" && T !== "sx" && T !== "as";
}
const systemDefaultTheme = createStyled$1.systemDefaultTheme = (0, _createTheme.default)(), lowercaseFirstLetter = (T) => T && T.charAt(0).toLowerCase() + T.slice(1);
function resolveTheme({
  defaultTheme: T,
  theme: S,
  themeId: R
}) {
  return isEmpty$2(S) ? T : S[R] || S;
}
function defaultOverridesResolver(T) {
  return T ? (S, R) => R[T] : null;
}
function processStyleArg(T, S) {
  let {
    ownerState: R
  } = S, k = (0, _objectWithoutPropertiesLoose2.default)(S, _excluded$1i);
  const D = typeof T == "function" ? T((0, _extends2.default)({
    ownerState: R
  }, k)) : T;
  if (Array.isArray(D))
    return D.flatMap((L) => processStyleArg(L, (0, _extends2.default)({
      ownerState: R
    }, k)));
  if (D && typeof D == "object" && Array.isArray(D.variants)) {
    const {
      variants: L = []
    } = D;
    let z = (0, _objectWithoutPropertiesLoose2.default)(D, _excluded2$c);
    return L.forEach((W) => {
      let U = !0;
      typeof W.props == "function" ? U = W.props((0, _extends2.default)({
        ownerState: R
      }, k, R)) : Object.keys(W.props).forEach((q) => {
        R?.[q] !== W.props[q] && k[q] !== W.props[q] && (U = !1);
      }), U && (Array.isArray(z) || (z = [z]), z.push(typeof W.style == "function" ? W.style((0, _extends2.default)({
        ownerState: R
      }, k, R)) : W.style));
    }), z;
  }
  return D;
}
function createStyled(T = {}) {
  const {
    themeId: S,
    defaultTheme: R = systemDefaultTheme,
    rootShouldForwardProp: k = shouldForwardProp,
    slotShouldForwardProp: D = shouldForwardProp
  } = T, L = (V) => (0, _styleFunctionSx.default)((0, _extends2.default)({}, V, {
    theme: resolveTheme((0, _extends2.default)({}, V, {
      defaultTheme: R,
      themeId: S
    }))
  }));
  return L.__mui_systemSx = !0, (V, z = {}) => {
    (0, _styledEngine$1.internal_processStyles)(V, (oe) => oe.filter((ae) => !(ae != null && ae.__mui_systemSx)));
    const {
      name: W,
      slot: U,
      skipVariantsResolver: q,
      skipSx: K,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: Y = defaultOverridesResolver(lowercaseFirstLetter(U))
    } = z, J = (0, _objectWithoutPropertiesLoose2.default)(z, _excluded3$4), Z = q !== void 0 ? q : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      U && U !== "Root" && U !== "root" || !1
    ), X = K || !1;
    let ee;
    define_process_env_default$1i.NODE_ENV !== "production" && W && (ee = `${W}-${lowercaseFirstLetter(U || "Root")}`);
    let te = shouldForwardProp;
    U === "Root" || U === "root" ? te = k : U ? te = D : isStringTag(V) && (te = void 0);
    const re = (0, _styledEngine$1.default)(V, (0, _extends2.default)({
      shouldForwardProp: te,
      label: ee
    }, J)), Q = (oe) => typeof oe == "function" && oe.__emotion_real !== oe || (0, _deepmerge.isPlainObject)(oe) ? (ae) => processStyleArg(oe, (0, _extends2.default)({}, ae, {
      theme: resolveTheme({
        theme: ae.theme,
        defaultTheme: R,
        themeId: S
      })
    })) : oe, ne = (oe, ...ae) => {
      let se = Q(oe);
      const ie = ae ? ae.map(Q) : [];
      W && Y && ie.push((Pe) => {
        const Re = resolveTheme((0, _extends2.default)({}, Pe, {
          defaultTheme: R,
          themeId: S
        }));
        if (!Re.components || !Re.components[W] || !Re.components[W].styleOverrides)
          return null;
        const ke = Re.components[W].styleOverrides, Te = {};
        return Object.entries(ke).forEach(([fe, ue]) => {
          Te[fe] = processStyleArg(ue, (0, _extends2.default)({}, Pe, {
            theme: Re
          }));
        }), Y(Pe, Te);
      }), W && !Z && ie.push((Pe) => {
        var Re;
        const ke = resolveTheme((0, _extends2.default)({}, Pe, {
          defaultTheme: R,
          themeId: S
        })), Te = ke == null || (Re = ke.components) == null || (Re = Re[W]) == null ? void 0 : Re.variants;
        return processStyleArg({
          variants: Te
        }, (0, _extends2.default)({}, Pe, {
          theme: ke
        }));
      }), X || ie.push(L);
      const he = ie.length - ae.length;
      if (Array.isArray(oe) && he > 0) {
        const Pe = new Array(he).fill("");
        se = [...oe, ...Pe], se.raw = [...oe.raw, ...Pe];
      }
      const xe = re(se, ...ie);
      if (define_process_env_default$1i.NODE_ENV !== "production") {
        let Pe;
        W && (Pe = `${W}${(0, _capitalize.default)(U || "")}`), Pe === void 0 && (Pe = `Styled(${(0, _getDisplayName.default)(V)})`), xe.displayName = Pe;
      }
      return V.muiName && (xe.muiName = V.muiName), xe;
    };
    return re.withConfig && (ne.withConfig = re.withConfig), ne;
  };
}
function slotShouldForwardProp(T) {
  return T !== "ownerState" && T !== "theme" && T !== "sx" && T !== "as";
}
const rootShouldForwardProp = (T) => slotShouldForwardProp(T) && T !== "classes", styled = _default({
  themeId: THEME_ID,
  defaultTheme,
  rootShouldForwardProp
});
var define_process_env_default$1h = {};
const _excluded$1h = ["theme"];
function ThemeProvider$1(T) {
  let {
    theme: S
  } = T, R = _objectWithoutPropertiesLoose$1(T, _excluded$1h);
  const k = S[THEME_ID];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$2, _extends$1({}, R, {
    themeId: k ? THEME_ID : void 0,
    theme: k || S
  }));
}
define_process_env_default$1h.NODE_ENV !== "production" && (ThemeProvider$1.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
});
const getOverlayAlpha = (T) => {
  let S;
  return T < 1 ? S = 5.11916 * T ** 2 : S = 4.5 * Math.log(T + 1) + 2, (S / 100).toFixed(2);
};
var define_process_env_default$1g = {};
const _excluded$1g = ["localeText"], MuiPickersAdapterContext = /* @__PURE__ */ React$1.createContext(null);
define_process_env_default$1g.NODE_ENV !== "production" && (MuiPickersAdapterContext.displayName = "MuiPickersAdapterContext");
const LocalizationProvider$1 = function T(S) {
  const {
    localeText: R
  } = S, k = _objectWithoutPropertiesLoose$1(S, _excluded$1g), {
    utils: D,
    localeText: L
  } = React$1.useContext(MuiPickersAdapterContext) ?? {
    utils: void 0,
    localeText: void 0
  }, V = useThemeProps({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: k,
    name: "MuiLocalizationProvider"
  }), {
    children: z,
    dateAdapter: W,
    dateFormats: U,
    dateLibInstance: q,
    adapterLocale: K,
    localeText: Y
  } = V, J = React$1.useMemo(() => _extends$1({}, Y, L, R), [Y, L, R]), Z = React$1.useMemo(() => {
    if (!W)
      return D || null;
    const te = new W({
      locale: K,
      formats: U,
      instance: q
    });
    if (!te.isMUIAdapter)
      throw new Error(["MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return te;
  }, [W, K, U, q, D]), X = React$1.useMemo(() => Z ? {
    minDate: Z.date("1900-01-01T00:00:00.000"),
    maxDate: Z.date("2099-12-31T00:00:00.000")
  } : null, [Z]), ee = React$1.useMemo(() => ({
    utils: Z,
    defaultDates: X,
    localeText: J
  }), [X, Z, J]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MuiPickersAdapterContext.Provider, {
    value: ee,
    children: z
  });
};
define_process_env_default$1g.NODE_ENV !== "production" && (LocalizationProvider$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: PropTypes.any,
  children: PropTypes.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: PropTypes.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: PropTypes.shape({
    dayOfMonth: PropTypes.string,
    dayOfMonthFull: PropTypes.string,
    fullDate: PropTypes.string,
    fullTime: PropTypes.string,
    fullTime12h: PropTypes.string,
    fullTime24h: PropTypes.string,
    hours12h: PropTypes.string,
    hours24h: PropTypes.string,
    keyboardDate: PropTypes.string,
    keyboardDateTime: PropTypes.string,
    keyboardDateTime12h: PropTypes.string,
    keyboardDateTime24h: PropTypes.string,
    meridiem: PropTypes.string,
    minutes: PropTypes.string,
    month: PropTypes.string,
    monthShort: PropTypes.string,
    normalDate: PropTypes.string,
    normalDateWithWeekday: PropTypes.string,
    seconds: PropTypes.string,
    shortDate: PropTypes.string,
    weekday: PropTypes.string,
    weekdayShort: PropTypes.string,
    year: PropTypes.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: PropTypes.any,
  /**
   * Locale for components texts
   */
  localeText: PropTypes.object
});
const getPickersLocalization = (T) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: _extends$1({}, T)
      }
    }
  }
}), enUSPickers = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "Open previous view",
  openNextView: "Open next view",
  calendarViewSwitchingButtonAriaLabel: (T) => T === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange labels
  start: "Start",
  end: "End",
  startDate: "Start date",
  startTime: "Start time",
  endDate: "End date",
  endTime: "End time",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (T, S, R) => `Select ${T}. ${S === null ? "No time selected" : `Selected time is ${R.format(S, "fullTime")}`}`,
  hoursClockNumberText: (T) => `${T} hours`,
  minutesClockNumberText: (T) => `${T} minutes`,
  secondsClockNumberText: (T) => `${T} seconds`,
  // Digital clock labels
  selectViewText: (T) => `Select ${T}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (T) => `Week ${T}`,
  calendarWeekNumberText: (T) => `${T}`,
  // Open picker labels
  openDatePickerDialogue: (T, S) => T !== null && S.isValid(T) ? `Choose date, selected date is ${S.format(T, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (T, S) => T !== null && S.isValid(T) ? `Choose time, selected time is ${S.format(T, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear value",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (T) => "Y".repeat(T.digitAmount),
  fieldMonthPlaceholder: (T) => T.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (T) => T.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa",
  // View names
  year: "Year",
  month: "Month",
  day: "Day",
  weekDay: "Week day",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds",
  meridiem: "Meridiem",
  // Common
  empty: "Empty"
}, DEFAULT_LOCALE = enUSPickers;
getPickersLocalization(enUSPickers);
const useLocalizationContext = () => {
  const T = React$1.useContext(MuiPickersAdapterContext);
  if (T === null)
    throw new Error(["MUI X: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (T.utils === null)
    throw new Error(["MUI X: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const S = React$1.useMemo(() => _extends$1({}, DEFAULT_LOCALE, T.localeText), [T.localeText]);
  return React$1.useMemo(() => _extends$1({}, T, {
    localeText: S
  }), [T, S]);
}, useUtils = () => useLocalizationContext().utils, useDefaultDates = () => useLocalizationContext().defaultDates, useNow = (T) => {
  const S = useUtils(), R = React$1.useRef();
  return R.current === void 0 && (R.current = S.date(void 0, T)), R.current;
}, usePickersTranslations = () => useLocalizationContext().localeText;
var define_process_env_default$1f = {};
define_process_env_default$1f.NODE_ENV !== "production" && (PropTypes.node, PropTypes.object.isRequired);
function useDefaultProps(T) {
  return useDefaultProps$1(T);
}
function getTypographyUtilityClass(T) {
  return generateUtilityClass$1("MuiTypography", T);
}
generateUtilityClasses$1("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
var define_process_env_default$1e = {};
const _excluded$1f = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], useUtilityClasses$$ = (T) => {
  const {
    align: S,
    gutterBottom: R,
    noWrap: k,
    paragraph: D,
    variant: L,
    classes: V
  } = T, z = {
    root: ["root", L, T.align !== "inherit" && `align${capitalize$1(S)}`, R && "gutterBottom", k && "noWrap", D && "paragraph"]
  };
  return composeClasses(z, getTypographyUtilityClass, V);
}, TypographyRoot = styled("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.root, R.variant && S[R.variant], R.align !== "inherit" && S[`align${capitalize$1(R.align)}`], R.noWrap && S.noWrap, R.gutterBottom && S.gutterBottom, R.paragraph && S.paragraph];
  }
})(({
  theme: T,
  ownerState: S
}) => _extends$1({
  margin: 0
}, S.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, S.variant !== "inherit" && T.typography[S.variant], S.align !== "inherit" && {
  textAlign: S.align
}, S.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, S.gutterBottom && {
  marginBottom: "0.35em"
}, S.paragraph && {
  marginBottom: 16
})), defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, colorTransformations = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, transformDeprecatedColors = (T) => colorTransformations[T] || T, Typography$2 = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiTypography"
  }), D = transformDeprecatedColors(k.color), L = extendSxProp(_extends$1({}, k, {
    color: D
  })), {
    align: V = "inherit",
    className: z,
    component: W,
    gutterBottom: U = !1,
    noWrap: q = !1,
    paragraph: K = !1,
    variant: Y = "body1",
    variantMapping: J = defaultVariantMapping
  } = L, Z = _objectWithoutPropertiesLoose$1(L, _excluded$1f), X = _extends$1({}, L, {
    align: V,
    color: D,
    className: z,
    component: W,
    gutterBottom: U,
    noWrap: q,
    paragraph: K,
    variant: Y,
    variantMapping: J
  }), ee = W || (K ? "p" : J[Y] || defaultVariantMapping[Y]) || "span", te = useUtilityClasses$$(X);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TypographyRoot, _extends$1({
    as: ee,
    ref: R,
    ownerState: X,
    className: clsx(te.root, z)
  }, Z));
});
define_process_env_default$1e.NODE_ENV !== "production" && (Typography$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: PropTypes.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: PropTypes.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: PropTypes.object
});
function _setPrototypeOf(T, S) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(R, k) {
    return R.__proto__ = k, R;
  }, _setPrototypeOf(T, S);
}
function _inheritsLoose(T, S) {
  T.prototype = Object.create(S.prototype), T.prototype.constructor = T, _setPrototypeOf(T, S);
}
function hasClass(T, S) {
  return T.classList ? !!S && T.classList.contains(S) : (" " + (T.className.baseVal || T.className) + " ").indexOf(" " + S + " ") !== -1;
}
function addClass(T, S) {
  T.classList ? T.classList.add(S) : hasClass(T, S) || (typeof T.className == "string" ? T.className = T.className + " " + S : T.setAttribute("class", (T.className && T.className.baseVal || "") + " " + S));
}
function replaceClassName(T, S) {
  return T.replace(new RegExp("(^|\\s)" + S + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function removeClass$1(T, S) {
  T.classList ? T.classList.remove(S) : typeof T.className == "string" ? T.className = replaceClassName(T.className, S) : T.setAttribute("class", replaceClassName(T.className && T.className.baseVal || "", S));
}
const config$1 = {
  disabled: !1
};
var define_process_env_default$1d = {}, timeoutsShape = define_process_env_default$1d.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null, classNamesShape = define_process_env_default$1d.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function T(S) {
  return S.scrollTop;
}, define_process_env_default$1c = {}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ function(T) {
  _inheritsLoose(S, T);
  function S(k, D) {
    var L;
    L = T.call(this, k, D) || this;
    var V = D, z = V && !V.isMounting ? k.enter : k.appear, W;
    return L.appearStatus = null, k.in ? z ? (W = EXITED, L.appearStatus = ENTERING) : W = ENTERED : k.unmountOnExit || k.mountOnEnter ? W = UNMOUNTED : W = EXITED, L.state = {
      status: W
    }, L.nextCallback = null, L;
  }
  S.getDerivedStateFromProps = function(D, L) {
    var V = D.in;
    return V && L.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var R = S.prototype;
  return R.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, R.componentDidUpdate = function(D) {
    var L = null;
    if (D !== this.props) {
      var V = this.state.status;
      this.props.in ? V !== ENTERING && V !== ENTERED && (L = ENTERING) : (V === ENTERING || V === ENTERED) && (L = EXITING);
    }
    this.updateStatus(!1, L);
  }, R.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, R.getTimeouts = function() {
    var D = this.props.timeout, L, V, z;
    return L = V = z = D, D != null && typeof D != "number" && (L = D.exit, V = D.enter, z = D.appear !== void 0 ? D.appear : V), {
      exit: L,
      enter: V,
      appear: z
    };
  }, R.updateStatus = function(D, L) {
    if (D === void 0 && (D = !1), L !== null)
      if (this.cancelNextCallback(), L === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var V = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          V && forceReflow(V);
        }
        this.performEnter(D);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === EXITED && this.setState({
      status: UNMOUNTED
    });
  }, R.performEnter = function(D) {
    var L = this, V = this.props.enter, z = this.context ? this.context.isMounting : D, W = this.props.nodeRef ? [z] : [ReactDOM__default.findDOMNode(this), z], U = W[0], q = W[1], K = this.getTimeouts(), Y = z ? K.appear : K.enter;
    if (!D && !V || config$1.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        L.props.onEntered(U);
      });
      return;
    }
    this.props.onEnter(U, q), this.safeSetState({
      status: ENTERING
    }, function() {
      L.props.onEntering(U, q), L.onTransitionEnd(Y, function() {
        L.safeSetState({
          status: ENTERED
        }, function() {
          L.props.onEntered(U, q);
        });
      });
    });
  }, R.performExit = function() {
    var D = this, L = this.props.exit, V = this.getTimeouts(), z = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!L || config$1.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        D.props.onExited(z);
      });
      return;
    }
    this.props.onExit(z), this.safeSetState({
      status: EXITING
    }, function() {
      D.props.onExiting(z), D.onTransitionEnd(V.exit, function() {
        D.safeSetState({
          status: EXITED
        }, function() {
          D.props.onExited(z);
        });
      });
    });
  }, R.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, R.safeSetState = function(D, L) {
    L = this.setNextCallback(L), this.setState(D, L);
  }, R.setNextCallback = function(D) {
    var L = this, V = !0;
    return this.nextCallback = function(z) {
      V && (V = !1, L.nextCallback = null, D(z));
    }, this.nextCallback.cancel = function() {
      V = !1;
    }, this.nextCallback;
  }, R.onTransitionEnd = function(D, L) {
    this.setNextCallback(L);
    var V = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this), z = D == null && !this.props.addEndListener;
    if (!V || z) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var W = this.props.nodeRef ? [this.nextCallback] : [V, this.nextCallback], U = W[0], q = W[1];
      this.props.addEndListener(U, q);
    }
    D != null && setTimeout(this.nextCallback, D);
  }, R.render = function() {
    var D = this.state.status;
    if (D === UNMOUNTED)
      return null;
    var L = this.props, V = L.children;
    L.in, L.mountOnEnter, L.unmountOnExit, L.appear, L.enter, L.exit, L.timeout, L.addEndListener, L.onEnter, L.onEntering, L.onEntered, L.onExit, L.onExiting, L.onExited, L.nodeRef;
    var z = _objectWithoutPropertiesLoose$1(L, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof V == "function" ? V(D, z) : React__default.cloneElement(React__default.Children.only(V), z))
    );
  }, S;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = define_process_env_default$1c.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(T, S, R, k, D, L) {
      var V = T[S];
      return PropTypes.instanceOf(V && "ownerDocument" in V ? V.ownerDocument.defaultView.Element : Element)(T, S, R, k, D, L);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function T(S) {
    var R = timeoutsShape;
    S.addEndListener || (R = R.isRequired);
    for (var k = arguments.length, D = new Array(k > 1 ? k - 1 : 0), L = 1; L < k; L++)
      D[L - 1] = arguments[L];
    return R.apply(void 0, [S].concat(D));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop$3() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop$3,
  onEntering: noop$3,
  onEntered: noop$3,
  onExit: noop$3,
  onExiting: noop$3,
  onExited: noop$3
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var define_process_env_default$1b = {}, _addClass = function T(S, R) {
  return S && R && R.split(" ").forEach(function(k) {
    return addClass(S, k);
  });
}, removeClass = function T(S, R) {
  return S && R && R.split(" ").forEach(function(k) {
    return removeClass$1(S, k);
  });
}, CSSTransition = /* @__PURE__ */ function(T) {
  _inheritsLoose(S, T);
  function S() {
    for (var k, D = arguments.length, L = new Array(D), V = 0; V < D; V++)
      L[V] = arguments[V];
    return k = T.call.apply(T, [this].concat(L)) || this, k.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, k.onEnter = function(z, W) {
      var U = k.resolveArguments(z, W), q = U[0], K = U[1];
      k.removeClasses(q, "exit"), k.addClass(q, K ? "appear" : "enter", "base"), k.props.onEnter && k.props.onEnter(z, W);
    }, k.onEntering = function(z, W) {
      var U = k.resolveArguments(z, W), q = U[0], K = U[1], Y = K ? "appear" : "enter";
      k.addClass(q, Y, "active"), k.props.onEntering && k.props.onEntering(z, W);
    }, k.onEntered = function(z, W) {
      var U = k.resolveArguments(z, W), q = U[0], K = U[1], Y = K ? "appear" : "enter";
      k.removeClasses(q, Y), k.addClass(q, Y, "done"), k.props.onEntered && k.props.onEntered(z, W);
    }, k.onExit = function(z) {
      var W = k.resolveArguments(z), U = W[0];
      k.removeClasses(U, "appear"), k.removeClasses(U, "enter"), k.addClass(U, "exit", "base"), k.props.onExit && k.props.onExit(z);
    }, k.onExiting = function(z) {
      var W = k.resolveArguments(z), U = W[0];
      k.addClass(U, "exit", "active"), k.props.onExiting && k.props.onExiting(z);
    }, k.onExited = function(z) {
      var W = k.resolveArguments(z), U = W[0];
      k.removeClasses(U, "exit"), k.addClass(U, "exit", "done"), k.props.onExited && k.props.onExited(z);
    }, k.resolveArguments = function(z, W) {
      return k.props.nodeRef ? [k.props.nodeRef.current, z] : [z, W];
    }, k.getClassNames = function(z) {
      var W = k.props.classNames, U = typeof W == "string", q = U && W ? W + "-" : "", K = U ? "" + q + z : W[z], Y = U ? K + "-active" : W[z + "Active"], J = U ? K + "-done" : W[z + "Done"];
      return {
        baseClassName: K,
        activeClassName: Y,
        doneClassName: J
      };
    }, k;
  }
  var R = S.prototype;
  return R.addClass = function(D, L, V) {
    var z = this.getClassNames(L)[V + "ClassName"], W = this.getClassNames("enter"), U = W.doneClassName;
    L === "appear" && V === "done" && U && (z += " " + U), V === "active" && D && forceReflow(D), z && (this.appliedClasses[L][V] = z, _addClass(D, z));
  }, R.removeClasses = function(D, L) {
    var V = this.appliedClasses[L], z = V.base, W = V.active, U = V.done;
    this.appliedClasses[L] = {}, z && removeClass(D, z), W && removeClass(D, W), U && removeClass(D, U);
  }, R.render = function() {
    var D = this.props;
    D.classNames;
    var L = _objectWithoutPropertiesLoose$1(D, ["classNames"]);
    return /* @__PURE__ */ React__default.createElement(Transition, _extends$1({}, L, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, S;
}(React__default.Component);
CSSTransition.defaultProps = {
  classNames: ""
};
CSSTransition.propTypes = define_process_env_default$1b.NODE_ENV !== "production" ? _extends$1({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
function _assertThisInitialized(T) {
  if (T === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return T;
}
function getChildMapping(T, S) {
  var R = function(L) {
    return S && isValidElement(L) ? S(L) : L;
  }, k = /* @__PURE__ */ Object.create(null);
  return T && Children.map(T, function(D) {
    return D;
  }).forEach(function(D) {
    k[D.key] = R(D);
  }), k;
}
function mergeChildMappings(T, S) {
  T = T || {}, S = S || {};
  function R(q) {
    return q in S ? S[q] : T[q];
  }
  var k = /* @__PURE__ */ Object.create(null), D = [];
  for (var L in T)
    L in S ? D.length && (k[L] = D, D = []) : D.push(L);
  var V, z = {};
  for (var W in S) {
    if (k[W])
      for (V = 0; V < k[W].length; V++) {
        var U = k[W][V];
        z[k[W][V]] = R(U);
      }
    z[W] = R(W);
  }
  for (V = 0; V < D.length; V++)
    z[D[V]] = R(D[V]);
  return z;
}
function getProp(T, S, R) {
  return R[S] != null ? R[S] : T.props[S];
}
function getInitialChildMapping(T, S) {
  return getChildMapping(T.children, function(R) {
    return cloneElement(R, {
      onExited: S.bind(null, R),
      in: !0,
      appear: getProp(R, "appear", T),
      enter: getProp(R, "enter", T),
      exit: getProp(R, "exit", T)
    });
  });
}
function getNextChildMapping(T, S, R) {
  var k = getChildMapping(T.children), D = mergeChildMappings(S, k);
  return Object.keys(D).forEach(function(L) {
    var V = D[L];
    if (isValidElement(V)) {
      var z = L in S, W = L in k, U = S[L], q = isValidElement(U) && !U.props.in;
      W && (!z || q) ? D[L] = cloneElement(V, {
        onExited: R.bind(null, V),
        in: !0,
        exit: getProp(V, "exit", T),
        enter: getProp(V, "enter", T)
      }) : !W && z && !q ? D[L] = cloneElement(V, {
        in: !1
      }) : W && z && isValidElement(U) && (D[L] = cloneElement(V, {
        onExited: R.bind(null, V),
        in: U.props.in,
        exit: getProp(V, "exit", T),
        enter: getProp(V, "enter", T)
      }));
    }
  }), D;
}
var define_process_env_default$1a = {}, values = Object.values || function(T) {
  return Object.keys(T).map(function(S) {
    return T[S];
  });
}, defaultProps = {
  component: "div",
  childFactory: function T(S) {
    return S;
  }
}, TransitionGroup = /* @__PURE__ */ function(T) {
  _inheritsLoose(S, T);
  function S(k, D) {
    var L;
    L = T.call(this, k, D) || this;
    var V = L.handleExited.bind(_assertThisInitialized(L));
    return L.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: V,
      firstRender: !0
    }, L;
  }
  var R = S.prototype;
  return R.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, R.componentWillUnmount = function() {
    this.mounted = !1;
  }, S.getDerivedStateFromProps = function(D, L) {
    var V = L.children, z = L.handleExited, W = L.firstRender;
    return {
      children: W ? getInitialChildMapping(D, z) : getNextChildMapping(D, V, z),
      firstRender: !1
    };
  }, R.handleExited = function(D, L) {
    var V = getChildMapping(this.props.children);
    D.key in V || (D.props.onExited && D.props.onExited(L), this.mounted && this.setState(function(z) {
      var W = _extends$1({}, z.children);
      return delete W[D.key], {
        children: W
      };
    }));
  }, R.render = function() {
    var D = this.props, L = D.component, V = D.childFactory, z = _objectWithoutPropertiesLoose$1(D, ["component", "childFactory"]), W = this.state.contextValue, U = values(this.state.children).map(V);
    return delete z.appear, delete z.enter, delete z.exit, L === null ? /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: W
    }, U) : /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: W
    }, /* @__PURE__ */ React__default.createElement(L, z, U));
  }, S;
}(React__default.Component);
TransitionGroup.propTypes = define_process_env_default$1a.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
var define_process_env_default$19 = {};
function Ripple(T) {
  const {
    className: S,
    classes: R,
    pulsate: k = !1,
    rippleX: D,
    rippleY: L,
    rippleSize: V,
    in: z,
    onExited: W,
    timeout: U
  } = T, [q, K] = React$1.useState(!1), Y = clsx(S, R.ripple, R.rippleVisible, k && R.ripplePulsate), J = {
    width: V,
    height: V,
    top: -(V / 2) + L,
    left: -(V / 2) + D
  }, Z = clsx(R.child, q && R.childLeaving, k && R.childPulsate);
  return !z && !q && K(!0), React$1.useEffect(() => {
    if (!z && W != null) {
      const X = setTimeout(W, U);
      return () => {
        clearTimeout(X);
      };
    }
  }, [W, z, U]), /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    className: Y,
    style: J,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: Z
    })
  });
}
define_process_env_default$19.NODE_ENV !== "production" && (Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,
  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
});
const touchRippleClasses = generateUtilityClasses$1("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]);
var define_process_env_default$18 = {};
const _excluded$1e = ["center", "classes", "className"];
let _ = (T) => T, _t, _t2, _t3, _t4;
const DURATION = 550, DELAY_RIPPLE = 80, enterKeyframe = keyframes$1(_t || (_t = _`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), exitKeyframe = keyframes$1(_t2 || (_t2 = _`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), pulsateKeyframe = keyframes$1(_t3 || (_t3 = _`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), TouchRippleRoot = styled("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), TouchRippleRipple = styled(Ripple, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(_t4 || (_t4 = _`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), touchRippleClasses.rippleVisible, enterKeyframe, DURATION, ({
  theme: T
}) => T.transitions.easing.easeInOut, touchRippleClasses.ripplePulsate, ({
  theme: T
}) => T.transitions.duration.shorter, touchRippleClasses.child, touchRippleClasses.childLeaving, exitKeyframe, DURATION, ({
  theme: T
}) => T.transitions.easing.easeInOut, touchRippleClasses.childPulsate, pulsateKeyframe, ({
  theme: T
}) => T.transitions.easing.easeInOut), TouchRipple = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiTouchRipple"
  }), {
    center: D = !1,
    classes: L = {},
    className: V
  } = k, z = _objectWithoutPropertiesLoose$1(k, _excluded$1e), [W, U] = React$1.useState([]), q = React$1.useRef(0), K = React$1.useRef(null);
  React$1.useEffect(() => {
    K.current && (K.current(), K.current = null);
  }, [W]);
  const Y = React$1.useRef(!1), J = useTimeout(), Z = React$1.useRef(null), X = React$1.useRef(null), ee = React$1.useCallback((ne) => {
    const {
      pulsate: oe,
      rippleX: ae,
      rippleY: se,
      rippleSize: ie,
      cb: he
    } = ne;
    U((xe) => [...xe, /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRipple, {
      classes: {
        ripple: clsx(L.ripple, touchRippleClasses.ripple),
        rippleVisible: clsx(L.rippleVisible, touchRippleClasses.rippleVisible),
        ripplePulsate: clsx(L.ripplePulsate, touchRippleClasses.ripplePulsate),
        child: clsx(L.child, touchRippleClasses.child),
        childLeaving: clsx(L.childLeaving, touchRippleClasses.childLeaving),
        childPulsate: clsx(L.childPulsate, touchRippleClasses.childPulsate)
      },
      timeout: DURATION,
      pulsate: oe,
      rippleX: ae,
      rippleY: se,
      rippleSize: ie
    }, q.current)]), q.current += 1, K.current = he;
  }, [L]), te = React$1.useCallback((ne = {}, oe = {}, ae = () => {
  }) => {
    const {
      pulsate: se = !1,
      center: ie = D || oe.pulsate,
      fakeElement: he = !1
      // For test purposes
    } = oe;
    if (ne?.type === "mousedown" && Y.current) {
      Y.current = !1;
      return;
    }
    ne?.type === "touchstart" && (Y.current = !0);
    const xe = he ? null : X.current, Pe = xe ? xe.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let Re, ke, Te;
    if (ie || ne === void 0 || ne.clientX === 0 && ne.clientY === 0 || !ne.clientX && !ne.touches)
      Re = Math.round(Pe.width / 2), ke = Math.round(Pe.height / 2);
    else {
      const {
        clientX: fe,
        clientY: ue
      } = ne.touches && ne.touches.length > 0 ? ne.touches[0] : ne;
      Re = Math.round(fe - Pe.left), ke = Math.round(ue - Pe.top);
    }
    if (ie)
      Te = Math.sqrt((2 * Pe.width ** 2 + Pe.height ** 2) / 3), Te % 2 === 0 && (Te += 1);
    else {
      const fe = Math.max(Math.abs((xe ? xe.clientWidth : 0) - Re), Re) * 2 + 2, ue = Math.max(Math.abs((xe ? xe.clientHeight : 0) - ke), ke) * 2 + 2;
      Te = Math.sqrt(fe ** 2 + ue ** 2);
    }
    ne != null && ne.touches ? Z.current === null && (Z.current = () => {
      ee({
        pulsate: se,
        rippleX: Re,
        rippleY: ke,
        rippleSize: Te,
        cb: ae
      });
    }, J.start(DELAY_RIPPLE, () => {
      Z.current && (Z.current(), Z.current = null);
    })) : ee({
      pulsate: se,
      rippleX: Re,
      rippleY: ke,
      rippleSize: Te,
      cb: ae
    });
  }, [D, ee, J]), re = React$1.useCallback(() => {
    te({}, {
      pulsate: !0
    });
  }, [te]), Q = React$1.useCallback((ne, oe) => {
    if (J.clear(), ne?.type === "touchend" && Z.current) {
      Z.current(), Z.current = null, J.start(0, () => {
        Q(ne, oe);
      });
      return;
    }
    Z.current = null, U((ae) => ae.length > 0 ? ae.slice(1) : ae), K.current = oe;
  }, [J]);
  return React$1.useImperativeHandle(R, () => ({
    pulsate: re,
    start: te,
    stop: Q
  }), [re, te, Q]), /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRoot, _extends$1({
    className: clsx(touchRippleClasses.root, L.root, V),
    ref: X
  }, z, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionGroup, {
      component: null,
      exit: !0,
      children: W
    })
  }));
});
define_process_env_default$18.NODE_ENV !== "production" && (TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string
});
function getButtonBaseUtilityClass(T) {
  return generateUtilityClass$1("MuiButtonBase", T);
}
const buttonBaseClasses = generateUtilityClasses$1("MuiButtonBase", ["root", "disabled", "focusVisible"]);
var define_process_env_default$17 = {};
const _excluded$1d = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], useUtilityClasses$_ = (T) => {
  const {
    disabled: S,
    focusVisible: R,
    focusVisibleClassName: k,
    classes: D
  } = T, V = composeClasses({
    root: ["root", S && "disabled", R && "focusVisible"]
  }, getButtonBaseUtilityClass, D);
  return R && k && (V.root += ` ${k}`), V;
}, ButtonBaseRoot = styled("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), ButtonBase = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiButtonBase"
  }), {
    action: D,
    centerRipple: L = !1,
    children: V,
    className: z,
    component: W = "button",
    disabled: U = !1,
    disableRipple: q = !1,
    disableTouchRipple: K = !1,
    focusRipple: Y = !1,
    LinkComponent: J = "a",
    onBlur: Z,
    onClick: X,
    onContextMenu: ee,
    onDragLeave: te,
    onFocus: re,
    onFocusVisible: Q,
    onKeyDown: ne,
    onKeyUp: oe,
    onMouseDown: ae,
    onMouseLeave: se,
    onMouseUp: ie,
    onTouchEnd: he,
    onTouchMove: xe,
    onTouchStart: Pe,
    tabIndex: Re = 0,
    TouchRippleProps: ke,
    touchRippleRef: Te,
    type: fe
  } = k, ue = _objectWithoutPropertiesLoose$1(k, _excluded$1d), Ce = React$1.useRef(null), ce = React$1.useRef(null), pe = useForkRef(ce, Te), {
    isFocusVisibleRef: _e,
    onFocus: ge,
    onBlur: Ae,
    ref: Ee
  } = useIsFocusVisible(), [ve, le] = React$1.useState(!1);
  U && ve && le(!1), React$1.useImperativeHandle(D, () => ({
    focusVisible: () => {
      le(!0), Ce.current.focus();
    }
  }), []);
  const [me, Se] = React$1.useState(!1);
  React$1.useEffect(() => {
    Se(!0);
  }, []);
  const ye = me && !q && !U;
  React$1.useEffect(() => {
    ve && Y && !q && me && ce.current.pulsate();
  }, [q, Y, ve, me]);
  function be(Xe, tt, at = K) {
    return useEventCallback((it) => (tt && tt(it), !at && ce.current && ce.current[Xe](it), !0));
  }
  const $e = be("start", ae), Oe = be("stop", ee), Ie = be("stop", te), we = be("stop", ie), Fe = be("stop", (Xe) => {
    ve && Xe.preventDefault(), se && se(Xe);
  }), De = be("start", Pe), Le = be("stop", he), ze = be("stop", xe), We = be("stop", (Xe) => {
    Ae(Xe), _e.current === !1 && le(!1), Z && Z(Xe);
  }, !1), Be = useEventCallback((Xe) => {
    Ce.current || (Ce.current = Xe.currentTarget), ge(Xe), _e.current === !0 && (le(!0), Q && Q(Xe)), re && re(Xe);
  }), Ye = () => {
    const Xe = Ce.current;
    return W && W !== "button" && !(Xe.tagName === "A" && Xe.href);
  }, Ge = React$1.useRef(!1), nt = useEventCallback((Xe) => {
    Y && !Ge.current && ve && ce.current && Xe.key === " " && (Ge.current = !0, ce.current.stop(Xe, () => {
      ce.current.start(Xe);
    })), Xe.target === Xe.currentTarget && Ye() && Xe.key === " " && Xe.preventDefault(), ne && ne(Xe), Xe.target === Xe.currentTarget && Ye() && Xe.key === "Enter" && !U && (Xe.preventDefault(), X && X(Xe));
  }), Ze = useEventCallback((Xe) => {
    Y && Xe.key === " " && ce.current && ve && !Xe.defaultPrevented && (Ge.current = !1, ce.current.stop(Xe, () => {
      ce.current.pulsate(Xe);
    })), oe && oe(Xe), X && Xe.target === Xe.currentTarget && Ye() && Xe.key === " " && !Xe.defaultPrevented && X(Xe);
  });
  let Me = W;
  Me === "button" && (ue.href || ue.to) && (Me = J);
  const Ne = {};
  Me === "button" ? (Ne.type = fe === void 0 ? "button" : fe, Ne.disabled = U) : (!ue.href && !ue.to && (Ne.role = "button"), U && (Ne["aria-disabled"] = U));
  const He = useForkRef(R, Ee, Ce);
  define_process_env_default$17.NODE_ENV !== "production" && React$1.useEffect(() => {
    ye && !ce.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [ye]);
  const qe = _extends$1({}, k, {
    centerRipple: L,
    component: W,
    disabled: U,
    disableRipple: q,
    disableTouchRipple: K,
    focusRipple: Y,
    tabIndex: Re,
    focusVisible: ve
  }), Ke = useUtilityClasses$_(qe);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonBaseRoot, _extends$1({
    as: Me,
    className: clsx(Ke.root, z),
    ownerState: qe,
    onBlur: We,
    onClick: X,
    onContextMenu: Oe,
    onFocus: Be,
    onKeyDown: nt,
    onKeyUp: Ze,
    onMouseDown: $e,
    onMouseLeave: Fe,
    onMouseUp: we,
    onDragLeave: Ie,
    onTouchEnd: Le,
    onTouchMove: ze,
    onTouchStart: De,
    ref: He,
    tabIndex: U ? -1 : Re,
    type: fe
  }, Ne, ue, {
    children: [V, ye ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRipple, _extends$1({
        ref: pe,
        center: L
      }, ke))
    ) : null]
  }));
});
define_process_env_default$17.NODE_ENV !== "production" && (ButtonBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string])
});
function getIconButtonUtilityClass(T) {
  return generateUtilityClass$1("MuiIconButton", T);
}
const iconButtonClasses = generateUtilityClasses$1("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]);
var define_process_env_default$16 = {};
const _excluded$1c = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], useUtilityClasses$Z = (T) => {
  const {
    classes: S,
    disabled: R,
    color: k,
    edge: D,
    size: L
  } = T, V = {
    root: ["root", R && "disabled", k !== "default" && `color${capitalize$1(k)}`, D && `edge${capitalize$1(D)}`, `size${capitalize$1(L)}`]
  };
  return composeClasses(V, getIconButtonUtilityClass, S);
}, IconButtonRoot = styled(ButtonBase, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.root, R.color !== "default" && S[`color${capitalize$1(R.color)}`], R.edge && S[`edge${capitalize$1(R.edge)}`], S[`size${capitalize$1(R.size)}`]];
  }
})(({
  theme: T,
  ownerState: S
}) => _extends$1({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: T.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (T.vars || T).palette.action.active,
  transition: T.transitions.create("background-color", {
    duration: T.transitions.duration.shortest
  })
}, !S.disableRipple && {
  "&:hover": {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.action.activeChannel} / ${T.vars.palette.action.hoverOpacity})` : alpha_1(T.palette.action.active, T.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, S.edge === "start" && {
  marginLeft: S.size === "small" ? -3 : -12
}, S.edge === "end" && {
  marginRight: S.size === "small" ? -3 : -12
}), ({
  theme: T,
  ownerState: S
}) => {
  var R;
  const k = (R = (T.vars || T).palette) == null ? void 0 : R[S.color];
  return _extends$1({}, S.color === "inherit" && {
    color: "inherit"
  }, S.color !== "inherit" && S.color !== "default" && _extends$1({
    color: k?.main
  }, !S.disableRipple && {
    "&:hover": _extends$1({}, k && {
      backgroundColor: T.vars ? `rgba(${k.mainChannel} / ${T.vars.palette.action.hoverOpacity})` : alpha_1(k.main, T.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), S.size === "small" && {
    padding: 5,
    fontSize: T.typography.pxToRem(18)
  }, S.size === "large" && {
    padding: 12,
    fontSize: T.typography.pxToRem(28)
  }, {
    [`&.${iconButtonClasses.disabled}`]: {
      backgroundColor: "transparent",
      color: (T.vars || T).palette.action.disabled
    }
  });
}), IconButton = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiIconButton"
  }), {
    edge: D = !1,
    children: L,
    className: V,
    color: z = "default",
    disabled: W = !1,
    disableFocusRipple: U = !1,
    size: q = "medium"
  } = k, K = _objectWithoutPropertiesLoose$1(k, _excluded$1c), Y = _extends$1({}, k, {
    edge: D,
    color: z,
    disabled: W,
    disableFocusRipple: U,
    size: q
  }), J = useUtilityClasses$Z(Y);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IconButtonRoot, _extends$1({
    className: clsx(J.root, V),
    centerRipple: !0,
    focusRipple: !U,
    disabled: W,
    ref: R
  }, K, {
    ownerState: Y,
    children: L
  }));
});
define_process_env_default$16.NODE_ENV !== "production" && (IconButton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: chainPropTypes(PropTypes.node, (T) => React$1.Children.toArray(T.children).some((R) => /* @__PURE__ */ React$1.isValidElement(R) && R.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getSvgIconUtilityClass(T) {
  return generateUtilityClass$1("MuiSvgIcon", T);
}
generateUtilityClasses$1("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
var define_process_env_default$15 = {};
const _excluded$1b = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], useUtilityClasses$Y = (T) => {
  const {
    color: S,
    fontSize: R,
    classes: k
  } = T, D = {
    root: ["root", S !== "inherit" && `color${capitalize$1(S)}`, `fontSize${capitalize$1(R)}`]
  };
  return composeClasses(D, getSvgIconUtilityClass, k);
}, SvgIconRoot = styled("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.root, R.color !== "inherit" && S[`color${capitalize$1(R.color)}`], S[`fontSize${capitalize$1(R.fontSize)}`]];
  }
})(({
  theme: T,
  ownerState: S
}) => {
  var R, k, D, L, V, z, W, U, q, K, Y, J, Z;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: S.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (R = T.transitions) == null || (k = R.create) == null ? void 0 : k.call(R, "fill", {
      duration: (D = T.transitions) == null || (D = D.duration) == null ? void 0 : D.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((L = T.typography) == null || (V = L.pxToRem) == null ? void 0 : V.call(L, 20)) || "1.25rem",
      medium: ((z = T.typography) == null || (W = z.pxToRem) == null ? void 0 : W.call(z, 24)) || "1.5rem",
      large: ((U = T.typography) == null || (q = U.pxToRem) == null ? void 0 : q.call(U, 35)) || "2.1875rem"
    }[S.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (K = (Y = (T.vars || T).palette) == null || (Y = Y[S.color]) == null ? void 0 : Y.main) != null ? K : {
      action: (J = (T.vars || T).palette) == null || (J = J.action) == null ? void 0 : J.active,
      disabled: (Z = (T.vars || T).palette) == null || (Z = Z.action) == null ? void 0 : Z.disabled,
      inherit: void 0
    }[S.color]
  };
}), SvgIcon = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiSvgIcon"
  }), {
    children: D,
    className: L,
    color: V = "inherit",
    component: z = "svg",
    fontSize: W = "medium",
    htmlColor: U,
    inheritViewBox: q = !1,
    titleAccess: K,
    viewBox: Y = "0 0 24 24"
  } = k, J = _objectWithoutPropertiesLoose$1(k, _excluded$1b), Z = /* @__PURE__ */ React$1.isValidElement(D) && D.type === "svg", X = _extends$1({}, k, {
    color: V,
    component: z,
    fontSize: W,
    instanceFontSize: S.fontSize,
    inheritViewBox: q,
    viewBox: Y,
    hasSvgAsChild: Z
  }), ee = {};
  q || (ee.viewBox = Y);
  const te = useUtilityClasses$Y(X);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SvgIconRoot, _extends$1({
    as: z,
    className: clsx(te.root, L),
    focusable: "false",
    color: U,
    "aria-hidden": K ? void 0 : !0,
    role: K ? "img" : void 0,
    ref: R
  }, ee, J, Z && D.props, {
    ownerState: X,
    children: [Z ? D.props.children : D, K ? /* @__PURE__ */ jsxRuntimeExports.jsx("title", {
      children: K
    }) : null]
  }));
});
define_process_env_default$15.NODE_ENV !== "production" && (SvgIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "large", "medium", "small"]), PropTypes.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes.string
});
SvgIcon.muiName = "SvgIcon";
var define_process_env_default$14 = {};
function createSvgIcon(T, S) {
  function R(k, D) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon, _extends$1({
      "data-testid": `${S}Icon`,
      ref: D
    }, k, {
      children: T
    }));
  }
  return define_process_env_default$14.NODE_ENV !== "production" && (R.displayName = `${S}Icon`), R.muiName = SvgIcon.muiName, /* @__PURE__ */ React$1.memo(/* @__PURE__ */ React$1.forwardRef(R));
}
const ArrowDropDownIcon$1 = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), ArrowLeftIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), ArrowRightIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), CalendarIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar"), ClockIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
  children: [/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock");
createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
  children: [/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time");
const ClearIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function getPickersArrowSwitcherUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersArrowSwitcher", T);
}
generateUtilityClasses$1("MuiPickersArrowSwitcher", ["root", "spacer", "button"]);
const _excluded$1a = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel", "labelId"], _excluded2$b = ["ownerState"], _excluded3$3 = ["ownerState"], PickersArrowSwitcherRoot = styled("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  display: "flex"
}), PickersArrowSwitcherSpacer = styled("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (T, S) => S.spacer
})(({
  theme: T
}) => ({
  width: T.spacing(3)
})), PickersArrowSwitcherButton = styled(IconButton, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (T, S) => S.button
})({
  variants: [{
    props: {
      hidden: !0
    },
    style: {
      visibility: "hidden"
    }
  }]
}), useUtilityClasses$X = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"]
  }, getPickersArrowSwitcherUtilityClass, S);
}, PickersArrowSwitcher = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useRtl(), D = useThemeProps({
    props: S,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: L,
    className: V,
    slots: z,
    slotProps: W,
    isNextDisabled: U,
    isNextHidden: q,
    onGoToNext: K,
    nextLabel: Y,
    isPreviousDisabled: J,
    isPreviousHidden: Z,
    onGoToPrevious: X,
    previousLabel: ee,
    labelId: te
  } = D, re = _objectWithoutPropertiesLoose$1(D, _excluded$1a), Q = D, ne = useUtilityClasses$X(Q), oe = {
    isDisabled: U,
    isHidden: q,
    goTo: K,
    label: Y
  }, ae = {
    isDisabled: J,
    isHidden: Z,
    goTo: X,
    label: ee
  }, se = z?.previousIconButton ?? PickersArrowSwitcherButton, ie = useSlotProps({
    elementType: se,
    externalSlotProps: W?.previousIconButton,
    additionalProps: {
      size: "medium",
      title: ae.label,
      "aria-label": ae.label,
      disabled: ae.isDisabled,
      edge: "end",
      onClick: ae.goTo
    },
    ownerState: _extends$1({}, Q, {
      hidden: ae.isHidden
    }),
    className: ne.button
  }), he = z?.nextIconButton ?? PickersArrowSwitcherButton, xe = useSlotProps({
    elementType: he,
    externalSlotProps: W?.nextIconButton,
    additionalProps: {
      size: "medium",
      title: oe.label,
      "aria-label": oe.label,
      disabled: oe.isDisabled,
      edge: "start",
      onClick: oe.goTo
    },
    ownerState: _extends$1({}, Q, {
      hidden: oe.isHidden
    }),
    className: ne.button
  }), Pe = z?.leftArrowIcon ?? ArrowLeftIcon, Re = useSlotProps({
    elementType: Pe,
    externalSlotProps: W?.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), ke = _objectWithoutPropertiesLoose$1(Re, _excluded2$b), Te = z?.rightArrowIcon ?? ArrowRightIcon, fe = useSlotProps({
    elementType: Te,
    externalSlotProps: W?.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), ue = _objectWithoutPropertiesLoose$1(fe, _excluded3$3);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersArrowSwitcherRoot, _extends$1({
    ref: R,
    className: clsx(ne.root, V),
    ownerState: Q
  }, re, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(se, _extends$1({}, ie, {
      children: k ? /* @__PURE__ */ jsxRuntimeExports.jsx(Te, _extends$1({}, ue)) : /* @__PURE__ */ jsxRuntimeExports.jsx(Pe, _extends$1({}, ke))
    })), L ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, {
      variant: "subtitle1",
      component: "span",
      id: te,
      children: L
    }) : /* @__PURE__ */ jsxRuntimeExports.jsx(PickersArrowSwitcherSpacer, {
      className: ne.spacer,
      ownerState: Q
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(he, _extends$1({}, xe, {
      children: k ? /* @__PURE__ */ jsxRuntimeExports.jsx(Pe, _extends$1({}, ke)) : /* @__PURE__ */ jsxRuntimeExports.jsx(Te, _extends$1({}, ue))
    }))]
  }));
}), areViewsEqual = (T, S) => T.length !== S.length ? !1 : S.every((R) => T.includes(R)), applyDefaultViewProps = ({
  openTo: T,
  defaultOpenTo: S,
  views: R,
  defaultViews: k
}) => {
  const D = R ?? k;
  let L;
  if (T != null)
    L = T;
  else if (D.includes(S))
    L = S;
  else if (D.length > 0)
    L = D[0];
  else
    throw new Error("MUI X: The `views` prop must contain at least one view.");
  return {
    views: D,
    openTo: L
  };
}, timeViews = ["hours", "minutes", "seconds"], isTimeView = (T) => timeViews.includes(T), isInternalTimeView = (T) => timeViews.includes(T) || T === "meridiem", getMeridiem = (T, S) => T ? S.getHours(T) >= 12 ? "pm" : "am" : null, convertValueToMeridiem = (T, S, R) => R && (T >= 12 ? "pm" : "am") !== S ? S === "am" ? T - 12 : T + 12 : T, convertToMeridiem = (T, S, R, k) => {
  const D = convertValueToMeridiem(k.getHours(T), S, R);
  return k.setHours(T, D);
}, getSecondsInDay = (T, S) => S.getHours(T) * 3600 + S.getMinutes(T) * 60 + S.getSeconds(T), createIsAfterIgnoreDatePart = (T, S) => (R, k) => T ? S.isAfter(R, k) : getSecondsInDay(R, S) > getSecondsInDay(k, S), resolveTimeFormat = (T, {
  format: S,
  views: R,
  ampm: k
}) => {
  if (S != null)
    return S;
  const D = T.formats;
  return areViewsEqual(R, ["hours"]) ? k ? `${D.hours12h} ${D.meridiem}` : D.hours24h : areViewsEqual(R, ["minutes"]) ? D.minutes : areViewsEqual(R, ["seconds"]) ? D.seconds : areViewsEqual(R, ["minutes", "seconds"]) ? `${D.minutes}:${D.seconds}` : areViewsEqual(R, ["hours", "minutes", "seconds"]) ? k ? `${D.hours12h}:${D.minutes}:${D.seconds} ${D.meridiem}` : `${D.hours24h}:${D.minutes}:${D.seconds}` : k ? `${D.hours12h}:${D.minutes} ${D.meridiem}` : `${D.hours24h}:${D.minutes}`;
};
var define_process_env_default$13 = {};
let warnedOnceNotValidView = !1;
function useViews({
  onChange: T,
  onViewChange: S,
  openTo: R,
  view: k,
  views: D,
  autoFocus: L,
  focusedView: V,
  onFocusedViewChange: z
}) {
  define_process_env_default$13.NODE_ENV !== "production" && (warnedOnceNotValidView || (k != null && !D.includes(k) && (console.warn(`MUI X: \`view="${k}"\` is not a valid prop.`, `It must be an element of \`views=["${D.join('", "')}"]\`.`), warnedOnceNotValidView = !0), k == null && R != null && !D.includes(R) && (console.warn(`MUI X: \`openTo="${R}"\` is not a valid prop.`, `It must be an element of \`views=["${D.join('", "')}"]\`.`), warnedOnceNotValidView = !0)));
  const W = React$1.useRef(R), U = React$1.useRef(D), q = React$1.useRef(D.includes(R) ? R : D[0]), [K, Y] = useControlled({
    name: "useViews",
    state: "view",
    controlled: k,
    default: q.current
  }), J = React$1.useRef(L ? K : null), [Z, X] = useControlled({
    name: "useViews",
    state: "focusedView",
    controlled: V,
    default: J.current
  });
  React$1.useEffect(() => {
    (W.current && W.current !== R || U.current && U.current.some((se) => !D.includes(se))) && (Y(D.includes(R) ? R : D[0]), U.current = D, W.current = R);
  }, [R, Y, K, D]);
  const ee = D.indexOf(K), te = D[ee - 1] ?? null, re = D[ee + 1] ?? null, Q = useEventCallback((se, ie) => {
    X(ie ? se : (he) => se === he ? null : he), z?.(se, ie);
  }), ne = useEventCallback((se) => {
    Q(se, !0), se !== K && (Y(se), S && S(se));
  }), oe = useEventCallback(() => {
    re && ne(re);
  }), ae = useEventCallback((se, ie, he) => {
    const xe = ie === "finish", Pe = he ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but when it's not the final view given all `views` -> overall selection state should be `partial`.
      D.indexOf(he) < D.length - 1
    ) : !!re;
    if (T(se, xe && Pe ? "partial" : ie, he), he && he !== K) {
      const ke = D[D.indexOf(he) + 1];
      ke && ne(ke);
    } else xe && oe();
  });
  return {
    view: K,
    setView: ne,
    focusedView: Z,
    setFocusedView: Q,
    nextView: re,
    previousView: te,
    // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
    defaultView: D.includes(R) ? R : D[0],
    goToNextView: oe,
    setValueAndGoToNextView: ae
  };
}
function useNextMonthDisabled(T, {
  disableFuture: S,
  maxDate: R,
  timezone: k
}) {
  const D = useUtils();
  return React$1.useMemo(() => {
    const L = D.date(void 0, k), V = D.startOfMonth(S && D.isBefore(L, R) ? L : R);
    return !D.isAfter(V, T);
  }, [S, R, T, D, k]);
}
function usePreviousMonthDisabled(T, {
  disablePast: S,
  minDate: R,
  timezone: k
}) {
  const D = useUtils();
  return React$1.useMemo(() => {
    const L = D.date(void 0, k), V = D.startOfMonth(S && D.isAfter(L, R) ? L : R);
    return !D.isBefore(V, T);
  }, [S, R, T, D, k]);
}
function useMeridiemMode(T, S, R, k) {
  const D = useUtils(), L = getMeridiem(T, D), V = React$1.useCallback((z) => {
    const W = T == null ? null : convertToMeridiem(T, z, !!S, D);
    R(W, k ?? "partial");
  }, [S, T, R, k, D]);
  return {
    meridiemMode: L,
    handleMeridiemChange: V
  };
}
const DAY_SIZE = 36, DAY_MARGIN = 2, DIALOG_WIDTH = 320, MAX_CALENDAR_HEIGHT = 280, VIEW_HEIGHT = 336, DIGITAL_CLOCK_VIEW_HEIGHT = 232, MULTI_SECTION_CLOCK_SECTION_WIDTH = 48, PickerViewRoot = styled("div")({
  overflow: "hidden",
  width: DIALOG_WIDTH,
  maxHeight: VIEW_HEIGHT,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
});
function getTimeClockUtilityClass(T) {
  return generateUtilityClass$1("MuiTimeClock", T);
}
generateUtilityClasses$1("MuiTimeClock", ["root", "arrowSwitcher"]);
const CLOCK_WIDTH = 220, CLOCK_HOUR_WIDTH = 36, clockCenter = {
  x: CLOCK_WIDTH / 2,
  y: CLOCK_WIDTH / 2
}, baseClockPoint = {
  x: clockCenter.x,
  y: 0
}, cx = baseClockPoint.x - clockCenter.x, cy = baseClockPoint.y - clockCenter.y, rad2deg = (T) => T * (180 / Math.PI), getAngleValue = (T, S, R) => {
  const k = S - clockCenter.x, D = R - clockCenter.y, L = Math.atan2(cx, cy) - Math.atan2(k, D);
  let V = rad2deg(L);
  V = Math.round(V / T) * T, V %= 360;
  const z = Math.floor(V / T) || 0, W = k ** 2 + D ** 2, U = Math.sqrt(W);
  return {
    value: z,
    distance: U
  };
}, getMinutes = (T, S, R = 1) => {
  const k = R * 6;
  let {
    value: D
  } = getAngleValue(k, T, S);
  return D = D * R % 60, D;
}, getHours = (T, S, R) => {
  const {
    value: k,
    distance: D
  } = getAngleValue(30, T, S);
  let L = k || 12;
  return R ? L %= 12 : D < CLOCK_WIDTH / 2 - CLOCK_HOUR_WIDTH && (L += 12, L %= 24), L;
};
function getClockPointerUtilityClass(T) {
  return generateUtilityClass$1("MuiClockPointer", T);
}
generateUtilityClasses$1("MuiClockPointer", ["root", "thumb"]);
const _excluded$19 = ["className", "hasSelected", "isInner", "type", "viewValue"], useUtilityClasses$W = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    thumb: ["thumb"]
  }, getClockPointerUtilityClass, S);
}, ClockPointerRoot = styled("div", {
  name: "MuiClockPointer",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})(({
  theme: T
}) => ({
  width: 2,
  backgroundColor: (T.vars || T).palette.primary.main,
  position: "absolute",
  left: "calc(50% - 1px)",
  bottom: "50%",
  transformOrigin: "center bottom 0px",
  variants: [{
    props: {
      shouldAnimate: !0
    },
    style: {
      transition: T.transitions.create(["transform", "height"])
    }
  }]
})), ClockPointerThumb = styled("div", {
  name: "MuiClockPointer",
  slot: "Thumb",
  overridesResolver: (T, S) => S.thumb
})(({
  theme: T
}) => ({
  width: 4,
  height: 4,
  backgroundColor: (T.vars || T).palette.primary.contrastText,
  borderRadius: "50%",
  position: "absolute",
  top: -21,
  left: `calc(50% - ${CLOCK_HOUR_WIDTH / 2}px)`,
  border: `${(CLOCK_HOUR_WIDTH - 4) / 2}px solid ${(T.vars || T).palette.primary.main}`,
  boxSizing: "content-box",
  variants: [{
    props: {
      hasSelected: !0
    },
    style: {
      backgroundColor: (T.vars || T).palette.primary.main
    }
  }]
}));
function ClockPointer(T) {
  const S = useThemeProps({
    props: T,
    name: "MuiClockPointer"
  }), {
    className: R,
    isInner: k,
    type: D,
    viewValue: L
  } = S, V = _objectWithoutPropertiesLoose$1(S, _excluded$19), z = React$1.useRef(D);
  React$1.useEffect(() => {
    z.current = D;
  }, [D]);
  const W = _extends$1({}, S, {
    shouldAnimate: z.current !== D
  }), U = useUtilityClasses$W(W), q = () => {
    let Y = 360 / (D === "hours" ? 12 : 60) * L;
    return D === "hours" && L > 12 && (Y -= 360), {
      height: Math.round((k ? 0.26 : 0.4) * CLOCK_WIDTH),
      transform: `rotateZ(${Y}deg)`
    };
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ClockPointerRoot, _extends$1({
    style: q(),
    className: clsx(R, U.root),
    ownerState: W
  }, V, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ClockPointerThumb, {
      ownerState: W,
      className: U.thumb
    })
  }));
}
function getClockUtilityClass(T) {
  return generateUtilityClass$1("MuiClock", T);
}
generateUtilityClasses$1("MuiClock", ["root", "clock", "wrapper", "squareMask", "pin", "amButton", "pmButton", "meridiemText"]);
const mergeDateAndTime = (T, S, R) => {
  let k = S;
  return k = T.setHours(k, T.getHours(R)), k = T.setMinutes(k, T.getMinutes(R)), k = T.setSeconds(k, T.getSeconds(R)), k;
}, findClosestEnabledDate = ({
  date: T,
  disableFuture: S,
  disablePast: R,
  maxDate: k,
  minDate: D,
  isDateDisabled: L,
  utils: V,
  timezone: z
}) => {
  const W = mergeDateAndTime(V, V.date(void 0, z), T);
  R && V.isBefore(D, W) && (D = W), S && V.isAfter(k, W) && (k = W);
  let U = T, q = T;
  for (V.isBefore(T, D) && (U = D, q = null), V.isAfter(T, k) && (q && (q = k), U = null); U || q; ) {
    if (U && V.isAfter(U, k) && (U = null), q && V.isBefore(q, D) && (q = null), U) {
      if (!L(U))
        return U;
      U = V.addDays(U, 1);
    }
    if (q) {
      if (!L(q))
        return q;
      q = V.addDays(q, -1);
    }
  }
  return null;
}, replaceInvalidDateByNull = (T, S) => S == null || !T.isValid(S) ? null : S, applyDefaultDate = (T, S, R) => S == null || !T.isValid(S) ? R : S, areDatesEqual = (T, S, R) => !T.isValid(S) && S != null && !T.isValid(R) && R != null ? !0 : T.isEqual(S, R), getMonthsInYear = (T, S) => {
  const k = [T.startOfYear(S)];
  for (; k.length < 12; ) {
    const D = k[k.length - 1];
    k.push(T.addMonths(D, 1));
  }
  return k;
}, getTodayDate = (T, S, R) => R === "date" ? T.startOfDay(T.date(void 0, S)) : T.date(void 0, S), formatMeridiem = (T, S) => {
  const R = T.setHours(T.date(), S === "am" ? 2 : 14);
  return T.format(R, "meridiem");
}, dateViews = ["year", "month", "day"], isDatePickerView = (T) => dateViews.includes(T), resolveDateFormat = (T, {
  format: S,
  views: R
}, k) => {
  if (S != null)
    return S;
  const D = T.formats;
  return areViewsEqual(R, ["year"]) ? D.year : areViewsEqual(R, ["month"]) ? D.month : areViewsEqual(R, ["day"]) ? D.dayOfMonth : areViewsEqual(R, ["month", "year"]) ? `${D.month} ${D.year}` : areViewsEqual(R, ["day", "month"]) ? `${D.month} ${D.dayOfMonth}` : k ? /en/.test(T.getCurrentLocaleCode()) ? D.normalDateWithWeekday : D.normalDate : D.keyboardDate;
}, getWeekdays = (T, S) => {
  const R = T.startOfWeek(S);
  return [0, 1, 2, 3, 4, 5, 6].map((k) => T.addDays(R, k));
}, useUtilityClasses$V = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    clock: ["clock"],
    wrapper: ["wrapper"],
    squareMask: ["squareMask"],
    pin: ["pin"],
    amButton: ["amButton"],
    pmButton: ["pmButton"],
    meridiemText: ["meridiemText"]
  }, getClockUtilityClass, S);
}, ClockRoot = styled("div", {
  name: "MuiClock",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})(({
  theme: T
}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: T.spacing(2)
})), ClockClock = styled("div", {
  name: "MuiClock",
  slot: "Clock",
  overridesResolver: (T, S) => S.clock
})({
  backgroundColor: "rgba(0,0,0,.07)",
  borderRadius: "50%",
  height: 220,
  width: 220,
  flexShrink: 0,
  position: "relative",
  pointerEvents: "none"
}), ClockWrapper = styled("div", {
  name: "MuiClock",
  slot: "Wrapper",
  overridesResolver: (T, S) => S.wrapper
})({
  "&:focus": {
    outline: "none"
  }
}), ClockSquareMask = styled("div", {
  name: "MuiClock",
  slot: "SquareMask",
  overridesResolver: (T, S) => S.squareMask
})({
  width: "100%",
  height: "100%",
  position: "absolute",
  pointerEvents: "auto",
  outline: 0,
  // Disable scroll capabilities.
  touchAction: "none",
  userSelect: "none",
  variants: [{
    props: {
      disabled: !1
    },
    style: {
      "@media (pointer: fine)": {
        cursor: "pointer",
        borderRadius: "50%"
      },
      "&:active": {
        cursor: "move"
      }
    }
  }]
}), ClockPin = styled("div", {
  name: "MuiClock",
  slot: "Pin",
  overridesResolver: (T, S) => S.pin
})(({
  theme: T
}) => ({
  width: 6,
  height: 6,
  borderRadius: "50%",
  backgroundColor: (T.vars || T).palette.primary.main,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
})), ClockAmButton = styled(IconButton, {
  name: "MuiClock",
  slot: "AmButton",
  overridesResolver: (T, S) => S.amButton
})(({
  theme: T
}) => ({
  zIndex: 1,
  position: "absolute",
  bottom: 8,
  left: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: CLOCK_HOUR_WIDTH,
  variants: [{
    props: {
      meridiemMode: "am"
    },
    style: {
      backgroundColor: (T.vars || T).palette.primary.main,
      color: (T.vars || T).palette.primary.contrastText,
      "&:hover": {
        backgroundColor: (T.vars || T).palette.primary.light
      }
    }
  }]
})), ClockPmButton = styled(IconButton, {
  name: "MuiClock",
  slot: "PmButton",
  overridesResolver: (T, S) => S.pmButton
})(({
  theme: T
}) => ({
  zIndex: 1,
  position: "absolute",
  bottom: 8,
  right: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: CLOCK_HOUR_WIDTH,
  variants: [{
    props: {
      meridiemMode: "pm"
    },
    style: {
      backgroundColor: (T.vars || T).palette.primary.main,
      color: (T.vars || T).palette.primary.contrastText,
      "&:hover": {
        backgroundColor: (T.vars || T).palette.primary.light
      }
    }
  }]
})), ClockMeridiemText = styled(Typography$2, {
  name: "MuiClock",
  slot: "meridiemText",
  overridesResolver: (T, S) => S.meridiemText
})({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
});
function Clock(T) {
  const S = useThemeProps({
    props: T,
    name: "MuiClock"
  }), {
    ampm: R,
    ampmInClock: k,
    autoFocus: D,
    children: L,
    value: V,
    handleMeridiemChange: z,
    isTimeDisabled: W,
    meridiemMode: U,
    minutesStep: q = 1,
    onChange: K,
    selectedId: Y,
    type: J,
    viewValue: Z,
    disabled: X = !1,
    readOnly: ee,
    className: te
  } = S, re = S, Q = useUtils(), ne = usePickersTranslations(), oe = React$1.useRef(!1), ae = useUtilityClasses$V(re), se = W(Z, J), ie = !R && J === "hours" && (Z < 1 || Z > 12), he = (pe, _e) => {
    X || ee || W(pe, J) || K(pe, _e);
  }, xe = (pe, _e) => {
    let {
      offsetX: ge,
      offsetY: Ae
    } = pe;
    if (ge === void 0) {
      const ve = pe.target.getBoundingClientRect();
      ge = pe.changedTouches[0].clientX - ve.left, Ae = pe.changedTouches[0].clientY - ve.top;
    }
    const Ee = J === "seconds" || J === "minutes" ? getMinutes(ge, Ae, q) : getHours(ge, Ae, !!R);
    he(Ee, _e);
  }, Pe = (pe) => {
    oe.current = !0, xe(pe, "shallow");
  }, Re = (pe) => {
    oe.current && (xe(pe, "finish"), oe.current = !1);
  }, ke = (pe) => {
    pe.buttons > 0 && xe(pe.nativeEvent, "shallow");
  }, Te = (pe) => {
    oe.current && (oe.current = !1), xe(pe.nativeEvent, "finish");
  }, fe = React$1.useMemo(() => J === "hours" ? !0 : Z % 5 === 0, [J, Z]), ue = J === "minutes" ? q : 1, Ce = React$1.useRef(null);
  useEnhancedEffect(() => {
    D && Ce.current.focus();
  }, [D]);
  const ce = (pe) => {
    if (!oe.current)
      switch (pe.key) {
        case "Home":
          he(0, "partial"), pe.preventDefault();
          break;
        case "End":
          he(J === "minutes" ? 59 : 23, "partial"), pe.preventDefault();
          break;
        case "ArrowUp":
          he(Z + ue, "partial"), pe.preventDefault();
          break;
        case "ArrowDown":
          he(Z - ue, "partial"), pe.preventDefault();
          break;
      }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ClockRoot, {
    className: clsx(te, ae.root),
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(ClockClock, {
      className: ae.clock,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ClockSquareMask, {
        onTouchMove: Pe,
        onTouchEnd: Re,
        onMouseUp: Te,
        onMouseMove: ke,
        ownerState: {
          disabled: X
        },
        className: ae.squareMask
      }), !se && /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ClockPin, {
          className: ae.pin
        }), V != null && /* @__PURE__ */ jsxRuntimeExports.jsx(ClockPointer, {
          type: J,
          viewValue: Z,
          isInner: ie,
          hasSelected: fe
        })]
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(ClockWrapper, {
        "aria-activedescendant": Y,
        "aria-label": ne.clockLabelText(J, V, Q),
        ref: Ce,
        role: "listbox",
        onKeyDown: ce,
        tabIndex: 0,
        className: ae.wrapper,
        children: L
      })]
    }), R && k && /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ClockAmButton, {
        onClick: ee ? void 0 : () => z("am"),
        disabled: X || U === null,
        ownerState: re,
        className: ae.amButton,
        title: formatMeridiem(Q, "am"),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ClockMeridiemText, {
          variant: "caption",
          className: ae.meridiemText,
          children: formatMeridiem(Q, "am")
        })
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(ClockPmButton, {
        disabled: X || U === null,
        onClick: ee ? void 0 : () => z("pm"),
        ownerState: re,
        className: ae.pmButton,
        title: formatMeridiem(Q, "pm"),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ClockMeridiemText, {
          variant: "caption",
          className: ae.meridiemText,
          children: formatMeridiem(Q, "pm")
        })
      })]
    })]
  });
}
function getClockNumberUtilityClass(T) {
  return generateUtilityClass$1("MuiClockNumber", T);
}
const clockNumberClasses = generateUtilityClasses$1("MuiClockNumber", ["root", "selected", "disabled"]), _excluded$18 = ["className", "disabled", "index", "inner", "label", "selected"], useUtilityClasses$U = (T) => {
  const {
    classes: S,
    selected: R,
    disabled: k
  } = T;
  return composeClasses({
    root: ["root", R && "selected", k && "disabled"]
  }, getClockNumberUtilityClass, S);
}, ClockNumberRoot = styled("span", {
  name: "MuiClockNumber",
  slot: "Root",
  overridesResolver: (T, S) => [S.root, {
    [`&.${clockNumberClasses.disabled}`]: S.disabled
  }, {
    [`&.${clockNumberClasses.selected}`]: S.selected
  }]
})(({
  theme: T
}) => ({
  height: CLOCK_HOUR_WIDTH,
  width: CLOCK_HOUR_WIDTH,
  position: "absolute",
  left: `calc((100% - ${CLOCK_HOUR_WIDTH}px) / 2)`,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  color: (T.vars || T).palette.text.primary,
  fontFamily: T.typography.fontFamily,
  "&:focused": {
    backgroundColor: (T.vars || T).palette.background.paper
  },
  [`&.${clockNumberClasses.selected}`]: {
    color: (T.vars || T).palette.primary.contrastText
  },
  [`&.${clockNumberClasses.disabled}`]: {
    pointerEvents: "none",
    color: (T.vars || T).palette.text.disabled
  },
  variants: [{
    props: {
      inner: !0
    },
    style: _extends$1({}, T.typography.body2, {
      color: (T.vars || T).palette.text.secondary
    })
  }]
}));
function ClockNumber(T) {
  const S = useThemeProps({
    props: T,
    name: "MuiClockNumber"
  }), {
    className: R,
    disabled: k,
    index: D,
    inner: L,
    label: V,
    selected: z
  } = S, W = _objectWithoutPropertiesLoose$1(S, _excluded$18), U = S, q = useUtilityClasses$U(U), K = D % 12 / 12 * Math.PI * 2 - Math.PI / 2, Y = (CLOCK_WIDTH - CLOCK_HOUR_WIDTH - 2) / 2 * (L ? 0.65 : 1), J = Math.round(Math.cos(K) * Y), Z = Math.round(Math.sin(K) * Y);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ClockNumberRoot, _extends$1({
    className: clsx(R, q.root),
    "aria-disabled": k ? !0 : void 0,
    "aria-selected": z ? !0 : void 0,
    role: "option",
    style: {
      transform: `translate(${J}px, ${Z + (CLOCK_WIDTH - CLOCK_HOUR_WIDTH) / 2}px`
    },
    ownerState: U
  }, W, {
    children: V
  }));
}
const getHourNumbers = ({
  ampm: T,
  value: S,
  getClockNumberText: R,
  isDisabled: k,
  selectedId: D,
  utils: L
}) => {
  const V = S ? L.getHours(S) : null, z = [], W = T ? 1 : 0, U = T ? 12 : 23, q = (K) => V === null ? !1 : T ? K === 12 ? V === 12 || V === 0 : V === K || V - 12 === K : V === K;
  for (let K = W; K <= U; K += 1) {
    let Y = K.toString();
    K === 0 && (Y = "00");
    const J = !T && (K === 0 || K > 12);
    Y = L.formatNumber(Y);
    const Z = q(K);
    z.push(/* @__PURE__ */ jsxRuntimeExports.jsx(ClockNumber, {
      id: Z ? D : void 0,
      index: K,
      inner: J,
      selected: Z,
      disabled: k(K),
      label: Y,
      "aria-label": R(Y)
    }, K));
  }
  return z;
}, getMinutesNumbers = ({
  utils: T,
  value: S,
  isDisabled: R,
  getClockNumberText: k,
  selectedId: D
}) => {
  const L = T.formatNumber;
  return [[5, L("05")], [10, L("10")], [15, L("15")], [20, L("20")], [25, L("25")], [30, L("30")], [35, L("35")], [40, L("40")], [45, L("45")], [50, L("50")], [55, L("55")], [0, L("00")]].map(([V, z], W) => {
    const U = V === S;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ClockNumber, {
      label: z,
      id: U ? D : void 0,
      index: W + 1,
      inner: !1,
      disabled: R(V),
      selected: U,
      "aria-label": k(z)
    }, V);
  });
}, useValueWithTimezone = ({
  timezone: T,
  value: S,
  defaultValue: R,
  onChange: k,
  valueManager: D
}) => {
  const L = useUtils(), V = React$1.useRef(R), z = S ?? V.current ?? D.emptyValue, W = React$1.useMemo(() => D.getTimezone(L, z), [L, D, z]), U = useEventCallback((J) => W == null ? J : D.setTimezone(L, W, J)), q = T ?? W ?? "default", K = React$1.useMemo(() => D.setTimezone(L, q, z), [D, L, q, z]), Y = useEventCallback((J, ...Z) => {
    const X = U(J);
    k?.(X, ...Z);
  });
  return {
    value: K,
    handleValueChange: Y,
    timezone: q
  };
}, useControlledValueWithTimezone = ({
  name: T,
  timezone: S,
  value: R,
  defaultValue: k,
  onChange: D,
  valueManager: L
}) => {
  const [V, z] = useControlled({
    name: T,
    state: "value",
    controlled: R,
    default: k ?? L.emptyValue
  }), W = useEventCallback((U, ...q) => {
    z(U), D?.(U, ...q);
  });
  return useValueWithTimezone({
    timezone: S,
    value: V,
    defaultValue: void 0,
    onChange: W,
    valueManager: L
  });
}, SECTION_TYPE_GRANULARITY = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, getSectionTypeGranularity = (T) => Math.max(...T.map((S) => SECTION_TYPE_GRANULARITY[S.type] ?? 1)), roundDate = (T, S, R) => {
  if (S === SECTION_TYPE_GRANULARITY.year)
    return T.startOfYear(R);
  if (S === SECTION_TYPE_GRANULARITY.month)
    return T.startOfMonth(R);
  if (S === SECTION_TYPE_GRANULARITY.day)
    return T.startOfDay(R);
  let k = R;
  return S < SECTION_TYPE_GRANULARITY.minutes && (k = T.setMinutes(k, 0)), S < SECTION_TYPE_GRANULARITY.seconds && (k = T.setSeconds(k, 0)), S < SECTION_TYPE_GRANULARITY.milliseconds && (k = T.setMilliseconds(k, 0)), k;
}, getDefaultReferenceDate = ({
  props: T,
  utils: S,
  granularity: R,
  timezone: k,
  getTodayDate: D
}) => {
  let L = D ? D() : roundDate(S, R, getTodayDate(S, k));
  T.minDate != null && S.isAfterDay(T.minDate, L) && (L = roundDate(S, R, T.minDate)), T.maxDate != null && S.isBeforeDay(T.maxDate, L) && (L = roundDate(S, R, T.maxDate));
  const V = createIsAfterIgnoreDatePart(T.disableIgnoringDatePartForTimeValidation ?? !1, S);
  return T.minTime != null && V(T.minTime, L) && (L = roundDate(S, R, T.disableIgnoringDatePartForTimeValidation ? T.minTime : mergeDateAndTime(S, L, T.minTime))), T.maxTime != null && V(L, T.maxTime) && (L = roundDate(S, R, T.disableIgnoringDatePartForTimeValidation ? T.maxTime : mergeDateAndTime(S, L, T.maxTime))), L;
};
var define_process_env_default$12 = {};
const getDateSectionConfigFromFormatToken = (T, S) => {
  const R = T.formatTokenMap[S];
  if (R == null)
    throw new Error([`MUI X: The token "${S}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof R == "string" ? {
    type: R,
    contentType: R === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: R.sectionType,
    contentType: R.contentType,
    maxLength: R.maxLength
  };
}, getDeltaFromKeyCode = (T) => {
  switch (T) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, getDaysInWeekStr = (T, S, R) => {
  const k = [], D = T.date(void 0, S), L = T.startOfWeek(D), V = T.endOfWeek(D);
  let z = L;
  for (; T.isBefore(z, V); )
    k.push(z), z = T.addDays(z, 1);
  return k.map((W) => T.formatByString(W, R));
}, getLetterEditingOptions = (T, S, R, k) => {
  switch (R) {
    case "month":
      return getMonthsInYear(T, T.date(void 0, S)).map((D) => T.formatByString(D, k));
    case "weekDay":
      return getDaysInWeekStr(T, S, k);
    case "meridiem": {
      const D = T.date(void 0, S);
      return [T.startOfDay(D), T.endOfDay(D)].map((L) => T.formatByString(L, k));
    }
    default:
      return [];
  }
}, FORMAT_SECONDS_NO_LEADING_ZEROS = "s", NON_LOCALIZED_DIGITS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], getLocalizedDigits = (T) => {
  const S = T.date(void 0);
  return T.formatByString(T.setSeconds(S, 0), FORMAT_SECONDS_NO_LEADING_ZEROS) === "0" ? NON_LOCALIZED_DIGITS : Array.from({
    length: 10
  }).map((k, D) => T.formatByString(T.setSeconds(S, D), FORMAT_SECONDS_NO_LEADING_ZEROS));
}, removeLocalizedDigits = (T, S) => {
  if (S[0] === "0")
    return T;
  const R = [];
  let k = "";
  for (let D = 0; D < T.length; D += 1) {
    k += T[D];
    const L = S.indexOf(k);
    L > -1 && (R.push(L.toString()), k = "");
  }
  return R.join("");
}, applyLocalizedDigits = (T, S) => S[0] === "0" ? T : T.split("").map((R) => S[Number(R)]).join(""), isStringNumber = (T, S) => {
  const R = removeLocalizedDigits(T, S);
  return R !== " " && !Number.isNaN(Number(R));
}, cleanLeadingZeros = (T, S) => {
  let R = T;
  for (R = Number(R).toString(); R.length < S; )
    R = `0${R}`;
  return R;
}, cleanDigitSectionValue = (T, S, R, k, D) => {
  if (define_process_env_default$12.NODE_ENV !== "production" && D.type !== "day" && D.contentType === "digit-with-letter")
    throw new Error([`MUI X: The token "${D.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (D.type === "day" && D.contentType === "digit-with-letter") {
    const V = T.setDate(R.longestMonth, S);
    return T.formatByString(V, D.format);
  }
  let L = S.toString();
  return D.hasLeadingZerosInInput && (L = cleanLeadingZeros(L, D.maxLength)), applyLocalizedDigits(L, k);
}, adjustSectionValue = (T, S, R, k, D, L, V, z) => {
  const W = getDeltaFromKeyCode(k), U = k === "Home", q = k === "End", K = R.value === "" || U || q, Y = () => {
    const Z = D[R.type]({
      currentDate: V,
      format: R.format,
      contentType: R.contentType
    }), X = (Q) => cleanDigitSectionValue(T, Q, Z, L, R), ee = R.type === "minutes" && z?.minutesStep ? z.minutesStep : 1;
    let re = parseInt(removeLocalizedDigits(R.value, L), 10) + W * ee;
    if (K) {
      if (R.type === "year" && !q && !U)
        return T.formatByString(T.date(void 0, S), R.format);
      W > 0 || U ? re = Z.minimum : re = Z.maximum;
    }
    return re % ee !== 0 && ((W < 0 || U) && (re += ee - (ee + re) % ee), (W > 0 || q) && (re -= re % ee)), re > Z.maximum ? X(Z.minimum + (re - Z.maximum - 1) % (Z.maximum - Z.minimum + 1)) : re < Z.minimum ? X(Z.maximum - (Z.minimum - re - 1) % (Z.maximum - Z.minimum + 1)) : X(re);
  }, J = () => {
    const Z = getLetterEditingOptions(T, S, R.type, R.format);
    if (Z.length === 0)
      return R.value;
    if (K)
      return W > 0 || U ? Z[0] : Z[Z.length - 1];
    const te = ((Z.indexOf(R.value) + W) % Z.length + Z.length) % Z.length;
    return Z[te];
  };
  return R.contentType === "digit" || R.contentType === "digit-with-letter" ? Y() : J();
}, getSectionVisibleValue = (T, S, R) => {
  let k = T.value || T.placeholder;
  const D = S === "non-input" ? T.hasLeadingZerosInFormat : T.hasLeadingZerosInInput;
  return S === "non-input" && T.hasLeadingZerosInInput && !T.hasLeadingZerosInFormat && (k = Number(removeLocalizedDigits(k, R)).toString()), ["input-rtl", "input-ltr"].includes(S) && T.contentType === "digit" && !D && k.length === 1 && (k = `${k}‎`), S === "input-rtl" && (k = `⁨${k}⁩`), k;
}, changeSectionValueFormat = (T, S, R, k) => {
  if (define_process_env_default$12.NODE_ENV !== "production" && getDateSectionConfigFromFormatToken(T, R).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return T.formatByString(T.parse(S, R), k);
}, isFourDigitYearFormat = (T, S, R) => T.formatByString(T.date(void 0, S), R).length === 4, doesSectionFormatHaveLeadingZeros = (T, S, R, k, D) => {
  if (R !== "digit")
    return !1;
  const L = T.date(void 0, S);
  switch (k) {
    case "year":
      return isFourDigitYearFormat(T, S, D) ? T.formatByString(T.setYear(L, 1), D) === "0001" : T.formatByString(T.setYear(L, 2001), D) === "01";
    case "month":
      return T.formatByString(T.startOfYear(L), D).length > 1;
    case "day":
      return T.formatByString(T.startOfMonth(L), D).length > 1;
    case "weekDay":
      return T.formatByString(T.startOfWeek(L), D).length > 1;
    case "hours":
      return T.formatByString(T.setHours(L, 1), D).length > 1;
    case "minutes":
      return T.formatByString(T.setMinutes(L, 1), D).length > 1;
    case "seconds":
      return T.formatByString(T.setSeconds(L, 1), D).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, getDateFromDateSections = (T, S, R) => {
  const k = S.some((W) => W.type === "day"), D = [], L = [];
  for (let W = 0; W < S.length; W += 1) {
    const U = S[W];
    k && U.type === "weekDay" || (D.push(U.format), L.push(getSectionVisibleValue(U, "non-input", R)));
  }
  const V = D.join(" "), z = L.join(" ");
  return T.parse(z, V);
}, createDateStrForV7HiddenInputFromSections = (T) => T.map((S) => `${S.startSeparator}${S.value || S.placeholder}${S.endSeparator}`).join(""), createDateStrForV6InputFromSections = (T, S, R) => {
  const D = T.map((L) => {
    const V = getSectionVisibleValue(L, R ? "input-rtl" : "input-ltr", S);
    return `${L.startSeparator}${V}${L.endSeparator}`;
  }).join("");
  return R ? `⁦${D}⁩` : D;
}, getSectionsBoundaries = (T, S, R) => {
  const k = T.date(void 0, R), D = T.endOfYear(k), L = T.endOfDay(k), {
    maxDaysInMonth: V,
    longestMonth: z
  } = getMonthsInYear(T, k).reduce((W, U) => {
    const q = T.getDaysInMonth(U);
    return q > W.maxDaysInMonth ? {
      maxDaysInMonth: q,
      longestMonth: U
    } : W;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: W
    }) => ({
      minimum: 0,
      maximum: isFourDigitYearFormat(T, R, W) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: T.getMonth(D) + 1
    }),
    day: ({
      currentDate: W
    }) => ({
      minimum: 1,
      maximum: W != null && T.isValid(W) ? T.getDaysInMonth(W) : V,
      longestMonth: z
    }),
    weekDay: ({
      format: W,
      contentType: U
    }) => {
      if (U === "digit") {
        const q = getDaysInWeekStr(T, R, W).map(Number);
        return {
          minimum: Math.min(...q),
          maximum: Math.max(...q)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: W
    }) => {
      const U = T.getHours(L);
      return removeLocalizedDigits(T.formatByString(T.endOfDay(k), W), S) !== U.toString() ? {
        minimum: 1,
        maximum: Number(removeLocalizedDigits(T.formatByString(T.startOfDay(k), W), S))
      } : {
        minimum: 0,
        maximum: U
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: T.getMinutes(L)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: T.getSeconds(L)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 1
    }),
    empty: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let warnedOnceInvalidSection = !1;
const validateSections = (T, S) => {
  if (define_process_env_default$12.NODE_ENV !== "production" && !warnedOnceInvalidSection) {
    const R = ["empty"];
    ["date", "date-time"].includes(S) && R.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(S) && R.push("hours", "minutes", "seconds", "meridiem");
    const k = T.find((D) => !R.includes(D.type));
    k && (console.warn(`MUI X: The field component you are using is not compatible with the "${k.type}" date section.`, `The supported date sections are ["${R.join('", "')}"]\`.`), warnedOnceInvalidSection = !0);
  }
}, transferDateSectionValue = (T, S, R, k, D) => {
  switch (R.type) {
    case "year":
      return T.setYear(D, T.getYear(k));
    case "month":
      return T.setMonth(D, T.getMonth(k));
    case "weekDay": {
      const L = getDaysInWeekStr(T, S, R.format), V = T.formatByString(k, R.format), z = L.indexOf(V), U = L.indexOf(R.value) - z;
      return T.addDays(k, U);
    }
    case "day":
      return T.setDate(D, T.getDate(k));
    case "meridiem": {
      const L = T.getHours(k) < 12, V = T.getHours(D);
      return L && V >= 12 ? T.addHours(D, -12) : !L && V < 12 ? T.addHours(D, 12) : D;
    }
    case "hours":
      return T.setHours(D, T.getHours(k));
    case "minutes":
      return T.setMinutes(D, T.getMinutes(k));
    case "seconds":
      return T.setSeconds(D, T.getSeconds(k));
    default:
      return D;
  }
}, reliableSectionModificationOrder = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8,
  empty: 9
}, mergeDateIntoReferenceDate = (T, S, R, k, D, L) => (
  // cloning sections before sort to avoid mutating it
  [...k].sort((V, z) => reliableSectionModificationOrder[V.type] - reliableSectionModificationOrder[z.type]).reduce((V, z) => !L || z.modified ? transferDateSectionValue(T, S, z, R, V) : V, D)
), isAndroid = () => navigator.userAgent.toLowerCase().indexOf("android") > -1, getSectionOrder = (T, S) => {
  const R = {};
  if (!S)
    return T.forEach((W, U) => {
      const q = U === 0 ? null : U - 1, K = U === T.length - 1 ? null : U + 1;
      R[U] = {
        leftIndex: q,
        rightIndex: K
      };
    }), {
      neighbors: R,
      startIndex: 0,
      endIndex: T.length - 1
    };
  const k = {}, D = {};
  let L = 0, V = 0, z = T.length - 1;
  for (; z >= 0; ) {
    V = T.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (W, U) => U >= L && W.endSeparator?.includes(" ") && // Special case where the spaces were not there in the initial input
      W.endSeparator !== " / "
    ), V === -1 && (V = T.length - 1);
    for (let W = V; W >= L; W -= 1)
      D[W] = z, k[z] = W, z -= 1;
    L = V + 1;
  }
  return T.forEach((W, U) => {
    const q = D[U], K = q === 0 ? null : k[q - 1], Y = q === T.length - 1 ? null : k[q + 1];
    R[U] = {
      leftIndex: K,
      rightIndex: Y
    };
  }), {
    neighbors: R,
    startIndex: k[0],
    endIndex: k[T.length - 1]
  };
}, parseSelectedSections = (T, S) => T == null ? null : T === "all" ? "all" : typeof T == "string" ? S.findIndex((R) => R.type === T) : T, getSectionValueText = (T, S) => {
  if (T.value)
    switch (T.type) {
      case "month": {
        if (T.contentType === "digit")
          return S.format(S.setMonth(S.date(), Number(T.value) - 1), "month");
        const R = S.parse(T.value, T.format);
        return R ? S.format(R, "month") : void 0;
      }
      case "day":
        return T.contentType === "digit" ? S.format(S.setDate(S.startOfYear(S.date()), Number(T.value)), "dayOfMonthFull") : T.value;
      case "weekDay":
        return;
      default:
        return;
    }
}, getSectionValueNow = (T, S) => {
  if (T.value)
    switch (T.type) {
      case "weekDay":
        return T.contentType === "letter" ? void 0 : Number(T.value);
      case "meridiem": {
        const R = S.parse(`01:00 ${T.value}`, `${S.formats.hours12h}:${S.formats.minutes} ${T.format}`);
        return R ? S.getHours(R) >= 12 ? 1 : 0 : void 0;
      }
      case "day":
        return T.contentType === "digit-with-letter" ? parseInt(T.value, 10) : Number(T.value);
      case "month": {
        if (T.contentType === "digit")
          return Number(T.value);
        const R = S.parse(T.value, T.format);
        return R ? S.getMonth(R) + 1 : void 0;
      }
      default:
        return T.contentType !== "letter" ? Number(T.value) : void 0;
    }
}, _excluded$17 = ["value", "referenceDate"], singleItemValueManager = {
  emptyValue: null,
  getTodayValue: getTodayDate,
  getInitialReferenceValue: (T) => {
    let {
      value: S,
      referenceDate: R
    } = T, k = _objectWithoutPropertiesLoose$1(T, _excluded$17);
    return S != null && k.utils.isValid(S) ? S : R ?? getDefaultReferenceDate(k);
  },
  cleanValue: replaceInvalidDateByNull,
  areValuesEqual: areDatesEqual,
  isSameError: (T, S) => T === S,
  hasError: (T) => T != null,
  defaultErrorState: null,
  getTimezone: (T, S) => S == null || !T.isValid(S) ? null : T.getTimezone(S),
  setTimezone: (T, S, R) => R == null ? null : T.setTimezone(R, S)
}, singleItemFieldValueManager = {
  updateReferenceValue: (T, S, R) => S == null || !T.isValid(S) ? R : S,
  getSectionsFromValue: (T, S, R, k) => !T.isValid(S) && !!R ? R : k(S),
  getV7HiddenInputValueFromSections: createDateStrForV7HiddenInputFromSections,
  getV6InputValueFromSections: createDateStrForV6InputFromSections,
  getActiveDateManager: (T, S) => ({
    date: S.value,
    referenceDate: S.referenceValue,
    getSections: (R) => R,
    getNewValuesFromNewActiveDate: (R) => ({
      value: R,
      referenceValue: R == null || !T.isValid(R) ? S.referenceValue : R
    })
  }),
  parseValueStr: (T, S, R) => R(T.trim(), S)
}, useClockReferenceDate = ({
  value: T,
  referenceDate: S,
  utils: R,
  props: k,
  timezone: D
}) => {
  const L = React$1.useMemo(
    () => singleItemValueManager.getInitialReferenceValue({
      value: T,
      utils: R,
      props: k,
      referenceDate: S,
      granularity: SECTION_TYPE_GRANULARITY.day,
      timezone: D,
      getTodayDate: () => getTodayDate(R, D, "date")
    }),
    // We only want to compute the reference date on mount.
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  return T ?? L;
};
var define_process_env_default$11 = {};
const _excluded$16 = ["ampm", "ampmInClock", "autoFocus", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableTime", "showViewSwitcher", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "timezone"], useUtilityClasses$T = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    arrowSwitcher: ["arrowSwitcher"]
  }, getTimeClockUtilityClass, S);
}, TimeClockRoot = styled(PickerViewRoot, {
  name: "MuiTimeClock",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  display: "flex",
  flexDirection: "column",
  position: "relative"
}), TimeClockArrowSwitcher = styled(PickersArrowSwitcher, {
  name: "MuiTimeClock",
  slot: "ArrowSwitcher",
  overridesResolver: (T, S) => S.arrowSwitcher
})({
  position: "absolute",
  right: 12,
  top: 15
}), TIME_CLOCK_DEFAULT_VIEWS = ["hours", "minutes"], TimeClock = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useUtils(), D = useThemeProps({
    props: S,
    name: "MuiTimeClock"
  }), {
    ampm: L = k.is12HourCycleInCurrentLocale(),
    ampmInClock: V = !1,
    autoFocus: z,
    slots: W,
    slotProps: U,
    value: q,
    defaultValue: K,
    referenceDate: Y,
    disableIgnoringDatePartForTimeValidation: J = !1,
    maxTime: Z,
    minTime: X,
    disableFuture: ee,
    disablePast: te,
    minutesStep: re = 1,
    shouldDisableTime: Q,
    showViewSwitcher: ne,
    onChange: oe,
    view: ae,
    views: se = TIME_CLOCK_DEFAULT_VIEWS,
    openTo: ie,
    onViewChange: he,
    focusedView: xe,
    onFocusedViewChange: Pe,
    className: Re,
    disabled: ke,
    readOnly: Te,
    timezone: fe
  } = D, ue = _objectWithoutPropertiesLoose$1(D, _excluded$16), {
    value: Ce,
    handleValueChange: ce,
    timezone: pe
  } = useControlledValueWithTimezone({
    name: "TimeClock",
    timezone: fe,
    value: q,
    defaultValue: K,
    onChange: oe,
    valueManager: singleItemValueManager
  }), _e = useClockReferenceDate({
    value: Ce,
    referenceDate: Y,
    utils: k,
    props: D,
    timezone: pe
  }), ge = usePickersTranslations(), Ae = useNow(pe), {
    view: Ee,
    setView: ve,
    previousView: le,
    nextView: me,
    setValueAndGoToNextView: Se
  } = useViews({
    view: ae,
    views: se,
    openTo: ie,
    onViewChange: he,
    onChange: ce,
    focusedView: xe,
    onFocusedViewChange: Pe
  }), {
    meridiemMode: ye,
    handleMeridiemChange: be
  } = useMeridiemMode(_e, L, Se), $e = React$1.useCallback((De, Le) => {
    const ze = createIsAfterIgnoreDatePart(J, k), We = Le === "hours" || Le === "minutes" && se.includes("seconds"), Be = ({
      start: Ge,
      end: nt
    }) => !(X && ze(X, nt) || Z && ze(Ge, Z) || ee && ze(Ge, Ae) || te && ze(Ae, We ? nt : Ge)), Ye = (Ge, nt = 1) => {
      if (Ge % nt !== 0)
        return !1;
      if (Q)
        switch (Le) {
          case "hours":
            return !Q(k.setHours(_e, Ge), "hours");
          case "minutes":
            return !Q(k.setMinutes(_e, Ge), "minutes");
          case "seconds":
            return !Q(k.setSeconds(_e, Ge), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (Le) {
      case "hours": {
        const Ge = convertValueToMeridiem(De, ye, L), nt = k.setHours(_e, Ge), Ze = k.setSeconds(k.setMinutes(nt, 0), 0), Me = k.setSeconds(k.setMinutes(nt, 59), 59);
        return !Be({
          start: Ze,
          end: Me
        }) || !Ye(Ge);
      }
      case "minutes": {
        const Ge = k.setMinutes(_e, De), nt = k.setSeconds(Ge, 0), Ze = k.setSeconds(Ge, 59);
        return !Be({
          start: nt,
          end: Ze
        }) || !Ye(De, re);
      }
      case "seconds": {
        const Ge = k.setSeconds(_e, De);
        return !Be({
          start: Ge,
          end: Ge
        }) || !Ye(De);
      }
      default:
        throw new Error("not supported");
    }
  }, [L, _e, J, Z, ye, X, re, Q, k, ee, te, Ae, se]), Oe = useId(), Ie = React$1.useMemo(() => {
    switch (Ee) {
      case "hours": {
        const De = (Le, ze) => {
          const We = convertValueToMeridiem(Le, ye, L);
          Se(k.setHours(_e, We), ze, "hours");
        };
        return {
          onChange: De,
          viewValue: k.getHours(_e),
          children: getHourNumbers({
            value: Ce,
            utils: k,
            ampm: L,
            onChange: De,
            getClockNumberText: ge.hoursClockNumberText,
            isDisabled: (Le) => ke || $e(Le, "hours"),
            selectedId: Oe
          })
        };
      }
      case "minutes": {
        const De = k.getMinutes(_e), Le = (ze, We) => {
          Se(k.setMinutes(_e, ze), We, "minutes");
        };
        return {
          viewValue: De,
          onChange: Le,
          children: getMinutesNumbers({
            utils: k,
            value: De,
            onChange: Le,
            getClockNumberText: ge.minutesClockNumberText,
            isDisabled: (ze) => ke || $e(ze, "minutes"),
            selectedId: Oe
          })
        };
      }
      case "seconds": {
        const De = k.getSeconds(_e), Le = (ze, We) => {
          Se(k.setSeconds(_e, ze), We, "seconds");
        };
        return {
          viewValue: De,
          onChange: Le,
          children: getMinutesNumbers({
            utils: k,
            value: De,
            onChange: Le,
            getClockNumberText: ge.secondsClockNumberText,
            isDisabled: (ze) => ke || $e(ze, "seconds"),
            selectedId: Oe
          })
        };
      }
      default:
        throw new Error("You must provide the type for ClockView");
    }
  }, [Ee, k, Ce, L, ge.hoursClockNumberText, ge.minutesClockNumberText, ge.secondsClockNumberText, ye, Se, _e, $e, Oe, ke]), we = D, Fe = useUtilityClasses$T(we);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TimeClockRoot, _extends$1({
    ref: R,
    className: clsx(Fe.root, Re),
    ownerState: we
  }, ue, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Clock, _extends$1({
      autoFocus: z ?? !!xe,
      ampmInClock: V && se.includes("hours"),
      value: Ce,
      type: Ee,
      ampm: L,
      minutesStep: re,
      isTimeDisabled: $e,
      meridiemMode: ye,
      handleMeridiemChange: be,
      selectedId: Oe,
      disabled: ke,
      readOnly: Te
    }, Ie)), ne && /* @__PURE__ */ jsxRuntimeExports.jsx(TimeClockArrowSwitcher, {
      className: Fe.arrowSwitcher,
      slots: W,
      slotProps: U,
      onGoToPrevious: () => ve(le),
      isPreviousDisabled: !le,
      previousLabel: ge.openPreviousView,
      onGoToNext: () => ve(me),
      isNextDisabled: !me,
      nextLabel: ge.openNextView,
      ownerState: we
    })]
  }));
});
define_process_env_default$11.NODE_ENV !== "production" && (TimeClock.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: PropTypes.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */
  ampmInClock: PropTypes.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * Controlled focused view.
   */
  focusedView: PropTypes.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: PropTypes.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: PropTypes.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: PropTypes.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["hours", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: PropTypes.object,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: PropTypes.func,
  showViewSwitcher: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Available views.
   * @default ['hours', 'minutes']
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
var define_process_env_default$10 = {};
const ListContext = /* @__PURE__ */ React$1.createContext({});
define_process_env_default$10.NODE_ENV !== "production" && (ListContext.displayName = "ListContext");
const dividerClasses = generateUtilityClasses$1("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), listItemIconClasses = generateUtilityClasses$1("MuiListItemIcon", ["root", "alignItemsFlexStart"]), listItemTextClasses = generateUtilityClasses$1("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]);
function getMenuItemUtilityClass(T) {
  return generateUtilityClass$1("MuiMenuItem", T);
}
const menuItemClasses = generateUtilityClasses$1("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]);
var define_process_env_default$$ = {};
const _excluded$15 = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], overridesResolver$3 = (T, S) => {
  const {
    ownerState: R
  } = T;
  return [S.root, R.dense && S.dense, R.divider && S.divider, !R.disableGutters && S.gutters];
}, useUtilityClasses$S = (T) => {
  const {
    disabled: S,
    dense: R,
    divider: k,
    disableGutters: D,
    selected: L,
    classes: V
  } = T, W = composeClasses({
    root: ["root", R && "dense", S && "disabled", !D && "gutters", k && "divider", L && "selected"]
  }, getMenuItemUtilityClass, V);
  return _extends$1({}, V, W);
}, MenuItemRoot = styled(ButtonBase, {
  shouldForwardProp: (T) => rootShouldForwardProp(T) || T === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: overridesResolver$3
})(({
  theme: T,
  ownerState: S
}) => _extends$1({}, T.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !S.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, S.divider && {
  borderBottom: `1px solid ${(T.vars || T).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (T.vars || T).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${menuItemClasses.selected}`]: {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / ${T.vars.palette.action.selectedOpacity})` : alpha_1(T.palette.primary.main, T.palette.action.selectedOpacity),
    [`&.${menuItemClasses.focusVisible}`]: {
      backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / calc(${T.vars.palette.action.selectedOpacity} + ${T.vars.palette.action.focusOpacity}))` : alpha_1(T.palette.primary.main, T.palette.action.selectedOpacity + T.palette.action.focusOpacity)
    }
  },
  [`&.${menuItemClasses.selected}:hover`]: {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / calc(${T.vars.palette.action.selectedOpacity} + ${T.vars.palette.action.hoverOpacity}))` : alpha_1(T.palette.primary.main, T.palette.action.selectedOpacity + T.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / ${T.vars.palette.action.selectedOpacity})` : alpha_1(T.palette.primary.main, T.palette.action.selectedOpacity)
    }
  },
  [`&.${menuItemClasses.focusVisible}`]: {
    backgroundColor: (T.vars || T).palette.action.focus
  },
  [`&.${menuItemClasses.disabled}`]: {
    opacity: (T.vars || T).palette.action.disabledOpacity
  },
  [`& + .${dividerClasses.root}`]: {
    marginTop: T.spacing(1),
    marginBottom: T.spacing(1)
  },
  [`& + .${dividerClasses.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses.root}`]: {
    minWidth: 36
  }
}, !S.dense && {
  [T.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, S.dense && _extends$1({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, T.typography.body2, {
  [`& .${listItemIconClasses.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), MenuItem = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiMenuItem"
  }), {
    autoFocus: D = !1,
    component: L = "li",
    dense: V = !1,
    divider: z = !1,
    disableGutters: W = !1,
    focusVisibleClassName: U,
    role: q = "menuitem",
    tabIndex: K,
    className: Y
  } = k, J = _objectWithoutPropertiesLoose$1(k, _excluded$15), Z = React$1.useContext(ListContext), X = React$1.useMemo(() => ({
    dense: V || Z.dense || !1,
    disableGutters: W
  }), [Z.dense, V, W]), ee = React$1.useRef(null);
  useEnhancedEffect(() => {
    D && (ee.current ? ee.current.focus() : define_process_env_default$$.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [D]);
  const te = _extends$1({}, k, {
    dense: X.dense,
    divider: z,
    disableGutters: W
  }), re = useUtilityClasses$S(k), Q = useForkRef(ee, R);
  let ne;
  return k.disabled || (ne = K !== void 0 ? K : -1), /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: X,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItemRoot, _extends$1({
      ref: Q,
      role: q,
      tabIndex: ne,
      component: L,
      focusVisibleClassName: clsx(re.focusVisible, U),
      className: clsx(re.root, Y)
    }, J, {
      ownerState: te,
      classes: re
    }))
  });
});
define_process_env_default$$.NODE_ENV !== "production" && (MenuItem.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * @ignore
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  role: PropTypes.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number
});
function getListUtilityClass(T) {
  return generateUtilityClass$1("MuiList", T);
}
generateUtilityClasses$1("MuiList", ["root", "padding", "dense", "subheader"]);
var define_process_env_default$_ = {};
const _excluded$14 = ["children", "className", "component", "dense", "disablePadding", "subheader"], useUtilityClasses$R = (T) => {
  const {
    classes: S,
    disablePadding: R,
    dense: k,
    subheader: D
  } = T;
  return composeClasses({
    root: ["root", !R && "padding", k && "dense", D && "subheader"]
  }, getListUtilityClass, S);
}, ListRoot = styled("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.root, !R.disablePadding && S.padding, R.dense && S.dense, R.subheader && S.subheader];
  }
})(({
  ownerState: T
}) => _extends$1({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !T.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, T.subheader && {
  paddingTop: 0
})), List = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiList"
  }), {
    children: D,
    className: L,
    component: V = "ul",
    dense: z = !1,
    disablePadding: W = !1,
    subheader: U
  } = k, q = _objectWithoutPropertiesLoose$1(k, _excluded$14), K = React$1.useMemo(() => ({
    dense: z
  }), [z]), Y = _extends$1({}, k, {
    component: V,
    dense: z,
    disablePadding: W
  }), J = useUtilityClasses$R(Y);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: K,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListRoot, _extends$1({
      as: V,
      className: clsx(J.root, L),
      ref: R,
      ownerState: Y
    }, q, {
      children: [U, D]
    }))
  });
});
define_process_env_default$_.NODE_ENV !== "production" && (List.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
var define_process_env_default$Z = {};
const _excluded$13 = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function nextItem(T, S, R) {
  return T === S ? T.firstChild : S && S.nextElementSibling ? S.nextElementSibling : R ? null : T.firstChild;
}
function previousItem(T, S, R) {
  return T === S ? R ? T.firstChild : T.lastChild : S && S.previousElementSibling ? S.previousElementSibling : R ? null : T.lastChild;
}
function textCriteriaMatches(T, S) {
  if (S === void 0)
    return !0;
  let R = T.innerText;
  return R === void 0 && (R = T.textContent), R = R.trim().toLowerCase(), R.length === 0 ? !1 : S.repeating ? R[0] === S.keys[0] : R.indexOf(S.keys.join("")) === 0;
}
function moveFocus(T, S, R, k, D, L) {
  let V = !1, z = D(T, S, S ? R : !1);
  for (; z; ) {
    if (z === T.firstChild) {
      if (V)
        return !1;
      V = !0;
    }
    const W = k ? !1 : z.disabled || z.getAttribute("aria-disabled") === "true";
    if (!z.hasAttribute("tabindex") || !textCriteriaMatches(z, L) || W)
      z = D(T, z, R);
    else
      return z.focus(), !0;
  }
  return !1;
}
const MenuList = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: k,
    autoFocus: D = !1,
    autoFocusItem: L = !1,
    children: V,
    className: z,
    disabledItemsFocusable: W = !1,
    disableListWrap: U = !1,
    onKeyDown: q,
    variant: K = "selectedMenu"
  } = S, Y = _objectWithoutPropertiesLoose$1(S, _excluded$13), J = React$1.useRef(null), Z = React$1.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  useEnhancedEffect(() => {
    D && J.current.focus();
  }, [D]), React$1.useImperativeHandle(k, () => ({
    adjustStyleForScrollbar: (Q, {
      direction: ne
    }) => {
      const oe = !J.current.style.width;
      if (Q.clientHeight < J.current.clientHeight && oe) {
        const ae = `${getScrollbarSize(ownerDocument(Q))}px`;
        J.current.style[ne === "rtl" ? "paddingLeft" : "paddingRight"] = ae, J.current.style.width = `calc(100% + ${ae})`;
      }
      return J.current;
    }
  }), []);
  const X = (Q) => {
    const ne = J.current, oe = Q.key, ae = ownerDocument(ne).activeElement;
    if (oe === "ArrowDown")
      Q.preventDefault(), moveFocus(ne, ae, U, W, nextItem);
    else if (oe === "ArrowUp")
      Q.preventDefault(), moveFocus(ne, ae, U, W, previousItem);
    else if (oe === "Home")
      Q.preventDefault(), moveFocus(ne, null, U, W, nextItem);
    else if (oe === "End")
      Q.preventDefault(), moveFocus(ne, null, U, W, previousItem);
    else if (oe.length === 1) {
      const se = Z.current, ie = oe.toLowerCase(), he = performance.now();
      se.keys.length > 0 && (he - se.lastTime > 500 ? (se.keys = [], se.repeating = !0, se.previousKeyMatched = !0) : se.repeating && ie !== se.keys[0] && (se.repeating = !1)), se.lastTime = he, se.keys.push(ie);
      const xe = ae && !se.repeating && textCriteriaMatches(ae, se);
      se.previousKeyMatched && (xe || moveFocus(ne, ae, !1, W, nextItem, se)) ? Q.preventDefault() : se.previousKeyMatched = !1;
    }
    q && q(Q);
  }, ee = useForkRef(J, R);
  let te = -1;
  React$1.Children.forEach(V, (Q, ne) => {
    if (!/* @__PURE__ */ React$1.isValidElement(Q)) {
      te === ne && (te += 1, te >= V.length && (te = -1));
      return;
    }
    define_process_env_default$Z.NODE_ENV !== "production" && reactIsExports.isFragment(Q) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), Q.props.disabled || (K === "selectedMenu" && Q.props.selected || te === -1) && (te = ne), te === ne && (Q.props.disabled || Q.props.muiSkipListHighlight || Q.type.muiSkipListHighlight) && (te += 1, te >= V.length && (te = -1));
  });
  const re = React$1.Children.map(V, (Q, ne) => {
    if (ne === te) {
      const oe = {};
      return L && (oe.autoFocus = !0), Q.props.tabIndex === void 0 && K === "selectedMenu" && (oe.tabIndex = 0), /* @__PURE__ */ React$1.cloneElement(Q, oe);
    }
    return Q;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(List, _extends$1({
    role: "menu",
    ref: ee,
    className: z,
    onKeyDown: X,
    tabIndex: D ? 0 : -1
  }, Y, {
    children: re
  }));
});
define_process_env_default$Z.NODE_ENV !== "production" && (MenuList.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: PropTypes.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
function getDigitalClockUtilityClass(T) {
  return generateUtilityClass$1("MuiDigitalClock", T);
}
generateUtilityClasses$1("MuiDigitalClock", ["root", "list", "item"]);
var define_process_env_default$Y = {};
const _excluded$12 = ["ampm", "timeStep", "autoFocus", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableTime", "onChange", "view", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "views", "skipDisabled", "timezone"], useUtilityClasses$Q = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    list: ["list"],
    item: ["item"]
  }, getDigitalClockUtilityClass, S);
}, DigitalClockRoot = styled(PickerViewRoot, {
  name: "MuiDigitalClock",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  overflowY: "auto",
  width: "100%",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: "auto"
  },
  maxHeight: DIGITAL_CLOCK_VIEW_HEIGHT,
  variants: [{
    props: {
      alreadyRendered: !0
    },
    style: {
      "@media (prefers-reduced-motion: no-preference)": {
        scrollBehavior: "smooth"
      }
    }
  }]
}), DigitalClockList = styled(MenuList, {
  name: "MuiDigitalClock",
  slot: "List",
  overridesResolver: (T, S) => S.list
})({
  padding: 0
}), DigitalClockItem = styled(MenuItem, {
  name: "MuiDigitalClock",
  slot: "Item",
  overridesResolver: (T, S) => S.item
})(({
  theme: T
}) => ({
  padding: "8px 16px",
  margin: "2px 4px",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / ${T.vars.palette.action.hoverOpacity})` : alpha$1(T.palette.primary.main, T.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (T.vars || T).palette.primary.main,
    color: (T.vars || T).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (T.vars || T).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / ${T.vars.palette.action.focusOpacity})` : alpha$1(T.palette.primary.main, T.palette.action.focusOpacity)
  }
})), DigitalClock = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useUtils(), D = React$1.useRef(null), L = useForkRef(R, D), V = useThemeProps({
    props: S,
    name: "MuiDigitalClock"
  }), {
    ampm: z = k.is12HourCycleInCurrentLocale(),
    timeStep: W = 30,
    autoFocus: U,
    slots: q,
    slotProps: K,
    value: Y,
    defaultValue: J,
    referenceDate: Z,
    disableIgnoringDatePartForTimeValidation: X = !1,
    maxTime: ee,
    minTime: te,
    disableFuture: re,
    disablePast: Q,
    minutesStep: ne = 1,
    shouldDisableTime: oe,
    onChange: ae,
    view: se,
    openTo: ie,
    onViewChange: he,
    focusedView: xe,
    onFocusedViewChange: Pe,
    className: Re,
    disabled: ke,
    readOnly: Te,
    views: fe = ["hours"],
    skipDisabled: ue = !1,
    timezone: Ce
  } = V, ce = _objectWithoutPropertiesLoose$1(V, _excluded$12), {
    value: pe,
    handleValueChange: _e,
    timezone: ge
  } = useControlledValueWithTimezone({
    name: "DigitalClock",
    timezone: Ce,
    value: Y,
    defaultValue: J,
    onChange: ae,
    valueManager: singleItemValueManager
  }), Ae = usePickersTranslations(), Ee = useNow(ge), ve = React$1.useMemo(() => _extends$1({}, V, {
    alreadyRendered: !!D.current
  }), [V]), le = useUtilityClasses$Q(ve), me = q?.digitalClockItem ?? DigitalClockItem, Se = useSlotProps({
    elementType: me,
    externalSlotProps: K?.digitalClockItem,
    ownerState: {},
    className: le.item
  }), ye = useClockReferenceDate({
    value: pe,
    referenceDate: Z,
    utils: k,
    props: V,
    timezone: ge
  }), be = useEventCallback((De) => _e(De, "finish", "hours")), {
    setValueAndGoToNextView: $e
  } = useViews({
    view: se,
    views: fe,
    openTo: ie,
    onViewChange: he,
    onChange: be,
    focusedView: xe,
    onFocusedViewChange: Pe
  }), Oe = useEventCallback((De) => {
    $e(De, "finish");
  });
  React$1.useEffect(() => {
    if (D.current === null)
      return;
    const De = D.current.querySelector('[role="listbox"] [role="option"][tabindex="0"], [role="listbox"] [role="option"][aria-selected="true"]');
    if (!De)
      return;
    const Le = De.offsetTop;
    (U || xe) && De.focus(), D.current.scrollTop = Le - 4;
  });
  const Ie = React$1.useCallback((De) => {
    const Le = createIsAfterIgnoreDatePart(X, k), ze = () => !(te && Le(te, De) || ee && Le(De, ee) || re && Le(De, Ee) || Q && Le(Ee, De)), We = () => k.getMinutes(De) % ne !== 0 ? !1 : oe ? !oe(De, "hours") : !0;
    return !ze() || !We();
  }, [X, k, te, ee, re, Ee, Q, ne, oe]), we = React$1.useMemo(() => {
    const De = k.startOfDay(ye);
    return [De, ...Array.from({
      length: Math.ceil(24 * 60 / W) - 1
    }, (Le, ze) => k.addMinutes(De, W * (ze + 1)))];
  }, [ye, W, k]), Fe = we.findIndex((De) => k.isEqual(De, ye));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DigitalClockRoot, _extends$1({
    ref: L,
    className: clsx(le.root, Re),
    ownerState: ve
  }, ce, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(DigitalClockList, {
      role: "listbox",
      "aria-label": Ae.timePickerToolbarTitle,
      className: le.list,
      children: we.map((De, Le) => {
        if (ue && Ie(De))
          return null;
        const ze = k.isEqual(De, pe), We = k.format(De, z ? "fullTime12h" : "fullTime24h"), Be = Fe === Le || Fe === -1 && Le === 0 ? 0 : -1;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(me, _extends$1({
          onClick: () => !Te && Oe(De),
          selected: ze,
          disabled: ke || Ie(De),
          disableRipple: Te,
          role: "option",
          "aria-disabled": Te,
          "aria-selected": ze,
          tabIndex: Be
        }, Se, {
          children: We
        }), We);
      })
    })
  }));
});
define_process_env_default$Y.NODE_ENV !== "production" && (DigitalClock.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: PropTypes.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * Controlled focused view.
   */
  focusedView: PropTypes.oneOf(["hours"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: PropTypes.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: PropTypes.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: PropTypes.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["hours"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: PropTypes.object,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: PropTypes.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The time steps between two time options.
   * For example, if `timeStep = 45`, then the available time options will be `[00:00, 00:45, 01:30, 02:15, 03:00, etc.]`.
   * @default 30
   */
  timeStep: PropTypes.number,
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["hours"]),
  /**
   * Available views.
   * @default ['hours']
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["hours"]))
});
function getMultiSectionDigitalClockUtilityClass(T) {
  return generateUtilityClass$1("MuiMultiSectionDigitalClock", T);
}
generateUtilityClasses$1("MuiMultiSectionDigitalClock", ["root"]);
function getMultiSectionDigitalClockSectionUtilityClass(T) {
  return generateUtilityClass$1("MuiMultiSectionDigitalClockSection", T);
}
generateUtilityClasses$1("MuiMultiSectionDigitalClockSection", ["root", "item"]);
const _excluded$11 = ["autoFocus", "onChange", "className", "disabled", "readOnly", "items", "active", "slots", "slotProps", "skipDisabled"], useUtilityClasses$P = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    item: ["item"]
  }, getMultiSectionDigitalClockSectionUtilityClass, S);
}, MultiSectionDigitalClockSectionRoot = styled(MenuList, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})(({
  theme: T
}) => ({
  maxHeight: DIGITAL_CLOCK_VIEW_HEIGHT,
  width: 56,
  padding: 0,
  overflow: "hidden",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: "auto"
  },
  "@media (pointer: fine)": {
    "&:hover": {
      overflowY: "auto"
    }
  },
  "@media (pointer: none), (pointer: coarse)": {
    overflowY: "auto"
  },
  "&:not(:first-of-type)": {
    borderLeft: `1px solid ${(T.vars || T).palette.divider}`
  },
  "&::after": {
    display: "block",
    content: '""',
    // subtracting the height of one item, extra margin and borders to make sure the max height is correct
    height: "calc(100% - 40px - 6px)"
  },
  variants: [{
    props: {
      alreadyRendered: !0
    },
    style: {
      "@media (prefers-reduced-motion: no-preference)": {
        scrollBehavior: "smooth"
      }
    }
  }]
})), MultiSectionDigitalClockSectionItem = styled(MenuItem, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Item",
  overridesResolver: (T, S) => S.item
})(({
  theme: T
}) => ({
  padding: 8,
  margin: "2px 4px",
  width: MULTI_SECTION_CLOCK_SECTION_WIDTH,
  justifyContent: "center",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / ${T.vars.palette.action.hoverOpacity})` : alpha$1(T.palette.primary.main, T.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (T.vars || T).palette.primary.main,
    color: (T.vars || T).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (T.vars || T).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / ${T.vars.palette.action.focusOpacity})` : alpha$1(T.palette.primary.main, T.palette.action.focusOpacity)
  }
})), MultiSectionDigitalClockSection = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = React$1.useRef(null), D = useForkRef(R, k), L = React$1.useRef(null), V = useThemeProps({
    props: S,
    name: "MuiMultiSectionDigitalClockSection"
  }), {
    autoFocus: z,
    onChange: W,
    className: U,
    disabled: q,
    readOnly: K,
    items: Y,
    active: J,
    slots: Z,
    slotProps: X,
    skipDisabled: ee
  } = V, te = _objectWithoutPropertiesLoose$1(V, _excluded$11), re = React$1.useMemo(() => _extends$1({}, V, {
    alreadyRendered: !!k.current
  }), [V]), Q = useUtilityClasses$P(re), ne = Z?.digitalClockSectionItem ?? MultiSectionDigitalClockSectionItem;
  React$1.useEffect(() => {
    if (k.current === null)
      return;
    const ae = k.current.querySelector('[role="option"][tabindex="0"], [role="option"][aria-selected="true"]');
    if (J && z && ae && ae.focus(), !ae || L.current === ae)
      return;
    L.current = ae;
    const se = ae.offsetTop;
    k.current.scrollTop = se - 4;
  });
  const oe = Y.findIndex((ae) => ae.isFocused(ae.value));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MultiSectionDigitalClockSectionRoot, _extends$1({
    ref: D,
    className: clsx(Q.root, U),
    ownerState: re,
    autoFocusItem: z && J,
    role: "listbox"
  }, te, {
    children: Y.map((ae, se) => {
      const ie = ae.isDisabled?.(ae.value), he = q || ie;
      if (ee && he)
        return null;
      const xe = ae.isSelected(ae.value), Pe = oe === se || oe === -1 && se === 0 ? 0 : -1;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ne, _extends$1({
        onClick: () => !K && W(ae.value),
        selected: xe,
        disabled: he,
        disableRipple: K,
        role: "option",
        "aria-disabled": K || he || void 0,
        "aria-label": ae.ariaLabel,
        "aria-selected": xe,
        tabIndex: Pe,
        className: Q.item
      }, X?.digitalClockSectionItem, {
        children: ae.label
      }), ae.label);
    })
  }));
}), getHourSectionOptions = ({
  now: T,
  value: S,
  utils: R,
  ampm: k,
  isDisabled: D,
  resolveAriaLabel: L,
  timeStep: V,
  valueOrReferenceDate: z
}) => {
  const W = S ? R.getHours(S) : null, U = [], q = (J, Z) => {
    const X = Z ?? W;
    return X === null ? !1 : k ? J === 12 ? X === 12 || X === 0 : X === J || X - 12 === J : X === J;
  }, K = (J) => q(J, R.getHours(z)), Y = k ? 11 : 23;
  for (let J = 0; J <= Y; J += V) {
    let Z = R.format(R.setHours(T, J), k ? "hours12h" : "hours24h");
    const X = L(parseInt(Z, 10).toString());
    Z = R.formatNumber(Z), U.push({
      value: J,
      label: Z,
      isSelected: q,
      isDisabled: D,
      isFocused: K,
      ariaLabel: X
    });
  }
  return U;
}, getTimeSectionOptions = ({
  value: T,
  utils: S,
  isDisabled: R,
  timeStep: k,
  resolveLabel: D,
  resolveAriaLabel: L,
  hasValue: V = !0
}) => {
  const z = (U) => T === null ? !1 : V && T === U, W = (U) => T === U;
  return [...Array.from({
    length: Math.ceil(60 / k)
  }, (U, q) => {
    const K = k * q;
    return {
      value: K,
      label: S.formatNumber(D(K)),
      isDisabled: R,
      isSelected: z,
      isFocused: W,
      ariaLabel: L(K.toString())
    };
  })];
};
var define_process_env_default$X = {};
const _excluded$10 = ["ampm", "timeSteps", "autoFocus", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableTime", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "skipDisabled", "timezone"], useUtilityClasses$O = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"]
  }, getMultiSectionDigitalClockUtilityClass, S);
}, MultiSectionDigitalClockRoot = styled(PickerViewRoot, {
  name: "MuiMultiSectionDigitalClock",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})(({
  theme: T
}) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  borderBottom: `1px solid ${(T.vars || T).palette.divider}`
})), MultiSectionDigitalClock = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useUtils(), D = useRtl(), L = useThemeProps({
    props: S,
    name: "MuiMultiSectionDigitalClock"
  }), {
    ampm: V = k.is12HourCycleInCurrentLocale(),
    timeSteps: z,
    autoFocus: W,
    slots: U,
    slotProps: q,
    value: K,
    defaultValue: Y,
    referenceDate: J,
    disableIgnoringDatePartForTimeValidation: Z = !1,
    maxTime: X,
    minTime: ee,
    disableFuture: te,
    disablePast: re,
    minutesStep: Q = 1,
    shouldDisableTime: ne,
    onChange: oe,
    view: ae,
    views: se = ["hours", "minutes"],
    openTo: ie,
    onViewChange: he,
    focusedView: xe,
    onFocusedViewChange: Pe,
    className: Re,
    disabled: ke,
    readOnly: Te,
    skipDisabled: fe = !1,
    timezone: ue
  } = L, Ce = _objectWithoutPropertiesLoose$1(L, _excluded$10), {
    value: ce,
    handleValueChange: pe,
    timezone: _e
  } = useControlledValueWithTimezone({
    name: "MultiSectionDigitalClock",
    timezone: ue,
    value: K,
    defaultValue: Y,
    onChange: oe,
    valueManager: singleItemValueManager
  }), ge = usePickersTranslations(), Ae = useNow(_e), Ee = React$1.useMemo(() => _extends$1({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, z), [z]), ve = useClockReferenceDate({
    value: ce,
    referenceDate: J,
    utils: k,
    props: L,
    timezone: _e
  }), le = useEventCallback((Be, Ye, Ge) => pe(Be, Ye, Ge)), me = React$1.useMemo(() => !V || !se.includes("hours") || se.includes("meridiem") ? se : [...se, "meridiem"], [V, se]), {
    view: Se,
    setValueAndGoToNextView: ye,
    focusedView: be
  } = useViews({
    view: ae,
    views: me,
    openTo: ie,
    onViewChange: he,
    onChange: le,
    focusedView: xe,
    onFocusedViewChange: Pe
  }), $e = useEventCallback((Be) => {
    ye(Be, "finish", "meridiem");
  }), {
    meridiemMode: Oe,
    handleMeridiemChange: Ie
  } = useMeridiemMode(ve, V, $e, "finish"), we = React$1.useCallback((Be, Ye) => {
    const Ge = createIsAfterIgnoreDatePart(Z, k), nt = Ye === "hours" || Ye === "minutes" && me.includes("seconds"), Ze = ({
      start: Ne,
      end: He
    }) => !(ee && Ge(ee, He) || X && Ge(Ne, X) || te && Ge(Ne, Ae) || re && Ge(Ae, nt ? He : Ne)), Me = (Ne, He = 1) => {
      if (Ne % He !== 0)
        return !1;
      if (ne)
        switch (Ye) {
          case "hours":
            return !ne(k.setHours(ve, Ne), "hours");
          case "minutes":
            return !ne(k.setMinutes(ve, Ne), "minutes");
          case "seconds":
            return !ne(k.setSeconds(ve, Ne), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (Ye) {
      case "hours": {
        const Ne = convertValueToMeridiem(Be, Oe, V), He = k.setHours(ve, Ne), qe = k.setSeconds(k.setMinutes(He, 0), 0), Ke = k.setSeconds(k.setMinutes(He, 59), 59);
        return !Ze({
          start: qe,
          end: Ke
        }) || !Me(Ne);
      }
      case "minutes": {
        const Ne = k.setMinutes(ve, Be), He = k.setSeconds(Ne, 0), qe = k.setSeconds(Ne, 59);
        return !Ze({
          start: He,
          end: qe
        }) || !Me(Be, Q);
      }
      case "seconds": {
        const Ne = k.setSeconds(ve, Be);
        return !Ze({
          start: Ne,
          end: Ne
        }) || !Me(Be);
      }
      default:
        throw new Error("not supported");
    }
  }, [V, ve, Z, X, Oe, ee, Q, ne, k, te, re, Ae, me]), Fe = React$1.useCallback((Be) => {
    switch (Be) {
      case "hours":
        return {
          onChange: (Ye) => {
            const Ge = convertValueToMeridiem(Ye, Oe, V);
            ye(k.setHours(ve, Ge), "finish", "hours");
          },
          items: getHourSectionOptions({
            now: Ae,
            value: ce,
            ampm: V,
            utils: k,
            isDisabled: (Ye) => we(Ye, "hours"),
            timeStep: Ee.hours,
            resolveAriaLabel: ge.hoursClockNumberText,
            valueOrReferenceDate: ve
          })
        };
      case "minutes":
        return {
          onChange: (Ye) => {
            ye(k.setMinutes(ve, Ye), "finish", "minutes");
          },
          items: getTimeSectionOptions({
            value: k.getMinutes(ve),
            utils: k,
            isDisabled: (Ye) => we(Ye, "minutes"),
            resolveLabel: (Ye) => k.format(k.setMinutes(Ae, Ye), "minutes"),
            timeStep: Ee.minutes,
            hasValue: !!ce,
            resolveAriaLabel: ge.minutesClockNumberText
          })
        };
      case "seconds":
        return {
          onChange: (Ye) => {
            ye(k.setSeconds(ve, Ye), "finish", "seconds");
          },
          items: getTimeSectionOptions({
            value: k.getSeconds(ve),
            utils: k,
            isDisabled: (Ye) => we(Ye, "seconds"),
            resolveLabel: (Ye) => k.format(k.setSeconds(Ae, Ye), "seconds"),
            timeStep: Ee.seconds,
            hasValue: !!ce,
            resolveAriaLabel: ge.secondsClockNumberText
          })
        };
      case "meridiem": {
        const Ye = formatMeridiem(k, "am"), Ge = formatMeridiem(k, "pm");
        return {
          onChange: Ie,
          items: [{
            value: "am",
            label: Ye,
            isSelected: () => !!ce && Oe === "am",
            isFocused: () => !!ve && Oe === "am",
            ariaLabel: Ye
          }, {
            value: "pm",
            label: Ge,
            isSelected: () => !!ce && Oe === "pm",
            isFocused: () => !!ve && Oe === "pm",
            ariaLabel: Ge
          }]
        };
      }
      default:
        throw new Error(`Unknown view: ${Be} found.`);
    }
  }, [Ae, ce, V, k, Ee.hours, Ee.minutes, Ee.seconds, ge.hoursClockNumberText, ge.minutesClockNumberText, ge.secondsClockNumberText, Oe, ye, ve, we, Ie]), De = React$1.useMemo(() => {
    if (!D)
      return me;
    const Ye = me.filter((Ge) => Ge !== "meridiem").toReversed();
    return me.includes("meridiem") && Ye.push("meridiem"), Ye;
  }, [D, me]), Le = React$1.useMemo(() => me.reduce((Be, Ye) => _extends$1({}, Be, {
    [Ye]: Fe(Ye)
  }), {}), [me, Fe]), ze = L, We = useUtilityClasses$O(ze);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MultiSectionDigitalClockRoot, _extends$1({
    ref: R,
    className: clsx(We.root, Re),
    ownerState: ze,
    role: "group"
  }, Ce, {
    children: De.map((Be) => /* @__PURE__ */ jsxRuntimeExports.jsx(MultiSectionDigitalClockSection, {
      items: Le[Be].items,
      onChange: Le[Be].onChange,
      active: Se === Be,
      autoFocus: W ?? be === Be,
      disabled: ke,
      readOnly: Te,
      slots: U,
      slotProps: q,
      skipDisabled: fe,
      "aria-label": ge.selectViewText(Be)
    }, Be))
  }));
});
define_process_env_default$X.NODE_ENV !== "production" && (MultiSectionDigitalClock.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: PropTypes.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * Controlled focused view.
   */
  focusedView: PropTypes.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: PropTypes.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: PropTypes.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: PropTypes.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: PropTypes.object,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: PropTypes.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: PropTypes.shape({
    hours: PropTypes.number,
    minutes: PropTypes.number,
    seconds: PropTypes.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Available views.
   * @default ['hours', 'minutes']
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired)
});
function getPickersDayUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersDay", T);
}
const pickersDayClasses = generateUtilityClasses$1("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]);
var define_process_env_default$W = {};
const _excluded$$ = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"], useUtilityClasses$N = (T) => {
  const {
    selected: S,
    disableMargin: R,
    disableHighlightToday: k,
    today: D,
    disabled: L,
    outsideCurrentMonth: V,
    showDaysOutsideCurrentMonth: z,
    classes: W
  } = T, U = V && !z;
  return composeClasses({
    root: ["root", S && !U && "selected", L && "disabled", !R && "dayWithMargin", !k && D && "today", V && z && "dayOutsideMonth", U && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, getPickersDayUtilityClass, W);
}, styleArg = ({
  theme: T
}) => _extends$1({}, T.typography.caption, {
  width: DAY_SIZE,
  height: DAY_SIZE,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: T.transitions.create("background-color", {
    duration: T.transitions.duration.short
  }),
  color: (T.vars || T).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / ${T.vars.palette.action.hoverOpacity})` : alpha$1(T.palette.primary.main, T.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / ${T.vars.palette.action.focusOpacity})` : alpha$1(T.palette.primary.main, T.palette.action.focusOpacity),
    [`&.${pickersDayClasses.selected}`]: {
      willChange: "background-color",
      backgroundColor: (T.vars || T).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.selected}`]: {
    color: (T.vars || T).palette.primary.contrastText,
    backgroundColor: (T.vars || T).palette.primary.main,
    fontWeight: T.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (T.vars || T).palette.primary.dark
    }
  },
  [`&.${pickersDayClasses.disabled}:not(.${pickersDayClasses.selected})`]: {
    color: (T.vars || T).palette.text.disabled
  },
  [`&.${pickersDayClasses.disabled}&.${pickersDayClasses.selected}`]: {
    opacity: 0.6
  },
  variants: [{
    props: {
      disableMargin: !1
    },
    style: {
      margin: `0 ${DAY_MARGIN}px`
    }
  }, {
    props: {
      outsideCurrentMonth: !0,
      showDaysOutsideCurrentMonth: !0
    },
    style: {
      color: (T.vars || T).palette.text.secondary
    }
  }, {
    props: {
      disableHighlightToday: !1,
      today: !0
    },
    style: {
      [`&:not(.${pickersDayClasses.selected})`]: {
        border: `1px solid ${(T.vars || T).palette.text.secondary}`
      }
    }
  }]
}), overridesResolver$2 = (T, S) => {
  const {
    ownerState: R
  } = T;
  return [S.root, !R.disableMargin && S.dayWithMargin, !R.disableHighlightToday && R.today && S.today, !R.outsideCurrentMonth && R.showDaysOutsideCurrentMonth && S.dayOutsideMonth, R.outsideCurrentMonth && !R.showDaysOutsideCurrentMonth && S.hiddenDaySpacingFiller];
}, PickersDayRoot = styled(ButtonBase, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: overridesResolver$2
})(styleArg), PickersDayFiller = styled("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: overridesResolver$2
})(({
  theme: T
}) => _extends$1({}, styleArg({
  theme: T
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
})), noop$2 = () => {
}, PickersDayRaw = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiPickersDay"
  }), {
    autoFocus: D = !1,
    className: L,
    day: V,
    disabled: z = !1,
    disableHighlightToday: W = !1,
    disableMargin: U = !1,
    isAnimating: q,
    onClick: K,
    onDaySelect: Y,
    onFocus: J = noop$2,
    onBlur: Z = noop$2,
    onKeyDown: X = noop$2,
    onMouseDown: ee = noop$2,
    onMouseEnter: te = noop$2,
    outsideCurrentMonth: re,
    selected: Q = !1,
    showDaysOutsideCurrentMonth: ne = !1,
    children: oe,
    today: ae = !1
  } = k, se = _objectWithoutPropertiesLoose$1(k, _excluded$$), ie = _extends$1({}, k, {
    autoFocus: D,
    disabled: z,
    disableHighlightToday: W,
    disableMargin: U,
    selected: Q,
    showDaysOutsideCurrentMonth: ne,
    today: ae
  }), he = useUtilityClasses$N(ie), xe = useUtils(), Pe = React$1.useRef(null), Re = useForkRef(Pe, R);
  useEnhancedEffect(() => {
    D && !z && !q && !re && Pe.current.focus();
  }, [D, z, q, re]);
  const ke = (fe) => {
    ee(fe), re && fe.preventDefault();
  }, Te = (fe) => {
    z || Y(V), re && fe.currentTarget.focus(), K && K(fe);
  };
  return re && !ne ? /* @__PURE__ */ jsxRuntimeExports.jsx(PickersDayFiller, {
    className: clsx(he.root, he.hiddenDaySpacingFiller, L),
    ownerState: ie,
    role: se.role
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx(PickersDayRoot, _extends$1({
    className: clsx(he.root, L),
    ref: Re,
    centerRipple: !0,
    disabled: z,
    tabIndex: Q ? 0 : -1,
    onKeyDown: (fe) => X(fe, V),
    onFocus: (fe) => J(fe, V),
    onBlur: (fe) => Z(fe, V),
    onMouseEnter: (fe) => te(fe, V),
    onClick: Te,
    onMouseDown: ke
  }, se, {
    ownerState: ie,
    children: oe || xe.format(V, "dayOfMonth")
  }));
});
define_process_env_default$W.NODE_ENV !== "production" && (PickersDayRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focusVisible: PropTypes.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * The date to show.
   */
  day: PropTypes.object.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  isAnimating: PropTypes.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: PropTypes.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: PropTypes.bool.isRequired,
  onBlur: PropTypes.func,
  onDaySelect: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: PropTypes.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: PropTypes.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })])
});
const PickersDay = /* @__PURE__ */ React$1.memo(PickersDayRaw);
var define_process_env_default$V = {};
const candidatesSelector = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function getTabIndex(T) {
  const S = parseInt(T.getAttribute("tabindex") || "", 10);
  return Number.isNaN(S) ? T.contentEditable === "true" || (T.nodeName === "AUDIO" || T.nodeName === "VIDEO" || T.nodeName === "DETAILS") && T.getAttribute("tabindex") === null ? 0 : T.tabIndex : S;
}
function isNonTabbableRadio(T) {
  if (T.tagName !== "INPUT" || T.type !== "radio" || !T.name)
    return !1;
  const S = (k) => T.ownerDocument.querySelector(`input[type="radio"]${k}`);
  let R = S(`[name="${T.name}"]:checked`);
  return R || (R = S(`[name="${T.name}"]`)), R !== T;
}
function isNodeMatchingSelectorFocusable(T) {
  return !(T.disabled || T.tagName === "INPUT" && T.type === "hidden" || isNonTabbableRadio(T));
}
function defaultGetTabbable(T) {
  const S = [], R = [];
  return Array.from(T.querySelectorAll(candidatesSelector)).forEach((k, D) => {
    const L = getTabIndex(k);
    L === -1 || !isNodeMatchingSelectorFocusable(k) || (L === 0 ? S.push(k) : R.push({
      documentOrder: D,
      tabIndex: L,
      node: k
    }));
  }), R.sort((k, D) => k.tabIndex === D.tabIndex ? k.documentOrder - D.documentOrder : k.tabIndex - D.tabIndex).map((k) => k.node).concat(S);
}
function defaultIsEnabled() {
  return !0;
}
function FocusTrap(T) {
  const {
    children: S,
    disableAutoFocus: R = !1,
    disableEnforceFocus: k = !1,
    disableRestoreFocus: D = !1,
    getTabbable: L = defaultGetTabbable,
    isEnabled: V = defaultIsEnabled,
    open: z
  } = T, W = React$1.useRef(!1), U = React$1.useRef(null), q = React$1.useRef(null), K = React$1.useRef(null), Y = React$1.useRef(null), J = React$1.useRef(!1), Z = React$1.useRef(null), X = useForkRef(S.ref, Z), ee = React$1.useRef(null);
  React$1.useEffect(() => {
    !z || !Z.current || (J.current = !R);
  }, [R, z]), React$1.useEffect(() => {
    if (!z || !Z.current)
      return;
    const Q = ownerDocument(Z.current);
    return Z.current.contains(Q.activeElement) || (Z.current.hasAttribute("tabIndex") || (define_process_env_default$V.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), Z.current.setAttribute("tabIndex", "-1")), J.current && Z.current.focus()), () => {
      D || (K.current && K.current.focus && (W.current = !0, K.current.focus()), K.current = null);
    };
  }, [z]), React$1.useEffect(() => {
    if (!z || !Z.current)
      return;
    const Q = ownerDocument(Z.current), ne = (se) => {
      ee.current = se, !(k || !V() || se.key !== "Tab") && Q.activeElement === Z.current && se.shiftKey && (W.current = !0, q.current && q.current.focus());
    }, oe = () => {
      const se = Z.current;
      if (se === null)
        return;
      if (!Q.hasFocus() || !V() || W.current) {
        W.current = !1;
        return;
      }
      if (se.contains(Q.activeElement) || k && Q.activeElement !== U.current && Q.activeElement !== q.current)
        return;
      if (Q.activeElement !== Y.current)
        Y.current = null;
      else if (Y.current !== null)
        return;
      if (!J.current)
        return;
      let ie = [];
      if ((Q.activeElement === U.current || Q.activeElement === q.current) && (ie = L(Z.current)), ie.length > 0) {
        var he, xe;
        const Pe = !!((he = ee.current) != null && he.shiftKey && ((xe = ee.current) == null ? void 0 : xe.key) === "Tab"), Re = ie[0], ke = ie[ie.length - 1];
        typeof Re != "string" && typeof ke != "string" && (Pe ? ke.focus() : Re.focus());
      } else
        se.focus();
    };
    Q.addEventListener("focusin", oe), Q.addEventListener("keydown", ne, !0);
    const ae = setInterval(() => {
      Q.activeElement && Q.activeElement.tagName === "BODY" && oe();
    }, 50);
    return () => {
      clearInterval(ae), Q.removeEventListener("focusin", oe), Q.removeEventListener("keydown", ne, !0);
    };
  }, [R, k, D, V, z, L]);
  const te = (Q) => {
    K.current === null && (K.current = Q.relatedTarget), J.current = !0, Y.current = Q.target;
    const ne = S.props.onFocus;
    ne && ne(Q);
  }, re = (Q) => {
    K.current === null && (K.current = Q.relatedTarget), J.current = !0;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: z ? 0 : -1,
      onFocus: re,
      ref: U,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ React$1.cloneElement(S, {
      ref: X,
      onFocus: te
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: z ? 0 : -1,
      onFocus: re,
      ref: q,
      "data-testid": "sentinelEnd"
    })]
  });
}
define_process_env_default$V.NODE_ENV !== "production" && (FocusTrap.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
});
define_process_env_default$V.NODE_ENV !== "production" && (FocusTrap.propTypes = exactProp(FocusTrap.propTypes));
var define_process_env_default$U = {};
function getContainer$1(T) {
  return typeof T == "function" ? T() : T;
}
const Portal = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const {
    children: k,
    container: D,
    disablePortal: L = !1
  } = S, [V, z] = React$1.useState(null), W = useForkRef(/* @__PURE__ */ React$1.isValidElement(k) ? k.ref : null, R);
  if (useEnhancedEffect(() => {
    L || z(getContainer$1(D) || document.body);
  }, [D, L]), useEnhancedEffect(() => {
    if (V && !L)
      return setRef(R, V), () => {
        setRef(R, null);
      };
  }, [R, V, L]), L) {
    if (/* @__PURE__ */ React$1.isValidElement(k)) {
      const U = {
        ref: W
      };
      return /* @__PURE__ */ React$1.cloneElement(k, U);
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(React$1.Fragment, {
      children: k
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React$1.Fragment, {
    children: V && /* @__PURE__ */ ReactDOM.createPortal(k, V)
  });
});
define_process_env_default$U.NODE_ENV !== "production" && (Portal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
});
define_process_env_default$U.NODE_ENV !== "production" && (Portal.propTypes = exactProp(Portal.propTypes));
function isOverflowing(T) {
  const S = ownerDocument(T);
  return S.body === T ? ownerWindow(T).innerWidth > S.documentElement.clientWidth : T.scrollHeight > T.clientHeight;
}
function ariaHidden(T, S) {
  S ? T.setAttribute("aria-hidden", "true") : T.removeAttribute("aria-hidden");
}
function getPaddingRight(T) {
  return parseInt(ownerWindow(T).getComputedStyle(T).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(T) {
  const R = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(T.tagName) !== -1, k = T.tagName === "INPUT" && T.getAttribute("type") === "hidden";
  return R || k;
}
function ariaHiddenSiblings(T, S, R, k, D) {
  const L = [S, R, ...k];
  [].forEach.call(T.children, (V) => {
    const z = L.indexOf(V) === -1, W = !isAriaHiddenForbiddenOnElement(V);
    z && W && ariaHidden(V, D);
  });
}
function findIndexOf(T, S) {
  let R = -1;
  return T.some((k, D) => S(k) ? (R = D, !0) : !1), R;
}
function handleContainer(T, S) {
  const R = [], k = T.container;
  if (!S.disableScrollLock) {
    if (isOverflowing(k)) {
      const V = getScrollbarSize(ownerDocument(k));
      R.push({
        value: k.style.paddingRight,
        property: "padding-right",
        el: k
      }), k.style.paddingRight = `${getPaddingRight(k) + V}px`;
      const z = ownerDocument(k).querySelectorAll(".mui-fixed");
      [].forEach.call(z, (W) => {
        R.push({
          value: W.style.paddingRight,
          property: "padding-right",
          el: W
        }), W.style.paddingRight = `${getPaddingRight(W) + V}px`;
      });
    }
    let L;
    if (k.parentNode instanceof DocumentFragment)
      L = ownerDocument(k).body;
    else {
      const V = k.parentElement, z = ownerWindow(k);
      L = V?.nodeName === "HTML" && z.getComputedStyle(V).overflowY === "scroll" ? V : k;
    }
    R.push({
      value: L.style.overflow,
      property: "overflow",
      el: L
    }, {
      value: L.style.overflowX,
      property: "overflow-x",
      el: L
    }, {
      value: L.style.overflowY,
      property: "overflow-y",
      el: L
    }), L.style.overflow = "hidden";
  }
  return () => {
    R.forEach(({
      value: L,
      el: V,
      property: z
    }) => {
      L ? V.style.setProperty(z, L) : V.style.removeProperty(z);
    });
  };
}
function getHiddenSiblings(T) {
  const S = [];
  return [].forEach.call(T.children, (R) => {
    R.getAttribute("aria-hidden") === "true" && S.push(R);
  }), S;
}
class ModalManager {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(S, R) {
    let k = this.modals.indexOf(S);
    if (k !== -1)
      return k;
    k = this.modals.length, this.modals.push(S), S.modalRef && ariaHidden(S.modalRef, !1);
    const D = getHiddenSiblings(R);
    ariaHiddenSiblings(R, S.mount, S.modalRef, D, !0);
    const L = findIndexOf(this.containers, (V) => V.container === R);
    return L !== -1 ? (this.containers[L].modals.push(S), k) : (this.containers.push({
      modals: [S],
      container: R,
      restore: null,
      hiddenSiblings: D
    }), k);
  }
  mount(S, R) {
    const k = findIndexOf(this.containers, (L) => L.modals.indexOf(S) !== -1), D = this.containers[k];
    D.restore || (D.restore = handleContainer(D, R));
  }
  remove(S, R = !0) {
    const k = this.modals.indexOf(S);
    if (k === -1)
      return k;
    const D = findIndexOf(this.containers, (V) => V.modals.indexOf(S) !== -1), L = this.containers[D];
    if (L.modals.splice(L.modals.indexOf(S), 1), this.modals.splice(k, 1), L.modals.length === 0)
      L.restore && L.restore(), S.modalRef && ariaHidden(S.modalRef, R), ariaHiddenSiblings(L.container, S.mount, S.modalRef, L.hiddenSiblings, !1), this.containers.splice(D, 1);
    else {
      const V = L.modals[L.modals.length - 1];
      V.modalRef && ariaHidden(V.modalRef, !1);
    }
    return k;
  }
  isTopModal(S) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === S;
  }
}
function getContainer(T) {
  return typeof T == "function" ? T() : T;
}
function getHasTransition(T) {
  return T ? T.props.hasOwnProperty("in") : !1;
}
const defaultManager = new ModalManager();
function useModal(T) {
  const {
    container: S,
    disableEscapeKeyDown: R = !1,
    disableScrollLock: k = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: D = defaultManager,
    closeAfterTransition: L = !1,
    onTransitionEnter: V,
    onTransitionExited: z,
    children: W,
    onClose: U,
    open: q,
    rootRef: K
  } = T, Y = React$1.useRef({}), J = React$1.useRef(null), Z = React$1.useRef(null), X = useForkRef(Z, K), [ee, te] = React$1.useState(!q), re = getHasTransition(W);
  let Q = !0;
  (T["aria-hidden"] === "false" || T["aria-hidden"] === !1) && (Q = !1);
  const ne = () => ownerDocument(J.current), oe = () => (Y.current.modalRef = Z.current, Y.current.mount = J.current, Y.current), ae = () => {
    D.mount(oe(), {
      disableScrollLock: k
    }), Z.current && (Z.current.scrollTop = 0);
  }, se = useEventCallback(() => {
    const ue = getContainer(S) || ne().body;
    D.add(oe(), ue), Z.current && ae();
  }), ie = React$1.useCallback(() => D.isTopModal(oe()), [D]), he = useEventCallback((ue) => {
    J.current = ue, ue && (q && ie() ? ae() : Z.current && ariaHidden(Z.current, Q));
  }), xe = React$1.useCallback(() => {
    D.remove(oe(), Q);
  }, [Q, D]);
  React$1.useEffect(() => () => {
    xe();
  }, [xe]), React$1.useEffect(() => {
    q ? se() : (!re || !L) && xe();
  }, [q, xe, re, L, se]);
  const Pe = (ue) => (Ce) => {
    var ce;
    (ce = ue.onKeyDown) == null || ce.call(ue, Ce), !(Ce.key !== "Escape" || Ce.which === 229 || // Wait until IME is settled.
    !ie()) && (R || (Ce.stopPropagation(), U && U(Ce, "escapeKeyDown")));
  }, Re = (ue) => (Ce) => {
    var ce;
    (ce = ue.onClick) == null || ce.call(ue, Ce), Ce.target === Ce.currentTarget && U && U(Ce, "backdropClick");
  };
  return {
    getRootProps: (ue = {}) => {
      const Ce = extractEventHandlers(T);
      delete Ce.onTransitionEnter, delete Ce.onTransitionExited;
      const ce = _extends$1({}, Ce, ue);
      return _extends$1({
        role: "presentation"
      }, ce, {
        onKeyDown: Pe(ce),
        ref: X
      });
    },
    getBackdropProps: (ue = {}) => {
      const Ce = ue;
      return _extends$1({
        "aria-hidden": !0
      }, Ce, {
        onClick: Re(Ce),
        open: q
      });
    },
    getTransitionProps: () => {
      const ue = () => {
        te(!1), V && V();
      }, Ce = () => {
        te(!0), z && z(), L && xe();
      };
      return {
        onEnter: createChainedFunction(ue, W?.props.onEnter),
        onExited: createChainedFunction(Ce, W?.props.onExited)
      };
    },
    rootRef: X,
    portalRef: he,
    isTopModal: ie,
    exited: ee,
    hasTransition: re
  };
}
var top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [top, bottom, right, left], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(T, S) {
  return T.concat([S + "-" + start, S + "-" + end]);
}, []), placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(T, S) {
  return T.concat([S, S + "-" + start, S + "-" + end]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main$1 = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [beforeRead, read, afterRead, beforeMain, main$1, afterMain, beforeWrite, write, afterWrite];
function getNodeName(T) {
  return T ? (T.nodeName || "").toLowerCase() : null;
}
function getWindow(T) {
  if (T == null)
    return window;
  if (T.toString() !== "[object Window]") {
    var S = T.ownerDocument;
    return S && S.defaultView || window;
  }
  return T;
}
function isElement(T) {
  var S = getWindow(T).Element;
  return T instanceof S || T instanceof Element;
}
function isHTMLElement$1(T) {
  var S = getWindow(T).HTMLElement;
  return T instanceof S || T instanceof HTMLElement;
}
function isShadowRoot(T) {
  if (typeof ShadowRoot > "u")
    return !1;
  var S = getWindow(T).ShadowRoot;
  return T instanceof S || T instanceof ShadowRoot;
}
function applyStyles(T) {
  var S = T.state;
  Object.keys(S.elements).forEach(function(R) {
    var k = S.styles[R] || {}, D = S.attributes[R] || {}, L = S.elements[R];
    !isHTMLElement$1(L) || !getNodeName(L) || (Object.assign(L.style, k), Object.keys(D).forEach(function(V) {
      var z = D[V];
      z === !1 ? L.removeAttribute(V) : L.setAttribute(V, z === !0 ? "" : z);
    }));
  });
}
function effect$2(T) {
  var S = T.state, R = {
    popper: {
      position: S.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(S.elements.popper.style, R.popper), S.styles = R, S.elements.arrow && Object.assign(S.elements.arrow.style, R.arrow), function() {
    Object.keys(S.elements).forEach(function(k) {
      var D = S.elements[k], L = S.attributes[k] || {}, V = Object.keys(S.styles.hasOwnProperty(k) ? S.styles[k] : R[k]), z = V.reduce(function(W, U) {
        return W[U] = "", W;
      }, {});
      !isHTMLElement$1(D) || !getNodeName(D) || (Object.assign(D.style, z), Object.keys(L).forEach(function(W) {
        D.removeAttribute(W);
      }));
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(T) {
  return T.split("-")[0];
}
var max = Math.max, min = Math.min, round$1 = Math.round;
function getUAString() {
  var T = navigator.userAgentData;
  return T != null && T.brands && Array.isArray(T.brands) ? T.brands.map(function(S) {
    return S.brand + "/" + S.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(T, S, R) {
  S === void 0 && (S = !1), R === void 0 && (R = !1);
  var k = T.getBoundingClientRect(), D = 1, L = 1;
  S && isHTMLElement$1(T) && (D = T.offsetWidth > 0 && round$1(k.width) / T.offsetWidth || 1, L = T.offsetHeight > 0 && round$1(k.height) / T.offsetHeight || 1);
  var V = isElement(T) ? getWindow(T) : window, z = V.visualViewport, W = !isLayoutViewport() && R, U = (k.left + (W && z ? z.offsetLeft : 0)) / D, q = (k.top + (W && z ? z.offsetTop : 0)) / L, K = k.width / D, Y = k.height / L;
  return {
    width: K,
    height: Y,
    top: q,
    right: U + K,
    bottom: q + Y,
    left: U,
    x: U,
    y: q
  };
}
function getLayoutRect(T) {
  var S = getBoundingClientRect(T), R = T.offsetWidth, k = T.offsetHeight;
  return Math.abs(S.width - R) <= 1 && (R = S.width), Math.abs(S.height - k) <= 1 && (k = S.height), {
    x: T.offsetLeft,
    y: T.offsetTop,
    width: R,
    height: k
  };
}
function contains(T, S) {
  var R = S.getRootNode && S.getRootNode();
  if (T.contains(S))
    return !0;
  if (R && isShadowRoot(R)) {
    var k = S;
    do {
      if (k && T.isSameNode(k))
        return !0;
      k = k.parentNode || k.host;
    } while (k);
  }
  return !1;
}
function getComputedStyle$1(T) {
  return getWindow(T).getComputedStyle(T);
}
function isTableElement(T) {
  return ["table", "td", "th"].indexOf(getNodeName(T)) >= 0;
}
function getDocumentElement(T) {
  return ((isElement(T) ? T.ownerDocument : (
    // $FlowFixMe[prop-missing]
    T.document
  )) || window.document).documentElement;
}
function getParentNode(T) {
  return getNodeName(T) === "html" ? T : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    T.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    T.parentNode || // DOM Element detected
    (isShadowRoot(T) ? T.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(T)
  );
}
function getTrueOffsetParent(T) {
  return !isHTMLElement$1(T) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(T).position === "fixed" ? null : T.offsetParent;
}
function getContainingBlock(T) {
  var S = /firefox/i.test(getUAString()), R = /Trident/i.test(getUAString());
  if (R && isHTMLElement$1(T)) {
    var k = getComputedStyle$1(T);
    if (k.position === "fixed")
      return null;
  }
  var D = getParentNode(T);
  for (isShadowRoot(D) && (D = D.host); isHTMLElement$1(D) && ["html", "body"].indexOf(getNodeName(D)) < 0; ) {
    var L = getComputedStyle$1(D);
    if (L.transform !== "none" || L.perspective !== "none" || L.contain === "paint" || ["transform", "perspective"].indexOf(L.willChange) !== -1 || S && L.willChange === "filter" || S && L.filter && L.filter !== "none")
      return D;
    D = D.parentNode;
  }
  return null;
}
function getOffsetParent(T) {
  for (var S = getWindow(T), R = getTrueOffsetParent(T); R && isTableElement(R) && getComputedStyle$1(R).position === "static"; )
    R = getTrueOffsetParent(R);
  return R && (getNodeName(R) === "html" || getNodeName(R) === "body" && getComputedStyle$1(R).position === "static") ? S : R || getContainingBlock(T) || S;
}
function getMainAxisFromPlacement(T) {
  return ["top", "bottom"].indexOf(T) >= 0 ? "x" : "y";
}
function within(T, S, R) {
  return max(T, min(S, R));
}
function withinMaxClamp(T, S, R) {
  var k = within(T, S, R);
  return k > R ? R : k;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(T) {
  return Object.assign({}, getFreshSideObject(), T);
}
function expandToHashMap(T, S) {
  return S.reduce(function(R, k) {
    return R[k] = T, R;
  }, {});
}
var toPaddingObject = function T(S, R) {
  return S = typeof S == "function" ? S(Object.assign({}, R.rects, {
    placement: R.placement
  })) : S, mergePaddingObject(typeof S != "number" ? S : expandToHashMap(S, basePlacements));
};
function arrow(T) {
  var S, R = T.state, k = T.name, D = T.options, L = R.elements.arrow, V = R.modifiersData.popperOffsets, z = getBasePlacement(R.placement), W = getMainAxisFromPlacement(z), U = [left, right].indexOf(z) >= 0, q = U ? "height" : "width";
  if (!(!L || !V)) {
    var K = toPaddingObject(D.padding, R), Y = getLayoutRect(L), J = W === "y" ? top : left, Z = W === "y" ? bottom : right, X = R.rects.reference[q] + R.rects.reference[W] - V[W] - R.rects.popper[q], ee = V[W] - R.rects.reference[W], te = getOffsetParent(L), re = te ? W === "y" ? te.clientHeight || 0 : te.clientWidth || 0 : 0, Q = X / 2 - ee / 2, ne = K[J], oe = re - Y[q] - K[Z], ae = re / 2 - Y[q] / 2 + Q, se = within(ne, ae, oe), ie = W;
    R.modifiersData[k] = (S = {}, S[ie] = se, S.centerOffset = se - ae, S);
  }
}
function effect$1(T) {
  var S = T.state, R = T.options, k = R.element, D = k === void 0 ? "[data-popper-arrow]" : k;
  D != null && (typeof D == "string" && (D = S.elements.popper.querySelector(D), !D) || contains(S.elements.popper, D) && (S.elements.arrow = D));
}
const arrow$1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(T) {
  return T.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(T, S) {
  var R = T.x, k = T.y, D = S.devicePixelRatio || 1;
  return {
    x: round$1(R * D) / D || 0,
    y: round$1(k * D) / D || 0
  };
}
function mapToStyles(T) {
  var S, R = T.popper, k = T.popperRect, D = T.placement, L = T.variation, V = T.offsets, z = T.position, W = T.gpuAcceleration, U = T.adaptive, q = T.roundOffsets, K = T.isFixed, Y = V.x, J = Y === void 0 ? 0 : Y, Z = V.y, X = Z === void 0 ? 0 : Z, ee = typeof q == "function" ? q({
    x: J,
    y: X
  }) : {
    x: J,
    y: X
  };
  J = ee.x, X = ee.y;
  var te = V.hasOwnProperty("x"), re = V.hasOwnProperty("y"), Q = left, ne = top, oe = window;
  if (U) {
    var ae = getOffsetParent(R), se = "clientHeight", ie = "clientWidth";
    if (ae === getWindow(R) && (ae = getDocumentElement(R), getComputedStyle$1(ae).position !== "static" && z === "absolute" && (se = "scrollHeight", ie = "scrollWidth")), ae = ae, D === top || (D === left || D === right) && L === end) {
      ne = bottom;
      var he = K && ae === oe && oe.visualViewport ? oe.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        ae[se]
      );
      X -= he - k.height, X *= W ? 1 : -1;
    }
    if (D === left || (D === top || D === bottom) && L === end) {
      Q = right;
      var xe = K && ae === oe && oe.visualViewport ? oe.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        ae[ie]
      );
      J -= xe - k.width, J *= W ? 1 : -1;
    }
  }
  var Pe = Object.assign({
    position: z
  }, U && unsetSides), Re = q === !0 ? roundOffsetsByDPR({
    x: J,
    y: X
  }, getWindow(R)) : {
    x: J,
    y: X
  };
  if (J = Re.x, X = Re.y, W) {
    var ke;
    return Object.assign({}, Pe, (ke = {}, ke[ne] = re ? "0" : "", ke[Q] = te ? "0" : "", ke.transform = (oe.devicePixelRatio || 1) <= 1 ? "translate(" + J + "px, " + X + "px)" : "translate3d(" + J + "px, " + X + "px, 0)", ke));
  }
  return Object.assign({}, Pe, (S = {}, S[ne] = re ? X + "px" : "", S[Q] = te ? J + "px" : "", S.transform = "", S));
}
function computeStyles(T) {
  var S = T.state, R = T.options, k = R.gpuAcceleration, D = k === void 0 ? !0 : k, L = R.adaptive, V = L === void 0 ? !0 : L, z = R.roundOffsets, W = z === void 0 ? !0 : z, U = {
    placement: getBasePlacement(S.placement),
    variation: getVariation(S.placement),
    popper: S.elements.popper,
    popperRect: S.rects.popper,
    gpuAcceleration: D,
    isFixed: S.options.strategy === "fixed"
  };
  S.modifiersData.popperOffsets != null && (S.styles.popper = Object.assign({}, S.styles.popper, mapToStyles(Object.assign({}, U, {
    offsets: S.modifiersData.popperOffsets,
    position: S.options.strategy,
    adaptive: V,
    roundOffsets: W
  })))), S.modifiersData.arrow != null && (S.styles.arrow = Object.assign({}, S.styles.arrow, mapToStyles(Object.assign({}, U, {
    offsets: S.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: W
  })))), S.attributes.popper = Object.assign({}, S.attributes.popper, {
    "data-popper-placement": S.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: !0
};
function effect(T) {
  var S = T.state, R = T.instance, k = T.options, D = k.scroll, L = D === void 0 ? !0 : D, V = k.resize, z = V === void 0 ? !0 : V, W = getWindow(S.elements.popper), U = [].concat(S.scrollParents.reference, S.scrollParents.popper);
  return L && U.forEach(function(q) {
    q.addEventListener("scroll", R.update, passive);
  }), z && W.addEventListener("resize", R.update, passive), function() {
    L && U.forEach(function(q) {
      q.removeEventListener("scroll", R.update, passive);
    }), z && W.removeEventListener("resize", R.update, passive);
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function T() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(T) {
  return T.replace(/left|right|bottom|top/g, function(S) {
    return hash$1[S];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(T) {
  return T.replace(/start|end/g, function(S) {
    return hash[S];
  });
}
function getWindowScroll(T) {
  var S = getWindow(T), R = S.pageXOffset, k = S.pageYOffset;
  return {
    scrollLeft: R,
    scrollTop: k
  };
}
function getWindowScrollBarX(T) {
  return getBoundingClientRect(getDocumentElement(T)).left + getWindowScroll(T).scrollLeft;
}
function getViewportRect(T, S) {
  var R = getWindow(T), k = getDocumentElement(T), D = R.visualViewport, L = k.clientWidth, V = k.clientHeight, z = 0, W = 0;
  if (D) {
    L = D.width, V = D.height;
    var U = isLayoutViewport();
    (U || !U && S === "fixed") && (z = D.offsetLeft, W = D.offsetTop);
  }
  return {
    width: L,
    height: V,
    x: z + getWindowScrollBarX(T),
    y: W
  };
}
function getDocumentRect(T) {
  var S, R = getDocumentElement(T), k = getWindowScroll(T), D = (S = T.ownerDocument) == null ? void 0 : S.body, L = max(R.scrollWidth, R.clientWidth, D ? D.scrollWidth : 0, D ? D.clientWidth : 0), V = max(R.scrollHeight, R.clientHeight, D ? D.scrollHeight : 0, D ? D.clientHeight : 0), z = -k.scrollLeft + getWindowScrollBarX(T), W = -k.scrollTop;
  return getComputedStyle$1(D || R).direction === "rtl" && (z += max(R.clientWidth, D ? D.clientWidth : 0) - L), {
    width: L,
    height: V,
    x: z,
    y: W
  };
}
function isScrollParent(T) {
  var S = getComputedStyle$1(T), R = S.overflow, k = S.overflowX, D = S.overflowY;
  return /auto|scroll|overlay|hidden/.test(R + D + k);
}
function getScrollParent(T) {
  return ["html", "body", "#document"].indexOf(getNodeName(T)) >= 0 ? T.ownerDocument.body : isHTMLElement$1(T) && isScrollParent(T) ? T : getScrollParent(getParentNode(T));
}
function listScrollParents(T, S) {
  var R;
  S === void 0 && (S = []);
  var k = getScrollParent(T), D = k === ((R = T.ownerDocument) == null ? void 0 : R.body), L = getWindow(k), V = D ? [L].concat(L.visualViewport || [], isScrollParent(k) ? k : []) : k, z = S.concat(V);
  return D ? z : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    z.concat(listScrollParents(getParentNode(V)))
  );
}
function rectToClientRect(T) {
  return Object.assign({}, T, {
    left: T.x,
    top: T.y,
    right: T.x + T.width,
    bottom: T.y + T.height
  });
}
function getInnerBoundingClientRect(T, S) {
  var R = getBoundingClientRect(T, !1, S === "fixed");
  return R.top = R.top + T.clientTop, R.left = R.left + T.clientLeft, R.bottom = R.top + T.clientHeight, R.right = R.left + T.clientWidth, R.width = T.clientWidth, R.height = T.clientHeight, R.x = R.left, R.y = R.top, R;
}
function getClientRectFromMixedType(T, S, R) {
  return S === viewport ? rectToClientRect(getViewportRect(T, R)) : isElement(S) ? getInnerBoundingClientRect(S, R) : rectToClientRect(getDocumentRect(getDocumentElement(T)));
}
function getClippingParents(T) {
  var S = listScrollParents(getParentNode(T)), R = ["absolute", "fixed"].indexOf(getComputedStyle$1(T).position) >= 0, k = R && isHTMLElement$1(T) ? getOffsetParent(T) : T;
  return isElement(k) ? S.filter(function(D) {
    return isElement(D) && contains(D, k) && getNodeName(D) !== "body";
  }) : [];
}
function getClippingRect(T, S, R, k) {
  var D = S === "clippingParents" ? getClippingParents(T) : [].concat(S), L = [].concat(D, [R]), V = L[0], z = L.reduce(function(W, U) {
    var q = getClientRectFromMixedType(T, U, k);
    return W.top = max(q.top, W.top), W.right = min(q.right, W.right), W.bottom = min(q.bottom, W.bottom), W.left = max(q.left, W.left), W;
  }, getClientRectFromMixedType(T, V, k));
  return z.width = z.right - z.left, z.height = z.bottom - z.top, z.x = z.left, z.y = z.top, z;
}
function computeOffsets(T) {
  var S = T.reference, R = T.element, k = T.placement, D = k ? getBasePlacement(k) : null, L = k ? getVariation(k) : null, V = S.x + S.width / 2 - R.width / 2, z = S.y + S.height / 2 - R.height / 2, W;
  switch (D) {
    case top:
      W = {
        x: V,
        y: S.y - R.height
      };
      break;
    case bottom:
      W = {
        x: V,
        y: S.y + S.height
      };
      break;
    case right:
      W = {
        x: S.x + S.width,
        y: z
      };
      break;
    case left:
      W = {
        x: S.x - R.width,
        y: z
      };
      break;
    default:
      W = {
        x: S.x,
        y: S.y
      };
  }
  var U = D ? getMainAxisFromPlacement(D) : null;
  if (U != null) {
    var q = U === "y" ? "height" : "width";
    switch (L) {
      case start:
        W[U] = W[U] - (S[q] / 2 - R[q] / 2);
        break;
      case end:
        W[U] = W[U] + (S[q] / 2 - R[q] / 2);
        break;
    }
  }
  return W;
}
function detectOverflow(T, S) {
  S === void 0 && (S = {});
  var R = S, k = R.placement, D = k === void 0 ? T.placement : k, L = R.strategy, V = L === void 0 ? T.strategy : L, z = R.boundary, W = z === void 0 ? clippingParents : z, U = R.rootBoundary, q = U === void 0 ? viewport : U, K = R.elementContext, Y = K === void 0 ? popper : K, J = R.altBoundary, Z = J === void 0 ? !1 : J, X = R.padding, ee = X === void 0 ? 0 : X, te = mergePaddingObject(typeof ee != "number" ? ee : expandToHashMap(ee, basePlacements)), re = Y === popper ? reference : popper, Q = T.rects.popper, ne = T.elements[Z ? re : Y], oe = getClippingRect(isElement(ne) ? ne : ne.contextElement || getDocumentElement(T.elements.popper), W, q, V), ae = getBoundingClientRect(T.elements.reference), se = computeOffsets({
    reference: ae,
    element: Q,
    strategy: "absolute",
    placement: D
  }), ie = rectToClientRect(Object.assign({}, Q, se)), he = Y === popper ? ie : ae, xe = {
    top: oe.top - he.top + te.top,
    bottom: he.bottom - oe.bottom + te.bottom,
    left: oe.left - he.left + te.left,
    right: he.right - oe.right + te.right
  }, Pe = T.modifiersData.offset;
  if (Y === popper && Pe) {
    var Re = Pe[D];
    Object.keys(xe).forEach(function(ke) {
      var Te = [right, bottom].indexOf(ke) >= 0 ? 1 : -1, fe = [top, bottom].indexOf(ke) >= 0 ? "y" : "x";
      xe[ke] += Re[fe] * Te;
    });
  }
  return xe;
}
function computeAutoPlacement(T, S) {
  S === void 0 && (S = {});
  var R = S, k = R.placement, D = R.boundary, L = R.rootBoundary, V = R.padding, z = R.flipVariations, W = R.allowedAutoPlacements, U = W === void 0 ? placements : W, q = getVariation(k), K = q ? z ? variationPlacements : variationPlacements.filter(function(Z) {
    return getVariation(Z) === q;
  }) : basePlacements, Y = K.filter(function(Z) {
    return U.indexOf(Z) >= 0;
  });
  Y.length === 0 && (Y = K);
  var J = Y.reduce(function(Z, X) {
    return Z[X] = detectOverflow(T, {
      placement: X,
      boundary: D,
      rootBoundary: L,
      padding: V
    })[getBasePlacement(X)], Z;
  }, {});
  return Object.keys(J).sort(function(Z, X) {
    return J[Z] - J[X];
  });
}
function getExpandedFallbackPlacements(T) {
  if (getBasePlacement(T) === auto)
    return [];
  var S = getOppositePlacement(T);
  return [getOppositeVariationPlacement(T), S, getOppositeVariationPlacement(S)];
}
function flip(T) {
  var S = T.state, R = T.options, k = T.name;
  if (!S.modifiersData[k]._skip) {
    for (var D = R.mainAxis, L = D === void 0 ? !0 : D, V = R.altAxis, z = V === void 0 ? !0 : V, W = R.fallbackPlacements, U = R.padding, q = R.boundary, K = R.rootBoundary, Y = R.altBoundary, J = R.flipVariations, Z = J === void 0 ? !0 : J, X = R.allowedAutoPlacements, ee = S.options.placement, te = getBasePlacement(ee), re = te === ee, Q = W || (re || !Z ? [getOppositePlacement(ee)] : getExpandedFallbackPlacements(ee)), ne = [ee].concat(Q).reduce(function(ve, le) {
      return ve.concat(getBasePlacement(le) === auto ? computeAutoPlacement(S, {
        placement: le,
        boundary: q,
        rootBoundary: K,
        padding: U,
        flipVariations: Z,
        allowedAutoPlacements: X
      }) : le);
    }, []), oe = S.rects.reference, ae = S.rects.popper, se = /* @__PURE__ */ new Map(), ie = !0, he = ne[0], xe = 0; xe < ne.length; xe++) {
      var Pe = ne[xe], Re = getBasePlacement(Pe), ke = getVariation(Pe) === start, Te = [top, bottom].indexOf(Re) >= 0, fe = Te ? "width" : "height", ue = detectOverflow(S, {
        placement: Pe,
        boundary: q,
        rootBoundary: K,
        altBoundary: Y,
        padding: U
      }), Ce = Te ? ke ? right : left : ke ? bottom : top;
      oe[fe] > ae[fe] && (Ce = getOppositePlacement(Ce));
      var ce = getOppositePlacement(Ce), pe = [];
      if (L && pe.push(ue[Re] <= 0), z && pe.push(ue[Ce] <= 0, ue[ce] <= 0), pe.every(function(ve) {
        return ve;
      })) {
        he = Pe, ie = !1;
        break;
      }
      se.set(Pe, pe);
    }
    if (ie)
      for (var _e = Z ? 3 : 1, ge = function(le) {
        var me = ne.find(function(Se) {
          var ye = se.get(Se);
          if (ye)
            return ye.slice(0, le).every(function(be) {
              return be;
            });
        });
        if (me)
          return he = me, "break";
      }, Ae = _e; Ae > 0; Ae--) {
        var Ee = ge(Ae);
        if (Ee === "break") break;
      }
    S.placement !== he && (S.modifiersData[k]._skip = !0, S.placement = he, S.reset = !0);
  }
}
const flip$1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function getSideOffsets(T, S, R) {
  return R === void 0 && (R = {
    x: 0,
    y: 0
  }), {
    top: T.top - S.height - R.y,
    right: T.right - S.width + R.x,
    bottom: T.bottom - S.height + R.y,
    left: T.left - S.width - R.x
  };
}
function isAnySideFullyClipped(T) {
  return [top, right, bottom, left].some(function(S) {
    return T[S] >= 0;
  });
}
function hide(T) {
  var S = T.state, R = T.name, k = S.rects.reference, D = S.rects.popper, L = S.modifiersData.preventOverflow, V = detectOverflow(S, {
    elementContext: "reference"
  }), z = detectOverflow(S, {
    altBoundary: !0
  }), W = getSideOffsets(V, k), U = getSideOffsets(z, D, L), q = isAnySideFullyClipped(W), K = isAnySideFullyClipped(U);
  S.modifiersData[R] = {
    referenceClippingOffsets: W,
    popperEscapeOffsets: U,
    isReferenceHidden: q,
    hasPopperEscaped: K
  }, S.attributes.popper = Object.assign({}, S.attributes.popper, {
    "data-popper-reference-hidden": q,
    "data-popper-escaped": K
  });
}
const hide$1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(T, S, R) {
  var k = getBasePlacement(T), D = [left, top].indexOf(k) >= 0 ? -1 : 1, L = typeof R == "function" ? R(Object.assign({}, S, {
    placement: T
  })) : R, V = L[0], z = L[1];
  return V = V || 0, z = (z || 0) * D, [left, right].indexOf(k) >= 0 ? {
    x: z,
    y: V
  } : {
    x: V,
    y: z
  };
}
function offset(T) {
  var S = T.state, R = T.options, k = T.name, D = R.offset, L = D === void 0 ? [0, 0] : D, V = placements.reduce(function(q, K) {
    return q[K] = distanceAndSkiddingToXY(K, S.rects, L), q;
  }, {}), z = V[S.placement], W = z.x, U = z.y;
  S.modifiersData.popperOffsets != null && (S.modifiersData.popperOffsets.x += W, S.modifiersData.popperOffsets.y += U), S.modifiersData[k] = V;
}
const offset$1 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(T) {
  var S = T.state, R = T.name;
  S.modifiersData[R] = computeOffsets({
    reference: S.rects.reference,
    element: S.rects.popper,
    strategy: "absolute",
    placement: S.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(T) {
  return T === "x" ? "y" : "x";
}
function preventOverflow(T) {
  var S = T.state, R = T.options, k = T.name, D = R.mainAxis, L = D === void 0 ? !0 : D, V = R.altAxis, z = V === void 0 ? !1 : V, W = R.boundary, U = R.rootBoundary, q = R.altBoundary, K = R.padding, Y = R.tether, J = Y === void 0 ? !0 : Y, Z = R.tetherOffset, X = Z === void 0 ? 0 : Z, ee = detectOverflow(S, {
    boundary: W,
    rootBoundary: U,
    padding: K,
    altBoundary: q
  }), te = getBasePlacement(S.placement), re = getVariation(S.placement), Q = !re, ne = getMainAxisFromPlacement(te), oe = getAltAxis(ne), ae = S.modifiersData.popperOffsets, se = S.rects.reference, ie = S.rects.popper, he = typeof X == "function" ? X(Object.assign({}, S.rects, {
    placement: S.placement
  })) : X, xe = typeof he == "number" ? {
    mainAxis: he,
    altAxis: he
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, he), Pe = S.modifiersData.offset ? S.modifiersData.offset[S.placement] : null, Re = {
    x: 0,
    y: 0
  };
  if (ae) {
    if (L) {
      var ke, Te = ne === "y" ? top : left, fe = ne === "y" ? bottom : right, ue = ne === "y" ? "height" : "width", Ce = ae[ne], ce = Ce + ee[Te], pe = Ce - ee[fe], _e = J ? -ie[ue] / 2 : 0, ge = re === start ? se[ue] : ie[ue], Ae = re === start ? -ie[ue] : -se[ue], Ee = S.elements.arrow, ve = J && Ee ? getLayoutRect(Ee) : {
        width: 0,
        height: 0
      }, le = S.modifiersData["arrow#persistent"] ? S.modifiersData["arrow#persistent"].padding : getFreshSideObject(), me = le[Te], Se = le[fe], ye = within(0, se[ue], ve[ue]), be = Q ? se[ue] / 2 - _e - ye - me - xe.mainAxis : ge - ye - me - xe.mainAxis, $e = Q ? -se[ue] / 2 + _e + ye + Se + xe.mainAxis : Ae + ye + Se + xe.mainAxis, Oe = S.elements.arrow && getOffsetParent(S.elements.arrow), Ie = Oe ? ne === "y" ? Oe.clientTop || 0 : Oe.clientLeft || 0 : 0, we = (ke = Pe?.[ne]) != null ? ke : 0, Fe = Ce + be - we - Ie, De = Ce + $e - we, Le = within(J ? min(ce, Fe) : ce, Ce, J ? max(pe, De) : pe);
      ae[ne] = Le, Re[ne] = Le - Ce;
    }
    if (z) {
      var ze, We = ne === "x" ? top : left, Be = ne === "x" ? bottom : right, Ye = ae[oe], Ge = oe === "y" ? "height" : "width", nt = Ye + ee[We], Ze = Ye - ee[Be], Me = [top, left].indexOf(te) !== -1, Ne = (ze = Pe?.[oe]) != null ? ze : 0, He = Me ? nt : Ye - se[Ge] - ie[Ge] - Ne + xe.altAxis, qe = Me ? Ye + se[Ge] + ie[Ge] - Ne - xe.altAxis : Ze, Ke = J && Me ? withinMaxClamp(He, Ye, qe) : within(J ? He : nt, Ye, J ? qe : Ze);
      ae[oe] = Ke, Re[oe] = Ke - Ye;
    }
    S.modifiersData[k] = Re;
  }
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(T) {
  return {
    scrollLeft: T.scrollLeft,
    scrollTop: T.scrollTop
  };
}
function getNodeScroll(T) {
  return T === getWindow(T) || !isHTMLElement$1(T) ? getWindowScroll(T) : getHTMLElementScroll(T);
}
function isElementScaled(T) {
  var S = T.getBoundingClientRect(), R = round$1(S.width) / T.offsetWidth || 1, k = round$1(S.height) / T.offsetHeight || 1;
  return R !== 1 || k !== 1;
}
function getCompositeRect(T, S, R) {
  R === void 0 && (R = !1);
  var k = isHTMLElement$1(S), D = isHTMLElement$1(S) && isElementScaled(S), L = getDocumentElement(S), V = getBoundingClientRect(T, D, R), z = {
    scrollLeft: 0,
    scrollTop: 0
  }, W = {
    x: 0,
    y: 0
  };
  return (k || !k && !R) && ((getNodeName(S) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  isScrollParent(L)) && (z = getNodeScroll(S)), isHTMLElement$1(S) ? (W = getBoundingClientRect(S, !0), W.x += S.clientLeft, W.y += S.clientTop) : L && (W.x = getWindowScrollBarX(L))), {
    x: V.left + z.scrollLeft - W.x,
    y: V.top + z.scrollTop - W.y,
    width: V.width,
    height: V.height
  };
}
function order(T) {
  var S = /* @__PURE__ */ new Map(), R = /* @__PURE__ */ new Set(), k = [];
  T.forEach(function(L) {
    S.set(L.name, L);
  });
  function D(L) {
    R.add(L.name);
    var V = [].concat(L.requires || [], L.requiresIfExists || []);
    V.forEach(function(z) {
      if (!R.has(z)) {
        var W = S.get(z);
        W && D(W);
      }
    }), k.push(L);
  }
  return T.forEach(function(L) {
    R.has(L.name) || D(L);
  }), k;
}
function orderModifiers(T) {
  var S = order(T);
  return modifierPhases.reduce(function(R, k) {
    return R.concat(S.filter(function(D) {
      return D.phase === k;
    }));
  }, []);
}
function debounce(T) {
  var S;
  return function() {
    return S || (S = new Promise(function(R) {
      Promise.resolve().then(function() {
        S = void 0, R(T());
      });
    })), S;
  };
}
function mergeByName(T) {
  var S = T.reduce(function(R, k) {
    var D = R[k.name];
    return R[k.name] = D ? Object.assign({}, D, k, {
      options: Object.assign({}, D.options, k.options),
      data: Object.assign({}, D.data, k.data)
    }) : k, R;
  }, {});
  return Object.keys(S).map(function(R) {
    return S[R];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var T = arguments.length, S = new Array(T), R = 0; R < T; R++)
    S[R] = arguments[R];
  return !S.some(function(k) {
    return !(k && typeof k.getBoundingClientRect == "function");
  });
}
function popperGenerator(T) {
  T === void 0 && (T = {});
  var S = T, R = S.defaultModifiers, k = R === void 0 ? [] : R, D = S.defaultOptions, L = D === void 0 ? DEFAULT_OPTIONS : D;
  return function(z, W, U) {
    U === void 0 && (U = L);
    var q = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, L),
      modifiersData: {},
      elements: {
        reference: z,
        popper: W
      },
      attributes: {},
      styles: {}
    }, K = [], Y = !1, J = {
      state: q,
      setOptions: function(te) {
        var re = typeof te == "function" ? te(q.options) : te;
        X(), q.options = Object.assign({}, L, q.options, re), q.scrollParents = {
          reference: isElement(z) ? listScrollParents(z) : z.contextElement ? listScrollParents(z.contextElement) : [],
          popper: listScrollParents(W)
        };
        var Q = orderModifiers(mergeByName([].concat(k, q.options.modifiers)));
        return q.orderedModifiers = Q.filter(function(ne) {
          return ne.enabled;
        }), Z(), J.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!Y) {
          var te = q.elements, re = te.reference, Q = te.popper;
          if (areValidElements(re, Q)) {
            q.rects = {
              reference: getCompositeRect(re, getOffsetParent(Q), q.options.strategy === "fixed"),
              popper: getLayoutRect(Q)
            }, q.reset = !1, q.placement = q.options.placement, q.orderedModifiers.forEach(function(xe) {
              return q.modifiersData[xe.name] = Object.assign({}, xe.data);
            });
            for (var ne = 0; ne < q.orderedModifiers.length; ne++) {
              if (q.reset === !0) {
                q.reset = !1, ne = -1;
                continue;
              }
              var oe = q.orderedModifiers[ne], ae = oe.fn, se = oe.options, ie = se === void 0 ? {} : se, he = oe.name;
              typeof ae == "function" && (q = ae({
                state: q,
                options: ie,
                name: he,
                instance: J
              }) || q);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function() {
        return new Promise(function(ee) {
          J.forceUpdate(), ee(q);
        });
      }),
      destroy: function() {
        X(), Y = !0;
      }
    };
    if (!areValidElements(z, W))
      return J;
    J.setOptions(U).then(function(ee) {
      !Y && U.onFirstUpdate && U.onFirstUpdate(ee);
    });
    function Z() {
      q.orderedModifiers.forEach(function(ee) {
        var te = ee.name, re = ee.options, Q = re === void 0 ? {} : re, ne = ee.effect;
        if (typeof ne == "function") {
          var oe = ne({
            state: q,
            name: te,
            instance: J,
            options: Q
          }), ae = function() {
          };
          K.push(oe || ae);
        }
      });
    }
    function X() {
      K.forEach(function(ee) {
        return ee();
      }), K = [];
    }
    return J;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1], createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
const COMPONENT_NAME = "Popper";
function getPopperUtilityClass(T) {
  return generateUtilityClass(COMPONENT_NAME, T);
}
generateUtilityClasses(COMPONENT_NAME, ["root"]);
var define_process_env_default$T = {};
const _excluded$_ = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], _excluded2$a = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function flipPlacement(T, S) {
  if (S === "ltr")
    return T;
  switch (T) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return T;
  }
}
function resolveAnchorEl$1(T) {
  return typeof T == "function" ? T() : T;
}
function isHTMLElement(T) {
  return T.nodeType !== void 0;
}
function isVirtualElement(T) {
  return !isHTMLElement(T);
}
const useUtilityClasses$M = () => composeClasses({
  root: ["root"]
}, useClassNamesOverride(getPopperUtilityClass)), defaultPopperOptions = {}, PopperTooltip = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k;
  const {
    anchorEl: D,
    children: L,
    direction: V,
    disablePortal: z,
    modifiers: W,
    open: U,
    placement: q,
    popperOptions: K,
    popperRef: Y,
    slotProps: J = {},
    slots: Z = {},
    TransitionProps: X
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = S, ee = _objectWithoutPropertiesLoose$1(S, _excluded$_), te = React$1.useRef(null), re = useForkRef(te, R), Q = React$1.useRef(null), ne = useForkRef(Q, Y), oe = React$1.useRef(ne);
  useEnhancedEffect(() => {
    oe.current = ne;
  }, [ne]), React$1.useImperativeHandle(Y, () => Q.current, []);
  const ae = flipPlacement(q, V), [se, ie] = React$1.useState(ae), [he, xe] = React$1.useState(resolveAnchorEl$1(D));
  React$1.useEffect(() => {
    Q.current && Q.current.forceUpdate();
  }), React$1.useEffect(() => {
    D && xe(resolveAnchorEl$1(D));
  }, [D]), useEnhancedEffect(() => {
    if (!he || !U)
      return;
    const fe = (ce) => {
      ie(ce.placement);
    };
    if (define_process_env_default$T.NODE_ENV !== "production" && he && isHTMLElement(he) && he.nodeType === 1) {
      const ce = he.getBoundingClientRect();
      define_process_env_default$T.NODE_ENV !== "test" && ce.top === 0 && ce.left === 0 && ce.right === 0 && ce.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let ue = [{
      name: "preventOverflow",
      options: {
        altBoundary: z
      }
    }, {
      name: "flip",
      options: {
        altBoundary: z
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: ce
      }) => {
        fe(ce);
      }
    }];
    W != null && (ue = ue.concat(W)), K && K.modifiers != null && (ue = ue.concat(K.modifiers));
    const Ce = createPopper(he, te.current, _extends$1({
      placement: ae
    }, K, {
      modifiers: ue
    }));
    return oe.current(Ce), () => {
      Ce.destroy(), oe.current(null);
    };
  }, [he, z, W, U, K, ae]);
  const Pe = {
    placement: se
  };
  X !== null && (Pe.TransitionProps = X);
  const Re = useUtilityClasses$M(), ke = (k = Z.root) != null ? k : "div", Te = useSlotProps({
    elementType: ke,
    externalSlotProps: J.root,
    externalForwardedProps: ee,
    additionalProps: {
      role: "tooltip",
      ref: re
    },
    ownerState: S,
    className: Re.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ke, _extends$1({}, Te, {
    children: typeof L == "function" ? L(Pe) : L
  }));
}), Popper$1 = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const {
    anchorEl: k,
    children: D,
    container: L,
    direction: V = "ltr",
    disablePortal: z = !1,
    keepMounted: W = !1,
    modifiers: U,
    open: q,
    placement: K = "bottom",
    popperOptions: Y = defaultPopperOptions,
    popperRef: J,
    style: Z,
    transition: X = !1,
    slotProps: ee = {},
    slots: te = {}
  } = S, re = _objectWithoutPropertiesLoose$1(S, _excluded2$a), [Q, ne] = React$1.useState(!0), oe = () => {
    ne(!1);
  }, ae = () => {
    ne(!0);
  };
  if (!W && !q && (!X || Q))
    return null;
  let se;
  if (L)
    se = L;
  else if (k) {
    const xe = resolveAnchorEl$1(k);
    se = xe && isHTMLElement(xe) ? ownerDocument(xe).body : ownerDocument(null).body;
  }
  const ie = !q && W && (!X || Q) ? "none" : void 0, he = X ? {
    in: q,
    onEnter: oe,
    onExited: ae
  } : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    disablePortal: z,
    container: se,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopperTooltip, _extends$1({
      anchorEl: k,
      direction: V,
      disablePortal: z,
      modifiers: U,
      ref: R,
      open: X ? !Q : q,
      placement: K,
      popperOptions: Y,
      popperRef: J,
      slotProps: ee,
      slots: te
    }, re, {
      style: _extends$1({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: ie
      }, Z),
      TransitionProps: he,
      children: D
    }))
  });
});
define_process_env_default$T.NODE_ENV !== "production" && (Popper$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), (T) => {
    if (T.open) {
      const S = resolveAnchorEl$1(T.anchorEl);
      if (S && isHTMLElement(S) && S.nodeType === 1) {
        const R = S.getBoundingClientRect();
        if (define_process_env_default$T.NODE_ENV !== "test" && R.top === 0 && R.left === 0 && R.right === 0 && R.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!S || typeof S.getBoundingClientRect != "function" || isVirtualElement(S) && S.contextElement != null && S.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: PropTypes.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
});
var define_process_env_default$S = {};
const _excluded$Z = ["onChange", "maxRows", "minRows", "style", "value"];
function getStyleValue(T) {
  return parseInt(T, 10) || 0;
}
const styles$2 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function isEmpty$1(T) {
  return T == null || Object.keys(T).length === 0 || T.outerHeightStyle === 0 && !T.overflowing;
}
const TextareaAutosize = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const {
    onChange: k,
    maxRows: D,
    minRows: L = 1,
    style: V,
    value: z
  } = S, W = _objectWithoutPropertiesLoose$1(S, _excluded$Z), {
    current: U
  } = React$1.useRef(z != null), q = React$1.useRef(null), K = useForkRef(R, q), Y = React$1.useRef(null), J = React$1.useCallback(() => {
    const ee = q.current, re = ownerWindow(ee).getComputedStyle(ee);
    if (re.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const Q = Y.current;
    Q.style.width = re.width, Q.value = ee.value || S.placeholder || "x", Q.value.slice(-1) === `
` && (Q.value += " ");
    const ne = re.boxSizing, oe = getStyleValue(re.paddingBottom) + getStyleValue(re.paddingTop), ae = getStyleValue(re.borderBottomWidth) + getStyleValue(re.borderTopWidth), se = Q.scrollHeight;
    Q.value = "x";
    const ie = Q.scrollHeight;
    let he = se;
    L && (he = Math.max(Number(L) * ie, he)), D && (he = Math.min(Number(D) * ie, he)), he = Math.max(he, ie);
    const xe = he + (ne === "border-box" ? oe + ae : 0), Pe = Math.abs(he - se) <= 1;
    return {
      outerHeightStyle: xe,
      overflowing: Pe
    };
  }, [D, L, S.placeholder]), Z = React$1.useCallback(() => {
    const ee = J();
    if (isEmpty$1(ee))
      return;
    const te = q.current;
    te.style.height = `${ee.outerHeightStyle}px`, te.style.overflow = ee.overflowing ? "hidden" : "";
  }, [J]);
  useEnhancedEffect(() => {
    const ee = () => {
      Z();
    };
    let te;
    const re = () => {
      cancelAnimationFrame(te), te = requestAnimationFrame(() => {
        ee();
      });
    }, Q = debounce$1(ee), ne = q.current, oe = ownerWindow(ne);
    oe.addEventListener("resize", Q);
    let ae;
    return typeof ResizeObserver < "u" && (ae = new ResizeObserver(define_process_env_default$S.NODE_ENV === "test" ? re : ee), ae.observe(ne)), () => {
      Q.clear(), cancelAnimationFrame(te), oe.removeEventListener("resize", Q), ae && ae.disconnect();
    };
  }, [J, Z]), useEnhancedEffect(() => {
    Z();
  });
  const X = (ee) => {
    U || Z(), k && k(ee);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("textarea", _extends$1({
      value: z,
      onChange: X,
      ref: K,
      rows: L,
      style: V
    }, W)), /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      "aria-hidden": !0,
      className: S.className,
      readOnly: !0,
      ref: Y,
      tabIndex: -1,
      style: _extends$1({}, styles$2.shadow, V, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
define_process_env_default$S.NODE_ENV !== "production" && (TextareaAutosize.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  placeholder: PropTypes.string,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
});
function formControlState({
  props: T,
  states: S,
  muiFormControl: R
}) {
  return S.reduce((k, D) => (k[D] = T[D], R && typeof T[D] > "u" && (k[D] = R[D]), k), {});
}
var define_process_env_default$R = {};
const FormControlContext = /* @__PURE__ */ React$1.createContext(void 0);
define_process_env_default$R.NODE_ENV !== "production" && (FormControlContext.displayName = "FormControlContext");
function useFormControl() {
  return React$1.useContext(FormControlContext);
}
var define_process_env_default$Q = {};
function GlobalStyles(T) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$1, _extends$1({}, T, {
    defaultTheme,
    themeId: THEME_ID
  }));
}
define_process_env_default$Q.NODE_ENV !== "production" && (GlobalStyles.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool])
});
function hasValue(T) {
  return T != null && !(Array.isArray(T) && T.length === 0);
}
function isFilled(T, S = !1) {
  return T && (hasValue(T.value) && T.value !== "" || S && hasValue(T.defaultValue) && T.defaultValue !== "");
}
function isAdornedStart(T) {
  return T.startAdornment;
}
function getInputBaseUtilityClass(T) {
  return generateUtilityClass$1("MuiInputBase", T);
}
const inputBaseClasses = generateUtilityClasses$1("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var define_process_env_default$P = {};
const _excluded$Y = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], rootOverridesResolver = (T, S) => {
  const {
    ownerState: R
  } = T;
  return [S.root, R.formControl && S.formControl, R.startAdornment && S.adornedStart, R.endAdornment && S.adornedEnd, R.error && S.error, R.size === "small" && S.sizeSmall, R.multiline && S.multiline, R.color && S[`color${capitalize$1(R.color)}`], R.fullWidth && S.fullWidth, R.hiddenLabel && S.hiddenLabel];
}, inputOverridesResolver = (T, S) => {
  const {
    ownerState: R
  } = T;
  return [S.input, R.size === "small" && S.inputSizeSmall, R.multiline && S.inputMultiline, R.type === "search" && S.inputTypeSearch, R.startAdornment && S.inputAdornedStart, R.endAdornment && S.inputAdornedEnd, R.hiddenLabel && S.inputHiddenLabel];
}, useUtilityClasses$L = (T) => {
  const {
    classes: S,
    color: R,
    disabled: k,
    error: D,
    endAdornment: L,
    focused: V,
    formControl: z,
    fullWidth: W,
    hiddenLabel: U,
    multiline: q,
    readOnly: K,
    size: Y,
    startAdornment: J,
    type: Z
  } = T, X = {
    root: ["root", `color${capitalize$1(R)}`, k && "disabled", D && "error", W && "fullWidth", V && "focused", z && "formControl", Y && Y !== "medium" && `size${capitalize$1(Y)}`, q && "multiline", J && "adornedStart", L && "adornedEnd", U && "hiddenLabel", K && "readOnly"],
    input: ["input", k && "disabled", Z === "search" && "inputTypeSearch", q && "inputMultiline", Y === "small" && "inputSizeSmall", U && "inputHiddenLabel", J && "inputAdornedStart", L && "inputAdornedEnd", K && "readOnly"]
  };
  return composeClasses(X, getInputBaseUtilityClass, S);
}, InputBaseRoot = styled("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(({
  theme: T,
  ownerState: S
}) => _extends$1({}, T.typography.body1, {
  color: (T.vars || T).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${inputBaseClasses.disabled}`]: {
    color: (T.vars || T).palette.text.disabled,
    cursor: "default"
  }
}, S.multiline && _extends$1({
  padding: "4px 0 5px"
}, S.size === "small" && {
  paddingTop: 1
}), S.fullWidth && {
  width: "100%"
})), InputBaseComponent = styled("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(({
  theme: T,
  ownerState: S
}) => {
  const R = T.palette.mode === "light", k = _extends$1({
    color: "currentColor"
  }, T.vars ? {
    opacity: T.vars.opacity.inputPlaceholder
  } : {
    opacity: R ? 0.42 : 0.5
  }, {
    transition: T.transitions.create("opacity", {
      duration: T.transitions.duration.shorter
    })
  }), D = {
    opacity: "0 !important"
  }, L = T.vars ? {
    opacity: T.vars.opacity.inputPlaceholder
  } : {
    opacity: R ? 0.42 : 0.5
  };
  return _extends$1({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": k,
    "&::-moz-placeholder": k,
    // Firefox 19+
    "&:-ms-input-placeholder": k,
    // IE11
    "&::-ms-input-placeholder": k,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${inputBaseClasses.formControl} &`]: {
      "&::-webkit-input-placeholder": D,
      "&::-moz-placeholder": D,
      // Firefox 19+
      "&:-ms-input-placeholder": D,
      // IE11
      "&::-ms-input-placeholder": D,
      // Edge
      "&:focus::-webkit-input-placeholder": L,
      "&:focus::-moz-placeholder": L,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": L,
      // IE11
      "&:focus::-ms-input-placeholder": L
      // Edge
    },
    [`&.${inputBaseClasses.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (T.vars || T).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, S.size === "small" && {
    paddingTop: 1
  }, S.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, S.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), inputGlobalStyles = /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), InputBase = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k;
  const D = useDefaultProps({
    props: S,
    name: "MuiInputBase"
  }), {
    "aria-describedby": L,
    autoComplete: V,
    autoFocus: z,
    className: W,
    components: U = {},
    componentsProps: q = {},
    defaultValue: K,
    disabled: Y,
    disableInjectingGlobalStyles: J,
    endAdornment: Z,
    fullWidth: X = !1,
    id: ee,
    inputComponent: te = "input",
    inputProps: re = {},
    inputRef: Q,
    maxRows: ne,
    minRows: oe,
    multiline: ae = !1,
    name: se,
    onBlur: ie,
    onChange: he,
    onClick: xe,
    onFocus: Pe,
    onKeyDown: Re,
    onKeyUp: ke,
    placeholder: Te,
    readOnly: fe,
    renderSuffix: ue,
    rows: Ce,
    slotProps: ce = {},
    slots: pe = {},
    startAdornment: _e,
    type: ge = "text",
    value: Ae
  } = D, Ee = _objectWithoutPropertiesLoose$1(D, _excluded$Y), ve = re.value != null ? re.value : Ae, {
    current: le
  } = React$1.useRef(ve != null), me = React$1.useRef(), Se = React$1.useCallback((Ke) => {
    define_process_env_default$P.NODE_ENV !== "production" && Ke && Ke.nodeName !== "INPUT" && !Ke.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), ye = useForkRef(me, Q, re.ref, Se), [be, $e] = React$1.useState(!1), Oe = useFormControl();
  define_process_env_default$P.NODE_ENV !== "production" && React$1.useEffect(() => {
    if (Oe)
      return Oe.registerEffect();
  }, [Oe]);
  const Ie = formControlState({
    props: D,
    muiFormControl: Oe,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  Ie.focused = Oe ? Oe.focused : be, React$1.useEffect(() => {
    !Oe && Y && be && ($e(!1), ie && ie());
  }, [Oe, Y, be, ie]);
  const we = Oe && Oe.onFilled, Fe = Oe && Oe.onEmpty, De = React$1.useCallback((Ke) => {
    isFilled(Ke) ? we && we() : Fe && Fe();
  }, [we, Fe]);
  useEnhancedEffect(() => {
    le && De({
      value: ve
    });
  }, [ve, De, le]);
  const Le = (Ke) => {
    if (Ie.disabled) {
      Ke.stopPropagation();
      return;
    }
    Pe && Pe(Ke), re.onFocus && re.onFocus(Ke), Oe && Oe.onFocus ? Oe.onFocus(Ke) : $e(!0);
  }, ze = (Ke) => {
    ie && ie(Ke), re.onBlur && re.onBlur(Ke), Oe && Oe.onBlur ? Oe.onBlur(Ke) : $e(!1);
  }, We = (Ke, ...Xe) => {
    if (!le) {
      const tt = Ke.target || me.current;
      if (tt == null)
        throw new Error(define_process_env_default$P.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : formatMuiErrorMessage$1(1));
      De({
        value: tt.value
      });
    }
    re.onChange && re.onChange(Ke, ...Xe), he && he(Ke, ...Xe);
  };
  React$1.useEffect(() => {
    De(me.current);
  }, []);
  const Be = (Ke) => {
    me.current && Ke.currentTarget === Ke.target && me.current.focus(), xe && xe(Ke);
  };
  let Ye = te, Ge = re;
  ae && Ye === "input" && (Ce ? (define_process_env_default$P.NODE_ENV !== "production" && (oe || ne) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Ge = _extends$1({
    type: void 0,
    minRows: Ce,
    maxRows: Ce
  }, Ge)) : Ge = _extends$1({
    type: void 0,
    maxRows: ne,
    minRows: oe
  }, Ge), Ye = TextareaAutosize);
  const nt = (Ke) => {
    De(Ke.animationName === "mui-auto-fill-cancel" ? me.current : {
      value: "x"
    });
  };
  React$1.useEffect(() => {
    Oe && Oe.setAdornedStart(!!_e);
  }, [Oe, _e]);
  const Ze = _extends$1({}, D, {
    color: Ie.color || "primary",
    disabled: Ie.disabled,
    endAdornment: Z,
    error: Ie.error,
    focused: Ie.focused,
    formControl: Oe,
    fullWidth: X,
    hiddenLabel: Ie.hiddenLabel,
    multiline: ae,
    size: Ie.size,
    startAdornment: _e,
    type: ge
  }), Me = useUtilityClasses$L(Ze), Ne = pe.root || U.Root || InputBaseRoot, He = ce.root || q.root || {}, qe = pe.input || U.Input || InputBaseComponent;
  return Ge = _extends$1({}, Ge, (k = ce.input) != null ? k : q.input), /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [!J && inputGlobalStyles, /* @__PURE__ */ jsxRuntimeExports.jsxs(Ne, _extends$1({}, He, !isHostComponent(Ne) && {
      ownerState: _extends$1({}, Ze, He.ownerState)
    }, {
      ref: R,
      onClick: Be
    }, Ee, {
      className: clsx(Me.root, He.className, W, fe && "MuiInputBase-readOnly"),
      children: [_e, /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
        value: null,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(qe, _extends$1({
          ownerState: Ze,
          "aria-invalid": Ie.error,
          "aria-describedby": L,
          autoComplete: V,
          autoFocus: z,
          defaultValue: K,
          disabled: Ie.disabled,
          id: ee,
          onAnimationStart: nt,
          name: se,
          placeholder: Te,
          readOnly: fe,
          required: Ie.required,
          rows: Ce,
          value: ve,
          onKeyDown: Re,
          onKeyUp: ke,
          type: ge
        }, Ge, !isHostComponent(qe) && {
          as: Ye,
          ownerState: _extends$1({}, Ze, Ge.ownerState)
        }, {
          ref: ye,
          className: clsx(Me.input, Ge.className, fe && "MuiInputBase-readOnly"),
          onBlur: ze,
          onChange: We,
          onFocus: Le
        }))
      }), Z, ue ? ue(_extends$1({}, Ie, {
        startAdornment: _e
      })) : null]
    }))]
  });
});
define_process_env_default$P.NODE_ENV !== "production" && (InputBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: elementTypeAcceptingRef$1,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The size of the component.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
const InputBase$1 = InputBase;
function getInputUtilityClass(T) {
  return generateUtilityClass$1("MuiInput", T);
}
const inputClasses = _extends$1({}, inputBaseClasses, generateUtilityClasses$1("MuiInput", ["root", "underline", "input"]));
var define_process_env_default$O = {};
const _excluded$X = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], useUtilityClasses$K = (T) => {
  const {
    classes: S,
    disableUnderline: R
  } = T, D = composeClasses({
    root: ["root", !R && "underline"],
    input: ["input"]
  }, getInputUtilityClass, S);
  return _extends$1({}, S, D);
}, InputRoot = styled(InputBaseRoot, {
  shouldForwardProp: (T) => rootShouldForwardProp(T) || T === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [...rootOverridesResolver(T, S), !R.disableUnderline && S.underline];
  }
})(({
  theme: T,
  ownerState: S
}) => {
  let k = T.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return T.vars && (k = `rgba(${T.vars.palette.common.onBackgroundChannel} / ${T.vars.opacity.inputUnderline})`), _extends$1({
    position: "relative"
  }, S.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !S.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(T.vars || T).palette[S.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: T.transitions.create("transform", {
        duration: T.transitions.duration.shorter,
        easing: T.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${inputClasses.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${inputClasses.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (T.vars || T).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${k}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: T.transitions.create("border-bottom-color", {
        duration: T.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${inputClasses.disabled}, .${inputClasses.error}):before`]: {
      borderBottom: `2px solid ${(T.vars || T).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${k}`
      }
    },
    [`&.${inputClasses.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), InputInput = styled(InputBaseComponent, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})({}), Input = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k, D, L, V;
  const z = useDefaultProps({
    props: S,
    name: "MuiInput"
  }), {
    disableUnderline: W,
    components: U = {},
    componentsProps: q,
    fullWidth: K = !1,
    inputComponent: Y = "input",
    multiline: J = !1,
    slotProps: Z,
    slots: X = {},
    type: ee = "text"
  } = z, te = _objectWithoutPropertiesLoose$1(z, _excluded$X), re = useUtilityClasses$K(z), ne = {
    root: {
      ownerState: {
        disableUnderline: W
      }
    }
  }, oe = Z ?? q ? deepmerge$1(Z ?? q, ne) : ne, ae = (k = (D = X.root) != null ? D : U.Root) != null ? k : InputRoot, se = (L = (V = X.input) != null ? V : U.Input) != null ? L : InputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase$1, _extends$1({
    slots: {
      root: ae,
      input: se
    },
    slotProps: oe,
    fullWidth: K,
    inputComponent: Y,
    multiline: J,
    ref: R,
    type: ee
  }, te, {
    classes: re
  }));
});
define_process_env_default$O.NODE_ENV !== "production" && (Input.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
Input.muiName = "Input";
function getFilledInputUtilityClass(T) {
  return generateUtilityClass$1("MuiFilledInput", T);
}
const filledInputClasses = _extends$1({}, inputBaseClasses, generateUtilityClasses$1("MuiFilledInput", ["root", "underline", "input"]));
var define_process_env_default$N = {};
const _excluded$W = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], useUtilityClasses$J = (T) => {
  const {
    classes: S,
    disableUnderline: R
  } = T, D = composeClasses({
    root: ["root", !R && "underline"],
    input: ["input"]
  }, getFilledInputUtilityClass, S);
  return _extends$1({}, S, D);
}, FilledInputRoot = styled(InputBaseRoot, {
  shouldForwardProp: (T) => rootShouldForwardProp(T) || T === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [...rootOverridesResolver(T, S), !R.disableUnderline && S.underline];
  }
})(({
  theme: T,
  ownerState: S
}) => {
  var R;
  const k = T.palette.mode === "light", D = k ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", L = k ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", V = k ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", z = k ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return _extends$1({
    position: "relative",
    backgroundColor: T.vars ? T.vars.palette.FilledInput.bg : L,
    borderTopLeftRadius: (T.vars || T).shape.borderRadius,
    borderTopRightRadius: (T.vars || T).shape.borderRadius,
    transition: T.transitions.create("background-color", {
      duration: T.transitions.duration.shorter,
      easing: T.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: T.vars ? T.vars.palette.FilledInput.hoverBg : V,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: T.vars ? T.vars.palette.FilledInput.bg : L
      }
    },
    [`&.${filledInputClasses.focused}`]: {
      backgroundColor: T.vars ? T.vars.palette.FilledInput.bg : L
    },
    [`&.${filledInputClasses.disabled}`]: {
      backgroundColor: T.vars ? T.vars.palette.FilledInput.disabledBg : z
    }
  }, !S.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(R = (T.vars || T).palette[S.color || "primary"]) == null ? void 0 : R.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: T.transitions.create("transform", {
        duration: T.transitions.duration.shorter,
        easing: T.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${filledInputClasses.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${filledInputClasses.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (T.vars || T).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${T.vars ? `rgba(${T.vars.palette.common.onBackgroundChannel} / ${T.vars.opacity.inputUnderline})` : D}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: T.transitions.create("border-bottom-color", {
        duration: T.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${filledInputClasses.disabled}, .${filledInputClasses.error}):before`]: {
      borderBottom: `1px solid ${(T.vars || T).palette.text.primary}`
    },
    [`&.${filledInputClasses.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, S.startAdornment && {
    paddingLeft: 12
  }, S.endAdornment && {
    paddingRight: 12
  }, S.multiline && _extends$1({
    padding: "25px 12px 8px"
  }, S.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, S.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, S.hiddenLabel && S.size === "small" && {
    paddingTop: 8,
    paddingBottom: 9
  }));
}), FilledInputInput = styled(InputBaseComponent, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(({
  theme: T,
  ownerState: S
}) => _extends$1({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !T.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: T.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: T.palette.mode === "light" ? null : "#fff",
    caretColor: T.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, T.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [T.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, S.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, S.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, S.startAdornment && {
  paddingLeft: 0
}, S.endAdornment && {
  paddingRight: 0
}, S.hiddenLabel && S.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
}, S.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
})), FilledInput = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k, D, L, V;
  const z = useDefaultProps({
    props: S,
    name: "MuiFilledInput"
  }), {
    components: W = {},
    componentsProps: U,
    fullWidth: q = !1,
    // declare here to prevent spreading to DOM
    inputComponent: K = "input",
    multiline: Y = !1,
    slotProps: J,
    slots: Z = {},
    type: X = "text"
  } = z, ee = _objectWithoutPropertiesLoose$1(z, _excluded$W), te = _extends$1({}, z, {
    fullWidth: q,
    inputComponent: K,
    multiline: Y,
    type: X
  }), re = useUtilityClasses$J(z), Q = {
    root: {
      ownerState: te
    },
    input: {
      ownerState: te
    }
  }, ne = J ?? U ? deepmerge$1(Q, J ?? U) : Q, oe = (k = (D = Z.root) != null ? D : W.Root) != null ? k : FilledInputRoot, ae = (L = (V = Z.input) != null ? V : W.Input) != null ? L : FilledInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase$1, _extends$1({
    slots: {
      root: oe,
      input: ae
    },
    componentsProps: ne,
    fullWidth: q,
    inputComponent: K,
    multiline: Y,
    ref: R,
    type: X
  }, ee, {
    classes: re
  }));
});
define_process_env_default$N.NODE_ENV !== "production" && (FilledInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
FilledInput.muiName = "Input";
var define_process_env_default$M = {}, _span$3;
const _excluded$V = ["children", "classes", "className", "label", "notched"], NotchedOutlineRoot$1 = styled("fieldset", {
  shouldForwardProp: rootShouldForwardProp
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), NotchedOutlineLegend = styled("legend", {
  shouldForwardProp: rootShouldForwardProp
})(({
  ownerState: T,
  theme: S
}) => _extends$1({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !T.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: S.transitions.create("width", {
    duration: 150,
    easing: S.transitions.easing.easeOut
  })
}, T.withLabel && _extends$1({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: S.transitions.create("max-width", {
    duration: 50,
    easing: S.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, T.notched && {
  maxWidth: "100%",
  transition: S.transitions.create("max-width", {
    duration: 100,
    easing: S.transitions.easing.easeOut,
    delay: 50
  })
})));
function NotchedOutline(T) {
  const {
    className: S,
    label: R,
    notched: k
  } = T, D = _objectWithoutPropertiesLoose$1(T, _excluded$V), L = R != null && R !== "", V = _extends$1({}, T, {
    notched: k,
    withLabel: L
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot$1, _extends$1({
    "aria-hidden": !0,
    className: S,
    ownerState: V
  }, D, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineLegend, {
      ownerState: V,
      children: L ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        children: R
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span$3 || (_span$3 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
define_process_env_default$M.NODE_ENV !== "production" && (NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The label.
   */
  label: PropTypes.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  style: PropTypes.object
});
function getOutlinedInputUtilityClass(T) {
  return generateUtilityClass$1("MuiOutlinedInput", T);
}
const outlinedInputClasses = _extends$1({}, inputBaseClasses, generateUtilityClasses$1("MuiOutlinedInput", ["root", "notchedOutline", "input"]));
var define_process_env_default$L = {};
const _excluded$U = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], useUtilityClasses$I = (T) => {
  const {
    classes: S
  } = T, k = composeClasses({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, getOutlinedInputUtilityClass, S);
  return _extends$1({}, S, k);
}, OutlinedInputRoot = styled(InputBaseRoot, {
  shouldForwardProp: (T) => rootShouldForwardProp(T) || T === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(({
  theme: T,
  ownerState: S
}) => {
  const R = T.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return _extends$1({
    position: "relative",
    borderRadius: (T.vars || T).shape.borderRadius,
    [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: (T.vars || T).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: T.vars ? `rgba(${T.vars.palette.common.onBackgroundChannel} / 0.23)` : R
      }
    },
    [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: (T.vars || T).palette[S.color].main,
      borderWidth: 2
    },
    [`&.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: (T.vars || T).palette.error.main
    },
    [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: (T.vars || T).palette.action.disabled
    }
  }, S.startAdornment && {
    paddingLeft: 14
  }, S.endAdornment && {
    paddingRight: 14
  }, S.multiline && _extends$1({
    padding: "16.5px 14px"
  }, S.size === "small" && {
    padding: "8.5px 14px"
  }));
}), NotchedOutlineRoot = styled(NotchedOutline, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (T, S) => S.notchedOutline
})(({
  theme: T
}) => {
  const S = T.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: T.vars ? `rgba(${T.vars.palette.common.onBackgroundChannel} / 0.23)` : S
  };
}), OutlinedInputInput = styled(InputBaseComponent, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(({
  theme: T,
  ownerState: S
}) => _extends$1({
  padding: "16.5px 14px"
}, !T.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: T.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: T.palette.mode === "light" ? null : "#fff",
    caretColor: T.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, T.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [T.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, S.size === "small" && {
  padding: "8.5px 14px"
}, S.multiline && {
  padding: 0
}, S.startAdornment && {
  paddingLeft: 0
}, S.endAdornment && {
  paddingRight: 0
})), OutlinedInput = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k, D, L, V, z;
  const W = useDefaultProps({
    props: S,
    name: "MuiOutlinedInput"
  }), {
    components: U = {},
    fullWidth: q = !1,
    inputComponent: K = "input",
    label: Y,
    multiline: J = !1,
    notched: Z,
    slots: X = {},
    type: ee = "text"
  } = W, te = _objectWithoutPropertiesLoose$1(W, _excluded$U), re = useUtilityClasses$I(W), Q = useFormControl(), ne = formControlState({
    props: W,
    muiFormControl: Q,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), oe = _extends$1({}, W, {
    color: ne.color || "primary",
    disabled: ne.disabled,
    error: ne.error,
    focused: ne.focused,
    formControl: Q,
    fullWidth: q,
    hiddenLabel: ne.hiddenLabel,
    multiline: J,
    size: ne.size,
    type: ee
  }), ae = (k = (D = X.root) != null ? D : U.Root) != null ? k : OutlinedInputRoot, se = (L = (V = X.input) != null ? V : U.Input) != null ? L : OutlinedInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase$1, _extends$1({
    slots: {
      root: ae,
      input: se
    },
    renderSuffix: (ie) => /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot, {
      ownerState: oe,
      className: re.notchedOutline,
      label: Y != null && Y !== "" && ne.required ? z || (z = /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [Y, " ", "*"]
      })) : Y,
      notched: typeof Z < "u" ? Z : !!(ie.startAdornment || ie.filled || ie.focused)
    }),
    fullWidth: q,
    inputComponent: K,
    multiline: J,
    ref: R,
    type: ee
  }, te, {
    classes: _extends$1({}, re, {
      notchedOutline: null
    })
  }));
});
define_process_env_default$L.NODE_ENV !== "production" && (OutlinedInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: PropTypes.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
OutlinedInput.muiName = "Input";
function getFormLabelUtilityClasses(T) {
  return generateUtilityClass$1("MuiFormLabel", T);
}
const formLabelClasses = generateUtilityClasses$1("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]);
var define_process_env_default$K = {};
const _excluded$T = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], useUtilityClasses$H = (T) => {
  const {
    classes: S,
    color: R,
    focused: k,
    disabled: D,
    error: L,
    filled: V,
    required: z
  } = T, W = {
    root: ["root", `color${capitalize$1(R)}`, D && "disabled", L && "error", V && "filled", k && "focused", z && "required"],
    asterisk: ["asterisk", L && "error"]
  };
  return composeClasses(W, getFormLabelUtilityClasses, S);
}, FormLabelRoot = styled("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: T
  }, S) => _extends$1({}, S.root, T.color === "secondary" && S.colorSecondary, T.filled && S.filled)
})(({
  theme: T,
  ownerState: S
}) => _extends$1({
  color: (T.vars || T).palette.text.secondary
}, T.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${formLabelClasses.focused}`]: {
    color: (T.vars || T).palette[S.color].main
  },
  [`&.${formLabelClasses.disabled}`]: {
    color: (T.vars || T).palette.text.disabled
  },
  [`&.${formLabelClasses.error}`]: {
    color: (T.vars || T).palette.error.main
  }
})), AsteriskComponent = styled("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (T, S) => S.asterisk
})(({
  theme: T
}) => ({
  [`&.${formLabelClasses.error}`]: {
    color: (T.vars || T).palette.error.main
  }
})), FormLabel = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiFormLabel"
  }), {
    children: D,
    className: L,
    component: V = "label"
  } = k, z = _objectWithoutPropertiesLoose$1(k, _excluded$T), W = useFormControl(), U = formControlState({
    props: k,
    muiFormControl: W,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), q = _extends$1({}, k, {
    color: U.color || "primary",
    component: V,
    disabled: U.disabled,
    error: U.error,
    filled: U.filled,
    focused: U.focused,
    required: U.required
  }), K = useUtilityClasses$H(q);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormLabelRoot, _extends$1({
    as: V,
    ownerState: q,
    className: clsx(K.root, L),
    ref: R
  }, z, {
    children: [D, U.required && /* @__PURE__ */ jsxRuntimeExports.jsxs(AsteriskComponent, {
      ownerState: q,
      "aria-hidden": !0,
      className: K.asterisk,
      children: [" ", "*"]
    })]
  }));
});
define_process_env_default$K.NODE_ENV !== "production" && (FormLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getInputLabelUtilityClasses(T) {
  return generateUtilityClass$1("MuiInputLabel", T);
}
generateUtilityClasses$1("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
var define_process_env_default$J = {};
const _excluded$S = ["disableAnimation", "margin", "shrink", "variant", "className"], useUtilityClasses$G = (T) => {
  const {
    classes: S,
    formControl: R,
    size: k,
    shrink: D,
    disableAnimation: L,
    variant: V,
    required: z
  } = T, W = {
    root: ["root", R && "formControl", !L && "animated", D && "shrink", k && k !== "normal" && `size${capitalize$1(k)}`, V],
    asterisk: [z && "asterisk"]
  }, U = composeClasses(W, getInputLabelUtilityClasses, S);
  return _extends$1({}, S, U);
}, InputLabelRoot = styled(FormLabel, {
  shouldForwardProp: (T) => rootShouldForwardProp(T) || T === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [{
      [`& .${formLabelClasses.asterisk}`]: S.asterisk
    }, S.root, R.formControl && S.formControl, R.size === "small" && S.sizeSmall, R.shrink && S.shrink, !R.disableAnimation && S.animated, R.focused && S.focused, S[R.variant]];
  }
})(({
  theme: T,
  ownerState: S
}) => _extends$1({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, S.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, S.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, S.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !S.disableAnimation && {
  transition: T.transitions.create(["color", "transform", "max-width"], {
    duration: T.transitions.duration.shorter,
    easing: T.transitions.easing.easeOut
  })
}, S.variant === "filled" && _extends$1({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, S.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, S.shrink && _extends$1({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, S.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), S.variant === "outlined" && _extends$1({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, S.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, S.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), InputLabel = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    name: "MuiInputLabel",
    props: S
  }), {
    disableAnimation: D = !1,
    shrink: L,
    className: V
  } = k, z = _objectWithoutPropertiesLoose$1(k, _excluded$S), W = useFormControl();
  let U = L;
  typeof U > "u" && W && (U = W.filled || W.focused || W.adornedStart);
  const q = formControlState({
    props: k,
    muiFormControl: W,
    states: ["size", "variant", "required", "focused"]
  }), K = _extends$1({}, k, {
    disableAnimation: D,
    formControl: W,
    shrink: U,
    size: q.size,
    variant: q.variant,
    required: q.required,
    focused: q.focused
  }), Y = useUtilityClasses$G(K);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabelRoot, _extends$1({
    "data-shrink": U,
    ownerState: K,
    ref: R,
    className: clsx(Y.root, V)
  }, z, {
    classes: Y
  }));
});
define_process_env_default$J.NODE_ENV !== "production" && (InputLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["normal", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
function getFormControlUtilityClasses(T) {
  return generateUtilityClass$1("MuiFormControl", T);
}
generateUtilityClasses$1("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
var define_process_env_default$I = {};
const _excluded$R = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], useUtilityClasses$F = (T) => {
  const {
    classes: S,
    margin: R,
    fullWidth: k
  } = T, D = {
    root: ["root", R !== "none" && `margin${capitalize$1(R)}`, k && "fullWidth"]
  };
  return composeClasses(D, getFormControlUtilityClasses, S);
}, FormControlRoot = styled("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: T
  }, S) => _extends$1({}, S.root, S[`margin${capitalize$1(T.margin)}`], T.fullWidth && S.fullWidth)
})(({
  ownerState: T
}) => _extends$1({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, T.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, T.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, T.fullWidth && {
  width: "100%"
})), FormControl = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiFormControl"
  }), {
    children: D,
    className: L,
    color: V = "primary",
    component: z = "div",
    disabled: W = !1,
    error: U = !1,
    focused: q,
    fullWidth: K = !1,
    hiddenLabel: Y = !1,
    margin: J = "none",
    required: Z = !1,
    size: X = "medium",
    variant: ee = "outlined"
  } = k, te = _objectWithoutPropertiesLoose$1(k, _excluded$R), re = _extends$1({}, k, {
    color: V,
    component: z,
    disabled: W,
    error: U,
    fullWidth: K,
    hiddenLabel: Y,
    margin: J,
    required: Z,
    size: X,
    variant: ee
  }), Q = useUtilityClasses$F(re), [ne, oe] = React$1.useState(() => {
    let ke = !1;
    return D && React$1.Children.forEach(D, (Te) => {
      if (!isMuiElement(Te, ["Input", "Select"]))
        return;
      const fe = isMuiElement(Te, ["Select"]) ? Te.props.input : Te;
      fe && isAdornedStart(fe.props) && (ke = !0);
    }), ke;
  }), [ae, se] = React$1.useState(() => {
    let ke = !1;
    return D && React$1.Children.forEach(D, (Te) => {
      isMuiElement(Te, ["Input", "Select"]) && (isFilled(Te.props, !0) || isFilled(Te.props.inputProps, !0)) && (ke = !0);
    }), ke;
  }), [ie, he] = React$1.useState(!1);
  W && ie && he(!1);
  const xe = q !== void 0 && !W ? q : ie;
  let Pe;
  if (define_process_env_default$I.NODE_ENV !== "production") {
    const ke = React$1.useRef(!1);
    Pe = () => (ke.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), ke.current = !0, () => {
      ke.current = !1;
    });
  }
  const Re = React$1.useMemo(() => ({
    adornedStart: ne,
    setAdornedStart: oe,
    color: V,
    disabled: W,
    error: U,
    filled: ae,
    focused: xe,
    fullWidth: K,
    hiddenLabel: Y,
    size: X,
    onBlur: () => {
      he(!1);
    },
    onEmpty: () => {
      se(!1);
    },
    onFilled: () => {
      se(!0);
    },
    onFocus: () => {
      he(!0);
    },
    registerEffect: Pe,
    required: Z,
    variant: ee
  }), [ne, V, W, U, ae, xe, K, Y, Pe, Z, X, ee]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
    value: Re,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlRoot, _extends$1({
      as: z,
      ownerState: re,
      className: clsx(Q.root, L),
      ref: R
    }, te, {
      children: D
    }))
  });
});
define_process_env_default$I.NODE_ENV !== "production" && (FormControl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
function getFormHelperTextUtilityClasses(T) {
  return generateUtilityClass$1("MuiFormHelperText", T);
}
const formHelperTextClasses = generateUtilityClasses$1("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var define_process_env_default$H = {}, _span$2;
const _excluded$Q = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], useUtilityClasses$E = (T) => {
  const {
    classes: S,
    contained: R,
    size: k,
    disabled: D,
    error: L,
    filled: V,
    focused: z,
    required: W
  } = T, U = {
    root: ["root", D && "disabled", L && "error", k && `size${capitalize$1(k)}`, R && "contained", z && "focused", V && "filled", W && "required"]
  };
  return composeClasses(U, getFormHelperTextUtilityClasses, S);
}, FormHelperTextRoot = styled("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.root, R.size && S[`size${capitalize$1(R.size)}`], R.contained && S.contained, R.filled && S.filled];
  }
})(({
  theme: T,
  ownerState: S
}) => _extends$1({
  color: (T.vars || T).palette.text.secondary
}, T.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${formHelperTextClasses.disabled}`]: {
    color: (T.vars || T).palette.text.disabled
  },
  [`&.${formHelperTextClasses.error}`]: {
    color: (T.vars || T).palette.error.main
  }
}, S.size === "small" && {
  marginTop: 4
}, S.contained && {
  marginLeft: 14,
  marginRight: 14
})), FormHelperText = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiFormHelperText"
  }), {
    children: D,
    className: L,
    component: V = "p"
  } = k, z = _objectWithoutPropertiesLoose$1(k, _excluded$Q), W = useFormControl(), U = formControlState({
    props: k,
    muiFormControl: W,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), q = _extends$1({}, k, {
    component: V,
    contained: U.variant === "filled" || U.variant === "outlined",
    variant: U.variant,
    size: U.size,
    disabled: U.disabled,
    error: U.error,
    filled: U.filled,
    focused: U.focused,
    required: U.required
  }), K = useUtilityClasses$E(q);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperTextRoot, _extends$1({
    as: V,
    ownerState: q,
    className: clsx(K.root, L),
    ref: R
  }, z, {
    children: D === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      _span$2 || (_span$2 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : D
  }));
});
define_process_env_default$H.NODE_ENV !== "production" && (FormHelperText.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined", "standard"]), PropTypes.string])
});
const reflow = (T) => T.scrollTop;
function getTransitionProps(T, S) {
  var R, k;
  const {
    timeout: D,
    easing: L,
    style: V = {}
  } = T;
  return {
    duration: (R = V.transitionDuration) != null ? R : typeof D == "number" ? D : D[S.mode] || 0,
    easing: (k = V.transitionTimingFunction) != null ? k : typeof L == "object" ? L[S.mode] : L,
    delay: V.transitionDelay
  };
}
var define_process_env_default$G = {};
const _excluded$P = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function getScale(T) {
  return `scale(${T}, ${T ** 2})`;
}
const styles$1 = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, isWebKit154 = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Grow = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const {
    addEndListener: k,
    appear: D = !0,
    children: L,
    easing: V,
    in: z,
    onEnter: W,
    onEntered: U,
    onEntering: q,
    onExit: K,
    onExited: Y,
    onExiting: J,
    style: Z,
    timeout: X = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: ee = Transition
  } = S, te = _objectWithoutPropertiesLoose$1(S, _excluded$P), re = useTimeout(), Q = React$1.useRef(), ne = useTheme$1(), oe = React$1.useRef(null), ae = useForkRef(oe, L.ref, R), se = (fe) => (ue) => {
    if (fe) {
      const Ce = oe.current;
      ue === void 0 ? fe(Ce) : fe(Ce, ue);
    }
  }, ie = se(q), he = se((fe, ue) => {
    reflow(fe);
    const {
      duration: Ce,
      delay: ce,
      easing: pe
    } = getTransitionProps({
      style: Z,
      timeout: X,
      easing: V
    }, {
      mode: "enter"
    });
    let _e;
    X === "auto" ? (_e = ne.transitions.getAutoHeightDuration(fe.clientHeight), Q.current = _e) : _e = Ce, fe.style.transition = [ne.transitions.create("opacity", {
      duration: _e,
      delay: ce
    }), ne.transitions.create("transform", {
      duration: isWebKit154 ? _e : _e * 0.666,
      delay: ce,
      easing: pe
    })].join(","), W && W(fe, ue);
  }), xe = se(U), Pe = se(J), Re = se((fe) => {
    const {
      duration: ue,
      delay: Ce,
      easing: ce
    } = getTransitionProps({
      style: Z,
      timeout: X,
      easing: V
    }, {
      mode: "exit"
    });
    let pe;
    X === "auto" ? (pe = ne.transitions.getAutoHeightDuration(fe.clientHeight), Q.current = pe) : pe = ue, fe.style.transition = [ne.transitions.create("opacity", {
      duration: pe,
      delay: Ce
    }), ne.transitions.create("transform", {
      duration: isWebKit154 ? pe : pe * 0.666,
      delay: isWebKit154 ? Ce : Ce || pe * 0.333,
      easing: ce
    })].join(","), fe.style.opacity = 0, fe.style.transform = getScale(0.75), K && K(fe);
  }), ke = se(Y), Te = (fe) => {
    X === "auto" && re.start(Q.current || 0, fe), k && k(oe.current, fe);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ee, _extends$1({
    appear: D,
    in: z,
    nodeRef: oe,
    onEnter: he,
    onEntered: xe,
    onEntering: ie,
    onExit: Re,
    onExited: ke,
    onExiting: Pe,
    addEndListener: Te,
    timeout: X === "auto" ? null : X
  }, te, {
    children: (fe, ue) => /* @__PURE__ */ React$1.cloneElement(L, _extends$1({
      style: _extends$1({
        opacity: 0,
        transform: getScale(0.75),
        visibility: fe === "exited" && !z ? "hidden" : void 0
      }, styles$1[fe], Z, L.props.style),
      ref: ae
    }, ue))
  }));
});
define_process_env_default$G.NODE_ENV !== "production" && (Grow.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
Grow.muiSupportAuto = !0;
var define_process_env_default$F = {};
const _excluded$O = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Fade = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useTheme$1(), D = {
    enter: k.transitions.duration.enteringScreen,
    exit: k.transitions.duration.leavingScreen
  }, {
    addEndListener: L,
    appear: V = !0,
    children: z,
    easing: W,
    in: U,
    onEnter: q,
    onEntered: K,
    onEntering: Y,
    onExit: J,
    onExited: Z,
    onExiting: X,
    style: ee,
    timeout: te = D,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: re = Transition
  } = S, Q = _objectWithoutPropertiesLoose$1(S, _excluded$O), ne = React$1.useRef(null), oe = useForkRef(ne, z.ref, R), ae = (Te) => (fe) => {
    if (Te) {
      const ue = ne.current;
      fe === void 0 ? Te(ue) : Te(ue, fe);
    }
  }, se = ae(Y), ie = ae((Te, fe) => {
    reflow(Te);
    const ue = getTransitionProps({
      style: ee,
      timeout: te,
      easing: W
    }, {
      mode: "enter"
    });
    Te.style.webkitTransition = k.transitions.create("opacity", ue), Te.style.transition = k.transitions.create("opacity", ue), q && q(Te, fe);
  }), he = ae(K), xe = ae(X), Pe = ae((Te) => {
    const fe = getTransitionProps({
      style: ee,
      timeout: te,
      easing: W
    }, {
      mode: "exit"
    });
    Te.style.webkitTransition = k.transitions.create("opacity", fe), Te.style.transition = k.transitions.create("opacity", fe), J && J(Te);
  }), Re = ae(Z), ke = (Te) => {
    L && L(ne.current, Te);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(re, _extends$1({
    appear: V,
    in: U,
    nodeRef: ne,
    onEnter: ie,
    onEntered: he,
    onEntering: se,
    onExit: Pe,
    onExited: Re,
    onExiting: xe,
    addEndListener: ke,
    timeout: te
  }, Q, {
    children: (Te, fe) => /* @__PURE__ */ React$1.cloneElement(z, _extends$1({
      style: _extends$1({
        opacity: 0,
        visibility: Te === "exited" && !U ? "hidden" : void 0
      }, styles[Te], ee, z.props.style),
      ref: oe
    }, fe))
  }));
});
define_process_env_default$F.NODE_ENV !== "production" && (Fade.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
function getBackdropUtilityClass(T) {
  return generateUtilityClass$1("MuiBackdrop", T);
}
generateUtilityClasses$1("MuiBackdrop", ["root", "invisible"]);
var define_process_env_default$E = {};
const _excluded$N = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], useUtilityClasses$D = (T) => {
  const {
    classes: S,
    invisible: R
  } = T;
  return composeClasses({
    root: ["root", R && "invisible"]
  }, getBackdropUtilityClass, S);
}, BackdropRoot = styled("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.root, R.invisible && S.invisible];
  }
})(({
  ownerState: T
}) => _extends$1({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, T.invisible && {
  backgroundColor: "transparent"
})), Backdrop = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k, D, L;
  const V = useDefaultProps({
    props: S,
    name: "MuiBackdrop"
  }), {
    children: z,
    className: W,
    component: U = "div",
    components: q = {},
    componentsProps: K = {},
    invisible: Y = !1,
    open: J,
    slotProps: Z = {},
    slots: X = {},
    TransitionComponent: ee = Fade,
    transitionDuration: te
  } = V, re = _objectWithoutPropertiesLoose$1(V, _excluded$N), Q = _extends$1({}, V, {
    component: U,
    invisible: Y
  }), ne = useUtilityClasses$D(Q), oe = (k = Z.root) != null ? k : K.root;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ee, _extends$1({
    in: J,
    timeout: te
  }, re, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(BackdropRoot, _extends$1({
      "aria-hidden": !0
    }, oe, {
      as: (D = (L = X.root) != null ? L : q.Root) != null ? D : U,
      className: clsx(ne.root, W, oe?.className),
      ownerState: _extends$1({}, Q, oe?.ownerState),
      classes: ne,
      ref: R,
      children: z
    }))
  }));
});
define_process_env_default$E.NODE_ENV !== "production" && (Backdrop.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
function getModalUtilityClass(T) {
  return generateUtilityClass$1("MuiModal", T);
}
generateUtilityClasses$1("MuiModal", ["root", "hidden", "backdrop"]);
var define_process_env_default$D = {};
const _excluded$M = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], useUtilityClasses$C = (T) => {
  const {
    open: S,
    exited: R,
    classes: k
  } = T;
  return composeClasses({
    root: ["root", !S && R && "hidden"],
    backdrop: ["backdrop"]
  }, getModalUtilityClass, k);
}, ModalRoot = styled("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.root, !R.open && R.exited && S.hidden];
  }
})(({
  theme: T,
  ownerState: S
}) => _extends$1({
  position: "fixed",
  zIndex: (T.vars || T).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !S.open && S.exited && {
  visibility: "hidden"
})), ModalBackdrop = styled(Backdrop, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (T, S) => S.backdrop
})({
  zIndex: -1
}), Modal$2 = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k, D, L, V, z, W;
  const U = useDefaultProps({
    name: "MuiModal",
    props: S
  }), {
    BackdropComponent: q = ModalBackdrop,
    BackdropProps: K,
    className: Y,
    closeAfterTransition: J = !1,
    children: Z,
    container: X,
    component: ee,
    components: te = {},
    componentsProps: re = {},
    disableAutoFocus: Q = !1,
    disableEnforceFocus: ne = !1,
    disableEscapeKeyDown: oe = !1,
    disablePortal: ae = !1,
    disableRestoreFocus: se = !1,
    disableScrollLock: ie = !1,
    hideBackdrop: he = !1,
    keepMounted: xe = !1,
    onBackdropClick: Pe,
    open: Re,
    slotProps: ke,
    slots: Te
    // eslint-disable-next-line react/prop-types
  } = U, fe = _objectWithoutPropertiesLoose$1(U, _excluded$M), ue = _extends$1({}, U, {
    closeAfterTransition: J,
    disableAutoFocus: Q,
    disableEnforceFocus: ne,
    disableEscapeKeyDown: oe,
    disablePortal: ae,
    disableRestoreFocus: se,
    disableScrollLock: ie,
    hideBackdrop: he,
    keepMounted: xe
  }), {
    getRootProps: Ce,
    getBackdropProps: ce,
    getTransitionProps: pe,
    portalRef: _e,
    isTopModal: ge,
    exited: Ae,
    hasTransition: Ee
  } = useModal(_extends$1({}, ue, {
    rootRef: R
  })), ve = _extends$1({}, ue, {
    exited: Ae
  }), le = useUtilityClasses$C(ve), me = {};
  if (Z.props.tabIndex === void 0 && (me.tabIndex = "-1"), Ee) {
    const {
      onEnter: we,
      onExited: Fe
    } = pe();
    me.onEnter = we, me.onExited = Fe;
  }
  const Se = (k = (D = Te?.root) != null ? D : te.Root) != null ? k : ModalRoot, ye = (L = (V = Te?.backdrop) != null ? V : te.Backdrop) != null ? L : q, be = (z = ke?.root) != null ? z : re.root, $e = (W = ke?.backdrop) != null ? W : re.backdrop, Oe = useSlotProps({
    elementType: Se,
    externalSlotProps: be,
    externalForwardedProps: fe,
    getSlotProps: Ce,
    additionalProps: {
      ref: R,
      as: ee
    },
    ownerState: ve,
    className: clsx(Y, be?.className, le?.root, !ve.open && ve.exited && le?.hidden)
  }), Ie = useSlotProps({
    elementType: ye,
    externalSlotProps: $e,
    additionalProps: K,
    getSlotProps: (we) => ce(_extends$1({}, we, {
      onClick: (Fe) => {
        Pe && Pe(Fe), we != null && we.onClick && we.onClick(Fe);
      }
    })),
    className: clsx($e?.className, K?.className, le?.backdrop),
    ownerState: ve
  });
  return !xe && !Re && (!Ee || Ae) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    ref: _e,
    container: X,
    disablePortal: ae,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Se, _extends$1({}, Oe, {
      children: [!he && q ? /* @__PURE__ */ jsxRuntimeExports.jsx(ye, _extends$1({}, Ie)) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap, {
        disableEnforceFocus: ne,
        disableAutoFocus: Q,
        disableRestoreFocus: se,
        isEnabled: ge,
        open: Re,
        children: /* @__PURE__ */ React$1.cloneElement(Z, me)
      })]
    }))
  });
});
define_process_env_default$D.NODE_ENV !== "production" && (Modal$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: PropTypes.object,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Backdrop: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getPaperUtilityClass(T) {
  return generateUtilityClass$1("MuiPaper", T);
}
generateUtilityClasses$1("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
var define_process_env_default$C = {};
const _excluded$L = ["className", "component", "elevation", "square", "variant"], useUtilityClasses$B = (T) => {
  const {
    square: S,
    elevation: R,
    variant: k,
    classes: D
  } = T, L = {
    root: ["root", k, !S && "rounded", k === "elevation" && `elevation${R}`]
  };
  return composeClasses(L, getPaperUtilityClass, D);
}, PaperRoot = styled("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.root, S[R.variant], !R.square && S.rounded, R.variant === "elevation" && S[`elevation${R.elevation}`]];
  }
})(({
  theme: T,
  ownerState: S
}) => {
  var R;
  return _extends$1({
    backgroundColor: (T.vars || T).palette.background.paper,
    color: (T.vars || T).palette.text.primary,
    transition: T.transitions.create("box-shadow")
  }, !S.square && {
    borderRadius: T.shape.borderRadius
  }, S.variant === "outlined" && {
    border: `1px solid ${(T.vars || T).palette.divider}`
  }, S.variant === "elevation" && _extends$1({
    boxShadow: (T.vars || T).shadows[S.elevation]
  }, !T.vars && T.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${alpha_1("#fff", getOverlayAlpha(S.elevation))}, ${alpha_1("#fff", getOverlayAlpha(S.elevation))})`
  }, T.vars && {
    backgroundImage: (R = T.vars.overlays) == null ? void 0 : R[S.elevation]
  }));
}), Paper = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiPaper"
  }), {
    className: D,
    component: L = "div",
    elevation: V = 1,
    square: z = !1,
    variant: W = "elevation"
  } = k, U = _objectWithoutPropertiesLoose$1(k, _excluded$L), q = _extends$1({}, k, {
    component: L,
    elevation: V,
    square: z,
    variant: W
  }), K = useUtilityClasses$B(q);
  return define_process_env_default$C.NODE_ENV !== "production" && useTheme$1().shadows[V] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${V}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${V}]\` is defined.`].join(`
`)), /* @__PURE__ */ jsxRuntimeExports.jsx(PaperRoot, _extends$1({
    as: L,
    ownerState: q,
    className: clsx(K.root, D),
    ref: R
  }, U));
});
define_process_env_default$C.NODE_ENV !== "production" && (Paper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes(integerPropType, (T) => {
    const {
      elevation: S,
      variant: R
    } = T;
    return S > 0 && R === "outlined" ? new Error(`MUI: Combining \`elevation={${S}}\` with \`variant="${R}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["elevation", "outlined"]), PropTypes.string])
});
function getPopoverUtilityClass(T) {
  return generateUtilityClass$1("MuiPopover", T);
}
generateUtilityClasses$1("MuiPopover", ["root", "paper"]);
var define_process_env_default$B = {};
const _excluded$K = ["onEntering"], _excluded2$9 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], _excluded3$2 = ["slotProps"];
function getOffsetTop(T, S) {
  let R = 0;
  return typeof S == "number" ? R = S : S === "center" ? R = T.height / 2 : S === "bottom" && (R = T.height), R;
}
function getOffsetLeft(T, S) {
  let R = 0;
  return typeof S == "number" ? R = S : S === "center" ? R = T.width / 2 : S === "right" && (R = T.width), R;
}
function getTransformOriginValue(T) {
  return [T.horizontal, T.vertical].map((S) => typeof S == "number" ? `${S}px` : S).join(" ");
}
function resolveAnchorEl(T) {
  return typeof T == "function" ? T() : T;
}
const useUtilityClasses$A = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    paper: ["paper"]
  }, getPopoverUtilityClass, S);
}, PopoverRoot = styled(Modal$2, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({}), PopoverPaper = styled(Paper, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (T, S) => S.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Popover = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k, D, L;
  const V = useDefaultProps({
    props: S,
    name: "MuiPopover"
  }), {
    action: z,
    anchorEl: W,
    anchorOrigin: U = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: q,
    anchorReference: K = "anchorEl",
    children: Y,
    className: J,
    container: Z,
    elevation: X = 8,
    marginThreshold: ee = 16,
    open: te,
    PaperProps: re = {},
    slots: Q,
    slotProps: ne,
    transformOrigin: oe = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: ae = Grow,
    transitionDuration: se = "auto",
    TransitionProps: {
      onEntering: ie
    } = {},
    disableScrollLock: he = !1
  } = V, xe = _objectWithoutPropertiesLoose$1(V.TransitionProps, _excluded$K), Pe = _objectWithoutPropertiesLoose$1(V, _excluded2$9), Re = (k = ne?.paper) != null ? k : re, ke = React$1.useRef(), Te = useForkRef(ke, Re.ref), fe = _extends$1({}, V, {
    anchorOrigin: U,
    anchorReference: K,
    elevation: X,
    marginThreshold: ee,
    externalPaperSlotProps: Re,
    transformOrigin: oe,
    TransitionComponent: ae,
    transitionDuration: se,
    TransitionProps: xe
  }), ue = useUtilityClasses$A(fe), Ce = React$1.useCallback(() => {
    if (K === "anchorPosition")
      return define_process_env_default$B.NODE_ENV !== "production" && (q || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), q;
    const we = resolveAnchorEl(W), Fe = we && we.nodeType === 1 ? we : ownerDocument(ke.current).body, De = Fe.getBoundingClientRect();
    if (define_process_env_default$B.NODE_ENV !== "production") {
      const Le = Fe.getBoundingClientRect();
      define_process_env_default$B.NODE_ENV !== "test" && Le.top === 0 && Le.left === 0 && Le.right === 0 && Le.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: De.top + getOffsetTop(De, U.vertical),
      left: De.left + getOffsetLeft(De, U.horizontal)
    };
  }, [W, U.horizontal, U.vertical, q, K]), ce = React$1.useCallback((we) => ({
    vertical: getOffsetTop(we, oe.vertical),
    horizontal: getOffsetLeft(we, oe.horizontal)
  }), [oe.horizontal, oe.vertical]), pe = React$1.useCallback((we) => {
    const Fe = {
      width: we.offsetWidth,
      height: we.offsetHeight
    }, De = ce(Fe);
    if (K === "none")
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(De)
      };
    const Le = Ce();
    let ze = Le.top - De.vertical, We = Le.left - De.horizontal;
    const Be = ze + Fe.height, Ye = We + Fe.width, Ge = ownerWindow(resolveAnchorEl(W)), nt = Ge.innerHeight - ee, Ze = Ge.innerWidth - ee;
    if (ee !== null && ze < ee) {
      const Me = ze - ee;
      ze -= Me, De.vertical += Me;
    } else if (ee !== null && Be > nt) {
      const Me = Be - nt;
      ze -= Me, De.vertical += Me;
    }
    if (define_process_env_default$B.NODE_ENV !== "production" && Fe.height > nt && Fe.height && nt && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${Fe.height - nt}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), ee !== null && We < ee) {
      const Me = We - ee;
      We -= Me, De.horizontal += Me;
    } else if (Ye > Ze) {
      const Me = Ye - Ze;
      We -= Me, De.horizontal += Me;
    }
    return {
      top: `${Math.round(ze)}px`,
      left: `${Math.round(We)}px`,
      transformOrigin: getTransformOriginValue(De)
    };
  }, [W, K, Ce, ce, ee]), [_e, ge] = React$1.useState(te), Ae = React$1.useCallback(() => {
    const we = ke.current;
    if (!we)
      return;
    const Fe = pe(we);
    Fe.top !== null && (we.style.top = Fe.top), Fe.left !== null && (we.style.left = Fe.left), we.style.transformOrigin = Fe.transformOrigin, ge(!0);
  }, [pe]);
  React$1.useEffect(() => (he && window.addEventListener("scroll", Ae), () => window.removeEventListener("scroll", Ae)), [W, he, Ae]);
  const Ee = (we, Fe) => {
    ie && ie(we, Fe), Ae();
  }, ve = () => {
    ge(!1);
  };
  React$1.useEffect(() => {
    te && Ae();
  }), React$1.useImperativeHandle(z, () => te ? {
    updatePosition: () => {
      Ae();
    }
  } : null, [te, Ae]), React$1.useEffect(() => {
    if (!te)
      return;
    const we = debounce$1(() => {
      Ae();
    }), Fe = ownerWindow(W);
    return Fe.addEventListener("resize", we), () => {
      we.clear(), Fe.removeEventListener("resize", we);
    };
  }, [W, te, Ae]);
  let le = se;
  se === "auto" && !ae.muiSupportAuto && (le = void 0);
  const me = Z || (W ? ownerDocument(resolveAnchorEl(W)).body : void 0), Se = (D = Q?.root) != null ? D : PopoverRoot, ye = (L = Q?.paper) != null ? L : PopoverPaper, be = useSlotProps({
    elementType: ye,
    externalSlotProps: _extends$1({}, Re, {
      style: _e ? Re.style : _extends$1({}, Re.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: X,
      ref: Te
    },
    ownerState: fe,
    className: clsx(ue.paper, Re?.className)
  }), $e = useSlotProps({
    elementType: Se,
    externalSlotProps: ne?.root || {},
    externalForwardedProps: Pe,
    additionalProps: {
      ref: R,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: me,
      open: te
    },
    ownerState: fe,
    className: clsx(ue.root, J)
  }), {
    slotProps: Oe
  } = $e, Ie = _objectWithoutPropertiesLoose$1($e, _excluded3$2);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Se, _extends$1({}, Ie, !isHostComponent(Se) && {
    slotProps: Oe,
    disableScrollLock: he
  }, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ae, _extends$1({
      appear: !0,
      in: te,
      onEntering: Ee,
      onExited: ve,
      timeout: le
    }, xe, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ye, _extends$1({}, be, {
        children: Y
      }))
    }))
  }));
});
define_process_env_default$B.NODE_ENV !== "production" && (Popover.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), (T) => {
    if (T.open && (!T.anchorReference || T.anchorReference === "anchorEl")) {
      const S = resolveAnchorEl(T.anchorEl);
      if (S && S.nodeType === 1) {
        const R = S.getBoundingClientRect();
        if (define_process_env_default$B.NODE_ENV !== "test" && R.top === 0 && R.left === 0 && R.right === 0 && R.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${S}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: PropTypes.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: integerPropType,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef$1
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object
});
function getMenuUtilityClass(T) {
  return generateUtilityClass$1("MuiMenu", T);
}
generateUtilityClasses$1("MuiMenu", ["root", "paper", "list"]);
var define_process_env_default$A = {};
const _excluded$J = ["onEntering"], _excluded2$8 = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], RTL_ORIGIN = {
  vertical: "top",
  horizontal: "right"
}, LTR_ORIGIN = {
  vertical: "top",
  horizontal: "left"
}, useUtilityClasses$z = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, getMenuUtilityClass, S);
}, MenuRoot = styled(Popover, {
  shouldForwardProp: (T) => rootShouldForwardProp(T) || T === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({}), MenuPaper = styled(PopoverPaper, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (T, S) => S.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), MenuMenuList = styled(MenuList, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (T, S) => S.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Menu = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k, D;
  const L = useDefaultProps({
    props: S,
    name: "MuiMenu"
  }), {
    autoFocus: V = !0,
    children: z,
    className: W,
    disableAutoFocusItem: U = !1,
    MenuListProps: q = {},
    onClose: K,
    open: Y,
    PaperProps: J = {},
    PopoverClasses: Z,
    transitionDuration: X = "auto",
    TransitionProps: {
      onEntering: ee
    } = {},
    variant: te = "selectedMenu",
    slots: re = {},
    slotProps: Q = {}
  } = L, ne = _objectWithoutPropertiesLoose$1(L.TransitionProps, _excluded$J), oe = _objectWithoutPropertiesLoose$1(L, _excluded2$8), ae = useRtl(), se = _extends$1({}, L, {
    autoFocus: V,
    disableAutoFocusItem: U,
    MenuListProps: q,
    onEntering: ee,
    PaperProps: J,
    transitionDuration: X,
    TransitionProps: ne,
    variant: te
  }), ie = useUtilityClasses$z(se), he = V && !U && Y, xe = React$1.useRef(null), Pe = (ce, pe) => {
    xe.current && xe.current.adjustStyleForScrollbar(ce, {
      direction: ae ? "rtl" : "ltr"
    }), ee && ee(ce, pe);
  }, Re = (ce) => {
    ce.key === "Tab" && (ce.preventDefault(), K && K(ce, "tabKeyDown"));
  };
  let ke = -1;
  React$1.Children.map(z, (ce, pe) => {
    /* @__PURE__ */ React$1.isValidElement(ce) && (define_process_env_default$A.NODE_ENV !== "production" && reactIsExports.isFragment(ce) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), ce.props.disabled || (te === "selectedMenu" && ce.props.selected || ke === -1) && (ke = pe));
  });
  const Te = (k = re.paper) != null ? k : MenuPaper, fe = (D = Q.paper) != null ? D : J, ue = useSlotProps({
    elementType: re.root,
    externalSlotProps: Q.root,
    ownerState: se,
    className: [ie.root, W]
  }), Ce = useSlotProps({
    elementType: Te,
    externalSlotProps: fe,
    ownerState: se,
    className: ie.paper
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuRoot, _extends$1({
    onClose: K,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: ae ? "right" : "left"
    },
    transformOrigin: ae ? RTL_ORIGIN : LTR_ORIGIN,
    slots: {
      paper: Te,
      root: re.root
    },
    slotProps: {
      root: ue,
      paper: Ce
    },
    open: Y,
    ref: R,
    transitionDuration: X,
    TransitionProps: _extends$1({
      onEntering: Pe
    }, ne),
    ownerState: se
  }, oe, {
    classes: Z,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuMenuList, _extends$1({
      onKeyDown: Re,
      actions: xe,
      autoFocus: V && (ke === -1 || U),
      autoFocusItem: he,
      variant: te
    }, q, {
      className: clsx(ie.list, q.className),
      children: z
    }))
  }));
});
define_process_env_default$A.NODE_ENV !== "production" && (Menu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: PropTypes.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: PropTypes.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: PropTypes.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
function getNativeSelectUtilityClasses(T) {
  return generateUtilityClass$1("MuiNativeSelect", T);
}
const nativeSelectClasses = generateUtilityClasses$1("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var define_process_env_default$z = {};
const _excluded$I = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], useUtilityClasses$y = (T) => {
  const {
    classes: S,
    variant: R,
    disabled: k,
    multiple: D,
    open: L,
    error: V
  } = T, z = {
    select: ["select", R, k && "disabled", D && "multiple", V && "error"],
    icon: ["icon", `icon${capitalize$1(R)}`, L && "iconOpen", k && "disabled"]
  };
  return composeClasses(z, getNativeSelectUtilityClasses, S);
}, nativeSelectSelectStyles = ({
  ownerState: T,
  theme: S
}) => _extends$1({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": _extends$1({}, S.vars ? {
    backgroundColor: `rgba(${S.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: S.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${nativeSelectClasses.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (S.vars || S).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, T.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, T.variant === "outlined" && {
  borderRadius: (S.vars || S).shape.borderRadius,
  "&:focus": {
    borderRadius: (S.vars || S).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), NativeSelectSelect = styled("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: rootShouldForwardProp,
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.select, S[R.variant], R.error && S.error, {
      [`&.${nativeSelectClasses.multiple}`]: S.multiple
    }];
  }
})(nativeSelectSelectStyles), nativeSelectIconStyles = ({
  ownerState: T,
  theme: S
}) => _extends$1({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (S.vars || S).palette.action.active,
  [`&.${nativeSelectClasses.disabled}`]: {
    color: (S.vars || S).palette.action.disabled
  }
}, T.open && {
  transform: "rotate(180deg)"
}, T.variant === "filled" && {
  right: 7
}, T.variant === "outlined" && {
  right: 7
}), NativeSelectIcon = styled("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.icon, R.variant && S[`icon${capitalize$1(R.variant)}`], R.open && S.iconOpen];
  }
})(nativeSelectIconStyles), NativeSelectInput = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const {
    className: k,
    disabled: D,
    error: L,
    IconComponent: V,
    inputRef: z,
    variant: W = "standard"
  } = S, U = _objectWithoutPropertiesLoose$1(S, _excluded$I), q = _extends$1({}, S, {
    disabled: D,
    variant: W,
    error: L
  }), K = useUtilityClasses$y(q);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectSelect, _extends$1({
      ownerState: q,
      className: clsx(K.select, k),
      disabled: D,
      ref: z || R
    }, U)), S.multiple ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectIcon, {
      as: V,
      ownerState: q,
      className: K.icon
    })]
  });
});
define_process_env_default$z.NODE_ENV !== "production" && (NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType,
  /**
   * @ignore
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
function getSelectUtilityClasses(T) {
  return generateUtilityClass$1("MuiSelect", T);
}
const selectClasses = generateUtilityClasses$1("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var define_process_env_default$y = {}, _span$1;
const _excluded$H = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], SelectSelect = styled("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [
      // Win specificity over the input base
      {
        [`&.${selectClasses.select}`]: S.select
      },
      {
        [`&.${selectClasses.select}`]: S[R.variant]
      },
      {
        [`&.${selectClasses.error}`]: S.error
      },
      {
        [`&.${selectClasses.multiple}`]: S.multiple
      }
    ];
  }
})(nativeSelectSelectStyles, {
  // Win specificity over the input base
  [`&.${selectClasses.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), SelectIcon = styled("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.icon, R.variant && S[`icon${capitalize$1(R.variant)}`], R.open && S.iconOpen];
  }
})(nativeSelectIconStyles), SelectNativeInput = styled("input", {
  shouldForwardProp: (T) => slotShouldForwardProp(T) && T !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (T, S) => S.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function areEqualValues(T, S) {
  return typeof S == "object" && S !== null ? T === S : String(T) === String(S);
}
function isEmpty(T) {
  return T == null || typeof T == "string" && !T.trim();
}
const useUtilityClasses$x = (T) => {
  const {
    classes: S,
    variant: R,
    disabled: k,
    multiple: D,
    open: L,
    error: V
  } = T, z = {
    select: ["select", R, k && "disabled", D && "multiple", V && "error"],
    icon: ["icon", `icon${capitalize$1(R)}`, L && "iconOpen", k && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return composeClasses(z, getSelectUtilityClasses, S);
}, SelectInput = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k;
  const {
    "aria-describedby": D,
    "aria-label": L,
    autoFocus: V,
    autoWidth: z,
    children: W,
    className: U,
    defaultOpen: q,
    defaultValue: K,
    disabled: Y,
    displayEmpty: J,
    error: Z = !1,
    IconComponent: X,
    inputRef: ee,
    labelId: te,
    MenuProps: re = {},
    multiple: Q,
    name: ne,
    onBlur: oe,
    onChange: ae,
    onClose: se,
    onFocus: ie,
    onOpen: he,
    open: xe,
    readOnly: Pe,
    renderValue: Re,
    SelectDisplayProps: ke = {},
    tabIndex: Te,
    value: fe,
    variant: ue = "standard"
  } = S, Ce = _objectWithoutPropertiesLoose$1(S, _excluded$H), [ce, pe] = useControlled({
    controlled: fe,
    default: K,
    name: "Select"
  }), [_e, ge] = useControlled({
    controlled: xe,
    default: q,
    name: "Select"
  }), Ae = React$1.useRef(null), Ee = React$1.useRef(null), [ve, le] = React$1.useState(null), {
    current: me
  } = React$1.useRef(xe != null), [Se, ye] = React$1.useState(), be = useForkRef(R, ee), $e = React$1.useCallback((Qe) => {
    Ee.current = Qe, Qe && le(Qe);
  }, []), Oe = ve?.parentNode;
  React$1.useImperativeHandle(be, () => ({
    focus: () => {
      Ee.current.focus();
    },
    node: Ae.current,
    value: ce
  }), [ce]), React$1.useEffect(() => {
    q && _e && ve && !me && (ye(z ? null : Oe.clientWidth), Ee.current.focus());
  }, [ve, z]), React$1.useEffect(() => {
    V && Ee.current.focus();
  }, [V]), React$1.useEffect(() => {
    if (!te)
      return;
    const Qe = ownerDocument(Ee.current).getElementById(te);
    if (Qe) {
      const ut = () => {
        getSelection().isCollapsed && Ee.current.focus();
      };
      return Qe.addEventListener("click", ut), () => {
        Qe.removeEventListener("click", ut);
      };
    }
  }, [te]);
  const Ie = (Qe, ut) => {
    Qe ? he && he(ut) : se && se(ut), me || (ye(z ? null : Oe.clientWidth), ge(Qe));
  }, we = (Qe) => {
    Qe.button === 0 && (Qe.preventDefault(), Ee.current.focus(), Ie(!0, Qe));
  }, Fe = (Qe) => {
    Ie(!1, Qe);
  }, De = React$1.Children.toArray(W), Le = (Qe) => {
    const ut = De.find((ft) => ft.props.value === Qe.target.value);
    ut !== void 0 && (pe(ut.props.value), ae && ae(Qe, ut));
  }, ze = (Qe) => (ut) => {
    let ft;
    if (ut.currentTarget.hasAttribute("tabindex")) {
      if (Q) {
        ft = Array.isArray(ce) ? ce.slice() : [];
        const vt = ce.indexOf(Qe.props.value);
        vt === -1 ? ft.push(Qe.props.value) : ft.splice(vt, 1);
      } else
        ft = Qe.props.value;
      if (Qe.props.onClick && Qe.props.onClick(ut), ce !== ft && (pe(ft), ae)) {
        const vt = ut.nativeEvent || ut, dt = new vt.constructor(vt.type, vt);
        Object.defineProperty(dt, "target", {
          writable: !0,
          value: {
            value: ft,
            name: ne
          }
        }), ae(dt, Qe);
      }
      Q || Ie(!1, ut);
    }
  }, We = (Qe) => {
    Pe || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(Qe.key) !== -1 && (Qe.preventDefault(), Ie(!0, Qe));
  }, Be = ve !== null && _e, Ye = (Qe) => {
    !Be && oe && (Object.defineProperty(Qe, "target", {
      writable: !0,
      value: {
        value: ce,
        name: ne
      }
    }), oe(Qe));
  };
  delete Ce["aria-invalid"];
  let Ge, nt;
  const Ze = [];
  let Me = !1, Ne = !1;
  (isFilled({
    value: ce
  }) || J) && (Re ? Ge = Re(ce) : Me = !0);
  const He = De.map((Qe) => {
    if (!/* @__PURE__ */ React$1.isValidElement(Qe))
      return null;
    define_process_env_default$y.NODE_ENV !== "production" && reactIsExports.isFragment(Qe) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let ut;
    if (Q) {
      if (!Array.isArray(ce))
        throw new Error(define_process_env_default$y.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : formatMuiErrorMessage$1(2));
      ut = ce.some((ft) => areEqualValues(ft, Qe.props.value)), ut && Me && Ze.push(Qe.props.children);
    } else
      ut = areEqualValues(ce, Qe.props.value), ut && Me && (nt = Qe.props.children);
    return ut && (Ne = !0), /* @__PURE__ */ React$1.cloneElement(Qe, {
      "aria-selected": ut ? "true" : "false",
      onClick: ze(Qe),
      onKeyUp: (ft) => {
        ft.key === " " && ft.preventDefault(), Qe.props.onKeyUp && Qe.props.onKeyUp(ft);
      },
      role: "option",
      selected: ut,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": Qe.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  define_process_env_default$y.NODE_ENV !== "production" && React$1.useEffect(() => {
    if (!Ne && !Q && ce !== "") {
      const Qe = De.map((ut) => ut.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${ce}\` for the select ${ne ? `(name="${ne}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${Qe.filter((ut) => ut != null).map((ut) => `\`${ut}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Ne, De, Q, ne, ce]), Me && (Q ? Ze.length === 0 ? Ge = null : Ge = Ze.reduce((Qe, ut, ft) => (Qe.push(ut), ft < Ze.length - 1 && Qe.push(", "), Qe), []) : Ge = nt);
  let qe = Se;
  !z && me && ve && (qe = Oe.clientWidth);
  let Ke;
  typeof Te < "u" ? Ke = Te : Ke = Y ? null : 0;
  const Xe = ke.id || (ne ? `mui-component-select-${ne}` : void 0), tt = _extends$1({}, S, {
    variant: ue,
    value: ce,
    open: Be,
    error: Z
  }), at = useUtilityClasses$x(tt), it = _extends$1({}, re.PaperProps, (k = re.slotProps) == null ? void 0 : k.paper), mt = useId();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SelectSelect, _extends$1({
      ref: $e,
      tabIndex: Ke,
      role: "combobox",
      "aria-controls": mt,
      "aria-disabled": Y ? "true" : void 0,
      "aria-expanded": Be ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": L,
      "aria-labelledby": [te, Xe].filter(Boolean).join(" ") || void 0,
      "aria-describedby": D,
      onKeyDown: We,
      onMouseDown: Y || Pe ? null : we,
      onBlur: Ye,
      onFocus: ie
    }, ke, {
      ownerState: tt,
      className: clsx(ke.className, at.select, U),
      id: Xe,
      children: isEmpty(Ge) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span$1 || (_span$1 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : Ge
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectNativeInput, _extends$1({
      "aria-invalid": Z,
      value: Array.isArray(ce) ? ce.join(",") : ce,
      name: ne,
      ref: Ae,
      "aria-hidden": !0,
      onChange: Le,
      tabIndex: -1,
      disabled: Y,
      className: at.nativeInput,
      autoFocus: V,
      ownerState: tt
    }, Ce)), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectIcon, {
      as: X,
      className: at.icon,
      ownerState: tt
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Menu, _extends$1({
      id: `menu-${ne || ""}`,
      anchorEl: Oe,
      open: Be,
      onClose: Fe,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, re, {
      MenuListProps: _extends$1({
        "aria-labelledby": te,
        role: "listbox",
        "aria-multiselectable": Q ? "true" : void 0,
        disableListWrap: !0,
        id: mt
      }, re.MenuListProps),
      slotProps: _extends$1({}, re.slotProps, {
        paper: _extends$1({}, it, {
          style: _extends$1({
            minWidth: qe
          }, it != null ? it.style : null)
        })
      }),
      children: He
    }))]
  });
});
define_process_env_default$y.NODE_ENV !== "production" && (SelectInput.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * @ignore
   */
  "aria-label": PropTypes.string,
  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * @ignore
   */
  readOnly: PropTypes.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  type: PropTypes.any,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
const ArrowDropDownIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
var define_process_env_default$x = {};
const _excluded$G = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], _excluded2$7 = ["root"], useUtilityClasses$w = (T) => {
  const {
    classes: S
  } = T;
  return S;
}, styledRootConfig = {
  name: "MuiSelect",
  overridesResolver: (T, S) => S.root,
  shouldForwardProp: (T) => rootShouldForwardProp(T) && T !== "variant",
  slot: "Root"
}, StyledInput = styled(Input, styledRootConfig)(""), StyledOutlinedInput = styled(OutlinedInput, styledRootConfig)(""), StyledFilledInput = styled(FilledInput, styledRootConfig)(""), Select = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    name: "MuiSelect",
    props: S
  }), {
    autoWidth: D = !1,
    children: L,
    classes: V = {},
    className: z,
    defaultOpen: W = !1,
    displayEmpty: U = !1,
    IconComponent: q = ArrowDropDownIcon,
    id: K,
    input: Y,
    inputProps: J,
    label: Z,
    labelId: X,
    MenuProps: ee,
    multiple: te = !1,
    native: re = !1,
    onClose: Q,
    onOpen: ne,
    open: oe,
    renderValue: ae,
    SelectDisplayProps: se,
    variant: ie = "outlined"
  } = k, he = _objectWithoutPropertiesLoose$1(k, _excluded$G), xe = re ? NativeSelectInput : SelectInput, Pe = useFormControl(), Re = formControlState({
    props: k,
    muiFormControl: Pe,
    states: ["variant", "error"]
  }), ke = Re.variant || ie, Te = _extends$1({}, k, {
    variant: ke,
    classes: V
  }), fe = useUtilityClasses$w(Te), ue = _objectWithoutPropertiesLoose$1(fe, _excluded2$7), Ce = Y || {
    standard: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInput, {
      ownerState: Te
    }),
    outlined: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOutlinedInput, {
      label: Z,
      ownerState: Te
    }),
    filled: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFilledInput, {
      ownerState: Te
    })
  }[ke], ce = useForkRef(R, Ce.ref);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React$1.Fragment, {
    children: /* @__PURE__ */ React$1.cloneElement(Ce, _extends$1({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: xe,
      inputProps: _extends$1({
        children: L,
        error: Re.error,
        IconComponent: q,
        variant: ke,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: te
      }, re ? {
        id: K
      } : {
        autoWidth: D,
        defaultOpen: W,
        displayEmpty: U,
        labelId: X,
        MenuProps: ee,
        onClose: Q,
        onOpen: ne,
        open: oe,
        renderValue: ae,
        SelectDisplayProps: _extends$1({
          id: K
        }, se)
      }, J, {
        classes: J ? deepmerge$1(ue, J.classes) : ue
      }, Y ? Y.props.inputProps : {})
    }, (te && re || U) && ke === "outlined" ? {
      notched: !0
    } : {}, {
      ref: ce,
      className: clsx(Ce.props.className, z, fe.root)
    }, !Y && {
      variant: ke
    }, he))
  });
});
define_process_env_default$x.NODE_ENV !== "production" && (Select.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: PropTypes.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: PropTypes.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: PropTypes.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.oneOfType([PropTypes.oneOf([""]), PropTypes.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
Select.muiName = "Select";
function getTextFieldUtilityClass(T) {
  return generateUtilityClass$1("MuiTextField", T);
}
generateUtilityClasses$1("MuiTextField", ["root"]);
var define_process_env_default$w = {};
const _excluded$F = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"], variantComponent = {
  standard: Input,
  filled: FilledInput,
  outlined: OutlinedInput
}, useUtilityClasses$v = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"]
  }, getTextFieldUtilityClass, S);
}, TextFieldRoot = styled(FormControl, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({}), TextField$3 = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiTextField"
  }), {
    autoComplete: D,
    autoFocus: L = !1,
    children: V,
    className: z,
    color: W = "primary",
    defaultValue: U,
    disabled: q = !1,
    error: K = !1,
    FormHelperTextProps: Y,
    fullWidth: J = !1,
    helperText: Z,
    id: X,
    InputLabelProps: ee,
    inputProps: te,
    InputProps: re,
    inputRef: Q,
    label: ne,
    maxRows: oe,
    minRows: ae,
    multiline: se = !1,
    name: ie,
    onBlur: he,
    onChange: xe,
    onFocus: Pe,
    placeholder: Re,
    required: ke = !1,
    rows: Te,
    select: fe = !1,
    SelectProps: ue,
    type: Ce,
    value: ce,
    variant: pe = "outlined"
  } = k, _e = _objectWithoutPropertiesLoose$1(k, _excluded$F), ge = _extends$1({}, k, {
    autoFocus: L,
    color: W,
    disabled: q,
    error: K,
    fullWidth: J,
    multiline: se,
    required: ke,
    select: fe,
    variant: pe
  }), Ae = useUtilityClasses$v(ge);
  define_process_env_default$w.NODE_ENV !== "production" && fe && !V && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const Ee = {};
  pe === "outlined" && (ee && typeof ee.shrink < "u" && (Ee.notched = ee.shrink), Ee.label = ne), fe && ((!ue || !ue.native) && (Ee.id = void 0), Ee["aria-describedby"] = void 0);
  const ve = useId(X), le = Z && ve ? `${ve}-helper-text` : void 0, me = ne && ve ? `${ve}-label` : void 0, Se = variantComponent[pe], ye = /* @__PURE__ */ jsxRuntimeExports.jsx(Se, _extends$1({
    "aria-describedby": le,
    autoComplete: D,
    autoFocus: L,
    defaultValue: U,
    fullWidth: J,
    multiline: se,
    name: ie,
    rows: Te,
    maxRows: oe,
    minRows: ae,
    type: Ce,
    value: ce,
    id: ve,
    inputRef: Q,
    onBlur: he,
    onChange: xe,
    onFocus: Pe,
    placeholder: Re,
    inputProps: te
  }, Ee, re));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TextFieldRoot, _extends$1({
    className: clsx(Ae.root, z),
    disabled: q,
    error: K,
    fullWidth: J,
    ref: R,
    required: ke,
    color: W,
    variant: pe,
    ownerState: ge
  }, _e, {
    children: [ne != null && ne !== "" && /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, _extends$1({
      htmlFor: ve,
      id: me
    }, ee, {
      children: ne
    })), fe ? /* @__PURE__ */ jsxRuntimeExports.jsx(Select, _extends$1({
      "aria-describedby": le,
      id: ve,
      labelId: me,
      value: ce,
      input: ye
    }, ue, {
      children: V
    })) : ye, Z && /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, _extends$1({
      id: le
    }, Y, {
      children: Z
    }))]
  }));
});
define_process_env_default$w.NODE_ENV !== "production" && (TextField$3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: PropTypes.bool,
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */
  SelectProps: PropTypes.object,
  /**
   * The size of the component.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
function useValidation(T, S, R, k) {
  const {
    value: D,
    onError: L
  } = T, V = useLocalizationContext(), z = React$1.useRef(k), W = S({
    adapter: V,
    value: D,
    props: T
  });
  return React$1.useEffect(() => {
    L && !R(W, z.current) && L(W, D), z.current = W;
  }, [R, L, z, W, D]), W;
}
const expandFormat = ({
  utils: T,
  format: S
}) => {
  let R = 10, k = S, D = T.expandFormat(S);
  for (; D !== k; )
    if (k = D, D = T.expandFormat(k), R -= 1, R < 0)
      throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.");
  return D;
}, getEscapedPartsFromFormat = ({
  utils: T,
  expandedFormat: S
}) => {
  const R = [], {
    start: k,
    end: D
  } = T.escapedCharacters, L = new RegExp(`(\\${k}[^\\${D}]*\\${D})+`, "g");
  let V = null;
  for (; V = L.exec(S); )
    R.push({
      start: V.index,
      end: L.lastIndex - 1
    });
  return R;
}, getSectionPlaceholder = (T, S, R, k, D) => {
  switch (k.type) {
    case "year":
      return R.fieldYearPlaceholder({
        digitAmount: T.formatByString(T.date(void 0, S), D).length,
        format: D
      });
    case "month":
      return R.fieldMonthPlaceholder({
        contentType: k.contentType,
        format: D
      });
    case "day":
      return R.fieldDayPlaceholder({
        format: D
      });
    case "weekDay":
      return R.fieldWeekDayPlaceholder({
        contentType: k.contentType,
        format: D
      });
    case "hours":
      return R.fieldHoursPlaceholder({
        format: D
      });
    case "minutes":
      return R.fieldMinutesPlaceholder({
        format: D
      });
    case "seconds":
      return R.fieldSecondsPlaceholder({
        format: D
      });
    case "meridiem":
      return R.fieldMeridiemPlaceholder({
        format: D
      });
    default:
      return D;
  }
}, createSection = ({
  utils: T,
  timezone: S,
  date: R,
  shouldRespectLeadingZeros: k,
  localeText: D,
  localizedDigits: L,
  now: V,
  token: z,
  startSeparator: W
}) => {
  if (z === "")
    throw new Error("MUI X: Should not call `commitToken` with an empty token");
  const U = getDateSectionConfigFromFormatToken(T, z), q = doesSectionFormatHaveLeadingZeros(T, S, U.contentType, U.type, z), K = k ? q : U.contentType === "digit", Y = R != null && T.isValid(R);
  let J = Y ? T.formatByString(R, z) : "", Z = null;
  if (K)
    if (q)
      Z = J === "" ? T.formatByString(V, z).length : J.length;
    else {
      if (U.maxLength == null)
        throw new Error(`MUI X: The token ${z} should have a 'maxDigitNumber' property on it's adapter`);
      Z = U.maxLength, Y && (J = applyLocalizedDigits(cleanLeadingZeros(removeLocalizedDigits(J, L), Z), L));
    }
  return _extends$1({}, U, {
    format: z,
    maxLength: Z,
    value: J,
    placeholder: getSectionPlaceholder(T, S, D, U, z),
    hasLeadingZerosInFormat: q,
    hasLeadingZerosInInput: K,
    startSeparator: W,
    endSeparator: "",
    modified: !1
  });
}, buildSections = (T) => {
  const {
    utils: S,
    expandedFormat: R,
    escapedParts: k
  } = T, D = S.date(void 0), L = [];
  let V = "";
  const z = Object.keys(S.formatTokenMap).sort((J, Z) => Z.length - J.length), W = /^([a-zA-Z]+)/, U = new RegExp(`^(${z.join("|")})*$`), q = new RegExp(`^(${z.join("|")})`), K = (J) => k.find((Z) => Z.start <= J && Z.end >= J);
  let Y = 0;
  for (; Y < R.length; ) {
    const J = K(Y), Z = J != null, X = W.exec(R.slice(Y))?.[1];
    if (!Z && X != null && U.test(X)) {
      let ee = X;
      for (; ee.length > 0; ) {
        const te = q.exec(ee)[1];
        ee = ee.slice(te.length), L.push(createSection(_extends$1({}, T, {
          now: D,
          token: te,
          startSeparator: V
        }))), V = "";
      }
      Y += X.length;
    } else {
      const ee = R[Y];
      Z && J?.start === Y || J?.end === Y || (L.length === 0 ? V += ee : L[L.length - 1].endSeparator += ee), Y += 1;
    }
  }
  return L.length === 0 && V.length > 0 && L.push({
    type: "empty",
    contentType: "letter",
    maxLength: null,
    format: "",
    value: "",
    placeholder: "",
    hasLeadingZerosInFormat: !1,
    hasLeadingZerosInInput: !1,
    startSeparator: V,
    endSeparator: "",
    modified: !1
  }), L;
}, postProcessSections = ({
  isRtl: T,
  formatDensity: S,
  sections: R
}) => R.map((k) => {
  const D = (L) => {
    let V = L;
    return T && V !== null && V.includes(" ") && (V = `⁩${V}⁦`), S === "spacious" && ["/", ".", "-"].includes(V) && (V = ` ${V} `), V;
  };
  return k.startSeparator = D(k.startSeparator), k.endSeparator = D(k.endSeparator), k;
}), buildSectionsFromFormat = (T) => {
  let S = expandFormat(T);
  T.isRtl && T.enableAccessibleFieldDOMStructure && (S = S.split(" ").reverse().join(" "));
  const R = getEscapedPartsFromFormat(_extends$1({}, T, {
    expandedFormat: S
  })), k = buildSections(_extends$1({}, T, {
    expandedFormat: S,
    escapedParts: R
  }));
  return postProcessSections(_extends$1({}, T, {
    sections: k
  }));
}, useFieldState = (T) => {
  const S = useUtils(), R = usePickersTranslations(), k = useLocalizationContext(), D = useRtl(), {
    valueManager: L,
    fieldValueManager: V,
    valueType: z,
    validator: W,
    internalProps: U,
    internalProps: {
      value: q,
      defaultValue: K,
      referenceDate: Y,
      onChange: J,
      format: Z,
      formatDensity: X = "dense",
      selectedSections: ee,
      onSelectedSectionsChange: te,
      shouldRespectLeadingZeros: re = !1,
      timezone: Q,
      enableAccessibleFieldDOMStructure: ne = !1
    }
  } = T, {
    timezone: oe,
    value: ae,
    handleValueChange: se
  } = useValueWithTimezone({
    timezone: Q,
    value: q,
    defaultValue: K,
    onChange: J,
    valueManager: L
  }), ie = React$1.useMemo(() => getLocalizedDigits(S), [S]), he = React$1.useMemo(() => getSectionsBoundaries(S, ie, oe), [S, ie, oe]), xe = React$1.useCallback((le, me = null) => V.getSectionsFromValue(S, le, me, (Se) => buildSectionsFromFormat({
    utils: S,
    timezone: oe,
    localeText: R,
    localizedDigits: ie,
    format: Z,
    date: Se,
    formatDensity: X,
    shouldRespectLeadingZeros: re,
    enableAccessibleFieldDOMStructure: ne,
    isRtl: D
  })), [V, Z, R, ie, D, re, S, X, oe, ne]), [Pe, Re] = React$1.useState(() => {
    const le = xe(ae);
    validateSections(le, z);
    const me = {
      sections: le,
      value: ae,
      referenceValue: L.emptyValue,
      tempValueStrAndroid: null
    }, Se = getSectionTypeGranularity(le), ye = L.getInitialReferenceValue({
      referenceDate: Y,
      value: ae,
      utils: S,
      props: U,
      granularity: Se,
      timezone: oe
    });
    return _extends$1({}, me, {
      referenceValue: ye
    });
  }), [ke, Te] = useControlled({
    controlled: ee,
    default: null,
    name: "useField",
    state: "selectedSections"
  }), fe = (le) => {
    Te(le), te?.(le);
  }, ue = React$1.useMemo(() => parseSelectedSections(ke, Pe.sections), [ke, Pe.sections]), Ce = ue === "all" ? 0 : ue, ce = ({
    value: le,
    referenceValue: me,
    sections: Se
  }) => {
    if (Re((be) => _extends$1({}, be, {
      sections: Se,
      value: le,
      referenceValue: me,
      tempValueStrAndroid: null
    })), L.areValuesEqual(S, Pe.value, le))
      return;
    const ye = {
      validationError: W({
        adapter: k,
        value: le,
        props: _extends$1({}, U, {
          value: le,
          timezone: oe
        })
      })
    };
    se(le, ye);
  }, pe = (le, me) => {
    const Se = [...Pe.sections];
    return Se[le] = _extends$1({}, Se[le], {
      value: me,
      modified: !0
    }), Se;
  }, _e = () => {
    ce({
      value: L.emptyValue,
      referenceValue: Pe.referenceValue,
      sections: xe(L.emptyValue)
    });
  }, ge = () => {
    if (Ce == null)
      return;
    const le = Pe.sections[Ce], me = V.getActiveDateManager(S, Pe, le), ye = me.getSections(Pe.sections).filter((Ie) => Ie.value !== "").length === (le.value === "" ? 0 : 1), be = pe(Ce, ""), $e = ye ? null : S.getInvalidDate(), Oe = me.getNewValuesFromNewActiveDate($e);
    ce(_extends$1({}, Oe, {
      sections: be
    }));
  }, Ae = (le) => {
    const me = (be, $e) => {
      const Oe = S.parse(be, Z);
      if (Oe == null || !S.isValid(Oe))
        return null;
      const Ie = buildSectionsFromFormat({
        utils: S,
        timezone: oe,
        localeText: R,
        localizedDigits: ie,
        format: Z,
        date: Oe,
        formatDensity: X,
        shouldRespectLeadingZeros: re,
        enableAccessibleFieldDOMStructure: ne,
        isRtl: D
      });
      return mergeDateIntoReferenceDate(S, oe, Oe, Ie, $e, !1);
    }, Se = V.parseValueStr(le, Pe.referenceValue, me), ye = V.updateReferenceValue(S, Se, Pe.referenceValue);
    ce({
      value: Se,
      referenceValue: ye,
      sections: xe(Se, Pe.sections)
    });
  }, Ee = ({
    activeSection: le,
    newSectionValue: me,
    shouldGoToNextSection: Se
  }) => {
    Se && Ce < Pe.sections.length - 1 && fe(Ce + 1);
    const ye = V.getActiveDateManager(S, Pe, le), be = pe(Ce, me), $e = ye.getSections(be), Oe = getDateFromDateSections(S, $e, ie);
    let Ie, we;
    if (Oe != null && S.isValid(Oe)) {
      const Fe = mergeDateIntoReferenceDate(S, oe, Oe, $e, ye.referenceDate, !0);
      Ie = ye.getNewValuesFromNewActiveDate(Fe), we = !0;
    } else
      Ie = ye.getNewValuesFromNewActiveDate(Oe), we = (Oe != null && !S.isValid(Oe)) != (ye.date != null && !S.isValid(ye.date));
    return we ? ce(_extends$1({}, Ie, {
      sections: be
    })) : Re((Fe) => _extends$1({}, Fe, Ie, {
      sections: be,
      tempValueStrAndroid: null
    }));
  }, ve = (le) => Re((me) => _extends$1({}, me, {
    tempValueStrAndroid: le
  }));
  return React$1.useEffect(() => {
    const le = xe(Pe.value);
    validateSections(le, z), Re((me) => _extends$1({}, me, {
      sections: le
    }));
  }, [Z, S.locale, D]), React$1.useEffect(() => {
    let le;
    L.areValuesEqual(S, Pe.value, ae) ? le = L.getTimezone(S, Pe.value) !== L.getTimezone(S, ae) : le = !0, le && Re((me) => _extends$1({}, me, {
      value: ae,
      referenceValue: V.updateReferenceValue(S, ae, me.referenceValue),
      sections: xe(ae)
    }));
  }, [ae]), {
    state: Pe,
    activeSectionIndex: Ce,
    parsedSelectedSections: ue,
    setSelectedSections: fe,
    clearValue: _e,
    clearActiveSection: ge,
    updateSectionValue: Ee,
    updateValueFromValueStr: Ae,
    setTempAndroidValueStr: ve,
    getSectionsFromValue: xe,
    sectionsValueBoundaries: he,
    localizedDigits: ie,
    timezone: oe
  };
}, QUERY_LIFE_DURATION_MS = 5e3, isQueryResponseWithoutValue = (T) => T.saveQuery != null, useFieldCharacterEditing = ({
  sections: T,
  updateSectionValue: S,
  sectionsValueBoundaries: R,
  localizedDigits: k,
  setTempAndroidValueStr: D,
  timezone: L
}) => {
  const V = useUtils(), [z, W] = React$1.useState(null), U = useEventCallback(() => W(null));
  React$1.useEffect(() => {
    z != null && T[z.sectionIndex]?.type !== z.sectionType && U();
  }, [T, z, U]), React$1.useEffect(() => {
    if (z != null) {
      const Z = setTimeout(() => U(), QUERY_LIFE_DURATION_MS);
      return () => {
        clearTimeout(Z);
      };
    }
    return () => {
    };
  }, [z, U]);
  const q = ({
    keyPressed: Z,
    sectionIndex: X
  }, ee, te) => {
    const re = Z.toLowerCase(), Q = T[X];
    if (z != null && (!te || te(z.value)) && z.sectionIndex === X) {
      const oe = `${z.value}${re}`, ae = ee(oe, Q);
      if (!isQueryResponseWithoutValue(ae))
        return W({
          sectionIndex: X,
          value: oe,
          sectionType: Q.type
        }), ae;
    }
    const ne = ee(re, Q);
    return isQueryResponseWithoutValue(ne) && !ne.saveQuery ? (U(), null) : (W({
      sectionIndex: X,
      value: re,
      sectionType: Q.type
    }), isQueryResponseWithoutValue(ne) ? null : ne);
  }, K = (Z) => {
    const X = (re, Q, ne) => {
      const oe = Q.filter((ae) => ae.toLowerCase().startsWith(ne));
      return oe.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: oe[0],
        shouldGoToNextSection: oe.length === 1
      };
    }, ee = (re, Q, ne, oe) => {
      const ae = (se) => getLetterEditingOptions(V, L, Q.type, se);
      if (Q.contentType === "letter")
        return X(Q.format, ae(Q.format), re);
      if (ne && oe != null && getDateSectionConfigFromFormatToken(V, ne).contentType === "letter") {
        const se = ae(ne), ie = X(ne, se, re);
        return isQueryResponseWithoutValue(ie) ? {
          saveQuery: !1
        } : _extends$1({}, ie, {
          sectionValue: oe(ie.sectionValue, se)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return q(Z, (re, Q) => {
      switch (Q.type) {
        case "month": {
          const ne = (oe) => changeSectionValueFormat(V, oe, V.formats.month, Q.format);
          return ee(re, Q, V.formats.month, ne);
        }
        case "weekDay": {
          const ne = (oe, ae) => ae.indexOf(oe).toString();
          return ee(re, Q, V.formats.weekday, ne);
        }
        case "meridiem":
          return ee(re, Q);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, Y = (Z) => {
    const X = (te, re) => {
      const Q = removeLocalizedDigits(te, k), ne = Number(Q), oe = R[re.type]({
        currentDate: null,
        format: re.format,
        contentType: re.contentType
      });
      if (ne > oe.maximum)
        return {
          saveQuery: !1
        };
      if (ne < oe.minimum)
        return {
          saveQuery: !0
        };
      const ae = ne * 10 > oe.maximum || Q.length === oe.maximum.toString().length;
      return {
        sectionValue: cleanDigitSectionValue(V, ne, oe, k, re),
        shouldGoToNextSection: ae
      };
    };
    return q(Z, (te, re) => {
      if (re.contentType === "digit" || re.contentType === "digit-with-letter")
        return X(te, re);
      if (re.type === "month") {
        const Q = doesSectionFormatHaveLeadingZeros(V, L, "digit", "month", "MM"), ne = X(te, {
          type: re.type,
          format: "MM",
          hasLeadingZerosInFormat: Q,
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (isQueryResponseWithoutValue(ne))
          return ne;
        const oe = changeSectionValueFormat(V, ne.sectionValue, "MM", re.format);
        return _extends$1({}, ne, {
          sectionValue: oe
        });
      }
      if (re.type === "weekDay") {
        const Q = X(te, re);
        if (isQueryResponseWithoutValue(Q))
          return Q;
        const ne = getDaysInWeekStr(V, L, re.format)[Number(Q.sectionValue) - 1];
        return _extends$1({}, Q, {
          sectionValue: ne
        });
      }
      return {
        saveQuery: !1
      };
    }, (te) => isStringNumber(te, k));
  };
  return {
    applyCharacterEditing: useEventCallback((Z) => {
      const X = T[Z.sectionIndex], te = isStringNumber(Z.keyPressed, k) ? Y(_extends$1({}, Z, {
        keyPressed: applyLocalizedDigits(Z.keyPressed, k)
      })) : K(Z);
      if (te == null) {
        D(null);
        return;
      }
      S({
        activeSection: X,
        newSectionValue: te.sectionValue,
        shouldGoToNextSection: te.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: U
  };
};
function arrayIncludes(T, S) {
  return Array.isArray(S) ? S.every((R) => T.indexOf(R) !== -1) : T.indexOf(S) !== -1;
}
const onSpaceOrEnter = (T, S) => (R) => {
  (R.key === "Enter" || R.key === " ") && (T(R), R.preventDefault(), R.stopPropagation());
}, getActiveElement = (T = document) => {
  const S = T.activeElement;
  return S ? S.shadowRoot ? getActiveElement(S.shadowRoot) : S : null;
}, useFieldV7TextField = (T) => {
  const {
    internalProps: {
      disabled: S,
      readOnly: R = !1
    },
    forwardedProps: {
      sectionListRef: k,
      onBlur: D,
      onClick: L,
      onFocus: V,
      onInput: z,
      onPaste: W,
      focused: U,
      autoFocus: q = !1
    },
    fieldValueManager: K,
    applyCharacterEditing: Y,
    resetCharacterQuery: J,
    setSelectedSections: Z,
    parsedSelectedSections: X,
    state: ee,
    clearActiveSection: te,
    clearValue: re,
    updateSectionValue: Q,
    updateValueFromValueStr: ne,
    sectionOrder: oe,
    areAllSectionsEmpty: ae,
    sectionsValueBoundaries: se
  } = T, ie = React$1.useRef(null), he = useForkRef(k, ie), xe = usePickersTranslations(), Pe = useUtils(), Re = useId(), [ke, Te] = React$1.useState(!1), fe = React$1.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!ie.current)
        return;
      const we = document.getSelection();
      if (!we)
        return;
      if (X == null) {
        we.rangeCount > 0 && ie.current.getRoot().contains(we.getRangeAt(0).startContainer) && we.removeAllRanges(), ke && ie.current.getRoot().blur();
        return;
      }
      if (!ie.current.getRoot().contains(getActiveElement(document)))
        return;
      const Fe = new window.Range();
      let De;
      X === "all" ? De = ie.current.getRoot() : ee.sections[X].type === "empty" ? De = ie.current.getSectionContainer(X) : De = ie.current.getSectionContent(X), Fe.selectNodeContents(De), De.focus(), we.removeAllRanges(), we.addRange(Fe);
    },
    getActiveSectionIndexFromDOM: () => {
      const we = getActiveElement(document);
      return !we || !ie.current || !ie.current.getRoot().contains(we) ? null : ie.current.getSectionIndexFromDOMElement(we);
    },
    focusField: (we = 0) => {
      if (!ie.current)
        return;
      const Fe = parseSelectedSections(we, ee.sections);
      Te(!0), ie.current.getSectionContent(Fe).focus();
    },
    setSelectedSections: (we) => {
      if (!ie.current)
        return;
      const Fe = parseSelectedSections(we, ee.sections);
      Te((Fe === "all" ? 0 : Fe) !== null), Z(we);
    },
    isFieldFocused: () => {
      const we = getActiveElement(document);
      return !!ie.current && ie.current.getRoot().contains(we);
    }
  }), [X, Z, ee.sections, ke]), ue = useEventCallback((we) => {
    if (!ie.current)
      return;
    const Fe = ee.sections[we];
    ie.current.getSectionContent(we).innerHTML = Fe.value || Fe.placeholder, fe.syncSelectionToDOM();
  }), Ce = useEventCallback((we, ...Fe) => {
    we.isDefaultPrevented() || !ie.current || (Te(!0), L?.(we, ...Fe), X === "all" ? setTimeout(() => {
      const De = document.getSelection().getRangeAt(0).startOffset;
      if (De === 0) {
        Z(oe.startIndex);
        return;
      }
      let Le = 0, ze = 0;
      for (; ze < De && Le < ee.sections.length; ) {
        const We = ee.sections[Le];
        Le += 1, ze += `${We.startSeparator}${We.value || We.placeholder}${We.endSeparator}`.length;
      }
      Z(Le - 1);
    }) : ke ? ie.current.getRoot().contains(we.target) || Z(oe.startIndex) : (Te(!0), Z(oe.startIndex)));
  }), ce = useEventCallback((we) => {
    if (z?.(we), !ie.current || X !== "all")
      return;
    const De = we.target.textContent ?? "";
    ie.current.getRoot().innerHTML = ee.sections.map((Le) => `${Le.startSeparator}${Le.value || Le.placeholder}${Le.endSeparator}`).join(""), fe.syncSelectionToDOM(), De.length === 0 || De.charCodeAt(0) === 10 ? (J(), re(), Z("all")) : De.length > 1 ? ne(De) : Y({
      keyPressed: De,
      sectionIndex: 0
    });
  }), pe = useEventCallback((we) => {
    if (W?.(we), R || X !== "all") {
      we.preventDefault();
      return;
    }
    const Fe = we.clipboardData.getData("text");
    we.preventDefault(), J(), ne(Fe);
  }), _e = useEventCallback((...we) => {
    if (V?.(...we), ke || !ie.current)
      return;
    Te(!0), ie.current.getSectionIndexFromDOMElement(getActiveElement(document)) != null || Z(oe.startIndex);
  }), ge = useEventCallback((...we) => {
    D?.(...we), setTimeout(() => {
      if (!ie.current)
        return;
      const Fe = getActiveElement(document);
      !ie.current.getRoot().contains(Fe) && (Te(!1), Z(null));
    });
  }), Ae = useEventCallback((we) => (Fe) => {
    Fe.isDefaultPrevented() || R || Z(we);
  }), Ee = useEventCallback((we) => {
    we.preventDefault();
  }), ve = useEventCallback((we) => () => {
    R || Z(we);
  }), le = useEventCallback((we) => {
    if (we.preventDefault(), R || typeof X != "number")
      return;
    const Fe = ee.sections[X], De = we.clipboardData.getData("text"), Le = /^[a-zA-Z]+$/.test(De), ze = /^[0-9]+$/.test(De), We = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(De);
    Fe.contentType === "letter" && Le || Fe.contentType === "digit" && ze || Fe.contentType === "digit-with-letter" && We ? (J(), Q({
      activeSection: Fe,
      newSectionValue: De,
      shouldGoToNextSection: !0
    })) : !Le && !ze && (J(), ne(De));
  }), me = useEventCallback((we) => {
    we.preventDefault(), we.dataTransfer.dropEffect = "none";
  }), Se = useEventCallback((we) => {
    if (!ie.current)
      return;
    const Fe = we.target, De = Fe.textContent ?? "", Le = ie.current.getSectionIndexFromDOMElement(Fe), ze = ee.sections[Le];
    if (R || !ie.current) {
      ue(Le);
      return;
    }
    if (De.length === 0) {
      if (ze.value === "") {
        ue(Le);
        return;
      }
      const We = we.nativeEvent.inputType;
      if (We === "insertParagraph" || We === "insertLineBreak") {
        ue(Le);
        return;
      }
      J(), te();
      return;
    }
    Y({
      keyPressed: De,
      sectionIndex: Le
    }), ue(Le);
  });
  useEnhancedEffect(() => {
    if (!(!ke || !ie.current)) {
      if (X === "all")
        ie.current.getRoot().focus();
      else if (typeof X == "number") {
        const we = ie.current.getSectionContent(X);
        we && we.focus();
      }
    }
  }, [X, ke]);
  const ye = React$1.useMemo(() => ee.sections.reduce((we, Fe) => (we[Fe.type] = se[Fe.type]({
    currentDate: null,
    contentType: Fe.contentType,
    format: Fe.format
  }), we), {}), [se, ee.sections]), be = X === "all", $e = React$1.useMemo(() => ee.sections.map((we, Fe) => {
    const De = !be && !S && !R;
    return {
      container: {
        "data-sectionindex": Fe,
        onClick: Ae(Fe)
      },
      content: {
        tabIndex: be || Fe > 0 ? -1 : 0,
        contentEditable: !be && !S && !R,
        role: "spinbutton",
        id: `${Re}-${we.type}`,
        "aria-labelledby": `${Re}-${we.type}`,
        "aria-readonly": R,
        "aria-valuenow": getSectionValueNow(we, Pe),
        "aria-valuemin": ye[we.type].minimum,
        "aria-valuemax": ye[we.type].maximum,
        "aria-valuetext": we.value ? getSectionValueText(we, Pe) : xe.empty,
        "aria-label": xe[we.type],
        "aria-disabled": S,
        spellCheck: De ? !1 : void 0,
        autoCapitalize: De ? "off" : void 0,
        autoCorrect: De ? "off" : void 0,
        [parseInt(React$1.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: De ? "next" : void 0,
        children: we.value || we.placeholder,
        onInput: Se,
        onPaste: le,
        onFocus: ve(Fe),
        onDragOver: me,
        onMouseUp: Ee,
        inputMode: we.contentType === "letter" ? "text" : "numeric"
      },
      before: {
        children: we.startSeparator
      },
      after: {
        children: we.endSeparator
      }
    };
  }), [ee.sections, ve, le, me, Se, Ae, Ee, S, R, be, xe, Pe, ye, Re]), Oe = useEventCallback((we) => {
    ne(we.target.value);
  }), Ie = React$1.useMemo(() => ae ? "" : K.getV7HiddenInputValueFromSections(ee.sections), [ae, ee.sections, K]);
  return React$1.useEffect(() => {
    if (ie.current == null)
      throw new Error(["MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`", "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.", "", "If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:", "", "<DatePicker slots={{ textField: MyCustomTextField }} />", "", "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"].join(`
`));
    q && ie.current && ie.current.getSectionContent(oe.startIndex).focus();
  }, []), {
    interactions: fe,
    returnedValue: {
      // Forwarded
      autoFocus: q,
      readOnly: R,
      focused: U ?? ke,
      sectionListRef: he,
      onBlur: ge,
      onClick: Ce,
      onFocus: _e,
      onInput: ce,
      onPaste: pe,
      // Additional
      enableAccessibleFieldDOMStructure: !0,
      elements: $e,
      // TODO v7: Try to set to undefined when there is a section selected.
      tabIndex: X === 0 ? -1 : 0,
      contentEditable: be,
      value: Ie,
      onChange: Oe,
      areAllSectionsEmpty: ae
    }
  };
}, cleanString = (T) => T.replace(/[\u2066\u2067\u2068\u2069]/g, ""), addPositionPropertiesToSections = (T, S, R) => {
  let k = 0, D = R ? 1 : 0;
  const L = [];
  for (let V = 0; V < T.length; V += 1) {
    const z = T[V], W = getSectionVisibleValue(z, R ? "input-rtl" : "input-ltr", S), U = `${z.startSeparator}${W}${z.endSeparator}`, q = cleanString(U).length, K = U.length, Y = cleanString(W), J = D + (Y === "" ? 0 : W.indexOf(Y[0])) + z.startSeparator.length, Z = J + Y.length;
    L.push(_extends$1({}, z, {
      start: k,
      end: k + q,
      startInInput: J,
      endInInput: Z
    })), k += q, D += K;
  }
  return L;
}, useFieldV6TextField = (T) => {
  const S = useRtl(), R = React$1.useRef(), {
    forwardedProps: {
      onFocus: k,
      onClick: D,
      onPaste: L,
      onBlur: V,
      inputRef: z,
      placeholder: W
    },
    internalProps: {
      readOnly: U = !1
    },
    parsedSelectedSections: q,
    activeSectionIndex: K,
    state: Y,
    fieldValueManager: J,
    valueManager: Z,
    applyCharacterEditing: X,
    resetCharacterQuery: ee,
    updateSectionValue: te,
    updateValueFromValueStr: re,
    clearActiveSection: Q,
    clearValue: ne,
    setTempAndroidValueStr: oe,
    setSelectedSections: ae,
    getSectionsFromValue: se,
    areAllSectionsEmpty: ie,
    localizedDigits: he
  } = T, xe = React$1.useRef(null), Pe = useForkRef(z, xe), Re = React$1.useMemo(() => addPositionPropertiesToSections(Y.sections, he, S), [Y.sections, he, S]), ke = React$1.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!xe.current)
        return;
      if (q == null) {
        xe.current.scrollLeft && (xe.current.scrollLeft = 0);
        return;
      }
      if (xe.current !== getActiveElement(document))
        return;
      const le = xe.current.scrollTop;
      if (q === "all")
        xe.current.select();
      else {
        const me = Re[q], Se = me.type === "empty" ? me.startInInput - me.startSeparator.length : me.startInInput, ye = me.type === "empty" ? me.endInInput + me.endSeparator.length : me.endInInput;
        (Se !== xe.current.selectionStart || ye !== xe.current.selectionEnd) && xe.current === getActiveElement(document) && xe.current.setSelectionRange(Se, ye), setTimeout(() => {
          xe.current && xe.current === getActiveElement(document) && (xe.current.selectionStart !== Se || xe.current.selectionEnd !== ye) && ke.syncSelectionToDOM();
        });
      }
      xe.current.scrollTop = le;
    },
    getActiveSectionIndexFromDOM: () => {
      const le = xe.current.selectionStart ?? 0, me = xe.current.selectionEnd ?? 0, Se = !!xe.current?.readOnly;
      if (le === 0 && me === 0 || Se)
        return null;
      const ye = le <= Re[0].startInInput ? 1 : Re.findIndex((be) => be.startInInput - be.startSeparator.length > le);
      return ye === -1 ? Re.length - 1 : ye - 1;
    },
    focusField: (le = 0) => {
      xe.current?.focus(), ae(le);
    },
    setSelectedSections: (le) => ae(le),
    isFieldFocused: () => xe.current === getActiveElement(document)
  }), [xe, q, Re, ae]), Te = () => {
    if (U) {
      ae(null);
      return;
    }
    const le = xe.current.selectionStart ?? 0;
    let me;
    le <= Re[0].startInInput || le >= Re[Re.length - 1].endInInput ? me = 1 : me = Re.findIndex((ye) => ye.startInInput - ye.startSeparator.length > le);
    const Se = me === -1 ? Re.length - 1 : me - 1;
    ae(Se);
  }, fe = useEventCallback((...le) => {
    k?.(...le);
    const me = xe.current;
    clearTimeout(R.current), R.current = setTimeout(() => {
      !me || me !== xe.current || K != null || U || (// avoid selecting all sections when focusing empty field without value
      me.value.length && Number(me.selectionEnd) - Number(me.selectionStart) === me.value.length ? ae("all") : Te());
    });
  }), ue = useEventCallback((le, ...me) => {
    le.isDefaultPrevented() || (D?.(le, ...me), Te());
  }), Ce = useEventCallback((le) => {
    if (L?.(le), le.preventDefault(), U)
      return;
    const me = le.clipboardData.getData("text");
    if (typeof q == "number") {
      const Se = Y.sections[q], ye = /^[a-zA-Z]+$/.test(me), be = /^[0-9]+$/.test(me), $e = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(me);
      if (Se.contentType === "letter" && ye || Se.contentType === "digit" && be || Se.contentType === "digit-with-letter" && $e) {
        ee(), te({
          activeSection: Se,
          newSectionValue: me,
          shouldGoToNextSection: !0
        });
        return;
      }
      if (ye || be)
        return;
    }
    ee(), re(me);
  }), ce = useEventCallback((...le) => {
    V?.(...le), ae(null);
  }), pe = useEventCallback((le) => {
    if (U)
      return;
    const me = le.target.value;
    if (me === "") {
      ee(), ne();
      return;
    }
    const Se = le.nativeEvent.data, ye = Se && Se.length > 1, be = ye ? Se : me, $e = cleanString(be);
    if (K == null || ye) {
      re(ye ? Se : $e);
      return;
    }
    let Oe;
    if (q === "all" && $e.length === 1)
      Oe = $e;
    else {
      const Ie = cleanString(J.getV6InputValueFromSections(Re, he, S));
      let we = -1, Fe = -1;
      for (let We = 0; We < Ie.length; We += 1)
        we === -1 && Ie[We] !== $e[We] && (we = We), Fe === -1 && Ie[Ie.length - We - 1] !== $e[$e.length - We - 1] && (Fe = We);
      const De = Re[K];
      if (we < De.start || Ie.length - Fe - 1 > De.end)
        return;
      const ze = $e.length - Ie.length + De.end - cleanString(De.endSeparator || "").length;
      Oe = $e.slice(De.start + cleanString(De.startSeparator || "").length, ze);
    }
    if (Oe.length === 0) {
      isAndroid() && oe(be), ee(), Q();
      return;
    }
    X({
      keyPressed: Oe,
      sectionIndex: K
    });
  }), _e = React$1.useMemo(() => W !== void 0 ? W : J.getV6InputValueFromSections(se(Z.emptyValue), he, S), [W, J, se, Z.emptyValue, he, S]), ge = React$1.useMemo(() => Y.tempValueStrAndroid ?? J.getV6InputValueFromSections(Y.sections, he, S), [Y.sections, J, Y.tempValueStrAndroid, he, S]);
  React$1.useEffect(() => (xe.current && xe.current === getActiveElement(document) && ae("all"), () => {
    clearTimeout(R.current);
  }), []);
  const Ae = React$1.useMemo(() => K == null || Y.sections[K].contentType === "letter" ? "text" : "numeric", [K, Y.sections]), ve = !(xe.current && xe.current === getActiveElement(document)) && ie;
  return {
    interactions: ke,
    returnedValue: {
      // Forwarded
      readOnly: U,
      onBlur: ce,
      onClick: ue,
      onFocus: fe,
      onPaste: Ce,
      inputRef: Pe,
      // Additional
      enableAccessibleFieldDOMStructure: !1,
      placeholder: _e,
      inputMode: Ae,
      autoComplete: "off",
      value: ve ? "" : ge,
      onChange: pe
    }
  };
}, useField = (T) => {
  const S = useUtils(), {
    internalProps: R,
    internalProps: {
      unstableFieldRef: k,
      minutesStep: D,
      enableAccessibleFieldDOMStructure: L = !1,
      disabled: V = !1,
      readOnly: z = !1
    },
    forwardedProps: {
      onKeyDown: W,
      error: U,
      clearable: q,
      onClear: K
    },
    fieldValueManager: Y,
    valueManager: J,
    validator: Z
  } = T, X = useRtl(), ee = useFieldState(T), {
    state: te,
    activeSectionIndex: re,
    parsedSelectedSections: Q,
    setSelectedSections: ne,
    clearValue: oe,
    clearActiveSection: ae,
    updateSectionValue: se,
    setTempAndroidValueStr: ie,
    sectionsValueBoundaries: he,
    localizedDigits: xe,
    timezone: Pe
  } = ee, Re = useFieldCharacterEditing({
    sections: te.sections,
    updateSectionValue: se,
    sectionsValueBoundaries: he,
    localizedDigits: xe,
    setTempAndroidValueStr: ie,
    timezone: Pe
  }), {
    resetCharacterQuery: ke
  } = Re, Te = J.areValuesEqual(S, te.value, J.emptyValue), fe = L ? useFieldV7TextField : useFieldV6TextField, ue = React$1.useMemo(() => getSectionOrder(te.sections, X && !L), [te.sections, X, L]), {
    returnedValue: Ce,
    interactions: ce
  } = fe(_extends$1({}, T, ee, Re, {
    areAllSectionsEmpty: Te,
    sectionOrder: ue
  })), pe = useEventCallback((le) => {
    switch (W?.(le), !0) {
      case ((le.ctrlKey || le.metaKey) && le.key.toLowerCase() === "a" && !le.shiftKey && !le.altKey): {
        le.preventDefault(), ne("all");
        break;
      }
      case le.key === "ArrowRight": {
        if (le.preventDefault(), Q == null)
          ne(ue.startIndex);
        else if (Q === "all")
          ne(ue.endIndex);
        else {
          const me = ue.neighbors[Q].rightIndex;
          me !== null && ne(me);
        }
        break;
      }
      case le.key === "ArrowLeft": {
        if (le.preventDefault(), Q == null)
          ne(ue.endIndex);
        else if (Q === "all")
          ne(ue.startIndex);
        else {
          const me = ue.neighbors[Q].leftIndex;
          me !== null && ne(me);
        }
        break;
      }
      case le.key === "Delete": {
        if (le.preventDefault(), z)
          break;
        Q == null || Q === "all" ? oe() : ae(), ke();
        break;
      }
      case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(le.key): {
        if (le.preventDefault(), z || re == null)
          break;
        const me = te.sections[re], Se = Y.getActiveDateManager(S, te, me), ye = adjustSectionValue(S, Pe, me, le.key, he, xe, Se.date, {
          minutesStep: D
        });
        se({
          activeSection: me,
          newSectionValue: ye,
          shouldGoToNextSection: !1
        });
        break;
      }
    }
  });
  useEnhancedEffect(() => {
    ce.syncSelectionToDOM();
  });
  const _e = useValidation(_extends$1({}, R, {
    value: te.value,
    timezone: Pe
  }), Z, J.isSameError, J.defaultErrorState), ge = React$1.useMemo(() => U !== void 0 ? U : J.hasError(_e), [J, _e, U]);
  React$1.useEffect(() => {
    !ge && re == null && ke();
  }, [te.referenceValue, re, ge]), React$1.useEffect(() => {
    te.tempValueStrAndroid != null && re != null && (ke(), ae());
  }, [te.sections]), React$1.useImperativeHandle(k, () => ({
    getSections: () => te.sections,
    getActiveSectionIndex: ce.getActiveSectionIndexFromDOM,
    setSelectedSections: ce.setSelectedSections,
    focusField: ce.focusField,
    isFieldFocused: ce.isFieldFocused
  }));
  const Ae = useEventCallback((le, ...me) => {
    le.preventDefault(), K?.(le, ...me), oe(), ce.isFieldFocused() ? ne(ue.startIndex) : ce.focusField(0);
  }), Ee = {
    onKeyDown: pe,
    onClear: Ae,
    error: ge,
    clearable: !!(q && !Te && !z && !V)
  }, ve = {
    disabled: V,
    readOnly: z
  };
  return _extends$1({}, T.forwardedProps, Ee, ve, Ce);
}, validateDate = ({
  props: T,
  value: S,
  adapter: R
}) => {
  if (S === null)
    return null;
  const {
    shouldDisableDate: k,
    shouldDisableMonth: D,
    shouldDisableYear: L,
    disablePast: V,
    disableFuture: z,
    timezone: W
  } = T, U = R.utils.date(void 0, W), q = applyDefaultDate(R.utils, T.minDate, R.defaultDates.minDate), K = applyDefaultDate(R.utils, T.maxDate, R.defaultDates.maxDate);
  switch (!0) {
    case !R.utils.isValid(S):
      return "invalidDate";
    case !!(k && k(S)):
      return "shouldDisableDate";
    case !!(D && D(S)):
      return "shouldDisableMonth";
    case !!(L && L(S)):
      return "shouldDisableYear";
    case !!(z && R.utils.isAfterDay(S, U)):
      return "disableFuture";
    case !!(V && R.utils.isBeforeDay(S, U)):
      return "disablePast";
    case !!(q && R.utils.isBeforeDay(S, q)):
      return "minDate";
    case !!(K && R.utils.isAfterDay(S, K)):
      return "maxDate";
    default:
      return null;
  }
}, DATE_VALIDATION_PROP_NAMES = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], TIME_VALIDATION_PROP_NAMES = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], DATE_TIME_VALIDATION_PROP_NAMES = ["minDateTime", "maxDateTime"], VALIDATION_PROP_NAMES = [...DATE_VALIDATION_PROP_NAMES, ...TIME_VALIDATION_PROP_NAMES, ...DATE_TIME_VALIDATION_PROP_NAMES], extractValidationProps = (T) => VALIDATION_PROP_NAMES.reduce((S, R) => (T.hasOwnProperty(R) && (S[R] = T[R]), S), {}), SHARED_FIELD_INTERNAL_PROP_NAMES = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef", "enableAccessibleFieldDOMStructure", "disabled", "readOnly", "dateSeparator"], splitFieldInternalAndForwardedProps = (T, S) => {
  const R = _extends$1({}, T), k = {}, D = (L) => {
    R.hasOwnProperty(L) && (k[L] = R[L], delete R[L]);
  };
  return SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(D), S === "date" ? DATE_VALIDATION_PROP_NAMES.forEach(D) : S === "time" ? TIME_VALIDATION_PROP_NAMES.forEach(D) : S === "date-time" && (DATE_VALIDATION_PROP_NAMES.forEach(D), TIME_VALIDATION_PROP_NAMES.forEach(D), DATE_TIME_VALIDATION_PROP_NAMES.forEach(D)), {
    forwardedProps: R,
    internalProps: k
  };
}, useDefaultizedDateField = (T) => {
  const S = useUtils(), R = useDefaultDates();
  return _extends$1({}, T, {
    disablePast: T.disablePast ?? !1,
    disableFuture: T.disableFuture ?? !1,
    format: T.format ?? S.formats.keyboardDate,
    minDate: applyDefaultDate(S, T.minDate, R.minDate),
    maxDate: applyDefaultDate(S, T.maxDate, R.maxDate)
  });
}, useDefaultizedTimeField = (T) => {
  const S = useUtils(), k = T.ampm ?? S.is12HourCycleInCurrentLocale() ? S.formats.fullTime12h : S.formats.fullTime24h;
  return _extends$1({}, T, {
    disablePast: T.disablePast ?? !1,
    disableFuture: T.disableFuture ?? !1,
    format: T.format ?? k
  });
}, useDateField = (T) => {
  const S = useDefaultizedDateField(T), {
    forwardedProps: R,
    internalProps: k
  } = splitFieldInternalAndForwardedProps(S, "date");
  return useField({
    forwardedProps: R,
    internalProps: k,
    valueManager: singleItemValueManager,
    fieldValueManager: singleItemFieldValueManager,
    validator: validateDate,
    valueType: "date"
  });
};
function getInputAdornmentUtilityClass(T) {
  return generateUtilityClass$1("MuiInputAdornment", T);
}
const inputAdornmentClasses = generateUtilityClasses$1("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var define_process_env_default$v = {}, _span;
const _excluded$E = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], overridesResolver$1 = (T, S) => {
  const {
    ownerState: R
  } = T;
  return [S.root, S[`position${capitalize$1(R.position)}`], R.disablePointerEvents === !0 && S.disablePointerEvents, S[R.variant]];
}, useUtilityClasses$u = (T) => {
  const {
    classes: S,
    disablePointerEvents: R,
    hiddenLabel: k,
    position: D,
    size: L,
    variant: V
  } = T, z = {
    root: ["root", R && "disablePointerEvents", D && `position${capitalize$1(D)}`, V, k && "hiddenLabel", L && `size${capitalize$1(L)}`]
  };
  return composeClasses(z, getInputAdornmentUtilityClass, S);
}, InputAdornmentRoot = styled("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: overridesResolver$1
})(({
  theme: T,
  ownerState: S
}) => _extends$1({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (T.vars || T).palette.action.active
}, S.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${inputAdornmentClasses.positionStart}&:not(.${inputAdornmentClasses.hiddenLabel})`]: {
    marginTop: 16
  }
}, S.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, S.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, S.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), InputAdornment = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiInputAdornment"
  }), {
    children: D,
    className: L,
    component: V = "div",
    disablePointerEvents: z = !1,
    disableTypography: W = !1,
    position: U,
    variant: q
  } = k, K = _objectWithoutPropertiesLoose$1(k, _excluded$E), Y = useFormControl() || {};
  let J = q;
  q && Y.variant && define_process_env_default$v.NODE_ENV !== "production" && q === Y.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), Y && !J && (J = Y.variant);
  const Z = _extends$1({}, k, {
    hiddenLabel: Y.hiddenLabel,
    size: Y.size,
    disablePointerEvents: z,
    position: U,
    variant: J
  }), X = useUtilityClasses$u(Z);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
    value: null,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornmentRoot, _extends$1({
      as: V,
      ownerState: Z,
      className: clsx(X.root, L),
      ref: R
    }, K, {
      children: typeof D == "string" && !W ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, {
        color: "text.secondary",
        children: D
      }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [U === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          _span || (_span = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, D]
      })
    }))
  });
});
define_process_env_default$v.NODE_ENV !== "production" && (InputAdornment.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: PropTypes.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const _excluded$D = ["clearable", "onClear", "InputProps", "sx", "slots", "slotProps"], _excluded2$6 = ["ownerState"], useClearableField = (T) => {
  const S = usePickersTranslations(), {
    clearable: R,
    onClear: k,
    InputProps: D,
    sx: L,
    slots: V,
    slotProps: z
  } = T, W = _objectWithoutPropertiesLoose$1(T, _excluded$D), U = V?.clearButton ?? IconButton, q = useSlotProps({
    elementType: U,
    externalSlotProps: z?.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: S.fieldClearLabel
    }
  }), K = _objectWithoutPropertiesLoose$1(q, _excluded2$6), Y = V?.clearIcon ?? ClearIcon, J = useSlotProps({
    elementType: Y,
    externalSlotProps: z?.clearIcon,
    ownerState: {}
  });
  return _extends$1({}, W, {
    InputProps: _extends$1({}, D, {
      endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [R && /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornment, {
          position: "end",
          sx: {
            marginRight: D?.endAdornment ? -1 : -1.5
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(U, _extends$1({}, K, {
            onClick: k,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Y, _extends$1({
              fontSize: "small"
            }, J))
          }))
        }), D?.endAdornment]
      })
    }),
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(L) ? L : [L]]
  });
};
function getPickersTextFieldUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersTextField", T);
}
generateUtilityClasses$1("MuiPickersTextField", ["root", "focused", "disabled", "error", "required"]);
function getPickersInputBaseUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersInputBase", T);
}
const pickersInputBaseClasses = generateUtilityClasses$1("MuiPickersInputBase", ["root", "focused", "disabled", "error", "notchedOutline", "sectionContent", "sectionBefore", "sectionAfter", "adornedStart", "adornedEnd", "input"]);
function getPickersSectionListUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersSectionList", T);
}
const pickersSectionListClasses = generateUtilityClasses$1("MuiPickersSectionList", ["root", "section", "sectionContent"]);
var define_process_env_default$u = {};
const _excluded$C = ["slots", "slotProps", "elements", "sectionListRef"], PickersSectionListRoot = styled("div", {
  name: "MuiPickersSectionList",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  direction: "ltr /*! @noflip */",
  outline: "none"
}), PickersSectionListSection = styled("span", {
  name: "MuiPickersSectionList",
  slot: "Section",
  overridesResolver: (T, S) => S.section
})({}), PickersSectionListSectionSeparator = styled("span", {
  name: "MuiPickersSectionList",
  slot: "SectionSeparator",
  overridesResolver: (T, S) => S.sectionSeparator
})({
  whiteSpace: "pre"
}), PickersSectionListSectionContent = styled("span", {
  name: "MuiPickersSectionList",
  slot: "SectionContent",
  overridesResolver: (T, S) => S.sectionContent
})({
  outline: "none"
}), useUtilityClasses$t = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    section: ["section"],
    sectionContent: ["sectionContent"]
  }, getPickersSectionListUtilityClass, S);
};
function PickersSection(T) {
  const {
    slots: S,
    slotProps: R,
    element: k,
    classes: D
  } = T, L = S?.section ?? PickersSectionListSection, V = useSlotProps({
    elementType: L,
    externalSlotProps: R?.section,
    externalForwardedProps: k.container,
    className: D.section,
    ownerState: {}
  }), z = S?.sectionContent ?? PickersSectionListSectionContent, W = useSlotProps({
    elementType: z,
    externalSlotProps: R?.sectionContent,
    externalForwardedProps: k.content,
    additionalProps: {
      suppressContentEditableWarning: !0
    },
    className: D.sectionContent,
    ownerState: {}
  }), U = S?.sectionSeparator ?? PickersSectionListSectionSeparator, q = useSlotProps({
    elementType: U,
    externalSlotProps: R?.sectionSeparator,
    externalForwardedProps: k.before,
    ownerState: {
      position: "before"
    }
  }), K = useSlotProps({
    elementType: U,
    externalSlotProps: R?.sectionSeparator,
    externalForwardedProps: k.after,
    ownerState: {
      position: "after"
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(L, _extends$1({}, V, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(U, _extends$1({}, q)), /* @__PURE__ */ jsxRuntimeExports.jsx(z, _extends$1({}, W)), /* @__PURE__ */ jsxRuntimeExports.jsx(U, _extends$1({}, K))]
  }));
}
const PickersSectionList = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiPickersSectionList"
  }), {
    slots: D,
    slotProps: L,
    elements: V,
    sectionListRef: z
  } = k, W = _objectWithoutPropertiesLoose$1(k, _excluded$C), U = useUtilityClasses$t(k), q = React$1.useRef(null), K = useForkRef(R, q), Y = (X) => {
    if (!q.current)
      throw new Error(`MUI X: Cannot call sectionListRef.${X} before the mount of the component.`);
    return q.current;
  };
  React$1.useImperativeHandle(z, () => ({
    getRoot() {
      return Y("getRoot");
    },
    getSectionContainer(X) {
      return Y("getSectionContainer").querySelector(`.${pickersSectionListClasses.section}[data-sectionindex="${X}"]`);
    },
    getSectionContent(X) {
      return Y("getSectionContent").querySelector(`.${pickersSectionListClasses.section}[data-sectionindex="${X}"] .${pickersSectionListClasses.sectionContent}`);
    },
    getSectionIndexFromDOMElement(X) {
      const ee = Y("getSectionIndexFromDOMElement");
      if (X == null || !ee.contains(X))
        return null;
      let te = null;
      return X.classList.contains(pickersSectionListClasses.section) ? te = X : X.classList.contains(pickersSectionListClasses.sectionContent) && (te = X.parentElement), te == null ? null : Number(te.dataset.sectionindex);
    }
  }));
  const J = D?.root ?? PickersSectionListRoot, Z = useSlotProps({
    elementType: J,
    externalSlotProps: L?.root,
    externalForwardedProps: W,
    additionalProps: {
      ref: K,
      suppressContentEditableWarning: !0
    },
    className: U.root,
    ownerState: {}
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(J, _extends$1({}, Z, {
    children: Z.contentEditable ? V.map(({
      content: X,
      before: ee,
      after: te
    }) => `${ee.children}${X.children}${te.children}`).join("") : /* @__PURE__ */ jsxRuntimeExports.jsx(React$1.Fragment, {
      children: V.map((X, ee) => /* @__PURE__ */ jsxRuntimeExports.jsx(PickersSection, {
        slots: D,
        slotProps: L,
        element: X,
        classes: U
      }, ee))
    })
  }));
});
define_process_env_default$u.NODE_ENV !== "production" && (PickersSectionList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   */
  slots: PropTypes.object
});
var define_process_env_default$t = {};
const _excluded$B = ["elements", "areAllSectionsEmpty", "defaultValue", "label", "value", "onChange", "id", "autoFocus", "endAdornment", "startAdornment", "renderSuffix", "slots", "slotProps", "contentEditable", "tabIndex", "onInput", "onPaste", "onKeyDown", "fullWidth", "name", "readOnly", "inputProps", "inputRef", "sectionListRef"], round = (T) => Math.round(T * 1e5) / 1e5, PickersInputBaseRoot = styled("div", {
  name: "MuiPickersInputBase",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})(({
  theme: T
}) => _extends$1({}, T.typography.body1, {
  color: (T.vars || T).palette.text.primary,
  cursor: "text",
  padding: 0,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  letterSpacing: `${round(0.15 / 16)}em`,
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
})), PickersInputBaseSectionsContainer = styled(PickersSectionListRoot, {
  name: "MuiPickersInputBase",
  slot: "SectionsContainer",
  overridesResolver: (T, S) => S.sectionsContainer
})(({
  theme: T
}) => ({
  padding: "4px 0 5px",
  fontFamily: T.typography.fontFamily,
  fontSize: "inherit",
  lineHeight: "1.4375em",
  // 23px
  flexGrow: 1,
  outline: "none",
  display: "flex",
  flexWrap: "nowrap",
  overflow: "hidden",
  letterSpacing: "inherit",
  // Baseline behavior
  width: "182px",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      textAlign: "right /*! @noflip */"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingTop: 1
    }
  }, {
    props: {
      adornedStart: !1,
      focused: !1,
      filled: !1
    },
    style: {
      color: "currentColor",
      opacity: 0
    }
  }, {
    // Can't use the object notation because label can be null or undefined
    props: ({
      adornedStart: S,
      focused: R,
      filled: k,
      label: D
    }) => !S && !R && !k && D == null,
    style: T.vars ? {
      opacity: T.vars.opacity.inputPlaceholder
    } : {
      opacity: T.palette.mode === "light" ? 0.42 : 0.5
    }
  }]
})), PickersInputBaseSection = styled(PickersSectionListSection, {
  name: "MuiPickersInputBase",
  slot: "Section",
  overridesResolver: (T, S) => S.section
})(({
  theme: T
}) => ({
  fontFamily: T.typography.fontFamily,
  fontSize: "inherit",
  letterSpacing: "inherit",
  lineHeight: "1.4375em",
  // 23px
  display: "flex"
})), PickersInputBaseSectionContent = styled(PickersSectionListSectionContent, {
  name: "MuiPickersInputBase",
  slot: "SectionContent",
  overridesResolver: (T, S) => S.content
})(({
  theme: T
}) => ({
  fontFamily: T.typography.fontFamily,
  lineHeight: "1.4375em",
  // 23px
  letterSpacing: "inherit",
  width: "fit-content",
  outline: "none"
})), PickersInputBaseSectionSeparator = styled(PickersSectionListSectionSeparator, {
  name: "MuiPickersInputBase",
  slot: "Separator",
  overridesResolver: (T, S) => S.separator
})(() => ({
  whiteSpace: "pre",
  letterSpacing: "inherit"
})), PickersInputBaseInput = styled("input", {
  name: "MuiPickersInputBase",
  slot: "Input",
  overridesResolver: (T, S) => S.hiddenInput
})(_extends$1({}, visuallyHidden)), useUtilityClasses$s = (T) => {
  const {
    focused: S,
    disabled: R,
    error: k,
    classes: D,
    fullWidth: L,
    readOnly: V,
    color: z,
    size: W,
    endAdornment: U,
    startAdornment: q
  } = T, K = {
    root: ["root", S && !R && "focused", R && "disabled", V && "readOnly", k && "error", L && "fullWidth", `color${capitalize$1(z)}`, W === "small" && "inputSizeSmall", !!q && "adornedStart", !!U && "adornedEnd"],
    notchedOutline: ["notchedOutline"],
    input: ["input"],
    sectionsContainer: ["sectionsContainer"],
    sectionContent: ["sectionContent"],
    sectionBefore: ["sectionBefore"],
    sectionAfter: ["sectionAfter"]
  };
  return composeClasses(K, getPickersInputBaseUtilityClass, D);
}, PickersInputBase = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiPickersInputBase"
  }), {
    elements: D,
    areAllSectionsEmpty: L,
    value: V,
    onChange: z,
    id: W,
    endAdornment: U,
    startAdornment: q,
    renderSuffix: K,
    slots: Y,
    slotProps: J,
    contentEditable: Z,
    tabIndex: X,
    onInput: ee,
    onPaste: te,
    onKeyDown: re,
    name: Q,
    readOnly: ne,
    inputProps: oe,
    inputRef: ae,
    sectionListRef: se
  } = k, ie = _objectWithoutPropertiesLoose$1(k, _excluded$B), he = React$1.useRef(null), xe = useForkRef(R, he), Pe = useForkRef(oe?.ref, ae), Re = useRtl(), ke = useFormControl();
  if (!ke)
    throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
  const Te = (_e) => {
    if (ke.disabled) {
      _e.stopPropagation();
      return;
    }
    ke.onFocus?.(_e);
  };
  React$1.useEffect(() => {
    ke && ke.setAdornedStart(!!q);
  }, [ke, q]), React$1.useEffect(() => {
    ke && (L ? ke.onEmpty() : ke.onFilled());
  }, [ke, L]);
  const fe = _extends$1({}, k, ke, {
    isRtl: Re
  }), ue = useUtilityClasses$s(fe), Ce = Y?.root || PickersInputBaseRoot, ce = useSlotProps({
    elementType: Ce,
    externalSlotProps: J?.root,
    externalForwardedProps: ie,
    additionalProps: {
      "aria-invalid": ke.error,
      ref: xe
    },
    className: ue.root,
    ownerState: fe
  }), pe = Y?.input || PickersInputBaseSectionsContainer;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Ce, _extends$1({}, ce, {
    children: [q, /* @__PURE__ */ jsxRuntimeExports.jsx(PickersSectionList, {
      sectionListRef: se,
      elements: D,
      contentEditable: Z,
      tabIndex: X,
      className: ue.sectionsContainer,
      onFocus: Te,
      onBlur: ke.onBlur,
      onInput: ee,
      onPaste: te,
      onKeyDown: re,
      slots: {
        root: pe,
        section: PickersInputBaseSection,
        sectionContent: PickersInputBaseSectionContent,
        sectionSeparator: PickersInputBaseSectionSeparator
      },
      slotProps: {
        root: {
          ownerState: fe
        },
        sectionContent: {
          className: pickersInputBaseClasses.sectionContent
        },
        sectionSeparator: ({
          position: _e
        }) => ({
          className: _e === "before" ? pickersInputBaseClasses.sectionBefore : pickersInputBaseClasses.sectionAfter
        })
      }
    }), U, K ? K(_extends$1({}, ke)) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBaseInput, _extends$1({
      name: Q,
      className: ue.input,
      value: V,
      onChange: z,
      id: W,
      "aria-hidden": "true",
      tabIndex: -1,
      readOnly: ne,
      required: ke.required,
      disabled: ke.disabled
    }, oe, {
      ref: Pe
    }))]
  }));
});
define_process_env_default$t.NODE_ENV !== "production" && (PickersInputBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  ownerState: PropTypes.any,
  readOnly: PropTypes.bool,
  renderSuffix: PropTypes.func,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.object,
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired
});
function getPickersOutlinedInputUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersOutlinedInput", T);
}
const pickersOutlinedInputClasses = _extends$1({}, pickersInputBaseClasses, generateUtilityClasses$1("MuiPickersOutlinedInput", ["root", "notchedOutline", "input"])), _excluded$A = ["children", "className", "label", "notched", "shrink"], OutlineRoot = styled("fieldset", {
  name: "MuiPickersOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (T, S) => S.notchedOutline
})(({
  theme: T
}) => {
  const S = T.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%",
    borderColor: T.vars ? `rgba(${T.vars.palette.common.onBackgroundChannel} / 0.23)` : S
  };
}), OutlineLabel = styled("span")(({
  theme: T
}) => ({
  fontFamily: T.typography.fontFamily,
  fontSize: "inherit"
})), OutlineLegend = styled("legend")(({
  theme: T
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: {
      withLabel: !1
    },
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: T.transitions.create("width", {
        duration: 150,
        easing: T.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      withLabel: !0
    },
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: T.transitions.create("max-width", {
        duration: 50,
        easing: T.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: {
      withLabel: !0,
      notched: !0
    },
    style: {
      maxWidth: "100%",
      transition: T.transitions.create("max-width", {
        duration: 100,
        easing: T.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
}));
function Outline(T) {
  const {
    className: S,
    label: R
  } = T, k = _objectWithoutPropertiesLoose$1(T, _excluded$A), D = R != null && R !== "", L = _extends$1({}, T, {
    withLabel: D
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(OutlineRoot, _extends$1({
    "aria-hidden": !0,
    className: S
  }, k, {
    ownerState: L,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(OutlineLegend, {
      ownerState: L,
      children: D ? /* @__PURE__ */ jsxRuntimeExports.jsx(OutlineLabel, {
        children: R
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        /* @__PURE__ */ jsxRuntimeExports.jsx(OutlineLabel, {
          className: "notranslate",
          children: "​"
        })
      )
    })
  }));
}
var define_process_env_default$s = {};
const _excluded$z = ["label", "autoFocus", "ownerState", "notched"], PickersOutlinedInputRoot = styled(PickersInputBaseRoot, {
  name: "MuiPickersOutlinedInput",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})(({
  theme: T
}) => {
  const S = T.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    padding: "0 14px",
    borderRadius: (T.vars || T).shape.borderRadius,
    [`&:hover .${pickersOutlinedInputClasses.notchedOutline}`]: {
      borderColor: (T.vars || T).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${pickersOutlinedInputClasses.notchedOutline}`]: {
        borderColor: T.vars ? `rgba(${T.vars.palette.common.onBackgroundChannel} / 0.23)` : S
      }
    },
    [`&.${pickersOutlinedInputClasses.focused} .${pickersOutlinedInputClasses.notchedOutline}`]: {
      borderStyle: "solid",
      borderWidth: 2
    },
    [`&.${pickersOutlinedInputClasses.disabled}`]: {
      [`& .${pickersOutlinedInputClasses.notchedOutline}`]: {
        borderColor: (T.vars || T).palette.action.disabled
      },
      "*": {
        color: (T.vars || T).palette.action.disabled
      }
    },
    [`&.${pickersOutlinedInputClasses.error} .${pickersOutlinedInputClasses.notchedOutline}`]: {
      borderColor: (T.vars || T).palette.error.main
    },
    variants: Object.keys((T.vars ?? T).palette).filter((R) => (T.vars ?? T).palette[R]?.main ?? !1).map((R) => ({
      props: {
        color: R
      },
      style: {
        [`&.${pickersOutlinedInputClasses.focused}:not(.${pickersOutlinedInputClasses.error}) .${pickersOutlinedInputClasses.notchedOutline}`]: {
          // @ts-ignore
          borderColor: (T.vars || T).palette[R].main
        }
      }
    }))
  };
}), PickersOutlinedInputSectionsContainer = styled(PickersInputBaseSectionsContainer, {
  name: "MuiPickersOutlinedInput",
  slot: "SectionsContainer",
  overridesResolver: (T, S) => S.sectionsContainer
})({
  padding: "16.5px 0",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 0"
    }
  }]
}), useUtilityClasses$r = (T) => {
  const {
    classes: S
  } = T, k = composeClasses({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, getPickersOutlinedInputUtilityClass, S);
  return _extends$1({}, S, k);
}, PickersOutlinedInput = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiPickersOutlinedInput"
  }), {
    label: D,
    ownerState: L,
    notched: V
  } = k, z = _objectWithoutPropertiesLoose$1(k, _excluded$z), W = useFormControl(), U = _extends$1({}, k, L, W, {
    color: W?.color || "primary"
  }), q = useUtilityClasses$r(U);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBase, _extends$1({
    slots: {
      root: PickersOutlinedInputRoot,
      input: PickersOutlinedInputSectionsContainer
    },
    renderSuffix: (K) => /* @__PURE__ */ jsxRuntimeExports.jsx(Outline, {
      shrink: !!(V || K.adornedStart || K.focused || K.filled),
      notched: !!(V || K.adornedStart || K.focused || K.filled),
      className: q.notchedOutline,
      label: D != null && D !== "" && W?.required ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [D, " ", "*"]
      }) : D,
      ownerState: U
    })
  }, z, {
    label: D,
    classes: q,
    ref: R
  }));
});
define_process_env_default$s.NODE_ENV !== "production" && (PickersOutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  notched: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  ownerState: PropTypes.any,
  readOnly: PropTypes.bool,
  renderSuffix: PropTypes.func,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.object,
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired
});
PickersOutlinedInput.muiName = "Input";
function getPickersFilledInputUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersFilledInput", T);
}
const pickersFilledInputClasses = _extends$1({}, pickersInputBaseClasses, generateUtilityClasses$1("MuiPickersFilledInput", ["root", "underline", "input"]));
var define_process_env_default$r = {};
const _excluded$y = ["label", "autoFocus", "disableUnderline", "ownerState"], PickersFilledInputRoot = styled(PickersInputBaseRoot, {
  name: "MuiPickersFilledInput",
  slot: "Root",
  overridesResolver: (T, S) => S.root,
  shouldForwardProp: (T) => shouldForwardProp$1(T) && T !== "disableUnderline"
})(({
  theme: T
}) => {
  const S = T.palette.mode === "light", R = S ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", k = S ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", D = S ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", L = S ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    backgroundColor: T.vars ? T.vars.palette.FilledInput.bg : k,
    borderTopLeftRadius: (T.vars || T).shape.borderRadius,
    borderTopRightRadius: (T.vars || T).shape.borderRadius,
    transition: T.transitions.create("background-color", {
      duration: T.transitions.duration.shorter,
      easing: T.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: T.vars ? T.vars.palette.FilledInput.hoverBg : D,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: T.vars ? T.vars.palette.FilledInput.bg : k
      }
    },
    [`&.${pickersFilledInputClasses.focused}`]: {
      backgroundColor: T.vars ? T.vars.palette.FilledInput.bg : k
    },
    [`&.${pickersFilledInputClasses.disabled}`]: {
      backgroundColor: T.vars ? T.vars.palette.FilledInput.disabledBg : L
    },
    variants: [...Object.keys((T.vars ?? T).palette).filter((V) => (T.vars ?? T).palette[V].main).map((V) => ({
      props: {
        color: V,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(T.vars || T).palette[V]?.main}`
        }
      }
    })), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: T.transitions.create("transform", {
            duration: T.transitions.duration.shorter,
            easing: T.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${pickersFilledInputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${pickersFilledInputClasses.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (T.vars || T).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${T.vars ? `rgba(${T.vars.palette.common.onBackgroundChannel} / ${T.vars.opacity.inputUnderline})` : R}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: T.transitions.create("border-bottom-color", {
            duration: T.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${pickersFilledInputClasses.disabled}, .${pickersFilledInputClasses.error}):before`]: {
          borderBottom: `1px solid ${(T.vars || T).palette.text.primary}`
        },
        [`&.${pickersFilledInputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, {
      props: ({
        startAdornment: V
      }) => !!V,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        endAdornment: V
      }) => !!V,
      style: {
        paddingRight: 12
      }
    }]
  };
}), PickersFilledSectionsContainer = styled(PickersInputBaseSectionsContainer, {
  name: "MuiPickersFilledInput",
  slot: "sectionsContainer",
  overridesResolver: (T, S) => S.sectionsContainer
})({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      startAdornment: T
    }) => !!T,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      endAdornment: T
    }) => !!T,
    style: {
      paddingRight: 0
    }
  }, {
    props: {
      hiddenLabel: !0
    },
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: {
      hiddenLabel: !0,
      size: "small"
    },
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }]
}), useUtilityClasses$q = (T) => {
  const {
    classes: S,
    disableUnderline: R
  } = T, D = composeClasses({
    root: ["root", !R && "underline"],
    input: ["input"]
  }, getPickersFilledInputUtilityClass, S);
  return _extends$1({}, S, D);
}, PickersFilledInput = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiPickersFilledInput"
  }), {
    label: D,
    disableUnderline: L = !1,
    ownerState: V
  } = k, z = _objectWithoutPropertiesLoose$1(k, _excluded$y), W = useFormControl(), U = _extends$1({}, k, V, W, {
    color: W?.color || "primary"
  }), q = useUtilityClasses$q(U);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBase, _extends$1({
    slots: {
      root: PickersFilledInputRoot,
      input: PickersFilledSectionsContainer
    },
    slotProps: {
      root: {
        disableUnderline: L
      }
    }
  }, z, {
    label: D,
    classes: q,
    ref: R
  }));
});
define_process_env_default$r.NODE_ENV !== "production" && (PickersFilledInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  disableUnderline: PropTypes.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  fullWidth: PropTypes.bool,
  hiddenLabel: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  ownerState: PropTypes.any,
  readOnly: PropTypes.bool,
  renderSuffix: PropTypes.func,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.object,
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired
});
PickersFilledInput.muiName = "Input";
function getPickersInputUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersFilledInput", T);
}
const pickersInputClasses = _extends$1({}, pickersInputBaseClasses, generateUtilityClasses$1("MuiPickersInput", ["root", "input"]));
var define_process_env_default$q = {};
const _excluded$x = ["label", "autoFocus", "disableUnderline", "ownerState"], PickersInputRoot = styled(PickersInputBaseRoot, {
  name: "MuiPickersInput",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})(({
  theme: T
}) => {
  let R = T.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return T.vars && (R = `rgba(${T.vars.palette.common.onBackgroundChannel} / ${T.vars.opacity.inputUnderline})`), {
    "label + &": {
      marginTop: 16
    },
    variants: [...Object.keys((T.vars ?? T).palette).filter((k) => (T.vars ?? T).palette[k].main).map((k) => ({
      props: {
        color: k
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(T.vars || T).palette[k].main}`
        }
      }
    })), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          background: "red",
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: T.transitions.create("transform", {
            duration: T.transitions.duration.shorter,
            easing: T.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${pickersInputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${pickersInputClasses.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (T.vars || T).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${R}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: T.transitions.create("border-bottom-color", {
            duration: T.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${pickersInputClasses.disabled}, .${pickersInputClasses.error}):before`]: {
          borderBottom: `2px solid ${(T.vars || T).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${R}`
          }
        },
        [`&.${pickersInputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }]
  };
}), useUtilityClasses$p = (T) => {
  const {
    classes: S,
    disableUnderline: R
  } = T, D = composeClasses({
    root: ["root", !R && "underline"],
    input: ["input"]
  }, getPickersInputUtilityClass, S);
  return _extends$1({}, S, D);
}, PickersInput = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiPickersInput"
  }), {
    label: D,
    disableUnderline: L = !1,
    ownerState: V
  } = k, z = _objectWithoutPropertiesLoose$1(k, _excluded$x), W = useFormControl(), U = _extends$1({}, k, V, W, {
    disableUnderline: L,
    color: W?.color || "primary"
  }), q = useUtilityClasses$p(U);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersInputBase, _extends$1({
    slots: {
      root: PickersInputRoot
    }
  }, z, {
    label: D,
    classes: q,
    ref: R
  }));
});
define_process_env_default$q.NODE_ENV !== "production" && (PickersInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  disableUnderline: PropTypes.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  fullWidth: PropTypes.bool,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  ownerState: PropTypes.any,
  readOnly: PropTypes.bool,
  renderSuffix: PropTypes.func,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: PropTypes.object,
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired
});
PickersInput.muiName = "Input";
var define_process_env_default$p = {};
const _excluded$w = ["onFocus", "onBlur", "className", "color", "disabled", "error", "variant", "required", "InputProps", "inputProps", "inputRef", "sectionListRef", "elements", "areAllSectionsEmpty", "onClick", "onKeyDown", "onKeyUp", "onPaste", "onInput", "endAdornment", "startAdornment", "tabIndex", "contentEditable", "focused", "value", "onChange", "fullWidth", "id", "name", "helperText", "FormHelperTextProps", "label", "InputLabelProps"], VARIANT_COMPONENT = {
  standard: PickersInput,
  filled: PickersFilledInput,
  outlined: PickersOutlinedInput
}, PickersTextFieldRoot = styled(FormControl, {
  name: "MuiPickersTextField",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({}), useUtilityClasses$o = (T) => {
  const {
    focused: S,
    disabled: R,
    classes: k,
    required: D
  } = T;
  return composeClasses({
    root: ["root", S && !R && "focused", R && "disabled", D && "required"]
  }, getPickersTextFieldUtilityClass, k);
}, PickersTextField = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiPickersTextField"
  }), {
    // Props used by FormControl
    onFocus: D,
    onBlur: L,
    className: V,
    color: z = "primary",
    disabled: W = !1,
    error: U = !1,
    variant: q = "outlined",
    required: K = !1,
    // Props used by PickersInput
    InputProps: Y,
    inputProps: J,
    inputRef: Z,
    sectionListRef: X,
    elements: ee,
    areAllSectionsEmpty: te,
    onClick: re,
    onKeyDown: Q,
    onPaste: ne,
    onInput: oe,
    endAdornment: ae,
    startAdornment: se,
    tabIndex: ie,
    contentEditable: he,
    focused: xe,
    value: Pe,
    onChange: Re,
    fullWidth: ke,
    id: Te,
    name: fe,
    // Props used by FormHelperText
    helperText: ue,
    FormHelperTextProps: Ce,
    // Props used by InputLabel
    label: ce,
    InputLabelProps: pe
  } = k, _e = _objectWithoutPropertiesLoose$1(k, _excluded$w), ge = React$1.useRef(null), Ae = useForkRef(R, ge), Ee = useId(Te), ve = ue && Ee ? `${Ee}-helper-text` : void 0, le = ce && Ee ? `${Ee}-label` : void 0, me = _extends$1({}, k, {
    color: z,
    disabled: W,
    error: U,
    focused: xe,
    required: K,
    variant: q
  }), Se = useUtilityClasses$o(me), ye = VARIANT_COMPONENT[q];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersTextFieldRoot, _extends$1({
    className: clsx(Se.root, V),
    ref: Ae,
    focused: xe,
    onFocus: D,
    onBlur: L,
    disabled: W,
    variant: q,
    error: U,
    color: z,
    fullWidth: ke,
    required: K,
    ownerState: me
  }, _e, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(InputLabel, _extends$1({
      htmlFor: Ee,
      id: le
    }, pe, {
      children: ce
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(ye, _extends$1({
      elements: ee,
      areAllSectionsEmpty: te,
      onClick: re,
      onKeyDown: Q,
      onInput: oe,
      onPaste: ne,
      endAdornment: ae,
      startAdornment: se,
      tabIndex: ie,
      contentEditable: he,
      value: Pe,
      onChange: Re,
      id: Ee,
      fullWidth: ke,
      inputProps: J,
      inputRef: Z,
      sectionListRef: X,
      label: ce,
      name: fe,
      role: "group",
      "aria-labelledby": le
    }, Y)), ue && /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperText, _extends$1({
      id: ve
    }, Ce, {
      children: ue
    }))]
  }));
});
define_process_env_default$p.NODE_ENV !== "production" && (PickersTextField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: PropTypes.bool.isRequired,
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: PropTypes.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: PropTypes.arrayOf(PropTypes.shape({
    after: PropTypes.object.isRequired,
    before: PropTypes.object.isRequired,
    container: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired
  })).isRequired,
  endAdornment: PropTypes.node,
  error: PropTypes.bool.isRequired,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  FormHelperTextProps: PropTypes.object,
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  id: PropTypes.string,
  InputLabelProps: PropTypes.object,
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,
  inputRef: refType,
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  name: PropTypes.string,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  onInput: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  onPaste: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: PropTypes.bool,
  sectionListRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      getRoot: PropTypes.func.isRequired,
      getSectionContainer: PropTypes.func.isRequired,
      getSectionContent: PropTypes.func.isRequired,
      getSectionIndexFromDOMElement: PropTypes.func.isRequired
    })
  })]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOf(["medium", "small"]),
  startAdornment: PropTypes.node,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.string.isRequired,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const _excluded$v = ["enableAccessibleFieldDOMStructure"], _excluded2$5 = ["InputProps", "readOnly"], _excluded3$1 = ["onPaste", "onKeyDown", "inputMode", "readOnly", "InputProps", "inputProps", "inputRef"], convertFieldResponseIntoMuiTextFieldProps = (T) => {
  let {
    enableAccessibleFieldDOMStructure: S
  } = T, R = _objectWithoutPropertiesLoose$1(T, _excluded$v);
  if (S) {
    const {
      InputProps: K,
      readOnly: Y
    } = R, J = _objectWithoutPropertiesLoose$1(R, _excluded2$5);
    return _extends$1({}, J, {
      InputProps: _extends$1({}, K ?? {}, {
        readOnly: Y
      })
    });
  }
  const {
    onPaste: k,
    onKeyDown: D,
    inputMode: L,
    readOnly: V,
    InputProps: z,
    inputProps: W,
    inputRef: U
  } = R, q = _objectWithoutPropertiesLoose$1(R, _excluded3$1);
  return _extends$1({}, q, {
    InputProps: _extends$1({}, z ?? {}, {
      readOnly: V
    }),
    inputProps: _extends$1({}, W ?? {}, {
      inputMode: L,
      onPaste: k,
      onKeyDown: D,
      ref: U
    })
  });
};
var define_process_env_default$o = {};
const _excluded$u = ["slots", "slotProps", "InputProps", "inputProps"], DateField$1 = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiDateField"
  }), {
    slots: D,
    slotProps: L,
    InputProps: V,
    inputProps: z
  } = k, W = _objectWithoutPropertiesLoose$1(k, _excluded$u), U = k, q = D?.textField ?? (S.enableAccessibleFieldDOMStructure ? PickersTextField : TextField$3), K = useSlotProps({
    elementType: q,
    externalSlotProps: L?.textField,
    externalForwardedProps: W,
    additionalProps: {
      ref: R
    },
    ownerState: U
  });
  K.inputProps = _extends$1({}, z, K.inputProps), K.InputProps = _extends$1({}, V, K.InputProps);
  const Y = useDateField(K), J = convertFieldResponseIntoMuiTextFieldProps(Y), Z = useClearableField(_extends$1({}, J, {
    slots: D,
    slotProps: L
  }));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(q, _extends$1({}, Z));
});
define_process_env_default$o.NODE_ENV !== "production" && (DateField$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: PropTypes.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: PropTypes.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.object,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: PropTypes.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: PropTypes.func,
  onFocus: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: PropTypes.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: PropTypes.bool,
  /**
   * The size of the component.
   */
  size: PropTypes.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const validateTime = ({
  adapter: T,
  value: S,
  props: R
}) => {
  if (S === null)
    return null;
  const {
    minTime: k,
    maxTime: D,
    minutesStep: L,
    shouldDisableTime: V,
    disableIgnoringDatePartForTimeValidation: z = !1,
    disablePast: W,
    disableFuture: U,
    timezone: q
  } = R, K = T.utils.date(void 0, q), Y = createIsAfterIgnoreDatePart(z, T.utils);
  switch (!0) {
    case !T.utils.isValid(S):
      return "invalidDate";
    case !!(k && Y(k, S)):
      return "minTime";
    case !!(D && Y(S, D)):
      return "maxTime";
    case !!(U && T.utils.isAfter(S, K)):
      return "disableFuture";
    case !!(W && T.utils.isBefore(S, K)):
      return "disablePast";
    case !!(V && V(S, "hours")):
      return "shouldDisableTime-hours";
    case !!(V && V(S, "minutes")):
      return "shouldDisableTime-minutes";
    case !!(V && V(S, "seconds")):
      return "shouldDisableTime-seconds";
    case !!(L && T.utils.getMinutes(S) % L !== 0):
      return "minutesStep";
    default:
      return null;
  }
}, useTimeField = (T) => {
  const S = useDefaultizedTimeField(T), {
    forwardedProps: R,
    internalProps: k
  } = splitFieldInternalAndForwardedProps(S, "time");
  return useField({
    forwardedProps: R,
    internalProps: k,
    valueManager: singleItemValueManager,
    fieldValueManager: singleItemFieldValueManager,
    validator: validateTime,
    valueType: "time"
  });
};
var define_process_env_default$n = {};
const _excluded$t = ["slots", "slotProps", "InputProps", "inputProps"], TimeField$1 = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiTimeField"
  }), {
    slots: D,
    slotProps: L,
    InputProps: V,
    inputProps: z
  } = k, W = _objectWithoutPropertiesLoose$1(k, _excluded$t), U = k, q = D?.textField ?? (S.enableAccessibleFieldDOMStructure ? PickersTextField : TextField$3), K = useSlotProps({
    elementType: q,
    externalSlotProps: L?.textField,
    externalForwardedProps: W,
    ownerState: U,
    additionalProps: {
      ref: R
    }
  });
  K.inputProps = _extends$1({}, z, K.inputProps), K.InputProps = _extends$1({}, V, K.InputProps);
  const Y = useTimeField(K), J = convertFieldResponseIntoMuiTextFieldProps(Y), Z = useClearableField(_extends$1({}, J, {
    slots: D,
    slotProps: L
  }));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(q, _extends$1({}, Z));
});
define_process_env_default$n.NODE_ENV !== "production" && (TimeField$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: PropTypes.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: PropTypes.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: PropTypes.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: PropTypes.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: PropTypes.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: PropTypes.number,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: PropTypes.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: PropTypes.func,
  onFocus: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: PropTypes.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: PropTypes.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: PropTypes.bool,
  /**
   * The size of the component.
   */
  size: PropTypes.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const useIsDateDisabled = ({
  shouldDisableDate: T,
  shouldDisableMonth: S,
  shouldDisableYear: R,
  minDate: k,
  maxDate: D,
  disableFuture: L,
  disablePast: V,
  timezone: z
}) => {
  const W = useLocalizationContext();
  return React$1.useCallback((U) => validateDate({
    adapter: W,
    value: U,
    props: {
      shouldDisableDate: T,
      shouldDisableMonth: S,
      shouldDisableYear: R,
      minDate: k,
      maxDate: D,
      disableFuture: L,
      disablePast: V,
      timezone: z
    }
  }) !== null, [W, T, S, R, k, D, L, V, z]);
}, createCalendarStateReducer = (T, S, R) => (k, D) => {
  switch (D.type) {
    case "changeMonth":
      return _extends$1({}, k, {
        slideDirection: D.direction,
        currentMonth: D.newMonth,
        isMonthSwitchingAnimating: !T
      });
    case "finishMonthSwitchingAnimation":
      return _extends$1({}, k, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (k.focusedDay != null && D.focusedDay != null && R.isSameDay(D.focusedDay, k.focusedDay))
        return k;
      const L = D.focusedDay != null && !S && !R.isSameMonth(k.currentMonth, D.focusedDay);
      return _extends$1({}, k, {
        focusedDay: D.focusedDay,
        isMonthSwitchingAnimating: L && !T && !D.withoutMonthSwitchingAnimation,
        currentMonth: L ? R.startOfMonth(D.focusedDay) : k.currentMonth,
        slideDirection: D.focusedDay != null && R.isAfterDay(D.focusedDay, k.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
}, useCalendarState = (T) => {
  const {
    value: S,
    referenceDate: R,
    disableFuture: k,
    disablePast: D,
    disableSwitchToMonthOnDayFocus: L = !1,
    maxDate: V,
    minDate: z,
    onMonthChange: W,
    reduceAnimations: U,
    shouldDisableDate: q,
    timezone: K
  } = T, Y = useUtils(), J = React$1.useRef(createCalendarStateReducer(!!U, L, Y)).current, Z = React$1.useMemo(
    () => singleItemValueManager.getInitialReferenceValue({
      value: S,
      utils: Y,
      timezone: K,
      props: T,
      referenceDate: R,
      granularity: SECTION_TYPE_GRANULARITY.day
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), [X, ee] = React$1.useReducer(J, {
    isMonthSwitchingAnimating: !1,
    focusedDay: Z,
    currentMonth: Y.startOfMonth(Z),
    slideDirection: "left"
  }), te = React$1.useCallback((ae) => {
    ee(_extends$1({
      type: "changeMonth"
    }, ae)), W && W(ae.newMonth);
  }, [W]), re = React$1.useCallback((ae) => {
    const se = ae;
    Y.isSameMonth(se, X.currentMonth) || te({
      newMonth: Y.startOfMonth(se),
      direction: Y.isAfterDay(se, X.currentMonth) ? "left" : "right"
    });
  }, [X.currentMonth, te, Y]), Q = useIsDateDisabled({
    shouldDisableDate: q,
    minDate: z,
    maxDate: V,
    disableFuture: k,
    disablePast: D,
    timezone: K
  }), ne = React$1.useCallback(() => {
    ee({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), oe = useEventCallback((ae, se) => {
    Q(ae) || ee({
      type: "changeFocusedDay",
      focusedDay: ae,
      withoutMonthSwitchingAnimation: se
    });
  });
  return {
    referenceDate: Z,
    calendarState: X,
    changeMonth: re,
    changeFocusedDay: oe,
    isDateDisabled: Q,
    onMonthSwitchingAnimationEnd: ne,
    handleChangeMonth: te
  };
}, getPickersFadeTransitionGroupUtilityClass = (T) => generateUtilityClass$1("MuiPickersFadeTransitionGroup", T);
generateUtilityClasses$1("MuiPickersFadeTransitionGroup", ["root"]);
const useUtilityClasses$n = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"]
  }, getPickersFadeTransitionGroupUtilityClass, S);
}, PickersFadeTransitionGroupRoot = styled(TransitionGroup, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  display: "block",
  position: "relative"
});
function PickersFadeTransitionGroup(T) {
  const S = useThemeProps({
    props: T,
    name: "MuiPickersFadeTransitionGroup"
  }), {
    children: R,
    className: k,
    reduceAnimations: D,
    transKey: L
  } = S, V = useUtilityClasses$n(S), z = useTheme$1();
  return D ? R : /* @__PURE__ */ jsxRuntimeExports.jsx(PickersFadeTransitionGroupRoot, {
    className: clsx(V.root, k),
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Fade, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: z.transitions.duration.enteringScreen,
        enter: z.transitions.duration.enteringScreen,
        exit: 0
      },
      children: R
    }, L)
  });
}
const getPickersSlideTransitionUtilityClass = (T) => generateUtilityClass$1("MuiPickersSlideTransition", T), pickersSlideTransitionClasses = generateUtilityClasses$1("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), _excluded$s = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"], useUtilityClasses$m = (T) => {
  const {
    classes: S,
    slideDirection: R
  } = T, k = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${R}`],
    exitActive: [`slideExitActiveLeft-${R}`]
  };
  return composeClasses(k, getPickersSlideTransitionUtilityClass, S);
}, PickersSlideTransitionRoot = styled(TransitionGroup, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (T, S) => [S.root, {
    [`.${pickersSlideTransitionClasses["slideEnter-left"]}`]: S["slideEnter-left"]
  }, {
    [`.${pickersSlideTransitionClasses["slideEnter-right"]}`]: S["slideEnter-right"]
  }, {
    [`.${pickersSlideTransitionClasses.slideEnterActive}`]: S.slideEnterActive
  }, {
    [`.${pickersSlideTransitionClasses.slideExit}`]: S.slideExit
  }, {
    [`.${pickersSlideTransitionClasses["slideExitActiveLeft-left"]}`]: S["slideExitActiveLeft-left"]
  }, {
    [`.${pickersSlideTransitionClasses["slideExitActiveLeft-right"]}`]: S["slideExitActiveLeft-right"]
  }]
})(({
  theme: T
}) => {
  const S = T.transitions.create("transform", {
    duration: T.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${pickersSlideTransitionClasses["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${pickersSlideTransitionClasses.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: S
    },
    [`& .${pickersSlideTransitionClasses.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${pickersSlideTransitionClasses["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: S,
      zIndex: 0
    },
    [`& .${pickersSlideTransitionClasses["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: S,
      zIndex: 0
    }
  };
});
function PickersSlideTransition(T) {
  const S = useThemeProps({
    props: T,
    name: "MuiPickersSlideTransition"
  }), {
    children: R,
    className: k,
    reduceAnimations: D,
    transKey: L
    // extracting `classes` from `other`
  } = S, V = _objectWithoutPropertiesLoose$1(S, _excluded$s), z = useUtilityClasses$m(S), W = useTheme$1();
  if (D)
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      className: clsx(z.root, k),
      children: R
    });
  const U = {
    exit: z.exit,
    enterActive: z.enterActive,
    enter: z.enter,
    exitActive: z.exitActive
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersSlideTransitionRoot, {
    className: clsx(z.root, k),
    childFactory: (q) => /* @__PURE__ */ React$1.cloneElement(q, {
      classNames: U
    }),
    role: "presentation",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(CSSTransition, _extends$1({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: W.transitions.duration.complex,
      classNames: U
    }, V, {
      children: R
    }), L)
  });
}
const getDayCalendarUtilityClass = (T) => generateUtilityClass$1("MuiDayCalendar", T);
generateUtilityClasses$1("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
const _excluded$r = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], _excluded2$4 = ["ownerState"], useUtilityClasses$l = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  }, getDayCalendarUtilityClass, S);
}, weeksContainerHeight = (DAY_SIZE + DAY_MARGIN * 2) * 6, PickersCalendarDayRoot = styled("div", {
  name: "MuiDayCalendar",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({}), PickersCalendarDayHeader = styled("div", {
  name: "MuiDayCalendar",
  slot: "Header",
  overridesResolver: (T, S) => S.header
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), PickersCalendarWeekDayLabel = styled(Typography$2, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel",
  overridesResolver: (T, S) => S.weekDayLabel
})(({
  theme: T
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (T.vars || T).palette.text.secondary
})), PickersCalendarWeekNumberLabel = styled(Typography$2, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel",
  overridesResolver: (T, S) => S.weekNumberLabel
})(({
  theme: T
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: T.palette.text.disabled
})), PickersCalendarWeekNumber = styled(Typography$2, {
  name: "MuiDayCalendar",
  slot: "WeekNumber",
  overridesResolver: (T, S) => S.weekNumber
})(({
  theme: T
}) => _extends$1({}, T.typography.caption, {
  width: DAY_SIZE,
  height: DAY_SIZE,
  padding: 0,
  margin: `0 ${DAY_MARGIN}px`,
  color: T.palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
})), PickersCalendarLoadingContainer = styled("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer",
  overridesResolver: (T, S) => S.loadingContainer
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: weeksContainerHeight
}), PickersCalendarSlideTransition = styled(PickersSlideTransition, {
  name: "MuiDayCalendar",
  slot: "SlideTransition",
  overridesResolver: (T, S) => S.slideTransition
})({
  minHeight: weeksContainerHeight
}), PickersCalendarWeekContainer = styled("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer",
  overridesResolver: (T, S) => S.monthContainer
})({
  overflow: "hidden"
}), PickersCalendarWeek = styled("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer",
  overridesResolver: (T, S) => S.weekContainer
})({
  margin: `${DAY_MARGIN}px 0`,
  display: "flex",
  justifyContent: "center"
});
function WrappedDay(T) {
  let {
    parentProps: S,
    day: R,
    focusableDay: k,
    selectedDays: D,
    isDateDisabled: L,
    currentMonthNumber: V,
    isViewFocused: z
  } = T, W = _objectWithoutPropertiesLoose$1(T, _excluded$r);
  const {
    disabled: U,
    disableHighlightToday: q,
    isMonthSwitchingAnimating: K,
    showDaysOutsideCurrentMonth: Y,
    slots: J,
    slotProps: Z,
    timezone: X
  } = S, ee = useUtils(), te = useNow(X), re = k !== null && ee.isSameDay(R, k), Q = D.some((Re) => ee.isSameDay(Re, R)), ne = ee.isSameDay(R, te), oe = J?.day ?? PickersDay, ae = useSlotProps({
    elementType: oe,
    externalSlotProps: Z?.day,
    additionalProps: _extends$1({
      disableHighlightToday: q,
      showDaysOutsideCurrentMonth: Y,
      role: "gridcell",
      isAnimating: K,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": ee.toJsDate(R).valueOf()
    }, W),
    ownerState: _extends$1({}, S, {
      day: R,
      selected: Q
    })
  }), se = _objectWithoutPropertiesLoose$1(ae, _excluded2$4), ie = React$1.useMemo(() => U || L(R), [U, L, R]), he = React$1.useMemo(() => ee.getMonth(R) !== V, [ee, R, V]), xe = React$1.useMemo(() => {
    const Re = ee.startOfMonth(ee.setMonth(R, V));
    return Y ? ee.isSameDay(R, ee.startOfWeek(Re)) : ee.isSameDay(R, Re);
  }, [V, R, Y, ee]), Pe = React$1.useMemo(() => {
    const Re = ee.endOfMonth(ee.setMonth(R, V));
    return Y ? ee.isSameDay(R, ee.endOfWeek(Re)) : ee.isSameDay(R, Re);
  }, [V, R, Y, ee]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(oe, _extends$1({}, se, {
    day: R,
    disabled: ie,
    autoFocus: z && re,
    today: ne,
    outsideCurrentMonth: he,
    isFirstVisibleCell: xe,
    isLastVisibleCell: Pe,
    selected: Q,
    tabIndex: re ? 0 : -1,
    "aria-selected": Q,
    "aria-current": ne ? "date" : void 0
  }));
}
function DayCalendar(T) {
  const S = useThemeProps({
    props: T,
    name: "MuiDayCalendar"
  }), R = useUtils(), {
    onFocusedDayChange: k,
    className: D,
    currentMonth: L,
    selectedDays: V,
    focusedDay: z,
    loading: W,
    onSelectedDaysChange: U,
    onMonthSwitchingAnimationEnd: q,
    readOnly: K,
    reduceAnimations: Y,
    renderLoading: J = () => /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      children: "..."
    }),
    slideDirection: Z,
    TransitionProps: X,
    disablePast: ee,
    disableFuture: te,
    minDate: re,
    maxDate: Q,
    shouldDisableDate: ne,
    shouldDisableMonth: oe,
    shouldDisableYear: ae,
    dayOfWeekFormatter: se = (ze) => R.format(ze, "weekdayShort").charAt(0).toUpperCase(),
    hasFocus: ie,
    onFocusedViewChange: he,
    gridLabelId: xe,
    displayWeekNumber: Pe,
    fixedWeekNumber: Re,
    autoFocus: ke,
    timezone: Te
  } = S, fe = useNow(Te), ue = useUtilityClasses$l(S), Ce = useRtl(), ce = useIsDateDisabled({
    shouldDisableDate: ne,
    shouldDisableMonth: oe,
    shouldDisableYear: ae,
    minDate: re,
    maxDate: Q,
    disablePast: ee,
    disableFuture: te,
    timezone: Te
  }), pe = usePickersTranslations(), [_e, ge] = useControlled({
    name: "DayCalendar",
    state: "hasFocus",
    controlled: ie,
    default: ke ?? !1
  }), [Ae, Ee] = React$1.useState(() => z || fe), ve = useEventCallback((ze) => {
    K || U(ze);
  }), le = (ze) => {
    ce(ze) || (k(ze), Ee(ze), he?.(!0), ge(!0));
  }, me = useEventCallback((ze, We) => {
    switch (ze.key) {
      case "ArrowUp":
        le(R.addDays(We, -7)), ze.preventDefault();
        break;
      case "ArrowDown":
        le(R.addDays(We, 7)), ze.preventDefault();
        break;
      case "ArrowLeft": {
        const Be = R.addDays(We, Ce ? 1 : -1), Ye = R.addMonths(We, Ce ? 1 : -1), Ge = findClosestEnabledDate({
          utils: R,
          date: Be,
          minDate: Ce ? Be : R.startOfMonth(Ye),
          maxDate: Ce ? R.endOfMonth(Ye) : Be,
          isDateDisabled: ce,
          timezone: Te
        });
        le(Ge || Be), ze.preventDefault();
        break;
      }
      case "ArrowRight": {
        const Be = R.addDays(We, Ce ? -1 : 1), Ye = R.addMonths(We, Ce ? -1 : 1), Ge = findClosestEnabledDate({
          utils: R,
          date: Be,
          minDate: Ce ? R.startOfMonth(Ye) : Be,
          maxDate: Ce ? Be : R.endOfMonth(Ye),
          isDateDisabled: ce,
          timezone: Te
        });
        le(Ge || Be), ze.preventDefault();
        break;
      }
      case "Home":
        le(R.startOfWeek(We)), ze.preventDefault();
        break;
      case "End":
        le(R.endOfWeek(We)), ze.preventDefault();
        break;
      case "PageUp":
        le(R.addMonths(We, 1)), ze.preventDefault();
        break;
      case "PageDown":
        le(R.addMonths(We, -1)), ze.preventDefault();
        break;
    }
  }), Se = useEventCallback((ze, We) => le(We)), ye = useEventCallback((ze, We) => {
    _e && R.isSameDay(Ae, We) && he?.(!1);
  }), be = R.getMonth(L), $e = R.getYear(L), Oe = React$1.useMemo(() => V.filter((ze) => !!ze).map((ze) => R.startOfDay(ze)), [R, V]), Ie = `${$e}-${be}`, we = React$1.useMemo(() => /* @__PURE__ */ React$1.createRef(), [Ie]), Fe = R.startOfWeek(fe), De = React$1.useMemo(() => {
    const ze = R.startOfMonth(L), We = R.endOfMonth(L);
    return ce(Ae) || R.isAfterDay(Ae, We) || R.isBeforeDay(Ae, ze) ? findClosestEnabledDate({
      utils: R,
      date: Ae,
      minDate: ze,
      maxDate: We,
      disablePast: ee,
      disableFuture: te,
      isDateDisabled: ce,
      timezone: Te
    }) : Ae;
  }, [L, te, ee, Ae, ce, R, Te]), Le = React$1.useMemo(() => {
    const ze = R.setTimezone(L, Te), We = R.getWeekArray(ze);
    let Be = R.addMonths(ze, 1);
    for (; Re && We.length < Re; ) {
      const Ye = R.getWeekArray(Be), Ge = R.isSameDay(We[We.length - 1][0], Ye[0][0]);
      Ye.slice(Ge ? 1 : 0).forEach((nt) => {
        We.length < Re && We.push(nt);
      }), Be = R.addMonths(Be, 1);
    }
    return We;
  }, [L, Re, R, Te]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarDayRoot, {
    role: "grid",
    "aria-labelledby": xe,
    className: ue.root,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarDayHeader, {
      role: "row",
      className: ue.header,
      children: [Pe && /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarWeekNumberLabel, {
        variant: "caption",
        role: "columnheader",
        "aria-label": pe.calendarWeekNumberHeaderLabel,
        className: ue.weekNumberLabel,
        children: pe.calendarWeekNumberHeaderText
      }), getWeekdays(R, fe).map((ze, We) => /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarWeekDayLabel, {
        variant: "caption",
        role: "columnheader",
        "aria-label": R.format(R.addDays(Fe, We), "weekday"),
        className: ue.weekDayLabel,
        children: se(ze)
      }, We.toString()))]
    }), W ? /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarLoadingContainer, {
      className: ue.loadingContainer,
      children: J()
    }) : /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarSlideTransition, _extends$1({
      transKey: Ie,
      onExited: q,
      reduceAnimations: Y,
      slideDirection: Z,
      className: clsx(D, ue.slideTransition)
    }, X, {
      nodeRef: we,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarWeekContainer, {
        ref: we,
        role: "rowgroup",
        className: ue.monthContainer,
        children: Le.map((ze, We) => /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarWeek, {
          role: "row",
          className: ue.weekContainer,
          "aria-rowindex": We + 1,
          children: [Pe && /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarWeekNumber, {
            className: ue.weekNumber,
            role: "rowheader",
            "aria-label": pe.calendarWeekNumberAriaLabelText(R.getWeekNumber(ze[0])),
            children: pe.calendarWeekNumberText(R.getWeekNumber(ze[0]))
          }), ze.map((Be, Ye) => /* @__PURE__ */ jsxRuntimeExports.jsx(WrappedDay, {
            parentProps: S,
            day: Be,
            selectedDays: Oe,
            focusableDay: De,
            onKeyDown: me,
            onFocus: Se,
            onBlur: ye,
            onDaySelect: ve,
            isDateDisabled: ce,
            currentMonthNumber: be,
            isViewFocused: _e,
            "aria-colindex": Ye + 1
          }, Be.toString()))]
        }, `week-${ze[0]}`))
      })
    }))]
  });
}
function getPickersMonthUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersMonth", T);
}
const pickersMonthClasses = generateUtilityClasses$1("MuiPickersMonth", ["root", "monthButton", "disabled", "selected"]), _excluded$q = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow", "slots", "slotProps"], useUtilityClasses$k = (T) => {
  const {
    disabled: S,
    selected: R,
    classes: k
  } = T;
  return composeClasses({
    root: ["root"],
    monthButton: ["monthButton", S && "disabled", R && "selected"]
  }, getPickersMonthUtilityClass, k);
}, PickersMonthRoot = styled("div", {
  name: "MuiPickersMonth",
  slot: "Root",
  overridesResolver: (T, S) => [S.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      monthsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), MonthCalendarButton = styled("button", {
  name: "MuiPickersMonth",
  slot: "MonthButton",
  overridesResolver: (T, S) => [S.monthButton, {
    [`&.${pickersMonthClasses.disabled}`]: S.disabled
  }, {
    [`&.${pickersMonthClasses.selected}`]: S.selected
  }]
})(({
  theme: T
}) => _extends$1({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, T.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.action.activeChannel} / ${T.vars.palette.action.hoverOpacity})` : alpha$1(T.palette.action.active, T.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.action.activeChannel} / ${T.vars.palette.action.hoverOpacity})` : alpha$1(T.palette.action.active, T.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${pickersMonthClasses.disabled}`]: {
    color: (T.vars || T).palette.text.secondary
  },
  [`&.${pickersMonthClasses.selected}`]: {
    color: (T.vars || T).palette.primary.contrastText,
    backgroundColor: (T.vars || T).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (T.vars || T).palette.primary.dark
    }
  }
})), PickersMonth = /* @__PURE__ */ React$1.memo(function T(S) {
  const R = useThemeProps({
    props: S,
    name: "MuiPickersMonth"
  }), {
    autoFocus: k,
    className: D,
    children: L,
    disabled: V,
    selected: z,
    value: W,
    tabIndex: U,
    onClick: q,
    onKeyDown: K,
    onFocus: Y,
    onBlur: J,
    "aria-current": Z,
    "aria-label": X,
    slots: ee,
    slotProps: te
  } = R, re = _objectWithoutPropertiesLoose$1(R, _excluded$q), Q = React$1.useRef(null), ne = useUtilityClasses$k(R);
  useEnhancedEffect(() => {
    k && Q.current?.focus();
  }, [k]);
  const oe = ee?.monthButton ?? MonthCalendarButton, ae = useSlotProps({
    elementType: oe,
    externalSlotProps: te?.monthButton,
    additionalProps: {
      children: L,
      disabled: V,
      tabIndex: U,
      ref: Q,
      type: "button",
      role: "radio",
      "aria-current": Z,
      "aria-checked": z,
      "aria-label": X,
      onClick: (se) => q(se, W),
      onKeyDown: (se) => K(se, W),
      onFocus: (se) => Y(se, W),
      onBlur: (se) => J(se, W)
    },
    ownerState: R,
    className: ne.monthButton
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersMonthRoot, _extends$1({
    className: clsx(ne.root, D),
    ownerState: R
  }, re, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(oe, _extends$1({}, ae))
  }));
});
function getMonthCalendarUtilityClass(T) {
  return generateUtilityClass$1("MuiMonthCalendar", T);
}
generateUtilityClasses$1("MuiMonthCalendar", ["root"]);
var define_process_env_default$m = {};
const _excluded$p = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], useUtilityClasses$j = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"]
  }, getMonthCalendarUtilityClass, S);
};
function useMonthCalendarDefaultizedProps(T, S) {
  const R = useUtils(), k = useDefaultDates(), D = useThemeProps({
    props: T,
    name: S
  });
  return _extends$1({
    disableFuture: !1,
    disablePast: !1
  }, D, {
    minDate: applyDefaultDate(R, D.minDate, k.minDate),
    maxDate: applyDefaultDate(R, D.maxDate, k.maxDate)
  });
}
const MonthCalendarRoot = styled("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  padding: "0 4px",
  width: DIALOG_WIDTH,
  // avoid padding increasing width over defined
  boxSizing: "border-box"
}), MonthCalendar = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useMonthCalendarDefaultizedProps(S, "MuiMonthCalendar"), {
    className: D,
    value: L,
    defaultValue: V,
    referenceDate: z,
    disabled: W,
    disableFuture: U,
    disablePast: q,
    maxDate: K,
    minDate: Y,
    onChange: J,
    shouldDisableMonth: Z,
    readOnly: X,
    autoFocus: ee = !1,
    onMonthFocus: te,
    hasFocus: re,
    onFocusedViewChange: Q,
    monthsPerRow: ne = 3,
    timezone: oe,
    gridLabelId: ae,
    slots: se,
    slotProps: ie
  } = k, he = _objectWithoutPropertiesLoose$1(k, _excluded$p), {
    value: xe,
    handleValueChange: Pe,
    timezone: Re
  } = useControlledValueWithTimezone({
    name: "MonthCalendar",
    timezone: oe,
    value: L,
    defaultValue: V,
    onChange: J,
    valueManager: singleItemValueManager
  }), ke = useNow(Re), Te = useRtl(), fe = useUtils(), ue = React$1.useMemo(
    () => singleItemValueManager.getInitialReferenceValue({
      value: xe,
      utils: fe,
      props: k,
      timezone: Re,
      referenceDate: z,
      granularity: SECTION_TYPE_GRANULARITY.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), Ce = k, ce = useUtilityClasses$j(Ce), pe = React$1.useMemo(() => fe.getMonth(ke), [fe, ke]), _e = React$1.useMemo(() => xe != null ? fe.getMonth(xe) : null, [xe, fe]), [ge, Ae] = React$1.useState(() => _e || fe.getMonth(ue)), [Ee, ve] = useControlled({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: re,
    default: ee ?? !1
  }), le = useEventCallback((Ie) => {
    ve(Ie), Q && Q(Ie);
  }), me = React$1.useCallback((Ie) => {
    const we = fe.startOfMonth(q && fe.isAfter(ke, Y) ? ke : Y), Fe = fe.startOfMonth(U && fe.isBefore(ke, K) ? ke : K), De = fe.startOfMonth(Ie);
    return fe.isBefore(De, we) || fe.isAfter(De, Fe) ? !0 : Z ? Z(De) : !1;
  }, [U, q, K, Y, ke, Z, fe]), Se = useEventCallback((Ie, we) => {
    if (X)
      return;
    const Fe = fe.setMonth(xe ?? ue, we);
    Pe(Fe);
  }), ye = useEventCallback((Ie) => {
    me(fe.setMonth(xe ?? ue, Ie)) || (Ae(Ie), le(!0), te && te(Ie));
  });
  React$1.useEffect(() => {
    Ae((Ie) => _e !== null && Ie !== _e ? _e : Ie);
  }, [_e]);
  const be = useEventCallback((Ie, we) => {
    switch (Ie.key) {
      case "ArrowUp":
        ye((12 + we - 3) % 12), Ie.preventDefault();
        break;
      case "ArrowDown":
        ye((12 + we + 3) % 12), Ie.preventDefault();
        break;
      case "ArrowLeft":
        ye((12 + we + (Te ? 1 : -1)) % 12), Ie.preventDefault();
        break;
      case "ArrowRight":
        ye((12 + we + (Te ? -1 : 1)) % 12), Ie.preventDefault();
        break;
    }
  }), $e = useEventCallback((Ie, we) => {
    ye(we);
  }), Oe = useEventCallback((Ie, we) => {
    ge === we && le(!1);
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MonthCalendarRoot, _extends$1({
    ref: R,
    className: clsx(ce.root, D),
    ownerState: Ce,
    role: "radiogroup",
    "aria-labelledby": ae
  }, he, {
    children: getMonthsInYear(fe, xe ?? ue).map((Ie) => {
      const we = fe.getMonth(Ie), Fe = fe.format(Ie, "monthShort"), De = fe.format(Ie, "month"), Le = we === _e, ze = W || me(Ie);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersMonth, {
        selected: Le,
        value: we,
        onClick: Se,
        onKeyDown: be,
        autoFocus: Ee && we === ge,
        disabled: ze,
        tabIndex: we === ge && !ze ? 0 : -1,
        onFocus: $e,
        onBlur: Oe,
        "aria-current": pe === we ? "date" : void 0,
        "aria-label": De,
        monthsPerRow: ne,
        slots: se,
        slotProps: ie,
        children: Fe
      }, Fe);
    })
  }));
});
define_process_env_default$m.NODE_ENV !== "production" && (MonthCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true` picker is disabled
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  gridLabelId: PropTypes.string,
  hasFocus: PropTypes.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: PropTypes.func,
  onFocusedViewChange: PropTypes.func,
  onMonthFocus: PropTypes.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: PropTypes.object,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object
});
function getPickersYearUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersYear", T);
}
const pickersYearClasses = generateUtilityClasses$1("MuiPickersYear", ["root", "yearButton", "selected", "disabled"]), _excluded$o = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow", "slots", "slotProps"], useUtilityClasses$i = (T) => {
  const {
    disabled: S,
    selected: R,
    classes: k
  } = T;
  return composeClasses({
    root: ["root"],
    yearButton: ["yearButton", S && "disabled", R && "selected"]
  }, getPickersYearUtilityClass, k);
}, PickersYearRoot = styled("div", {
  name: "MuiPickersYear",
  slot: "Root",
  overridesResolver: (T, S) => [S.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      yearsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), YearCalendarButton = styled("button", {
  name: "MuiPickersYear",
  slot: "YearButton",
  overridesResolver: (T, S) => [S.yearButton, {
    [`&.${pickersYearClasses.disabled}`]: S.disabled
  }, {
    [`&.${pickersYearClasses.selected}`]: S.selected
  }]
})(({
  theme: T
}) => _extends$1({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, T.typography.subtitle1, {
  margin: "6px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.action.activeChannel} / ${T.vars.palette.action.focusOpacity})` : alpha$1(T.palette.action.active, T.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.action.activeChannel} / ${T.vars.palette.action.hoverOpacity})` : alpha$1(T.palette.action.active, T.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${pickersYearClasses.disabled}`]: {
    color: (T.vars || T).palette.text.secondary
  },
  [`&.${pickersYearClasses.selected}`]: {
    color: (T.vars || T).palette.primary.contrastText,
    backgroundColor: (T.vars || T).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (T.vars || T).palette.primary.dark
    }
  }
})), PickersYear = /* @__PURE__ */ React$1.memo(function T(S) {
  const R = useThemeProps({
    props: S,
    name: "MuiPickersYear"
  }), {
    autoFocus: k,
    className: D,
    children: L,
    disabled: V,
    selected: z,
    value: W,
    tabIndex: U,
    onClick: q,
    onKeyDown: K,
    onFocus: Y,
    onBlur: J,
    "aria-current": Z,
    slots: X,
    slotProps: ee
  } = R, te = _objectWithoutPropertiesLoose$1(R, _excluded$o), re = React$1.useRef(null), Q = useUtilityClasses$i(R);
  useEnhancedEffect(() => {
    k && re.current?.focus();
  }, [k]);
  const ne = X?.yearButton ?? YearCalendarButton, oe = useSlotProps({
    elementType: ne,
    externalSlotProps: ee?.yearButton,
    additionalProps: {
      children: L,
      disabled: V,
      tabIndex: U,
      ref: re,
      type: "button",
      role: "radio",
      "aria-current": Z,
      "aria-checked": z,
      onClick: (ae) => q(ae, W),
      onKeyDown: (ae) => K(ae, W),
      onFocus: (ae) => Y(ae, W),
      onBlur: (ae) => J(ae, W)
    },
    ownerState: R,
    className: Q.yearButton
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersYearRoot, _extends$1({
    className: clsx(Q.root, D),
    ownerState: R
  }, te, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ne, _extends$1({}, oe))
  }));
});
function getYearCalendarUtilityClass(T) {
  return generateUtilityClass$1("MuiYearCalendar", T);
}
generateUtilityClasses$1("MuiYearCalendar", ["root"]);
var define_process_env_default$l = {};
const _excluded$n = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], useUtilityClasses$h = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"]
  }, getYearCalendarUtilityClass, S);
};
function useYearCalendarDefaultizedProps(T, S) {
  const R = useUtils(), k = useDefaultDates(), D = useThemeProps({
    props: T,
    name: S
  });
  return _extends$1({
    disablePast: !1,
    disableFuture: !1
  }, D, {
    yearsPerRow: D.yearsPerRow ?? 3,
    minDate: applyDefaultDate(R, D.minDate, k.minDate),
    maxDate: applyDefaultDate(R, D.maxDate, k.maxDate)
  });
}
const YearCalendarRoot = styled("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  padding: "0 4px",
  width: DIALOG_WIDTH,
  maxHeight: MAX_CALENDAR_HEIGHT,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative"
}), YearCalendar = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useYearCalendarDefaultizedProps(S, "MuiYearCalendar"), {
    autoFocus: D,
    className: L,
    value: V,
    defaultValue: z,
    referenceDate: W,
    disabled: U,
    disableFuture: q,
    disablePast: K,
    maxDate: Y,
    minDate: J,
    onChange: Z,
    readOnly: X,
    shouldDisableYear: ee,
    onYearFocus: te,
    hasFocus: re,
    onFocusedViewChange: Q,
    yearsPerRow: ne,
    timezone: oe,
    gridLabelId: ae,
    slots: se,
    slotProps: ie
  } = k, he = _objectWithoutPropertiesLoose$1(k, _excluded$n), {
    value: xe,
    handleValueChange: Pe,
    timezone: Re
  } = useControlledValueWithTimezone({
    name: "YearCalendar",
    timezone: oe,
    value: V,
    defaultValue: z,
    onChange: Z,
    valueManager: singleItemValueManager
  }), ke = useNow(Re), Te = useRtl(), fe = useUtils(), ue = React$1.useMemo(
    () => singleItemValueManager.getInitialReferenceValue({
      value: xe,
      utils: fe,
      props: k,
      timezone: Re,
      referenceDate: W,
      granularity: SECTION_TYPE_GRANULARITY.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), Ce = k, ce = useUtilityClasses$h(Ce), pe = React$1.useMemo(() => fe.getYear(ke), [fe, ke]), _e = React$1.useMemo(() => xe != null ? fe.getYear(xe) : null, [xe, fe]), [ge, Ae] = React$1.useState(() => _e || fe.getYear(ue)), [Ee, ve] = useControlled({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: re,
    default: D ?? !1
  }), le = useEventCallback((Fe) => {
    ve(Fe), Q && Q(Fe);
  }), me = React$1.useCallback((Fe) => {
    if (K && fe.isBeforeYear(Fe, ke) || q && fe.isAfterYear(Fe, ke) || J && fe.isBeforeYear(Fe, J) || Y && fe.isAfterYear(Fe, Y))
      return !0;
    if (!ee)
      return !1;
    const De = fe.startOfYear(Fe);
    return ee(De);
  }, [q, K, Y, J, ke, ee, fe]), Se = useEventCallback((Fe, De) => {
    if (X)
      return;
    const Le = fe.setYear(xe ?? ue, De);
    Pe(Le);
  }), ye = useEventCallback((Fe) => {
    me(fe.setYear(xe ?? ue, Fe)) || (Ae(Fe), le(!0), te?.(Fe));
  });
  React$1.useEffect(() => {
    Ae((Fe) => _e !== null && Fe !== _e ? _e : Fe);
  }, [_e]);
  const be = useEventCallback((Fe, De) => {
    switch (Fe.key) {
      case "ArrowUp":
        ye(De - ne), Fe.preventDefault();
        break;
      case "ArrowDown":
        ye(De + ne), Fe.preventDefault();
        break;
      case "ArrowLeft":
        ye(De + (Te ? 1 : -1)), Fe.preventDefault();
        break;
      case "ArrowRight":
        ye(De + (Te ? -1 : 1)), Fe.preventDefault();
        break;
    }
  }), $e = useEventCallback((Fe, De) => {
    ye(De);
  }), Oe = useEventCallback((Fe, De) => {
    ge === De && le(!1);
  }), Ie = React$1.useRef(null), we = useForkRef(R, Ie);
  return React$1.useEffect(() => {
    if (D || Ie.current === null)
      return;
    const Fe = Ie.current.querySelector('[tabindex="0"]');
    if (!Fe)
      return;
    const De = Fe.offsetHeight, Le = Fe.offsetTop, ze = Ie.current.clientHeight, We = Ie.current.scrollTop, Be = Le + De;
    De > ze || Le < We || (Ie.current.scrollTop = Be - ze / 2 - De / 2);
  }, [D]), /* @__PURE__ */ jsxRuntimeExports.jsx(YearCalendarRoot, _extends$1({
    ref: we,
    className: clsx(ce.root, L),
    ownerState: Ce,
    role: "radiogroup",
    "aria-labelledby": ae
  }, he, {
    children: fe.getYearRange([J, Y]).map((Fe) => {
      const De = fe.getYear(Fe), Le = De === _e, ze = U || me(Fe);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersYear, {
        selected: Le,
        value: De,
        onClick: Se,
        onKeyDown: be,
        autoFocus: Ee && De === ge,
        disabled: ze,
        tabIndex: De === ge && !ze ? 0 : -1,
        onFocus: $e,
        onBlur: Oe,
        "aria-current": pe === De ? "date" : void 0,
        yearsPerRow: ne,
        slots: se,
        slotProps: ie,
        children: fe.format(Fe, "year")
      }, fe.format(Fe, "year"));
    })
  }));
});
define_process_env_default$l.NODE_ENV !== "production" && (YearCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true` picker is disabled
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  gridLabelId: PropTypes.string,
  hasFocus: PropTypes.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.object,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: PropTypes.func,
  onFocusedViewChange: PropTypes.func,
  onYearFocus: PropTypes.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: PropTypes.object,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
});
const getPickersCalendarHeaderUtilityClass = (T) => generateUtilityClass$1("MuiPickersCalendarHeader", T), pickersCalendarHeaderClasses = generateUtilityClasses$1("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]);
var define_process_env_default$k = {};
const _excluded$m = ["slots", "slotProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone", "format"], _excluded2$3 = ["ownerState"], useUtilityClasses$g = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  }, getPickersCalendarHeaderUtilityClass, S);
}, PickersCalendarHeaderRoot = styled("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  display: "flex",
  alignItems: "center",
  marginTop: 12,
  marginBottom: 4,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 40,
  minHeight: 40
}), PickersCalendarHeaderLabelContainer = styled("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer",
  overridesResolver: (T, S) => S.labelContainer
})(({
  theme: T
}) => _extends$1({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, T.typography.body1, {
  fontWeight: T.typography.fontWeightMedium
})), PickersCalendarHeaderLabel = styled("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label",
  overridesResolver: (T, S) => S.label
})({
  marginRight: 6
}), PickersCalendarHeaderSwitchViewButton = styled(IconButton, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton",
  overridesResolver: (T, S) => S.switchViewButton
})({
  marginRight: "auto",
  variants: [{
    props: {
      view: "year"
    },
    style: {
      [`.${pickersCalendarHeaderClasses.switchViewIcon}`]: {
        transform: "rotate(180deg)"
      }
    }
  }]
}), PickersCalendarHeaderSwitchViewIcon = styled(ArrowDropDownIcon$1, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon",
  overridesResolver: (T, S) => S.switchViewIcon
})(({
  theme: T
}) => ({
  willChange: "transform",
  transition: T.transitions.create("transform"),
  transform: "rotate(0deg)"
})), PickersCalendarHeader = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = usePickersTranslations(), D = useUtils(), L = useThemeProps({
    props: S,
    name: "MuiPickersCalendarHeader"
  }), {
    slots: V,
    slotProps: z,
    currentMonth: W,
    disabled: U,
    disableFuture: q,
    disablePast: K,
    maxDate: Y,
    minDate: J,
    onMonthChange: Z,
    onViewChange: X,
    view: ee,
    reduceAnimations: te,
    views: re,
    labelId: Q,
    className: ne,
    timezone: oe,
    format: ae = `${D.formats.month} ${D.formats.year}`
  } = L, se = _objectWithoutPropertiesLoose$1(L, _excluded$m), ie = L, he = useUtilityClasses$g(L), xe = V?.switchViewButton ?? PickersCalendarHeaderSwitchViewButton, Pe = useSlotProps({
    elementType: xe,
    externalSlotProps: z?.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": k.calendarViewSwitchingButtonAriaLabel(ee)
    },
    ownerState: ie,
    className: he.switchViewButton
  }), Re = V?.switchViewIcon ?? PickersCalendarHeaderSwitchViewIcon, ke = useSlotProps({
    elementType: Re,
    externalSlotProps: z?.switchViewIcon,
    ownerState: void 0,
    className: he.switchViewIcon
  }), Te = _objectWithoutPropertiesLoose$1(ke, _excluded2$3), fe = () => Z(D.addMonths(W, 1), "left"), ue = () => Z(D.addMonths(W, -1), "right"), Ce = useNextMonthDisabled(W, {
    disableFuture: q,
    maxDate: Y,
    timezone: oe
  }), ce = usePreviousMonthDisabled(W, {
    disablePast: K,
    minDate: J,
    timezone: oe
  }), pe = () => {
    if (!(re.length === 1 || !X || U))
      if (re.length === 2)
        X(re.find((ge) => ge !== ee) || re[0]);
      else {
        const ge = re.indexOf(ee) !== 0 ? 0 : 1;
        X(re[ge]);
      }
  };
  if (re.length === 1 && re[0] === "year")
    return null;
  const _e = D.formatByString(W, ae);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarHeaderRoot, _extends$1({}, se, {
    ownerState: ie,
    className: clsx(ne, he.root),
    ref: R,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(PickersCalendarHeaderLabelContainer, {
      role: "presentation",
      onClick: pe,
      ownerState: ie,
      "aria-live": "polite",
      className: he.labelContainer,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(PickersFadeTransitionGroup, {
        reduceAnimations: te,
        transKey: _e,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersCalendarHeaderLabel, {
          id: Q,
          ownerState: ie,
          className: he.label,
          children: _e
        })
      }), re.length > 1 && !U && /* @__PURE__ */ jsxRuntimeExports.jsx(xe, _extends$1({}, Pe, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Re, _extends$1({}, Te))
      }))]
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Fade, {
      in: ee === "day",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersArrowSwitcher, {
        slots: V,
        slotProps: z,
        onGoToPrevious: ue,
        isPreviousDisabled: ce,
        previousLabel: k.previousMonth,
        onGoToNext: fe,
        isNextDisabled: Ce,
        nextLabel: k.nextMonth
      })
    })]
  }));
});
define_process_env_default$k.NODE_ENV !== "production" && (PickersCalendarHeader.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  currentMonth: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  /**
   * Format used to display the date.
   * @default `${adapter.formats.month} ${adapter.formats.year}`
   */
  format: PropTypes.string,
  /**
   * Id of the calendar text element.
   * It is used to establish an `aria-labelledby` relationship with the calendar `grid` element.
   */
  labelId: PropTypes.string,
  maxDate: PropTypes.object.isRequired,
  minDate: PropTypes.object.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  onViewChange: PropTypes.func,
  reduceAnimations: PropTypes.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  timezone: PropTypes.string.isRequired,
  view: PropTypes.oneOf(["day", "month", "year"]).isRequired,
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const PREFERS_REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)", mobileVersionMatches = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), androidVersion = mobileVersionMatches && mobileVersionMatches[1] ? parseInt(mobileVersionMatches[1], 10) : null, iOSVersion = mobileVersionMatches && mobileVersionMatches[2] ? parseInt(mobileVersionMatches[2], 10) : null, slowAnimationDevices = androidVersion && androidVersion < 10 || iOSVersion && iOSVersion < 13 || !1, useDefaultReduceAnimations = () => useMediaQuery(PREFERS_REDUCED_MOTION, {
  defaultMatches: !1
}) || slowAnimationDevices, getDateCalendarUtilityClass = (T) => generateUtilityClass$1("MuiDateCalendar", T);
generateUtilityClasses$1("MuiDateCalendar", ["root", "viewTransitionContainer"]);
var define_process_env_default$j = {};
const _excluded$l = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsPerRow", "monthsPerRow", "timezone"], useUtilityClasses$f = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, getDateCalendarUtilityClass, S);
};
function useDateCalendarDefaultizedProps(T, S) {
  const R = useUtils(), k = useDefaultDates(), D = useDefaultReduceAnimations(), L = useThemeProps({
    props: T,
    name: S
  });
  return _extends$1({}, L, {
    loading: L.loading ?? !1,
    disablePast: L.disablePast ?? !1,
    disableFuture: L.disableFuture ?? !1,
    openTo: L.openTo ?? "day",
    views: L.views ?? ["year", "day"],
    reduceAnimations: L.reduceAnimations ?? D,
    renderLoading: L.renderLoading ?? (() => /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      children: "..."
    })),
    minDate: applyDefaultDate(R, L.minDate, k.minDate),
    maxDate: applyDefaultDate(R, L.maxDate, k.maxDate)
  });
}
const DateCalendarRoot = styled(PickerViewRoot, {
  name: "MuiDateCalendar",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  display: "flex",
  flexDirection: "column",
  height: VIEW_HEIGHT
}), DateCalendarViewTransitionContainer = styled(PickersFadeTransitionGroup, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer",
  overridesResolver: (T, S) => S.viewTransitionContainer
})({}), DateCalendar = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useUtils(), D = useId(), L = useDateCalendarDefaultizedProps(S, "MuiDateCalendar"), {
    autoFocus: V,
    onViewChange: z,
    value: W,
    defaultValue: U,
    referenceDate: q,
    disableFuture: K,
    disablePast: Y,
    onChange: J,
    onYearChange: Z,
    onMonthChange: X,
    reduceAnimations: ee,
    shouldDisableDate: te,
    shouldDisableMonth: re,
    shouldDisableYear: Q,
    view: ne,
    views: oe,
    openTo: ae,
    className: se,
    disabled: ie,
    readOnly: he,
    minDate: xe,
    maxDate: Pe,
    disableHighlightToday: Re,
    focusedView: ke,
    onFocusedViewChange: Te,
    showDaysOutsideCurrentMonth: fe,
    fixedWeekNumber: ue,
    dayOfWeekFormatter: Ce,
    slots: ce,
    slotProps: pe,
    loading: _e,
    renderLoading: ge,
    displayWeekNumber: Ae,
    yearsPerRow: Ee,
    monthsPerRow: ve,
    timezone: le
  } = L, me = _objectWithoutPropertiesLoose$1(L, _excluded$l), {
    value: Se,
    handleValueChange: ye,
    timezone: be
  } = useControlledValueWithTimezone({
    name: "DateCalendar",
    timezone: le,
    value: W,
    defaultValue: U,
    onChange: J,
    valueManager: singleItemValueManager
  }), {
    view: $e,
    setView: Oe,
    focusedView: Ie,
    setFocusedView: we,
    goToNextView: Fe,
    setValueAndGoToNextView: De
  } = useViews({
    view: ne,
    views: oe,
    openTo: ae,
    onChange: ye,
    onViewChange: z,
    autoFocus: V,
    focusedView: ke,
    onFocusedViewChange: Te
  }), {
    referenceDate: Le,
    calendarState: ze,
    changeFocusedDay: We,
    changeMonth: Be,
    handleChangeMonth: Ye,
    isDateDisabled: Ge,
    onMonthSwitchingAnimationEnd: nt
  } = useCalendarState({
    value: Se,
    referenceDate: q,
    reduceAnimations: ee,
    onMonthChange: X,
    minDate: xe,
    maxDate: Pe,
    shouldDisableDate: te,
    disablePast: Y,
    disableFuture: K,
    timezone: be
  }), Ze = ie && Se || xe, Me = ie && Se || Pe, Ne = `${D}-grid-label`, He = Ie !== null, qe = ce?.calendarHeader ?? PickersCalendarHeader, Ke = useSlotProps({
    elementType: qe,
    externalSlotProps: pe?.calendarHeader,
    additionalProps: {
      views: oe,
      view: $e,
      currentMonth: ze.currentMonth,
      onViewChange: Oe,
      onMonthChange: (dt, xt) => Ye({
        newMonth: dt,
        direction: xt
      }),
      minDate: Ze,
      maxDate: Me,
      disabled: ie,
      disablePast: Y,
      disableFuture: K,
      reduceAnimations: ee,
      timezone: be,
      labelId: Ne
    },
    ownerState: L
  }), Xe = useEventCallback((dt) => {
    const xt = k.startOfMonth(dt), Ot = k.endOfMonth(dt), Rt = Ge(dt) ? findClosestEnabledDate({
      utils: k,
      date: dt,
      minDate: k.isBefore(xe, xt) ? xt : xe,
      maxDate: k.isAfter(Pe, Ot) ? Ot : Pe,
      disablePast: Y,
      disableFuture: K,
      isDateDisabled: Ge,
      timezone: be
    }) : dt;
    Rt ? (De(Rt, "finish"), X?.(xt)) : (Fe(), Be(xt)), We(Rt, !0);
  }), tt = useEventCallback((dt) => {
    const xt = k.startOfYear(dt), Ot = k.endOfYear(dt), Rt = Ge(dt) ? findClosestEnabledDate({
      utils: k,
      date: dt,
      minDate: k.isBefore(xe, xt) ? xt : xe,
      maxDate: k.isAfter(Pe, Ot) ? Ot : Pe,
      disablePast: Y,
      disableFuture: K,
      isDateDisabled: Ge,
      timezone: be
    }) : dt;
    Rt ? (De(Rt, "finish"), Z?.(Rt)) : (Fe(), Be(xt)), We(Rt, !0);
  }), at = useEventCallback((dt) => ye(dt && mergeDateAndTime(k, dt, Se ?? Le), "finish", $e));
  React$1.useEffect(() => {
    Se != null && k.isValid(Se) && Be(Se);
  }, [Se]);
  const it = L, mt = useUtilityClasses$f(it), Qe = {
    disablePast: Y,
    disableFuture: K,
    maxDate: Pe,
    minDate: xe
  }, ut = {
    disableHighlightToday: Re,
    readOnly: he,
    disabled: ie,
    timezone: be,
    gridLabelId: Ne,
    slots: ce,
    slotProps: pe
  }, ft = React$1.useRef($e);
  React$1.useEffect(() => {
    ft.current !== $e && (Ie === ft.current && we($e, !0), ft.current = $e);
  }, [Ie, we, $e]);
  const vt = React$1.useMemo(() => [Se], [Se]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(DateCalendarRoot, _extends$1({
    ref: R,
    className: clsx(mt.root, se),
    ownerState: it
  }, me, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(qe, _extends$1({}, Ke, {
      slots: ce,
      slotProps: pe
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(DateCalendarViewTransitionContainer, {
      reduceAnimations: ee,
      className: mt.viewTransitionContainer,
      transKey: $e,
      ownerState: it,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
        children: [$e === "year" && /* @__PURE__ */ jsxRuntimeExports.jsx(YearCalendar, _extends$1({}, Qe, ut, {
          value: Se,
          onChange: tt,
          shouldDisableYear: Q,
          hasFocus: He,
          onFocusedViewChange: (dt) => we("year", dt),
          yearsPerRow: Ee,
          referenceDate: Le
        })), $e === "month" && /* @__PURE__ */ jsxRuntimeExports.jsx(MonthCalendar, _extends$1({}, Qe, ut, {
          hasFocus: He,
          className: se,
          value: Se,
          onChange: Xe,
          shouldDisableMonth: re,
          onFocusedViewChange: (dt) => we("month", dt),
          monthsPerRow: ve,
          referenceDate: Le
        })), $e === "day" && /* @__PURE__ */ jsxRuntimeExports.jsx(DayCalendar, _extends$1({}, ze, Qe, ut, {
          onMonthSwitchingAnimationEnd: nt,
          onFocusedDayChange: We,
          reduceAnimations: ee,
          selectedDays: vt,
          onSelectedDaysChange: at,
          shouldDisableDate: te,
          shouldDisableMonth: re,
          shouldDisableYear: Q,
          hasFocus: He,
          onFocusedViewChange: (dt) => we("day", dt),
          showDaysOutsideCurrentMonth: fe,
          fixedWeekNumber: ue,
          dayOfWeekFormatter: Ce,
          displayWeekNumber: Ae,
          loading: _e,
          renderLoading: ge
        }))]
      })
    })]
  }));
});
define_process_env_default$j.NODE_ENV !== "production" && (DateCalendar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Controlled focused view.
   */
  focusedView: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: PropTypes.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: PropTypes.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
});
function getPickersToolbarUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersToolbar", T);
}
generateUtilityClasses$1("MuiPickersToolbar", ["root", "content"]);
const _excluded$k = ["children", "className", "toolbarTitle", "hidden", "titleId", "isLandscape", "classes", "landscapeDirection"], useUtilityClasses$e = (T) => {
  const {
    classes: S,
    isLandscape: R
  } = T;
  return composeClasses({
    root: ["root"],
    content: ["content"],
    penIconButton: ["penIconButton", R && "penIconButtonLandscape"]
  }, getPickersToolbarUtilityClass, S);
}, PickersToolbarRoot = styled("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})(({
  theme: T
}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: T.spacing(2, 3),
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      height: "auto",
      maxWidth: 160,
      padding: 16,
      justifyContent: "flex-start",
      flexWrap: "wrap"
    }
  }]
})), PickersToolbarContent = styled("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (T, S) => S.content
})({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  flex: 1,
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      justifyContent: "flex-start",
      alignItems: "flex-start",
      flexDirection: "column"
    }
  }, {
    props: {
      isLandscape: !0,
      landscapeDirection: "row"
    },
    style: {
      flexDirection: "row"
    }
  }]
}), PickersToolbar = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiPickersToolbar"
  }), {
    children: D,
    className: L,
    toolbarTitle: V,
    hidden: z,
    titleId: W
  } = k, U = _objectWithoutPropertiesLoose$1(k, _excluded$k), q = k, K = useUtilityClasses$e(q);
  return z ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersToolbarRoot, _extends$1({
    ref: R,
    className: clsx(K.root, L),
    ownerState: q
  }, U, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Typography$2, {
      color: "text.secondary",
      variant: "overline",
      id: W,
      children: V
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarContent, {
      className: K.content,
      ownerState: q,
      children: D
    })]
  }));
});
function getDatePickerToolbarUtilityClass(T) {
  return generateUtilityClass$1("MuiDatePickerToolbar", T);
}
generateUtilityClasses$1("MuiDatePickerToolbar", ["root", "title"]);
var define_process_env_default$i = {};
const _excluded$j = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views", "className", "onViewChange", "view"], useUtilityClasses$d = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    title: ["title"]
  }, getDatePickerToolbarUtilityClass, S);
}, DatePickerToolbarRoot = styled(PickersToolbar, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({}), DatePickerToolbarTitle = styled(Typography$2, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (T, S) => S.title
})({
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      margin: "auto 16px auto auto"
    }
  }]
}), DatePickerToolbar = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiDatePickerToolbar"
  }), {
    value: D,
    isLandscape: L,
    toolbarFormat: V,
    toolbarPlaceholder: z = "––",
    views: W,
    className: U
  } = k, q = _objectWithoutPropertiesLoose$1(k, _excluded$j), K = useUtils(), Y = usePickersTranslations(), J = useUtilityClasses$d(k), Z = React$1.useMemo(() => {
    if (!D)
      return z;
    const ee = resolveDateFormat(K, {
      format: V,
      views: W
    }, !0);
    return K.formatByString(D, ee);
  }, [D, V, z, K, W]), X = k;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DatePickerToolbarRoot, _extends$1({
    ref: R,
    toolbarTitle: Y.datePickerToolbarTitle,
    isLandscape: L,
    className: clsx(J.root, U)
  }, q, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(DatePickerToolbarTitle, {
      variant: "h4",
      align: L ? "left" : "center",
      ownerState: X,
      className: J.title,
      children: Z
    })
  }));
});
define_process_env_default$i.NODE_ENV !== "production" && (DatePickerToolbar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: PropTypes.bool,
  isLandscape: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  titleId: PropTypes.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: PropTypes.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: PropTypes.node,
  value: PropTypes.object,
  /**
   * Currently visible picker view.
   */
  view: PropTypes.oneOf(["day", "month", "year"]).isRequired,
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired).isRequired
});
function useDatePickerDefaultizedProps(T, S) {
  const R = useUtils(), k = useDefaultDates(), D = useThemeProps({
    props: T,
    name: S
  }), L = React$1.useMemo(() => D.localeText?.toolbarTitle == null ? D.localeText : _extends$1({}, D.localeText, {
    datePickerToolbarTitle: D.localeText.toolbarTitle
  }), [D.localeText]);
  return _extends$1({}, D, {
    localeText: L
  }, applyDefaultViewProps({
    views: D.views,
    openTo: D.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: D.disableFuture ?? !1,
    disablePast: D.disablePast ?? !1,
    minDate: applyDefaultDate(R, D.minDate, k.minDate),
    maxDate: applyDefaultDate(R, D.maxDate, k.maxDate),
    slots: _extends$1({
      toolbar: DatePickerToolbar
    }, D.slots)
  });
}
var useThemeWithoutDefault = {};
Object.defineProperty(useThemeWithoutDefault, "__esModule", {
  value: !0
});
var default_1 = useThemeWithoutDefault.default = void 0, React = _interopRequireWildcard(React__default), _styledEngine = require$$1;
function _getRequireWildcardCache(T) {
  if (typeof WeakMap != "function") return null;
  var S = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache = function(k) {
    return k ? R : S;
  })(T);
}
function _interopRequireWildcard(T, S) {
  if (T && T.__esModule) return T;
  if (T === null || typeof T != "object" && typeof T != "function") return { default: T };
  var R = _getRequireWildcardCache(S);
  if (R && R.has(T)) return R.get(T);
  var k = { __proto__: null }, D = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var L in T) if (L !== "default" && Object.prototype.hasOwnProperty.call(T, L)) {
    var V = D ? Object.getOwnPropertyDescriptor(T, L) : null;
    V && (V.get || V.set) ? Object.defineProperty(k, L, V) : k[L] = T[L];
  }
  return k.default = T, R && R.set(T, k), k;
}
function isObjectEmpty$1(T) {
  return Object.keys(T).length === 0;
}
function useTheme(T = null) {
  const S = React.useContext(_styledEngine.ThemeContext);
  return !S || isObjectEmpty$1(S) ? T : S;
}
default_1 = useThemeWithoutDefault.default = useTheme;
var define_process_env_default$h = {};
const _excluded$i = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], PopperRoot = styled(Popper$1, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({}), Popper = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  var k;
  const D = default_1(), L = useDefaultProps({
    props: S,
    name: "MuiPopper"
  }), {
    anchorEl: V,
    component: z,
    components: W,
    componentsProps: U,
    container: q,
    disablePortal: K,
    keepMounted: Y,
    modifiers: J,
    open: Z,
    placement: X,
    popperOptions: ee,
    popperRef: te,
    transition: re,
    slots: Q,
    slotProps: ne
  } = L, oe = _objectWithoutPropertiesLoose$1(L, _excluded$i), ae = (k = Q?.root) != null ? k : W?.Root, se = _extends$1({
    anchorEl: V,
    container: q,
    disablePortal: K,
    keepMounted: Y,
    modifiers: J,
    open: Z,
    placement: X,
    popperOptions: ee,
    popperRef: te,
    transition: re
  }, oe);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PopperRoot, _extends$1({
    as: z,
    direction: D?.direction,
    slots: {
      root: ae
    },
    slotProps: ne ?? U
  }, se, {
    ref: R
  }));
});
define_process_env_default$h.NODE_ENV !== "production" && (Popper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
});
function getPickersPopperUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersPopper", T);
}
generateUtilityClasses$1("MuiPickersPopper", ["root", "paper"]);
const _excluded$h = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], useUtilityClasses$c = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"],
    paper: ["paper"]
  }, getPickersPopperUtilityClass, S);
}, PickersPopperRoot = styled(Popper, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})(({
  theme: T
}) => ({
  zIndex: T.zIndex.modal
})), PickersPopperPaper = styled(Paper, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (T, S) => S.paper
})({
  outline: 0,
  transformOrigin: "top center",
  variants: [{
    props: ({
      placement: T
    }) => ["top", "top-start", "top-end"].includes(T),
    style: {
      transformOrigin: "bottom center"
    }
  }]
});
function clickedRootScrollbar(T, S) {
  return S.documentElement.clientWidth < T.clientX || S.documentElement.clientHeight < T.clientY;
}
function useClickAwayListener(T, S) {
  const R = React$1.useRef(!1), k = React$1.useRef(!1), D = React$1.useRef(null), L = React$1.useRef(!1);
  React$1.useEffect(() => {
    if (!T)
      return;
    function W() {
      L.current = !0;
    }
    return document.addEventListener("mousedown", W, !0), document.addEventListener("touchstart", W, !0), () => {
      document.removeEventListener("mousedown", W, !0), document.removeEventListener("touchstart", W, !0), L.current = !1;
    };
  }, [T]);
  const V = useEventCallback((W) => {
    if (!L.current)
      return;
    const U = k.current;
    k.current = !1;
    const q = ownerDocument(D.current);
    if (!D.current || // is a TouchEvent?
    "clientX" in W && clickedRootScrollbar(W, q))
      return;
    if (R.current) {
      R.current = !1;
      return;
    }
    let K;
    W.composedPath ? K = W.composedPath().indexOf(D.current) > -1 : K = !q.documentElement.contains(W.target) || D.current.contains(W.target), !K && !U && S(W);
  }), z = () => {
    k.current = !0;
  };
  return React$1.useEffect(() => {
    if (T) {
      const W = ownerDocument(D.current), U = () => {
        R.current = !0;
      };
      return W.addEventListener("touchstart", V), W.addEventListener("touchmove", U), () => {
        W.removeEventListener("touchstart", V), W.removeEventListener("touchmove", U);
      };
    }
  }, [T, V]), React$1.useEffect(() => {
    if (T) {
      const W = ownerDocument(D.current);
      return W.addEventListener("click", V), () => {
        W.removeEventListener("click", V), k.current = !1;
      };
    }
  }, [T, V]), [D, z, z];
}
const PickersPopperPaperWrapper = /* @__PURE__ */ React$1.forwardRef((T, S) => {
  const {
    PaperComponent: R,
    popperPlacement: k,
    ownerState: D,
    children: L,
    paperSlotProps: V,
    paperClasses: z,
    onPaperClick: W,
    onPaperTouchStart: U
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = T, q = _objectWithoutPropertiesLoose$1(T, _excluded$h), K = _extends$1({}, D, {
    placement: k
  }), Y = useSlotProps({
    elementType: R,
    externalSlotProps: V,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: S
    },
    className: z,
    ownerState: K
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(R, _extends$1({}, q, Y, {
    onClick: (J) => {
      W(J), Y.onClick?.(J);
    },
    onTouchStart: (J) => {
      U(J), Y.onTouchStart?.(J);
    },
    ownerState: K,
    children: L
  }));
});
function PickersPopper(T) {
  const S = useThemeProps({
    props: T,
    name: "MuiPickersPopper"
  }), {
    anchorEl: R,
    children: k,
    containerRef: D = null,
    shouldRestoreFocus: L,
    onBlur: V,
    onDismiss: z,
    open: W,
    role: U,
    placement: q,
    slots: K,
    slotProps: Y,
    reduceAnimations: J
  } = S;
  React$1.useEffect(() => {
    function fe(ue) {
      W && ue.key === "Escape" && z();
    }
    return document.addEventListener("keydown", fe), () => {
      document.removeEventListener("keydown", fe);
    };
  }, [z, W]);
  const Z = React$1.useRef(null);
  React$1.useEffect(() => {
    U === "tooltip" || L && !L() || (W ? Z.current = getActiveElement(document) : Z.current && Z.current instanceof HTMLElement && setTimeout(() => {
      Z.current instanceof HTMLElement && Z.current.focus();
    }));
  }, [W, U, L]);
  const [X, ee, te] = useClickAwayListener(W, V ?? z), re = React$1.useRef(null), Q = useForkRef(re, D), ne = useForkRef(Q, X), oe = S, ae = useUtilityClasses$c(oe), se = useDefaultReduceAnimations(), ie = J ?? se, he = (fe) => {
    fe.key === "Escape" && (fe.stopPropagation(), z());
  }, xe = K?.desktopTransition ?? ie ? Fade : Grow, Pe = K?.desktopTrapFocus ?? FocusTrap, Re = K?.desktopPaper ?? PickersPopperPaper, ke = K?.popper ?? PickersPopperRoot, Te = useSlotProps({
    elementType: ke,
    externalSlotProps: Y?.popper,
    additionalProps: {
      transition: !0,
      role: U,
      open: W,
      anchorEl: R,
      placement: q,
      onKeyDown: he
    },
    className: ae.root,
    ownerState: S
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ke, _extends$1({}, Te, {
    children: ({
      TransitionProps: fe,
      placement: ue
    }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Pe, _extends$1({
      open: W,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: U === "tooltip",
      isEnabled: () => !0
    }, Y?.desktopTrapFocus, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(xe, _extends$1({}, fe, Y?.desktopTransition, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersPopperPaperWrapper, {
          PaperComponent: Re,
          ownerState: oe,
          popperPlacement: ue,
          ref: ne,
          onPaperClick: ee,
          onPaperTouchStart: te,
          paperClasses: ae.paper,
          paperSlotProps: Y?.desktopPaper,
          children: k
        })
      }))
    }))
  }));
}
const useOpenState = ({
  open: T,
  onOpen: S,
  onClose: R
}) => {
  const k = React$1.useRef(typeof T == "boolean").current, [D, L] = React$1.useState(!1);
  React$1.useEffect(() => {
    if (k) {
      if (typeof T != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      L(T);
    }
  }, [k, T]);
  const V = React$1.useCallback((z) => {
    k || L(z), z && S && S(), !z && R && R();
  }, [k, S, R]);
  return {
    isOpen: D,
    setIsOpen: V
  };
};
var define_process_env_default$g = {};
const shouldPublishValue = (T) => {
  const {
    action: S,
    hasChanged: R,
    dateState: k,
    isControlled: D
  } = T, L = !D && !k.hasBeenModifiedSinceMount;
  return S.name === "setValueFromField" ? !0 : S.name === "setValueFromAction" ? L && ["accept", "today", "clear"].includes(S.pickerAction) ? !0 : R(k.lastPublishedValue) : S.name === "setValueFromView" && S.selectionState !== "shallow" || S.name === "setValueFromShortcut" ? L ? !0 : R(k.lastPublishedValue) : !1;
}, shouldCommitValue = (T) => {
  const {
    action: S,
    hasChanged: R,
    dateState: k,
    isControlled: D,
    closeOnSelect: L
  } = T, V = !D && !k.hasBeenModifiedSinceMount;
  return S.name === "setValueFromAction" ? V && ["accept", "today", "clear"].includes(S.pickerAction) ? !0 : R(k.lastCommittedValue) : S.name === "setValueFromView" && S.selectionState === "finish" && L ? V ? !0 : R(k.lastCommittedValue) : S.name === "setValueFromShortcut" ? S.changeImportance === "accept" && R(k.lastCommittedValue) : !1;
}, shouldClosePicker = (T) => {
  const {
    action: S,
    closeOnSelect: R
  } = T;
  return S.name === "setValueFromAction" ? !0 : S.name === "setValueFromView" ? S.selectionState === "finish" && R : S.name === "setValueFromShortcut" ? S.changeImportance === "accept" : !1;
}, usePickerValue = ({
  props: T,
  valueManager: S,
  valueType: R,
  wrapperVariant: k,
  validator: D
}) => {
  const {
    onAccept: L,
    onChange: V,
    value: z,
    defaultValue: W,
    closeOnSelect: U = k === "desktop",
    timezone: q
  } = T, {
    current: K
  } = React$1.useRef(W), {
    current: Y
  } = React$1.useRef(z !== void 0);
  define_process_env_default$g.NODE_ENV !== "production" && (React$1.useEffect(() => {
    Y !== (z !== void 0) && console.error([`MUI X: A component is changing the ${Y ? "" : "un"}controlled value of a picker to be ${Y ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [z]), React$1.useEffect(() => {
    !Y && K !== W && console.error(["MUI X: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(K)]));
  const J = useUtils(), Z = useLocalizationContext(), {
    isOpen: X,
    setIsOpen: ee
  } = useOpenState(T), {
    timezone: te,
    value: re,
    handleValueChange: Q
  } = useValueWithTimezone({
    timezone: q,
    value: z,
    defaultValue: K,
    onChange: V,
    valueManager: S
  }), [ne, oe] = React$1.useState(() => {
    let Ee;
    return re !== void 0 ? Ee = re : K !== void 0 ? Ee = K : Ee = S.emptyValue, {
      draft: Ee,
      lastPublishedValue: Ee,
      lastCommittedValue: Ee,
      lastControlledValue: re,
      hasBeenModifiedSinceMount: !1
    };
  });
  useValidation(_extends$1({}, T, {
    value: ne.draft,
    timezone: te
  }), D, S.isSameError, S.defaultErrorState);
  const ae = useEventCallback((Ee) => {
    const ve = {
      action: Ee,
      dateState: ne,
      hasChanged: ($e) => !S.areValuesEqual(J, Ee.value, $e),
      isControlled: Y,
      closeOnSelect: U
    }, le = shouldPublishValue(ve), me = shouldCommitValue(ve), Se = shouldClosePicker(ve);
    oe(($e) => _extends$1({}, $e, {
      draft: Ee.value,
      lastPublishedValue: le ? Ee.value : $e.lastPublishedValue,
      lastCommittedValue: me ? Ee.value : $e.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    }));
    let ye = null;
    const be = () => (ye || (ye = {
      validationError: Ee.name === "setValueFromField" ? Ee.context.validationError : D({
        adapter: Z,
        value: Ee.value,
        props: _extends$1({}, T, {
          value: Ee.value,
          timezone: te
        })
      })
    }, Ee.name === "setValueFromShortcut" && (ye.shortcut = Ee.shortcut)), ye);
    le && Q(Ee.value, be()), me && L && L(Ee.value, be()), Se && ee(!1);
  });
  if (re !== void 0 && (ne.lastControlledValue === void 0 || !S.areValuesEqual(J, ne.lastControlledValue, re))) {
    const Ee = S.areValuesEqual(J, ne.draft, re);
    oe((ve) => _extends$1({}, ve, {
      lastControlledValue: re
    }, Ee ? {} : {
      lastCommittedValue: re,
      lastPublishedValue: re,
      draft: re,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const se = useEventCallback(() => {
    ae({
      value: S.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), ie = useEventCallback(() => {
    ae({
      value: ne.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), he = useEventCallback(() => {
    ae({
      value: ne.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), xe = useEventCallback(() => {
    ae({
      value: ne.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), Pe = useEventCallback(() => {
    ae({
      value: S.getTodayValue(J, te, R),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), Re = useEventCallback((Ee) => {
    Ee.preventDefault(), ee(!0);
  }), ke = useEventCallback((Ee) => {
    Ee?.preventDefault(), ee(!1);
  }), Te = useEventCallback((Ee, ve = "partial") => ae({
    name: "setValueFromView",
    value: Ee,
    selectionState: ve
  })), fe = useEventCallback((Ee, ve, le) => ae({
    name: "setValueFromShortcut",
    value: Ee,
    changeImportance: ve,
    shortcut: le
  })), ue = useEventCallback((Ee, ve) => ae({
    name: "setValueFromField",
    value: Ee,
    context: ve
  })), Ce = {
    onClear: se,
    onAccept: ie,
    onDismiss: he,
    onCancel: xe,
    onSetToday: Pe,
    onOpen: Re,
    onClose: ke
  }, ce = {
    value: ne.draft,
    onChange: ue
  }, pe = React$1.useMemo(() => S.cleanValue(J, ne.draft), [J, S, ne.draft]), _e = {
    value: pe,
    onChange: Te,
    onClose: ke,
    open: X
  }, Ae = _extends$1({}, Ce, {
    value: pe,
    onChange: Te,
    onSelectShortcut: fe,
    isValid: (Ee) => {
      const ve = D({
        adapter: Z,
        value: Ee,
        props: _extends$1({}, T, {
          value: Ee,
          timezone: te
        })
      });
      return !S.hasError(ve);
    }
  });
  return {
    open: X,
    fieldProps: ce,
    viewProps: _e,
    layoutProps: Ae,
    actions: Ce
  };
}, _excluded$g = ["className", "sx"], usePickerViews = ({
  props: T,
  propsFromPickerValue: S,
  additionalViewProps: R,
  autoFocusView: k,
  rendererInterceptor: D,
  fieldRef: L
}) => {
  const {
    onChange: V,
    open: z,
    onClose: W
  } = S, {
    view: U,
    views: q,
    openTo: K,
    onViewChange: Y,
    viewRenderers: J,
    timezone: Z
  } = T, X = _objectWithoutPropertiesLoose$1(T, _excluded$g), {
    view: ee,
    setView: te,
    defaultView: re,
    focusedView: Q,
    setFocusedView: ne,
    setValueAndGoToNextView: oe
  } = useViews({
    view: U,
    views: q,
    openTo: K,
    onChange: V,
    onViewChange: Y,
    autoFocus: k
  }), {
    hasUIView: ae,
    viewModeLookup: se
  } = React$1.useMemo(() => q.reduce((Te, fe) => {
    let ue;
    return J[fe] != null ? ue = "UI" : ue = "field", Te.viewModeLookup[fe] = ue, ue === "UI" && (Te.hasUIView = !0), Te;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [J, q]), ie = React$1.useMemo(() => q.reduce((Te, fe) => J[fe] != null && isTimeView(fe) ? Te + 1 : Te, 0), [J, q]), he = se[ee], xe = useEventCallback(() => he === "UI"), [Pe, Re] = React$1.useState(he === "UI" ? ee : null);
  return Pe !== ee && se[ee] === "UI" && Re(ee), useEnhancedEffect(() => {
    he === "field" && z && (W(), setTimeout(() => {
      L?.current?.setSelectedSections(ee), L?.current?.focusField(ee);
    }));
  }, [ee]), useEnhancedEffect(() => {
    if (!z)
      return;
    let Te = ee;
    he === "field" && Pe != null && (Te = Pe), Te !== re && se[Te] === "UI" && se[re] === "UI" && (Te = re), Te !== ee && te(Te), ne(Te, !0);
  }, [z]), {
    hasUIView: ae,
    shouldRestoreFocus: xe,
    layoutProps: {
      views: q,
      view: Pe,
      onViewChange: te
    },
    renderCurrentView: () => {
      if (Pe == null)
        return null;
      const Te = J[Pe];
      if (Te == null)
        return null;
      const fe = _extends$1({}, X, R, S, {
        views: q,
        timezone: Z,
        onChange: oe,
        view: Pe,
        onViewChange: te,
        focusedView: Q,
        onFocusedViewChange: ne,
        showViewSwitcher: ie > 1,
        timeViewsCount: ie
      });
      return D ? D(J, Pe, fe) : Te(fe);
    }
  };
};
function getOrientation() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
const useIsLandscape = (T, S) => {
  const [R, k] = React$1.useState(getOrientation);
  return useEnhancedEffect(() => {
    const L = () => {
      k(getOrientation());
    };
    return window.addEventListener("orientationchange", L), () => {
      window.removeEventListener("orientationchange", L);
    };
  }, []), arrayIncludes(T, ["hours", "minutes", "seconds"]) ? !1 : (S || R) === "landscape";
}, usePickerLayoutProps = ({
  props: T,
  propsFromPickerValue: S,
  propsFromPickerViews: R,
  wrapperVariant: k
}) => {
  const {
    orientation: D
  } = T, L = useIsLandscape(R.views, D), V = useRtl();
  return {
    layoutProps: _extends$1({}, R, S, {
      isLandscape: L,
      isRtl: V,
      wrapperVariant: k,
      disabled: T.disabled,
      readOnly: T.readOnly
    })
  };
}, buildWarning = (T, S = "warning") => {
  let R = !1;
  const k = Array.isArray(T) ? T.join(`
`) : T;
  return () => {
    R || (R = !0, S === "error" ? console.error(k) : console.warn(k));
  };
};
var define_process_env_default$f = {};
const warnRenderInputIsDefined = buildWarning(["The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]), usePicker = ({
  props: T,
  valueManager: S,
  valueType: R,
  wrapperVariant: k,
  additionalViewProps: D,
  validator: L,
  autoFocusView: V,
  rendererInterceptor: z,
  fieldRef: W
}) => {
  define_process_env_default$f.NODE_ENV !== "production" && T.renderInput != null && warnRenderInputIsDefined();
  const U = usePickerValue({
    props: T,
    valueManager: S,
    valueType: R,
    wrapperVariant: k,
    validator: L
  }), q = usePickerViews({
    props: T,
    additionalViewProps: D,
    autoFocusView: V,
    fieldRef: W,
    propsFromPickerValue: U.viewProps,
    rendererInterceptor: z
  }), K = usePickerLayoutProps({
    props: T,
    wrapperVariant: k,
    propsFromPickerValue: U.layoutProps,
    propsFromPickerViews: q.layoutProps
  });
  return {
    // Picker value
    open: U.open,
    actions: U.actions,
    fieldProps: U.fieldProps,
    // Picker views
    renderCurrentView: q.renderCurrentView,
    hasUIView: q.hasUIView,
    shouldRestoreFocus: q.shouldRestoreFocus,
    // Picker layout
    layoutProps: K.layoutProps
  };
};
function getPickersLayoutUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersLayout", T);
}
const pickersLayoutClasses = generateUtilityClasses$1("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]);
function getButtonUtilityClass(T) {
  return generateUtilityClass$1("MuiButton", T);
}
const buttonClasses = generateUtilityClasses$1("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]);
var define_process_env_default$e = {};
const ButtonGroupContext = /* @__PURE__ */ React$1.createContext({});
define_process_env_default$e.NODE_ENV !== "production" && (ButtonGroupContext.displayName = "ButtonGroupContext");
var define_process_env_default$d = {};
const ButtonGroupButtonContext = /* @__PURE__ */ React$1.createContext(void 0);
define_process_env_default$d.NODE_ENV !== "production" && (ButtonGroupButtonContext.displayName = "ButtonGroupButtonContext");
var define_process_env_default$c = {};
const _excluded$f = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], useUtilityClasses$b = (T) => {
  const {
    color: S,
    disableElevation: R,
    fullWidth: k,
    size: D,
    variant: L,
    classes: V
  } = T, z = {
    root: ["root", L, `${L}${capitalize$1(S)}`, `size${capitalize$1(D)}`, `${L}Size${capitalize$1(D)}`, `color${capitalize$1(S)}`, R && "disableElevation", k && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${capitalize$1(D)}`],
    endIcon: ["icon", "endIcon", `iconSize${capitalize$1(D)}`]
  }, W = composeClasses(z, getButtonUtilityClass, V);
  return _extends$1({}, V, W);
}, commonIconStyles = (T) => _extends$1({}, T.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, T.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, T.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), ButtonRoot = styled(ButtonBase, {
  shouldForwardProp: (T) => rootShouldForwardProp(T) || T === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.root, S[R.variant], S[`${R.variant}${capitalize$1(R.color)}`], S[`size${capitalize$1(R.size)}`], S[`${R.variant}Size${capitalize$1(R.size)}`], R.color === "inherit" && S.colorInherit, R.disableElevation && S.disableElevation, R.fullWidth && S.fullWidth];
  }
})(({
  theme: T,
  ownerState: S
}) => {
  var R, k;
  const D = T.palette.mode === "light" ? T.palette.grey[300] : T.palette.grey[800], L = T.palette.mode === "light" ? T.palette.grey.A100 : T.palette.grey[700];
  return _extends$1({}, T.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (T.vars || T).shape.borderRadius,
    transition: T.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: T.transitions.duration.short
    }),
    "&:hover": _extends$1({
      textDecoration: "none",
      backgroundColor: T.vars ? `rgba(${T.vars.palette.text.primaryChannel} / ${T.vars.palette.action.hoverOpacity})` : alpha_1(T.palette.text.primary, T.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, S.variant === "text" && S.color !== "inherit" && {
      backgroundColor: T.vars ? `rgba(${T.vars.palette[S.color].mainChannel} / ${T.vars.palette.action.hoverOpacity})` : alpha_1(T.palette[S.color].main, T.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, S.variant === "outlined" && S.color !== "inherit" && {
      border: `1px solid ${(T.vars || T).palette[S.color].main}`,
      backgroundColor: T.vars ? `rgba(${T.vars.palette[S.color].mainChannel} / ${T.vars.palette.action.hoverOpacity})` : alpha_1(T.palette[S.color].main, T.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, S.variant === "contained" && {
      backgroundColor: T.vars ? T.vars.palette.Button.inheritContainedHoverBg : L,
      boxShadow: (T.vars || T).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (T.vars || T).shadows[2],
        backgroundColor: (T.vars || T).palette.grey[300]
      }
    }, S.variant === "contained" && S.color !== "inherit" && {
      backgroundColor: (T.vars || T).palette[S.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (T.vars || T).palette[S.color].main
      }
    }),
    "&:active": _extends$1({}, S.variant === "contained" && {
      boxShadow: (T.vars || T).shadows[8]
    }),
    [`&.${buttonClasses.focusVisible}`]: _extends$1({}, S.variant === "contained" && {
      boxShadow: (T.vars || T).shadows[6]
    }),
    [`&.${buttonClasses.disabled}`]: _extends$1({
      color: (T.vars || T).palette.action.disabled
    }, S.variant === "outlined" && {
      border: `1px solid ${(T.vars || T).palette.action.disabledBackground}`
    }, S.variant === "contained" && {
      color: (T.vars || T).palette.action.disabled,
      boxShadow: (T.vars || T).shadows[0],
      backgroundColor: (T.vars || T).palette.action.disabledBackground
    })
  }, S.variant === "text" && {
    padding: "6px 8px"
  }, S.variant === "text" && S.color !== "inherit" && {
    color: (T.vars || T).palette[S.color].main
  }, S.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, S.variant === "outlined" && S.color !== "inherit" && {
    color: (T.vars || T).palette[S.color].main,
    border: T.vars ? `1px solid rgba(${T.vars.palette[S.color].mainChannel} / 0.5)` : `1px solid ${alpha_1(T.palette[S.color].main, 0.5)}`
  }, S.variant === "contained" && {
    color: T.vars ? (
      // this is safe because grey does not change between default light/dark mode
      T.vars.palette.text.primary
    ) : (R = (k = T.palette).getContrastText) == null ? void 0 : R.call(k, T.palette.grey[300]),
    backgroundColor: T.vars ? T.vars.palette.Button.inheritContainedBg : D,
    boxShadow: (T.vars || T).shadows[2]
  }, S.variant === "contained" && S.color !== "inherit" && {
    color: (T.vars || T).palette[S.color].contrastText,
    backgroundColor: (T.vars || T).palette[S.color].main
  }, S.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, S.size === "small" && S.variant === "text" && {
    padding: "4px 5px",
    fontSize: T.typography.pxToRem(13)
  }, S.size === "large" && S.variant === "text" && {
    padding: "8px 11px",
    fontSize: T.typography.pxToRem(15)
  }, S.size === "small" && S.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: T.typography.pxToRem(13)
  }, S.size === "large" && S.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: T.typography.pxToRem(15)
  }, S.size === "small" && S.variant === "contained" && {
    padding: "4px 10px",
    fontSize: T.typography.pxToRem(13)
  }, S.size === "large" && S.variant === "contained" && {
    padding: "8px 22px",
    fontSize: T.typography.pxToRem(15)
  }, S.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: T
}) => T.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${buttonClasses.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${buttonClasses.disabled}`]: {
    boxShadow: "none"
  }
}), ButtonStartIcon = styled("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.startIcon, S[`iconSize${capitalize$1(R.size)}`]];
  }
})(({
  ownerState: T
}) => _extends$1({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, T.size === "small" && {
  marginLeft: -2
}, commonIconStyles(T))), ButtonEndIcon = styled("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.endIcon, S[`iconSize${capitalize$1(R.size)}`]];
  }
})(({
  ownerState: T
}) => _extends$1({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, T.size === "small" && {
  marginRight: -2
}, commonIconStyles(T))), Button$2 = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = React$1.useContext(ButtonGroupContext), D = React$1.useContext(ButtonGroupButtonContext), L = resolveProps(k, S), V = useDefaultProps({
    props: L,
    name: "MuiButton"
  }), {
    children: z,
    color: W = "primary",
    component: U = "button",
    className: q,
    disabled: K = !1,
    disableElevation: Y = !1,
    disableFocusRipple: J = !1,
    endIcon: Z,
    focusVisibleClassName: X,
    fullWidth: ee = !1,
    size: te = "medium",
    startIcon: re,
    type: Q,
    variant: ne = "text"
  } = V, oe = _objectWithoutPropertiesLoose$1(V, _excluded$f), ae = _extends$1({}, V, {
    color: W,
    component: U,
    disabled: K,
    disableElevation: Y,
    disableFocusRipple: J,
    fullWidth: ee,
    size: te,
    type: Q,
    variant: ne
  }), se = useUtilityClasses$b(ae), ie = re && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonStartIcon, {
    className: se.startIcon,
    ownerState: ae,
    children: re
  }), he = Z && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonEndIcon, {
    className: se.endIcon,
    ownerState: ae,
    children: Z
  }), xe = D || "";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonRoot, _extends$1({
    ownerState: ae,
    className: clsx(k.className, se.root, q, xe),
    component: U,
    disabled: K,
    focusRipple: !J,
    focusVisibleClassName: clsx(se.focusVisible, X),
    ref: R,
    type: Q
  }, oe, {
    classes: se,
    children: [ie, z, he]
  }));
});
define_process_env_default$c.NODE_ENV !== "production" && (Button$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["contained", "outlined", "text"]), PropTypes.string])
});
function getDialogActionsUtilityClass(T) {
  return generateUtilityClass$1("MuiDialogActions", T);
}
generateUtilityClasses$1("MuiDialogActions", ["root", "spacing"]);
var define_process_env_default$b = {};
const _excluded$e = ["className", "disableSpacing"], useUtilityClasses$a = (T) => {
  const {
    classes: S,
    disableSpacing: R
  } = T;
  return composeClasses({
    root: ["root", !R && "spacing"]
  }, getDialogActionsUtilityClass, S);
}, DialogActionsRoot = styled("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.root, !R.disableSpacing && S.spacing];
  }
})(({
  ownerState: T
}) => _extends$1({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto"
}, !T.disableSpacing && {
  "& > :not(style) ~ :not(style)": {
    marginLeft: 8
  }
})), DialogActions$3 = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiDialogActions"
  }), {
    className: D,
    disableSpacing: L = !1
  } = k, V = _objectWithoutPropertiesLoose$1(k, _excluded$e), z = _extends$1({}, k, {
    disableSpacing: L
  }), W = useUtilityClasses$a(z);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DialogActionsRoot, _extends$1({
    className: clsx(W.root, D),
    ownerState: z,
    ref: R
  }, V));
});
define_process_env_default$b.NODE_ENV !== "production" && (DialogActions$3.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
var define_process_env_default$a = {};
const _excluded$d = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function PickersActionBar(T) {
  const {
    onAccept: S,
    onClear: R,
    onCancel: k,
    onSetToday: D,
    actions: L
  } = T, V = _objectWithoutPropertiesLoose$1(T, _excluded$d), z = usePickersTranslations();
  if (L == null || L.length === 0)
    return null;
  const W = L?.map((U) => {
    switch (U) {
      case "clear":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, {
          onClick: R,
          children: z.clearButtonLabel
        }, U);
      case "cancel":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, {
          onClick: k,
          children: z.cancelButtonLabel
        }, U);
      case "accept":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, {
          onClick: S,
          children: z.okButtonLabel
        }, U);
      case "today":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Button$2, {
          onClick: D,
          children: z.todayButtonLabel
        }, U);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DialogActions$3, _extends$1({}, V, {
    children: W
  }));
}
define_process_env_default$a.NODE_ENV !== "production" && (PickersActionBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: PropTypes.arrayOf(PropTypes.oneOf(["accept", "cancel", "clear", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: PropTypes.bool,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onSetToday: PropTypes.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getListItemUtilityClass(T) {
  return generateUtilityClass$1("MuiListItem", T);
}
const listItemClasses = generateUtilityClasses$1("MuiListItem", ["root", "container", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "padding", "button", "secondaryAction", "selected"]), listItemButtonClasses = generateUtilityClasses$1("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function getListItemSecondaryActionClassesUtilityClass(T) {
  return generateUtilityClass$1("MuiListItemSecondaryAction", T);
}
generateUtilityClasses$1("MuiListItemSecondaryAction", ["root", "disableGutters"]);
var define_process_env_default$9 = {};
const _excluded$c = ["className"], useUtilityClasses$9 = (T) => {
  const {
    disableGutters: S,
    classes: R
  } = T;
  return composeClasses({
    root: ["root", S && "disableGutters"]
  }, getListItemSecondaryActionClassesUtilityClass, R);
}, ListItemSecondaryActionRoot = styled("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.root, R.disableGutters && S.disableGutters];
  }
})(({
  ownerState: T
}) => _extends$1({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)"
}, T.disableGutters && {
  right: 0
})), ListItemSecondaryAction = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiListItemSecondaryAction"
  }), {
    className: D
  } = k, L = _objectWithoutPropertiesLoose$1(k, _excluded$c), V = React$1.useContext(ListContext), z = _extends$1({}, k, {
    disableGutters: V.disableGutters
  }), W = useUtilityClasses$9(z);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemSecondaryActionRoot, _extends$1({
    className: clsx(W.root, D),
    ownerState: z,
    ref: R
  }, L));
});
define_process_env_default$9.NODE_ENV !== "production" && (ListItemSecondaryAction.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
var define_process_env_default$8 = {};
const _excluded$b = ["className"], _excluded2$2 = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"], overridesResolver = (T, S) => {
  const {
    ownerState: R
  } = T;
  return [S.root, R.dense && S.dense, R.alignItems === "flex-start" && S.alignItemsFlexStart, R.divider && S.divider, !R.disableGutters && S.gutters, !R.disablePadding && S.padding, R.button && S.button, R.hasSecondaryAction && S.secondaryAction];
}, useUtilityClasses$8 = (T) => {
  const {
    alignItems: S,
    button: R,
    classes: k,
    dense: D,
    disabled: L,
    disableGutters: V,
    disablePadding: z,
    divider: W,
    hasSecondaryAction: U,
    selected: q
  } = T;
  return composeClasses({
    root: ["root", D && "dense", !V && "gutters", !z && "padding", W && "divider", L && "disabled", R && "button", S === "flex-start" && "alignItemsFlexStart", U && "secondaryAction", q && "selected"],
    container: ["container"]
  }, getListItemUtilityClass, k);
}, ListItemRoot = styled("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver
})(({
  theme: T,
  ownerState: S
}) => _extends$1({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left"
}, !S.disablePadding && _extends$1({
  paddingTop: 8,
  paddingBottom: 8
}, S.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !S.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!S.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!S.secondaryAction && {
  [`& > .${listItemButtonClasses.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${listItemClasses.focusVisible}`]: {
    backgroundColor: (T.vars || T).palette.action.focus
  },
  [`&.${listItemClasses.selected}`]: {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / ${T.vars.palette.action.selectedOpacity})` : alpha_1(T.palette.primary.main, T.palette.action.selectedOpacity),
    [`&.${listItemClasses.focusVisible}`]: {
      backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / calc(${T.vars.palette.action.selectedOpacity} + ${T.vars.palette.action.focusOpacity}))` : alpha_1(T.palette.primary.main, T.palette.action.selectedOpacity + T.palette.action.focusOpacity)
    }
  },
  [`&.${listItemClasses.disabled}`]: {
    opacity: (T.vars || T).palette.action.disabledOpacity
  }
}, S.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, S.divider && {
  borderBottom: `1px solid ${(T.vars || T).palette.divider}`,
  backgroundClip: "padding-box"
}, S.button && {
  transition: T.transitions.create("background-color", {
    duration: T.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (T.vars || T).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${listItemClasses.selected}:hover`]: {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / calc(${T.vars.palette.action.selectedOpacity} + ${T.vars.palette.action.hoverOpacity}))` : alpha_1(T.palette.primary.main, T.palette.action.selectedOpacity + T.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: T.vars ? `rgba(${T.vars.palette.primary.mainChannel} / ${T.vars.palette.action.selectedOpacity})` : alpha_1(T.palette.primary.main, T.palette.action.selectedOpacity)
    }
  }
}, S.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
})), ListItemContainer = styled("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (T, S) => S.container
})({
  position: "relative"
}), ListItem = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiListItem"
  }), {
    alignItems: D = "center",
    autoFocus: L = !1,
    button: V = !1,
    children: z,
    className: W,
    component: U,
    components: q = {},
    componentsProps: K = {},
    ContainerComponent: Y = "li",
    ContainerProps: {
      className: J
    } = {},
    dense: Z = !1,
    disabled: X = !1,
    disableGutters: ee = !1,
    disablePadding: te = !1,
    divider: re = !1,
    focusVisibleClassName: Q,
    secondaryAction: ne,
    selected: oe = !1,
    slotProps: ae = {},
    slots: se = {}
  } = k, ie = _objectWithoutPropertiesLoose$1(k.ContainerProps, _excluded$b), he = _objectWithoutPropertiesLoose$1(k, _excluded2$2), xe = React$1.useContext(ListContext), Pe = React$1.useMemo(() => ({
    dense: Z || xe.dense || !1,
    alignItems: D,
    disableGutters: ee
  }), [D, xe.dense, Z, ee]), Re = React$1.useRef(null);
  useEnhancedEffect(() => {
    L && (Re.current ? Re.current.focus() : define_process_env_default$8.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItem whose component has not been rendered."));
  }, [L]);
  const ke = React$1.Children.toArray(z), Te = ke.length && isMuiElement(ke[ke.length - 1], ["ListItemSecondaryAction"]), fe = _extends$1({}, k, {
    alignItems: D,
    autoFocus: L,
    button: V,
    dense: Pe.dense,
    disabled: X,
    disableGutters: ee,
    disablePadding: te,
    divider: re,
    hasSecondaryAction: Te,
    selected: oe
  }), ue = useUtilityClasses$8(fe), Ce = useForkRef(Re, R), ce = se.root || q.Root || ListItemRoot, pe = ae.root || K.root || {}, _e = _extends$1({
    className: clsx(ue.root, pe.className, W),
    disabled: X
  }, he);
  let ge = U || "li";
  return V && (_e.component = U || "div", _e.focusVisibleClassName = clsx(listItemClasses.focusVisible, Q), ge = ButtonBase), Te ? (ge = !_e.component && !U ? "div" : ge, Y === "li" && (ge === "li" ? ge = "div" : _e.component === "li" && (_e.component = "div")), /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: Pe,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItemContainer, _extends$1({
      as: Y,
      className: clsx(ue.container, J),
      ref: Ce,
      ownerState: fe
    }, ie, {
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ce, _extends$1({}, pe, !isHostComponent(ce) && {
        as: ge,
        ownerState: _extends$1({}, fe, pe.ownerState)
      }, _e, {
        children: ke
      })), ke.pop()]
    }))
  })) : /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: Pe,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ce, _extends$1({}, pe, {
      as: ge,
      ref: Ce
    }, !isHostComponent(ce) && {
      ownerState: _extends$1({}, fe, pe.ownerState)
    }, _e, {
      children: [ke, ne && /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemSecondaryAction, {
        children: ne
      })]
    }))
  });
});
define_process_env_default$8.NODE_ENV !== "production" && (ListItem.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: PropTypes.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  button: PropTypes.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes.node, (T) => {
    const S = React$1.Children.toArray(T.children);
    let R = -1;
    for (let k = S.length - 1; k >= 0; k -= 1) {
      const D = S[k];
      if (isMuiElement(D, ["ListItemSecondaryAction"])) {
        R = k;
        break;
      }
    }
    return R !== -1 && R !== S.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: elementTypeAcceptingRef$1,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: PropTypes.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: PropTypes.node,
  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  selected: PropTypes.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const CancelIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function getChipUtilityClass(T) {
  return generateUtilityClass$1("MuiChip", T);
}
const chipClasses = generateUtilityClasses$1("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]);
var define_process_env_default$7 = {};
const _excluded$a = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"], useUtilityClasses$7 = (T) => {
  const {
    classes: S,
    disabled: R,
    size: k,
    color: D,
    iconColor: L,
    onDelete: V,
    clickable: z,
    variant: W
  } = T, U = {
    root: ["root", W, R && "disabled", `size${capitalize$1(k)}`, `color${capitalize$1(D)}`, z && "clickable", z && `clickableColor${capitalize$1(D)}`, V && "deletable", V && `deletableColor${capitalize$1(D)}`, `${W}${capitalize$1(D)}`],
    label: ["label", `label${capitalize$1(k)}`],
    avatar: ["avatar", `avatar${capitalize$1(k)}`, `avatarColor${capitalize$1(D)}`],
    icon: ["icon", `icon${capitalize$1(k)}`, `iconColor${capitalize$1(L)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${capitalize$1(k)}`, `deleteIconColor${capitalize$1(D)}`, `deleteIcon${capitalize$1(W)}Color${capitalize$1(D)}`]
  };
  return composeClasses(U, getChipUtilityClass, S);
}, ChipRoot = styled("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T, {
      color: k,
      iconColor: D,
      clickable: L,
      onDelete: V,
      size: z,
      variant: W
    } = R;
    return [{
      [`& .${chipClasses.avatar}`]: S.avatar
    }, {
      [`& .${chipClasses.avatar}`]: S[`avatar${capitalize$1(z)}`]
    }, {
      [`& .${chipClasses.avatar}`]: S[`avatarColor${capitalize$1(k)}`]
    }, {
      [`& .${chipClasses.icon}`]: S.icon
    }, {
      [`& .${chipClasses.icon}`]: S[`icon${capitalize$1(z)}`]
    }, {
      [`& .${chipClasses.icon}`]: S[`iconColor${capitalize$1(D)}`]
    }, {
      [`& .${chipClasses.deleteIcon}`]: S.deleteIcon
    }, {
      [`& .${chipClasses.deleteIcon}`]: S[`deleteIcon${capitalize$1(z)}`]
    }, {
      [`& .${chipClasses.deleteIcon}`]: S[`deleteIconColor${capitalize$1(k)}`]
    }, {
      [`& .${chipClasses.deleteIcon}`]: S[`deleteIcon${capitalize$1(W)}Color${capitalize$1(k)}`]
    }, S.root, S[`size${capitalize$1(z)}`], S[`color${capitalize$1(k)}`], L && S.clickable, L && k !== "default" && S[`clickableColor${capitalize$1(k)})`], V && S.deletable, V && k !== "default" && S[`deletableColor${capitalize$1(k)}`], S[W], S[`${W}${capitalize$1(k)}`]];
  }
})(({
  theme: T,
  ownerState: S
}) => {
  const R = T.palette.mode === "light" ? T.palette.grey[700] : T.palette.grey[300];
  return _extends$1({
    maxWidth: "100%",
    fontFamily: T.typography.fontFamily,
    fontSize: T.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (T.vars || T).palette.text.primary,
    backgroundColor: (T.vars || T).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: T.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${chipClasses.disabled}`]: {
      opacity: (T.vars || T).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${chipClasses.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: T.vars ? T.vars.palette.Chip.defaultAvatarColor : R,
      fontSize: T.typography.pxToRem(12)
    },
    [`& .${chipClasses.avatarColorPrimary}`]: {
      color: (T.vars || T).palette.primary.contrastText,
      backgroundColor: (T.vars || T).palette.primary.dark
    },
    [`& .${chipClasses.avatarColorSecondary}`]: {
      color: (T.vars || T).palette.secondary.contrastText,
      backgroundColor: (T.vars || T).palette.secondary.dark
    },
    [`& .${chipClasses.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: T.typography.pxToRem(10)
    },
    [`& .${chipClasses.icon}`]: _extends$1({
      marginLeft: 5,
      marginRight: -6
    }, S.size === "small" && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, S.iconColor === S.color && _extends$1({
      color: T.vars ? T.vars.palette.Chip.defaultIconColor : R
    }, S.color !== "default" && {
      color: "inherit"
    })),
    [`& .${chipClasses.deleteIcon}`]: _extends$1({
      WebkitTapHighlightColor: "transparent",
      color: T.vars ? `rgba(${T.vars.palette.text.primaryChannel} / 0.26)` : alpha_1(T.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: T.vars ? `rgba(${T.vars.palette.text.primaryChannel} / 0.4)` : alpha_1(T.palette.text.primary, 0.4)
      }
    }, S.size === "small" && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, S.color !== "default" && {
      color: T.vars ? `rgba(${T.vars.palette[S.color].contrastTextChannel} / 0.7)` : alpha_1(T.palette[S.color].contrastText, 0.7),
      "&:hover, &:active": {
        color: (T.vars || T).palette[S.color].contrastText
      }
    })
  }, S.size === "small" && {
    height: 24
  }, S.color !== "default" && {
    backgroundColor: (T.vars || T).palette[S.color].main,
    color: (T.vars || T).palette[S.color].contrastText
  }, S.onDelete && {
    [`&.${chipClasses.focusVisible}`]: {
      backgroundColor: T.vars ? `rgba(${T.vars.palette.action.selectedChannel} / calc(${T.vars.palette.action.selectedOpacity} + ${T.vars.palette.action.focusOpacity}))` : alpha_1(T.palette.action.selected, T.palette.action.selectedOpacity + T.palette.action.focusOpacity)
    }
  }, S.onDelete && S.color !== "default" && {
    [`&.${chipClasses.focusVisible}`]: {
      backgroundColor: (T.vars || T).palette[S.color].dark
    }
  });
}, ({
  theme: T,
  ownerState: S
}) => _extends$1({}, S.clickable && {
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.action.selectedChannel} / calc(${T.vars.palette.action.selectedOpacity} + ${T.vars.palette.action.hoverOpacity}))` : alpha_1(T.palette.action.selected, T.palette.action.selectedOpacity + T.palette.action.hoverOpacity)
  },
  [`&.${chipClasses.focusVisible}`]: {
    backgroundColor: T.vars ? `rgba(${T.vars.palette.action.selectedChannel} / calc(${T.vars.palette.action.selectedOpacity} + ${T.vars.palette.action.focusOpacity}))` : alpha_1(T.palette.action.selected, T.palette.action.selectedOpacity + T.palette.action.focusOpacity)
  },
  "&:active": {
    boxShadow: (T.vars || T).shadows[1]
  }
}, S.clickable && S.color !== "default" && {
  [`&:hover, &.${chipClasses.focusVisible}`]: {
    backgroundColor: (T.vars || T).palette[S.color].dark
  }
}), ({
  theme: T,
  ownerState: S
}) => _extends$1({}, S.variant === "outlined" && {
  backgroundColor: "transparent",
  border: T.vars ? `1px solid ${T.vars.palette.Chip.defaultBorder}` : `1px solid ${T.palette.mode === "light" ? T.palette.grey[400] : T.palette.grey[700]}`,
  [`&.${chipClasses.clickable}:hover`]: {
    backgroundColor: (T.vars || T).palette.action.hover
  },
  [`&.${chipClasses.focusVisible}`]: {
    backgroundColor: (T.vars || T).palette.action.focus
  },
  [`& .${chipClasses.avatar}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses.icon}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${chipClasses.deleteIconSmall}`]: {
    marginRight: 3
  }
}, S.variant === "outlined" && S.color !== "default" && {
  color: (T.vars || T).palette[S.color].main,
  border: `1px solid ${T.vars ? `rgba(${T.vars.palette[S.color].mainChannel} / 0.7)` : alpha_1(T.palette[S.color].main, 0.7)}`,
  [`&.${chipClasses.clickable}:hover`]: {
    backgroundColor: T.vars ? `rgba(${T.vars.palette[S.color].mainChannel} / ${T.vars.palette.action.hoverOpacity})` : alpha_1(T.palette[S.color].main, T.palette.action.hoverOpacity)
  },
  [`&.${chipClasses.focusVisible}`]: {
    backgroundColor: T.vars ? `rgba(${T.vars.palette[S.color].mainChannel} / ${T.vars.palette.action.focusOpacity})` : alpha_1(T.palette[S.color].main, T.palette.action.focusOpacity)
  },
  [`& .${chipClasses.deleteIcon}`]: {
    color: T.vars ? `rgba(${T.vars.palette[S.color].mainChannel} / 0.7)` : alpha_1(T.palette[S.color].main, 0.7),
    "&:hover, &:active": {
      color: (T.vars || T).palette[S.color].main
    }
  }
})), ChipLabel = styled("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T, {
      size: k
    } = R;
    return [S.label, S[`label${capitalize$1(k)}`]];
  }
})(({
  ownerState: T
}) => _extends$1({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap"
}, T.variant === "outlined" && {
  paddingLeft: 11,
  paddingRight: 11
}, T.size === "small" && {
  paddingLeft: 8,
  paddingRight: 8
}, T.size === "small" && T.variant === "outlined" && {
  paddingLeft: 7,
  paddingRight: 7
}));
function isDeleteKeyboardEvent(T) {
  return T.key === "Backspace" || T.key === "Delete";
}
const Chip = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiChip"
  }), {
    avatar: D,
    className: L,
    clickable: V,
    color: z = "default",
    component: W,
    deleteIcon: U,
    disabled: q = !1,
    icon: K,
    label: Y,
    onClick: J,
    onDelete: Z,
    onKeyDown: X,
    onKeyUp: ee,
    size: te = "medium",
    variant: re = "filled",
    tabIndex: Q,
    skipFocusWhenDisabled: ne = !1
    // TODO v6: Rename to `focusableWhenDisabled`.
  } = k, oe = _objectWithoutPropertiesLoose$1(k, _excluded$a), ae = React$1.useRef(null), se = useForkRef(ae, R), ie = (pe) => {
    pe.stopPropagation(), Z && Z(pe);
  }, he = (pe) => {
    pe.currentTarget === pe.target && isDeleteKeyboardEvent(pe) && pe.preventDefault(), X && X(pe);
  }, xe = (pe) => {
    pe.currentTarget === pe.target && (Z && isDeleteKeyboardEvent(pe) ? Z(pe) : pe.key === "Escape" && ae.current && ae.current.blur()), ee && ee(pe);
  }, Pe = V !== !1 && J ? !0 : V, Re = Pe || Z ? ButtonBase : W || "div", ke = _extends$1({}, k, {
    component: Re,
    disabled: q,
    size: te,
    color: z,
    iconColor: /* @__PURE__ */ React$1.isValidElement(K) && K.props.color || z,
    onDelete: !!Z,
    clickable: Pe,
    variant: re
  }), Te = useUtilityClasses$7(ke), fe = Re === ButtonBase ? _extends$1({
    component: W || "div",
    focusVisibleClassName: Te.focusVisible
  }, Z && {
    disableRipple: !0
  }) : {};
  let ue = null;
  Z && (ue = U && /* @__PURE__ */ React$1.isValidElement(U) ? /* @__PURE__ */ React$1.cloneElement(U, {
    className: clsx(U.props.className, Te.deleteIcon),
    onClick: ie
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CancelIcon, {
    className: clsx(Te.deleteIcon),
    onClick: ie
  }));
  let Ce = null;
  D && /* @__PURE__ */ React$1.isValidElement(D) && (Ce = /* @__PURE__ */ React$1.cloneElement(D, {
    className: clsx(Te.avatar, D.props.className)
  }));
  let ce = null;
  return K && /* @__PURE__ */ React$1.isValidElement(K) && (ce = /* @__PURE__ */ React$1.cloneElement(K, {
    className: clsx(Te.icon, K.props.className)
  })), define_process_env_default$7.NODE_ENV !== "production" && Ce && ce && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ jsxRuntimeExports.jsxs(ChipRoot, _extends$1({
    as: Re,
    className: clsx(Te.root, L),
    disabled: Pe && q ? !0 : void 0,
    onClick: J,
    onKeyDown: he,
    onKeyUp: xe,
    ref: se,
    tabIndex: ne && q ? -1 : Q,
    ownerState: ke
  }, fe, oe, {
    children: [Ce || ce, /* @__PURE__ */ jsxRuntimeExports.jsx(ChipLabel, {
      className: clsx(Te.label),
      ownerState: ke,
      children: Y
    }), ue]
  }));
});
define_process_env_default$7.NODE_ENV !== "production" && (Chip.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: PropTypes.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: PropTypes.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Icon element.
   */
  icon: PropTypes.element,
  /**
   * The content of the component.
   */
  label: PropTypes.node,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  tabIndex: PropTypes.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined"]), PropTypes.string])
});
var define_process_env_default$6 = {};
const _excluded$9 = ["items", "changeImportance", "isLandscape", "onChange", "isValid"], _excluded2$1 = ["getValue"];
function PickersShortcuts(T) {
  const {
    items: S,
    changeImportance: R = "accept",
    onChange: k,
    isValid: D
  } = T, L = _objectWithoutPropertiesLoose$1(T, _excluded$9);
  if (S == null || S.length === 0)
    return null;
  const V = S.map((z) => {
    let {
      getValue: W
    } = z, U = _objectWithoutPropertiesLoose$1(z, _excluded2$1);
    const q = W({
      isValid: D
    });
    return _extends$1({}, U, {
      label: U.label,
      onClick: () => {
        k(q, R, U);
      },
      disabled: !D(q)
    });
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(List, _extends$1({
    dense: !0,
    sx: [{
      maxHeight: VIEW_HEIGHT,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(L.sx) ? L.sx : [L.sx]]
  }, L, {
    children: V.map((z) => /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Chip, _extends$1({}, z))
    }, z.id ?? z.label))
  }));
}
define_process_env_default$6.NODE_ENV !== "production" && (PickersShortcuts.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: PropTypes.oneOf(["accept", "set"]),
  className: PropTypes.string,
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  isLandscape: PropTypes.bool.isRequired,
  isValid: PropTypes.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default []
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    getValue: PropTypes.func.isRequired,
    id: PropTypes.string,
    label: PropTypes.string.isRequired
  })),
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function toolbarHasView(T) {
  return T.view !== null;
}
const useUtilityClasses$6 = (T) => {
  const {
    classes: S,
    isLandscape: R
  } = T;
  return composeClasses({
    root: ["root", R && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, getPickersLayoutUtilityClass, S);
}, usePickerLayout = (T) => {
  const {
    wrapperVariant: S,
    onAccept: R,
    onClear: k,
    onCancel: D,
    onSetToday: L,
    view: V,
    views: z,
    onViewChange: W,
    value: U,
    onChange: q,
    onSelectShortcut: K,
    isValid: Y,
    isLandscape: J,
    disabled: Z,
    readOnly: X,
    children: ee,
    slots: te,
    slotProps: re
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = T, Q = useUtilityClasses$6(T), ne = te?.actionBar ?? PickersActionBar, oe = useSlotProps({
    elementType: ne,
    externalSlotProps: re?.actionBar,
    additionalProps: {
      onAccept: R,
      onClear: k,
      onCancel: D,
      onSetToday: L,
      actions: S === "desktop" ? [] : ["cancel", "accept"]
    },
    className: Q.actionBar,
    ownerState: _extends$1({}, T, {
      wrapperVariant: S
    })
  }), ae = /* @__PURE__ */ jsxRuntimeExports.jsx(ne, _extends$1({}, oe)), se = te?.toolbar, ie = useSlotProps({
    elementType: se,
    externalSlotProps: re?.toolbar,
    additionalProps: {
      isLandscape: J,
      onChange: q,
      value: U,
      view: V,
      onViewChange: W,
      views: z,
      disabled: Z,
      readOnly: X
    },
    className: Q.toolbar,
    ownerState: _extends$1({}, T, {
      wrapperVariant: S
    })
  }), he = toolbarHasView(ie) && se ? /* @__PURE__ */ jsxRuntimeExports.jsx(se, _extends$1({}, ie)) : null, xe = ee, Pe = te?.tabs, Re = V && Pe ? /* @__PURE__ */ jsxRuntimeExports.jsx(Pe, _extends$1({
    view: V,
    onViewChange: W,
    className: Q.tabs
  }, re?.tabs)) : null, ke = te?.shortcuts ?? PickersShortcuts, Te = useSlotProps({
    elementType: ke,
    externalSlotProps: re?.shortcuts,
    additionalProps: {
      isValid: Y,
      isLandscape: J,
      onChange: K
    },
    className: Q.shortcuts,
    ownerState: {
      isValid: Y,
      isLandscape: J,
      onChange: K,
      wrapperVariant: S
    }
  }), fe = V && ke ? /* @__PURE__ */ jsxRuntimeExports.jsx(ke, _extends$1({}, Te)) : null;
  return {
    toolbar: he,
    content: xe,
    tabs: Re,
    actionBar: ae,
    shortcuts: fe
  };
};
var define_process_env_default$5 = {};
const useUtilityClasses$5 = (T) => {
  const {
    isLandscape: S,
    classes: R
  } = T;
  return composeClasses({
    root: ["root", S && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, getPickersLayoutUtilityClass, R);
}, PickersLayoutRoot = styled("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${pickersLayoutClasses.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  },
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      [`& .${pickersLayoutClasses.toolbar}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      },
      [`.${pickersLayoutClasses.shortcuts}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      }
    }
  }, {
    props: {
      isLandscape: !0,
      isRtl: !0
    },
    style: {
      [`& .${pickersLayoutClasses.toolbar}`]: {
        gridColumn: 3
      }
    }
  }, {
    props: {
      isLandscape: !1
    },
    style: {
      [`& .${pickersLayoutClasses.toolbar}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      },
      [`& .${pickersLayoutClasses.shortcuts}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      }
    }
  }, {
    props: {
      isLandscape: !1,
      isRtl: !0
    },
    style: {
      [`& .${pickersLayoutClasses.shortcuts}`]: {
        gridColumn: 3
      }
    }
  }]
}), PickersLayoutContentWrapper = styled("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (T, S) => S.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), PickersLayout = function T(S) {
  const R = useThemeProps({
    props: S,
    name: "MuiPickersLayout"
  }), {
    toolbar: k,
    content: D,
    tabs: L,
    actionBar: V,
    shortcuts: z
  } = usePickerLayout(R), {
    sx: W,
    className: U,
    isLandscape: q,
    ref: K,
    wrapperVariant: Y
  } = R, J = useUtilityClasses$5(R);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(PickersLayoutRoot, {
    ref: K,
    sx: W,
    className: clsx(U, J.root),
    ownerState: R,
    children: [q ? z : k, q ? k : z, /* @__PURE__ */ jsxRuntimeExports.jsx(PickersLayoutContentWrapper, {
      className: J.contentWrapper,
      children: Y === "desktop" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [D, L]
      }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [L, D]
      })
    }), V]
  });
};
define_process_env_default$5.NODE_ENV !== "production" && (PickersLayout.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isLandscape: PropTypes.bool.isRequired,
  /**
   * `true` if the application is in right-to-left direction.
   */
  isRtl: PropTypes.bool.isRequired,
  isValid: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  onSelectShortcut: PropTypes.func.isRequired,
  onSetToday: PropTypes.func.isRequired,
  onViewChange: PropTypes.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  readOnly: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  value: PropTypes.any,
  view: PropTypes.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: PropTypes.oneOf(["desktop", "mobile"])
});
const _excluded$8 = ["props", "getOpenDialogAriaText"], _excluded2 = ["ownerState"], _excluded3 = ["ownerState"], useDesktopPicker = (T) => {
  let {
    props: S,
    getOpenDialogAriaText: R
  } = T, k = _objectWithoutPropertiesLoose$1(T, _excluded$8);
  const {
    slots: D,
    slotProps: L,
    className: V,
    sx: z,
    format: W,
    formatDensity: U,
    enableAccessibleFieldDOMStructure: q,
    selectedSections: K,
    onSelectedSectionsChange: Y,
    timezone: J,
    name: Z,
    label: X,
    inputRef: ee,
    readOnly: te,
    disabled: re,
    autoFocus: Q,
    localeText: ne,
    reduceAnimations: oe
  } = S, ae = useUtils(), se = React$1.useRef(null), ie = React$1.useRef(null), he = useId(), xe = L?.toolbar?.hidden ?? !1, {
    open: Pe,
    actions: Re,
    hasUIView: ke,
    layoutProps: Te,
    renderCurrentView: fe,
    shouldRestoreFocus: ue,
    fieldProps: Ce
  } = usePicker(_extends$1({}, k, {
    props: S,
    fieldRef: ie,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), ce = D.inputAdornment ?? InputAdornment, pe = useSlotProps({
    elementType: ce,
    externalSlotProps: L?.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: S
  }), _e = _objectWithoutPropertiesLoose$1(pe, _excluded2), ge = D.openPickerButton ?? IconButton, Ae = useSlotProps({
    elementType: ge,
    externalSlotProps: L?.openPickerButton,
    additionalProps: {
      disabled: re || te,
      onClick: Pe ? Re.onClose : Re.onOpen,
      "aria-label": R(Ce.value, ae),
      edge: _e.position
    },
    ownerState: S
  }), Ee = _objectWithoutPropertiesLoose$1(Ae, _excluded3), ve = D.openPickerIcon, le = D.field, me = useSlotProps({
    elementType: le,
    externalSlotProps: L?.field,
    additionalProps: _extends$1({}, Ce, xe && {
      id: he
    }, {
      readOnly: te,
      disabled: re,
      className: V,
      sx: z,
      format: W,
      formatDensity: U,
      enableAccessibleFieldDOMStructure: q,
      selectedSections: K,
      onSelectedSectionsChange: Y,
      timezone: J,
      label: X,
      name: Z,
      autoFocus: Q && !S.open,
      focused: Pe ? !0 : void 0
    }, ee ? {
      inputRef: ee
    } : {}),
    ownerState: S
  });
  ke && (me.InputProps = _extends$1({}, me.InputProps, {
    ref: se
  }, !S.disableOpenPicker && {
    [`${_e.position}Adornment`]: /* @__PURE__ */ jsxRuntimeExports.jsx(ce, _extends$1({}, _e, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ge, _extends$1({}, Ee, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ve, _extends$1({}, L?.openPickerIcon))
      }))
    }))
  }));
  const Se = _extends$1({
    textField: D.textField,
    clearIcon: D.clearIcon,
    clearButton: D.clearButton
  }, me.slots), ye = D.layout ?? PickersLayout;
  let be = he;
  xe && (X ? be = `${he}-label` : be = void 0);
  const $e = _extends$1({}, L, {
    toolbar: _extends$1({}, L?.toolbar, {
      titleId: he
    }),
    popper: _extends$1({
      "aria-labelledby": be
    }, L?.popper)
  }), Oe = useForkRef(ie, me.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ jsxRuntimeExports.jsxs(LocalizationProvider$1, {
      localeText: ne,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(le, _extends$1({}, me, {
        slots: Se,
        slotProps: $e,
        unstableFieldRef: Oe
      })), /* @__PURE__ */ jsxRuntimeExports.jsx(PickersPopper, _extends$1({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: se.current
      }, Re, {
        open: Pe,
        slots: D,
        slotProps: $e,
        shouldRestoreFocus: ue,
        reduceAnimations: oe,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ye, _extends$1({}, Te, $e?.layout, {
          slots: D,
          slotProps: $e,
          children: fe()
        }))
      }))]
    })
  };
}, renderDateViewCalendar = ({
  view: T,
  onViewChange: S,
  views: R,
  focusedView: k,
  onFocusedViewChange: D,
  value: L,
  defaultValue: V,
  referenceDate: z,
  onChange: W,
  className: U,
  classes: q,
  disableFuture: K,
  disablePast: Y,
  minDate: J,
  maxDate: Z,
  shouldDisableDate: X,
  shouldDisableMonth: ee,
  shouldDisableYear: te,
  reduceAnimations: re,
  onMonthChange: Q,
  monthsPerRow: ne,
  onYearChange: oe,
  yearsPerRow: ae,
  slots: se,
  slotProps: ie,
  loading: he,
  renderLoading: xe,
  disableHighlightToday: Pe,
  readOnly: Re,
  disabled: ke,
  showDaysOutsideCurrentMonth: Te,
  dayOfWeekFormatter: fe,
  sx: ue,
  autoFocus: Ce,
  fixedWeekNumber: ce,
  displayWeekNumber: pe,
  timezone: _e
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(DateCalendar, {
  view: T,
  onViewChange: S,
  views: R.filter(isDatePickerView),
  focusedView: k && isDatePickerView(k) ? k : null,
  onFocusedViewChange: D,
  value: L,
  defaultValue: V,
  referenceDate: z,
  onChange: W,
  className: U,
  classes: q,
  disableFuture: K,
  disablePast: Y,
  minDate: J,
  maxDate: Z,
  shouldDisableDate: X,
  shouldDisableMonth: ee,
  shouldDisableYear: te,
  reduceAnimations: re,
  onMonthChange: Q,
  monthsPerRow: ne,
  onYearChange: oe,
  yearsPerRow: ae,
  slots: se,
  slotProps: ie,
  loading: he,
  renderLoading: xe,
  disableHighlightToday: Pe,
  readOnly: Re,
  disabled: ke,
  showDaysOutsideCurrentMonth: Te,
  dayOfWeekFormatter: fe,
  sx: ue,
  autoFocus: Ce,
  fixedWeekNumber: ce,
  displayWeekNumber: pe,
  timezone: _e
}), DesktopDatePicker = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = usePickersTranslations(), D = useUtils(), L = useDatePickerDefaultizedProps(S, "MuiDesktopDatePicker"), V = _extends$1({
    day: renderDateViewCalendar,
    month: renderDateViewCalendar,
    year: renderDateViewCalendar
  }, L.viewRenderers), z = _extends$1({}, L, {
    viewRenderers: V,
    format: resolveDateFormat(D, L, !1),
    yearsPerRow: L.yearsPerRow ?? 4,
    slots: _extends$1({
      openPickerIcon: CalendarIcon,
      field: DateField$1
    }, L.slots),
    slotProps: _extends$1({}, L.slotProps, {
      field: (U) => _extends$1({}, resolveComponentProps(L.slotProps?.field, U), extractValidationProps(L), {
        ref: R
      }),
      toolbar: _extends$1({
        hidden: !0
      }, L.slotProps?.toolbar)
    })
  }), {
    renderPicker: W
  } = useDesktopPicker({
    props: z,
    valueManager: singleItemValueManager,
    valueType: "date",
    getOpenDialogAriaText: z.localeText?.openDatePickerDialogue ?? k.openDatePickerDialogue,
    validator: validateDate
  });
  return W();
});
DesktopDatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: PropTypes.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: PropTypes.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: PropTypes.shape({
    day: PropTypes.func,
    month: PropTypes.func,
    year: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
};
function getDialogContentUtilityClass(T) {
  return generateUtilityClass$1("MuiDialogContent", T);
}
generateUtilityClasses$1("MuiDialogContent", ["root", "dividers"]);
const dialogTitleClasses = generateUtilityClasses$1("MuiDialogTitle", ["root"]);
var define_process_env_default$4 = {};
const _excluded$7 = ["className", "dividers"], useUtilityClasses$4 = (T) => {
  const {
    classes: S,
    dividers: R
  } = T;
  return composeClasses({
    root: ["root", R && "dividers"]
  }, getDialogContentUtilityClass, S);
}, DialogContentRoot = styled("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.root, R.dividers && S.dividers];
  }
})(({
  theme: T,
  ownerState: S
}) => _extends$1({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px"
}, S.dividers ? {
  padding: "16px 24px",
  borderTop: `1px solid ${(T.vars || T).palette.divider}`,
  borderBottom: `1px solid ${(T.vars || T).palette.divider}`
} : {
  [`.${dialogTitleClasses.root} + &`]: {
    paddingTop: 0
  }
})), DialogContent = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiDialogContent"
  }), {
    className: D,
    dividers: L = !1
  } = k, V = _objectWithoutPropertiesLoose$1(k, _excluded$7), z = _extends$1({}, k, {
    dividers: L
  }), W = useUtilityClasses$4(z);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContentRoot, _extends$1({
    className: clsx(W.root, D),
    ownerState: z,
    ref: R
  }, V));
});
define_process_env_default$4.NODE_ENV !== "production" && (DialogContent.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getDialogUtilityClass(T) {
  return generateUtilityClass$1("MuiDialog", T);
}
const dialogClasses = generateUtilityClasses$1("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]);
var define_process_env_default$3 = {};
const DialogContext = /* @__PURE__ */ React$1.createContext({});
define_process_env_default$3.NODE_ENV !== "production" && (DialogContext.displayName = "DialogContext");
var define_process_env_default$2 = {};
const _excluded$6 = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"], DialogBackdrop = styled(Backdrop, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (T, S) => S.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), useUtilityClasses$3 = (T) => {
  const {
    classes: S,
    scroll: R,
    maxWidth: k,
    fullWidth: D,
    fullScreen: L
  } = T, V = {
    root: ["root"],
    container: ["container", `scroll${capitalize$1(R)}`],
    paper: ["paper", `paperScroll${capitalize$1(R)}`, `paperWidth${capitalize$1(String(k))}`, D && "paperFullWidth", L && "paperFullScreen"]
  };
  return composeClasses(V, getDialogUtilityClass, S);
}, DialogRoot = styled(Modal$2, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), DialogContainer = styled("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.container, S[`scroll${capitalize$1(R.scroll)}`]];
  }
})(({
  ownerState: T
}) => _extends$1({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, T.scroll === "paper" && {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, T.scroll === "body" && {
  overflowY: "auto",
  overflowX: "hidden",
  textAlign: "center",
  "&::after": {
    content: '""',
    display: "inline-block",
    verticalAlign: "middle",
    height: "100%",
    width: "0"
  }
})), DialogPaper = styled(Paper, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (T, S) => {
    const {
      ownerState: R
    } = T;
    return [S.paper, S[`scrollPaper${capitalize$1(R.scroll)}`], S[`paperWidth${capitalize$1(String(R.maxWidth))}`], R.fullWidth && S.paperFullWidth, R.fullScreen && S.paperFullScreen];
  }
})(({
  theme: T,
  ownerState: S
}) => _extends$1({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  // Fix IE11 issue, to remove at some point.
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  }
}, S.scroll === "paper" && {
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100% - 64px)"
}, S.scroll === "body" && {
  display: "inline-block",
  verticalAlign: "middle",
  textAlign: "left"
  // 'initial' doesn't work on IE11
}, !S.maxWidth && {
  maxWidth: "calc(100% - 64px)"
}, S.maxWidth === "xs" && {
  maxWidth: T.breakpoints.unit === "px" ? Math.max(T.breakpoints.values.xs, 444) : `max(${T.breakpoints.values.xs}${T.breakpoints.unit}, 444px)`,
  [`&.${dialogClasses.paperScrollBody}`]: {
    [T.breakpoints.down(Math.max(T.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, S.maxWidth && S.maxWidth !== "xs" && {
  maxWidth: `${T.breakpoints.values[S.maxWidth]}${T.breakpoints.unit}`,
  [`&.${dialogClasses.paperScrollBody}`]: {
    [T.breakpoints.down(T.breakpoints.values[S.maxWidth] + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, S.fullWidth && {
  width: "calc(100% - 64px)"
}, S.fullScreen && {
  margin: 0,
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  maxHeight: "none",
  borderRadius: 0,
  [`&.${dialogClasses.paperScrollBody}`]: {
    margin: 0,
    maxWidth: "100%"
  }
})), Dialog = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useDefaultProps({
    props: S,
    name: "MuiDialog"
  }), D = useTheme$1(), L = {
    enter: D.transitions.duration.enteringScreen,
    exit: D.transitions.duration.leavingScreen
  }, {
    "aria-describedby": V,
    "aria-labelledby": z,
    BackdropComponent: W,
    BackdropProps: U,
    children: q,
    className: K,
    disableEscapeKeyDown: Y = !1,
    fullScreen: J = !1,
    fullWidth: Z = !1,
    maxWidth: X = "sm",
    onBackdropClick: ee,
    onClick: te,
    onClose: re,
    open: Q,
    PaperComponent: ne = Paper,
    PaperProps: oe = {},
    scroll: ae = "paper",
    TransitionComponent: se = Fade,
    transitionDuration: ie = L,
    TransitionProps: he
  } = k, xe = _objectWithoutPropertiesLoose$1(k, _excluded$6), Pe = _extends$1({}, k, {
    disableEscapeKeyDown: Y,
    fullScreen: J,
    fullWidth: Z,
    maxWidth: X,
    scroll: ae
  }), Re = useUtilityClasses$3(Pe), ke = React$1.useRef(), Te = (ce) => {
    ke.current = ce.target === ce.currentTarget;
  }, fe = (ce) => {
    te && te(ce), ke.current && (ke.current = null, ee && ee(ce), re && re(ce, "backdropClick"));
  }, ue = useId(z), Ce = React$1.useMemo(() => ({
    titleId: ue
  }), [ue]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DialogRoot, _extends$1({
    className: clsx(Re.root, K),
    closeAfterTransition: !0,
    components: {
      Backdrop: DialogBackdrop
    },
    componentsProps: {
      backdrop: _extends$1({
        transitionDuration: ie,
        as: W
      }, U)
    },
    disableEscapeKeyDown: Y,
    onClose: re,
    open: Q,
    ref: R,
    onClick: fe,
    ownerState: Pe
  }, xe, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(se, _extends$1({
      appear: !0,
      in: Q,
      timeout: ie,
      role: "presentation"
    }, he, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContainer, {
        className: clsx(Re.container),
        onMouseDown: Te,
        ownerState: Pe,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogPaper, _extends$1({
          as: ne,
          elevation: 24,
          role: "dialog",
          "aria-describedby": V,
          "aria-labelledby": ue
        }, oe, {
          className: clsx(Re.paper, oe.className),
          ownerState: Pe,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(DialogContext.Provider, {
            value: Ce,
            children: q
          })
        }))
      })
    }))
  }));
});
define_process_env_default$2.NODE_ENV !== "production" && (Dialog.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": PropTypes.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": PropTypes.string,
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: PropTypes.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: PropTypes.oneOfType([PropTypes.oneOf(["xs", "sm", "md", "lg", "xl", !1]), PropTypes.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: PropTypes.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: PropTypes.oneOf(["body", "paper"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: PropTypes.object
});
const PickersModalDialogRoot = styled(Dialog)({
  [`& .${dialogClasses.container}`]: {
    outline: 0
  },
  [`& .${dialogClasses.paper}`]: {
    outline: 0,
    minWidth: DIALOG_WIDTH
  }
}), PickersModalDialogContent = styled(DialogContent)({
  "&:first-of-type": {
    padding: 0
  }
});
function PickersModalDialog(T) {
  const {
    children: S,
    onDismiss: R,
    open: k,
    slots: D,
    slotProps: L
  } = T, V = D?.dialog ?? PickersModalDialogRoot, z = D?.mobileTransition ?? Fade;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(V, _extends$1({
    open: k,
    onClose: R
  }, L?.dialog, {
    TransitionComponent: z,
    TransitionProps: L?.mobileTransition,
    PaperComponent: D?.mobilePaper,
    PaperProps: L?.mobilePaper,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersModalDialogContent, {
      children: S
    })
  }));
}
const _excluded$5 = ["props", "getOpenDialogAriaText"], useMobilePicker = (T) => {
  let {
    props: S,
    getOpenDialogAriaText: R
  } = T, k = _objectWithoutPropertiesLoose$1(T, _excluded$5);
  const {
    slots: D,
    slotProps: L,
    className: V,
    sx: z,
    format: W,
    formatDensity: U,
    enableAccessibleFieldDOMStructure: q,
    selectedSections: K,
    onSelectedSectionsChange: Y,
    timezone: J,
    name: Z,
    label: X,
    inputRef: ee,
    readOnly: te,
    disabled: re,
    localeText: Q
  } = S, ne = useUtils(), oe = React$1.useRef(null), ae = useId(), se = L?.toolbar?.hidden ?? !1, {
    open: ie,
    actions: he,
    layoutProps: xe,
    renderCurrentView: Pe,
    fieldProps: Re
  } = usePicker(_extends$1({}, k, {
    props: S,
    fieldRef: oe,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), ke = D.field, Te = useSlotProps({
    elementType: ke,
    externalSlotProps: L?.field,
    additionalProps: _extends$1({}, Re, se && {
      id: ae
    }, !(re || te) && {
      onClick: he.onOpen,
      onKeyDown: onSpaceOrEnter(he.onOpen)
    }, {
      readOnly: te ?? !0,
      disabled: re,
      className: V,
      sx: z,
      format: W,
      formatDensity: U,
      enableAccessibleFieldDOMStructure: q,
      selectedSections: K,
      onSelectedSectionsChange: Y,
      timezone: J,
      label: X,
      name: Z
    }, ee ? {
      inputRef: ee
    } : {}),
    ownerState: S
  });
  Te.inputProps = _extends$1({}, Te.inputProps, {
    "aria-label": R(Re.value, ne)
  });
  const fe = _extends$1({
    textField: D.textField
  }, Te.slots), ue = D.layout ?? PickersLayout;
  let Ce = ae;
  se && (X ? Ce = `${ae}-label` : Ce = void 0);
  const ce = _extends$1({}, L, {
    toolbar: _extends$1({}, L?.toolbar, {
      titleId: ae
    }),
    mobilePaper: _extends$1({
      "aria-labelledby": Ce
    }, L?.mobilePaper)
  }), pe = useForkRef(oe, Te.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ jsxRuntimeExports.jsxs(LocalizationProvider$1, {
      localeText: Q,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ke, _extends$1({}, Te, {
        slots: fe,
        slotProps: ce,
        unstableFieldRef: pe
      })), /* @__PURE__ */ jsxRuntimeExports.jsx(PickersModalDialog, _extends$1({}, he, {
        open: ie,
        slots: D,
        slotProps: ce,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ue, _extends$1({}, xe, ce?.layout, {
          slots: D,
          slotProps: ce,
          children: Pe()
        }))
      }))]
    })
  };
}, MobileDatePicker = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = usePickersTranslations(), D = useUtils(), L = useDatePickerDefaultizedProps(S, "MuiMobileDatePicker"), V = _extends$1({
    day: renderDateViewCalendar,
    month: renderDateViewCalendar,
    year: renderDateViewCalendar
  }, L.viewRenderers), z = _extends$1({}, L, {
    viewRenderers: V,
    format: resolveDateFormat(D, L, !1),
    slots: _extends$1({
      field: DateField$1
    }, L.slots),
    slotProps: _extends$1({}, L.slotProps, {
      field: (U) => _extends$1({}, resolveComponentProps(L.slotProps?.field, U), extractValidationProps(L), {
        ref: R
      }),
      toolbar: _extends$1({
        hidden: !1
      }, L.slotProps?.toolbar)
    })
  }), {
    renderPicker: W
  } = useMobilePicker({
    props: z,
    valueManager: singleItemValueManager,
    valueType: "date",
    getOpenDialogAriaText: z.localeText?.openDatePickerDialogue ?? k.openDatePickerDialogue,
    validator: validateDate
  });
  return W();
});
MobileDatePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: PropTypes.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: PropTypes.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: PropTypes.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: PropTypes.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: PropTypes.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: PropTypes.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable date.
   */
  maxDate: PropTypes.object,
  /**
   * Minimal selectable date.
   */
  minDate: PropTypes.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: PropTypes.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: PropTypes.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: PropTypes.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: PropTypes.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: PropTypes.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: PropTypes.shape({
    day: PropTypes.func,
    month: PropTypes.func,
    year: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: PropTypes.oneOf([3, 4])
};
function getPickersToolbarTextUtilityClass(T) {
  return generateUtilityClass$1("MuiPickersToolbarText", T);
}
const pickersToolbarTextClasses = generateUtilityClasses$1("MuiPickersToolbarText", ["root", "selected"]), _excluded$4 = ["className", "selected", "value"], useUtilityClasses$2 = (T) => {
  const {
    classes: S,
    selected: R
  } = T;
  return composeClasses({
    root: ["root", R && "selected"]
  }, getPickersToolbarTextUtilityClass, S);
}, PickersToolbarTextRoot = styled(Typography$2, {
  name: "MuiPickersToolbarText",
  slot: "Root",
  overridesResolver: (T, S) => [S.root, {
    [`&.${pickersToolbarTextClasses.selected}`]: S.selected
  }]
})(({
  theme: T
}) => ({
  transition: T.transitions.create("color"),
  color: (T.vars || T).palette.text.secondary,
  [`&.${pickersToolbarTextClasses.selected}`]: {
    color: (T.vars || T).palette.text.primary
  }
})), PickersToolbarText = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiPickersToolbarText"
  }), {
    className: D,
    value: L
  } = k, V = _objectWithoutPropertiesLoose$1(k, _excluded$4), z = useUtilityClasses$2(k);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarTextRoot, _extends$1({
    ref: R,
    className: clsx(D, z.root),
    component: "span"
  }, V, {
    children: L
  }));
}), _excluded$3 = ["align", "className", "selected", "typographyClassName", "value", "variant", "width"], useUtilityClasses$1 = (T) => {
  const {
    classes: S
  } = T;
  return composeClasses({
    root: ["root"]
  }, getPickersToolbarUtilityClass, S);
}, PickersToolbarButtonRoot = styled(Button$2, {
  name: "MuiPickersToolbarButton",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({
  padding: 0,
  minWidth: 16,
  textTransform: "none"
}), PickersToolbarButton = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = useThemeProps({
    props: S,
    name: "MuiPickersToolbarButton"
  }), {
    align: D,
    className: L,
    selected: V,
    typographyClassName: z,
    value: W,
    variant: U,
    width: q
  } = k, K = _objectWithoutPropertiesLoose$1(k, _excluded$3), Y = useUtilityClasses$1(k);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarButtonRoot, _extends$1({
    variant: "text",
    ref: R,
    className: clsx(L, Y.root)
  }, q ? {
    sx: {
      width: q
    }
  } : {}, K, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarText, {
      align: D,
      className: z,
      variant: U,
      value: W,
      selected: V
    })
  }));
});
function getTimePickerToolbarUtilityClass(T) {
  return generateUtilityClass$1("MuiTimePickerToolbar", T);
}
const timePickerToolbarClasses = generateUtilityClasses$1("MuiTimePickerToolbar", ["root", "separator", "hourMinuteLabel", "hourMinuteLabelLandscape", "hourMinuteLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]);
var define_process_env_default$1 = {};
const _excluded$2 = ["ampm", "ampmInClock", "value", "isLandscape", "onChange", "view", "onViewChange", "views", "disabled", "readOnly", "className"], useUtilityClasses = (T) => {
  const {
    isLandscape: S,
    classes: R,
    isRtl: k
  } = T;
  return composeClasses({
    root: ["root"],
    separator: ["separator"],
    hourMinuteLabel: ["hourMinuteLabel", S && "hourMinuteLabelLandscape", k && "hourMinuteLabelReverse"],
    ampmSelection: ["ampmSelection", S && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  }, getTimePickerToolbarUtilityClass, R);
}, TimePickerToolbarRoot = styled(PickersToolbar, {
  name: "MuiTimePickerToolbar",
  slot: "Root",
  overridesResolver: (T, S) => S.root
})({}), TimePickerToolbarSeparator = styled(PickersToolbarText, {
  name: "MuiTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (T, S) => S.separator
})({
  outline: 0,
  margin: "0 4px 0 2px",
  cursor: "default"
}), TimePickerToolbarHourMinuteLabel = styled("div", {
  name: "MuiTimePickerToolbar",
  slot: "HourMinuteLabel",
  overridesResolver: (T, S) => [{
    [`&.${timePickerToolbarClasses.hourMinuteLabelLandscape}`]: S.hourMinuteLabelLandscape,
    [`&.${timePickerToolbarClasses.hourMinuteLabelReverse}`]: S.hourMinuteLabelReverse
  }, S.hourMinuteLabel]
})({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      isLandscape: !0
    },
    style: {
      marginTop: "auto"
    }
  }]
}), TimePickerToolbarAmPmSelection = styled("div", {
  name: "MuiTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (T, S) => [{
    [`.${timePickerToolbarClasses.ampmLabel}`]: S.ampmLabel
  }, {
    [`&.${timePickerToolbarClasses.ampmLandscape}`]: S.ampmLandscape
  }, S.ampmSelection]
})({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12,
  [`& .${timePickerToolbarClasses.ampmLabel}`]: {
    fontSize: 17
  },
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      margin: "4px 0 auto",
      flexDirection: "row",
      justifyContent: "space-around",
      flexBasis: "100%"
    }
  }]
});
function TimePickerToolbar(T) {
  const S = useThemeProps({
    props: T,
    name: "MuiTimePickerToolbar"
  }), {
    ampm: R,
    ampmInClock: k,
    value: D,
    isLandscape: L,
    onChange: V,
    view: z,
    onViewChange: W,
    views: U,
    disabled: q,
    readOnly: K,
    className: Y
  } = S, J = _objectWithoutPropertiesLoose$1(S, _excluded$2), Z = useUtils(), X = usePickersTranslations(), ee = useRtl(), te = !!(R && !k && U.includes("hours")), {
    meridiemMode: re,
    handleMeridiemChange: Q
  } = useMeridiemMode(D, R, V), ne = (ie) => R ? Z.format(ie, "hours12h") : Z.format(ie, "hours24h"), oe = _extends$1({}, S, {
    isRtl: ee
  }), ae = useUtilityClasses(oe), se = /* @__PURE__ */ jsxRuntimeExports.jsx(TimePickerToolbarSeparator, {
    tabIndex: -1,
    value: ":",
    variant: "h3",
    selected: !1,
    className: ae.separator
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TimePickerToolbarRoot, _extends$1({
    landscapeDirection: "row",
    toolbarTitle: X.timePickerToolbarTitle,
    isLandscape: L,
    ownerState: oe,
    className: clsx(ae.root, Y)
  }, J, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(TimePickerToolbarHourMinuteLabel, {
      className: ae.hourMinuteLabel,
      ownerState: oe,
      children: [arrayIncludes(U, "hours") && /* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarButton, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => W("hours"),
        selected: z === "hours",
        value: D ? ne(D) : "--"
      }), arrayIncludes(U, ["hours", "minutes"]) && se, arrayIncludes(U, "minutes") && /* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarButton, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => W("minutes"),
        selected: z === "minutes",
        value: D ? Z.format(D, "minutes") : "--"
      }), arrayIncludes(U, ["minutes", "seconds"]) && se, arrayIncludes(U, "seconds") && /* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarButton, {
        variant: "h3",
        onClick: () => W("seconds"),
        selected: z === "seconds",
        value: D ? Z.format(D, "seconds") : "--"
      })]
    }), te && /* @__PURE__ */ jsxRuntimeExports.jsxs(TimePickerToolbarAmPmSelection, {
      className: ae.ampmSelection,
      ownerState: oe,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarButton, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: re === "am",
        typographyClassName: ae.ampmLabel,
        value: formatMeridiem(Z, "am"),
        onClick: K ? void 0 : () => Q("am"),
        disabled: q
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(PickersToolbarButton, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: re === "pm",
        typographyClassName: ae.ampmLabel,
        value: formatMeridiem(Z, "pm"),
        onClick: K ? void 0 : () => Q("pm"),
        disabled: q
      })]
    })]
  }));
}
define_process_env_default$1.NODE_ENV !== "production" && (TimePickerToolbar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  ampm: PropTypes.bool,
  ampmInClock: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: PropTypes.bool,
  isLandscape: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  titleId: PropTypes.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: PropTypes.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: PropTypes.node,
  value: PropTypes.object,
  /**
   * Currently visible picker view.
   */
  view: PropTypes.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired,
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired).isRequired
});
function useTimePickerDefaultizedProps(T, S) {
  const R = useUtils(), k = useThemeProps({
    props: T,
    name: S
  }), D = k.ampm ?? R.is12HourCycleInCurrentLocale(), L = React$1.useMemo(() => k.localeText?.toolbarTitle == null ? k.localeText : _extends$1({}, k.localeText, {
    timePickerToolbarTitle: k.localeText.toolbarTitle
  }), [k.localeText]);
  return _extends$1({}, k, {
    ampm: D,
    localeText: L
  }, applyDefaultViewProps({
    views: k.views,
    openTo: k.openTo,
    defaultViews: ["hours", "minutes"],
    defaultOpenTo: "hours"
  }), {
    disableFuture: k.disableFuture ?? !1,
    disablePast: k.disablePast ?? !1,
    slots: _extends$1({
      toolbar: TimePickerToolbar
    }, k.slots),
    slotProps: _extends$1({}, k.slotProps, {
      toolbar: _extends$1({
        ampm: D,
        ampmInClock: k.ampmInClock
      }, k.slotProps?.toolbar)
    })
  });
}
const renderTimeViewClock = ({
  view: T,
  onViewChange: S,
  focusedView: R,
  onFocusedViewChange: k,
  views: D,
  value: L,
  defaultValue: V,
  referenceDate: z,
  onChange: W,
  className: U,
  classes: q,
  disableFuture: K,
  disablePast: Y,
  minTime: J,
  maxTime: Z,
  shouldDisableTime: X,
  minutesStep: ee,
  ampm: te,
  ampmInClock: re,
  slots: Q,
  slotProps: ne,
  readOnly: oe,
  disabled: ae,
  sx: se,
  autoFocus: ie,
  showViewSwitcher: he,
  disableIgnoringDatePartForTimeValidation: xe,
  timezone: Pe
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(TimeClock, {
  view: T,
  onViewChange: S,
  focusedView: R && isTimeView(R) ? R : null,
  onFocusedViewChange: k,
  views: D.filter(isTimeView),
  value: L,
  defaultValue: V,
  referenceDate: z,
  onChange: W,
  className: U,
  classes: q,
  disableFuture: K,
  disablePast: Y,
  minTime: J,
  maxTime: Z,
  shouldDisableTime: X,
  minutesStep: ee,
  ampm: te,
  ampmInClock: re,
  slots: Q,
  slotProps: ne,
  readOnly: oe,
  disabled: ae,
  sx: se,
  autoFocus: ie,
  showViewSwitcher: he,
  disableIgnoringDatePartForTimeValidation: xe,
  timezone: Pe
}), renderDigitalClockTimeView = ({
  view: T,
  onViewChange: S,
  focusedView: R,
  onFocusedViewChange: k,
  views: D,
  value: L,
  defaultValue: V,
  referenceDate: z,
  onChange: W,
  className: U,
  classes: q,
  disableFuture: K,
  disablePast: Y,
  minTime: J,
  maxTime: Z,
  shouldDisableTime: X,
  minutesStep: ee,
  ampm: te,
  slots: re,
  slotProps: Q,
  readOnly: ne,
  disabled: oe,
  sx: ae,
  autoFocus: se,
  disableIgnoringDatePartForTimeValidation: ie,
  timeSteps: he,
  skipDisabled: xe,
  timezone: Pe
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(DigitalClock, {
  view: T,
  onViewChange: S,
  focusedView: R,
  onFocusedViewChange: k,
  views: D.filter(isTimeView),
  value: L,
  defaultValue: V,
  referenceDate: z,
  onChange: W,
  className: U,
  classes: q,
  disableFuture: K,
  disablePast: Y,
  minTime: J,
  maxTime: Z,
  shouldDisableTime: X,
  minutesStep: ee,
  ampm: te,
  slots: re,
  slotProps: Q,
  readOnly: ne,
  disabled: oe,
  sx: ae,
  autoFocus: se,
  disableIgnoringDatePartForTimeValidation: ie,
  timeStep: he?.minutes,
  skipDisabled: xe,
  timezone: Pe
}), renderMultiSectionDigitalClockTimeView = ({
  view: T,
  onViewChange: S,
  focusedView: R,
  onFocusedViewChange: k,
  views: D,
  value: L,
  defaultValue: V,
  referenceDate: z,
  onChange: W,
  className: U,
  classes: q,
  disableFuture: K,
  disablePast: Y,
  minTime: J,
  maxTime: Z,
  shouldDisableTime: X,
  minutesStep: ee,
  ampm: te,
  slots: re,
  slotProps: Q,
  readOnly: ne,
  disabled: oe,
  sx: ae,
  autoFocus: se,
  disableIgnoringDatePartForTimeValidation: ie,
  timeSteps: he,
  skipDisabled: xe,
  timezone: Pe
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(MultiSectionDigitalClock, {
  view: T,
  onViewChange: S,
  focusedView: R,
  onFocusedViewChange: k,
  views: D.filter(isTimeView),
  value: L,
  defaultValue: V,
  referenceDate: z,
  onChange: W,
  className: U,
  classes: q,
  disableFuture: K,
  disablePast: Y,
  minTime: J,
  maxTime: Z,
  shouldDisableTime: X,
  minutesStep: ee,
  ampm: te,
  slots: re,
  slotProps: Q,
  readOnly: ne,
  disabled: oe,
  sx: ae,
  autoFocus: se,
  disableIgnoringDatePartForTimeValidation: ie,
  timeSteps: he,
  skipDisabled: xe,
  timezone: Pe
}), resolveViews = (T, S, R) => R ? S.filter((k) => !isInternalTimeView(k) || k === "hours") : T ? [...S, "meridiem"] : S, resolveShouldRenderTimeInASingleColumn = (T, S) => 24 * 60 / ((T.hours ?? 1) * (T.minutes ?? 5)) <= S;
function resolveTimeViewsResponse({
  thresholdToRenderTimeInASingleColumn: T,
  ampm: S,
  timeSteps: R,
  views: k
}) {
  const D = T ?? 24, L = _extends$1({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, R), V = resolveShouldRenderTimeInASingleColumn(L, D);
  return {
    thresholdToRenderTimeInASingleColumn: D,
    timeSteps: L,
    shouldRenderTimeInASingleColumn: V,
    views: resolveViews(S, k, V)
  };
}
const DesktopTimePicker = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = usePickersTranslations(), D = useUtils(), L = useTimePickerDefaultizedProps(S, "MuiDesktopTimePicker"), {
    shouldRenderTimeInASingleColumn: V,
    views: z,
    timeSteps: W
  } = resolveTimeViewsResponse(L), U = V ? renderDigitalClockTimeView : renderMultiSectionDigitalClockTimeView, q = _extends$1({
    hours: U,
    minutes: U,
    seconds: U,
    meridiem: U
  }, L.viewRenderers), K = L.ampmInClock ?? !0, Y = V ? [] : ["accept"], Z = q.hours?.name === renderMultiSectionDigitalClockTimeView.name ? z : z.filter((te) => te !== "meridiem"), X = _extends$1({}, L, {
    ampmInClock: K,
    timeSteps: W,
    viewRenderers: q,
    format: resolveTimeFormat(D, L),
    // Setting only `hours` time view in case of single column time picker
    // Allows for easy view lifecycle management
    views: V ? ["hours"] : Z,
    slots: _extends$1({
      field: TimeField$1,
      openPickerIcon: ClockIcon
    }, L.slots),
    slotProps: _extends$1({}, L.slotProps, {
      field: (te) => _extends$1({}, resolveComponentProps(L.slotProps?.field, te), extractValidationProps(L), {
        ref: R
      }),
      toolbar: _extends$1({
        hidden: !0,
        ampmInClock: K
      }, L.slotProps?.toolbar),
      actionBar: _extends$1({
        actions: Y
      }, L.slotProps?.actionBar)
    })
  }), {
    renderPicker: ee
  } = useDesktopPicker({
    props: X,
    valueManager: singleItemValueManager,
    valueType: "time",
    getOpenDialogAriaText: X.localeText?.openTimePickerDialogue ?? k.openTimePickerDialogue,
    validator: validateTime
  });
  return ee();
});
DesktopTimePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: PropTypes.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: PropTypes.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: PropTypes.bool,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: PropTypes.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: PropTypes.any,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: PropTypes.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: PropTypes.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: PropTypes.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.object,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: PropTypes.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: PropTypes.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: PropTypes.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: PropTypes.shape({
    hours: PropTypes.number,
    minutes: PropTypes.number,
    seconds: PropTypes.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: PropTypes.shape({
    hours: PropTypes.func,
    meridiem: PropTypes.func,
    minutes: PropTypes.func,
    seconds: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const MobileTimePicker = /* @__PURE__ */ React$1.forwardRef(function T(S, R) {
  const k = usePickersTranslations(), D = useUtils(), L = useTimePickerDefaultizedProps(S, "MuiMobileTimePicker"), V = _extends$1({
    hours: renderTimeViewClock,
    minutes: renderTimeViewClock,
    seconds: renderTimeViewClock
  }, L.viewRenderers), z = L.ampmInClock ?? !1, W = _extends$1({}, L, {
    ampmInClock: z,
    viewRenderers: V,
    format: resolveTimeFormat(D, L),
    slots: _extends$1({
      field: TimeField$1
    }, L.slots),
    slotProps: _extends$1({}, L.slotProps, {
      field: (q) => _extends$1({}, resolveComponentProps(L.slotProps?.field, q), extractValidationProps(L), {
        ref: R
      }),
      toolbar: _extends$1({
        hidden: !1,
        ampmInClock: z
      }, L.slotProps?.toolbar)
    })
  }), {
    renderPicker: U
  } = useMobilePicker({
    props: W,
    valueManager: singleItemValueManager,
    valueType: "time",
    getOpenDialogAriaText: W.localeText?.openTimePickerDialogue ?? k.openTimePickerDialogue,
    validator: validateTime
  });
  return U();
});
MobileTimePicker.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default utils.is12HourCycleInCurrentLocale()
   */
  ampm: PropTypes.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: PropTypes.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: PropTypes.bool,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: PropTypes.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: PropTypes.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: PropTypes.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: PropTypes.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: PropTypes.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: PropTypes.any,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: PropTypes.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: PropTypes.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: PropTypes.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: PropTypes.object,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: PropTypes.object,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: PropTypes.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: PropTypes.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: PropTypes.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: PropTypes.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: PropTypes.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: PropTypes.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: PropTypes.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: PropTypes.oneOf(["landscape", "portrait"]),
  readOnly: PropTypes.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: PropTypes.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: PropTypes.object,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: PropTypes.oneOfType([PropTypes.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), PropTypes.number]),
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: PropTypes.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: PropTypes.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: PropTypes.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: PropTypes.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: PropTypes.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: PropTypes.shape({
    hours: PropTypes.func,
    minutes: PropTypes.func,
    seconds: PropTypes.func
  }),
  /**
   * Available views.
   */
  views: PropTypes.arrayOf(PropTypes.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
var weekOfYear = { exports: {} };
(function(T, S) {
  (function(R, k) {
    T.exports = k();
  })(commonjsGlobal, function() {
    var R = "week", k = "year";
    return function(D, L, V) {
      var z = L.prototype;
      z.week = function(W) {
        if (W === void 0 && (W = null), W !== null) return this.add(7 * (W - this.week()), "day");
        var U = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var q = V(this).startOf(k).add(1, k).date(U), K = V(this).endOf(R);
          if (q.isBefore(K)) return 1;
        }
        var Y = V(this).startOf(k).date(U).startOf(R).subtract(1, "millisecond"), J = this.diff(Y, R, !0);
        return J < 0 ? V(this).startOf("week").week() : Math.ceil(J);
      }, z.weeks = function(W) {
        return W === void 0 && (W = null), this.week(W);
      };
    };
  });
})(weekOfYear);
var weekOfYearExports = weekOfYear.exports;
const weekOfYearPlugin = /* @__PURE__ */ getDefaultExportFromCjs(weekOfYearExports);
var customParseFormat = { exports: {} };
(function(T, S) {
  (function(R, k) {
    T.exports = k();
  })(commonjsGlobal, function() {
    var R = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, k = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, D = /\d\d/, L = /\d\d?/, V = /\d*[^-_:/,()\s\d]+/, z = {}, W = function(X) {
      return (X = +X) + (X > 68 ? 1900 : 2e3);
    }, U = function(X) {
      return function(ee) {
        this[X] = +ee;
      };
    }, q = [/[+-]\d\d:?(\d\d)?|Z/, function(X) {
      (this.zone || (this.zone = {})).offset = function(ee) {
        if (!ee || ee === "Z") return 0;
        var te = ee.match(/([+-]|\d\d)/g), re = 60 * te[1] + (+te[2] || 0);
        return re === 0 ? 0 : te[0] === "+" ? -re : re;
      }(X);
    }], K = function(X) {
      var ee = z[X];
      return ee && (ee.indexOf ? ee : ee.s.concat(ee.f));
    }, Y = function(X, ee) {
      var te, re = z.meridiem;
      if (re) {
        for (var Q = 1; Q <= 24; Q += 1) if (X.indexOf(re(Q, 0, ee)) > -1) {
          te = Q > 12;
          break;
        }
      } else te = X === (ee ? "pm" : "PM");
      return te;
    }, J = { A: [V, function(X) {
      this.afternoon = Y(X, !1);
    }], a: [V, function(X) {
      this.afternoon = Y(X, !0);
    }], S: [/\d/, function(X) {
      this.milliseconds = 100 * +X;
    }], SS: [D, function(X) {
      this.milliseconds = 10 * +X;
    }], SSS: [/\d{3}/, function(X) {
      this.milliseconds = +X;
    }], s: [L, U("seconds")], ss: [L, U("seconds")], m: [L, U("minutes")], mm: [L, U("minutes")], H: [L, U("hours")], h: [L, U("hours")], HH: [L, U("hours")], hh: [L, U("hours")], D: [L, U("day")], DD: [D, U("day")], Do: [V, function(X) {
      var ee = z.ordinal, te = X.match(/\d+/);
      if (this.day = te[0], ee) for (var re = 1; re <= 31; re += 1) ee(re).replace(/\[|\]/g, "") === X && (this.day = re);
    }], M: [L, U("month")], MM: [D, U("month")], MMM: [V, function(X) {
      var ee = K("months"), te = (K("monthsShort") || ee.map(function(re) {
        return re.slice(0, 3);
      })).indexOf(X) + 1;
      if (te < 1) throw new Error();
      this.month = te % 12 || te;
    }], MMMM: [V, function(X) {
      var ee = K("months").indexOf(X) + 1;
      if (ee < 1) throw new Error();
      this.month = ee % 12 || ee;
    }], Y: [/[+-]?\d+/, U("year")], YY: [D, function(X) {
      this.year = W(X);
    }], YYYY: [/\d{4}/, U("year")], Z: q, ZZ: q };
    function Z(X) {
      var ee, te;
      ee = X, te = z && z.formats;
      for (var re = (X = ee.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(he, xe, Pe) {
        var Re = Pe && Pe.toUpperCase();
        return xe || te[Pe] || R[Pe] || te[Re].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(ke, Te, fe) {
          return Te || fe.slice(1);
        });
      })).match(k), Q = re.length, ne = 0; ne < Q; ne += 1) {
        var oe = re[ne], ae = J[oe], se = ae && ae[0], ie = ae && ae[1];
        re[ne] = ie ? { regex: se, parser: ie } : oe.replace(/^\[|\]$/g, "");
      }
      return function(he) {
        for (var xe = {}, Pe = 0, Re = 0; Pe < Q; Pe += 1) {
          var ke = re[Pe];
          if (typeof ke == "string") Re += ke.length;
          else {
            var Te = ke.regex, fe = ke.parser, ue = he.slice(Re), Ce = Te.exec(ue)[0];
            fe.call(xe, Ce), he = he.replace(Ce, "");
          }
        }
        return function(ce) {
          var pe = ce.afternoon;
          if (pe !== void 0) {
            var _e = ce.hours;
            pe ? _e < 12 && (ce.hours += 12) : _e === 12 && (ce.hours = 0), delete ce.afternoon;
          }
        }(xe), xe;
      };
    }
    return function(X, ee, te) {
      te.p.customParseFormat = !0, X && X.parseTwoDigitYear && (W = X.parseTwoDigitYear);
      var re = ee.prototype, Q = re.parse;
      re.parse = function(ne) {
        var oe = ne.date, ae = ne.utc, se = ne.args;
        this.$u = ae;
        var ie = se[1];
        if (typeof ie == "string") {
          var he = se[2] === !0, xe = se[3] === !0, Pe = he || xe, Re = se[2];
          xe && (Re = se[2]), z = this.$locale(), !he && Re && (z = te.Ls[Re]), this.$d = function(ue, Ce, ce) {
            try {
              if (["x", "X"].indexOf(Ce) > -1) return new Date((Ce === "X" ? 1e3 : 1) * ue);
              var pe = Z(Ce)(ue), _e = pe.year, ge = pe.month, Ae = pe.day, Ee = pe.hours, ve = pe.minutes, le = pe.seconds, me = pe.milliseconds, Se = pe.zone, ye = /* @__PURE__ */ new Date(), be = Ae || (_e || ge ? 1 : ye.getDate()), $e = _e || ye.getFullYear(), Oe = 0;
              _e && !ge || (Oe = ge > 0 ? ge - 1 : ye.getMonth());
              var Ie = Ee || 0, we = ve || 0, Fe = le || 0, De = me || 0;
              return Se ? new Date(Date.UTC($e, Oe, be, Ie, we, Fe, De + 60 * Se.offset * 1e3)) : ce ? new Date(Date.UTC($e, Oe, be, Ie, we, Fe, De)) : new Date($e, Oe, be, Ie, we, Fe, De);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(oe, ie, ae), this.init(), Re && Re !== !0 && (this.$L = this.locale(Re).$L), Pe && oe != this.format(ie) && (this.$d = /* @__PURE__ */ new Date("")), z = {};
        } else if (ie instanceof Array) for (var ke = ie.length, Te = 1; Te <= ke; Te += 1) {
          se[1] = ie[Te - 1];
          var fe = te.apply(this, se);
          if (fe.isValid()) {
            this.$d = fe.$d, this.$L = fe.$L, this.init();
            break;
          }
          Te === ke && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else Q.call(this, ne);
      };
    };
  });
})(customParseFormat);
var customParseFormatExports = customParseFormat.exports;
const customParseFormatPlugin = /* @__PURE__ */ getDefaultExportFromCjs(customParseFormatExports);
var localizedFormat = { exports: {} };
(function(T, S) {
  (function(R, k) {
    T.exports = k();
  })(commonjsGlobal, function() {
    var R = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(k, D, L) {
      var V = D.prototype, z = V.format;
      L.en.formats = R, V.format = function(W) {
        W === void 0 && (W = "YYYY-MM-DDTHH:mm:ssZ");
        var U = this.$locale().formats, q = function(K, Y) {
          return K.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(J, Z, X) {
            var ee = X && X.toUpperCase();
            return Z || Y[X] || R[X] || Y[ee].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(te, re, Q) {
              return re || Q.slice(1);
            });
          });
        }(W, U === void 0 ? {} : U);
        return z.call(this, q);
      };
    };
  });
})(localizedFormat);
var localizedFormatExports = localizedFormat.exports;
const localizedFormatPlugin = /* @__PURE__ */ getDefaultExportFromCjs(localizedFormatExports);
var isBetween = { exports: {} };
(function(T, S) {
  (function(R, k) {
    T.exports = k();
  })(commonjsGlobal, function() {
    return function(R, k, D) {
      k.prototype.isBetween = function(L, V, z, W) {
        var U = D(L), q = D(V), K = (W = W || "()")[0] === "(", Y = W[1] === ")";
        return (K ? this.isAfter(U, z) : !this.isBefore(U, z)) && (Y ? this.isBefore(q, z) : !this.isAfter(q, z)) || (K ? this.isBefore(U, z) : !this.isAfter(U, z)) && (Y ? this.isAfter(q, z) : !this.isBefore(q, z));
      };
    };
  });
})(isBetween);
var isBetweenExports = isBetween.exports;
const isBetweenPlugin = /* @__PURE__ */ getDefaultExportFromCjs(isBetweenExports);
var advancedFormat = { exports: {} };
(function(T, S) {
  (function(R, k) {
    T.exports = k();
  })(commonjsGlobal, function() {
    return function(R, k) {
      var D = k.prototype, L = D.format;
      D.format = function(V) {
        var z = this, W = this.$locale();
        if (!this.isValid()) return L.bind(this)(V);
        var U = this.$utils(), q = (V || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(K) {
          switch (K) {
            case "Q":
              return Math.ceil((z.$M + 1) / 3);
            case "Do":
              return W.ordinal(z.$D);
            case "gggg":
              return z.weekYear();
            case "GGGG":
              return z.isoWeekYear();
            case "wo":
              return W.ordinal(z.week(), "W");
            case "w":
            case "ww":
              return U.s(z.week(), K === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return U.s(z.isoWeek(), K === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return U.s(String(z.$H === 0 ? 24 : z.$H), K === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(z.$d.getTime() / 1e3);
            case "x":
              return z.$d.getTime();
            case "z":
              return "[" + z.offsetName() + "]";
            case "zzz":
              return "[" + z.offsetName("long") + "]";
            default:
              return K;
          }
        });
        return L.bind(this)(q);
      };
    };
  });
})(advancedFormat);
var advancedFormatExports = advancedFormat.exports;
const advancedFormatPlugin = /* @__PURE__ */ getDefaultExportFromCjs(advancedFormatExports);
defaultDayjs.extend(localizedFormatPlugin);
defaultDayjs.extend(weekOfYearPlugin);
defaultDayjs.extend(isBetweenPlugin);
defaultDayjs.extend(advancedFormatPlugin);
const localeNotFoundWarning = buildWarning(["Your locale has not been found.", "Either the locale key is not a supported one. Locales supported by dayjs are available here: https://github.com/iamkun/dayjs/tree/dev/src/locale", "Or you forget to import the locale from 'dayjs/locale/{localeUsed}'", "fallback on English locale"]), formatTokenMap = {
  // Year
  YY: "year",
  YYYY: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  D: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  DD: "day",
  Do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  d: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 2
  },
  dd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ddd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  dddd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  A: "meridiem",
  a: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, defaultFormats = {
  year: "YYYY",
  month: "MMMM",
  monthShort: "MMM",
  dayOfMonth: "D",
  dayOfMonthFull: "Do",
  weekday: "dddd",
  weekdayShort: "dd",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "A",
  minutes: "mm",
  seconds: "ss",
  fullDate: "ll",
  keyboardDate: "L",
  shortDate: "MMM D",
  normalDate: "D MMMM",
  normalDateWithWeekday: "ddd, MMM D",
  fullTime: "LT",
  fullTime12h: "hh:mm A",
  fullTime24h: "HH:mm",
  keyboardDateTime: "L LT",
  keyboardDateTime12h: "L hh:mm A",
  keyboardDateTime24h: "L HH:mm"
}, MISSING_UTC_PLUGIN = ["Missing UTC plugin", "To be able to use UTC or timezones, you have to enable the `utc` plugin", "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc"].join(`
`), MISSING_TIMEZONE_PLUGIN = ["Missing timezone plugin", "To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin", "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone"].join(`
`), withLocale = (T, S) => S ? (...R) => T(...R).locale(S) : T;
class AdapterDayjs {
  constructor({
    locale: S,
    formats: R
  } = {}) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !0, this.lib = "dayjs", this.dayjs = void 0, this.locale = void 0, this.formats = void 0, this.escapedCharacters = {
      start: "[",
      end: "]"
    }, this.formatTokenMap = formatTokenMap, this.setLocaleToValue = (k) => {
      const D = this.getCurrentLocaleCode();
      return D === k.locale() ? k : k.locale(D);
    }, this.hasUTCPlugin = () => typeof defaultDayjs.utc < "u", this.hasTimezonePlugin = () => typeof defaultDayjs.tz < "u", this.isSame = (k, D, L) => {
      const V = this.setTimezone(D, this.getTimezone(k));
      return k.format(L) === V.format(L);
    }, this.cleanTimezone = (k) => {
      switch (k) {
        case "default":
          return;
        case "system":
          return defaultDayjs.tz.guess();
        default:
          return k;
      }
    }, this.createSystemDate = (k) => {
      if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
        const D = defaultDayjs.tz.guess();
        return D !== "UTC" ? defaultDayjs.tz(k, D) : defaultDayjs(k);
      }
      return defaultDayjs(k);
    }, this.createUTCDate = (k) => {
      if (!this.hasUTCPlugin())
        throw new Error(MISSING_UTC_PLUGIN);
      return defaultDayjs.utc(k);
    }, this.createTZDate = (k, D) => {
      if (!this.hasUTCPlugin())
        throw new Error(MISSING_UTC_PLUGIN);
      if (!this.hasTimezonePlugin())
        throw new Error(MISSING_TIMEZONE_PLUGIN);
      const L = k !== void 0 && !k.endsWith("Z");
      return defaultDayjs(k).tz(this.cleanTimezone(D), L);
    }, this.getLocaleFormats = () => {
      const k = defaultDayjs.Ls, D = this.locale || "en";
      let L = k[D];
      return L === void 0 && (localeNotFoundWarning(), L = k.en), L.formats;
    }, this.adjustOffset = (k) => {
      if (!this.hasTimezonePlugin())
        return k;
      const D = this.getTimezone(k);
      if (D !== "UTC") {
        const L = k.tz(this.cleanTimezone(D), !0);
        if ((L.$offset ?? 0) === (k.$offset ?? 0))
          return k;
        k.$offset = L.$offset;
      }
      return k;
    }, this.date = (k, D = "default") => {
      if (k === null)
        return null;
      let L;
      return D === "UTC" ? L = this.createUTCDate(k) : D === "system" || D === "default" && !this.hasTimezonePlugin() ? L = this.createSystemDate(k) : L = this.createTZDate(k, D), this.locale === void 0 ? L : L.locale(this.locale);
    }, this.getInvalidDate = () => defaultDayjs(/* @__PURE__ */ new Date("Invalid date")), this.getTimezone = (k) => {
      if (this.hasTimezonePlugin()) {
        const D = k.$x?.$timezone;
        if (D)
          return D;
      }
      return this.hasUTCPlugin() && k.isUTC() ? "UTC" : "system";
    }, this.setTimezone = (k, D) => {
      if (this.getTimezone(k) === D)
        return k;
      if (D === "UTC") {
        if (!this.hasUTCPlugin())
          throw new Error(MISSING_UTC_PLUGIN);
        return k.utc();
      }
      if (D === "system")
        return k.local();
      if (!this.hasTimezonePlugin()) {
        if (D === "default")
          return k;
        throw new Error(MISSING_TIMEZONE_PLUGIN);
      }
      return defaultDayjs.tz(k, this.cleanTimezone(D));
    }, this.toJsDate = (k) => k.toDate(), this.parse = (k, D) => k === "" ? null : this.dayjs(k, D, this.locale, !0), this.getCurrentLocaleCode = () => this.locale || "en", this.is12HourCycleInCurrentLocale = () => /A|a/.test(this.getLocaleFormats().LT || ""), this.expandFormat = (k) => {
      const D = this.getLocaleFormats(), L = (V) => V.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (z, W, U) => W || U.slice(1));
      return k.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (V, z, W) => {
        const U = W && W.toUpperCase();
        return z || D[W] || L(D[U]);
      });
    }, this.isValid = (k) => k == null ? !1 : k.isValid(), this.format = (k, D) => this.formatByString(k, this.formats[D]), this.formatByString = (k, D) => this.dayjs(k).format(D), this.formatNumber = (k) => k, this.isEqual = (k, D) => k === null && D === null ? !0 : k === null || D === null ? !1 : k.toDate().getTime() === D.toDate().getTime(), this.isSameYear = (k, D) => this.isSame(k, D, "YYYY"), this.isSameMonth = (k, D) => this.isSame(k, D, "YYYY-MM"), this.isSameDay = (k, D) => this.isSame(k, D, "YYYY-MM-DD"), this.isSameHour = (k, D) => k.isSame(D, "hour"), this.isAfter = (k, D) => k > D, this.isAfterYear = (k, D) => this.hasUTCPlugin() ? !this.isSameYear(k, D) && k.utc() > D.utc() : k.isAfter(D, "year"), this.isAfterDay = (k, D) => this.hasUTCPlugin() ? !this.isSameDay(k, D) && k.utc() > D.utc() : k.isAfter(D, "day"), this.isBefore = (k, D) => k < D, this.isBeforeYear = (k, D) => this.hasUTCPlugin() ? !this.isSameYear(k, D) && k.utc() < D.utc() : k.isBefore(D, "year"), this.isBeforeDay = (k, D) => this.hasUTCPlugin() ? !this.isSameDay(k, D) && k.utc() < D.utc() : k.isBefore(D, "day"), this.isWithinRange = (k, [D, L]) => k >= D && k <= L, this.startOfYear = (k) => this.adjustOffset(k.startOf("year")), this.startOfMonth = (k) => this.adjustOffset(k.startOf("month")), this.startOfWeek = (k) => this.adjustOffset(k.startOf("week")), this.startOfDay = (k) => this.adjustOffset(k.startOf("day")), this.endOfYear = (k) => this.adjustOffset(k.endOf("year")), this.endOfMonth = (k) => this.adjustOffset(k.endOf("month")), this.endOfWeek = (k) => this.adjustOffset(k.endOf("week")), this.endOfDay = (k) => this.adjustOffset(k.endOf("day")), this.addYears = (k, D) => this.adjustOffset(D < 0 ? k.subtract(Math.abs(D), "year") : k.add(D, "year")), this.addMonths = (k, D) => this.adjustOffset(D < 0 ? k.subtract(Math.abs(D), "month") : k.add(D, "month")), this.addWeeks = (k, D) => this.adjustOffset(D < 0 ? k.subtract(Math.abs(D), "week") : k.add(D, "week")), this.addDays = (k, D) => this.adjustOffset(D < 0 ? k.subtract(Math.abs(D), "day") : k.add(D, "day")), this.addHours = (k, D) => this.adjustOffset(D < 0 ? k.subtract(Math.abs(D), "hour") : k.add(D, "hour")), this.addMinutes = (k, D) => this.adjustOffset(D < 0 ? k.subtract(Math.abs(D), "minute") : k.add(D, "minute")), this.addSeconds = (k, D) => this.adjustOffset(D < 0 ? k.subtract(Math.abs(D), "second") : k.add(D, "second")), this.getYear = (k) => k.year(), this.getMonth = (k) => k.month(), this.getDate = (k) => k.date(), this.getHours = (k) => k.hour(), this.getMinutes = (k) => k.minute(), this.getSeconds = (k) => k.second(), this.getMilliseconds = (k) => k.millisecond(), this.setYear = (k, D) => this.adjustOffset(k.set("year", D)), this.setMonth = (k, D) => this.adjustOffset(k.set("month", D)), this.setDate = (k, D) => this.adjustOffset(k.set("date", D)), this.setHours = (k, D) => this.adjustOffset(k.set("hour", D)), this.setMinutes = (k, D) => this.adjustOffset(k.set("minute", D)), this.setSeconds = (k, D) => this.adjustOffset(k.set("second", D)), this.setMilliseconds = (k, D) => this.adjustOffset(k.set("millisecond", D)), this.getDaysInMonth = (k) => k.daysInMonth(), this.getWeekArray = (k) => {
      const D = this.setLocaleToValue(k), L = this.startOfWeek(this.startOfMonth(D)), V = this.endOfWeek(this.endOfMonth(D));
      let z = 0, W = L;
      const U = [];
      for (; W < V; ) {
        const q = Math.floor(z / 7);
        U[q] = U[q] || [], U[q].push(W), W = this.addDays(W, 1), z += 1;
      }
      return U;
    }, this.getWeekNumber = (k) => k.week(), this.getYearRange = ([k, D]) => {
      const L = this.startOfYear(k), V = this.endOfYear(D), z = [];
      let W = L;
      for (; this.isBefore(W, V); )
        z.push(W), W = this.addYears(W, 1);
      return z;
    }, this.dayjs = withLocale(defaultDayjs, S), this.locale = S, this.formats = _extends$1({}, defaultFormats, R), defaultDayjs.extend(customParseFormatPlugin);
  }
  getDayOfWeek(S) {
    return S.day() + 1;
  }
}
function _getPrototypeOf(T) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(S) {
    return S.__proto__ || Object.getPrototypeOf(S);
  }, _getPrototypeOf(T);
}
function _isNativeFunction(T) {
  try {
    return Function.toString.call(T).indexOf("[native code]") !== -1;
  } catch {
    return typeof T == "function";
  }
}
function _isNativeReflectConstruct() {
  try {
    var T = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = function() {
    return !!T;
  })();
}
function _construct(T, S, R) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var k = [null];
  k.push.apply(k, S);
  var D = new (T.bind.apply(T, k))();
  return R && _setPrototypeOf(D, R.prototype), D;
}
function _wrapNativeSuper(T) {
  var S = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function(k) {
    if (k === null || !_isNativeFunction(k)) return k;
    if (typeof k != "function") throw new TypeError("Super expression must either be null or a function");
    if (S !== void 0) {
      if (S.has(k)) return S.get(k);
      S.set(k, D);
    }
    function D() {
      return _construct(k, arguments, _getPrototypeOf(this).constructor);
    }
    return D.prototype = Object.create(k.prototype, {
      constructor: {
        value: D,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf(D, k);
  }, _wrapNativeSuper(T);
}
var define_process_env_default = {}, ERRORS = {
  1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
  2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
  3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
  4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
  5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
  6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
  7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
  8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
  9: `Please provide a number of steps to the modularScale helper.

`,
  10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
  12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
  13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
  14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
  16: `You must provide a template to this method.

`,
  17: `You passed an unsupported selector state to this method.

`,
  18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  23: `fontFace expects a name of a font-family.

`,
  24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  25: `fontFace expects localFonts to be an array.

`,
  26: `fontFace expects fileFormats to be an array.

`,
  27: `radialGradient requries at least 2 color-stops to properly render.

`,
  28: `Please supply a filename to retinaImage() as the first argument.

`,
  29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
  32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
  33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
  34: `borderRadius expects a radius value as a string or number as the second argument.

`,
  35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  36: `Property must be a string value.

`,
  37: `Syntax Error at %s.

`,
  38: `Formula contains a function that needs parentheses at %s.

`,
  39: `Formula is missing closing parenthesis at %s.

`,
  40: `Formula has too many closing parentheses at %s.

`,
  41: `All values in a formula must have the same unit or be unitless.

`,
  42: `Please provide a number of steps to the modularScale helper.

`,
  43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
  44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
  45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
  46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
  47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
  48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
  49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
  50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
  51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
  52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
  53: `fontFace expects localFonts to be an array.

`,
  54: `fontFace expects fileFormats to be an array.

`,
  55: `fontFace expects a name of a font-family.

`,
  56: `linearGradient requries at least 2 color-stops to properly render.

`,
  57: `radialGradient requries at least 2 color-stops to properly render.

`,
  58: `Please supply a filename to retinaImage() as the first argument.

`,
  59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
  60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  61: `Property must be a string value.

`,
  62: `borderRadius expects a radius value as a string or number as the second argument.

`,
  63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
  64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
  65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
  66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
  67: `You must provide a template to this method.

`,
  68: `You passed an unsupported selector state to this method.

`,
  69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
  70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
  71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
  72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
  73: `Please provide a valid CSS variable.

`,
  74: `CSS variable not found and no default was provided.

`,
  75: `important requires a valid style object, got a %s instead.

`,
  76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
  77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
  78: `base must be set in "px" or "%" but you set it in "%s".
`
};
function format() {
  for (var T = arguments.length, S = new Array(T), R = 0; R < T; R++)
    S[R] = arguments[R];
  var k = S[0], D = [], L;
  for (L = 1; L < S.length; L += 1)
    D.push(S[L]);
  return D.forEach(function(V) {
    k = k.replace(/%[a-z]/, V);
  }), k;
}
var PolishedError = /* @__PURE__ */ function(T) {
  _inheritsLoose(S, T);
  function S(R) {
    var k;
    if (define_process_env_default.NODE_ENV === "production")
      k = T.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + R + " for more information.") || this;
    else {
      for (var D = arguments.length, L = new Array(D > 1 ? D - 1 : 0), V = 1; V < D; V++)
        L[V - 1] = arguments[V];
      k = T.call(this, format.apply(void 0, [ERRORS[R]].concat(L))) || this;
    }
    return _assertThisInitialized(k);
  }
  return S;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function colorToInt(T) {
  return Math.round(T * 255);
}
function convertToInt(T, S, R) {
  return colorToInt(T) + "," + colorToInt(S) + "," + colorToInt(R);
}
function hslToRgb(T, S, R, k) {
  if (k === void 0 && (k = convertToInt), S === 0)
    return k(R, R, R);
  var D = (T % 360 + 360) % 360 / 60, L = (1 - Math.abs(2 * R - 1)) * S, V = L * (1 - Math.abs(D % 2 - 1)), z = 0, W = 0, U = 0;
  D >= 0 && D < 1 ? (z = L, W = V) : D >= 1 && D < 2 ? (z = V, W = L) : D >= 2 && D < 3 ? (W = L, U = V) : D >= 3 && D < 4 ? (W = V, U = L) : D >= 4 && D < 5 ? (z = V, U = L) : D >= 5 && D < 6 && (z = L, U = V);
  var q = R - L / 2, K = z + q, Y = W + q, J = U + q;
  return k(K, Y, J);
}
var namedColorMap = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function nameToHex(T) {
  if (typeof T != "string") return T;
  var S = T.toLowerCase();
  return namedColorMap[S] ? "#" + namedColorMap[S] : T;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/, hexRgbaRegex = /^#[a-fA-F0-9]{8}$/, reducedHexRegex = /^#[a-fA-F0-9]{3}$/, reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/, rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function parseToRgb(T) {
  if (typeof T != "string")
    throw new PolishedError(3);
  var S = nameToHex(T);
  if (S.match(hexRegex))
    return {
      red: parseInt("" + S[1] + S[2], 16),
      green: parseInt("" + S[3] + S[4], 16),
      blue: parseInt("" + S[5] + S[6], 16)
    };
  if (S.match(hexRgbaRegex)) {
    var R = parseFloat((parseInt("" + S[7] + S[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + S[1] + S[2], 16),
      green: parseInt("" + S[3] + S[4], 16),
      blue: parseInt("" + S[5] + S[6], 16),
      alpha: R
    };
  }
  if (S.match(reducedHexRegex))
    return {
      red: parseInt("" + S[1] + S[1], 16),
      green: parseInt("" + S[2] + S[2], 16),
      blue: parseInt("" + S[3] + S[3], 16)
    };
  if (S.match(reducedRgbaHexRegex)) {
    var k = parseFloat((parseInt("" + S[4] + S[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + S[1] + S[1], 16),
      green: parseInt("" + S[2] + S[2], 16),
      blue: parseInt("" + S[3] + S[3], 16),
      alpha: k
    };
  }
  var D = rgbRegex.exec(S);
  if (D)
    return {
      red: parseInt("" + D[1], 10),
      green: parseInt("" + D[2], 10),
      blue: parseInt("" + D[3], 10)
    };
  var L = rgbaRegex.exec(S.substring(0, 50));
  if (L)
    return {
      red: parseInt("" + L[1], 10),
      green: parseInt("" + L[2], 10),
      blue: parseInt("" + L[3], 10),
      alpha: parseFloat("" + L[4]) > 1 ? parseFloat("" + L[4]) / 100 : parseFloat("" + L[4])
    };
  var V = hslRegex.exec(S);
  if (V) {
    var z = parseInt("" + V[1], 10), W = parseInt("" + V[2], 10) / 100, U = parseInt("" + V[3], 10) / 100, q = "rgb(" + hslToRgb(z, W, U) + ")", K = rgbRegex.exec(q);
    if (!K)
      throw new PolishedError(4, S, q);
    return {
      red: parseInt("" + K[1], 10),
      green: parseInt("" + K[2], 10),
      blue: parseInt("" + K[3], 10)
    };
  }
  var Y = hslaRegex.exec(S.substring(0, 50));
  if (Y) {
    var J = parseInt("" + Y[1], 10), Z = parseInt("" + Y[2], 10) / 100, X = parseInt("" + Y[3], 10) / 100, ee = "rgb(" + hslToRgb(J, Z, X) + ")", te = rgbRegex.exec(ee);
    if (!te)
      throw new PolishedError(4, S, ee);
    return {
      red: parseInt("" + te[1], 10),
      green: parseInt("" + te[2], 10),
      blue: parseInt("" + te[3], 10),
      alpha: parseFloat("" + Y[4]) > 1 ? parseFloat("" + Y[4]) / 100 : parseFloat("" + Y[4])
    };
  }
  throw new PolishedError(5);
}
function rgbToHsl(T) {
  var S = T.red / 255, R = T.green / 255, k = T.blue / 255, D = Math.max(S, R, k), L = Math.min(S, R, k), V = (D + L) / 2;
  if (D === L)
    return T.alpha !== void 0 ? {
      hue: 0,
      saturation: 0,
      lightness: V,
      alpha: T.alpha
    } : {
      hue: 0,
      saturation: 0,
      lightness: V
    };
  var z, W = D - L, U = V > 0.5 ? W / (2 - D - L) : W / (D + L);
  switch (D) {
    case S:
      z = (R - k) / W + (R < k ? 6 : 0);
      break;
    case R:
      z = (k - S) / W + 2;
      break;
    default:
      z = (S - R) / W + 4;
      break;
  }
  return z *= 60, T.alpha !== void 0 ? {
    hue: z,
    saturation: U,
    lightness: V,
    alpha: T.alpha
  } : {
    hue: z,
    saturation: U,
    lightness: V
  };
}
function parseToHsl(T) {
  return rgbToHsl(parseToRgb(T));
}
var reduceHexValue = function T(S) {
  return S.length === 7 && S[1] === S[2] && S[3] === S[4] && S[5] === S[6] ? "#" + S[1] + S[3] + S[5] : S;
}, reduceHexValue$1 = reduceHexValue;
function numberToHex(T) {
  var S = T.toString(16);
  return S.length === 1 ? "0" + S : S;
}
function colorToHex(T) {
  return numberToHex(Math.round(T * 255));
}
function convertToHex(T, S, R) {
  return reduceHexValue$1("#" + colorToHex(T) + colorToHex(S) + colorToHex(R));
}
function hslToHex(T, S, R) {
  return hslToRgb(T, S, R, convertToHex);
}
function hsl(T, S, R) {
  if (typeof T == "number" && typeof S == "number" && typeof R == "number")
    return hslToHex(T, S, R);
  if (typeof T == "object" && S === void 0 && R === void 0)
    return hslToHex(T.hue, T.saturation, T.lightness);
  throw new PolishedError(1);
}
function hsla(T, S, R, k) {
  if (typeof T == "number" && typeof S == "number" && typeof R == "number" && typeof k == "number")
    return k >= 1 ? hslToHex(T, S, R) : "rgba(" + hslToRgb(T, S, R) + "," + k + ")";
  if (typeof T == "object" && S === void 0 && R === void 0 && k === void 0)
    return T.alpha >= 1 ? hslToHex(T.hue, T.saturation, T.lightness) : "rgba(" + hslToRgb(T.hue, T.saturation, T.lightness) + "," + T.alpha + ")";
  throw new PolishedError(2);
}
function rgb$1(T, S, R) {
  if (typeof T == "number" && typeof S == "number" && typeof R == "number")
    return reduceHexValue$1("#" + numberToHex(T) + numberToHex(S) + numberToHex(R));
  if (typeof T == "object" && S === void 0 && R === void 0)
    return reduceHexValue$1("#" + numberToHex(T.red) + numberToHex(T.green) + numberToHex(T.blue));
  throw new PolishedError(6);
}
function rgba$1(T, S, R, k) {
  if (typeof T == "string" && typeof S == "number") {
    var D = parseToRgb(T);
    return "rgba(" + D.red + "," + D.green + "," + D.blue + "," + S + ")";
  } else {
    if (typeof T == "number" && typeof S == "number" && typeof R == "number" && typeof k == "number")
      return k >= 1 ? rgb$1(T, S, R) : "rgba(" + T + "," + S + "," + R + "," + k + ")";
    if (typeof T == "object" && S === void 0 && R === void 0 && k === void 0)
      return T.alpha >= 1 ? rgb$1(T.red, T.green, T.blue) : "rgba(" + T.red + "," + T.green + "," + T.blue + "," + T.alpha + ")";
  }
  throw new PolishedError(7);
}
var isRgb = function T(S) {
  return typeof S.red == "number" && typeof S.green == "number" && typeof S.blue == "number" && (typeof S.alpha != "number" || typeof S.alpha > "u");
}, isRgba = function T(S) {
  return typeof S.red == "number" && typeof S.green == "number" && typeof S.blue == "number" && typeof S.alpha == "number";
}, isHsl = function T(S) {
  return typeof S.hue == "number" && typeof S.saturation == "number" && typeof S.lightness == "number" && (typeof S.alpha != "number" || typeof S.alpha > "u");
}, isHsla = function T(S) {
  return typeof S.hue == "number" && typeof S.saturation == "number" && typeof S.lightness == "number" && typeof S.alpha == "number";
};
function toColorString(T) {
  if (typeof T != "object") throw new PolishedError(8);
  if (isRgba(T)) return rgba$1(T);
  if (isRgb(T)) return rgb$1(T);
  if (isHsla(T)) return hsla(T);
  if (isHsl(T)) return hsl(T);
  throw new PolishedError(8);
}
function curried(T, S, R) {
  return function() {
    var D = R.concat(Array.prototype.slice.call(arguments));
    return D.length >= S ? T.apply(this, D) : curried(T, S, D);
  };
}
function curry(T) {
  return curried(T, T.length, []);
}
function adjustHue(T, S) {
  if (S === "transparent") return S;
  var R = parseToHsl(S);
  return toColorString(_extends$1({}, R, {
    hue: R.hue + parseFloat(T)
  }));
}
curry(adjustHue);
function guard(T, S, R) {
  return Math.max(T, Math.min(S, R));
}
function darken(T, S) {
  if (S === "transparent") return S;
  var R = parseToHsl(S);
  return toColorString(_extends$1({}, R, {
    lightness: guard(0, 1, R.lightness - parseFloat(T))
  }));
}
var curriedDarken = curry(darken), curriedDarken$1 = curriedDarken;
function desaturate(T, S) {
  if (S === "transparent") return S;
  var R = parseToHsl(S);
  return toColorString(_extends$1({}, R, {
    saturation: guard(0, 1, R.saturation - parseFloat(T))
  }));
}
curry(desaturate);
function lighten(T, S) {
  if (S === "transparent") return S;
  var R = parseToHsl(S);
  return toColorString(_extends$1({}, R, {
    lightness: guard(0, 1, R.lightness + parseFloat(T))
  }));
}
var curriedLighten = curry(lighten), curriedLighten$1 = curriedLighten;
function mix(T, S, R) {
  if (S === "transparent") return R;
  if (R === "transparent") return S;
  if (T === 0) return R;
  var k = parseToRgb(S), D = _extends$1({}, k, {
    alpha: typeof k.alpha == "number" ? k.alpha : 1
  }), L = parseToRgb(R), V = _extends$1({}, L, {
    alpha: typeof L.alpha == "number" ? L.alpha : 1
  }), z = D.alpha - V.alpha, W = parseFloat(T) * 2 - 1, U = W * z === -1 ? W : W + z, q = 1 + W * z, K = (U / q + 1) / 2, Y = 1 - K, J = {
    red: Math.floor(D.red * K + V.red * Y),
    green: Math.floor(D.green * K + V.green * Y),
    blue: Math.floor(D.blue * K + V.blue * Y),
    alpha: D.alpha * parseFloat(T) + V.alpha * (1 - parseFloat(T))
  };
  return rgba$1(J);
}
var curriedMix = curry(mix), mix$1 = curriedMix;
function opacify(T, S) {
  if (S === "transparent") return S;
  var R = parseToRgb(S), k = typeof R.alpha == "number" ? R.alpha : 1, D = _extends$1({}, R, {
    alpha: guard(0, 1, (k * 100 + parseFloat(T) * 100) / 100)
  });
  return rgba$1(D);
}
var curriedOpacify = curry(opacify), curriedOpacify$1 = curriedOpacify;
function saturate(T, S) {
  if (S === "transparent") return S;
  var R = parseToHsl(S);
  return toColorString(_extends$1({}, R, {
    saturation: guard(0, 1, R.saturation + parseFloat(T))
  }));
}
curry(saturate);
function setHue(T, S) {
  return S === "transparent" ? S : toColorString(_extends$1({}, parseToHsl(S), {
    hue: parseFloat(T)
  }));
}
curry(setHue);
function setLightness(T, S) {
  return S === "transparent" ? S : toColorString(_extends$1({}, parseToHsl(S), {
    lightness: parseFloat(T)
  }));
}
curry(setLightness);
function setSaturation(T, S) {
  return S === "transparent" ? S : toColorString(_extends$1({}, parseToHsl(S), {
    saturation: parseFloat(T)
  }));
}
curry(setSaturation);
function shade(T, S) {
  return S === "transparent" ? S : mix$1(parseFloat(T), "rgb(0, 0, 0)", S);
}
curry(shade);
function tint(T, S) {
  return S === "transparent" ? S : mix$1(parseFloat(T), "rgb(255, 255, 255)", S);
}
curry(tint);
function transparentize(T, S) {
  if (S === "transparent") return S;
  var R = parseToRgb(S), k = typeof R.alpha == "number" ? R.alpha : 1, D = _extends$1({}, R, {
    alpha: guard(0, 1, +(k * 100 - parseFloat(T) * 100).toFixed(2) / 100)
  });
  return rgba$1(D);
}
var curriedTransparentize = curry(transparentize), curriedTransparentize$1 = curriedTransparentize;
["allowFullScreen", "allowTransparency", "autoComplete", "autoFocus", "autoPlay", "cellPadding", "cellSpacing", "charSet", "className", "classId", "colSpan", "contentEditable", "contextMenu", "crossOrigin", "encType", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "frameBorder", "hrefLang", "inputMode", "keyParams", "keyType", "marginHeight", "marginWidth", "maxLength", "mediaGroup", "minLength", "noValidate", "radioGroup", "readOnly", "rowSpan", "spellCheck", "srcDoc", "srcLang", "srcSet", "tabIndex", "useMap"].reduce((T, S) => (T[S.toLowerCase()] = S, T), { for: "htmlFor" });
var Ht;
(function(T) {
  T[T.MAX = 0] = "MAX", T[T.HIGH = 1] = "HIGH", T[T.MED = 2] = "MED", T[T.LOW = 3] = "LOW", T[T.MIN = 4] = "MIN";
})(Ht || (Ht = {}));
function noop$1() {
}
var noop_1 = noop$1, Set$1 = _Set, noop = noop_1, setToArray = _setToArray, INFINITY = 1 / 0;
Set$1 && 1 / setToArray(new Set$1([, -0]))[1] == INFINITY;
var doctrine = {}, utils = {}, ast = { exports: {} };
(function() {
  function T(V) {
    if (V == null)
      return !1;
    switch (V.type) {
      case "ArrayExpression":
      case "AssignmentExpression":
      case "BinaryExpression":
      case "CallExpression":
      case "ConditionalExpression":
      case "FunctionExpression":
      case "Identifier":
      case "Literal":
      case "LogicalExpression":
      case "MemberExpression":
      case "NewExpression":
      case "ObjectExpression":
      case "SequenceExpression":
      case "ThisExpression":
      case "UnaryExpression":
      case "UpdateExpression":
        return !0;
    }
    return !1;
  }
  function S(V) {
    if (V == null)
      return !1;
    switch (V.type) {
      case "DoWhileStatement":
      case "ForInStatement":
      case "ForStatement":
      case "WhileStatement":
        return !0;
    }
    return !1;
  }
  function R(V) {
    if (V == null)
      return !1;
    switch (V.type) {
      case "BlockStatement":
      case "BreakStatement":
      case "ContinueStatement":
      case "DebuggerStatement":
      case "DoWhileStatement":
      case "EmptyStatement":
      case "ExpressionStatement":
      case "ForInStatement":
      case "ForStatement":
      case "IfStatement":
      case "LabeledStatement":
      case "ReturnStatement":
      case "SwitchStatement":
      case "ThrowStatement":
      case "TryStatement":
      case "VariableDeclaration":
      case "WhileStatement":
      case "WithStatement":
        return !0;
    }
    return !1;
  }
  function k(V) {
    return R(V) || V != null && V.type === "FunctionDeclaration";
  }
  function D(V) {
    switch (V.type) {
      case "IfStatement":
        return V.alternate != null ? V.alternate : V.consequent;
      case "LabeledStatement":
      case "ForStatement":
      case "ForInStatement":
      case "WhileStatement":
      case "WithStatement":
        return V.body;
    }
    return null;
  }
  function L(V) {
    var z;
    if (V.type !== "IfStatement" || V.alternate == null)
      return !1;
    z = V.consequent;
    do {
      if (z.type === "IfStatement" && z.alternate == null)
        return !0;
      z = D(z);
    } while (z);
    return !1;
  }
  ast.exports = {
    isExpression: T,
    isStatement: R,
    isIterationStatement: S,
    isSourceElement: k,
    isProblematicIfStatement: L,
    trailingStatement: D
  };
})();
var astExports = ast.exports, code = { exports: {} };
(function() {
  var T, S, R, k, D, L;
  S = {
    // ECMAScript 5.1/Unicode v9.0.0 NonAsciiIdentifierStart:
    NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
    // ECMAScript 5.1/Unicode v9.0.0 NonAsciiIdentifierPart:
    NonAsciiIdentifierPart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/
  }, T = {
    // ECMAScript 6/Unicode v9.0.0 NonAsciiIdentifierStart:
    NonAsciiIdentifierStart: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,
    // ECMAScript 6/Unicode v9.0.0 NonAsciiIdentifierPart:
    NonAsciiIdentifierPart: /[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
  };
  function V(ee) {
    return 48 <= ee && ee <= 57;
  }
  function z(ee) {
    return 48 <= ee && ee <= 57 || // 0..9
    97 <= ee && ee <= 102 || // a..f
    65 <= ee && ee <= 70;
  }
  function W(ee) {
    return ee >= 48 && ee <= 55;
  }
  R = [
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8239,
    8287,
    12288,
    65279
  ];
  function U(ee) {
    return ee === 32 || ee === 9 || ee === 11 || ee === 12 || ee === 160 || ee >= 5760 && R.indexOf(ee) >= 0;
  }
  function q(ee) {
    return ee === 10 || ee === 13 || ee === 8232 || ee === 8233;
  }
  function K(ee) {
    if (ee <= 65535)
      return String.fromCharCode(ee);
    var te = String.fromCharCode(Math.floor((ee - 65536) / 1024) + 55296), re = String.fromCharCode((ee - 65536) % 1024 + 56320);
    return te + re;
  }
  for (k = new Array(128), L = 0; L < 128; ++L)
    k[L] = L >= 97 && L <= 122 || // a..z
    L >= 65 && L <= 90 || // A..Z
    L === 36 || L === 95;
  for (D = new Array(128), L = 0; L < 128; ++L)
    D[L] = L >= 97 && L <= 122 || // a..z
    L >= 65 && L <= 90 || // A..Z
    L >= 48 && L <= 57 || // 0..9
    L === 36 || L === 95;
  function Y(ee) {
    return ee < 128 ? k[ee] : S.NonAsciiIdentifierStart.test(K(ee));
  }
  function J(ee) {
    return ee < 128 ? D[ee] : S.NonAsciiIdentifierPart.test(K(ee));
  }
  function Z(ee) {
    return ee < 128 ? k[ee] : T.NonAsciiIdentifierStart.test(K(ee));
  }
  function X(ee) {
    return ee < 128 ? D[ee] : T.NonAsciiIdentifierPart.test(K(ee));
  }
  code.exports = {
    isDecimalDigit: V,
    isHexDigit: z,
    isOctalDigit: W,
    isWhiteSpace: U,
    isLineTerminator: q,
    isIdentifierStartES5: Y,
    isIdentifierPartES5: J,
    isIdentifierStartES6: Z,
    isIdentifierPartES6: X
  };
})();
var codeExports = code.exports, keyword = { exports: {} };
(function() {
  var T = codeExports;
  function S(Y) {
    switch (Y) {
      case "implements":
      case "interface":
      case "package":
      case "private":
      case "protected":
      case "public":
      case "static":
      case "let":
        return !0;
      default:
        return !1;
    }
  }
  function R(Y, J) {
    return !J && Y === "yield" ? !1 : k(Y, J);
  }
  function k(Y, J) {
    if (J && S(Y))
      return !0;
    switch (Y.length) {
      case 2:
        return Y === "if" || Y === "in" || Y === "do";
      case 3:
        return Y === "var" || Y === "for" || Y === "new" || Y === "try";
      case 4:
        return Y === "this" || Y === "else" || Y === "case" || Y === "void" || Y === "with" || Y === "enum";
      case 5:
        return Y === "while" || Y === "break" || Y === "catch" || Y === "throw" || Y === "const" || Y === "yield" || Y === "class" || Y === "super";
      case 6:
        return Y === "return" || Y === "typeof" || Y === "delete" || Y === "switch" || Y === "export" || Y === "import";
      case 7:
        return Y === "default" || Y === "finally" || Y === "extends";
      case 8:
        return Y === "function" || Y === "continue" || Y === "debugger";
      case 10:
        return Y === "instanceof";
      default:
        return !1;
    }
  }
  function D(Y, J) {
    return Y === "null" || Y === "true" || Y === "false" || R(Y, J);
  }
  function L(Y, J) {
    return Y === "null" || Y === "true" || Y === "false" || k(Y, J);
  }
  function V(Y) {
    return Y === "eval" || Y === "arguments";
  }
  function z(Y) {
    var J, Z, X;
    if (Y.length === 0 || (X = Y.charCodeAt(0), !T.isIdentifierStartES5(X)))
      return !1;
    for (J = 1, Z = Y.length; J < Z; ++J)
      if (X = Y.charCodeAt(J), !T.isIdentifierPartES5(X))
        return !1;
    return !0;
  }
  function W(Y, J) {
    return (Y - 55296) * 1024 + (J - 56320) + 65536;
  }
  function U(Y) {
    var J, Z, X, ee, te;
    if (Y.length === 0)
      return !1;
    for (te = T.isIdentifierStartES6, J = 0, Z = Y.length; J < Z; ++J) {
      if (X = Y.charCodeAt(J), 55296 <= X && X <= 56319) {
        if (++J, J >= Z || (ee = Y.charCodeAt(J), !(56320 <= ee && ee <= 57343)))
          return !1;
        X = W(X, ee);
      }
      if (!te(X))
        return !1;
      te = T.isIdentifierPartES6;
    }
    return !0;
  }
  function q(Y, J) {
    return z(Y) && !D(Y, J);
  }
  function K(Y, J) {
    return U(Y) && !L(Y, J);
  }
  keyword.exports = {
    isKeywordES5: R,
    isKeywordES6: k,
    isReservedWordES5: D,
    isReservedWordES6: L,
    isRestrictedWord: V,
    isIdentifierNameES5: z,
    isIdentifierNameES6: U,
    isIdentifierES5: q,
    isIdentifierES6: K
  };
})();
var keywordExports = keyword.exports;
(function() {
  utils.ast = astExports, utils.code = codeExports, utils.keyword = keywordExports;
})();
var typed = {}, utility = {};
const name$1 = "doctrine", description = "JSDoc parser", homepage = "https://github.com/eslint/doctrine", main = "lib/doctrine.js", version = "3.0.0", engines = {
  node: ">=6.0.0"
}, directories = {
  lib: "./lib"
}, files = [
  "lib"
], maintainers = [
  {
    name: "Nicholas C. Zakas",
    email: "nicholas+npm@nczconsulting.com",
    web: "https://www.nczonline.net"
  },
  {
    name: "Yusuke Suzuki",
    email: "utatane.tea@gmail.com",
    web: "https://github.com/Constellation"
  }
], repository = "eslint/doctrine", devDependencies = {
  coveralls: "^3.0.1",
  dateformat: "^1.0.11",
  eslint: "^1.10.3",
  "eslint-release": "^1.0.0",
  linefix: "^0.1.1",
  mocha: "^3.4.2",
  "npm-license": "^0.3.1",
  nyc: "^10.3.2",
  semver: "^5.0.3",
  shelljs: "^0.5.3",
  "shelljs-nodecli": "^0.1.1",
  should: "^5.0.1"
}, license = "Apache-2.0", scripts = {
  pretest: "npm run lint",
  test: "nyc mocha",
  coveralls: "nyc report --reporter=text-lcov | coveralls",
  lint: "eslint lib/",
  "generate-release": "eslint-generate-release",
  "generate-alpharelease": "eslint-generate-prerelease alpha",
  "generate-betarelease": "eslint-generate-prerelease beta",
  "generate-rcrelease": "eslint-generate-prerelease rc",
  "publish-release": "eslint-publish-release"
}, dependencies = {
  esutils: "^2.0.2"
}, require$$0 = {
  name: name$1,
  description,
  homepage,
  main,
  version,
  engines,
  directories,
  files,
  maintainers,
  repository,
  devDependencies,
  license,
  scripts,
  dependencies
};
var assert = { exports: {} }, errors = {}, util = {}, types = {}, hasSymbols$1 = shams$1, shams = function T() {
  return hasSymbols$1() && !!Symbol.toStringTag;
}, hasToStringTag$3 = shams(), callBound$2 = callBound$4, $toString$1 = callBound$2("Object.prototype.toString"), isStandardArguments = function T(S) {
  return hasToStringTag$3 && S && typeof S == "object" && Symbol.toStringTag in S ? !1 : $toString$1(S) === "[object Arguments]";
}, isLegacyArguments = function T(S) {
  return isStandardArguments(S) ? !0 : S !== null && typeof S == "object" && typeof S.length == "number" && S.length >= 0 && $toString$1(S) !== "[object Array]" && $toString$1(S.callee) === "[object Function]";
}, supportsStandardArguments = function() {
  return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments;
var isArguments$1 = supportsStandardArguments ? isStandardArguments : isLegacyArguments, toStr$3 = Object.prototype.toString, fnToStr$1 = Function.prototype.toString, isFnRegex = /^\s*(?:function)?\*/, hasToStringTag$2 = shams(), getProto = Object.getPrototypeOf, getGeneratorFunc = function() {
  if (!hasToStringTag$2)
    return !1;
  try {
    return Function("return function*() {}")();
  } catch {
  }
}, GeneratorFunction, isGeneratorFunction = function T(S) {
  if (typeof S != "function")
    return !1;
  if (isFnRegex.test(fnToStr$1.call(S)))
    return !0;
  if (!hasToStringTag$2) {
    var R = toStr$3.call(S);
    return R === "[object GeneratorFunction]";
  }
  if (!getProto)
    return !1;
  if (typeof GeneratorFunction > "u") {
    var k = getGeneratorFunc();
    GeneratorFunction = k ? getProto(k) : !1;
  }
  return getProto(S) === GeneratorFunction;
}, fnToStr = Function.prototype.toString, reflectApply = typeof Reflect == "object" && Reflect !== null && Reflect.apply, badArrayLike, isCallableMarker;
if (typeof reflectApply == "function" && typeof Object.defineProperty == "function")
  try {
    badArrayLike = Object.defineProperty({}, "length", {
      get: function() {
        throw isCallableMarker;
      }
    }), isCallableMarker = {}, reflectApply(function() {
      throw 42;
    }, null, badArrayLike);
  } catch (T) {
    T !== isCallableMarker && (reflectApply = null);
  }
else
  reflectApply = null;
var constructorRegex = /^\s*class\b/, isES6ClassFn = function T(S) {
  try {
    var R = fnToStr.call(S);
    return constructorRegex.test(R);
  } catch {
    return !1;
  }
}, tryFunctionObject = function T(S) {
  try {
    return isES6ClassFn(S) ? !1 : (fnToStr.call(S), !0);
  } catch {
    return !1;
  }
}, toStr$2 = Object.prototype.toString, objectClass = "[object Object]", fnClass = "[object Function]", genClass = "[object GeneratorFunction]", ddaClass = "[object HTMLAllCollection]", ddaClass2 = "[object HTML document.all class]", ddaClass3 = "[object HTMLCollection]", hasToStringTag$1 = typeof Symbol == "function" && !!Symbol.toStringTag, isIE68 = !(0 in [,]), isDDA = function T() {
  return !1;
};
if (typeof document == "object") {
  var all = document.all;
  toStr$2.call(all) === toStr$2.call(document.all) && (isDDA = function(S) {
    if ((isIE68 || !S) && (typeof S > "u" || typeof S == "object"))
      try {
        var R = toStr$2.call(S);
        return (R === ddaClass || R === ddaClass2 || R === ddaClass3 || R === objectClass) && S("") == null;
      } catch {
      }
    return !1;
  });
}
var isCallable$1 = reflectApply ? function T(S) {
  if (isDDA(S))
    return !0;
  if (!S || typeof S != "function" && typeof S != "object")
    return !1;
  try {
    reflectApply(S, null, badArrayLike);
  } catch (R) {
    if (R !== isCallableMarker)
      return !1;
  }
  return !isES6ClassFn(S) && tryFunctionObject(S);
} : function T(S) {
  if (isDDA(S))
    return !0;
  if (!S || typeof S != "function" && typeof S != "object")
    return !1;
  if (hasToStringTag$1)
    return tryFunctionObject(S);
  if (isES6ClassFn(S))
    return !1;
  var R = toStr$2.call(S);
  return R !== fnClass && R !== genClass && !/^\[object HTML/.test(R) ? !1 : tryFunctionObject(S);
}, isCallable = isCallable$1, toStr$1 = Object.prototype.toString, hasOwnProperty = Object.prototype.hasOwnProperty, forEachArray = function T(S, R, k) {
  for (var D = 0, L = S.length; D < L; D++)
    hasOwnProperty.call(S, D) && (k == null ? R(S[D], D, S) : R.call(k, S[D], D, S));
}, forEachString = function T(S, R, k) {
  for (var D = 0, L = S.length; D < L; D++)
    k == null ? R(S.charAt(D), D, S) : R.call(k, S.charAt(D), D, S);
}, forEachObject = function T(S, R, k) {
  for (var D in S)
    hasOwnProperty.call(S, D) && (k == null ? R(S[D], D, S) : R.call(k, S[D], D, S));
}, forEach$1 = function T(S, R, k) {
  if (!isCallable(R))
    throw new TypeError("iterator must be a function");
  var D;
  arguments.length >= 3 && (D = k), toStr$1.call(S) === "[object Array]" ? forEachArray(S, R, D) : typeof S == "string" ? forEachString(S, R, D) : forEachObject(S, R, D);
}, forEach_1 = forEach$1, possibleTypedArrayNames = [
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array"
], possibleNames = possibleTypedArrayNames, g$1 = typeof globalThis > "u" ? commonjsGlobal : globalThis, availableTypedArrays$1 = function T() {
  for (var S = [], R = 0; R < possibleNames.length; R++)
    typeof g$1[possibleNames[R]] == "function" && (S[S.length] = possibleNames[R]);
  return S;
}, forEach = forEach_1, availableTypedArrays = availableTypedArrays$1, callBind = callBindExports, callBound$1 = callBound$4, gOPD = gopd$1, $toString = callBound$1("Object.prototype.toString"), hasToStringTag = shams(), g = typeof globalThis > "u" ? commonjsGlobal : globalThis, typedArrays = availableTypedArrays(), $slice = callBound$1("String.prototype.slice"), getPrototypeOf = Object.getPrototypeOf, $indexOf = callBound$1("Array.prototype.indexOf", !0) || function T(S, R) {
  for (var k = 0; k < S.length; k += 1)
    if (S[k] === R)
      return k;
  return -1;
}, cache = { __proto__: null };
hasToStringTag && gOPD && getPrototypeOf ? forEach(typedArrays, function(T) {
  var S = new g[T]();
  if (Symbol.toStringTag in S) {
    var R = getPrototypeOf(S), k = gOPD(R, Symbol.toStringTag);
    if (!k) {
      var D = getPrototypeOf(R);
      k = gOPD(D, Symbol.toStringTag);
    }
    cache["$" + T] = callBind(k.get);
  }
}) : forEach(typedArrays, function(T) {
  var S = new g[T](), R = S.slice || S.set;
  R && (cache["$" + T] = callBind(R));
});
var tryTypedArrays = function T(S) {
  var R = !1;
  return forEach(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    cache,
    /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function(k, D) {
      if (!R)
        try {
          "$" + k(S) === D && (R = $slice(D, 1));
        } catch {
        }
    }
  ), R;
}, trySlices = function T(S) {
  var R = !1;
  return forEach(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    cache,
    /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
    function(k, D) {
      if (!R)
        try {
          k(S), R = $slice(D, 1);
        } catch {
        }
    }
  ), R;
}, whichTypedArray$1 = function T(S) {
  if (!S || typeof S != "object")
    return !1;
  if (!hasToStringTag) {
    var R = $slice($toString(S), 8, -1);
    return $indexOf(typedArrays, R) > -1 ? R : R !== "Object" ? !1 : trySlices(S);
  }
  return gOPD ? tryTypedArrays(S) : null;
}, whichTypedArray = whichTypedArray$1, isTypedArray = function T(S) {
  return !!whichTypedArray(S);
};
(function(T) {
  var S = isArguments$1, R = isGeneratorFunction, k = whichTypedArray$1, D = isTypedArray;
  function L(Be) {
    return Be.call.bind(Be);
  }
  var V = typeof BigInt < "u", z = typeof Symbol < "u", W = L(Object.prototype.toString), U = L(Number.prototype.valueOf), q = L(String.prototype.valueOf), K = L(Boolean.prototype.valueOf);
  if (V)
    var Y = L(BigInt.prototype.valueOf);
  if (z)
    var J = L(Symbol.prototype.valueOf);
  function Z(Be, Ye) {
    if (typeof Be != "object")
      return !1;
    try {
      return Ye(Be), !0;
    } catch {
      return !1;
    }
  }
  T.isArgumentsObject = S, T.isGeneratorFunction = R, T.isTypedArray = D;
  function X(Be) {
    return typeof Promise < "u" && Be instanceof Promise || Be !== null && typeof Be == "object" && typeof Be.then == "function" && typeof Be.catch == "function";
  }
  T.isPromise = X;
  function ee(Be) {
    return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(Be) : D(Be) || Ee(Be);
  }
  T.isArrayBufferView = ee;
  function te(Be) {
    return k(Be) === "Uint8Array";
  }
  T.isUint8Array = te;
  function re(Be) {
    return k(Be) === "Uint8ClampedArray";
  }
  T.isUint8ClampedArray = re;
  function Q(Be) {
    return k(Be) === "Uint16Array";
  }
  T.isUint16Array = Q;
  function ne(Be) {
    return k(Be) === "Uint32Array";
  }
  T.isUint32Array = ne;
  function oe(Be) {
    return k(Be) === "Int8Array";
  }
  T.isInt8Array = oe;
  function ae(Be) {
    return k(Be) === "Int16Array";
  }
  T.isInt16Array = ae;
  function se(Be) {
    return k(Be) === "Int32Array";
  }
  T.isInt32Array = se;
  function ie(Be) {
    return k(Be) === "Float32Array";
  }
  T.isFloat32Array = ie;
  function he(Be) {
    return k(Be) === "Float64Array";
  }
  T.isFloat64Array = he;
  function xe(Be) {
    return k(Be) === "BigInt64Array";
  }
  T.isBigInt64Array = xe;
  function Pe(Be) {
    return k(Be) === "BigUint64Array";
  }
  T.isBigUint64Array = Pe;
  function Re(Be) {
    return W(Be) === "[object Map]";
  }
  Re.working = typeof Map < "u" && Re(/* @__PURE__ */ new Map());
  function ke(Be) {
    return typeof Map > "u" ? !1 : Re.working ? Re(Be) : Be instanceof Map;
  }
  T.isMap = ke;
  function Te(Be) {
    return W(Be) === "[object Set]";
  }
  Te.working = typeof Set < "u" && Te(/* @__PURE__ */ new Set());
  function fe(Be) {
    return typeof Set > "u" ? !1 : Te.working ? Te(Be) : Be instanceof Set;
  }
  T.isSet = fe;
  function ue(Be) {
    return W(Be) === "[object WeakMap]";
  }
  ue.working = typeof WeakMap < "u" && ue(/* @__PURE__ */ new WeakMap());
  function Ce(Be) {
    return typeof WeakMap > "u" ? !1 : ue.working ? ue(Be) : Be instanceof WeakMap;
  }
  T.isWeakMap = Ce;
  function ce(Be) {
    return W(Be) === "[object WeakSet]";
  }
  ce.working = typeof WeakSet < "u" && ce(/* @__PURE__ */ new WeakSet());
  function pe(Be) {
    return ce(Be);
  }
  T.isWeakSet = pe;
  function _e(Be) {
    return W(Be) === "[object ArrayBuffer]";
  }
  _e.working = typeof ArrayBuffer < "u" && _e(new ArrayBuffer());
  function ge(Be) {
    return typeof ArrayBuffer > "u" ? !1 : _e.working ? _e(Be) : Be instanceof ArrayBuffer;
  }
  T.isArrayBuffer = ge;
  function Ae(Be) {
    return W(Be) === "[object DataView]";
  }
  Ae.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && Ae(new DataView(new ArrayBuffer(1), 0, 1));
  function Ee(Be) {
    return typeof DataView > "u" ? !1 : Ae.working ? Ae(Be) : Be instanceof DataView;
  }
  T.isDataView = Ee;
  var ve = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
  function le(Be) {
    return W(Be) === "[object SharedArrayBuffer]";
  }
  function me(Be) {
    return typeof ve > "u" ? !1 : (typeof le.working > "u" && (le.working = le(new ve())), le.working ? le(Be) : Be instanceof ve);
  }
  T.isSharedArrayBuffer = me;
  function Se(Be) {
    return W(Be) === "[object AsyncFunction]";
  }
  T.isAsyncFunction = Se;
  function ye(Be) {
    return W(Be) === "[object Map Iterator]";
  }
  T.isMapIterator = ye;
  function be(Be) {
    return W(Be) === "[object Set Iterator]";
  }
  T.isSetIterator = be;
  function $e(Be) {
    return W(Be) === "[object Generator]";
  }
  T.isGeneratorObject = $e;
  function Oe(Be) {
    return W(Be) === "[object WebAssembly.Module]";
  }
  T.isWebAssemblyCompiledModule = Oe;
  function Ie(Be) {
    return Z(Be, U);
  }
  T.isNumberObject = Ie;
  function we(Be) {
    return Z(Be, q);
  }
  T.isStringObject = we;
  function Fe(Be) {
    return Z(Be, K);
  }
  T.isBooleanObject = Fe;
  function De(Be) {
    return V && Z(Be, Y);
  }
  T.isBigIntObject = De;
  function Le(Be) {
    return z && Z(Be, J);
  }
  T.isSymbolObject = Le;
  function ze(Be) {
    return Ie(Be) || we(Be) || Fe(Be) || De(Be) || Le(Be);
  }
  T.isBoxedPrimitive = ze;
  function We(Be) {
    return typeof Uint8Array < "u" && (ge(Be) || me(Be));
  }
  T.isAnyArrayBuffer = We, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(Be) {
    Object.defineProperty(T, Be, {
      enumerable: !1,
      value: function() {
        throw new Error(Be + " is not supported in userland");
      }
    });
  });
})(types);
var isBufferBrowser = function T(S) {
  return S && typeof S == "object" && typeof S.copy == "function" && typeof S.fill == "function" && typeof S.readUInt8 == "function";
}, inherits_browser = { exports: {} };
typeof Object.create == "function" ? inherits_browser.exports = function(S, R) {
  R && (S.super_ = R, S.prototype = Object.create(R.prototype, {
    constructor: {
      value: S,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : inherits_browser.exports = function(S, R) {
  if (R) {
    S.super_ = R;
    var k = function() {
    };
    k.prototype = R.prototype, S.prototype = new k(), S.prototype.constructor = S;
  }
};
var inherits_browserExports = inherits_browser.exports;
(function(T) {
  var S = {}, R = Object.getOwnPropertyDescriptors || function(ve) {
    for (var le = Object.keys(ve), me = {}, Se = 0; Se < le.length; Se++)
      me[le[Se]] = Object.getOwnPropertyDescriptor(ve, le[Se]);
    return me;
  }, k = /%[sdj%]/g;
  T.format = function(Ee) {
    if (!ae(Ee)) {
      for (var ve = [], le = 0; le < arguments.length; le++)
        ve.push(z(arguments[le]));
      return ve.join(" ");
    }
    for (var le = 1, me = arguments, Se = me.length, ye = String(Ee).replace(k, function($e) {
      if ($e === "%%") return "%";
      if (le >= Se) return $e;
      switch ($e) {
        case "%s":
          return String(me[le++]);
        case "%d":
          return Number(me[le++]);
        case "%j":
          try {
            return JSON.stringify(me[le++]);
          } catch {
            return "[Circular]";
          }
        default:
          return $e;
      }
    }), be = me[le]; le < Se; be = me[++le])
      Q(be) || !xe(be) ? ye += " " + be : ye += " " + z(be);
    return ye;
  }, T.deprecate = function(Ee, ve) {
    if (typeof process < "u" && process.noDeprecation === !0)
      return Ee;
    if (typeof process > "u")
      return function() {
        return T.deprecate(Ee, ve).apply(this, arguments);
      };
    var le = !1;
    function me() {
      if (!le) {
        if (process.throwDeprecation)
          throw new Error(ve);
        process.traceDeprecation ? console.trace(ve) : console.error(ve), le = !0;
      }
      return Ee.apply(this, arguments);
    }
    return me;
  };
  var D = {}, L = /^$/;
  if (S.NODE_DEBUG) {
    var V = S.NODE_DEBUG;
    V = V.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), L = new RegExp("^" + V + "$", "i");
  }
  T.debuglog = function(Ee) {
    if (Ee = Ee.toUpperCase(), !D[Ee])
      if (L.test(Ee)) {
        var ve = process.pid;
        D[Ee] = function() {
          var le = T.format.apply(T, arguments);
          console.error("%s %d: %s", Ee, ve, le);
        };
      } else
        D[Ee] = function() {
        };
    return D[Ee];
  };
  function z(Ee, ve) {
    var le = {
      seen: [],
      stylize: U
    };
    return arguments.length >= 3 && (le.depth = arguments[2]), arguments.length >= 4 && (le.colors = arguments[3]), re(ve) ? le.showHidden = ve : ve && T._extend(le, ve), ie(le.showHidden) && (le.showHidden = !1), ie(le.depth) && (le.depth = 2), ie(le.colors) && (le.colors = !1), ie(le.customInspect) && (le.customInspect = !0), le.colors && (le.stylize = W), K(le, Ee, le.depth);
  }
  T.inspect = z, z.colors = {
    bold: [1, 22],
    italic: [3, 23],
    underline: [4, 24],
    inverse: [7, 27],
    white: [37, 39],
    grey: [90, 39],
    black: [30, 39],
    blue: [34, 39],
    cyan: [36, 39],
    green: [32, 39],
    magenta: [35, 39],
    red: [31, 39],
    yellow: [33, 39]
  }, z.styles = {
    special: "cyan",
    number: "yellow",
    boolean: "yellow",
    undefined: "grey",
    null: "bold",
    string: "green",
    date: "magenta",
    // "name": intentionally not styling
    regexp: "red"
  };
  function W(Ee, ve) {
    var le = z.styles[ve];
    return le ? "\x1B[" + z.colors[le][0] + "m" + Ee + "\x1B[" + z.colors[le][1] + "m" : Ee;
  }
  function U(Ee, ve) {
    return Ee;
  }
  function q(Ee) {
    var ve = {};
    return Ee.forEach(function(le, me) {
      ve[le] = !0;
    }), ve;
  }
  function K(Ee, ve, le) {
    if (Ee.customInspect && ve && ke(ve.inspect) && // Filter out the util module, it's inspect function is special
    ve.inspect !== T.inspect && // Also filter out any prototype objects using the circular check.
    !(ve.constructor && ve.constructor.prototype === ve)) {
      var me = ve.inspect(le, Ee);
      return ae(me) || (me = K(Ee, me, le)), me;
    }
    var Se = Y(Ee, ve);
    if (Se)
      return Se;
    var ye = Object.keys(ve), be = q(ye);
    if (Ee.showHidden && (ye = Object.getOwnPropertyNames(ve)), Re(ve) && (ye.indexOf("message") >= 0 || ye.indexOf("description") >= 0))
      return J(ve);
    if (ye.length === 0) {
      if (ke(ve)) {
        var $e = ve.name ? ": " + ve.name : "";
        return Ee.stylize("[Function" + $e + "]", "special");
      }
      if (he(ve))
        return Ee.stylize(RegExp.prototype.toString.call(ve), "regexp");
      if (Pe(ve))
        return Ee.stylize(Date.prototype.toString.call(ve), "date");
      if (Re(ve))
        return J(ve);
    }
    var Oe = "", Ie = !1, we = ["{", "}"];
    if (te(ve) && (Ie = !0, we = ["[", "]"]), ke(ve)) {
      var Fe = ve.name ? ": " + ve.name : "";
      Oe = " [Function" + Fe + "]";
    }
    if (he(ve) && (Oe = " " + RegExp.prototype.toString.call(ve)), Pe(ve) && (Oe = " " + Date.prototype.toUTCString.call(ve)), Re(ve) && (Oe = " " + J(ve)), ye.length === 0 && (!Ie || ve.length == 0))
      return we[0] + Oe + we[1];
    if (le < 0)
      return he(ve) ? Ee.stylize(RegExp.prototype.toString.call(ve), "regexp") : Ee.stylize("[Object]", "special");
    Ee.seen.push(ve);
    var De;
    return Ie ? De = Z(Ee, ve, le, be, ye) : De = ye.map(function(Le) {
      return X(Ee, ve, le, be, Le, Ie);
    }), Ee.seen.pop(), ee(De, Oe, we);
  }
  function Y(Ee, ve) {
    if (ie(ve))
      return Ee.stylize("undefined", "undefined");
    if (ae(ve)) {
      var le = "'" + JSON.stringify(ve).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
      return Ee.stylize(le, "string");
    }
    if (oe(ve))
      return Ee.stylize("" + ve, "number");
    if (re(ve))
      return Ee.stylize("" + ve, "boolean");
    if (Q(ve))
      return Ee.stylize("null", "null");
  }
  function J(Ee) {
    return "[" + Error.prototype.toString.call(Ee) + "]";
  }
  function Z(Ee, ve, le, me, Se) {
    for (var ye = [], be = 0, $e = ve.length; be < $e; ++be)
      pe(ve, String(be)) ? ye.push(X(
        Ee,
        ve,
        le,
        me,
        String(be),
        !0
      )) : ye.push("");
    return Se.forEach(function(Oe) {
      Oe.match(/^\d+$/) || ye.push(X(
        Ee,
        ve,
        le,
        me,
        Oe,
        !0
      ));
    }), ye;
  }
  function X(Ee, ve, le, me, Se, ye) {
    var be, $e, Oe;
    if (Oe = Object.getOwnPropertyDescriptor(ve, Se) || { value: ve[Se] }, Oe.get ? Oe.set ? $e = Ee.stylize("[Getter/Setter]", "special") : $e = Ee.stylize("[Getter]", "special") : Oe.set && ($e = Ee.stylize("[Setter]", "special")), pe(me, Se) || (be = "[" + Se + "]"), $e || (Ee.seen.indexOf(Oe.value) < 0 ? (Q(le) ? $e = K(Ee, Oe.value, null) : $e = K(Ee, Oe.value, le - 1), $e.indexOf(`
`) > -1 && (ye ? $e = $e.split(`
`).map(function(Ie) {
      return "  " + Ie;
    }).join(`
`).slice(2) : $e = `
` + $e.split(`
`).map(function(Ie) {
      return "   " + Ie;
    }).join(`
`))) : $e = Ee.stylize("[Circular]", "special")), ie(be)) {
      if (ye && Se.match(/^\d+$/))
        return $e;
      be = JSON.stringify("" + Se), be.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (be = be.slice(1, -1), be = Ee.stylize(be, "name")) : (be = be.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), be = Ee.stylize(be, "string"));
    }
    return be + ": " + $e;
  }
  function ee(Ee, ve, le) {
    var me = Ee.reduce(function(Se, ye) {
      return ye.indexOf(`
`) >= 0, Se + ye.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    return me > 60 ? le[0] + (ve === "" ? "" : ve + `
 `) + " " + Ee.join(`,
  `) + " " + le[1] : le[0] + ve + " " + Ee.join(", ") + " " + le[1];
  }
  T.types = types;
  function te(Ee) {
    return Array.isArray(Ee);
  }
  T.isArray = te;
  function re(Ee) {
    return typeof Ee == "boolean";
  }
  T.isBoolean = re;
  function Q(Ee) {
    return Ee === null;
  }
  T.isNull = Q;
  function ne(Ee) {
    return Ee == null;
  }
  T.isNullOrUndefined = ne;
  function oe(Ee) {
    return typeof Ee == "number";
  }
  T.isNumber = oe;
  function ae(Ee) {
    return typeof Ee == "string";
  }
  T.isString = ae;
  function se(Ee) {
    return typeof Ee == "symbol";
  }
  T.isSymbol = se;
  function ie(Ee) {
    return Ee === void 0;
  }
  T.isUndefined = ie;
  function he(Ee) {
    return xe(Ee) && fe(Ee) === "[object RegExp]";
  }
  T.isRegExp = he, T.types.isRegExp = he;
  function xe(Ee) {
    return typeof Ee == "object" && Ee !== null;
  }
  T.isObject = xe;
  function Pe(Ee) {
    return xe(Ee) && fe(Ee) === "[object Date]";
  }
  T.isDate = Pe, T.types.isDate = Pe;
  function Re(Ee) {
    return xe(Ee) && (fe(Ee) === "[object Error]" || Ee instanceof Error);
  }
  T.isError = Re, T.types.isNativeError = Re;
  function ke(Ee) {
    return typeof Ee == "function";
  }
  T.isFunction = ke;
  function Te(Ee) {
    return Ee === null || typeof Ee == "boolean" || typeof Ee == "number" || typeof Ee == "string" || typeof Ee == "symbol" || // ES6 symbol
    typeof Ee > "u";
  }
  T.isPrimitive = Te, T.isBuffer = isBufferBrowser;
  function fe(Ee) {
    return Object.prototype.toString.call(Ee);
  }
  function ue(Ee) {
    return Ee < 10 ? "0" + Ee.toString(10) : Ee.toString(10);
  }
  var Ce = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  function ce() {
    var Ee = /* @__PURE__ */ new Date(), ve = [
      ue(Ee.getHours()),
      ue(Ee.getMinutes()),
      ue(Ee.getSeconds())
    ].join(":");
    return [Ee.getDate(), Ce[Ee.getMonth()], ve].join(" ");
  }
  T.log = function() {
    console.log("%s - %s", ce(), T.format.apply(T, arguments));
  }, T.inherits = inherits_browserExports, T._extend = function(Ee, ve) {
    if (!ve || !xe(ve)) return Ee;
    for (var le = Object.keys(ve), me = le.length; me--; )
      Ee[le[me]] = ve[le[me]];
    return Ee;
  };
  function pe(Ee, ve) {
    return Object.prototype.hasOwnProperty.call(Ee, ve);
  }
  var _e = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
  T.promisify = function(ve) {
    if (typeof ve != "function")
      throw new TypeError('The "original" argument must be of type Function');
    if (_e && ve[_e]) {
      var le = ve[_e];
      if (typeof le != "function")
        throw new TypeError('The "util.promisify.custom" argument must be of type Function');
      return Object.defineProperty(le, _e, {
        value: le,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), le;
    }
    function le() {
      for (var me, Se, ye = new Promise(function(Oe, Ie) {
        me = Oe, Se = Ie;
      }), be = [], $e = 0; $e < arguments.length; $e++)
        be.push(arguments[$e]);
      be.push(function(Oe, Ie) {
        Oe ? Se(Oe) : me(Ie);
      });
      try {
        ve.apply(this, be);
      } catch (Oe) {
        Se(Oe);
      }
      return ye;
    }
    return Object.setPrototypeOf(le, Object.getPrototypeOf(ve)), _e && Object.defineProperty(le, _e, {
      value: le,
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), Object.defineProperties(
      le,
      R(ve)
    );
  }, T.promisify.custom = _e;
  function ge(Ee, ve) {
    if (!Ee) {
      var le = new Error("Promise was rejected with a falsy value");
      le.reason = Ee, Ee = le;
    }
    return ve(Ee);
  }
  function Ae(Ee) {
    if (typeof Ee != "function")
      throw new TypeError('The "original" argument must be of type Function');
    function ve() {
      for (var le = [], me = 0; me < arguments.length; me++)
        le.push(arguments[me]);
      var Se = le.pop();
      if (typeof Se != "function")
        throw new TypeError("The last argument must be of type Function");
      var ye = this, be = function() {
        return Se.apply(ye, arguments);
      };
      Ee.apply(this, le).then(
        function($e) {
          process.nextTick(be.bind(null, null, $e));
        },
        function($e) {
          process.nextTick(ge.bind(null, $e, be));
        }
      );
    }
    return Object.setPrototypeOf(ve, Object.getPrototypeOf(Ee)), Object.defineProperties(
      ve,
      R(Ee)
    ), ve;
  }
  T.callbackify = Ae;
})(util);
var hasRequiredErrors;
function requireErrors() {
  if (hasRequiredErrors) return errors;
  hasRequiredErrors = 1;
  function T(re) {
    "@babel/helpers - typeof";
    return T = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Q) {
      return typeof Q;
    } : function(Q) {
      return Q && typeof Symbol == "function" && Q.constructor === Symbol && Q !== Symbol.prototype ? "symbol" : typeof Q;
    }, T(re);
  }
  function S(re, Q, ne) {
    return Object.defineProperty(re, "prototype", { writable: !1 }), re;
  }
  function R(re, Q) {
    if (!(re instanceof Q))
      throw new TypeError("Cannot call a class as a function");
  }
  function k(re, Q) {
    if (typeof Q != "function" && Q !== null)
      throw new TypeError("Super expression must either be null or a function");
    re.prototype = Object.create(Q && Q.prototype, { constructor: { value: re, writable: !0, configurable: !0 } }), Object.defineProperty(re, "prototype", { writable: !1 }), Q && D(re, Q);
  }
  function D(re, Q) {
    return D = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(oe, ae) {
      return oe.__proto__ = ae, oe;
    }, D(re, Q);
  }
  function L(re) {
    var Q = W();
    return function() {
      var oe = U(re), ae;
      if (Q) {
        var se = U(this).constructor;
        ae = Reflect.construct(oe, arguments, se);
      } else
        ae = oe.apply(this, arguments);
      return V(this, ae);
    };
  }
  function V(re, Q) {
    if (Q && (T(Q) === "object" || typeof Q == "function"))
      return Q;
    if (Q !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return z(re);
  }
  function z(re) {
    if (re === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return re;
  }
  function W() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function U(re) {
    return U = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ne) {
      return ne.__proto__ || Object.getPrototypeOf(ne);
    }, U(re);
  }
  var q = {}, K, Y;
  function J(re, Q, ne) {
    ne || (ne = Error);
    function oe(se, ie, he) {
      return typeof Q == "string" ? Q : Q(se, ie, he);
    }
    var ae = /* @__PURE__ */ function(se) {
      k(he, se);
      var ie = L(he);
      function he(xe, Pe, Re) {
        var ke;
        return R(this, he), ke = ie.call(this, oe(xe, Pe, Re)), ke.code = re, ke;
      }
      return S(he);
    }(ne);
    q[re] = ae;
  }
  function Z(re, Q) {
    if (Array.isArray(re)) {
      var ne = re.length;
      return re = re.map(function(oe) {
        return String(oe);
      }), ne > 2 ? "one of ".concat(Q, " ").concat(re.slice(0, ne - 1).join(", "), ", or ") + re[ne - 1] : ne === 2 ? "one of ".concat(Q, " ").concat(re[0], " or ").concat(re[1]) : "of ".concat(Q, " ").concat(re[0]);
    } else
      return "of ".concat(Q, " ").concat(String(re));
  }
  function X(re, Q, ne) {
    return re.substr(0, Q.length) === Q;
  }
  function ee(re, Q, ne) {
    return (ne === void 0 || ne > re.length) && (ne = re.length), re.substring(ne - Q.length, ne) === Q;
  }
  function te(re, Q, ne) {
    return typeof ne != "number" && (ne = 0), ne + Q.length > re.length ? !1 : re.indexOf(Q, ne) !== -1;
  }
  return J("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError), J("ERR_INVALID_ARG_TYPE", function(re, Q, ne) {
    K === void 0 && (K = requireAssert()), K(typeof re == "string", "'name' must be a string");
    var oe;
    typeof Q == "string" && X(Q, "not ") ? (oe = "must not be", Q = Q.replace(/^not /, "")) : oe = "must be";
    var ae;
    if (ee(re, " argument"))
      ae = "The ".concat(re, " ").concat(oe, " ").concat(Z(Q, "type"));
    else {
      var se = te(re, ".") ? "property" : "argument";
      ae = 'The "'.concat(re, '" ').concat(se, " ").concat(oe, " ").concat(Z(Q, "type"));
    }
    return ae += ". Received type ".concat(T(ne)), ae;
  }, TypeError), J("ERR_INVALID_ARG_VALUE", function(re, Q) {
    var ne = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
    Y === void 0 && (Y = util);
    var oe = Y.inspect(Q);
    return oe.length > 128 && (oe = "".concat(oe.slice(0, 128), "...")), "The argument '".concat(re, "' ").concat(ne, ". Received ").concat(oe);
  }, TypeError), J("ERR_INVALID_RETURN_VALUE", function(re, Q, ne) {
    var oe;
    return ne && ne.constructor && ne.constructor.name ? oe = "instance of ".concat(ne.constructor.name) : oe = "type ".concat(T(ne)), "Expected ".concat(re, ' to be returned from the "').concat(Q, '"') + " function but got ".concat(oe, ".");
  }, TypeError), J("ERR_MISSING_ARGS", function() {
    for (var re = arguments.length, Q = new Array(re), ne = 0; ne < re; ne++)
      Q[ne] = arguments[ne];
    K === void 0 && (K = requireAssert()), K(Q.length > 0, "At least one arg needs to be specified");
    var oe = "The ", ae = Q.length;
    switch (Q = Q.map(function(se) {
      return '"'.concat(se, '"');
    }), ae) {
      case 1:
        oe += "".concat(Q[0], " argument");
        break;
      case 2:
        oe += "".concat(Q[0], " and ").concat(Q[1], " arguments");
        break;
      default:
        oe += Q.slice(0, ae - 1).join(", "), oe += ", and ".concat(Q[ae - 1], " arguments");
        break;
    }
    return "".concat(oe, " must be specified");
  }, TypeError), errors.codes = q, errors;
}
var assertion_error, hasRequiredAssertion_error;
function requireAssertion_error() {
  if (hasRequiredAssertion_error) return assertion_error;
  hasRequiredAssertion_error = 1;
  function T(pe, _e) {
    var ge = Object.keys(pe);
    if (Object.getOwnPropertySymbols) {
      var Ae = Object.getOwnPropertySymbols(pe);
      _e && (Ae = Ae.filter(function(Ee) {
        return Object.getOwnPropertyDescriptor(pe, Ee).enumerable;
      })), ge.push.apply(ge, Ae);
    }
    return ge;
  }
  function S(pe) {
    for (var _e = 1; _e < arguments.length; _e++) {
      var ge = arguments[_e] != null ? arguments[_e] : {};
      _e % 2 ? T(Object(ge), !0).forEach(function(Ae) {
        R(pe, Ae, ge[Ae]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(pe, Object.getOwnPropertyDescriptors(ge)) : T(Object(ge)).forEach(function(Ae) {
        Object.defineProperty(pe, Ae, Object.getOwnPropertyDescriptor(ge, Ae));
      });
    }
    return pe;
  }
  function R(pe, _e, ge) {
    return _e = V(_e), _e in pe ? Object.defineProperty(pe, _e, { value: ge, enumerable: !0, configurable: !0, writable: !0 }) : pe[_e] = ge, pe;
  }
  function k(pe, _e) {
    if (!(pe instanceof _e))
      throw new TypeError("Cannot call a class as a function");
  }
  function D(pe, _e) {
    for (var ge = 0; ge < _e.length; ge++) {
      var Ae = _e[ge];
      Ae.enumerable = Ae.enumerable || !1, Ae.configurable = !0, "value" in Ae && (Ae.writable = !0), Object.defineProperty(pe, V(Ae.key), Ae);
    }
  }
  function L(pe, _e, ge) {
    return _e && D(pe.prototype, _e), Object.defineProperty(pe, "prototype", { writable: !1 }), pe;
  }
  function V(pe) {
    var _e = z(pe, "string");
    return re(_e) === "symbol" ? _e : String(_e);
  }
  function z(pe, _e) {
    if (re(pe) !== "object" || pe === null) return pe;
    var ge = pe[Symbol.toPrimitive];
    if (ge !== void 0) {
      var Ae = ge.call(pe, _e || "default");
      if (re(Ae) !== "object") return Ae;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (_e === "string" ? String : Number)(pe);
  }
  function W(pe, _e) {
    if (typeof _e != "function" && _e !== null)
      throw new TypeError("Super expression must either be null or a function");
    pe.prototype = Object.create(_e && _e.prototype, { constructor: { value: pe, writable: !0, configurable: !0 } }), Object.defineProperty(pe, "prototype", { writable: !1 }), _e && ee(pe, _e);
  }
  function U(pe) {
    var _e = Z();
    return function() {
      var Ae = te(pe), Ee;
      if (_e) {
        var ve = te(this).constructor;
        Ee = Reflect.construct(Ae, arguments, ve);
      } else
        Ee = Ae.apply(this, arguments);
      return q(this, Ee);
    };
  }
  function q(pe, _e) {
    if (_e && (re(_e) === "object" || typeof _e == "function"))
      return _e;
    if (_e !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return K(pe);
  }
  function K(pe) {
    if (pe === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return pe;
  }
  function Y(pe) {
    var _e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
    return Y = function(Ae) {
      if (Ae === null || !X(Ae)) return Ae;
      if (typeof Ae != "function")
        throw new TypeError("Super expression must either be null or a function");
      if (typeof _e < "u") {
        if (_e.has(Ae)) return _e.get(Ae);
        _e.set(Ae, Ee);
      }
      function Ee() {
        return J(Ae, arguments, te(this).constructor);
      }
      return Ee.prototype = Object.create(Ae.prototype, { constructor: { value: Ee, enumerable: !1, writable: !0, configurable: !0 } }), ee(Ee, Ae);
    }, Y(pe);
  }
  function J(pe, _e, ge) {
    return Z() ? J = Reflect.construct.bind() : J = function(Ee, ve, le) {
      var me = [null];
      me.push.apply(me, ve);
      var Se = Function.bind.apply(Ee, me), ye = new Se();
      return le && ee(ye, le.prototype), ye;
    }, J.apply(null, arguments);
  }
  function Z() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function X(pe) {
    return Function.toString.call(pe).indexOf("[native code]") !== -1;
  }
  function ee(pe, _e) {
    return ee = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Ae, Ee) {
      return Ae.__proto__ = Ee, Ae;
    }, ee(pe, _e);
  }
  function te(pe) {
    return te = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ge) {
      return ge.__proto__ || Object.getPrototypeOf(ge);
    }, te(pe);
  }
  function re(pe) {
    "@babel/helpers - typeof";
    return re = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(_e) {
      return typeof _e;
    } : function(_e) {
      return _e && typeof Symbol == "function" && _e.constructor === Symbol && _e !== Symbol.prototype ? "symbol" : typeof _e;
    }, re(pe);
  }
  var Q = util, ne = Q.inspect, oe = requireErrors(), ae = oe.codes.ERR_INVALID_ARG_TYPE;
  function se(pe, _e, ge) {
    return (ge === void 0 || ge > pe.length) && (ge = pe.length), pe.substring(ge - _e.length, ge) === _e;
  }
  function ie(pe, _e) {
    if (_e = Math.floor(_e), pe.length == 0 || _e == 0) return "";
    var ge = pe.length * _e;
    for (_e = Math.floor(Math.log(_e) / Math.log(2)); _e; )
      pe += pe, _e--;
    return pe += pe.substring(0, ge - pe.length), pe;
  }
  var he = "", xe = "", Pe = "", Re = "", ke = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
  }, Te = 10;
  function fe(pe) {
    var _e = Object.keys(pe), ge = Object.create(Object.getPrototypeOf(pe));
    return _e.forEach(function(Ae) {
      ge[Ae] = pe[Ae];
    }), Object.defineProperty(ge, "message", {
      value: pe.message
    }), ge;
  }
  function ue(pe) {
    return ne(pe, {
      compact: !1,
      customInspect: !1,
      depth: 1e3,
      maxArrayLength: 1 / 0,
      // Assert compares only enumerable properties (with a few exceptions).
      showHidden: !1,
      // Having a long line as error is better than wrapping the line for
      // comparison for now.
      // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
      // have meta information about the inspected properties (i.e., know where
      // in what line the property starts and ends).
      breakLength: 1 / 0,
      // Assert does not detect proxies currently.
      showProxy: !1,
      sorted: !0,
      // Inspect getters as we also check them when comparing entries.
      getters: !0
    });
  }
  function Ce(pe, _e, ge) {
    var Ae = "", Ee = "", ve = 0, le = "", me = !1, Se = ue(pe), ye = Se.split(`
`), be = ue(_e).split(`
`), $e = 0, Oe = "";
    if (ge === "strictEqual" && re(pe) === "object" && re(_e) === "object" && pe !== null && _e !== null && (ge = "strictEqualObject"), ye.length === 1 && be.length === 1 && ye[0] !== be[0]) {
      var Ie = ye[0].length + be[0].length;
      if (Ie <= Te) {
        if ((re(pe) !== "object" || pe === null) && (re(_e) !== "object" || _e === null) && (pe !== 0 || _e !== 0))
          return "".concat(ke[ge], `

`) + "".concat(ye[0], " !== ").concat(be[0], `
`);
      } else if (ge !== "strictEqualObject") {
        var we = process.stderr && process.stderr.isTTY ? process.stderr.columns : 80;
        if (Ie < we) {
          for (; ye[0][$e] === be[0][$e]; )
            $e++;
          $e > 2 && (Oe = `
  `.concat(ie(" ", $e), "^"), $e = 0);
        }
      }
    }
    for (var Fe = ye[ye.length - 1], De = be[be.length - 1]; Fe === De && ($e++ < 2 ? le = `
  `.concat(Fe).concat(le) : Ae = Fe, ye.pop(), be.pop(), !(ye.length === 0 || be.length === 0)); )
      Fe = ye[ye.length - 1], De = be[be.length - 1];
    var Le = Math.max(ye.length, be.length);
    if (Le === 0) {
      var ze = Se.split(`
`);
      if (ze.length > 30)
        for (ze[26] = "".concat(he, "...").concat(Re); ze.length > 27; )
          ze.pop();
      return "".concat(ke.notIdentical, `

`).concat(ze.join(`
`), `
`);
    }
    $e > 3 && (le = `
`.concat(he, "...").concat(Re).concat(le), me = !0), Ae !== "" && (le = `
  `.concat(Ae).concat(le), Ae = "");
    var We = 0, Be = ke[ge] + `
`.concat(xe, "+ actual").concat(Re, " ").concat(Pe, "- expected").concat(Re), Ye = " ".concat(he, "...").concat(Re, " Lines skipped");
    for ($e = 0; $e < Le; $e++) {
      var Ge = $e - ve;
      if (ye.length < $e + 1)
        Ge > 1 && $e > 2 && (Ge > 4 ? (Ee += `
`.concat(he, "...").concat(Re), me = !0) : Ge > 3 && (Ee += `
  `.concat(be[$e - 2]), We++), Ee += `
  `.concat(be[$e - 1]), We++), ve = $e, Ae += `
`.concat(Pe, "-").concat(Re, " ").concat(be[$e]), We++;
      else if (be.length < $e + 1)
        Ge > 1 && $e > 2 && (Ge > 4 ? (Ee += `
`.concat(he, "...").concat(Re), me = !0) : Ge > 3 && (Ee += `
  `.concat(ye[$e - 2]), We++), Ee += `
  `.concat(ye[$e - 1]), We++), ve = $e, Ee += `
`.concat(xe, "+").concat(Re, " ").concat(ye[$e]), We++;
      else {
        var nt = be[$e], Ze = ye[$e], Me = Ze !== nt && (!se(Ze, ",") || Ze.slice(0, -1) !== nt);
        Me && se(nt, ",") && nt.slice(0, -1) === Ze && (Me = !1, Ze += ","), Me ? (Ge > 1 && $e > 2 && (Ge > 4 ? (Ee += `
`.concat(he, "...").concat(Re), me = !0) : Ge > 3 && (Ee += `
  `.concat(ye[$e - 2]), We++), Ee += `
  `.concat(ye[$e - 1]), We++), ve = $e, Ee += `
`.concat(xe, "+").concat(Re, " ").concat(Ze), Ae += `
`.concat(Pe, "-").concat(Re, " ").concat(nt), We += 2) : (Ee += Ae, Ae = "", (Ge === 1 || $e === 0) && (Ee += `
  `.concat(Ze), We++));
      }
      if (We > 20 && $e < Le - 2)
        return "".concat(Be).concat(Ye, `
`).concat(Ee, `
`).concat(he, "...").concat(Re).concat(Ae, `
`) + "".concat(he, "...").concat(Re);
    }
    return "".concat(Be).concat(me ? Ye : "", `
`).concat(Ee).concat(Ae).concat(le).concat(Oe);
  }
  var ce = /* @__PURE__ */ function(pe, _e) {
    W(Ae, pe);
    var ge = U(Ae);
    function Ae(Ee) {
      var ve;
      if (k(this, Ae), re(Ee) !== "object" || Ee === null)
        throw new ae("options", "Object", Ee);
      var le = Ee.message, me = Ee.operator, Se = Ee.stackStartFn, ye = Ee.actual, be = Ee.expected, $e = Error.stackTraceLimit;
      if (Error.stackTraceLimit = 0, le != null)
        ve = ge.call(this, String(le));
      else if (process.stderr && process.stderr.isTTY && (process.stderr && process.stderr.getColorDepth && process.stderr.getColorDepth() !== 1 ? (he = "\x1B[34m", xe = "\x1B[32m", Re = "\x1B[39m", Pe = "\x1B[31m") : (he = "", xe = "", Re = "", Pe = "")), re(ye) === "object" && ye !== null && re(be) === "object" && be !== null && "stack" in ye && ye instanceof Error && "stack" in be && be instanceof Error && (ye = fe(ye), be = fe(be)), me === "deepStrictEqual" || me === "strictEqual")
        ve = ge.call(this, Ce(ye, be, me));
      else if (me === "notDeepStrictEqual" || me === "notStrictEqual") {
        var Oe = ke[me], Ie = ue(ye).split(`
`);
        if (me === "notStrictEqual" && re(ye) === "object" && ye !== null && (Oe = ke.notStrictEqualObject), Ie.length > 30)
          for (Ie[26] = "".concat(he, "...").concat(Re); Ie.length > 27; )
            Ie.pop();
        Ie.length === 1 ? ve = ge.call(this, "".concat(Oe, " ").concat(Ie[0])) : ve = ge.call(this, "".concat(Oe, `

`).concat(Ie.join(`
`), `
`));
      } else {
        var we = ue(ye), Fe = "", De = ke[me];
        me === "notDeepEqual" || me === "notEqual" ? (we = "".concat(ke[me], `

`).concat(we), we.length > 1024 && (we = "".concat(we.slice(0, 1021), "..."))) : (Fe = "".concat(ue(be)), we.length > 512 && (we = "".concat(we.slice(0, 509), "...")), Fe.length > 512 && (Fe = "".concat(Fe.slice(0, 509), "...")), me === "deepEqual" || me === "equal" ? we = "".concat(De, `

`).concat(we, `

should equal

`) : Fe = " ".concat(me, " ").concat(Fe)), ve = ge.call(this, "".concat(we).concat(Fe));
      }
      return Error.stackTraceLimit = $e, ve.generatedMessage = !le, Object.defineProperty(K(ve), "name", {
        value: "AssertionError [ERR_ASSERTION]",
        enumerable: !1,
        writable: !0,
        configurable: !0
      }), ve.code = "ERR_ASSERTION", ve.actual = ye, ve.expected = be, ve.operator = me, Error.captureStackTrace && Error.captureStackTrace(K(ve), Se), ve.stack, ve.name = "AssertionError", q(ve);
    }
    return L(Ae, [{
      key: "toString",
      value: function() {
        return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
      }
    }, {
      key: _e,
      value: function(ve, le) {
        return ne(this, S(S({}, le), {}, {
          customInspect: !1,
          depth: 0
        }));
      }
    }]), Ae;
  }(/* @__PURE__ */ Y(Error), ne.custom);
  return assertion_error = ce, assertion_error;
}
var toStr = Object.prototype.toString, isArguments = function T(S) {
  var R = toStr.call(S), k = R === "[object Arguments]";
  return k || (k = R !== "[object Array]" && S !== null && typeof S == "object" && typeof S.length == "number" && S.length >= 0 && toStr.call(S.callee) === "[object Function]"), k;
}, implementation$5, hasRequiredImplementation$1;
function requireImplementation$1() {
  if (hasRequiredImplementation$1) return implementation$5;
  hasRequiredImplementation$1 = 1;
  var T;
  if (!Object.keys) {
    var S = Object.prototype.hasOwnProperty, R = Object.prototype.toString, k = isArguments, D = Object.prototype.propertyIsEnumerable, L = !D.call({ toString: null }, "toString"), V = D.call(function() {
    }, "prototype"), z = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], W = function(Y) {
      var J = Y.constructor;
      return J && J.prototype === Y;
    }, U = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, q = function() {
      if (typeof window > "u")
        return !1;
      for (var Y in window)
        try {
          if (!U["$" + Y] && S.call(window, Y) && window[Y] !== null && typeof window[Y] == "object")
            try {
              W(window[Y]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), K = function(Y) {
      if (typeof window > "u" || !q)
        return W(Y);
      try {
        return W(Y);
      } catch {
        return !1;
      }
    };
    T = function(J) {
      var Z = J !== null && typeof J == "object", X = R.call(J) === "[object Function]", ee = k(J), te = Z && R.call(J) === "[object String]", re = [];
      if (!Z && !X && !ee)
        throw new TypeError("Object.keys called on a non-object");
      var Q = V && X;
      if (te && J.length > 0 && !S.call(J, 0))
        for (var ne = 0; ne < J.length; ++ne)
          re.push(String(ne));
      if (ee && J.length > 0)
        for (var oe = 0; oe < J.length; ++oe)
          re.push(String(oe));
      else
        for (var ae in J)
          !(Q && ae === "prototype") && S.call(J, ae) && re.push(String(ae));
      if (L)
        for (var se = K(J), ie = 0; ie < z.length; ++ie)
          !(se && z[ie] === "constructor") && S.call(J, z[ie]) && re.push(z[ie]);
      return re;
    };
  }
  return implementation$5 = T, implementation$5;
}
var slice = Array.prototype.slice, isArgs = isArguments, origKeys = Object.keys, keysShim = origKeys ? function T(S) {
  return origKeys(S);
} : requireImplementation$1(), originalKeys = Object.keys;
keysShim.shim = function T() {
  if (Object.keys) {
    var S = function() {
      var R = Object.keys(arguments);
      return R && R.length === arguments.length;
    }(1, 2);
    S || (Object.keys = function(k) {
      return isArgs(k) ? originalKeys(slice.call(k)) : originalKeys(k);
    });
  } else
    Object.keys = keysShim;
  return Object.keys || keysShim;
};
var objectKeys$1 = keysShim, objectKeys = objectKeys$1, hasSymbols = shams$1(), callBound = callBound$4, toObject = Object, $push = callBound("Array.prototype.push"), $propIsEnumerable = callBound("Object.prototype.propertyIsEnumerable"), originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null, implementation$4 = function T(S, R) {
  if (S == null)
    throw new TypeError("target must be an object");
  var k = toObject(S);
  if (arguments.length === 1)
    return k;
  for (var D = 1; D < arguments.length; ++D) {
    var L = toObject(arguments[D]), V = objectKeys(L), z = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
    if (z)
      for (var W = z(L), U = 0; U < W.length; ++U) {
        var q = W[U];
        $propIsEnumerable(L, q) && $push(V, q);
      }
    for (var K = 0; K < V.length; ++K) {
      var Y = V[K];
      if ($propIsEnumerable(L, Y)) {
        var J = L[Y];
        k[Y] = J;
      }
    }
  }
  return k;
}, implementation$3 = implementation$4, lacksProperEnumerationOrder = function() {
  if (!Object.assign)
    return !1;
  for (var T = "abcdefghijklmnopqrst", S = T.split(""), R = {}, k = 0; k < S.length; ++k)
    R[S[k]] = S[k];
  var D = Object.assign({}, R), L = "";
  for (var V in D)
    L += V;
  return T !== L;
}, assignHasPendingExceptions = function() {
  if (!Object.assign || !Object.preventExtensions)
    return !1;
  var T = Object.preventExtensions({ 1: 2 });
  try {
    Object.assign(T, "xy");
  } catch {
    return T[1] === "y";
  }
  return !1;
}, polyfill$2 = function T() {
  return !Object.assign || lacksProperEnumerationOrder() || assignHasPendingExceptions() ? implementation$3 : Object.assign;
}, numberIsNaN = function(T) {
  return T !== T;
}, implementation$2 = function T(S, R) {
  return S === 0 && R === 0 ? 1 / S === 1 / R : !!(S === R || numberIsNaN(S) && numberIsNaN(R));
}, implementation$1 = implementation$2, polyfill$1 = function T() {
  return typeof Object.is == "function" ? Object.is : implementation$1;
}, defineProperties_1, hasRequiredDefineProperties;
function requireDefineProperties() {
  if (hasRequiredDefineProperties) return defineProperties_1;
  hasRequiredDefineProperties = 1;
  var T = objectKeys$1, S = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", R = Object.prototype.toString, k = Array.prototype.concat, D = defineDataProperty, L = function(U) {
    return typeof U == "function" && R.call(U) === "[object Function]";
  }, V = hasPropertyDescriptors_1(), z = function(U, q, K, Y) {
    if (q in U) {
      if (Y === !0) {
        if (U[q] === K)
          return;
      } else if (!L(Y) || !Y())
        return;
    }
    V ? D(U, q, K, !0) : D(U, q, K);
  }, W = function(U, q) {
    var K = arguments.length > 2 ? arguments[2] : {}, Y = T(q);
    S && (Y = k.call(Y, Object.getOwnPropertySymbols(q)));
    for (var J = 0; J < Y.length; J += 1)
      z(U, Y[J], q[Y[J]], K[Y[J]]);
  };
  return W.supportsDescriptors = !!V, defineProperties_1 = W, defineProperties_1;
}
var shim$1, hasRequiredShim$1;
function requireShim$1() {
  if (hasRequiredShim$1) return shim$1;
  hasRequiredShim$1 = 1;
  var T = polyfill$1, S = requireDefineProperties();
  return shim$1 = function() {
    var k = T();
    return S(Object, { is: k }, {
      is: function() {
        return Object.is !== k;
      }
    }), k;
  }, shim$1;
}
var objectIs, hasRequiredObjectIs;
function requireObjectIs() {
  if (hasRequiredObjectIs) return objectIs;
  hasRequiredObjectIs = 1;
  var T = requireDefineProperties(), S = callBindExports, R = implementation$2, k = polyfill$1, D = requireShim$1(), L = S(k(), Object);
  return T(L, {
    getPolyfill: k,
    implementation: R,
    shim: D
  }), objectIs = L, objectIs;
}
var implementation, hasRequiredImplementation;
function requireImplementation() {
  return hasRequiredImplementation || (hasRequiredImplementation = 1, implementation = function(S) {
    return S !== S;
  }), implementation;
}
var polyfill, hasRequiredPolyfill;
function requirePolyfill() {
  if (hasRequiredPolyfill) return polyfill;
  hasRequiredPolyfill = 1;
  var T = requireImplementation();
  return polyfill = function() {
    return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : T;
  }, polyfill;
}
var shim, hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim;
  hasRequiredShim = 1;
  var T = requireDefineProperties(), S = requirePolyfill();
  return shim = function() {
    var k = S();
    return T(Number, { isNaN: k }, {
      isNaN: function() {
        return Number.isNaN !== k;
      }
    }), k;
  }, shim;
}
var isNan, hasRequiredIsNan;
function requireIsNan() {
  if (hasRequiredIsNan) return isNan;
  hasRequiredIsNan = 1;
  var T = callBindExports, S = requireDefineProperties(), R = requireImplementation(), k = requirePolyfill(), D = requireShim(), L = T(k(), Number);
  return S(L, {
    getPolyfill: k,
    implementation: R,
    shim: D
  }), isNan = L, isNan;
}
var comparisons, hasRequiredComparisons;
function requireComparisons() {
  if (hasRequiredComparisons) return comparisons;
  hasRequiredComparisons = 1;
  function T(Me, Ne) {
    return L(Me) || D(Me, Ne) || R(Me, Ne) || S();
  }
  function S() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function R(Me, Ne) {
    if (Me) {
      if (typeof Me == "string") return k(Me, Ne);
      var He = Object.prototype.toString.call(Me).slice(8, -1);
      if (He === "Object" && Me.constructor && (He = Me.constructor.name), He === "Map" || He === "Set") return Array.from(Me);
      if (He === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(He)) return k(Me, Ne);
    }
  }
  function k(Me, Ne) {
    (Ne == null || Ne > Me.length) && (Ne = Me.length);
    for (var He = 0, qe = new Array(Ne); He < Ne; He++) qe[He] = Me[He];
    return qe;
  }
  function D(Me, Ne) {
    var He = Me == null ? null : typeof Symbol < "u" && Me[Symbol.iterator] || Me["@@iterator"];
    if (He != null) {
      var qe, Ke, Xe, tt, at = [], it = !0, mt = !1;
      try {
        if (Xe = (He = He.call(Me)).next, Ne !== 0) for (; !(it = (qe = Xe.call(He)).done) && (at.push(qe.value), at.length !== Ne); it = !0) ;
      } catch (Qe) {
        mt = !0, Ke = Qe;
      } finally {
        try {
          if (!it && He.return != null && (tt = He.return(), Object(tt) !== tt)) return;
        } finally {
          if (mt) throw Ke;
        }
      }
      return at;
    }
  }
  function L(Me) {
    if (Array.isArray(Me)) return Me;
  }
  function V(Me) {
    "@babel/helpers - typeof";
    return V = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Ne) {
      return typeof Ne;
    } : function(Ne) {
      return Ne && typeof Symbol == "function" && Ne.constructor === Symbol && Ne !== Symbol.prototype ? "symbol" : typeof Ne;
    }, V(Me);
  }
  var z = /a/g.flags !== void 0, W = function(Ne) {
    var He = [];
    return Ne.forEach(function(qe) {
      return He.push(qe);
    }), He;
  }, U = function(Ne) {
    var He = [];
    return Ne.forEach(function(qe, Ke) {
      return He.push([Ke, qe]);
    }), He;
  }, q = Object.is ? Object.is : requireObjectIs(), K = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
  }, Y = Number.isNaN ? Number.isNaN : requireIsNan();
  function J(Me) {
    return Me.call.bind(Me);
  }
  var Z = J(Object.prototype.hasOwnProperty), X = J(Object.prototype.propertyIsEnumerable), ee = J(Object.prototype.toString), te = util.types, re = te.isAnyArrayBuffer, Q = te.isArrayBufferView, ne = te.isDate, oe = te.isMap, ae = te.isRegExp, se = te.isSet, ie = te.isNativeError, he = te.isBoxedPrimitive, xe = te.isNumberObject, Pe = te.isStringObject, Re = te.isBooleanObject, ke = te.isBigIntObject, Te = te.isSymbolObject, fe = te.isFloat32Array, ue = te.isFloat64Array;
  function Ce(Me) {
    if (Me.length === 0 || Me.length > 10) return !0;
    for (var Ne = 0; Ne < Me.length; Ne++) {
      var He = Me.charCodeAt(Ne);
      if (He < 48 || He > 57) return !0;
    }
    return Me.length === 10 && Me >= Math.pow(2, 32);
  }
  function ce(Me) {
    return Object.keys(Me).filter(Ce).concat(K(Me).filter(Object.prototype.propertyIsEnumerable.bind(Me)));
  }
  /*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
   * @license  MIT
   */
  function pe(Me, Ne) {
    if (Me === Ne)
      return 0;
    for (var He = Me.length, qe = Ne.length, Ke = 0, Xe = Math.min(He, qe); Ke < Xe; ++Ke)
      if (Me[Ke] !== Ne[Ke]) {
        He = Me[Ke], qe = Ne[Ke];
        break;
      }
    return He < qe ? -1 : qe < He ? 1 : 0;
  }
  var _e = !0, ge = !1, Ae = 0, Ee = 1, ve = 2, le = 3;
  function me(Me, Ne) {
    return z ? Me.source === Ne.source && Me.flags === Ne.flags : RegExp.prototype.toString.call(Me) === RegExp.prototype.toString.call(Ne);
  }
  function Se(Me, Ne) {
    if (Me.byteLength !== Ne.byteLength)
      return !1;
    for (var He = 0; He < Me.byteLength; He++)
      if (Me[He] !== Ne[He])
        return !1;
    return !0;
  }
  function ye(Me, Ne) {
    return Me.byteLength !== Ne.byteLength ? !1 : pe(new Uint8Array(Me.buffer, Me.byteOffset, Me.byteLength), new Uint8Array(Ne.buffer, Ne.byteOffset, Ne.byteLength)) === 0;
  }
  function be(Me, Ne) {
    return Me.byteLength === Ne.byteLength && pe(new Uint8Array(Me), new Uint8Array(Ne)) === 0;
  }
  function $e(Me, Ne) {
    return xe(Me) ? xe(Ne) && q(Number.prototype.valueOf.call(Me), Number.prototype.valueOf.call(Ne)) : Pe(Me) ? Pe(Ne) && String.prototype.valueOf.call(Me) === String.prototype.valueOf.call(Ne) : Re(Me) ? Re(Ne) && Boolean.prototype.valueOf.call(Me) === Boolean.prototype.valueOf.call(Ne) : ke(Me) ? ke(Ne) && BigInt.prototype.valueOf.call(Me) === BigInt.prototype.valueOf.call(Ne) : Te(Ne) && Symbol.prototype.valueOf.call(Me) === Symbol.prototype.valueOf.call(Ne);
  }
  function Oe(Me, Ne, He, qe) {
    if (Me === Ne)
      return Me !== 0 ? !0 : He ? q(Me, Ne) : !0;
    if (He) {
      if (V(Me) !== "object")
        return typeof Me == "number" && Y(Me) && Y(Ne);
      if (V(Ne) !== "object" || Me === null || Ne === null || Object.getPrototypeOf(Me) !== Object.getPrototypeOf(Ne))
        return !1;
    } else {
      if (Me === null || V(Me) !== "object")
        return Ne === null || V(Ne) !== "object" ? Me == Ne : !1;
      if (Ne === null || V(Ne) !== "object")
        return !1;
    }
    var Ke = ee(Me), Xe = ee(Ne);
    if (Ke !== Xe)
      return !1;
    if (Array.isArray(Me)) {
      if (Me.length !== Ne.length)
        return !1;
      var tt = ce(Me), at = ce(Ne);
      return tt.length !== at.length ? !1 : we(Me, Ne, He, qe, Ee, tt);
    }
    if (Ke === "[object Object]" && (!oe(Me) && oe(Ne) || !se(Me) && se(Ne)))
      return !1;
    if (ne(Me)) {
      if (!ne(Ne) || Date.prototype.getTime.call(Me) !== Date.prototype.getTime.call(Ne))
        return !1;
    } else if (ae(Me)) {
      if (!ae(Ne) || !me(Me, Ne))
        return !1;
    } else if (ie(Me) || Me instanceof Error) {
      if (Me.message !== Ne.message || Me.name !== Ne.name)
        return !1;
    } else if (Q(Me)) {
      if (!He && (fe(Me) || ue(Me))) {
        if (!Se(Me, Ne))
          return !1;
      } else if (!ye(Me, Ne))
        return !1;
      var it = ce(Me), mt = ce(Ne);
      return it.length !== mt.length ? !1 : we(Me, Ne, He, qe, Ae, it);
    } else {
      if (se(Me))
        return !se(Ne) || Me.size !== Ne.size ? !1 : we(Me, Ne, He, qe, ve);
      if (oe(Me))
        return !oe(Ne) || Me.size !== Ne.size ? !1 : we(Me, Ne, He, qe, le);
      if (re(Me)) {
        if (!be(Me, Ne))
          return !1;
      } else if (he(Me) && !$e(Me, Ne))
        return !1;
    }
    return we(Me, Ne, He, qe, Ae);
  }
  function Ie(Me, Ne) {
    return Ne.filter(function(He) {
      return X(Me, He);
    });
  }
  function we(Me, Ne, He, qe, Ke, Xe) {
    if (arguments.length === 5) {
      Xe = Object.keys(Me);
      var tt = Object.keys(Ne);
      if (Xe.length !== tt.length)
        return !1;
    }
    for (var at = 0; at < Xe.length; at++)
      if (!Z(Ne, Xe[at]))
        return !1;
    if (He && arguments.length === 5) {
      var it = K(Me);
      if (it.length !== 0) {
        var mt = 0;
        for (at = 0; at < it.length; at++) {
          var Qe = it[at];
          if (X(Me, Qe)) {
            if (!X(Ne, Qe))
              return !1;
            Xe.push(Qe), mt++;
          } else if (X(Ne, Qe))
            return !1;
        }
        var ut = K(Ne);
        if (it.length !== ut.length && Ie(Ne, ut).length !== mt)
          return !1;
      } else {
        var ft = K(Ne);
        if (ft.length !== 0 && Ie(Ne, ft).length !== 0)
          return !1;
      }
    }
    if (Xe.length === 0 && (Ke === Ae || Ke === Ee && Me.length === 0 || Me.size === 0))
      return !0;
    if (qe === void 0)
      qe = {
        val1: /* @__PURE__ */ new Map(),
        val2: /* @__PURE__ */ new Map(),
        position: 0
      };
    else {
      var vt = qe.val1.get(Me);
      if (vt !== void 0) {
        var dt = qe.val2.get(Ne);
        if (dt !== void 0)
          return vt === dt;
      }
      qe.position++;
    }
    qe.val1.set(Me, qe.position), qe.val2.set(Ne, qe.position);
    var xt = Ge(Me, Ne, He, Xe, qe, Ke);
    return qe.val1.delete(Me), qe.val2.delete(Ne), xt;
  }
  function Fe(Me, Ne, He, qe) {
    for (var Ke = W(Me), Xe = 0; Xe < Ke.length; Xe++) {
      var tt = Ke[Xe];
      if (Oe(Ne, tt, He, qe))
        return Me.delete(tt), !0;
    }
    return !1;
  }
  function De(Me) {
    switch (V(Me)) {
      case "undefined":
        return null;
      case "object":
        return;
      case "symbol":
        return !1;
      case "string":
        Me = +Me;
      case "number":
        if (Y(Me))
          return !1;
    }
    return !0;
  }
  function Le(Me, Ne, He) {
    var qe = De(He);
    return qe ?? (Ne.has(qe) && !Me.has(qe));
  }
  function ze(Me, Ne, He, qe, Ke) {
    var Xe = De(He);
    if (Xe != null)
      return Xe;
    var tt = Ne.get(Xe);
    return tt === void 0 && !Ne.has(Xe) || !Oe(qe, tt, !1, Ke) ? !1 : !Me.has(Xe) && Oe(qe, tt, !1, Ke);
  }
  function We(Me, Ne, He, qe) {
    for (var Ke = null, Xe = W(Me), tt = 0; tt < Xe.length; tt++) {
      var at = Xe[tt];
      if (V(at) === "object" && at !== null)
        Ke === null && (Ke = /* @__PURE__ */ new Set()), Ke.add(at);
      else if (!Ne.has(at)) {
        if (He || !Le(Me, Ne, at))
          return !1;
        Ke === null && (Ke = /* @__PURE__ */ new Set()), Ke.add(at);
      }
    }
    if (Ke !== null) {
      for (var it = W(Ne), mt = 0; mt < it.length; mt++) {
        var Qe = it[mt];
        if (V(Qe) === "object" && Qe !== null) {
          if (!Fe(Ke, Qe, He, qe)) return !1;
        } else if (!He && !Me.has(Qe) && !Fe(Ke, Qe, He, qe))
          return !1;
      }
      return Ke.size === 0;
    }
    return !0;
  }
  function Be(Me, Ne, He, qe, Ke, Xe) {
    for (var tt = W(Me), at = 0; at < tt.length; at++) {
      var it = tt[at];
      if (Oe(He, it, Ke, Xe) && Oe(qe, Ne.get(it), Ke, Xe))
        return Me.delete(it), !0;
    }
    return !1;
  }
  function Ye(Me, Ne, He, qe) {
    for (var Ke = null, Xe = U(Me), tt = 0; tt < Xe.length; tt++) {
      var at = T(Xe[tt], 2), it = at[0], mt = at[1];
      if (V(it) === "object" && it !== null)
        Ke === null && (Ke = /* @__PURE__ */ new Set()), Ke.add(it);
      else {
        var Qe = Ne.get(it);
        if (Qe === void 0 && !Ne.has(it) || !Oe(mt, Qe, He, qe)) {
          if (He || !ze(Me, Ne, it, mt, qe)) return !1;
          Ke === null && (Ke = /* @__PURE__ */ new Set()), Ke.add(it);
        }
      }
    }
    if (Ke !== null) {
      for (var ut = U(Ne), ft = 0; ft < ut.length; ft++) {
        var vt = T(ut[ft], 2), dt = vt[0], xt = vt[1];
        if (V(dt) === "object" && dt !== null) {
          if (!Be(Ke, Me, dt, xt, He, qe)) return !1;
        } else if (!He && (!Me.has(dt) || !Oe(Me.get(dt), xt, !1, qe)) && !Be(Ke, Me, dt, xt, !1, qe))
          return !1;
      }
      return Ke.size === 0;
    }
    return !0;
  }
  function Ge(Me, Ne, He, qe, Ke, Xe) {
    var tt = 0;
    if (Xe === ve) {
      if (!We(Me, Ne, He, Ke))
        return !1;
    } else if (Xe === le) {
      if (!Ye(Me, Ne, He, Ke))
        return !1;
    } else if (Xe === Ee)
      for (; tt < Me.length; tt++)
        if (Z(Me, tt)) {
          if (!Z(Ne, tt) || !Oe(Me[tt], Ne[tt], He, Ke))
            return !1;
        } else {
          if (Z(Ne, tt))
            return !1;
          for (var at = Object.keys(Me); tt < at.length; tt++) {
            var it = at[tt];
            if (!Z(Ne, it) || !Oe(Me[it], Ne[it], He, Ke))
              return !1;
          }
          return at.length === Object.keys(Ne).length;
        }
    for (tt = 0; tt < qe.length; tt++) {
      var mt = qe[tt];
      if (!Oe(Me[mt], Ne[mt], He, Ke))
        return !1;
    }
    return !0;
  }
  function nt(Me, Ne) {
    return Oe(Me, Ne, ge);
  }
  function Ze(Me, Ne) {
    return Oe(Me, Ne, _e);
  }
  return comparisons = {
    isDeepEqual: nt,
    isDeepStrictEqual: Ze
  }, comparisons;
}
var hasRequiredAssert;
function requireAssert() {
  if (hasRequiredAssert) return assert.exports;
  hasRequiredAssert = 1;
  function T(ve) {
    "@babel/helpers - typeof";
    return T = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(le) {
      return typeof le;
    } : function(le) {
      return le && typeof Symbol == "function" && le.constructor === Symbol && le !== Symbol.prototype ? "symbol" : typeof le;
    }, T(ve);
  }
  function S(ve, le, me) {
    return Object.defineProperty(ve, "prototype", { writable: !1 }), ve;
  }
  function R(ve, le) {
    if (!(ve instanceof le))
      throw new TypeError("Cannot call a class as a function");
  }
  var k = requireErrors(), D = k.codes, L = D.ERR_AMBIGUOUS_ARGUMENT, V = D.ERR_INVALID_ARG_TYPE, z = D.ERR_INVALID_ARG_VALUE, W = D.ERR_INVALID_RETURN_VALUE, U = D.ERR_MISSING_ARGS, q = requireAssertion_error(), K = util, Y = K.inspect, J = util.types, Z = J.isPromise, X = J.isRegExp, ee = polyfill$2(), te = polyfill$1(), re = callBound$4("RegExp.prototype.test"), Q, ne;
  function oe() {
    var ve = requireComparisons();
    Q = ve.isDeepEqual, ne = ve.isDeepStrictEqual;
  }
  var ae = !1, se = assert.exports = Re, ie = {};
  function he(ve) {
    throw ve.message instanceof Error ? ve.message : new q(ve);
  }
  function xe(ve, le, me, Se, ye) {
    var be = arguments.length, $e;
    if (be === 0)
      $e = "Failed";
    else if (be === 1)
      me = ve, ve = void 0;
    else {
      if (ae === !1) {
        ae = !0;
        var Oe = process.emitWarning ? process.emitWarning : console.warn.bind(console);
        Oe("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
      }
      be === 2 && (Se = "!=");
    }
    if (me instanceof Error) throw me;
    var Ie = {
      actual: ve,
      expected: le,
      operator: Se === void 0 ? "fail" : Se,
      stackStartFn: ye || xe
    };
    me !== void 0 && (Ie.message = me);
    var we = new q(Ie);
    throw $e && (we.message = $e, we.generatedMessage = !0), we;
  }
  se.fail = xe, se.AssertionError = q;
  function Pe(ve, le, me, Se) {
    if (!me) {
      var ye = !1;
      if (le === 0)
        ye = !0, Se = "No value argument passed to `assert.ok()`";
      else if (Se instanceof Error)
        throw Se;
      var be = new q({
        actual: me,
        expected: !0,
        message: Se,
        operator: "==",
        stackStartFn: ve
      });
      throw be.generatedMessage = ye, be;
    }
  }
  function Re() {
    for (var ve = arguments.length, le = new Array(ve), me = 0; me < ve; me++)
      le[me] = arguments[me];
    Pe.apply(void 0, [Re, le.length].concat(le));
  }
  se.ok = Re, se.equal = function ve(le, me, Se) {
    if (arguments.length < 2)
      throw new U("actual", "expected");
    le != me && he({
      actual: le,
      expected: me,
      message: Se,
      operator: "==",
      stackStartFn: ve
    });
  }, se.notEqual = function ve(le, me, Se) {
    if (arguments.length < 2)
      throw new U("actual", "expected");
    le == me && he({
      actual: le,
      expected: me,
      message: Se,
      operator: "!=",
      stackStartFn: ve
    });
  }, se.deepEqual = function ve(le, me, Se) {
    if (arguments.length < 2)
      throw new U("actual", "expected");
    Q === void 0 && oe(), Q(le, me) || he({
      actual: le,
      expected: me,
      message: Se,
      operator: "deepEqual",
      stackStartFn: ve
    });
  }, se.notDeepEqual = function ve(le, me, Se) {
    if (arguments.length < 2)
      throw new U("actual", "expected");
    Q === void 0 && oe(), Q(le, me) && he({
      actual: le,
      expected: me,
      message: Se,
      operator: "notDeepEqual",
      stackStartFn: ve
    });
  }, se.deepStrictEqual = function ve(le, me, Se) {
    if (arguments.length < 2)
      throw new U("actual", "expected");
    Q === void 0 && oe(), ne(le, me) || he({
      actual: le,
      expected: me,
      message: Se,
      operator: "deepStrictEqual",
      stackStartFn: ve
    });
  }, se.notDeepStrictEqual = ke;
  function ke(ve, le, me) {
    if (arguments.length < 2)
      throw new U("actual", "expected");
    Q === void 0 && oe(), ne(ve, le) && he({
      actual: ve,
      expected: le,
      message: me,
      operator: "notDeepStrictEqual",
      stackStartFn: ke
    });
  }
  se.strictEqual = function ve(le, me, Se) {
    if (arguments.length < 2)
      throw new U("actual", "expected");
    te(le, me) || he({
      actual: le,
      expected: me,
      message: Se,
      operator: "strictEqual",
      stackStartFn: ve
    });
  }, se.notStrictEqual = function ve(le, me, Se) {
    if (arguments.length < 2)
      throw new U("actual", "expected");
    te(le, me) && he({
      actual: le,
      expected: me,
      message: Se,
      operator: "notStrictEqual",
      stackStartFn: ve
    });
  };
  var Te = /* @__PURE__ */ S(function ve(le, me, Se) {
    var ye = this;
    R(this, ve), me.forEach(function(be) {
      be in le && (Se !== void 0 && typeof Se[be] == "string" && X(le[be]) && re(le[be], Se[be]) ? ye[be] = Se[be] : ye[be] = le[be]);
    });
  });
  function fe(ve, le, me, Se, ye, be) {
    if (!(me in ve) || !ne(ve[me], le[me])) {
      if (!Se) {
        var $e = new Te(ve, ye), Oe = new Te(le, ye, ve), Ie = new q({
          actual: $e,
          expected: Oe,
          operator: "deepStrictEqual",
          stackStartFn: be
        });
        throw Ie.actual = ve, Ie.expected = le, Ie.operator = be.name, Ie;
      }
      he({
        actual: ve,
        expected: le,
        message: Se,
        operator: be.name,
        stackStartFn: be
      });
    }
  }
  function ue(ve, le, me, Se) {
    if (typeof le != "function") {
      if (X(le)) return re(le, ve);
      if (arguments.length === 2)
        throw new V("expected", ["Function", "RegExp"], le);
      if (T(ve) !== "object" || ve === null) {
        var ye = new q({
          actual: ve,
          expected: le,
          message: me,
          operator: "deepStrictEqual",
          stackStartFn: Se
        });
        throw ye.operator = Se.name, ye;
      }
      var be = Object.keys(le);
      if (le instanceof Error)
        be.push("name", "message");
      else if (be.length === 0)
        throw new z("error", le, "may not be an empty object");
      return Q === void 0 && oe(), be.forEach(function($e) {
        typeof ve[$e] == "string" && X(le[$e]) && re(le[$e], ve[$e]) || fe(ve, le, $e, me, be, Se);
      }), !0;
    }
    return le.prototype !== void 0 && ve instanceof le ? !0 : Error.isPrototypeOf(le) ? !1 : le.call({}, ve) === !0;
  }
  function Ce(ve) {
    if (typeof ve != "function")
      throw new V("fn", "Function", ve);
    try {
      ve();
    } catch (le) {
      return le;
    }
    return ie;
  }
  function ce(ve) {
    return Z(ve) || ve !== null && T(ve) === "object" && typeof ve.then == "function" && typeof ve.catch == "function";
  }
  function pe(ve) {
    return Promise.resolve().then(function() {
      var le;
      if (typeof ve == "function") {
        if (le = ve(), !ce(le))
          throw new W("instance of Promise", "promiseFn", le);
      } else if (ce(ve))
        le = ve;
      else
        throw new V("promiseFn", ["Function", "Promise"], ve);
      return Promise.resolve().then(function() {
        return le;
      }).then(function() {
        return ie;
      }).catch(function(me) {
        return me;
      });
    });
  }
  function _e(ve, le, me, Se) {
    if (typeof me == "string") {
      if (arguments.length === 4)
        throw new V("error", ["Object", "Error", "Function", "RegExp"], me);
      if (T(le) === "object" && le !== null) {
        if (le.message === me)
          throw new L("error/message", 'The error message "'.concat(le.message, '" is identical to the message.'));
      } else if (le === me)
        throw new L("error/message", 'The error "'.concat(le, '" is identical to the message.'));
      Se = me, me = void 0;
    } else if (me != null && T(me) !== "object" && typeof me != "function")
      throw new V("error", ["Object", "Error", "Function", "RegExp"], me);
    if (le === ie) {
      var ye = "";
      me && me.name && (ye += " (".concat(me.name, ")")), ye += Se ? ": ".concat(Se) : ".";
      var be = ve.name === "rejects" ? "rejection" : "exception";
      he({
        actual: void 0,
        expected: me,
        operator: ve.name,
        message: "Missing expected ".concat(be).concat(ye),
        stackStartFn: ve
      });
    }
    if (me && !ue(le, me, Se, ve))
      throw le;
  }
  function ge(ve, le, me, Se) {
    if (le !== ie) {
      if (typeof me == "string" && (Se = me, me = void 0), !me || ue(le, me)) {
        var ye = Se ? ": ".concat(Se) : ".", be = ve.name === "doesNotReject" ? "rejection" : "exception";
        he({
          actual: le,
          expected: me,
          operator: ve.name,
          message: "Got unwanted ".concat(be).concat(ye, `
`) + 'Actual message: "'.concat(le && le.message, '"'),
          stackStartFn: ve
        });
      }
      throw le;
    }
  }
  se.throws = function ve(le) {
    for (var me = arguments.length, Se = new Array(me > 1 ? me - 1 : 0), ye = 1; ye < me; ye++)
      Se[ye - 1] = arguments[ye];
    _e.apply(void 0, [ve, Ce(le)].concat(Se));
  }, se.rejects = function ve(le) {
    for (var me = arguments.length, Se = new Array(me > 1 ? me - 1 : 0), ye = 1; ye < me; ye++)
      Se[ye - 1] = arguments[ye];
    return pe(le).then(function(be) {
      return _e.apply(void 0, [ve, be].concat(Se));
    });
  }, se.doesNotThrow = function ve(le) {
    for (var me = arguments.length, Se = new Array(me > 1 ? me - 1 : 0), ye = 1; ye < me; ye++)
      Se[ye - 1] = arguments[ye];
    ge.apply(void 0, [ve, Ce(le)].concat(Se));
  }, se.doesNotReject = function ve(le) {
    for (var me = arguments.length, Se = new Array(me > 1 ? me - 1 : 0), ye = 1; ye < me; ye++)
      Se[ye - 1] = arguments[ye];
    return pe(le).then(function(be) {
      return ge.apply(void 0, [ve, be].concat(Se));
    });
  }, se.ifError = function ve(le) {
    if (le != null) {
      var me = "ifError got unwanted exception: ";
      T(le) === "object" && typeof le.message == "string" ? le.message.length === 0 && le.constructor ? me += le.constructor.name : me += le.message : me += Y(le);
      var Se = new q({
        actual: le,
        expected: null,
        operator: "ifError",
        message: me,
        stackStartFn: ve
      }), ye = le.stack;
      if (typeof ye == "string") {
        var be = ye.split(`
`);
        be.shift();
        for (var $e = Se.stack.split(`
`), Oe = 0; Oe < be.length; Oe++) {
          var Ie = $e.indexOf(be[Oe]);
          if (Ie !== -1) {
            $e = $e.slice(0, Ie);
            break;
          }
        }
        Se.stack = "".concat($e.join(`
`), `
`).concat(be.join(`
`));
      }
      throw Se;
    }
  };
  function Ae(ve, le, me, Se, ye) {
    if (!X(le))
      throw new V("regexp", "RegExp", le);
    var be = ye === "match";
    if (typeof ve != "string" || re(le, ve) !== be) {
      if (me instanceof Error)
        throw me;
      var $e = !me;
      me = me || (typeof ve != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(T(ve), " (").concat(Y(ve), ")") : (be ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(Y(le), `. Input:

`).concat(Y(ve), `
`));
      var Oe = new q({
        actual: ve,
        expected: le,
        message: me,
        operator: ye,
        stackStartFn: Se
      });
      throw Oe.generatedMessage = $e, Oe;
    }
  }
  se.match = function ve(le, me, Se) {
    Ae(le, me, Se, ve, "match");
  }, se.doesNotMatch = function ve(le, me, Se) {
    Ae(le, me, Se, ve, "doesNotMatch");
  };
  function Ee() {
    for (var ve = arguments.length, le = new Array(ve), me = 0; me < ve; me++)
      le[me] = arguments[me];
    Pe.apply(void 0, [Ee, le.length].concat(le));
  }
  return se.strict = ee(Ee, se, {
    equal: se.strictEqual,
    deepEqual: se.deepStrictEqual,
    notEqual: se.notStrictEqual,
    notDeepEqual: se.notDeepStrictEqual
  }), se.strict.strict = se.strict, assert.exports;
}
(function() {
  var T;
  T = require$$0.version, utility.VERSION = T;
  function S(k) {
    this.name = "DoctrineError", this.message = k;
  }
  S.prototype = function() {
    var k = function() {
    };
    return k.prototype = Error.prototype, new k();
  }(), S.prototype.constructor = S, utility.DoctrineError = S;
  function R(k) {
    throw new S(k);
  }
  utility.throwError = R, utility.assert = requireAssert();
})();
(function() {
  var T, S, R, k, D, L, V, z, W, U, q, K;
  W = utils, U = utility, T = {
    NullableLiteral: "NullableLiteral",
    AllLiteral: "AllLiteral",
    NullLiteral: "NullLiteral",
    UndefinedLiteral: "UndefinedLiteral",
    VoidLiteral: "VoidLiteral",
    UnionType: "UnionType",
    ArrayType: "ArrayType",
    RecordType: "RecordType",
    FieldType: "FieldType",
    FunctionType: "FunctionType",
    ParameterType: "ParameterType",
    RestType: "RestType",
    NonNullableType: "NonNullableType",
    OptionalType: "OptionalType",
    NullableType: "NullableType",
    NameExpression: "NameExpression",
    TypeApplication: "TypeApplication",
    StringLiteralType: "StringLiteralType",
    NumericLiteralType: "NumericLiteralType",
    BooleanLiteralType: "BooleanLiteralType"
  }, S = {
    ILLEGAL: 0,
    // ILLEGAL
    DOT_LT: 1,
    // .<
    REST: 2,
    // ...
    LT: 3,
    // <
    GT: 4,
    // >
    LPAREN: 5,
    // (
    RPAREN: 6,
    // )
    LBRACE: 7,
    // {
    RBRACE: 8,
    // }
    LBRACK: 9,
    // [
    RBRACK: 10,
    // ]
    COMMA: 11,
    // ,
    COLON: 12,
    // :
    STAR: 13,
    // *
    PIPE: 14,
    // |
    QUESTION: 15,
    // ?
    BANG: 16,
    // !
    EQUAL: 17,
    // =
    NAME: 18,
    // name token
    STRING: 19,
    // string
    NUMBER: 20,
    // number
    EOF: 21
  };
  function Y(me) {
    return "><(){}[],:*|?!=".indexOf(String.fromCharCode(me)) === -1 && !W.code.isWhiteSpace(me) && !W.code.isLineTerminator(me);
  }
  function J(me, Se, ye, be) {
    this._previous = me, this._index = Se, this._token = ye, this._value = be;
  }
  J.prototype.restore = function() {
    L = this._previous, D = this._index, V = this._token, z = this._value;
  }, J.save = function() {
    return new J(L, D, V, z);
  };
  function Z(me, Se) {
    return K && (me.range = [Se[0] + q, Se[1] + q]), me;
  }
  function X() {
    var me = R.charAt(D);
    return D += 1, me;
  }
  function ee(me) {
    var Se, ye, be, $e = 0;
    for (ye = me === "u" ? 4 : 2, Se = 0; Se < ye; ++Se)
      if (D < k && W.code.isHexDigit(R.charCodeAt(D)))
        be = X(), $e = $e * 16 + "0123456789abcdef".indexOf(be.toLowerCase());
      else
        return "";
    return String.fromCharCode($e);
  }
  function te() {
    var me = "", Se, ye, be, $e, Oe;
    for (Se = R.charAt(D), ++D; D < k; )
      if (ye = X(), ye === Se) {
        Se = "";
        break;
      } else if (ye === "\\")
        if (ye = X(), W.code.isLineTerminator(ye.charCodeAt(0)))
          ye === "\r" && R.charCodeAt(D) === 10 && ++D;
        else
          switch (ye) {
            case "n":
              me += `
`;
              break;
            case "r":
              me += "\r";
              break;
            case "t":
              me += "	";
              break;
            case "u":
            case "x":
              Oe = D, $e = ee(ye), $e ? me += $e : (D = Oe, me += ye);
              break;
            case "b":
              me += "\b";
              break;
            case "f":
              me += "\f";
              break;
            case "v":
              me += "\v";
              break;
            default:
              W.code.isOctalDigit(ye.charCodeAt(0)) ? (be = "01234567".indexOf(ye), D < k && W.code.isOctalDigit(R.charCodeAt(D)) && (be = be * 8 + "01234567".indexOf(X()), "0123".indexOf(ye) >= 0 && D < k && W.code.isOctalDigit(R.charCodeAt(D)) && (be = be * 8 + "01234567".indexOf(X()))), me += String.fromCharCode(be)) : me += ye;
              break;
          }
      else {
        if (W.code.isLineTerminator(ye.charCodeAt(0)))
          break;
        me += ye;
      }
    return Se !== "" && U.throwError("unexpected quote"), z = me, S.STRING;
  }
  function re() {
    var me, Se;
    if (me = "", Se = R.charCodeAt(D), Se !== 46) {
      if (me = X(), Se = R.charCodeAt(D), me === "0") {
        if (Se === 120 || Se === 88) {
          for (me += X(); D < k && (Se = R.charCodeAt(D), !!W.code.isHexDigit(Se)); )
            me += X();
          return me.length <= 2 && U.throwError("unexpected token"), D < k && (Se = R.charCodeAt(D), W.code.isIdentifierStartES5(Se) && U.throwError("unexpected token")), z = parseInt(me, 16), S.NUMBER;
        }
        if (W.code.isOctalDigit(Se)) {
          for (me += X(); D < k && (Se = R.charCodeAt(D), !!W.code.isOctalDigit(Se)); )
            me += X();
          return D < k && (Se = R.charCodeAt(D), (W.code.isIdentifierStartES5(Se) || W.code.isDecimalDigit(Se)) && U.throwError("unexpected token")), z = parseInt(me, 8), S.NUMBER;
        }
        W.code.isDecimalDigit(Se) && U.throwError("unexpected token");
      }
      for (; D < k && (Se = R.charCodeAt(D), !!W.code.isDecimalDigit(Se)); )
        me += X();
    }
    if (Se === 46)
      for (me += X(); D < k && (Se = R.charCodeAt(D), !!W.code.isDecimalDigit(Se)); )
        me += X();
    if (Se === 101 || Se === 69)
      if (me += X(), Se = R.charCodeAt(D), (Se === 43 || Se === 45) && (me += X()), Se = R.charCodeAt(D), W.code.isDecimalDigit(Se))
        for (me += X(); D < k && (Se = R.charCodeAt(D), !!W.code.isDecimalDigit(Se)); )
          me += X();
      else
        U.throwError("unexpected token");
    return D < k && (Se = R.charCodeAt(D), W.code.isIdentifierStartES5(Se) && U.throwError("unexpected token")), z = parseFloat(me), S.NUMBER;
  }
  function Q() {
    var me, Se;
    for (z = X(); D < k && Y(R.charCodeAt(D)); ) {
      if (me = R.charCodeAt(D), me === 46) {
        if (D + 1 >= k)
          return S.ILLEGAL;
        if (Se = R.charCodeAt(D + 1), Se === 60)
          break;
      }
      z += X();
    }
    return S.NAME;
  }
  function ne() {
    var me;
    for (L = D; D < k && W.code.isWhiteSpace(R.charCodeAt(D)); )
      X();
    if (D >= k)
      return V = S.EOF, V;
    switch (me = R.charCodeAt(D), me) {
      case 39:
      case 34:
        return V = te(), V;
      case 58:
        return X(), V = S.COLON, V;
      case 44:
        return X(), V = S.COMMA, V;
      case 40:
        return X(), V = S.LPAREN, V;
      case 41:
        return X(), V = S.RPAREN, V;
      case 91:
        return X(), V = S.LBRACK, V;
      case 93:
        return X(), V = S.RBRACK, V;
      case 123:
        return X(), V = S.LBRACE, V;
      case 125:
        return X(), V = S.RBRACE, V;
      case 46:
        if (D + 1 < k) {
          if (me = R.charCodeAt(D + 1), me === 60)
            return X(), X(), V = S.DOT_LT, V;
          if (me === 46 && D + 2 < k && R.charCodeAt(D + 2) === 46)
            return X(), X(), X(), V = S.REST, V;
          if (W.code.isDecimalDigit(me))
            return V = re(), V;
        }
        return V = S.ILLEGAL, V;
      case 60:
        return X(), V = S.LT, V;
      case 62:
        return X(), V = S.GT, V;
      case 42:
        return X(), V = S.STAR, V;
      case 124:
        return X(), V = S.PIPE, V;
      case 63:
        return X(), V = S.QUESTION, V;
      case 33:
        return X(), V = S.BANG, V;
      case 61:
        return X(), V = S.EQUAL, V;
      case 45:
        return V = re(), V;
      default:
        return W.code.isDecimalDigit(me) ? (V = re(), V) : (U.assert(Y(me)), V = Q(), V);
    }
  }
  function oe(me, Se) {
    U.assert(V === me, Se || "consumed token not matched"), ne();
  }
  function ae(me, Se) {
    V !== me && U.throwError(Se || "unexpected token"), ne();
  }
  function se() {
    var me, Se = D - 1;
    if (oe(S.LPAREN, "UnionType should start with ("), me = [], V !== S.RPAREN)
      for (; me.push(pe()), V !== S.RPAREN; )
        ae(S.PIPE);
    return oe(S.RPAREN, "UnionType should end with )"), Z({
      type: T.UnionType,
      elements: me
    }, [Se, L]);
  }
  function ie() {
    var me, Se = D - 1, ye;
    for (oe(S.LBRACK, "ArrayType should start with ["), me = []; V !== S.RBRACK; ) {
      if (V === S.REST) {
        ye = D - 3, oe(S.REST), me.push(Z({
          type: T.RestType,
          expression: pe()
        }, [ye, L]));
        break;
      } else
        me.push(pe());
      V !== S.RBRACK && ae(S.COMMA);
    }
    return ae(S.RBRACK), Z({
      type: T.ArrayType,
      elements: me
    }, [Se, L]);
  }
  function he() {
    var me = z;
    if (V === S.NAME || V === S.STRING)
      return ne(), me;
    if (V === S.NUMBER)
      return oe(S.NUMBER), String(me);
    U.throwError("unexpected token");
  }
  function xe() {
    var me, Se = L;
    return me = he(), V === S.COLON ? (oe(S.COLON), Z({
      type: T.FieldType,
      key: me,
      value: pe()
    }, [Se, L])) : Z({
      type: T.FieldType,
      key: me,
      value: null
    }, [Se, L]);
  }
  function Pe() {
    var me, Se = D - 1, ye;
    if (oe(S.LBRACE, "RecordType should start with {"), me = [], V === S.COMMA)
      oe(S.COMMA);
    else
      for (; V !== S.RBRACE; )
        me.push(xe()), V !== S.RBRACE && ae(S.COMMA);
    return ye = D, ae(S.RBRACE), Z({
      type: T.RecordType,
      fields: me
    }, [Se, ye]);
  }
  function Re() {
    var me = z, Se = D - me.length;
    return ae(S.NAME), V === S.COLON && (me === "module" || me === "external" || me === "event") && (oe(S.COLON), me += ":" + z, ae(S.NAME)), Z({
      type: T.NameExpression,
      name: me
    }, [Se, L]);
  }
  function ke() {
    var me = [];
    for (me.push(_e()); V === S.COMMA; )
      oe(S.COMMA), me.push(_e());
    return me;
  }
  function Te() {
    var me, Se, ye = D - z.length;
    return me = Re(), V === S.DOT_LT || V === S.LT ? (ne(), Se = ke(), ae(S.GT), Z({
      type: T.TypeApplication,
      expression: me,
      applications: Se
    }, [ye, L])) : me;
  }
  function fe() {
    return oe(S.COLON, "ResultType should start with :"), V === S.NAME && z === "void" ? (oe(S.NAME), {
      type: T.VoidLiteral
    }) : pe();
  }
  function ue() {
    for (var me = [], Se = !1, ye, be = !1, $e, Oe = D - 3, Ie; V !== S.RPAREN; )
      V === S.REST && (oe(S.REST), be = !0), $e = L, ye = pe(), ye.type === T.NameExpression && V === S.COLON && (Ie = L - ye.name.length, oe(S.COLON), ye = Z({
        type: T.ParameterType,
        name: ye.name,
        expression: pe()
      }, [Ie, L])), V === S.EQUAL ? (oe(S.EQUAL), ye = Z({
        type: T.OptionalType,
        expression: ye
      }, [$e, L]), Se = !0) : Se && U.throwError("unexpected token"), be && (ye = Z({
        type: T.RestType,
        expression: ye
      }, [Oe, L])), me.push(ye), V !== S.RPAREN && ae(S.COMMA);
    return me;
  }
  function Ce() {
    var me, Se, ye, be, $e, Oe = D - z.length;
    return U.assert(V === S.NAME && z === "function", "FunctionType should start with 'function'"), oe(S.NAME), ae(S.LPAREN), me = !1, ye = [], Se = null, V !== S.RPAREN && (V === S.NAME && (z === "this" || z === "new") ? (me = z === "new", oe(S.NAME), ae(S.COLON), Se = Te(), V === S.COMMA && (oe(S.COMMA), ye = ue())) : ye = ue()), ae(S.RPAREN), be = null, V === S.COLON && (be = fe()), $e = Z({
      type: T.FunctionType,
      params: ye,
      result: be
    }, [Oe, L]), Se && ($e.this = Se, me && ($e.new = !0)), $e;
  }
  function ce() {
    var me, Se;
    switch (V) {
      case S.STAR:
        return oe(S.STAR), Z({
          type: T.AllLiteral
        }, [L - 1, L]);
      case S.LPAREN:
        return se();
      case S.LBRACK:
        return ie();
      case S.LBRACE:
        return Pe();
      case S.NAME:
        if (Se = D - z.length, z === "null")
          return oe(S.NAME), Z({
            type: T.NullLiteral
          }, [Se, L]);
        if (z === "undefined")
          return oe(S.NAME), Z({
            type: T.UndefinedLiteral
          }, [Se, L]);
        if (z === "true" || z === "false")
          return oe(S.NAME), Z({
            type: T.BooleanLiteralType,
            value: z === "true"
          }, [Se, L]);
        if (me = J.save(), z === "function")
          try {
            return Ce();
          } catch {
            me.restore();
          }
        return Te();
      case S.STRING:
        return ne(), Z({
          type: T.StringLiteralType,
          value: z
        }, [L - z.length - 2, L]);
      case S.NUMBER:
        return ne(), Z({
          type: T.NumericLiteralType,
          value: z
        }, [L - String(z).length, L]);
      default:
        U.throwError("unexpected token");
    }
  }
  function pe() {
    var me, Se;
    return V === S.QUESTION ? (Se = D - 1, oe(S.QUESTION), V === S.COMMA || V === S.EQUAL || V === S.RBRACE || V === S.RPAREN || V === S.PIPE || V === S.EOF || V === S.RBRACK || V === S.GT ? Z({
      type: T.NullableLiteral
    }, [Se, L]) : Z({
      type: T.NullableType,
      expression: ce(),
      prefix: !0
    }, [Se, L])) : V === S.BANG ? (Se = D - 1, oe(S.BANG), Z({
      type: T.NonNullableType,
      expression: ce(),
      prefix: !0
    }, [Se, L])) : (Se = L, me = ce(), V === S.BANG ? (oe(S.BANG), Z({
      type: T.NonNullableType,
      expression: me,
      prefix: !1
    }, [Se, L])) : V === S.QUESTION ? (oe(S.QUESTION), Z({
      type: T.NullableType,
      expression: me,
      prefix: !1
    }, [Se, L])) : V === S.LBRACK ? (oe(S.LBRACK), ae(S.RBRACK, "expected an array-style type declaration (" + z + "[])"), Z({
      type: T.TypeApplication,
      expression: Z({
        type: T.NameExpression,
        name: "Array"
      }, [Se, L]),
      applications: [me]
    }, [Se, L])) : me);
  }
  function _e() {
    var me, Se;
    if (me = pe(), V !== S.PIPE)
      return me;
    for (Se = [me], oe(S.PIPE); Se.push(pe()), V === S.PIPE; )
      oe(S.PIPE);
    return Z({
      type: T.UnionType,
      elements: Se
    }, [0, D]);
  }
  function ge() {
    var me;
    return V === S.REST ? (oe(S.REST), Z({
      type: T.RestType,
      expression: _e()
    }, [0, D])) : (me = _e(), V === S.EQUAL ? (oe(S.EQUAL), Z({
      type: T.OptionalType,
      expression: me
    }, [0, D])) : me);
  }
  function Ae(me, Se) {
    var ye;
    return R = me, k = R.length, D = 0, L = 0, K = Se && Se.range, q = Se && Se.startIndex || 0, ne(), ye = _e(), Se && Se.midstream ? {
      expression: ye,
      index: L
    } : (V !== S.EOF && U.throwError("not reach to EOF"), ye);
  }
  function Ee(me, Se) {
    var ye;
    return R = me, k = R.length, D = 0, L = 0, K = Se && Se.range, q = Se && Se.startIndex || 0, ne(), ye = ge(), Se && Se.midstream ? {
      expression: ye,
      index: L
    } : (V !== S.EOF && U.throwError("not reach to EOF"), ye);
  }
  function ve(me, Se, ye) {
    var be, $e, Oe;
    switch (me.type) {
      case T.NullableLiteral:
        be = "?";
        break;
      case T.AllLiteral:
        be = "*";
        break;
      case T.NullLiteral:
        be = "null";
        break;
      case T.UndefinedLiteral:
        be = "undefined";
        break;
      case T.VoidLiteral:
        be = "void";
        break;
      case T.UnionType:
        for (ye ? be = "" : be = "(", $e = 0, Oe = me.elements.length; $e < Oe; ++$e)
          be += ve(me.elements[$e], Se), $e + 1 !== Oe && (be += Se ? "|" : " | ");
        ye || (be += ")");
        break;
      case T.ArrayType:
        for (be = "[", $e = 0, Oe = me.elements.length; $e < Oe; ++$e)
          be += ve(me.elements[$e], Se), $e + 1 !== Oe && (be += Se ? "," : ", ");
        be += "]";
        break;
      case T.RecordType:
        for (be = "{", $e = 0, Oe = me.fields.length; $e < Oe; ++$e)
          be += ve(me.fields[$e], Se), $e + 1 !== Oe && (be += Se ? "," : ", ");
        be += "}";
        break;
      case T.FieldType:
        me.value ? be = me.key + (Se ? ":" : ": ") + ve(me.value, Se) : be = me.key;
        break;
      case T.FunctionType:
        for (be = Se ? "function(" : "function (", me.this && (me.new ? be += Se ? "new:" : "new: " : be += Se ? "this:" : "this: ", be += ve(me.this, Se), me.params.length !== 0 && (be += Se ? "," : ", ")), $e = 0, Oe = me.params.length; $e < Oe; ++$e)
          be += ve(me.params[$e], Se), $e + 1 !== Oe && (be += Se ? "," : ", ");
        be += ")", me.result && (be += (Se ? ":" : ": ") + ve(me.result, Se));
        break;
      case T.ParameterType:
        be = me.name + (Se ? ":" : ": ") + ve(me.expression, Se);
        break;
      case T.RestType:
        be = "...", me.expression && (be += ve(me.expression, Se));
        break;
      case T.NonNullableType:
        me.prefix ? be = "!" + ve(me.expression, Se) : be = ve(me.expression, Se) + "!";
        break;
      case T.OptionalType:
        be = ve(me.expression, Se) + "=";
        break;
      case T.NullableType:
        me.prefix ? be = "?" + ve(me.expression, Se) : be = ve(me.expression, Se) + "?";
        break;
      case T.NameExpression:
        be = me.name;
        break;
      case T.TypeApplication:
        for (be = ve(me.expression, Se) + ".<", $e = 0, Oe = me.applications.length; $e < Oe; ++$e)
          be += ve(me.applications[$e], Se), $e + 1 !== Oe && (be += Se ? "," : ", ");
        be += ">";
        break;
      case T.StringLiteralType:
        be = '"' + me.value + '"';
        break;
      case T.NumericLiteralType:
        be = String(me.value);
        break;
      case T.BooleanLiteralType:
        be = String(me.value);
        break;
      default:
        U.throwError("Unknown type " + me.type);
    }
    return be;
  }
  function le(me, Se) {
    return Se == null && (Se = {}), ve(me, Se.compact, Se.topLevel);
  }
  typed.parseType = Ae, typed.parseParamType = Ee, typed.stringify = le, typed.Syntax = T;
})();
(function(T) {
  (function() {
    var S, R, k, D, L;
    D = utils, S = typed, R = utility;
    function V(ae, se, ie) {
      return ae.slice(se, ie);
    }
    L = /* @__PURE__ */ function() {
      var ae = Object.prototype.hasOwnProperty;
      return function(ie, he) {
        return ae.call(ie, he);
      };
    }();
    function z(ae) {
      var se = {}, ie;
      for (ie in ae)
        ae.hasOwnProperty(ie) && (se[ie] = ae[ie]);
      return se;
    }
    function W(ae) {
      return ae >= 97 && ae <= 122 || ae >= 65 && ae <= 90 || ae >= 48 && ae <= 57;
    }
    function U(ae) {
      return ae === "param" || ae === "argument" || ae === "arg";
    }
    function q(ae) {
      return ae === "return" || ae === "returns";
    }
    function K(ae) {
      return ae === "property" || ae === "prop";
    }
    function Y(ae) {
      return U(ae) || K(ae) || ae === "alias" || ae === "this" || ae === "mixes" || ae === "requires";
    }
    function J(ae) {
      return Y(ae) || ae === "const" || ae === "constant";
    }
    function Z(ae) {
      return K(ae) || U(ae);
    }
    function X(ae) {
      return K(ae) || U(ae);
    }
    function ee(ae) {
      return U(ae) || q(ae) || ae === "define" || ae === "enum" || ae === "implements" || ae === "this" || ae === "type" || ae === "typedef" || K(ae);
    }
    function te(ae) {
      return ee(ae) || ae === "throws" || ae === "const" || ae === "constant" || ae === "namespace" || ae === "member" || ae === "var" || ae === "module" || ae === "constructor" || ae === "class" || ae === "extends" || ae === "augments" || ae === "public" || ae === "private" || ae === "protected";
    }
    var re = "[ \\f\\t\\v\\u00a0\\u1680\\u180e\\u2000-\\u200a\\u202f\\u205f\\u3000\\ufeff]", Q = "(" + re + "*(?:\\*" + re + `?)?)(.+|[\r
\u2028\u2029])`;
    function ne(ae) {
      return ae.replace(/^\/\*\*?/, "").replace(/\*\/$/, "").replace(new RegExp(Q, "g"), "$2").replace(/\s*$/, "");
    }
    function oe(ae, se) {
      for (var ie = ae.replace(/^\/\*\*?/, ""), he = 0, xe = new RegExp(Q, "g"), Pe; Pe = xe.exec(ie); )
        if (he += Pe[1].length, Pe.index + Pe[0].length > se + he)
          return se + he + ae.length - ie.length;
      return ae.replace(/\*\/$/, "").replace(/\s*$/, "").length;
    }
    (function(ae) {
      var se, ie, he, xe, Pe, Re, ke, Te, fe;
      function ue() {
        var be = Pe.charCodeAt(ie);
        return ie += 1, D.code.isLineTerminator(be) && !(be === 13 && Pe.charCodeAt(ie) === 10) && (he += 1), String.fromCharCode(be);
      }
      function Ce() {
        var be = "";
        for (ue(); ie < xe && W(Pe.charCodeAt(ie)); )
          be += ue();
        return be;
      }
      function ce() {
        var be, $e, Oe = ie;
        for ($e = !1; Oe < xe; ) {
          if (be = Pe.charCodeAt(Oe), D.code.isLineTerminator(be) && !(be === 13 && Pe.charCodeAt(Oe + 1) === 10))
            $e = !0;
          else if ($e) {
            if (be === 64)
              break;
            D.code.isWhiteSpace(be) || ($e = !1);
          }
          Oe += 1;
        }
        return Oe;
      }
      function pe(be, $e, Oe) {
        for (var Ie, we, Fe, De, Le = !1; ie < $e; )
          if (Ie = Pe.charCodeAt(ie), D.code.isWhiteSpace(Ie))
            ue();
          else if (Ie === 123) {
            ue();
            break;
          } else {
            Le = !0;
            break;
          }
        if (Le)
          return null;
        for (we = 1, Fe = ""; ie < $e; )
          if (Ie = Pe.charCodeAt(ie), D.code.isLineTerminator(Ie))
            ue();
          else {
            if (Ie === 125) {
              if (we -= 1, we === 0) {
                ue();
                break;
              }
            } else Ie === 123 && (we += 1);
            Fe === "" && (De = ie), Fe += ue();
          }
        return we !== 0 ? R.throwError("Braces are not balanced") : X(be) ? S.parseParamType(Fe, { startIndex: ve(De), range: Oe }) : S.parseType(Fe, { startIndex: ve(De), range: Oe });
      }
      function _e(be) {
        var $e;
        if (!D.code.isIdentifierStartES5(Pe.charCodeAt(ie)) && !Pe[ie].match(/[0-9]/))
          return null;
        for ($e = ue(); ie < be && D.code.isIdentifierPartES5(Pe.charCodeAt(ie)); )
          $e += ue();
        return $e;
      }
      function ge(be) {
        for (; ie < be && (D.code.isWhiteSpace(Pe.charCodeAt(ie)) || D.code.isLineTerminator(Pe.charCodeAt(ie))); )
          ue();
      }
      function Ae(be, $e, Oe) {
        var Ie = "", we, Fe;
        if (ge(be), ie >= be)
          return null;
        if (Pe.charCodeAt(ie) === 91)
          if ($e)
            we = !0, Ie = ue();
          else
            return null;
        if (Ie += _e(be), Oe)
          for (Pe.charCodeAt(ie) === 58 && (Ie === "module" || Ie === "external" || Ie === "event") && (Ie += ue(), Ie += _e(be)), Pe.charCodeAt(ie) === 91 && Pe.charCodeAt(ie + 1) === 93 && (Ie += ue(), Ie += ue()); Pe.charCodeAt(ie) === 46 || Pe.charCodeAt(ie) === 47 || Pe.charCodeAt(ie) === 35 || Pe.charCodeAt(ie) === 45 || Pe.charCodeAt(ie) === 126; )
            Ie += ue(), Ie += _e(be);
        if (we) {
          if (ge(be), Pe.charCodeAt(ie) === 61) {
            Ie += ue(), ge(be);
            for (var De, Le = 1; ie < be; ) {
              if (De = Pe.charCodeAt(ie), D.code.isWhiteSpace(De) && (Fe || (ge(be), De = Pe.charCodeAt(ie))), De === 39 && (Fe ? Fe === "'" && (Fe = "") : Fe = "'"), De === 34 && (Fe ? Fe === '"' && (Fe = "") : Fe = '"'), De === 91)
                Le++;
              else if (De === 93 && --Le === 0)
                break;
              Ie += ue();
            }
          }
          if (ge(be), ie >= be || Pe.charCodeAt(ie) !== 93)
            return null;
          Ie += ue();
        }
        return Ie;
      }
      function Ee() {
        for (; ie < xe && Pe.charCodeAt(ie) !== 64; )
          ue();
        return ie >= xe ? !1 : (R.assert(
          Pe.charCodeAt(ie) === 64
          /* '@' */
        ), !0);
      }
      function ve(be) {
        return Pe === Re ? be : oe(Re, be);
      }
      function le(be, $e) {
        this._options = be, this._title = $e.toLowerCase(), this._tag = {
          title: $e,
          description: null
        }, this._options.lineNumbers && (this._tag.lineNumber = he), this._first = ie - $e.length - 1, this._last = 0, this._extra = {};
      }
      le.prototype.addError = function($e) {
        var Oe = Array.prototype.slice.call(arguments, 1), Ie = $e.replace(
          /%(\d)/g,
          function(we, Fe) {
            return R.assert(Fe < Oe.length, "Message reference must be in range"), Oe[Fe];
          }
        );
        return this._tag.errors || (this._tag.errors = []), fe && R.throwError(Ie), this._tag.errors.push(Ie), ke;
      }, le.prototype.parseType = function() {
        if (ee(this._title))
          try {
            if (this._tag.type = pe(this._title, this._last, this._options.range), !this._tag.type && !U(this._title) && !q(this._title) && !this.addError("Missing or invalid tag type"))
              return !1;
          } catch (be) {
            if (this._tag.type = null, !this.addError(be.message))
              return !1;
          }
        else if (te(this._title))
          try {
            this._tag.type = pe(this._title, this._last, this._options.range);
          } catch {
          }
        return !0;
      }, le.prototype._parseNamePath = function(be) {
        var $e;
        return $e = Ae(this._last, Te && X(this._title), !0), !$e && !be && !this.addError("Missing or invalid tag name") ? !1 : (this._tag.name = $e, !0);
      }, le.prototype.parseNamePath = function() {
        return this._parseNamePath(!1);
      }, le.prototype.parseNamePathOptional = function() {
        return this._parseNamePath(!0);
      }, le.prototype.parseName = function() {
        var be, $e;
        if (J(this._title))
          if (this._tag.name = Ae(this._last, Te && X(this._title), Z(this._title)), this._tag.name)
            $e = this._tag.name, $e.charAt(0) === "[" && $e.charAt($e.length - 1) === "]" && (be = $e.substring(1, $e.length - 1).split("="), be.length > 1 && (this._tag.default = be.slice(1).join("=")), this._tag.name = be[0], this._tag.type && this._tag.type.type !== "OptionalType" && (this._tag.type = {
              type: "OptionalType",
              expression: this._tag.type
            }));
          else {
            if (!Y(this._title))
              return !0;
            if (U(this._title) && this._tag.type && this._tag.type.name)
              this._extra.name = this._tag.type, this._tag.name = this._tag.type.name, this._tag.type = null;
            else if (!this.addError("Missing or invalid tag name"))
              return !1;
          }
        return !0;
      }, le.prototype.parseDescription = function() {
        var $e = V(Pe, ie, this._last).trim();
        return $e && (/^-\s+/.test($e) && ($e = $e.substring(2)), this._tag.description = $e), !0;
      }, le.prototype.parseCaption = function() {
        var $e = V(Pe, ie, this._last).trim(), Oe = "<caption>", Ie = "</caption>", we = $e.indexOf(Oe), Fe = $e.indexOf(Ie);
        return we >= 0 && Fe >= 0 ? (this._tag.caption = $e.substring(
          we + Oe.length,
          Fe
        ).trim(), this._tag.description = $e.substring(Fe + Ie.length).trim()) : this._tag.description = $e, !0;
      }, le.prototype.parseKind = function() {
        var $e, Oe;
        return Oe = {
          class: !0,
          constant: !0,
          event: !0,
          external: !0,
          file: !0,
          function: !0,
          member: !0,
          mixin: !0,
          module: !0,
          namespace: !0,
          typedef: !0
        }, $e = V(Pe, ie, this._last).trim(), this._tag.kind = $e, !(!L(Oe, $e) && !this.addError("Invalid kind name '%0'", $e));
      }, le.prototype.parseAccess = function() {
        var $e;
        return $e = V(Pe, ie, this._last).trim(), this._tag.access = $e, !($e !== "private" && $e !== "protected" && $e !== "public" && !this.addError("Invalid access name '%0'", $e));
      }, le.prototype.parseThis = function() {
        var $e = V(Pe, ie, this._last).trim();
        if ($e && $e.charAt(0) === "{") {
          var Oe = this.parseType();
          return Oe && this._tag.type.type === "NameExpression" || this._tag.type.type === "UnionType" ? (this._tag.name = this._tag.type.name, !0) : this.addError("Invalid name for this");
        } else
          return this.parseNamePath();
      }, le.prototype.parseVariation = function() {
        var $e, Oe;
        return Oe = V(Pe, ie, this._last).trim(), $e = parseFloat(Oe, 10), this._tag.variation = $e, !(isNaN($e) && !this.addError("Invalid variation '%0'", Oe));
      }, le.prototype.ensureEnd = function() {
        var be = V(Pe, ie, this._last).trim();
        return !(be && !this.addError("Unknown content '%0'", be));
      }, le.prototype.epilogue = function() {
        var $e;
        return $e = this._tag.description, !(X(this._title) && !this._tag.type && $e && $e.charAt(0) === "[" && (this._tag.type = this._extra.name, this._tag.name || (this._tag.name = void 0), !Te && !this.addError("Missing or invalid tag name")));
      }, se = {
        // http://usejsdoc.org/tags-access.html
        access: ["parseAccess"],
        // http://usejsdoc.org/tags-alias.html
        alias: ["parseNamePath", "ensureEnd"],
        // http://usejsdoc.org/tags-augments.html
        augments: ["parseType", "parseNamePathOptional", "ensureEnd"],
        // http://usejsdoc.org/tags-constructor.html
        constructor: ["parseType", "parseNamePathOptional", "ensureEnd"],
        // Synonym: http://usejsdoc.org/tags-constructor.html
        class: ["parseType", "parseNamePathOptional", "ensureEnd"],
        // Synonym: http://usejsdoc.org/tags-extends.html
        extends: ["parseType", "parseNamePathOptional", "ensureEnd"],
        // http://usejsdoc.org/tags-example.html
        example: ["parseCaption"],
        // http://usejsdoc.org/tags-deprecated.html
        deprecated: ["parseDescription"],
        // http://usejsdoc.org/tags-global.html
        global: ["ensureEnd"],
        // http://usejsdoc.org/tags-inner.html
        inner: ["ensureEnd"],
        // http://usejsdoc.org/tags-instance.html
        instance: ["ensureEnd"],
        // http://usejsdoc.org/tags-kind.html
        kind: ["parseKind"],
        // http://usejsdoc.org/tags-mixes.html
        mixes: ["parseNamePath", "ensureEnd"],
        // http://usejsdoc.org/tags-mixin.html
        mixin: ["parseNamePathOptional", "ensureEnd"],
        // http://usejsdoc.org/tags-member.html
        member: ["parseType", "parseNamePathOptional", "ensureEnd"],
        // http://usejsdoc.org/tags-method.html
        method: ["parseNamePathOptional", "ensureEnd"],
        // http://usejsdoc.org/tags-module.html
        module: ["parseType", "parseNamePathOptional", "ensureEnd"],
        // Synonym: http://usejsdoc.org/tags-method.html
        func: ["parseNamePathOptional", "ensureEnd"],
        // Synonym: http://usejsdoc.org/tags-method.html
        function: ["parseNamePathOptional", "ensureEnd"],
        // Synonym: http://usejsdoc.org/tags-member.html
        var: ["parseType", "parseNamePathOptional", "ensureEnd"],
        // http://usejsdoc.org/tags-name.html
        name: ["parseNamePath", "ensureEnd"],
        // http://usejsdoc.org/tags-namespace.html
        namespace: ["parseType", "parseNamePathOptional", "ensureEnd"],
        // http://usejsdoc.org/tags-private.html
        private: ["parseType", "parseDescription"],
        // http://usejsdoc.org/tags-protected.html
        protected: ["parseType", "parseDescription"],
        // http://usejsdoc.org/tags-public.html
        public: ["parseType", "parseDescription"],
        // http://usejsdoc.org/tags-readonly.html
        readonly: ["ensureEnd"],
        // http://usejsdoc.org/tags-requires.html
        requires: ["parseNamePath", "ensureEnd"],
        // http://usejsdoc.org/tags-since.html
        since: ["parseDescription"],
        // http://usejsdoc.org/tags-static.html
        static: ["ensureEnd"],
        // http://usejsdoc.org/tags-summary.html
        summary: ["parseDescription"],
        // http://usejsdoc.org/tags-this.html
        this: ["parseThis", "ensureEnd"],
        // http://usejsdoc.org/tags-todo.html
        todo: ["parseDescription"],
        // http://usejsdoc.org/tags-typedef.html
        typedef: ["parseType", "parseNamePathOptional"],
        // http://usejsdoc.org/tags-variation.html
        variation: ["parseVariation"],
        // http://usejsdoc.org/tags-version.html
        version: ["parseDescription"]
      }, le.prototype.parse = function() {
        var $e, Oe, Ie, we;
        if (!this._title && !this.addError("Missing or invalid title"))
          return null;
        for (this._last = ce(this._title), this._options.range && (this._tag.range = [this._first, Pe.slice(0, this._last).replace(/\s*$/, "").length].map(ve)), L(se, this._title) ? Ie = se[this._title] : Ie = ["parseType", "parseName", "parseDescription", "epilogue"], $e = 0, Oe = Ie.length; $e < Oe; ++$e)
          if (we = Ie[$e], !this[we]())
            return null;
        return this._tag;
      };
      function me(be) {
        var $e, Oe, Ie;
        if (!Ee())
          return null;
        for ($e = Ce(), Oe = new le(be, $e), Ie = Oe.parse(); ie < Oe._last; )
          ue();
        return Ie;
      }
      function Se(be) {
        var $e = "", Oe, Ie;
        for (Ie = !0; ie < xe && (Oe = Pe.charCodeAt(ie), !(Ie && Oe === 64)); )
          D.code.isLineTerminator(Oe) ? Ie = !0 : Ie && !D.code.isWhiteSpace(Oe) && (Ie = !1), $e += ue();
        return be ? $e : $e.trim();
      }
      function ye(be, $e) {
        var Oe = [], Ie, we, Fe, De, Le;
        if ($e === void 0 && ($e = {}), typeof $e.unwrap == "boolean" && $e.unwrap ? Pe = ne(be) : Pe = be, Re = be, $e.tags)
          if (Array.isArray($e.tags))
            for (Fe = {}, De = 0, Le = $e.tags.length; De < Le; De++)
              typeof $e.tags[De] == "string" ? Fe[$e.tags[De]] = !0 : R.throwError('Invalid "tags" parameter: ' + $e.tags);
          else
            R.throwError('Invalid "tags" parameter: ' + $e.tags);
        for (xe = Pe.length, ie = 0, he = 0, ke = $e.recoverable, Te = $e.sloppy, fe = $e.strict, we = Se($e.preserveWhitespace); Ie = me($e), !!Ie; )
          (!Fe || Fe.hasOwnProperty(Ie.title)) && Oe.push(Ie);
        return {
          description: we,
          tags: Oe
        };
      }
      ae.parse = ye;
    })(k = {}), T.version = R.VERSION, T.parse = k.parse, T.parseType = S.parseType, T.parseParamType = S.parseParamType, T.unwrapComment = ne, T.Syntax = z(S.Syntax), T.Error = R.DoctrineError, T.type = {
      Syntax: T.Syntax,
      parseType: S.parseType,
      parseParamType: S.parseParamType,
      stringify: S.stringify
    };
  })();
})(doctrine);
var TypeSystem = ((T) => (T.JAVASCRIPT = "JavaScript", T.FLOW = "Flow", T.TYPESCRIPT = "TypeScript", T.UNKNOWN = "Unknown", T))(TypeSystem || {}), SourceType = ((T) => (T.AUTO = "auto", T.CODE = "code", T.DYNAMIC = "dynamic", T))(SourceType || {}), Wrapper$1 = newStyled.div(withReset, ({ theme: T }) => ({ backgroundColor: T.base === "light" ? "rgba(0,0,0,.01)" : "rgba(255,255,255,.01)", borderRadius: T.appBorderRadius, border: `1px dashed ${T.appBorderColor}`, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, margin: "25px 0 40px", color: curriedTransparentize$1(0.3, T.color.defaultText), fontSize: T.typography.size.s2 })), EmptyBlock = (T) => React__default.createElement(Wrapper$1, { ...T, className: "docblock-emptyblock sb-unstyled" }), StyledSyntaxHighlighter = newStyled(SyntaxHighlighter2)(({ theme: T }) => ({ fontSize: `${T.typography.size.s2 - 1}px`, lineHeight: "19px", margin: "25px 0 40px", borderRadius: T.appBorderRadius, boxShadow: T.base === "light" ? "rgba(0, 0, 0, 0.10) 0 1px 3px 0" : "rgba(0, 0, 0, 0.20) 0 2px 5px 0", "pre.prismjs": { padding: 20, background: "inherit" } })), SourceSkeletonWrapper = newStyled.div(({ theme: T }) => ({ background: T.background.content, borderRadius: T.appBorderRadius, border: `1px solid ${T.appBorderColor}`, boxShadow: T.base === "light" ? "rgba(0, 0, 0, 0.10) 0 1px 3px 0" : "rgba(0, 0, 0, 0.20) 0 2px 5px 0", margin: "25px 0 40px", padding: "20px 20px 20px 22px" })), SourceSkeletonPlaceholder = newStyled.div(({ theme: T }) => ({ animation: `${T.animation.glow} 1.5s ease-in-out infinite`, background: T.appBorderColor, height: 17, marginTop: 1, width: "60%", [`&:first-child${ignoreSsrWarning}`]: { margin: 0 } })), SourceSkeleton = () => React__default.createElement(SourceSkeletonWrapper, null, React__default.createElement(SourceSkeletonPlaceholder, null), React__default.createElement(SourceSkeletonPlaceholder, { style: { width: "80%" } }), React__default.createElement(SourceSkeletonPlaceholder, { style: { width: "30%" } }), React__default.createElement(SourceSkeletonPlaceholder, { style: { width: "80%" } })), Source = ({ isLoading: T, error: S, language: R, code: k, dark: D, format: L = !1, ...V }) => {
  let { typography: z } = useTheme$5();
  if (T) return React__default.createElement(SourceSkeleton, null);
  if (S) return React__default.createElement(EmptyBlock, null, S);
  let W = React__default.createElement(StyledSyntaxHighlighter, { bordered: !0, copyable: !0, format: L, language: R, className: "docblock-source sb-unstyled", ...V }, k);
  if (typeof D > "u") return W;
  let U = D ? themes.dark : themes.light;
  return React__default.createElement(ThemeProvider$4, { theme: convert({ ...U, fontCode: z.fonts.mono, fontBase: z.fonts.base }) }, W);
}, toGlobalSelector = (T) => `& :where(${T}:not(.sb-anchor, .sb-unstyled, .sb-unstyled ${T}))`, breakpoint = 600;
newStyled.h1(withReset, ({ theme: T }) => ({ color: T.color.defaultText, fontSize: T.typography.size.m3, fontWeight: T.typography.weight.bold, lineHeight: "32px", [`@media (min-width: ${breakpoint}px)`]: { fontSize: T.typography.size.l1, lineHeight: "36px", marginBottom: "16px" } }));
newStyled.h2(withReset, ({ theme: T }) => ({ fontWeight: T.typography.weight.regular, fontSize: T.typography.size.s3, lineHeight: "20px", borderBottom: "none", marginBottom: 15, [`@media (min-width: ${breakpoint}px)`]: { fontSize: T.typography.size.m1, lineHeight: "28px", marginBottom: 24 }, color: curriedTransparentize$1(0.25, T.color.defaultText) }));
newStyled.div(({ theme: T }) => {
  let S = { fontFamily: T.typography.fonts.base, fontSize: T.typography.size.s3, margin: 0, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale", WebkitTapHighlightColor: "rgba(0, 0, 0, 0)", WebkitOverflowScrolling: "touch" }, R = { margin: "20px 0 8px", padding: 0, cursor: "text", position: "relative", color: T.color.defaultText, "&:first-of-type": { marginTop: 0, paddingTop: 0 }, "&:hover a.anchor": { textDecoration: "none" }, "& code": { fontSize: "inherit" } }, k = { lineHeight: 1, margin: "0 2px", padding: "3px 5px", whiteSpace: "nowrap", borderRadius: 3, fontSize: T.typography.size.s2 - 1, border: T.base === "light" ? `1px solid ${T.color.mediumlight}` : `1px solid ${T.color.darker}`, color: T.base === "light" ? curriedTransparentize$1(0.1, T.color.defaultText) : curriedTransparentize$1(0.3, T.color.defaultText), backgroundColor: T.base === "light" ? T.color.lighter : T.color.border };
  return { maxWidth: 1e3, width: "100%", [toGlobalSelector("a")]: { ...S, fontSize: "inherit", lineHeight: "24px", color: T.color.secondary, textDecoration: "none", "&.absent": { color: "#cc0000" }, "&.anchor": { display: "block", paddingLeft: 30, marginLeft: -30, cursor: "pointer", position: "absolute", top: 0, left: 0, bottom: 0 } }, [toGlobalSelector("blockquote")]: { ...S, margin: "16px 0", borderLeft: `4px solid ${T.color.medium}`, padding: "0 15px", color: T.color.dark, "& > :first-of-type": { marginTop: 0 }, "& > :last-child": { marginBottom: 0 } }, [toGlobalSelector("div")]: S, [toGlobalSelector("dl")]: { ...S, margin: "16px 0", padding: 0, "& dt": { fontSize: "14px", fontWeight: "bold", fontStyle: "italic", padding: 0, margin: "16px 0 4px" }, "& dt:first-of-type": { padding: 0 }, "& dt > :first-of-type": { marginTop: 0 }, "& dt > :last-child": { marginBottom: 0 }, "& dd": { margin: "0 0 16px", padding: "0 15px" }, "& dd > :first-of-type": { marginTop: 0 }, "& dd > :last-child": { marginBottom: 0 } }, [toGlobalSelector("h1")]: { ...S, ...R, fontSize: `${T.typography.size.l1}px`, fontWeight: T.typography.weight.bold }, [toGlobalSelector("h2")]: { ...S, ...R, fontSize: `${T.typography.size.m2}px`, paddingBottom: 4, borderBottom: `1px solid ${T.appBorderColor}` }, [toGlobalSelector("h3")]: { ...S, ...R, fontSize: `${T.typography.size.m1}px`, fontWeight: T.typography.weight.bold }, [toGlobalSelector("h4")]: { ...S, ...R, fontSize: `${T.typography.size.s3}px` }, [toGlobalSelector("h5")]: { ...S, ...R, fontSize: `${T.typography.size.s2}px` }, [toGlobalSelector("h6")]: { ...S, ...R, fontSize: `${T.typography.size.s2}px`, color: T.color.dark }, [toGlobalSelector("hr")]: { border: "0 none", borderTop: `1px solid ${T.appBorderColor}`, height: 4, padding: 0 }, [toGlobalSelector("img")]: { maxWidth: "100%" }, [toGlobalSelector("li")]: { ...S, fontSize: T.typography.size.s2, color: T.color.defaultText, lineHeight: "24px", "& + li": { marginTop: ".25em" }, "& ul, & ol": { marginTop: ".25em", marginBottom: 0 }, "& code": k }, [toGlobalSelector("ol")]: { ...S, margin: "16px 0", paddingLeft: 30, "& :first-of-type": { marginTop: 0 }, "& :last-child": { marginBottom: 0 } }, [toGlobalSelector("p")]: { ...S, margin: "16px 0", fontSize: T.typography.size.s2, lineHeight: "24px", color: T.color.defaultText, "& code": k }, [toGlobalSelector("pre")]: { ...S, fontFamily: T.typography.fonts.mono, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale", lineHeight: "18px", padding: "11px 1rem", whiteSpace: "pre-wrap", color: "inherit", borderRadius: 3, margin: "1rem 0", "&:not(.prismjs)": { background: "transparent", border: "none", borderRadius: 0, padding: 0, margin: 0 }, "& pre, &.prismjs": { padding: 15, margin: 0, whiteSpace: "pre-wrap", color: "inherit", fontSize: "13px", lineHeight: "19px", code: { color: "inherit", fontSize: "inherit" } }, "& code": { whiteSpace: "pre" }, "& code, & tt": { border: "none" } }, [toGlobalSelector("span")]: { ...S, "&.frame": { display: "block", overflow: "hidden", "& > span": { border: `1px solid ${T.color.medium}`, display: "block", float: "left", overflow: "hidden", margin: "13px 0 0", padding: 7, width: "auto" }, "& span img": { display: "block", float: "left" }, "& span span": { clear: "both", color: T.color.darkest, display: "block", padding: "5px 0 0" } }, "&.align-center": { display: "block", overflow: "hidden", clear: "both", "& > span": { display: "block", overflow: "hidden", margin: "13px auto 0", textAlign: "center" }, "& span img": { margin: "0 auto", textAlign: "center" } }, "&.align-right": { display: "block", overflow: "hidden", clear: "both", "& > span": { display: "block", overflow: "hidden", margin: "13px 0 0", textAlign: "right" }, "& span img": { margin: 0, textAlign: "right" } }, "&.float-left": { display: "block", marginRight: 13, overflow: "hidden", float: "left", "& span": { margin: "13px 0 0" } }, "&.float-right": { display: "block", marginLeft: 13, overflow: "hidden", float: "right", "& > span": { display: "block", overflow: "hidden", margin: "13px auto 0", textAlign: "right" } } }, [toGlobalSelector("table")]: { ...S, margin: "16px 0", fontSize: T.typography.size.s2, lineHeight: "24px", padding: 0, borderCollapse: "collapse", "& tr": { borderTop: `1px solid ${T.appBorderColor}`, backgroundColor: T.appContentBg, margin: 0, padding: 0 }, "& tr:nth-of-type(2n)": { backgroundColor: T.base === "dark" ? T.color.darker : T.color.lighter }, "& tr th": { fontWeight: "bold", color: T.color.defaultText, border: `1px solid ${T.appBorderColor}`, margin: 0, padding: "6px 13px" }, "& tr td": { border: `1px solid ${T.appBorderColor}`, color: T.color.defaultText, margin: 0, padding: "6px 13px" }, "& tr th :first-of-type, & tr td :first-of-type": { marginTop: 0 }, "& tr th :last-child, & tr td :last-child": { marginBottom: 0 } }, [toGlobalSelector("ul")]: { ...S, margin: "16px 0", paddingLeft: 30, "& :first-of-type": { marginTop: 0 }, "& :last-child": { marginBottom: 0 }, listStyle: "disc" } };
});
newStyled.div(({ theme: T }) => ({ background: T.background.content, display: "flex", justifyContent: "center", padding: "4rem 20px", minHeight: "100vh", boxSizing: "border-box", gap: "3rem", [`@media (min-width: ${breakpoint}px)`]: {} }));
var getBlockBackgroundStyle = (T) => ({ borderRadius: T.appBorderRadius, background: T.background.content, boxShadow: T.base === "light" ? "rgba(0, 0, 0, 0.10) 0 1px 3px 0" : "rgba(0, 0, 0, 0.20) 0 2px 5px 0", border: `1px solid ${T.appBorderColor}` }), Bar = newStyled(FlexBar)({ position: "absolute", left: 0, right: 0, top: 0, transition: "transform .2s linear" }), Wrapper2 = newStyled.div({ display: "flex", alignItems: "center", gap: 4 }), IconPlaceholder = newStyled.div(({ theme: T }) => ({ width: 14, height: 14, borderRadius: 2, margin: "0 7px", backgroundColor: T.appBorderColor, animation: `${T.animation.glow} 1.5s ease-in-out infinite` })), Toolbar = ({ isLoading: T, storyId: S, baseUrl: R, zoom: k, resetZoom: D, ...L }) => React__default.createElement(Bar, { ...L }, React__default.createElement(Wrapper2, { key: "left" }, T ? [1, 2, 3].map((V) => React__default.createElement(IconPlaceholder, { key: V })) : React__default.createElement(React__default.Fragment, null, React__default.createElement(IconButton$1, { key: "zoomin", onClick: (V) => {
  V.preventDefault(), k(0.8);
}, title: "Zoom in" }, React__default.createElement(ZoomIcon, null)), React__default.createElement(IconButton$1, { key: "zoomout", onClick: (V) => {
  V.preventDefault(), k(1.25);
}, title: "Zoom out" }, React__default.createElement(ZoomOutIcon, null)), React__default.createElement(IconButton$1, { key: "zoomreset", onClick: (V) => {
  V.preventDefault(), D();
}, title: "Reset zoom" }, React__default.createElement(ZoomResetIcon, null))))), ZoomContext = createContext$1({ scale: 1 }), ChildrenContainer = newStyled.div(({ isColumn: T, columns: S, layout: R }) => ({ display: T || !S ? "block" : "flex", position: "relative", flexWrap: "wrap", overflow: "auto", flexDirection: T ? "column" : "row", "& .innerZoomElementWrapper > *": T ? { width: R !== "fullscreen" ? "calc(100% - 20px)" : "100%", display: "block" } : { maxWidth: R !== "fullscreen" ? "calc(100% - 20px)" : "100%", display: "inline-block" } }), ({ layout: T = "padded" }) => T === "centered" || T === "padded" ? { padding: "30px 20px", "& .innerZoomElementWrapper > *": { width: "auto", border: "10px solid transparent!important" } } : {}, ({ layout: T = "padded" }) => T === "centered" ? { display: "flex", justifyContent: "center", justifyItems: "center", alignContent: "center", alignItems: "center" } : {}, ({ columns: T }) => T && T > 1 ? { ".innerZoomElementWrapper > *": { minWidth: `calc(100% / ${T} - 20px)` } } : {}), StyledSource = newStyled(Source)(({ theme: T }) => ({ margin: 0, borderTopLeftRadius: 0, borderTopRightRadius: 0, borderBottomLeftRadius: T.appBorderRadius, borderBottomRightRadius: T.appBorderRadius, border: "none", background: T.base === "light" ? "rgba(0, 0, 0, 0.85)" : curriedDarken$1(0.05, T.background.content), color: T.color.lightest, button: { background: T.base === "light" ? "rgba(0, 0, 0, 0.85)" : curriedDarken$1(0.05, T.background.content) } })), PreviewContainer = newStyled.div(({ theme: T, withSource: S, isExpanded: R }) => ({ position: "relative", overflow: "hidden", margin: "25px 0 40px", ...getBlockBackgroundStyle(T), borderBottomLeftRadius: S && R && 0, borderBottomRightRadius: S && R && 0, borderBottomWidth: R && 0, "h3 + &": { marginTop: "16px" } }), ({ withToolbar: T }) => T && { paddingTop: 40 }), getSource = (T, S, R) => {
  switch (!0) {
    case !!(T && T.error):
      return { source: null, actionItem: { title: "No code available", className: "docblock-code-toggle docblock-code-toggle--disabled", disabled: !0, onClick: () => R(!1) } };
    case S:
      return { source: React__default.createElement(StyledSource, { ...T, dark: !0 }), actionItem: { title: "Hide code", className: "docblock-code-toggle docblock-code-toggle--expanded", onClick: () => R(!1) } };
    default:
      return { source: React__default.createElement(StyledSource, { ...T, dark: !0 }), actionItem: { title: "Show code", className: "docblock-code-toggle", onClick: () => R(!0) } };
  }
};
function getStoryId(T) {
  if (Children.count(T) === 1) {
    let S = T;
    if (S.props) return S.props.id;
  }
  return null;
}
var PositionedToolbar = newStyled(Toolbar)({ position: "absolute", top: 0, left: 0, right: 0, height: 40 }), Relative = newStyled.div({ overflow: "hidden", position: "relative" }), Preview = ({ isLoading: T, isColumn: S, columns: R, children: k, withSource: D, withToolbar: L = !1, isExpanded: V = !1, additionalActions: z, className: W, layout: U = "padded", ...q }) => {
  let [K, Y] = useState$1(V), { source: J, actionItem: Z } = getSource(D, K, Y), [X, ee] = useState$1(1), te = [W].concat(["sbdocs", "sbdocs-preview", "sb-unstyled"]), re = D ? [Z] : [], [Q, ne] = useState$1(z ? [...z] : []), oe = [...re, ...Q], { window: ae } = scope, se = useCallback(async (he) => {
    let { createCopyToClipboardFunction: xe } = await Promise.resolve().then(() => index$4);
    xe();
  }, []), ie = (he) => {
    let xe = ae.getSelection();
    xe && xe.type === "Range" || (he.preventDefault(), Q.filter((Pe) => Pe.title === "Copied").length === 0 && se(J.props.code).then(() => {
      ne([...Q, { title: "Copied", onClick: () => {
      } }]), ae.setTimeout(() => ne(Q.filter((Pe) => Pe.title !== "Copied")), 1500);
    }));
  };
  return React__default.createElement(PreviewContainer, { withSource: D, withToolbar: L, ...q, className: te.join(" ") }, L && React__default.createElement(PositionedToolbar, { isLoading: T, border: !0, zoom: (he) => ee(X * he), resetZoom: () => ee(1), storyId: getStoryId(k), baseUrl: "./iframe.html" }), React__default.createElement(ZoomContext.Provider, { value: { scale: X } }, React__default.createElement(Relative, { className: "docs-story", onCopyCapture: D && ie }, React__default.createElement(ChildrenContainer, { isColumn: S || !Array.isArray(k), columns: R, layout: U }, React__default.createElement(Zoom.Element, { scale: X }, Array.isArray(k) ? k.map((he, xe) => React__default.createElement("div", { key: xe }, he)) : React__default.createElement("div", null, k))), React__default.createElement(ActionBar, { actionItems: oe }))), D && K && J);
};
newStyled(Preview)(() => ({ ".docs-story": { paddingTop: 32, paddingBottom: 40 } }));
newStyled.table(({ theme: T }) => ({ "&&": { borderCollapse: "collapse", borderSpacing: 0, border: "none", tr: { border: "none !important", background: "none" }, "td, th": { padding: 0, border: "none", width: "auto!important" }, marginTop: 0, marginBottom: 0, "th:first-of-type, td:first-of-type": { paddingLeft: 0 }, "th:last-of-type, td:last-of-type": { paddingRight: 0 }, td: { paddingTop: 0, paddingBottom: 4, "&:not(:first-of-type)": { paddingLeft: 10, paddingRight: 0 } }, tbody: { boxShadow: "none", border: "none" }, code: codeCommon({ theme: T }), div: { span: { fontWeight: "bold" } }, "& code": { margin: 0, display: "inline-block", fontSize: T.typography.size.s1 } } }));
newStyled.div(({ isExpanded: T }) => ({ display: "flex", flexDirection: T ? "column" : "row", flexWrap: "wrap", alignItems: "flex-start", marginBottom: "-4px", minWidth: 100 }));
newStyled.span(codeCommon, ({ theme: T, simple: S = !1 }) => ({ flex: "0 0 auto", fontFamily: T.typography.fonts.mono, fontSize: T.typography.size.s1, wordBreak: "break-word", whiteSpace: "normal", maxWidth: "100%", margin: 0, marginRight: "4px", marginBottom: "4px", paddingTop: "2px", paddingBottom: "2px", lineHeight: "13px", ...S && { background: "transparent", border: "0 none", paddingLeft: 0 } }));
newStyled.button(({ theme: T }) => ({ fontFamily: T.typography.fonts.mono, color: T.color.secondary, marginBottom: "4px", background: "none", border: "none" }));
newStyled.div(codeCommon, ({ theme: T }) => ({ fontFamily: T.typography.fonts.mono, color: T.color.secondary, fontSize: T.typography.size.s1, margin: 0, whiteSpace: "nowrap", display: "flex", alignItems: "center" }));
newStyled.div(({ theme: T, width: S }) => ({ width: S, minWidth: 200, maxWidth: 800, padding: 15, fontFamily: T.typography.fonts.mono, fontSize: T.typography.size.s1, boxSizing: "content-box", "& code": { padding: "0 !important" } }));
newStyled(ChevronSmallUpIcon)({ marginLeft: 4 });
newStyled(ChevronSmallDownIcon)({ marginLeft: 4 });
memoize$3(1e3)((T) => {
  let S = T.split(/\r?\n/);
  return `${Math.max(...S.map((R) => R.length))}ch`;
});
newStyled.label(({ theme: T }) => ({ lineHeight: "18px", alignItems: "center", marginBottom: 8, display: "inline-block", position: "relative", whiteSpace: "nowrap", background: T.boolean.background, borderRadius: "3em", padding: 1, '&[aria-disabled="true"]': { opacity: 0.5, input: { cursor: "not-allowed" } }, input: { appearance: "none", width: "100%", height: "100%", position: "absolute", left: 0, top: 0, margin: 0, padding: 0, border: "none", background: "transparent", cursor: "pointer", borderRadius: "3em", "&:focus": { outline: "none", boxShadow: `${T.color.secondary} 0 0 0 1px inset !important` } }, span: { textAlign: "center", fontSize: T.typography.size.s1, fontWeight: T.typography.weight.bold, lineHeight: "1", cursor: "pointer", display: "inline-block", padding: "7px 15px", transition: "all 100ms ease-out", userSelect: "none", borderRadius: "3em", color: curriedTransparentize$1(0.5, T.color.defaultText), background: "transparent", "&:hover": { boxShadow: `${curriedOpacify$1(0.3, T.appBorderColor)} 0 0 0 1px inset` }, "&:active": { boxShadow: `${curriedOpacify$1(0.05, T.appBorderColor)} 0 0 0 2px inset`, color: curriedOpacify$1(1, T.appBorderColor) }, "&:first-of-type": { paddingRight: 8 }, "&:last-of-type": { paddingLeft: 8 } }, "input:checked ~ span:last-of-type, input:not(:checked) ~ span:first-of-type": { background: T.boolean.selectedBackground, boxShadow: T.base === "light" ? `${curriedOpacify$1(0.1, T.appBorderColor)} 0 0 2px` : `${T.appBorderColor} 0 0 0 1px`, color: T.color.defaultText, padding: "7px 15px" } }));
newStyled(Form.Input)(({ readOnly: T }) => ({ opacity: T ? 0.5 : 1 }));
newStyled.div(({ theme: T }) => ({ flex: 1, display: "flex", input: { marginLeft: 10, flex: 1, height: 32, "&::-webkit-calendar-picker-indicator": { opacity: 0.5, height: 12, filter: T.base === "light" ? void 0 : "invert(1)" } }, "input:first-of-type": { marginLeft: 0, flexGrow: 4 }, "input:last-of-type": { flexGrow: 3 } }));
newStyled.label({ display: "flex" });
newStyled(Form.Input)(({ readOnly: T }) => ({ opacity: T ? 0.5 : 1 }));
newStyled.div(({ isInline: T }) => T ? { display: "flex", flexWrap: "wrap", alignItems: "flex-start", label: { display: "inline-flex", marginRight: 15 } } : { label: { display: "flex" } }, (T) => {
  if (T["aria-readonly"] === "true") return { input: { cursor: "not-allowed" } };
});
newStyled.span({ "[aria-readonly=true] &": { opacity: 0.5 } });
newStyled.label({ lineHeight: "20px", alignItems: "center", marginBottom: 8, "&:last-child": { marginBottom: 0 }, input: { margin: 0, marginRight: 6 } });
newStyled.div(({ isInline: T }) => T ? { display: "flex", flexWrap: "wrap", alignItems: "flex-start", label: { display: "inline-flex", marginRight: 15 } } : { label: { display: "flex" } }, (T) => {
  if (T["aria-readonly"] === "true") return { input: { cursor: "not-allowed" } };
});
newStyled.span({ "[aria-readonly=true] &": { opacity: 0.5 } });
newStyled.label({ lineHeight: "20px", alignItems: "center", marginBottom: 8, "&:last-child": { marginBottom: 0 }, input: { margin: 0, marginRight: 6 } });
var styleResets = { appearance: "none", border: "0 none", boxSizing: "inherit", display: " block", margin: " 0", background: "transparent", padding: 0, fontSize: "inherit", position: "relative" };
newStyled.select(styleResets, ({ theme: T }) => ({ boxSizing: "border-box", position: "relative", padding: "6px 10px", width: "100%", color: T.input.color || "inherit", background: T.input.background, borderRadius: T.input.borderRadius, boxShadow: `${T.input.border} 0 0 0 1px inset`, fontSize: T.typography.size.s2 - 1, lineHeight: "20px", "&:focus": { boxShadow: `${T.color.secondary} 0 0 0 1px inset`, outline: "none" }, "&[disabled]": { cursor: "not-allowed", opacity: 0.5 }, "::placeholder": { color: T.textMutedColor }, "&[multiple]": { overflow: "auto", padding: 0, option: { display: "block", padding: "6px 10px", marginLeft: 1, marginRight: 1 } } }));
newStyled.span(({ theme: T }) => ({ display: "inline-block", lineHeight: "normal", overflow: "hidden", position: "relative", verticalAlign: "top", width: "100%", svg: { position: "absolute", zIndex: 1, pointerEvents: "none", height: "12px", marginTop: "-6px", right: "12px", top: "50%", fill: T.textMutedColor, path: { fill: T.textMutedColor } } }));
var VALUE = "value", KEY = "key", ERROR = "Error", OBJECT = "Object", ARRAY = "Array", STRING = "String", NUMBER = "Number", BOOLEAN = "Boolean", DATE = "Date", NULL = "Null", UNDEFINED = "Undefined", FUNCTION = "Function", SYMBOL = "Symbol", ADD_DELTA_TYPE = "ADD_DELTA_TYPE", REMOVE_DELTA_TYPE = "REMOVE_DELTA_TYPE", UPDATE_DELTA_TYPE = "UPDATE_DELTA_TYPE";
function getObjectType(T) {
  return T !== null && typeof T == "object" && !Array.isArray(T) && typeof T[Symbol.iterator] == "function" ? "Iterable" : Object.prototype.toString.call(T).slice(8, -1);
}
function isComponentWillChange(T, S) {
  let R = getObjectType(T), k = getObjectType(S);
  return (R === "Function" || k === "Function") && k !== R;
}
var JsonAddValue = class extends Component {
  constructor(T) {
    super(T), this.state = { inputRefKey: null, inputRefValue: null }, this.refInputValue = this.refInputValue.bind(this), this.refInputKey = this.refInputKey.bind(this), this.onKeydown = this.onKeydown.bind(this), this.onSubmit = this.onSubmit.bind(this);
  }
  componentDidMount() {
    let { inputRefKey: T, inputRefValue: S } = this.state, { onlyValue: R } = this.props;
    T && typeof T.focus == "function" && T.focus(), R && S && typeof S.focus == "function" && S.focus(), document.addEventListener("keydown", this.onKeydown);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeydown);
  }
  onKeydown(T) {
    T.altKey || T.ctrlKey || T.metaKey || T.shiftKey || T.repeat || ((T.code === "Enter" || T.key === "Enter") && (T.preventDefault(), this.onSubmit()), (T.code === "Escape" || T.key === "Escape") && (T.preventDefault(), this.props.handleCancel()));
  }
  onSubmit() {
    let { handleAdd: T, onlyValue: S, onSubmitValueParser: R, keyPath: k, deep: D } = this.props, { inputRefKey: L, inputRefValue: V } = this.state, z = {};
    if (!S) {
      if (!L.value) return;
      z.key = L.value;
    }
    z.newValue = R(!1, k, D, z.key, V.value), T(z);
  }
  refInputKey(T) {
    this.state.inputRefKey = T;
  }
  refInputValue(T) {
    this.state.inputRefValue = T;
  }
  render() {
    let { handleCancel: T, onlyValue: S, addButtonElement: R, cancelButtonElement: k, inputElementGenerator: D, keyPath: L, deep: V } = this.props, z = cloneElement(R, { onClick: this.onSubmit }), W = cloneElement(k, { onClick: T }), U = D(VALUE, L, V), q = cloneElement(U, { placeholder: "Value", ref: this.refInputValue }), K = null;
    if (!S) {
      let Y = D(KEY, L, V);
      K = cloneElement(Y, { placeholder: "Key", ref: this.refInputKey });
    }
    return React__default.createElement("span", { className: "rejt-add-value-node" }, K, q, W, z);
  }
};
JsonAddValue.defaultProps = { onlyValue: !1, addButtonElement: React__default.createElement("button", null, "+"), cancelButtonElement: React__default.createElement("button", null, "c") };
var JsonArray = class extends Component {
  constructor(T) {
    super(T);
    let S = [...T.keyPath, T.name];
    this.state = { data: T.data, name: T.name, keyPath: S, deep: T.deep, nextDeep: T.deep + 1, collapsed: T.isCollapsed(S, T.deep, T.data), addFormVisible: !1 }, this.handleCollapseMode = this.handleCollapseMode.bind(this), this.handleRemoveItem = this.handleRemoveItem.bind(this), this.handleAddMode = this.handleAddMode.bind(this), this.handleAddValueAdd = this.handleAddValueAdd.bind(this), this.handleAddValueCancel = this.handleAddValueCancel.bind(this), this.handleEditValue = this.handleEditValue.bind(this), this.onChildUpdate = this.onChildUpdate.bind(this), this.renderCollapsed = this.renderCollapsed.bind(this), this.renderNotCollapsed = this.renderNotCollapsed.bind(this);
  }
  static getDerivedStateFromProps(T, S) {
    return T.data !== S.data ? { data: T.data } : null;
  }
  onChildUpdate(T, S) {
    let { data: R, keyPath: k } = this.state;
    R[T] = S, this.setState({ data: R });
    let { onUpdate: D } = this.props, L = k.length;
    D(k[L - 1], R);
  }
  handleAddMode() {
    this.setState({ addFormVisible: !0 });
  }
  handleCollapseMode() {
    this.setState((T) => ({ collapsed: !T.collapsed }));
  }
  handleRemoveItem(T) {
    return () => {
      let { beforeRemoveAction: S, logger: R } = this.props, { data: k, keyPath: D, nextDeep: L } = this.state, V = k[T];
      S(T, D, L, V).then(() => {
        let z = { keyPath: D, deep: L, key: T, oldValue: V, type: REMOVE_DELTA_TYPE };
        k.splice(T, 1), this.setState({ data: k });
        let { onUpdate: W, onDeltaUpdate: U } = this.props;
        W(D[D.length - 1], k), U(z);
      }).catch(R.error);
    };
  }
  handleAddValueAdd({ newValue: T }) {
    let { data: S, keyPath: R, nextDeep: k } = this.state, { beforeAddAction: D, logger: L } = this.props;
    D(S.length, R, k, T).then(() => {
      let V = [...S, T];
      this.setState({ data: V }), this.handleAddValueCancel();
      let { onUpdate: z, onDeltaUpdate: W } = this.props;
      z(R[R.length - 1], V), W({ type: ADD_DELTA_TYPE, keyPath: R, deep: k, key: V.length - 1, newValue: T });
    }).catch(L.error);
  }
  handleAddValueCancel() {
    this.setState({ addFormVisible: !1 });
  }
  handleEditValue({ key: T, value: S }) {
    return new Promise((R, k) => {
      let { beforeUpdateAction: D } = this.props, { data: L, keyPath: V, nextDeep: z } = this.state, W = L[T];
      D(T, V, z, W, S).then(() => {
        L[T] = S, this.setState({ data: L });
        let { onUpdate: U, onDeltaUpdate: q } = this.props;
        U(V[V.length - 1], L), q({ type: UPDATE_DELTA_TYPE, keyPath: V, deep: z, key: T, newValue: S, oldValue: W }), R(void 0);
      }).catch(k);
    });
  }
  renderCollapsed() {
    let { name: T, data: S, keyPath: R, deep: k } = this.state, { handleRemove: D, readOnly: L, getStyle: V, dataType: z, minusMenuElement: W } = this.props, { minus: U, collapsed: q } = V(T, S, R, k, z), K = L(T, S, R, k, z), Y = cloneElement(W, { onClick: D, className: "rejt-minus-menu", style: U });
    return React__default.createElement("span", { className: "rejt-collapsed" }, React__default.createElement("span", { className: "rejt-collapsed-text", style: q, onClick: this.handleCollapseMode }, "[...] ", S.length, " ", S.length === 1 ? "item" : "items"), !K && Y);
  }
  renderNotCollapsed() {
    let { name: T, data: S, keyPath: R, deep: k, addFormVisible: D, nextDeep: L } = this.state, { isCollapsed: V, handleRemove: z, onDeltaUpdate: W, readOnly: U, getStyle: q, dataType: K, addButtonElement: Y, cancelButtonElement: J, editButtonElement: Z, inputElementGenerator: X, textareaElementGenerator: ee, minusMenuElement: te, plusMenuElement: re, beforeRemoveAction: Q, beforeAddAction: ne, beforeUpdateAction: oe, logger: ae, onSubmitValueParser: se } = this.props, { minus: ie, plus: he, delimiter: xe, ul: Pe, addForm: Re } = q(T, S, R, k, K), ke = U(T, S, R, k, K), Te = cloneElement(re, { onClick: this.handleAddMode, className: "rejt-plus-menu", style: he }), fe = cloneElement(te, { onClick: z, className: "rejt-minus-menu", style: ie });
    return React__default.createElement("span", { className: "rejt-not-collapsed" }, React__default.createElement("span", { className: "rejt-not-collapsed-delimiter", style: xe }, "["), !D && Te, React__default.createElement("ul", { className: "rejt-not-collapsed-list", style: Pe }, S.map((ue, Ce) => React__default.createElement(JsonNode, { key: Ce, name: Ce.toString(), data: ue, keyPath: R, deep: L, isCollapsed: V, handleRemove: this.handleRemoveItem(Ce), handleUpdateValue: this.handleEditValue, onUpdate: this.onChildUpdate, onDeltaUpdate: W, readOnly: U, getStyle: q, addButtonElement: Y, cancelButtonElement: J, editButtonElement: Z, inputElementGenerator: X, textareaElementGenerator: ee, minusMenuElement: te, plusMenuElement: re, beforeRemoveAction: Q, beforeAddAction: ne, beforeUpdateAction: oe, logger: ae, onSubmitValueParser: se }))), !ke && D && React__default.createElement("div", { className: "rejt-add-form", style: Re }, React__default.createElement(JsonAddValue, { handleAdd: this.handleAddValueAdd, handleCancel: this.handleAddValueCancel, onlyValue: !0, addButtonElement: Y, cancelButtonElement: J, inputElementGenerator: X, keyPath: R, deep: k, onSubmitValueParser: se })), React__default.createElement("span", { className: "rejt-not-collapsed-delimiter", style: xe }, "]"), !ke && fe);
  }
  render() {
    let { name: T, collapsed: S, data: R, keyPath: k, deep: D } = this.state, { dataType: L, getStyle: V } = this.props, z = S ? this.renderCollapsed() : this.renderNotCollapsed(), W = V(T, R, k, D, L);
    return React__default.createElement("div", { className: "rejt-array-node" }, React__default.createElement("span", { onClick: this.handleCollapseMode }, React__default.createElement("span", { className: "rejt-name", style: W.name }, T, " :", " ")), z);
  }
};
JsonArray.defaultProps = { keyPath: [], deep: 0, minusMenuElement: React__default.createElement("span", null, " - "), plusMenuElement: React__default.createElement("span", null, " + ") };
var JsonFunctionValue = class extends Component {
  constructor(T) {
    super(T);
    let S = [...T.keyPath, T.name];
    this.state = { value: T.value, name: T.name, keyPath: S, deep: T.deep, editEnabled: !1, inputRef: null }, this.handleEditMode = this.handleEditMode.bind(this), this.refInput = this.refInput.bind(this), this.handleCancelEdit = this.handleCancelEdit.bind(this), this.handleEdit = this.handleEdit.bind(this), this.onKeydown = this.onKeydown.bind(this);
  }
  static getDerivedStateFromProps(T, S) {
    return T.value !== S.value ? { value: T.value } : null;
  }
  componentDidUpdate() {
    let { editEnabled: T, inputRef: S, name: R, value: k, keyPath: D, deep: L } = this.state, { readOnly: V, dataType: z } = this.props, W = V(R, k, D, L, z);
    T && !W && typeof S.focus == "function" && S.focus();
  }
  componentDidMount() {
    document.addEventListener("keydown", this.onKeydown);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeydown);
  }
  onKeydown(T) {
    T.altKey || T.ctrlKey || T.metaKey || T.shiftKey || T.repeat || ((T.code === "Enter" || T.key === "Enter") && (T.preventDefault(), this.handleEdit()), (T.code === "Escape" || T.key === "Escape") && (T.preventDefault(), this.handleCancelEdit()));
  }
  handleEdit() {
    let { handleUpdateValue: T, originalValue: S, logger: R, onSubmitValueParser: k, keyPath: D } = this.props, { inputRef: L, name: V, deep: z } = this.state;
    if (!L) return;
    let W = k(!0, D, z, V, L.value);
    T({ value: W, key: V }).then(() => {
      isComponentWillChange(S, W) || this.handleCancelEdit();
    }).catch(R.error);
  }
  handleEditMode() {
    this.setState({ editEnabled: !0 });
  }
  refInput(T) {
    this.state.inputRef = T;
  }
  handleCancelEdit() {
    this.setState({ editEnabled: !1 });
  }
  render() {
    let { name: T, value: S, editEnabled: R, keyPath: k, deep: D } = this.state, { handleRemove: L, originalValue: V, readOnly: z, dataType: W, getStyle: U, editButtonElement: q, cancelButtonElement: K, textareaElementGenerator: Y, minusMenuElement: J, keyPath: Z } = this.props, X = U(T, V, k, D, W), ee = null, te = null, re = z(T, V, k, D, W);
    if (R && !re) {
      let Q = Y(VALUE, Z, D, T, V, W), ne = cloneElement(q, { onClick: this.handleEdit }), oe = cloneElement(K, { onClick: this.handleCancelEdit }), ae = cloneElement(Q, { ref: this.refInput, defaultValue: V });
      ee = React__default.createElement("span", { className: "rejt-edit-form", style: X.editForm }, ae, " ", oe, ne), te = null;
    } else {
      ee = React__default.createElement("span", { className: "rejt-value", style: X.value, onClick: re ? null : this.handleEditMode }, S);
      let Q = cloneElement(J, { onClick: L, className: "rejt-minus-menu", style: X.minus });
      te = re ? null : Q;
    }
    return React__default.createElement("li", { className: "rejt-function-value-node", style: X.li }, React__default.createElement("span", { className: "rejt-name", style: X.name }, T, " :", " "), ee, te);
  }
};
JsonFunctionValue.defaultProps = { keyPath: [], deep: 0, handleUpdateValue: () => {
}, editButtonElement: React__default.createElement("button", null, "e"), cancelButtonElement: React__default.createElement("button", null, "c"), minusMenuElement: React__default.createElement("span", null, " - ") };
var JsonNode = class extends Component {
  constructor(T) {
    super(T), this.state = { data: T.data, name: T.name, keyPath: T.keyPath, deep: T.deep };
  }
  static getDerivedStateFromProps(T, S) {
    return T.data !== S.data ? { data: T.data } : null;
  }
  render() {
    let { data: T, name: S, keyPath: R, deep: k } = this.state, { isCollapsed: D, handleRemove: L, handleUpdateValue: V, onUpdate: z, onDeltaUpdate: W, readOnly: U, getStyle: q, addButtonElement: K, cancelButtonElement: Y, editButtonElement: J, inputElementGenerator: Z, textareaElementGenerator: X, minusMenuElement: ee, plusMenuElement: te, beforeRemoveAction: re, beforeAddAction: Q, beforeUpdateAction: ne, logger: oe, onSubmitValueParser: ae } = this.props, se = () => !0, ie = getObjectType(T);
    switch (ie) {
      case ERROR:
        return React__default.createElement(JsonObject, { data: T, name: S, isCollapsed: D, keyPath: R, deep: k, handleRemove: L, onUpdate: z, onDeltaUpdate: W, readOnly: se, dataType: ie, getStyle: q, addButtonElement: K, cancelButtonElement: Y, editButtonElement: J, inputElementGenerator: Z, textareaElementGenerator: X, minusMenuElement: ee, plusMenuElement: te, beforeRemoveAction: re, beforeAddAction: Q, beforeUpdateAction: ne, logger: oe, onSubmitValueParser: ae });
      case OBJECT:
        return React__default.createElement(JsonObject, { data: T, name: S, isCollapsed: D, keyPath: R, deep: k, handleRemove: L, onUpdate: z, onDeltaUpdate: W, readOnly: U, dataType: ie, getStyle: q, addButtonElement: K, cancelButtonElement: Y, editButtonElement: J, inputElementGenerator: Z, textareaElementGenerator: X, minusMenuElement: ee, plusMenuElement: te, beforeRemoveAction: re, beforeAddAction: Q, beforeUpdateAction: ne, logger: oe, onSubmitValueParser: ae });
      case ARRAY:
        return React__default.createElement(JsonArray, { data: T, name: S, isCollapsed: D, keyPath: R, deep: k, handleRemove: L, onUpdate: z, onDeltaUpdate: W, readOnly: U, dataType: ie, getStyle: q, addButtonElement: K, cancelButtonElement: Y, editButtonElement: J, inputElementGenerator: Z, textareaElementGenerator: X, minusMenuElement: ee, plusMenuElement: te, beforeRemoveAction: re, beforeAddAction: Q, beforeUpdateAction: ne, logger: oe, onSubmitValueParser: ae });
      case STRING:
        return React__default.createElement(JsonValue, { name: S, value: `"${T}"`, originalValue: T, keyPath: R, deep: k, handleRemove: L, handleUpdateValue: V, readOnly: U, dataType: ie, getStyle: q, cancelButtonElement: Y, editButtonElement: J, inputElementGenerator: Z, minusMenuElement: ee, logger: oe, onSubmitValueParser: ae });
      case NUMBER:
        return React__default.createElement(JsonValue, { name: S, value: T, originalValue: T, keyPath: R, deep: k, handleRemove: L, handleUpdateValue: V, readOnly: U, dataType: ie, getStyle: q, cancelButtonElement: Y, editButtonElement: J, inputElementGenerator: Z, minusMenuElement: ee, logger: oe, onSubmitValueParser: ae });
      case BOOLEAN:
        return React__default.createElement(JsonValue, { name: S, value: T ? "true" : "false", originalValue: T, keyPath: R, deep: k, handleRemove: L, handleUpdateValue: V, readOnly: U, dataType: ie, getStyle: q, cancelButtonElement: Y, editButtonElement: J, inputElementGenerator: Z, minusMenuElement: ee, logger: oe, onSubmitValueParser: ae });
      case DATE:
        return React__default.createElement(JsonValue, { name: S, value: T.toISOString(), originalValue: T, keyPath: R, deep: k, handleRemove: L, handleUpdateValue: V, readOnly: se, dataType: ie, getStyle: q, cancelButtonElement: Y, editButtonElement: J, inputElementGenerator: Z, minusMenuElement: ee, logger: oe, onSubmitValueParser: ae });
      case NULL:
        return React__default.createElement(JsonValue, { name: S, value: "null", originalValue: "null", keyPath: R, deep: k, handleRemove: L, handleUpdateValue: V, readOnly: U, dataType: ie, getStyle: q, cancelButtonElement: Y, editButtonElement: J, inputElementGenerator: Z, minusMenuElement: ee, logger: oe, onSubmitValueParser: ae });
      case UNDEFINED:
        return React__default.createElement(JsonValue, { name: S, value: "undefined", originalValue: "undefined", keyPath: R, deep: k, handleRemove: L, handleUpdateValue: V, readOnly: U, dataType: ie, getStyle: q, cancelButtonElement: Y, editButtonElement: J, inputElementGenerator: Z, minusMenuElement: ee, logger: oe, onSubmitValueParser: ae });
      case FUNCTION:
        return React__default.createElement(JsonFunctionValue, { name: S, value: T.toString(), originalValue: T, keyPath: R, deep: k, handleRemove: L, handleUpdateValue: V, readOnly: U, dataType: ie, getStyle: q, cancelButtonElement: Y, editButtonElement: J, textareaElementGenerator: X, minusMenuElement: ee, logger: oe, onSubmitValueParser: ae });
      case SYMBOL:
        return React__default.createElement(JsonValue, { name: S, value: T.toString(), originalValue: T, keyPath: R, deep: k, handleRemove: L, handleUpdateValue: V, readOnly: se, dataType: ie, getStyle: q, cancelButtonElement: Y, editButtonElement: J, inputElementGenerator: Z, minusMenuElement: ee, logger: oe, onSubmitValueParser: ae });
      default:
        return null;
    }
  }
};
JsonNode.defaultProps = { keyPath: [], deep: 0 };
var JsonObject = class extends Component {
  constructor(T) {
    super(T);
    let S = T.deep === -1 ? [] : [...T.keyPath, T.name];
    this.state = { name: T.name, data: T.data, keyPath: S, deep: T.deep, nextDeep: T.deep + 1, collapsed: T.isCollapsed(S, T.deep, T.data), addFormVisible: !1 }, this.handleCollapseMode = this.handleCollapseMode.bind(this), this.handleRemoveValue = this.handleRemoveValue.bind(this), this.handleAddMode = this.handleAddMode.bind(this), this.handleAddValueAdd = this.handleAddValueAdd.bind(this), this.handleAddValueCancel = this.handleAddValueCancel.bind(this), this.handleEditValue = this.handleEditValue.bind(this), this.onChildUpdate = this.onChildUpdate.bind(this), this.renderCollapsed = this.renderCollapsed.bind(this), this.renderNotCollapsed = this.renderNotCollapsed.bind(this);
  }
  static getDerivedStateFromProps(T, S) {
    return T.data !== S.data ? { data: T.data } : null;
  }
  onChildUpdate(T, S) {
    let { data: R, keyPath: k } = this.state;
    R[T] = S, this.setState({ data: R });
    let { onUpdate: D } = this.props, L = k.length;
    D(k[L - 1], R);
  }
  handleAddMode() {
    this.setState({ addFormVisible: !0 });
  }
  handleAddValueCancel() {
    this.setState({ addFormVisible: !1 });
  }
  handleAddValueAdd({ key: T, newValue: S }) {
    let { data: R, keyPath: k, nextDeep: D } = this.state, { beforeAddAction: L, logger: V } = this.props;
    L(T, k, D, S).then(() => {
      R[T] = S, this.setState({ data: R }), this.handleAddValueCancel();
      let { onUpdate: z, onDeltaUpdate: W } = this.props;
      z(k[k.length - 1], R), W({ type: ADD_DELTA_TYPE, keyPath: k, deep: D, key: T, newValue: S });
    }).catch(V.error);
  }
  handleRemoveValue(T) {
    return () => {
      let { beforeRemoveAction: S, logger: R } = this.props, { data: k, keyPath: D, nextDeep: L } = this.state, V = k[T];
      S(T, D, L, V).then(() => {
        let z = { keyPath: D, deep: L, key: T, oldValue: V, type: REMOVE_DELTA_TYPE };
        delete k[T], this.setState({ data: k });
        let { onUpdate: W, onDeltaUpdate: U } = this.props;
        W(D[D.length - 1], k), U(z);
      }).catch(R.error);
    };
  }
  handleCollapseMode() {
    this.setState((T) => ({ collapsed: !T.collapsed }));
  }
  handleEditValue({ key: T, value: S }) {
    return new Promise((R, k) => {
      let { beforeUpdateAction: D } = this.props, { data: L, keyPath: V, nextDeep: z } = this.state, W = L[T];
      D(T, V, z, W, S).then(() => {
        L[T] = S, this.setState({ data: L });
        let { onUpdate: U, onDeltaUpdate: q } = this.props;
        U(V[V.length - 1], L), q({ type: UPDATE_DELTA_TYPE, keyPath: V, deep: z, key: T, newValue: S, oldValue: W }), R();
      }).catch(k);
    });
  }
  renderCollapsed() {
    let { name: T, keyPath: S, deep: R, data: k } = this.state, { handleRemove: D, readOnly: L, dataType: V, getStyle: z, minusMenuElement: W } = this.props, { minus: U, collapsed: q } = z(T, k, S, R, V), K = Object.getOwnPropertyNames(k), Y = L(T, k, S, R, V), J = cloneElement(W, { onClick: D, className: "rejt-minus-menu", style: U });
    return React__default.createElement("span", { className: "rejt-collapsed" }, React__default.createElement("span", { className: "rejt-collapsed-text", style: q, onClick: this.handleCollapseMode }, "{...}", " ", K.length, " ", K.length === 1 ? "key" : "keys"), !Y && J);
  }
  renderNotCollapsed() {
    let { name: T, data: S, keyPath: R, deep: k, nextDeep: D, addFormVisible: L } = this.state, { isCollapsed: V, handleRemove: z, onDeltaUpdate: W, readOnly: U, getStyle: q, dataType: K, addButtonElement: Y, cancelButtonElement: J, editButtonElement: Z, inputElementGenerator: X, textareaElementGenerator: ee, minusMenuElement: te, plusMenuElement: re, beforeRemoveAction: Q, beforeAddAction: ne, beforeUpdateAction: oe, logger: ae, onSubmitValueParser: se } = this.props, { minus: ie, plus: he, addForm: xe, ul: Pe, delimiter: Re } = q(T, S, R, k, K), ke = Object.getOwnPropertyNames(S), Te = U(T, S, R, k, K), fe = cloneElement(re, { onClick: this.handleAddMode, className: "rejt-plus-menu", style: he }), ue = cloneElement(te, { onClick: z, className: "rejt-minus-menu", style: ie }), Ce = ke.map((ce) => React__default.createElement(JsonNode, { key: ce, name: ce, data: S[ce], keyPath: R, deep: D, isCollapsed: V, handleRemove: this.handleRemoveValue(ce), handleUpdateValue: this.handleEditValue, onUpdate: this.onChildUpdate, onDeltaUpdate: W, readOnly: U, getStyle: q, addButtonElement: Y, cancelButtonElement: J, editButtonElement: Z, inputElementGenerator: X, textareaElementGenerator: ee, minusMenuElement: te, plusMenuElement: re, beforeRemoveAction: Q, beforeAddAction: ne, beforeUpdateAction: oe, logger: ae, onSubmitValueParser: se }));
    return React__default.createElement("span", { className: "rejt-not-collapsed" }, React__default.createElement("span", { className: "rejt-not-collapsed-delimiter", style: Re }, "{"), !Te && fe, React__default.createElement("ul", { className: "rejt-not-collapsed-list", style: Pe }, Ce), !Te && L && React__default.createElement("div", { className: "rejt-add-form", style: xe }, React__default.createElement(JsonAddValue, { handleAdd: this.handleAddValueAdd, handleCancel: this.handleAddValueCancel, addButtonElement: Y, cancelButtonElement: J, inputElementGenerator: X, keyPath: R, deep: k, onSubmitValueParser: se })), React__default.createElement("span", { className: "rejt-not-collapsed-delimiter", style: Re }, "}"), !Te && ue);
  }
  render() {
    let { name: T, collapsed: S, data: R, keyPath: k, deep: D } = this.state, { getStyle: L, dataType: V } = this.props, z = S ? this.renderCollapsed() : this.renderNotCollapsed(), W = L(T, R, k, D, V);
    return React__default.createElement("div", { className: "rejt-object-node" }, React__default.createElement("span", { onClick: this.handleCollapseMode }, React__default.createElement("span", { className: "rejt-name", style: W.name }, T, " :", " ")), z);
  }
};
JsonObject.defaultProps = { keyPath: [], deep: 0, minusMenuElement: React__default.createElement("span", null, " - "), plusMenuElement: React__default.createElement("span", null, " + ") };
var JsonValue = class extends Component {
  constructor(T) {
    super(T);
    let S = [...T.keyPath, T.name];
    this.state = { value: T.value, name: T.name, keyPath: S, deep: T.deep, editEnabled: !1, inputRef: null }, this.handleEditMode = this.handleEditMode.bind(this), this.refInput = this.refInput.bind(this), this.handleCancelEdit = this.handleCancelEdit.bind(this), this.handleEdit = this.handleEdit.bind(this), this.onKeydown = this.onKeydown.bind(this);
  }
  static getDerivedStateFromProps(T, S) {
    return T.value !== S.value ? { value: T.value } : null;
  }
  componentDidUpdate() {
    let { editEnabled: T, inputRef: S, name: R, value: k, keyPath: D, deep: L } = this.state, { readOnly: V, dataType: z } = this.props, W = V(R, k, D, L, z);
    T && !W && typeof S.focus == "function" && S.focus();
  }
  componentDidMount() {
    document.addEventListener("keydown", this.onKeydown);
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.onKeydown);
  }
  onKeydown(T) {
    T.altKey || T.ctrlKey || T.metaKey || T.shiftKey || T.repeat || ((T.code === "Enter" || T.key === "Enter") && (T.preventDefault(), this.handleEdit()), (T.code === "Escape" || T.key === "Escape") && (T.preventDefault(), this.handleCancelEdit()));
  }
  handleEdit() {
    let { handleUpdateValue: T, originalValue: S, logger: R, onSubmitValueParser: k, keyPath: D } = this.props, { inputRef: L, name: V, deep: z } = this.state;
    if (!L) return;
    let W = k(!0, D, z, V, L.value);
    T({ value: W, key: V }).then(() => {
      isComponentWillChange(S, W) || this.handleCancelEdit();
    }).catch(R.error);
  }
  handleEditMode() {
    this.setState({ editEnabled: !0 });
  }
  refInput(T) {
    this.state.inputRef = T;
  }
  handleCancelEdit() {
    this.setState({ editEnabled: !1 });
  }
  render() {
    let { name: T, value: S, editEnabled: R, keyPath: k, deep: D } = this.state, { handleRemove: L, originalValue: V, readOnly: z, dataType: W, getStyle: U, editButtonElement: q, cancelButtonElement: K, inputElementGenerator: Y, minusMenuElement: J, keyPath: Z } = this.props, X = U(T, V, k, D, W), ee = z(T, V, k, D, W), te = R && !ee, re = Y(VALUE, Z, D, T, V, W), Q = cloneElement(q, { onClick: this.handleEdit }), ne = cloneElement(K, { onClick: this.handleCancelEdit }), oe = cloneElement(re, { ref: this.refInput, defaultValue: JSON.stringify(V) }), ae = cloneElement(J, { onClick: L, className: "rejt-minus-menu", style: X.minus });
    return React__default.createElement("li", { className: "rejt-value-node", style: X.li }, React__default.createElement("span", { className: "rejt-name", style: X.name }, T, " : "), te ? React__default.createElement("span", { className: "rejt-edit-form", style: X.editForm }, oe, " ", ne, Q) : React__default.createElement("span", { className: "rejt-value", style: X.value, onClick: ee ? null : this.handleEditMode }, String(S)), !ee && !te && ae);
  }
};
JsonValue.defaultProps = { keyPath: [], deep: 0, handleUpdateValue: () => Promise.resolve(), editButtonElement: React__default.createElement("button", null, "e"), cancelButtonElement: React__default.createElement("button", null, "c"), minusMenuElement: React__default.createElement("span", null, " - ") };
var object = { minus: { color: "red" }, plus: { color: "green" }, collapsed: { color: "grey" }, delimiter: {}, ul: { padding: "0px", margin: "0 0 0 25px", listStyle: "none" }, name: { color: "#2287CD" }, addForm: {} }, array = { minus: { color: "red" }, plus: { color: "green" }, collapsed: { color: "grey" }, delimiter: {}, ul: { padding: "0px", margin: "0 0 0 25px", listStyle: "none" }, name: { color: "#2287CD" }, addForm: {} }, value = { minus: { color: "red" }, editForm: {}, value: { color: "#7bba3d" }, li: { minHeight: "22px", lineHeight: "22px", outline: "0px" }, name: { color: "#2287CD" } };
function parse3(T) {
  let S = T;
  if (S.indexOf("function") === 0) return (0, eval)(`(${S})`);
  try {
    S = JSON.parse(T);
  } catch {
  }
  return S;
}
var JsonTree = class extends Component {
  constructor(T) {
    super(T), this.state = { data: T.data, rootName: T.rootName }, this.onUpdate = this.onUpdate.bind(this), this.removeRoot = this.removeRoot.bind(this);
  }
  static getDerivedStateFromProps(T, S) {
    return T.data !== S.data || T.rootName !== S.rootName ? { data: T.data, rootName: T.rootName } : null;
  }
  onUpdate(T, S) {
    this.setState({ data: S }), this.props.onFullyUpdate(S);
  }
  removeRoot() {
    this.onUpdate(null, null);
  }
  render() {
    let { data: T, rootName: S } = this.state, { isCollapsed: R, onDeltaUpdate: k, readOnly: D, getStyle: L, addButtonElement: V, cancelButtonElement: z, editButtonElement: W, inputElement: U, textareaElement: q, minusMenuElement: K, plusMenuElement: Y, beforeRemoveAction: J, beforeAddAction: Z, beforeUpdateAction: X, logger: ee, onSubmitValueParser: te, fallback: re = null } = this.props, Q = getObjectType(T), ne = D;
    getObjectType(D) === "Boolean" && (ne = () => D);
    let oe = U;
    U && getObjectType(U) !== "Function" && (oe = () => U);
    let ae = q;
    return q && getObjectType(q) !== "Function" && (ae = () => q), Q === "Object" || Q === "Array" ? React__default.createElement("div", { className: "rejt-tree" }, React__default.createElement(JsonNode, { data: T, name: S, deep: -1, isCollapsed: R, onUpdate: this.onUpdate, onDeltaUpdate: k, readOnly: ne, getStyle: L, addButtonElement: V, cancelButtonElement: z, editButtonElement: W, inputElementGenerator: oe, textareaElementGenerator: ae, minusMenuElement: K, plusMenuElement: Y, handleRemove: this.removeRoot, beforeRemoveAction: J, beforeAddAction: Z, beforeUpdateAction: X, logger: ee, onSubmitValueParser: te })) : re;
  }
};
JsonTree.defaultProps = { rootName: "root", isCollapsed: (T, S) => S !== -1, getStyle: (T, S, R, k, D) => {
  switch (D) {
    case "Object":
    case "Error":
      return object;
    case "Array":
      return array;
    default:
      return value;
  }
}, readOnly: () => !1, onFullyUpdate: () => {
}, onDeltaUpdate: () => {
}, beforeRemoveAction: () => Promise.resolve(), beforeAddAction: () => Promise.resolve(), beforeUpdateAction: () => Promise.resolve(), logger: { error: () => {
} }, onSubmitValueParser: (T, S, R, k, D) => parse3(D), inputElement: () => React__default.createElement("input", null), textareaElement: () => React__default.createElement("textarea", null), fallback: null };
newStyled.div(({ theme: T }) => ({ position: "relative", display: "flex", '&[aria-readonly="true"]': { opacity: 0.5 }, ".rejt-tree": { marginLeft: "1rem", fontSize: "13px" }, ".rejt-value-node, .rejt-object-node > .rejt-collapsed, .rejt-array-node > .rejt-collapsed, .rejt-object-node > .rejt-not-collapsed, .rejt-array-node > .rejt-not-collapsed": { "& > svg": { opacity: 0, transition: "opacity 0.2s" } }, ".rejt-value-node:hover, .rejt-object-node:hover > .rejt-collapsed, .rejt-array-node:hover > .rejt-collapsed, .rejt-object-node:hover > .rejt-not-collapsed, .rejt-array-node:hover > .rejt-not-collapsed": { "& > svg": { opacity: 1 } }, ".rejt-edit-form button": { display: "none" }, ".rejt-add-form": { marginLeft: 10 }, ".rejt-add-value-node": { display: "inline-flex", alignItems: "center" }, ".rejt-name": { lineHeight: "22px" }, ".rejt-not-collapsed-delimiter": { lineHeight: "22px" }, ".rejt-plus-menu": { marginLeft: 5 }, ".rejt-object-node > span > *, .rejt-array-node > span > *": { position: "relative", zIndex: 2 }, ".rejt-object-node, .rejt-array-node": { position: "relative" }, ".rejt-object-node > span:first-of-type::after, .rejt-array-node > span:first-of-type::after, .rejt-collapsed::before, .rejt-not-collapsed::before": { content: '""', position: "absolute", top: 0, display: "block", width: "100%", marginLeft: "-1rem", padding: "0 4px 0 1rem", height: 22 }, ".rejt-collapsed::before, .rejt-not-collapsed::before": { zIndex: 1, background: "transparent", borderRadius: 4, transition: "background 0.2s", pointerEvents: "none", opacity: 0.1 }, ".rejt-object-node:hover, .rejt-array-node:hover": { "& > .rejt-collapsed::before, & > .rejt-not-collapsed::before": { background: T.color.secondary } }, ".rejt-collapsed::after, .rejt-not-collapsed::after": { content: '""', position: "absolute", display: "inline-block", pointerEvents: "none", width: 0, height: 0 }, ".rejt-collapsed::after": { left: -8, top: 8, borderTop: "3px solid transparent", borderBottom: "3px solid transparent", borderLeft: "3px solid rgba(153,153,153,0.6)" }, ".rejt-not-collapsed::after": { left: -10, top: 10, borderTop: "3px solid rgba(153,153,153,0.6)", borderLeft: "3px solid transparent", borderRight: "3px solid transparent" }, ".rejt-value": { display: "inline-block", border: "1px solid transparent", borderRadius: 4, margin: "1px 0", padding: "0 4px", cursor: "text", color: T.color.defaultText }, ".rejt-value-node:hover > .rejt-value": { background: T.color.lighter, borderColor: T.appBorderColor } }));
newStyled.button(({ theme: T, primary: S }) => ({ border: 0, height: 20, margin: 1, borderRadius: 4, background: S ? T.color.secondary : "transparent", color: S ? T.color.lightest : T.color.dark, fontWeight: S ? "bold" : "normal", cursor: "pointer", order: S ? "initial" : 9 }));
newStyled(AddIcon)(({ theme: T, disabled: S }) => ({ display: "inline-block", verticalAlign: "middle", width: 15, height: 15, padding: 3, marginLeft: 5, cursor: S ? "not-allowed" : "pointer", color: T.textMutedColor, "&:hover": S ? {} : { color: T.color.ancillary }, "svg + &": { marginLeft: 0 } }));
newStyled(SubtractIcon)(({ theme: T, disabled: S }) => ({ display: "inline-block", verticalAlign: "middle", width: 15, height: 15, padding: 3, marginLeft: 5, cursor: S ? "not-allowed" : "pointer", color: T.textMutedColor, "&:hover": S ? {} : { color: T.color.negative }, "svg + &": { marginLeft: 0 } }));
newStyled.input(({ theme: T, placeholder: S }) => ({ outline: 0, margin: S ? 1 : "1px 0", padding: "3px 4px", color: T.color.defaultText, background: T.background.app, border: `1px solid ${T.appBorderColor}`, borderRadius: 4, lineHeight: "14px", width: S === "Key" ? 80 : 120, "&:focus": { border: `1px solid ${T.color.secondary}` } }));
newStyled(IconButton$1)(({ theme: T }) => ({ position: "absolute", zIndex: 2, top: 2, right: 2, height: 21, padding: "0 3px", background: T.background.bar, border: `1px solid ${T.appBorderColor}`, borderRadius: 3, color: T.textMutedColor, fontSize: "9px", fontWeight: "bold", textDecoration: "none", span: { marginLeft: 3, marginTop: 1 } }));
newStyled(Form.Textarea)(({ theme: T }) => ({ flex: 1, padding: "7px 6px", fontFamily: T.typography.fonts.mono, fontSize: "12px", lineHeight: "18px", "&::placeholder": { fontFamily: T.typography.fonts.base, fontSize: "13px" }, "&:placeholder-shown": { padding: "7px 10px" } }));
newStyled.input(({ theme: T, min: S, max: R, value: k, disabled: D }) => ({ "&": { width: "100%", backgroundColor: "transparent", appearance: "none" }, "&::-webkit-slider-runnable-track": { background: T.base === "light" ? `linear-gradient(to right, 
            ${T.color.green} 0%, ${T.color.green} ${(k - S) / (R - S) * 100}%, 
            ${curriedDarken$1(0.02, T.input.background)} ${(k - S) / (R - S) * 100}%, 
            ${curriedDarken$1(0.02, T.input.background)} 100%)` : `linear-gradient(to right, 
            ${T.color.green} 0%, ${T.color.green} ${(k - S) / (R - S) * 100}%, 
            ${curriedLighten$1(0.02, T.input.background)} ${(k - S) / (R - S) * 100}%, 
            ${curriedLighten$1(0.02, T.input.background)} 100%)`, boxShadow: `${T.appBorderColor} 0 0 0 1px inset`, borderRadius: 6, width: "100%", height: 6, cursor: D ? "not-allowed" : "pointer" }, "&::-webkit-slider-thumb": { marginTop: "-6px", width: 16, height: 16, border: `1px solid ${rgba$1(T.appBorderColor, 0.2)}`, borderRadius: "50px", boxShadow: `0 1px 3px 0px ${rgba$1(T.appBorderColor, 0.2)}`, cursor: D ? "not-allowed" : "grab", appearance: "none", background: `${T.input.background}`, transition: "all 150ms ease-out", "&:hover": { background: `${curriedDarken$1(0.05, T.input.background)}`, transform: "scale3d(1.1, 1.1, 1.1) translateY(-1px)", transition: "all 50ms ease-out" }, "&:active": { background: `${T.input.background}`, transform: "scale3d(1, 1, 1) translateY(0px)", cursor: D ? "not-allowed" : "grab" } }, "&:focus": { outline: "none", "&::-webkit-slider-runnable-track": { borderColor: rgba$1(T.color.secondary, 0.4) }, "&::-webkit-slider-thumb": { borderColor: T.color.secondary, boxShadow: `0 0px 5px 0px ${T.color.secondary}` } }, "&::-moz-range-track": { background: T.base === "light" ? `linear-gradient(to right, 
            ${T.color.green} 0%, ${T.color.green} ${(k - S) / (R - S) * 100}%, 
            ${curriedDarken$1(0.02, T.input.background)} ${(k - S) / (R - S) * 100}%, 
            ${curriedDarken$1(0.02, T.input.background)} 100%)` : `linear-gradient(to right, 
            ${T.color.green} 0%, ${T.color.green} ${(k - S) / (R - S) * 100}%, 
            ${curriedLighten$1(0.02, T.input.background)} ${(k - S) / (R - S) * 100}%, 
            ${curriedLighten$1(0.02, T.input.background)} 100%)`, boxShadow: `${T.appBorderColor} 0 0 0 1px inset`, borderRadius: 6, width: "100%", height: 6, cursor: D ? "not-allowed" : "pointer", outline: "none" }, "&::-moz-range-thumb": { width: 16, height: 16, border: `1px solid ${rgba$1(T.appBorderColor, 0.2)}`, borderRadius: "50px", boxShadow: `0 1px 3px 0px ${rgba$1(T.appBorderColor, 0.2)}`, cursor: D ? "not-allowed" : "grap", background: `${T.input.background}`, transition: "all 150ms ease-out", "&:hover": { background: `${curriedDarken$1(0.05, T.input.background)}`, transform: "scale3d(1.1, 1.1, 1.1) translateY(-1px)", transition: "all 50ms ease-out" }, "&:active": { background: `${T.input.background}`, transform: "scale3d(1, 1, 1) translateY(0px)", cursor: "grabbing" } }, "&::-ms-track": { background: T.base === "light" ? `linear-gradient(to right, 
            ${T.color.green} 0%, ${T.color.green} ${(k - S) / (R - S) * 100}%, 
            ${curriedDarken$1(0.02, T.input.background)} ${(k - S) / (R - S) * 100}%, 
            ${curriedDarken$1(0.02, T.input.background)} 100%)` : `linear-gradient(to right, 
            ${T.color.green} 0%, ${T.color.green} ${(k - S) / (R - S) * 100}%, 
            ${curriedLighten$1(0.02, T.input.background)} ${(k - S) / (R - S) * 100}%, 
            ${curriedLighten$1(0.02, T.input.background)} 100%)`, boxShadow: `${T.appBorderColor} 0 0 0 1px inset`, color: "transparent", width: "100%", height: "6px", cursor: "pointer" }, "&::-ms-fill-lower": { borderRadius: 6 }, "&::-ms-fill-upper": { borderRadius: 6 }, "&::-ms-thumb": { width: 16, height: 16, background: `${T.input.background}`, border: `1px solid ${rgba$1(T.appBorderColor, 0.2)}`, borderRadius: 50, cursor: "grab", marginTop: 0 }, "@supports (-ms-ime-align:auto)": { "input[type=range]": { margin: "0" } } }));
var RangeLabel = newStyled.span({ paddingLeft: 5, paddingRight: 5, fontSize: 12, whiteSpace: "nowrap", fontFeatureSettings: "tnum", fontVariantNumeric: "tabular-nums", "[aria-readonly=true] &": { opacity: 0.5 } });
newStyled(RangeLabel)(({ numberOFDecimalsPlaces: T, max: S }) => ({ width: `${T + S.toString().length * 2 + 3}ch`, textAlign: "right", flexShrink: 0 }));
newStyled.div({ display: "flex", alignItems: "center", width: "100%" });
newStyled.label({ display: "flex" });
newStyled.div(({ isMaxed: T }) => ({ marginLeft: "0.75rem", paddingTop: "0.35rem", color: T ? "red" : void 0 }));
newStyled(Form.Input)({ padding: 10 });
lazy(() => import("./Color-PRSJMWNM-CLrJH9qw.js"));
newStyled.span({ fontWeight: "bold" });
newStyled.span(({ theme: T }) => ({ color: T.color.negative, fontFamily: T.typography.fonts.mono, cursor: "help" }));
newStyled.div(({ theme: T }) => ({ "&&": { p: { margin: "0 0 10px 0" }, a: { color: T.color.secondary } }, code: { ...codeCommon({ theme: T }), fontSize: 12, fontFamily: T.typography.fonts.mono }, "& code": { margin: 0, display: "inline-block" }, "& pre > code": { whiteSpace: "pre-wrap" } }));
newStyled.div(({ theme: T, hasDescription: S }) => ({ color: T.base === "light" ? curriedTransparentize$1(0.1, T.color.defaultText) : curriedTransparentize$1(0.2, T.color.defaultText), marginTop: S ? 4 : 0 }));
newStyled.div(({ theme: T, hasDescription: S }) => ({ color: T.base === "light" ? curriedTransparentize$1(0.1, T.color.defaultText) : curriedTransparentize$1(0.2, T.color.defaultText), marginTop: S ? 12 : 0, marginBottom: 12 }));
newStyled.td(({ theme: T, expandable: S }) => ({ paddingLeft: S ? "40px !important" : "20px !important" }));
newStyled(ChevronDownIcon)(({ theme: T }) => ({ marginRight: 8, marginLeft: -10, marginTop: -2, height: 12, width: 12, color: T.base === "light" ? curriedTransparentize$1(0.25, T.color.defaultText) : curriedTransparentize$1(0.3, T.color.defaultText), border: "none", display: "inline-block" }));
newStyled(ChevronRightIcon)(({ theme: T }) => ({ marginRight: 8, marginLeft: -10, marginTop: -2, height: 12, width: 12, color: T.base === "light" ? curriedTransparentize$1(0.25, T.color.defaultText) : curriedTransparentize$1(0.3, T.color.defaultText), border: "none", display: "inline-block" }));
newStyled.span(({ theme: T }) => ({ display: "flex", lineHeight: "20px", alignItems: "center" }));
newStyled.td(({ theme: T }) => ({ position: "relative", letterSpacing: "0.35em", textTransform: "uppercase", fontWeight: T.typography.weight.bold, fontSize: T.typography.size.s1 - 1, color: T.base === "light" ? curriedTransparentize$1(0.4, T.color.defaultText) : curriedTransparentize$1(0.6, T.color.defaultText), background: `${T.background.app} !important`, "& ~ td": { background: `${T.background.app} !important` } }));
newStyled.td(({ theme: T }) => ({ position: "relative", fontWeight: T.typography.weight.bold, fontSize: T.typography.size.s2 - 1, background: T.background.app }));
newStyled.td(() => ({ position: "relative" }));
newStyled.tr(({ theme: T }) => ({ "&:hover > td": { backgroundColor: `${curriedLighten$1(5e-3, T.background.app)} !important`, boxShadow: `${T.color.mediumlight} 0 - 1px 0 0 inset`, cursor: "row-resize" } }));
newStyled.button(() => ({ background: "none", border: "none", padding: "0", font: "inherit", position: "absolute", top: 0, bottom: 0, left: 0, right: 0, height: "100%", width: "100%", color: "transparent", cursor: "row-resize !important" }));
newStyled.div(({ theme: T }) => ({ display: "flex", gap: 16, borderBottom: `1px solid ${T.appBorderColor}`, "&:last-child": { borderBottom: 0 } }));
newStyled.div(({ numColumn: T }) => ({ display: "flex", flexDirection: "column", flex: T || 1, gap: 5, padding: "12px 20px" }));
newStyled.div(({ theme: T, width: S, height: R }) => ({ animation: `${T.animation.glow} 1.5s ease-in-out infinite`, background: T.appBorderColor, width: S || "100%", height: R || 16, borderRadius: 3 }));
newStyled.div(({ inAddonPanel: T, theme: S }) => ({ height: T ? "100%" : "auto", display: "flex", border: T ? "none" : `1px solid ${S.appBorderColor}`, borderRadius: T ? 0 : S.appBorderRadius, padding: T ? 0 : 40, alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 15, background: S.background.content, boxShadow: "rgba(0, 0, 0, 0.10) 0 1px 3px 0" }));
newStyled.div(({ theme: T }) => ({ display: "flex", fontSize: T.typography.size.s2 - 1, gap: 25 }));
newStyled.div(({ theme: T }) => ({ width: 1, height: 16, backgroundColor: T.appBorderColor }));
newStyled.table(({ theme: T, compact: S, inAddonPanel: R }) => ({ "&&": { borderSpacing: 0, color: T.color.defaultText, "td, th": { padding: 0, border: "none", verticalAlign: "top", textOverflow: "ellipsis" }, fontSize: T.typography.size.s2 - 1, lineHeight: "20px", textAlign: "left", width: "100%", marginTop: R ? 0 : 25, marginBottom: R ? 0 : 40, "thead th:first-of-type, td:first-of-type": { width: "25%" }, "th:first-of-type, td:first-of-type": { paddingLeft: 20 }, "th:nth-of-type(2), td:nth-of-type(2)": { ...S ? null : { width: "35%" } }, "td:nth-of-type(3)": { ...S ? null : { width: "15%" } }, "th:last-of-type, td:last-of-type": { paddingRight: 20, ...S ? null : { width: "25%" } }, th: { color: T.base === "light" ? curriedTransparentize$1(0.25, T.color.defaultText) : curriedTransparentize$1(0.45, T.color.defaultText), paddingTop: 10, paddingBottom: 10, paddingLeft: 15, paddingRight: 15 }, td: { paddingTop: "10px", paddingBottom: "10px", "&:not(:first-of-type)": { paddingLeft: 15, paddingRight: 15 }, "&:last-of-type": { paddingRight: 20 } }, marginLeft: R ? 0 : 1, marginRight: R ? 0 : 1, tbody: { ...R ? null : { filter: T.base === "light" ? "drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.10))" : "drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.20))" }, "> tr > *": { background: T.background.content, borderTop: `1px solid ${T.appBorderColor}` }, ...R ? null : { "> tr:first-of-type > *": { borderBlockStart: `1px solid ${T.appBorderColor}` }, "> tr:last-of-type > *": { borderBlockEnd: `1px solid ${T.appBorderColor}` }, "> tr > *:first-of-type": { borderInlineStart: `1px solid ${T.appBorderColor}` }, "> tr > *:last-of-type": { borderInlineEnd: `1px solid ${T.appBorderColor}` }, "> tr:first-of-type > td:first-of-type": { borderTopLeftRadius: T.appBorderRadius }, "> tr:first-of-type > td:last-of-type": { borderTopRightRadius: T.appBorderRadius }, "> tr:last-of-type > td:first-of-type": { borderBottomLeftRadius: T.appBorderRadius }, "> tr:last-of-type > td:last-of-type": { borderBottomRightRadius: T.appBorderRadius } } } } }));
newStyled(IconButton$1)(({ theme: T }) => ({ margin: "-4px -12px -4px 0" }));
newStyled.span({ display: "flex", justifyContent: "space-between" });
newStyled.div(({ theme: T }) => ({ marginRight: 30, fontSize: `${T.typography.size.s1}px`, color: T.base === "light" ? curriedTransparentize$1(0.4, T.color.defaultText) : curriedTransparentize$1(0.6, T.color.defaultText) }));
newStyled.div({ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" });
newStyled.div({ display: "flex", flexDirection: "row", alignItems: "baseline", "&:not(:last-child)": { marginBottom: "1rem" } });
newStyled.div(withReset, ({ theme: T }) => ({ ...getBlockBackgroundStyle(T), margin: "25px 0 40px", padding: "30px 20px" }));
newStyled.div(({ theme: T }) => ({ fontWeight: T.typography.weight.bold, color: T.color.defaultText }));
newStyled.div(({ theme: T }) => ({ color: T.base === "light" ? curriedTransparentize$1(0.2, T.color.defaultText) : curriedTransparentize$1(0.6, T.color.defaultText) }));
newStyled.div({ flex: "0 0 30%", lineHeight: "20px", marginTop: 5 });
newStyled.div(({ theme: T }) => ({ flex: 1, textAlign: "center", fontFamily: T.typography.fonts.mono, fontSize: T.typography.size.s1, lineHeight: 1, overflow: "hidden", color: T.base === "light" ? curriedTransparentize$1(0.4, T.color.defaultText) : curriedTransparentize$1(0.6, T.color.defaultText), "> div": { display: "inline-block", overflow: "hidden", maxWidth: "100%", textOverflow: "ellipsis" }, span: { display: "block", marginTop: 2 } }));
newStyled.div({ display: "flex", flexDirection: "row" });
newStyled.div(({ background: T }) => ({ position: "relative", flex: 1, "&::before": { position: "absolute", top: 0, left: 0, width: "100%", height: "100%", background: T, content: '""' } }));
newStyled.div(({ theme: T }) => ({ ...getBlockBackgroundStyle(T), display: "flex", flexDirection: "row", height: 50, marginBottom: 5, overflow: "hidden", backgroundColor: "white", backgroundImage: "repeating-linear-gradient(-45deg, #ccc, #ccc 1px, #fff 1px, #fff 16px)", backgroundClip: "padding-box" }));
newStyled.div({ display: "flex", flexDirection: "column", flex: 1, position: "relative", marginBottom: 30 });
newStyled.div({ flex: 1, display: "flex", flexDirection: "row" });
newStyled.div({ display: "flex", alignItems: "flex-start" });
newStyled.div({ flex: "0 0 30%" });
newStyled.div({ flex: 1 });
newStyled.div(({ theme: T }) => ({ display: "flex", flexDirection: "row", alignItems: "center", paddingBottom: 20, fontWeight: T.typography.weight.bold, color: T.base === "light" ? curriedTransparentize$1(0.4, T.color.defaultText) : curriedTransparentize$1(0.6, T.color.defaultText) }));
newStyled.div(({ theme: T }) => ({ fontSize: T.typography.size.s2, lineHeight: "20px", display: "flex", flexDirection: "column" }));
newStyled.div(({ theme: T }) => ({ fontFamily: T.typography.fonts.base, fontSize: T.typography.size.s2, color: T.color.defaultText, marginLeft: 10, lineHeight: 1.2 }));
newStyled.div(({ theme: T }) => ({ ...getBlockBackgroundStyle(T), overflow: "hidden", height: 40, width: 40, display: "flex", alignItems: "center", justifyContent: "center", flex: "none", "> img, > svg": { width: 20, height: 20 } }));
newStyled.div({ display: "inline-flex", flexDirection: "row", alignItems: "center", flex: "0 1 calc(20% - 10px)", minWidth: 120, margin: "0px 10px 30px 0" });
newStyled.div({ display: "flex", flexFlow: "row wrap" });
scope && scope.__DOCS_CONTEXT__ === void 0 && (scope.__DOCS_CONTEXT__ = createContext$1(null), scope.__DOCS_CONTEXT__.displayName = "DocsContext");
var DocsContext = scope ? scope.__DOCS_CONTEXT__ : createContext$1(null);
function argsHash(T) {
  return stringify$4(T, { allowFunction: !1 });
}
var SourceContext = createContext$1({ sources: {} }), UNKNOWN_ARGS_HASH = "--unknown--", getStorySource = (T, S, R) => {
  let { sources: k } = R, D = k?.[T];
  return D?.[argsHash(S)] || D?.[UNKNOWN_ARGS_HASH] || { code: "" };
}, getSnippet = ({ snippet: T, storyContext: S, typeFromProps: R, transformFromProps: k }) => {
  let { __isArgsStory: D } = S.parameters, L = S.parameters.docs?.source || {}, V = R || L.type || SourceType.AUTO;
  if (L.code !== void 0) return L.code;
  let z = V === SourceType.DYNAMIC || V === SourceType.AUTO && T && D ? T : L.originalSource || "";
  return (k ?? L.transform)?.(z, S) || z;
}, useSourceProps = (T, S, R) => {
  let k, { of: D } = T;
  if ("of" in T && D === void 0) throw new Error("Unexpected `of={undefined}`, did you mistype a CSF file reference?");
  if (D) k = S.resolveOf(D, ["story"]).story;
  else try {
    k = S.storyById();
  } catch {
  }
  let L = k?.parameters?.docs?.source || {}, { code: V } = T, z = T.format ?? L.format, W = T.language ?? L.language ?? "jsx", U = T.dark ?? L.dark ?? !1;
  if (!V && !k) return { error: "Oh no! The source is not available." };
  if (V) return { code: V, format: z, language: W, dark: U };
  let q = S.getStoryContext(k), K = T.__forceInitialArgs ? q.initialArgs : q.unmappedArgs, Y = getStorySource(k.id, K, R);
  return z = Y.format ?? k.parameters.docs?.source?.format ?? !1, { code: getSnippet({ snippet: Y.code, storyContext: { ...q, args: K }, typeFromProps: T.type, transformFromProps: T.transform }), format: z, language: W, dark: U };
}, Source2 = (T) => {
  let S = useContext(SourceContext), R = useContext(DocsContext), k = useSourceProps(T, R, S);
  return React__default.createElement(Source, { ...k });
}, { document: document2 } = scope;
function navigate(T, S) {
  T.channel.emit(NAVIGATE_URL, S);
}
components2.a;
var SUPPORTED_MDX_HEADERS = ["h1", "h2", "h3", "h4", "h5", "h6"], OcticonHeaders = SUPPORTED_MDX_HEADERS.reduce((T, S) => ({ ...T, [S]: newStyled(S)({ "& svg": { position: "relative", top: "-0.1em", visibility: "hidden" }, "&:hover svg": { visibility: "visible" } }) }), {}), OcticonAnchor = newStyled.a(() => ({ float: "left", lineHeight: "inherit", paddingRight: "10px", marginLeft: "-24px", color: "inherit" })), HeaderWithOcticonAnchor = ({ as: T, id: S, children: R, ...k }) => {
  let D = useContext(DocsContext), L = OcticonHeaders[T], V = `#${S}`;
  return React__default.createElement(L, { id: S, ...k }, React__default.createElement(OcticonAnchor, { "aria-hidden": "true", href: V, tabIndex: -1, target: "_self", onClick: (z) => {
    document2.getElementById(S) && navigate(D, V);
  } }, React__default.createElement(LinkIcon, null)), R);
}, HeaderMdx = (T) => {
  let { as: S, id: R, children: k, ...D } = T;
  if (R) return React__default.createElement(HeaderWithOcticonAnchor, { as: S, id: R, ...D }, k);
  let L = S, { as: V, ...z } = T;
  return React__default.createElement(L, { ...nameSpaceClassNames(z, S) });
};
SUPPORTED_MDX_HEADERS.reduce((T, S) => ({ ...T, [S]: (R) => React__default.createElement(HeaderMdx, { as: S, ...R }) }), {});
var DescriptionType = ((T) => (T.INFO = "info", T.NOTES = "notes", T.DOCGEN = "docgen", T.AUTO = "auto", T))(DescriptionType || {});
newStyled.div(({ theme: T }) => ({ width: "10rem", "@media (max-width: 768px)": { display: "none" } }));
newStyled.div(({ theme: T }) => ({ position: "fixed", bottom: 0, top: 0, width: "10rem", paddingTop: "4rem", paddingBottom: "2rem", overflowY: "auto", fontFamily: T.typography.fonts.base, fontSize: T.typography.size.s2, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale", WebkitTapHighlightColor: "rgba(0, 0, 0, 0)", WebkitOverflowScrolling: "touch", "& *": { boxSizing: "border-box" }, "& > .toc-wrapper > .toc-list": { paddingLeft: 0, borderLeft: `solid 2px ${T.color.mediumlight}`, ".toc-list": { paddingLeft: 0, borderLeft: `solid 2px ${T.color.mediumlight}`, ".toc-list": { paddingLeft: 0, borderLeft: `solid 2px ${T.color.mediumlight}` } } }, "& .toc-list-item": { position: "relative", listStyleType: "none", marginLeft: 20, paddingTop: 3, paddingBottom: 3 }, "& .toc-list-item::before": { content: '""', position: "absolute", height: "100%", top: 0, left: 0, transform: "translateX(calc(-2px - 20px))", borderLeft: `solid 2px ${T.color.mediumdark}`, opacity: 0, transition: "opacity 0.2s" }, "& .toc-list-item.is-active-li::before": { opacity: 1 }, "& .toc-list-item > a": { color: T.color.defaultText, textDecoration: "none" }, "& .toc-list-item.is-active-li > a": { fontWeight: 600, color: T.color.secondary, textDecoration: "none" } }));
newStyled.p(({ theme: T }) => ({ fontWeight: 600, fontSize: "0.875em", color: T.textColor, textTransform: "uppercase", marginBottom: 10 }));
var Heading2 = ({ children: T, disableAnchor: S, ...R }) => {
  if (S || typeof T != "string") return React__default.createElement(H2, null, T);
  let k = T.toLowerCase().replace(/[^a-z0-9]/gi, "-");
  return React__default.createElement(HeaderMdx, { as: "h2", id: k, ...R }, T);
};
newStyled(Heading2)(({ theme: T }) => ({ fontSize: `${T.typography.size.s2 - 1}px`, fontWeight: T.typography.weight.bold, lineHeight: "16px", letterSpacing: "0.35em", textTransform: "uppercase", color: T.textMutedColor, border: 0, marginBottom: "12px", "&:first-of-type": { marginTop: "56px" } }));
const Packages = {
  PropTypes,
  Mui,
  MuiStyles: {
    createTheme,
    MuiThemeProvider: ThemeProvider$1
  },
  MuiBase: {
    TablePagination: TablePagination$1,
    tablePaginationClasses
  },
  "@mui/x-data-grid-pro": {
    DataGridPro,
    GridFooterContainer,
    GridToolbarColumnsButton,
    GRID_CHECKBOX_SELECTION_COL_DEF,
    GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
    useGridApiContext
  },
  emotion: {
    styled: emStyled
  },
  "react-color": {
    CustomPicker: ColorWrap$2,
    components: {
      EditableInput: common$1.EditableInput,
      Hue: common$1.Hue,
      Saturation: common$1.Saturation,
      Swatch: common$1.Swatch
    }
  },
  "react-intl": {
    FormattedMessage,
    useIntl,
    IntlProvider
  },
  "dayjs-pkg": {
    dayjs: defaultDayjs,
    plugin: {
      timezone,
      utc
    },
    locale: {
      en,
      de,
      es
    }
  },
  "@mui/x-date-pickers": {
    MobileDatePicker,
    MobileTimePicker,
    DesktopDatePicker,
    AdapterDayjs,
    LocalizationProvider: LocalizationProvider$1,
    DesktopTimePicker
  },
  "@mui/x-date-pickers-pro": {
    DateRangePicker,
    MobileDateTimePicker,
    DesktopDateTimePicker
  },
  "@tanstack/react-query": {
    QueryClient,
    QueryClientProvider,
    TanstackQueryClient: useQueryClient$1
  },
  PhoneInput,
  lodash: {
    debounce: debounce$6,
    isEqual: isEqual$2,
    isNil,
    find: find$2,
    get: get$6,
    isEmpty: isEmpty$4,
    mergeWith: mergeWith$2,
    isArray: isArray$m,
    union,
    omit,
    keys: keys$8,
    random
  },
  yup,
  formik: {
    useFormik
  },
  storybook: {
    useDarkMode,
    Source: Source2
  },
  colord: w$2
}, iconName = {
  add: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Add, { ...T }),
  "access-time": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(AccessTime, { ...T }),
  "arrow-drop-down": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowDropDown, { ...T }),
  "arrow-drop-up": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowDropUp, { ...T }),
  "calendar-month": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(CalendarMonth, { ...T }),
  check: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Check, { ...T }),
  "arrow-drop-left": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowLeft, { ...T }),
  "arrow-drop-right": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowRight, { ...T }),
  "edit-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(EditOutlined, { ...T }),
  "delete-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteOutlined, { ...T }),
  clear: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Clear, { ...T }),
  "info-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(InfoOutlined, { ...T }),
  badge: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Badge, { ...T }),
  "badge-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(BadgeOutlined, { ...T }),
  business: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Business, { ...T }),
  "cancel-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(CancelOutlined, { ...T }),
  "cancel-rounded": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(CancelRounded, { ...T }),
  "check-circle-rounded": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(CheckCircleRounded, { ...T }),
  "check-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(CheckOutlined, { ...T }),
  "visibility-off": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(VisibilityOff, { ...T }),
  visibility: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Visibility, { ...T }),
  "sticky-note-2-rounded": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(StickyNote2Rounded, { ...T }),
  "search-rounded": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(SearchRounded, { ...T }),
  "refresh-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(RefreshOutlined, { ...T }),
  "person-add-alt": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(PersonAddAlt, { ...T }),
  "map-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(MapOutlined, { ...T }),
  "local-shipping-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(LocalShippingOutlined, { ...T }),
  "local-shipping": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(LocalShipping, { ...T }),
  "keyboard-arrow-right": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(KeyboardArrowRight, { ...T }),
  "keyboard-arrow-down": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(KeyboardArrowDown, { ...T }),
  "inventory-2-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Inventory2Outlined, { ...T }),
  "chevron-right": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronRight, { ...T }),
  circle: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Circle$2, { ...T }),
  "close-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(CloseOutlined, { ...T }),
  close: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Close$1, { ...T }),
  inventory: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Inventory, { ...T }),
  "insert-invitation": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(InsertInvitation, { ...T }),
  "group-add-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(GroupAddOutlined, { ...T }),
  "group-add": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(GroupAdd, { ...T }),
  "folder-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(FolderOutlined, { ...T }),
  "folder-open": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(FolderOpen, { ...T }),
  folder: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Folder, { ...T }),
  "flag-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(FlagOutlined, { ...T }),
  "file-download-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(FileDownloadOutlined, { ...T }),
  "color-lens-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(ColorLensOutlined, { ...T }),
  "dashboard-customize": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(DashboardCustomize, { ...T }),
  "favorite-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(FavoriteOutlined, { ...T }),
  "favorite-border-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(FavoriteBorderOutlined, { ...T }),
  event: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Event$1, { ...T }),
  error: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Error$1, { ...T }),
  edit: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Edit, { ...T }),
  "download-for-offline-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(DownloadForOfflineOutlined, { ...T }),
  "delete-rounded": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteRounded, { ...T }),
  delete: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Delete, { ...T }),
  "dashboard-customize-outlined": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(DashboardCustomizeOutlined, { ...T }),
  "chevron-left-rounded": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronLeftRounded, { ...T }),
  "chevron-right-rounded": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(ChevronRightRounded, { ...T }),
  "first-page-rounded": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(FirstPageRounded, { ...T }),
  "last-page-rounded": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(LastPageRounded, { ...T }),
  "arrow-back": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowBack, { ...T }),
  login: (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(Login, { ...T }),
  "location-on": (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(LocationOn, { ...T })
}, IconElement = ({
  name: T,
  ...S
}) => {
  const R = useMemo(() => iconName[T], [T]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(R, { ...S });
};
IconElement.propTypes = {
  name: Packages.PropTypes.string.isRequired
};
const Icons = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconElement,
  IconsMaterial,
  Packages
}, Symbol.toStringTag, { value: "Module" })), aqua = {
  10: "#1B5D58",
  15: "#12868C",
  20: "#208080",
  30: "#229497",
  40: "#24A9AF",
  50: "#26B9C1",
  60: "#3AC4C7",
  70: "#57CECF",
  80: "#84DDDC",
  90: "#B3EAE9",
  95: "#E0F7F6",
  100: "#FFFFFF"
}, blue = {
  10: "#124E88",
  20: "#196EAA",
  30: "#1C7FBE",
  40: "#2191D2",
  50: "#249FE0",
  60: "#38ADE5",
  70: "#55BBE9",
  75: "#5BA4EA",
  80: "#82CEF0",
  90: "#B3E1F6",
  92: "#D1E2EB",
  93: "#C9DAE3",
  94: "#C8D5DC",
  95: "#E1F4FC",
  96: "#7D9DAC",
  100: "#FFFFFF",
  110: "#3BA9E9",
  120: "#0B78B7",
  130: "#2B8EC7",
  140: "#0C6192",
  150: "#ADBCCF",
  160: "#3A5576"
}, darkBlue = {
  10: "#002B54",
  15: "#0A3763",
  20: "#023C6C",
  30: "#094678",
  35: "#14497B",
  40: "#164F84",
  50: "#1F578C",
  51: "#3A7FC1",
  55: "#425E81",
  60: "#496E9A",
  64: "#527AA9",
  65: "#5D799C",
  66: "#6086B3",
  67: "#6F96C4",
  70: "#6B88AB",
  75: "#7F96B2",
  80: "#94A9C3",
  90: "#BECBDB",
  95: "#E5EAF0",
  100: "#FFFFFF"
}, green = {
  10: "#005D29",
  15: "#0A6A6F",
  20: "#067D3D",
  30: "#138E48",
  40: "#1EA054",
  41: "#1E7139",
  45: "#1DA2A9",
  50: "#27AF5D",
  55: "#2B904C",
  60: "#4FBB75",
  65: "#62B47C",
  70: "#71C78D",
  75: "#7DD098",
  80: "#9BD6AD",
  90: "#C2E6CD",
  95: "#E6F5EB",
  100: "#FFFFFF",
  110: "#388752"
}, neutral = {
  0: "#000000",
  10: "#1C1B1F",
  20: "#313033",
  21: "#403c4c",
  30: "#484649",
  40: "#605D62",
  49: "#77727b",
  50: "#787579",
  60: "#939094",
  70: "#AEAAAE",
  80: "#C9C5CA",
  81: "79747E1F",
  82: "#484351",
  83: "#3F3A48",
  84: "#413C49",
  85: "#938F99",
  86: "#E6E1E51F",
  87: "#49454F",
  88: "#79747E",
  89: "#00000026",
  90: "#E6E1E5",
  91: "#1C1B1F61",
  92: "#1C1B1F1F",
  93: "#CAC4D0",
  94: "#F8FAFD",
  95: "#F4EFF4",
  96: "#F7F7F7",
  97: "#E7E0EC",
  99: "#FFFBFE",
  100: "#FFFFFF",
  110: "#FAFAFA",
  120: "#FEFEFE"
}, orange = {
  1: "#924708",
  5: "#D84505",
  9: "#B0590F",
  10: "#DF4E10",
  13: "#D36B13",
  15: "#E14C0B",
  20: "#EC4F0B",
  25: "#FF4F02",
  30: "#E96811",
  40: "#F07812",
  50: "#F68714",
  60: "#FA9315",
  70: "#FBA22D",
  80: "#FCB350",
  85: "#FDC981",
  90: "#FEDEB3",
  95: "#FFF2E0",
  100: "#FFFFFF"
}, purple = {
  10: "#EADDFF",
  20: "#6750A4",
  30: "#E8DEF8",
  40: "#4A4458",
  50: "#322f3a",
  80: "#393646",
  90: "#424264"
}, red = {
  5: "#9F3E39",
  10: "#A62416",
  11: "#FFD8E4",
  20: "#B52D21",
  30: "#C33427",
  35: "#C85D58",
  40: "#D43D2D",
  50: "#E2462E",
  60: "#E05448",
  70: "#D9716C",
  80: "#E69894",
  90: "#FACBCE",
  91: "#8E2D28",
  95: "#FDEAEC",
  100: "#FFFFFF",
  110: "#FFECF1"
}, rgb = {
  dark: {
    10: "rgb(28, 27, 31)"
  },
  light: {
    10: "rgb(244, 239, 244)",
    50: "rgb(230, 225, 229)"
  },
  translucent: {
    white: {
      30: "rgb(255, 255, 255, 0.1)"
    },
    dark: {
      40: "rgb(57, 54, 70, 0.6)"
    }
  },
  other: {
    10: "rgb(49, 48, 51)"
  }
}, rgba = {
  white: {
    10: "rgba(255, 255, 255, 0.2)",
    20: "rgba(255, 255, 255, 0.08)",
    30: "rgba(255, 255, 255, 0.13)",
    40: "rgba(255, 255, 255, 0.3)",
    50: "rgba(255, 255, 255, 0.10)",
    60: "rgba(255, 255, 255, 0.15)",
    70: "rgba(252, 251, 255, 0.6)",
    80: "rgba(252, 251, 255, 0.9)",
    90: "rgba(252, 251, 255, 0.5)"
  },
  black: {
    10: "rgba(0, 0, 0, 0.25)",
    20: "rgba(0, 0, 0, 0.3)",
    30: "rgba(0, 0, 0, 0.15)",
    40: "rgba(0, 0, 0, 0.04)",
    50: "rgba(0, 0, 0, 0.06)",
    60: "rgba(0, 0, 0, 0.26)",
    70: "rgba(0, 0, 0, 0.09)",
    80: "rgba(0, 0, 0, 0.06)"
  },
  gray: {
    10: "rgba(101, 119, 136, 0.2)",
    20: "rgba(28, 27, 31, 0.40)",
    30: "rgba(28, 27, 31, 0.9)"
  },
  purple: {
    10: "rgba(208, 188, 255, 0.14)"
  }
}, surface = {
  light: {
    0: "#FCFBFF",
    1: `linear-gradient(0deg, rgba(0, 43, 84, 0.05), rgba(0, 43, 84, 0.05)), ${neutral[99]}`,
    2: `linear-gradient(0deg, rgba(0, 43, 84, 0.08), rgba(0, 43, 84, 0.08)), ${neutral[99]}`,
    3: `linear-gradient(0deg, rgba(0, 43, 84, 0.11), rgba(0, 43, 84, 0.11)), ${neutral[99]}`,
    4: `linear-gradient(0deg, rgba(0, 43, 84, 0.12), rgba(0, 43, 84, 0.12)), ${neutral[99]}`,
    5: `linear-gradient(0deg, rgba(0, 43, 84, 0.14), rgba(0, 43, 84, 0.14)), ${neutral[99]}`,
    6: "#938F99",
    7: `linear-gradient(0deg, rgba(0, 43, 84, 0.05), rgba(0, 43, 84, 0.05)), ${neutral[99]}`
  },
  dark: {
    0: neutral[10],
    1: `linear-gradient(0deg, rgba(85, 187, 233, 0.05), rgba(85, 187, 233, 0.05)), ${neutral[10]}`,
    2: `linear-gradient(0deg, rgba(85, 187, 233, 0.08), rgba(85, 187, 233, 0.08)), ${neutral[10]}`,
    3: `linear-gradient(0deg, rgba(85, 187, 233, 0.11), rgba(85, 187, 233, 0.11)), ${neutral[10]}`,
    4: `linear-gradient(0deg, rgba(85, 187, 233, 0.12), rgba(85, 187, 233, 0.12)), ${neutral[10]}`,
    5: `linear-gradient(0deg, rgba(85, 187, 233, 0.14), rgba(85, 187, 233, 0.14)), ${neutral[10]}`,
    6: "#938F99",
    7: "linear-gradient(0deg, rgba(208, 188, 255, 0.14) 0%, rgba(208, 188, 255, 0.14) 100%), rgb(67, 66, 71)"
  },
  glass: {
    0: "linear-gradient(0deg, rgba(208, 188, 255, 0.05) 0%, rgba(208, 188, 255, 0.05) 100%), rgba(28, 27, 31, 0.40)",
    1: "linear-gradient(0deg, rgba(28, 27, 31, 0.01), rgba(28, 27, 31, 0.01))"
  },
  tile: {
    0: "linear-gradient(135deg, #B2B8BE, #929395)",
    1: "linear-gradient(135deg, #A1A6AB, #7E8083)"
  }
}, yellow = {
  10: "#E77F13",
  20: "#EBA625",
  30: "#EDBE2F",
  40: "#EFD539",
  50: "#EDE53D",
  60: "#F1EA5A",
  70: "#F4EE78",
  80: "#F6F39E",
  90: "#FAF8C4",
  95: "#FDFDE7",
  100: "#FFFFFF",
  110: "#CFA525",
  120: "#BE660B"
}, colors = {
  darkBlue,
  blue,
  neutral,
  aqua,
  green,
  red,
  orange,
  yellow,
  surface,
  purple,
  rgb,
  rgba
}, background = {
  light: {
    1: `linear-gradient(0deg, rgba(103, 80, 164, 0.05) 0%, rgba(103, 80, 164, 0.05)), ${colors.neutral[99]}`,
    2: `linear-gradient(0deg, rgba(103, 80, 164, 0.08) 0%, rgba(103, 80, 164, 0.08) 100%), ${colors.neutral[99]}`,
    3: `linear-gradient(0deg, rgba(103, 80, 164, 0.11) 0%, rgba(103, 80, 164, 0.11) 100%), ${colors.neutral[99]}`,
    4: `linear-gradient(0deg, rgba(103, 80, 164, 0.12) 0%, rgba(103, 80, 164, 0.12) 100%), ${colors.neutral[99]}`,
    5: `linear-gradient(0deg, rgba(103, 80, 164, 0.14) 0%, rgba(103, 80, 164, 0.14) 100%), ${colors.neutral[99]}`,
    6: `linear-gradient(0deg, rgba(103, 80, 164, 0.14) 0%, rgba(103, 80, 164, 0.14) 100%), ${colors.neutral[99]}`,
    tableHF: colors.neutral[94]
  },
  dark: {
    1: `linear-gradient(0deg, rgba(208, 188, 255, 0.05) 0%, rgba(208, 188, 255, 0.05) 100%), ${colors.neutral[10]}`,
    2: `linear-gradient(0deg, rgba(208, 188, 255, 0.08) 0%, rgba(208, 188, 255, 0.08) 100%), ${colors.neutral[10]}`,
    3: `linear-gradient(0deg, rgba(208, 188, 255, 0.11) 0%, rgba(208, 188, 255, 0.11) 100%), ${colors.neutral[10]}`,
    4: `linear-gradient(0deg, rgba(208, 188, 255, 0.12) 0%, rgba(208, 188, 255, 0.12) 100%), ${colors.neutral[10]}`,
    5: `linear-gradient(0deg, rgba(208, 188, 255, 0.14) 0%, rgba(208, 188, 255, 0.14) 100%), ${colors.neutral[10]}`,
    tableHF: colors.neutral[30]
  }
}, shadow = {
  light: {
    1: "0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.30)",
    2: "0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.30)",
    3: "0px 1px 3px 0px rgba(0, 0, 0, 0.30), 0px 4px 8px 3px rgba(0, 0, 0, 0.15)",
    4: "0px 2px 3px 0px rgba(0, 0, 0, 0.30), 0px 6px 10px 4px rgba(0, 0, 0, 0.15)",
    5: "0px 4px 4px 0px rgba(0, 0, 0, 0.30), 0px 8px 12px 6px rgba(0, 0, 0, 0.15)",
    6: "0px 4px 20px 0px rgba(101, 119, 136, 0.20)",
    7: "0px -4px 10px 0px rgba(0, 0, 0, 0.25)",
    8: "0px 3px 6px 0px rgba(101, 119, 136, 0.25)",
    9: "0px 3px 3px 0px rgba(0, 0, 0, 0.25)",
    10: "0px 4px 10px 0px rgba(0, 0, 0, 0.30)",
    11: "0px 4px 10px 0px rgba(0, 0, 0, 0.25)",
    12: "0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)"
  },
  dark: {
    1: "0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)",
    2: "0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
    3: "0px 1px 3px 0px rgba(0, 0, 0, 0.30), 0px 4px 8px 3px rgba(0, 0, 0, 0.15)",
    4: "0px 2px 3px 0px rgba(0, 0, 0, 0.30), 0px 6px 10px 4px rgba(0, 0, 0, 0.15)",
    5: "0px 4px 4px 0px rgba(0, 0, 0, 0.30), 0px 8px 12px 6px rgba(0, 0, 0, 0.15)",
    6: "0px 4px 20px 0px rgba(101, 119, 136, 0.20)",
    7: "0px -4px 10px 0px rgba(0, 0, 0, 0.25)",
    8: "0px 4px 8px 3px rgba(0, 0, 0, 0.15), 0px 1px 3px 0px rgba(0, 0, 0, 0.30)",
    9: "0px 3px 3px 0px rgba(0, 0, 0, 0.25)",
    10: "0px 4px 10px 0px rgba(0, 0, 0, 0.30)",
    11: "0px 4px 10px 0px rgba(0, 0, 0, 0.25)",
    12: "0px 8px 12px 6px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.3)"
  }
}, elevation = (T) => ({
  1: `box-shadow: ${shadow[T][1]}; background:  ${background[T][1]};`,
  2: `box-shadow: ${shadow[T][2]}; background:  ${background[T][2]};`,
  3: `box-shadow: ${shadow[T][3]}; background:  ${background[T][3]};`,
  4: `box-shadow: ${shadow[T][4]}; background:  ${background[T][4]};`,
  5: `box-shadow: ${shadow[T][5]}; background:  ${background[T][5]};`
}), mixins = {
  validateMode: (T) => (S) => typeof S == "string" ? S : {
    light: S.light,
    dark: S.dark
  }[T],
  surfaceTheme: (T) => (S) => colors.surface[T][S],
  shadowTheme: (T) => (S) => shadow[T][S],
  backgroundTheme: (T) => (S) => background[T][S]
}, breakpoints$2 = {
  values: {
    xs: 430,
    sm: 768,
    md: 1024,
    lg: 1280,
    xl: 1920
  }
}, dark$n = (T) => ({
  MuiTextField: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          disabled: R
        } = S.ownerState;
        return {
          svg: {
            color: T.colors.neutral[100],
            pointerEvents: "auto",
            ...R && {
              color: T.colors.neutral[30],
              pointerEvents: "none"
            }
          },
          '&:hover svg[data-testid="CancelOutlinedIcon"]': {
            display: "block !important",
            pointerEvents: "auto"
          }
        };
      }
    }
  },
  MuiInputAdornment: {
    styleOverrides: {
      positionEnd: {
        cursor: "pointer"
      }
    }
  },
  MuiFilledInput: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          backgroundColor: T.colors.rgba.black[50],
          ...R.variant === "filled" && {
            height: "51px"
          },
          "&:hover:not(.Mui-error), &:focus": {
            backgroundColor: T.colors.rgba.white[30],
            "::before, ::after": {
              borderBottom: `2px solid ${T.colors.neutral[95]}`
            }
          },
          "::before, ::after": {
            borderBottom: `1px solid ${T.colors.neutral[95]}`
          },
          "&.Mui.error": {
            "::before": {
              borderBottom: `1px solid ${T.colors.red[80]}`
            }
          }
        };
      },
      input: {
        color: T.colors.neutral[95]
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          variant: R,
          formControl: k
        } = S.ownerState;
        return {
          ...R === "outlined" && {
            color: T.colors.neutral[100],
            lineHeight: 1,
            "&.Mui-focused": {
              color: k.error ? T.colors.red[80] : T.colors.blue[90]
            }
          },
          ...R === "filled" && {
            "&.Mui-focused": {
              color: k.error ? T.colors.red[80] : T.colors.neutral[90]
            }
          },
          "&.Mui-error": {
            "::before": {
              borderBottom: `1px solid ${T.colors.red[80]}`
            }
          }
        };
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => ({
        height: 20,
        ...S.ownerState["data-shrink"] && {
          color: T.colors.neutral[100],
          fontWeight: T.typography.fontWeightSemiBold
        }
      })
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        padding: 2,
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: !0
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          height: 48,
          /**
           * This approach was inferred from StackOverflow
           *
           * Reference: https://stackoverflow.com/questions/52911169/how-to-change-the-border-color-of-material-ui-textfield
           */
          "&:hover fieldset": {
            borderColor: `${T.colors.blue[90]} !important`,
            ...R.disabled && {
              borderColor: `${T.colors.rgba.white[40]} !important`
            },
            ...R.error && {
              borderColor: `${T.colors.red[80]} !important`
            }
          },
          "&.Mui-focused fieldset": {
            borderColor: `${T.colors.blue[90]} !important`,
            ...R.error && {
              borderColor: `${T.colors.red[80]} !important`
            }
          }
        };
      },
      notchedOutline: {
        borderColor: T.colors.neutral[100]
      }
    }
  }
}), light$n = (T) => ({
  MuiTextField: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          disabled: R,
          variant: k
        } = S.ownerState;
        return {
          svg: {
            pointerEvents: "auto",
            color: T.colors.neutral[40],
            ...k === "filled" && {
              color: T.colors.blue[95]
            },
            ...R && {
              color: T.colors.neutral[80],
              pointerEvents: "none"
            }
          },
          '&:hover svg[data-testid="CancelOutlinedIcon"]': {
            display: "block !important"
          }
        };
      }
    }
  },
  MuiInputAdornment: {
    styleOverrides: {
      positionEnd: {
        cursor: "pointer"
      }
    }
  },
  MuiFilledInput: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          backgroundColor: T.colors.rgba.black[50],
          ...R.variant === "filled" && {
            height: "51px"
          },
          "::before, ::after": {
            borderBottom: `1px solid ${T.colors.neutral[95]}`
          },
          ...R.variant === "filled" && {
            color: R.error ? T.colors.neutral[40] : T.colors.neutral[95],
            "&:hover:not(.Mui-error, .Mui-disabled)": {
              "::before": {
                borderBottom: `1px solid ${T.colors.neutral[95]}`
              }
            },
            "&.Mui-focused": {
              borderBottom: `1px solid${T.colors.blue[90]}`,
              "::after": {
                borderBottom: `1px solid${T.colors.blue[90]}`
              }
            },
            "&.Mui-error": {
              borderBottom: `1px solid${T.colors.red[90]}`,
              "::before, ::after": {
                borderBottom: `1px solid${T.colors.red[90]}`
              }
            }
          },
          ...R.variant === "outlined" && {
            /* Custom style rules for 'outlined' variant */
          }
        };
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          variant: R,
          formControl: k
        } = S.ownerState;
        return {
          ...R === "outlined" && {
            lineHeight: 1,
            "&.Mui-focused": {
              color: k.error ? T.colors.red[50] : T.colors.darkBlue[50]
            }
          },
          ...R === "filled" && {
            color: T.colors.neutral[95],
            "&.Mui-focused": {
              color: T.colors.neutral[30],
              ...k.error && {
                color: T.colors.red[90]
              }
            }
          }
        };
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          className: R
        } = S.ownerState;
        return {
          height: 20,
          ...S.ownerState["data-shrink"] && {
            color: T.colors.neutral[10],
            fontWeight: T.typography.fontWeightSemiBold
          },
          ...R.includes("filled") && {
            color: `${T.colors.neutral[95]} !important`,
            ...S.ownerState["data-shrink"] && {
              color: `${T.colors.blue[95]} !important`,
              fontWeight: T.typography.fontWeightSemiBold
            }
          },
          ...S.ownerState.error && R.includes("filled") && {
            color: `${T.colors.red[90]} !important`
          }
        };
      },
      asterisk: (S) => {
        const {
          className: R,
          error: k
        } = S.ownerState;
        return {
          color: R.includes("filled") && k && `${T.colors.red[90]} !important`
        };
      }
    }
  },
  MuiFormHelperText: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          error: R,
          variant: k
        } = S.ownerState;
        return {
          ...R && k === "filled" && {
            color: `${T.colors.red[90]} !important`
          }
        };
      }
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        padding: 2,
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: !0
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          height: 48,
          /**
           * This approach was inferred from StackOverflow
           *
           * Reference: https://stackoverflow.com/questions/52911169/how-to-change-the-border-color-of-material-ui-textfield
           */
          "&:hover fieldset": {
            borderColor: `${T.colors.darkBlue[50]} !important`,
            ...R.disabled && {
              borderColor: `${T.colors.rgba.black[60]} !important`
            },
            ...R.error && {
              borderColor: `${T.colors.red[50]} !important`
            },
            ...R.error && R.variant === "filled" && {
              borderColor: `${T.colors.red[90]} !important`
            }
          }
        };
      },
      notchedOutline: {
        borderColor: T.colors.neutral[60]
      },
      input: {
        color: T.colors.neutral[40]
      }
    }
  }
}), TextFieldThemeConfig = {
  dark: dark$n,
  light: light$n
}, components = (T) => ({
  ...TextFieldThemeConfig[T](resources(T))
}), palette = (T) => ({
  ...T === "light" ? {
    mode: T,
    primary: {
      main: colors.darkBlue[50]
    },
    error: {
      main: colors.red[50]
    },
    disabled: {
      main: colors.neutral[90]
    }
  } : {
    mode: T,
    primary: {
      main: colors.blue[95]
    },
    error: {
      main: colors.red[80]
    },
    disabled: {
      main: colors.neutral[30]
    }
  }
}), typography = {
  fontFamily: "Work Sans",
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  pxToRemMixin: (T) => `${T / 16}rem`
}, resources = (T) => ({
  colors,
  typography,
  shadow: mixins.shadowTheme(T),
  surface: mixins.surfaceTheme(T)
}), LocalizationProvider = () => {
  const {
    FormattedMessage: T,
    useIntl: S
  } = Packages["react-intl"];
  return {
    FormattedMessage: T,
    useIntl: S
  };
}, {
  colord
} = Packages, getGradientBackground = (T, S) => {
  let R, k;
  return S ? (R = colord(T).toHex(), k = colord(S).toHex()) : (R = colord(T).toHex(), k = colord(T).darken(0.05).toHex()), `linear-gradient(135deg, ${R} 0%, ${k} 100%)`;
}, darkenGradient = (T, S = 0.05, R = 0.1) => {
  const k = T.match(/#[0-9a-fA-F]{6}/g);
  if (k && k.length >= 2) {
    const [D, L] = k, V = colord(D).darken(S).toHex(), z = colord(L).darken(R).toHex();
    return `linear-gradient(135deg, ${V} 5.32%, ${z} 95.17%)`;
  } else if (k && k.length === 1) {
    const D = k[0], L = colord(D).darken(S).toHex(), V = colord(D).darken(R).toHex();
    return `linear-gradient(135deg, ${L} 5.32%, ${V} 95.17%)`;
  }
  return T;
}, config = ({
  mode: T,
  config: S = {}
}) => ({
  colors,
  breakpoints: breakpoints$2,
  shadow: mixins.shadowTheme(T),
  background: mixins.backgroundTheme(T),
  surface: mixins.surfaceTheme(T),
  validateMode: mixins.validateMode(T),
  elevation: elevation(T),
  palette: palette(T),
  typography,
  components: Object.keys(S).length === 0 ? components(T) : S
}), ThemeProvider = ({
  children: T,
  themeName: S
}) => {
  const {
    MuiThemeProvider: R,
    createTheme: k
  } = Packages.MuiStyles, D = useMemo(() => k(config({
    mode: S
  })), [k, S]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(R, { theme: D, children: T });
};
ThemeProvider.propTypes = {
  children: Packages.PropTypes.node.isRequired,
  themeName: Packages.PropTypes.string.isRequired
};
const index$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ThemeProvider,
  coreThemeConfig: config
}, Symbol.toStringTag, { value: "Module" })), useFormHandler = (T) => {
  const [S, R] = useState$1(!1), k = Packages.formik.useFormik(T?.config ?? {
    initialValues: T.initialValues,
    validationSchema: T.validationSchema,
    onSubmit: T.onSubmitHandler,
    enableReinitialize: !0
  }), D = async (Y) => {
    await k.setFieldValue(Y.field, Y.value, Y.shouldValidate ?? !0), await k.setFieldTouched(Y.field, !0, !1);
  }, L = () => ({
    initialValues: k.initialValues,
    currentState: k.values,
    isValid: !k.isValid,
    errors: k.errors,
    hasBeenUpdated: !Packages.lodash.isEqual(k.initialValues, k.values)
  }), V = (Y) => {
    if (!S) {
      const J = !!k.touched[Y] && Y in k.errors;
      return {
        invalid: J,
        error: J ? k.errors[Y] : ""
      };
    }
    return {
      invalid: Y in k.errors,
      error: k.errors[Y]
    };
  }, z = (Y) => {
    k.setErrors({});
  };
  return {
    setFormValue: D,
    formState: L,
    fieldState: V,
    resetForm: (Y) => {
      if (z(), R(!1), Y !== void 0) {
        const {
          currentState: J
        } = L();
        k.setValues({
          ...J,
          ...Y
        });
        return;
      }
      k.resetForm(T.initialValues);
    },
    triggerValidation: async (Y) => {
      if (R(!0), Y !== void 0) {
        await k.validateField(Y);
        return;
      }
      await k.validateForm();
    },
    onSubmitHandler: () => {
      k.handleSubmit();
    },
    debugMode: () => {
      const {
        initialValues: Y,
        currentState: J,
        isValid: Z,
        errors: X,
        hasBeenUpdated: ee
      } = L();
      return {
        initialValues: Y,
        currentState: J,
        isValid: !Z,
        errors: X,
        hasBeenUpdated: ee
      };
    },
    handleBlur: k.handleBlur
  };
}, Box$3 = Packages.emotion.styled(Packages.Mui.Box)(() => {
  const T = Packages.Mui.useTheme();
  return {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    h3: {
      fontSize: 30
    },
    p: {
      fontFamily: T.typography.fontFamily,
      margin: 10
    }
  };
}), DebugComponent = (T) => {
  const {
    Typography: S
  } = Packages.Mui, {
    initialValues: R,
    currentState: k,
    isValid: D,
    errors: L,
    hasBeenUpdated: V
  } = T.debugMode();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$3, { component: "div", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(S, { variant: "h3", children: "DEBUG MODE" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(S, { component: "p", children: [
      "Initial Values: ",
      JSON.stringify(R)
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(S, { component: "p", children: [
      "Current State: ",
      JSON.stringify(k)
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(S, { component: "p", children: [
      "Valid Data: ",
      JSON.stringify(D)
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(S, { component: "p", children: [
      "Errors: ",
      JSON.stringify(L)
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(S, { component: "p", children: [
      "Form Has Been Updated: ",
      String(V)
    ] })
  ] });
}, useLocalStorage = (T, S) => {
  const [R, k] = useState$1(() => {
    try {
      const L = localStorage.getItem(T);
      return L ? JSON.parse(L) : (localStorage.setItem(T, JSON.stringify(S)), S);
    } catch (L) {
      return console.log(`Error - useLocalStorage: ${L}`), S;
    }
  });
  return {
    storedValue: R,
    setValue: (L) => {
      try {
        localStorage.setItem(T, JSON.stringify(L));
      } catch (V) {
        console.error(`LocalStorageStorage - Error: ${V}`);
      }
      k(L);
    }
  };
}, useQueryClient = () => {
  const {
    TanstackQueryClient: T
  } = Packages["@tanstack/react-query"], S = T();
  return {
    prefetch: (D, L) => S.prefetchQuery(D, L),
    invalidate: (D) => S.invalidateQueries({
      queryKey: D,
      exact: !0
    })
  };
}, formatDate = (T, S = "") => Packages["dayjs-pkg"].dayjs(T).format(S), isObjectEmpty = (T) => Object.keys(T).length <= 0, mergeObjectsWithoutDuplicates = (T, S) => {
  const {
    lodash: {
      mergeWith: R,
      isArray: k,
      union: D
    }
  } = Packages;
  return R({}, T, S, (L, V) => {
    if (k(L))
      return D(L, V);
  });
}, isHexColor = (T) => /^#[0-9A-F]{6}$/i.test(T), useWithBaseField = (T, S) => {
  const [R, k] = useState$1(""), D = (q, K) => {
    switch (S) {
      case "SelectField":
      case "TextField":
      case "RadioButton":
        return q.target.value;
      case "Checkbox":
        return q.target.checked;
      case "DateField":
      case "TimeField":
      case "DateTimeField":
        return formatDate(q);
      case "DateRangeField": {
        const [Y, J] = q;
        return [formatDate(Y), formatDate(J)];
      }
      case "AutocompleteField":
        return Array.isArray(K) ? K?.map((Y) => Y.value) || [] : K || "";
      default:
        return q;
    }
  }, L = useCallback(Packages.lodash.debounce((q, K) => {
    T.formhandler && T.formhandler.setFormValue({
      field: T.name,
      value: D(q) === "Invalid Date" ? R : D(q, K)
    }), T.onChange && T.onChange(q === "Invalid Date" ? R : D(q, K));
  }, 300), []), V = useCallback(Packages.lodash.debounce((q) => {
    T.formhandler && T.formhandler.setFormValue({
      field: T.name,
      value: D(q) === "Invalid Date" ? R : D(q)
    }), T.onBlur && T.onBlur(q === "Invalid Date" ? R : D(q));
  }, 300), []), z = (q, K) => {
    k(D(q) === "Invalid Date" ? R : D(q, K)), L(q, K);
  }, W = (q) => {
    if (S === "AutocompleteField") {
      !R && T?.formhandler && V(q);
      return;
    }
    k(D(q) === "Invalid Date" ? R : D(q)), V(q);
  }, U = useCallback(() => {
    k(T.formhandler?.formState().currentState[T.name] || T.value || "");
  }, [T.formhandler, T.name, T.value]);
  return {
    onBlurHandler: W,
    onChangeHandler: z,
    debouncedBlurHandler: V,
    debouncedChangeHandler: L,
    inputValue: R,
    setInitialValue: U
  };
}, withBaseField = (T, S, R) => {
  const k = (D) => {
    const {
      debouncedBlurHandler: L,
      debouncedChangeHandler: V,
      setInitialValue: z,
      inputValue: W,
      onBlurHandler: U,
      onChangeHandler: q
    } = useWithBaseField(D, S), {
      InputAdornment: K
    } = Packages.Mui;
    return useEffect$1(() => (z(), function() {
      V.cancel(), L.cancel();
    }), [L, V, z]), /* @__PURE__ */ jsxRuntimeExports.jsx(T, { ...D, value: W, onChange: q, ...!["Checkbox"].includes(S) && {
      onBlur: U
    }, ...["DateField"].includes(S) && {
      slotProps: {
        ...D.slotProps,
        textField: {
          onBlur: U,
          required: D.required,
          fullWidth: D.fullWidth,
          error: D.formhandler?.fieldState(D.name).invalid ?? D.error,
          helperText: D.formhandler?.fieldState(D.name).error ?? D.helperText,
          ...R === "mobile" && {
            InputProps: {
              endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(K, { position: "end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "insert-invitation" }) })
            }
          }
        }
      }
    } });
  };
  return k.propTypes = {
    componentType: Packages.PropTypes.string,
    componentVariant: Packages.PropTypes.string,
    formhandler: Packages.PropTypes.object,
    helperText: Packages.PropTypes.string,
    name: Packages.PropTypes.string,
    error: Packages.PropTypes.bool,
    required: Packages.PropTypes.bool,
    fullWidth: Packages.PropTypes.bool,
    slotProps: Packages.PropTypes.object
  }, k;
}, withThemeOverrides = (T, S) => {
  const R = (k) => {
    const {
      createTheme: D,
      MuiThemeProvider: L
    } = Packages.MuiStyles, V = Packages.Mui.useTheme(), z = V.palette.mode, W = useMemo(() => {
      const U = {
        colors: V.colors,
        typography: V.typography,
        spacing: V.spacing,
        shadow: mixins.shadowTheme(V.palette.mode),
        surface: mixins.surfaceTheme(V.palette.mode),
        background: mixins.backgroundTheme(V.palette.mode),
        breakpoints: V.breakpoints
      }, q = config({
        mode: z,
        config: S[z](U)
      });
      return D(q);
    }, [V.breakpoints, V.colors, V.palette.mode, V.spacing, V.typography, D, z]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(L, { theme: W, children: /* @__PURE__ */ jsxRuntimeExports.jsx(T, { ...k }) });
  };
  return R.propTypes = {
    /**
     * A function that returns the design configuration.
     *
     * @param {string} mode - The color mode for the theme (e.g., 'light' or 'dark').
     *
     * @returns {object} - Configuration object for customizing the theme.
     */
    getThemeConfig: Packages.PropTypes.func,
    /**
     * Optional object containing Material-UI overrides.
     */
    muiOverrides: Packages.PropTypes.object
  }, R;
}, Modal$1 = Packages.emotion.styled(Packages.Mui.Modal)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
})), Container$2 = Packages.emotion.styled(Packages.Mui.Stack)(() => ({
  borderRadius: 20,
  width: 958
})), Header = Packages.emotion.styled(Packages.Mui.Box)(() => {
  const T = Packages.Mui.useTheme();
  return {
    position: "relative",
    display: "grid",
    gridTemplateRows: "1fr",
    gridTemplateColumns: "1fr 20rem",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    borderBottom: `1px solid ${T.validateMode({
      light: T.colors.neutral[93],
      dark: T.colors.neutral[85]
    })}`
  };
}), HeaderIcon = Packages.emotion.styled(Packages.Mui.Box)(() => ({
  justifySelf: "flex-end",
  img: {
    position: "absolute",
    top: "25%",
    left: "50%"
  },
  ".crud-icon": {
    height: 38,
    width: 38
  }
})), HeaderTitle = Packages.emotion.styled(Packages.Mui.Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  gap: 10,
  left: "50%",
  top: "25%",
  transform: "translate(-45%, -5%)"
})), HeaderActions = Packages.emotion.styled(Packages.Mui.Box)(() => ({
  display: "flex",
  justifySelf: "flex-end",
  gap: 15
})), dark$m = (T) => ({
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        fontSize: "24px !important"
      }
    }
  },
  MuiButton: {
    defaultProps: {
      disableRipple: !1
    },
    styleOverrides: {
      root: {
        height: "48px",
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: T.typography.fontWeightSemiBold,
        borderRadius: "100px",
        textTransform: "none",
        padding: 0
      },
      startIcon: {
        margin: 0,
        padding: 0
      }
    },
    /**
     * Adding new component variants
     *
     * Reference: https://v5-0-6.mui.com/customization/theme-components/#adding-new-component-variants
     */
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        width: "auto",
        color: T.colors.blue[10],
        border: "none",
        boxShadow: "none",
        backgroundColor: T.colors.blue[90],
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.blue[80]
        },
        "&:focus": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.blue[70]
        },
        "&:active": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.blue[60]
        },
        "&:disabled": {
          border: "none",
          color: T.colors.neutral[50],
          backgroundColor: T.colors.neutral[20]
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        width: "auto",
        color: T.colors.blue[80],
        border: `1px solid ${T.colors.neutral[88]}`,
        backgroundColor: T.surface(0),
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          border: `1px solid ${T.colors.neutral[88]}`,
          background: T.surface(1)
        },
        "&:focus": {
          border: `1px solid ${T.colors.blue[80]}`,
          background: T.surface(2)
        },
        "&:active": {
          background: T.surface(3)
        },
        "&:disabled": {
          boxShadow: "none",
          border: `1px solid ${T.colors.neutral[86]}`,
          color: T.colors.neutral[50],
          backgroundColor: T.colors.neutral[92]
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        width: "auto",
        color: T.colors.blue[80],
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          background: T.surface(1)
        },
        "&:focus": {
          background: T.surface(2)
        },
        "&:active": {
          background: T.surface(3)
        }
      }
    }, {
      props: {
        variant: "elevated"
      },
      style: {
        width: "auto",
        color: T.colors.blue[10],
        border: "none",
        boxShadow: T.shadow(1),
        backgroundColor: T.colors.blue[90],
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          border: "none",
          boxShadow: T.shadow(1),
          backgroundColor: T.colors.blue[80]
        },
        "&:focus": {
          border: "none",
          boxShadow: T.shadow(1),
          backgroundColor: T.colors.blue[70]
        },
        "&:active": {
          border: "none",
          boxShadow: T.shadow(1),
          backgroundColor: T.colors.blue[60]
        },
        "&:disabled": {
          border: "none",
          color: T.colors.neutral[50],
          backgroundColor: T.colors.neutral[20]
        }
      }
    }, {
      props: {
        variant: "tonal"
      },
      style: {
        width: "auto",
        color: T.colors.purple[30],
        border: "none",
        boxShadow: "none",
        backgroundColor: T.colors.purple[40],
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          border: "none",
          backgroundColor: T.colors.purple[40]
        },
        "&:focus": {
          border: "none",
          backgroundColor: T.colors.purple[40]
        },
        "&:active": {
          border: "none",
          backgroundColor: T.colors.purple[40]
        },
        "&:disabled": {
          border: "none",
          color: T.colors.neutral[50],
          backgroundColor: T.colors.neutral[20]
        }
      }
    }, {
      props: {
        variant: "success"
      },
      style: {
        width: "auto",
        border: "none",
        color: T.colors.neutral[100],
        fontSize: "16px",
        height: "52px",
        backgroundColor: T.colors.green[50],
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          border: "none",
          boxShadow: T.shadow(1),
          backgroundColor: T.colors.green[50]
        },
        "&:focus": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.green[50]
        },
        "&:active": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.green[40]
        },
        "&:disabled": {
          border: "none",
          boxShadow: "none",
          color: T.colors.neutral[50],
          backgroundColor: T.colors.neutral[20]
        }
      }
    }, {
      props: {
        variant: "danger"
      },
      style: {
        width: "auto",
        border: "none",
        color: T.colors.neutral[100],
        fontSize: "16px",
        height: "52px",
        backgroundColor: T.colors.red[30],
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          boxShadow: T.shadow(1),
          backgroundColor: T.colors.red[30]
        },
        "&:focus": {
          boxShadow: "none",
          backgroundColor: T.colors.red[30]
        },
        "&:active": {
          boxShadow: "none",
          backgroundColor: T.colors.red[20]
        },
        "&:disabled": {
          boxShadow: "none",
          color: T.colors.neutral[50],
          backgroundColor: T.colors.neutral[20]
        }
      }
    }, {
      props: {
        variant: "icon"
      },
      style: {
        width: "auto",
        minWidth: "40px",
        height: "40px",
        color: T.colors.blue[95],
        backgroundColor: "transparent",
        border: `1px solid ${T.colors.neutral[100]}`,
        "&:hover": {
          background: T.surface(1),
          border: `1px solid ${T.colors.blue[95]}`
        },
        "&:focus": {
          color: T.colors.blue[95],
          background: T.surface(2),
          border: `1px solid ${T.colors.blue[95]}`,
          boxShadow: "none"
        },
        "&:active": {
          background: T.surface(3),
          border: `1px solid ${T.colors.blue[95]}`,
          boxShadow: "none"
        },
        "&:disabled": {
          boxShadow: "none",
          border: `1px solid ${T.colors.neutral[86]}`,
          color: T.colors.neutral[50],
          backgroundColor: T.colors.neutral[92]
        }
      }
    }, {
      props: {
        variant: "favorite"
      },
      style: {
        width: "auto",
        minWidth: "40px",
        height: "40px",
        backgroundColor: "transparent",
        border: `1px solid ${T.colors.blue[95]}`,
        "&:hover": {
          background: T.surface(1),
          border: `1px solid ${T.colors.blue[95]}`
        },
        "&:focus": {
          color: T.colors.blue[95],
          background: T.surface(2),
          border: `1px solid ${T.colors.blue[95]}`,
          boxShadow: "none"
        },
        "&:active": {
          background: T.surface(3),
          border: `1px solid ${T.colors.blue[95]}`,
          boxShadow: "none"
        },
        "&:disabled": {
          boxShadow: "none",
          border: `1px solid ${T.colors.neutral[86]}`,
          color: T.colors.neutral[50],
          backgroundColor: T.colors.neutral[92]
        }
      }
    }, {
      props: {
        variant: "top-level"
      },
      style: {
        width: "auto",
        height: "40px",
        padding: "10px",
        color: T.colors.blue[95],
        border: `1px solid ${T.colors.blue[95]}`,
        backgroundColor: "transparent",
        gap: "16px",
        fontWeight: T.typography.fontWeightMedium,
        "&:hover": {
          background: T.surface(1)
        },
        "&:focus": {
          backgroundColor: T.colors.darkBlue[60],
          boxShadow: T.shadow(1)
        },
        "&:active": {
          backgroundColor: T.colors.darkBlue[60],
          boxShadow: T.shadow(1)
        }
      }
    }, {
      props: {
        variant: "login-primary"
      },
      style: {
        paddingLeft: "16px",
        color: T.colors.neutral[100],
        backgroundColor: T.colors.orange[25],
        gap: "8px",
        fontSize: "clamp(0.875rem, 0.785rem + 0.337vw, 1rem)",
        fontWeight: T.typography.fontWeightSemiBold,
        "&:hover": {
          backgroundColor: T.colors.orange[20]
        },
        "&:focus": {
          backgroundColor: T.colors.orange[15]
        },
        "&:active": {
          backgroundColor: T.colors.orange[5]
        },
        "&:disabled": {
          color: T.colors.neutral[95],
          backgroundColor: T.colors.neutral[80]
        }
      }
    }, {
      props: {
        variant: "login-secondary"
      },
      style: {
        paddingLeft: "16px",
        color: T.colors.neutral[95],
        backgroundColor: "transparent",
        border: `1px solid ${T.colors.neutral[95]}`,
        gap: "8px",
        fontSize: "clamp(0.875rem, 0.785rem + 0.337vw, 1rem)",
        fontWeight: T.typography.fontWeightSemiBold,
        "&:hover": {
          backgroundColor: T.colors.rgba.white[50]
        },
        "&:focus": {
          backgroundColor: T.colors.rgba.white[60]
        },
        "&:active": {
          backgroundColor: T.colors.rgba.white[10]
        },
        "&:disabled": {
          color: T.colors.neutral[70],
          border: `1px solid ${T.colors.neutral[70]}`,
          backgroundColor: "transparent"
        }
      }
    }, {
      props: {
        variant: "modal-header"
      },
      style: {
        width: "auto",
        height: "35px",
        color: T.colors.blue[95],
        border: `1px solid ${T.colors.neutral[93]}`,
        backgroundColor: "transparent",
        boxShadow: T.shadow(3),
        "&:hover": {
          background: T.surface(1)
        },
        "&:focus": {
          background: T.surface(1),
          boxShadow: T.shadow(3)
        },
        "&:active": {
          background: T.surface(1),
          boxShadow: T.shadow(3)
        }
      }
    }]
  }
}), light$m = (T) => ({
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        fontSize: "24px !important"
      }
    }
  },
  MuiButton: {
    defaultProps: {
      disableRipple: !1
    },
    styleOverrides: {
      root: {
        height: "48px",
        fontSize: "16px",
        lineHeight: "24px",
        fontWeight: T.typography.fontWeightSemiBold,
        borderRadius: "100px",
        textTransform: "none",
        padding: 0
      },
      startIcon: {
        margin: 0,
        padding: 0
      }
    },
    /**
     * Adding new component variants
     *
     * Reference: https://v5-0-6.mui.com/customization/theme-components/#adding-new-component-variants
     */
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        width: "auto",
        color: T.colors.neutral[100],
        border: "none",
        boxShadow: "none",
        backgroundColor: T.colors.darkBlue[50],
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          border: "none",
          boxShadow: T.shadow(1),
          backgroundColor: T.colors.darkBlue[40]
        },
        "&:focus": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.darkBlue[30]
        },
        "&:active": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.darkBlue[20]
        },
        "&:disabled": {
          border: "none",
          boxShadow: "none",
          color: T.colors.neutral[91],
          backgroundColor: T.colors.neutral[92]
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        width: "auto",
        color: T.colors.darkBlue[30],
        border: `1px solid ${T.colors.neutral[88]}`,
        backgroundColor: T.colors.neutral[100],
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          border: `1px solid ${T.colors.neutral[88]}`,
          background: T.surface(1)
        },
        "&:focus": {
          border: `1px solid ${T.colors.darkBlue[30]}`,
          background: T.surface(2)
        },
        "&:active": {
          border: `1px solid ${T.colors.neutral[88]}`,
          background: T.surface(3)
        },
        "&:disabled": {
          boxShadow: "none",
          border: `1px solid ${T.colors.neutral[92]}`,
          color: T.colors.neutral[91],
          background: T.surface(3)
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        width: "auto",
        color: T.colors.darkBlue[30],
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          border: "none",
          background: T.surface(1)
        },
        "&:focus": {
          background: T.surface(2)
        },
        "&:active": {
          background: T.surface(3)
        },
        "&:disabled": {
          border: "none",
          boxShadow: "none",
          color: T.colors.neutral[91],
          background: T.surface(1)
        }
      }
    }, {
      props: {
        variant: "elevated"
      },
      style: {
        width: "auto",
        color: T.colors.darkBlue[30],
        border: "none",
        boxShadow: T.shadow(1),
        backgroundColor: T.surface(1),
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          border: "none",
          boxShadow: T.shadow(1),
          background: T.surface(2)
        },
        "&:focus": {
          border: "none",
          boxShadow: T.shadow(1),
          background: T.surface(3)
        },
        "&:active": {
          border: "none",
          boxShadow: T.shadow(1),
          background: T.surface(4)
        },
        "&:disabled": {
          border: "none",
          boxShadow: "none",
          color: T.colors.neutral[91],
          backgroundColor: T.colors.neutral[92]
        }
      }
    }, {
      props: {
        variant: "tonal"
      },
      style: {
        width: "auto",
        color: T.colors.darkBlue[30],
        border: "none",
        boxShadow: "none",
        backgroundColor: T.surface(1),
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          border: "none",
          boxShadow: T.shadow(1),
          background: T.surface(2)
        },
        "&:focus": {
          border: "none",
          boxShadow: "none",
          background: T.surface(3)
        },
        "&:active": {
          border: "none",
          boxShadow: "none",
          background: T.surface(4)
        },
        "&:disabled": {
          border: "none",
          boxShadow: "none",
          color: T.colors.neutral[91],
          backgroundColor: T.colors.neutral[92]
        }
      }
    }, {
      props: {
        variant: "success"
      },
      style: {
        width: "auto",
        color: T.colors.neutral[100],
        border: "none",
        boxShadow: "none",
        backgroundColor: T.colors.green[50],
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          border: "none",
          boxShadow: T.shadow(1),
          backgroundColor: T.colors.green[50]
        },
        "&:focus": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.green[50]
        },
        "&:active": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.green[40]
        },
        "&:disabled": {
          border: "none",
          boxShadow: "none",
          color: T.colors.neutral[91],
          backgroundColor: T.colors.neutral[92]
        }
      }
    }, {
      props: {
        variant: "danger"
      },
      style: {
        width: "auto",
        color: T.colors.neutral[100],
        border: "none",
        boxShadow: "none",
        backgroundColor: T.colors.red[30],
        gap: "8px",
        padding: "0px 1rem",
        "&:hover": {
          boxShadow: T.shadow(1),
          backgroundColor: T.colors.red[30]
        },
        "&:focus": {
          boxShadow: "none",
          backgroundColor: T.colors.red[30]
        },
        "&:active": {
          boxShadow: "none",
          backgroundColor: T.colors.red[20]
        },
        "&:disabled": {
          boxShadow: "none",
          color: T.colors.neutral[91],
          backgroundColor: T.colors.neutral[92]
        }
      }
    }, {
      props: {
        variant: "icon"
      },
      style: {
        minWidth: "40px",
        width: "auto",
        height: "40px",
        color: T.colors.neutral[40],
        border: `1px solid ${T.colors.neutral[40]}`,
        backgroundColor: T.colors.neutral[100],
        "&:hover": {
          background: T.surface(1),
          border: `1px solid ${T.colors.neutral[40]}`
        },
        "&:focus": {
          color: T.colors.neutral[40],
          background: T.colors.neutral[100],
          border: `1px solid ${T.colors.neutral[40]}`
        },
        "&:disabled": {
          boxShadow: "none",
          color: T.colors.neutral[91],
          backgroundColor: T.colors.neutral[92]
        }
      }
    }, {
      props: {
        variant: "favorite"
      },
      style: {
        width: "auto",
        minWidth: "40px",
        height: "40px",
        color: T.colors.neutral[40],
        border: `1px solid ${T.colors.neutral[40]}`,
        backgroundColor: T.colors.neutral[100],
        "&:hover": {
          background: T.surface(1),
          border: `1px solid ${T.colors.neutral[40]}`
        },
        "&:focus": {
          color: T.colors.neutral[40],
          background: T.colors.neutral[100],
          border: `1px solid ${T.colors.neutral[40]}`
        },
        "&:active": {
          background: T.surface(3),
          color: T.colors.darkBlue[30],
          boxShadow: `0px 4px 4px 0px ${T.colors.rgba.black[10]} inset`
        },
        "&:disabled": {
          boxShadow: "none",
          color: T.colors.neutral[91],
          backgroundColor: T.colors.neutral[92]
        }
      }
    }, {
      props: {
        variant: "top-level"
      },
      style: {
        width: "auto",
        height: "40px",
        padding: "10px",
        color: T.colors.neutral[40],
        border: `1px solid ${T.colors.neutral[40]}`,
        backgroundColor: T.colors.neutral[100],
        gap: "16px",
        fontWeight: T.typography.fontWeightMedium,
        "&:hover": {
          background: T.surface(1)
        },
        "&:focus": {
          background: T.colors.blue[95],
          boxShadow: T.shadow(1)
        },
        "&:active": {
          background: T.colors.blue[95],
          boxShadow: T.shadow(1)
        }
      }
    }, {
      props: {
        variant: "login-primary"
      },
      style: {
        paddingLeft: "16px",
        color: T.colors.neutral[100],
        backgroundColor: T.colors.orange[25],
        gap: "8px",
        fontSize: "clamp(0.875rem, 0.785rem + 0.337vw, 1rem)",
        fontWeight: T.typography.fontWeightSemiBold,
        "&:hover": {
          backgroundColor: T.colors.orange[20]
        },
        "&:focus": {
          backgroundColor: T.colors.orange[15]
        },
        "&:active": {
          backgroundColor: T.colors.orange[5]
        },
        "&:disabled": {
          color: T.colors.neutral[95],
          backgroundColor: T.colors.neutral[80]
        }
      }
    }, {
      props: {
        variant: "login-secondary"
      },
      style: {
        paddingLeft: "16px",
        color: T.colors.neutral[95],
        backgroundColor: "transparent",
        border: `1px solid ${T.colors.neutral[95]}`,
        gap: "8px",
        fontSize: "clamp(0.875rem, 0.785rem + 0.337vw, 1rem)",
        fontWeight: T.typography.fontWeightSemiBold,
        "&:hover": {
          backgroundColor: T.colors.rgba.white[50]
        },
        "&:focus": {
          backgroundColor: T.colors.rgba.white[60]
        },
        "&:active": {
          backgroundColor: T.colors.rgba.white[10]
        },
        "&:disabled": {
          color: T.colors.neutral[70],
          border: `1px solid ${T.colors.neutral[70]}`,
          backgroundColor: "transparent"
        }
      }
    }, {
      props: {
        variant: "modal-header"
      },
      style: {
        width: "auto",
        height: "35px",
        color: T.colors.neutral[40],
        border: `1px solid ${T.colors.neutral[93]}`,
        backgroundColor: T.colors.neutral[100],
        boxShadow: T.shadow(1),
        "&:hover": {
          background: T.surface(1)
        },
        "&:focus": {
          background: T.surface(1),
          boxShadow: T.shadow(1)
        },
        "&:active": {
          background: T.surface(1),
          boxShadow: T.shadow(1)
        }
      }
    }]
  }
}), ButtonThemeConfig = {
  dark: dark$m,
  light: light$m
}, dark$l = (T) => ({
  ...ButtonThemeConfig.dark(resources("dark")),
  MuiStack: {
    styleOverrides: {
      root: {
        background: T.background(5),
        borderRadius: "0 0 20px 20px",
        "&:focus-visible": {
          outline: "none"
        }
      }
    }
  },
  MuiTypography: {
    styleOverrides: {
      root: {
        color: T.colors.neutral[95],
        fontSize: 30,
        fontWeight: T.typography.fontWeightSemiBold
      }
    }
  },
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        color: T.colors.neutral[95]
      }
    }
  }
}), light$l = (T) => ({
  ...ButtonThemeConfig.light(resources("light")),
  MuiStack: {
    styleOverrides: {
      root: {
        background: T.colors.neutral[100],
        borderRadius: "0 0 20px 20px",
        "&:focus-visible": {
          outline: "none"
        }
      }
    }
  },
  MuiTypography: {
    styleOverrides: {
      root: {
        color: T.colors.neutral[30],
        fontSize: 30,
        fontWeight: T.typography.fontWeightSemiBold
      }
    }
  },
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        color: T.colors.neutral[30]
      }
    }
  }
}), ModalThemeConfig = {
  dark: dark$l,
  light: light$l
}, BaseModal = ({
  token: T,
  open: S,
  onDeleteCallbackFn: R,
  onCloseCallbackFn: k,
  children: D,
  mode: L,
  headerIcon: V
}) => {
  const {
    FormattedMessage: z
  } = LocalizationProvider(), {
    Typography: W,
    Box: U
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal$1, { open: S, onClose: k, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Container$2, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Header, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(U, { component: "span", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(HeaderTitle, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(HeaderIcon, { component: "span", children: [
          L ? L === "add" ? /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "add", className: "crud-icon" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "edit-outlined", className: "crud-icon" }) : "",
          V
        ] }),
        T && /* @__PURE__ */ jsxRuntimeExports.jsx(W, { component: "h2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(z, { id: T }) })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HeaderActions, { component: "span", children: !V && L !== "add" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        R && /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { variant: "modal-header", icon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "delete-outlined" }), onClick: R }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { variant: "modal-header", icon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "clear" }), onClick: k })
      ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { variant: "modal-header", icon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "clear" }), onClick: k }) })
    ] }),
    D
  ] }) });
};
BaseModal.propTypes = {
  token: Packages.PropTypes.string,
  open: Packages.PropTypes.bool.isRequired,
  onDeleteCallbackFn: Packages.PropTypes.func,
  onCloseCallbackFn: Packages.PropTypes.func.isRequired,
  children: Packages.PropTypes.node.isRequired,
  mode: Packages.PropTypes.string,
  headerIcon: Packages.PropTypes.object
};
const Modal = withThemeOverrides(BaseModal, ModalThemeConfig), component$d = {
  data_dense_grid: {
    displaying: "Displaying",
    record: "{value, plural, =0 {records} one {record} other {records}}",
    records_selected: "{value, plural, =0 {records selected} one {record selected} other {records selected}}",
    displaying_of: "{displayedRowsCount} of {rowModels}",
    displaying_of_from_page: "{displayedRowsCount} of {rowModels} records from page {pageNumber}",
    no_results_found: "No results found",
    no_match: "Try adjusting your filters, to increase the number of results.",
    no_items_to_display: "There are currently no items to display",
    no_data: "No data found"
  }
}, component$c = {
  data_dense_grid: {
    displaying: "Mostrando",
    record: "{value, plural, =0 {registros} one {registro} other {registros}}",
    records_selected: "{value, plural, =0 {registros seleccionados} one {registro seleccionado} other {registros seleccionados}}",
    displaying_of: "{displayedRowsCount} de {rowModels}",
    displaying_of_from_page: "{displayedRowsCount} de {rowModels} registros de la página {pageNumber}",
    no_results_found: "No se encontraron resultados",
    no_match: "Intenta ajustar tus filtros para aumentar el número de resultados.",
    no_items_to_display: "Actualmente no hay elementos para mostrar",
    no_data: "No se encontraron datos"
  }
}, i18n$5 = {
  "en-US": component$d,
  "es-CO": component$c
}, component$b = {
  autocomplete_field: {
    clearText: "Clear",
    closeText: "Close",
    loadingText: "Loading...",
    openText: "Open",
    noOptionsText: "No options available"
  }
}, component$a = {
  autocomplete_field: {
    clearText: "Borrar",
    closeText: "Cerrar",
    loadingText: "Cargando...",
    openText: "Abrir",
    noOptionsText: "No hay opciones disponibles"
  }
}, i18n$4 = {
  "en-US": component$b,
  "es-CO": component$a
}, component$9 = {
  international_address: {
    country: "Country",
    address1: "Address",
    address2: "Address 2",
    address3: "Address 3",
    address4: "Address 4",
    city: "City",
    state: "State",
    zipCode: "Zip Code",
    longitude: "Longitude",
    latitude: "Latitude",
    department: "Department",
    suburb: "Suburb",
    postalCode: "PostalCode",
    neighborhood: "Neighborhood",
    province: "Province"
  }
}, component$8 = {
  international_address: {
    country: "País",
    address1: "Dirección",
    address2: "Dirección 2",
    address3: "Dirección 3",
    address4: "Dirección 4",
    city: "Ciudad",
    state: "Estado",
    zipCode: "Código postal",
    longitude: "Longitud",
    latitude: "Latitud",
    department: "Departamento",
    suburb: "Suburbio",
    postalCode: "Código postal",
    neighborhood: "Barrio",
    province: "Provincia"
  }
}, i18n$3 = {
  "en-US": component$9,
  "es-CO": component$8
}, component$7 = {
  dynamic_time_period_menu: {
    option: {
      yesterday: "Yesterday",
      today: "Today",
      tomorrow: "Tomorrow",
      custom: "Custom"
    },
    select: {
      date: "Select a date",
      date_range: "Select a date range",
      start_range: "Select start range",
      end_range: "Select end range"
    }
  }
}, component$6 = {
  dynamic_time_period_menu: {
    option: {
      yesterday: "Ayer",
      today: "Today",
      tomorrow: "Mañana",
      custom: "Personalizado"
    },
    select: {
      date: "Seleccionar una fecha",
      date_range: "Seleccionar un rango de fechas",
      start_range: "Seleccionar el inicio del rango",
      end_range: "Seleccionar el final del rango"
    }
  }
}, i18n$2 = {
  "en-US": component$7,
  "es-CO": component$6
}, component$5 = {
  time_period_menu: {
    option: {
      today: "Today",
      future: "Future",
      last_seven_days: "Last 7 days",
      this_month: "This month",
      custom: "Custom"
    },
    select: {
      date: "Select a date",
      date_range: "Select a date range",
      start_range: "Select start range",
      end_range: "Select end range"
    }
  }
}, component$4 = {
  time_period_menu: {
    option: {
      today: "Hoy",
      future: "Futuro",
      last_seven_days: "Últimos 7 días",
      this_month: "Este mes",
      custom: "Personalizado"
    },
    select: {
      date: "Seleccionar una fecha",
      date_range: "Seleccionar un rango de fechas",
      start_range: "Seleccionar el inicio del rango",
      end_range: "Seleccionar el final del rango"
    }
  }
}, i18n$1 = {
  "en-US": component$5,
  "es-CO": component$4
}, component$3 = {
  entity_switcher: {
    no_results_found: "No results found",
    no_match_company: "No companies match your search criteria. Please refine your search, or contact your site administrator if you believe there has been an error.",
    search: "Search"
  }
}, component$2 = {
  entity_switcher: {
    no_results_found: "No se encontraron resultados",
    no_match_company: "Ninguna empresa coincide con tus criterios de búsqueda. Por favor, refina tu búsqueda o contacta con el administrador del sitio si crees que ha habido un error.",
    search: "Buscar"
  }
}, i18n = {
  "en-US": component$3,
  "es-CO": component$2
}, component$1 = {
  cai_material: {
    ...i18n$1["en-US"],
    ...i18n$5["en-US"],
    ...i18n$4["en-US"],
    ...i18n$2["en-US"],
    ...i18n$3["en-US"],
    ...i18n["en-US"]
  }
}, general$1 = {
  cai_material: {
    actions: {
      done: "Done"
    }
  }
}, enUS = {
  component: component$1,
  general: general$1
}, component = {
  cai_material: {
    ...i18n$1["es-CO"],
    ...i18n$5["es-CO"],
    ...i18n$4["es-CO"],
    ...i18n$2["es-CO"],
    ...i18n$3["es-CO"],
    ...i18n["es-CO"]
  }
}, general = {
  cai_material: {
    actions: {
      done: "Listo"
    }
  }
}, esCO = {
  component,
  general
}, CAI_MATERIAL = {
  i18n: {
    "en-US": enUS,
    "es-CO": esCO
  }
}, useTanStackClient = () => {
  const {
    QueryClient: T
  } = Packages["@tanstack/react-query"], R = 1e3 * 60 * 60 * 12;
  return new T({
    defaultOptions: {
      queries: {
        staleTime: 5e3,
        cacheTime: R,
        refetchOnWindowFocus: !1,
        refetchOnReconnect: !0
      }
    }
  });
}, TanStackProvider = (T) => {
  const {
    QueryClientProvider: S
  } = Packages["@tanstack/react-query"], R = useTanStackClient();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(S, { client: R, children: T.children });
};
TanStackProvider.propTypes = {
  children: Packages.PropTypes.node.isRequired
};
const index$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TanStackProvider,
  useTanStackClient
}, Symbol.toStringTag, { value: "Module" })), index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  TanStack: index$1
}, Symbol.toStringTag, { value: "Module" })), UserPreferencesContext = createContext$1({}), useUserPreferencesContext = () => useContext(UserPreferencesContext), UserPreferencesProvider = ({
  children: T,
  config: S
}) => {
  const [R, k] = useState$1(S), D = (V) => {
    k((z) => ({
      ...z,
      columnVisibility: V
    }));
  }, L = (V) => {
    k((z) => ({
      ...z,
      pinnedColumns: V
    }));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(UserPreferencesContext.Provider, { value: {
    preferences: R,
    setColumnVisibility: D,
    setPinnedColumns: L
  }, children: T });
};
UserPreferencesProvider.propTypes = {
  children: Packages.PropTypes.node.isRequired,
  config: Packages.PropTypes.shape({
    columnVisibility: Packages.PropTypes.object,
    pinnedColumns: Packages.PropTypes.object
  }),
  id: Packages.PropTypes.string
};
const withControlledColumnVisibility = (T) => {
  const S = (R) => {
    const {
      preferences: k,
      setColumnVisibility: D
    } = useUserPreferencesContext(), {
      setValue: L
    } = useLocalStorage(`DataDenseGridLayout#${R.id}`);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(T, { ...R, columnVisibilityModel: k.columnVisibility, onColumnVisibilityModelChange: (V) => {
      D(V), L({
        ...k,
        columnVisibility: V
      }), R.onColumnVisibilityModelChange && R.onColumnVisibilityModelChange(V);
    } });
  };
  return S.propTypes = {
    id: Packages.PropTypes.string.isRequired,
    onColumnVisibilityModelChange: Packages.PropTypes.func
  }, S;
}, withControlledPinnedColumns = (T) => {
  const S = (R) => {
    const {
      preferences: k,
      setPinnedColumns: D
    } = useUserPreferencesContext(), {
      setValue: L
    } = useLocalStorage(`DataDenseGridLayout#${R.id}`);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      T,
      {
        ...R,
        ...!R.disableColumnPinning && {
          pinnedColumns: k.pinnedColumns,
          onPinnedColumnsChange: (V) => {
            D(V), L({
              ...k,
              pinnedColumns: V
            });
          }
        }
      }
    );
  };
  return S.propTypes = {
    id: Packages.PropTypes.string.isRequired,
    disableColumnPinning: Packages.PropTypes.bool
  }, S;
}, withUserPreferencesProvider = (T) => {
  const S = (R) => {
    const {
      isEqual: k
    } = Packages.lodash, D = R.columns.reduce((V, z) => (V[z.field] = R.hiddenColumns ? !R.hiddenColumns.includes(z.field) : !0, V), {}), {
      storedValue: L
    } = useLocalStorage(`DataDenseGridLayout#${R.id}`);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(UserPreferencesProvider, { config: {
      columnVisibility: k(D, L?.columnVisibility) ? L?.columnVisibility : mergeObjectsWithoutDuplicates(D, L?.columnVisibility),
      pinnedColumns: k(R.pinnedColumns, L?.pinnedColumns) ? L?.pinnedColumns : mergeObjectsWithoutDuplicates(R.pinnedColumns, L?.pinnedColumns)
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(T, { ...R }) });
  };
  return S.propTypes = {
    columns: Packages.PropTypes.array.isRequired,
    hiddenColumns: Packages.PropTypes.arrayOf(Packages.PropTypes.string),
    pinnedColumns: Packages.PropTypes.object,
    id: Packages.PropTypes.string.isRequired
  }, S;
}, dark$k = (T) => ({
  MuiDrawer: {
    styleOverrides: {
      root: {
        position: "initial",
        boxShadow: `${T.colors.rgba.gray[10]} 0px 4px 20px 0px`
      },
      paper: {
        background: `linear-gradient(0deg, ${T.colors.rgba.purple[10]} 0%, ${T.colors.rgba.purple[10]} 100%), ${T.colors.rgb.dark[10]} `,
        borderRadius: "20px 20px 0px 0px",
        width: "fit-content",
        height: "fit-content",
        left: "50%",
        transform: "translateX(-50%) !important",
        border: `1px solid ${T.colors.neutral[87]}`,
        borderBottom: "none"
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        backgroundColor: T.background(5)
      }
    }
  },
  MuiSwitch: {
    styleOverrides: {
      thumb: (S) => {
        const {
          checked: R
        } = S.ownerState;
        return {
          color: T.colors.blue[90],
          ...!R && {
            color: T.colors.neutral[120]
          }
        };
      },
      track: (S) => {
        const {
          checked: R
        } = S.ownerState;
        return {
          backgroundColor: `${T.colors.blue[90]} !important`,
          ...!R && {
            backgroundColor: `${T.colors.neutral[120]} !important`,
            opacity: 0.3
          }
        };
      }
    }
  },
  MuiTypography: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          component: R
        } = S.ownerState;
        return {
          ...R === void 0 && {
            fontWeight: T.typography.fontWeightMedium
          },
          ...R === "span" && {
            color: T.colors.neutral[95]
          }
        };
      }
    }
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        color: T.colors.neutral[95]
      }
    }
  },
  MuiButton: {
    defaultProps: {
      disableRipple: !0
    },
    styleOverrides: {
      root: {
        color: T.colors.blue[90]
      }
    }
  },
  MuiIconButton: {
    defaultProps: {
      disableRipple: !0
    },
    styleOverrides: {
      root: {
        "&:hover": {
          backgroundColor: T.colors.rgba.white[20]
        }
      },
      sizeSmall: {
        color: T.colors.neutral[95],
        fontSize: 24
      },
      sizeMedium: {
        width: 32,
        height: 32,
        backgroundColor: T.colors.blue[50],
        color: T.colors.neutral[100],
        "&:hover": {
          backgroundColor: T.colors.blue[50]
        }
      }
    }
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        color: T.colors.darkBlue[90],
        "&.Mui-checked": {
          color: T.colors.darkBlue[90]
        }
      }
    }
  },
  MuiDataGrid: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: () => ({
        color: T.colors.neutral[95],
        borderRadius: 10,
        borderColor: T.colors.neutral[40],
        boxShadow: "0px 4px 20px 0px #65778833",
        height: "inherit",
        maxHeight: "100%",
        backgroundColor: T.colors.neutral[21],
        ".MuiDataGrid-columnHeaders:hover .MuiDataGrid-columnSeparator": {
          "&:hover": {
            color: "inherit"
          }
        },
        "&::after": {
          content: "''",
          display: "block",
          position: "absolute",
          right: 0,
          width: "100%",
          height: "3px",
          backgroundColor: T.colors.rgba.black[20],
          filter: "blur(1px)",
          marginTop: "55px",
          zIndex: 1
        }
      }),
      panelWrapper: {
        maxHeight: 365
      },
      columnHeaders: {
        backgroundColor: T.colors.neutral[30],
        "div:last-child::after": {
          display: "none"
        }
      },
      columnHeader: {
        padding: "0 15px",
        "&:focus": {
          outline: "none"
        },
        "&:focus-within": {
          outline: "none"
        },
        "&::after": {
          content: "''",
          display: "block",
          position: "absolute",
          right: "-0.6px",
          width: "1px",
          height: "inherit",
          background: T.colors.neutral[88],
          filter: "blur(1px)"
        },
        'svg[data-testid="ArrowUpwardIcon"], svg[data-testid="ArrowDownwardIcon"]': {
          height: 18,
          width: 18
        }
      },
      columnHeaderRow: {
        'div[data-field="__check__"]': {
          padding: 0
        },
        'div[data-field="__check__"], div[data-field="__detail_panel_toggle__"], div:last-child': {
          ".MuiDataGrid-columnSeparator": {
            svg: {
              visibility: "hidden"
            }
          }
        }
      },
      columnHeaderTitleContainer: {
        justifyContent: "space-between"
      },
      pinnedColumnHeaders: {
        backgroundColor: T.colors.neutral[30],
        backgroundImage: "none",
        "&.MuiDataGrid-withBorderColor": {
          borderRadius: "0 10px 0 0 !important"
        }
      },
      pinnedColumns: {
        "&.MuiDataGrid-withBorderColor": {
          borderRadius: "0 10px 0 0 !important",
          background: "transparent "
        },
        button: {
          background: "none",
          height: 40,
          width: 40,
          "&:hover": {
            background: "none"
          }
        },
        'div[class*="MuiDataGrid-cell"]': {
          padding: "0 5%"
        }
      },
      row: {
        cursor: "pointer",
        backgroundColor: T.colors.neutral[21],
        "&:hover, &.Mui-selected:hover": {
          background: T.surface(7)
        },
        "&.Mui-selected": {
          backgroundColor: T.colors.darkBlue[60]
        },
        "&--detailPanelExpanded": {
          borderBottom: "transparent"
        }
      },
      cell: {
        "&:focus, &:focus-within": {
          outline: "none"
        },
        button: {
          background: "none"
        }
      },
      withBorderColor: {
        borderColor: "inherit",
        borderRadius: "10px 10px 0 0"
      },
      footerContainer: {
        backgroundColor: T.colors.neutral[30],
        borderRadius: "0 0 10px 10px !important",
        boxShadow: `0px -1px 2px 0px ${T.colors.rgba.black[20]}, 0px -1px 3px 1px ${T.colors.rgba.black[30]}`,
        zIndex: 1
      },
      menuIconButton: {
        backgroundColor: T.colors.rgb.other[10],
        color: T.colors.rgb.light[50]
      },
      paper: {
        borderRadius: 10
      },
      detailPanel: {
        backgroundColor: T.colors.neutral[21],
        borderBottom: `1px solid ${T.colors.neutral[95]}`
      }
    }
  }
}), light$k = (T) => ({
  MuiSkeleton: {
    styleOverrides: {
      root: {
        backgroundColor: T.colors.rgba.black[40]
      }
    }
  },
  MuiDrawer: {
    styleOverrides: {
      root: {
        position: "initial",
        boxShadow: `${T.colors.rgba.gray[10]} 0px 4px 20px 0px`
      },
      paper: {
        backgroundColor: T.colors.neutral[100],
        borderRadius: "20px 20px 0px 0px",
        width: "fit-content",
        height: "fit-content",
        left: "50%",
        transform: "translateX(-50%) !important",
        border: `1px solid ${T.colors.neutral[80]}`,
        borderBottom: "none"
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 10,
        backgroundColor: T.background(5)
      }
    }
  },
  MuiSwitch: {
    styleOverrides: {
      thumb: (S) => {
        const {
          checked: R
        } = S.ownerState;
        return {
          color: T.colors.blue[50],
          ...!R && {
            color: T.colors.neutral[100]
          }
        };
      },
      track: (S) => {
        const {
          checked: R
        } = S.ownerState;
        return {
          backgroundColor: `${T.colors.blue[50]} !important`,
          ...!R && {
            backgroundColor: `${T.colors.neutral[0]} !important`,
            opacity: 0.38
          }
        };
      }
    }
  },
  MuiTypography: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          component: R
        } = S.ownerState;
        return {
          ...R === void 0 && {
            fontWeight: T.typography.fontWeightMedium
          },
          ...R === "span" && {
            color: T.colors.neutral[40]
          }
        };
      }
    }
  },
  MuiButton: {
    defaultProps: {
      disableRipple: !0
    },
    styleOverrides: {
      root: {
        color: T.colors.blue[50]
      }
    }
  },
  MuiIconButton: {
    defaultProps: {
      disableRipple: !0
    },
    styleOverrides: {
      root: {
        "&:hover": {
          backgroundColor: T.colors.rgba.black[40]
        }
      },
      sizeSmall: {
        color: T.colors.neutral[40],
        fontSize: 24
      },
      sizeMedium: {
        width: 32,
        height: 32,
        backgroundColor: T.colors.blue[50],
        color: T.colors.neutral[100],
        "&:hover": {
          backgroundColor: T.colors.blue[50]
        }
      }
    }
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        color: T.colors.darkBlue[50],
        "&.Mui-checked": {
          color: T.colors.darkBlue[50]
        }
      }
    }
  },
  MuiDataGrid: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: () => ({
        color: T.colors.neutral[40],
        borderRadius: 10,
        borderColor: T.colors.neutral[40],
        boxShadow: "0px 4px 20px 0px #65778833",
        height: "inherit",
        maxHeight: "100%",
        backgroundColor: T.colors.neutral[100],
        ".MuiDataGrid-columnHeaders:hover .MuiDataGrid-columnSeparator": {
          "&:hover": {
            color: "inherit"
          }
        },
        "&::after": {
          content: "''",
          display: "block",
          position: "absolute",
          right: 0,
          width: "100%",
          height: "3px",
          backgroundColor: T.colors.rgba.black[20],
          filter: "blur(1px)",
          marginTop: "55px",
          zIndex: 1
        }
      }),
      panelWrapper: {
        maxHeight: 365
      },
      columnHeaders: {
        backgroundColor: T.colors.neutral[94],
        "div:last-child::after": {
          display: "none"
        }
      },
      columnHeader: {
        padding: "0 15px",
        "&:focus": {
          outline: "none"
        },
        "&:focus-within": {
          outline: "none"
        },
        "&::after": {
          content: "''",
          display: "block",
          position: "absolute",
          right: "-0.6px",
          width: "1px",
          height: "inherit",
          background: T.colors.rgba.black[10],
          filter: "blur(1px)"
        },
        'svg[data-testid="ArrowUpwardIcon"], svg[data-testid="ArrowDownwardIcon"]': {
          height: 18,
          width: 18
        }
      },
      columnHeaderRow: {
        'div[data-field="__check__"]': {
          padding: 0
        },
        'div[data-field="__check__"], div[data-field="__detail_panel_toggle__"], div:last-child': {
          ".MuiDataGrid-columnSeparator": {
            svg: {
              visibility: "hidden"
            }
          }
        }
      },
      columnHeaderTitleContainer: {
        justifyContent: "space-between"
      },
      pinnedColumnHeaders: {
        backgroundColor: T.colors.neutral[94],
        backgroundImage: "none",
        "&.MuiDataGrid-withBorderColor": {
          borderRadius: "0 10px 0 0 !important"
        }
      },
      pinnedColumns: {
        "&.MuiDataGrid-withBorderColor": {
          borderRadius: "0 10px 0 0 !important"
        },
        button: {
          background: "none",
          height: 40,
          width: 40,
          "&:hover": {
            background: "none"
          }
        },
        'div[class*="MuiDataGrid-cell"]': {
          padding: "0 5%"
        }
      },
      row: {
        cursor: "pointer",
        backgroundColor: T.colors.neutral[100],
        "&:hover, &.Mui-selected:hover": {
          background: T.surface(7)
        },
        "&.Mui-selected": {
          backgroundColor: T.colors.blue[95]
        },
        "&--detailPanelExpanded": {
          borderBottom: "transparent"
        }
      },
      cell: {
        "&:focus, &:focus-within": {
          outline: "none"
        },
        button: {
          background: "none"
        }
      },
      withBorderColor: {
        borderColor: "inherit",
        borderRadius: "10px 10px 0 0"
      },
      footerContainer: {
        backgroundColor: T.colors.neutral[94],
        borderRadius: "0 0 10px 10px !important",
        boxShadow: `0px -1px 3px 1px ${T.colors.rgba.black[30]}, 0px -1px 2px ${T.colors.rgba.black[20]}`,
        zIndex: 1
      },
      menuIconButton: {
        color: T.colors.neutral[88],
        backgroundColor: T.colors.rgb.light[10]
      },
      paper: {
        borderRadius: 10
      },
      detailPanel: {
        borderBottom: `1px solid ${T.colors.neutral[40]}`
      }
    }
  }
}), DataDenseGridThemeConfig = {
  dark: dark$k,
  light: light$k
}, SearchEmpty = "data:image/svg+xml,%3csvg%20width='136'%20height='127'%20viewBox='0%200%20136%20127'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20id='search_empty%201'%20clip-path='url(%23clip0_333_1050)'%3e%3cg%20id='Path%206'%3e%3cpath%20d='M91.5707%2089.7402H42.9952C41.032%2089.738%2039.1498%2088.9587%2037.7616%2087.5734C36.3734%2086.1881%2035.5925%2084.3098%2035.5903%2082.3507V33.8758C35.5925%2031.9167%2036.3734%2030.0384%2037.7616%2028.6531C39.1498%2027.2678%2041.032%2026.4885%2042.9952%2026.4863H91.5707C93.5339%2026.4885%2095.4161%2027.2678%2096.8043%2028.6531C98.1925%2030.0384%2098.9733%2031.9167%2098.9755%2033.8758V82.3507C98.9733%2084.3098%2098.1925%2086.1881%2096.8043%2087.5734C95.4161%2088.9587%2093.5339%2089.738%2091.5707%2089.7402ZM42.9952%2027.6687C41.3455%2027.6687%2039.7634%2028.3227%2038.597%2029.4867C37.4305%2030.6508%2036.7752%2032.2296%2036.7752%2033.8758V82.3507C36.7752%2083.9969%2037.4305%2085.5757%2038.597%2086.7398C39.7634%2087.9039%2041.3455%2088.5578%2042.9952%2088.5578H77.0212C82.5296%2088.5578%2087.8124%2086.3741%2091.7075%2082.4872C95.6025%2078.6002%2097.7907%2073.3283%2097.7907%2067.8313V33.8758C97.7907%2032.2296%2097.1354%2030.6508%2095.9689%2029.4867C94.8024%2028.3227%2093.2204%2027.6687%2091.5707%2027.6687H42.9952Z'%20fill='%23FFFBFE'/%3e%3cpath%20d='M91.5707%2089.7402H42.9952C41.032%2089.738%2039.1498%2088.9587%2037.7616%2087.5734C36.3734%2086.1881%2035.5925%2084.3098%2035.5903%2082.3507V33.8758C35.5925%2031.9167%2036.3734%2030.0384%2037.7616%2028.6531C39.1498%2027.2678%2041.032%2026.4885%2042.9952%2026.4863H91.5707C93.5339%2026.4885%2095.4161%2027.2678%2096.8043%2028.6531C98.1925%2030.0384%2098.9733%2031.9167%2098.9755%2033.8758V82.3507C98.9733%2084.3098%2098.1925%2086.1881%2096.8043%2087.5734C95.4161%2088.9587%2093.5339%2089.738%2091.5707%2089.7402ZM42.9952%2027.6687C41.3455%2027.6687%2039.7634%2028.3227%2038.597%2029.4867C37.4305%2030.6508%2036.7752%2032.2296%2036.7752%2033.8758V82.3507C36.7752%2083.9969%2037.4305%2085.5757%2038.597%2086.7398C39.7634%2087.9039%2041.3455%2088.5578%2042.9952%2088.5578H77.0212C82.5296%2088.5578%2087.8124%2086.3741%2091.7075%2082.4872C95.6025%2078.6002%2097.7907%2073.3283%2097.7907%2067.8313V33.8758C97.7907%2032.2296%2097.1354%2030.6508%2095.9689%2029.4867C94.8024%2028.3227%2093.2204%2027.6687%2091.5707%2027.6687H42.9952Z'%20fill='%23002B54'%20fill-opacity='0.11'/%3e%3c/g%3e%3cg%20id='Path%207'%3e%3cpath%20d='M48.2313%2032.709C47.1259%2032.7102%2046.0662%2033.149%2045.2845%2033.929C44.5029%2034.709%2044.0632%2035.7665%2044.062%2036.8696V43.3821C44.0632%2044.4852%2044.5029%2045.5427%2045.2845%2046.3227C46.0662%2047.1027%2047.1259%2047.5415%2048.2313%2047.5427H54.7573C55.8626%2047.5415%2056.9224%2047.1027%2057.704%2046.3227C58.4857%2045.5427%2058.9253%2044.4852%2058.9266%2043.3821V36.8696C58.9253%2035.7665%2058.4857%2034.709%2057.704%2033.929C56.9224%2033.149%2055.8626%2032.7102%2054.7573%2032.709H48.2313Z'%20fill='%23FFFBFE'/%3e%3cpath%20d='M48.2313%2032.709C47.1259%2032.7102%2046.0662%2033.149%2045.2845%2033.929C44.5029%2034.709%2044.0632%2035.7665%2044.062%2036.8696V43.3821C44.0632%2044.4852%2044.5029%2045.5427%2045.2845%2046.3227C46.0662%2047.1027%2047.1259%2047.5415%2048.2313%2047.5427H54.7573C55.8626%2047.5415%2056.9224%2047.1027%2057.704%2046.3227C58.4857%2045.5427%2058.9253%2044.4852%2058.9266%2043.3821V36.8696C58.9253%2035.7665%2058.4857%2034.709%2057.704%2033.929C56.9224%2033.149%2055.8626%2032.7102%2054.7573%2032.709H48.2313Z'%20fill='%23002B54'%20fill-opacity='0.11'/%3e%3c/g%3e%3cg%20id='Path%208'%3e%3cpath%20d='M48.2313%2051.042C47.1259%2051.0432%2046.0662%2051.482%2045.2845%2052.262C44.5029%2053.042%2044.0632%2054.0995%2044.062%2055.2026V61.7151C44.0632%2062.8182%2044.5029%2063.8757%2045.2845%2064.6557C46.0662%2065.4358%2047.1259%2065.8745%2048.2313%2065.8757H54.7573C55.8626%2065.8745%2056.9224%2065.4358%2057.704%2064.6557C58.4857%2063.8757%2058.9253%2062.8182%2058.9266%2061.7151V55.2026C58.9253%2054.0995%2058.4857%2053.042%2057.704%2052.262C56.9224%2051.482%2055.8626%2051.0432%2054.7573%2051.042H48.2313Z'%20fill='%23FFFBFE'/%3e%3cpath%20d='M48.2313%2051.042C47.1259%2051.0432%2046.0662%2051.482%2045.2845%2052.262C44.5029%2053.042%2044.0632%2054.0995%2044.062%2055.2026V61.7151C44.0632%2062.8182%2044.5029%2063.8757%2045.2845%2064.6557C46.0662%2065.4358%2047.1259%2065.8745%2048.2313%2065.8757H54.7573C55.8626%2065.8745%2056.9224%2065.4358%2057.704%2064.6557C58.4857%2063.8757%2058.9253%2062.8182%2058.9266%2061.7151V55.2026C58.9253%2054.0995%2058.4857%2053.042%2057.704%2052.262C56.9224%2051.482%2055.8626%2051.0432%2054.7573%2051.042H48.2313Z'%20fill='%23002B54'%20fill-opacity='0.11'/%3e%3c/g%3e%3cg%20id='Path%209'%3e%3cpath%20d='M48.2313%2069.376C47.1259%2069.3772%2046.0662%2069.816%2045.2845%2070.596C44.5029%2071.376%2044.0632%2072.4335%2044.062%2073.5366V80.0491C44.0632%2081.1522%2044.5029%2082.2097%2045.2845%2082.9897C46.0662%2083.7697%2047.1259%2084.2085%2048.2313%2084.2097H54.7573C55.8626%2084.2085%2056.9224%2083.7697%2057.704%2082.9897C58.4857%2082.2097%2058.9253%2081.1522%2058.9266%2080.0491V73.5366C58.9253%2072.4335%2058.4857%2071.376%2057.704%2070.596C56.9224%2069.816%2055.8626%2069.3772%2054.7573%2069.376H48.2313Z'%20fill='%23FFFBFE'/%3e%3cpath%20d='M48.2313%2069.376C47.1259%2069.3772%2046.0662%2069.816%2045.2845%2070.596C44.5029%2071.376%2044.0632%2072.4335%2044.062%2073.5366V80.0491C44.0632%2081.1522%2044.5029%2082.2097%2045.2845%2082.9897C46.0662%2083.7697%2047.1259%2084.2085%2048.2313%2084.2097H54.7573C55.8626%2084.2085%2056.9224%2083.7697%2057.704%2082.9897C58.4857%2082.2097%2058.9253%2081.1522%2058.9266%2080.0491V73.5366C58.9253%2072.4335%2058.4857%2071.376%2057.704%2070.596C56.9224%2069.816%2055.8626%2069.3772%2054.7573%2069.376H48.2313Z'%20fill='%23002B54'%20fill-opacity='0.11'/%3e%3c/g%3e%3cg%20id='Group%206'%3e%3cpath%20id='Path%2010'%20d='M52.5601%2016.8203C51.1673%2016.8219%2049.8319%2017.3747%2048.8471%2018.3575C47.8622%2019.3404%2047.3082%2020.6729%2047.3066%2022.0629V30.2686C47.3082%2031.6585%2047.8622%2032.991%2048.8471%2033.9739C49.8319%2034.9567%2051.1673%2035.5096%2052.5601%2035.5111H60.7828C62.1756%2035.5096%2063.511%2034.9567%2064.4958%2033.9739C65.4807%2032.991%2066.0347%2031.6585%2066.0362%2030.2686V22.0629C66.0347%2020.6729%2065.4807%2019.3404%2064.4958%2018.3575C63.511%2017.3747%2062.1756%2016.8219%2060.7828%2016.8203H52.5601Z'%20fill='%2394A9C3'/%3e%3cpath%20id='Path%2011'%20d='M79.6314%2039.752C78.2386%2039.7535%2076.9032%2040.3063%2075.9183%2041.2892C74.9335%2042.272%2074.3795%2043.6046%2074.3779%2044.9945V53.2002C74.3795%2054.5901%2074.9335%2055.9227%2075.9183%2056.9055C76.9032%2057.8884%2078.2386%2058.4412%2079.6314%2058.4427H87.8543C89.2472%2058.4412%2090.5825%2057.8884%2091.5674%2056.9055C92.5522%2055.9227%2093.1062%2054.5901%2093.1078%2053.2002V44.9945C93.1062%2043.6046%2092.5522%2042.272%2091.5674%2041.2892C90.5825%2040.3063%2089.2472%2039.7535%2087.8543%2039.752H79.6314Z'%20fill='%2394A9C3'/%3e%3cg%20id='Group%202'%3e%3cpath%20id='Path%2012'%20d='M67.862%20122.347L66.1914%20122.333L65.4512%20115.753L67.9166%20115.774L67.862%20122.347Z'%20fill='%23A0616A'/%3e%3cpath%20id='Path%2013'%20d='M62.5117%20124.997C62.5102%20125.195%2062.5874%20125.385%2062.7262%20125.526C62.865%20125.667%2063.0542%20125.747%2063.2522%20125.749L66.5735%20125.777L67.155%20124.601L67.3686%20125.783L68.6218%20125.794L68.3053%20121.578L67.8693%20121.549L66.0909%20121.427L65.5173%20121.389L65.5072%20122.582L62.8392%20124.387C62.7392%20124.455%2062.6571%20124.546%2062.6001%20124.653C62.5431%20124.759%2062.5129%20124.878%2062.512%20124.999L62.5117%20124.997Z'%20fill='%232F2E41'/%3e%3c/g%3e%3cg%20id='Group%203'%3e%3cpath%20id='Path%2014'%20d='M76.3615%20122.347L74.6909%20122.333L73.9512%20115.753L76.4166%20115.774L76.3615%20122.347Z'%20fill='%23A0616A'/%3e%3cpath%20id='Path%2015'%20d='M71.0117%20124.997C71.0102%20125.195%2071.0874%20125.385%2071.2262%20125.526C71.365%20125.667%2071.5542%20125.747%2071.7522%20125.749L75.0735%20125.777L75.655%20124.601L75.8686%20125.783L77.1218%20125.794L76.8053%20121.578L76.3693%20121.549L74.5909%20121.427L74.0173%20121.389L74.0072%20122.582L71.3392%20124.387C71.2392%20124.455%2071.1571%20124.546%2071.1001%20124.653C71.0431%20124.759%2071.0128%20124.878%2071.012%20124.999L71.0117%20124.997Z'%20fill='%232F2E41'/%3e%3c/g%3e%3cpath%20id='Path%2016'%20d='M61.3069%2069.1484L68.078%2069.3618L74.493%2070.7845C74.493%2070.7845%2073.8515%2071.5667%2075.9899%2073.7007C75.9899%2073.7007%2078.8409%2078.6797%2076.8453%2083.5165L75.9899%20102.862C75.9899%20102.862%2078.4838%20116.501%2076.5778%20120.841L74.0595%20120.999L69.7974%20103.02L67.7204%2083.6578L66.7249%20102.721C66.7249%20102.721%2070.5425%20115.806%2068.1319%20121L65.4044%20120.843L60.7376%20102.721C60.7376%20102.721%2058.7418%2081.8096%2059.0269%2077.8264C59.312%2073.8432%2061.3076%2069.1487%2061.3076%2069.1487L61.3069%2069.1484Z'%20fill='%23605D62'/%3e%3cg%20id='Group%204'%3e%3cpath%20id='Path%2017'%20d='M84.0463%2038.5773C83.7239%2038.6602%2083.4323%2038.8343%2083.2065%2039.0786C82.9808%2039.3229%2082.8305%2039.627%2082.7738%2039.9545C82.7171%2040.2819%2082.7563%2040.6188%2082.8867%2040.9245C83.0172%2041.2303%2083.2333%2041.4919%2083.5092%2041.6781V41.6805L83.3779%2044.8546L85.8119%2045.979L86.0062%2041.0948H85.9893C86.1559%2040.7997%2086.2317%2040.4621%2086.2074%2040.1242C86.1831%2039.7863%2086.0597%2039.463%2085.8526%2039.1946C85.6455%2038.9261%2085.3638%2038.7245%2085.0427%2038.6147C84.7215%2038.5049%2084.3751%2038.4918%2084.0466%2038.5771L84.0463%2038.5773Z'%20fill='%23A0616A'/%3e%3cpath%20id='Path%2018'%20d='M70.4427%2049.9048C69.9411%2049.4044%2069.6483%2048.7329%2069.6233%2048.0255C69.5984%2047.3182%2069.8431%2046.6277%2070.3083%2046.0934C70.7734%2045.559%2071.4243%2045.2206%2072.1296%2045.1464C72.835%2045.0721%2073.5423%2045.2676%2074.1089%2045.6933L81.7513%2051.436L83.1133%2043.1631L86.0372%2044.1025L85.3396%2054.875C85.3157%2055.2433%2085.1984%2055.5995%2084.9987%2055.9101C84.799%2056.2207%2084.5235%2056.4756%2084.1979%2056.6507C83.8724%2056.8258%2083.5077%2056.9155%2083.1379%2056.9113C82.7681%2056.9071%2082.4054%2056.8092%2082.084%2056.6267L71.0389%2050.3558C70.8211%2050.2324%2070.6205%2050.0809%2070.4425%2049.905L70.4427%2049.9048Z'%20fill='%23939094'/%3e%3c/g%3e%3cg%20id='Group%205'%3e%3cpath%20id='Path%2019'%20d='M58.7887%2033.9498C58.9592%2034.2353%2059.0434%2034.5637%2059.0314%2034.8958C59.0193%2035.2279%2058.9115%2035.5494%2058.7208%2035.8218C58.53%2036.0941%2058.2646%2036.3058%2057.9563%2036.4313C57.648%2036.5568%2057.3099%2036.5908%2056.9827%2036.5292L56.981%2036.5309L54.835%2038.8775L52.3135%2037.9658L55.6203%2034.3607L55.6321%2034.373C55.7221%2034.0464%2055.9064%2033.7534%2056.162%2033.5306C56.4177%2033.3078%2056.7333%2033.1649%2057.0697%2033.1199C57.4061%2033.0748%2057.7484%2033.1294%2058.0539%2033.2771C58.3594%2033.4247%2058.6146%2033.6587%2058.7877%2033.9501L58.7887%2033.9498Z'%20fill='%23A0616A'/%3e%3cpath%20id='Path%2020'%20d='M59.7154%2051.4528L47.4473%2048.1458C47.0903%2048.0495%2046.7637%2047.8642%2046.4982%2047.6074C46.2327%2047.3506%2046.0369%2047.0306%2045.9293%2046.6775C45.8217%2046.3245%2045.8059%2045.9499%2045.8832%2045.589C45.9605%2045.2282%2046.1284%2044.8928%2046.3713%2044.6145L53.476%2036.4746L56.2151%2037.8618L51.3455%2044.6937L60.825%2045.9856C61.5272%2046.0821%2062.1666%2046.4405%2062.6146%2046.9886C63.0625%2047.5368%2063.2857%2048.2339%2063.2391%2048.9397C63.1925%2049.6455%2062.8797%2050.3074%2062.3635%2050.7922C61.8474%2051.277%2061.1664%2051.5486%2060.4576%2051.5523C60.2072%2051.5524%2059.9579%2051.5196%2059.7161%2051.4545L59.7154%2051.4528Z'%20fill='%23939094'/%3e%3c/g%3e%3cpath%20id='Path%2021'%20d='M77.2059%2071.9951L60.0501%2072.7805C59.5788%2072.0665%2059.7071%2070.9929%2060.3663%2069.6482C62.8577%2064.5719%2060.9657%2054.9683%2059.6927%2049.9677C59.6067%2049.6386%2059.593%2049.2949%2059.6526%2048.9601C59.7122%2048.6253%2059.8436%2048.3072%2060.0378%2048.0278C60.2321%2047.7484%2060.4846%2047.5142%2060.778%2047.3413C61.0714%2047.1683%2061.3988%2047.0607%2061.7378%2047.0258L63.3544%2046.8645L64.8486%2042.3096H70.0854L72.2579%2044.7865L75.9449%2047.0217C75.2737%2053.9201%2072.4142%2063.6611%2076.4879%2068.5461C77.3788%2069.6145%2077.6316%2070.7705%2077.2039%2071.9954L77.2059%2071.9951Z'%20fill='%23939094'/%3e%3cpath%20id='Ellipse%201'%20d='M66.803%2042.4149C69.6201%2042.4149%2071.9038%2040.1359%2071.9038%2037.3246C71.9038%2034.5134%2069.6201%2032.2344%2066.803%2032.2344C63.9859%2032.2344%2061.7021%2034.5134%2061.7021%2037.3246C61.7021%2040.1359%2063.9859%2042.4149%2066.803%2042.4149Z'%20fill='%23A0616A'/%3e%3cpath%20id='Path%2022'%20d='M72.5746%2034.0662C73.2849%2031.4842%2065.5496%2029.27%2064.0466%2031.3495C63.8377%2031.054%2063.0651%2030.8743%2062.7109%2030.965C62.3639%2031.0802%2062.0433%2031.263%2061.7676%2031.5028C61.3456%2031.7821%2060.985%2032.1443%2060.708%2032.5673C60.4608%2033.0073%2060.4226%2033.6047%2060.7552%2033.9851C61.0188%2034.288%2061.4818%2035.8974%2061.8781%2035.9773C62.1544%2036.0335%2062.3868%2036.0787%2062.587%2036.1115C62.765%2035.8521%2063.2192%2035.5263%2063.1866%2035.2127C63.4561%2035.3904%2063.3581%2035.703%2063.3032%2036.0228C63.1227%2037.0871%2059.0543%2045.325%2061.3845%2042.8975C61.6535%2043.0503%2061.9365%2043.1772%2062.2296%2043.2766C62.8094%2042.3922%2063.2535%2041.4264%2063.5472%2040.411L63.5494%2040.4301C63.6055%2040.8706%2063.7905%2041.2849%2064.0813%2041.6212C64.372%2041.9574%2064.7557%2042.2007%2065.1842%2042.3206C68.6818%2043.3318%2071.5112%2041.8481%2072.4837%2039.1722C72.1275%2038.4503%2071.9722%2038.5288%2072.0041%2038.5073C72.1086%2038.4376%2072.2276%2038.3923%2072.3521%2038.3748C72.4766%2038.3572%2072.6035%2038.3679%2072.7233%2038.406C72.8431%2038.4441%2072.9528%2038.5086%2073.0442%2038.5948C73.1356%2038.6809%2073.2064%2038.7865%2073.2514%2038.9038C73.3077%2039.0504%2073.3589%2039.177%2073.4032%2039.2719C73.9103%2037.463%2074.5133%2037.7231%2072.5741%2034.0667L72.5746%2034.0662Z'%20fill='%232F2E41'/%3e%3cpath%20id='Path%2023'%20d='M70.162%2032.1923L69.8046%2030.3695C69.7583%2030.2192%2069.7621%2030.058%2069.8154%2029.91C69.8681%2029.8242%2069.9459%2029.7566%2070.0382%2029.7162C70.1306%2029.6759%2070.2331%2029.6647%2070.332%2029.6841C70.5309%2029.7127%2070.6798%2029.8941%2070.8777%2029.9285C71.5661%2030.0508%2072.4758%2029.3715%2072.7225%2031.0877C72.8253%2031.8032%2073.9695%2031.879%2074.3516%2032.493C74.7337%2033.107%2074.7805%2033.9936%2074.259%2034.4952C74.0367%2034.6814%2073.7672%2034.8025%2073.4802%2034.8452C73.1932%2034.888%2072.8999%2034.8507%2072.6328%2034.7375C72.1014%2034.5025%2071.6363%2034.1405%2071.2785%2033.6834C70.9228%2033.228%2070.5352%2032.7984%2070.1184%2032.3979'%20fill='%232F2E41'/%3e%3cpath%20id='Path%2024'%20d='M72.8474%2034.9649C71.4512%2034.7693%2070.5003%2034.2638%2070.0197%2033.4593C69.8332%2033.116%2069.7202%2032.7378%2069.6876%2032.3486C69.655%2031.9594%2069.7036%2031.5677%2069.8303%2031.1982L70.1243%2031.3078C70.1203%2031.3185%2069.7382%2032.3796%2070.2908%2033.3014C70.7207%2034.0184%2071.5952%2034.4735%2072.89%2034.6539L72.8474%2034.9649Z'%20fill='%2394A9C3'/%3e%3c/g%3e%3cpath%20id='Path%2025'%20d='M79.3969%2015.2698C77.9251%2015.2698%2076.4862%2014.8342%2075.2624%2014.0182C74.0386%2013.2022%2073.0848%2012.0424%2072.5216%2010.6854C71.9583%209.32836%2071.8109%207.83516%2072.0981%206.39458C72.3852%204.954%2073.094%203.63074%2074.1347%202.59214C75.1755%201.55354%2076.5015%200.846241%2077.9451%200.559692C79.3887%200.273142%2080.885%200.42021%2082.2448%200.982297C83.6046%201.54438%2084.7668%202.49624%2085.5846%203.71751C86.4023%204.93878%2086.8387%206.37459%2086.8387%207.8434C86.8364%209.81229%2086.0516%2011.6999%2084.6565%2013.0921C83.2614%2014.4843%2081.3699%2015.2675%2079.3969%2015.2698ZM79.3969%203.38746C78.5138%203.38746%2077.6505%203.64879%2076.9162%204.13842C76.1819%204.62804%2075.6096%205.32397%2075.2716%206.13818C74.9336%206.9524%2074.8452%207.84834%2075.0175%208.71271C75.1898%209.57708%2075.6151%2010.371%2076.2395%2010.9942C76.864%2011.6174%2077.6596%2012.0418%2078.5258%2012.2137C79.392%2012.3857%2080.2898%2012.2974%2081.1057%2011.9601C81.9216%2011.6229%2082.6189%2011.0518%2083.1096%2010.319C83.6002%209.58621%2083.8621%208.7247%2083.8621%207.8434C83.8608%206.66201%2083.3899%205.52937%2082.5528%204.694C81.7157%203.85863%2080.5807%203.38875%2079.3969%203.38746Z'%20fill='%2394A9C3'/%3e%3cpath%20id='Path%2026'%20d='M90.847%2020.3164C90.4689%2020.317%2090.1048%2020.1732%2089.8295%2019.9145L82.845%2013.3823C82.6993%2013.2497%2082.5815%2013.0896%2082.4983%2012.9113C82.4151%2012.7329%2082.3683%2012.5398%2082.3605%2012.3432C82.3528%2012.1467%2082.3842%2011.9505%2082.4531%2011.7662C82.5219%2011.5818%2082.6268%2011.413%2082.7616%2011.2694C82.8964%2011.1258%2083.0584%2011.0105%2083.2383%2010.9299C83.4182%2010.8494%2083.6123%2010.8053%2083.8094%2010.8003C84.0064%2010.7953%2084.2026%2010.8294%2084.3863%2010.9006C84.5701%2010.9718%2084.7378%2011.0788%2084.8798%2011.2153L91.8646%2017.7475C92.0823%2017.9512%2092.2336%2018.2155%2092.299%2018.5061C92.3643%2018.7967%2092.3405%2019.1002%2092.2308%2019.3771C92.1211%2019.6541%2091.9305%2019.8917%2091.6838%2020.0592C91.437%2020.2267%2091.1455%2020.3163%2090.847%2020.3164Z'%20fill='%2394A9C3'/%3e%3cg%20id='Group%207'%3e%3cg%20id='Path%2027'%3e%3cpath%20d='M122.415%20122.18C122.528%20122.185%20122.641%20122.156%20122.738%20122.095C122.834%20122.034%20122.909%20121.945%20122.953%20121.84C122.997%20121.735%20123.008%20121.619%20122.983%20121.508C122.959%20121.397%20122.901%20121.296%20122.818%20121.219L122.78%20121.068L122.795%20121.031C122.909%20120.761%20123.102%20120.531%20123.347%20120.369C123.593%20120.207%20123.881%20120.122%20124.175%20120.123C124.469%20120.124%20124.756%20120.212%20125.001%20120.375C125.245%20120.539%20125.436%20120.771%20125.548%20121.042C125.999%20122.124%20126.572%20123.208%20126.713%20124.353C126.775%20124.859%20126.749%20125.372%20126.636%20125.868C127.694%20123.566%20128.243%20121.063%20128.246%20118.53C128.247%20117.894%20128.211%20117.259%20128.14%20116.628C128.082%20116.11%20128%20115.596%20127.897%20115.085C127.33%20112.315%20126.112%20109.719%20124.345%20107.51C123.489%20107.044%20122.797%20106.327%20122.362%20105.457C122.205%20105.144%20122.093%20104.81%20122.032%20104.465C122.128%20104.478%20122.396%20103.011%20122.323%20102.921C122.457%20102.717%20122.698%20102.616%20122.845%20102.417C123.575%20101.429%20124.582%20101.602%20125.107%20102.945C126.229%20103.51%20126.24%20104.447%20125.552%20105.349C125.113%20105.923%20125.053%20106.699%20124.67%20107.313C124.709%20107.364%20124.75%20107.413%20124.79%20107.463C125.513%20108.391%20126.143%20109.388%20126.672%20110.438C126.543%20109.261%20126.696%20108.071%20127.119%20106.965C127.547%20105.934%20128.35%20105.065%20129.056%20104.174C129.243%20103.935%20129.497%20103.756%20129.786%20103.661C130.075%20103.565%20130.385%20103.557%20130.678%20103.638C130.972%20103.719%20131.234%20103.884%20131.433%20104.114C131.632%20104.343%20131.758%20104.627%20131.796%20104.928C131.797%20104.941%20131.799%20104.954%20131.8%20104.967C131.695%20105.026%20131.592%20105.089%20131.492%20105.155C131.366%20105.24%20131.268%20105.36%20131.211%20105.501C131.155%20105.641%20131.142%20105.796%20131.175%20105.944C131.208%20106.091%20131.285%20106.226%20131.395%20106.33C131.506%20106.433%20131.646%20106.501%20131.796%20106.524L131.811%20106.527C131.774%20106.904%20131.708%20107.278%20131.613%20107.646C132.52%20111.145%20130.563%20112.42%20127.768%20112.477C127.706%20112.509%20127.645%20112.54%20127.584%20112.57C128.115%20114.071%20128.448%20115.635%20128.575%20117.222C128.646%20118.157%20128.642%20119.097%20128.562%20120.033L128.567%20119.999C128.769%20118.959%20129.325%20118.021%20130.141%20117.342C131.352%20116.349%20133.064%20115.983%20134.371%20115.185C134.51%20115.096%20134.671%20115.049%20134.836%20115.048C135.001%20115.048%20135.163%20115.095%20135.302%20115.183C135.441%20115.271%20135.553%20115.398%20135.622%20115.547C135.692%20115.696%20135.718%20115.862%20135.696%20116.025L135.691%20116.06C135.496%20116.14%20135.306%20116.231%20135.123%20116.333C135.018%20116.393%20134.915%20116.455%20134.814%20116.522C134.688%20116.606%20134.59%20116.726%20134.534%20116.867C134.477%20117.008%20134.465%20117.162%20134.497%20117.31C134.53%20117.458%20134.607%20117.592%20134.718%20117.696C134.829%20117.8%20134.968%20117.867%20135.118%20117.891L135.134%20117.893L135.165%20117.898C134.832%20118.691%20134.365%20119.421%20133.784%20120.056C133.217%20123.111%20130.782%20123.401%20128.177%20122.511H128.176C127.89%20123.75%20127.476%20124.957%20126.94%20126.111H122.525C122.509%20126.062%20122.494%20126.011%20122.48%20125.962C122.889%20125.988%20123.299%20125.963%20123.702%20125.889C123.374%20125.488%20123.047%20125.084%20122.719%20124.683C122.712%20124.675%20122.705%20124.667%20122.698%20124.658C122.532%20124.453%20122.365%20124.249%20122.199%20124.044C122.19%20123.415%20122.262%20122.787%20122.414%20122.177L122.415%20122.18Z'%20fill='%23FFFBFE'/%3e%3cpath%20d='M122.415%20122.18C122.528%20122.185%20122.641%20122.156%20122.738%20122.095C122.834%20122.034%20122.909%20121.945%20122.953%20121.84C122.997%20121.735%20123.008%20121.619%20122.983%20121.508C122.959%20121.397%20122.901%20121.296%20122.818%20121.219L122.78%20121.068L122.795%20121.031C122.909%20120.761%20123.102%20120.531%20123.347%20120.369C123.593%20120.207%20123.881%20120.122%20124.175%20120.123C124.469%20120.124%20124.756%20120.212%20125.001%20120.375C125.245%20120.539%20125.436%20120.771%20125.548%20121.042C125.999%20122.124%20126.572%20123.208%20126.713%20124.353C126.775%20124.859%20126.749%20125.372%20126.636%20125.868C127.694%20123.566%20128.243%20121.063%20128.246%20118.53C128.247%20117.894%20128.211%20117.259%20128.14%20116.628C128.082%20116.11%20128%20115.596%20127.897%20115.085C127.33%20112.315%20126.112%20109.719%20124.345%20107.51C123.489%20107.044%20122.797%20106.327%20122.362%20105.457C122.205%20105.144%20122.093%20104.81%20122.032%20104.465C122.128%20104.478%20122.396%20103.011%20122.323%20102.921C122.457%20102.717%20122.698%20102.616%20122.845%20102.417C123.575%20101.429%20124.582%20101.602%20125.107%20102.945C126.229%20103.51%20126.24%20104.447%20125.552%20105.349C125.113%20105.923%20125.053%20106.699%20124.67%20107.313C124.709%20107.364%20124.75%20107.413%20124.79%20107.463C125.513%20108.391%20126.143%20109.388%20126.672%20110.438C126.543%20109.261%20126.696%20108.071%20127.119%20106.965C127.547%20105.934%20128.35%20105.065%20129.056%20104.174C129.243%20103.935%20129.497%20103.756%20129.786%20103.661C130.075%20103.565%20130.385%20103.557%20130.678%20103.638C130.972%20103.719%20131.234%20103.884%20131.433%20104.114C131.632%20104.343%20131.758%20104.627%20131.796%20104.928C131.797%20104.941%20131.799%20104.954%20131.8%20104.967C131.695%20105.026%20131.592%20105.089%20131.492%20105.155C131.366%20105.24%20131.268%20105.36%20131.211%20105.501C131.155%20105.641%20131.142%20105.796%20131.175%20105.944C131.208%20106.091%20131.285%20106.226%20131.395%20106.33C131.506%20106.433%20131.646%20106.501%20131.796%20106.524L131.811%20106.527C131.774%20106.904%20131.708%20107.278%20131.613%20107.646C132.52%20111.145%20130.563%20112.42%20127.768%20112.477C127.706%20112.509%20127.645%20112.54%20127.584%20112.57C128.115%20114.071%20128.448%20115.635%20128.575%20117.222C128.646%20118.157%20128.642%20119.097%20128.562%20120.033L128.567%20119.999C128.769%20118.959%20129.325%20118.021%20130.141%20117.342C131.352%20116.349%20133.064%20115.983%20134.371%20115.185C134.51%20115.096%20134.671%20115.049%20134.836%20115.048C135.001%20115.048%20135.163%20115.095%20135.302%20115.183C135.441%20115.271%20135.553%20115.398%20135.622%20115.547C135.692%20115.696%20135.718%20115.862%20135.696%20116.025L135.691%20116.06C135.496%20116.14%20135.306%20116.231%20135.123%20116.333C135.018%20116.393%20134.915%20116.455%20134.814%20116.522C134.688%20116.606%20134.59%20116.726%20134.534%20116.867C134.477%20117.008%20134.465%20117.162%20134.497%20117.31C134.53%20117.458%20134.607%20117.592%20134.718%20117.696C134.829%20117.8%20134.968%20117.867%20135.118%20117.891L135.134%20117.893L135.165%20117.898C134.832%20118.691%20134.365%20119.421%20133.784%20120.056C133.217%20123.111%20130.782%20123.401%20128.177%20122.511H128.176C127.89%20123.75%20127.476%20124.957%20126.94%20126.111H122.525C122.509%20126.062%20122.494%20126.011%20122.48%20125.962C122.889%20125.988%20123.299%20125.963%20123.702%20125.889C123.374%20125.488%20123.047%20125.084%20122.719%20124.683C122.712%20124.675%20122.705%20124.667%20122.698%20124.658C122.532%20124.453%20122.365%20124.249%20122.199%20124.044C122.19%20123.415%20122.262%20122.787%20122.414%20122.177L122.415%20122.18Z'%20fill='%23002B54'%20fill-opacity='0.11'/%3e%3c/g%3e%3cg%20id='Path%2028'%3e%3cpath%20d='M0.294435%20126.126C0.294306%20126.164%200.301757%20126.202%200.31636%20126.237C0.330963%20126.273%200.352429%20126.305%200.379522%20126.332C0.406615%20126.359%200.4388%20126.38%200.474224%20126.395C0.509648%20126.409%200.54761%20126.417%200.585926%20126.417H135.379C135.457%20126.417%20135.531%20126.386%20135.586%20126.332C135.64%20126.277%20135.671%20126.203%20135.671%20126.126C135.671%20126.049%20135.64%20125.975%20135.586%20125.92C135.531%20125.866%20135.457%20125.835%20135.379%20125.835H0.585926C0.547619%20125.835%200.509672%20125.842%200.474263%20125.857C0.438854%20125.871%200.406681%20125.893%200.379595%20125.92C0.352508%20125.947%200.331041%20125.979%200.316426%20126.014C0.301812%20126.05%200.294338%20126.088%200.294435%20126.126Z'%20fill='%23FFFBFE'/%3e%3cpath%20d='M0.294435%20126.126C0.294306%20126.164%200.301757%20126.202%200.31636%20126.237C0.330963%20126.273%200.352429%20126.305%200.379522%20126.332C0.406615%20126.359%200.4388%20126.38%200.474224%20126.395C0.509648%20126.409%200.54761%20126.417%200.585926%20126.417H135.379C135.457%20126.417%20135.531%20126.386%20135.586%20126.332C135.64%20126.277%20135.671%20126.203%20135.671%20126.126C135.671%20126.049%20135.64%20125.975%20135.586%20125.92C135.531%20125.866%20135.457%20125.835%20135.379%20125.835H0.585926C0.547619%20125.835%200.509672%20125.842%200.474263%20125.857C0.438854%20125.871%200.406681%20125.893%200.379595%20125.92C0.352508%20125.947%200.331041%20125.979%200.316426%20126.014C0.301812%20126.05%200.294338%20126.088%200.294435%20126.126Z'%20fill='%23002B54'%20fill-opacity='0.14'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_333_1050'%3e%3crect%20width='135.411'%20height='126'%20fill='white'%20transform='translate(0.294434%200.416992)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", SearchEmptyMobile = "data:image/svg+xml,%3csvg%20width='78'%20height='73'%20viewBox='0%200%2078%2073'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_1650_18686)'%3e%3cmask%20id='mask0_1650_18686'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='0'%20y='0'%20width='78'%20height='73'%3e%3cpath%20d='M77.831%200.239258H0.168823V72.504H77.831V0.239258Z'%20fill='white'/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_1650_18686)'%3e%3cpath%20d='M52.5184%2051.4689H24.6589C23.533%2051.4676%2022.4535%2051.0207%2021.6573%2050.2262C20.8611%2049.4317%2020.4132%2048.3544%2020.412%2047.2308V19.429C20.4132%2018.3054%2020.8611%2017.2282%2021.6573%2016.4336C22.4535%2015.6391%2023.533%2015.1922%2024.6589%2015.1909H52.5184C53.6443%2015.1922%2054.7238%2015.6391%2055.52%2016.4336C56.3162%2017.2282%2056.764%2018.3054%2056.7653%2019.429V47.2308C56.764%2048.3544%2056.3162%2049.4317%2055.52%2050.2262C54.7238%2051.0207%2053.6443%2051.4676%2052.5184%2051.4689ZM24.6589%2015.8691C23.7128%2015.8691%2022.8054%2016.2441%2022.1364%2016.9117C21.4674%2017.5794%2021.0916%2018.4849%2021.0916%2019.429V47.2308C21.0916%2048.1749%2021.4674%2049.0804%2022.1364%2049.7481C22.8054%2050.4157%2023.7128%2050.7907%2024.6589%2050.7907H44.1738C47.3331%2050.7907%2050.3629%2049.5383%2052.5968%2047.3091C54.8307%2045.0798%2056.0857%2042.0562%2056.0857%2038.9035V19.429C56.0857%2018.4849%2055.7099%2017.5794%2055.0409%2016.9117C54.3719%2016.2441%2053.4645%2015.8691%2052.5184%2015.8691H24.6589Z'%20fill='%23FFFBFE'/%3e%3cpath%20d='M52.5184%2051.4689H24.6589C23.533%2051.4676%2022.4535%2051.0207%2021.6573%2050.2262C20.8611%2049.4317%2020.4132%2048.3544%2020.412%2047.2308V19.429C20.4132%2018.3054%2020.8611%2017.2282%2021.6573%2016.4336C22.4535%2015.6391%2023.533%2015.1922%2024.6589%2015.1909H52.5184C53.6443%2015.1922%2054.7238%2015.6391%2055.52%2016.4336C56.3162%2017.2282%2056.764%2018.3054%2056.7653%2019.429V47.2308C56.764%2048.3544%2056.3162%2049.4317%2055.52%2050.2262C54.7238%2051.0207%2053.6443%2051.4676%2052.5184%2051.4689ZM24.6589%2015.8691C23.7128%2015.8691%2022.8054%2016.2441%2022.1364%2016.9117C21.4674%2017.5794%2021.0916%2018.4849%2021.0916%2019.429V47.2308C21.0916%2048.1749%2021.4674%2049.0804%2022.1364%2049.7481C22.8054%2050.4157%2023.7128%2050.7907%2024.6589%2050.7907H44.1738C47.3331%2050.7907%2050.3629%2049.5383%2052.5968%2047.3091C54.8307%2045.0798%2056.0857%2042.0562%2056.0857%2038.9035V19.429C56.0857%2018.4849%2055.7099%2017.5794%2055.0409%2016.9117C54.3719%2016.2441%2053.4645%2015.8691%2052.5184%2015.8691H24.6589Z'%20fill='%23002B54'%20fill-opacity='0.11'/%3e%3cpath%20d='M27.662%2018.7598C27.028%2018.7605%2026.4202%2019.0121%2025.9719%2019.4595C25.5236%2019.9068%2025.2714%2020.5133%2025.2708%2021.146V24.8811C25.2714%2025.5138%2025.5236%2026.1203%2025.9719%2026.5676C26.4202%2027.015%2027.028%2027.2666%2027.662%2027.2673H31.4048C32.0387%2027.2666%2032.6466%2027.015%2033.0948%2026.5676C33.5432%2026.1203%2033.7953%2025.5138%2033.796%2024.8811V21.146C33.7953%2020.5133%2033.5432%2019.9068%2033.0948%2019.4595C32.6466%2019.0121%2032.0387%2018.7605%2031.4048%2018.7598H27.662Z'%20fill='%23FFFBFE'/%3e%3cpath%20d='M27.662%2018.7598C27.028%2018.7605%2026.4202%2019.0121%2025.9719%2019.4595C25.5236%2019.9068%2025.2714%2020.5133%2025.2708%2021.146V24.8811C25.2714%2025.5138%2025.5236%2026.1203%2025.9719%2026.5676C26.4202%2027.015%2027.028%2027.2666%2027.662%2027.2673H31.4048C32.0387%2027.2666%2032.6466%2027.015%2033.0948%2026.5676C33.5432%2026.1203%2033.7953%2025.5138%2033.796%2024.8811V21.146C33.7953%2020.5133%2033.5432%2019.9068%2033.0948%2019.4595C32.6466%2019.0121%2032.0387%2018.7605%2031.4048%2018.7598H27.662Z'%20fill='%23002B54'%20fill-opacity='0.11'/%3e%3cpath%20d='M27.662%2029.2744C27.028%2029.2751%2026.4202%2029.5268%2025.9719%2029.9741C25.5236%2030.4215%2025.2714%2031.028%2025.2708%2031.6606V35.3958C25.2714%2036.0284%2025.5236%2036.6349%2025.9719%2037.0823C26.4202%2037.5297%2027.028%2037.7813%2027.662%2037.782H31.4048C32.0387%2037.7813%2032.6466%2037.5297%2033.0948%2037.0823C33.5432%2036.6349%2033.7953%2036.0284%2033.796%2035.3958V31.6606C33.7953%2031.028%2033.5432%2030.4215%2033.0948%2029.9741C32.6466%2029.5268%2032.0387%2029.2751%2031.4048%2029.2744H27.662Z'%20fill='%23FFFBFE'/%3e%3cpath%20d='M27.662%2029.2744C27.028%2029.2751%2026.4202%2029.5268%2025.9719%2029.9741C25.5236%2030.4215%2025.2714%2031.028%2025.2708%2031.6606V35.3958C25.2714%2036.0284%2025.5236%2036.6349%2025.9719%2037.0823C26.4202%2037.5297%2027.028%2037.7813%2027.662%2037.782H31.4048C32.0387%2037.7813%2032.6466%2037.5297%2033.0948%2037.0823C33.5432%2036.6349%2033.7953%2036.0284%2033.796%2035.3958V31.6606C33.7953%2031.028%2033.5432%2030.4215%2033.0948%2029.9741C32.6466%2029.5268%2032.0387%2029.2751%2031.4048%2029.2744H27.662Z'%20fill='%23002B54'%20fill-opacity='0.11'/%3e%3cpath%20d='M27.662%2039.7891C27.028%2039.7898%2026.4202%2040.0414%2025.9719%2040.4888C25.5236%2040.9361%2025.2714%2041.5426%2025.2708%2042.1753V45.9104C25.2714%2046.5431%2025.5236%2047.1496%2025.9719%2047.5969C26.4202%2048.0443%2027.028%2048.2959%2027.662%2048.2966H31.4048C32.0387%2048.2959%2032.6466%2048.0443%2033.0948%2047.5969C33.5432%2047.1496%2033.7953%2046.5431%2033.796%2045.9104V42.1753C33.7953%2041.5426%2033.5432%2040.9361%2033.0948%2040.4888C32.6466%2040.0414%2032.0387%2039.7898%2031.4048%2039.7891H27.662Z'%20fill='%23FFFBFE'/%3e%3cpath%20d='M27.662%2039.7891C27.028%2039.7898%2026.4202%2040.0414%2025.9719%2040.4888C25.5236%2040.9361%2025.2714%2041.5426%2025.2708%2042.1753V45.9104C25.2714%2046.5431%2025.5236%2047.1496%2025.9719%2047.5969C26.4202%2048.0443%2027.028%2048.2959%2027.662%2048.2966H31.4048C32.0387%2048.2959%2032.6466%2048.0443%2033.0948%2047.5969C33.5432%2047.1496%2033.7953%2046.5431%2033.796%2045.9104V42.1753C33.7953%2041.5426%2033.5432%2040.9361%2033.0948%2040.4888C32.6466%2040.0414%2032.0387%2039.7898%2031.4048%2039.7891H27.662Z'%20fill='%23002B54'%20fill-opacity='0.11'/%3e%3cpath%20d='M30.1448%209.64697C29.3459%209.64789%2028.58%209.96494%2028.0152%2010.5286C27.4504%2011.0923%2027.1326%2011.8566%2027.1317%2012.6538V17.36C27.1326%2018.1571%2027.4504%2018.9213%2028.0152%2019.4851C28.58%2020.0487%2029.3459%2020.3658%2030.1448%2020.3667H34.8607C35.6595%2020.3658%2036.4254%2020.0487%2036.9902%2019.4851C37.5551%2018.9213%2037.8728%2018.1571%2037.8737%2017.36V12.6538C37.8728%2011.8566%2037.5551%2011.0923%2036.9902%2010.5286C36.4254%209.96494%2035.6595%209.64789%2034.8607%209.64697H30.1448Z'%20fill='%2394A9C3'/%3e%3cpath%20d='M45.671%2022.7988C44.8722%2022.7997%2044.1063%2023.1167%2043.5414%2023.6805C42.9766%2024.2441%2042.6589%2025.0084%2042.658%2025.8056V30.5118C42.6589%2031.3089%2042.9766%2032.0732%2043.5414%2032.6369C44.1063%2033.2006%2044.8722%2033.5176%2045.671%2033.5185H50.3871C51.1859%2033.5176%2051.9518%2033.2006%2052.5166%2032.6369C53.0815%2032.0732%2053.3992%2031.3089%2053.4001%2030.5118V25.8056C53.3992%2025.0084%2053.0815%2024.2441%2052.5166%2023.6805C51.9518%2023.1167%2051.1859%2022.7997%2050.3871%2022.7988H45.671Z'%20fill='%2394A9C3'/%3e%3cpath%20d='M38.9209%2070.1695L37.9627%2070.1615L37.5382%2066.3877L38.9522%2066.3997L38.9209%2070.1695Z'%20fill='%23A0616A'/%3e%3cpath%20d='M35.8523%2071.6894C35.8514%2071.803%2035.8957%2071.9119%2035.9753%2071.9928C36.0549%2072.0737%2036.1634%2072.1196%2036.277%2072.1207L38.1819%2072.1368L38.5154%2071.4623L38.6379%2072.1402L39.3566%2072.1465L39.1751%2069.7285L38.925%2069.7119L37.9051%2069.6419L37.5761%2069.6201L37.5703%2070.3043L36.0401%2071.3396C35.9828%2071.3786%2035.9357%2071.4307%2035.903%2071.4921C35.8703%2071.5529%2035.853%2071.6212%2035.8525%2071.6906L35.8523%2071.6894Z'%20fill='%232F2E41'/%3e%3cpath%20d='M43.7956%2070.1695L42.8374%2070.1615L42.4132%2066.3877L43.8272%2066.3997L43.7956%2070.1695Z'%20fill='%23A0616A'/%3e%3cpath%20d='M40.7273%2071.6894C40.7264%2071.803%2040.7707%2071.9119%2040.8503%2071.9928C40.9299%2072.0737%2041.0384%2072.1196%2041.152%2072.1207L43.0569%2072.1368L43.3904%2071.4623L43.5129%2072.1402L44.2316%2072.1465L44.0501%2069.7285L43.8%2069.7119L42.7801%2069.6419L42.4511%2069.6201L42.4453%2070.3043L40.9151%2071.3396C40.8578%2071.3786%2040.8107%2071.4307%2040.778%2071.4921C40.7453%2071.5529%2040.7279%2071.6212%2040.7275%2071.6906L40.7273%2071.6894Z'%20fill='%232F2E41'/%3e%3cpath%20d='M35.1613%2039.6587L39.0447%2039.7811L42.7239%2040.597C42.7239%2040.597%2042.356%2041.0457%2043.5824%2042.2696C43.5824%2042.2696%2045.2175%2045.1252%2044.073%2047.8992L43.5824%2058.9944C43.5824%2058.9944%2045.0127%2066.8168%2043.9196%2069.3059L42.4753%2069.3965L40.0308%2059.085L38.8396%2047.9803L38.2687%2058.9136C38.2687%2058.9136%2040.4582%2066.4182%2039.0756%2069.3971L37.5113%2069.3071L34.8348%2058.9136C34.8348%2058.9136%2033.6901%2046.9203%2033.8536%2044.6358C34.0171%2042.3513%2035.1613%2039.6587%2035.1613%2039.6587Z'%20fill='%23605D62'/%3e%3cpath%20d='M48.203%2022.1253C48.0181%2022.1728%2047.8509%2022.2727%2047.7214%2022.4128C47.5919%2022.5529%2047.5057%2022.7273%2047.4732%2022.9151C47.4407%2023.1029%2047.4632%2023.2961%2047.538%2023.4715C47.6128%2023.6468%2047.7368%2023.7969%2047.895%2023.9037V23.905L47.8197%2025.7255L49.2157%2026.3704L49.3271%2023.5691H49.3174C49.413%2023.3999%2049.4564%2023.2063%2049.4425%2023.0125C49.4286%2022.8187%2049.3578%2022.6332%2049.239%2022.4793C49.1202%2022.3253%2048.9587%2022.2097%2048.7745%2022.1467C48.5903%2022.0837%2048.3915%2022.0763%2048.203%2022.1253Z'%20fill='%23A0616A'/%3e%3cpath%20d='M40.401%2028.6219C40.1133%2028.3349%2039.9454%2027.9498%2039.931%2027.5441C39.9168%2027.1384%2040.0571%2026.7424%2040.3239%2026.436C40.5907%2026.1295%2040.964%2025.9354%2041.3685%2025.8929C41.7731%2025.8502%2042.1787%2025.9624%2042.5037%2026.2065L46.8868%2029.5001L47.668%2024.7554L49.3449%2025.2941L48.9448%2031.4725C48.9311%2031.6837%2048.8638%2031.888%2048.7493%2032.0661C48.6348%2032.2443%2048.4767%2032.3905%2048.29%2032.4909C48.1033%2032.5913%2047.8942%2032.6428%2047.6821%2032.6404C47.47%2032.638%2047.262%2032.5818%2047.0776%2032.4771L40.7429%2028.8806C40.618%2028.8098%2040.5031%2028.7228%2040.401%2028.6219Z'%20fill='%23939094'/%3e%3cpath%20d='M33.717%2019.4711C33.8148%2019.6349%2033.8631%2019.8232%2033.8562%2020.0137C33.8493%2020.2041%2033.7874%2020.3885%2033.6781%2020.5448C33.5686%2020.7009%2033.4164%2020.8224%2033.2396%2020.8943C33.0628%2020.9663%2032.8689%2020.9858%2032.6812%2020.9505L32.6802%2020.9515L31.4495%2022.2973L30.0033%2021.7744L31.8998%2019.7068L31.9066%2019.7138C31.9582%2019.5265%2032.0639%2019.3585%2032.2105%2019.2307C32.3572%2019.1029%2032.5382%2019.021%2032.7311%2018.9951C32.9241%2018.9693%2033.1204%2019.0006%2033.2956%2019.0853C33.4708%2019.17%2033.6172%2019.3042%2033.7164%2019.4713L33.717%2019.4711Z'%20fill='%23A0616A'/%3e%3cpath%20d='M34.2486%2029.5094L27.2124%2027.6127C27.0077%2027.5575%2026.8204%2027.4512%2026.6681%2027.3039C26.5158%2027.1566%2026.4035%2026.9731%2026.3418%2026.7706C26.2801%2026.5682%2026.271%2026.3533%2026.3154%2026.1463C26.3597%2025.9394%2026.456%2025.747%2026.5953%2025.5874L30.6701%2020.9189L32.241%2021.7145L29.4482%2025.6328L34.8849%2026.3738C35.2877%2026.4291%2035.6544%2026.6347%2035.9113%2026.949C36.1682%2027.2634%2036.2962%2027.6632%2036.2695%2028.068C36.2428%2028.4728%2036.0634%2028.8525%2035.7673%2029.1305C35.4713%2029.4086%2035.0807%2029.5643%2034.6742%2029.5664C34.5306%2029.5665%2034.3876%2029.5477%2034.249%2029.5104L34.2486%2029.5094Z'%20fill='%23939094'/%3e%3cpath%20d='M44.2799%2041.2911L34.4405%2041.7416C34.1702%2041.3321%2034.2438%2040.7163%2034.6219%2039.9451C36.0508%2037.0337%2034.9656%2031.5258%2034.2355%2028.6578C34.1862%2028.469%2034.1784%2028.2719%2034.2125%2028.0799C34.2467%2027.8879%2034.3221%2027.7054%2034.4335%2027.5452C34.5449%2027.3849%2034.6897%2027.2506%2034.858%2027.1515C35.0263%2027.0522%2035.214%2026.9905%2035.4085%2026.9705L36.3356%2026.878L37.1926%2024.2656H40.1961L41.442%2025.6862L43.5566%2026.9682C43.1717%2030.9246%2041.5317%2036.5113%2043.8681%2039.313C44.379%2039.9258%2044.524%2040.5888%2044.2787%2041.2913L44.2799%2041.2911Z'%20fill='%23939094'/%3e%3cpath%20d='M38.3135%2024.3261C39.9291%2024.3261%2041.2389%2023.019%2041.2389%2021.4067C41.2389%2019.7944%2039.9291%2018.4873%2038.3135%2018.4873C36.6978%2018.4873%2035.3879%2019.7944%2035.3879%2021.4067C35.3879%2023.019%2036.6978%2024.3261%2038.3135%2024.3261Z'%20fill='%23A0616A'/%3e%3cpath%20d='M41.6237%2019.538C42.0311%2018.0572%2037.5946%2016.7873%2036.7326%2017.9799C36.6128%2017.8104%2036.1697%2017.7074%2035.9666%2017.7594C35.7675%2017.8255%2035.5837%2017.9303%2035.4255%2018.0678C35.1835%2018.228%2034.9767%2018.4358%2034.8178%2018.6784C34.6761%2018.9307%2034.6542%2019.2733%2034.8449%2019.4915C34.9961%2019.6652%2035.2616%2020.5883%2035.4889%2020.6341C35.6474%2020.6663%2035.7807%2020.6922%2035.8955%2020.7111C35.9976%2020.5623%2036.2581%2020.3754%2036.2394%2020.1956C36.394%2020.2975%2036.3377%2020.4768%2036.3063%2020.6602C36.2027%2021.2706%2033.8694%2025.9953%2035.2058%2024.603C35.3601%2024.6907%2035.5224%2024.7634%2035.6905%2024.8205C36.0231%2024.3132%2036.2778%2023.7593%2036.4462%2023.177L36.4475%2023.1879C36.4796%2023.4405%2036.5857%2023.6782%2036.7525%2023.871C36.9192%2024.0639%2037.1393%2024.2034%2037.3851%2024.2722C39.391%2024.8521%2041.0138%2024.0012%2041.5715%2022.4665C41.3673%2022.0524%2041.2782%2022.0975%2041.2965%2022.0851C41.3564%2022.0451%2041.4247%2022.0192%2041.4961%2022.0091C41.5675%2021.999%2041.6403%2022.0052%2041.709%2022.027C41.7777%2022.0489%2041.8406%2022.0859%2041.893%2022.1353C41.9454%2022.1847%2041.986%2022.2453%2042.0118%2022.3125C42.0441%2022.3966%2042.0735%2022.4692%2042.0989%2022.5236C42.3897%2021.4862%2042.7359%2021.6351%2041.6237%2019.538Z'%20fill='%232F2E41'/%3e%3cpath%20d='M40.24%2018.4634L40.035%2017.4179C40.0085%2017.3317%2040.0107%2017.2393%2040.0412%2017.1544C40.0715%2017.1052%2040.1161%2017.0664%2040.169%2017.0433C40.222%2017.0201%2040.2808%2017.0137%2040.3375%2017.0248C40.4516%2017.0413%2040.537%2017.1453%2040.6505%2017.165C41.0453%2017.2352%2041.5671%2016.8456%2041.7085%2017.8299C41.7675%2018.2402%2042.4237%2018.2837%2042.6429%2018.6358C42.862%2018.988%2042.8889%2019.4965%2042.5898%2019.7842C42.4623%2019.8909%2042.3077%2019.9604%2042.1431%2019.9849C41.9785%2020.0094%2041.8103%2019.988%2041.6571%2019.9231C41.3523%2019.7883%2041.0856%2019.5807%2040.8804%2019.3186C40.6764%2019.0574%2040.4541%2018.811%2040.215%2018.5813'%20fill='%232F2E41'/%3e%3cpath%20d='M41.7802%2020.0534C40.9794%2019.9412%2040.434%2019.6513%2040.1584%2019.1899C40.0514%2018.993%2039.9866%2018.7761%2039.9679%2018.5529C39.9492%2018.3296%2039.9771%2018.105%2040.0498%2017.8931L40.2184%2017.9559C40.2161%2017.9621%2039.9969%2018.5706%2040.3139%2019.0993C40.5604%2019.5105%2041.062%2019.7715%2041.8046%2019.875L41.7802%2020.0534Z'%20fill='%2394A9C3'/%3e%3cpath%20d='M45.5364%208.75778C44.6923%208.75778%2043.867%208.50795%2043.1652%208.03995C42.4633%207.57195%2041.9162%206.90677%2041.5932%206.12849C41.2702%205.35019%2041.1856%204.4938%2041.3503%203.66758C41.515%202.84137%2041.9215%202.08244%2042.5184%201.48677C43.1153%200.891101%2043.8758%200.485445%2044.7038%200.3211C45.5317%200.156756%2046.3899%200.241103%2047.1698%200.563477C47.9497%200.885848%2048.6162%201.43177%2049.0852%202.1322C49.5542%202.83264%2049.8045%203.65612%2049.8045%204.49852C49.8032%205.62774%2049.3531%206.71034%2048.553%207.50881C47.7528%208.30727%2046.668%208.75646%2045.5364%208.75778ZM45.5364%201.94291C45.0299%201.94291%2044.5348%202.09279%2044.1137%202.37361C43.6925%202.65442%2043.3643%203.05355%2043.1704%203.52053C42.9766%203.98751%2042.9259%204.50135%2043.0247%204.9971C43.1235%205.49284%2043.3674%205.94817%2043.7256%206.3056C44.0837%206.66302%2044.54%206.90643%2045.0368%207.00502C45.5336%207.10366%2046.0485%207.05302%2046.5165%206.85957C46.9844%206.66618%2047.3843%206.33863%2047.6658%205.91835C47.9471%205.49807%2048.0973%205.00397%2048.0973%204.49852C48.0966%203.82096%2047.8265%203.17136%2047.3464%202.69225C46.8663%202.21314%2046.2154%201.94365%2045.5364%201.94291Z'%20fill='%2394A9C3'/%3e%3cpath%20d='M52.1034%2011.6524C51.8865%2011.6527%2051.6777%2011.5702%2051.5198%2011.4219L47.514%207.67546C47.4304%207.59941%2047.3629%207.50759%2047.3152%207.40533C47.2674%207.30301%2047.2406%207.19227%2047.2361%207.07951C47.2317%206.96681%2047.2497%206.85428%2047.2892%206.74858C47.3287%206.64282%2047.3889%206.54601%2047.4662%206.46365C47.5435%206.3813%2047.6364%206.31517%2047.7396%206.26894C47.8427%206.22277%2047.9541%206.19748%2048.0671%206.19461C48.1801%206.19174%2048.2926%206.2113%2048.398%206.25214C48.5034%206.29297%2048.5996%206.35434%2048.681%206.43263L52.687%2010.179C52.8119%2010.2959%2052.8986%2010.4474%2052.9362%2010.6141C52.9736%2010.7808%2052.96%2010.9548%2052.897%2011.1137C52.8341%2011.2725%2052.7248%2011.4088%2052.5833%2011.5049C52.4418%2011.6009%2052.2746%2011.6523%2052.1034%2011.6524Z'%20fill='%2394A9C3'/%3e%3cpath%20d='M70.2086%2070.0739C70.2734%2070.0767%2070.3382%2070.0601%2070.3938%2070.0251C70.4489%2069.9901%2070.4919%2069.9391%2070.5171%2069.8789C70.5424%2069.8186%2070.5487%2069.7521%2070.5343%2069.6884C70.5206%2069.6248%2070.4873%2069.5669%2070.4397%2069.5227L70.4179%2069.4361L70.4265%2069.4149C70.4919%2069.26%2070.6026%2069.1281%2070.7431%2069.0352C70.8842%2068.9423%2071.0494%2068.8935%2071.218%2068.8941C71.3866%2068.8947%2071.5512%2068.9451%2071.6917%2069.0386C71.8316%2069.1327%2071.9412%2069.2657%2072.0054%2069.4212C72.2641%2070.0417%2072.5927%2070.6634%2072.6736%2071.3201C72.7091%2071.6103%2072.6942%2071.9046%2072.6294%2072.189C73.2362%2070.8688%2073.5511%2069.4332%2073.5528%2067.9805C73.5534%2067.6157%2073.5327%2067.2515%2073.492%2066.8896C73.4587%2066.5925%2073.4117%2066.2977%2073.3526%2066.0047C73.0275%2064.416%2072.3289%2062.9271%2071.3155%2061.6602C70.8245%2061.3929%2070.4276%2060.9817%2070.1782%2060.4827C70.0881%2060.3032%2070.0239%2060.1116%2069.9889%2059.9138C70.044%2059.9212%2070.1977%2059.0799%2070.1558%2059.0282C70.2326%2058.9112%2070.3709%2058.8533%2070.4552%2058.7392C70.8738%2058.1725%2071.4514%2058.2718%2071.7525%2059.042C72.396%2059.3661%2072.4023%2059.9035%2072.0077%2060.4208C71.7559%2060.75%2071.7215%2061.195%2071.5019%2061.5472C71.5242%2061.5764%2071.5477%2061.6045%2071.5707%2061.6332C71.9853%2062.1655%2072.3467%2062.7373%2072.6501%2063.3395C72.5761%2062.6644%2072.6638%2061.9819%2072.9064%2061.3476C73.1519%2060.7563%2073.6125%2060.2579%2074.0174%2059.7469C74.1246%2059.6098%2074.2703%2059.5071%2074.436%2059.4527C74.6018%2059.3976%2074.7796%2059.393%2074.9476%2059.4395C75.1162%2059.4859%2075.2665%2059.5806%2075.3806%2059.7125C75.4948%2059.8438%2075.567%2060.0067%2075.5888%2060.1793C75.5894%2060.1868%2075.5906%2060.1942%2075.5911%2060.2017C75.5309%2060.2355%2075.4718%2060.2717%2075.4145%2060.3095C75.3422%2060.3583%2075.286%2060.4271%2075.2533%2060.508C75.2212%2060.5882%2075.2137%2060.6771%2075.2327%2060.762C75.2516%2060.8463%2075.2958%2060.9238%2075.3589%2060.9834C75.4225%2061.0425%2075.5028%2061.0815%2075.5888%2061.0947L75.5974%2061.0964C75.5762%2061.3126%2075.5384%2061.5271%2075.4839%2061.7382C76.0041%2063.745%2074.8817%2064.4762%2073.2787%2064.5089C73.2431%2064.5272%2073.2081%2064.545%2073.1731%2064.5622C73.4777%2065.4231%2073.6687%2066.3201%2073.7415%2067.2303C73.7822%2067.7665%2073.7799%2068.3057%2073.734%2068.8425L73.7369%2068.823C73.8528%2068.2265%2074.1716%2067.6885%2074.6396%2067.2991C75.3342%2066.7296%2076.3161%2066.5197%2077.0657%2066.062C77.1454%2066.011%2077.2377%2065.984%2077.3324%2065.9834C77.427%2065.9834%2077.5199%2066.0104%2077.5996%2066.0609C77.6794%2066.1113%2077.7436%2066.1842%2077.7832%2066.2696C77.8233%2066.3551%2077.8382%2066.4503%2077.8256%2066.5438L77.8227%2066.5639C77.7109%2066.6097%2077.6019%2066.6619%2077.497%2066.7204C77.4367%2066.7548%2077.3777%2066.7904%2077.3197%2066.8288C77.2475%2066.877%2077.1913%2066.9458%2077.1592%2067.0267C77.1265%2067.1076%2077.1196%2067.1959%2077.1379%2067.2808C77.1569%2067.3656%2077.201%2067.4425%2077.2647%2067.5021C77.3284%2067.5618%2077.4081%2067.6002%2077.4941%2067.614L77.5033%2067.6151L77.5211%2067.618C77.3301%2068.0728%2077.0622%2068.4915%2076.729%2068.8557C76.4038%2070.6078%2075.0073%2070.7741%2073.5132%2070.2637H73.5127C73.3486%2070.9743%2073.1112%2071.6665%2072.8038%2072.3284H70.2716C70.2625%2072.3003%2070.2539%2072.271%2070.2458%2072.2429C70.4804%2072.2579%2070.7156%2072.2435%2070.9467%2072.2011C70.7586%2071.9711%2070.571%2071.7394%2070.3829%2071.5094C70.3789%2071.5048%2070.3749%2071.5002%2070.3709%2071.4951C70.2757%2071.3775%2070.1799%2071.2605%2070.0847%2071.1429C70.0795%2070.7822%2070.1208%2070.422%2070.208%2070.0721L70.2086%2070.0739Z'%20fill='%23FFFBFE'/%3e%3cpath%20d='M70.2086%2070.0739C70.2734%2070.0767%2070.3382%2070.0601%2070.3938%2070.0251C70.4489%2069.9901%2070.4919%2069.9391%2070.5171%2069.8789C70.5424%2069.8186%2070.5487%2069.7521%2070.5343%2069.6884C70.5206%2069.6248%2070.4873%2069.5669%2070.4397%2069.5227L70.4179%2069.4361L70.4265%2069.4149C70.4919%2069.26%2070.6026%2069.1281%2070.7431%2069.0352C70.8842%2068.9423%2071.0494%2068.8935%2071.218%2068.8941C71.3866%2068.8947%2071.5512%2068.9451%2071.6917%2069.0386C71.8316%2069.1327%2071.9412%2069.2657%2072.0054%2069.4212C72.2641%2070.0417%2072.5927%2070.6634%2072.6736%2071.3201C72.7091%2071.6103%2072.6942%2071.9046%2072.6294%2072.189C73.2362%2070.8688%2073.5511%2069.4332%2073.5528%2067.9805C73.5534%2067.6157%2073.5327%2067.2515%2073.492%2066.8896C73.4587%2066.5925%2073.4117%2066.2977%2073.3526%2066.0047C73.0275%2064.416%2072.3289%2062.9271%2071.3155%2061.6602C70.8245%2061.3929%2070.4276%2060.9817%2070.1782%2060.4827C70.0881%2060.3032%2070.0239%2060.1116%2069.9889%2059.9138C70.044%2059.9212%2070.1977%2059.0799%2070.1558%2059.0282C70.2326%2058.9112%2070.3709%2058.8533%2070.4552%2058.7392C70.8738%2058.1725%2071.4514%2058.2718%2071.7525%2059.042C72.396%2059.3661%2072.4023%2059.9035%2072.0077%2060.4208C71.7559%2060.75%2071.7215%2061.195%2071.5019%2061.5472C71.5242%2061.5764%2071.5477%2061.6045%2071.5707%2061.6332C71.9853%2062.1655%2072.3467%2062.7373%2072.6501%2063.3395C72.5761%2062.6644%2072.6638%2061.9819%2072.9064%2061.3476C73.1519%2060.7563%2073.6125%2060.2579%2074.0174%2059.7469C74.1246%2059.6098%2074.2703%2059.5071%2074.436%2059.4527C74.6018%2059.3976%2074.7796%2059.393%2074.9476%2059.4395C75.1162%2059.4859%2075.2665%2059.5806%2075.3806%2059.7125C75.4948%2059.8438%2075.567%2060.0067%2075.5888%2060.1793C75.5894%2060.1868%2075.5906%2060.1942%2075.5911%2060.2017C75.5309%2060.2355%2075.4718%2060.2717%2075.4145%2060.3095C75.3422%2060.3583%2075.286%2060.4271%2075.2533%2060.508C75.2212%2060.5882%2075.2137%2060.6771%2075.2327%2060.762C75.2516%2060.8463%2075.2958%2060.9238%2075.3589%2060.9834C75.4225%2061.0425%2075.5028%2061.0815%2075.5888%2061.0947L75.5974%2061.0964C75.5762%2061.3126%2075.5384%2061.5271%2075.4839%2061.7382C76.0041%2063.745%2074.8817%2064.4762%2073.2787%2064.5089C73.2431%2064.5272%2073.2081%2064.545%2073.1731%2064.5622C73.4777%2065.4231%2073.6687%2066.3201%2073.7415%2067.2303C73.7822%2067.7665%2073.7799%2068.3057%2073.734%2068.8425L73.7369%2068.823C73.8528%2068.2265%2074.1716%2067.6885%2074.6396%2067.2991C75.3342%2066.7296%2076.3161%2066.5197%2077.0657%2066.062C77.1454%2066.011%2077.2377%2065.984%2077.3324%2065.9834C77.427%2065.9834%2077.5199%2066.0104%2077.5996%2066.0609C77.6794%2066.1113%2077.7436%2066.1842%2077.7832%2066.2696C77.8233%2066.3551%2077.8382%2066.4503%2077.8256%2066.5438L77.8227%2066.5639C77.7109%2066.6097%2077.6019%2066.6619%2077.497%2066.7204C77.4367%2066.7548%2077.3777%2066.7904%2077.3197%2066.8288C77.2475%2066.877%2077.1913%2066.9458%2077.1592%2067.0267C77.1265%2067.1076%2077.1196%2067.1959%2077.1379%2067.2808C77.1569%2067.3656%2077.201%2067.4425%2077.2647%2067.5021C77.3284%2067.5618%2077.4081%2067.6002%2077.4941%2067.614L77.5033%2067.6151L77.5211%2067.618C77.3301%2068.0728%2077.0622%2068.4915%2076.729%2068.8557C76.4038%2070.6078%2075.0073%2070.7741%2073.5132%2070.2637H73.5127C73.3486%2070.9743%2073.1112%2071.6665%2072.8038%2072.3284H70.2716C70.2625%2072.3003%2070.2539%2072.271%2070.2458%2072.2429C70.4804%2072.2579%2070.7156%2072.2435%2070.9467%2072.2011C70.7586%2071.9711%2070.571%2071.7394%2070.3829%2071.5094C70.3789%2071.5048%2070.3749%2071.5002%2070.3709%2071.4951C70.2757%2071.3775%2070.1799%2071.2605%2070.0847%2071.1429C70.0795%2070.7822%2070.1208%2070.422%2070.208%2070.0721L70.2086%2070.0739Z'%20fill='%23002B54'%20fill-opacity='0.11'/%3e%3cpath%20d='M0.168824%2072.3368C0.16875%2072.3586%200.173024%2072.3804%200.181399%2072.4005C0.189774%2072.4211%200.202085%2072.4395%200.217624%2072.455C0.233163%2072.4705%200.251622%2072.4825%200.271938%2072.4911C0.292255%2072.4991%200.314027%2072.5037%200.336003%2072.5037H77.6438C77.6885%2072.5037%2077.731%2072.4859%2077.7625%2072.455C77.7935%2072.4234%2077.8113%2072.381%2077.8113%2072.3368C77.8113%2072.2927%2077.7935%2072.2502%2077.7625%2072.2187C77.731%2072.1877%2077.6885%2072.1699%2077.6438%2072.1699H0.336003C0.314033%2072.1699%200.292269%2072.1739%200.271961%2072.1825C0.251653%2072.1906%200.233201%2072.2032%200.217666%2072.2187C0.202131%2072.2342%200.189819%2072.2525%200.181437%2072.2726C0.173055%2072.2932%200.168769%2072.315%200.168824%2072.3368Z'%20fill='%23FFFBFE'/%3e%3cpath%20d='M0.168824%2072.3368C0.16875%2072.3586%200.173024%2072.3804%200.181399%2072.4005C0.189774%2072.4211%200.202085%2072.4395%200.217624%2072.455C0.233163%2072.4705%200.251622%2072.4825%200.271938%2072.4911C0.292255%2072.4991%200.314027%2072.5037%200.336003%2072.5037H77.6438C77.6885%2072.5037%2077.731%2072.4859%2077.7625%2072.455C77.7935%2072.4234%2077.8113%2072.381%2077.8113%2072.3368C77.8113%2072.2927%2077.7935%2072.2502%2077.7625%2072.2187C77.731%2072.1877%2077.6885%2072.1699%2077.6438%2072.1699H0.336003C0.314033%2072.1699%200.292269%2072.1739%200.271961%2072.1825C0.251653%2072.1906%200.233201%2072.2032%200.217666%2072.2187C0.202131%2072.2342%200.189819%2072.2525%200.181437%2072.2726C0.173055%2072.2932%200.168769%2072.315%200.168824%2072.3368Z'%20fill='%23002B54'%20fill-opacity='0.14'/%3e%3c/g%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1650_18686'%3e%3crect%20width='78'%20height='72.8382'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", EmptyState$1 = Packages.emotion.styled(Packages.Mui.Box)(() => {
  const T = Packages.Mui.useTheme();
  return {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    textAlign: "center",
    maxWidth: 528,
    margin: "20px auto",
    gap: 20,
    color: T.validateMode({
      light: T.colors.neutral[40],
      dark: T.colors.neutral[100]
    }),
    wordWrap: "break-word",
    img: {
      width: 135,
      margin: "20px auto"
    },
    h2: {
      fontSize: 22,
      fontWeight: T.typography.fontWeightSemiBold,
      lineHeight: "28px"
    },
    span: {
      fontFamily: T.typography.fontFamily,
      fontSize: 20,
      fontWeight: T.typography.fontWeightRegular,
      lineHeight: "24px",
      margin: 0
    }
  };
}), EmptyState = ({
  mainText: T,
  secondaryText: S
}) => {
  const {
    FormattedMessage: R
  } = LocalizationProvider(), {
    Box: k,
    Typography: D
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(EmptyState$1, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(k, { component: "picture", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(k, { component: "source", media: "(max-width: 600px)", srcSet: SearchEmptyMobile }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(k, { component: "img", src: SearchEmpty })
    ] }),
    T && /* @__PURE__ */ jsxRuntimeExports.jsx(D, { variant: "h2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(R, { id: T }) }),
    S && /* @__PURE__ */ jsxRuntimeExports.jsx(D, { variant: "p", children: /* @__PURE__ */ jsxRuntimeExports.jsx(R, { id: S }) })
  ] });
};
EmptyState.propTypes = {
  mainText: Packages.PropTypes.string,
  secondaryText: Packages.PropTypes.string
};
const Box$2 = Packages.emotion.styled(Packages.Mui.Box)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
  padding: "0px 25px",
  height: "100%",
  boxSizing: "border-box"
})), Stack$4 = Packages.emotion.styled(Packages.Mui.Stack)(({
  paginationisenabled: T
}) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: T ? 5 : 21,
  padding: "0 15px"
})), TablePagination = Packages.emotion.styled(Packages.MuiBase.TablePagination)(() => {
  const T = Packages.Mui.useTheme();
  return {
    [`& .${Packages.MuiBase.tablePaginationClasses.spacer}`]: {
      display: "none"
    },
    [`& .${Packages.MuiBase.tablePaginationClasses.toolbar}`]: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: 8,
      padding: "4px 0"
    },
    [`& .${Packages.MuiBase.tablePaginationClasses.actions}`]: {
      display: "flex",
      gap: 6,
      border: "transparent",
      textAlign: "center"
    },
    [`& .${Packages.MuiBase.tablePaginationClasses.displayedRows}`]: {
      margin: 0,
      fontFamily: T.typography.fontFamily,
      fontSize: "0.875rem",
      lineHeight: 1.43,
      fontWeight: T.typography.fontWeightMedium
    },
    [`& .${Packages.MuiBase.tablePaginationClasses.actions} > button`]: {
      display: "flex",
      alignItems: "center",
      padding: 0,
      border: "transparent",
      borderRadius: "50%",
      backgroundColor: "transparent",
      color: T.validateMode({
        light: T.colors.neutral[40],
        dark: T.colors.neutral[95]
      }),
      transition: "all 120ms ease",
      cursor: "pointer",
      "> svg": {
        fontSize: 22
      },
      "&:focus, &:hover": {
        backgroundColor: T.validateMode({
          light: T.colors.rgb.light[10],
          dark: T.colors.rgb.other[10]
        })
      },
      "&:disabled": {
        opacity: 0.3,
        cursor: "default",
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  };
}), useConfig = () => {
  const T = ["__check__", "__detail_panel_toggle__"];
  return {
    HIDDEN_COLUMNS: T,
    getTogglableColumns: (R) => R.filter((k) => !T.includes(k.field)).map((k) => k.field)
  };
}, GridApiContext = () => {
  const {
    useGridApiContext: T
  } = Packages["@mui/x-data-grid-pro"], S = T();
  return {
    getRowModels: () => ({
      // eslint-disable-next-line no-unused-vars
      records: Array.from(S.current.getRowModels(), ([L, V]) => V),
      size: S.current.getRowModels().size
    }),
    getSelectedRows: () => ({
      // eslint-disable-next-line no-unused-vars
      records: Array.from(S.current.getSelectedRows(), ([L, V]) => V),
      size: S.current.getSelectedRows().size
    }),
    getDisplayedRowsCount: () => {
      const L = S.current.state.filter?.filteredRowsLookup;
      return L ? Object.values(L).reduce((V, z) => V + (z ? 1 : 0), 0) : 0;
    }
  };
}, CallToActionDrawer = ({
  ActionPanel: T
}) => {
  const {
    Drawer: S
  } = Packages.Mui, {
    getSelectedRows: R
  } = GridApiContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    S,
    {
      anchor: "bottom",
      open: R().size > 0,
      disableEnforceFocus: !0,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(T, { records: R().records })
    }
  );
};
CallToActionDrawer.propTypes = {
  ActionPanel: Packages.PropTypes.elementType
};
const TableFooter = ({
  actionPanel: T,
  withRefreshDataButton: S,
  onRefreshDataCallback: R,
  paginationEnabled: k = !1,
  paginationObject: D
}) => {
  const {
    GridFooterContainer: L,
    GridToolbarColumnsButton: V
  } = Packages["@mui/x-data-grid-pro"], {
    IconButton: z,
    Typography: W,
    TableFooter: U,
    TableRow: q,
    Table: K
  } = Packages.Mui, {
    getRowModels: Y,
    getSelectedRows: J,
    getDisplayedRowsCount: Z
  } = GridApiContext(), {
    FormattedMessage: X
  } = LocalizationProvider(), ee = Y(), te = J(), re = Z();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(L, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack$4, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(V, {}),
        te.size > 0 && /* @__PURE__ */ jsxRuntimeExports.jsxs(W, { variant: "body2", children: [
          te.size,
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(X, { id: "component.cai_material.data_dense_grid.records_selected", values: {
            value: te.size
          } })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack$4, { paginationisenabled: `${k}`, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(W, { variant: "body2", children: k ? /* @__PURE__ */ jsxRuntimeExports.jsx(X, { id: "component.cai_material.data_dense_grid.displaying" }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(X, { id: "component.cai_material.data_dense_grid.displaying" }),
          " ",
          ee.size === re ? ee.size : /* @__PURE__ */ jsxRuntimeExports.jsx(X, { id: "component.cai_material.data_dense_grid.displaying_of", values: {
            displayedRowsCount: re,
            rowModels: ee.size
          } }),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(X, { id: "component.cai_material.data_dense_grid.record", values: {
            value: ee.size
          } })
        ] }) }),
        S && !k && /* @__PURE__ */ jsxRuntimeExports.jsx(z, { onClick: R, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "refresh-outlined" }) }),
        k && /* @__PURE__ */ jsxRuntimeExports.jsx(K, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(U, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(q, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TablePagination,
          {
            count: D.state.rowCount,
            rowsPerPageOptions: [],
            rowsPerPage: 10,
            page: D.state.paginationModel.page,
            onPageChange: (Q) => {
              D.onPaginationModelChange({
                page: Q.target.getAttribute("data-testid") === "ChevronLeftRoundedIcon" ? D.state.paginationModel.page - 1 : D.state.paginationModel.page + 1,
                pageSize: 10
              });
            },
            slotProps: {
              actions: {
                showFirstButton: !1,
                showLastButton: !1,
                slots: {
                  firstPageIcon: IconsMaterial.FirstPageRounded,
                  lastPageIcon: IconsMaterial.LastPageRounded,
                  nextPageIcon: IconsMaterial.ChevronRightRounded,
                  backPageIcon: IconsMaterial.ChevronLeftRounded
                }
              }
            }
          }
        ) }) }) })
      ] })
    ] }),
    T && /* @__PURE__ */ jsxRuntimeExports.jsx(CallToActionDrawer, { ActionPanel: T })
  ] });
};
TableFooter.propTypes = {
  actionPanel: Packages.PropTypes.elementType,
  withRefreshDataButton: Packages.PropTypes.bool,
  onRefreshDataCallback: Packages.PropTypes.func,
  paginationEnabled: Packages.PropTypes.bool,
  paginationObject: Packages.PropTypes.object
};
const TABLE_CONFIG = {
  /**
   * The height of each row in pixels.
   */
  rowHeight: 54
}, TableLoader = () => {
  const {
    useGridApiContext: T
  } = Packages["@mui/x-data-grid-pro"], {
    Skeleton: S
  } = Packages.Mui, D = T().current?.getRootDimensions()?.viewportInnerSize.height ?? 0, L = Math.ceil(D / TABLE_CONFIG.rowHeight) - 1, V = useMemo(() => {
    const z = [];
    for (let W = 0; W < L; W += 1)
      z.push(/* @__PURE__ */ jsxRuntimeExports.jsx(S, { animation: "wave", variant: "rounded" }, W));
    return z;
  }, [L]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$2, { children: V });
}, DataDenseGrid$1 = ({
  columns: T,
  rows: S,
  config: R,
  withExpandableRows: k,
  withRefreshDataButton: D,
  hiddenColumns: L,
  pagination: V = !1,
  onPaginationModelChange: z = () => {
  },
  ...W
}) => {
  const {
    DataGridPro: U,
    GRID_CHECKBOX_SELECTION_COL_DEF: q,
    GRID_DETAIL_PANEL_TOGGLE_COL_DEF: K
  } = Packages["@mui/x-data-grid-pro"], {
    getTogglableColumns: Y
  } = useConfig();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    U,
    {
      disableColumnReorder: !0,
      ...W,
      columns: [{
        ...q,
        width: 40,
        minWidth: 40
      }, {
        ...K,
        width: 40,
        minWidth: 40
      }, ...T],
      rows: S,
      rowHeight: TABLE_CONFIG.rowHeight,
      hiddenColumns: L,
      disableDensitySelector: !0,
      disableRowSelectionOnClick: !0,
      slots: {
        footer: (J) => /* @__PURE__ */ jsxRuntimeExports.jsx(TableFooter, { ...J, ...R?.actionPanel && {
          actionPanel: R.actionPanel
        }, ...R?.onRefreshDataCallback && {
          onRefreshDataCallback: R.onRefreshDataCallback
        }, ...D && {
          withRefreshDataButton: D
        }, ...V && {
          paginationEnabled: !0,
          paginationObject: {
            state: W.initialState.pagination,
            onPaginationModelChange: z
          }
        } }),
        /**
         * Component rendered when the grid is in a loading state.
         */
        loadingOverlay: TableLoader,
        /**
         * noResultsOverlay = No results overlay component rendered when the grid has no results after filtering.
         */
        noResultsOverlay: () => /* @__PURE__ */ jsxRuntimeExports.jsx(EmptyState, { mainText: "component.cai_material.data_dense_grid.no_results_found", secondaryText: "component.cai_material.data_dense_grid.no_match" }),
        /**
         * noRowsOverlay = No rows overlay component rendered when the grid has no data.
         */
        noRowsOverlay: () => /* @__PURE__ */ jsxRuntimeExports.jsx(EmptyState, { mainText: "component.cai_material.data_dense_grid.no_data", secondaryText: "component.cai_material.data_dense_grid.no_items_to_display" }),
        ...k && {
          /**
           * Icon displayed on the detail panel toggle column when collapsed.
           */
          detailPanelExpandIcon: IconsMaterial.KeyboardArrowDown,
          /**
           * Icon displayed on the detail panel toggle column when expanded.
           */
          detailPanelCollapseIcon: IconsMaterial.KeyboardArrowUp
        },
        ...W.slots && W.slots
      },
      slotProps: {
        /**
         * Customize the list of columns in panel
         *
         * Reference: https://mui.com/x/react-data-grid/column-visibility/#customize-the-list-of-columns-in-panel
         */
        columnsPanel: {
          getTogglableColumns: Y
        },
        ...W.slotProps && W.slotProps
      },
      ...k && {
        /**
         * Function that returns the element to render in row detail.
         */
        getDetailPanelContent: R?.detailPanelContent,
        /**
         * Function that returns the height of the row detail panel.
         */
        getDetailPanelHeight: () => "auto"
      }
    }
  );
};
DataDenseGrid$1.propTypes = {
  columns: Packages.PropTypes.array.isRequired,
  rows: Packages.PropTypes.array.isRequired,
  config: Packages.PropTypes.shape({
    actionPanel: Packages.PropTypes.elementType,
    detailPanelContent: Packages.PropTypes.elementType,
    onRefreshDataCallback: Packages.PropTypes.func
  }),
  slots: Packages.PropTypes.shape({
    noRowsOverlay: Packages.PropTypes.elementType
  }),
  slotProps: Packages.PropTypes.object,
  hiddenColumns: Packages.PropTypes.array,
  withExpandableRows: Packages.PropTypes.bool,
  withRefreshDataButton: Packages.PropTypes.bool,
  pagination: Packages.PropTypes.bool,
  onPaginationModelChange: Packages.PropTypes.func,
  initialState: Packages.PropTypes.shape({
    pagination: Packages.PropTypes.shape({
      paginationModel: Packages.PropTypes.shape({
        page: Packages.PropTypes.number,
        pageSize: Packages.PropTypes.number
      }),
      rowCount: Packages.PropTypes.number
    })
  })
};
const ThemedDenseGrid = withThemeOverrides(DataDenseGrid$1, DataDenseGridThemeConfig), ControlledVisibilityDenseGrid = withControlledColumnVisibility(ThemedDenseGrid), ControlledPinnedColumnsDenseGrid = withControlledPinnedColumns(ControlledVisibilityDenseGrid), UserPrefDenseGrid = withUserPreferencesProvider(ControlledPinnedColumnsDenseGrid), BaseDataDenseGrid$1 = UserPrefDenseGrid, BasicDataDenseGrid = (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(BaseDataDenseGrid$1, { ...T }), BaseDataDenseGrid = Packages.emotion.styled(BaseDataDenseGrid$1)(() => ({
  'div[class^="MuiDataGrid-main"] > div[class^="MuiDataGrid-columnHeaders"] > div[class^="MuiDataGrid-columnHeadersInner"] > div:nth-of-type(1) > div[class^="MuiDataGrid-columnHeader"]:nth-of-type(1)': {
    "&::after": {
      opacity: 0
    }
  }
})), MultiSelectableDataDenseGrid = ({
  rowSelectionModel: T,
  onRowSelectionModelChange: S,
  ...R
}) => {
  const [k, D] = useState$1([]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseDataDenseGrid,
    {
      ...R,
      onRowSelectionModelChange: S ?? ((L) => {
        D(L);
      }),
      rowSelectionModel: T ?? k,
      checkboxSelection: !0,
      withRefreshDataButton: !0
    }
  );
};
MultiSelectableDataDenseGrid.propTypes = {
  withExpandableRows: Packages.PropTypes.bool,
  rowSelectionModel: Packages.PropTypes.array,
  onRowSelectionModelChange: Packages.PropTypes.func,
  config: Packages.PropTypes.shape({
    detailPanelContent: Packages.PropTypes.elementType
  })
};
const PaginationControlledDataDenseGrid = (T) => {
  const [S, R] = useState$1({
    page: 0,
    pageSize: 10
  }), [k, D] = useState$1([]), [L, V] = useState$1(!1);
  return useEffect$1(() => {
    let z = !0;
    return (async () => {
      V(!0);
      const W = await T.onLoadServerRows(S.page);
      console.log("newRows --> ", W), z && (D(W), V(!1));
    })(), () => {
      z = !1;
    };
  }, [S.page, T]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseDataDenseGrid$1,
    {
      ...T,
      initialState: {
        ...T.initialState,
        pagination: {
          paginationModel: S,
          rowCount: T.totalRowCount
        }
      },
      rows: k,
      loading: L,
      paginationModel: S,
      pageSizeOptions: [10],
      onPaginationModelChange: R,
      pagination: !0,
      keepNonExistentRowsSelected: !0
    }
  );
};
PaginationControlledDataDenseGrid.propTypes = {
  onLoadServerRows: Packages.PropTypes.func.isRequired,
  totalRowCount: Packages.PropTypes.number.isRequired,
  initialState: Packages.PropTypes.shape({
    pagination: Packages.PropTypes.shape({
      paginationModel: Packages.PropTypes.shape({
        page: Packages.PropTypes.number,
        pageSize: Packages.PropTypes.number
      }),
      rowCount: Packages.PropTypes.number
    })
  }),
  rowSelectionModel: Packages.PropTypes.array,
  onRowSelectionModelChange: Packages.PropTypes.func,
  config: Packages.PropTypes.shape({
    detailPanelContent: Packages.PropTypes.elementType
  }),
  ...BaseDataDenseGrid$1.propTypes
};
const RowExpandableDataDenseGrid = ({
  rowSelectionModel: T,
  onRowSelectionModelChange: S,
  ...R
}) => {
  const [k, D] = useState$1([]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseDataDenseGrid$1,
    {
      ...R,
      onRowSelectionModelChange: S ?? ((L) => {
        D(L);
      }),
      rowSelectionModel: T ?? k,
      withExpandableRows: !0,
      withRefreshDataButton: !0
    }
  );
};
RowExpandableDataDenseGrid.propTypes = {
  rowSelectionModel: Packages.PropTypes.array,
  onRowSelectionModelChange: Packages.PropTypes.func,
  config: Packages.PropTypes.shape({
    detailPanelContent: Packages.PropTypes.elementType
  })
};
const DataDenseGrid = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    case "basic":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BasicDataDenseGrid, { ...S });
    case "multi-selectable":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(MultiSelectableDataDenseGrid, { ...S });
    case "row-expandable":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(RowExpandableDataDenseGrid, { ...S });
    case "pagination-controlled":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationControlledDataDenseGrid, { ...S });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseDataDenseGrid$1, { ...S });
  }
};
DataDenseGrid.propTypes = {
  variant: Packages.PropTypes.oneOf(["basic", "multi-selectable", "row-expandable", "pagination-controlled"]).isRequired
};
const dark$j = (T) => ({
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        color: T.colors.neutral[100],
        backgroundColor: T.colors.blue[30],
        fontWeight: T.typography.fontWeightRegular,
        height: "fit-content",
        width: "fit-content",
        fontSize: 16,
        padding: 20,
        borderRadius: 10
      },
      arrow: {
        color: T.colors.blue[30]
      }
    }
  },
  MuiInputAdornment: {
    styleOverrides: {
      root: {
        color: T.colors.neutral[100],
        cursor: "default"
      }
    }
  }
}), light$j = (T) => ({
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        color: T.colors.neutral[100],
        backgroundColor: T.colors.blue[30],
        fontWeight: T.typography.fontWeightRegular,
        height: "fit-content",
        width: "fit-content",
        fontSize: 16,
        padding: 20,
        borderRadius: 10
      },
      arrow: {
        color: T.colors.blue[30]
      }
    }
  },
  MuiInputAdornment: {
    styleOverrides: {
      root: {
        color: "inherit",
        cursor: "default"
      }
    }
  }
}), TooltipThemeConfig = {
  dark: dark$j,
  light: light$j
}, BaseTooltip = ({
  render: T,
  token: S,
  ...R
}) => {
  const {
    Tooltip: k
  } = Packages.Mui, {
    FormattedMessage: D
  } = LocalizationProvider();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(k, { ...R, ...S && {
    title: /* @__PURE__ */ jsxRuntimeExports.jsx(D, { id: S })
  }, arrow: !0, children: T?.() });
};
BaseTooltip.propTypes = {
  render: Packages.PropTypes.func.isRequired,
  token: Packages.PropTypes.string.isRequired
};
const Tooltip = withThemeOverrides(BaseTooltip, TooltipThemeConfig), Button$1 = (T) => {
  const {
    Button: S
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(S, { ...T, ...T.icon && {
    startIcon: T.icon
  }, children: T.children });
};
Button$1.propTypes = {
  children: Packages.PropTypes.node,
  icon: Packages.PropTypes.element
};
const BaseButton = withThemeOverrides(Button$1, ButtonThemeConfig), DangerButton = (T) => {
  const {
    FormattedMessage: S
  } = LocalizationProvider();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...T, variant: "danger", children: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { id: T.token, defaultMessage: T.defaultMessage, values: T.values }) });
};
DangerButton.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object
};
const ElevatedButton = (T) => {
  const {
    FormattedMessage: S
  } = LocalizationProvider();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...T, variant: "elevated", children: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { id: T.token, defaultMessage: T.defaultMessage, values: T.values }) });
};
ElevatedButton.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object,
  icon: Packages.PropTypes.element
};
const LoginButtonPrimary = (T) => {
  const {
    FormattedMessage: S
  } = LocalizationProvider();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...T, variant: "login-primary", fullWidth: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { id: T.token, defaultMessage: T.defaultMessage, values: T.values }) });
};
LoginButtonPrimary.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object
};
const LoginButtonSecondary = (T) => {
  const {
    FormattedMessage: S
  } = LocalizationProvider();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...T, variant: "login-secondary", fullWidth: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { id: T.token, defaultMessage: T.defaultMessage, values: T.values }) });
};
LoginButtonSecondary.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object
};
const PrimaryButton = (T) => {
  const {
    FormattedMessage: S
  } = LocalizationProvider();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...T, variant: "contained", color: "primary", children: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { id: T.token, defaultMessage: T.defaultMessage, values: T.values }) });
};
PrimaryButton.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object
};
const SecondaryButton = (T) => {
  const {
    FormattedMessage: S
  } = LocalizationProvider();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...T, variant: "outlined", color: "secondary", children: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { id: T.token, defaultMessage: T.defaultMessage, values: T.values }) });
};
SecondaryButton.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object
};
const SuccessButton = (T) => {
  const {
    FormattedMessage: S
  } = LocalizationProvider();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...T, variant: "success", children: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { id: T.token, defaultMessage: T.defaultMessage, values: T.values }) });
};
SuccessButton.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object
};
const TextButton = (T) => {
  const {
    FormattedMessage: S
  } = LocalizationProvider();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...T, variant: "text", children: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { id: T.token, defaultMessage: T.defaultMessage, values: T.values }) });
};
TextButton.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object,
  icon: Packages.PropTypes.element
};
const TonalButton = (T) => {
  const {
    FormattedMessage: S
  } = LocalizationProvider();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...T, variant: "tonal", children: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { id: T.token, defaultMessage: T.defaultMessage, values: T.values }) });
};
TonalButton.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object,
  icon: Packages.PropTypes.element
};
const TopLevelButton = (T) => {
  const {
    FormattedMessage: S
  } = LocalizationProvider();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseButton, { ...T, variant: "top-level", children: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { id: T.token, defaultMessage: T.defaultMessage, values: T.values }) });
};
TopLevelButton.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object,
  icon: Packages.PropTypes.element
};
const Button = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    case "primary":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PrimaryButton, { ...S });
    case "secondary":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SecondaryButton, { ...S });
    case "text":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(TextButton, { ...S });
    case "elevated":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ElevatedButton, { ...S });
    case "tonal":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(TonalButton, { ...S });
    case "success":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SuccessButton, { ...S });
    case "danger":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DangerButton, { ...S });
    case "top-level":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(TopLevelButton, { ...S });
    case "login-primary":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LoginButtonPrimary, { ...S });
    case "login-secondary":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LoginButtonSecondary, { ...S });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PrimaryButton, { ...S });
  }
};
Button.propTypes = {
  variant: Packages.PropTypes.oneOf(["primary", "secondary", "text", "elevated", "tonal", "success", "danger", "top-level", "login-primary", "login-secondary"])
};
const dark$i = (T) => ({
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        margin: 0,
        color: T.colors.neutral[95]
      }
    }
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        color: T.colors.neutral[95]
      }
    }
  }
}), light$i = (T) => ({
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        margin: 0,
        color: T.colors.neutral[40]
      }
    }
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        color: T.colors.neutral[40]
      }
    }
  }
}), CheckboxThemeConfig = {
  dark: dark$i,
  light: light$i
}, BaseCheckbox = ({
  helperText: T,
  tooltipToken: S,
  ...R
}) => {
  const {
    FormControl: k,
    FormGroup: D,
    FormControlLabel: L,
    Checkbox: V,
    FormHelperText: z,
    InputAdornment: W,
    Stack: U
  } = Packages.Mui, {
    useIntl: q
  } = LocalizationProvider(), K = q();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(k, { component: "fieldset", error: R.formhandler?.fieldState(R.name).invalid || R.error, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(D, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(U, { direction: "row", alignItems: "center", gap: 1, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(L, { required: R.required, label: K.formatMessage({
        id: R.token
      }), control: /* @__PURE__ */ jsxRuntimeExports.jsx(V, { checked: !!R.value, ...R }) }),
      S && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { token: S, render: () => /* @__PURE__ */ jsxRuntimeExports.jsx(W, { position: "end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "info-outlined" }) }), placement: "top", slotProps: {
        popper: {
          modifiers: [{
            name: "offset",
            options: {
              offset: [0, 10]
            }
          }]
        }
      } })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(z, { children: R.formhandler?.fieldState(R.name).error || T })
  ] }) });
};
BaseCheckbox.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  value: Packages.PropTypes.oneOfType([Packages.PropTypes.string, Packages.PropTypes.bool]),
  name: Packages.PropTypes.string,
  error: Packages.PropTypes.bool,
  required: Packages.PropTypes.bool,
  helperText: Packages.PropTypes.string,
  tooltipToken: Packages.PropTypes.string,
  formhandler: Packages.PropTypes.object
};
const Checkbox = withBaseField(withThemeOverrides(BaseCheckbox, CheckboxThemeConfig), "Checkbox"), dark$h = (T) => ({
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        fontSize: "22px",
        color: T.colors.neutral[100]
      }
    }
  },
  MuiPickersDay: {
    styleOverrides: {
      root: {
        "&&.Mui-selected": {
          backgroundColor: T.colors.blue[90]
        }
      }
    }
  },
  MuiPickersYear: {
    styleOverrides: {
      yearButton: {
        "&&.Mui-selected": {
          backgroundColor: T.colors.blue[90]
        }
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: "10px",
        width: "330px",
        height: "auto"
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        color: T.colors.blue[90]
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          height: "48px",
          "& svg": {
            ...R.disabled && {
              color: T.colors.neutral[30]
            }
          },
          ...R.variant === "outlined" && {
            lineHeight: 1
          }
        };
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      root: (S) => {
        const {
          error: R
        } = S.ownerState;
        return {
          top: "-4px !important",
          color: T.colors.neutral[100],
          ...S.ownerState["data-shrink"] && {
            fontWeight: T.typography.fontWeightSemiBold,
            color: `${T.colors.blue[90]} !important`,
            ...R && {
              color: `${T.colors.red[80]} !important`
            }
          }
        };
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          /**
           * This approach was inferred from StackOverflow
           *
           * Reference: https://stackoverflow.com/questions/52911169/how-to-change-the-border-color-of-material-ui-textfield
           */
          "&:hover fieldset": {
            borderColor: `${T.colors.blue[90]} !important`,
            ...R.disabled && {
              borderColor: "rgba(255, 255, 255, 0.3) !important",
              borderWidth: "1px"
            },
            ...R.error && {
              borderColor: `${T.colors.red[80]} !important`
            }
          },
          "&.Mui-focused fieldset": {
            borderColor: `${T.colors.blue[90]} !important`,
            ...R.error && {
              borderColor: `${T.colors.red[80]} !important`,
              borderWidth: "2px"
            }
          },
          "&.Mui-disabled": {
            borderColor: `${T.colors.neutral[30]} !important`,
            borderWidth: "1px"
          }
        };
      },
      notchedOutline: {
        borderColor: T.colors.neutral[100]
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 20
      }
    }
  }
}), light$h = (T) => ({
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        fontSize: "22px",
        color: T.colors.neutral[40]
      }
    }
  },
  MuiPickersDay: {
    styleOverrides: {
      root: {
        "&&.Mui-selected": {
          backgroundColor: T.colors.darkBlue[10]
        }
      }
    }
  },
  MuiPickersYear: {
    styleOverrides: {
      yearButton: {
        "&&.Mui-selected": {
          backgroundColor: T.colors.darkBlue[10]
        }
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: "10px",
        width: "330px",
        height: "auto"
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        color: T.colors.darkBlue[10]
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          color: T.colors.neutral[40],
          /**
           * This approach was inferred from StackOverflow
           *
           * Reference: https://stackoverflow.com/questions/52911169/how-to-change-the-border-color-of-material-ui-textfield
           */
          "&:hover fieldset": {
            borderColor: `${T.colors.darkBlue[50]} !important`,
            ...R.disabled && {
              borderColor: "rgba(0, 0, 0, 0.26) !important"
            },
            ...R.error && {
              borderColor: `${T.colors.red[50]} !important`
            }
          },
          "&.Mui-focused": {
            borderColor: `${T.colors.darkBlue[50]} !important`,
            borderWidth: "2px",
            ...R.error && {
              borderColor: `${T.colors.red[50]} !important`,
              borderWidth: "2px"
            }
          },
          "&.Mui-disabled": {
            borderColor: `${T.colors.neutral[80]} !important`,
            borderWidth: "1px"
          }
        };
      },
      notchedOutline: {
        borderColor: T.colors.neutral[60]
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          height: "48px",
          "& svg": {
            ...R.disabled && {
              color: T.colors.neutral[80]
            }
          },
          ...R.variant === "outlined" && {
            lineHeight: 1,
            "&.Mui-disabled": {
              color: T.colors.neutral[80]
            }
          }
        };
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      root: (S) => ({
        top: "-4px !important",
        ...S.ownerState["data-shrink"] && {
          color: T.colors.neutral[10],
          fontWeight: T.typography.fontWeightSemiBold
        }
      })
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 20
      }
    }
  }
}), DateFieldThemeConfig = {
  dark: dark$h,
  light: light$h
}, BaseDateField$1 = ({
  adapterLocale: T,
  ...S
}) => {
  const {
    DesktopDatePicker: R,
    AdapterDayjs: k,
    LocalizationProvider: D
  } = Packages["@mui/x-date-pickers"], {
    dayjs: L
  } = Packages["dayjs-pkg"], {
    FormattedMessage: V,
    useIntl: z
  } = LocalizationProvider(), W = useRef(null), U = z();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(D, { dateAdapter: k, adapterLocale: T || U.locale, children: /* @__PURE__ */ jsxRuntimeExports.jsx(R, { ...S, ref: W, label: /* @__PURE__ */ jsxRuntimeExports.jsx(V, { id: S.token, defaultMessage: S.defaultMessage, values: S.values }), value: S.value ? L(S.value) : null }) });
};
BaseDateField$1.propTypes = {
  value: Packages.PropTypes.oneOfType([Packages.PropTypes.string, Packages.PropTypes.instanceOf(Date)]),
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object,
  onChange: Packages.PropTypes.func,
  onBlur: Packages.PropTypes.func,
  format: Packages.PropTypes.string,
  adapterLocale: Packages.PropTypes.string
};
const DesktopDateField = withBaseField(withThemeOverrides(BaseDateField$1, DateFieldThemeConfig), "DateField");
Packages["dayjs-pkg"].dayjs.extend(Packages["dayjs-pkg"].plugin.utc);
Packages["dayjs-pkg"].dayjs.extend(Packages["dayjs-pkg"].plugin.timezone);
const BaseDateField = ({
  adapterLocale: T,
  ...S
}) => {
  const {
    MobileDatePicker: R,
    AdapterDayjs: k,
    LocalizationProvider: D
  } = Packages["@mui/x-date-pickers"], {
    dayjs: L
  } = Packages["dayjs-pkg"], {
    FormattedMessage: V,
    useIntl: z
  } = LocalizationProvider(), W = useRef(null), U = z();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(D, { dateAdapter: k, adapterLocale: T || U.locale, children: /* @__PURE__ */ jsxRuntimeExports.jsx(R, { ...S, ref: W, label: /* @__PURE__ */ jsxRuntimeExports.jsx(V, { id: S.token, defaultMessage: S.defaultMessage, values: S.values }), value: S.value ? L(S.value) : null }) });
};
BaseDateField.propTypes = {
  value: Packages.PropTypes.oneOfType([Packages.PropTypes.string, Packages.PropTypes.instanceOf(Date)]),
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object,
  onChange: Packages.PropTypes.func,
  onBlur: Packages.PropTypes.func,
  format: Packages.PropTypes.string,
  adapterLocale: Packages.PropTypes.string
};
const MobileDateField = withBaseField(withThemeOverrides(BaseDateField, DateFieldThemeConfig), "DateField", "mobile"), DateField = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    case "mobile":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(MobileDateField, { ...S });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopDateField, { ...S });
  }
};
DateField.propTypes = {
  variant: Packages.PropTypes.oneOf(["desktop", "mobile"])
};
const DialogActions$2 = ({
  props: T,
  value: S,
  handler: R
}) => {
  const {
    DialogActions: k
  } = Packages.Mui, D = ["Invalid Date", ""].includes(formatDate(S[0])) || ["Invalid Date", ""].includes(formatDate(S[1]));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(k, { className: T.className, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { variant: "text", token: "general.cai_material.actions.done", disabled: D, onClick: R }) });
};
DialogActions$2.propTypes = {
  props: Packages.PropTypes.object,
  value: Packages.PropTypes.string,
  handler: Packages.PropTypes.func,
  className: Packages.PropTypes.object
};
const dark$g = (T) => ({
  MuiTextField: {
    styleOverrides: {
      root: (S) => ({
        svg: {
          color: T.colors.neutral[95],
          ...S.variant === "filled" && {
            color: T.colors.neutral[30]
          }
        },
        "&& ::placeholder": {
          opacity: "1"
        }
      })
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontWeight: T.typography.fontWeightSemiBold,
        color: T.colors.neutral[95]
      }
    }
  },
  MuiInputAdornment: {
    styleOverrides: {
      positionStart: {
        cursor: "pointer",
        marginLeft: "4px",
        marginRight: "8px"
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        height: 48
      },
      notchedOutline: {
        borderColor: T.colors.neutral[95]
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: 10,
        borderTop: `1px solid ${T.colors.neutral[97]}`
      }
    }
  },
  MuiDateRangePickerDay: {
    styleOverrides: {
      root: {
        "&& .Mui-selected": {
          background: T.colors.blue[90],
          color: T.colors.blue[10]
        }
      },
      day: {
        fontWeight: T.typography.fontWeightRegular,
        fontSize: "14px",
        fontFamily: T.typography.fontFamily
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        height: "48px",
        background: "white",
        color: T.colors.blue[10],
        border: "none",
        boxShadow: "none",
        backgroundColor: T.colors.blue[90],
        borderRadius: "100px",
        padding: "0px 1rem",
        gap: "8px",
        fontFamily: T.typography.fontFamily,
        textTransform: "none",
        fontSize: "16px",
        "&:hover": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.blue[80]
        },
        "&:focus": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.blue[70]
        },
        "&:active": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.blue[60]
        },
        "&:disabled": {
          border: "none",
          color: T.colors.neutral[50],
          backgroundColor: T.colors.neutral[20]
        }
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 20,
        background: T.colors.neutral[21]
      }
    }
  }
}), light$g = (T) => ({
  MuiTextField: {
    styleOverrides: {
      root: (S) => ({
        svg: {
          color: T.colors.neutral[10],
          ...S.variant === "filled" && {
            color: T.colors.neutral[30]
          }
        },
        borderColor: T.colors.neutral[0],
        "&& ::placeholder": {
          opacity: "1"
        }
      })
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontWeight: T.typography.fontWeightSemiBold,
        color: T.colors.neutral[10]
      }
    }
  },
  MuiInputAdornment: {
    styleOverrides: {
      positionStart: {
        cursor: "pointer",
        marginLeft: "4px",
        marginRight: "8px"
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        height: 48
      },
      notchedOutline: {
        borderColor: T.colors.neutral[40]
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: 10,
        borderTop: `1px solid ${T.colors.neutral[97]}`
      }
    }
  },
  MuiDateRangePickerDay: {
    styleOverrides: {
      root: {
        "&& .Mui-selected": {
          background: T.colors.blue[10]
        }
      },
      day: {
        fontWeight: T.typography.fontWeightRegular,
        fontSize: "14px",
        fontFamily: T.typography.fontFamily
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        height: "48px",
        background: "white",
        color: T.colors.neutral[100],
        border: "none",
        boxShadow: "none",
        backgroundColor: T.colors.darkBlue[50],
        borderRadius: "100px",
        padding: "0px 1rem",
        gap: "8px",
        fontFamily: T.typography.fontFamily,
        textTransform: "none",
        fontSize: "16px",
        "&:hover": {
          border: "none",
          boxShadow: T.shadow(1),
          backgroundColor: T.colors.darkBlue[40]
        },
        "&:focus": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.darkBlue[30]
        },
        "&:active": {
          border: "none",
          boxShadow: "none",
          backgroundColor: T.colors.darkBlue[20]
        },
        "&:disabled": {
          border: "none",
          boxShadow: "none",
          color: T.colors.neutral[91],
          backgroundColor: T.colors.neutral[92]
        }
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 20
      }
    }
  }
}), DateRangeFieldThemeConfig = {
  dark: dark$g,
  light: light$g
}, BaseDateRangeField = ({
  datesDisablingStrategy: T,
  onSelectionComplete: S,
  adapterLocale: R,
  ...k
}) => {
  const {
    AdapterDayjs: D,
    LocalizationProvider: L
  } = Packages["@mui/x-date-pickers"], {
    DateRangePicker: V
  } = Packages["@mui/x-date-pickers-pro"], {
    dayjs: z
  } = Packages["dayjs-pkg"], {
    InputAdornment: W
  } = Packages.Mui, {
    useIntl: U
  } = LocalizationProvider(), q = U(), K = useRef(null), [Y, J] = useState$1(!!k.open);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(L, { dateAdapter: D, adapterLocale: R || q.locale, children: /* @__PURE__ */ jsxRuntimeExports.jsx(V, { ref: K, open: Y, shouldDisableDate: T, closeOnSelect: !1, onOpen: () => J(!0), onClose: () => J(!1), slots: {
    actionBar: (Z) => DialogActions$2({
      props: Z,
      value: Z.ownerState.value,
      handler: () => {
        const X = Z.ownerState.value;
        S && S([formatDate(X[0]), formatDate(X[1])]), J(!1);
      }
    })
  }, slotProps: {
    textField: ({
      position: Z
    }) => ({
      label: Z === "start" ? q.formatMessage({
        id: k.token.start
      }) : q.formatMessage({
        id: k.token.end
      }),
      InputProps: {
        startAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(W, { position: "start", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "calendar-month" }) })
      }
    })
  }, ...k, value: k.value ? [z(k.value[0]), z(k.value[1])] : [null, null] }) });
};
BaseDateRangeField.propTypes = {
  datesDisablingStrategy: Packages.PropTypes.func,
  onSelectionComplete: Packages.PropTypes.func,
  adapterLocale: Packages.PropTypes.string,
  open: Packages.PropTypes.bool,
  token: Packages.PropTypes.shape({
    start: Packages.PropTypes.string.isRequired,
    end: Packages.PropTypes.string.isRequired
  }).isRequired,
  ownerState: Packages.PropTypes.shape({
    value: Packages.PropTypes.oneOfType([
      Packages.PropTypes.string,
      Packages.PropTypes.arrayOf(Packages.PropTypes.string),
      Packages.PropTypes.arrayOf(Packages.PropTypes.object)
      // In case it contains date objects
    ])
  })
};
const DateRangeField = withBaseField(withThemeOverrides(BaseDateRangeField, DateRangeFieldThemeConfig), "DateRangeField"), FavoriteBaseButton = Packages.emotion.styled(BaseButton)(({
  ...T
}) => {
  const S = Packages.Mui.useTheme();
  return `
    min-width: 40px;

    ${T.enabled === "true" && "box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;"}

    &:active {
      background: ${S.surface(3)};

      color: ${S.validateMode({
    light: S.colors.darkBlue[30],
    dark: S.colors.blue[90]
  })};
    }

    & .MuiSvgIcon-root {
      color: ${S.validateMode({
    light: S.colors.darkBlue[30],
    dark: S.colors.blue[90]
  })};
    }
  `;
}), GeneralBaseButton = Packages.emotion.styled(BaseButton)(() => {
  const T = Packages.Mui.useTheme();
  return `
      min-width: 40px;
      &:active{
        background: ${T.surface(3)};
  
        color: ${T.validateMode({
    light: T.colors.neutral[40],
    dark: T.colors.blue[90]
  })};
      }
    `;
}), ModalBaseButton = Packages.emotion.styled(BaseButton)(() => {
  const T = Packages.Mui.useTheme();
  return `
      min-width: 35px;
      color: ${T.validateMode({
    light: T.colors.neutral[40],
    dark: T.colors.neutral[95]
  })};
      border: 1px solid ${T.validateMode({
    light: T.colors.neutral[93],
    dark: T.colors.neutral[87]
  })};
      &:active{
        background: ${T.surface(3)};
        color: ${T.validateMode({
    light: T.colors.neutral[40],
    dark: T.colors.blue[90]
  })};
      };
  
      .MuiSvgIcon-root {
        font-size: 24px !important;
      };
    `;
}), GlassModalBaseButton = Packages.emotion.styled(BaseButton)(() => {
  const T = Packages.Mui.useTheme();
  return `
      min-width: 35px;
      background: ${T.validateMode({
    light: T.colors.rgba.white[90],
    dark: T.colors.rgba.gray[20]
  })};
      color: ${T.validateMode({
    light: T.colors.neutral[40],
    dark: T.colors.neutral[100]
  })};
      border: 0px solid ${T.validateMode({
    light: T.colors.neutral[93],
    dark: T.colors.neutral[87]
  })};
      &:hover{
        background: ${T.validateMode({
    light: T.colors.rgba.white[40],
    dark: T.colors.rgba.white[20]
  })};
        color: ${T.validateMode({
    light: T.colors.neutral[40],
    dark: T.colors.neutral[100]
  })};
      };
      &:focus{
        background: ${T.validateMode({
    light: T.colors.rgba.white[40],
    dark: T.colors.rgba.white[20]
  })};
        color: ${T.validateMode({
    light: T.colors.neutral[40],
    dark: T.colors.neutral[100]
  })};
      };
  
      .MuiSvgIcon-root {
        font-size: 24px !important;
      };
    `;
}), Favorite = (T) => {
  const S = Packages.Mui.useTheme(), [R, k] = useState$1(T.enabled || !1), D = () => {
    k(!R);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FavoriteBaseButton, { ...T, enabled: R.toString(), variant: "favorite", onClick: D, children: R ? /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "favorite-outlined", sx: {
    color: S.colors.darkBlue[10]
  } }) : /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "favorite-border-outlined", sx: {
    color: S.colors.neutral[40]
  } }) });
};
Favorite.propTypes = {
  enabled: Packages.PropTypes.bool
};
const General$1 = (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(GeneralBaseButton, { ...T, variant: "icon" });
General$1.propTypes = {
  icon: Packages.PropTypes.element.isRequired
};
const ModalHeaderIcon = (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(ModalBaseButton, { ...T, variant: "modal-header" });
ModalHeaderIcon.propTypes = {
  icon: Packages.PropTypes.element.isRequired
};
const GlassModalHeader = (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(GlassModalBaseButton, { ...T, variant: "modal-header" });
GlassModalHeader.propTypes = {
  icon: Packages.PropTypes.element.isRequired
};
const Icon = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    case "favorite":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Favorite, { ...S });
    case "modal-header":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalHeaderIcon, { ...S });
    case "glass-modal-header":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(GlassModalHeader, { ...S });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(General$1, { ...S });
  }
};
Icon.propTypes = {
  variant: Packages.PropTypes.oneOf(["general", "favorite", "modal-header", "glass-modal-header"]),
  enabled: Packages.PropTypes.bool
};
const TYPES = {
  NUMBER: {
    type: "number",
    initialValue: 0,
    constructor: Number
  },
  STRING: {
    type: "string",
    initialValue: "",
    constructor: String
  },
  BOOLEAN: {
    type: "boolean",
    initialValue: !1,
    constructor: Boolean
  },
  DATE: {
    type: "date",
    initialValue: null,
    constructor: Date
  }
}, AUS = {
  mapping: {
    country: {
      id: "countryCode",
      required: !0
    },
    address1: {
      id: "address1",
      required: !0
    },
    address2: {
      id: "address2"
    },
    city: {
      id: "city",
      required: !0
    },
    suburb: {
      id: "countrySubDivision",
      required: !0,
      listValues: [{
        value: "NSW",
        label: "New South Wales"
      }, {
        value: "QLD",
        label: "Queensland"
      }]
    },
    postalCode: {
      id: "postalCode",
      required: !0
    },
    longitude: {
      id: "coordinates.longitude",
      type: TYPES.NUMBER,
      disabled: !1
    },
    latitude: {
      id: "coordinates.latitude",
      type: TYPES.NUMBER,
      disabled: !1
    }
  },
  textFormatSeparator: ",",
  // Specifies the separator used below. A comma is the default. Only shown here for clarity.
  textFormats: {
    oneLine: "{address1}, {address2}, {city}, {suburb} {postalCode}",
    multiLine: `{address1}
{address2}
{city}, {suburb} {postalCode}`
  },
  layouts: {
    default: {
      sm: `
        'country'
        'address1'
        'address2'
        'city'
        'suburb'
        'postalCode'
        'latitude'
        'longitude'
      `,
      md: `
        'country country country'
        'address1 address1 address1'
        'address2 address2 address2'
        'city suburb postalCode'
        'latitude longitude .'
      `,
      lg: `
      'country country address1 address1'
      'address2 address2 city suburb'
      'postalCode postalCode longitude latitude'`
    }
  }
}, BRA = {
  mapping: {
    country: {
      id: "countryCode",
      required: !0
    },
    address1: {
      id: "address1",
      required: !0
    },
    address2: {
      id: "address2"
    },
    city: {
      id: "city",
      required: !0
    },
    neighborhood: {
      id: "address3"
    },
    postalCode: {
      id: "postalCode",
      required: !0
    },
    longitude: {
      id: "coordinates.longitude",
      type: TYPES.NUMBER,
      disabled: !1
    },
    latitude: {
      id: "coordinates.latitude",
      type: TYPES.NUMBER,
      disabled: !1
    }
  },
  textFormatSeparator: ",",
  // Specifies the separator used below. A comma is the default. Only shown here for clarity.
  textFormats: {
    oneLine: "{address1}, {address2}, {city}, {neighborhood} {postalCode}",
    multiLine: `{address1}
{address2}
{city}, {neighborhood} {postalCode}`
  },
  layouts: {
    default: {
      sm: `
        'country'
        'address1'
        'address2'
        'city'
        'neighborhood'
        'postalCode'
        'latitude'
        'longitude'
      `,
      md: `
        'country country country'
        'address1 address1 address1'
        'address2 address2 address2'
        'city neighborhood postalCode'
        'latitude longitude .'
      `,
      lg: `
      'country country address1 address1'
      'address2 address2 city neighborhood'
      'postalCode postalCode longitude latitude'`
    }
  }
}, CAN = {
  mapping: {
    country: {
      id: "countryCode",
      required: !0
    },
    address1: {
      id: "address1",
      required: !0
    },
    address2: {
      id: "address2",
      required: !0
    },
    city: {
      id: "city",
      required: !0
    },
    province: {
      id: "countrySubDivision",
      required: !0,
      listValues: [{
        value: "AB",
        label: "Alberta"
      }, {
        value: "BC",
        label: "British Columbia"
      }, {
        value: "MB",
        label: "Manitoba"
      }, {
        value: "NB",
        label: "New Brunswick"
      }, {
        value: "NL",
        label: "Newfoundland and Labrador"
      }, {
        value: "NS",
        label: "Nova Scotia"
      }, {
        value: "NT",
        label: "Northwest Territories"
      }, {
        value: "NU",
        label: "Nunavut"
      }, {
        value: "ON",
        label: "Ontario"
      }, {
        value: "PE",
        label: "Prince Edward Island"
      }, {
        value: "QC",
        label: "Quebec"
      }, {
        value: "SK",
        label: "Saskatchewan"
      }, {
        value: "YT",
        label: "Yukon"
      }]
    },
    postalCode: {
      id: "postalCode",
      required: !0
    },
    longitude: {
      id: "coordinates.longitude",
      type: TYPES.NUMBER,
      disabled: !1
    },
    latitude: {
      id: "coordinates.latitude",
      type: TYPES.NUMBER,
      disabled: !1
    }
  },
  textFormatSeparator: ",",
  // Specifies the separator used below. A comma is the default. Only shown here for clarity.
  textFormats: {
    oneLine: "{address1}, {address2}, {city}, {province} {postalCode}",
    multiLine: `{address1}
{address2}
{city}, {province} {postalCode}`
  },
  layouts: {
    default: {
      sm: `
        'country'
        'address1'
        'address2'
        'city'
        'province'
        'postalCode'
        'latitude'
        'longitude'
      `,
      md: `
        'country country country'
        'address1 address1 address1'
        'address2 address2 address2'
        'city province postalCode'
        'latitude longitude .'
      `,
      lg: `
      'country country address1 address1'
      'address2 address2 city province'
      'postalCode postalCode longitude latitude'`
    }
  }
}, COL = {
  mapping: {
    country: {
      id: "countryCode",
      required: !0
    },
    address1: {
      id: "address1",
      required: !0
    },
    address2: {
      id: "address2"
    },
    neighborhood: {
      id: "address3"
    },
    city: {
      id: "city",
      required: !0
    },
    department: {
      id: "countrySubDivision",
      required: !0,
      listValues: [{
        value: "AMA",
        label: "Amazonas"
      }, {
        value: "ANT",
        label: "Antioquia"
      }, {
        value: "ARA",
        label: "Arauca"
      }, {
        value: "ATL",
        label: "Atlántico"
      }, {
        value: "BOL",
        label: "Bolívar"
      }, {
        value: "BOY",
        label: "Boyacá"
      }, {
        value: "CAL",
        label: "Caldas"
      }, {
        value: "CAQ",
        label: "Caquetá"
      }, {
        value: "CAS",
        label: "Casanare"
      }, {
        value: "CAU",
        label: "Cauca"
      }, {
        value: "CES",
        label: "Cesar"
      }, {
        value: "CHO",
        label: "Chocó"
      }, {
        value: "COR",
        label: "Córdoba"
      }, {
        value: "CUN",
        label: "Cundinamarca"
      }, {
        value: "GUA",
        label: "Guainía"
      }, {
        value: "GUV",
        label: "Guaviare"
      }, {
        value: "HUI",
        label: "Huila"
      }, {
        value: "LAG",
        label: "La Guajira"
      }, {
        value: "MAG",
        label: "Magdalena"
      }, {
        value: "MET",
        label: "Meta"
      }, {
        value: "NAR",
        label: "Nariño"
      }, {
        value: "NSA",
        label: "Norte de Santander"
      }, {
        value: "PUT",
        label: "Putumayo"
      }, {
        value: "QUI",
        label: "Quindío"
      }, {
        value: "RIS",
        label: "Risaralda"
      }, {
        value: "SAP",
        label: "San Andrés y Providencia"
      }, {
        value: "SAN",
        label: "Santander"
      }, {
        value: "SUC",
        label: "Sucre"
      }, {
        value: "TOL",
        label: "Tolima"
      }, {
        value: "VAC",
        label: "Valle del Cauca"
      }, {
        value: "VAU",
        label: "Vaupés"
      }, {
        value: "VID",
        label: "Vichada"
      }]
    },
    postalCode: {
      id: "postalCode",
      required: !0
    },
    longitude: {
      id: "coordinates.longitude",
      type: TYPES.NUMBER,
      disabled: !1
    },
    latitude: {
      id: "coordinates.latitude",
      type: TYPES.NUMBER,
      disabled: !1
    }
  },
  textFormatSeparator: ",",
  // Specifies the separator used below. A comma is the default. Only shown here for clarity.
  textFormats: {
    oneLine: "{address1}, {address2}, {city}, {neighborhood}, {department}, {state} {postalCode}",
    multiLine: `{address1}
{address2}
{city}, {neighborhood}
{department}, {postalCode}`
  },
  layouts: {
    default: {
      sm: `
        'country'
        'address1'
        'address2'
        'city'
        'neighborhood'
        'department'
        'postalCode'
        'latitude'
        'longitude'
      `,
      md: `
        'country country'
        'address1 address1'
        'address2 address2'
        'city neighborhood'
        'department postalCode'
        'latitude longitude'
      `,
      lg: `
      'country country address1 address1'
      'address2 address2 city neighborhood'
      'department postalCode longitude latitude'`
    }
  }
}, DOM = {
  mapping: {
    country: {
      id: "countryCode",
      required: !0
    },
    address1: {
      id: "address1",
      required: !0
    },
    address2: {
      id: "address2"
    },
    city: {
      id: "city",
      required: !0
    },
    state: {
      id: "countrySubDivision",
      required: !0,
      listValues: [{
        value: "02",
        label: "Azua"
      }, {
        value: "03",
        label: "Baoruco"
      }]
    },
    postalCode: {
      id: "postalCode",
      required: !0
    },
    longitude: {
      id: "coordinates.longitude",
      type: TYPES.NUMBER,
      disabled: !1
    },
    latitude: {
      id: "coordinates.latitude",
      type: TYPES.NUMBER,
      disabled: !1
    }
  },
  textFormatSeparator: ",",
  // Specifies the separator used below. A comma is the default. Only shown here for clarity.
  textFormats: {
    oneLine: "{address1}, {address2}, {city}, {state} {zipCode}",
    multiLine: `{address1}
{address2}
{city}, {state} {zipCode}`
  },
  layouts: {
    default: {
      sm: `
        'country'
        'address1'
        'address2'
        'city'
        'state'
        'postalCode'
        'latitude'
        'longitude'
      `,
      md: `
        'country country country'
        'address1 address1 address1'
        'address2 address2 address2'
        'city state postalCode'
        'latitude longitude .'
      `,
      lg: `
      'country country address1 address1'
      'address2 address2 city state'
      'postalCode postalCode longitude latitude'`
    }
  }
}, NZL = {
  mapping: {
    country: {
      id: "countryCode",
      required: !0
    },
    address1: {
      id: "address1",
      required: !0
    },
    address2: {
      id: "address2"
    },
    city: {
      id: "city",
      required: !0
    },
    suburb: {
      id: "countrySubDivision",
      required: !0,
      listValues: [{
        value: "AUK",
        label: "Auckland"
      }, {
        value: "BOP",
        label: "Bay of Plenty"
      }]
    },
    postalCode: {
      id: "postalCode",
      required: !0
    },
    longitude: {
      id: "coordinates.longitude",
      type: TYPES.NUMBER,
      disabled: !1
    },
    latitude: {
      id: "coordinates.latitude",
      type: TYPES.NUMBER,
      disabled: !1
    }
  },
  textFormatSeparator: ",",
  // Specifies the separator used below. A comma is the default. Only shown here for clarity.
  textFormats: {
    oneLine: "{address1}, {address2}, {city}, {suburb} {postalCode}",
    multiLine: `{address1}
{address2}
{city}, {suburb} {postalCode}`
  },
  layouts: {
    default: {
      sm: `
        'country'
        'address1'
        'address2'
        'city'
        'suburb'
        'postalCode'
        'latitude'
        'longitude'
      `,
      md: `
        'country country country'
        'address1 address1 address1'
        'address2 address2 address2'
        'city suburb postalCode'
        'latitude longitude .'
      `,
      lg: `
      'country country address1 address1'
      'address2 address2 city suburb'
      'postalCode postalCode longitude latitude'`
    }
  }
}, AL = {
  value: "AL",
  label: "Alabama",
  city: ["Abbeville", "Adamsville", "Addison", "Akron", "Alabaster", "Albertville", "Alexander City", "Aliceville", "Allgood", "Altoona", "Andalusia", "Anderson", "Anniston", "Arab", "Ardmore", "Argo", "Ariton", "Arley", "Ashford", "Ashland", "Ashville", "Athens", "Atmore", "Attalla", "Auburn", "Autaugaville", "Avon", "Babbie", "Baileyton", "Bakerhill", "Banks", "Bay Minette", "Bayou La Batre", "Bear Creek", "Beatrice", "Beaverton", "Belk", "Benton", "Berlin", "Berry", "Bessemer", "Billingsley", "Birmingham", "Black", "Blountsville", "Blue Springs", "Boaz", "Boligee", "Bon Air", "Brantley", "Brent", "Brewton", "Bridgeport", "Brighton", "Brilliant", "Brookside", "Brookwood", "Brundidge", "Butler", "Calera", "Camden", "Camp Hill", "Carbon Hill", "Cardiff", "Carolina", "Carrollton", "Castleberry", "Cedar Bluff", "Center Point", "Centre", "Centreville", "Chatom", "Chelsea", "Cherokee", "Chickasaw", "Childersburg", "Citronelle", "Clanton", "Clay", "Clayhatchee", "Clayton", "Cleveland", "Clio", "Coaling", "Coffee Springs", "Coffeeville", "Coker", "Collinsville", "Colony", "Columbia", "Columbiana", "Coosada", "Cordova", "Cottonwood", "County Line", "Courtland", "Cowarts", "Creola", "Crossville", "Cuba", "Cullman", "Cusseta", "Dadeville", "Daleville", "Daphne", "Dauphin Island", "Daviston", "Dayton", "Deatsville", "Decatur", "Demopolis", "Detroit", "Dodge City", "Dora", "Dothan", "Double Springs", "Douglas", "Dozier", "Dutton", "East Brewton", "Eclectic", "Edwardsville", "Elba", "Elberta", "Eldridge", "Elkmont", "Elmore", "Emelle", "Enterprise", "Epes", "Ethelsville", "Eufaula", "Eutaw", "Eva", "Evergreen", "Excel", "Fairfield", "Fairhope", "Fairview", "Falkville", "Faunsdale", "Fayette", "Five Points", "Flomaton", "Florala", "Florence", "Foley", "Forkland", "Fort Deposit", "Fort Payne", "Franklin", "Frisco City", "Fruithurst", "Fulton", "Fultondale", "Fyffe", "Gadsden", "Gainesville", "Gantt", "Garden City", "Gardendale", "Gaylesville", "Geiger", "Geneva", "Georgiana", "Geraldine", "Gilbertown", "Glen Allen", "Glencoe", "Glenwood", "Goldville", "Good Hope", "Goodwater", "Gordo", "Gordon", "Gordonville", "Goshen", "Grant", "Graysville", "Greensboro", "Greenville", "Grimes", "Grove Hill", "Guin", "Gulf Shores", "Guntersville", "Gurley", "Gu-Win", "Hackleburg", "Haleburg", "Haleyville", "Hamilton", "Hammondville", "Hanceville", "Harpersville", "Hartford", "Hartselle", "Hayden", "Hayneville", "Headland", "Heath", "Heflin", "Helena", "Henagar", "Highland Lake", "Hillsboro", "Hobson City", "Hodges", "Hokes Bluff", "Holly Pond", "Hollywood", "Homewood", "Hoover", "Horn Hill", "Hueytown", "Huntsville", "Hurtsboro", "Hytop", "Ider", "Indian Springs Village", "Irondale", "Jackson", "Jackson's Gap", "Jacksonville", "Jasper", "Jemison", "Kansas", "Kellyton", "Kennedy", "Killen", "Kimberly", "Kinsey", "Kinston", "LaFayette", "Lake View", "Lakeview", "Lanett", "Langston", "Leeds", "Leesburg", "Leighton", "Lester", "Level Plains", "Lexington", "Libertyville", "Lincoln", "Linden", "Lineville", "Lipscomb", "Lisman", "Littleville", "Livingston", "Loachapoka", "Lockhart", "Locust Fork", "Louisville", "Lowndesboro", "Loxley", "Luverne", "Lynn", "Madison", "Madrid", "Magnolia Springs", "Malvern", "Maplesville", "Margaret", "Marion", "Maytown", "McIntosh", "McKenzie", "McMullen", "Memphis", "Mentone", "Midfield", "Midland City", "Midway", "Millbrook", "Millport", "Millry", "Mobile", "Monroeville", "Montevallo", "Montgomery", "Moody", "Mooresville", "Morris", "Mosses", "Moulton", "Moundville", "Mount Vernon", "Mountain Brook", "Mulga", "Munford", "Muscle Shoals", "Myrtlewood", "Napier Field", "Natural Bridge", "Nauvoo", "Nectar", "Needham", "New Brockton", "New Hope", "New Site", "Newbern", "Newton", "Newville", "North Courtland", "North Johns", "Northport", "Notasulga", "Oak Grove", "Oak Hill", "Oakman", "Odenville", "Ohatchee", "Oneonta", "Onycha", "Opelika", "Opp", "Orange Beach", "Orrville", "Owens Cross Roads", "Oxford", "Ozark", "Paint Rock", "Parrish", "Pelham", "Pell City", "Pennington", "Perdido Beach", "Petrey", "Phenix City", "Phil Campbell", "Pickensville", "Piedmont", "Pike Road", "Pinckard", "Pine Apple", "Pine Hill", "Pine Ridge", "Pinson", "Pisgah", "Pleasant Grove", "Pleasant Groves", "Pollard", "Powell", "Prattville", "Priceville", "Prichard", "Providence", "Ragland", "Rainbow City", "Rainsville", "Ranburne", "Red Bay", "Red Level", "Reece City", "Reform", "Rehobeth", "Repton", "Ridgeville", "River Falls", "Riverside", "Riverview", "Roanoke", "Robertsdale", "Rockford", "Rogersville", "Rosa", "Russellville", "Rutledge", "St. Florian", "Samson", "Sand Rock", "Sanford", "Saraland", "Sardis City", "Satsuma", "Scottsboro", "Section", "Selma", "Sheffield", "Shiloh", "Shorter", "Silas", "Silverhill", "Sipsey", "Skyline", "Slocomb", "Smiths Station", "Snead", "Somerville", "South Vinemont", "Southside", "Spanish Fort", "Springville", "Steele", "Stevenson", "Sulligent", "Sumiton", "Summerdale", "Susan Moore", "Sweet Water", "Sylacauga", "Sylvan Springs", "Sylvania", "Talladega Springs", "Talladega", "Tallassee", "Tarrant", "Taylor", "Thomaston", "Thomasville", "Thorsby", "Town Creek", "Toxey", "Trafford", "Triana", "Trinity", "Troy", "Trussville", "Tuscaloosa", "Tuscumbia", "Tuskegee", "Twin", "Union Grove", "Union Springs", "Union", "Uniontown", "Valley", "Valley Grande", "Valley Head", "Vance", "Vernon", "Vestavia Hills", "Vina", "Vincent", "Vredenburgh", "Wadley", "Waldo", "Walnut Grove", "Warrior", "Waterloo", "Waverly", "Weaver", "Webb", "Wedowee", "West Blocton", "West Jefferson", "West Point", "Westover", "Wetumpka", "White Hall", "Wilsonville", "Wilton", "Winfield", "Woodland", "Woodstock", "Woodville", "Yellow Bluff", "York"]
}, states = [AL, {
  value: "AK",
  label: "Alaska",
  city: ["Anchorage"]
}, {
  value: "AZ",
  label: "Arizona"
}, {
  value: "AR",
  label: "Arkansas"
}, {
  value: "CA",
  label: "California"
}, {
  value: "CO",
  label: "Colorado"
}, {
  value: "CT",
  label: "Connecticut"
}, {
  value: "DE",
  label: "Delaware"
}, {
  value: "DC",
  label: "District of Columbia"
}, {
  value: "FL",
  label: "Florida"
}, {
  value: "GA",
  label: "Georgia"
}, {
  value: "HI",
  label: "Hawaii"
}, {
  value: "ID",
  label: "Idaho"
}, {
  value: "IL",
  label: "Illinois"
}, {
  value: "IN",
  label: "Indiana"
}, {
  value: "IA",
  label: "Iowa"
}, {
  value: "KS",
  label: "Kansas"
}, {
  value: "KY",
  label: "Kentucky"
}, {
  value: "LA",
  label: "Louisiana"
}, {
  value: "ME",
  label: "Maine"
}, {
  value: "MD",
  label: "Maryland"
}, {
  value: "MA",
  label: "Massachusetts"
}, {
  value: "MI",
  label: "Michigan"
}, {
  value: "MN",
  label: "Minnesota"
}, {
  value: "MS",
  label: "Mississippi"
}, {
  value: "MO",
  label: "Missouri"
}, {
  value: "MT",
  label: "Montana"
}, {
  value: "NE",
  label: "Nebraska"
}, {
  value: "NV",
  label: "Nevada"
}, {
  value: "NH",
  label: "New Hampshire"
}, {
  value: "NJ",
  label: "New Jersey"
}, {
  value: "NM",
  label: "New Mexico"
}, {
  value: "NY",
  label: "New York"
}, {
  value: "NC",
  label: "North Carolina"
}, {
  value: "ND",
  label: "North Dakota"
}, {
  value: "OH",
  label: "Ohio"
}, {
  value: "OK",
  label: "Oklahoma"
}, {
  value: "OR",
  label: "Oregon"
}, {
  value: "PA",
  label: "Pennsylvania"
}, {
  value: "RI",
  label: "Rhode Island"
}, {
  value: "SC",
  label: "South Carolina"
}, {
  value: "SD",
  label: "South Dakota"
}, {
  value: "TN",
  label: "Tennessee"
}, {
  value: "TX",
  label: "Texas"
}, {
  value: "UT",
  label: "Utah"
}, {
  value: "VT",
  label: "Vermont"
}, {
  value: "VA",
  label: "Virginia"
}, {
  value: "WA",
  label: "Washington"
}, {
  value: "WV",
  label: "West Virginia"
}, {
  value: "WI",
  label: "Wisconsin"
}, {
  value: "WY",
  label: "Wyoming"
}], USA = {
  mapping: {
    country: {
      id: "countryCode",
      required: !0
    },
    address1: {
      id: "address1",
      required: !0
    },
    address2: {
      id: "address2"
    },
    city: {
      id: "city",
      required: !0
    },
    /*
        city: { id: 'city', required: true, listValues: 'state' },
         When listValues is a string, in this example "state", we will attempt to find the appropriate array from the
        listValues associated with the "state" field for the currently selected state.  The config for, say, Alabama, has
        the required "label" and "value" fields, but it also has a "city" field that is an array of city names.  We will use
        this array to populate the listValues for the city field.  This is a way to have config-driven, dynamic listValues
        based on the value of another field.
     */
    state: {
      id: "countrySubDivision",
      required: !0,
      listValues: states
    },
    zipCode: {
      id: "postalCode",
      required: !0
    },
    longitude: {
      id: "coordinates.longitude",
      type: TYPES.NUMBER,
      disabled: !1
    },
    latitude: {
      id: "coordinates.latitude",
      type: TYPES.NUMBER,
      disabled: !1
    }
  },
  textFormatSeparator: ",",
  // Specifies the separator used below. A comma is the default. Only shown here for clarity.
  textFormats: {
    oneLine: "{address1}, {address2}, {city}, {state} {zipCode}",
    multiLine: `{address1}
{address2}
{city}, {state} {zipCode}`
  },
  layouts: {
    default: {
      // Follows CSS Grid syntax
      sm: `
        'country'
        'address1'
        'address2'
        'city'
        'state'
        'zipCode'
        'latitude'
        'longitude'
      `,
      md: `
        'country country country'
        'address1 address1 address1'
        'address2 address2 address2'
        'city state zipCode'
        'latitude longitude .'
      `,
      lg: `
      'country country address1 address1'
      'address2 address2 city state'
      'zipCode zipCode longitude latitude'`
    }
  },
  mobileLayouts: {
    // To be determined
  }
}, configs = {
  AUS,
  BRA,
  CAN,
  COL,
  DOM,
  NZL,
  USA
}, SUPPORTED_COUNTRIES = [{
  id: "AUS",
  name: "Australia"
}, {
  id: "BRA",
  name: "Brazil"
}, {
  id: "CAN",
  name: "Canada"
}, {
  id: "DOM",
  name: "Dominican Republic"
}, {
  id: "COL",
  name: "Colombia"
}, {
  id: "NZL",
  name: "New Zealand"
}, {
  id: "USA",
  name: "United States"
}], INTL_ADDRESS_FORMATS = {
  ONE_LINE: "oneLine",
  MULTI_LINE: "multiLine"
}, EMPTY_STATE_VALUES = {
  address1: "",
  address2: "",
  city: "",
  countrySubDivision: "",
  postalCode: null,
  coordinates: {
    longitude: 0,
    latitude: 0
  }
}, FormContext = createContext$1(), useFormContext = () => {
  const T = useContext(FormContext);
  if (!T)
    throw new Error("useFormContext cannot be rendered outside of the FormContext context provider");
  return T;
}, ensureValidCountryCode = (T) => {
  const {
    find: S
  } = Packages.lodash, R = {
    ...T
  };
  return S(SUPPORTED_COUNTRIES, {
    id: R.countryCode ?? "__NULLISH__"
  }) || (R.countryCode = "USA"), R;
}, getInternationalAddressText = (T, S = INTL_ADDRESS_FORMATS.ONE_LINE, R = "USA") => {
  const {
    get: k
  } = Packages.lodash;
  if (!T || typeof T == "object" && Object.keys(T).length === 0) return "";
  const D = T?.countryCode || R, L = configs[D] ?? configs.US, V = L?.textFormatSeparator || ",";
  function z(te) {
    return k(T, L?.mapping?.[te]?.id, "") || "";
  }
  function W(te) {
    return te?.replace?.(/{(.*?)}/g, function(re, Q) {
      return z(Q);
    });
  }
  let U = L?.textFormats?.[S], q = W(U), K = new RegExp("\\s*" + V, "gm");
  q = q?.replace?.(K, V);
  let Y = new RegExp(V + "\\s*(?=" + V + ")", "gm");
  q = q?.replace?.(Y, "");
  let J = new RegExp(V + "\\s*$", "gm");
  q = q?.replace?.(J, "");
  let Z = new RegExp("^\\s*" + V + "\\s*", "gm");
  q = q?.replace?.(Z, "");
  let X = /^\s*[\n]/gm;
  q = q?.replace?.(X, "");
  let ee = /\n+$/g;
  return q = q?.replace?.(ee, ""), q || "";
}, getValidationSchema = (T) => {
  const S = configs[T], R = Object.keys(S.mapping).reduce((k, D) => (S.mapping?.[D]?.required ? k[S.mapping[D].id] = Packages.yup.string().required("required") : k[S.mapping[D].id] = Packages.yup.string(), k), {});
  return Packages.yup.object().shape(R);
}, prepareAddress = (T = {}) => {
  const S = removeNulls(T);
  return ensureValidCountryCode(S);
}, removeNulls = (T) => {
  const S = {
    ...T
  };
  for (let R in S)
    S[R] === null ? delete S[R] : typeof S[R] == "object" && removeNulls(S[R]);
  return S;
}, FormProvider = memo(({
  children: T,
  onChange: S,
  initialAddress: R,
  layout: k,
  required: D,
  disabled: L,
  isLoading: V,
  enableReinitialize: z,
  emitOnInitialValues: W,
  ensureValid: U,
  action: q,
  iso: K,
  address: Y
}) => {
  const [J, Z] = useState$1(), [X, ee] = useState$1(prepareAddress(R));
  useEffect$1(() => {
    ee(prepareAddress(R));
  }, [z, R]);
  const te = useFormHandler({
    config: {
      enableReinitialize: z,
      initialValues: X,
      validationSchema: J,
      validateOnMount: !0
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormContext.Provider, { value: {
    ...te,
    emitChange: S,
    layout: k,
    required: D,
    disabled: L,
    setInitialAddress: ee,
    validationSchema: J,
    setValidationSchema: Z,
    isLoading: V,
    emitOnInitialValues: W,
    ensureValid: U,
    action: q,
    iso: K,
    address: Y
  }, children: T });
});
FormProvider.propTypes = {
  children: Packages.PropTypes.node,
  onChange: Packages.PropTypes.func,
  initialAddress: Packages.PropTypes.object,
  layout: Packages.PropTypes.string,
  required: Packages.PropTypes.bool,
  disabled: Packages.PropTypes.bool,
  isLoading: Packages.PropTypes.bool,
  enableReinitialize: Packages.PropTypes.bool,
  emitOnInitialValues: Packages.PropTypes.bool,
  ensureValid: Packages.PropTypes.bool,
  action: Packages.PropTypes.object,
  iso: Packages.PropTypes.bool,
  address: Packages.PropTypes.object
};
const getInitialValues = (T) => {
  const S = configs[T];
  if (!S)
    throw new Error(`No format found for country code ${T}`);
  const {
    mapping: R
  } = S;
  return {
    ...Object.keys(R).reduce((D, L) => (set$1(D, R[L].id, R[L].defaultValue || (R[L].type ?? TYPES.STRING).constructor("")), D), {}),
    countryCode: T
  };
}, useAddressFieldSections = () => {
  const {
    required: T,
    disabled: S,
    ensureValid: R,
    iso: k,
    address: D,
    ...L
  } = useFormContext(), {
    setFormValue: V,
    formState: z,
    handleBlur: W,
    resetForm: U
  } = L, q = z().currentState, {
    find: K,
    get: Y
  } = Packages.lodash, J = configs?.[q?.countryCode || "USA"], Z = (ee = {}) => {
    const {
      city: te = "",
      countrySubDivision: re = "",
      postalCode: Q = "",
      countryCode: ne = "USA",
      address2: oe = "",
      coordinates: ae
    } = ee.address;
    switch (ne) {
      default:
        return {
          countrySubDivision: re,
          address2: oe,
          city: te,
          postalCode: Q,
          coordinates: ae
        };
    }
  };
  return {
    sections: useMemo(() => Object.keys(J.mapping).reduce((ee, te) => {
      const re = J.mapping[te], Q = () => {
        if (k)
          if (typeof re.listValues == "string") {
            const se = J.mapping[re.listValues], ie = K(se.listValues, {
              value: q[se.id]
            }), he = q[re.id]?.trim?.();
            let xe = ie?.[re.id] ?? [];
            return xe.length ? (xe.includes(he) || V({
              field: re.id,
              value: ""
            }), xe.map((Pe) => ({
              value: Pe,
              label: Pe
            }))) : he || "";
          } else
            return re.listValues;
      }, ne = Q(), oe = R && T && re.required, ae = S || re.disabled;
      return te === "country" ? ee[te] = /* @__PURE__ */ jsxRuntimeExports.jsx(SelectField, { token: `component.cai_material.international_address.${te}`, value: Y(q, re.id, ""), name: re.id, onChange: (se) => {
        U(getInitialValues(se)), V({
          field: re.id,
          value: (re.type ?? TYPES.STRING).constructor(se)
        });
      }, onBlur: W, required: oe, disabled: ae, className: "country-picker", options: SUPPORTED_COUNTRIES.map((se) => ({
        value: se.id,
        label: se.name
      })), disableClearable: !0 }, te) : te === "address1" ? ee[te] = /* @__PURE__ */ jsxRuntimeExports.jsx(
        AutocompleteField,
        {
          variant: "async",
          defaultValue: Y(q, re.id, ""),
          style: {
            gridArea: te
          },
          name: re.id,
          token: `component.cai_material.international_address.${te}`,
          ...Y(q, re.id, "") && {
            inputValue: Y(q, re.id, ""),
            value: Y(q, re.id, "")
          },
          onInputChange: D.onInputChange,
          onChange: async (se) => {
            const ie = se ? await D.onChange({
              parameters: {
                placeId: se.placeId
              }
            }) : void 0;
            U(se ? Z(ie) : EMPTY_STATE_VALUES), V({
              field: re.id,
              value: (re.type ?? TYPES.STRING).constructor(se?.text || "")
            });
          },
          metadata: {
            countryCode: q?.countryCode || "USA"
          }
        },
        Y(q, re.id, "")
      ) : ee[te] = ne?.length && typeof ne != "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx(SelectField, { style: {
        gridArea: te
      }, token: `component.cai_material.international_address.${te}`, value: Y(q, re.id, ""), name: re.id, onChange: (se) => {
        V({
          field: re.id,
          value: (re.type ?? TYPES.STRING).constructor(se)
        });
      }, onBlur: W, required: oe, disabled: ae, options: Q() }, te) : /* @__PURE__ */ jsxRuntimeExports.jsx(TextField$1, { style: {
        gridArea: te
      }, token: `component.cai_material.international_address.${te}`, value: Y(q, re.id, ""), name: re.id, onChange: (se) => {
        V({
          field: re.id,
          value: (re.type ?? TYPES.STRING).constructor(se)
        });
      }, onBlur: W, required: oe, disabled: ae }, te), ee;
    }, {}), [J.mapping, q])
  };
}, useEmitChanges = () => {
  const {
    emitChange: T,
    emitOnInitialValues: S,
    ensureValid: R,
    ...k
  } = useFormContext(), {
    isEmpty: D
  } = Packages.lodash, L = useRef(!0), {
    triggerValidation: V,
    formState: z
  } = k, W = z().currentState, U = z().errors;
  useEffect$1(() => {
    if (!(L.current && (L.current = !1, !S))) {
      if (!R) {
        T?.(W);
        return;
      }
      V().then((q) => {
        D(q) && D(U) ? T?.(W) : T?.(null);
      });
    }
  }, [T, S, R, U, W]);
}, between$3 = (T, S) => ({
  [T.breakpoints.between("lg", "xl")]: {
    gridTemplateColumns: "1fr 1fr 1fr 1fr",
    gridTemplateAreas: S.lg
  }
}), lg$7 = (T, S) => ({
  [T.breakpoints.down("lg")]: {
    gridTemplateColumns: "1fr 1fr 1fr 1fr",
    gridTemplateAreas: S.lg
  }
}), md$6 = (T, S) => ({
  [T.breakpoints.down("md")]: {
    gridTemplateColumns: "auto",
    gridTemplateAreas: S.md
  }
}), lg$6 = (T, S) => ({
  [T.breakpoints.down("sm")]: {
    gridTemplateColumns: "auto",
    gridTemplateAreas: S.sm
  }
}), xl$6 = (T, S) => ({
  [T.breakpoints.up("xl")]: {
    gridTemplateColumns: "1fr 1fr 1fr 1fr",
    gridTemplateAreas: S.lg
  }
}), xs$6 = (T) => ({
  [T.breakpoints.up("xs")]: {
    height: "105px",
    width: "105px"
  }
}), mediaQueries$4 = {
  xl: xl$6,
  lg: lg$7,
  md: md$6,
  sm: lg$6,
  xs: xs$6,
  between: between$3
}, Box$1 = Packages.emotion.styled(Packages.Mui.Box)(({
  layout: T
}) => {
  const S = Packages.Mui.useTheme();
  return {
    display: "grid",
    gap: 20,
    width: "100%",
    ".country-picker": {
      gridArea: "country"
    },
    ...mediaQueries$4.xl(S, T),
    ...mediaQueries$4.lg(S, T),
    ...mediaQueries$4.md(S, T),
    ...mediaQueries$4.sm(S, T),
    ...mediaQueries$4.between(S, T)
  };
}), Skeleton = Packages.emotion.styled(Packages.Mui.Skeleton)(({
  classes: T
}) => ({
  gridArea: T,
  width: "100%",
  height: 48,
  borderRadius: 6
})), useSkeletonFieldsSection = () => {
  const {
    ...T
  } = useFormContext(), {
    formState: S
  } = T, R = S().currentState, k = configs?.[R?.countryCode || "USA"];
  return {
    sections: useMemo(() => Object.keys(k.mapping).reduce((L, V) => (k.mapping[V].hidden || (L[V] = /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, { classes: V, variant: "rectangular", className: "MuiFormControl-root MuiFormControl-fullWidth header-skeleton" })), L), {}), [k.mapping])
  };
}, useWatchCountryCode = () => {
  const {
    required: T,
    validationSchema: S,
    setValidationSchema: R,
    formState: k,
    triggerValidation: D
  } = useFormContext(), L = k().currentState, {
    countryCode: V = "USA"
  } = L, z = useMemo(() => T ? getValidationSchema(V) : void 0, [V, T]);
  useEffect$1(() => {
    S && setTimeout(() => D());
  }, [S]), useEffect$1(() => {
    R(z);
  }, [z, R]);
}, AddressFields = () => {
  const {
    sections: T
  } = useAddressFieldSections(), {
    layout: S,
    ...R
  } = useFormContext(), {
    formState: k
  } = R, D = k().currentState, L = configs?.[D?.countryCode || "USA"];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { layout: L.layouts[S], children: Object.entries(T).map(([, V]) => V) });
}, SkeletonFields = () => {
  const {
    sections: T
  } = useSkeletonFieldsSection(), {
    layout: S,
    ...R
  } = useFormContext(), {
    formState: k
  } = R, D = k().currentState, L = configs?.[D?.countryCode || "USA"];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { layout: L.layouts[S], children: Object.entries(T).map(([, V]) => V) });
}, AddressForm = () => {
  const {
    isLoading: T
  } = useFormContext();
  return useWatchCountryCode(), useEmitChanges(), T ? /* @__PURE__ */ jsxRuntimeExports.jsx(SkeletonFields, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(AddressFields, {});
}, InternationalAddress = ({
  name: T,
  className: S,
  layout: R = "default",
  isLoading: k = !1,
  initialValue: D,
  enableReinitialize: L = !1,
  emitOnInitialValues: V = !0,
  onChange: z,
  field: W,
  form: U,
  formhandler: q,
  required: K,
  disabled: Y,
  ensureValid: J = !0,
  iso: Z = !0,
  action: X,
  address: ee
}) => {
  const te = U?.setFieldValue || q?.setFormValue, re = useCallback((Q) => {
    te ? W ? te(W.name, Q) : te({
      field: T,
      value: Q
    }) : z?.(Q);
  }, [W?.name, T, z]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormProvider, { className: S, onChange: re, layout: R, required: K, disabled: Y, isLoading: k, initialAddress: D, enableReinitialize: L, emitOnInitialValues: V, ensureValid: J, action: X, iso: Z, address: ee, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AddressForm, {}) });
};
InternationalAddress.propTypes = {
  name: Packages.PropTypes.string,
  className: Packages.PropTypes.string,
  layout: Packages.PropTypes.string,
  isLoading: Packages.PropTypes.bool,
  initialValue: Packages.PropTypes.any,
  enableReinitialize: Packages.PropTypes.bool,
  emitOnInitialValues: Packages.PropTypes.bool,
  onChange: Packages.PropTypes.func,
  action: Packages.PropTypes.shape({
    icon: Packages.PropTypes.elementType,
    onClick: Packages.PropTypes.func
  }),
  required: Packages.PropTypes.bool,
  disabled: Packages.PropTypes.bool,
  ensureValid: Packages.PropTypes.bool,
  iso: Packages.PropTypes.bool,
  form: Packages.PropTypes.object,
  formhandler: Packages.PropTypes.object,
  field: Packages.PropTypes.object,
  address: Packages.PropTypes.object
};
const IconContainer = Packages.emotion.styled(Packages.Mui.Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 50,
  height: 50
})), IconImage = Packages.emotion.styled(Packages.Mui.Box)(({
  icon: T
}) => ({
  width: T && !isHexColor(T) ? "2.1875rem" : "auto",
  height: T && !isHexColor(T) ? "2.375rem" : "auto",
  margin: T && !isHexColor(T) ? "0 0.75rem 0.375rem" : "0"
})), Typography$1 = Packages.emotion.styled(Packages.Mui.Typography)(({
  titlelength: T
}) => {
  const S = T > 8 ? 0.9375 : 1.1, R = S / 1;
  return {
    fontSize: `clamp(${S}rem, ${0.964 * R}rem + ${0.134 * R}vw, ${1.2 * R}rem)`,
    textAlign: "center",
    paddingLeft: "0.125rem",
    paddingRight: "0.125rem"
  };
}), TileTitle = ({
  title: T
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Typography$1, { titlelength: T?.length, variant: "h3", children: T });
TileTitle.propTypes = {
  title: Packages.PropTypes.string.isRequired
};
const __variableDynamicImportRuntimeHelper = (T, S, R) => {
  const k = T[S];
  return k ? typeof k == "function" ? k() : Promise.resolve(k) : new Promise((D, L) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(L.bind(null, new Error("Unknown variable dynamic import: " + S + (S.split("/").length !== R ? ". Note that variables only represent file names one level deep." : ""))));
  });
}, useLoadAppIcon = (T, S) => {
  const [R, k] = useState$1(null);
  return useEffect$1(() => {
    (async () => {
      if (S && !isHexColor(S))
        k(S);
      else
        try {
          const L = await __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "../../../../../core/assets/app-icons/apis.svg": () => import("./apis-CwPxQ2Qp.js"), "../../../../../core/assets/app-icons/assurance.svg": () => import("./assurance-CJ3UH9o8.js"), "../../../../../core/assets/app-icons/automation.svg": () => import("./automation-CNAlvkf6.js"), "../../../../../core/assets/app-icons/batch-exp.svg": () => import("./batch-exp-n4BHhdS8.js"), "../../../../../core/assets/app-icons/bulk-materials-exp.svg": () => import("./bulk-materials-exp-BbNDjeVc.js"), "../../../../../core/assets/app-icons/company-admin.svg": () => import("./company-admin-dU4fG8ly.js"), "../../../../../core/assets/app-icons/consumer-exp.svg": () => import("./consumer-exp-DRf0x9mi.js"), "../../../../../core/assets/app-icons/dispatch-exp.svg": () => import("./dispatch-exp-CGBhRUgp.js"), "../../../../../core/assets/app-icons/drum.svg": () => import("./drum-BDOb-R3g.js"), "../../../../../core/assets/app-icons/loadout.svg": () => import("./loadout-DOp-TzSd.js"), "../../../../../core/assets/app-icons/payments.svg": () => import("./payments-DBVxctgE.js"), "../../../../../core/assets/app-icons/qc.svg": () => import("./qc-CRk4J6jr.js"), "../../../../../core/assets/app-icons/sales-quote-exp.svg": () => import("./sales-quote-exp-2YZ-GAvS.js"), "../../../../../core/assets/app-icons/supply-exp.svg": () => import("./supply-exp-cVgcUWP0.js"), "../../../../../core/assets/app-icons/trackit-exp.svg": () => import("./trackit-exp-COmSiegM.js") }), `../../../../../core/assets/app-icons/${T}.svg`, 9);
          k(L.default);
        } catch {
          try {
            const L = await import("./tricon_circle-C98H_DdS.js");
            k(L.default);
          } catch {
            k(null);
          }
        }
    })();
  }, [T, S]), R;
}, TileIcon = ({
  variant: T,
  icon: S
}) => {
  const R = useLoadAppIcon(T, S);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IconContainer, { component: "div", children: R ? /* @__PURE__ */ jsxRuntimeExports.jsx(IconImage, { component: "img", alt: S ? "Custom logo" : T ? `${T} Logo` : "Default logo", src: R, icon: S }) : null });
};
TileIcon.propTypes = {
  variant: Packages.PropTypes.string,
  icon: Packages.PropTypes.string
};
const CATEGORIES = {
  category0: ["company-admin"],
  category1: ["dispatch-exp", "bulk-materials-exp"],
  category2: ["trackit-exp", "integrated-trucking-exp"],
  category3: ["loadout", "automation", "drum", "qc", "batch-exp", "assurance", "supply-exp"],
  category4: ["apis", "payments", "consumer-exp", "sales-quote-exp"]
}, STYLES_PER_CATEGORY = [
  // Category 0: Admin
  {
    gradient: getGradientBackground(colors.blue[150], colors.blue[160]),
    order: 0
  },
  // Category 1: Dispatching
  {
    gradient: getGradientBackground(colors.blue[75], colors.darkBlue[35]),
    order: 1
  },
  // Category 2: Trucking
  {
    gradient: getGradientBackground(colors.blue[110], colors.blue[120]),
    order: 2
  },
  // Category 3: Production and QC
  {
    gradient: getGradientBackground(colors.green[70], colors.green[110]),
    order: 3
  },
  // Category 4: Office
  {
    gradient: getGradientBackground(colors.orange[40], colors.orange[9]),
    order: 4
  }
], appGradientsAndOrder = Object.entries(CATEGORIES).reduce((T, [S, R]) => {
  const k = parseInt(S.replace("category", ""), 10);
  return R.forEach((D) => {
    T[D] = STYLES_PER_CATEGORY[k];
  }), T;
}, {}), dark$f = (T) => {
  const S = Object.fromEntries(Object.entries(appGradientsAndOrder).map(([R, {
    gradient: k
  }]) => [R, darkenGradient(k)]));
  return {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontWeight: T.typography.fontWeightSemiBold,
          color: T.colors.neutral[100]
        }
      }
    },
    MuiStack: {
      styleOverrides: {
        root: (R) => {
          const k = R.variant || R.name?.toLowerCase();
          let D = R.tilecolor ? getGradientBackground(R.tilecolor) : appGradientsAndOrder[k]?.gradient || T.colors.surface.tile[0];
          const L = appGradientsAndOrder[k]?.order;
          return {
            width: "103px",
            height: "103px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "0.9375rem",
            cursor: "pointer",
            boxShadow: T.shadow(9),
            border: `0.5px solid ${T.colors.neutral[90]}`,
            background: D,
            gap: "0.25rem",
            // Set order for tiles with custom colors, default tiles (with no color assigned) go at the end
            order: L !== void 0 ? L : R.tilecolor ? "98" : "99",
            "&:hover": {
              background: darkenGradient(D, 0.05, 0.1)
            },
            ...mediaQueries$3.xs(T),
            ...mediaQueries$3.sm(T),
            ...mediaQueries$3.md(T),
            ...mediaQueries$3.lg(T),
            ...mediaQueries$3.xl(T)
          };
        }
      },
      variants: Object.entries(appGradientsAndOrder).map(([R, {
        gradient: k
      }]) => ({
        props: {
          variant: R
        },
        style: {
          background: k,
          "&:hover": {
            background: S[R]
          }
        }
      })).concat(Object.entries(appGradientsAndOrder).map(([R, {
        gradient: k
      }]) => ({
        props: {
          name: R
        },
        style: {
          background: k,
          "&:hover": {
            background: S[R]
          }
        }
      })))
    }
  };
}, light$f = (T) => {
  const S = Object.fromEntries(Object.entries(appGradientsAndOrder).map(([R, {
    gradient: k
  }]) => [R, darkenGradient(k)]));
  return {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontWeight: T.typography.fontWeightSemiBold,
          color: T.colors.neutral[100]
        }
      }
    },
    MuiStack: {
      styleOverrides: {
        root: (R) => {
          const k = R.variant || R.name?.toLowerCase();
          let D = R.tilecolor ? getGradientBackground(R.tilecolor) : appGradientsAndOrder[k]?.gradient || T.colors.surface.tile[0];
          const L = appGradientsAndOrder[k]?.order;
          return {
            width: "103px",
            height: "103px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "0.9375rem",
            cursor: "pointer",
            boxShadow: T.shadow(9),
            border: `0.5px solid ${T.colors.neutral[90]}`,
            background: D,
            gap: "0.25rem",
            // Set order for tiles with custom colors, default tiles (with no color assigned) go at the end
            order: L !== void 0 ? L : R.tilecolor ? "98" : "99",
            "&:hover": {
              background: darkenGradient(D, 0.05, 0.1)
            },
            ...mediaQueries$3.xs(T),
            ...mediaQueries$3.sm(T),
            ...mediaQueries$3.md(T),
            ...mediaQueries$3.lg(T),
            ...mediaQueries$3.xl(T)
          };
        }
      },
      variants: Object.entries(appGradientsAndOrder).map(([R, {
        gradient: k
      }]) => ({
        props: {
          variant: R
        },
        style: {
          background: k,
          "&:hover": {
            background: S[R]
          }
        }
      })).concat(Object.entries(appGradientsAndOrder).map(([R, {
        gradient: k
      }]) => ({
        props: {
          name: R
        },
        style: {
          background: k,
          "&:hover": {
            background: S[R]
          }
        }
      })))
    }
  };
}, between$2 = () => ({}), lg$5 = () => ({}), md$5 = (T) => ({
  [T.breakpoints.up("md")]: {
    height: "6.875rem",
    width: "6.875rem"
  }
}), sm$5 = () => ({}), xl$5 = (T) => ({
  [T.breakpoints.up("xl")]: {
    width: "7.1875rem",
    height: "7.1875rem"
  }
}), xs$5 = (T) => ({
  [T.breakpoints.up("xs")]: {
    height: "105px",
    width: "105px"
  }
}), mediaQueries$3 = {
  xl: xl$5,
  lg: lg$5,
  md: md$5,
  sm: sm$5,
  xs: xs$5,
  between: between$2
}, LicenseTileThemeConfig = {
  dark: dark$f,
  light: light$f
}, BaseLicenseTile = (T) => {
  const {
    Stack: S
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(S, { ...T, onClick: T.onClick, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TileIcon, { variant: T.variant, icon: T.icon }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(TileTitle, { title: T.name })
  ] });
};
BaseLicenseTile.propTypes = {
  children: Packages.PropTypes.node,
  name: Packages.PropTypes.string.isRequired,
  onClick: Packages.PropTypes.func,
  variant: Packages.PropTypes.string,
  // String based on the crn (unique id) of each app
  icon: Packages.PropTypes.string,
  tilecolor: Packages.PropTypes.string
};
const LicenseTile = withThemeOverrides(BaseLicenseTile, LicenseTileThemeConfig), dark$e = (T) => ({
  MuiPickersYear: {
    styleOverrides: {
      yearButton: {
        "&&.Mui-selected": {
          backgroundColor: T.colors.blue[90]
        }
      }
    }
  },
  MuiPickersDay: {
    styleOverrides: {
      root: {
        "&&.Mui-selected": {
          backgroundColor: T.colors.blue[90]
        }
      }
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        "&.Mui-selected": {
          color: T.colors.blue[90],
          "&:focus": {
            color: T.colors.blue[90]
          }
        }
      },
      span: {
        backgroundColor: T.colors.blue[90],
        "&:focus": {
          backgroundColor: T.colors.blue[90]
        }
      }
    }
  },
  MuiTabs: {
    styleOverrides: {
      indicator: {
        backgroundColor: T.colors.blue[90],
        "&:focus": {
          backgroundColor: T.colors.blue[90]
        }
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: "10px"
      }
    }
  },
  MuiClockPointer: {
    styleOverrides: {
      root: {
        background: T.colors.blue[90]
      },
      thumb: {
        background: T.colors.neutral[87],
        border: `16px solid ${T.colors.blue[90]}`
      }
    }
  },
  MuiClock: {
    styleOverrides: {
      pin: {
        background: T.colors.blue[90]
      },
      clock: {
        background: T.colors.neutral[87]
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        "& button": {
          fontWeight: T.typography.fontWeightMedium,
          borderRadius: 100,
          color: T.colors.blue[90],
          fontFamily: T.typography.fontFamily,
          fontSize: "15px"
        }
      }
    }
  },
  MuiPickersPopper: {
    styleOverrides: {
      paper: {
        borderRadius: "10px"
      }
    }
  },
  MuiMultiSectionDigitalClockSection: {
    styleOverrides: {
      root: {
        "&::after": {
          height: "auto"
        }
      },
      item: {
        "&&.Mui-selected": {
          backgroundColor: T.colors.blue[90],
          borderRadius: "5px"
        }
      }
    }
  }
}), light$e = (T) => ({
  MuiPickersYear: {
    styleOverrides: {
      yearButton: {
        "&&.Mui-selected": {
          backgroundColor: T.colors.darkBlue[10]
        }
      }
    }
  },
  MuiPickersDay: {
    styleOverrides: {
      root: {
        "&&.Mui-selected": {
          backgroundColor: T.colors.darkBlue[10]
        }
      }
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        "&.Mui-selected": {
          color: T.colors.darkBlue[10],
          "&:focus": {
            color: T.colors.darkBlue[10]
          }
        }
      },
      span: {
        backgroundColor: T.colors.darkBlue[10],
        "&:focus": {
          backgroundColor: T.colors.darkBlue[10]
        }
      }
    }
  },
  MuiTabs: {
    styleOverrides: {
      indicator: {
        backgroundColor: T.colors.darkBlue[10],
        "&:focus": {
          backgroundColor: T.colors.darkBlue[10]
        }
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: "10px"
      }
    }
  },
  MuiClockPointer: {
    styleOverrides: {
      root: {
        background: T.colors.darkBlue[10]
      },
      thumb: {
        background: T.colors.neutral[100],
        border: `16px solid ${T.colors.darkBlue[10]}`
      }
    }
  },
  MuiClock: {
    styleOverrides: {
      pin: {
        background: T.colors.darkBlue[10]
      },
      clock: {
        background: T.colors.neutral[95]
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        "& button": {
          fontWeight: T.typography.fontWeightMedium,
          borderRadius: 100,
          color: T.colors.darkBlue[10],
          ffontFamily: T.typography.fontFamily,
          fontSize: "15px"
        }
      }
    }
  },
  MuiPickersPopper: {
    styleOverrides: {
      paper: {
        borderRadius: "10px"
      }
    }
  },
  MuiMultiSectionDigitalClockSection: {
    styleOverrides: {
      root: {
        "&::after": {
          height: "auto"
        }
      },
      item: {
        "&&.Mui-selected": {
          backgroundColor: T.colors.darkBlue[10],
          borderRadius: "5px"
        }
      }
    }
  }
}), DateTimeFieldThemeConfig = {
  dark: dark$e,
  light: light$e
}, BaseDateTimeField$1 = ({
  format: T = 12,
  ...S
}) => {
  const {
    AdapterDayjs: R,
    LocalizationProvider: k
  } = Packages["@mui/x-date-pickers"], {
    DesktopDateTimePicker: D
  } = Packages["@mui/x-date-pickers-pro"], {
    dayjs: L
  } = Packages["dayjs-pkg"], {
    FormattedMessage: V
  } = LocalizationProvider(), z = useRef(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(k, { dateAdapter: R, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    D,
    {
      ...S,
      ref: z,
      label: /* @__PURE__ */ jsxRuntimeExports.jsx(V, { id: S.token }),
      value: S.value ? L(S.value) : L(),
      closeOnSelect: !1,
      ...T && {
        ampm: T === 12
      },
      timeSteps: {
        hours: 1,
        minutes: 1
      }
    }
  ) });
};
BaseDateTimeField$1.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  value: Packages.PropTypes.string,
  format: Packages.PropTypes.number,
  onChange: Packages.PropTypes.func
};
const DesktopDateTimeField = withBaseField(withThemeOverrides(BaseDateTimeField$1, DateTimeFieldThemeConfig), "DateTimeField"), BaseDateTimeField = ({
  format: T = 12,
  ...S
}) => {
  const {
    InputAdornment: R
  } = Packages.Mui, {
    AdapterDayjs: k,
    LocalizationProvider: D
  } = Packages["@mui/x-date-pickers"], {
    MobileDateTimePicker: L
  } = Packages["@mui/x-date-pickers-pro"], {
    dayjs: V
  } = Packages["dayjs-pkg"], {
    FormattedMessage: z
  } = LocalizationProvider(), W = useRef(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(D, { dateAdapter: k, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    L,
    {
      ...S,
      ref: W,
      label: /* @__PURE__ */ jsxRuntimeExports.jsx(z, { id: S.token }),
      value: S.value ? V(S.value) : V(),
      closeOnSelect: !1,
      ...T && {
        ampm: T === 12
      },
      slotProps: {
        textField: {
          InputProps: {
            endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(R, { position: "end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "event" }) })
          }
        }
      }
    }
  ) });
};
BaseDateTimeField.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  value: Packages.PropTypes.string,
  format: Packages.PropTypes.number,
  onChange: Packages.PropTypes.func
};
const MobileDateTimeField = withBaseField(withThemeOverrides(BaseDateTimeField, DateTimeFieldThemeConfig), "DateTimeField"), DateTimeField = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    case "mobile":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(MobileDateTimeField, { ...S });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopDateTimeField, { ...S });
  }
};
DateTimeField.propTypes = {
  variant: Packages.PropTypes.oneOf(["desktop", "mobile"]).isRequired
};
const dark$d = (T) => ({
  MuiRadio: {
    styleOverrides: {
      root: {
        color: `${T.colors.blue[90]} !important`
      }
    }
  },
  MuiTypography: {
    styleOverrides: {
      root: {
        color: T.colors.neutral[95]
      }
    }
  },
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        margin: 0
      }
    }
  }
}), light$d = (T) => ({
  MuiRadio: {
    styleOverrides: {
      root: {
        "&.Mui-checked": {
          color: T.colors.darkBlue[50]
        },
        "&.Mui-disabled": {
          color: T.colors.neutral[90]
        },
        "&:hover, &:focus": {
          background: T.surface(3)
        }
      }
    }
  },
  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        margin: 0
      }
    }
  }
}), RadioButtonThemeConfig = {
  dark: dark$d,
  light: light$d
}, BaseRadioButton = ({
  options: T,
  ...S
}) => {
  const {
    RadioGroup: R,
    FormControlLabel: k,
    Radio: D,
    Stack: L,
    InputAdornment: V
  } = Packages.Mui, {
    FormattedMessage: z
  } = LocalizationProvider();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(R, { defaultValue: T[0].value, ...S, children: T.map(({
    label: W,
    value: U,
    description: q = void 0
  }) => /* @__PURE__ */ jsxRuntimeExports.jsx(k, { control: /* @__PURE__ */ jsxRuntimeExports.jsx(D, {}), value: U, label: q ? /* @__PURE__ */ jsxRuntimeExports.jsxs(L, { direction: "row", gap: 1, justifyContent: "center", alignItems: "center", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(z, { id: W }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { token: q, render: () => /* @__PURE__ */ jsxRuntimeExports.jsx(V, { position: "end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "info-outlined" }) }), placement: "right" })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(z, { id: W }) }, U)) });
};
BaseRadioButton.propTypes = {
  options: Packages.PropTypes.arrayOf(Packages.PropTypes.shape({
    label: Packages.PropTypes.string.isRequired,
    value: Packages.PropTypes.string.isRequired,
    description: Packages.PropTypes.string
  })).isRequired
};
const RadioButton = withBaseField(withThemeOverrides(BaseRadioButton, RadioButtonThemeConfig), "RadioButton"), dark$c = (T) => ({
  ...TextFieldThemeConfig.dark(resources("dark")),
  MuiTextField: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          disabled: R,
          variant: k
        } = S.ownerState;
        return {
          svg: {
            pointerEvents: "none",
            color: T.colors.neutral[100],
            ...k === "filled" && {
              color: T.colors.blue[95]
            },
            ...R && {
              color: T.colors.neutral[80]
            }
          },
          ".infoOutlined-icon": {
            position: "absolute",
            right: "35px",
            svg: {
              pointerEvents: R ? "none" : "auto"
            }
          },
          ".cancelOutlined-icon": {
            display: "none",
            cursor: "pointer",
            pointerEvents: "auto",
            position: "absolute",
            right: "70px"
          },
          "&:hover .cancelOutlined-icon": {
            display: "block !important"
          }
        };
      }
    }
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        maxHeight: "335px",
        ...breakpoints$1.xl(T)
      }
    }
  }
}), light$c = (T) => ({
  ...TextFieldThemeConfig.light(resources("light")),
  MuiTextField: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          disabled: R,
          variant: k
        } = S.ownerState;
        return {
          svg: {
            pointerEvents: "none",
            color: T.colors.neutral[40],
            ...k === "filled" && {
              color: T.colors.blue[95]
            },
            ...R && {
              color: T.colors.neutral[80]
            }
          },
          ".infoOutlined-icon": {
            position: "absolute",
            right: "35px",
            svg: {
              pointerEvents: R ? "none" : "auto"
            }
          },
          ".cancelOutlined-icon": {
            display: "none",
            cursor: "pointer",
            pointerEvents: "auto",
            position: "absolute",
            right: "70px"
          },
          "&:hover .cancelOutlined-icon": {
            display: "block !important"
          }
        };
      }
    }
  },
  MuiMenu: {
    styleOverrides: {
      paper: {
        maxHeight: "335px",
        ...breakpoints$1.xl(T)
      }
    }
  }
}), lg$4 = () => {
}, md$4 = () => {
}, sm$4 = () => {
}, xl$4 = (T) => ({
  [T.breakpoints.down("sm")]: {
    maxHeight: "450px"
  }
}), xs$4 = () => {
}, breakpoints$1 = {
  lg: lg$4,
  md: md$4,
  sm: sm$4,
  xl: xl$4,
  xs: xs$4
}, SelectFieldThemeConfig = {
  dark: dark$c,
  light: light$c
}, SelectFieldUtil = ({
  rest: T,
  isClearable: S,
  tooltipToken: R
}) => {
  const {
    InputAdornment: k
  } = Packages.Mui, D = S && /* @__PURE__ */ jsxRuntimeExports.jsx(k, { position: "end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "cancel-outlined", className: "cancelOutlined-icon", onClick: () => {
    T.onChange({
      target: {
        value: ""
      }
    });
  } }) }), L = R && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { token: R, render: () => /* @__PURE__ */ jsxRuntimeExports.jsx(k, { position: "end", className: "infoOutlined-icon", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "info-outlined" }) }), placement: "top", slotProps: {
    popper: {
      modifiers: [{
        name: "offset",
        options: {
          offset: [0, 10]
        }
      }]
    }
  } }), V = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    D,
    T?.InputProps?.endAdornment,
    L
  ] });
  return {
    ...T.InputProps,
    endAdornment: V
  };
}, BaseSelectField = ({
  tooltipToken: T,
  disableClearable: S,
  ...R
}) => {
  const {
    FormattedMessage: k,
    useIntl: D
  } = LocalizationProvider(), L = D(), {
    TextField: V,
    MenuItem: z
  } = Packages.Mui, W = R.value && !S && !R.disabled, U = SelectFieldUtil({
    rest: R,
    isClearable: W,
    tooltipToken: T
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(V, { ...R, label: /* @__PURE__ */ jsxRuntimeExports.jsx(k, { id: R.token }), error: R.formhandler?.fieldState(R.name).invalid ?? R.error, helperText: R.formhandler?.fieldState(R.name).error ?? R.helperText, InputProps: U, select: !0, fullWidth: !0, children: R.options?.map((q) => /* @__PURE__ */ jsxRuntimeExports.jsx(z, { value: q.value, children: q?.translationKey ? L.formatMessage({
    id: q.translationKey
  }) : q.label }, q.value)) });
};
BaseSelectField.propTypes = {
  tooltipToken: Packages.PropTypes.string,
  disableClearable: Packages.PropTypes.bool,
  value: Packages.PropTypes.any,
  disabled: Packages.PropTypes.bool,
  error: Packages.PropTypes.bool,
  formhandler: Packages.PropTypes.object,
  name: Packages.PropTypes.string,
  helperText: Packages.PropTypes.string,
  options: Packages.PropTypes.arrayOf(Packages.PropTypes.shape({
    value: Packages.PropTypes.any.isRequired,
    label: Packages.PropTypes.string.isRequired,
    translationKey: Packages.PropTypes.string
  }))
};
const SelectField = withBaseField(withThemeOverrides(BaseSelectField, SelectFieldThemeConfig), "SelectField"), CancelOutlinedIcon = Packages.emotion.styled(IconsMaterial.CancelOutlined)(() => ({
  /**
   * This will work alongside the definition for the svg in src/components/input/text-field/theme/light.js.
   *
   * NOTE: The Cancel button should be rendered 'on hover' over the input if it has a value.
   */
  display: "none"
})), TextFieldUtil = (T, S) => {
  const {
    InputAdornment: R
  } = Packages.Mui, k = /* @__PURE__ */ jsxRuntimeExports.jsxs(R, { position: "end", children: [
    T.value && /* @__PURE__ */ jsxRuntimeExports.jsx(CancelOutlinedIcon, { ...T, onClick: () => {
      T.onChange({
        target: {
          value: ""
        }
      });
    } }),
    S && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { token: S, render: () => /* @__PURE__ */ jsxRuntimeExports.jsx(R, { position: "end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "info-outlined" }) }), placement: "top", slotProps: {
      popper: {
        modifiers: [{
          name: "offset",
          // To adjust the distance between the tooltip and its anchor,
          options: {
            offset: [0, 10]
          }
        }]
      }
    } })
  ] }), D = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    k,
    T?.InputProps?.endAdornment
  ] });
  return {
    InputProps: {
      ...T.InputProps,
      endAdornment: D()
    }
  };
}, TextField$2 = ({
  tooltipToken: T,
  ...S
}) => {
  const R = useRef(null), {
    FormattedMessage: k
  } = LocalizationProvider(), {
    InputProps: D
  } = TextFieldUtil(S, T), {
    TextField: L
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(L, { InputProps: D, ...S, ref: R, autoComplete: "off", label: /* @__PURE__ */ jsxRuntimeExports.jsx(k, { id: S.token, defaultMessage: S.defaultMessage, values: S.values }), error: S.formhandler?.fieldState(S.name).invalid ?? S.error, helperText: S.formhandler?.fieldState(S.name).error ?? S.helperText, fullWidth: !0 });
};
TextField$2.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object,
  formhandler: Packages.PropTypes.object,
  helperText: Packages.PropTypes.string,
  name: Packages.PropTypes.string,
  error: Packages.PropTypes.bool,
  InputProps: Packages.PropTypes.object,
  tooltipToken: Packages.PropTypes.string
};
const BaseTextField = withBaseField(TextField$2, "TextField"), SearchTextField = (T) => {
  const {
    InputAdornment: S
  } = Packages.Mui, {
    useIntl: R
  } = LocalizationProvider(), k = R();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseTextField, { ...T, placeholder: k.formatMessage({
    id: T.token,
    defaultMessage: T.defaultMessage
  }, {
    values: T.values
  }), InputProps: {
    startAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { position: "start", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "search-rounded" }) })
  }, fullWidth: !0 });
};
SearchTextField.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object
};
const TextField$1 = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    case "search":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(SearchTextField, { ...S });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseTextField, { ...S });
  }
};
TextField$1.propTypes = {
  variant: Packages.PropTypes.oneOf(["default", "search"])
};
const dark$b = (T) => ({
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        fontSize: "22px",
        color: T.colors.neutral[100]
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        background: T.surface(3),
        "&.MuiPickersPopper-paper": {
          borderRadius: "10px"
        }
      }
    }
  },
  MuiPickersArrowSwitcher: {
    styleOverrides: {
      root: {
        display: "none"
      }
    }
  },
  MuiClock: {
    styleOverrides: {
      root: {
        margin: "auto",
        width: "330px"
      },
      pin: {
        background: T.colors.blue[90]
      },
      clock: {
        width: "256px",
        height: "256px",
        background: T.colors.neutral[87]
      }
    }
  },
  MuiClockNumber: {
    styleOverrides: {
      root: {
        height: "70px",
        width: "35px",
        fontFamily: T.typography.fontFamily,
        color: T.colors.neutral[90]
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      paper: (S) => {
        const R = S?.ownerState?.children?.props?.children?.props, {
          isLandscape: k
        } = R;
        return k ? {
          borderRadius: "10px",
          width: "572px",
          height: "384px",
          "& > div > div > :nth-child(2)": {
            marginTop: "45px"
          }
        } : {
          borderRadius: "10px",
          width: "330px",
          height: "520px"
        };
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        "& button": {
          width: "12px",
          fontWeight: T.typography.fontWeightMedium,
          borderRadius: 100,
          color: T.colors.blue[80],
          fontFamily: T.typography.fontFamily,
          fontSize: "15px",
          "&:hover, &:focus, &:active ": {
            background: T.surface(1)
          }
        }
      }
    }
  },
  MuiClockPointer: {
    styleOverrides: {
      root: {
        background: T.colors.blue[90]
      },
      thumb: {
        background: T.colors.neutral[100],
        border: `16px solid ${T.colors.blue[90]}`
      }
    }
  },
  MuiPickersToolbar: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const R = S?.ownerState || {};
        return {
          ...R?.isLandscape && {
            marginLeft: "12px",
            marginRight: "48px"
          },
          ...!R?.isLandscape && {
            marginBottom: "25px"
          },
          "& > span": {
            fontFamily: T.typography.fontFamily,
            fontSize: "12px",
            textTransform: "none",
            letterSpacing: "0.5px",
            fontWeight: T.typography.fontWeightMedium,
            marginBottom: "10px",
            color: T.colors.neutral[95]
          }
        };
      },
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      content: (S) => {
        const R = S?.ownerState?.children[0]?.props?.ownerState;
        return {
          height: "80px",
          "& div:nth-child(1)": {
            width: "216px",
            height: "inherit",
            margin: "auto",
            marginBottom: R?.isLandscape && R?.ampm && "15px",
            "span.Mui-selected": {
              background: T.colors.darkBlue[60],
              borderRadius: "8px",
              width: "inherit",
              height: "inherit",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            "& > :nth-child(1)": {
              background: T.colors.neutral[87],
              width: "96px",
              height: "inherit",
              borderRadius: "8px"
            },
            "& > :nth-child(2)": {
              width: "24px",
              height: "inherit",
              margin: 0,
              display: "grid",
              placeContent: "center"
            },
            "& > :nth-child(3)": {
              background: T.colors.neutral[87],
              height: "inherit",
              width: "96px",
              borderRadius: "8px"
            }
          },
          "& div:nth-child(2)": {
            width: R?.isLandscape ? "216px" : "52px",
            border: `1px solid ${T.colors.neutral[88]}`,
            borderRadius: "8px",
            "span.Mui-selected": {
              background: T.colors.darkBlue[60],
              borderRadius: "inherit",
              width: "inherit",
              height: "inherit",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            "& > :nth-child(1)": {
              background: T.surface(3),
              width: "inherit",
              height: "38px",
              borderRight: R?.isLandscape && `1px solid ${T.colors.neutral[88]}`,
              borderBottom: !R?.isLandscape && `1px solid ${T.colors.neutral[88]}`,
              borderTopLeftRadius: "8px",
              borderTopRightRadius: R?.isLandscape ? 0 : "8px",
              borderBottomLeftRadius: R?.isLandscape ? "8px" : 0,
              borderBottomRightRadius: 0,
              "&:hover, &:focus, &:active ": {
                background: T.colors.darkBlue[60]
              }
            },
            "& > :nth-child(2)": {
              background: T.surface(3),
              width: "inherit",
              height: "38px",
              borderTopLeftRadius: 0,
              borderTopRightRadius: R?.isLandscape ? "8px" : 0,
              borderBottomLeftRadius: R?.isLandscape ? 0 : "8px",
              borderBottomRightRadius: "8px"
            }
          }
        };
      }
    }
  },
  MuiMultiSectionDigitalClockSection: {
    styleOverrides: {
      root: {
        "::after": {
          height: "auto"
        }
      },
      item: {
        "&.Mui-selected": {
          fontWeight: T.typography.fontWeightMedium,
          backgroundColor: T.colors.blue[90],
          "&:hover, &:active": {
            backgroundColor: T.colors.blue[90]
          }
        },
        borderRadius: "5px",
        fontWeight: 400
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          height: "48px",
          "& svg": {
            ...R.error && {
              color: T.colors.red[80]
            },
            ...R.disabled && {
              color: T.colors.neutral[30]
            }
          },
          ...R.variant === "outlined" && {
            lineHeight: 1
          }
        };
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          variant: R,
          formControl: k
        } = S.ownerState;
        return {
          color: T.colors.neutral[100],
          ...k.error && {
            color: T.colors.red[80],
            "&.Mui-hover": {
              color: T.colors.red[80]
            },
            "&.Mui-focused": {
              color: T.colors.red[80]
            }
          },
          ...R === "outlined" && {
            lineHeight: 1,
            "&.Mui-focused": {
              color: k.error ? T.colors.red[80] : T.colors.blue[95]
            },
            "&.Mui-disabled": {
              color: T.colors.neutral[30]
            }
          },
          ...R === "filled" && {
            "&.Mui-focused": {
              color: k.error ? T.colors.red[80] : T.colors.neutral[30]
            }
          }
        };
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => ({
        height: 20,
        ...S.ownerState["data-shrink"] && {
          fontWeight: T.typography.fontWeightSemiBold
        }
      })
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          /**
           * This approach was inferred from StackOverflow
           *
           * Reference: https://stackoverflow.com/questions/52911169/how-to-change-the-border-color-of-material-ui-textfield
           */
          "&.Mui-hover fieldset": {
            borderColor: `${T.colors.blue[90]} !important`,
            ...R.disabled && {
              borderColor: "rgba(255, 255, 255, 0.3) !important",
              borderWidth: "1px"
            },
            ...R.error && {
              borderColor: `${T.colors.red[80]} !important`
            }
          },
          "&.Mui-focused": {
            ...R.error && {
              borderColor: `${T.colors.red[80]} !important`,
              borderWidth: "2px"
            }
          },
          "&.Mui-disabled": {
            borderColor: `${T.colors.neutral[30]} !important`,
            borderWidth: "1px"
          }
        };
      },
      notchedOutline: {
        borderColor: T.colors.neutral[100]
      }
    }
  }
}), light$b = (T) => ({
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        fontSize: "22px",
        color: T.colors.neutral[40]
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        "&.MuiPickersPopper-paper": {
          borderRadius: "10px"
        }
      }
    }
  },
  MuiPickersArrowSwitcher: {
    styleOverrides: {
      root: {
        display: "none"
      }
    }
  },
  MuiClock: {
    styleOverrides: {
      root: {
        margin: 0,
        width: "330px"
      },
      pin: {
        background: T.colors.darkBlue[10]
      },
      clock: {
        width: "256px",
        height: "256px",
        background: T.colors.neutral[95]
      }
    }
  },
  MuiClockNumber: {
    styleOverrides: {
      root: {
        height: "70px",
        width: "35px",
        fontFamily: T.typography.fontFamily,
        color: T.colors.neutral[40]
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      paper: (S) => {
        const R = S.ownerState.children.props.children.props, {
          isLandscape: k
        } = R;
        return k ? {
          borderRadius: "10px",
          width: "572px",
          height: "384px",
          "& > div > div > :nth-child(2)": {
            marginTop: "45px"
          }
        } : {
          borderRadius: "10px",
          width: "330px",
          height: "520px"
        };
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        "& button": {
          width: "12px",
          fontWeight: T.typography.fontWeightMedium,
          borderRadius: 100,
          color: T.colors.darkBlue[10],
          fontFamily: T.typography.fontFamily,
          fontSize: "15px"
        }
      }
    }
  },
  MuiClockPointer: {
    styleOverrides: {
      root: {
        background: T.colors.darkBlue[10]
      },
      thumb: {
        background: T.colors.neutral[100],
        border: `16px solid ${T.colors.darkBlue[10]}`
      }
    }
  },
  MuiPickersToolbar: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const R = S?.ownerState || {};
        return {
          ...R?.isLandscape && {
            marginLeft: "12px",
            marginRight: "48px"
          },
          ...!R?.isLandscape && {
            marginBottom: "25px"
          },
          "& > span": {
            fontFamily: T.typography.fontFamily,
            fontSize: "12px",
            textTransform: "none",
            letterSpacing: "0.5px",
            fontWeight: T.typography.fontWeightMedium,
            marginBottom: "10px"
          }
        };
      },
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      content: (S) => {
        const R = S?.ownerState?.children[0]?.props?.ownerState;
        return {
          height: "80px",
          "& div:nth-child(1)": {
            width: "216px",
            height: "inherit",
            margin: "auto",
            marginBottom: R?.isLandscape && R?.ampm && "15px",
            "span.Mui-selected": {
              background: T.colors.blue[95],
              borderRadius: "8px",
              width: "inherit",
              height: "inherit",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            "& > :nth-child(1)": {
              background: T.colors.neutral[95],
              width: "96px",
              height: "inherit",
              borderRadius: "8px"
            },
            "& > :nth-child(2)": {
              width: "24px",
              height: "inherit",
              margin: 0,
              display: "grid",
              placeContent: "center"
            },
            "& > :nth-child(3)": {
              background: T.colors.neutral[95],
              height: "inherit",
              width: "96px",
              borderRadius: "8px"
            }
          },
          "& div:nth-child(2)": {
            width: R?.isLandscape ? "216px" : "52px",
            border: `1px solid ${T.colors.neutral[88]}`,
            borderRadius: "8px",
            "span.Mui-selected": {
              background: T.colors.blue[95],
              borderRadius: "inherit",
              width: "inherit",
              height: "inherit",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            "& > :nth-child(1)": {
              background: T.colors.neutral[100],
              width: "inherit",
              height: "38px",
              boxSizing: "initial",
              borderRight: R?.isLandscape && `1px solid ${T.colors.neutral[88]}`,
              borderBottom: !R?.isLandscape && `1px solid ${T.colors.neutral[88]}`,
              borderTopLeftRadius: "8px",
              borderTopRightRadius: R?.isLandscape ? 0 : "8px",
              borderBottomLeftRadius: R?.isLandscape ? "8px" : 0,
              borderBottomRightRadius: 0
            },
            "& > :nth-child(2)": {
              background: T.colors.neutral[100],
              width: "inherit",
              height: "38px",
              borderTopLeftRadius: 0,
              borderTopRightRadius: R?.isLandscape ? "8px" : 0,
              borderBottomLeftRadius: R?.isLandscape ? 0 : "8px",
              borderBottomRightRadius: "8px"
            }
          }
        };
      }
    }
  },
  MuiMultiSectionDigitalClockSection: {
    styleOverrides: {
      root: {
        "::after": {
          height: "auto"
        }
      },
      item: {
        "&.Mui-selected": {
          color: T.colors.neutral[100],
          backgroundColor: T.colors.darkBlue[10],
          fontWeight: T.typography.fontWeightMedium,
          "&:hover, &:focus": {
            backgroundColor: T.colors.darkBlue[10]
          }
        },
        color: T.colors.neutral[0],
        backgroundColor: T.colors.neutral[100],
        borderRadius: "5px",
        fontWeight: T.typography.fontWeightRegular
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          height: "48px",
          "& svg": {
            ...R.error && {
              color: T.colors.red[60]
            },
            ...R.disabled && {
              color: T.colors.neutral[80]
            }
          },
          ...R.variant === "outlined" && {
            lineHeight: 1,
            "&.Mui-disabled": {
              color: T.colors.neutral[80]
            }
          }
        };
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          variant: R,
          formControl: k
        } = S.ownerState;
        return {
          color: T.colors.neutral[30],
          ...R === "outlined" && {
            lineHeight: 1,
            "&.Mui-focused": {
              color: k.error ? T.colors.red[50] : T.colors.darkBlue[50],
              fontWeight: 600
            }
          },
          ...R === "filled" && {
            "&.Mui-focused": {
              color: k.error ? T.colors.red[50] : T.colors.neutral[30],
              fontWeight: 600
            },
            "&.Mui-disabled": {
              color: T.colors.neutral[80]
            }
          }
        };
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => ({
        height: 20,
        ...S.ownerState["data-shrink"] && {
          fontWeight: T.typography.fontWeightSemiBold
        }
      })
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          /**
           * This approach was inferred from StackOverflow
           *
           * Reference: https://stackoverflow.com/questions/52911169/how-to-change-the-border-color-of-material-ui-textfield
           */
          "&:hover fieldset": {
            borderColor: `${T.colors.darkBlue[50]} !important`,
            ...R.disabled && {
              borderColor: "rgba(0, 0, 0, 0.26) !important"
            },
            ...R.error && {
              borderColor: `${T.colors.red[50]} !important`
            }
          },
          "&.Mui-focused": {
            borderColor: `${T.colors.darkBlue[50]} !important`,
            borderWidth: "2px",
            ...R.error && {
              borderColor: `${T.colors.red[50]} !important`,
              borderWidth: "2px"
            }
          },
          "&.Mui-disabled": {
            borderColor: `${T.colors.neutral[80]} !important`,
            borderWidth: "1px"
          }
        };
      },
      notchedOutline: {
        borderColor: T.colors.neutral[60]
      }
    }
  }
}), TimeFieldThemeConfig = {
  dark: dark$b,
  light: light$b
};
Packages["dayjs-pkg"].dayjs.extend(Packages["dayjs-pkg"].plugin.utc);
Packages["dayjs-pkg"].dayjs.extend(Packages["dayjs-pkg"].plugin.timezone);
const BaseTimeField$1 = ({
  token: T,
  value: S,
  format: R = 12,
  defaultTime: k,
  ...D
}) => {
  const {
    FormattedMessage: L
  } = LocalizationProvider(), {
    DesktopTimePicker: V,
    AdapterDayjs: z,
    LocalizationProvider: W
  } = Packages["@mui/x-date-pickers"], {
    dayjs: U
  } = Packages["dayjs-pkg"];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(W, { dateAdapter: z, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    V,
    {
      ...D,
      value: S !== "" && k ? U(S) : null,
      label: /* @__PURE__ */ jsxRuntimeExports.jsx(L, { id: T }),
      error: D.formhandler?.fieldState(D.name).invalid ?? D.error,
      helperText: D.formhandler?.fieldState(D.name).error ?? D.helperText,
      ...R && {
        ampm: R === 12
      },
      shouldRespectLeadingZeros: !0,
      timeSteps: {
        hours: 1,
        minutes: 1
      },
      closeOnSelect: !1
    }
  ) });
};
BaseTimeField$1.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  value: Packages.PropTypes.string,
  format: Packages.PropTypes.number,
  defaultTime: Packages.PropTypes.bool,
  formhandler: Packages.PropTypes.object,
  helperText: Packages.PropTypes.string,
  name: Packages.PropTypes.string,
  error: Packages.PropTypes.bool
};
const DesktopTimeField = withBaseField(withThemeOverrides(BaseTimeField$1, TimeFieldThemeConfig), "TimeField");
Packages["dayjs-pkg"].dayjs.extend(Packages["dayjs-pkg"].plugin.utc);
Packages["dayjs-pkg"].dayjs.extend(Packages["dayjs-pkg"].plugin.timezone);
const BaseTimeField = ({
  token: T,
  value: S,
  format: R = 12,
  defaultTime: k,
  ...D
}) => {
  const {
    FormattedMessage: L
  } = LocalizationProvider(), {
    MobileTimePicker: V,
    AdapterDayjs: z,
    LocalizationProvider: W
  } = Packages["@mui/x-date-pickers"], {
    dayjs: U
  } = Packages["dayjs-pkg"], {
    InputAdornment: q
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(W, { dateAdapter: z, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    V,
    {
      ...D,
      value: S !== "" && k ? U(S) : null,
      label: /* @__PURE__ */ jsxRuntimeExports.jsx(L, { id: T }),
      error: D.formhandler?.fieldState(D.name).invalid ?? D.error,
      helperText: D.formhandler?.fieldState(D.name).error ?? D.helperText,
      ...R && {
        ampm: R === 12
      },
      shouldRespectLeadingZeros: !0,
      slotProps: {
        textField: {
          InputProps: {
            endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(q, { position: "end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "access-time" }) })
          }
        }
      }
    }
  ) });
};
BaseTimeField.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  value: Packages.PropTypes.string,
  format: Packages.PropTypes.number,
  defaultTime: Packages.PropTypes.bool,
  formhandler: Packages.PropTypes.object,
  helperText: Packages.PropTypes.string,
  name: Packages.PropTypes.string,
  error: Packages.PropTypes.bool
};
const MobileTimeField = withBaseField(withThemeOverrides(BaseTimeField, TimeFieldThemeConfig), "TimeField"), TimeField = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    case "desktop":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopTimeField, { ...S });
    case "mobile":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(MobileTimeField, { ...S });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(DesktopTimeField, { ...S });
  }
};
TimeField.propTypes = {
  variant: Packages.PropTypes.oneOf(["desktop", "mobile"]).isRequired
};
const BasePhoneInputField$2 = Packages.emotion.styled(Packages.PhoneInput)(({
  disabled: T,
  isInputFocused: S,
  hover: R,
  error: k
}) => {
  const D = Packages.Mui.useTheme();
  return {
    ".special-label": {
      fontFamily: D.typography.fontFamily,
      left: "13px",
      top: "-10px",
      fontSize: "12.5px",
      color: D.validateMode({
        light: D.colors.neutral[10],
        dark: D.colors.neutral[95]
      }),
      ...R && {
        color: D.validateMode({
          light: D.colors.darkBlue[50],
          dark: D.colors.blue[90]
        })
      },
      ...k && {
        color: D.validateMode({
          light: D.colors.red[60],
          dark: D.colors.red[80]
        })
      },
      ...S && {
        color: D.validateMode({
          light: D.colors.darkBlue[50],
          dark: D.colors.blue[95]
        })
      },
      ...T && {
        color: D.colors.neutral[70]
      },
      background: D.validateMode({
        light: D.colors.neutral[100],
        dark: D.colors.purple[80]
      }),
      fontWeight: D.typography.fontWeightSemiBold
    },
    ".form-control": {
      width: "100% !important",
      height: 48,
      border: `1px solid ${D.validateMode({
        light: D.colors.neutral[60],
        dark: D.colors.neutral[100]
      })}`,
      ...k && {
        border: `1px solid ${D.validateMode({
          light: D.colors.red[60],
          dark: D.colors.red[80]
        })}`
      },
      padding: "19.5px 14px 19.5px 80px",
      fontFamily: D.typography.fontFamily,
      color: D.validateMode({
        light: D.colors.neutral[40],
        dark: D.colors.neutral[100]
      }),
      background: D.validateMode({
        light: D.colors.neutral[100],
        dark: D.colors.purple[80]
      }),
      "&:disabled": {
        opacity: 0.38
      },
      "&:hover": {
        border: `1px solid ${D.validateMode({
          light: D.colors.darkBlue[50],
          dark: D.colors.blue[90]
        })}`,
        ...k && {
          border: `1px solid ${D.validateMode({
            light: D.colors.red[60],
            dark: D.colors.red[80]
          })}`
        }
      },
      "&:focus": {
        border: D.validateMode({
          light: `2px solid ${D.colors.darkBlue[50]}`,
          dark: `2px solid ${D.colors.blue[95]}`
        }),
        boxShadow: "none"
      }
    },
    ".country-list": {
      fontFamily: D.typography.fontFamily,
      width: 406,
      color: D.validateMode({
        light: D.colors.neutral[0],
        dark: D.colors.neutral[100]
      }),
      background: D.validateMode({
        light: D.colors.neutral[100],
        dark: D.colors.purple[80]
      }),
      "& .country .dial-code": {
        color: D.validateMode({
          light: `${D.colors.neutral[70]} !important`,
          dark: `${D.colors.neutral[60]} !important`
        })
      },
      "& .country:hover": {
        background: D.validateMode({
          light: D.colors.neutral[99],
          dark: D.colors.neutral[30]
        })
      },
      "& .country.highlight": {
        background: D.validateMode({
          light: D.colors.blue[95],
          dark: D.colors.darkBlue[60]
        })
      }
    },
    ".selected-flag": {
      padding: "0 0 0 19px",
      ".arrow": {
        left: "40px",
        borderBottomColor: D.validateMode({
          light: `${D.colors.neutral[0]} !important`,
          dark: `${D.colors.neutral[99]} !important`
        }),
        borderTopColor: D.validateMode({
          light: `${D.colors.neutral[0]} !important`,
          dark: `${D.colors.neutral[99]} !important`
        })
      }
    }
  };
}), BasePhoneInputField$1 = (T) => {
  const {
    FormattedMessage: S
  } = LocalizationProvider(), [R, k] = useState$1(!1), [D, L] = useState$1(!1), {
    Stack: V
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(V, { onMouseEnter: () => L(!0), onMouseLeave: () => L(!1), children: /* @__PURE__ */ jsxRuntimeExports.jsx(BasePhoneInputField$2, { ...T, country: T.country ? T.country : "us", specialLabel: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { id: T.token, defaultMessage: T.defaultMessage, values: T.values }), onFocus: () => k(!0), onBlur: () => k(!1), isInputFocused: R, hover: D, error: T.error }) });
};
BasePhoneInputField$1.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object,
  country: Packages.PropTypes.string,
  error: Packages.PropTypes.bool
};
const BasePhoneNumberField = withBaseField(BasePhoneInputField$1, "PhoneNumberField"), BasePhoneInputField = Packages.emotion.styled(BasePhoneNumberField)(({
  disabled: T,
  isInputFocused: S,
  error: R
}) => {
  const k = Packages.Mui.useTheme();
  return {
    ".special-label": {
      fontFamily: k.typography.fontFamily,
      left: "12px",
      top: "9px",
      fontSize: "0.75rem",
      background: "transparent",
      fontWeight: k.typography.fontWeightRegular,
      color: k.colors.neutral[100],
      ...R && {
        color: k.colors.red[90]
      },
      ...S && {
        color: k.colors.blue[90]
      },
      ...T && {
        color: k.colors.neutral[70]
      }
    },
    ".form-control": {
      boxSizing: "border-box",
      width: "100% ",
      height: 56,
      padding: "35.5px 14px 19.5px 80px",
      fontFamily: k.typography.fontFamily,
      color: k.colors.neutral[100],
      background: k.colors.rgba.black[80],
      border: "none",
      borderRadius: "0",
      borderBottom: `1px solid ${k.colors.neutral[95]}`,
      ...R && {
        borderBottom: `1px solid ${k.colors.red[90]}`
      },
      "&:disabled": {
        opacity: 0.38
      },
      "&:hover": {
        background: k.colors.rgba.black[70],
        border: "none",
        borderBottom: `2px solid ${k.colors.neutral[95]}`,
        ...R && {
          borderBottom: `2px solid ${k.colors.red[90]}`
        }
      },
      "&:focus": {
        border: "none",
        boxShadow: "none",
        borderBottom: `2px solid ${k.colors.blue[90]}`
      }
    },
    ".country-list": {
      fontFamily: k.typography.fontFamily,
      width: 406,
      color: k.colors.neutral[100],
      background: k.colors.rgb.translucent.dark[40],
      borderRadius: 4,
      top: 47,
      "& .country .dial-code": {
        color: k.colors.neutral[70]
      },
      "& .country:hover": {
        background: k.colors.rgb.translucent.white[10]
      },
      "& .country.highlight": {
        background: k.colors.darkBlue[60]
      }
    },
    ".selected-flag": {
      padding: "75px 0 0 19px",
      ".arrow": {
        left: "40px",
        borderBottomColor: `${k.colors.neutral[100]} !important`,
        borderTopColor: `${k.colors.neutral[99]} !important`
      }
    }
  };
}), GlassPhoneNumberField = (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(BasePhoneInputField, { ...T }), PhoneNumberField = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    case "default":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BasePhoneNumberField, { ...S });
    case "glass":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(GlassPhoneNumberField, { ...S });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BasePhoneNumberField, { ...S });
  }
};
PhoneNumberField.propTypes = {
  variant: Packages.PropTypes.oneOf(["glass", "default"])
};
const CancelRoundedIcon = Packages.emotion.styled(IconsMaterial.CancelRounded)(() => ({
  /**
   * This will work alongside the definition for the svg in src/components/input/text-field/theme/light.js.
   *
   * NOTE: The Cancel button should be rendered 'on hover' over the input if it has a value.
   */
  display: "block"
})), useGlassTextField = (T, S) => {
  const {
    InputAdornment: R,
    IconButton: k
  } = Packages.Mui, [D, L] = useState$1(!1), V = () => L((J) => !J), z = (J) => {
    J.preventDefault();
  }, W = /* @__PURE__ */ jsxRuntimeExports.jsxs(R, { position: "end", children: [
    S && /* @__PURE__ */ jsxRuntimeExports.jsx(k, { "aria-label": "toggle password visibility", onClick: V, onMouseDown: z, edge: "end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: D ? "visibility-off" : "visibility" }) }),
    T.variant === "standard" && T.value && /* @__PURE__ */ jsxRuntimeExports.jsx(CancelRoundedIcon, { onClick: () => {
      T.onChange({
        target: {
          value: ""
        }
      });
    } })
  ] }), U = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    W,
    T?.InputProps?.endAdornment
  ] }), q = {
    ...T.InputProps,
    endAdornment: U()
  };
  return {
    Type: S ? D ? "text" : "password" : "text",
    InputProps: q
  };
}, dark$a = (T) => ({
  MuiTextField: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          disabled: R
        } = S.ownerState;
        return {
          svg: {
            color: T.colors.blue[95],
            ...R && {
              pointerEvents: "none",
              color: T.colors.neutral[80]
            }
          },
          '&:hover svg[data-testid="CancelOutlinedIcon"]': {
            display: "block !important"
          }
        };
      }
    }
  },
  MuiInputAdornment: {
    styleOverrides: {
      positionEnd: (S) => {
        const {
          variant: R
        } = S.ownerState;
        return {
          cursor: "pointer",
          marginRight: 6,
          width: 24,
          ...R === "standard" && {
            padding: 12,
            marginRight: 0,
            svg: {
              color: T.colors.neutral[100]
            }
          }
        };
      },
      positionStart: (S) => {
        const {
          variant: R
        } = S.ownerState;
        return {
          ...R === "standard" && {
            padding: 12,
            marginRight: 0,
            svg: {
              color: T.colors.neutral[100]
            }
          }
        };
      }
    }
  },
  MuiFilledInput: {
    styleOverrides: {
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          backgroundColor: T.colors.rgba.black[80],
          paddingLeft: 11,
          color: T.colors.neutral[95],
          "&:hover:not(.Mui-error,.Mui-focused), &:focus": {
            backgroundColor: T.colors.rgba.black[70],
            "::before, ::after": {
              borderBottom: `2px solid ${T.colors.neutral[90]} !important`
            }
          },
          "&.Mui-focused": {
            backgroundColor: T.colors.rgba.black[70],
            "::before, ::after": {
              borderBottom: `2px solid ${R.error ? T.colors.red[90] : T.colors.blue[90]} !important`
            }
          },
          "::before, ::after": {
            borderBottom: `1px solid ${R.error ? T.colors.red[90] : T.colors.neutral[95]} !important`
          }
        };
      },
      input: {
        paddingLeft: 0
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          variant: R,
          formControl: k
        } = S.ownerState;
        return {
          fontWeight: T.typography.fontWeightRegular,
          ...R === "outlined" && {
            left: -11,
            ...S.ownerState.shrink && {
              top: 5
            },
            color: `${T.colors.neutral[95]} !important`,
            ...S.ownerState.shrink && {
              color: `${T.colors.blue[90]} !important`
            },
            ...k.error && S.ownerState.shrink && {
              color: `${T.colors.red[90]} !important`
            },
            "&.Mui-focused": {
              left: -11,
              top: 5
            }
          },
          ...R === "filled" && {
            left: 0,
            color: `${T.colors.neutral[95]} !important`,
            ...S.ownerState.shrink && {
              color: `${T.colors.blue[90]} !important`
            },
            ...k.error && S.ownerState.shrink && {
              color: `${T.colors.red[90]} !important`
            },
            "&.Mui-focused": {
              left: 0
            }
          }
        };
      }
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        padding: 2,
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: !0
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          backgroundColor: "transparent",
          color: T.colors.neutral[95],
          borderRadius: 0,
          "&:hover fieldset": {
            borderBottom: `2px solid ${T.colors.neutral[90]} !important`,
            ...R.error && {
              borderBottom: `2px solid ${T.colors.red[90]} !important`
            }
          },
          "&.Mui-focused fieldset": {
            borderBottom: `2px solid ${T.colors.blue[90]} !important`,
            ...R.error && {
              borderBottom: `2px solid ${T.colors.red[90]} !important`
            }
          }
        };
      },
      notchedOutline: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          border: "none",
          borderBottom: `1px solid ${T.colors.neutral[95]} !important`,
          ...R.error && {
            borderBottom: `1px solid ${T.colors.red[90]} !important`
          }
        };
      },
      input: {
        paddingLeft: "1px !important"
      }
    }
  },
  MuiInput: {
    styleOverrides: {
      root: {
        height: 48,
        fontWeight: 400,
        background: T.colors.surface.glass[1],
        backdropFilter: "blur(40px)",
        boxShadow: T.shadow(10),
        borderRadius: "0.625rem",
        border: `1px solid ${T.colors.neutral[85]} `,
        color: T.colors.neutral[90],
        "::placeholder": {
          opacity: 1
        },
        "&:hover": {
          border: `1px solid ${T.colors.neutral[95]}`
        },
        "&.Mui-focused ": {
          border: `2px solid ${T.colors.blue[60]}`
        },
        "::before, ::after": {
          display: "none"
        }
      }
    }
  }
}), light$a = (T) => ({
  MuiTextField: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          disabled: R
        } = S.ownerState;
        return {
          svg: {
            color: T.colors.blue[95],
            ...R && {
              pointerEvents: "none",
              color: T.colors.neutral[80]
            }
          },
          '&:hover svg[data-testid="CancelRoundedIcon"]': {
            display: "block !important"
          }
        };
      }
    }
  },
  MuiInputAdornment: {
    styleOverrides: {
      positionEnd: (S) => {
        const {
          variant: R
        } = S.ownerState;
        return {
          cursor: "pointer",
          marginRight: 6,
          width: 24,
          ...R === "standard" && {
            padding: 12,
            marginRight: 0,
            svg: {
              color: T.colors.neutral[100]
            }
          }
        };
      },
      positionStart: (S) => {
        const {
          variant: R
        } = S.ownerState;
        return {
          ...R === "standard" && {
            padding: 12,
            marginRight: 0,
            svg: {
              color: T.colors.neutral[100]
            }
          }
        };
      }
    }
  },
  MuiFilledInput: {
    styleOverrides: {
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          backgroundColor: T.colors.rgba.black[80],
          paddingLeft: 11,
          color: T.colors.neutral[95],
          "&:hover:not(.Mui-error,.Mui-focused), &:focus": {
            backgroundColor: T.colors.rgba.black[70],
            "::before, ::after": {
              borderBottom: `2px solid ${T.colors.neutral[90]} !important`
            }
          },
          "&.Mui-focused": {
            backgroundColor: T.colors.rgba.black[70],
            "::before, ::after": {
              borderBottom: `2px solid ${R.error ? T.colors.red[90] : T.colors.blue[90]} !important`
            }
          },
          "::before, ::after": {
            borderBottom: `1px solid ${R.error ? T.colors.red[90] : T.colors.neutral[95]} !important`
          }
        };
      },
      input: {
        paddingLeft: 0
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          variant: R,
          formControl: k
        } = S.ownerState;
        return {
          fontWeight: T.typography.fontWeightRegular,
          ...R === "outlined" && {
            left: -11,
            ...S.ownerState.shrink && {
              top: 5
            },
            color: `${T.colors.neutral[95]} !important`,
            ...S.ownerState.shrink && {
              color: `${T.colors.blue[90]} !important`
            },
            ...k.error && S.ownerState.shrink && {
              color: `${T.colors.red[90]} !important`
            },
            "&.Mui-focused": {
              left: -11,
              top: 5
            }
          },
          ...R === "filled" && {
            left: 0,
            color: `${T.colors.neutral[95]} !important`,
            ...S.ownerState.shrink && {
              color: `${T.colors.blue[90]} !important`
            },
            ...k.error && S.ownerState.shrink && {
              color: `${T.colors.red[90]} !important`
            },
            "&.Mui-focused": {
              left: 0
            }
          }
        };
      }
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        padding: 2,
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: !0
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          backgroundColor: "transparent",
          color: T.colors.neutral[95],
          borderRadius: 0,
          "&:hover fieldset": {
            borderBottom: `2px solid ${T.colors.neutral[95]} !important`,
            ...R.error && {
              borderBottom: `2px solid ${T.colors.red[90]} !important`
            }
          },
          "&.Mui-focused fieldset": {
            borderBottom: `2px solid ${T.colors.blue[90]} !important`,
            ...R.error && {
              borderBottom: `2px solid ${T.colors.red[90]} !important`
            }
          }
        };
      },
      notchedOutline: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          border: "none",
          borderBottom: `1px solid ${T.colors.neutral[95]} !important`,
          ...R.error && {
            borderBottom: `1px solid ${T.colors.red[90]} !important`
          }
        };
      },
      input: {
        paddingLeft: "1px !important"
      }
    }
  },
  MuiInput: {
    styleOverrides: {
      root: {
        height: 48,
        fontWeight: 400,
        background: T.colors.surface.glass[1],
        backdropFilter: "blur(40px)",
        boxShadow: T.shadow(10),
        borderRadius: "0.625rem",
        border: `1px solid ${T.colors.neutral[85]} `,
        color: T.colors.neutral[90],
        "::placeholder": {
          opacity: 1
        },
        "&:hover": {
          border: `1px solid ${T.colors.neutral[95]}`
        },
        "&.Mui-focused ": {
          border: `2px solid ${T.colors.blue[60]}`
        },
        "::before, ::after": {
          display: "none"
        }
      }
    }
  }
}), BaseGlassTextFieldThemeConfig = {
  dark: dark$a,
  light: light$a
}, TextField = ({
  password: T,
  ...S
}) => {
  const R = useRef(null), {
    TextField: k
  } = Packages.Mui, {
    FormattedMessage: D
  } = LocalizationProvider(), {
    Type: L,
    InputProps: V
  } = useGlassTextField(S, T);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(k, { ref: R, autoComplete: "off", label: /* @__PURE__ */ jsxRuntimeExports.jsx(D, { id: S.token, defaultMessage: S.defaultMessage, values: S.values }), ...S, type: L, InputProps: V, error: S.formhandler?.fieldState(S.name).invalid ?? S.error, helperText: S.formhandler?.fieldState(S.name).error ?? S.helperText, fullWidth: !0 });
};
TextField.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object,
  InputProps: Packages.PropTypes.object,
  formhandler: Packages.PropTypes.object,
  helperText: Packages.PropTypes.string,
  name: Packages.PropTypes.string,
  error: Packages.PropTypes.bool,
  password: Packages.PropTypes.bool
};
const BaseGlassTextField = withBaseField(withThemeOverrides(TextField, BaseGlassTextFieldThemeConfig), "TextField"), FilledGlassTextField = (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(BaseGlassTextField, { ...T, variant: "filled" }), OutlinedGlassTextField = (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(BaseGlassTextField, { ...T, variant: "outlined" }), GlassSearchTextField = (T) => {
  const {
    InputAdornment: S
  } = Packages.Mui, {
    useIntl: R
  } = LocalizationProvider(), k = R();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseGlassTextField, { ...T, variant: "standard", label: "", InputProps: {
    startAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { position: "start", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "search-rounded" }) })
  }, placeholder: k.formatMessage({
    id: T.token,
    defaultMessage: T.defaultMessage
  }, {
    values: T.values
  }) });
};
GlassSearchTextField.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  defaultMessage: Packages.PropTypes.string,
  values: Packages.PropTypes.object
};
const GlassTextField$1 = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    case "filled":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FilledGlassTextField, { ...S });
    case "search":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(GlassSearchTextField, { ...S });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(OutlinedGlassTextField, { ...S });
  }
};
GlassTextField$1.propTypes = {
  variant: Packages.PropTypes.oneOf(["filled", "search", "outlined"])
};
const AutocompleteUtil = ({
  InternalInputProps: T,
  params: S
}) => {
  const {
    Stack: R
  } = Packages.Mui, k = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    T?.startAdornment && /* @__PURE__ */ jsxRuntimeExports.jsx(R, { className: "startAdornment-icon", children: T?.startAdornment }),
    S.InputProps.startAdornment
  ] }), D = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    T?.endAdornment && /* @__PURE__ */ jsxRuntimeExports.jsx(R, { className: "endAdornment-icon", children: T.endAdornment }),
    S.InputProps.endAdornment
  ] });
  return {
    InputProps: {
      ...S.InputProps,
      ...(T?.startAdornment || S.InputProps?.startAdornment) && {
        startAdornment: k
      },
      ...(T?.endAdornment || S.InputProps?.endAdornment) && {
        endAdornment: D
      }
    }
  };
}, RenderInput = ({
  params: T,
  token: S,
  error: R,
  InputProps: k,
  value: D,
  required: L,
  helperText: V,
  name: z,
  formhandler: W
}) => {
  const {
    Stack: U
  } = Packages.Mui, {
    InputProps: q
  } = AutocompleteUtil({
    InternalInputProps: k,
    params: T
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(U, { ref: T.InputProps.ref, children: /* @__PURE__ */ jsxRuntimeExports.jsx(TextField$1, { ...T, required: L, error: W?.fieldState(z).invalid ?? R, helperText: W?.fieldState(z).error ?? V, token: S, value: D, InputProps: q }) });
};
RenderInput.propTypes = {
  params: Packages.PropTypes.object.isRequired,
  token: Packages.PropTypes.string.isRequired,
  error: Packages.PropTypes.bool.isRequired,
  InputProps: Packages.PropTypes.object.isRequired,
  value: Packages.PropTypes.any.isRequired,
  required: Packages.PropTypes.bool.isRequired,
  helperText: Packages.PropTypes.string.isRequired,
  name: Packages.PropTypes.string.isRequired,
  formhandler: Packages.PropTypes.object.isRequired
};
const GridIcon = Packages.emotion.styled(Packages.Mui.Grid)(() => ({
  display: "flex",
  width: 44
})), GridLabel = Packages.emotion.styled(Packages.Mui.Grid)(() => ({
  width: "calc(100% - 44px)",
  wordWrap: "break-word"
})), AsyncAutocompleteField = ({
  token: T,
  onInputChange: S,
  error: R,
  InputProps: k,
  required: D,
  helperText: L,
  formhandler: V,
  metadata: z = {},
  ...W
}) => {
  const {
    Mui: {
      Autocomplete: U,
      Grid: q,
      Typography: K,
      MenuItem: Y
    }
  } = Packages, [J, Z] = useState$1(W?.value || null), [X, ee] = useState$1(W?.inputValue || ""), [te, re] = useState$1([]), Q = useCallback(Packages.lodash.debounce(async (ne, oe, ae) => {
    const se = await S({
      parameters: {
        text: oe,
        ...z
      }
    });
    if (ae) {
      let ie = [];
      se && (ie = [...ie, ...se], re(ie));
    }
  }, 300), [J, X]);
  return useEffect$1(() => {
    let ne = !0;
    if (X === "") {
      re(J ? [J] : []), Z(null), ee("");
      return;
    }
    return Q(null, X, ne), () => {
      ne = !1, Q.cancel();
    };
  }, [J, X, Q]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    U,
    {
      ...W,
      options: te,
      value: J,
      filterOptions: (ne) => ne,
      getOptionLabel: (ne) => ne.text ?? ne,
      isOptionEqualToValue: (ne, oe) => {
        const ae = typeof oe == "string" ? oe : oe.text;
        return oe ? ne.text === ae : !0;
      },
      renderInput: (ne) => RenderInput({
        params: ne,
        token: T,
        error: R,
        InputProps: k,
        value: J,
        required: D,
        helperText: L,
        name,
        formhandler: V
      }),
      onChange: (ne, oe) => {
        re(oe ? [oe, ...te] : te), Z(oe), W.formhandler && W.formhandler.setFormValue({
          field: W.name,
          value: oe?.text
        }), W.onChange && W.onChange(oe);
      },
      onInputChange: (ne, oe) => {
        ee(oe);
      },
      clearIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "cancel-outlined" }),
      renderOption: (ne, oe) => /* @__PURE__ */ createElement$1(Y, { ...ne, key: oe.placeId }, /* @__PURE__ */ jsxRuntimeExports.jsxs(q, { container: !0, alignItems: "center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(GridIcon, { item: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "location-on" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(GridLabel, { item: !0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(K, { variant: "body2", color: "text.secondary", children: oe.text }) })
      ] })),
      fullWidth: !0
    }
  );
};
AsyncAutocompleteField.propTypes = {
  token: Packages.PropTypes.string.isRequired,
  onInputChange: Packages.PropTypes.func.isRequired,
  error: Packages.PropTypes.bool,
  InputProps: Packages.PropTypes.object,
  required: Packages.PropTypes.bool,
  helperText: Packages.PropTypes.string,
  formhandler: Packages.PropTypes.object,
  rest: Packages.PropTypes.object,
  metadata: Packages.PropTypes.object
};
const dark$9 = (T) => ({
  MuiAutocomplete: {
    styleOverrides: {
      tag: {
        borderRadius: 8,
        color: T.colors.purple[30],
        background: T.colors.purple[40],
        border: "none",
        fontSize: 14,
        padding: "0px 10px",
        svg: {
          color: T.colors.purple[30],
          width: 18
        }
      },
      endAdornment: (S) => ({
        button: {
          padding: "2px 3px",
          color: T.colors.neutral[100]
        },
        ...S.ownerState.addicon && {
          width: 150,
          display: "grid",
          gridTemplateColumns: "1fr auto",
          alignItems: "end",
          button: {
            justifySelf: "end",
            marginLeft: 44,
            padding: "2px 3px",
            color: T.colors.neutral[100]
          }
        }
      }),
      option: (S) => {
        const {
          disabled: R
        } = S.ownerState;
        return {
          color: T.colors.neutral[100],
          ...R && {
            color: T.colors.neutral[100]
          },
          '&[aria-selected="true"]': {
            backgroundColor: "transparent !important"
          }
        };
      },
      root: {
        "& .MuiOutlinedInput-root": {
          padding: 4.5
        },
        ".startAdornment-icon": {
          margin: "0 0.6rem"
        },
        ".endAdornment-icon": {
          position: "absolute",
          right: "2rem",
          top: "calc(50% - 12px)",
          cursor: "pointer",
          marginRight: 5
        }
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          /**
           * This approach was inferred from StackOverflow
           *
           * Reference: https://stackoverflow.com/questions/52911169/how-to-change-the-border-color-of-material-ui-textfield
           */
          fieldset: {
            borderColor: `${T.colors.neutral[100]} !important`,
            ...R.focused && {
              borderColor: `${T.colors.blue[90]} !important`
            },
            ...R.error && {
              borderColor: `${T.colors.red[80]} !important`
            },
            ...R.disabled && {
              borderColor: `${T.colors.neutral[30]} !important`
            }
          },
          "&:hover fieldset": {
            borderColor: `${T.colors.blue[90]} !important`,
            ...R.error && {
              borderColor: `${T.colors.red[80]} !important`
            },
            ...R.disabled && {
              borderColor: `${T.colors.neutral[30]} !important`
            }
          }
        };
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          disabled: R,
          error: k
        } = S.ownerState;
        return {
          height: 20,
          ...R && {
            color: `${T.colors.neutral[30]} !important`
          },
          ...k && {
            color: `${T.colors.red[80]} !important`
          },
          ...S.ownerState["data-shrink"] && {
            color: T.colors.neutral[100],
            fontWeight: T.typography.fontWeightSemiBold,
            ...k && {
              color: `${T.colors.red[80]} !important`
            }
          }
        };
      },
      asterisk: (S) => {
        const {
          error: R
        } = S.ownerState;
        return {
          ...R && {
            color: `${T.colors.red[80]} !important`
          }
        };
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        lineHeight: 1,
        color: T.colors.neutral[100]
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        color: T.colors.neutral[100]
      }
    }
  }
}), light$9 = (T) => ({
  MuiAutocomplete: {
    styleOverrides: {
      tag: {
        borderRadius: 8,
        background: T.colors.aqua[95],
        border: "none",
        fontSize: 14,
        padding: "0px 10px",
        svg: {
          color: T.colors.neutral[0],
          width: 18
        }
      },
      startAdornment: {
        root: {
          background: "red"
        }
      },
      endAdornment: {
        button: {
          padding: "2px 3px",
          color: T.colors.neutral[40]
        }
      },
      option: (S) => {
        const {
          disabled: R
        } = S.ownerState;
        return {
          color: T.colors.neutral[40],
          ...R && {
            color: T.colors.neutral[80]
          },
          '&[aria-selected="true"]': {
            backgroundColor: "transparent !important"
          }
        };
      },
      root: {
        "& .MuiOutlinedInput-root": {
          padding: 4.5
        },
        ".startAdornment-icon": {
          margin: "0 0.6rem"
        },
        ".endAdornment-icon": {
          position: "absolute",
          right: "2rem",
          top: "calc(50% - 12px)",
          cursor: "pointer",
          marginRight: 5
        }
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          formControl: R
        } = S.ownerState;
        return {
          /**
           * This approach was inferred from StackOverflow
           *
           * Reference: https://stackoverflow.com/questions/52911169/how-to-change-the-border-color-of-material-ui-textfield
           */
          fieldset: {
            borderColor: `${T.colors.neutral[60]} !important`,
            ...R.focused && {
              borderColor: `${T.colors.darkBlue[50]} !important`
            },
            ...R.error && {
              borderColor: `${T.colors.red[50]} !important`
            },
            ...R.disabled && {
              borderColor: `${T.colors.neutral[90]} !important`
            }
          },
          "&:hover fieldset": {
            borderColor: `${T.colors.darkBlue[50]} !important`,
            ...R.error && {
              borderColor: `${T.colors.red[50]} !important`
            },
            ...R.disabled && {
              borderColor: `${T.colors.neutral[90]} !important`
            }
          }
        };
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => ({
        height: 20,
        ...S.ownerState.error && {
          color: `${T.colors.red[50]} !important`
        },
        ...S.ownerState["data-shrink"] && {
          color: T.colors.neutral[10],
          fontWeight: T.typography.fontWeightSemiBold
        }
      })
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        lineHeight: 1
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        color: T.colors.neutral[40]
      }
    }
  }
}), AutocompleteThemeConfig = {
  dark: dark$9,
  light: light$9
}, AutocompleteField$1 = ({
  options: T,
  token: S,
  error: R,
  disabled: k,
  value: D,
  required: L,
  disableClearable: V,
  InputProps: z,
  helperText: W,
  name: U,
  formhandler: q,
  ...K
}) => {
  const [Y, J] = useState$1(""), {
    Autocomplete: Z
  } = Packages.Mui, {
    useIntl: X
  } = LocalizationProvider(), ee = X();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Z,
    {
      ...K,
      ...!K.multiple && {
        value: D,
        inputValue: Y,
        onInputChange: (te, re) => {
          J(re);
        }
      },
      options: T,
      disabled: k,
      getOptionLabel: (te) => te.label ?? te,
      clearIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "cancel-outlined" }),
      disableClearable: V,
      clearText: ee.formatMessage({
        id: "component.cai_material.autocomplete_field.clearText"
      }),
      closeText: ee.formatMessage({
        id: "component.cai_material.autocomplete_field.closeText"
      }),
      loadingText: ee.formatMessage({
        id: "component.cai_material.autocomplete_field.loadingText"
      }),
      openText: ee.formatMessage({
        id: "component.cai_material.autocomplete_field.openText"
      }),
      noOptionsText: ee.formatMessage({
        id: "component.cai_material.autocomplete_field.noOptionsText"
      }),
      isOptionEqualToValue: (te, re) => re ? te.value === re.value : !0,
      renderInput: (te) => RenderInput({
        params: te,
        token: S,
        error: R,
        InputProps: z,
        value: D,
        required: L,
        helperText: W,
        name: U,
        formhandler: q
      }),
      fullWidth: !0
    }
  );
};
AutocompleteField$1.propTypes = {
  options: Packages.PropTypes.array.isRequired,
  token: Packages.PropTypes.string,
  error: Packages.PropTypes.bool,
  disabled: Packages.PropTypes.bool,
  value: Packages.PropTypes.oneOfType([Packages.PropTypes.array, Packages.PropTypes.object, Packages.PropTypes.string]),
  required: Packages.PropTypes.bool,
  disableClearable: Packages.PropTypes.bool,
  InputProps: Packages.PropTypes.object,
  helperText: Packages.PropTypes.string,
  name: Packages.PropTypes.string,
  formhandler: Packages.PropTypes.object
};
const BaseAutocompleteField = withBaseField(withThemeOverrides(AutocompleteField$1, AutocompleteThemeConfig), "AutocompleteField"), MultipleAutocompleteField = ({
  options: T,
  token: S,
  error: R,
  disabled: k,
  value: D,
  required: L,
  disableClearable: V,
  helperText: z,
  ...W
}) => {
  const {
    Checkbox: U,
    Chip: q,
    MenuItem: K,
    Box: Y
  } = Packages.Mui, J = ({
    key: Z,
    ...X
  }, ee, {
    selected: te
  }) => /* @__PURE__ */ createElement$1(K, { ...X, key: Z }, /* @__PURE__ */ jsxRuntimeExports.jsxs(Y, { component: "span", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(U, { checked: te }),
    ee.label
  ] }, Z));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseAutocompleteField, { ...W, multiple: !0, disabled: k, required: L, options: T, disableClearable: V, token: S, value: D, error: R, helperText: z, renderTags: (Z, X) => Z.map((ee, te) => /* @__PURE__ */ createElement$1(q, { variant: "outlined", label: ee.label, deleteIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "close" }), ...X({
    index: te
  }), key: te })), renderOption: J });
};
MultipleAutocompleteField.propTypes = {
  options: Packages.PropTypes.array.isRequired,
  token: Packages.PropTypes.string.isRequired,
  error: Packages.PropTypes.bool,
  disabled: Packages.PropTypes.bool,
  value: Packages.PropTypes.array,
  required: Packages.PropTypes.bool,
  disableClearable: Packages.PropTypes.bool,
  helperText: Packages.PropTypes.string,
  renderOption: Packages.PropTypes.func
};
const AutocompleteField = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    case "async":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AsyncAutocompleteField, { ...S });
    case "multiple":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(MultipleAutocompleteField, { ...S });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseAutocompleteField, { ...S });
  }
};
AutocompleteField.propTypes = {
  variant: Packages.PropTypes.oneOf(["multiple", "async"])
};
const dark$8 = (T) => ({
  MuiButtonGroup: {
    styleOverrides: {
      root: {
        boxShadow: T.shadow(1),
        borderTopLeftRadius: "2.7778rem",
        borderBottomLeftRadius: "2.7778rem",
        borderTopRightRadius: "2.7778rem",
        borderBottomRightRadius: "2.7778rem"
      },
      grouped: {
        minWidth: "5rem",
        borderColor: T.colors.neutral[85],
        "&:hover": {
          borderColor: T.colors.neutral[85]
        },
        "&:disabled": {
          borderColor: "#3e3945"
        },
        "&:first-of-type": {
          borderTopLeftRadius: "2.7778rem",
          borderBottomLeftRadius: "2.7778rem"
        },
        "&:last-of-type": {
          borderTopRightRadius: "2.7778rem",
          borderBottomRightRadius: "2.7778rem"
        }
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: (S) => {
        const {
          className: R
        } = S.ownerState;
        return {
          color: T.colors.neutral[90],
          backgroundColor: T.surface(4),
          textTransform: "none",
          fontWeight: T.typography.fontWeightRegular,
          "&:hover": {
            backgroundColor: T.colors.neutral[84]
          },
          "&:focus": {
            backgroundColor: T.colors.neutral[83]
          },
          "&:active": {
            backgroundColor: T.colors.neutral[82]
          },
          "&:disabled": {
            color: T.colors.neutral[49],
            backgroundColor: T.colors.purple[50]
          },
          ...R === "selected" && {
            backgroundColor: T.colors.darkBlue[60],
            color: T.colors.purple[30],
            "&:hover": {
              backgroundColor: `${T.colors.darkBlue[64]} !important`
            },
            "&:focus": {
              backgroundColor: `${T.colors.darkBlue[66]} !important`
            },
            "&:active": {
              backgroundColor: `${T.colors.darkBlue[67]} !important`
            }
          }
        };
      }
    }
  }
}), light$8 = (T) => ({
  MuiButtonGroup: {
    styleOverrides: {
      root: {
        boxShadow: T.shadow(1),
        borderTopLeftRadius: "2.7778rem",
        borderBottomLeftRadius: "2.7778rem",
        borderTopRightRadius: "2.7778rem",
        borderBottomRightRadius: "2.7778rem"
      },
      grouped: {
        minWidth: "5rem",
        borderColor: T.colors.neutral[60],
        overflow: "hidden",
        "&:hover": {
          borderColor: T.colors.neutral[60]
        },
        "&:disabled": {
          color: `rgba(${T.colors.neutral[60]},0.12)`,
          borderColor: T.colors.neutral[81]
        },
        "&:first-of-type": {
          borderTopLeftRadius: "2.7778rem",
          borderBottomLeftRadius: "2.7778rem"
        },
        "&:last-of-type": {
          borderTopRightRadius: "2.7778rem",
          borderBottomRightRadius: "2.7778rem"
        }
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: (S) => {
        const {
          className: R
        } = S.ownerState;
        return {
          color: T.colors.neutral[40],
          backgroundColor: T.colors.neutral[100],
          textTransform: "none",
          fontWeight: T.typography.fontWeightMedium,
          "&:hover": {
            backgroundColor: T.surface(1)
          },
          "&:focus": {
            backgroundColor: T.surface(2)
          },
          "&:active": {
            backgroundColor: T.surface(3)
          },
          "&:disabled": {
            color: T.surface(1),
            backgroundColor: T.surface(1)
          },
          ...R === "selected" && {
            background: T.colors.blue[95],
            "&:hover": {
              backgroundColor: `${T.colors.blue[92]} !important`
            },
            "&:focus": {
              backgroundColor: `${T.colors.blue[93]} !important`
            },
            "&:active": {
              backgroundColor: `${T.colors.blue[94]} !important`
            }
          }
        };
      }
    }
  }
}), SegmentedButtonThemeConfig = {
  dark: dark$8,
  light: light$8
}, BaseSegmentedButton = ({
  options: T,
  onClick: S,
  disableCheckIcon: R,
  ...k
}) => {
  const {
    ButtonGroup: D,
    Button: L
  } = Packages.Mui, [V, z] = useState$1(k.value || T[0].value), W = (U) => {
    z(U), S(U);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(D, { ...k, children: T.map((U, q) => /* @__PURE__ */ jsxRuntimeExports.jsx(L, { ...U.value === V && {
    className: "selected",
    ...!R && {
      startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "check" })
    }
  }, onClick: () => W(U.value), disabled: U.disabled, children: U.label }, q)) });
};
BaseSegmentedButton.propTypes = {
  options: Packages.PropTypes.arrayOf(Packages.PropTypes.shape({
    label: Packages.PropTypes.string.isRequired,
    value: Packages.PropTypes.string.isRequired,
    disabled: Packages.PropTypes.bool
  })).isRequired,
  disableCheckIcon: Packages.PropTypes.bool,
  onClick: Packages.PropTypes.func.isRequired,
  value: Packages.PropTypes.any
};
const SegmentedButton = withThemeOverrides(BaseSegmentedButton, SegmentedButtonThemeConfig), dark$7 = (T) => ({
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        fontSize: 24
      }
    }
  },
  MuiFab: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          token: R
        } = S;
        return {
          fontSize: 14,
          backgroundColor: T.colors.blue[90],
          color: T.colors.blue[10],
          borderRadius: 16,
          padding: 16,
          width: "auto",
          boxShadow: T.shadow(3),
          textTransform: "none",
          ...R && {
            paddingRight: 20,
            gap: 10
          },
          "&:hover": {
            backgroundColor: T.colors.blue[80]
          },
          "&:active": {
            backgroundColor: T.colors.blue[70]
          },
          "&:disabled": {
            color: T.colors.neutral[50],
            backgroundColor: T.colors.neutral[20]
          }
        };
      }
    }
  }
}), light$7 = (T) => ({
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        fontSize: 24
      }
    }
  },
  MuiFab: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          token: R
        } = S.ownerState;
        return {
          fontSize: 14,
          backgroundColor: T.colors.darkBlue[50],
          color: T.colors.neutral[100],
          borderRadius: 16,
          padding: 16,
          width: "auto",
          textTransform: "none",
          boxShadow: T.shadow(3),
          ...R && {
            paddingRight: 20,
            gap: 10
          },
          "&:hover": {
            backgroundColor: T.colors.darkBlue[60]
          },
          "&:active": {
            backgroundColor: T.colors.darkBlue[70]
          },
          "&:disabled": {
            color: T.colors.neutral[91],
            backgroundColor: T.colors.neutral[92]
          }
        };
      }
    }
  }
}), FabThemeConfig = {
  dark: dark$7,
  light: light$7
}, Fab$1 = (T) => {
  const {
    FormattedMessage: S
  } = LocalizationProvider(), {
    Fab: R,
    Typography: k
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(R, { ...T, children: [
    T.icon,
    T?.token && /* @__PURE__ */ jsxRuntimeExports.jsx(k, { variant: "body2", children: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { id: T.token }) })
  ] });
};
Fab$1.propTypes = {
  icon: Packages.PropTypes.element,
  token: Packages.PropTypes.string
};
const PrimaryFab = withThemeOverrides(Fab$1, FabThemeConfig), Fab = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(PrimaryFab, { ...S });
  }
};
Fab.propTypes = {
  variant: Packages.PropTypes.oneOf(["primary"])
};
const dark$6 = (T) => ({
  MuiStack: {
    styleOverrides: {
      root: (S) => {
        const R = S.className.includes("singleIcon"), k = S.disabled, D = S.className.includes("active");
        return {
          border: `1px solid ${T.colors.neutral[93]}`,
          color: T.colors.neutral[95],
          borderRadius: 12,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: 16,
          height: 46,
          width: "100%",
          fontFamily: T.typography.fontFamily,
          fontWeight: T.typography.fontWeightMedium,
          boxShadow: T.shadow(1),
          background: T.colors.purple[80],
          ".contentBox": {
            display: "flex",
            alignItems: "center",
            padding: "0 16px",
            gap: 10,
            height: "100%",
            "&:first-of-type": {
              gap: 16
            }
          },
          ...D && {
            background: T.colors.darkBlue[60]
          },
          ...R && !k && {
            cursor: "pointer",
            "&:hover": {
              background: T.colors.purple[50]
            }
          },
          ...k && {
            cursor: "default",
            color: T.colors.neutral[50],
            border: `1px solid ${T.colors.neutral[50]}`,
            pointerEvents: "none",
            userSelect: "none",
            boxShadow: "none"
          }
        };
      }
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: (S) => ({
        ...S.className.includes("singleIcon") && {
          pointerEvents: "none"
        }
      })
    }
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        marginLeft: "auto"
      }
    }
  }
}), light$6 = (T) => ({
  MuiStack: {
    styleOverrides: {
      root: (S) => {
        const R = S.className.includes("singleIcon"), k = S.disabled, D = S.className.includes("active");
        return {
          border: `1px solid ${T.colors.neutral[93]}`,
          color: T.colors.neutral[40],
          borderRadius: 12,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: 16,
          height: 46,
          width: "100% ",
          fontFamily: T.typography.fontFamily,
          fontWeight: T.typography.fontWeightMedium,
          boxShadow: T.shadow(1),
          ".contentBox": {
            display: "flex",
            alignItems: "center",
            padding: "0 16px",
            gap: 10,
            height: "100%",
            "&:first-of-type": {
              gap: 16
            }
          },
          ...D && {
            background: T.colors.blue[95]
          },
          ...R && !k && {
            cursor: "pointer",
            "&:hover": {
              background: T.surface(1)
            }
          },
          ...k && {
            cursor: "default",
            color: T.colors.neutral[70],
            pointerEvents: "none",
            userSelect: "none",
            boxShadow: "none"
          }
        };
      }
    }
  },
  MuiIconButton: {
    styleOverrides: {
      root: (S) => ({
        ...S.className.includes("singleIcon") && {
          pointerEvents: "none"
        }
      })
    }
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        marginLeft: "auto"
      }
    }
  }
}), ContentActionButtonThemeConfig = {
  dark: dark$6,
  light: light$6
}, BaseContentActionButton = ({
  content: T,
  actionIcons: S,
  disabled: R,
  ...k
}) => {
  const {
    Stack: D,
    Box: L,
    IconButton: V,
    Divider: z
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(D, { ...k, disabled: R, ...S?.length === 1 && {
    onClick: S[0].onClick,
    className: `singleIcon ${k.className ? k.className : ""}`
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(L, { className: "contentBox", children: [
      T?.icon,
      T?.text
    ] }),
    S?.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(z, { orientation: "vertical", variant: "fullWidth", flexItem: !0 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(L, { className: "contentBox", children: S?.map(({
      icon: W,
      onClick: U
    }, q) => /* @__PURE__ */ jsxRuntimeExports.jsx(V, { disabled: R, onClick: U, ...S.length === 1 && {
      className: "singleIcon"
    }, children: W }, q)) })
  ] });
};
BaseContentActionButton.propTypes = {
  content: Packages.PropTypes.shape({
    icon: Packages.PropTypes.element.isRequired,
    text: Packages.PropTypes.oneOfType([Packages.PropTypes.string, Packages.PropTypes.object]).isRequired
  }).isRequired,
  actionIcons: Packages.PropTypes.arrayOf(Packages.PropTypes.shape({
    icon: Packages.PropTypes.element.isRequired,
    onClick: Packages.PropTypes.func.isRequired
  })).isRequired,
  disabled: Packages.PropTypes.bool
};
const ContentActionButton = withThemeOverrides(BaseContentActionButton, ContentActionButtonThemeConfig), Container$1 = Packages.emotion.styled(Packages.Mui.Stack)`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 703px 84px;
  grid-template-areas:
    'content'
    'footer';

  @media screen and (max-width: 1600px) {
    grid-template-rows: 507px 84px;
  }

  @media screen and (max-width: 1344px) {
    grid-template-rows: 383px 84px;
  }
`, Content$1 = Packages.emotion.styled(Packages.Mui.Stack)(() => {
  const T = Packages.Mui.useTheme();
  return `
      grid-area: content;
      padding: 26px 150px;
      gap: 32px;
      overflow-y: scroll;
      padding-top: 35px;
      color: ${T.validateMode({
    light: T.colors.neutral[40],
    dark: T.colors.neutral[90]
  })};
  
      .MuiFormControl-root {
        width: 100%;
      }
  
      .MuiFormHelperText-root {
        position: absolute;
        bottom: -20px;
      }
    `;
}), Footer$1 = Packages.emotion.styled(Packages.Mui.Stack)(() => {
  const T = Packages.Mui.useTheme();
  return `
      grid-area: footer;
      padding: 15px;
      border-top: 1px solid ${T.validateMode({
    light: T.colors.neutral[93],
    dark: T.colors.neutral[85]
  })};
    `;
}), Container = ({
  children: T
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Container$1, { children: T });
Container.propTypes = {
  children: Packages.PropTypes.node.isRequired
};
const Content = ({
  children: T,
  customClassName: S
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Content$1, { className: S, children: T });
Content.propTypes = {
  children: Packages.PropTypes.node.isRequired,
  customClassName: Packages.PropTypes.string
};
const Footer = ({
  children: T
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Footer$1, { children: T });
Footer.propTypes = {
  children: Packages.PropTypes.element
};
const GridForm = {
  Container,
  Content,
  Footer
}, DialogActions$1 = ({
  props: T,
  value: S,
  handler: R
}) => {
  const {
    DialogActions: k
  } = Packages.Mui, D = ["Invalid Date", ""].includes(formatDate(S[0])) || ["Invalid Date", ""].includes(formatDate(S[1]));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(k, { className: T.className, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { variant: "text", token: "general.cai_material.actions.done", disabled: D, onClick: R }) });
};
DialogActions$1.propTypes = {
  props: Packages.PropTypes.object,
  value: Packages.PropTypes.string,
  handler: Packages.PropTypes.func,
  className: Packages.PropTypes.object
};
const Drawer$1 = Packages.emotion.styled(Packages.Mui.Drawer)((T) => ({
  "& + div.base-Popper-root": {
    '&[data-popper-placement="top-start"]': {
      bottom: "2rem !important",
      left: `${T.customselectiontype === "specific-date" ? 4 : -6}rem !important`
    }
  }
})), dark$5 = (T) => ({
  MuiMenu: {
    styleOverrides: {
      root: {
        "& .MuiPaper-root": {
          borderRadius: 10,
          marginTop: 7
        }
      },
      list: {
        padding: "4px 0",
        width: "12.5rem"
      }
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          isactive: R
        } = S.ownerState;
        return {
          height: 60,
          fontWeight: T.typography.fontWeightRegular,
          ...R === "true" && {
            backgroundColor: T.colors.darkBlue[60]
          },
          "&:hover": {
            backgroundColor: T.surface(1)
          },
          "&:active": {
            backgroundColor: T.colors.darkBlue[60]
          }
        };
      }
    }
  },
  MuiSvgIcon: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => ({
        fontSize: S.ownerState?.["data-testid"] === "CheckIcon" ? 18 : "24px !important",
        marginRight: T.spacing(1.5)
      })
    }
  },
  MuiButton: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          isopen: R
        } = S.ownerState;
        return {
          ...R === "true" && {
            boxShadow: T.shadow(1)
          },
          borderRadius: 20,
          width: "fit-content",
          height: 40,
          padding: "10px 30px",
          fontSize: 16,
          textTransform: "capitalize",
          fontWeight: T.typography.fontWeightSemiBold,
          backgroundColor: T.colors.darkBlue[60],
          border: `1px solid ${T.colors.blue[95]}`,
          color: T.colors.blue[95],
          svg: {
            marginRight: 10,
            fontSize: 24
          },
          "&:hover": {
            backgroundColor: `${T.colors.darkBlue[60]} !important`,
            border: `1px solid ${T.colors.blue[95]}`
          },
          "&:focus": {
            backgroundColor: T.colors.darkBlue[60]
          },
          "&:active": {
            boxShadow: T.shadow(1)
          }
        };
      }
    }
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        width: "100%",
        borderRadius: "20px 20px 0px 0px",
        backgroundColor: "transparent"
      }
    }
  },
  MuiDrawer: {
    defaultProps: {
      disableEnforceFocus: !0
    },
    styleOverrides: {
      root: {
        zIndex: 0,
        "& .MuiPaper-root": {
          width: 480,
          left: "50%",
          transform: "translateX(-50%) !important",
          padding: 20,
          borderRadius: "20px 20px 0 0",
          backgroundColor: T.colors.neutral[21],
          boxSizing: "border-box"
        },
        "& .MuiFormControl-root": {
          width: "inherit"
        }
      }
    }
  },
  MuiModal: {
    styleOverrides: {
      backdrop: {
        backgroundColor: "transparent"
      }
    }
  }
}), light$5 = (T) => ({
  MuiMenu: {
    styleOverrides: {
      root: {
        "& .MuiPaper-root": {
          borderRadius: 10,
          marginTop: 7
        }
      },
      list: {
        padding: "4px 0",
        width: "12.5rem"
      }
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          isactive: R
        } = S.ownerState;
        return {
          height: 60,
          fontWeight: T.typography.fontWeightRegular,
          ...R === "true" && {
            backgroundColor: T.colors.blue[95]
          },
          "&:hover": {
            backgroundColor: T.surface(1)
          },
          "&:active": {
            backgroundColor: T.colors.blue[95]
          }
        };
      }
    }
  },
  MuiSvgIcon: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => ({
        fontSize: S.ownerState?.["data-testid"] === "CheckIcon" ? 18 : "24px !important",
        marginRight: T.spacing(1.5)
      })
    }
  },
  MuiButton: {
    styleOverrides: {
      /**
       * Overrides based on props
       *
       * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
       */
      root: (S) => {
        const {
          isopen: R
        } = S.ownerState;
        return {
          ...R === "true" && {
            boxShadow: T.shadow(1)
          },
          borderRadius: 20,
          width: "fit-content",
          height: 40,
          padding: "10px 30px",
          fontSize: 16,
          textTransform: "capitalize",
          fontWeight: T.typography.fontWeightSemiBold,
          backgroundColor: T.colors.blue[95],
          border: `1px solid ${T.colors.neutral[40]}`,
          color: T.colors.neutral[40],
          transition: "box-shadow 0.3s ease",
          "&:hover": {
            backgroundColor: `${T.colors.blue[90]} !important`,
            border: `1px solid ${T.colors.neutral[40]}`
          },
          "&:focus": {
            backgroundColor: T.colors.blue[95]
          },
          "&:active": {
            boxShadow: T.shadow(1)
          }
        };
      }
    }
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        width: "100%",
        borderRadius: "20px 20px 0px 0px",
        backgroundColor: T.colors.neutral[100]
      }
    }
  },
  MuiDrawer: {
    defaultProps: {
      disableEnforceFocus: !0
    },
    styleOverrides: {
      root: {
        zIndex: 0,
        "& .MuiPaper-root": {
          width: 480,
          left: "50%",
          transform: "translateX(-50%) !important",
          padding: 20,
          borderRadius: "20px 20px 0 0",
          backgroundColor: T.colors.neutral[100],
          boxSizing: "border-box"
        },
        "& .MuiFormControl-root": {
          width: "inherit"
        }
      }
    }
  },
  MuiModal: {
    styleOverrides: {
      backdrop: {
        backgroundColor: "transparent"
      }
    }
  }
}), TimePeriodMenuThemeConfig = {
  dark: dark$5,
  light: light$5
}, TimePeriodMenuUtil = ({
  currentOption: T,
  withCustomSelection: S,
  selectedDate: R,
  options: k
}) => {
  const {
    dayjs: D
  } = Packages["dayjs-pkg"], {
    useIntl: L,
    FormattedMessage: V
  } = LocalizationProvider(), z = L(), W = () => isObjectEmpty(S) ? k : [...k, {
    token: "component.cai_material.time_period_menu.option.custom",
    value: "custom"
  }], U = () => S.type === "date-range" ? R ? `${D(R[0]).format("DD/MM/YYYY")} - ${D(R[1]).format("DD/MM/YYYY")}` : z.formatMessage({
    id: "component.cai_material.time_period_menu.select.date_range"
  }) : R ? D(R).format("DD/MM/YYYY") : z.formatMessage({
    id: "component.cai_material.time_period_menu.select.date"
  });
  return {
    menuTitle: T.value === "custom" ? U() : /* @__PURE__ */ jsxRuntimeExports.jsx(V, { id: T.token }),
    defineOptions: W
  };
}, BaseTimePeriodMenu = ({
  options: T,
  callbackFn: S,
  withCustomSelection: R = {}
}) => {
  const {
    Box: k,
    InputAdornment: D,
    Button: L,
    ListItem: V,
    Menu: z,
    MenuItem: W
  } = Packages.Mui, {
    FormattedMessage: U,
    useIntl: q
  } = LocalizationProvider(), K = q(), [Y, J] = useState$1(!1), [Z, X] = useState$1(""), [ee, te] = useState$1(T[0]), {
    menuTitle: re,
    defineOptions: Q
  } = TimePeriodMenuUtil({
    currentOption: ee,
    withCustomSelection: R,
    selectedDate: Z,
    options: T
  }), [ne, oe] = useState$1(null), ae = !!ne, se = () => {
    J(!Y);
  }, ie = (he) => {
    oe(null), te(he), he.value === "custom" ? se() : (S(he.value), X(""));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(L, { isopen: ae.toString(), onClick: (he) => {
      oe(he.currentTarget);
    }, startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "calendar-month", fontSize: "small" }), endIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: `arrow-drop-${ae ? "up" : "down"}` }), disableRipple: !0, children: re }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(z, { anchorEl: ne, open: ae, onClose: () => {
      oe(null);
    }, children: Q().map((he, xe) => /* @__PURE__ */ jsxRuntimeExports.jsxs(W, { onClick: () => ie(he), isactive: (ee.value === he.value).toString(), disableRipple: !0, children: [
      ee.value === he.value && /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "check" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(k, { component: "span", children: /* @__PURE__ */ jsxRuntimeExports.jsx(U, { id: he.token }) })
    ] }, `${he.value}-${xe}`)) }),
    !isObjectEmpty(R) && /* @__PURE__ */ jsxRuntimeExports.jsx(Drawer$1, { anchor: "bottom", open: Y, onClose: se, customselectiontype: R.type, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(V, { disablePadding: !0, children: [
      R.type === "specific-date" && /* @__PURE__ */ jsxRuntimeExports.jsx(DateField, { token: "component.cai_material.time_period_menu.select.date", open: Y, value: Z, onChange: (he) => {
        X(he), R.callbackFn(formatDate(he)), se();
      } }),
      R.type === "date-range" && /* @__PURE__ */ jsxRuntimeExports.jsx(DateRangeField, { token: {
        start: "component.cai_material.time_period_menu.select.start_range",
        end: "component.cai_material.time_period_menu.select.end_range"
      }, open: !0, value: [Z[0], Z[1]], slots: {
        actionBar: (he) => DialogActions$1({
          props: he,
          value: he.ownerState.value,
          handler: R?.callbackFn ? () => {
            const xe = he.ownerState.value;
            X([formatDate(xe[0]), formatDate(xe[1])]), R.callbackFn([formatDate(xe[0]), formatDate(xe[1])]), se();
          } : se()
        })
      }, slotProps: {
        textField: ({
          position: he
        }) => ({
          label: he === "start" ? K.formatMessage({
            id: "component.cai_material.time_period_menu.select.start_range"
          }) : K.formatMessage({
            id: "component.cai_material.time_period_menu.select.end_range"
          }),
          InputProps: {
            startAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(D, { position: "start", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "calendar-month", style: {
              marginRight: 0
            } }) })
          }
        })
      } })
    ] }) })
  ] });
};
BaseTimePeriodMenu.propTypes = {
  options: Packages.PropTypes.array.isRequired,
  callbackFn: Packages.PropTypes.func.isRequired,
  withCustomSelection: Packages.PropTypes.shape({
    type: Packages.PropTypes.string,
    callbackFn: Packages.PropTypes.func
  }),
  ownerState: Packages.PropTypes.shape({
    value: Packages.PropTypes.oneOfType([Packages.PropTypes.string, Packages.PropTypes.arrayOf(Packages.PropTypes.string)])
  })
};
const TimePeriodMenu = withThemeOverrides(BaseTimePeriodMenu, TimePeriodMenuThemeConfig);
function DialogActions({
  props: T,
  value: S,
  handler: R
}) {
  const {
    DialogActions: k
  } = Packages.Mui, D = ["Invalid Date", ""].includes(formatDate(S[0])) || ["Invalid Date", ""].includes(formatDate(S[1]));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(k, { className: T.className, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { variant: "text", token: "general.cai_material.actions.done", disabled: D, onClick: R }) });
}
DialogActions.propTypes = {
  props: Packages.PropTypes.object,
  value: Packages.PropTypes.string,
  handler: Packages.PropTypes.func,
  className: Packages.PropTypes.object
};
const useTimePeriodMenu = ({
  currentOption: T,
  withCustomSelection: S,
  selectedDate: R,
  options: k,
  setSelectedDate: D,
  format: L,
  callbackFn: V,
  toggleDrawer: z
}) => {
  const {
    dayjs: W
  } = Packages["dayjs-pkg"], {
    FormattedMessage: U
  } = LocalizationProvider(), [q, K] = useState$1(/* @__PURE__ */ jsxRuntimeExports.jsx(U, { id: T.token }));
  return {
    menuTitle: q,
    defineOptions: () => isObjectEmpty(S) ? k : [...k, {
      token: "component.cai_material.dynamic_time_period_menu.option.custom",
      value: "custom"
    }],
    generateMenuDate: (Z, X) => {
      const ee = S.type === "date-range";
      if (X) {
        let te;
        ee && Z.value === "custom" ? (R[1] ? te = [R[0].add(X === "prev" ? -1 : 1, "day"), R[1].add(X === "prev" ? -1 : 1, "day")] : te = [W(), W().add(1, "day")], S.callbackFn([formatDate(te[0]), formatDate(te[1])]), K(`${formatDate(te[0], L)} - ${formatDate(te[1], L)}`)) : (te = R.add(X === "prev" ? -1 : 1, "day"), V(Z.value, formatDate(te)), K(formatDate(te, L))), D(te);
      } else {
        switch (Z.value) {
          case "yesterday":
            D(W().subtract(1, "day")), V(Z.value, formatDate(W().subtract(1, "day")));
            break;
          case "today":
            D(W()), V(Z.value, formatDate(W()));
            break;
          case "tomorrow":
            D(W().add(1, "day")), V(Z.value, formatDate(W().add(1, "day")));
            break;
          case "custom":
            K(/* @__PURE__ */ jsxRuntimeExports.jsx(U, { id: "component.cai_material.dynamic_time_period_menu.select.date" })), z();
            return;
        }
        K(/* @__PURE__ */ jsxRuntimeExports.jsx(U, { id: Z.token }));
      }
    },
    setMenuTitle: K
  };
}, Drawer = Packages.emotion.styled(Packages.Mui.Drawer)((T) => ({
  "& + div.base-Popper-root": {
    '&[data-popper-placement="top-start"]': {
      bottom: "2rem !important",
      left: `${T.customselectiontype === "specific-date" ? 4 : -6}rem !important`
    }
  }
}));
function dark$4(T) {
  return {
    MuiMenu: {
      styleOverrides: {
        root: {
          "& .MuiPaper-root": {
            borderRadius: 10,
            marginTop: 7
          }
        },
        list: {
          padding: "4px 0",
          width: "12.5rem"
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        /**
         * Overrides based on props
         *
         * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
         */
        root: (S) => {
          const {
            isactive: R
          } = S.ownerState;
          return {
            height: 60,
            fontWeight: T.typography.fontWeightRegular,
            ...R === "true" && {
              backgroundColor: T.colors.darkBlue[60]
            },
            "&:hover": {
              backgroundColor: T.surface(1)
            },
            "&:active": {
              backgroundColor: T.colors.darkBlue[60]
            }
          };
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        /**
         * Overrides based on props
         *
         * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
         */
        root: (S) => {
          const {
            "data-testid": R
          } = S.ownerState;
          return {
            fontSize: S.ownerState?.["data-testid"] === "CheckIcon" ? 18 : "24px !important",
            marginRight: T.spacing(1.5),
            marginLeft: T.spacing(1.5),
            ...["ArrowLeftIcon", "ArrowRightIcon"].includes(R) && {
              margin: 0
            }
          };
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        /**
         * Overrides based on props
         *
         * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
         */
        root: (S) => {
          const {
            isopen: R,
            className: k
          } = S.ownerState;
          return {
            borderRadius: 0,
            width: "fit-content",
            height: 40,
            padding: "0px 5px",
            fontSize: 16,
            textTransform: "capitalize",
            fontWeight: T.typography.fontWeightMedium,
            backgroundColor: T.colors.neutral[10],
            borderLeft: `1px solid ${T.colors.blue[95]}`,
            borderRight: `1px solid ${T.colors.blue[95]}`,
            color: T.colors.blue[95],
            ...R === "true" && {
              boxShadow: T.shadow(1),
              backgroundColor: T.colors.darkBlue[60]
            },
            ...k === "arrow-button" && {
              padding: 0,
              borderLeft: "none",
              borderRight: "none",
              minWidth: `${T.spacing(5.5)} !important`,
              width: "fit-content"
            },
            "&:hover": {
              backgroundColor: `${T.colors.neutral[20]} !important`
            },
            "&:focus": {
              backgroundColor: T.colors.darkBlue[60]
            },
            "&:active": {
              boxShadow: T.shadow(1)
            }
          };
        },
        startIcon: {
          margin: 0,
          padding: 0
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          width: "100%",
          borderRadius: "20px 20px 0px 0px",
          backgroundColor: "transparent"
        }
      }
    },
    MuiDrawer: {
      defaultProps: {
        disableEnforceFocus: !0
      },
      styleOverrides: {
        root: {
          zIndex: 0,
          "& .MuiPaper-root": {
            width: 480,
            left: "50%",
            transform: "translateX(-50%) !important",
            padding: 20,
            borderRadius: "20px 20px 0 0",
            backgroundColor: T.colors.neutral[21],
            boxSizing: "border-box"
          },
          "& .MuiFormControl-root": {
            width: "inherit"
          }
        }
      }
    },
    MuiModal: {
      styleOverrides: {
        backdrop: {
          backgroundColor: "transparent"
        }
      }
    },
    MuiStack: {
      styleOverrides: {
        root: {
          width: "fit-content",
          display: "flex",
          flexDirection: "row",
          borderRadius: "100px",
          overflow: "hidden",
          border: `1px solid ${T.colors.blue[95]}`
        }
      }
    }
  };
}
function light$4(T) {
  return {
    MuiMenu: {
      styleOverrides: {
        root: {
          "& .MuiPaper-root": {
            borderRadius: 10,
            marginTop: 7
          }
        },
        list: {
          padding: "4px 0",
          width: "12.5rem"
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        /**
         * Overrides based on props
         *
         * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
         */
        root: (S) => {
          const {
            isactive: R
          } = S.ownerState;
          return {
            height: 60,
            fontWeight: T.typography.fontWeightRegular,
            ...R === "true" && {
              backgroundColor: T.colors.blue[95]
            },
            "&:hover": {
              backgroundColor: T.surface(1)
            },
            "&:active": {
              backgroundColor: T.colors.blue[95]
            }
          };
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        /**
         * Overrides based on props
         *
         * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
         */
        root: (S) => {
          const {
            "data-testid": R
          } = S.ownerState;
          return {
            fontSize: S.ownerState?.["data-testid"] === "CheckIcon" ? 18 : "24px !important",
            marginRight: T.spacing(1.5),
            marginLeft: T.spacing(1.5),
            ...["ArrowLeftIcon", "ArrowRightIcon"].includes(R) && {
              margin: 0
            }
          };
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        /**
         * Overrides based on props
         *
         * Reference: https://mui.com/material-ui/customization/theme-components/#overrides-based-on-props
         */
        root: (S) => {
          const {
            isopen: R,
            className: k
          } = S.ownerState;
          return {
            borderRadius: 0,
            width: "fit-content",
            height: 40,
            padding: "0px 5px",
            fontSize: 16,
            textTransform: "capitalize",
            fontWeight: T.typography.fontWeightMedium,
            backgroundColor: T.colors.neutral[100],
            borderLeft: `1px solid ${T.colors.neutral[93]}`,
            borderRight: `1px solid ${T.colors.neutral[93]}`,
            color: T.colors.neutral[40],
            transition: "box-shadow 0.3s ease",
            ...R === "true" && {
              boxShadow: T.shadow(1),
              backgroundColor: T.colors.blue[95]
            },
            ...k === "arrow-button" && {
              padding: 0,
              borderLeft: "none",
              borderRight: "none",
              minWidth: `${T.spacing(5.5)} !important`
            },
            "&:hover": {
              backgroundColor: `${T.colors.surface[1]} !important`
            },
            "&:focus": {
              backgroundColor: T.colors.blue[95]
            },
            "&:active": {
              boxShadow: T.shadow(1)
            }
          };
        },
        startIcon: {
          margin: 0,
          padding: 0
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          width: "100%",
          borderRadius: "20px 20px 0px 0px",
          backgroundColor: T.colors.neutral[100]
        }
      }
    },
    MuiDrawer: {
      defaultProps: {
        disableEnforceFocus: !0
      },
      styleOverrides: {
        root: {
          zIndex: 0,
          "& .MuiPaper-root": {
            width: 480,
            left: "50%",
            transform: "translateX(-50%) !important",
            padding: 20,
            borderRadius: "20px 20px 0 0",
            backgroundColor: T.colors.neutral[100],
            boxSizing: "border-box"
          },
          "& .MuiFormControl-root": {
            width: "inherit"
          }
        }
      }
    },
    MuiModal: {
      styleOverrides: {
        backdrop: {
          backgroundColor: "transparent"
        }
      }
    },
    MuiStack: {
      styleOverrides: {
        root: {
          width: "fit-content",
          display: "flex",
          flexDirection: "row",
          borderRadius: "100px",
          overflow: "hidden",
          border: `1px solid ${T.colors.neutral[0]}`
        }
      }
    }
  };
}
const DynamicTimePeriodMenuThemeConfig = {
  dark: dark$4,
  light: light$4
}, BaseDynamicTimePeriodMenu = ({
  options: T,
  callbackFn: S,
  withCustomSelection: R = {},
  format: k = "DD/MM/YYYY"
}) => {
  const {
    Box: D,
    InputAdornment: L,
    Button: V,
    ListItem: z,
    Menu: W,
    MenuItem: U,
    Stack: q
  } = Packages.Mui, {
    dayjs: K
  } = Packages["dayjs-pkg"], {
    FormattedMessage: Y,
    useIntl: J
  } = LocalizationProvider(), Z = J(), [X, ee] = useState$1(!1), [te, re] = useState$1(K()), [Q, ne] = useState$1(T[1]), oe = () => {
    ee(!X);
  }, {
    menuTitle: ae,
    defineOptions: se,
    generateMenuDate: ie,
    setMenuTitle: he
  } = useTimePeriodMenu({
    currentOption: Q,
    withCustomSelection: R,
    selectedDate: te,
    options: T,
    setSelectedDate: re,
    setCurrentOption: ne,
    format: k,
    callbackFn: S,
    toggleDrawer: oe
  }), [xe, Pe] = useState$1(null), Re = !!xe, ke = (Te) => {
    Pe(null), ne(Te), ie(Te);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(q, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(V, { className: "arrow-button", startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "arrow-drop-left", fontSize: "small" }), onClick: () => ie(Q, "prev") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(V, { isopen: Re.toString(), onClick: (Te) => {
        Pe(Te.currentTarget);
      }, startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "calendar-month", fontSize: "small" }), endIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: `arrow-drop-${Re ? "up" : "down"}` }), disableRipple: !0, children: ae }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(V, { className: "arrow-button", startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "arrow-drop-right", fontSize: "small" }), onClick: () => ie(Q, "next") })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(W, { anchorEl: xe, open: Re, onClose: () => {
      Pe(null);
    }, children: se().map((Te, fe) => /* @__PURE__ */ jsxRuntimeExports.jsxs(U, { onClick: () => {
      ke(Te);
    }, isactive: (Q.value === Te.value).toString(), disableRipple: !0, children: [
      Q.value === Te.value && /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "check" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(D, { component: "span", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Y, { id: Te.token }) })
    ] }, `${Te.value}-${fe}`)) }),
    !isObjectEmpty(R) && /* @__PURE__ */ jsxRuntimeExports.jsx(Drawer, { anchor: "bottom", open: X, onClose: oe, customselectiontype: R.type, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(z, { disablePadding: !0, children: [
      R.type === "specific-date" && /* @__PURE__ */ jsxRuntimeExports.jsx(DateField, { token: "component.cai_material.dynamic_time_period_menu.select.date", open: X, value: te.format(k).toString(), format: k, onChange: (Te) => {
        re(K(Te)), he(formatDate(Te, k)), R.callbackFn(formatDate(Te)), oe();
      } }),
      R.type === "date-range" && /* @__PURE__ */ jsxRuntimeExports.jsx(DateRangeField, { token: {
        start: "component.cai_material.dynamic_time_period_menu.select.start_range",
        end: "component.cai_material.dynamic_time_period_menu.select.end_range"
      }, open: !0, value: [te[0], te[1]], maxDate: te[0] ? Packages["dayjs-pkg"].dayjs(te[0]).add(30, "day") : null, onChange: (Te) => {
        re([K(Te[0]), K(Te[1])]);
      }, slots: {
        actionBar: (Te) => DialogActions({
          props: Te,
          value: Te.ownerState.value,
          handler: R?.callbackFn ? () => {
            const fe = Te.ownerState.value;
            he(`${formatDate(fe[0], k)} - ${formatDate(fe[1], k)}`), R.callbackFn([formatDate(fe[0]), formatDate(fe[1])]), oe();
          } : oe()
        })
      }, slotProps: {
        textField: ({
          position: Te
        }) => ({
          label: Te === "start" ? Z.formatMessage({
            id: "component.cai_material.dynamic_time_period_menu.select.start_range"
          }) : Z.formatMessage({
            id: "component.cai_material.dynamic_time_period_menu.select.end_range"
          }),
          InputProps: {
            startAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(L, { position: "start", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "calendar-month", style: {
              marginRight: 0
            } }) })
          }
        })
      } })
    ] }) })
  ] });
};
BaseDynamicTimePeriodMenu.propTypes = {
  options: Packages.PropTypes.array.isRequired,
  callbackFn: Packages.PropTypes.func.isRequired,
  withCustomSelection: Packages.PropTypes.shape({
    type: Packages.PropTypes.string,
    callbackFn: Packages.PropTypes.func
  }),
  format: Packages.PropTypes.string,
  ownerState: Packages.PropTypes.shape({
    value: Packages.PropTypes.oneOfType([
      Packages.PropTypes.string,
      Packages.PropTypes.arrayOf(Packages.PropTypes.string),
      Packages.PropTypes.arrayOf(Packages.PropTypes.object)
      // In case it contains date objects
    ])
  })
};
const DynamicTimePeriodMenu = withThemeOverrides(BaseDynamicTimePeriodMenu, DynamicTimePeriodMenuThemeConfig), dark$3 = (T) => ({
  MuiLink: {
    styleOverrides: {
      root: {
        fontFamily: T.typography.fontFamily,
        fontSize: "12px",
        fontWeight: T.typography.fontWeightSemiBold,
        color: T.colors.blue[95],
        textDecoration: "none"
      }
    }
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        background: T.colors.neutral[90],
        color: "white",
        width: "1px"
      }
    }
  }
}), light$3 = (T) => ({
  MuiLink: {
    styleOverrides: {
      root: {
        fontFamily: T.typography.fontFamily,
        fontSize: "12px",
        fontWeight: T.typography.fontWeightSemiBold,
        color: T.colors.blue[95],
        textDecoration: "none"
      }
    }
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        background: T.colors.neutral[90],
        color: "white",
        width: "1px"
      }
    }
  }
}), lg$3 = (T) => ({
  [T.breakpoints.up("lg")]: {
    fontSize: 16
  },
  [T.breakpoints.down("lg")]: {
    fontSize: 12
  }
}), md$3 = () => {
}, sm$3 = () => {
}, xl$3 = () => {
}, xs$3 = () => {
}, mediaQueries$2 = {
  lg: lg$3,
  md: md$3,
  sm: sm$3,
  xl: xl$3,
  xs: xs$3
}, BreadcrumbsThemeConfig = {
  dark: dark$3,
  light: light$3
}, Stack$3 = Packages.emotion.styled(Packages.Mui.Stack)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  gap: 8,
  height: 23
})), Link = Packages.emotion.styled(Packages.Mui.Link)(() => {
  const T = Packages.Mui.useTheme();
  return {
    ...mediaQueries$2.lg(T)
  };
}), BaseBreadcrumbs = ({
  links: T
}) => {
  const {
    Divider: S
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Stack$3, { children: T.map(({
    url: R,
    text: k
  }, D) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: R, children: k }),
    D !== T.length - 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(S, { orientation: "vertical" })
  ] }, D)) });
};
BaseBreadcrumbs.propTypes = {
  links: Packages.PropTypes.array
};
const Breadcrumbs = withThemeOverrides(BaseBreadcrumbs, BreadcrumbsThemeConfig), BaseLayer = ({
  ...T
}) => {
  const {
    Box: S
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(S, { ...T, children: T.children });
};
BaseLayer.propTypes = {
  children: Packages.PropTypes.node
};
const between$1 = (T, S) => ({
  [T.breakpoints.between("lg", "xl")]: {
    maxWidth: S.autowidth === "true" ? "auto" : "75vw",
    minWidth: S.autowidth === "true" ? "auto" : "56.5vw"
  },
  [T.breakpoints.between("md", "lg")]: {
    maxWidth: S.autowidth === "true" ? "auto" : "85vw",
    minWidth: S.autowidth === "true" ? "auto" : "80vw"
  },
  [T.breakpoints.between("sm", "md")]: {
    maxWidth: S.autowidth === "true" ? "auto" : "85vw",
    minWidth: S.autowidth === "true" ? "auto" : "80vw",
    borderRadius: "1.25rem"
  }
}), lg$2 = () => {
}, md$2 = () => {
}, sm$2 = (T) => ({
  [T.breakpoints.down("sm")]: {
    borderRadius: "1.25rem 1.25rem 0 0",
    width: "100%",
    marginTop: "1rem",
    height: "calc(100vh - 10%)",
    alignSelf: "end",
    padding: "1.5rem 1rem 1rem 1rem"
  }
}), xl$2 = (T, S) => ({
  [T.breakpoints.up("xl")]: {
    maxWidth: S.autowidth === "true" ? "auto" : "50vw",
    minWidth: S.autowidth === "true" ? "auto" : "45vw"
  }
}), xs$2 = (T) => ({
  [T.breakpoints.down("xs")]: {
    borderRadius: "1.25rem 1.25rem 0 0",
    width: "100%",
    marginTop: "1rem",
    height: "calc(100vh - 10%)",
    alignSelf: "end",
    padding: "1.5rem 1rem 1rem 1rem"
  }
}), mediaQueries$1 = {
  xl: xl$2,
  lg: lg$2,
  md: md$2,
  sm: sm$2,
  xs: xs$2,
  between: between$1
}, GeneralBaseLayer = Packages.emotion.styled(BaseLayer)(() => {
  const T = Packages.Mui.useTheme();
  return {
    borderRadius: "1.25rem",
    border: "none",
    background: T.validateMode({
      light: T.colors.neutral[110],
      dark: T.background(5)
    }),
    boxShadow: T.shadow(8),
    color: T.validateMode({
      light: T.colors.neutral[40],
      dark: T.colors.neutral[90]
    }),
    padding: "1.25rem"
  };
}), GlassBaseLayer = Packages.emotion.styled(BaseLayer)(() => {
  const T = Packages.Mui.useTheme();
  return `
      font-family: ${T.typography.fontFamily};
      color: ${T.colors.neutral[100]};
      border-radius: 1.25rem;
      border: 1px solid ${T.colors.neutral[60]};
      background: ${T.colors.surface.glass[0]};
      box-shadow: ${T.shadow(7)};
      backdrop-filter: blur(40px);
      width: 100%;
      padding: 1.25rem;
    `;
}), LoginBaseLayer = Packages.emotion.styled(BaseLayer)((T) => {
  const S = Packages.Mui.useTheme();
  return {
    fontFamily: S.typography.fontFamily,
    color: S.colors.neutral[100],
    borderRadius: "1.25rem",
    border: `1px solid ${S.colors.neutral[60]}`,
    background: S.colors.surface.glass[0],
    boxShadow: S.shadow(7),
    backdropFilter: "blur(40px)",
    padding: "2.5rem",
    textAlign: "center",
    ...mediaQueries$1.xl(S, T),
    ...mediaQueries$1.between(S, T),
    ...mediaQueries$1.sm(S),
    ...mediaQueries$1.xs(S)
  };
}), General = (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(GeneralBaseLayer, { ...T, children: T.children });
General.propTypes = {
  type: Packages.PropTypes.string,
  children: Packages.PropTypes.node
};
const Glass = (T) => /* @__PURE__ */ jsxRuntimeExports.jsx(GlassBaseLayer, { ...T, children: T.children });
Glass.propTypes = {
  type: Packages.PropTypes.string,
  children: Packages.PropTypes.node
};
const LoginFlow = ({
  autowidth: T,
  ...S
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(LoginBaseLayer, { ...S, autowidth: T?.toString(), children: S.children });
LoginFlow.propTypes = {
  type: Packages.PropTypes.string,
  children: Packages.PropTypes.node,
  autowidth: Packages.PropTypes.bool
};
const Layer = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    case "glass":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Glass, { ...S });
    case "login-flow":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(LoginFlow, { ...S });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(General, { ...S });
  }
};
Layer.propTypes = {
  variant: Packages.PropTypes.oneOf(["glass", "login-flow"])
};
const v = "5.7.13", fr = 60, ip = 0, op = 241, w = 512, h = 512, nm = "Lines", ddd = 0, assets = [
  {
    id: "comp_0",
    nm: "All the layers",
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "5",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              408,
              280,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              56,
              184,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.667,
                        y: 1
                      },
                      o: {
                        x: 0.333,
                        y: 0
                      },
                      t: 17,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              128
                            ],
                            [
                              -16,
                              -128
                            ],
                            [
                              0,
                              -144
                            ],
                            [
                              16,
                              -128
                            ],
                            [
                              16,
                              128
                            ],
                            [
                              0,
                              144
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.667,
                        y: 1
                      },
                      o: {
                        x: 0.333,
                        y: 0
                      },
                      t: 34,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              60.25
                            ],
                            [
                              -16,
                              -59.75
                            ],
                            [
                              0,
                              -75.75
                            ],
                            [
                              16,
                              -59.75
                            ],
                            [
                              16,
                              60.25
                            ],
                            [
                              0,
                              76.25
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 52,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              128
                            ],
                            [
                              -16,
                              -128
                            ],
                            [
                              0,
                              -144
                            ],
                            [
                              16,
                              -128
                            ],
                            [
                              16,
                              128
                            ],
                            [
                              0,
                              144
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    56,
                    184
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Group 1",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.9142,
                0.5723,
                0.4258,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          }
        ],
        ip: 0,
        op: 540,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "4",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              328,
              280,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              56,
              184,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.333,
                        y: 0
                      },
                      t: 13,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              128
                            ],
                            [
                              -16,
                              -128
                            ],
                            [
                              0,
                              -144
                            ],
                            [
                              16,
                              -128
                            ],
                            [
                              16,
                              128
                            ],
                            [
                              0,
                              144
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.667,
                        y: 1
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 30,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              60.25
                            ],
                            [
                              -16,
                              -59.75
                            ],
                            [
                              0,
                              -75.75
                            ],
                            [
                              16,
                              -59.75
                            ],
                            [
                              16,
                              60.25
                            ],
                            [
                              0,
                              76.25
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 48,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              128
                            ],
                            [
                              -16,
                              -128
                            ],
                            [
                              0,
                              -144
                            ],
                            [
                              16,
                              -128
                            ],
                            [
                              16,
                              128
                            ],
                            [
                              0,
                              144
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    56,
                    184
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Group 1",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.8632,
                0.5507,
                0.4168,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          }
        ],
        ip: 0,
        op: 540,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "3",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              248,
              280,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              56,
              184,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.333,
                        y: 0
                      },
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              128
                            ],
                            [
                              -16,
                              -128
                            ],
                            [
                              0,
                              -144
                            ],
                            [
                              16,
                              -128
                            ],
                            [
                              16,
                              128
                            ],
                            [
                              0,
                              144
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.667,
                        y: 1
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      t: 26,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              61
                            ],
                            [
                              -16,
                              -59.5
                            ],
                            [
                              0,
                              -75.5
                            ],
                            [
                              16,
                              -59.5
                            ],
                            [
                              16,
                              61
                            ],
                            [
                              0,
                              77
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 44,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              128
                            ],
                            [
                              -16,
                              -128
                            ],
                            [
                              0,
                              -144
                            ],
                            [
                              16,
                              -128
                            ],
                            [
                              16,
                              128
                            ],
                            [
                              0,
                              144
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    56,
                    184
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Group 1",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.9951,
                0.316,
                0.0249,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          }
        ],
        ip: 0,
        op: 540,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "2",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              168,
              280,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              56,
              184,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.667,
                        y: 1
                      },
                      o: {
                        x: 0.333,
                        y: 0
                      },
                      t: 5,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              128
                            ],
                            [
                              -16,
                              -128
                            ],
                            [
                              0,
                              -144
                            ],
                            [
                              16,
                              -128
                            ],
                            [
                              16,
                              128
                            ],
                            [
                              0,
                              144
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.667,
                        y: 1
                      },
                      o: {
                        x: 0.333,
                        y: 0
                      },
                      t: 22,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              61
                            ],
                            [
                              -16,
                              -60
                            ],
                            [
                              0,
                              -76
                            ],
                            [
                              16,
                              -60
                            ],
                            [
                              16,
                              61
                            ],
                            [
                              0,
                              77
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 40,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              128
                            ],
                            [
                              -16,
                              -128
                            ],
                            [
                              0,
                              -144
                            ],
                            [
                              16,
                              -128
                            ],
                            [
                              16,
                              128
                            ],
                            [
                              0,
                              144
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    56,
                    184
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Group 1",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                1,
                0.3098,
                78e-4,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          }
        ],
        ip: 0,
        op: 540,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              88,
              280,
              0
            ],
            ix: 2,
            l: 2
          },
          a: {
            a: 0,
            k: [
              56,
              184,
              0
            ],
            ix: 1,
            l: 2
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6,
            l: 2
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.667,
                        y: 1
                      },
                      o: {
                        x: 0.333,
                        y: 0
                      },
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              128
                            ],
                            [
                              -16,
                              -128
                            ],
                            [
                              0,
                              -144
                            ],
                            [
                              16,
                              -128
                            ],
                            [
                              16,
                              128
                            ],
                            [
                              0,
                              144
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.667,
                        y: 1
                      },
                      o: {
                        x: 0.333,
                        y: 0
                      },
                      t: 17,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              61
                            ],
                            [
                              -16,
                              -60
                            ],
                            [
                              0,
                              -76
                            ],
                            [
                              16,
                              -60
                            ],
                            [
                              16,
                              61
                            ],
                            [
                              0,
                              77
                            ]
                          ],
                          c: !0
                        }
                      ]
                    },
                    {
                      t: 35,
                      s: [
                        {
                          i: [
                            [
                              0,
                              8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              -8.8,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              8.8,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              -8.8
                            ],
                            [
                              8.8,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              8.8
                            ],
                            [
                              -8.8,
                              0
                            ]
                          ],
                          v: [
                            [
                              -16,
                              128
                            ],
                            [
                              -16,
                              -128
                            ],
                            [
                              0,
                              -144
                            ],
                            [
                              16,
                              -128
                            ],
                            [
                              16,
                              128
                            ],
                            [
                              0,
                              144
                            ]
                          ],
                          c: !0
                        }
                      ]
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: !1
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    56,
                    184
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Group 1",
            np: 2,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: !1
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.9297,
                0.5101,
                0.3303,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            bm: 0,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: !1
          }
        ],
        ip: 0,
        op: 540,
        st: 0,
        bm: 0
      }
    ]
  }
], layers = [
  {
    ddd: 0,
    ind: 1,
    ty: 0,
    nm: "All the layers",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          256,
          256,
          0
        ],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [
          256,
          256,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 512,
    h: 512,
    ip: 179,
    op: 243,
    st: 179,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 0,
    nm: "All the layers",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          256,
          256,
          0
        ],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [
          256,
          256,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 512,
    h: 512,
    ip: 119,
    op: 179,
    st: 119,
    bm: 0
  },
  {
    ddd: 0,
    ind: 3,
    ty: 0,
    nm: "All the layers",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          256,
          256,
          0
        ],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [
          256,
          256,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 512,
    h: 512,
    ip: 60,
    op: 120,
    st: 60,
    bm: 0
  },
  {
    ddd: 0,
    ind: 4,
    ty: 0,
    nm: "All the layers",
    refId: "comp_0",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          256,
          256,
          0
        ],
        ix: 2,
        l: 2
      },
      a: {
        a: 0,
        k: [
          256,
          256,
          0
        ],
        ix: 1,
        l: 2
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6,
        l: 2
      }
    },
    ao: 0,
    w: 512,
    h: 512,
    ip: 0,
    op: 60,
    st: 0,
    bm: 0
  }
], markers = [], animation = {
  v,
  fr,
  ip,
  op,
  w,
  h,
  nm,
  ddd,
  assets,
  layers,
  markers
};
var lottie$1 = { exports: {} };
(function(module, exports) {
  typeof navigator < "u" && function(T, S) {
    module.exports = S();
  }(commonjsGlobal, function() {
    var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(S) {
      _useWebWorker = !!S;
    }, getWebWorker = function() {
      return _useWebWorker;
    }, setLocationHref = function(S) {
      locationHref = S;
    }, getLocationHref = function() {
      return locationHref;
    };
    function createTag(T) {
      return document.createElement(T);
    }
    function extendPrototype(T, S) {
      var R, k = T.length, D;
      for (R = 0; R < k; R += 1) {
        D = T[R].prototype;
        for (var L in D)
          Object.prototype.hasOwnProperty.call(D, L) && (S.prototype[L] = D[L]);
      }
    }
    function getDescriptor(T, S) {
      return Object.getOwnPropertyDescriptor(T, S);
    }
    function createProxyFunction(T) {
      function S() {
      }
      return S.prototype = T, S;
    }
    var audioControllerFactory = function() {
      function T(S) {
        this.audios = [], this.audioFactory = S, this._volume = 1, this._isMuted = !1;
      }
      return T.prototype = {
        addAudio: function(R) {
          this.audios.push(R);
        },
        pause: function() {
          var R, k = this.audios.length;
          for (R = 0; R < k; R += 1)
            this.audios[R].pause();
        },
        resume: function() {
          var R, k = this.audios.length;
          for (R = 0; R < k; R += 1)
            this.audios[R].resume();
        },
        setRate: function(R) {
          var k, D = this.audios.length;
          for (k = 0; k < D; k += 1)
            this.audios[k].setRate(R);
        },
        createAudio: function(R) {
          return this.audioFactory ? this.audioFactory(R) : window.Howl ? new window.Howl({
            src: [R]
          }) : {
            isPlaying: !1,
            play: function() {
              this.isPlaying = !0;
            },
            seek: function() {
              this.isPlaying = !1;
            },
            playing: function() {
            },
            rate: function() {
            },
            setVolume: function() {
            }
          };
        },
        setAudioFactory: function(R) {
          this.audioFactory = R;
        },
        setVolume: function(R) {
          this._volume = R, this._updateVolume();
        },
        mute: function() {
          this._isMuted = !0, this._updateVolume();
        },
        unmute: function() {
          this._isMuted = !1, this._updateVolume();
        },
        getVolume: function() {
          return this._volume;
        },
        _updateVolume: function() {
          var R, k = this.audios.length;
          for (R = 0; R < k; R += 1)
            this.audios[R].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }, function() {
        return new T();
      };
    }(), createTypedArray = /* @__PURE__ */ function() {
      function T(R, k) {
        var D = 0, L = [], V;
        switch (R) {
          case "int16":
          case "uint8c":
            V = 1;
            break;
          default:
            V = 1.1;
            break;
        }
        for (D = 0; D < k; D += 1)
          L.push(V);
        return L;
      }
      function S(R, k) {
        return R === "float32" ? new Float32Array(k) : R === "int16" ? new Int16Array(k) : R === "uint8c" ? new Uint8ClampedArray(k) : T(R, k);
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? S : T;
    }();
    function createSizedArray(T) {
      return Array.apply(null, {
        length: T
      });
    }
    function _typeof$6(T) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$6 = function(R) {
        return typeof R;
      } : _typeof$6 = function(R) {
        return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
      }, _typeof$6(T);
    }
    var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
    (function() {
      var T = ["abs", "acos", "acosh", "asin", "asinh", "atan", "atanh", "atan2", "ceil", "cbrt", "expm1", "clz32", "cos", "cosh", "exp", "floor", "fround", "hypot", "imul", "log", "log1p", "log2", "log10", "max", "min", "pow", "random", "round", "sign", "sin", "sinh", "sqrt", "tan", "tanh", "trunc", "E", "LN10", "LN2", "LOG10E", "LOG2E", "PI", "SQRT1_2", "SQRT2"], S, R = T.length;
      for (S = 0; S < R; S += 1)
        BMMath[T[S]] = Math[T[S]];
    })(), BMMath.random = Math.random, BMMath.abs = function(T) {
      var S = _typeof$6(T);
      if (S === "object" && T.length) {
        var R = createSizedArray(T.length), k, D = T.length;
        for (k = 0; k < D; k += 1)
          R[k] = Math.abs(T[k]);
        return R;
      }
      return Math.abs(T);
    };
    var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = 0.5519;
    function styleDiv(T) {
      T.style.position = "absolute", T.style.top = 0, T.style.left = 0, T.style.display = "block", T.style.transformOrigin = "0 0", T.style.webkitTransformOrigin = "0 0", T.style.backfaceVisibility = "visible", T.style.webkitBackfaceVisibility = "visible", T.style.transformStyle = "preserve-3d", T.style.webkitTransformStyle = "preserve-3d", T.style.mozTransformStyle = "preserve-3d";
    }
    function BMEnterFrameEvent(T, S, R, k) {
      this.type = T, this.currentTime = S, this.totalTime = R, this.direction = k < 0 ? -1 : 1;
    }
    function BMCompleteEvent(T, S) {
      this.type = T, this.direction = S < 0 ? -1 : 1;
    }
    function BMCompleteLoopEvent(T, S, R, k) {
      this.type = T, this.currentLoop = R, this.totalLoops = S, this.direction = k < 0 ? -1 : 1;
    }
    function BMSegmentStartEvent(T, S, R) {
      this.type = T, this.firstFrame = S, this.totalFrames = R;
    }
    function BMDestroyEvent(T, S) {
      this.type = T, this.target = S;
    }
    function BMRenderFrameErrorEvent(T, S) {
      this.type = "renderFrameError", this.nativeError = T, this.currentTime = S;
    }
    function BMConfigErrorEvent(T) {
      this.type = "configError", this.nativeError = T;
    }
    var createElementID = /* @__PURE__ */ function() {
      var T = 0;
      return function() {
        return T += 1, idPrefix$1 + "__lottie_element_" + T;
      };
    }();
    function HSVtoRGB(T, S, R) {
      var k, D, L, V, z, W, U, q;
      switch (V = Math.floor(T * 6), z = T * 6 - V, W = R * (1 - S), U = R * (1 - z * S), q = R * (1 - (1 - z) * S), V % 6) {
        case 0:
          k = R, D = q, L = W;
          break;
        case 1:
          k = U, D = R, L = W;
          break;
        case 2:
          k = W, D = R, L = q;
          break;
        case 3:
          k = W, D = U, L = R;
          break;
        case 4:
          k = q, D = W, L = R;
          break;
        case 5:
          k = R, D = W, L = U;
          break;
      }
      return [k, D, L];
    }
    function RGBtoHSV(T, S, R) {
      var k = Math.max(T, S, R), D = Math.min(T, S, R), L = k - D, V, z = k === 0 ? 0 : L / k, W = k / 255;
      switch (k) {
        case D:
          V = 0;
          break;
        case T:
          V = S - R + L * (S < R ? 6 : 0), V /= 6 * L;
          break;
        case S:
          V = R - T + L * 2, V /= 6 * L;
          break;
        case R:
          V = T - S + L * 4, V /= 6 * L;
          break;
      }
      return [V, z, W];
    }
    function addSaturationToRGB(T, S) {
      var R = RGBtoHSV(T[0] * 255, T[1] * 255, T[2] * 255);
      return R[1] += S, R[1] > 1 ? R[1] = 1 : R[1] <= 0 && (R[1] = 0), HSVtoRGB(R[0], R[1], R[2]);
    }
    function addBrightnessToRGB(T, S) {
      var R = RGBtoHSV(T[0] * 255, T[1] * 255, T[2] * 255);
      return R[2] += S, R[2] > 1 ? R[2] = 1 : R[2] < 0 && (R[2] = 0), HSVtoRGB(R[0], R[1], R[2]);
    }
    function addHueToRGB(T, S) {
      var R = RGBtoHSV(T[0] * 255, T[1] * 255, T[2] * 255);
      return R[0] += S / 360, R[0] > 1 ? R[0] -= 1 : R[0] < 0 && (R[0] += 1), HSVtoRGB(R[0], R[1], R[2]);
    }
    var rgbToHex = function() {
      var T = [], S, R;
      for (S = 0; S < 256; S += 1)
        R = S.toString(16), T[S] = R.length === 1 ? "0" + R : R;
      return function(k, D, L) {
        return k < 0 && (k = 0), D < 0 && (D = 0), L < 0 && (L = 0), "#" + T[k] + T[D] + T[L];
      };
    }(), setSubframeEnabled = function(S) {
      subframeEnabled = !!S;
    }, getSubframeEnabled = function() {
      return subframeEnabled;
    }, setExpressionsPlugin = function(S) {
      expressionsPlugin = S;
    }, getExpressionsPlugin = function() {
      return expressionsPlugin;
    }, setExpressionInterfaces = function(S) {
      expressionsInterfaces = S;
    }, getExpressionInterfaces = function() {
      return expressionsInterfaces;
    }, setDefaultCurveSegments = function(S) {
      defaultCurveSegments = S;
    }, getDefaultCurveSegments = function() {
      return defaultCurveSegments;
    }, setIdPrefix = function(S) {
      idPrefix$1 = S;
    };
    function createNS(T) {
      return document.createElementNS(svgNS, T);
    }
    function _typeof$5(T) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$5 = function(R) {
        return typeof R;
      } : _typeof$5 = function(R) {
        return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
      }, _typeof$5(T);
    }
    var dataManager = /* @__PURE__ */ function() {
      var T = 1, S = [], R, k, D = {
        onmessage: function() {
        },
        postMessage: function(J) {
          R({
            data: J
          });
        }
      }, L = {
        postMessage: function(J) {
          D.onmessage({
            data: J
          });
        }
      };
      function V(Y) {
        if (window.Worker && window.Blob && getWebWorker()) {
          var J = new Blob(["var _workerSelf = self; self.onmessage = ", Y.toString()], {
            type: "text/javascript"
          }), Z = URL.createObjectURL(J);
          return new Worker(Z);
        }
        return R = Y, D;
      }
      function z() {
        k || (k = V(function(J) {
          function Z() {
            function ee(fe, ue) {
              var Ce, ce, pe = fe.length, _e, ge, Ae, Ee;
              for (ce = 0; ce < pe; ce += 1)
                if (Ce = fe[ce], "ks" in Ce && !Ce.completed) {
                  if (Ce.completed = !0, Ce.hasMask) {
                    var ve = Ce.masksProperties;
                    for (ge = ve.length, _e = 0; _e < ge; _e += 1)
                      if (ve[_e].pt.k.i)
                        oe(ve[_e].pt.k);
                      else
                        for (Ee = ve[_e].pt.k.length, Ae = 0; Ae < Ee; Ae += 1)
                          ve[_e].pt.k[Ae].s && oe(ve[_e].pt.k[Ae].s[0]), ve[_e].pt.k[Ae].e && oe(ve[_e].pt.k[Ae].e[0]);
                  }
                  Ce.ty === 0 ? (Ce.layers = Q(Ce.refId, ue), ee(Ce.layers, ue)) : Ce.ty === 4 ? ne(Ce.shapes) : Ce.ty === 5 && ke(Ce);
                }
            }
            function te(fe, ue) {
              if (fe) {
                var Ce = 0, ce = fe.length;
                for (Ce = 0; Ce < ce; Ce += 1)
                  fe[Ce].t === 1 && (fe[Ce].data.layers = Q(fe[Ce].data.refId, ue), ee(fe[Ce].data.layers, ue));
              }
            }
            function re(fe, ue) {
              for (var Ce = 0, ce = ue.length; Ce < ce; ) {
                if (ue[Ce].id === fe)
                  return ue[Ce];
                Ce += 1;
              }
              return null;
            }
            function Q(fe, ue) {
              var Ce = re(fe, ue);
              return Ce ? Ce.layers.__used ? JSON.parse(JSON.stringify(Ce.layers)) : (Ce.layers.__used = !0, Ce.layers) : null;
            }
            function ne(fe) {
              var ue, Ce = fe.length, ce, pe;
              for (ue = Ce - 1; ue >= 0; ue -= 1)
                if (fe[ue].ty === "sh")
                  if (fe[ue].ks.k.i)
                    oe(fe[ue].ks.k);
                  else
                    for (pe = fe[ue].ks.k.length, ce = 0; ce < pe; ce += 1)
                      fe[ue].ks.k[ce].s && oe(fe[ue].ks.k[ce].s[0]), fe[ue].ks.k[ce].e && oe(fe[ue].ks.k[ce].e[0]);
                else fe[ue].ty === "gr" && ne(fe[ue].it);
            }
            function oe(fe) {
              var ue, Ce = fe.i.length;
              for (ue = 0; ue < Ce; ue += 1)
                fe.i[ue][0] += fe.v[ue][0], fe.i[ue][1] += fe.v[ue][1], fe.o[ue][0] += fe.v[ue][0], fe.o[ue][1] += fe.v[ue][1];
            }
            function ae(fe, ue) {
              var Ce = ue ? ue.split(".") : [100, 100, 100];
              return fe[0] > Ce[0] ? !0 : Ce[0] > fe[0] ? !1 : fe[1] > Ce[1] ? !0 : Ce[1] > fe[1] ? !1 : fe[2] > Ce[2] ? !0 : Ce[2] > fe[2] ? !1 : null;
            }
            var se = /* @__PURE__ */ function() {
              var fe = [4, 4, 14];
              function ue(ce) {
                var pe = ce.t.d;
                ce.t.d = {
                  k: [{
                    s: pe,
                    t: 0
                  }]
                };
              }
              function Ce(ce) {
                var pe, _e = ce.length;
                for (pe = 0; pe < _e; pe += 1)
                  ce[pe].ty === 5 && ue(ce[pe]);
              }
              return function(ce) {
                if (ae(fe, ce.v) && (Ce(ce.layers), ce.assets)) {
                  var pe, _e = ce.assets.length;
                  for (pe = 0; pe < _e; pe += 1)
                    ce.assets[pe].layers && Ce(ce.assets[pe].layers);
                }
              };
            }(), ie = /* @__PURE__ */ function() {
              var fe = [4, 7, 99];
              return function(ue) {
                if (ue.chars && !ae(fe, ue.v)) {
                  var Ce, ce = ue.chars.length;
                  for (Ce = 0; Ce < ce; Ce += 1) {
                    var pe = ue.chars[Ce];
                    pe.data && pe.data.shapes && (ne(pe.data.shapes), pe.data.ip = 0, pe.data.op = 99999, pe.data.st = 0, pe.data.sr = 1, pe.data.ks = {
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      }
                    }, ue.chars[Ce].t || (pe.data.shapes.push({
                      ty: "no"
                    }), pe.data.shapes[0].it.push({
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      },
                      sk: {
                        k: 0,
                        a: 0
                      },
                      sa: {
                        k: 0,
                        a: 0
                      },
                      ty: "tr"
                    })));
                  }
                }
              };
            }(), he = /* @__PURE__ */ function() {
              var fe = [5, 7, 15];
              function ue(ce) {
                var pe = ce.t.p;
                typeof pe.a == "number" && (pe.a = {
                  a: 0,
                  k: pe.a
                }), typeof pe.p == "number" && (pe.p = {
                  a: 0,
                  k: pe.p
                }), typeof pe.r == "number" && (pe.r = {
                  a: 0,
                  k: pe.r
                });
              }
              function Ce(ce) {
                var pe, _e = ce.length;
                for (pe = 0; pe < _e; pe += 1)
                  ce[pe].ty === 5 && ue(ce[pe]);
              }
              return function(ce) {
                if (ae(fe, ce.v) && (Ce(ce.layers), ce.assets)) {
                  var pe, _e = ce.assets.length;
                  for (pe = 0; pe < _e; pe += 1)
                    ce.assets[pe].layers && Ce(ce.assets[pe].layers);
                }
              };
            }(), xe = /* @__PURE__ */ function() {
              var fe = [4, 1, 9];
              function ue(ce) {
                var pe, _e = ce.length, ge, Ae;
                for (pe = 0; pe < _e; pe += 1)
                  if (ce[pe].ty === "gr")
                    ue(ce[pe].it);
                  else if (ce[pe].ty === "fl" || ce[pe].ty === "st")
                    if (ce[pe].c.k && ce[pe].c.k[0].i)
                      for (Ae = ce[pe].c.k.length, ge = 0; ge < Ae; ge += 1)
                        ce[pe].c.k[ge].s && (ce[pe].c.k[ge].s[0] /= 255, ce[pe].c.k[ge].s[1] /= 255, ce[pe].c.k[ge].s[2] /= 255, ce[pe].c.k[ge].s[3] /= 255), ce[pe].c.k[ge].e && (ce[pe].c.k[ge].e[0] /= 255, ce[pe].c.k[ge].e[1] /= 255, ce[pe].c.k[ge].e[2] /= 255, ce[pe].c.k[ge].e[3] /= 255);
                    else
                      ce[pe].c.k[0] /= 255, ce[pe].c.k[1] /= 255, ce[pe].c.k[2] /= 255, ce[pe].c.k[3] /= 255;
              }
              function Ce(ce) {
                var pe, _e = ce.length;
                for (pe = 0; pe < _e; pe += 1)
                  ce[pe].ty === 4 && ue(ce[pe].shapes);
              }
              return function(ce) {
                if (ae(fe, ce.v) && (Ce(ce.layers), ce.assets)) {
                  var pe, _e = ce.assets.length;
                  for (pe = 0; pe < _e; pe += 1)
                    ce.assets[pe].layers && Ce(ce.assets[pe].layers);
                }
              };
            }(), Pe = /* @__PURE__ */ function() {
              var fe = [4, 4, 18];
              function ue(ce) {
                var pe, _e = ce.length, ge, Ae;
                for (pe = _e - 1; pe >= 0; pe -= 1)
                  if (ce[pe].ty === "sh")
                    if (ce[pe].ks.k.i)
                      ce[pe].ks.k.c = ce[pe].closed;
                    else
                      for (Ae = ce[pe].ks.k.length, ge = 0; ge < Ae; ge += 1)
                        ce[pe].ks.k[ge].s && (ce[pe].ks.k[ge].s[0].c = ce[pe].closed), ce[pe].ks.k[ge].e && (ce[pe].ks.k[ge].e[0].c = ce[pe].closed);
                  else ce[pe].ty === "gr" && ue(ce[pe].it);
              }
              function Ce(ce) {
                var pe, _e, ge = ce.length, Ae, Ee, ve, le;
                for (_e = 0; _e < ge; _e += 1) {
                  if (pe = ce[_e], pe.hasMask) {
                    var me = pe.masksProperties;
                    for (Ee = me.length, Ae = 0; Ae < Ee; Ae += 1)
                      if (me[Ae].pt.k.i)
                        me[Ae].pt.k.c = me[Ae].cl;
                      else
                        for (le = me[Ae].pt.k.length, ve = 0; ve < le; ve += 1)
                          me[Ae].pt.k[ve].s && (me[Ae].pt.k[ve].s[0].c = me[Ae].cl), me[Ae].pt.k[ve].e && (me[Ae].pt.k[ve].e[0].c = me[Ae].cl);
                  }
                  pe.ty === 4 && ue(pe.shapes);
                }
              }
              return function(ce) {
                if (ae(fe, ce.v) && (Ce(ce.layers), ce.assets)) {
                  var pe, _e = ce.assets.length;
                  for (pe = 0; pe < _e; pe += 1)
                    ce.assets[pe].layers && Ce(ce.assets[pe].layers);
                }
              };
            }();
            function Re(fe) {
              fe.__complete || (xe(fe), se(fe), ie(fe), he(fe), Pe(fe), ee(fe.layers, fe.assets), te(fe.chars, fe.assets), fe.__complete = !0);
            }
            function ke(fe) {
              fe.t.a.length === 0 && "m" in fe.t.p;
            }
            var Te = {};
            return Te.completeData = Re, Te.checkColors = xe, Te.checkChars = ie, Te.checkPathProperties = he, Te.checkShapes = Pe, Te.completeLayers = ee, Te;
          }
          if (L.dataManager || (L.dataManager = Z()), L.assetLoader || (L.assetLoader = /* @__PURE__ */ function() {
            function ee(re) {
              var Q = re.getResponseHeader("content-type");
              return Q && re.responseType === "json" && Q.indexOf("json") !== -1 || re.response && _typeof$5(re.response) === "object" ? re.response : re.response && typeof re.response == "string" ? JSON.parse(re.response) : re.responseText ? JSON.parse(re.responseText) : null;
            }
            function te(re, Q, ne, oe) {
              var ae, se = new XMLHttpRequest();
              try {
                se.responseType = "json";
              } catch {
              }
              se.onreadystatechange = function() {
                if (se.readyState === 4)
                  if (se.status === 200)
                    ae = ee(se), ne(ae);
                  else
                    try {
                      ae = ee(se), ne(ae);
                    } catch (ie) {
                      oe && oe(ie);
                    }
              };
              try {
                se.open(["G", "E", "T"].join(""), re, !0);
              } catch {
                se.open(["G", "E", "T"].join(""), Q + "/" + re, !0);
              }
              se.send();
            }
            return {
              load: te
            };
          }()), J.data.type === "loadAnimation")
            L.assetLoader.load(J.data.path, J.data.fullPath, function(ee) {
              L.dataManager.completeData(ee), L.postMessage({
                id: J.data.id,
                payload: ee,
                status: "success"
              });
            }, function() {
              L.postMessage({
                id: J.data.id,
                status: "error"
              });
            });
          else if (J.data.type === "complete") {
            var X = J.data.animation;
            L.dataManager.completeData(X), L.postMessage({
              id: J.data.id,
              payload: X,
              status: "success"
            });
          } else J.data.type === "loadData" && L.assetLoader.load(J.data.path, J.data.fullPath, function(ee) {
            L.postMessage({
              id: J.data.id,
              payload: ee,
              status: "success"
            });
          }, function() {
            L.postMessage({
              id: J.data.id,
              status: "error"
            });
          });
        }), k.onmessage = function(Y) {
          var J = Y.data, Z = J.id, X = S[Z];
          S[Z] = null, J.status === "success" ? X.onComplete(J.payload) : X.onError && X.onError();
        });
      }
      function W(Y, J) {
        T += 1;
        var Z = "processId_" + T;
        return S[Z] = {
          onComplete: Y,
          onError: J
        }, Z;
      }
      function U(Y, J, Z) {
        z();
        var X = W(J, Z);
        k.postMessage({
          type: "loadAnimation",
          path: Y,
          fullPath: window.location.origin + window.location.pathname,
          id: X
        });
      }
      function q(Y, J, Z) {
        z();
        var X = W(J, Z);
        k.postMessage({
          type: "loadData",
          path: Y,
          fullPath: window.location.origin + window.location.pathname,
          id: X
        });
      }
      function K(Y, J, Z) {
        z();
        var X = W(J, Z);
        k.postMessage({
          type: "complete",
          animation: Y,
          id: X
        });
      }
      return {
        loadAnimation: U,
        loadData: q,
        completeAnimation: K
      };
    }(), ImagePreloader = function() {
      var T = function() {
        var te = createTag("canvas");
        te.width = 1, te.height = 1;
        var re = te.getContext("2d");
        return re.fillStyle = "rgba(0,0,0,0)", re.fillRect(0, 0, 1, 1), te;
      }();
      function S() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function R() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function k(te, re, Q) {
        var ne = "";
        if (te.e)
          ne = te.p;
        else if (re) {
          var oe = te.p;
          oe.indexOf("images/") !== -1 && (oe = oe.split("/")[1]), ne = re + oe;
        } else
          ne = Q, ne += te.u ? te.u : "", ne += te.p;
        return ne;
      }
      function D(te) {
        var re = 0, Q = setInterval(function() {
          var ne = te.getBBox();
          (ne.width || re > 500) && (this._imageLoaded(), clearInterval(Q)), re += 1;
        }.bind(this), 50);
      }
      function L(te) {
        var re = k(te, this.assetsPath, this.path), Q = createNS("image");
        isSafari ? this.testImageLoaded(Q) : Q.addEventListener("load", this._imageLoaded, !1), Q.addEventListener("error", function() {
          ne.img = T, this._imageLoaded();
        }.bind(this), !1), Q.setAttributeNS("http://www.w3.org/1999/xlink", "href", re), this._elementHelper.append ? this._elementHelper.append(Q) : this._elementHelper.appendChild(Q);
        var ne = {
          img: Q,
          assetData: te
        };
        return ne;
      }
      function V(te) {
        var re = k(te, this.assetsPath, this.path), Q = createTag("img");
        Q.crossOrigin = "anonymous", Q.addEventListener("load", this._imageLoaded, !1), Q.addEventListener("error", function() {
          ne.img = T, this._imageLoaded();
        }.bind(this), !1), Q.src = re;
        var ne = {
          img: Q,
          assetData: te
        };
        return ne;
      }
      function z(te) {
        var re = {
          assetData: te
        }, Q = k(te, this.assetsPath, this.path);
        return dataManager.loadData(Q, function(ne) {
          re.img = ne, this._footageLoaded();
        }.bind(this), function() {
          re.img = {}, this._footageLoaded();
        }.bind(this)), re;
      }
      function W(te, re) {
        this.imagesLoadedCb = re;
        var Q, ne = te.length;
        for (Q = 0; Q < ne; Q += 1)
          te[Q].layers || (!te[Q].t || te[Q].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(te[Q]))) : te[Q].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(te[Q]))));
      }
      function U(te) {
        this.path = te || "";
      }
      function q(te) {
        this.assetsPath = te || "";
      }
      function K(te) {
        for (var re = 0, Q = this.images.length; re < Q; ) {
          if (this.images[re].assetData === te)
            return this.images[re].img;
          re += 1;
        }
        return null;
      }
      function Y() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }
      function J() {
        return this.totalImages === this.loadedAssets;
      }
      function Z() {
        return this.totalFootages === this.loadedFootagesCount;
      }
      function X(te, re) {
        te === "svg" ? (this._elementHelper = re, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      }
      function ee() {
        this._imageLoaded = S.bind(this), this._footageLoaded = R.bind(this), this.testImageLoaded = D.bind(this), this.createFootageData = z.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return ee.prototype = {
        loadAssets: W,
        setAssetsPath: q,
        setPath: U,
        loadedImages: J,
        loadedFootages: Z,
        destroy: Y,
        getAsset: K,
        createImgData: V,
        createImageData: L,
        imageLoaded: S,
        footageLoaded: R,
        setCacheType: X
      }, ee;
    }();
    function BaseEvent() {
    }
    BaseEvent.prototype = {
      triggerEvent: function(S, R) {
        if (this._cbs[S])
          for (var k = this._cbs[S], D = 0; D < k.length; D += 1)
            k[D](R);
      },
      addEventListener: function(S, R) {
        return this._cbs[S] || (this._cbs[S] = []), this._cbs[S].push(R), function() {
          this.removeEventListener(S, R);
        }.bind(this);
      },
      removeEventListener: function(S, R) {
        if (!R)
          this._cbs[S] = null;
        else if (this._cbs[S]) {
          for (var k = 0, D = this._cbs[S].length; k < D; )
            this._cbs[S][k] === R && (this._cbs[S].splice(k, 1), k -= 1, D -= 1), k += 1;
          this._cbs[S].length || (this._cbs[S] = null);
        }
      }
    };
    var markerParser = /* @__PURE__ */ function() {
      function T(S) {
        for (var R = S.split(`\r
`), k = {}, D, L = 0, V = 0; V < R.length; V += 1)
          D = R[V].split(":"), D.length === 2 && (k[D[0]] = D[1].trim(), L += 1);
        if (L === 0)
          throw new Error();
        return k;
      }
      return function(S) {
        for (var R = [], k = 0; k < S.length; k += 1) {
          var D = S[k], L = {
            time: D.tm,
            duration: D.dr
          };
          try {
            L.payload = JSON.parse(S[k].cm);
          } catch {
            try {
              L.payload = T(S[k].cm);
            } catch {
              L.payload = {
                name: S[k].cm
              };
            }
          }
          R.push(L);
        }
        return R;
      };
    }(), ProjectInterface = /* @__PURE__ */ function() {
      function T(S) {
        this.compositions.push(S);
      }
      return function() {
        function S(R) {
          for (var k = 0, D = this.compositions.length; k < D; ) {
            if (this.compositions[k].data && this.compositions[k].data.nm === R)
              return this.compositions[k].prepareFrame && this.compositions[k].data.xt && this.compositions[k].prepareFrame(this.currentFrame), this.compositions[k].compInterface;
            k += 1;
          }
          return null;
        }
        return S.compositions = [], S.currentFrame = 0, S.registerComposition = T, S;
      };
    }(), renderers = {}, registerRenderer = function(S, R) {
      renderers[S] = R;
    };
    function getRenderer(T) {
      return renderers[T];
    }
    function getRegisteredRenderer() {
      if (renderers.canvas)
        return "canvas";
      for (var T in renderers)
        if (renderers[T])
          return T;
      return "";
    }
    function _typeof$4(T) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$4 = function(R) {
        return typeof R;
      } : _typeof$4 = function(R) {
        return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
      }, _typeof$4(T);
    }
    var AnimationItem = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader(), this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
    };
    extendPrototype([BaseEvent], AnimationItem), AnimationItem.prototype.setParams = function(T) {
      (T.wrapper || T.container) && (this.wrapper = T.wrapper || T.container);
      var S = "svg";
      T.animType ? S = T.animType : T.renderer && (S = T.renderer);
      var R = getRenderer(S);
      this.renderer = new R(this, T.rendererSettings), this.imagePreloader.setCacheType(S, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = S, T.loop === "" || T.loop === null || T.loop === void 0 || T.loop === !0 ? this.loop = !0 : T.loop === !1 ? this.loop = !1 : this.loop = parseInt(T.loop, 10), this.autoplay = "autoplay" in T ? T.autoplay : !0, this.name = T.name ? T.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(T, "autoloadSegments") ? T.autoloadSegments : !0, this.assetsPath = T.assetsPath, this.initialSegment = T.initialSegment, T.audioFactory && this.audioController.setAudioFactory(T.audioFactory), T.animationData ? this.setupAnimation(T.animationData) : T.path && (T.path.lastIndexOf("\\") !== -1 ? this.path = T.path.substr(0, T.path.lastIndexOf("\\") + 1) : this.path = T.path.substr(0, T.path.lastIndexOf("/") + 1), this.fileName = T.path.substr(T.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(T.path, this.configAnimation, this.onSetupError));
    }, AnimationItem.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, AnimationItem.prototype.setupAnimation = function(T) {
      dataManager.completeAnimation(T, this.configAnimation);
    }, AnimationItem.prototype.setData = function(T, S) {
      S && _typeof$4(S) !== "object" && (S = JSON.parse(S));
      var R = {
        wrapper: T,
        animationData: S
      }, k = T.attributes;
      R.path = k.getNamedItem("data-animation-path") ? k.getNamedItem("data-animation-path").value : k.getNamedItem("data-bm-path") ? k.getNamedItem("data-bm-path").value : k.getNamedItem("bm-path") ? k.getNamedItem("bm-path").value : "", R.animType = k.getNamedItem("data-anim-type") ? k.getNamedItem("data-anim-type").value : k.getNamedItem("data-bm-type") ? k.getNamedItem("data-bm-type").value : k.getNamedItem("bm-type") ? k.getNamedItem("bm-type").value : k.getNamedItem("data-bm-renderer") ? k.getNamedItem("data-bm-renderer").value : k.getNamedItem("bm-renderer") ? k.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
      var D = k.getNamedItem("data-anim-loop") ? k.getNamedItem("data-anim-loop").value : k.getNamedItem("data-bm-loop") ? k.getNamedItem("data-bm-loop").value : k.getNamedItem("bm-loop") ? k.getNamedItem("bm-loop").value : "";
      D === "false" ? R.loop = !1 : D === "true" ? R.loop = !0 : D !== "" && (R.loop = parseInt(D, 10));
      var L = k.getNamedItem("data-anim-autoplay") ? k.getNamedItem("data-anim-autoplay").value : k.getNamedItem("data-bm-autoplay") ? k.getNamedItem("data-bm-autoplay").value : k.getNamedItem("bm-autoplay") ? k.getNamedItem("bm-autoplay").value : !0;
      R.autoplay = L !== "false", R.name = k.getNamedItem("data-name") ? k.getNamedItem("data-name").value : k.getNamedItem("data-bm-name") ? k.getNamedItem("data-bm-name").value : k.getNamedItem("bm-name") ? k.getNamedItem("bm-name").value : "";
      var V = k.getNamedItem("data-anim-prerender") ? k.getNamedItem("data-anim-prerender").value : k.getNamedItem("data-bm-prerender") ? k.getNamedItem("data-bm-prerender").value : k.getNamedItem("bm-prerender") ? k.getNamedItem("bm-prerender").value : "";
      V === "false" && (R.prerender = !1), R.path ? this.setParams(R) : this.trigger("destroy");
    }, AnimationItem.prototype.includeLayers = function(T) {
      T.op > this.animationData.op && (this.animationData.op = T.op, this.totalFrames = Math.floor(T.op - this.animationData.ip));
      var S = this.animationData.layers, R, k = S.length, D = T.layers, L, V = D.length;
      for (L = 0; L < V; L += 1)
        for (R = 0; R < k; ) {
          if (S[R].id === D[L].id) {
            S[R] = D[L];
            break;
          }
          R += 1;
        }
      if ((T.chars || T.fonts) && (this.renderer.globalData.fontManager.addChars(T.chars), this.renderer.globalData.fontManager.addFonts(T.fonts, this.renderer.globalData.defs)), T.assets)
        for (k = T.assets.length, R = 0; R < k; R += 1)
          this.animationData.assets.push(T.assets[R]);
      this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
    }, AnimationItem.prototype.onSegmentComplete = function(T) {
      this.animationData = T;
      var S = getExpressionsPlugin();
      S && S.initExpressions(this), this.loadNextSegment();
    }, AnimationItem.prototype.loadNextSegment = function() {
      var T = this.animationData.segments;
      if (!T || T.length === 0 || !this.autoloadSegments) {
        this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
        return;
      }
      var S = T.shift();
      this.timeCompleted = S.time * this.frameRate;
      var R = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, dataManager.loadData(R, this.includeLayers.bind(this), function() {
        this.trigger("data_failed");
      }.bind(this));
    }, AnimationItem.prototype.loadSegments = function() {
      var T = this.animationData.segments;
      T || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, AnimationItem.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, AnimationItem.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, AnimationItem.prototype.configAnimation = function(T) {
      if (this.renderer)
        try {
          this.animationData = T, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(T), T.assets || (T.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(T.assets), this.markers = markerParser(T.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (S) {
          this.triggerConfigError(S);
        }
    }, AnimationItem.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, AnimationItem.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var T = getExpressionsPlugin();
        T && T.initExpressions(this), this.renderer.initItems(), setTimeout(function() {
          this.trigger("DOMLoaded");
        }.bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, AnimationItem.prototype.resize = function(T, S) {
      var R = typeof T == "number" ? T : void 0, k = typeof S == "number" ? S : void 0;
      this.renderer.updateContainerSize(R, k);
    }, AnimationItem.prototype.setSubframe = function(T) {
      this.isSubframeEnabled = !!T;
    }, AnimationItem.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, AnimationItem.prototype.renderFrame = function() {
      if (!(this.isLoaded === !1 || !this.renderer))
        try {
          this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (T) {
          this.triggerRenderFrameError(T);
        }
    }, AnimationItem.prototype.play = function(T) {
      T && this.name !== T || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, AnimationItem.prototype.pause = function(T) {
      T && this.name !== T || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, AnimationItem.prototype.togglePause = function(T) {
      T && this.name !== T || (this.isPaused === !0 ? this.play() : this.pause());
    }, AnimationItem.prototype.stop = function(T) {
      T && this.name !== T || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, AnimationItem.prototype.getMarkerData = function(T) {
      for (var S, R = 0; R < this.markers.length; R += 1)
        if (S = this.markers[R], S.payload && S.payload.name === T)
          return S;
      return null;
    }, AnimationItem.prototype.goToAndStop = function(T, S, R) {
      if (!(R && this.name !== R)) {
        var k = Number(T);
        if (isNaN(k)) {
          var D = this.getMarkerData(T);
          D && this.goToAndStop(D.time, !0);
        } else S ? this.setCurrentRawFrameValue(T) : this.setCurrentRawFrameValue(T * this.frameModifier);
        this.pause();
      }
    }, AnimationItem.prototype.goToAndPlay = function(T, S, R) {
      if (!(R && this.name !== R)) {
        var k = Number(T);
        if (isNaN(k)) {
          var D = this.getMarkerData(T);
          D && (D.duration ? this.playSegments([D.time, D.time + D.duration], !0) : this.goToAndStop(D.time, !0));
        } else
          this.goToAndStop(k, S, R);
        this.play();
      }
    }, AnimationItem.prototype.advanceTime = function(T) {
      if (!(this.isPaused === !0 || this.isLoaded === !1)) {
        var S = this.currentRawFrame + T * this.frameModifier, R = !1;
        S >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(S > this.totalFrames ? S % this.totalFrames : 0) || (R = !0, S = this.totalFrames - 1) : S >= this.totalFrames ? (this.playCount += 1, this.checkSegments(S % this.totalFrames) || (this.setCurrentRawFrameValue(S % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(S) : S < 0 ? this.checkSegments(S % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + S % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (R = !0, S = 0)) : this.setCurrentRawFrameValue(S), R && (this.setCurrentRawFrameValue(S), this.pause(), this.trigger("complete"));
      }
    }, AnimationItem.prototype.adjustSegment = function(T, S) {
      this.playCount = 0, T[1] < T[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = T[0] - T[1], this.timeCompleted = this.totalFrames, this.firstFrame = T[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - S)) : T[1] > T[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = T[1] - T[0], this.timeCompleted = this.totalFrames, this.firstFrame = T[0], this.setCurrentRawFrameValue(1e-3 + S)), this.trigger("segmentStart");
    }, AnimationItem.prototype.setSegment = function(T, S) {
      var R = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < T ? R = T : this.currentRawFrame + this.firstFrame > S && (R = S - T)), this.firstFrame = T, this.totalFrames = S - T, this.timeCompleted = this.totalFrames, R !== -1 && this.goToAndStop(R, !0);
    }, AnimationItem.prototype.playSegments = function(T, S) {
      if (S && (this.segments.length = 0), _typeof$4(T[0]) === "object") {
        var R, k = T.length;
        for (R = 0; R < k; R += 1)
          this.segments.push(T[R]);
      } else
        this.segments.push(T);
      this.segments.length && S && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, AnimationItem.prototype.resetSegments = function(T) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), T && this.checkSegments(0);
    }, AnimationItem.prototype.checkSegments = function(T) {
      return this.segments.length ? (this.adjustSegment(this.segments.shift(), T), !0) : !1;
    }, AnimationItem.prototype.destroy = function(T) {
      T && this.name !== T || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
    }, AnimationItem.prototype.setCurrentRawFrameValue = function(T) {
      this.currentRawFrame = T, this.gotoFrame();
    }, AnimationItem.prototype.setSpeed = function(T) {
      this.playSpeed = T, this.updaFrameModifier();
    }, AnimationItem.prototype.setDirection = function(T) {
      this.playDirection = T < 0 ? -1 : 1, this.updaFrameModifier();
    }, AnimationItem.prototype.setLoop = function(T) {
      this.loop = T;
    }, AnimationItem.prototype.setVolume = function(T, S) {
      S && this.name !== S || this.audioController.setVolume(T);
    }, AnimationItem.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, AnimationItem.prototype.mute = function(T) {
      T && this.name !== T || this.audioController.mute();
    }, AnimationItem.prototype.unmute = function(T) {
      T && this.name !== T || this.audioController.unmute();
    }, AnimationItem.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, AnimationItem.prototype.getPath = function() {
      return this.path;
    }, AnimationItem.prototype.getAssetsPath = function(T) {
      var S = "";
      if (T.e)
        S = T.p;
      else if (this.assetsPath) {
        var R = T.p;
        R.indexOf("images/") !== -1 && (R = R.split("/")[1]), S = this.assetsPath + R;
      } else
        S = this.path, S += T.u ? T.u : "", S += T.p;
      return S;
    }, AnimationItem.prototype.getAssetData = function(T) {
      for (var S = 0, R = this.assets.length; S < R; ) {
        if (T === this.assets[S].id)
          return this.assets[S];
        S += 1;
      }
      return null;
    }, AnimationItem.prototype.hide = function() {
      this.renderer.hide();
    }, AnimationItem.prototype.show = function() {
      this.renderer.show();
    }, AnimationItem.prototype.getDuration = function(T) {
      return T ? this.totalFrames : this.totalFrames / this.frameRate;
    }, AnimationItem.prototype.updateDocumentData = function(T, S, R) {
      try {
        var k = this.renderer.getElementByPath(T);
        k.updateDocumentData(S, R);
      } catch {
      }
    }, AnimationItem.prototype.trigger = function(T) {
      if (this._cbs && this._cbs[T])
        switch (T) {
          case "enterFrame":
            this.triggerEvent(T, new BMEnterFrameEvent(T, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
          case "drawnFrame":
            this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(T, this.drawnFrameEvent);
            break;
          case "loopComplete":
            this.triggerEvent(T, new BMCompleteLoopEvent(T, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(T, new BMCompleteEvent(T, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(T, new BMSegmentStartEvent(T, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(T, new BMDestroyEvent(T, this));
            break;
          default:
            this.triggerEvent(T);
        }
      T === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(T, this.currentFrame, this.totalFrames, this.frameMult)), T === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(T, this.loop, this.playCount, this.frameMult)), T === "complete" && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(T, this.frameMult)), T === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(T, this.firstFrame, this.totalFrames)), T === "destroy" && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(T, this));
    }, AnimationItem.prototype.triggerRenderFrameError = function(T) {
      var S = new BMRenderFrameErrorEvent(T, this.currentFrame);
      this.triggerEvent("error", S), this.onError && this.onError.call(this, S);
    }, AnimationItem.prototype.triggerConfigError = function(T) {
      var S = new BMConfigErrorEvent(T, this.currentFrame);
      this.triggerEvent("error", S), this.onError && this.onError.call(this, S);
    };
    var animationManager = function() {
      var T = {}, S = [], R = 0, k = 0, D = 0, L = !0, V = !1;
      function z(ue) {
        for (var Ce = 0, ce = ue.target; Ce < k; )
          S[Ce].animation === ce && (S.splice(Ce, 1), Ce -= 1, k -= 1, ce.isPaused || K()), Ce += 1;
      }
      function W(ue, Ce) {
        if (!ue)
          return null;
        for (var ce = 0; ce < k; ) {
          if (S[ce].elem === ue && S[ce].elem !== null)
            return S[ce].animation;
          ce += 1;
        }
        var pe = new AnimationItem();
        return Y(pe, ue), pe.setData(ue, Ce), pe;
      }
      function U() {
        var ue, Ce = S.length, ce = [];
        for (ue = 0; ue < Ce; ue += 1)
          ce.push(S[ue].animation);
        return ce;
      }
      function q() {
        D += 1, xe();
      }
      function K() {
        D -= 1;
      }
      function Y(ue, Ce) {
        ue.addEventListener("destroy", z), ue.addEventListener("_active", q), ue.addEventListener("_idle", K), S.push({
          elem: Ce,
          animation: ue
        }), k += 1;
      }
      function J(ue) {
        var Ce = new AnimationItem();
        return Y(Ce, null), Ce.setParams(ue), Ce;
      }
      function Z(ue, Ce) {
        var ce;
        for (ce = 0; ce < k; ce += 1)
          S[ce].animation.setSpeed(ue, Ce);
      }
      function X(ue, Ce) {
        var ce;
        for (ce = 0; ce < k; ce += 1)
          S[ce].animation.setDirection(ue, Ce);
      }
      function ee(ue) {
        var Ce;
        for (Ce = 0; Ce < k; Ce += 1)
          S[Ce].animation.play(ue);
      }
      function te(ue) {
        var Ce = ue - R, ce;
        for (ce = 0; ce < k; ce += 1)
          S[ce].animation.advanceTime(Ce);
        R = ue, D && !V ? window.requestAnimationFrame(te) : L = !0;
      }
      function re(ue) {
        R = ue, window.requestAnimationFrame(te);
      }
      function Q(ue) {
        var Ce;
        for (Ce = 0; Ce < k; Ce += 1)
          S[Ce].animation.pause(ue);
      }
      function ne(ue, Ce, ce) {
        var pe;
        for (pe = 0; pe < k; pe += 1)
          S[pe].animation.goToAndStop(ue, Ce, ce);
      }
      function oe(ue) {
        var Ce;
        for (Ce = 0; Ce < k; Ce += 1)
          S[Ce].animation.stop(ue);
      }
      function ae(ue) {
        var Ce;
        for (Ce = 0; Ce < k; Ce += 1)
          S[Ce].animation.togglePause(ue);
      }
      function se(ue) {
        var Ce;
        for (Ce = k - 1; Ce >= 0; Ce -= 1)
          S[Ce].animation.destroy(ue);
      }
      function ie(ue, Ce, ce) {
        var pe = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), _e, ge = pe.length;
        for (_e = 0; _e < ge; _e += 1)
          ce && pe[_e].setAttribute("data-bm-type", ce), W(pe[_e], ue);
        if (Ce && ge === 0) {
          ce || (ce = "svg");
          var Ae = document.getElementsByTagName("body")[0];
          Ae.innerText = "";
          var Ee = createTag("div");
          Ee.style.width = "100%", Ee.style.height = "100%", Ee.setAttribute("data-bm-type", ce), Ae.appendChild(Ee), W(Ee, ue);
        }
      }
      function he() {
        var ue;
        for (ue = 0; ue < k; ue += 1)
          S[ue].animation.resize();
      }
      function xe() {
        !V && D && L && (window.requestAnimationFrame(re), L = !1);
      }
      function Pe() {
        V = !0;
      }
      function Re() {
        V = !1, xe();
      }
      function ke(ue, Ce) {
        var ce;
        for (ce = 0; ce < k; ce += 1)
          S[ce].animation.setVolume(ue, Ce);
      }
      function Te(ue) {
        var Ce;
        for (Ce = 0; Ce < k; Ce += 1)
          S[Ce].animation.mute(ue);
      }
      function fe(ue) {
        var Ce;
        for (Ce = 0; Ce < k; Ce += 1)
          S[Ce].animation.unmute(ue);
      }
      return T.registerAnimation = W, T.loadAnimation = J, T.setSpeed = Z, T.setDirection = X, T.play = ee, T.pause = Q, T.stop = oe, T.togglePause = ae, T.searchAnimations = ie, T.resize = he, T.goToAndStop = ne, T.destroy = se, T.freeze = Pe, T.unfreeze = Re, T.setVolume = ke, T.mute = Te, T.unmute = fe, T.getRegisteredAnimations = U, T;
    }(), BezierFactory = function() {
      var T = {};
      T.getBezierEasing = R;
      var S = {};
      function R(re, Q, ne, oe, ae) {
        var se = ae || ("bez_" + re + "_" + Q + "_" + ne + "_" + oe).replace(/\./g, "p");
        if (S[se])
          return S[se];
        var ie = new te([re, Q, ne, oe]);
        return S[se] = ie, ie;
      }
      var k = 4, D = 1e-3, L = 1e-7, V = 10, z = 11, W = 1 / (z - 1), U = typeof Float32Array == "function";
      function q(re, Q) {
        return 1 - 3 * Q + 3 * re;
      }
      function K(re, Q) {
        return 3 * Q - 6 * re;
      }
      function Y(re) {
        return 3 * re;
      }
      function J(re, Q, ne) {
        return ((q(Q, ne) * re + K(Q, ne)) * re + Y(Q)) * re;
      }
      function Z(re, Q, ne) {
        return 3 * q(Q, ne) * re * re + 2 * K(Q, ne) * re + Y(Q);
      }
      function X(re, Q, ne, oe, ae) {
        var se, ie, he = 0;
        do
          ie = Q + (ne - Q) / 2, se = J(ie, oe, ae) - re, se > 0 ? ne = ie : Q = ie;
        while (Math.abs(se) > L && ++he < V);
        return ie;
      }
      function ee(re, Q, ne, oe) {
        for (var ae = 0; ae < k; ++ae) {
          var se = Z(Q, ne, oe);
          if (se === 0) return Q;
          var ie = J(Q, ne, oe) - re;
          Q -= ie / se;
        }
        return Q;
      }
      function te(re) {
        this._p = re, this._mSampleValues = U ? new Float32Array(z) : new Array(z), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return te.prototype = {
        get: function(Q) {
          var ne = this._p[0], oe = this._p[1], ae = this._p[2], se = this._p[3];
          return this._precomputed || this._precompute(), ne === oe && ae === se ? Q : Q === 0 ? 0 : Q === 1 ? 1 : J(this._getTForX(Q), oe, se);
        },
        // Private part
        _precompute: function() {
          var Q = this._p[0], ne = this._p[1], oe = this._p[2], ae = this._p[3];
          this._precomputed = !0, (Q !== ne || oe !== ae) && this._calcSampleValues();
        },
        _calcSampleValues: function() {
          for (var Q = this._p[0], ne = this._p[2], oe = 0; oe < z; ++oe)
            this._mSampleValues[oe] = J(oe * W, Q, ne);
        },
        /**
             * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
             */
        _getTForX: function(Q) {
          for (var ne = this._p[0], oe = this._p[2], ae = this._mSampleValues, se = 0, ie = 1, he = z - 1; ie !== he && ae[ie] <= Q; ++ie)
            se += W;
          --ie;
          var xe = (Q - ae[ie]) / (ae[ie + 1] - ae[ie]), Pe = se + xe * W, Re = Z(Pe, ne, oe);
          return Re >= D ? ee(Q, Pe, ne, oe) : Re === 0 ? Pe : X(Q, se, se + W, ne, oe);
        }
      }, T;
    }(), pooling = /* @__PURE__ */ function() {
      function T(S) {
        return S.concat(createSizedArray(S.length));
      }
      return {
        double: T
      };
    }(), poolFactory = /* @__PURE__ */ function() {
      return function(T, S, R) {
        var k = 0, D = T, L = createSizedArray(D), V = {
          newElement: z,
          release: W
        };
        function z() {
          var U;
          return k ? (k -= 1, U = L[k]) : U = S(), U;
        }
        function W(U) {
          k === D && (L = pooling.double(L), D *= 2), R && R(U), L[k] = U, k += 1;
        }
        return V;
      };
    }(), bezierLengthPool = function() {
      function T() {
        return {
          addedLength: 0,
          percents: createTypedArray("float32", getDefaultCurveSegments()),
          lengths: createTypedArray("float32", getDefaultCurveSegments())
        };
      }
      return poolFactory(8, T);
    }(), segmentsLengthPool = function() {
      function T() {
        return {
          lengths: [],
          totalLength: 0
        };
      }
      function S(R) {
        var k, D = R.lengths.length;
        for (k = 0; k < D; k += 1)
          bezierLengthPool.release(R.lengths[k]);
        R.lengths.length = 0;
      }
      return poolFactory(8, T, S);
    }();
    function bezFunction() {
      var T = Math;
      function S(Y, J, Z, X, ee, te) {
        var re = Y * X + J * ee + Z * te - ee * X - te * Y - Z * J;
        return re > -1e-3 && re < 1e-3;
      }
      function R(Y, J, Z, X, ee, te, re, Q, ne) {
        if (Z === 0 && te === 0 && ne === 0)
          return S(Y, J, X, ee, re, Q);
        var oe = T.sqrt(T.pow(X - Y, 2) + T.pow(ee - J, 2) + T.pow(te - Z, 2)), ae = T.sqrt(T.pow(re - Y, 2) + T.pow(Q - J, 2) + T.pow(ne - Z, 2)), se = T.sqrt(T.pow(re - X, 2) + T.pow(Q - ee, 2) + T.pow(ne - te, 2)), ie;
        return oe > ae ? oe > se ? ie = oe - ae - se : ie = se - ae - oe : se > ae ? ie = se - ae - oe : ie = ae - oe - se, ie > -1e-4 && ie < 1e-4;
      }
      var k = /* @__PURE__ */ function() {
        return function(Y, J, Z, X) {
          var ee = getDefaultCurveSegments(), te, re, Q, ne, oe, ae = 0, se, ie = [], he = [], xe = bezierLengthPool.newElement();
          for (Q = Z.length, te = 0; te < ee; te += 1) {
            for (oe = te / (ee - 1), se = 0, re = 0; re < Q; re += 1)
              ne = bmPow(1 - oe, 3) * Y[re] + 3 * bmPow(1 - oe, 2) * oe * Z[re] + 3 * (1 - oe) * bmPow(oe, 2) * X[re] + bmPow(oe, 3) * J[re], ie[re] = ne, he[re] !== null && (se += bmPow(ie[re] - he[re], 2)), he[re] = ie[re];
            se && (se = bmSqrt(se), ae += se), xe.percents[te] = oe, xe.lengths[te] = ae;
          }
          return xe.addedLength = ae, xe;
        };
      }();
      function D(Y) {
        var J = segmentsLengthPool.newElement(), Z = Y.c, X = Y.v, ee = Y.o, te = Y.i, re, Q = Y._length, ne = J.lengths, oe = 0;
        for (re = 0; re < Q - 1; re += 1)
          ne[re] = k(X[re], X[re + 1], ee[re], te[re + 1]), oe += ne[re].addedLength;
        return Z && Q && (ne[re] = k(X[re], X[0], ee[re], te[0]), oe += ne[re].addedLength), J.totalLength = oe, J;
      }
      function L(Y) {
        this.segmentLength = 0, this.points = new Array(Y);
      }
      function V(Y, J) {
        this.partialLength = Y, this.point = J;
      }
      var z = /* @__PURE__ */ function() {
        var Y = {};
        return function(J, Z, X, ee) {
          var te = (J[0] + "_" + J[1] + "_" + Z[0] + "_" + Z[1] + "_" + X[0] + "_" + X[1] + "_" + ee[0] + "_" + ee[1]).replace(/\./g, "p");
          if (!Y[te]) {
            var re = getDefaultCurveSegments(), Q, ne, oe, ae, se, ie = 0, he, xe, Pe = null;
            J.length === 2 && (J[0] !== Z[0] || J[1] !== Z[1]) && S(J[0], J[1], Z[0], Z[1], J[0] + X[0], J[1] + X[1]) && S(J[0], J[1], Z[0], Z[1], Z[0] + ee[0], Z[1] + ee[1]) && (re = 2);
            var Re = new L(re);
            for (oe = X.length, Q = 0; Q < re; Q += 1) {
              for (xe = createSizedArray(oe), se = Q / (re - 1), he = 0, ne = 0; ne < oe; ne += 1)
                ae = bmPow(1 - se, 3) * J[ne] + 3 * bmPow(1 - se, 2) * se * (J[ne] + X[ne]) + 3 * (1 - se) * bmPow(se, 2) * (Z[ne] + ee[ne]) + bmPow(se, 3) * Z[ne], xe[ne] = ae, Pe !== null && (he += bmPow(xe[ne] - Pe[ne], 2));
              he = bmSqrt(he), ie += he, Re.points[Q] = new V(he, xe), Pe = xe;
            }
            Re.segmentLength = ie, Y[te] = Re;
          }
          return Y[te];
        };
      }();
      function W(Y, J) {
        var Z = J.percents, X = J.lengths, ee = Z.length, te = bmFloor((ee - 1) * Y), re = Y * J.addedLength, Q = 0;
        if (te === ee - 1 || te === 0 || re === X[te])
          return Z[te];
        for (var ne = X[te] > re ? -1 : 1, oe = !0; oe; )
          if (X[te] <= re && X[te + 1] > re ? (Q = (re - X[te]) / (X[te + 1] - X[te]), oe = !1) : te += ne, te < 0 || te >= ee - 1) {
            if (te === ee - 1)
              return Z[te];
            oe = !1;
          }
        return Z[te] + (Z[te + 1] - Z[te]) * Q;
      }
      function U(Y, J, Z, X, ee, te) {
        var re = W(ee, te), Q = 1 - re, ne = T.round((Q * Q * Q * Y[0] + (re * Q * Q + Q * re * Q + Q * Q * re) * Z[0] + (re * re * Q + Q * re * re + re * Q * re) * X[0] + re * re * re * J[0]) * 1e3) / 1e3, oe = T.round((Q * Q * Q * Y[1] + (re * Q * Q + Q * re * Q + Q * Q * re) * Z[1] + (re * re * Q + Q * re * re + re * Q * re) * X[1] + re * re * re * J[1]) * 1e3) / 1e3;
        return [ne, oe];
      }
      var q = createTypedArray("float32", 8);
      function K(Y, J, Z, X, ee, te, re) {
        ee < 0 ? ee = 0 : ee > 1 && (ee = 1);
        var Q = W(ee, re);
        te = te > 1 ? 1 : te;
        var ne = W(te, re), oe, ae = Y.length, se = 1 - Q, ie = 1 - ne, he = se * se * se, xe = Q * se * se * 3, Pe = Q * Q * se * 3, Re = Q * Q * Q, ke = se * se * ie, Te = Q * se * ie + se * Q * ie + se * se * ne, fe = Q * Q * ie + se * Q * ne + Q * se * ne, ue = Q * Q * ne, Ce = se * ie * ie, ce = Q * ie * ie + se * ne * ie + se * ie * ne, pe = Q * ne * ie + se * ne * ne + Q * ie * ne, _e = Q * ne * ne, ge = ie * ie * ie, Ae = ne * ie * ie + ie * ne * ie + ie * ie * ne, Ee = ne * ne * ie + ie * ne * ne + ne * ie * ne, ve = ne * ne * ne;
        for (oe = 0; oe < ae; oe += 1)
          q[oe * 4] = T.round((he * Y[oe] + xe * Z[oe] + Pe * X[oe] + Re * J[oe]) * 1e3) / 1e3, q[oe * 4 + 1] = T.round((ke * Y[oe] + Te * Z[oe] + fe * X[oe] + ue * J[oe]) * 1e3) / 1e3, q[oe * 4 + 2] = T.round((Ce * Y[oe] + ce * Z[oe] + pe * X[oe] + _e * J[oe]) * 1e3) / 1e3, q[oe * 4 + 3] = T.round((ge * Y[oe] + Ae * Z[oe] + Ee * X[oe] + ve * J[oe]) * 1e3) / 1e3;
        return q;
      }
      return {
        getSegmentsLength: D,
        getNewSegment: K,
        getPointInSegment: U,
        buildBezierData: z,
        pointOnLine2D: S,
        pointOnLine3D: R
      };
    }
    var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
    function interpolateValue(T, S) {
      var R = this.offsetTime, k;
      this.propType === "multidimensional" && (k = createTypedArray("float32", this.pv.length));
      for (var D = S.lastIndex, L = D, V = this.keyframes.length - 1, z = !0, W, U, q; z; ) {
        if (W = this.keyframes[L], U = this.keyframes[L + 1], L === V - 1 && T >= U.t - R) {
          W.h && (W = U), D = 0;
          break;
        }
        if (U.t - R > T) {
          D = L;
          break;
        }
        L < V - 1 ? L += 1 : (D = 0, z = !1);
      }
      q = this.keyframesMetadata[L] || {};
      var K, Y, J, Z, X, ee, te = U.t - R, re = W.t - R, Q;
      if (W.to) {
        q.bezierData || (q.bezierData = bez.buildBezierData(W.s, U.s || W.e, W.to, W.ti));
        var ne = q.bezierData;
        if (T >= te || T < re) {
          var oe = T >= te ? ne.points.length - 1 : 0;
          for (Y = ne.points[oe].point.length, K = 0; K < Y; K += 1)
            k[K] = ne.points[oe].point[K];
        } else {
          q.__fnct ? ee = q.__fnct : (ee = BezierFactory.getBezierEasing(W.o.x, W.o.y, W.i.x, W.i.y, W.n).get, q.__fnct = ee), J = ee((T - re) / (te - re));
          var ae = ne.segmentLength * J, se, ie = S.lastFrame < T && S._lastKeyframeIndex === L ? S._lastAddedLength : 0;
          for (X = S.lastFrame < T && S._lastKeyframeIndex === L ? S._lastPoint : 0, z = !0, Z = ne.points.length; z; ) {
            if (ie += ne.points[X].partialLength, ae === 0 || J === 0 || X === ne.points.length - 1) {
              for (Y = ne.points[X].point.length, K = 0; K < Y; K += 1)
                k[K] = ne.points[X].point[K];
              break;
            } else if (ae >= ie && ae < ie + ne.points[X + 1].partialLength) {
              for (se = (ae - ie) / ne.points[X + 1].partialLength, Y = ne.points[X].point.length, K = 0; K < Y; K += 1)
                k[K] = ne.points[X].point[K] + (ne.points[X + 1].point[K] - ne.points[X].point[K]) * se;
              break;
            }
            X < Z - 1 ? X += 1 : z = !1;
          }
          S._lastPoint = X, S._lastAddedLength = ie - ne.points[X].partialLength, S._lastKeyframeIndex = L;
        }
      } else {
        var he, xe, Pe, Re, ke;
        if (V = W.s.length, Q = U.s || W.e, this.sh && W.h !== 1)
          if (T >= te)
            k[0] = Q[0], k[1] = Q[1], k[2] = Q[2];
          else if (T <= re)
            k[0] = W.s[0], k[1] = W.s[1], k[2] = W.s[2];
          else {
            var Te = createQuaternion(W.s), fe = createQuaternion(Q), ue = (T - re) / (te - re);
            quaternionToEuler(k, slerp(Te, fe, ue));
          }
        else
          for (L = 0; L < V; L += 1)
            W.h !== 1 && (T >= te ? J = 1 : T < re ? J = 0 : (W.o.x.constructor === Array ? (q.__fnct || (q.__fnct = []), q.__fnct[L] ? ee = q.__fnct[L] : (he = W.o.x[L] === void 0 ? W.o.x[0] : W.o.x[L], xe = W.o.y[L] === void 0 ? W.o.y[0] : W.o.y[L], Pe = W.i.x[L] === void 0 ? W.i.x[0] : W.i.x[L], Re = W.i.y[L] === void 0 ? W.i.y[0] : W.i.y[L], ee = BezierFactory.getBezierEasing(he, xe, Pe, Re).get, q.__fnct[L] = ee)) : q.__fnct ? ee = q.__fnct : (he = W.o.x, xe = W.o.y, Pe = W.i.x, Re = W.i.y, ee = BezierFactory.getBezierEasing(he, xe, Pe, Re).get, W.keyframeMetadata = ee), J = ee((T - re) / (te - re)))), Q = U.s || W.e, ke = W.h === 1 ? W.s[L] : W.s[L] + (Q[L] - W.s[L]) * J, this.propType === "multidimensional" ? k[L] = ke : k = ke;
      }
      return S.lastIndex = D, k;
    }
    function slerp(T, S, R) {
      var k = [], D = T[0], L = T[1], V = T[2], z = T[3], W = S[0], U = S[1], q = S[2], K = S[3], Y, J, Z, X, ee;
      return J = D * W + L * U + V * q + z * K, J < 0 && (J = -J, W = -W, U = -U, q = -q, K = -K), 1 - J > 1e-6 ? (Y = Math.acos(J), Z = Math.sin(Y), X = Math.sin((1 - R) * Y) / Z, ee = Math.sin(R * Y) / Z) : (X = 1 - R, ee = R), k[0] = X * D + ee * W, k[1] = X * L + ee * U, k[2] = X * V + ee * q, k[3] = X * z + ee * K, k;
    }
    function quaternionToEuler(T, S) {
      var R = S[0], k = S[1], D = S[2], L = S[3], V = Math.atan2(2 * k * L - 2 * R * D, 1 - 2 * k * k - 2 * D * D), z = Math.asin(2 * R * k + 2 * D * L), W = Math.atan2(2 * R * L - 2 * k * D, 1 - 2 * R * R - 2 * D * D);
      T[0] = V / degToRads, T[1] = z / degToRads, T[2] = W / degToRads;
    }
    function createQuaternion(T) {
      var S = T[0] * degToRads, R = T[1] * degToRads, k = T[2] * degToRads, D = Math.cos(S / 2), L = Math.cos(R / 2), V = Math.cos(k / 2), z = Math.sin(S / 2), W = Math.sin(R / 2), U = Math.sin(k / 2), q = D * L * V - z * W * U, K = z * W * V + D * L * U, Y = z * L * V + D * W * U, J = D * W * V - z * L * U;
      return [K, Y, J, q];
    }
    function getValueAtCurrentTime() {
      var T = this.comp.renderedFrame - this.offsetTime, S = this.keyframes[0].t - this.offsetTime, R = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(T === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= R && T >= R || this._caching.lastFrame < S && T < S))) {
        this._caching.lastFrame >= T && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var k = this.interpolateValue(T, this._caching);
        this.pv = k;
      }
      return this._caching.lastFrame = T, this.pv;
    }
    function setVValue(T) {
      var S;
      if (this.propType === "unidimensional")
        S = T * this.mult, mathAbs(this.v - S) > 1e-5 && (this.v = S, this._mdf = !0);
      else
        for (var R = 0, k = this.v.length; R < k; )
          S = T[R] * this.mult, mathAbs(this.v[R] - S) > 1e-5 && (this.v[R] = S, this._mdf = !0), R += 1;
    }
    function processEffectsSequence() {
      if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
        if (this.lock) {
          this.setVValue(this.pv);
          return;
        }
        this.lock = !0, this._mdf = this._isFirstFrame;
        var T, S = this.effectsSequence.length, R = this.kf ? this.pv : this.data.k;
        for (T = 0; T < S; T += 1)
          R = this.effectsSequence[T](R);
        this.setVValue(R), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function addEffect(T) {
      this.effectsSequence.push(T), this.container.addDynamicProperty(this);
    }
    function ValueProperty(T, S, R, k) {
      this.propType = "unidimensional", this.mult = R || 1, this.data = S, this.v = R ? S.k * R : S.k, this.pv = S.k, this._mdf = !1, this.elem = T, this.container = k, this.comp = T.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function MultiDimensionalProperty(T, S, R, k) {
      this.propType = "multidimensional", this.mult = R || 1, this.data = S, this._mdf = !1, this.elem = T, this.container = k, this.comp = T.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var D, L = S.k.length;
      for (this.v = createTypedArray("float32", L), this.pv = createTypedArray("float32", L), this.vel = createTypedArray("float32", L), D = 0; D < L; D += 1)
        this.v[D] = S.k[D] * this.mult, this.pv[D] = S.k[D];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
    }
    function KeyframedValueProperty(T, S, R, k) {
      this.propType = "unidimensional", this.keyframes = S.k, this.keyframesMetadata = [], this.offsetTime = T.data.st, this.frameId = -1, this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: 0,
        _lastKeyframeIndex: -1
      }, this.k = !0, this.kf = !0, this.data = S, this.mult = R || 1, this.elem = T, this.container = k, this.comp = T.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.addEffect = addEffect;
    }
    function KeyframedMultidimensionalProperty(T, S, R, k) {
      this.propType = "multidimensional";
      var D, L = S.k.length, V, z, W, U;
      for (D = 0; D < L - 1; D += 1)
        S.k[D].to && S.k[D].s && S.k[D + 1] && S.k[D + 1].s && (V = S.k[D].s, z = S.k[D + 1].s, W = S.k[D].to, U = S.k[D].ti, (V.length === 2 && !(V[0] === z[0] && V[1] === z[1]) && bez.pointOnLine2D(V[0], V[1], z[0], z[1], V[0] + W[0], V[1] + W[1]) && bez.pointOnLine2D(V[0], V[1], z[0], z[1], z[0] + U[0], z[1] + U[1]) || V.length === 3 && !(V[0] === z[0] && V[1] === z[1] && V[2] === z[2]) && bez.pointOnLine3D(V[0], V[1], V[2], z[0], z[1], z[2], V[0] + W[0], V[1] + W[1], V[2] + W[2]) && bez.pointOnLine3D(V[0], V[1], V[2], z[0], z[1], z[2], z[0] + U[0], z[1] + U[1], z[2] + U[2])) && (S.k[D].to = null, S.k[D].ti = null), V[0] === z[0] && V[1] === z[1] && W[0] === 0 && W[1] === 0 && U[0] === 0 && U[1] === 0 && (V.length === 2 || V[2] === z[2] && W[2] === 0 && U[2] === 0) && (S.k[D].to = null, S.k[D].ti = null));
      this.effectsSequence = [getValueAtCurrentTime.bind(this)], this.data = S, this.keyframes = S.k, this.keyframesMetadata = [], this.offsetTime = T.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = R || 1, this.elem = T, this.container = k, this.comp = T.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
      var q = S.k[0].s.length;
      for (this.v = createTypedArray("float32", q), this.pv = createTypedArray("float32", q), D = 0; D < q; D += 1)
        this.v[D] = initFrame, this.pv[D] = initFrame;
      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0,
        value: createTypedArray("float32", q)
      }, this.addEffect = addEffect;
    }
    var PropertyFactory = /* @__PURE__ */ function() {
      function T(R, k, D, L, V) {
        k.sid && (k = R.globalData.slotManager.getProp(k));
        var z;
        if (!k.k.length)
          z = new ValueProperty(R, k, L, V);
        else if (typeof k.k[0] == "number")
          z = new MultiDimensionalProperty(R, k, L, V);
        else
          switch (D) {
            case 0:
              z = new KeyframedValueProperty(R, k, L, V);
              break;
            case 1:
              z = new KeyframedMultidimensionalProperty(R, k, L, V);
              break;
          }
        return z.effectsSequence.length && V.addDynamicProperty(z), z;
      }
      var S = {
        getProp: T
      };
      return S;
    }();
    function DynamicPropertyContainer() {
    }
    DynamicPropertyContainer.prototype = {
      addDynamicProperty: function(S) {
        this.dynamicProperties.indexOf(S) === -1 && (this.dynamicProperties.push(S), this.container.addDynamicProperty(this), this._isAnimated = !0);
      },
      iterateDynamicProperties: function() {
        this._mdf = !1;
        var S, R = this.dynamicProperties.length;
        for (S = 0; S < R; S += 1)
          this.dynamicProperties[S].getValue(), this.dynamicProperties[S]._mdf && (this._mdf = !0);
      },
      initDynamicPropertyContainer: function(S) {
        this.container = S, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
      }
    };
    var pointPool = function() {
      function T() {
        return createTypedArray("float32", 2);
      }
      return poolFactory(8, T);
    }();
    function ShapePath() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
    }
    ShapePath.prototype.setPathData = function(T, S) {
      this.c = T, this.setLength(S);
      for (var R = 0; R < S; )
        this.v[R] = pointPool.newElement(), this.o[R] = pointPool.newElement(), this.i[R] = pointPool.newElement(), R += 1;
    }, ShapePath.prototype.setLength = function(T) {
      for (; this._maxLength < T; )
        this.doubleArrayLength();
      this._length = T;
    }, ShapePath.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
    }, ShapePath.prototype.setXYAt = function(T, S, R, k, D) {
      var L;
      switch (this._length = Math.max(this._length, k + 1), this._length >= this._maxLength && this.doubleArrayLength(), R) {
        case "v":
          L = this.v;
          break;
        case "i":
          L = this.i;
          break;
        case "o":
          L = this.o;
          break;
        default:
          L = [];
          break;
      }
      (!L[k] || L[k] && !D) && (L[k] = pointPool.newElement()), L[k][0] = T, L[k][1] = S;
    }, ShapePath.prototype.setTripleAt = function(T, S, R, k, D, L, V, z) {
      this.setXYAt(T, S, "v", V, z), this.setXYAt(R, k, "o", V, z), this.setXYAt(D, L, "i", V, z);
    }, ShapePath.prototype.reverse = function() {
      var T = new ShapePath();
      T.setPathData(this.c, this._length);
      var S = this.v, R = this.o, k = this.i, D = 0;
      this.c && (T.setTripleAt(S[0][0], S[0][1], k[0][0], k[0][1], R[0][0], R[0][1], 0, !1), D = 1);
      var L = this._length - 1, V = this._length, z;
      for (z = D; z < V; z += 1)
        T.setTripleAt(S[L][0], S[L][1], k[L][0], k[L][1], R[L][0], R[L][1], z, !1), L -= 1;
      return T;
    }, ShapePath.prototype.length = function() {
      return this._length;
    };
    var shapePool = function() {
      function T() {
        return new ShapePath();
      }
      function S(D) {
        var L = D._length, V;
        for (V = 0; V < L; V += 1)
          pointPool.release(D.v[V]), pointPool.release(D.i[V]), pointPool.release(D.o[V]), D.v[V] = null, D.i[V] = null, D.o[V] = null;
        D._length = 0, D.c = !1;
      }
      function R(D) {
        var L = k.newElement(), V, z = D._length === void 0 ? D.v.length : D._length;
        for (L.setLength(z), L.c = D.c, V = 0; V < z; V += 1)
          L.setTripleAt(D.v[V][0], D.v[V][1], D.o[V][0], D.o[V][1], D.i[V][0], D.i[V][1], V);
        return L;
      }
      var k = poolFactory(4, T, S);
      return k.clone = R, k;
    }();
    function ShapeCollection() {
      this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
    }
    ShapeCollection.prototype.addShape = function(T) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = T, this._length += 1;
    }, ShapeCollection.prototype.releaseShapes = function() {
      var T;
      for (T = 0; T < this._length; T += 1)
        shapePool.release(this.shapes[T]);
      this._length = 0;
    };
    var shapeCollectionPool = function() {
      var T = {
        newShapeCollection: D,
        release: L
      }, S = 0, R = 4, k = createSizedArray(R);
      function D() {
        var V;
        return S ? (S -= 1, V = k[S]) : V = new ShapeCollection(), V;
      }
      function L(V) {
        var z, W = V._length;
        for (z = 0; z < W; z += 1)
          shapePool.release(V.shapes[z]);
        V._length = 0, S === R && (k = pooling.double(k), R *= 2), k[S] = V, S += 1;
      }
      return T;
    }(), ShapePropertyFactory = function() {
      var T = -999999;
      function S(te, re, Q) {
        var ne = Q.lastIndex, oe, ae, se, ie, he, xe, Pe, Re, ke, Te = this.keyframes;
        if (te < Te[0].t - this.offsetTime)
          oe = Te[0].s[0], se = !0, ne = 0;
        else if (te >= Te[Te.length - 1].t - this.offsetTime)
          oe = Te[Te.length - 1].s ? Te[Te.length - 1].s[0] : Te[Te.length - 2].e[0], se = !0;
        else {
          for (var fe = ne, ue = Te.length - 1, Ce = !0, ce, pe, _e; Ce && (ce = Te[fe], pe = Te[fe + 1], !(pe.t - this.offsetTime > te)); )
            fe < ue - 1 ? fe += 1 : Ce = !1;
          if (_e = this.keyframesMetadata[fe] || {}, se = ce.h === 1, ne = fe, !se) {
            if (te >= pe.t - this.offsetTime)
              Re = 1;
            else if (te < ce.t - this.offsetTime)
              Re = 0;
            else {
              var ge;
              _e.__fnct ? ge = _e.__fnct : (ge = BezierFactory.getBezierEasing(ce.o.x, ce.o.y, ce.i.x, ce.i.y).get, _e.__fnct = ge), Re = ge((te - (ce.t - this.offsetTime)) / (pe.t - this.offsetTime - (ce.t - this.offsetTime)));
            }
            ae = pe.s ? pe.s[0] : ce.e[0];
          }
          oe = ce.s[0];
        }
        for (xe = re._length, Pe = oe.i[0].length, Q.lastIndex = ne, ie = 0; ie < xe; ie += 1)
          for (he = 0; he < Pe; he += 1)
            ke = se ? oe.i[ie][he] : oe.i[ie][he] + (ae.i[ie][he] - oe.i[ie][he]) * Re, re.i[ie][he] = ke, ke = se ? oe.o[ie][he] : oe.o[ie][he] + (ae.o[ie][he] - oe.o[ie][he]) * Re, re.o[ie][he] = ke, ke = se ? oe.v[ie][he] : oe.v[ie][he] + (ae.v[ie][he] - oe.v[ie][he]) * Re, re.v[ie][he] = ke;
      }
      function R() {
        var te = this.comp.renderedFrame - this.offsetTime, re = this.keyframes[0].t - this.offsetTime, Q = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, ne = this._caching.lastFrame;
        return ne !== T && (ne < re && te < re || ne > Q && te > Q) || (this._caching.lastIndex = ne < te ? this._caching.lastIndex : 0, this.interpolateShape(te, this.pv, this._caching)), this._caching.lastFrame = te, this.pv;
      }
      function k() {
        this.paths = this.localShapeCollection;
      }
      function D(te, re) {
        if (te._length !== re._length || te.c !== re.c)
          return !1;
        var Q, ne = te._length;
        for (Q = 0; Q < ne; Q += 1)
          if (te.v[Q][0] !== re.v[Q][0] || te.v[Q][1] !== re.v[Q][1] || te.o[Q][0] !== re.o[Q][0] || te.o[Q][1] !== re.o[Q][1] || te.i[Q][0] !== re.i[Q][0] || te.i[Q][1] !== re.i[Q][1])
            return !1;
        return !0;
      }
      function L(te) {
        D(this.v, te) || (this.v = shapePool.clone(te), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function V() {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (!this.effectsSequence.length) {
            this._mdf = !1;
            return;
          }
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = !1;
          var te;
          this.kf ? te = this.pv : this.data.ks ? te = this.data.ks.k : te = this.data.pt.k;
          var re, Q = this.effectsSequence.length;
          for (re = 0; re < Q; re += 1)
            te = this.effectsSequence[re](te);
          this.setVValue(te), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function z(te, re, Q) {
        this.propType = "shape", this.comp = te.comp, this.container = te, this.elem = te, this.data = re, this.k = !1, this.kf = !1, this._mdf = !1;
        var ne = Q === 3 ? re.pt.k : re.ks.k;
        this.v = shapePool.clone(ne), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = k, this.effectsSequence = [];
      }
      function W(te) {
        this.effectsSequence.push(te), this.container.addDynamicProperty(this);
      }
      z.prototype.interpolateShape = S, z.prototype.getValue = V, z.prototype.setVValue = L, z.prototype.addEffect = W;
      function U(te, re, Q) {
        this.propType = "shape", this.comp = te.comp, this.elem = te, this.container = te, this.offsetTime = te.data.st, this.keyframes = Q === 3 ? re.pt.k : re.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var ne = this.keyframes[0].s[0].i.length;
        this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, ne), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = T, this.reset = k, this._caching = {
          lastFrame: T,
          lastIndex: 0
        }, this.effectsSequence = [R.bind(this)];
      }
      U.prototype.getValue = V, U.prototype.interpolateShape = S, U.prototype.setVValue = L, U.prototype.addEffect = W;
      var q = function() {
        var te = roundCorner;
        function re(Q, ne) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = ne.d, this.elem = Q, this.comp = Q.comp, this.frameId = -1, this.initDynamicPropertyContainer(Q), this.p = PropertyFactory.getProp(Q, ne.p, 1, 0, this), this.s = PropertyFactory.getProp(Q, ne.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return re.prototype = {
          reset: k,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
          },
          convertEllToPath: function() {
            var ne = this.p.v[0], oe = this.p.v[1], ae = this.s.v[0] / 2, se = this.s.v[1] / 2, ie = this.d !== 3, he = this.v;
            he.v[0][0] = ne, he.v[0][1] = oe - se, he.v[1][0] = ie ? ne + ae : ne - ae, he.v[1][1] = oe, he.v[2][0] = ne, he.v[2][1] = oe + se, he.v[3][0] = ie ? ne - ae : ne + ae, he.v[3][1] = oe, he.i[0][0] = ie ? ne - ae * te : ne + ae * te, he.i[0][1] = oe - se, he.i[1][0] = ie ? ne + ae : ne - ae, he.i[1][1] = oe - se * te, he.i[2][0] = ie ? ne + ae * te : ne - ae * te, he.i[2][1] = oe + se, he.i[3][0] = ie ? ne - ae : ne + ae, he.i[3][1] = oe + se * te, he.o[0][0] = ie ? ne + ae * te : ne - ae * te, he.o[0][1] = oe - se, he.o[1][0] = ie ? ne + ae : ne - ae, he.o[1][1] = oe + se * te, he.o[2][0] = ie ? ne - ae * te : ne + ae * te, he.o[2][1] = oe + se, he.o[3][0] = ie ? ne - ae : ne + ae, he.o[3][1] = oe - se * te;
          }
        }, extendPrototype([DynamicPropertyContainer], re), re;
      }(), K = function() {
        function te(re, Q) {
          this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = re, this.comp = re.comp, this.data = Q, this.frameId = -1, this.d = Q.d, this.initDynamicPropertyContainer(re), Q.sy === 1 ? (this.ir = PropertyFactory.getProp(re, Q.ir, 0, 0, this), this.is = PropertyFactory.getProp(re, Q.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(re, Q.pt, 0, 0, this), this.p = PropertyFactory.getProp(re, Q.p, 1, 0, this), this.r = PropertyFactory.getProp(re, Q.r, 0, degToRads, this), this.or = PropertyFactory.getProp(re, Q.or, 0, 0, this), this.os = PropertyFactory.getProp(re, Q.os, 0, 0.01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return te.prototype = {
          reset: k,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
          },
          convertStarToPath: function() {
            var Q = Math.floor(this.pt.v) * 2, ne = Math.PI * 2 / Q, oe = !0, ae = this.or.v, se = this.ir.v, ie = this.os.v, he = this.is.v, xe = 2 * Math.PI * ae / (Q * 2), Pe = 2 * Math.PI * se / (Q * 2), Re, ke, Te, fe, ue = -Math.PI / 2;
            ue += this.r.v;
            var Ce = this.data.d === 3 ? -1 : 1;
            for (this.v._length = 0, Re = 0; Re < Q; Re += 1) {
              ke = oe ? ae : se, Te = oe ? ie : he, fe = oe ? xe : Pe;
              var ce = ke * Math.cos(ue), pe = ke * Math.sin(ue), _e = ce === 0 && pe === 0 ? 0 : pe / Math.sqrt(ce * ce + pe * pe), ge = ce === 0 && pe === 0 ? 0 : -ce / Math.sqrt(ce * ce + pe * pe);
              ce += +this.p.v[0], pe += +this.p.v[1], this.v.setTripleAt(ce, pe, ce - _e * fe * Te * Ce, pe - ge * fe * Te * Ce, ce + _e * fe * Te * Ce, pe + ge * fe * Te * Ce, Re, !0), oe = !oe, ue += ne * Ce;
            }
          },
          convertPolygonToPath: function() {
            var Q = Math.floor(this.pt.v), ne = Math.PI * 2 / Q, oe = this.or.v, ae = this.os.v, se = 2 * Math.PI * oe / (Q * 4), ie, he = -Math.PI * 0.5, xe = this.data.d === 3 ? -1 : 1;
            for (he += this.r.v, this.v._length = 0, ie = 0; ie < Q; ie += 1) {
              var Pe = oe * Math.cos(he), Re = oe * Math.sin(he), ke = Pe === 0 && Re === 0 ? 0 : Re / Math.sqrt(Pe * Pe + Re * Re), Te = Pe === 0 && Re === 0 ? 0 : -Pe / Math.sqrt(Pe * Pe + Re * Re);
              Pe += +this.p.v[0], Re += +this.p.v[1], this.v.setTripleAt(Pe, Re, Pe - ke * se * ae * xe, Re - Te * se * ae * xe, Pe + ke * se * ae * xe, Re + Te * se * ae * xe, ie, !0), he += ne * xe;
            }
            this.paths.length = 0, this.paths[0] = this.v;
          }
        }, extendPrototype([DynamicPropertyContainer], te), te;
      }(), Y = function() {
        function te(re, Q) {
          this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = re, this.comp = re.comp, this.frameId = -1, this.d = Q.d, this.initDynamicPropertyContainer(re), this.p = PropertyFactory.getProp(re, Q.p, 1, 0, this), this.s = PropertyFactory.getProp(re, Q.s, 1, 0, this), this.r = PropertyFactory.getProp(re, Q.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return te.prototype = {
          convertRectToPath: function() {
            var Q = this.p.v[0], ne = this.p.v[1], oe = this.s.v[0] / 2, ae = this.s.v[1] / 2, se = bmMin(oe, ae, this.r.v), ie = se * (1 - roundCorner);
            this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(Q + oe, ne - ae + se, Q + oe, ne - ae + se, Q + oe, ne - ae + ie, 0, !0), this.v.setTripleAt(Q + oe, ne + ae - se, Q + oe, ne + ae - ie, Q + oe, ne + ae - se, 1, !0), se !== 0 ? (this.v.setTripleAt(Q + oe - se, ne + ae, Q + oe - se, ne + ae, Q + oe - ie, ne + ae, 2, !0), this.v.setTripleAt(Q - oe + se, ne + ae, Q - oe + ie, ne + ae, Q - oe + se, ne + ae, 3, !0), this.v.setTripleAt(Q - oe, ne + ae - se, Q - oe, ne + ae - se, Q - oe, ne + ae - ie, 4, !0), this.v.setTripleAt(Q - oe, ne - ae + se, Q - oe, ne - ae + ie, Q - oe, ne - ae + se, 5, !0), this.v.setTripleAt(Q - oe + se, ne - ae, Q - oe + se, ne - ae, Q - oe + ie, ne - ae, 6, !0), this.v.setTripleAt(Q + oe - se, ne - ae, Q + oe - ie, ne - ae, Q + oe - se, ne - ae, 7, !0)) : (this.v.setTripleAt(Q - oe, ne + ae, Q - oe + ie, ne + ae, Q - oe, ne + ae, 2), this.v.setTripleAt(Q - oe, ne - ae, Q - oe, ne - ae + ie, Q - oe, ne - ae, 3))) : (this.v.setTripleAt(Q + oe, ne - ae + se, Q + oe, ne - ae + ie, Q + oe, ne - ae + se, 0, !0), se !== 0 ? (this.v.setTripleAt(Q + oe - se, ne - ae, Q + oe - se, ne - ae, Q + oe - ie, ne - ae, 1, !0), this.v.setTripleAt(Q - oe + se, ne - ae, Q - oe + ie, ne - ae, Q - oe + se, ne - ae, 2, !0), this.v.setTripleAt(Q - oe, ne - ae + se, Q - oe, ne - ae + se, Q - oe, ne - ae + ie, 3, !0), this.v.setTripleAt(Q - oe, ne + ae - se, Q - oe, ne + ae - ie, Q - oe, ne + ae - se, 4, !0), this.v.setTripleAt(Q - oe + se, ne + ae, Q - oe + se, ne + ae, Q - oe + ie, ne + ae, 5, !0), this.v.setTripleAt(Q + oe - se, ne + ae, Q + oe - ie, ne + ae, Q + oe - se, ne + ae, 6, !0), this.v.setTripleAt(Q + oe, ne + ae - se, Q + oe, ne + ae - se, Q + oe, ne + ae - ie, 7, !0)) : (this.v.setTripleAt(Q - oe, ne - ae, Q - oe + ie, ne - ae, Q - oe, ne - ae, 1, !0), this.v.setTripleAt(Q - oe, ne + ae, Q - oe, ne + ae - ie, Q - oe, ne + ae, 2, !0), this.v.setTripleAt(Q + oe, ne + ae, Q + oe - ie, ne + ae, Q + oe, ne + ae, 3, !0)));
          },
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
          },
          reset: k
        }, extendPrototype([DynamicPropertyContainer], te), te;
      }();
      function J(te, re, Q) {
        var ne;
        if (Q === 3 || Q === 4) {
          var oe = Q === 3 ? re.pt : re.ks, ae = oe.k;
          ae.length ? ne = new U(te, re, Q) : ne = new z(te, re, Q);
        } else Q === 5 ? ne = new Y(te, re) : Q === 6 ? ne = new q(te, re) : Q === 7 && (ne = new K(te, re));
        return ne.k && te.addDynamicProperty(ne), ne;
      }
      function Z() {
        return z;
      }
      function X() {
        return U;
      }
      var ee = {};
      return ee.getShapeProp = J, ee.getConstructorFunction = Z, ee.getKeyframedConstructorFunction = X, ee;
    }();
    /*!
     Transformation Matrix v2.0
     (c) Epistemex 2014-2015
     www.epistemex.com
     By Ken Fyrstenberg
     Contributions by leeoniya.
     License: MIT, header required.
     */
    var Matrix = /* @__PURE__ */ function() {
      var T = Math.cos, S = Math.sin, R = Math.tan, k = Math.round;
      function D() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function L(ce) {
        if (ce === 0)
          return this;
        var pe = T(ce), _e = S(ce);
        return this._t(pe, -_e, 0, 0, _e, pe, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function V(ce) {
        if (ce === 0)
          return this;
        var pe = T(ce), _e = S(ce);
        return this._t(1, 0, 0, 0, 0, pe, -_e, 0, 0, _e, pe, 0, 0, 0, 0, 1);
      }
      function z(ce) {
        if (ce === 0)
          return this;
        var pe = T(ce), _e = S(ce);
        return this._t(pe, 0, _e, 0, 0, 1, 0, 0, -_e, 0, pe, 0, 0, 0, 0, 1);
      }
      function W(ce) {
        if (ce === 0)
          return this;
        var pe = T(ce), _e = S(ce);
        return this._t(pe, -_e, 0, 0, _e, pe, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function U(ce, pe) {
        return this._t(1, pe, ce, 1, 0, 0);
      }
      function q(ce, pe) {
        return this.shear(R(ce), R(pe));
      }
      function K(ce, pe) {
        var _e = T(pe), ge = S(pe);
        return this._t(_e, ge, 0, 0, -ge, _e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, R(ce), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(_e, -ge, 0, 0, ge, _e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function Y(ce, pe, _e) {
        return !_e && _e !== 0 && (_e = 1), ce === 1 && pe === 1 && _e === 1 ? this : this._t(ce, 0, 0, 0, 0, pe, 0, 0, 0, 0, _e, 0, 0, 0, 0, 1);
      }
      function J(ce, pe, _e, ge, Ae, Ee, ve, le, me, Se, ye, be, $e, Oe, Ie, we) {
        return this.props[0] = ce, this.props[1] = pe, this.props[2] = _e, this.props[3] = ge, this.props[4] = Ae, this.props[5] = Ee, this.props[6] = ve, this.props[7] = le, this.props[8] = me, this.props[9] = Se, this.props[10] = ye, this.props[11] = be, this.props[12] = $e, this.props[13] = Oe, this.props[14] = Ie, this.props[15] = we, this;
      }
      function Z(ce, pe, _e) {
        return _e = _e || 0, ce !== 0 || pe !== 0 || _e !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ce, pe, _e, 1) : this;
      }
      function X(ce, pe, _e, ge, Ae, Ee, ve, le, me, Se, ye, be, $e, Oe, Ie, we) {
        var Fe = this.props;
        if (ce === 1 && pe === 0 && _e === 0 && ge === 0 && Ae === 0 && Ee === 1 && ve === 0 && le === 0 && me === 0 && Se === 0 && ye === 1 && be === 0)
          return Fe[12] = Fe[12] * ce + Fe[15] * $e, Fe[13] = Fe[13] * Ee + Fe[15] * Oe, Fe[14] = Fe[14] * ye + Fe[15] * Ie, Fe[15] *= we, this._identityCalculated = !1, this;
        var De = Fe[0], Le = Fe[1], ze = Fe[2], We = Fe[3], Be = Fe[4], Ye = Fe[5], Ge = Fe[6], nt = Fe[7], Ze = Fe[8], Me = Fe[9], Ne = Fe[10], He = Fe[11], qe = Fe[12], Ke = Fe[13], Xe = Fe[14], tt = Fe[15];
        return Fe[0] = De * ce + Le * Ae + ze * me + We * $e, Fe[1] = De * pe + Le * Ee + ze * Se + We * Oe, Fe[2] = De * _e + Le * ve + ze * ye + We * Ie, Fe[3] = De * ge + Le * le + ze * be + We * we, Fe[4] = Be * ce + Ye * Ae + Ge * me + nt * $e, Fe[5] = Be * pe + Ye * Ee + Ge * Se + nt * Oe, Fe[6] = Be * _e + Ye * ve + Ge * ye + nt * Ie, Fe[7] = Be * ge + Ye * le + Ge * be + nt * we, Fe[8] = Ze * ce + Me * Ae + Ne * me + He * $e, Fe[9] = Ze * pe + Me * Ee + Ne * Se + He * Oe, Fe[10] = Ze * _e + Me * ve + Ne * ye + He * Ie, Fe[11] = Ze * ge + Me * le + Ne * be + He * we, Fe[12] = qe * ce + Ke * Ae + Xe * me + tt * $e, Fe[13] = qe * pe + Ke * Ee + Xe * Se + tt * Oe, Fe[14] = qe * _e + Ke * ve + Xe * ye + tt * Ie, Fe[15] = qe * ge + Ke * le + Xe * be + tt * we, this._identityCalculated = !1, this;
      }
      function ee(ce) {
        var pe = ce.props;
        return this.transform(pe[0], pe[1], pe[2], pe[3], pe[4], pe[5], pe[6], pe[7], pe[8], pe[9], pe[10], pe[11], pe[12], pe[13], pe[14], pe[15]);
      }
      function te() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function re(ce) {
        for (var pe = 0; pe < 16; ) {
          if (ce.props[pe] !== this.props[pe])
            return !1;
          pe += 1;
        }
        return !0;
      }
      function Q(ce) {
        var pe;
        for (pe = 0; pe < 16; pe += 1)
          ce.props[pe] = this.props[pe];
        return ce;
      }
      function ne(ce) {
        var pe;
        for (pe = 0; pe < 16; pe += 1)
          this.props[pe] = ce[pe];
      }
      function oe(ce, pe, _e) {
        return {
          x: ce * this.props[0] + pe * this.props[4] + _e * this.props[8] + this.props[12],
          y: ce * this.props[1] + pe * this.props[5] + _e * this.props[9] + this.props[13],
          z: ce * this.props[2] + pe * this.props[6] + _e * this.props[10] + this.props[14]
        };
      }
      function ae(ce, pe, _e) {
        return ce * this.props[0] + pe * this.props[4] + _e * this.props[8] + this.props[12];
      }
      function se(ce, pe, _e) {
        return ce * this.props[1] + pe * this.props[5] + _e * this.props[9] + this.props[13];
      }
      function ie(ce, pe, _e) {
        return ce * this.props[2] + pe * this.props[6] + _e * this.props[10] + this.props[14];
      }
      function he() {
        var ce = this.props[0] * this.props[5] - this.props[1] * this.props[4], pe = this.props[5] / ce, _e = -this.props[1] / ce, ge = -this.props[4] / ce, Ae = this.props[0] / ce, Ee = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / ce, ve = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / ce, le = new Matrix();
        return le.props[0] = pe, le.props[1] = _e, le.props[4] = ge, le.props[5] = Ae, le.props[12] = Ee, le.props[13] = ve, le;
      }
      function xe(ce) {
        var pe = this.getInverseMatrix();
        return pe.applyToPointArray(ce[0], ce[1], ce[2] || 0);
      }
      function Pe(ce) {
        var pe, _e = ce.length, ge = [];
        for (pe = 0; pe < _e; pe += 1)
          ge[pe] = xe(ce[pe]);
        return ge;
      }
      function Re(ce, pe, _e) {
        var ge = createTypedArray("float32", 6);
        if (this.isIdentity())
          ge[0] = ce[0], ge[1] = ce[1], ge[2] = pe[0], ge[3] = pe[1], ge[4] = _e[0], ge[5] = _e[1];
        else {
          var Ae = this.props[0], Ee = this.props[1], ve = this.props[4], le = this.props[5], me = this.props[12], Se = this.props[13];
          ge[0] = ce[0] * Ae + ce[1] * ve + me, ge[1] = ce[0] * Ee + ce[1] * le + Se, ge[2] = pe[0] * Ae + pe[1] * ve + me, ge[3] = pe[0] * Ee + pe[1] * le + Se, ge[4] = _e[0] * Ae + _e[1] * ve + me, ge[5] = _e[0] * Ee + _e[1] * le + Se;
        }
        return ge;
      }
      function ke(ce, pe, _e) {
        var ge;
        return this.isIdentity() ? ge = [ce, pe, _e] : ge = [ce * this.props[0] + pe * this.props[4] + _e * this.props[8] + this.props[12], ce * this.props[1] + pe * this.props[5] + _e * this.props[9] + this.props[13], ce * this.props[2] + pe * this.props[6] + _e * this.props[10] + this.props[14]], ge;
      }
      function Te(ce, pe) {
        if (this.isIdentity())
          return ce + "," + pe;
        var _e = this.props;
        return Math.round((ce * _e[0] + pe * _e[4] + _e[12]) * 100) / 100 + "," + Math.round((ce * _e[1] + pe * _e[5] + _e[13]) * 100) / 100;
      }
      function fe() {
        for (var ce = 0, pe = this.props, _e = "matrix3d(", ge = 1e4; ce < 16; )
          _e += k(pe[ce] * ge) / ge, _e += ce === 15 ? ")" : ",", ce += 1;
        return _e;
      }
      function ue(ce) {
        var pe = 1e4;
        return ce < 1e-6 && ce > 0 || ce > -1e-6 && ce < 0 ? k(ce * pe) / pe : ce;
      }
      function Ce() {
        var ce = this.props, pe = ue(ce[0]), _e = ue(ce[1]), ge = ue(ce[4]), Ae = ue(ce[5]), Ee = ue(ce[12]), ve = ue(ce[13]);
        return "matrix(" + pe + "," + _e + "," + ge + "," + Ae + "," + Ee + "," + ve + ")";
      }
      return function() {
        this.reset = D, this.rotate = L, this.rotateX = V, this.rotateY = z, this.rotateZ = W, this.skew = q, this.skewFromAxis = K, this.shear = U, this.scale = Y, this.setTransform = J, this.translate = Z, this.transform = X, this.multiply = ee, this.applyToPoint = oe, this.applyToX = ae, this.applyToY = se, this.applyToZ = ie, this.applyToPointArray = ke, this.applyToTriplePoints = Re, this.applyToPointStringified = Te, this.toCSS = fe, this.to2dCSS = Ce, this.clone = Q, this.cloneFromProps = ne, this.equals = re, this.inversePoints = Pe, this.inversePoint = xe, this.getInverseMatrix = he, this._t = this.transform, this.isIdentity = te, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
      };
    }();
    function _typeof$3(T) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$3 = function(R) {
        return typeof R;
      } : _typeof$3 = function(R) {
        return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
      }, _typeof$3(T);
    }
    var lottie = {};
    function setLocation(T) {
      setLocationHref(T);
    }
    function searchAnimations() {
      animationManager.searchAnimations();
    }
    function setSubframeRendering(T) {
      setSubframeEnabled(T);
    }
    function setPrefix(T) {
      setIdPrefix(T);
    }
    function loadAnimation(T) {
      return animationManager.loadAnimation(T);
    }
    function setQuality(T) {
      if (typeof T == "string")
        switch (T) {
          case "high":
            setDefaultCurveSegments(200);
            break;
          default:
          case "medium":
            setDefaultCurveSegments(50);
            break;
          case "low":
            setDefaultCurveSegments(10);
            break;
        }
      else !isNaN(T) && T > 1 && setDefaultCurveSegments(T);
    }
    function inBrowser() {
      return typeof navigator < "u";
    }
    function installPlugin(T, S) {
      T === "expressions" && setExpressionsPlugin(S);
    }
    function getFactory(T) {
      switch (T) {
        case "propertyFactory":
          return PropertyFactory;
        case "shapePropertyFactory":
          return ShapePropertyFactory;
        case "matrix":
          return Matrix;
        default:
          return null;
      }
    }
    lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
    function checkReady() {
      document.readyState === "complete" && (clearInterval(readyStateCheckInterval), searchAnimations());
    }
    function getQueryVariable(T) {
      for (var S = queryString.split("&"), R = 0; R < S.length; R += 1) {
        var k = S[R].split("=");
        if (decodeURIComponent(k[0]) == T)
          return decodeURIComponent(k[1]);
      }
      return null;
    }
    var queryString = "";
    {
      var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
        src: ""
      };
      queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", getQueryVariable("renderer");
    }
    var readyStateCheckInterval = setInterval(checkReady, 100);
    try {
      _typeof$3(exports) !== "object" && (window.bodymovin = lottie);
    } catch (T) {
    }
    var ShapeModifiers = function() {
      var T = {}, S = {};
      T.registerModifier = R, T.getModifier = k;
      function R(D, L) {
        S[D] || (S[D] = L);
      }
      function k(D, L, V) {
        return new S[D](L, V);
      }
      return T;
    }();
    function ShapeModifier() {
    }
    ShapeModifier.prototype.initModifierProperties = function() {
    }, ShapeModifier.prototype.addShapeToModifier = function() {
    }, ShapeModifier.prototype.addShape = function(T) {
      if (!this.closed) {
        T.sh.container.addDynamicProperty(T.sh);
        var S = {
          shape: T.sh,
          data: T,
          localShapeCollection: shapeCollectionPool.newShapeCollection()
        };
        this.shapes.push(S), this.addShapeToModifier(S), this._isAnimated && T.setAsAnimated();
      }
    }, ShapeModifier.prototype.init = function(T, S) {
      this.shapes = [], this.elem = T, this.initDynamicPropertyContainer(T), this.initModifierProperties(T, S), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, ShapeModifier.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, extendPrototype([DynamicPropertyContainer], ShapeModifier);
    function TrimModifier() {
    }
    extendPrototype([ShapeModifier], TrimModifier), TrimModifier.prototype.initModifierProperties = function(T, S) {
      this.s = PropertyFactory.getProp(T, S.s, 0, 0.01, this), this.e = PropertyFactory.getProp(T, S.e, 0, 0.01, this), this.o = PropertyFactory.getProp(T, S.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = S.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, TrimModifier.prototype.addShapeToModifier = function(T) {
      T.pathsData = [];
    }, TrimModifier.prototype.calculateShapeEdges = function(T, S, R, k, D) {
      var L = [];
      S <= 1 ? L.push({
        s: T,
        e: S
      }) : T >= 1 ? L.push({
        s: T - 1,
        e: S - 1
      }) : (L.push({
        s: T,
        e: 1
      }), L.push({
        s: 0,
        e: S - 1
      }));
      var V = [], z, W = L.length, U;
      for (z = 0; z < W; z += 1)
        if (U = L[z], !(U.e * D < k || U.s * D > k + R)) {
          var q, K;
          U.s * D <= k ? q = 0 : q = (U.s * D - k) / R, U.e * D >= k + R ? K = 1 : K = (U.e * D - k) / R, V.push([q, K]);
        }
      return V.length || V.push([0, 0]), V;
    }, TrimModifier.prototype.releasePathsData = function(T) {
      var S, R = T.length;
      for (S = 0; S < R; S += 1)
        segmentsLengthPool.release(T[S]);
      return T.length = 0, T;
    }, TrimModifier.prototype.processShapes = function(T) {
      var S, R;
      if (this._mdf || T) {
        var k = this.o.v % 360 / 360;
        if (k < 0 && (k += 1), this.s.v > 1 ? S = 1 + k : this.s.v < 0 ? S = 0 + k : S = this.s.v + k, this.e.v > 1 ? R = 1 + k : this.e.v < 0 ? R = 0 + k : R = this.e.v + k, S > R) {
          var D = S;
          S = R, R = D;
        }
        S = Math.round(S * 1e4) * 1e-4, R = Math.round(R * 1e4) * 1e-4, this.sValue = S, this.eValue = R;
      } else
        S = this.sValue, R = this.eValue;
      var L, V, z = this.shapes.length, W, U, q, K, Y, J = 0;
      if (R === S)
        for (V = 0; V < z; V += 1)
          this.shapes[V].localShapeCollection.releaseShapes(), this.shapes[V].shape._mdf = !0, this.shapes[V].shape.paths = this.shapes[V].localShapeCollection, this._mdf && (this.shapes[V].pathsData.length = 0);
      else if (R === 1 && S === 0 || R === 0 && S === 1) {
        if (this._mdf)
          for (V = 0; V < z; V += 1)
            this.shapes[V].pathsData.length = 0, this.shapes[V].shape._mdf = !0;
      } else {
        var Z = [], X, ee;
        for (V = 0; V < z; V += 1)
          if (X = this.shapes[V], !X.shape._mdf && !this._mdf && !T && this.m !== 2)
            X.shape.paths = X.localShapeCollection;
          else {
            if (L = X.shape.paths, U = L._length, Y = 0, !X.shape._mdf && X.pathsData.length)
              Y = X.totalShapeLength;
            else {
              for (q = this.releasePathsData(X.pathsData), W = 0; W < U; W += 1)
                K = bez.getSegmentsLength(L.shapes[W]), q.push(K), Y += K.totalLength;
              X.totalShapeLength = Y, X.pathsData = q;
            }
            J += Y, X.shape._mdf = !0;
          }
        var te = S, re = R, Q = 0, ne;
        for (V = z - 1; V >= 0; V -= 1)
          if (X = this.shapes[V], X.shape._mdf) {
            for (ee = X.localShapeCollection, ee.releaseShapes(), this.m === 2 && z > 1 ? (ne = this.calculateShapeEdges(S, R, X.totalShapeLength, Q, J), Q += X.totalShapeLength) : ne = [[te, re]], U = ne.length, W = 0; W < U; W += 1) {
              te = ne[W][0], re = ne[W][1], Z.length = 0, re <= 1 ? Z.push({
                s: X.totalShapeLength * te,
                e: X.totalShapeLength * re
              }) : te >= 1 ? Z.push({
                s: X.totalShapeLength * (te - 1),
                e: X.totalShapeLength * (re - 1)
              }) : (Z.push({
                s: X.totalShapeLength * te,
                e: X.totalShapeLength
              }), Z.push({
                s: 0,
                e: X.totalShapeLength * (re - 1)
              }));
              var oe = this.addShapes(X, Z[0]);
              if (Z[0].s !== Z[0].e) {
                if (Z.length > 1) {
                  var ae = X.shape.paths.shapes[X.shape.paths._length - 1];
                  if (ae.c) {
                    var se = oe.pop();
                    this.addPaths(oe, ee), oe = this.addShapes(X, Z[1], se);
                  } else
                    this.addPaths(oe, ee), oe = this.addShapes(X, Z[1]);
                }
                this.addPaths(oe, ee);
              }
            }
            X.shape.paths = ee;
          }
      }
    }, TrimModifier.prototype.addPaths = function(T, S) {
      var R, k = T.length;
      for (R = 0; R < k; R += 1)
        S.addShape(T[R]);
    }, TrimModifier.prototype.addSegment = function(T, S, R, k, D, L, V) {
      D.setXYAt(S[0], S[1], "o", L), D.setXYAt(R[0], R[1], "i", L + 1), V && D.setXYAt(T[0], T[1], "v", L), D.setXYAt(k[0], k[1], "v", L + 1);
    }, TrimModifier.prototype.addSegmentFromArray = function(T, S, R, k) {
      S.setXYAt(T[1], T[5], "o", R), S.setXYAt(T[2], T[6], "i", R + 1), k && S.setXYAt(T[0], T[4], "v", R), S.setXYAt(T[3], T[7], "v", R + 1);
    }, TrimModifier.prototype.addShapes = function(T, S, R) {
      var k = T.pathsData, D = T.shape.paths.shapes, L, V = T.shape.paths._length, z, W, U = 0, q, K, Y, J, Z = [], X, ee = !0;
      for (R ? (K = R._length, X = R._length) : (R = shapePool.newElement(), K = 0, X = 0), Z.push(R), L = 0; L < V; L += 1) {
        for (Y = k[L].lengths, R.c = D[L].c, W = D[L].c ? Y.length : Y.length + 1, z = 1; z < W; z += 1)
          if (q = Y[z - 1], U + q.addedLength < S.s)
            U += q.addedLength, R.c = !1;
          else if (U > S.e) {
            R.c = !1;
            break;
          } else
            S.s <= U && S.e >= U + q.addedLength ? (this.addSegment(D[L].v[z - 1], D[L].o[z - 1], D[L].i[z], D[L].v[z], R, K, ee), ee = !1) : (J = bez.getNewSegment(D[L].v[z - 1], D[L].v[z], D[L].o[z - 1], D[L].i[z], (S.s - U) / q.addedLength, (S.e - U) / q.addedLength, Y[z - 1]), this.addSegmentFromArray(J, R, K, ee), ee = !1, R.c = !1), U += q.addedLength, K += 1;
        if (D[L].c && Y.length) {
          if (q = Y[z - 1], U <= S.e) {
            var te = Y[z - 1].addedLength;
            S.s <= U && S.e >= U + te ? (this.addSegment(D[L].v[z - 1], D[L].o[z - 1], D[L].i[0], D[L].v[0], R, K, ee), ee = !1) : (J = bez.getNewSegment(D[L].v[z - 1], D[L].v[0], D[L].o[z - 1], D[L].i[0], (S.s - U) / te, (S.e - U) / te, Y[z - 1]), this.addSegmentFromArray(J, R, K, ee), ee = !1, R.c = !1);
          } else
            R.c = !1;
          U += q.addedLength, K += 1;
        }
        if (R._length && (R.setXYAt(R.v[X][0], R.v[X][1], "i", X), R.setXYAt(R.v[R._length - 1][0], R.v[R._length - 1][1], "o", R._length - 1)), U > S.e)
          break;
        L < V - 1 && (R = shapePool.newElement(), ee = !0, Z.push(R), K = 0);
      }
      return Z;
    };
    function PuckerAndBloatModifier() {
    }
    extendPrototype([ShapeModifier], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(T, S) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(T, S.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, PuckerAndBloatModifier.prototype.processPath = function(T, S) {
      var R = S / 100, k = [0, 0], D = T._length, L = 0;
      for (L = 0; L < D; L += 1)
        k[0] += T.v[L][0], k[1] += T.v[L][1];
      k[0] /= D, k[1] /= D;
      var V = shapePool.newElement();
      V.c = T.c;
      var z, W, U, q, K, Y;
      for (L = 0; L < D; L += 1)
        z = T.v[L][0] + (k[0] - T.v[L][0]) * R, W = T.v[L][1] + (k[1] - T.v[L][1]) * R, U = T.o[L][0] + (k[0] - T.o[L][0]) * -R, q = T.o[L][1] + (k[1] - T.o[L][1]) * -R, K = T.i[L][0] + (k[0] - T.i[L][0]) * -R, Y = T.i[L][1] + (k[1] - T.i[L][1]) * -R, V.setTripleAt(z, W, U, q, K, Y, L);
      return V;
    }, PuckerAndBloatModifier.prototype.processShapes = function(T) {
      var S, R, k = this.shapes.length, D, L, V = this.amount.v;
      if (V !== 0) {
        var z, W;
        for (R = 0; R < k; R += 1) {
          if (z = this.shapes[R], W = z.localShapeCollection, !(!z.shape._mdf && !this._mdf && !T))
            for (W.releaseShapes(), z.shape._mdf = !0, S = z.shape.paths.shapes, L = z.shape.paths._length, D = 0; D < L; D += 1)
              W.addShape(this.processPath(S[D], V));
          z.shape.paths = z.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var TransformPropertyFactory = function() {
      var T = [0, 0];
      function S(W) {
        var U = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || U, this.a && W.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && W.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && W.skewFromAxis(-this.sk.v, this.sa.v), this.r ? W.rotate(-this.r.v) : W.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? W.translate(this.px.v, this.py.v, -this.pz.v) : W.translate(this.px.v, this.py.v, 0) : W.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
      function R(W) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || W) {
            var U;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var q, K;
              if (U = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (q = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / U, 0), K = this.p.getValueAtTime(this.p.keyframes[0].t / U, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (q = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / U, 0), K = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / U, 0)) : (q = this.p.pv, K = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / U, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                q = [], K = [];
                var Y = this.px, J = this.py;
                Y._caching.lastFrame + Y.offsetTime <= Y.keyframes[0].t ? (q[0] = Y.getValueAtTime((Y.keyframes[0].t + 0.01) / U, 0), q[1] = J.getValueAtTime((J.keyframes[0].t + 0.01) / U, 0), K[0] = Y.getValueAtTime(Y.keyframes[0].t / U, 0), K[1] = J.getValueAtTime(J.keyframes[0].t / U, 0)) : Y._caching.lastFrame + Y.offsetTime >= Y.keyframes[Y.keyframes.length - 1].t ? (q[0] = Y.getValueAtTime(Y.keyframes[Y.keyframes.length - 1].t / U, 0), q[1] = J.getValueAtTime(J.keyframes[J.keyframes.length - 1].t / U, 0), K[0] = Y.getValueAtTime((Y.keyframes[Y.keyframes.length - 1].t - 0.01) / U, 0), K[1] = J.getValueAtTime((J.keyframes[J.keyframes.length - 1].t - 0.01) / U, 0)) : (q = [Y.pv, J.pv], K[0] = Y.getValueAtTime((Y._caching.lastFrame + Y.offsetTime - 0.01) / U, Y.offsetTime), K[1] = J.getValueAtTime((J._caching.lastFrame + J.offsetTime - 0.01) / U, J.offsetTime));
              } else
                K = T, q = K;
              this.v.rotate(-Math.atan2(q[1] - K[1], q[0] - K[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }
      function k() {
        if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length)
          this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;
        else
          return;
        if (!this.s.effectsSequence.length)
          this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;
        else
          return;
        if (this.sk)
          if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          else
            return;
        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
      }
      function D() {
      }
      function L(W) {
        this._addDynamicProperty(W), this.elem.addDynamicProperty(W), this._isDirty = !0;
      }
      function V(W, U, q) {
        if (this.elem = W, this.frameId = -1, this.propType = "transform", this.data = U, this.v = new Matrix(), this.pre = new Matrix(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(q || W), U.p && U.p.s ? (this.px = PropertyFactory.getProp(W, U.p.x, 0, 0, this), this.py = PropertyFactory.getProp(W, U.p.y, 0, 0, this), U.p.z && (this.pz = PropertyFactory.getProp(W, U.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(W, U.p || {
          k: [0, 0, 0]
        }, 1, 0, this), U.rx) {
          if (this.rx = PropertyFactory.getProp(W, U.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(W, U.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(W, U.rz, 0, degToRads, this), U.or.k[0].ti) {
            var K, Y = U.or.k.length;
            for (K = 0; K < Y; K += 1)
              U.or.k[K].to = null, U.or.k[K].ti = null;
          }
          this.or = PropertyFactory.getProp(W, U.or, 1, degToRads, this), this.or.sh = !0;
        } else
          this.r = PropertyFactory.getProp(W, U.r || {
            k: 0
          }, 0, degToRads, this);
        U.sk && (this.sk = PropertyFactory.getProp(W, U.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(W, U.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(W, U.a || {
          k: [0, 0, 0]
        }, 1, 0, this), this.s = PropertyFactory.getProp(W, U.s || {
          k: [100, 100, 100]
        }, 1, 0.01, this), U.o ? this.o = PropertyFactory.getProp(W, U.o, 0, 0.01, W) : this.o = {
          _mdf: !1,
          v: 1
        }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      V.prototype = {
        applyToMatrix: S,
        getValue: R,
        precalculateMatrix: k,
        autoOrient: D
      }, extendPrototype([DynamicPropertyContainer], V), V.prototype.addDynamicProperty = L, V.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;
      function z(W, U, q) {
        return new V(W, U, q);
      }
      return {
        getTransformProperty: z
      };
    }();
    function RepeaterModifier() {
    }
    extendPrototype([ShapeModifier], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(T, S) {
      this.getValue = this.processKeys, this.c = PropertyFactory.getProp(T, S.c, 0, null, this), this.o = PropertyFactory.getProp(T, S.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(T, S.tr, this), this.so = PropertyFactory.getProp(T, S.tr.so, 0, 0.01, this), this.eo = PropertyFactory.getProp(T, S.tr.eo, 0, 0.01, this), this.data = S, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix(), this.rMatrix = new Matrix(), this.sMatrix = new Matrix(), this.tMatrix = new Matrix(), this.matrix = new Matrix();
    }, RepeaterModifier.prototype.applyTransforms = function(T, S, R, k, D, L) {
      var V = L ? -1 : 1, z = k.s.v[0] + (1 - k.s.v[0]) * (1 - D), W = k.s.v[1] + (1 - k.s.v[1]) * (1 - D);
      T.translate(k.p.v[0] * V * D, k.p.v[1] * V * D, k.p.v[2]), S.translate(-k.a.v[0], -k.a.v[1], k.a.v[2]), S.rotate(-k.r.v * V * D), S.translate(k.a.v[0], k.a.v[1], k.a.v[2]), R.translate(-k.a.v[0], -k.a.v[1], k.a.v[2]), R.scale(L ? 1 / z : z, L ? 1 / W : W), R.translate(k.a.v[0], k.a.v[1], k.a.v[2]);
    }, RepeaterModifier.prototype.init = function(T, S, R, k) {
      for (this.elem = T, this.arr = S, this.pos = R, this.elemsData = k, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(T), this.initModifierProperties(T, S[R]); R > 0; )
        R -= 1, this._elements.unshift(S[R]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, RepeaterModifier.prototype.resetElements = function(T) {
      var S, R = T.length;
      for (S = 0; S < R; S += 1)
        T[S]._processed = !1, T[S].ty === "gr" && this.resetElements(T[S].it);
    }, RepeaterModifier.prototype.cloneElements = function(T) {
      var S = JSON.parse(JSON.stringify(T));
      return this.resetElements(S), S;
    }, RepeaterModifier.prototype.changeGroupRender = function(T, S) {
      var R, k = T.length;
      for (R = 0; R < k; R += 1)
        T[R]._render = S, T[R].ty === "gr" && this.changeGroupRender(T[R].it, S);
    }, RepeaterModifier.prototype.processShapes = function(T) {
      var S, R, k, D, L, V = !1;
      if (this._mdf || T) {
        var z = Math.ceil(this.c.v);
        if (this._groups.length < z) {
          for (; this._groups.length < z; ) {
            var W = {
              it: this.cloneElements(this._elements),
              ty: "gr"
            };
            W.it.push({
              a: {
                a: 0,
                ix: 1,
                k: [0, 0]
              },
              nm: "Transform",
              o: {
                a: 0,
                ix: 7,
                k: 100
              },
              p: {
                a: 0,
                ix: 2,
                k: [0, 0]
              },
              r: {
                a: 1,
                ix: 6,
                k: [{
                  s: 0,
                  e: 0,
                  t: 0
                }, {
                  s: 0,
                  e: 0,
                  t: 1
                }]
              },
              s: {
                a: 0,
                ix: 3,
                k: [100, 100]
              },
              sa: {
                a: 0,
                ix: 5,
                k: 0
              },
              sk: {
                a: 0,
                ix: 4,
                k: 0
              },
              ty: "tr"
            }), this.arr.splice(0, 0, W), this._groups.splice(0, 0, W), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), V = !0;
        }
        L = 0;
        var U;
        for (k = 0; k <= this._groups.length - 1; k += 1) {
          if (U = L < z, this._groups[k]._render = U, this.changeGroupRender(this._groups[k].it, U), !U) {
            var q = this.elemsData[k].it, K = q[q.length - 1];
            K.transform.op.v !== 0 ? (K.transform.op._mdf = !0, K.transform.op.v = 0) : K.transform.op._mdf = !1;
          }
          L += 1;
        }
        this._currentCopies = z;
        var Y = this.o.v, J = Y % 1, Z = Y > 0 ? Math.floor(Y) : Math.ceil(Y), X = this.pMatrix.props, ee = this.rMatrix.props, te = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var re = 0;
        if (Y > 0) {
          for (; re < Z; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), re += 1;
          J && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, J, !1), re += J);
        } else if (Y < 0) {
          for (; re > Z; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), re -= 1;
          J && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -J, !0), re -= J);
        }
        k = this.data.m === 1 ? 0 : this._currentCopies - 1, D = this.data.m === 1 ? 1 : -1, L = this._currentCopies;
        for (var Q, ne; L; ) {
          if (S = this.elemsData[k].it, R = S[S.length - 1].transform.mProps.v.props, ne = R.length, S[S.length - 1].transform.mProps._mdf = !0, S[S.length - 1].transform.op._mdf = !0, S[S.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (k / (this._currentCopies - 1)), re !== 0) {
            for ((k !== 0 && D === 1 || k !== this._currentCopies - 1 && D === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(ee[0], ee[1], ee[2], ee[3], ee[4], ee[5], ee[6], ee[7], ee[8], ee[9], ee[10], ee[11], ee[12], ee[13], ee[14], ee[15]), this.matrix.transform(te[0], te[1], te[2], te[3], te[4], te[5], te[6], te[7], te[8], te[9], te[10], te[11], te[12], te[13], te[14], te[15]), this.matrix.transform(X[0], X[1], X[2], X[3], X[4], X[5], X[6], X[7], X[8], X[9], X[10], X[11], X[12], X[13], X[14], X[15]), Q = 0; Q < ne; Q += 1)
              R[Q] = this.matrix.props[Q];
            this.matrix.reset();
          } else
            for (this.matrix.reset(), Q = 0; Q < ne; Q += 1)
              R[Q] = this.matrix.props[Q];
          re += 1, L -= 1, k += D;
        }
      } else
        for (L = this._currentCopies, k = 0, D = 1; L; )
          S = this.elemsData[k].it, R = S[S.length - 1].transform.mProps.v.props, S[S.length - 1].transform.mProps._mdf = !1, S[S.length - 1].transform.op._mdf = !1, L -= 1, k += D;
      return V;
    }, RepeaterModifier.prototype.addShape = function() {
    };
    function RoundCornersModifier() {
    }
    extendPrototype([ShapeModifier], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(T, S) {
      this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(T, S.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, RoundCornersModifier.prototype.processPath = function(T, S) {
      var R = shapePool.newElement();
      R.c = T.c;
      var k, D = T._length, L, V, z, W, U, q, K = 0, Y, J, Z, X, ee, te;
      for (k = 0; k < D; k += 1)
        L = T.v[k], z = T.o[k], V = T.i[k], L[0] === z[0] && L[1] === z[1] && L[0] === V[0] && L[1] === V[1] ? (k === 0 || k === D - 1) && !T.c ? (R.setTripleAt(L[0], L[1], z[0], z[1], V[0], V[1], K), K += 1) : (k === 0 ? W = T.v[D - 1] : W = T.v[k - 1], U = Math.sqrt(Math.pow(L[0] - W[0], 2) + Math.pow(L[1] - W[1], 2)), q = U ? Math.min(U / 2, S) / U : 0, ee = L[0] + (W[0] - L[0]) * q, Y = ee, te = L[1] - (L[1] - W[1]) * q, J = te, Z = Y - (Y - L[0]) * roundCorner, X = J - (J - L[1]) * roundCorner, R.setTripleAt(Y, J, Z, X, ee, te, K), K += 1, k === D - 1 ? W = T.v[0] : W = T.v[k + 1], U = Math.sqrt(Math.pow(L[0] - W[0], 2) + Math.pow(L[1] - W[1], 2)), q = U ? Math.min(U / 2, S) / U : 0, Z = L[0] + (W[0] - L[0]) * q, Y = Z, X = L[1] + (W[1] - L[1]) * q, J = X, ee = Y - (Y - L[0]) * roundCorner, te = J - (J - L[1]) * roundCorner, R.setTripleAt(Y, J, Z, X, ee, te, K), K += 1) : (R.setTripleAt(T.v[k][0], T.v[k][1], T.o[k][0], T.o[k][1], T.i[k][0], T.i[k][1], K), K += 1);
      return R;
    }, RoundCornersModifier.prototype.processShapes = function(T) {
      var S, R, k = this.shapes.length, D, L, V = this.rd.v;
      if (V !== 0) {
        var z, W;
        for (R = 0; R < k; R += 1) {
          if (z = this.shapes[R], W = z.localShapeCollection, !(!z.shape._mdf && !this._mdf && !T))
            for (W.releaseShapes(), z.shape._mdf = !0, S = z.shape.paths.shapes, L = z.shape.paths._length, D = 0; D < L; D += 1)
              W.addShape(this.processPath(S[D], V));
          z.shape.paths = z.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function floatEqual(T, S) {
      return Math.abs(T - S) * 1e5 <= Math.min(Math.abs(T), Math.abs(S));
    }
    function floatZero(T) {
      return Math.abs(T) <= 1e-5;
    }
    function lerp(T, S, R) {
      return T * (1 - R) + S * R;
    }
    function lerpPoint(T, S, R) {
      return [lerp(T[0], S[0], R), lerp(T[1], S[1], R)];
    }
    function quadRoots(T, S, R) {
      if (T === 0) return [];
      var k = S * S - 4 * T * R;
      if (k < 0) return [];
      var D = -S / (2 * T);
      if (k === 0) return [D];
      var L = Math.sqrt(k) / (2 * T);
      return [D - L, D + L];
    }
    function polynomialCoefficients(T, S, R, k) {
      return [-T + 3 * S - 3 * R + k, 3 * T - 6 * S + 3 * R, -3 * T + 3 * S, T];
    }
    function singlePoint(T) {
      return new PolynomialBezier(T, T, T, T, !1);
    }
    function PolynomialBezier(T, S, R, k, D) {
      D && pointEqual(T, S) && (S = lerpPoint(T, k, 1 / 3)), D && pointEqual(R, k) && (R = lerpPoint(T, k, 2 / 3));
      var L = polynomialCoefficients(T[0], S[0], R[0], k[0]), V = polynomialCoefficients(T[1], S[1], R[1], k[1]);
      this.a = [L[0], V[0]], this.b = [L[1], V[1]], this.c = [L[2], V[2]], this.d = [L[3], V[3]], this.points = [T, S, R, k];
    }
    PolynomialBezier.prototype.point = function(T) {
      return [((this.a[0] * T + this.b[0]) * T + this.c[0]) * T + this.d[0], ((this.a[1] * T + this.b[1]) * T + this.c[1]) * T + this.d[1]];
    }, PolynomialBezier.prototype.derivative = function(T) {
      return [(3 * T * this.a[0] + 2 * this.b[0]) * T + this.c[0], (3 * T * this.a[1] + 2 * this.b[1]) * T + this.c[1]];
    }, PolynomialBezier.prototype.tangentAngle = function(T) {
      var S = this.derivative(T);
      return Math.atan2(S[1], S[0]);
    }, PolynomialBezier.prototype.normalAngle = function(T) {
      var S = this.derivative(T);
      return Math.atan2(S[0], S[1]);
    }, PolynomialBezier.prototype.inflectionPoints = function() {
      var T = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (floatZero(T)) return [];
      var S = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / T, R = S * S - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / T;
      if (R < 0) return [];
      var k = Math.sqrt(R);
      return floatZero(k) ? k > 0 && k < 1 ? [S] : [] : [S - k, S + k].filter(function(D) {
        return D > 0 && D < 1;
      });
    }, PolynomialBezier.prototype.split = function(T) {
      if (T <= 0) return [singlePoint(this.points[0]), this];
      if (T >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
      var S = lerpPoint(this.points[0], this.points[1], T), R = lerpPoint(this.points[1], this.points[2], T), k = lerpPoint(this.points[2], this.points[3], T), D = lerpPoint(S, R, T), L = lerpPoint(R, k, T), V = lerpPoint(D, L, T);
      return [new PolynomialBezier(this.points[0], S, D, V, !0), new PolynomialBezier(V, L, k, this.points[3], !0)];
    };
    function extrema(T, S) {
      var R = T.points[0][S], k = T.points[T.points.length - 1][S];
      if (R > k) {
        var D = k;
        k = R, R = D;
      }
      for (var L = quadRoots(3 * T.a[S], 2 * T.b[S], T.c[S]), V = 0; V < L.length; V += 1)
        if (L[V] > 0 && L[V] < 1) {
          var z = T.point(L[V])[S];
          z < R ? R = z : z > k && (k = z);
        }
      return {
        min: R,
        max: k
      };
    }
    PolynomialBezier.prototype.bounds = function() {
      return {
        x: extrema(this, 0),
        y: extrema(this, 1)
      };
    }, PolynomialBezier.prototype.boundingBox = function() {
      var T = this.bounds();
      return {
        left: T.x.min,
        right: T.x.max,
        top: T.y.min,
        bottom: T.y.max,
        width: T.x.max - T.x.min,
        height: T.y.max - T.y.min,
        cx: (T.x.max + T.x.min) / 2,
        cy: (T.y.max + T.y.min) / 2
      };
    };
    function intersectData(T, S, R) {
      var k = T.boundingBox();
      return {
        cx: k.cx,
        cy: k.cy,
        width: k.width,
        height: k.height,
        bez: T,
        t: (S + R) / 2,
        t1: S,
        t2: R
      };
    }
    function splitData(T) {
      var S = T.bez.split(0.5);
      return [intersectData(S[0], T.t1, T.t), intersectData(S[1], T.t, T.t2)];
    }
    function boxIntersect(T, S) {
      return Math.abs(T.cx - S.cx) * 2 < T.width + S.width && Math.abs(T.cy - S.cy) * 2 < T.height + S.height;
    }
    function intersectsImpl(T, S, R, k, D, L) {
      if (boxIntersect(T, S)) {
        if (R >= L || T.width <= k && T.height <= k && S.width <= k && S.height <= k) {
          D.push([T.t, S.t]);
          return;
        }
        var V = splitData(T), z = splitData(S);
        intersectsImpl(V[0], z[0], R + 1, k, D, L), intersectsImpl(V[0], z[1], R + 1, k, D, L), intersectsImpl(V[1], z[0], R + 1, k, D, L), intersectsImpl(V[1], z[1], R + 1, k, D, L);
      }
    }
    PolynomialBezier.prototype.intersections = function(T, S, R) {
      S === void 0 && (S = 2), R === void 0 && (R = 7);
      var k = [];
      return intersectsImpl(intersectData(this, 0, 1), intersectData(T, 0, 1), 0, S, k, R), k;
    }, PolynomialBezier.shapeSegment = function(T, S) {
      var R = (S + 1) % T.length();
      return new PolynomialBezier(T.v[S], T.o[S], T.i[R], T.v[R], !0);
    }, PolynomialBezier.shapeSegmentInverted = function(T, S) {
      var R = (S + 1) % T.length();
      return new PolynomialBezier(T.v[R], T.i[R], T.o[S], T.v[S], !0);
    };
    function crossProduct(T, S) {
      return [T[1] * S[2] - T[2] * S[1], T[2] * S[0] - T[0] * S[2], T[0] * S[1] - T[1] * S[0]];
    }
    function lineIntersection(T, S, R, k) {
      var D = [T[0], T[1], 1], L = [S[0], S[1], 1], V = [R[0], R[1], 1], z = [k[0], k[1], 1], W = crossProduct(crossProduct(D, L), crossProduct(V, z));
      return floatZero(W[2]) ? null : [W[0] / W[2], W[1] / W[2]];
    }
    function polarOffset(T, S, R) {
      return [T[0] + Math.cos(S) * R, T[1] - Math.sin(S) * R];
    }
    function pointDistance(T, S) {
      return Math.hypot(T[0] - S[0], T[1] - S[1]);
    }
    function pointEqual(T, S) {
      return floatEqual(T[0], S[0]) && floatEqual(T[1], S[1]);
    }
    function ZigZagModifier() {
    }
    extendPrototype([ShapeModifier], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(T, S) {
      this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(T, S.s, 0, null, this), this.frequency = PropertyFactory.getProp(T, S.r, 0, null, this), this.pointsType = PropertyFactory.getProp(T, S.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function setPoint(T, S, R, k, D, L, V) {
      var z = R - Math.PI / 2, W = R + Math.PI / 2, U = S[0] + Math.cos(R) * k * D, q = S[1] - Math.sin(R) * k * D;
      T.setTripleAt(U, q, U + Math.cos(z) * L, q - Math.sin(z) * L, U + Math.cos(W) * V, q - Math.sin(W) * V, T.length());
    }
    function getPerpendicularVector(T, S) {
      var R = [S[0] - T[0], S[1] - T[1]], k = -Math.PI * 0.5, D = [Math.cos(k) * R[0] - Math.sin(k) * R[1], Math.sin(k) * R[0] + Math.cos(k) * R[1]];
      return D;
    }
    function getProjectingAngle(T, S) {
      var R = S === 0 ? T.length() - 1 : S - 1, k = (S + 1) % T.length(), D = T.v[R], L = T.v[k], V = getPerpendicularVector(D, L);
      return Math.atan2(0, 1) - Math.atan2(V[1], V[0]);
    }
    function zigZagCorner(T, S, R, k, D, L, V) {
      var z = getProjectingAngle(S, R), W = S.v[R % S._length], U = S.v[R === 0 ? S._length - 1 : R - 1], q = S.v[(R + 1) % S._length], K = L === 2 ? Math.sqrt(Math.pow(W[0] - U[0], 2) + Math.pow(W[1] - U[1], 2)) : 0, Y = L === 2 ? Math.sqrt(Math.pow(W[0] - q[0], 2) + Math.pow(W[1] - q[1], 2)) : 0;
      setPoint(T, S.v[R % S._length], z, V, k, Y / ((D + 1) * 2), K / ((D + 1) * 2));
    }
    function zigZagSegment(T, S, R, k, D, L) {
      for (var V = 0; V < k; V += 1) {
        var z = (V + 1) / (k + 1), W = D === 2 ? Math.sqrt(Math.pow(S.points[3][0] - S.points[0][0], 2) + Math.pow(S.points[3][1] - S.points[0][1], 2)) : 0, U = S.normalAngle(z), q = S.point(z);
        setPoint(T, q, U, L, R, W / ((k + 1) * 2), W / ((k + 1) * 2)), L = -L;
      }
      return L;
    }
    ZigZagModifier.prototype.processPath = function(T, S, R, k) {
      var D = T._length, L = shapePool.newElement();
      if (L.c = T.c, T.c || (D -= 1), D === 0) return L;
      var V = -1, z = PolynomialBezier.shapeSegment(T, 0);
      zigZagCorner(L, T, 0, S, R, k, V);
      for (var W = 0; W < D; W += 1)
        V = zigZagSegment(L, z, S, R, k, -V), W === D - 1 && !T.c ? z = null : z = PolynomialBezier.shapeSegment(T, (W + 1) % D), zigZagCorner(L, T, W + 1, S, R, k, V);
      return L;
    }, ZigZagModifier.prototype.processShapes = function(T) {
      var S, R, k = this.shapes.length, D, L, V = this.amplitude.v, z = Math.max(0, Math.round(this.frequency.v)), W = this.pointsType.v;
      if (V !== 0) {
        var U, q;
        for (R = 0; R < k; R += 1) {
          if (U = this.shapes[R], q = U.localShapeCollection, !(!U.shape._mdf && !this._mdf && !T))
            for (q.releaseShapes(), U.shape._mdf = !0, S = U.shape.paths.shapes, L = U.shape.paths._length, D = 0; D < L; D += 1)
              q.addShape(this.processPath(S[D], V, z, W));
          U.shape.paths = U.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function linearOffset(T, S, R) {
      var k = Math.atan2(S[0] - T[0], S[1] - T[1]);
      return [polarOffset(T, k, R), polarOffset(S, k, R)];
    }
    function offsetSegment(T, S) {
      var R, k, D, L, V, z, W;
      W = linearOffset(T.points[0], T.points[1], S), R = W[0], k = W[1], W = linearOffset(T.points[1], T.points[2], S), D = W[0], L = W[1], W = linearOffset(T.points[2], T.points[3], S), V = W[0], z = W[1];
      var U = lineIntersection(R, k, D, L);
      U === null && (U = k);
      var q = lineIntersection(V, z, D, L);
      return q === null && (q = V), new PolynomialBezier(R, U, q, z);
    }
    function joinLines(T, S, R, k, D) {
      var L = S.points[3], V = R.points[0];
      if (k === 3 || pointEqual(L, V)) return L;
      if (k === 2) {
        var z = -S.tangentAngle(1), W = -R.tangentAngle(0) + Math.PI, U = lineIntersection(L, polarOffset(L, z + Math.PI / 2, 100), V, polarOffset(V, z + Math.PI / 2, 100)), q = U ? pointDistance(U, L) : pointDistance(L, V) / 2, K = polarOffset(L, z, 2 * q * roundCorner);
        return T.setXYAt(K[0], K[1], "o", T.length() - 1), K = polarOffset(V, W, 2 * q * roundCorner), T.setTripleAt(V[0], V[1], V[0], V[1], K[0], K[1], T.length()), V;
      }
      var Y = pointEqual(L, S.points[2]) ? S.points[0] : S.points[2], J = pointEqual(V, R.points[1]) ? R.points[3] : R.points[1], Z = lineIntersection(Y, L, V, J);
      return Z && pointDistance(Z, L) < D ? (T.setTripleAt(Z[0], Z[1], Z[0], Z[1], Z[0], Z[1], T.length()), Z) : L;
    }
    function getIntersection(T, S) {
      var R = T.intersections(S);
      return R.length && floatEqual(R[0][0], 1) && R.shift(), R.length ? R[0] : null;
    }
    function pruneSegmentIntersection(T, S) {
      var R = T.slice(), k = S.slice(), D = getIntersection(T[T.length - 1], S[0]);
      return D && (R[T.length - 1] = T[T.length - 1].split(D[0])[0], k[0] = S[0].split(D[1])[1]), T.length > 1 && S.length > 1 && (D = getIntersection(T[0], S[S.length - 1]), D) ? [[T[0].split(D[0])[0]], [S[S.length - 1].split(D[1])[1]]] : [R, k];
    }
    function pruneIntersections(T) {
      for (var S, R = 1; R < T.length; R += 1)
        S = pruneSegmentIntersection(T[R - 1], T[R]), T[R - 1] = S[0], T[R] = S[1];
      return T.length > 1 && (S = pruneSegmentIntersection(T[T.length - 1], T[0]), T[T.length - 1] = S[0], T[0] = S[1]), T;
    }
    function offsetSegmentSplit(T, S) {
      var R = T.inflectionPoints(), k, D, L, V;
      if (R.length === 0)
        return [offsetSegment(T, S)];
      if (R.length === 1 || floatEqual(R[1], 1))
        return L = T.split(R[0]), k = L[0], D = L[1], [offsetSegment(k, S), offsetSegment(D, S)];
      L = T.split(R[0]), k = L[0];
      var z = (R[1] - R[0]) / (1 - R[0]);
      return L = L[1].split(z), V = L[0], D = L[1], [offsetSegment(k, S), offsetSegment(V, S), offsetSegment(D, S)];
    }
    function OffsetPathModifier() {
    }
    extendPrototype([ShapeModifier], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(T, S) {
      this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(T, S.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(T, S.ml, 0, null, this), this.lineJoin = S.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, OffsetPathModifier.prototype.processPath = function(T, S, R, k) {
      var D = shapePool.newElement();
      D.c = T.c;
      var L = T.length();
      T.c || (L -= 1);
      var V, z, W, U = [];
      for (V = 0; V < L; V += 1)
        W = PolynomialBezier.shapeSegment(T, V), U.push(offsetSegmentSplit(W, S));
      if (!T.c)
        for (V = L - 1; V >= 0; V -= 1)
          W = PolynomialBezier.shapeSegmentInverted(T, V), U.push(offsetSegmentSplit(W, S));
      U = pruneIntersections(U);
      var q = null, K = null;
      for (V = 0; V < U.length; V += 1) {
        var Y = U[V];
        for (K && (q = joinLines(D, K, Y[0], R, k)), K = Y[Y.length - 1], z = 0; z < Y.length; z += 1)
          W = Y[z], q && pointEqual(W.points[0], q) ? D.setXYAt(W.points[1][0], W.points[1][1], "o", D.length() - 1) : D.setTripleAt(W.points[0][0], W.points[0][1], W.points[1][0], W.points[1][1], W.points[0][0], W.points[0][1], D.length()), D.setTripleAt(W.points[3][0], W.points[3][1], W.points[3][0], W.points[3][1], W.points[2][0], W.points[2][1], D.length()), q = W.points[3];
      }
      return U.length && joinLines(D, K, U[0][0], R, k), D;
    }, OffsetPathModifier.prototype.processShapes = function(T) {
      var S, R, k = this.shapes.length, D, L, V = this.amount.v, z = this.miterLimit.v, W = this.lineJoin;
      if (V !== 0) {
        var U, q;
        for (R = 0; R < k; R += 1) {
          if (U = this.shapes[R], q = U.localShapeCollection, !(!U.shape._mdf && !this._mdf && !T))
            for (q.releaseShapes(), U.shape._mdf = !0, S = U.shape.paths.shapes, L = U.shape.paths._length, D = 0; D < L; D += 1)
              q.addShape(this.processPath(S[D], V, W, z));
          U.shape.paths = U.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function getFontProperties(T) {
      for (var S = T.fStyle ? T.fStyle.split(" ") : [], R = "normal", k = "normal", D = S.length, L, V = 0; V < D; V += 1)
        switch (L = S[V].toLowerCase(), L) {
          case "italic":
            k = "italic";
            break;
          case "bold":
            R = "700";
            break;
          case "black":
            R = "900";
            break;
          case "medium":
            R = "500";
            break;
          case "regular":
          case "normal":
            R = "400";
            break;
          case "light":
          case "thin":
            R = "200";
            break;
        }
      return {
        style: k,
        weight: T.fWeight || R
      };
    }
    var FontManager = function() {
      var T = 5e3, S = {
        w: 0,
        size: 0,
        shapes: [],
        data: {
          shapes: []
        }
      }, R = [];
      R = R.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var k = 127988, D = 917631, L = 917601, V = 917626, z = 65039, W = 8205, U = 127462, q = 127487, K = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
      function Y(ue) {
        var Ce = ue.split(","), ce, pe = Ce.length, _e = [];
        for (ce = 0; ce < pe; ce += 1)
          Ce[ce] !== "sans-serif" && Ce[ce] !== "monospace" && _e.push(Ce[ce]);
        return _e.join(",");
      }
      function J(ue, Ce) {
        var ce = createTag("span");
        ce.setAttribute("aria-hidden", !0), ce.style.fontFamily = Ce;
        var pe = createTag("span");
        pe.innerText = "giItT1WQy@!-/#", ce.style.position = "absolute", ce.style.left = "-10000px", ce.style.top = "-10000px", ce.style.fontSize = "300px", ce.style.fontVariant = "normal", ce.style.fontStyle = "normal", ce.style.fontWeight = "normal", ce.style.letterSpacing = "0", ce.appendChild(pe), document.body.appendChild(ce);
        var _e = pe.offsetWidth;
        return pe.style.fontFamily = Y(ue) + ", " + Ce, {
          node: pe,
          w: _e,
          parent: ce
        };
      }
      function Z() {
        var ue, Ce = this.fonts.length, ce, pe, _e = Ce;
        for (ue = 0; ue < Ce; ue += 1)
          this.fonts[ue].loaded ? _e -= 1 : this.fonts[ue].fOrigin === "n" || this.fonts[ue].origin === 0 ? this.fonts[ue].loaded = !0 : (ce = this.fonts[ue].monoCase.node, pe = this.fonts[ue].monoCase.w, ce.offsetWidth !== pe ? (_e -= 1, this.fonts[ue].loaded = !0) : (ce = this.fonts[ue].sansCase.node, pe = this.fonts[ue].sansCase.w, ce.offsetWidth !== pe && (_e -= 1, this.fonts[ue].loaded = !0)), this.fonts[ue].loaded && (this.fonts[ue].sansCase.parent.parentNode.removeChild(this.fonts[ue].sansCase.parent), this.fonts[ue].monoCase.parent.parentNode.removeChild(this.fonts[ue].monoCase.parent)));
        _e !== 0 && Date.now() - this.initTime < T ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }
      function X(ue, Ce) {
        var ce = document.body && Ce ? "svg" : "canvas", pe, _e = getFontProperties(ue);
        if (ce === "svg") {
          var ge = createNS("text");
          ge.style.fontSize = "100px", ge.setAttribute("font-family", ue.fFamily), ge.setAttribute("font-style", _e.style), ge.setAttribute("font-weight", _e.weight), ge.textContent = "1", ue.fClass ? (ge.style.fontFamily = "inherit", ge.setAttribute("class", ue.fClass)) : ge.style.fontFamily = ue.fFamily, Ce.appendChild(ge), pe = ge;
        } else {
          var Ae = new OffscreenCanvas(500, 500).getContext("2d");
          Ae.font = _e.style + " " + _e.weight + " 100px " + ue.fFamily, pe = Ae;
        }
        function Ee(ve) {
          return ce === "svg" ? (pe.textContent = ve, pe.getComputedTextLength()) : pe.measureText(ve).width;
        }
        return {
          measureText: Ee
        };
      }
      function ee(ue, Ce) {
        if (!ue) {
          this.isLoaded = !0;
          return;
        }
        if (this.chars) {
          this.isLoaded = !0, this.fonts = ue.list;
          return;
        }
        if (!document.body) {
          this.isLoaded = !0, ue.list.forEach(function(ye) {
            ye.helper = X(ye), ye.cache = {};
          }), this.fonts = ue.list;
          return;
        }
        var ce = ue.list, pe, _e = ce.length, ge = _e;
        for (pe = 0; pe < _e; pe += 1) {
          var Ae = !0, Ee, ve;
          if (ce[pe].loaded = !1, ce[pe].monoCase = J(ce[pe].fFamily, "monospace"), ce[pe].sansCase = J(ce[pe].fFamily, "sans-serif"), !ce[pe].fPath)
            ce[pe].loaded = !0, ge -= 1;
          else if (ce[pe].fOrigin === "p" || ce[pe].origin === 3) {
            if (Ee = document.querySelectorAll('style[f-forigin="p"][f-family="' + ce[pe].fFamily + '"], style[f-origin="3"][f-family="' + ce[pe].fFamily + '"]'), Ee.length > 0 && (Ae = !1), Ae) {
              var le = createTag("style");
              le.setAttribute("f-forigin", ce[pe].fOrigin), le.setAttribute("f-origin", ce[pe].origin), le.setAttribute("f-family", ce[pe].fFamily), le.type = "text/css", le.innerText = "@font-face {font-family: " + ce[pe].fFamily + "; font-style: normal; src: url('" + ce[pe].fPath + "');}", Ce.appendChild(le);
            }
          } else if (ce[pe].fOrigin === "g" || ce[pe].origin === 1) {
            for (Ee = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), ve = 0; ve < Ee.length; ve += 1)
              Ee[ve].href.indexOf(ce[pe].fPath) !== -1 && (Ae = !1);
            if (Ae) {
              var me = createTag("link");
              me.setAttribute("f-forigin", ce[pe].fOrigin), me.setAttribute("f-origin", ce[pe].origin), me.type = "text/css", me.rel = "stylesheet", me.href = ce[pe].fPath, document.body.appendChild(me);
            }
          } else if (ce[pe].fOrigin === "t" || ce[pe].origin === 2) {
            for (Ee = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), ve = 0; ve < Ee.length; ve += 1)
              ce[pe].fPath === Ee[ve].src && (Ae = !1);
            if (Ae) {
              var Se = createTag("link");
              Se.setAttribute("f-forigin", ce[pe].fOrigin), Se.setAttribute("f-origin", ce[pe].origin), Se.setAttribute("rel", "stylesheet"), Se.setAttribute("href", ce[pe].fPath), Ce.appendChild(Se);
            }
          }
          ce[pe].helper = X(ce[pe], Ce), ce[pe].cache = {}, this.fonts.push(ce[pe]);
        }
        ge === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
      function te(ue) {
        if (ue) {
          this.chars || (this.chars = []);
          var Ce, ce = ue.length, pe, _e = this.chars.length, ge;
          for (Ce = 0; Ce < ce; Ce += 1) {
            for (pe = 0, ge = !1; pe < _e; )
              this.chars[pe].style === ue[Ce].style && this.chars[pe].fFamily === ue[Ce].fFamily && this.chars[pe].ch === ue[Ce].ch && (ge = !0), pe += 1;
            ge || (this.chars.push(ue[Ce]), _e += 1);
          }
        }
      }
      function re(ue, Ce, ce) {
        for (var pe = 0, _e = this.chars.length; pe < _e; ) {
          if (this.chars[pe].ch === ue && this.chars[pe].style === Ce && this.chars[pe].fFamily === ce)
            return this.chars[pe];
          pe += 1;
        }
        return (typeof ue == "string" && ue.charCodeAt(0) !== 13 || !ue) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", ue, Ce, ce)), S;
      }
      function Q(ue, Ce, ce) {
        var pe = this.getFontByName(Ce), _e = ue;
        if (!pe.cache[_e]) {
          var ge = pe.helper;
          if (ue === " ") {
            var Ae = ge.measureText("|" + ue + "|"), Ee = ge.measureText("||");
            pe.cache[_e] = (Ae - Ee) / 100;
          } else
            pe.cache[_e] = ge.measureText(ue) / 100;
        }
        return pe.cache[_e] * ce;
      }
      function ne(ue) {
        for (var Ce = 0, ce = this.fonts.length; Ce < ce; ) {
          if (this.fonts[Ce].fName === ue)
            return this.fonts[Ce];
          Ce += 1;
        }
        return this.fonts[0];
      }
      function oe(ue) {
        var Ce = 0, ce = ue.charCodeAt(0);
        if (ce >= 55296 && ce <= 56319) {
          var pe = ue.charCodeAt(1);
          pe >= 56320 && pe <= 57343 && (Ce = (ce - 55296) * 1024 + pe - 56320 + 65536);
        }
        return Ce;
      }
      function ae(ue, Ce) {
        var ce = ue.toString(16) + Ce.toString(16);
        return K.indexOf(ce) !== -1;
      }
      function se(ue) {
        return ue === W;
      }
      function ie(ue) {
        return ue === z;
      }
      function he(ue) {
        var Ce = oe(ue);
        return Ce >= U && Ce <= q;
      }
      function xe(ue) {
        return he(ue.substr(0, 2)) && he(ue.substr(2, 2));
      }
      function Pe(ue) {
        return R.indexOf(ue) !== -1;
      }
      function Re(ue, Ce) {
        var ce = oe(ue.substr(Ce, 2));
        if (ce !== k)
          return !1;
        var pe = 0;
        for (Ce += 2; pe < 5; ) {
          if (ce = oe(ue.substr(Ce, 2)), ce < L || ce > V)
            return !1;
          pe += 1, Ce += 2;
        }
        return oe(ue.substr(Ce, 2)) === D;
      }
      function ke() {
        this.isLoaded = !0;
      }
      var Te = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      Te.isModifier = ae, Te.isZeroWidthJoiner = se, Te.isFlagEmoji = xe, Te.isRegionalCode = he, Te.isCombinedCharacter = Pe, Te.isRegionalFlag = Re, Te.isVariationSelector = ie, Te.BLACK_FLAG_CODE_POINT = k;
      var fe = {
        addChars: te,
        addFonts: ee,
        getCharData: re,
        getFontByName: ne,
        measureText: Q,
        checkLoadedFonts: Z,
        setIsLoaded: ke
      };
      return Te.prototype = fe, Te;
    }();
    function SlotManager(T) {
      this.animationData = T;
    }
    SlotManager.prototype.getProp = function(T) {
      return this.animationData.slots && this.animationData.slots[T.sid] ? Object.assign(T, this.animationData.slots[T.sid].p) : T;
    };
    function slotFactory(T) {
      return new SlotManager(T);
    }
    function RenderableElement() {
    }
    RenderableElement.prototype = {
      initRenderable: function() {
        this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
      },
      addRenderableComponent: function(S) {
        this.renderableComponents.indexOf(S) === -1 && this.renderableComponents.push(S);
      },
      removeRenderableComponent: function(S) {
        this.renderableComponents.indexOf(S) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(S), 1);
      },
      prepareRenderableFrame: function(S) {
        this.checkLayerLimits(S);
      },
      checkTransparency: function() {
        this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
      },
      /**
         * @function
         * Initializes frame related properties.
         *
         * @param {number} num
         * current frame number in Layer's time
         *
         */
      checkLayerLimits: function(S) {
        this.data.ip - this.data.st <= S && this.data.op - this.data.st > S ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
      },
      renderRenderable: function() {
        var S, R = this.renderableComponents.length;
        for (S = 0; S < R; S += 1)
          this.renderableComponents[S].renderFrame(this._isFirstFrame);
      },
      sourceRectAtTime: function() {
        return {
          top: 0,
          left: 0,
          width: 100,
          height: 100
        };
      },
      getLayerSize: function() {
        return this.data.ty === 5 ? {
          w: this.data.textData.width,
          h: this.data.textData.height
        } : {
          w: this.data.width,
          h: this.data.height
        };
      }
    };
    var getBlendMode = /* @__PURE__ */ function() {
      var T = {
        0: "source-over",
        1: "multiply",
        2: "screen",
        3: "overlay",
        4: "darken",
        5: "lighten",
        6: "color-dodge",
        7: "color-burn",
        8: "hard-light",
        9: "soft-light",
        10: "difference",
        11: "exclusion",
        12: "hue",
        13: "saturation",
        14: "color",
        15: "luminosity"
      };
      return function(S) {
        return T[S] || "";
      };
    }();
    function SliderEffect(T, S, R) {
      this.p = PropertyFactory.getProp(S, T.v, 0, 0, R);
    }
    function AngleEffect(T, S, R) {
      this.p = PropertyFactory.getProp(S, T.v, 0, 0, R);
    }
    function ColorEffect(T, S, R) {
      this.p = PropertyFactory.getProp(S, T.v, 1, 0, R);
    }
    function PointEffect(T, S, R) {
      this.p = PropertyFactory.getProp(S, T.v, 1, 0, R);
    }
    function LayerIndexEffect(T, S, R) {
      this.p = PropertyFactory.getProp(S, T.v, 0, 0, R);
    }
    function MaskIndexEffect(T, S, R) {
      this.p = PropertyFactory.getProp(S, T.v, 0, 0, R);
    }
    function CheckboxEffect(T, S, R) {
      this.p = PropertyFactory.getProp(S, T.v, 0, 0, R);
    }
    function NoValueEffect() {
      this.p = {};
    }
    function EffectsManager(T, S) {
      var R = T.ef || [];
      this.effectElements = [];
      var k, D = R.length, L;
      for (k = 0; k < D; k += 1)
        L = new GroupEffect(R[k], S), this.effectElements.push(L);
    }
    function GroupEffect(T, S) {
      this.init(T, S);
    }
    extendPrototype([DynamicPropertyContainer], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(T, S) {
      this.data = T, this.effectElements = [], this.initDynamicPropertyContainer(S);
      var R, k = this.data.ef.length, D, L = this.data.ef;
      for (R = 0; R < k; R += 1) {
        switch (D = null, L[R].ty) {
          case 0:
            D = new SliderEffect(L[R], S, this);
            break;
          case 1:
            D = new AngleEffect(L[R], S, this);
            break;
          case 2:
            D = new ColorEffect(L[R], S, this);
            break;
          case 3:
            D = new PointEffect(L[R], S, this);
            break;
          case 4:
          case 7:
            D = new CheckboxEffect(L[R], S, this);
            break;
          case 10:
            D = new LayerIndexEffect(L[R], S, this);
            break;
          case 11:
            D = new MaskIndexEffect(L[R], S, this);
            break;
          case 5:
            D = new EffectsManager(L[R], S);
            break;
          default:
            D = new NoValueEffect(L[R]);
            break;
        }
        D && this.effectElements.push(D);
      }
    };
    function BaseElement() {
    }
    BaseElement.prototype = {
      checkMasks: function() {
        if (!this.data.hasMask)
          return !1;
        for (var S = 0, R = this.data.masksProperties.length; S < R; ) {
          if (this.data.masksProperties[S].mode !== "n" && this.data.masksProperties[S].cl !== !1)
            return !0;
          S += 1;
        }
        return !1;
      },
      initExpressions: function() {
        var S = getExpressionInterfaces();
        if (S) {
          var R = S("layer"), k = S("effects"), D = S("shape"), L = S("text"), V = S("comp");
          this.layerInterface = R(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
          var z = k.createEffectsInterface(this, this.layerInterface);
          this.layerInterface.registerEffectsInterface(z), this.data.ty === 0 || this.data.xt ? this.compInterface = V(this) : this.data.ty === 4 ? (this.layerInterface.shapeInterface = D(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : this.data.ty === 5 && (this.layerInterface.textInterface = L(this), this.layerInterface.text = this.layerInterface.textInterface);
        }
      },
      setBlendMode: function() {
        var S = getBlendMode(this.data.bm), R = this.baseElement || this.layerElement;
        R.style["mix-blend-mode"] = S;
      },
      initBaseData: function(S, R, k) {
        this.globalData = R, this.comp = k, this.data = S, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
      },
      getType: function() {
        return this.type;
      },
      sourceRectAtTime: function() {
      }
    };
    function FrameElement() {
    }
    FrameElement.prototype = {
      /**
         * @function
         * Initializes frame related properties.
         *
         */
      initFrame: function() {
        this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
      },
      /**
         * @function
         * Calculates all dynamic values
         *
         * @param {number} num
         * current frame number in Layer's time
         * @param {boolean} isVisible
         * if layers is currently in range
         *
         */
      prepareProperties: function(S, R) {
        var k, D = this.dynamicProperties.length;
        for (k = 0; k < D; k += 1)
          (R || this._isParent && this.dynamicProperties[k].propType === "transform") && (this.dynamicProperties[k].getValue(), this.dynamicProperties[k]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
      },
      addDynamicProperty: function(S) {
        this.dynamicProperties.indexOf(S) === -1 && this.dynamicProperties.push(S);
      }
    };
    function FootageElement(T, S, R) {
      this.initFrame(), this.initRenderable(), this.assetData = S.getAssetData(T.refId), this.footageData = S.imageLoader.getAsset(this.assetData), this.initBaseData(T, S, R);
    }
    FootageElement.prototype.prepareFrame = function() {
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement), FootageElement.prototype.getBaseElement = function() {
      return null;
    }, FootageElement.prototype.renderFrame = function() {
    }, FootageElement.prototype.destroy = function() {
    }, FootageElement.prototype.initExpressions = function() {
      var T = getExpressionInterfaces();
      if (T) {
        var S = T("footage");
        this.layerInterface = S(this);
      }
    }, FootageElement.prototype.getFootageData = function() {
      return this.footageData;
    };
    function AudioElement(T, S, R) {
      this.initFrame(), this.initRenderable(), this.assetData = S.getAssetData(T.refId), this.initBaseData(T, S, R), this._isPlaying = !1, this._canPlay = !1;
      var k = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(k), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = T.tm ? PropertyFactory.getProp(this, T.tm, 0, S.frameRate, this) : {
        _placeholder: !0
      }, this.lv = PropertyFactory.getProp(this, T.au && T.au.lv ? T.au.lv : {
        k: [100]
      }, 1, 0.01, this);
    }
    AudioElement.prototype.prepareFrame = function(T) {
      if (this.prepareRenderableFrame(T, !0), this.prepareProperties(T, !0), this.tm._placeholder)
        this._currentTime = T / this.data.sr;
      else {
        var S = this.tm.v;
        this._currentTime = S;
      }
      this._volume = this.lv.v[0];
      var R = this._volume * this._volumeMultiplier;
      this._previousVolume !== R && (this._previousVolume = R, this.audio.volume(R));
    }, extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement), AudioElement.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, AudioElement.prototype.show = function() {
    }, AudioElement.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, AudioElement.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, AudioElement.prototype.resume = function() {
      this._canPlay = !0;
    }, AudioElement.prototype.setRate = function(T) {
      this.audio.rate(T);
    }, AudioElement.prototype.volume = function(T) {
      this._volumeMultiplier = T, this._previousVolume = T * this._volume, this.audio.volume(this._previousVolume);
    }, AudioElement.prototype.getBaseElement = function() {
      return null;
    }, AudioElement.prototype.destroy = function() {
    }, AudioElement.prototype.sourceRectAtTime = function() {
    }, AudioElement.prototype.initExpressions = function() {
    };
    function BaseRenderer() {
    }
    BaseRenderer.prototype.checkLayers = function(T) {
      var S, R = this.layers.length, k;
      for (this.completeLayers = !0, S = R - 1; S >= 0; S -= 1)
        this.elements[S] || (k = this.layers[S], k.ip - k.st <= T - this.layers[S].st && k.op - k.st > T - this.layers[S].st && this.buildItem(S)), this.completeLayers = this.elements[S] ? this.completeLayers : !1;
      this.checkPendingElements();
    }, BaseRenderer.prototype.createItem = function(T) {
      switch (T.ty) {
        case 2:
          return this.createImage(T);
        case 0:
          return this.createComp(T);
        case 1:
          return this.createSolid(T);
        case 3:
          return this.createNull(T);
        case 4:
          return this.createShape(T);
        case 5:
          return this.createText(T);
        case 6:
          return this.createAudio(T);
        case 13:
          return this.createCamera(T);
        case 15:
          return this.createFootage(T);
        default:
          return this.createNull(T);
      }
    }, BaseRenderer.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, BaseRenderer.prototype.createAudio = function(T) {
      return new AudioElement(T, this.globalData, this);
    }, BaseRenderer.prototype.createFootage = function(T) {
      return new FootageElement(T, this.globalData, this);
    }, BaseRenderer.prototype.buildAllItems = function() {
      var T, S = this.layers.length;
      for (T = 0; T < S; T += 1)
        this.buildItem(T);
      this.checkPendingElements();
    }, BaseRenderer.prototype.includeLayers = function(T) {
      this.completeLayers = !1;
      var S, R = T.length, k, D = this.layers.length;
      for (S = 0; S < R; S += 1)
        for (k = 0; k < D; ) {
          if (this.layers[k].id === T[S].id) {
            this.layers[k] = T[S];
            break;
          }
          k += 1;
        }
    }, BaseRenderer.prototype.setProjectInterface = function(T) {
      this.globalData.projectInterface = T;
    }, BaseRenderer.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, BaseRenderer.prototype.buildElementParenting = function(T, S, R) {
      for (var k = this.elements, D = this.layers, L = 0, V = D.length; L < V; )
        D[L].ind == S && (!k[L] || k[L] === !0 ? (this.buildItem(L), this.addPendingElement(T)) : (R.push(k[L]), k[L].setAsParent(), D[L].parent !== void 0 ? this.buildElementParenting(T, D[L].parent, R) : T.setHierarchy(R))), L += 1;
    }, BaseRenderer.prototype.addPendingElement = function(T) {
      this.pendingElements.push(T);
    }, BaseRenderer.prototype.searchExtraCompositions = function(T) {
      var S, R = T.length;
      for (S = 0; S < R; S += 1)
        if (T[S].xt) {
          var k = this.createComp(T[S]);
          k.initExpressions(), this.globalData.projectInterface.registerComposition(k);
        }
    }, BaseRenderer.prototype.getElementById = function(T) {
      var S, R = this.elements.length;
      for (S = 0; S < R; S += 1)
        if (this.elements[S].data.ind === T)
          return this.elements[S];
      return null;
    }, BaseRenderer.prototype.getElementByPath = function(T) {
      var S = T.shift(), R;
      if (typeof S == "number")
        R = this.elements[S];
      else {
        var k, D = this.elements.length;
        for (k = 0; k < D; k += 1)
          if (this.elements[k].data.nm === S) {
            R = this.elements[k];
            break;
          }
      }
      return T.length === 0 ? R : R.getElementByPath(T);
    }, BaseRenderer.prototype.setupGlobalData = function(T, S) {
      this.globalData.fontManager = new FontManager(), this.globalData.slotManager = slotFactory(T), this.globalData.fontManager.addChars(T.chars), this.globalData.fontManager.addFonts(T.fonts, S), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = T.fr, this.globalData.nm = T.nm, this.globalData.compSize = {
        w: T.w,
        h: T.h
      };
    };
    var effectTypes = {
      TRANSFORM_EFFECT: "transformEFfect"
    };
    function TransformElement() {
    }
    TransformElement.prototype = {
      initTransform: function() {
        var S = new Matrix();
        this.finalTransform = {
          mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
            o: 0
          },
          _matMdf: !1,
          _localMatMdf: !1,
          _opMdf: !1,
          mat: S,
          localMat: S,
          localOpacity: 1
        }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
      },
      renderTransform: function() {
        if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
          var S, R = this.finalTransform.mat, k = 0, D = this.hierarchy.length;
          if (!this.finalTransform._matMdf)
            for (; k < D; ) {
              if (this.hierarchy[k].finalTransform.mProp._mdf) {
                this.finalTransform._matMdf = !0;
                break;
              }
              k += 1;
            }
          if (this.finalTransform._matMdf)
            for (S = this.finalTransform.mProp.v.props, R.cloneFromProps(S), k = 0; k < D; k += 1)
              R.multiply(this.hierarchy[k].finalTransform.mProp.v);
        }
        this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
      },
      renderLocalTransform: function() {
        if (this.localTransforms) {
          var S = 0, R = this.localTransforms.length;
          if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf)
            for (; S < R; )
              this.localTransforms[S]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[S]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), S += 1;
          if (this.finalTransform._localMatMdf) {
            var k = this.finalTransform.localMat;
            for (this.localTransforms[0].matrix.clone(k), S = 1; S < R; S += 1) {
              var D = this.localTransforms[S].matrix;
              k.multiply(D);
            }
            k.multiply(this.finalTransform.mat);
          }
          if (this.finalTransform._opMdf) {
            var L = this.finalTransform.localOpacity;
            for (S = 0; S < R; S += 1)
              L *= this.localTransforms[S].opacity * 0.01;
            this.finalTransform.localOpacity = L;
          }
        }
      },
      searchEffectTransforms: function() {
        if (this.renderableEffectsManager) {
          var S = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
          if (S.length) {
            this.localTransforms = [], this.finalTransform.localMat = new Matrix();
            var R = 0, k = S.length;
            for (R = 0; R < k; R += 1)
              this.localTransforms.push(S[R]);
          }
        }
      },
      globalToLocal: function(S) {
        var R = [];
        R.push(this.finalTransform);
        for (var k = !0, D = this.comp; k; )
          D.finalTransform ? (D.data.hasMask && R.splice(0, 0, D.finalTransform), D = D.comp) : k = !1;
        var L, V = R.length, z;
        for (L = 0; L < V; L += 1)
          z = R[L].mat.applyToPointArray(0, 0, 0), S = [S[0] - z[0], S[1] - z[1], 0];
        return S;
      },
      mHelper: new Matrix()
    };
    function MaskElement(T, S, R) {
      this.data = T, this.element = S, this.globalData = R, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var k = this.globalData.defs, D, L = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = createSizedArray(L), this.solidPath = "";
      var V, z = this.masksProperties, W = 0, U = [], q, K, Y = createElementID(), J, Z, X, ee, te = "clipPath", re = "clip-path";
      for (D = 0; D < L; D += 1)
        if ((z[D].mode !== "a" && z[D].mode !== "n" || z[D].inv || z[D].o.k !== 100 || z[D].o.x) && (te = "mask", re = "mask"), (z[D].mode === "s" || z[D].mode === "i") && W === 0 ? (J = createNS("rect"), J.setAttribute("fill", "#ffffff"), J.setAttribute("width", this.element.comp.data.w || 0), J.setAttribute("height", this.element.comp.data.h || 0), U.push(J)) : J = null, V = createNS("path"), z[D].mode === "n")
          this.viewData[D] = {
            op: PropertyFactory.getProp(this.element, z[D].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, z[D], 3),
            elem: V,
            lastPath: ""
          }, k.appendChild(V);
        else {
          W += 1, V.setAttribute("fill", z[D].mode === "s" ? "#000000" : "#ffffff"), V.setAttribute("clip-rule", "nonzero");
          var Q;
          if (z[D].x.k !== 0 ? (te = "mask", re = "mask", ee = PropertyFactory.getProp(this.element, z[D].x, 0, null, this.element), Q = createElementID(), Z = createNS("filter"), Z.setAttribute("id", Q), X = createNS("feMorphology"), X.setAttribute("operator", "erode"), X.setAttribute("in", "SourceGraphic"), X.setAttribute("radius", "0"), Z.appendChild(X), k.appendChild(Z), V.setAttribute("stroke", z[D].mode === "s" ? "#000000" : "#ffffff")) : (X = null, ee = null), this.storedData[D] = {
            elem: V,
            x: ee,
            expan: X,
            lastPath: "",
            lastOperator: "",
            filterId: Q,
            lastRadius: 0
          }, z[D].mode === "i") {
            K = U.length;
            var ne = createNS("g");
            for (q = 0; q < K; q += 1)
              ne.appendChild(U[q]);
            var oe = createNS("mask");
            oe.setAttribute("mask-type", "alpha"), oe.setAttribute("id", Y + "_" + W), oe.appendChild(V), k.appendChild(oe), ne.setAttribute("mask", "url(" + getLocationHref() + "#" + Y + "_" + W + ")"), U.length = 0, U.push(ne);
          } else
            U.push(V);
          z[D].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[D] = {
            elem: V,
            lastPath: "",
            op: PropertyFactory.getProp(this.element, z[D].o, 0, 0.01, this.element),
            prop: ShapePropertyFactory.getShapeProp(this.element, z[D], 3),
            invRect: J
          }, this.viewData[D].prop.k || this.drawPath(z[D], this.viewData[D].prop.v, this.viewData[D]);
        }
      for (this.maskElement = createNS(te), L = U.length, D = 0; D < L; D += 1)
        this.maskElement.appendChild(U[D]);
      W > 0 && (this.maskElement.setAttribute("id", Y), this.element.maskedElement.setAttribute(re, "url(" + getLocationHref() + "#" + Y + ")"), k.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    MaskElement.prototype.getMaskProperty = function(T) {
      return this.viewData[T].prop;
    }, MaskElement.prototype.renderFrame = function(T) {
      var S = this.element.finalTransform.mat, R, k = this.masksProperties.length;
      for (R = 0; R < k; R += 1)
        if ((this.viewData[R].prop._mdf || T) && this.drawPath(this.masksProperties[R], this.viewData[R].prop.v, this.viewData[R]), (this.viewData[R].op._mdf || T) && this.viewData[R].elem.setAttribute("fill-opacity", this.viewData[R].op.v), this.masksProperties[R].mode !== "n" && (this.viewData[R].invRect && (this.element.finalTransform.mProp._mdf || T) && this.viewData[R].invRect.setAttribute("transform", S.getInverseMatrix().to2dCSS()), this.storedData[R].x && (this.storedData[R].x._mdf || T))) {
          var D = this.storedData[R].expan;
          this.storedData[R].x.v < 0 ? (this.storedData[R].lastOperator !== "erode" && (this.storedData[R].lastOperator = "erode", this.storedData[R].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[R].filterId + ")")), D.setAttribute("radius", -this.storedData[R].x.v)) : (this.storedData[R].lastOperator !== "dilate" && (this.storedData[R].lastOperator = "dilate", this.storedData[R].elem.setAttribute("filter", null)), this.storedData[R].elem.setAttribute("stroke-width", this.storedData[R].x.v * 2));
        }
    }, MaskElement.prototype.getMaskelement = function() {
      return this.maskElement;
    }, MaskElement.prototype.createLayerSolidPath = function() {
      var T = "M0,0 ";
      return T += " h" + this.globalData.compSize.w, T += " v" + this.globalData.compSize.h, T += " h-" + this.globalData.compSize.w, T += " v-" + this.globalData.compSize.h + " ", T;
    }, MaskElement.prototype.drawPath = function(T, S, R) {
      var k = " M" + S.v[0][0] + "," + S.v[0][1], D, L;
      for (L = S._length, D = 1; D < L; D += 1)
        k += " C" + S.o[D - 1][0] + "," + S.o[D - 1][1] + " " + S.i[D][0] + "," + S.i[D][1] + " " + S.v[D][0] + "," + S.v[D][1];
      if (S.c && L > 1 && (k += " C" + S.o[D - 1][0] + "," + S.o[D - 1][1] + " " + S.i[0][0] + "," + S.i[0][1] + " " + S.v[0][0] + "," + S.v[0][1]), R.lastPath !== k) {
        var V = "";
        R.elem && (S.c && (V = T.inv ? this.solidPath + k : k), R.elem.setAttribute("d", V)), R.lastPath = k;
      }
    }, MaskElement.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var filtersFactory = function() {
      var T = {};
      T.createFilter = S, T.createAlphaToLuminanceFilter = R;
      function S(k, D) {
        var L = createNS("filter");
        return L.setAttribute("id", k), D !== !0 && (L.setAttribute("filterUnits", "objectBoundingBox"), L.setAttribute("x", "0%"), L.setAttribute("y", "0%"), L.setAttribute("width", "100%"), L.setAttribute("height", "100%")), L;
      }
      function R() {
        var k = createNS("feColorMatrix");
        return k.setAttribute("type", "matrix"), k.setAttribute("color-interpolation-filters", "sRGB"), k.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), k;
      }
      return T;
    }(), featureSupport = function() {
      var T = {
        maskType: !0,
        svgLumaHidden: !0,
        offscreenCanvas: typeof OffscreenCanvas < "u"
      };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (T.maskType = !1), /firefox/i.test(navigator.userAgent) && (T.svgLumaHidden = !1), T;
    }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
    function SVGEffects(T) {
      var S, R = "SourceGraphic", k = T.data.ef ? T.data.ef.length : 0, D = createElementID(), L = filtersFactory.createFilter(D, !0), V = 0;
      this.filters = [];
      var z;
      for (S = 0; S < k; S += 1) {
        z = null;
        var W = T.data.ef[S].ty;
        if (registeredEffects$1[W]) {
          var U = registeredEffects$1[W].effect;
          z = new U(L, T.effectsManager.effectElements[S], T, idPrefix + V, R), R = idPrefix + V, registeredEffects$1[W].countsAsEffect && (V += 1);
        }
        z && this.filters.push(z);
      }
      V && (T.globalData.defs.appendChild(L), T.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + D + ")")), this.filters.length && T.addRenderableComponent(this);
    }
    SVGEffects.prototype.renderFrame = function(T) {
      var S, R = this.filters.length;
      for (S = 0; S < R; S += 1)
        this.filters[S].renderFrame(T);
    }, SVGEffects.prototype.getEffects = function(T) {
      var S, R = this.filters.length, k = [];
      for (S = 0; S < R; S += 1)
        this.filters[S].type === T && k.push(this.filters[S]);
      return k;
    };
    function registerEffect$1(T, S, R) {
      registeredEffects$1[T] = {
        effect: S,
        countsAsEffect: R
      };
    }
    function SVGBaseElement() {
    }
    SVGBaseElement.prototype = {
      initRendererElement: function() {
        this.layerElement = createNS("g");
      },
      createContainerElements: function() {
        this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
        var S = null;
        if (this.data.td) {
          this.matteMasks = {};
          var R = createNS("g");
          R.setAttribute("id", this.layerId), R.appendChild(this.layerElement), S = R, this.globalData.defs.appendChild(R);
        } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), S = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
        if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
          var k = createNS("clipPath"), D = createNS("path");
          D.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
          var L = createElementID();
          if (k.setAttribute("id", L), k.appendChild(D), this.globalData.defs.appendChild(k), this.checkMasks()) {
            var V = createNS("g");
            V.setAttribute("clip-path", "url(" + getLocationHref() + "#" + L + ")"), V.appendChild(this.layerElement), this.transformedElement = V, S ? S.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
          } else
            this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + L + ")");
        }
        this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
      },
      destroyBaseElement: function() {
        this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
      },
      getBaseElement: function() {
        return this.data.hd ? null : this.baseElement;
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
      },
      getMatte: function(S) {
        if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[S]) {
          var R = this.layerId + "_" + S, k, D, L, V;
          if (S === 1 || S === 3) {
            var z = createNS("mask");
            z.setAttribute("id", R), z.setAttribute("mask-type", S === 3 ? "luminance" : "alpha"), L = createNS("use"), L.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), z.appendChild(L), this.globalData.defs.appendChild(z), !featureSupport.maskType && S === 1 && (z.setAttribute("mask-type", "luminance"), k = createElementID(), D = filtersFactory.createFilter(k), this.globalData.defs.appendChild(D), D.appendChild(filtersFactory.createAlphaToLuminanceFilter()), V = createNS("g"), V.appendChild(L), z.appendChild(V), V.setAttribute("filter", "url(" + getLocationHref() + "#" + k + ")"));
          } else if (S === 2) {
            var W = createNS("mask");
            W.setAttribute("id", R), W.setAttribute("mask-type", "alpha");
            var U = createNS("g");
            W.appendChild(U), k = createElementID(), D = filtersFactory.createFilter(k);
            var q = createNS("feComponentTransfer");
            q.setAttribute("in", "SourceGraphic"), D.appendChild(q);
            var K = createNS("feFuncA");
            K.setAttribute("type", "table"), K.setAttribute("tableValues", "1.0 0.0"), q.appendChild(K), this.globalData.defs.appendChild(D);
            var Y = createNS("rect");
            Y.setAttribute("width", this.comp.data.w), Y.setAttribute("height", this.comp.data.h), Y.setAttribute("x", "0"), Y.setAttribute("y", "0"), Y.setAttribute("fill", "#ffffff"), Y.setAttribute("opacity", "0"), U.setAttribute("filter", "url(" + getLocationHref() + "#" + k + ")"), U.appendChild(Y), L = createNS("use"), L.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), U.appendChild(L), featureSupport.maskType || (W.setAttribute("mask-type", "luminance"), D.appendChild(filtersFactory.createAlphaToLuminanceFilter()), V = createNS("g"), U.appendChild(Y), V.appendChild(this.layerElement), U.appendChild(V)), this.globalData.defs.appendChild(W);
          }
          this.matteMasks[S] = R;
        }
        return this.matteMasks[S];
      },
      setMatte: function(S) {
        this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + S + ")");
      }
    };
    function HierarchyElement() {
    }
    HierarchyElement.prototype = {
      /**
         * @function
         * Initializes hierarchy properties
         *
         */
      initHierarchy: function() {
        this.hierarchy = [], this._isParent = !1, this.checkParenting();
      },
      /**
         * @function
         * Sets layer's hierarchy.
         * @param {array} hierarch
         * layer's parent list
         *
         */
      setHierarchy: function(S) {
        this.hierarchy = S;
      },
      /**
         * @function
         * Sets layer as parent.
         *
         */
      setAsParent: function() {
        this._isParent = !0;
      },
      /**
         * @function
         * Searches layer's parenting chain
         *
         */
      checkParenting: function() {
        this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
      }
    };
    function RenderableDOMElement() {
    }
    (function() {
      var T = {
        initElement: function(R, k, D) {
          this.initFrame(), this.initBaseData(R, k, D), this.initTransform(R, k, D), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
        },
        hide: function() {
          if (!this.hidden && (!this.isInRange || this.isTransparent)) {
            var R = this.baseElement || this.layerElement;
            R.style.display = "none", this.hidden = !0;
          }
        },
        show: function() {
          if (this.isInRange && !this.isTransparent) {
            if (!this.data.hd) {
              var R = this.baseElement || this.layerElement;
              R.style.display = "block";
            }
            this.hidden = !1, this._isFirstFrame = !0;
          }
        },
        renderFrame: function() {
          this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
        },
        renderInnerContent: function() {
        },
        prepareFrame: function(R) {
          this._mdf = !1, this.prepareRenderableFrame(R), this.prepareProperties(R, this.isInRange), this.checkTransparency();
        },
        destroy: function() {
          this.innerElem = null, this.destroyBaseElement();
        }
      };
      extendPrototype([RenderableElement, createProxyFunction(T)], RenderableDOMElement);
    })();
    function IImageElement(T, S, R) {
      this.assetData = S.getAssetData(T.refId), this.assetData && this.assetData.sid && (this.assetData = S.slotManager.getProp(this.assetData)), this.initElement(T, S, R), this.sourceRect = {
        top: 0,
        left: 0,
        width: this.assetData.w,
        height: this.assetData.h
      };
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement), IImageElement.prototype.createContent = function() {
      var T = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", T), this.layerElement.appendChild(this.innerElem);
    }, IImageElement.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    };
    function ProcessedElement(T, S) {
      this.elem = T, this.pos = S;
    }
    function IShapeElement() {
    }
    IShapeElement.prototype = {
      addShapeToModifiers: function(S) {
        var R, k = this.shapeModifiers.length;
        for (R = 0; R < k; R += 1)
          this.shapeModifiers[R].addShape(S);
      },
      isShapeInAnimatedModifiers: function(S) {
        for (var R = 0, k = this.shapeModifiers.length; R < k; )
          if (this.shapeModifiers[R].isAnimatedWithShape(S))
            return !0;
        return !1;
      },
      renderModifiers: function() {
        if (this.shapeModifiers.length) {
          var S, R = this.shapes.length;
          for (S = 0; S < R; S += 1)
            this.shapes[S].sh.reset();
          R = this.shapeModifiers.length;
          var k;
          for (S = R - 1; S >= 0 && (k = this.shapeModifiers[S].processShapes(this._isFirstFrame), !k); S -= 1)
            ;
        }
      },
      searchProcessedElement: function(S) {
        for (var R = this.processedElements, k = 0, D = R.length; k < D; ) {
          if (R[k].elem === S)
            return R[k].pos;
          k += 1;
        }
        return 0;
      },
      addProcessedElement: function(S, R) {
        for (var k = this.processedElements, D = k.length; D; )
          if (D -= 1, k[D].elem === S) {
            k[D].pos = R;
            return;
          }
        k.push(new ProcessedElement(S, R));
      },
      prepareFrame: function(S) {
        this.prepareRenderableFrame(S), this.prepareProperties(S, this.isInRange);
      }
    };
    var lineCapEnum = {
      1: "butt",
      2: "round",
      3: "square"
    }, lineJoinEnum = {
      1: "miter",
      2: "round",
      3: "bevel"
    };
    function SVGShapeData(T, S, R) {
      this.caches = [], this.styles = [], this.transformers = T, this.lStr = "", this.sh = R, this.lvl = S, this._isAnimated = !!R.k;
      for (var k = 0, D = T.length; k < D; ) {
        if (T[k].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        k += 1;
      }
    }
    SVGShapeData.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    };
    function SVGStyleData(T, S) {
      this.data = T, this.type = T.ty, this.d = "", this.lvl = S, this._mdf = !1, this.closed = T.hd === !0, this.pElem = createNS("path"), this.msElem = null;
    }
    SVGStyleData.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    };
    function DashProperty(T, S, R, k) {
      this.elem = T, this.frameId = -1, this.dataProps = createSizedArray(S.length), this.renderer = R, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", S.length ? S.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(k);
      var D, L = S.length || 0, V;
      for (D = 0; D < L; D += 1)
        V = PropertyFactory.getProp(T, S[D].v, 0, 0, this), this.k = V.k || this.k, this.dataProps[D] = {
          n: S[D].n,
          p: V
        };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    DashProperty.prototype.getValue = function(T) {
      if (!(this.elem.globalData.frameId === this.frameId && !T) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || T, this._mdf)) {
        var S = 0, R = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), S = 0; S < R; S += 1)
          this.dataProps[S].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[S].p.v : this.dashArray[S] = this.dataProps[S].p.v : this.dashoffset[0] = this.dataProps[S].p.v;
      }
    }, extendPrototype([DynamicPropertyContainer], DashProperty);
    function SVGStrokeStyleData(T, S, R) {
      this.initDynamicPropertyContainer(T), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(T, S.o, 0, 0.01, this), this.w = PropertyFactory.getProp(T, S.w, 0, null, this), this.d = new DashProperty(T, S.d || {}, "svg", this), this.c = PropertyFactory.getProp(T, S.c, 1, 255, this), this.style = R, this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);
    function SVGFillStyleData(T, S, R) {
      this.initDynamicPropertyContainer(T), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(T, S.o, 0, 0.01, this), this.c = PropertyFactory.getProp(T, S.c, 1, 255, this), this.style = R;
    }
    extendPrototype([DynamicPropertyContainer], SVGFillStyleData);
    function SVGNoStyleData(T, S, R) {
      this.initDynamicPropertyContainer(T), this.getValue = this.iterateDynamicProperties, this.style = R;
    }
    extendPrototype([DynamicPropertyContainer], SVGNoStyleData);
    function GradientProperty(T, S, R) {
      this.data = S, this.c = createTypedArray("uint8c", S.p * 4);
      var k = S.k.k[0].s ? S.k.k[0].s.length - S.p * 4 : S.k.k.length - S.p * 4;
      this.o = createTypedArray("float32", k), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = k, this.initDynamicPropertyContainer(R), this.prop = PropertyFactory.getProp(T, S.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    GradientProperty.prototype.comparePoints = function(T, S) {
      for (var R = 0, k = this.o.length / 2, D; R < k; ) {
        if (D = Math.abs(T[R * 4] - T[S * 4 + R * 2]), D > 0.01)
          return !1;
        R += 1;
      }
      return !0;
    }, GradientProperty.prototype.checkCollapsable = function() {
      if (this.o.length / 2 !== this.c.length / 4)
        return !1;
      if (this.data.k.k[0].s)
        for (var T = 0, S = this.data.k.k.length; T < S; ) {
          if (!this.comparePoints(this.data.k.k[T].s, this.data.p))
            return !1;
          T += 1;
        }
      else if (!this.comparePoints(this.data.k.k, this.data.p))
        return !1;
      return !0;
    }, GradientProperty.prototype.getValue = function(T) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || T) {
        var S, R = this.data.p * 4, k, D;
        for (S = 0; S < R; S += 1)
          k = S % 4 === 0 ? 100 : 255, D = Math.round(this.prop.v[S] * k), this.c[S] !== D && (this.c[S] = D, this._cmdf = !T);
        if (this.o.length)
          for (R = this.prop.v.length, S = this.data.p * 4; S < R; S += 1)
            k = S % 2 === 0 ? 100 : 1, D = S % 2 === 0 ? Math.round(this.prop.v[S] * 100) : this.prop.v[S], this.o[S - this.data.p * 4] !== D && (this.o[S - this.data.p * 4] = D, this._omdf = !T);
        this._mdf = !T;
      }
    }, extendPrototype([DynamicPropertyContainer], GradientProperty);
    function SVGGradientFillStyleData(T, S, R) {
      this.initDynamicPropertyContainer(T), this.getValue = this.iterateDynamicProperties, this.initGradientData(T, S, R);
    }
    SVGGradientFillStyleData.prototype.initGradientData = function(T, S, R) {
      this.o = PropertyFactory.getProp(T, S.o, 0, 0.01, this), this.s = PropertyFactory.getProp(T, S.s, 1, null, this), this.e = PropertyFactory.getProp(T, S.e, 1, null, this), this.h = PropertyFactory.getProp(T, S.h || {
        k: 0
      }, 0, 0.01, this), this.a = PropertyFactory.getProp(T, S.a || {
        k: 0
      }, 0, degToRads, this), this.g = new GradientProperty(T, S.g, this), this.style = R, this.stops = [], this.setGradientData(R.pElem, S), this.setGradientOpacity(S, R), this._isAnimated = !!this._isAnimated;
    }, SVGGradientFillStyleData.prototype.setGradientData = function(T, S) {
      var R = createElementID(), k = createNS(S.t === 1 ? "linearGradient" : "radialGradient");
      k.setAttribute("id", R), k.setAttribute("spreadMethod", "pad"), k.setAttribute("gradientUnits", "userSpaceOnUse");
      var D = [], L, V, z;
      for (z = S.g.p * 4, V = 0; V < z; V += 4)
        L = createNS("stop"), k.appendChild(L), D.push(L);
      T.setAttribute(S.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + R + ")"), this.gf = k, this.cst = D;
    }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(T, S) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var R, k, D, L = createNS("mask"), V = createNS("path");
        L.appendChild(V);
        var z = createElementID(), W = createElementID();
        L.setAttribute("id", W);
        var U = createNS(T.t === 1 ? "linearGradient" : "radialGradient");
        U.setAttribute("id", z), U.setAttribute("spreadMethod", "pad"), U.setAttribute("gradientUnits", "userSpaceOnUse"), D = T.g.k.k[0].s ? T.g.k.k[0].s.length : T.g.k.k.length;
        var q = this.stops;
        for (k = T.g.p * 4; k < D; k += 2)
          R = createNS("stop"), R.setAttribute("stop-color", "rgb(255,255,255)"), U.appendChild(R), q.push(R);
        V.setAttribute(T.ty === "gf" ? "fill" : "stroke", "url(" + getLocationHref() + "#" + z + ")"), T.ty === "gs" && (V.setAttribute("stroke-linecap", lineCapEnum[T.lc || 2]), V.setAttribute("stroke-linejoin", lineJoinEnum[T.lj || 2]), T.lj === 1 && V.setAttribute("stroke-miterlimit", T.ml)), this.of = U, this.ms = L, this.ost = q, this.maskId = W, S.msElem = V;
      }
    }, extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);
    function SVGGradientStrokeStyleData(T, S, R) {
      this.initDynamicPropertyContainer(T), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(T, S.w, 0, null, this), this.d = new DashProperty(T, S.d || {}, "svg", this), this.initGradientData(T, S, R), this._isAnimated = !!this._isAnimated;
    }
    extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);
    function ShapeGroupData() {
      this.it = [], this.prevViewData = [], this.gr = createNS("g");
    }
    function SVGTransformData(T, S, R) {
      this.transform = {
        mProps: T,
        op: S,
        container: R
      }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var buildShapeString = function(S, R, k, D) {
      if (R === 0)
        return "";
      var L = S.o, V = S.i, z = S.v, W, U = " M" + D.applyToPointStringified(z[0][0], z[0][1]);
      for (W = 1; W < R; W += 1)
        U += " C" + D.applyToPointStringified(L[W - 1][0], L[W - 1][1]) + " " + D.applyToPointStringified(V[W][0], V[W][1]) + " " + D.applyToPointStringified(z[W][0], z[W][1]);
      return k && R && (U += " C" + D.applyToPointStringified(L[W - 1][0], L[W - 1][1]) + " " + D.applyToPointStringified(V[0][0], V[0][1]) + " " + D.applyToPointStringified(z[0][0], z[0][1]), U += "z"), U;
    }, SVGElementsRenderer = function() {
      var T = new Matrix(), S = new Matrix(), R = {
        createRenderFunction: k
      };
      function k(K) {
        switch (K.ty) {
          case "fl":
            return z;
          case "gf":
            return U;
          case "gs":
            return W;
          case "st":
            return q;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return V;
          case "tr":
            return D;
          case "no":
            return L;
          default:
            return null;
        }
      }
      function D(K, Y, J) {
        (J || Y.transform.op._mdf) && Y.transform.container.setAttribute("opacity", Y.transform.op.v), (J || Y.transform.mProps._mdf) && Y.transform.container.setAttribute("transform", Y.transform.mProps.v.to2dCSS());
      }
      function L() {
      }
      function V(K, Y, J) {
        var Z, X, ee, te, re, Q, ne = Y.styles.length, oe = Y.lvl, ae, se, ie, he;
        for (Q = 0; Q < ne; Q += 1) {
          if (te = Y.sh._mdf || J, Y.styles[Q].lvl < oe) {
            for (se = S.reset(), ie = oe - Y.styles[Q].lvl, he = Y.transformers.length - 1; !te && ie > 0; )
              te = Y.transformers[he].mProps._mdf || te, ie -= 1, he -= 1;
            if (te)
              for (ie = oe - Y.styles[Q].lvl, he = Y.transformers.length - 1; ie > 0; )
                se.multiply(Y.transformers[he].mProps.v), ie -= 1, he -= 1;
          } else
            se = T;
          if (ae = Y.sh.paths, X = ae._length, te) {
            for (ee = "", Z = 0; Z < X; Z += 1)
              re = ae.shapes[Z], re && re._length && (ee += buildShapeString(re, re._length, re.c, se));
            Y.caches[Q] = ee;
          } else
            ee = Y.caches[Q];
          Y.styles[Q].d += K.hd === !0 ? "" : ee, Y.styles[Q]._mdf = te || Y.styles[Q]._mdf;
        }
      }
      function z(K, Y, J) {
        var Z = Y.style;
        (Y.c._mdf || J) && Z.pElem.setAttribute("fill", "rgb(" + bmFloor(Y.c.v[0]) + "," + bmFloor(Y.c.v[1]) + "," + bmFloor(Y.c.v[2]) + ")"), (Y.o._mdf || J) && Z.pElem.setAttribute("fill-opacity", Y.o.v);
      }
      function W(K, Y, J) {
        U(K, Y, J), q(K, Y, J);
      }
      function U(K, Y, J) {
        var Z = Y.gf, X = Y.g._hasOpacity, ee = Y.s.v, te = Y.e.v;
        if (Y.o._mdf || J) {
          var re = K.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          Y.style.pElem.setAttribute(re, Y.o.v);
        }
        if (Y.s._mdf || J) {
          var Q = K.t === 1 ? "x1" : "cx", ne = Q === "x1" ? "y1" : "cy";
          Z.setAttribute(Q, ee[0]), Z.setAttribute(ne, ee[1]), X && !Y.g._collapsable && (Y.of.setAttribute(Q, ee[0]), Y.of.setAttribute(ne, ee[1]));
        }
        var oe, ae, se, ie;
        if (Y.g._cmdf || J) {
          oe = Y.cst;
          var he = Y.g.c;
          for (se = oe.length, ae = 0; ae < se; ae += 1)
            ie = oe[ae], ie.setAttribute("offset", he[ae * 4] + "%"), ie.setAttribute("stop-color", "rgb(" + he[ae * 4 + 1] + "," + he[ae * 4 + 2] + "," + he[ae * 4 + 3] + ")");
        }
        if (X && (Y.g._omdf || J)) {
          var xe = Y.g.o;
          for (Y.g._collapsable ? oe = Y.cst : oe = Y.ost, se = oe.length, ae = 0; ae < se; ae += 1)
            ie = oe[ae], Y.g._collapsable || ie.setAttribute("offset", xe[ae * 2] + "%"), ie.setAttribute("stop-opacity", xe[ae * 2 + 1]);
        }
        if (K.t === 1)
          (Y.e._mdf || J) && (Z.setAttribute("x2", te[0]), Z.setAttribute("y2", te[1]), X && !Y.g._collapsable && (Y.of.setAttribute("x2", te[0]), Y.of.setAttribute("y2", te[1])));
        else {
          var Pe;
          if ((Y.s._mdf || Y.e._mdf || J) && (Pe = Math.sqrt(Math.pow(ee[0] - te[0], 2) + Math.pow(ee[1] - te[1], 2)), Z.setAttribute("r", Pe), X && !Y.g._collapsable && Y.of.setAttribute("r", Pe)), Y.e._mdf || Y.h._mdf || Y.a._mdf || J) {
            Pe || (Pe = Math.sqrt(Math.pow(ee[0] - te[0], 2) + Math.pow(ee[1] - te[1], 2)));
            var Re = Math.atan2(te[1] - ee[1], te[0] - ee[0]), ke = Y.h.v;
            ke >= 1 ? ke = 0.99 : ke <= -1 && (ke = -0.99);
            var Te = Pe * ke, fe = Math.cos(Re + Y.a.v) * Te + ee[0], ue = Math.sin(Re + Y.a.v) * Te + ee[1];
            Z.setAttribute("fx", fe), Z.setAttribute("fy", ue), X && !Y.g._collapsable && (Y.of.setAttribute("fx", fe), Y.of.setAttribute("fy", ue));
          }
        }
      }
      function q(K, Y, J) {
        var Z = Y.style, X = Y.d;
        X && (X._mdf || J) && X.dashStr && (Z.pElem.setAttribute("stroke-dasharray", X.dashStr), Z.pElem.setAttribute("stroke-dashoffset", X.dashoffset[0])), Y.c && (Y.c._mdf || J) && Z.pElem.setAttribute("stroke", "rgb(" + bmFloor(Y.c.v[0]) + "," + bmFloor(Y.c.v[1]) + "," + bmFloor(Y.c.v[2]) + ")"), (Y.o._mdf || J) && Z.pElem.setAttribute("stroke-opacity", Y.o.v), (Y.w._mdf || J) && (Z.pElem.setAttribute("stroke-width", Y.w.v), Z.msElem && Z.msElem.setAttribute("stroke-width", Y.w.v));
      }
      return R;
    }();
    function SVGShapeElement(T, S, R) {
      this.shapes = [], this.shapesData = T.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(T, S, R), this.prevViewData = [];
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {
    }, SVGShapeElement.prototype.identityMatrix = new Matrix(), SVGShapeElement.prototype.buildExpressionInterface = function() {
    }, SVGShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, SVGShapeElement.prototype.filterUniqueShapes = function() {
      var T, S = this.shapes.length, R, k, D = this.stylesList.length, L, V = [], z = !1;
      for (k = 0; k < D; k += 1) {
        for (L = this.stylesList[k], z = !1, V.length = 0, T = 0; T < S; T += 1)
          R = this.shapes[T], R.styles.indexOf(L) !== -1 && (V.push(R), z = R._isAnimated || z);
        V.length > 1 && z && this.setShapesAsAnimated(V);
      }
    }, SVGShapeElement.prototype.setShapesAsAnimated = function(T) {
      var S, R = T.length;
      for (S = 0; S < R; S += 1)
        T[S].setAsAnimated();
    }, SVGShapeElement.prototype.createStyleElement = function(T, S) {
      var R, k = new SVGStyleData(T, S), D = k.pElem;
      if (T.ty === "st")
        R = new SVGStrokeStyleData(this, T, k);
      else if (T.ty === "fl")
        R = new SVGFillStyleData(this, T, k);
      else if (T.ty === "gf" || T.ty === "gs") {
        var L = T.ty === "gf" ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
        R = new L(this, T, k), this.globalData.defs.appendChild(R.gf), R.maskId && (this.globalData.defs.appendChild(R.ms), this.globalData.defs.appendChild(R.of), D.setAttribute("mask", "url(" + getLocationHref() + "#" + R.maskId + ")"));
      } else T.ty === "no" && (R = new SVGNoStyleData(this, T, k));
      return (T.ty === "st" || T.ty === "gs") && (D.setAttribute("stroke-linecap", lineCapEnum[T.lc || 2]), D.setAttribute("stroke-linejoin", lineJoinEnum[T.lj || 2]), D.setAttribute("fill-opacity", "0"), T.lj === 1 && D.setAttribute("stroke-miterlimit", T.ml)), T.r === 2 && D.setAttribute("fill-rule", "evenodd"), T.ln && D.setAttribute("id", T.ln), T.cl && D.setAttribute("class", T.cl), T.bm && (D.style["mix-blend-mode"] = getBlendMode(T.bm)), this.stylesList.push(k), this.addToAnimatedContents(T, R), R;
    }, SVGShapeElement.prototype.createGroupElement = function(T) {
      var S = new ShapeGroupData();
      return T.ln && S.gr.setAttribute("id", T.ln), T.cl && S.gr.setAttribute("class", T.cl), T.bm && (S.gr.style["mix-blend-mode"] = getBlendMode(T.bm)), S;
    }, SVGShapeElement.prototype.createTransformElement = function(T, S) {
      var R = TransformPropertyFactory.getTransformProperty(this, T, this), k = new SVGTransformData(R, R.o, S);
      return this.addToAnimatedContents(T, k), k;
    }, SVGShapeElement.prototype.createShapeElement = function(T, S, R) {
      var k = 4;
      T.ty === "rc" ? k = 5 : T.ty === "el" ? k = 6 : T.ty === "sr" && (k = 7);
      var D = ShapePropertyFactory.getShapeProp(this, T, k, this), L = new SVGShapeData(S, R, D);
      return this.shapes.push(L), this.addShapeToModifiers(L), this.addToAnimatedContents(T, L), L;
    }, SVGShapeElement.prototype.addToAnimatedContents = function(T, S) {
      for (var R = 0, k = this.animatedContents.length; R < k; ) {
        if (this.animatedContents[R].element === S)
          return;
        R += 1;
      }
      this.animatedContents.push({
        fn: SVGElementsRenderer.createRenderFunction(T),
        element: S,
        data: T
      });
    }, SVGShapeElement.prototype.setElementStyles = function(T) {
      var S = T.styles, R, k = this.stylesList.length;
      for (R = 0; R < k; R += 1)
        this.stylesList[R].closed || S.push(this.stylesList[R]);
    }, SVGShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var T, S = this.itemsData.length;
      for (T = 0; T < S; T += 1)
        this.prevViewData[T] = this.itemsData[T];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), S = this.dynamicProperties.length, T = 0; T < S; T += 1)
        this.dynamicProperties[T].getValue();
      this.renderModifiers();
    }, SVGShapeElement.prototype.searchShapes = function(T, S, R, k, D, L, V) {
      var z = [].concat(L), W, U = T.length - 1, q, K, Y = [], J = [], Z, X, ee;
      for (W = U; W >= 0; W -= 1) {
        if (ee = this.searchProcessedElement(T[W]), ee ? S[W] = R[ee - 1] : T[W]._render = V, T[W].ty === "fl" || T[W].ty === "st" || T[W].ty === "gf" || T[W].ty === "gs" || T[W].ty === "no")
          ee ? S[W].style.closed = !1 : S[W] = this.createStyleElement(T[W], D), T[W]._render && S[W].style.pElem.parentNode !== k && k.appendChild(S[W].style.pElem), Y.push(S[W].style);
        else if (T[W].ty === "gr") {
          if (!ee)
            S[W] = this.createGroupElement(T[W]);
          else
            for (K = S[W].it.length, q = 0; q < K; q += 1)
              S[W].prevViewData[q] = S[W].it[q];
          this.searchShapes(T[W].it, S[W].it, S[W].prevViewData, S[W].gr, D + 1, z, V), T[W]._render && S[W].gr.parentNode !== k && k.appendChild(S[W].gr);
        } else T[W].ty === "tr" ? (ee || (S[W] = this.createTransformElement(T[W], k)), Z = S[W].transform, z.push(Z)) : T[W].ty === "sh" || T[W].ty === "rc" || T[W].ty === "el" || T[W].ty === "sr" ? (ee || (S[W] = this.createShapeElement(T[W], z, D)), this.setElementStyles(S[W])) : T[W].ty === "tm" || T[W].ty === "rd" || T[W].ty === "ms" || T[W].ty === "pb" || T[W].ty === "zz" || T[W].ty === "op" ? (ee ? (X = S[W], X.closed = !1) : (X = ShapeModifiers.getModifier(T[W].ty), X.init(this, T[W]), S[W] = X, this.shapeModifiers.push(X)), J.push(X)) : T[W].ty === "rp" && (ee ? (X = S[W], X.closed = !0) : (X = ShapeModifiers.getModifier(T[W].ty), S[W] = X, X.init(this, T, W, S), this.shapeModifiers.push(X), V = !1), J.push(X));
        this.addProcessedElement(T[W], W + 1);
      }
      for (U = Y.length, W = 0; W < U; W += 1)
        Y[W].closed = !0;
      for (U = J.length, W = 0; W < U; W += 1)
        J[W].closed = !0;
    }, SVGShapeElement.prototype.renderInnerContent = function() {
      this.renderModifiers();
      var T, S = this.stylesList.length;
      for (T = 0; T < S; T += 1)
        this.stylesList[T].reset();
      for (this.renderShape(), T = 0; T < S; T += 1)
        (this.stylesList[T]._mdf || this._isFirstFrame) && (this.stylesList[T].msElem && (this.stylesList[T].msElem.setAttribute("d", this.stylesList[T].d), this.stylesList[T].d = "M0 0" + this.stylesList[T].d), this.stylesList[T].pElem.setAttribute("d", this.stylesList[T].d || "M0 0"));
    }, SVGShapeElement.prototype.renderShape = function() {
      var T, S = this.animatedContents.length, R;
      for (T = 0; T < S; T += 1)
        R = this.animatedContents[T], (this._isFirstFrame || R.element._isAnimated) && R.data !== !0 && R.fn(R.data, R.element, this._isFirstFrame);
    }, SVGShapeElement.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    };
    function LetterProps(T, S, R, k, D, L) {
      this.o = T, this.sw = S, this.sc = R, this.fc = k, this.m = D, this.p = L, this._mdf = {
        o: !0,
        sw: !!S,
        sc: !!R,
        fc: !!k,
        m: !0,
        p: !0
      };
    }
    LetterProps.prototype.update = function(T, S, R, k, D, L) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var V = !1;
      return this.o !== T && (this.o = T, this._mdf.o = !0, V = !0), this.sw !== S && (this.sw = S, this._mdf.sw = !0, V = !0), this.sc !== R && (this.sc = R, this._mdf.sc = !0, V = !0), this.fc !== k && (this.fc = k, this._mdf.fc = !0, V = !0), this.m !== D && (this.m = D, this._mdf.m = !0, V = !0), L.length && (this.p[0] !== L[0] || this.p[1] !== L[1] || this.p[4] !== L[4] || this.p[5] !== L[5] || this.p[12] !== L[12] || this.p[13] !== L[13]) && (this.p = L, this._mdf.p = !0, V = !0), V;
    };
    function TextProperty(T, S) {
      this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, S.d && S.d.sid && (S.d = T.globalData.slotManager.getProp(S.d)), this.data = S, this.elem = T, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
        ascent: 0,
        boxWidth: this.defaultBoxWidth,
        f: "",
        fStyle: "",
        fWeight: "",
        fc: "",
        j: "",
        justifyOffset: "",
        l: [],
        lh: 0,
        lineWidths: [],
        ls: "",
        of: "",
        s: "",
        sc: "",
        sw: 0,
        t: 0,
        tr: 0,
        sz: 0,
        ps: null,
        fillColorAnim: !1,
        strokeColorAnim: !1,
        strokeWidthAnim: !1,
        yOffset: 0,
        finalSize: 0,
        finalText: [],
        finalLineHeight: 0,
        __complete: !1
      }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    TextProperty.prototype.defaultBoxWidth = [0, 0], TextProperty.prototype.copyData = function(T, S) {
      for (var R in S)
        Object.prototype.hasOwnProperty.call(S, R) && (T[R] = S[R]);
      return T;
    }, TextProperty.prototype.setCurrentData = function(T) {
      T.__complete || this.completeTextData(T), this.currentData = T, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, TextProperty.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, TextProperty.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, TextProperty.prototype.addEffect = function(T) {
      this.effectsSequence.push(T), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.getValue = function(T) {
      if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !T)) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var S = this.currentData, R = this.keysIndex;
        if (this.lock) {
          this.setCurrentData(this.currentData);
          return;
        }
        this.lock = !0, this._mdf = !1;
        var k, D = this.effectsSequence.length, L = T || this.data.d.k[this.keysIndex].s;
        for (k = 0; k < D; k += 1)
          R !== this.keysIndex ? L = this.effectsSequence[k](L, L.t) : L = this.effectsSequence[k](this.currentData, L.t);
        S !== L && this.setCurrentData(L), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }, TextProperty.prototype.getKeyframeValue = function() {
      for (var T = this.data.d.k, S = this.elem.comp.renderedFrame, R = 0, k = T.length; R <= k - 1 && !(R === k - 1 || T[R + 1].t > S); )
        R += 1;
      return this.keysIndex !== R && (this.keysIndex = R), this.data.d.k[this.keysIndex].s;
    }, TextProperty.prototype.buildFinalText = function(T) {
      for (var S = [], R = 0, k = T.length, D, L, V = !1, z = !1, W = ""; R < k; )
        V = z, z = !1, D = T.charCodeAt(R), W = T.charAt(R), FontManager.isCombinedCharacter(D) ? V = !0 : D >= 55296 && D <= 56319 ? FontManager.isRegionalFlag(T, R) ? W = T.substr(R, 14) : (L = T.charCodeAt(R + 1), L >= 56320 && L <= 57343 && (FontManager.isModifier(D, L) ? (W = T.substr(R, 2), V = !0) : FontManager.isFlagEmoji(T.substr(R, 4)) ? W = T.substr(R, 4) : W = T.substr(R, 2))) : D > 56319 ? (L = T.charCodeAt(R + 1), FontManager.isVariationSelector(D) && (V = !0)) : FontManager.isZeroWidthJoiner(D) && (V = !0, z = !0), V ? (S[S.length - 1] += W, V = !1) : S.push(W), R += W.length;
      return S;
    }, TextProperty.prototype.completeTextData = function(T) {
      T.__complete = !0;
      var S = this.elem.globalData.fontManager, R = this.data, k = [], D, L, V, z = 0, W, U = R.m.g, q = 0, K = 0, Y = 0, J = [], Z = 0, X = 0, ee, te, re = S.getFontByName(T.f), Q, ne = 0, oe = getFontProperties(re);
      T.fWeight = oe.weight, T.fStyle = oe.style, T.finalSize = T.s, T.finalText = this.buildFinalText(T.t), L = T.finalText.length, T.finalLineHeight = T.lh;
      var ae = T.tr / 1e3 * T.finalSize, se;
      if (T.sz)
        for (var ie = !0, he = T.sz[0], xe = T.sz[1], Pe, Re; ie; ) {
          Re = this.buildFinalText(T.t), Pe = 0, Z = 0, L = Re.length, ae = T.tr / 1e3 * T.finalSize;
          var ke = -1;
          for (D = 0; D < L; D += 1)
            se = Re[D].charCodeAt(0), V = !1, Re[D] === " " ? ke = D : (se === 13 || se === 3) && (Z = 0, V = !0, Pe += T.finalLineHeight || T.finalSize * 1.2), S.chars ? (Q = S.getCharData(Re[D], re.fStyle, re.fFamily), ne = V ? 0 : Q.w * T.finalSize / 100) : ne = S.measureText(Re[D], T.f, T.finalSize), Z + ne > he && Re[D] !== " " ? (ke === -1 ? L += 1 : D = ke, Pe += T.finalLineHeight || T.finalSize * 1.2, Re.splice(D, ke === D ? 1 : 0, "\r"), ke = -1, Z = 0) : (Z += ne, Z += ae);
          Pe += re.ascent * T.finalSize / 100, this.canResize && T.finalSize > this.minimumFontSize && xe < Pe ? (T.finalSize -= 1, T.finalLineHeight = T.finalSize * T.lh / T.s) : (T.finalText = Re, L = T.finalText.length, ie = !1);
        }
      Z = -ae, ne = 0;
      var Te = 0, fe;
      for (D = 0; D < L; D += 1)
        if (V = !1, fe = T.finalText[D], se = fe.charCodeAt(0), se === 13 || se === 3 ? (Te = 0, J.push(Z), X = Z > X ? Z : X, Z = -2 * ae, W = "", V = !0, Y += 1) : W = fe, S.chars ? (Q = S.getCharData(fe, re.fStyle, S.getFontByName(T.f).fFamily), ne = V ? 0 : Q.w * T.finalSize / 100) : ne = S.measureText(W, T.f, T.finalSize), fe === " " ? Te += ne + ae : (Z += ne + ae + Te, Te = 0), k.push({
          l: ne,
          an: ne,
          add: q,
          n: V,
          anIndexes: [],
          val: W,
          line: Y,
          animatorJustifyOffset: 0
        }), U == 2) {
          if (q += ne, W === "" || W === " " || D === L - 1) {
            for ((W === "" || W === " ") && (q -= ne); K <= D; )
              k[K].an = q, k[K].ind = z, k[K].extra = ne, K += 1;
            z += 1, q = 0;
          }
        } else if (U == 3) {
          if (q += ne, W === "" || D === L - 1) {
            for (W === "" && (q -= ne); K <= D; )
              k[K].an = q, k[K].ind = z, k[K].extra = ne, K += 1;
            q = 0, z += 1;
          }
        } else
          k[z].ind = z, k[z].extra = 0, z += 1;
      if (T.l = k, X = Z > X ? Z : X, J.push(Z), T.sz)
        T.boxWidth = T.sz[0], T.justifyOffset = 0;
      else
        switch (T.boxWidth = X, T.j) {
          case 1:
            T.justifyOffset = -T.boxWidth;
            break;
          case 2:
            T.justifyOffset = -T.boxWidth / 2;
            break;
          default:
            T.justifyOffset = 0;
        }
      T.lineWidths = J;
      var ue = R.a, Ce, ce;
      te = ue.length;
      var pe, _e, ge = [];
      for (ee = 0; ee < te; ee += 1) {
        for (Ce = ue[ee], Ce.a.sc && (T.strokeColorAnim = !0), Ce.a.sw && (T.strokeWidthAnim = !0), (Ce.a.fc || Ce.a.fh || Ce.a.fs || Ce.a.fb) && (T.fillColorAnim = !0), _e = 0, pe = Ce.s.b, D = 0; D < L; D += 1)
          ce = k[D], ce.anIndexes[ee] = _e, (pe == 1 && ce.val !== "" || pe == 2 && ce.val !== "" && ce.val !== " " || pe == 3 && (ce.n || ce.val == " " || D == L - 1) || pe == 4 && (ce.n || D == L - 1)) && (Ce.s.rn === 1 && ge.push(_e), _e += 1);
        R.a[ee].s.totalChars = _e;
        var Ae = -1, Ee;
        if (Ce.s.rn === 1)
          for (D = 0; D < L; D += 1)
            ce = k[D], Ae != ce.anIndexes[ee] && (Ae = ce.anIndexes[ee], Ee = ge.splice(Math.floor(Math.random() * ge.length), 1)[0]), ce.anIndexes[ee] = Ee;
      }
      T.yOffset = T.finalLineHeight || T.finalSize * 1.2, T.ls = T.ls || 0, T.ascent = re.ascent * T.finalSize / 100;
    }, TextProperty.prototype.updateDocumentData = function(T, S) {
      S = S === void 0 ? this.keysIndex : S;
      var R = this.copyData({}, this.data.d.k[S].s);
      R = this.copyData(R, T), this.data.d.k[S].s = R, this.recalculate(S), this.setCurrentData(R), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.recalculate = function(T) {
      var S = this.data.d.k[T].s;
      S.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(S);
    }, TextProperty.prototype.canResizeFont = function(T) {
      this.canResize = T, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, TextProperty.prototype.setMinimumFontSize = function(T) {
      this.minimumFontSize = Math.floor(T) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var TextSelectorProp = function() {
      var T = Math.max, S = Math.min, R = Math.floor;
      function k(L, V) {
        this._currentTextLength = -1, this.k = !1, this.data = V, this.elem = L, this.comp = L.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(L), this.s = PropertyFactory.getProp(L, V.s || {
          k: 0
        }, 0, 0, this), "e" in V ? this.e = PropertyFactory.getProp(L, V.e, 0, 0, this) : this.e = {
          v: 100
        }, this.o = PropertyFactory.getProp(L, V.o || {
          k: 0
        }, 0, 0, this), this.xe = PropertyFactory.getProp(L, V.xe || {
          k: 0
        }, 0, 0, this), this.ne = PropertyFactory.getProp(L, V.ne || {
          k: 0
        }, 0, 0, this), this.sm = PropertyFactory.getProp(L, V.sm || {
          k: 100
        }, 0, 0, this), this.a = PropertyFactory.getProp(L, V.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      k.prototype = {
        getMult: function(V) {
          this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
          var z = 0, W = 0, U = 1, q = 1;
          this.ne.v > 0 ? z = this.ne.v / 100 : W = -this.ne.v / 100, this.xe.v > 0 ? U = 1 - this.xe.v / 100 : q = 1 + this.xe.v / 100;
          var K = BezierFactory.getBezierEasing(z, W, U, q).get, Y = 0, J = this.finalS, Z = this.finalE, X = this.data.sh;
          if (X === 2)
            Z === J ? Y = V >= Z ? 1 : 0 : Y = T(0, S(0.5 / (Z - J) + (V - J) / (Z - J), 1)), Y = K(Y);
          else if (X === 3)
            Z === J ? Y = V >= Z ? 0 : 1 : Y = 1 - T(0, S(0.5 / (Z - J) + (V - J) / (Z - J), 1)), Y = K(Y);
          else if (X === 4)
            Z === J ? Y = 0 : (Y = T(0, S(0.5 / (Z - J) + (V - J) / (Z - J), 1)), Y < 0.5 ? Y *= 2 : Y = 1 - 2 * (Y - 0.5)), Y = K(Y);
          else if (X === 5) {
            if (Z === J)
              Y = 0;
            else {
              var ee = Z - J;
              V = S(T(0, V + 0.5 - J), Z - J);
              var te = -ee / 2 + V, re = ee / 2;
              Y = Math.sqrt(1 - te * te / (re * re));
            }
            Y = K(Y);
          } else X === 6 ? (Z === J ? Y = 0 : (V = S(T(0, V + 0.5 - J), Z - J), Y = (1 + Math.cos(Math.PI + Math.PI * 2 * V / (Z - J))) / 2), Y = K(Y)) : (V >= R(J) && (V - J < 0 ? Y = T(0, S(S(Z, 1) - (J - V), 1)) : Y = T(0, S(Z - V, 1))), Y = K(Y));
          if (this.sm.v !== 100) {
            var Q = this.sm.v * 0.01;
            Q === 0 && (Q = 1e-8);
            var ne = 0.5 - Q * 0.5;
            Y < ne ? Y = 0 : (Y = (Y - ne) / Q, Y > 1 && (Y = 1));
          }
          return Y * this.a.v;
        },
        getValue: function(V) {
          this.iterateDynamicProperties(), this._mdf = V || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, V && this.data.r === 2 && (this.e.v = this._currentTextLength);
          var z = this.data.r === 2 ? 1 : 100 / this.data.totalChars, W = this.o.v / z, U = this.s.v / z + W, q = this.e.v / z + W;
          if (U > q) {
            var K = U;
            U = q, q = K;
          }
          this.finalS = U, this.finalE = q;
        }
      }, extendPrototype([DynamicPropertyContainer], k);
      function D(L, V, z) {
        return new k(L, V);
      }
      return {
        getTextSelectorProp: D
      };
    }();
    function TextAnimatorDataProperty(T, S, R) {
      var k = {
        propType: !1
      }, D = PropertyFactory.getProp, L = S.a;
      this.a = {
        r: L.r ? D(T, L.r, 0, degToRads, R) : k,
        rx: L.rx ? D(T, L.rx, 0, degToRads, R) : k,
        ry: L.ry ? D(T, L.ry, 0, degToRads, R) : k,
        sk: L.sk ? D(T, L.sk, 0, degToRads, R) : k,
        sa: L.sa ? D(T, L.sa, 0, degToRads, R) : k,
        s: L.s ? D(T, L.s, 1, 0.01, R) : k,
        a: L.a ? D(T, L.a, 1, 0, R) : k,
        o: L.o ? D(T, L.o, 0, 0.01, R) : k,
        p: L.p ? D(T, L.p, 1, 0, R) : k,
        sw: L.sw ? D(T, L.sw, 0, 0, R) : k,
        sc: L.sc ? D(T, L.sc, 1, 0, R) : k,
        fc: L.fc ? D(T, L.fc, 1, 0, R) : k,
        fh: L.fh ? D(T, L.fh, 0, 0, R) : k,
        fs: L.fs ? D(T, L.fs, 0, 0.01, R) : k,
        fb: L.fb ? D(T, L.fb, 0, 0.01, R) : k,
        t: L.t ? D(T, L.t, 0, 0, R) : k
      }, this.s = TextSelectorProp.getTextSelectorProp(T, S.s, R), this.s.t = S.s.t;
    }
    function TextAnimatorProperty(T, S, R) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = T, this._renderType = S, this._elem = R, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
        alignment: {}
      }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(R);
    }
    TextAnimatorProperty.prototype.searchProperties = function() {
      var T, S = this._textData.a.length, R, k = PropertyFactory.getProp;
      for (T = 0; T < S; T += 1)
        R = this._textData.a[T], this._animatorsData[T] = new TextAnimatorDataProperty(this._elem, R, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = {
        a: k(this._elem, this._textData.p.a, 0, 0, this),
        f: k(this._elem, this._textData.p.f, 0, 0, this),
        l: k(this._elem, this._textData.p.l, 0, 0, this),
        r: k(this._elem, this._textData.p.r, 0, 0, this),
        p: k(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = k(this._elem, this._textData.m.a, 1, 0, this);
    }, TextAnimatorProperty.prototype.getMeasures = function(T, S) {
      if (this.lettersChangedFlag = S, !(!this._mdf && !this._isFirstFrame && !S && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
        this._isFirstFrame = !1;
        var R = this._moreOptions.alignment.v, k = this._animatorsData, D = this._textData, L = this.mHelper, V = this._renderType, z = this.renderedLetters.length, W, U, q, K, Y = T.l, J, Z, X, ee, te, re, Q, ne, oe, ae, se, ie, he, xe, Pe;
        if (this._hasMaskedPath) {
          if (Pe = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var Re = Pe.v;
            this._pathData.r.v && (Re = Re.reverse()), J = {
              tLength: 0,
              segments: []
            }, K = Re._length - 1;
            var ke;
            for (ie = 0, q = 0; q < K; q += 1)
              ke = bez.buildBezierData(Re.v[q], Re.v[q + 1], [Re.o[q][0] - Re.v[q][0], Re.o[q][1] - Re.v[q][1]], [Re.i[q + 1][0] - Re.v[q + 1][0], Re.i[q + 1][1] - Re.v[q + 1][1]]), J.tLength += ke.segmentLength, J.segments.push(ke), ie += ke.segmentLength;
            q = K, Pe.v.c && (ke = bez.buildBezierData(Re.v[q], Re.v[0], [Re.o[q][0] - Re.v[q][0], Re.o[q][1] - Re.v[q][1]], [Re.i[0][0] - Re.v[0][0], Re.i[0][1] - Re.v[0][1]]), J.tLength += ke.segmentLength, J.segments.push(ke), ie += ke.segmentLength), this._pathData.pi = J;
          }
          if (J = this._pathData.pi, Z = this._pathData.f.v, Q = 0, re = 1, ee = 0, te = !0, ae = J.segments, Z < 0 && Pe.v.c)
            for (J.tLength < Math.abs(Z) && (Z = -Math.abs(Z) % J.tLength), Q = ae.length - 1, oe = ae[Q].points, re = oe.length - 1; Z < 0; )
              Z += oe[re].partialLength, re -= 1, re < 0 && (Q -= 1, oe = ae[Q].points, re = oe.length - 1);
          oe = ae[Q].points, ne = oe[re - 1], X = oe[re], se = X.partialLength;
        }
        K = Y.length, W = 0, U = 0;
        var Te = T.finalSize * 1.2 * 0.714, fe = !0, ue, Ce, ce, pe, _e;
        pe = k.length;
        var ge, Ae = -1, Ee, ve, le, me = Z, Se = Q, ye = re, be = -1, $e, Oe, Ie, we, Fe, De, Le, ze, We = "", Be = this.defaultPropsArray, Ye;
        if (T.j === 2 || T.j === 1) {
          var Ge = 0, nt = 0, Ze = T.j === 2 ? -0.5 : -1, Me = 0, Ne = !0;
          for (q = 0; q < K; q += 1)
            if (Y[q].n) {
              for (Ge && (Ge += nt); Me < q; )
                Y[Me].animatorJustifyOffset = Ge, Me += 1;
              Ge = 0, Ne = !0;
            } else {
              for (ce = 0; ce < pe; ce += 1)
                ue = k[ce].a, ue.t.propType && (Ne && T.j === 2 && (nt += ue.t.v * Ze), Ce = k[ce].s, ge = Ce.getMult(Y[q].anIndexes[ce], D.a[ce].s.totalChars), ge.length ? Ge += ue.t.v * ge[0] * Ze : Ge += ue.t.v * ge * Ze);
              Ne = !1;
            }
          for (Ge && (Ge += nt); Me < q; )
            Y[Me].animatorJustifyOffset = Ge, Me += 1;
        }
        for (q = 0; q < K; q += 1) {
          if (L.reset(), $e = 1, Y[q].n)
            W = 0, U += T.yOffset, U += fe ? 1 : 0, Z = me, fe = !1, this._hasMaskedPath && (Q = Se, re = ye, oe = ae[Q].points, ne = oe[re - 1], X = oe[re], se = X.partialLength, ee = 0), We = "", ze = "", De = "", Ye = "", Be = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (be !== Y[q].line) {
                switch (T.j) {
                  case 1:
                    Z += ie - T.lineWidths[Y[q].line];
                    break;
                  case 2:
                    Z += (ie - T.lineWidths[Y[q].line]) / 2;
                    break;
                }
                be = Y[q].line;
              }
              Ae !== Y[q].ind && (Y[Ae] && (Z += Y[Ae].extra), Z += Y[q].an / 2, Ae = Y[q].ind), Z += R[0] * Y[q].an * 5e-3;
              var He = 0;
              for (ce = 0; ce < pe; ce += 1)
                ue = k[ce].a, ue.p.propType && (Ce = k[ce].s, ge = Ce.getMult(Y[q].anIndexes[ce], D.a[ce].s.totalChars), ge.length ? He += ue.p.v[0] * ge[0] : He += ue.p.v[0] * ge), ue.a.propType && (Ce = k[ce].s, ge = Ce.getMult(Y[q].anIndexes[ce], D.a[ce].s.totalChars), ge.length ? He += ue.a.v[0] * ge[0] : He += ue.a.v[0] * ge);
              for (te = !0, this._pathData.a.v && (Z = Y[0].an * 0.5 + (ie - this._pathData.f.v - Y[0].an * 0.5 - Y[Y.length - 1].an * 0.5) * Ae / (K - 1), Z += this._pathData.f.v); te; )
                ee + se >= Z + He || !oe ? (he = (Z + He - ee) / X.partialLength, ve = ne.point[0] + (X.point[0] - ne.point[0]) * he, le = ne.point[1] + (X.point[1] - ne.point[1]) * he, L.translate(-R[0] * Y[q].an * 5e-3, -(R[1] * Te) * 0.01), te = !1) : oe && (ee += X.partialLength, re += 1, re >= oe.length && (re = 0, Q += 1, ae[Q] ? oe = ae[Q].points : Pe.v.c ? (re = 0, Q = 0, oe = ae[Q].points) : (ee -= X.partialLength, oe = null)), oe && (ne = X, X = oe[re], se = X.partialLength));
              Ee = Y[q].an / 2 - Y[q].add, L.translate(-Ee, 0, 0);
            } else
              Ee = Y[q].an / 2 - Y[q].add, L.translate(-Ee, 0, 0), L.translate(-R[0] * Y[q].an * 5e-3, -R[1] * Te * 0.01, 0);
            for (ce = 0; ce < pe; ce += 1)
              ue = k[ce].a, ue.t.propType && (Ce = k[ce].s, ge = Ce.getMult(Y[q].anIndexes[ce], D.a[ce].s.totalChars), (W !== 0 || T.j !== 0) && (this._hasMaskedPath ? ge.length ? Z += ue.t.v * ge[0] : Z += ue.t.v * ge : ge.length ? W += ue.t.v * ge[0] : W += ue.t.v * ge));
            for (T.strokeWidthAnim && (Ie = T.sw || 0), T.strokeColorAnim && (T.sc ? Oe = [T.sc[0], T.sc[1], T.sc[2]] : Oe = [0, 0, 0]), T.fillColorAnim && T.fc && (we = [T.fc[0], T.fc[1], T.fc[2]]), ce = 0; ce < pe; ce += 1)
              ue = k[ce].a, ue.a.propType && (Ce = k[ce].s, ge = Ce.getMult(Y[q].anIndexes[ce], D.a[ce].s.totalChars), ge.length ? L.translate(-ue.a.v[0] * ge[0], -ue.a.v[1] * ge[1], ue.a.v[2] * ge[2]) : L.translate(-ue.a.v[0] * ge, -ue.a.v[1] * ge, ue.a.v[2] * ge));
            for (ce = 0; ce < pe; ce += 1)
              ue = k[ce].a, ue.s.propType && (Ce = k[ce].s, ge = Ce.getMult(Y[q].anIndexes[ce], D.a[ce].s.totalChars), ge.length ? L.scale(1 + (ue.s.v[0] - 1) * ge[0], 1 + (ue.s.v[1] - 1) * ge[1], 1) : L.scale(1 + (ue.s.v[0] - 1) * ge, 1 + (ue.s.v[1] - 1) * ge, 1));
            for (ce = 0; ce < pe; ce += 1) {
              if (ue = k[ce].a, Ce = k[ce].s, ge = Ce.getMult(Y[q].anIndexes[ce], D.a[ce].s.totalChars), ue.sk.propType && (ge.length ? L.skewFromAxis(-ue.sk.v * ge[0], ue.sa.v * ge[1]) : L.skewFromAxis(-ue.sk.v * ge, ue.sa.v * ge)), ue.r.propType && (ge.length ? L.rotateZ(-ue.r.v * ge[2]) : L.rotateZ(-ue.r.v * ge)), ue.ry.propType && (ge.length ? L.rotateY(ue.ry.v * ge[1]) : L.rotateY(ue.ry.v * ge)), ue.rx.propType && (ge.length ? L.rotateX(ue.rx.v * ge[0]) : L.rotateX(ue.rx.v * ge)), ue.o.propType && (ge.length ? $e += (ue.o.v * ge[0] - $e) * ge[0] : $e += (ue.o.v * ge - $e) * ge), T.strokeWidthAnim && ue.sw.propType && (ge.length ? Ie += ue.sw.v * ge[0] : Ie += ue.sw.v * ge), T.strokeColorAnim && ue.sc.propType)
                for (Fe = 0; Fe < 3; Fe += 1)
                  ge.length ? Oe[Fe] += (ue.sc.v[Fe] - Oe[Fe]) * ge[0] : Oe[Fe] += (ue.sc.v[Fe] - Oe[Fe]) * ge;
              if (T.fillColorAnim && T.fc) {
                if (ue.fc.propType)
                  for (Fe = 0; Fe < 3; Fe += 1)
                    ge.length ? we[Fe] += (ue.fc.v[Fe] - we[Fe]) * ge[0] : we[Fe] += (ue.fc.v[Fe] - we[Fe]) * ge;
                ue.fh.propType && (ge.length ? we = addHueToRGB(we, ue.fh.v * ge[0]) : we = addHueToRGB(we, ue.fh.v * ge)), ue.fs.propType && (ge.length ? we = addSaturationToRGB(we, ue.fs.v * ge[0]) : we = addSaturationToRGB(we, ue.fs.v * ge)), ue.fb.propType && (ge.length ? we = addBrightnessToRGB(we, ue.fb.v * ge[0]) : we = addBrightnessToRGB(we, ue.fb.v * ge));
              }
            }
            for (ce = 0; ce < pe; ce += 1)
              ue = k[ce].a, ue.p.propType && (Ce = k[ce].s, ge = Ce.getMult(Y[q].anIndexes[ce], D.a[ce].s.totalChars), this._hasMaskedPath ? ge.length ? L.translate(0, ue.p.v[1] * ge[0], -ue.p.v[2] * ge[1]) : L.translate(0, ue.p.v[1] * ge, -ue.p.v[2] * ge) : ge.length ? L.translate(ue.p.v[0] * ge[0], ue.p.v[1] * ge[1], -ue.p.v[2] * ge[2]) : L.translate(ue.p.v[0] * ge, ue.p.v[1] * ge, -ue.p.v[2] * ge));
            if (T.strokeWidthAnim && (De = Ie < 0 ? 0 : Ie), T.strokeColorAnim && (Le = "rgb(" + Math.round(Oe[0] * 255) + "," + Math.round(Oe[1] * 255) + "," + Math.round(Oe[2] * 255) + ")"), T.fillColorAnim && T.fc && (ze = "rgb(" + Math.round(we[0] * 255) + "," + Math.round(we[1] * 255) + "," + Math.round(we[2] * 255) + ")"), this._hasMaskedPath) {
              if (L.translate(0, -T.ls), L.translate(0, R[1] * Te * 0.01 + U, 0), this._pathData.p.v) {
                xe = (X.point[1] - ne.point[1]) / (X.point[0] - ne.point[0]);
                var qe = Math.atan(xe) * 180 / Math.PI;
                X.point[0] < ne.point[0] && (qe += 180), L.rotate(-qe * Math.PI / 180);
              }
              L.translate(ve, le, 0), Z -= R[0] * Y[q].an * 5e-3, Y[q + 1] && Ae !== Y[q + 1].ind && (Z += Y[q].an / 2, Z += T.tr * 1e-3 * T.finalSize);
            } else {
              switch (L.translate(W, U, 0), T.ps && L.translate(T.ps[0], T.ps[1] + T.ascent, 0), T.j) {
                case 1:
                  L.translate(Y[q].animatorJustifyOffset + T.justifyOffset + (T.boxWidth - T.lineWidths[Y[q].line]), 0, 0);
                  break;
                case 2:
                  L.translate(Y[q].animatorJustifyOffset + T.justifyOffset + (T.boxWidth - T.lineWidths[Y[q].line]) / 2, 0, 0);
                  break;
              }
              L.translate(0, -T.ls), L.translate(Ee, 0, 0), L.translate(R[0] * Y[q].an * 5e-3, R[1] * Te * 0.01, 0), W += Y[q].l + T.tr * 1e-3 * T.finalSize;
            }
            V === "html" ? We = L.toCSS() : V === "svg" ? We = L.to2dCSS() : Be = [L.props[0], L.props[1], L.props[2], L.props[3], L.props[4], L.props[5], L.props[6], L.props[7], L.props[8], L.props[9], L.props[10], L.props[11], L.props[12], L.props[13], L.props[14], L.props[15]], Ye = $e;
          }
          z <= q ? (_e = new LetterProps(Ye, De, Le, ze, We, Be), this.renderedLetters.push(_e), z += 1, this.lettersChangedFlag = !0) : (_e = this.renderedLetters[q], this.lettersChangedFlag = _e.update(Ye, De, Le, ze, We, Be) || this.lettersChangedFlag);
        }
      }
    }, TextAnimatorProperty.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, TextAnimatorProperty.prototype.mHelper = new Matrix(), TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);
    function ITextElement() {
    }
    ITextElement.prototype.initElement = function(T, S, R) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(T, S, R), this.textProperty = new TextProperty(this, T.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(T.t, this.renderType, this), this.initTransform(T, S, R), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, ITextElement.prototype.prepareFrame = function(T) {
      this._mdf = !1, this.prepareRenderableFrame(T), this.prepareProperties(T, this.isInRange);
    }, ITextElement.prototype.createPathShape = function(T, S) {
      var R, k = S.length, D, L = "";
      for (R = 0; R < k; R += 1)
        S[R].ty === "sh" && (D = S[R].ks.k, L += buildShapeString(D, D.i.length, !0, T));
      return L;
    }, ITextElement.prototype.updateDocumentData = function(T, S) {
      this.textProperty.updateDocumentData(T, S);
    }, ITextElement.prototype.canResizeFont = function(T) {
      this.textProperty.canResizeFont(T);
    }, ITextElement.prototype.setMinimumFontSize = function(T) {
      this.textProperty.setMinimumFontSize(T);
    }, ITextElement.prototype.applyTextPropertiesToMatrix = function(T, S, R, k, D) {
      switch (T.ps && S.translate(T.ps[0], T.ps[1] + T.ascent, 0), S.translate(0, -T.ls, 0), T.j) {
        case 1:
          S.translate(T.justifyOffset + (T.boxWidth - T.lineWidths[R]), 0, 0);
          break;
        case 2:
          S.translate(T.justifyOffset + (T.boxWidth - T.lineWidths[R]) / 2, 0, 0);
          break;
      }
      S.translate(k, D, 0);
    }, ITextElement.prototype.buildColor = function(T) {
      return "rgb(" + Math.round(T[0] * 255) + "," + Math.round(T[1] * 255) + "," + Math.round(T[2] * 255) + ")";
    }, ITextElement.prototype.emptyProp = new LetterProps(), ITextElement.prototype.destroy = function() {
    }, ITextElement.prototype.validateText = function() {
      (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    };
    var emptyShapeData = {
      shapes: []
    };
    function SVGTextLottieElement(T, S, R) {
      this.textSpans = [], this.renderType = "svg", this.initElement(T, S, R);
    }
    extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
    }, SVGTextLottieElement.prototype.buildTextContents = function(T) {
      for (var S = 0, R = T.length, k = [], D = ""; S < R; )
        T[S] === "\r" || T[S] === "" ? (k.push(D), D = "") : D += T[S], S += 1;
      return k.push(D), k;
    }, SVGTextLottieElement.prototype.buildShapeData = function(T, S) {
      if (T.shapes && T.shapes.length) {
        var R = T.shapes[0];
        if (R.it) {
          var k = R.it[R.it.length - 1];
          k.s && (k.s.k[0] = S, k.s.k[1] = S);
        }
      }
      return T;
    }, SVGTextLottieElement.prototype.buildNewText = function() {
      this.addDynamicProperty(this);
      var T, S, R = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(R ? R.l.length : 0), R.fc ? this.layerElement.setAttribute("fill", this.buildColor(R.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), R.sc && (this.layerElement.setAttribute("stroke", this.buildColor(R.sc)), this.layerElement.setAttribute("stroke-width", R.sw)), this.layerElement.setAttribute("font-size", R.finalSize);
      var k = this.globalData.fontManager.getFontByName(R.f);
      if (k.fClass)
        this.layerElement.setAttribute("class", k.fClass);
      else {
        this.layerElement.setAttribute("font-family", k.fFamily);
        var D = R.fWeight, L = R.fStyle;
        this.layerElement.setAttribute("font-style", L), this.layerElement.setAttribute("font-weight", D);
      }
      this.layerElement.setAttribute("aria-label", R.t);
      var V = R.l || [], z = !!this.globalData.fontManager.chars;
      S = V.length;
      var W, U = this.mHelper, q = "", K = this.data.singleShape, Y = 0, J = 0, Z = !0, X = R.tr * 1e-3 * R.finalSize;
      if (K && !z && !R.sz) {
        var ee = this.textContainer, te = "start";
        switch (R.j) {
          case 1:
            te = "end";
            break;
          case 2:
            te = "middle";
            break;
          default:
            te = "start";
            break;
        }
        ee.setAttribute("text-anchor", te), ee.setAttribute("letter-spacing", X);
        var re = this.buildTextContents(R.finalText);
        for (S = re.length, J = R.ps ? R.ps[1] + R.ascent : 0, T = 0; T < S; T += 1)
          W = this.textSpans[T].span || createNS("tspan"), W.textContent = re[T], W.setAttribute("x", 0), W.setAttribute("y", J), W.style.display = "inherit", ee.appendChild(W), this.textSpans[T] || (this.textSpans[T] = {
            span: null,
            glyph: null
          }), this.textSpans[T].span = W, J += R.finalLineHeight;
        this.layerElement.appendChild(ee);
      } else {
        var Q = this.textSpans.length, ne;
        for (T = 0; T < S; T += 1) {
          if (this.textSpans[T] || (this.textSpans[T] = {
            span: null,
            childSpan: null,
            glyph: null
          }), !z || !K || T === 0) {
            if (W = Q > T ? this.textSpans[T].span : createNS(z ? "g" : "text"), Q <= T) {
              if (W.setAttribute("stroke-linecap", "butt"), W.setAttribute("stroke-linejoin", "round"), W.setAttribute("stroke-miterlimit", "4"), this.textSpans[T].span = W, z) {
                var oe = createNS("g");
                W.appendChild(oe), this.textSpans[T].childSpan = oe;
              }
              this.textSpans[T].span = W, this.layerElement.appendChild(W);
            }
            W.style.display = "inherit";
          }
          if (U.reset(), K && (V[T].n && (Y = -X, J += R.yOffset, J += Z ? 1 : 0, Z = !1), this.applyTextPropertiesToMatrix(R, U, V[T].line, Y, J), Y += V[T].l || 0, Y += X), z) {
            ne = this.globalData.fontManager.getCharData(R.finalText[T], k.fStyle, this.globalData.fontManager.getFontByName(R.f).fFamily);
            var ae;
            if (ne.t === 1)
              ae = new SVGCompElement(ne.data, this.globalData, this);
            else {
              var se = emptyShapeData;
              ne.data && ne.data.shapes && (se = this.buildShapeData(ne.data, R.finalSize)), ae = new SVGShapeElement(se, this.globalData, this);
            }
            if (this.textSpans[T].glyph) {
              var ie = this.textSpans[T].glyph;
              this.textSpans[T].childSpan.removeChild(ie.layerElement), ie.destroy();
            }
            this.textSpans[T].glyph = ae, ae._debug = !0, ae.prepareFrame(0), ae.renderFrame(), this.textSpans[T].childSpan.appendChild(ae.layerElement), ne.t === 1 && this.textSpans[T].childSpan.setAttribute("transform", "scale(" + R.finalSize / 100 + "," + R.finalSize / 100 + ")");
          } else
            K && W.setAttribute("transform", "translate(" + U.props[12] + "," + U.props[13] + ")"), W.textContent = V[T].val, W.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        K && W && W.setAttribute("d", q);
      }
      for (; T < this.textSpans.length; )
        this.textSpans[T].span.style.display = "none", T += 1;
      this._sizeChanged = !0;
    }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var T = this.layerElement.getBBox();
        this.bbox = {
          top: T.y,
          left: T.x,
          width: T.width,
          height: T.height
        };
      }
      return this.bbox;
    }, SVGTextLottieElement.prototype.getValue = function() {
      var T, S = this.textSpans.length, R;
      for (this.renderedFrame = this.comp.renderedFrame, T = 0; T < S; T += 1)
        R = this.textSpans[T].glyph, R && (R.prepareFrame(this.comp.renderedFrame - this.data.st), R._mdf && (this._mdf = !0));
    }, SVGTextLottieElement.prototype.renderInnerContent = function() {
      if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        this._sizeChanged = !0;
        var T, S, R = this.textAnimator.renderedLetters, k = this.textProperty.currentData.l;
        S = k.length;
        var D, L, V;
        for (T = 0; T < S; T += 1)
          k[T].n || (D = R[T], L = this.textSpans[T].span, V = this.textSpans[T].glyph, V && V.renderFrame(), D._mdf.m && L.setAttribute("transform", D.m), D._mdf.o && L.setAttribute("opacity", D.o), D._mdf.sw && L.setAttribute("stroke-width", D.sw), D._mdf.sc && L.setAttribute("stroke", D.sc), D._mdf.fc && L.setAttribute("fill", D.fc));
      }
    };
    function ISolidElement(T, S, R) {
      this.initElement(T, S, R);
    }
    extendPrototype([IImageElement], ISolidElement), ISolidElement.prototype.createContent = function() {
      var T = createNS("rect");
      T.setAttribute("width", this.data.sw), T.setAttribute("height", this.data.sh), T.setAttribute("fill", this.data.sc), this.layerElement.appendChild(T);
    };
    function NullElement(T, S, R) {
      this.initFrame(), this.initBaseData(T, S, R), this.initFrame(), this.initTransform(T, S, R), this.initHierarchy();
    }
    NullElement.prototype.prepareFrame = function(T) {
      this.prepareProperties(T, !0);
    }, NullElement.prototype.renderFrame = function() {
    }, NullElement.prototype.getBaseElement = function() {
      return null;
    }, NullElement.prototype.destroy = function() {
    }, NullElement.prototype.sourceRectAtTime = function() {
    }, NullElement.prototype.hide = function() {
    }, extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);
    function SVGRendererBase() {
    }
    extendPrototype([BaseRenderer], SVGRendererBase), SVGRendererBase.prototype.createNull = function(T) {
      return new NullElement(T, this.globalData, this);
    }, SVGRendererBase.prototype.createShape = function(T) {
      return new SVGShapeElement(T, this.globalData, this);
    }, SVGRendererBase.prototype.createText = function(T) {
      return new SVGTextLottieElement(T, this.globalData, this);
    }, SVGRendererBase.prototype.createImage = function(T) {
      return new IImageElement(T, this.globalData, this);
    }, SVGRendererBase.prototype.createSolid = function(T) {
      return new ISolidElement(T, this.globalData, this);
    }, SVGRendererBase.prototype.configAnimation = function(T) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + T.w + " " + T.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", T.w), this.svgElement.setAttribute("height", T.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var S = this.globalData.defs;
      this.setupGlobalData(T, S), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = T;
      var R = createNS("clipPath"), k = createNS("rect");
      k.setAttribute("width", T.w), k.setAttribute("height", T.h), k.setAttribute("x", 0), k.setAttribute("y", 0);
      var D = createElementID();
      R.setAttribute("id", D), R.appendChild(k), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + D + ")"), S.appendChild(R), this.layers = T.layers, this.elements = createSizedArray(T.layers.length);
    }, SVGRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var T, S = this.layers ? this.layers.length : 0;
      for (T = 0; T < S; T += 1)
        this.elements[T] && this.elements[T].destroy && this.elements[T].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, SVGRendererBase.prototype.updateContainerSize = function() {
    }, SVGRendererBase.prototype.findIndexByInd = function(T) {
      var S = 0, R = this.layers.length;
      for (S = 0; S < R; S += 1)
        if (this.layers[S].ind === T)
          return S;
      return -1;
    }, SVGRendererBase.prototype.buildItem = function(T) {
      var S = this.elements;
      if (!(S[T] || this.layers[T].ty === 99)) {
        S[T] = !0;
        var R = this.createItem(this.layers[T]);
        if (S[T] = R, getExpressionsPlugin() && (this.layers[T].ty === 0 && this.globalData.projectInterface.registerComposition(R), R.initExpressions()), this.appendElementInPos(R, T), this.layers[T].tt) {
          var k = "tp" in this.layers[T] ? this.findIndexByInd(this.layers[T].tp) : T - 1;
          if (k === -1)
            return;
          if (!this.elements[k] || this.elements[k] === !0)
            this.buildItem(k), this.addPendingElement(R);
          else {
            var D = S[k], L = D.getMatte(this.layers[T].tt);
            R.setMatte(L);
          }
        }
      }
    }, SVGRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var T = this.pendingElements.pop();
        if (T.checkParenting(), T.data.tt)
          for (var S = 0, R = this.elements.length; S < R; ) {
            if (this.elements[S] === T) {
              var k = "tp" in T.data ? this.findIndexByInd(T.data.tp) : S - 1, D = this.elements[k], L = D.getMatte(this.layers[S].tt);
              T.setMatte(L);
              break;
            }
            S += 1;
          }
      }
    }, SVGRendererBase.prototype.renderFrame = function(T) {
      if (!(this.renderedFrame === T || this.destroyed)) {
        T === null ? T = this.renderedFrame : this.renderedFrame = T, this.globalData.frameNum = T, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = T, this.globalData._mdf = !1;
        var S, R = this.layers.length;
        for (this.completeLayers || this.checkLayers(T), S = R - 1; S >= 0; S -= 1)
          (this.completeLayers || this.elements[S]) && this.elements[S].prepareFrame(T - this.layers[S].st);
        if (this.globalData._mdf)
          for (S = 0; S < R; S += 1)
            (this.completeLayers || this.elements[S]) && this.elements[S].renderFrame();
      }
    }, SVGRendererBase.prototype.appendElementInPos = function(T, S) {
      var R = T.getBaseElement();
      if (R) {
        for (var k = 0, D; k < S; )
          this.elements[k] && this.elements[k] !== !0 && this.elements[k].getBaseElement() && (D = this.elements[k].getBaseElement()), k += 1;
        D ? this.layerElement.insertBefore(R, D) : this.layerElement.appendChild(R);
      }
    }, SVGRendererBase.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, SVGRendererBase.prototype.show = function() {
      this.layerElement.style.display = "block";
    };
    function ICompElement() {
    }
    extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement), ICompElement.prototype.initElement = function(T, S, R) {
      this.initFrame(), this.initBaseData(T, S, R), this.initTransform(T, S, R), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !S.progressiveLoad) && this.buildAllItems(), this.hide();
    }, ICompElement.prototype.prepareFrame = function(T) {
      if (this._mdf = !1, this.prepareRenderableFrame(T), this.prepareProperties(T, this.isInRange), !(!this.isInRange && !this.data.xt)) {
        if (this.tm._placeholder)
          this.renderedFrame = T / this.data.sr;
        else {
          var S = this.tm.v;
          S === this.data.op && (S = this.data.op - 1), this.renderedFrame = S;
        }
        var R, k = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), R = k - 1; R >= 0; R -= 1)
          (this.completeLayers || this.elements[R]) && (this.elements[R].prepareFrame(this.renderedFrame - this.layers[R].st), this.elements[R]._mdf && (this._mdf = !0));
      }
    }, ICompElement.prototype.renderInnerContent = function() {
      var T, S = this.layers.length;
      for (T = 0; T < S; T += 1)
        (this.completeLayers || this.elements[T]) && this.elements[T].renderFrame();
    }, ICompElement.prototype.setElements = function(T) {
      this.elements = T;
    }, ICompElement.prototype.getElements = function() {
      return this.elements;
    }, ICompElement.prototype.destroyElements = function() {
      var T, S = this.layers.length;
      for (T = 0; T < S; T += 1)
        this.elements[T] && this.elements[T].destroy();
    }, ICompElement.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    };
    function SVGCompElement(T, S, R) {
      this.layers = T.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(T, S, R), this.tm = T.tm ? PropertyFactory.getProp(this, T.tm, 0, S.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement), SVGCompElement.prototype.createComp = function(T) {
      return new SVGCompElement(T, this.globalData, this);
    };
    function SVGRenderer(T, S) {
      this.animationItem = T, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
      var R = "";
      if (S && S.title) {
        var k = createNS("title"), D = createElementID();
        k.setAttribute("id", D), k.textContent = S.title, this.svgElement.appendChild(k), R += D;
      }
      if (S && S.description) {
        var L = createNS("desc"), V = createElementID();
        L.setAttribute("id", V), L.textContent = S.description, this.svgElement.appendChild(L), R += " " + V;
      }
      R && this.svgElement.setAttribute("aria-labelledby", R);
      var z = createNS("defs");
      this.svgElement.appendChild(z);
      var W = createNS("g");
      this.svgElement.appendChild(W), this.layerElement = W, this.renderConfig = {
        preserveAspectRatio: S && S.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: S && S.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: S && S.contentVisibility || "visible",
        progressiveLoad: S && S.progressiveLoad || !1,
        hideOnTransparent: !(S && S.hideOnTransparent === !1),
        viewBoxOnly: S && S.viewBoxOnly || !1,
        viewBoxSize: S && S.viewBoxSize || !1,
        className: S && S.className || "",
        id: S && S.id || "",
        focusable: S && S.focusable,
        filterSize: {
          width: S && S.filterSize && S.filterSize.width || "100%",
          height: S && S.filterSize && S.filterSize.height || "100%",
          x: S && S.filterSize && S.filterSize.x || "0%",
          y: S && S.filterSize && S.filterSize.y || "0%"
        },
        width: S && S.width,
        height: S && S.height,
        runExpressions: !S || S.runExpressions === void 0 || S.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        defs: z,
        renderConfig: this.renderConfig
      }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    extendPrototype([SVGRendererBase], SVGRenderer), SVGRenderer.prototype.createComp = function(T) {
      return new SVGCompElement(T, this.globalData, this);
    };
    function ShapeTransformManager() {
      this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
    }
    ShapeTransformManager.prototype = {
      addTransformSequence: function(S) {
        var R, k = S.length, D = "_";
        for (R = 0; R < k; R += 1)
          D += S[R].transform.key + "_";
        var L = this.sequences[D];
        return L || (L = {
          transforms: [].concat(S),
          finalTransform: new Matrix(),
          _mdf: !1
        }, this.sequences[D] = L, this.sequenceList.push(L)), L;
      },
      processSequence: function(S, R) {
        for (var k = 0, D = S.transforms.length, L = R; k < D && !R; ) {
          if (S.transforms[k].transform.mProps._mdf) {
            L = !0;
            break;
          }
          k += 1;
        }
        if (L)
          for (S.finalTransform.reset(), k = D - 1; k >= 0; k -= 1)
            S.finalTransform.multiply(S.transforms[k].transform.mProps.v);
        S._mdf = L;
      },
      processSequences: function(S) {
        var R, k = this.sequenceList.length;
        for (R = 0; R < k; R += 1)
          this.processSequence(this.sequenceList[R], S);
      },
      getNewKey: function() {
        return this.transform_key_count += 1, "_" + this.transform_key_count;
      }
    };
    var lumaLoader = function() {
      var S = "__lottie_element_luma_buffer", R = null, k = null, D = null;
      function L() {
        var W = createNS("svg"), U = createNS("filter"), q = createNS("feColorMatrix");
        return U.setAttribute("id", S), q.setAttribute("type", "matrix"), q.setAttribute("color-interpolation-filters", "sRGB"), q.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), U.appendChild(q), W.appendChild(U), W.setAttribute("id", S + "_svg"), featureSupport.svgLumaHidden && (W.style.display = "none"), W;
      }
      function V() {
        R || (D = L(), document.body.appendChild(D), R = createTag("canvas"), k = R.getContext("2d"), k.filter = "url(#" + S + ")", k.fillStyle = "rgba(0,0,0,0)", k.fillRect(0, 0, 1, 1));
      }
      function z(W) {
        return R || V(), R.width = W.width, R.height = W.height, k.filter = "url(#" + S + ")", R;
      }
      return {
        load: V,
        get: z
      };
    };
    function createCanvas(T, S) {
      if (featureSupport.offscreenCanvas)
        return new OffscreenCanvas(T, S);
      var R = createTag("canvas");
      return R.width = T, R.height = S, R;
    }
    var assetLoader = function() {
      return {
        loadLumaCanvas: lumaLoader.load,
        getLumaCanvas: lumaLoader.get,
        createCanvas
      };
    }(), registeredEffects = {};
    function CVEffects(T) {
      var S, R = T.data.ef ? T.data.ef.length : 0;
      this.filters = [];
      var k;
      for (S = 0; S < R; S += 1) {
        k = null;
        var D = T.data.ef[S].ty;
        if (registeredEffects[D]) {
          var L = registeredEffects[D].effect;
          k = new L(T.effectsManager.effectElements[S], T);
        }
        k && this.filters.push(k);
      }
      this.filters.length && T.addRenderableComponent(this);
    }
    CVEffects.prototype.renderFrame = function(T) {
      var S, R = this.filters.length;
      for (S = 0; S < R; S += 1)
        this.filters[S].renderFrame(T);
    }, CVEffects.prototype.getEffects = function(T) {
      var S, R = this.filters.length, k = [];
      for (S = 0; S < R; S += 1)
        this.filters[S].type === T && k.push(this.filters[S]);
      return k;
    };
    function registerEffect(T, S) {
      registeredEffects[T] = {
        effect: S
      };
    }
    function CVMaskElement(T, S) {
      this.data = T, this.element = S, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
      var R, k = this.masksProperties.length, D = !1;
      for (R = 0; R < k; R += 1)
        this.masksProperties[R].mode !== "n" && (D = !0), this.viewData[R] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[R], 3);
      this.hasMasks = D, D && this.element.addRenderableComponent(this);
    }
    CVMaskElement.prototype.renderFrame = function() {
      if (this.hasMasks) {
        var T = this.element.finalTransform.mat, S = this.element.canvasContext, R, k = this.masksProperties.length, D, L, V;
        for (S.beginPath(), R = 0; R < k; R += 1)
          if (this.masksProperties[R].mode !== "n") {
            this.masksProperties[R].inv && (S.moveTo(0, 0), S.lineTo(this.element.globalData.compSize.w, 0), S.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), S.lineTo(0, this.element.globalData.compSize.h), S.lineTo(0, 0)), V = this.viewData[R].v, D = T.applyToPointArray(V.v[0][0], V.v[0][1], 0), S.moveTo(D[0], D[1]);
            var z, W = V._length;
            for (z = 1; z < W; z += 1)
              L = T.applyToTriplePoints(V.o[z - 1], V.i[z], V.v[z]), S.bezierCurveTo(L[0], L[1], L[2], L[3], L[4], L[5]);
            L = T.applyToTriplePoints(V.o[z - 1], V.i[0], V.v[0]), S.bezierCurveTo(L[0], L[1], L[2], L[3], L[4], L[5]);
          }
        this.element.globalData.renderer.save(!0), S.clip();
      }
    }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
      this.element = null;
    };
    function CVBaseElement() {
    }
    var operationsMap = {
      1: "source-in",
      2: "source-out",
      3: "source-in",
      4: "source-out"
    };
    CVBaseElement.prototype = {
      createElements: function() {
      },
      initRendererElement: function() {
      },
      createContainerElements: function() {
        if (this.data.tt >= 1) {
          this.buffers = [];
          var S = this.globalData.canvasContext, R = assetLoader.createCanvas(S.canvas.width, S.canvas.height);
          this.buffers.push(R);
          var k = assetLoader.createCanvas(S.canvas.width, S.canvas.height);
          this.buffers.push(k), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
        }
        this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
      },
      createContent: function() {
      },
      setBlendMode: function() {
        var S = this.globalData;
        if (S.blendMode !== this.data.bm) {
          S.blendMode = this.data.bm;
          var R = getBlendMode(this.data.bm);
          S.canvasContext.globalCompositeOperation = R;
        }
      },
      createRenderableComponents: function() {
        this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
      },
      hideElement: function() {
        !this.hidden && (!this.isInRange || this.isTransparent) && (this.hidden = !0);
      },
      showElement: function() {
        this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
      },
      clearCanvas: function(S) {
        S.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
      },
      prepareLayer: function() {
        if (this.data.tt >= 1) {
          var S = this.buffers[0], R = S.getContext("2d");
          this.clearCanvas(R), R.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
        }
      },
      exitLayer: function() {
        if (this.data.tt >= 1) {
          var S = this.buffers[1], R = S.getContext("2d");
          this.clearCanvas(R), R.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
          var k = this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1);
          if (k.renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
            var D = assetLoader.getLumaCanvas(this.canvasContext.canvas), L = D.getContext("2d");
            L.drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(D, 0, 0);
          }
          this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(S, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
        }
      },
      renderFrame: function(S) {
        if (!(this.hidden || this.data.hd) && !(this.data.td === 1 && !S)) {
          this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
          var R = this.data.ty === 0;
          this.prepareLayer(), this.globalData.renderer.save(R), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(R), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
        }
      },
      destroy: function() {
        this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
      },
      mHelper: new Matrix()
    }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;
    function CVShapeData(T, S, R, k) {
      this.styledShapes = [], this.tr = [0, 0, 0, 0, 0, 0];
      var D = 4;
      S.ty === "rc" ? D = 5 : S.ty === "el" ? D = 6 : S.ty === "sr" && (D = 7), this.sh = ShapePropertyFactory.getShapeProp(T, S, D, T);
      var L, V = R.length, z;
      for (L = 0; L < V; L += 1)
        R[L].closed || (z = {
          transforms: k.addTransformSequence(R[L].transforms),
          trNodes: []
        }, this.styledShapes.push(z), R[L].elements.push(z));
    }
    CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;
    function CVShapeElement(T, S, R) {
      this.shapes = [], this.shapesData = T.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager(), this.initElement(T, S, R);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
      opacity: 1,
      _opMdf: !1
    }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
    }, CVShapeElement.prototype.createStyleElement = function(T, S) {
      var R = {
        data: T,
        type: T.ty,
        preTransforms: this.transformsManager.addTransformSequence(S),
        transforms: [],
        elements: [],
        closed: T.hd === !0
      }, k = {};
      if (T.ty === "fl" || T.ty === "st" ? (k.c = PropertyFactory.getProp(this, T.c, 1, 255, this), k.c.k || (R.co = "rgb(" + bmFloor(k.c.v[0]) + "," + bmFloor(k.c.v[1]) + "," + bmFloor(k.c.v[2]) + ")")) : (T.ty === "gf" || T.ty === "gs") && (k.s = PropertyFactory.getProp(this, T.s, 1, null, this), k.e = PropertyFactory.getProp(this, T.e, 1, null, this), k.h = PropertyFactory.getProp(this, T.h || {
        k: 0
      }, 0, 0.01, this), k.a = PropertyFactory.getProp(this, T.a || {
        k: 0
      }, 0, degToRads, this), k.g = new GradientProperty(this, T.g, this)), k.o = PropertyFactory.getProp(this, T.o, 0, 0.01, this), T.ty === "st" || T.ty === "gs") {
        if (R.lc = lineCapEnum[T.lc || 2], R.lj = lineJoinEnum[T.lj || 2], T.lj == 1 && (R.ml = T.ml), k.w = PropertyFactory.getProp(this, T.w, 0, null, this), k.w.k || (R.wi = k.w.v), T.d) {
          var D = new DashProperty(this, T.d, "canvas", this);
          k.d = D, k.d.k || (R.da = k.d.dashArray, R.do = k.d.dashoffset[0]);
        }
      } else
        R.r = T.r === 2 ? "evenodd" : "nonzero";
      return this.stylesList.push(R), k.style = R, k;
    }, CVShapeElement.prototype.createGroupElement = function() {
      var T = {
        it: [],
        prevViewData: []
      };
      return T;
    }, CVShapeElement.prototype.createTransformElement = function(T) {
      var S = {
        transform: {
          opacity: 1,
          _opMdf: !1,
          key: this.transformsManager.getNewKey(),
          op: PropertyFactory.getProp(this, T.o, 0, 0.01, this),
          mProps: TransformPropertyFactory.getTransformProperty(this, T, this)
        }
      };
      return S;
    }, CVShapeElement.prototype.createShapeElement = function(T) {
      var S = new CVShapeData(this, T, this.stylesList, this.transformsManager);
      return this.shapes.push(S), this.addShapeToModifiers(S), S;
    }, CVShapeElement.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var T, S = this.itemsData.length;
      for (T = 0; T < S; T += 1)
        this.prevViewData[T] = this.itemsData[T];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), S = this.dynamicProperties.length, T = 0; T < S; T += 1)
        this.dynamicProperties[T].getValue();
      this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
    }, CVShapeElement.prototype.addTransformToStyleList = function(T) {
      var S, R = this.stylesList.length;
      for (S = 0; S < R; S += 1)
        this.stylesList[S].closed || this.stylesList[S].transforms.push(T);
    }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
      var T, S = this.stylesList.length;
      for (T = 0; T < S; T += 1)
        this.stylesList[T].closed || this.stylesList[T].transforms.pop();
    }, CVShapeElement.prototype.closeStyles = function(T) {
      var S, R = T.length;
      for (S = 0; S < R; S += 1)
        T[S].closed = !0;
    }, CVShapeElement.prototype.searchShapes = function(T, S, R, k, D) {
      var L, V = T.length - 1, z, W, U = [], q = [], K, Y, J, Z = [].concat(D);
      for (L = V; L >= 0; L -= 1) {
        if (K = this.searchProcessedElement(T[L]), K ? S[L] = R[K - 1] : T[L]._shouldRender = k, T[L].ty === "fl" || T[L].ty === "st" || T[L].ty === "gf" || T[L].ty === "gs")
          K ? S[L].style.closed = !1 : S[L] = this.createStyleElement(T[L], Z), U.push(S[L].style);
        else if (T[L].ty === "gr") {
          if (!K)
            S[L] = this.createGroupElement(T[L]);
          else
            for (W = S[L].it.length, z = 0; z < W; z += 1)
              S[L].prevViewData[z] = S[L].it[z];
          this.searchShapes(T[L].it, S[L].it, S[L].prevViewData, k, Z);
        } else T[L].ty === "tr" ? (K || (J = this.createTransformElement(T[L]), S[L] = J), Z.push(S[L]), this.addTransformToStyleList(S[L])) : T[L].ty === "sh" || T[L].ty === "rc" || T[L].ty === "el" || T[L].ty === "sr" ? K || (S[L] = this.createShapeElement(T[L])) : T[L].ty === "tm" || T[L].ty === "rd" || T[L].ty === "pb" || T[L].ty === "zz" || T[L].ty === "op" ? (K ? (Y = S[L], Y.closed = !1) : (Y = ShapeModifiers.getModifier(T[L].ty), Y.init(this, T[L]), S[L] = Y, this.shapeModifiers.push(Y)), q.push(Y)) : T[L].ty === "rp" && (K ? (Y = S[L], Y.closed = !0) : (Y = ShapeModifiers.getModifier(T[L].ty), S[L] = Y, Y.init(this, T, L, S), this.shapeModifiers.push(Y), k = !1), q.push(Y));
        this.addProcessedElement(T[L], L + 1);
      }
      for (this.removeTransformFromStyleList(), this.closeStyles(U), V = q.length, L = 0; L < V; L += 1)
        q[L].closed = !0;
    }, CVShapeElement.prototype.renderInnerContent = function() {
      this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
    }, CVShapeElement.prototype.renderShapeTransform = function(T, S) {
      (T._opMdf || S.op._mdf || this._isFirstFrame) && (S.opacity = T.opacity, S.opacity *= S.op.v, S._opMdf = !0);
    }, CVShapeElement.prototype.drawLayer = function() {
      var T, S = this.stylesList.length, R, k, D, L, V, z, W = this.globalData.renderer, U = this.globalData.canvasContext, q, K;
      for (T = 0; T < S; T += 1)
        if (K = this.stylesList[T], q = K.type, !((q === "st" || q === "gs") && K.wi === 0 || !K.data._shouldRender || K.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
          for (W.save(), V = K.elements, q === "st" || q === "gs" ? (W.ctxStrokeStyle(q === "st" ? K.co : K.grd), W.ctxLineWidth(K.wi), W.ctxLineCap(K.lc), W.ctxLineJoin(K.lj), W.ctxMiterLimit(K.ml || 0)) : W.ctxFillStyle(q === "fl" ? K.co : K.grd), W.ctxOpacity(K.coOp), q !== "st" && q !== "gs" && U.beginPath(), W.ctxTransform(K.preTransforms.finalTransform.props), k = V.length, R = 0; R < k; R += 1) {
            for ((q === "st" || q === "gs") && (U.beginPath(), K.da && (U.setLineDash(K.da), U.lineDashOffset = K.do)), z = V[R].trNodes, L = z.length, D = 0; D < L; D += 1)
              z[D].t === "m" ? U.moveTo(z[D].p[0], z[D].p[1]) : z[D].t === "c" ? U.bezierCurveTo(z[D].pts[0], z[D].pts[1], z[D].pts[2], z[D].pts[3], z[D].pts[4], z[D].pts[5]) : U.closePath();
            (q === "st" || q === "gs") && (W.ctxStroke(), K.da && U.setLineDash(this.dashResetter));
          }
          q !== "st" && q !== "gs" && this.globalData.renderer.ctxFill(K.r), W.restore();
        }
    }, CVShapeElement.prototype.renderShape = function(T, S, R, k) {
      var D, L = S.length - 1, V;
      for (V = T, D = L; D >= 0; D -= 1)
        S[D].ty === "tr" ? (V = R[D].transform, this.renderShapeTransform(T, V)) : S[D].ty === "sh" || S[D].ty === "el" || S[D].ty === "rc" || S[D].ty === "sr" ? this.renderPath(S[D], R[D]) : S[D].ty === "fl" ? this.renderFill(S[D], R[D], V) : S[D].ty === "st" ? this.renderStroke(S[D], R[D], V) : S[D].ty === "gf" || S[D].ty === "gs" ? this.renderGradientFill(S[D], R[D], V) : S[D].ty === "gr" ? this.renderShape(V, S[D].it, R[D].it) : S[D].ty;
      k && this.drawLayer();
    }, CVShapeElement.prototype.renderStyledShape = function(T, S) {
      if (this._isFirstFrame || S._mdf || T.transforms._mdf) {
        var R = T.trNodes, k = S.paths, D, L, V, z = k._length;
        R.length = 0;
        var W = T.transforms.finalTransform;
        for (V = 0; V < z; V += 1) {
          var U = k.shapes[V];
          if (U && U.v) {
            for (L = U._length, D = 1; D < L; D += 1)
              D === 1 && R.push({
                t: "m",
                p: W.applyToPointArray(U.v[0][0], U.v[0][1], 0)
              }), R.push({
                t: "c",
                pts: W.applyToTriplePoints(U.o[D - 1], U.i[D], U.v[D])
              });
            L === 1 && R.push({
              t: "m",
              p: W.applyToPointArray(U.v[0][0], U.v[0][1], 0)
            }), U.c && L && (R.push({
              t: "c",
              pts: W.applyToTriplePoints(U.o[D - 1], U.i[0], U.v[0])
            }), R.push({
              t: "z"
            }));
          }
        }
        T.trNodes = R;
      }
    }, CVShapeElement.prototype.renderPath = function(T, S) {
      if (T.hd !== !0 && T._shouldRender) {
        var R, k = S.styledShapes.length;
        for (R = 0; R < k; R += 1)
          this.renderStyledShape(S.styledShapes[R], S.sh);
      }
    }, CVShapeElement.prototype.renderFill = function(T, S, R) {
      var k = S.style;
      (S.c._mdf || this._isFirstFrame) && (k.co = "rgb(" + bmFloor(S.c.v[0]) + "," + bmFloor(S.c.v[1]) + "," + bmFloor(S.c.v[2]) + ")"), (S.o._mdf || R._opMdf || this._isFirstFrame) && (k.coOp = S.o.v * R.opacity);
    }, CVShapeElement.prototype.renderGradientFill = function(T, S, R) {
      var k = S.style, D;
      if (!k.grd || S.g._mdf || S.s._mdf || S.e._mdf || T.t !== 1 && (S.h._mdf || S.a._mdf)) {
        var L = this.globalData.canvasContext, V = S.s.v, z = S.e.v;
        if (T.t === 1)
          D = L.createLinearGradient(V[0], V[1], z[0], z[1]);
        else {
          var W = Math.sqrt(Math.pow(V[0] - z[0], 2) + Math.pow(V[1] - z[1], 2)), U = Math.atan2(z[1] - V[1], z[0] - V[0]), q = S.h.v;
          q >= 1 ? q = 0.99 : q <= -1 && (q = -0.99);
          var K = W * q, Y = Math.cos(U + S.a.v) * K + V[0], J = Math.sin(U + S.a.v) * K + V[1];
          D = L.createRadialGradient(Y, J, 0, V[0], V[1], W);
        }
        var Z, X = T.g.p, ee = S.g.c, te = 1;
        for (Z = 0; Z < X; Z += 1)
          S.g._hasOpacity && S.g._collapsable && (te = S.g.o[Z * 2 + 1]), D.addColorStop(ee[Z * 4] / 100, "rgba(" + ee[Z * 4 + 1] + "," + ee[Z * 4 + 2] + "," + ee[Z * 4 + 3] + "," + te + ")");
        k.grd = D;
      }
      k.coOp = S.o.v * R.opacity;
    }, CVShapeElement.prototype.renderStroke = function(T, S, R) {
      var k = S.style, D = S.d;
      D && (D._mdf || this._isFirstFrame) && (k.da = D.dashArray, k.do = D.dashoffset[0]), (S.c._mdf || this._isFirstFrame) && (k.co = "rgb(" + bmFloor(S.c.v[0]) + "," + bmFloor(S.c.v[1]) + "," + bmFloor(S.c.v[2]) + ")"), (S.o._mdf || R._opMdf || this._isFirstFrame) && (k.coOp = S.o.v * R.opacity), (S.w._mdf || this._isFirstFrame) && (k.wi = S.w.v);
    }, CVShapeElement.prototype.destroy = function() {
      this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
    };
    function CVTextElement(T, S, R) {
      this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
        fill: "rgba(0,0,0,0)",
        stroke: "rgba(0,0,0,0)",
        sWidth: 0,
        fValue: ""
      }, this.initElement(T, S, R);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
      var T = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(T.l ? T.l.length : 0);
      var S = !1;
      T.fc ? (S = !0, this.values.fill = this.buildColor(T.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = S;
      var R = !1;
      T.sc && (R = !0, this.values.stroke = this.buildColor(T.sc), this.values.sWidth = T.sw);
      var k = this.globalData.fontManager.getFontByName(T.f), D, L, V = T.l, z = this.mHelper;
      this.stroke = R, this.values.fValue = T.finalSize + "px " + this.globalData.fontManager.getFontByName(T.f).fFamily, L = T.finalText.length;
      var W, U, q, K, Y, J, Z, X, ee, te, re = this.data.singleShape, Q = T.tr * 1e-3 * T.finalSize, ne = 0, oe = 0, ae = !0, se = 0;
      for (D = 0; D < L; D += 1) {
        W = this.globalData.fontManager.getCharData(T.finalText[D], k.fStyle, this.globalData.fontManager.getFontByName(T.f).fFamily), U = W && W.data || {}, z.reset(), re && V[D].n && (ne = -Q, oe += T.yOffset, oe += ae ? 1 : 0, ae = !1), Y = U.shapes ? U.shapes[0].it : [], Z = Y.length, z.scale(T.finalSize / 100, T.finalSize / 100), re && this.applyTextPropertiesToMatrix(T, z, V[D].line, ne, oe), ee = createSizedArray(Z - 1);
        var ie = 0;
        for (J = 0; J < Z; J += 1)
          if (Y[J].ty === "sh") {
            for (K = Y[J].ks.k.i.length, X = Y[J].ks.k, te = [], q = 1; q < K; q += 1)
              q === 1 && te.push(z.applyToX(X.v[0][0], X.v[0][1], 0), z.applyToY(X.v[0][0], X.v[0][1], 0)), te.push(z.applyToX(X.o[q - 1][0], X.o[q - 1][1], 0), z.applyToY(X.o[q - 1][0], X.o[q - 1][1], 0), z.applyToX(X.i[q][0], X.i[q][1], 0), z.applyToY(X.i[q][0], X.i[q][1], 0), z.applyToX(X.v[q][0], X.v[q][1], 0), z.applyToY(X.v[q][0], X.v[q][1], 0));
            te.push(z.applyToX(X.o[q - 1][0], X.o[q - 1][1], 0), z.applyToY(X.o[q - 1][0], X.o[q - 1][1], 0), z.applyToX(X.i[0][0], X.i[0][1], 0), z.applyToY(X.i[0][0], X.i[0][1], 0), z.applyToX(X.v[0][0], X.v[0][1], 0), z.applyToY(X.v[0][0], X.v[0][1], 0)), ee[ie] = te, ie += 1;
          }
        re && (ne += V[D].l, ne += Q), this.textSpans[se] ? this.textSpans[se].elem = ee : this.textSpans[se] = {
          elem: ee
        }, se += 1;
      }
    }, CVTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var T = this.canvasContext;
      T.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
      var S, R, k, D, L, V, z = this.textAnimator.renderedLetters, W = this.textProperty.currentData.l;
      R = W.length;
      var U, q = null, K = null, Y = null, J, Z, X = this.globalData.renderer;
      for (S = 0; S < R; S += 1)
        if (!W[S].n) {
          if (U = z[S], U && (X.save(), X.ctxTransform(U.p), X.ctxOpacity(U.o)), this.fill) {
            for (U && U.fc ? q !== U.fc && (X.ctxFillStyle(U.fc), q = U.fc) : q !== this.values.fill && (q = this.values.fill, X.ctxFillStyle(this.values.fill)), J = this.textSpans[S].elem, D = J.length, this.globalData.canvasContext.beginPath(), k = 0; k < D; k += 1)
              for (Z = J[k], V = Z.length, this.globalData.canvasContext.moveTo(Z[0], Z[1]), L = 2; L < V; L += 6)
                this.globalData.canvasContext.bezierCurveTo(Z[L], Z[L + 1], Z[L + 2], Z[L + 3], Z[L + 4], Z[L + 5]);
            this.globalData.canvasContext.closePath(), X.ctxFill();
          }
          if (this.stroke) {
            for (U && U.sw ? Y !== U.sw && (Y = U.sw, X.ctxLineWidth(U.sw)) : Y !== this.values.sWidth && (Y = this.values.sWidth, X.ctxLineWidth(this.values.sWidth)), U && U.sc ? K !== U.sc && (K = U.sc, X.ctxStrokeStyle(U.sc)) : K !== this.values.stroke && (K = this.values.stroke, X.ctxStrokeStyle(this.values.stroke)), J = this.textSpans[S].elem, D = J.length, this.globalData.canvasContext.beginPath(), k = 0; k < D; k += 1)
              for (Z = J[k], V = Z.length, this.globalData.canvasContext.moveTo(Z[0], Z[1]), L = 2; L < V; L += 6)
                this.globalData.canvasContext.bezierCurveTo(Z[L], Z[L + 1], Z[L + 2], Z[L + 3], Z[L + 4], Z[L + 5]);
            this.globalData.canvasContext.closePath(), X.ctxStroke();
          }
          U && this.globalData.renderer.restore();
        }
    };
    function CVImageElement(T, S, R) {
      this.assetData = S.getAssetData(T.refId), this.img = S.imageLoader.getAsset(this.assetData), this.initElement(T, S, R);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
      if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
        var T = createTag("canvas");
        T.width = this.assetData.w, T.height = this.assetData.h;
        var S = T.getContext("2d"), R = this.img.width, k = this.img.height, D = R / k, L = this.assetData.w / this.assetData.h, V, z, W = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
        D > L && W === "xMidYMid slice" || D < L && W !== "xMidYMid slice" ? (z = k, V = z * L) : (V = R, z = V / L), S.drawImage(this.img, (R - V) / 2, (k - z) / 2, V, z, 0, 0, this.assetData.w, this.assetData.h), this.img = T;
      }
    }, CVImageElement.prototype.renderInnerContent = function() {
      this.canvasContext.drawImage(this.img, 0, 0);
    }, CVImageElement.prototype.destroy = function() {
      this.img = null;
    };
    function CVSolidElement(T, S, R) {
      this.initElement(T, S, R);
    }
    extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
      this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
    };
    function CanvasRendererBase() {
    }
    extendPrototype([BaseRenderer], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(T) {
      return new CVShapeElement(T, this.globalData, this);
    }, CanvasRendererBase.prototype.createText = function(T) {
      return new CVTextElement(T, this.globalData, this);
    }, CanvasRendererBase.prototype.createImage = function(T) {
      return new CVImageElement(T, this.globalData, this);
    }, CanvasRendererBase.prototype.createSolid = function(T) {
      return new CVSolidElement(T, this.globalData, this);
    }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(T) {
      T[0] === 1 && T[1] === 0 && T[4] === 0 && T[5] === 1 && T[12] === 0 && T[13] === 0 || this.canvasContext.transform(T[0], T[1], T[4], T[5], T[12], T[13]);
    }, CanvasRendererBase.prototype.ctxOpacity = function(T) {
      this.canvasContext.globalAlpha *= T < 0 ? 0 : T;
    }, CanvasRendererBase.prototype.ctxFillStyle = function(T) {
      this.canvasContext.fillStyle = T;
    }, CanvasRendererBase.prototype.ctxStrokeStyle = function(T) {
      this.canvasContext.strokeStyle = T;
    }, CanvasRendererBase.prototype.ctxLineWidth = function(T) {
      this.canvasContext.lineWidth = T;
    }, CanvasRendererBase.prototype.ctxLineCap = function(T) {
      this.canvasContext.lineCap = T;
    }, CanvasRendererBase.prototype.ctxLineJoin = function(T) {
      this.canvasContext.lineJoin = T;
    }, CanvasRendererBase.prototype.ctxMiterLimit = function(T) {
      this.canvasContext.miterLimit = T;
    }, CanvasRendererBase.prototype.ctxFill = function(T) {
      this.canvasContext.fill(T);
    }, CanvasRendererBase.prototype.ctxFillRect = function(T, S, R, k) {
      this.canvasContext.fillRect(T, S, R, k);
    }, CanvasRendererBase.prototype.ctxStroke = function() {
      this.canvasContext.stroke();
    }, CanvasRendererBase.prototype.reset = function() {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      this.contextData.reset();
    }, CanvasRendererBase.prototype.save = function() {
      this.canvasContext.save();
    }, CanvasRendererBase.prototype.restore = function(T) {
      if (!this.renderConfig.clearCanvas) {
        this.canvasContext.restore();
        return;
      }
      T && (this.globalData.blendMode = "source-over"), this.contextData.restore(T);
    }, CanvasRendererBase.prototype.configAnimation = function(T) {
      if (this.animationItem.wrapper) {
        this.animationItem.container = createTag("canvas");
        var S = this.animationItem.container.style;
        S.width = "100%", S.height = "100%";
        var R = "0px 0px 0px";
        S.transformOrigin = R, S.mozTransformOrigin = R, S.webkitTransformOrigin = R, S["-webkit-transform"] = R, S.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
      } else
        this.canvasContext = this.renderConfig.context;
      this.contextData.setContext(this.canvasContext), this.data = T, this.layers = T.layers, this.transformCanvas = {
        w: T.w,
        h: T.h,
        sx: 0,
        sy: 0,
        tx: 0,
        ty: 0
      }, this.setupGlobalData(T, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(T.layers.length), this.updateContainerSize();
    }, CanvasRendererBase.prototype.updateContainerSize = function(T, S) {
      this.reset();
      var R, k;
      T ? (R = T, k = S, this.canvasContext.canvas.width = R, this.canvasContext.canvas.height = k) : (this.animationItem.wrapper && this.animationItem.container ? (R = this.animationItem.wrapper.offsetWidth, k = this.animationItem.wrapper.offsetHeight) : (R = this.canvasContext.canvas.width, k = this.canvasContext.canvas.height), this.canvasContext.canvas.width = R * this.renderConfig.dpr, this.canvasContext.canvas.height = k * this.renderConfig.dpr);
      var D, L;
      if (this.renderConfig.preserveAspectRatio.indexOf("meet") !== -1 || this.renderConfig.preserveAspectRatio.indexOf("slice") !== -1) {
        var V = this.renderConfig.preserveAspectRatio.split(" "), z = V[1] || "meet", W = V[0] || "xMidYMid", U = W.substr(0, 4), q = W.substr(4);
        D = R / k, L = this.transformCanvas.w / this.transformCanvas.h, L > D && z === "meet" || L < D && z === "slice" ? (this.transformCanvas.sx = R / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = R / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = k / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = k / (this.transformCanvas.h / this.renderConfig.dpr)), U === "xMid" && (L < D && z === "meet" || L > D && z === "slice") ? this.transformCanvas.tx = (R - this.transformCanvas.w * (k / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : U === "xMax" && (L < D && z === "meet" || L > D && z === "slice") ? this.transformCanvas.tx = (R - this.transformCanvas.w * (k / this.transformCanvas.h)) * this.renderConfig.dpr : this.transformCanvas.tx = 0, q === "YMid" && (L > D && z === "meet" || L < D && z === "slice") ? this.transformCanvas.ty = (k - this.transformCanvas.h * (R / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : q === "YMax" && (L > D && z === "meet" || L < D && z === "slice") ? this.transformCanvas.ty = (k - this.transformCanvas.h * (R / this.transformCanvas.w)) * this.renderConfig.dpr : this.transformCanvas.ty = 0;
      } else this.renderConfig.preserveAspectRatio === "none" ? (this.transformCanvas.sx = R / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = k / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
      this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
    }, CanvasRendererBase.prototype.destroy = function() {
      this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = "");
      var T, S = this.layers ? this.layers.length : 0;
      for (T = S - 1; T >= 0; T -= 1)
        this.elements[T] && this.elements[T].destroy && this.elements[T].destroy();
      this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
    }, CanvasRendererBase.prototype.renderFrame = function(T, S) {
      if (!(this.renderedFrame === T && this.renderConfig.clearCanvas === !0 && !S || this.destroyed || T === -1)) {
        this.renderedFrame = T, this.globalData.frameNum = T - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || S, this.globalData.projectInterface.currentFrame = T;
        var R, k = this.layers.length;
        for (this.completeLayers || this.checkLayers(T), R = k - 1; R >= 0; R -= 1)
          (this.completeLayers || this.elements[R]) && this.elements[R].prepareFrame(T - this.layers[R].st);
        if (this.globalData._mdf) {
          for (this.renderConfig.clearCanvas === !0 ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), R = k - 1; R >= 0; R -= 1)
            (this.completeLayers || this.elements[R]) && this.elements[R].renderFrame();
          this.renderConfig.clearCanvas !== !0 && this.restore();
        }
      }
    }, CanvasRendererBase.prototype.buildItem = function(T) {
      var S = this.elements;
      if (!(S[T] || this.layers[T].ty === 99)) {
        var R = this.createItem(this.layers[T], this, this.globalData);
        S[T] = R, R.initExpressions();
      }
    }, CanvasRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var T = this.pendingElements.pop();
        T.checkParenting();
      }
    }, CanvasRendererBase.prototype.hide = function() {
      this.animationItem.container.style.display = "none";
    }, CanvasRendererBase.prototype.show = function() {
      this.animationItem.container.style.display = "block";
    };
    function CanvasContext() {
      this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
    }
    function CVContextData() {
      this.stack = [], this.cArrPos = 0, this.cTr = new Matrix();
      var T, S = 15;
      for (T = 0; T < S; T += 1) {
        var R = new CanvasContext();
        this.stack[T] = R;
      }
      this._length = S, this.nativeContext = null, this.transformMat = new Matrix(), this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
    }
    CVContextData.prototype.duplicate = function() {
      var T = this._length * 2, S = 0;
      for (S = this._length; S < T; S += 1)
        this.stack[S] = new CanvasContext();
      this._length = T;
    }, CVContextData.prototype.reset = function() {
      this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
    }, CVContextData.prototype.restore = function(T) {
      this.cArrPos -= 1;
      var S = this.stack[this.cArrPos], R = S.transform, k, D = this.cTr.props;
      for (k = 0; k < 16; k += 1)
        D[k] = R[k];
      if (T) {
        this.nativeContext.restore();
        var L = this.stack[this.cArrPos + 1];
        this.appliedFillStyle = L.fillStyle, this.appliedStrokeStyle = L.strokeStyle, this.appliedLineWidth = L.lineWidth, this.appliedLineCap = L.lineCap, this.appliedLineJoin = L.lineJoin, this.appliedMiterLimit = L.miterLimit;
      }
      this.nativeContext.setTransform(R[0], R[1], R[4], R[5], R[12], R[13]), (T || S.opacity !== -1 && this.currentOpacity !== S.opacity) && (this.nativeContext.globalAlpha = S.opacity, this.currentOpacity = S.opacity), this.currentFillStyle = S.fillStyle, this.currentStrokeStyle = S.strokeStyle, this.currentLineWidth = S.lineWidth, this.currentLineCap = S.lineCap, this.currentLineJoin = S.lineJoin, this.currentMiterLimit = S.miterLimit;
    }, CVContextData.prototype.save = function(T) {
      T && this.nativeContext.save();
      var S = this.cTr.props;
      this._length <= this.cArrPos && this.duplicate();
      var R = this.stack[this.cArrPos], k;
      for (k = 0; k < 16; k += 1)
        R.transform[k] = S[k];
      this.cArrPos += 1;
      var D = this.stack[this.cArrPos];
      D.opacity = R.opacity, D.fillStyle = R.fillStyle, D.strokeStyle = R.strokeStyle, D.lineWidth = R.lineWidth, D.lineCap = R.lineCap, D.lineJoin = R.lineJoin, D.miterLimit = R.miterLimit;
    }, CVContextData.prototype.setOpacity = function(T) {
      this.stack[this.cArrPos].opacity = T;
    }, CVContextData.prototype.setContext = function(T) {
      this.nativeContext = T;
    }, CVContextData.prototype.fillStyle = function(T) {
      this.stack[this.cArrPos].fillStyle !== T && (this.currentFillStyle = T, this.stack[this.cArrPos].fillStyle = T);
    }, CVContextData.prototype.strokeStyle = function(T) {
      this.stack[this.cArrPos].strokeStyle !== T && (this.currentStrokeStyle = T, this.stack[this.cArrPos].strokeStyle = T);
    }, CVContextData.prototype.lineWidth = function(T) {
      this.stack[this.cArrPos].lineWidth !== T && (this.currentLineWidth = T, this.stack[this.cArrPos].lineWidth = T);
    }, CVContextData.prototype.lineCap = function(T) {
      this.stack[this.cArrPos].lineCap !== T && (this.currentLineCap = T, this.stack[this.cArrPos].lineCap = T);
    }, CVContextData.prototype.lineJoin = function(T) {
      this.stack[this.cArrPos].lineJoin !== T && (this.currentLineJoin = T, this.stack[this.cArrPos].lineJoin = T);
    }, CVContextData.prototype.miterLimit = function(T) {
      this.stack[this.cArrPos].miterLimit !== T && (this.currentMiterLimit = T, this.stack[this.cArrPos].miterLimit = T);
    }, CVContextData.prototype.transform = function(T) {
      this.transformMat.cloneFromProps(T);
      var S = this.cTr;
      this.transformMat.multiply(S), S.cloneFromProps(this.transformMat.props);
      var R = S.props;
      this.nativeContext.setTransform(R[0], R[1], R[4], R[5], R[12], R[13]);
    }, CVContextData.prototype.opacity = function(T) {
      var S = this.stack[this.cArrPos].opacity;
      S *= T < 0 ? 0 : T, this.stack[this.cArrPos].opacity !== S && (this.currentOpacity !== T && (this.nativeContext.globalAlpha = T, this.currentOpacity = T), this.stack[this.cArrPos].opacity = S);
    }, CVContextData.prototype.fill = function(T) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(T);
    }, CVContextData.prototype.fillRect = function(T, S, R, k) {
      this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(T, S, R, k);
    }, CVContextData.prototype.stroke = function() {
      this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
    };
    function CVCompElement(T, S, R) {
      this.completeLayers = !1, this.layers = T.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(T, S, R), this.tm = T.tm ? PropertyFactory.getProp(this, T.tm, 0, S.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
      var T = this.canvasContext;
      T.beginPath(), T.moveTo(0, 0), T.lineTo(this.data.w, 0), T.lineTo(this.data.w, this.data.h), T.lineTo(0, this.data.h), T.lineTo(0, 0), T.clip();
      var S, R = this.layers.length;
      for (S = R - 1; S >= 0; S -= 1)
        (this.completeLayers || this.elements[S]) && this.elements[S].renderFrame();
    }, CVCompElement.prototype.destroy = function() {
      var T, S = this.layers.length;
      for (T = S - 1; T >= 0; T -= 1)
        this.elements[T] && this.elements[T].destroy();
      this.layers = null, this.elements = null;
    }, CVCompElement.prototype.createComp = function(T) {
      return new CVCompElement(T, this.globalData, this);
    };
    function CanvasRenderer(T, S) {
      this.animationItem = T, this.renderConfig = {
        clearCanvas: S && S.clearCanvas !== void 0 ? S.clearCanvas : !0,
        context: S && S.context || null,
        progressiveLoad: S && S.progressiveLoad || !1,
        preserveAspectRatio: S && S.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: S && S.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: S && S.contentVisibility || "visible",
        className: S && S.className || "",
        id: S && S.id || "",
        runExpressions: !S || S.runExpressions === void 0 || S.runExpressions
      }, this.renderConfig.dpr = S && S.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = S && S.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
        frameNum: -1,
        _mdf: !1,
        renderConfig: this.renderConfig,
        currentGlobalAlpha: -1
      }, this.contextData = new CVContextData(), this.elements = [], this.pendingElements = [], this.transformMat = new Matrix(), this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
    }
    extendPrototype([CanvasRendererBase], CanvasRenderer), CanvasRenderer.prototype.createComp = function(T) {
      return new CVCompElement(T, this.globalData, this);
    };
    function HBaseElement() {
    }
    HBaseElement.prototype = {
      checkBlendMode: function() {
      },
      initRendererElement: function() {
        this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
      },
      createContainerElements: function() {
        this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        var S = this.transformedElement ? this.transformedElement.style : {};
        if (this.finalTransform._matMdf) {
          var R = this.finalTransform.mat.toCSS();
          S.transform = R, S.webkitTransform = R;
        }
        this.finalTransform._opMdf && (S.opacity = this.finalTransform.mProp.o.v);
      },
      renderFrame: function() {
        this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
      },
      destroy: function() {
        this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
      },
      createRenderableComponents: function() {
        this.maskManager = new MaskElement(this.data, this, this.globalData);
      },
      addEffects: function() {
      },
      setMatte: function() {
      }
    }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;
    function HSolidElement(T, S, R) {
      this.initElement(T, S, R);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement), HSolidElement.prototype.createContent = function() {
      var T;
      this.data.hasMask ? (T = createNS("rect"), T.setAttribute("width", this.data.sw), T.setAttribute("height", this.data.sh), T.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : (T = createTag("div"), T.style.width = this.data.sw + "px", T.style.height = this.data.sh + "px", T.style.backgroundColor = this.data.sc), this.layerElement.appendChild(T);
    };
    function HShapeElement(T, S, R) {
      this.shapes = [], this.shapesData = T.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(T, S, R), this.prevViewData = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      };
    }
    extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
      var T;
      if (this.baseElement.style.fontSize = 0, this.data.hasMask)
        this.layerElement.appendChild(this.shapesContainer), T = this.svgElement;
      else {
        T = createNS("svg");
        var S = this.comp.data ? this.comp.data : this.globalData.compSize;
        T.setAttribute("width", S.w), T.setAttribute("height", S.h), T.appendChild(this.shapesContainer), this.layerElement.appendChild(T);
      }
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = T;
    }, HShapeElement.prototype.getTransformedPoint = function(T, S) {
      var R, k = T.length;
      for (R = 0; R < k; R += 1)
        S = T[R].mProps.v.applyToPointArray(S[0], S[1], 0);
      return S;
    }, HShapeElement.prototype.calculateShapeBoundingBox = function(T, S) {
      var R = T.sh.v, k = T.transformers, D, L = R._length, V, z, W, U;
      if (!(L <= 1)) {
        for (D = 0; D < L - 1; D += 1)
          V = this.getTransformedPoint(k, R.v[D]), z = this.getTransformedPoint(k, R.o[D]), W = this.getTransformedPoint(k, R.i[D + 1]), U = this.getTransformedPoint(k, R.v[D + 1]), this.checkBounds(V, z, W, U, S);
        R.c && (V = this.getTransformedPoint(k, R.v[D]), z = this.getTransformedPoint(k, R.o[D]), W = this.getTransformedPoint(k, R.i[0]), U = this.getTransformedPoint(k, R.v[0]), this.checkBounds(V, z, W, U, S));
      }
    }, HShapeElement.prototype.checkBounds = function(T, S, R, k, D) {
      this.getBoundsOfCurve(T, S, R, k);
      var L = this.shapeBoundingBox;
      D.x = bmMin(L.left, D.x), D.xMax = bmMax(L.right, D.xMax), D.y = bmMin(L.top, D.y), D.yMax = bmMax(L.bottom, D.yMax);
    }, HShapeElement.prototype.shapeBoundingBox = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, HShapeElement.prototype.tempBoundingBox = {
      x: 0,
      xMax: 0,
      y: 0,
      yMax: 0,
      width: 0,
      height: 0
    }, HShapeElement.prototype.getBoundsOfCurve = function(T, S, R, k) {
      for (var D = [[T[0], k[0]], [T[1], k[1]]], L, V, z, W, U, q, K, Y = 0; Y < 2; ++Y)
        V = 6 * T[Y] - 12 * S[Y] + 6 * R[Y], L = -3 * T[Y] + 9 * S[Y] - 9 * R[Y] + 3 * k[Y], z = 3 * S[Y] - 3 * T[Y], V |= 0, L |= 0, z |= 0, L === 0 && V === 0 || (L === 0 ? (W = -z / V, W > 0 && W < 1 && D[Y].push(this.calculateF(W, T, S, R, k, Y))) : (U = V * V - 4 * z * L, U >= 0 && (q = (-V + bmSqrt(U)) / (2 * L), q > 0 && q < 1 && D[Y].push(this.calculateF(q, T, S, R, k, Y)), K = (-V - bmSqrt(U)) / (2 * L), K > 0 && K < 1 && D[Y].push(this.calculateF(K, T, S, R, k, Y)))));
      this.shapeBoundingBox.left = bmMin.apply(null, D[0]), this.shapeBoundingBox.top = bmMin.apply(null, D[1]), this.shapeBoundingBox.right = bmMax.apply(null, D[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, D[1]);
    }, HShapeElement.prototype.calculateF = function(T, S, R, k, D, L) {
      return bmPow(1 - T, 3) * S[L] + 3 * bmPow(1 - T, 2) * T * R[L] + 3 * (1 - T) * bmPow(T, 2) * k[L] + bmPow(T, 3) * D[L];
    }, HShapeElement.prototype.calculateBoundingBox = function(T, S) {
      var R, k = T.length;
      for (R = 0; R < k; R += 1)
        T[R] && T[R].sh ? this.calculateShapeBoundingBox(T[R], S) : T[R] && T[R].it ? this.calculateBoundingBox(T[R].it, S) : T[R] && T[R].style && T[R].w && this.expandStrokeBoundingBox(T[R].w, S);
    }, HShapeElement.prototype.expandStrokeBoundingBox = function(T, S) {
      var R = 0;
      if (T.keyframes) {
        for (var k = 0; k < T.keyframes.length; k += 1) {
          var D = T.keyframes[k].s;
          D > R && (R = D);
        }
        R *= T.mult;
      } else
        R = T.v * T.mult;
      S.x -= R, S.xMax += R, S.y -= R, S.yMax += R;
    }, HShapeElement.prototype.currentBoxContains = function(T) {
      return this.currentBBox.x <= T.x && this.currentBBox.y <= T.y && this.currentBBox.width + this.currentBBox.x >= T.x + T.width && this.currentBBox.height + this.currentBBox.y >= T.y + T.height;
    }, HShapeElement.prototype.renderInnerContent = function() {
      if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
        var T = this.tempBoundingBox, S = 999999;
        if (T.x = S, T.xMax = -S, T.y = S, T.yMax = -S, this.calculateBoundingBox(this.itemsData, T), T.width = T.xMax < T.x ? 0 : T.xMax - T.x, T.height = T.yMax < T.y ? 0 : T.yMax - T.y, this.currentBoxContains(T))
          return;
        var R = !1;
        if (this.currentBBox.w !== T.width && (this.currentBBox.w = T.width, this.shapeCont.setAttribute("width", T.width), R = !0), this.currentBBox.h !== T.height && (this.currentBBox.h = T.height, this.shapeCont.setAttribute("height", T.height), R = !0), R || this.currentBBox.x !== T.x || this.currentBBox.y !== T.y) {
          this.currentBBox.w = T.width, this.currentBBox.h = T.height, this.currentBBox.x = T.x, this.currentBBox.y = T.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
          var k = this.shapeCont.style, D = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
          k.transform = D, k.webkitTransform = D;
        }
      }
    };
    function HTextElement(T, S, R) {
      this.textSpans = [], this.textPaths = [], this.currentBBox = {
        x: 999999,
        y: -999999,
        h: 0,
        w: 0
      }, this.renderType = "svg", this.isMasked = !1, this.initElement(T, S, R);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement), HTextElement.prototype.createContent = function() {
      if (this.isMasked = this.checkMasks(), this.isMasked) {
        this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
        var T = createNS("g");
        this.maskedElement.appendChild(T), this.innerElem = T;
      } else
        this.renderType = "html", this.innerElem = this.layerElement;
      this.checkParenting();
    }, HTextElement.prototype.buildNewText = function() {
      var T = this.textProperty.currentData;
      this.renderedLetters = createSizedArray(T.l ? T.l.length : 0);
      var S = this.innerElem.style, R = T.fc ? this.buildColor(T.fc) : "rgba(0,0,0,0)";
      S.fill = R, S.color = R, T.sc && (S.stroke = this.buildColor(T.sc), S.strokeWidth = T.sw + "px");
      var k = this.globalData.fontManager.getFontByName(T.f);
      if (!this.globalData.fontManager.chars)
        if (S.fontSize = T.finalSize + "px", S.lineHeight = T.finalSize + "px", k.fClass)
          this.innerElem.className = k.fClass;
        else {
          S.fontFamily = k.fFamily;
          var D = T.fWeight, L = T.fStyle;
          S.fontStyle = L, S.fontWeight = D;
        }
      var V, z, W = T.l;
      z = W.length;
      var U, q, K, Y = this.mHelper, J, Z = "", X = 0;
      for (V = 0; V < z; V += 1) {
        if (this.globalData.fontManager.chars ? (this.textPaths[X] ? U = this.textPaths[X] : (U = createNS("path"), U.setAttribute("stroke-linecap", lineCapEnum[1]), U.setAttribute("stroke-linejoin", lineJoinEnum[2]), U.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[X] ? (q = this.textSpans[X], K = q.children[0]) : (q = createTag("div"), q.style.lineHeight = 0, K = createNS("svg"), K.appendChild(U), styleDiv(q)))) : this.isMasked ? U = this.textPaths[X] ? this.textPaths[X] : createNS("text") : this.textSpans[X] ? (q = this.textSpans[X], U = this.textPaths[X]) : (q = createTag("span"), styleDiv(q), U = createTag("span"), styleDiv(U), q.appendChild(U)), this.globalData.fontManager.chars) {
          var ee = this.globalData.fontManager.getCharData(T.finalText[V], k.fStyle, this.globalData.fontManager.getFontByName(T.f).fFamily), te;
          if (ee ? te = ee.data : te = null, Y.reset(), te && te.shapes && te.shapes.length && (J = te.shapes[0].it, Y.scale(T.finalSize / 100, T.finalSize / 100), Z = this.createPathShape(Y, J), U.setAttribute("d", Z)), this.isMasked)
            this.innerElem.appendChild(U);
          else {
            if (this.innerElem.appendChild(q), te && te.shapes) {
              document.body.appendChild(K);
              var re = K.getBBox();
              K.setAttribute("width", re.width + 2), K.setAttribute("height", re.height + 2), K.setAttribute("viewBox", re.x - 1 + " " + (re.y - 1) + " " + (re.width + 2) + " " + (re.height + 2));
              var Q = K.style, ne = "translate(" + (re.x - 1) + "px," + (re.y - 1) + "px)";
              Q.transform = ne, Q.webkitTransform = ne, W[V].yOffset = re.y - 1;
            } else
              K.setAttribute("width", 1), K.setAttribute("height", 1);
            q.appendChild(K);
          }
        } else if (U.textContent = W[V].val, U.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked)
          this.innerElem.appendChild(U);
        else {
          this.innerElem.appendChild(q);
          var oe = U.style, ae = "translate3d(0," + -T.finalSize / 1.2 + "px,0)";
          oe.transform = ae, oe.webkitTransform = ae;
        }
        this.isMasked ? this.textSpans[X] = U : this.textSpans[X] = q, this.textSpans[X].style.display = "block", this.textPaths[X] = U, X += 1;
      }
      for (; X < this.textSpans.length; )
        this.textSpans[X].style.display = "none", X += 1;
    }, HTextElement.prototype.renderInnerContent = function() {
      this.validateText();
      var T;
      if (this.data.singleShape) {
        if (!this._isFirstFrame && !this.lettersChangedFlag)
          return;
        if (this.isMasked && this.finalTransform._matMdf) {
          this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), T = this.svgElement.style;
          var S = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
          T.transform = S, T.webkitTransform = S;
        }
      }
      if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), !(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag)) {
        var R, k, D = 0, L = this.textAnimator.renderedLetters, V = this.textProperty.currentData.l;
        k = V.length;
        var z, W, U;
        for (R = 0; R < k; R += 1)
          V[R].n ? D += 1 : (W = this.textSpans[R], U = this.textPaths[R], z = L[D], D += 1, z._mdf.m && (this.isMasked ? W.setAttribute("transform", z.m) : (W.style.webkitTransform = z.m, W.style.transform = z.m)), W.style.opacity = z.o, z.sw && z._mdf.sw && U.setAttribute("stroke-width", z.sw), z.sc && z._mdf.sc && U.setAttribute("stroke", z.sc), z.fc && z._mdf.fc && (U.setAttribute("fill", z.fc), U.style.color = z.fc));
        if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
          var q = this.innerElem.getBBox();
          this.currentBBox.w !== q.width && (this.currentBBox.w = q.width, this.svgElement.setAttribute("width", q.width)), this.currentBBox.h !== q.height && (this.currentBBox.h = q.height, this.svgElement.setAttribute("height", q.height));
          var K = 1;
          if (this.currentBBox.w !== q.width + K * 2 || this.currentBBox.h !== q.height + K * 2 || this.currentBBox.x !== q.x - K || this.currentBBox.y !== q.y - K) {
            this.currentBBox.w = q.width + K * 2, this.currentBBox.h = q.height + K * 2, this.currentBBox.x = q.x - K, this.currentBBox.y = q.y - K, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), T = this.svgElement.style;
            var Y = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
            T.transform = Y, T.webkitTransform = Y;
          }
        }
      }
    };
    function HCameraElement(T, S, R) {
      this.initFrame(), this.initBaseData(T, S, R), this.initHierarchy();
      var k = PropertyFactory.getProp;
      if (this.pe = k(this, T.pe, 0, 0, this), T.ks.p.s ? (this.px = k(this, T.ks.p.x, 1, 0, this), this.py = k(this, T.ks.p.y, 1, 0, this), this.pz = k(this, T.ks.p.z, 1, 0, this)) : this.p = k(this, T.ks.p, 1, 0, this), T.ks.a && (this.a = k(this, T.ks.a, 1, 0, this)), T.ks.or.k.length && T.ks.or.k[0].to) {
        var D, L = T.ks.or.k.length;
        for (D = 0; D < L; D += 1)
          T.ks.or.k[D].to = null, T.ks.or.k[D].ti = null;
      }
      this.or = k(this, T.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = k(this, T.ks.rx, 0, degToRads, this), this.ry = k(this, T.ks.ry, 0, degToRads, this), this.rz = k(this, T.ks.rz, 0, degToRads, this), this.mat = new Matrix(), this._prevMat = new Matrix(), this._isFirstFrame = !0, this.finalTransform = {
        mProp: this
      };
    }
    extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement), HCameraElement.prototype.setup = function() {
      var T, S = this.comp.threeDElements.length, R, k, D;
      for (T = 0; T < S; T += 1)
        if (R = this.comp.threeDElements[T], R.type === "3d") {
          k = R.perspectiveElem.style, D = R.container.style;
          var L = this.pe.v + "px", V = "0px 0px 0px", z = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
          k.perspective = L, k.webkitPerspective = L, D.transformOrigin = V, D.mozTransformOrigin = V, D.webkitTransformOrigin = V, k.transform = z, k.webkitTransform = z;
        }
    }, HCameraElement.prototype.createElements = function() {
    }, HCameraElement.prototype.hide = function() {
    }, HCameraElement.prototype.renderFrame = function() {
      var T = this._isFirstFrame, S, R;
      if (this.hierarchy)
        for (R = this.hierarchy.length, S = 0; S < R; S += 1)
          T = this.hierarchy[S].finalTransform.mProp._mdf || T;
      if (T || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
        if (this.mat.reset(), this.hierarchy)
          for (R = this.hierarchy.length - 1, S = R; S >= 0; S -= 1) {
            var k = this.hierarchy[S].finalTransform.mProp;
            this.mat.translate(-k.p.v[0], -k.p.v[1], k.p.v[2]), this.mat.rotateX(-k.or.v[0]).rotateY(-k.or.v[1]).rotateZ(k.or.v[2]), this.mat.rotateX(-k.rx.v).rotateY(-k.ry.v).rotateZ(k.rz.v), this.mat.scale(1 / k.s.v[0], 1 / k.s.v[1], 1 / k.s.v[2]), this.mat.translate(k.a.v[0], k.a.v[1], k.a.v[2]);
          }
        if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
          var D;
          this.p ? D = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]] : D = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
          var L = Math.sqrt(Math.pow(D[0], 2) + Math.pow(D[1], 2) + Math.pow(D[2], 2)), V = [D[0] / L, D[1] / L, D[2] / L], z = Math.sqrt(V[2] * V[2] + V[0] * V[0]), W = Math.atan2(V[1], z), U = Math.atan2(V[0], -V[2]);
          this.mat.rotateY(U).rotateX(-W);
        }
        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
        var q = !this._prevMat.equals(this.mat);
        if ((q || this.pe._mdf) && this.comp.threeDElements) {
          R = this.comp.threeDElements.length;
          var K, Y, J;
          for (S = 0; S < R; S += 1)
            if (K = this.comp.threeDElements[S], K.type === "3d") {
              if (q) {
                var Z = this.mat.toCSS();
                J = K.container.style, J.transform = Z, J.webkitTransform = Z;
              }
              this.pe._mdf && (Y = K.perspectiveElem.style, Y.perspective = this.pe.v + "px", Y.webkitPerspective = this.pe.v + "px");
            }
          this.mat.clone(this._prevMat);
        }
      }
      this._isFirstFrame = !1;
    }, HCameraElement.prototype.prepareFrame = function(T) {
      this.prepareProperties(T, !0);
    }, HCameraElement.prototype.destroy = function() {
    }, HCameraElement.prototype.getBaseElement = function() {
      return null;
    };
    function HImageElement(T, S, R) {
      this.assetData = S.getAssetData(T.refId), this.initElement(T, S, R);
    }
    extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement), HImageElement.prototype.createContent = function() {
      var T = this.globalData.getAssetsPath(this.assetData), S = new Image();
      this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", T), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(S), S.crossOrigin = "anonymous", S.src = T, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
    };
    function HybridRendererBase(T, S) {
      this.animationItem = T, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: S && S.className || "",
        imagePreserveAspectRatio: S && S.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(S && S.hideOnTransparent === !1),
        filterSize: {
          width: S && S.filterSize && S.filterSize.width || "400%",
          height: S && S.filterSize && S.filterSize.height || "400%",
          x: S && S.filterSize && S.filterSize.x || "-100%",
          y: S && S.filterSize && S.filterSize.y || "-100%"
        }
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([BaseRenderer], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var T = this.pendingElements.pop();
        T.checkParenting();
      }
    }, HybridRendererBase.prototype.appendElementInPos = function(T, S) {
      var R = T.getBaseElement();
      if (R) {
        var k = this.layers[S];
        if (!k.ddd || !this.supports3d)
          if (this.threeDElements)
            this.addTo3dContainer(R, S);
          else {
            for (var D = 0, L, V, z; D < S; )
              this.elements[D] && this.elements[D] !== !0 && this.elements[D].getBaseElement && (V = this.elements[D], z = this.layers[D].ddd ? this.getThreeDContainerByPos(D) : V.getBaseElement(), L = z || L), D += 1;
            L ? (!k.ddd || !this.supports3d) && this.layerElement.insertBefore(R, L) : (!k.ddd || !this.supports3d) && this.layerElement.appendChild(R);
          }
        else
          this.addTo3dContainer(R, S);
      }
    }, HybridRendererBase.prototype.createShape = function(T) {
      return this.supports3d ? new HShapeElement(T, this.globalData, this) : new SVGShapeElement(T, this.globalData, this);
    }, HybridRendererBase.prototype.createText = function(T) {
      return this.supports3d ? new HTextElement(T, this.globalData, this) : new SVGTextLottieElement(T, this.globalData, this);
    }, HybridRendererBase.prototype.createCamera = function(T) {
      return this.camera = new HCameraElement(T, this.globalData, this), this.camera;
    }, HybridRendererBase.prototype.createImage = function(T) {
      return this.supports3d ? new HImageElement(T, this.globalData, this) : new IImageElement(T, this.globalData, this);
    }, HybridRendererBase.prototype.createSolid = function(T) {
      return this.supports3d ? new HSolidElement(T, this.globalData, this) : new ISolidElement(T, this.globalData, this);
    }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(T) {
      for (var S = 0, R = this.threeDElements.length; S < R; ) {
        if (this.threeDElements[S].startPos <= T && this.threeDElements[S].endPos >= T)
          return this.threeDElements[S].perspectiveElem;
        S += 1;
      }
      return null;
    }, HybridRendererBase.prototype.createThreeDContainer = function(T, S) {
      var R = createTag("div"), k, D;
      styleDiv(R);
      var L = createTag("div");
      if (styleDiv(L), S === "3d") {
        k = R.style, k.width = this.globalData.compSize.w + "px", k.height = this.globalData.compSize.h + "px";
        var V = "50% 50%";
        k.webkitTransformOrigin = V, k.mozTransformOrigin = V, k.transformOrigin = V, D = L.style;
        var z = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
        D.transform = z, D.webkitTransform = z;
      }
      R.appendChild(L);
      var W = {
        container: L,
        perspectiveElem: R,
        startPos: T,
        endPos: T,
        type: S
      };
      return this.threeDElements.push(W), W;
    }, HybridRendererBase.prototype.build3dContainers = function() {
      var T, S = this.layers.length, R, k = "";
      for (T = 0; T < S; T += 1)
        this.layers[T].ddd && this.layers[T].ty !== 3 ? (k !== "3d" && (k = "3d", R = this.createThreeDContainer(T, "3d")), R.endPos = Math.max(R.endPos, T)) : (k !== "2d" && (k = "2d", R = this.createThreeDContainer(T, "2d")), R.endPos = Math.max(R.endPos, T));
      for (S = this.threeDElements.length, T = S - 1; T >= 0; T -= 1)
        this.resizerElem.appendChild(this.threeDElements[T].perspectiveElem);
    }, HybridRendererBase.prototype.addTo3dContainer = function(T, S) {
      for (var R = 0, k = this.threeDElements.length; R < k; ) {
        if (S <= this.threeDElements[R].endPos) {
          for (var D = this.threeDElements[R].startPos, L; D < S; )
            this.elements[D] && this.elements[D].getBaseElement && (L = this.elements[D].getBaseElement()), D += 1;
          L ? this.threeDElements[R].container.insertBefore(T, L) : this.threeDElements[R].container.appendChild(T);
          break;
        }
        R += 1;
      }
    }, HybridRendererBase.prototype.configAnimation = function(T) {
      var S = createTag("div"), R = this.animationItem.wrapper, k = S.style;
      k.width = T.w + "px", k.height = T.h + "px", this.resizerElem = S, styleDiv(S), k.transformStyle = "flat", k.mozTransformStyle = "flat", k.webkitTransformStyle = "flat", this.renderConfig.className && S.setAttribute("class", this.renderConfig.className), R.appendChild(S), k.overflow = "hidden";
      var D = createNS("svg");
      D.setAttribute("width", "1"), D.setAttribute("height", "1"), styleDiv(D), this.resizerElem.appendChild(D);
      var L = createNS("defs");
      D.appendChild(L), this.data = T, this.setupGlobalData(T, D), this.globalData.defs = L, this.layers = T.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
    }, HybridRendererBase.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
      var T, S = this.layers ? this.layers.length : 0;
      for (T = 0; T < S; T += 1)
        this.elements[T] && this.elements[T].destroy && this.elements[T].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, HybridRendererBase.prototype.updateContainerSize = function() {
      var T = this.animationItem.wrapper.offsetWidth, S = this.animationItem.wrapper.offsetHeight, R = T / S, k = this.globalData.compSize.w / this.globalData.compSize.h, D, L, V, z;
      k > R ? (D = T / this.globalData.compSize.w, L = T / this.globalData.compSize.w, V = 0, z = (S - this.globalData.compSize.h * (T / this.globalData.compSize.w)) / 2) : (D = S / this.globalData.compSize.h, L = S / this.globalData.compSize.h, V = (T - this.globalData.compSize.w * (S / this.globalData.compSize.h)) / 2, z = 0);
      var W = this.resizerElem.style;
      W.webkitTransform = "matrix3d(" + D + ",0,0,0,0," + L + ",0,0,0,0,1,0," + V + "," + z + ",0,1)", W.transform = W.webkitTransform;
    }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
      this.resizerElem.style.display = "none";
    }, HybridRendererBase.prototype.show = function() {
      this.resizerElem.style.display = "block";
    }, HybridRendererBase.prototype.initItems = function() {
      if (this.buildAllItems(), this.camera)
        this.camera.setup();
      else {
        var T = this.globalData.compSize.w, S = this.globalData.compSize.h, R, k = this.threeDElements.length;
        for (R = 0; R < k; R += 1) {
          var D = this.threeDElements[R].perspectiveElem.style;
          D.webkitPerspective = Math.sqrt(Math.pow(T, 2) + Math.pow(S, 2)) + "px", D.perspective = D.webkitPerspective;
        }
      }
    }, HybridRendererBase.prototype.searchExtraCompositions = function(T) {
      var S, R = T.length, k = createTag("div");
      for (S = 0; S < R; S += 1)
        if (T[S].xt) {
          var D = this.createComp(T[S], k, this.globalData.comp, null);
          D.initExpressions(), this.globalData.projectInterface.registerComposition(D);
        }
    };
    function HCompElement(T, S, R) {
      this.layers = T.layers, this.supports3d = !T.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(T, S, R), this.tm = T.tm ? PropertyFactory.getProp(this, T.tm, 0, S.frameRate, this) : {
        _placeholder: !0
      };
    }
    extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
      this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
    }, HCompElement.prototype.addTo3dContainer = function(T, S) {
      for (var R = 0, k; R < S; )
        this.elements[R] && this.elements[R].getBaseElement && (k = this.elements[R].getBaseElement()), R += 1;
      k ? this.layerElement.insertBefore(T, k) : this.layerElement.appendChild(T);
    }, HCompElement.prototype.createComp = function(T) {
      return this.supports3d ? new HCompElement(T, this.globalData, this) : new SVGCompElement(T, this.globalData, this);
    };
    function HybridRenderer(T, S) {
      this.animationItem = T, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
        className: S && S.className || "",
        imagePreserveAspectRatio: S && S.imagePreserveAspectRatio || "xMidYMid slice",
        hideOnTransparent: !(S && S.hideOnTransparent === !1),
        filterSize: {
          width: S && S.filterSize && S.filterSize.width || "400%",
          height: S && S.filterSize && S.filterSize.height || "400%",
          x: S && S.filterSize && S.filterSize.x || "-100%",
          y: S && S.filterSize && S.filterSize.y || "-100%"
        },
        runExpressions: !S || S.runExpressions === void 0 || S.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        renderConfig: this.renderConfig
      }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
    }
    extendPrototype([HybridRendererBase], HybridRenderer), HybridRenderer.prototype.createComp = function(T) {
      return this.supports3d ? new HCompElement(T, this.globalData, this) : new SVGCompElement(T, this.globalData, this);
    };
    var CompExpressionInterface = /* @__PURE__ */ function() {
      return function(T) {
        function S(R) {
          for (var k = 0, D = T.layers.length; k < D; ) {
            if (T.layers[k].nm === R || T.layers[k].ind === R)
              return T.elements[k].layerInterface;
            k += 1;
          }
          return null;
        }
        return Object.defineProperty(S, "_name", {
          value: T.data.nm
        }), S.layer = S, S.pixelAspect = 1, S.height = T.data.h || T.globalData.compSize.h, S.width = T.data.w || T.globalData.compSize.w, S.pixelAspect = 1, S.frameDuration = 1 / T.globalData.frameRate, S.displayStartTime = 0, S.numLayers = T.layers.length, S;
      };
    }();
    function _typeof$2(T) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$2 = function(R) {
        return typeof R;
      } : _typeof$2 = function(R) {
        return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
      }, _typeof$2(T);
    }
    function seedRandom(T, S) {
      var R = this, k = 256, D = 6, L = 52, V = "random", z = S.pow(k, D), W = S.pow(2, L), U = W * 2, q = k - 1, K;
      function Y(Q, ne, oe) {
        var ae = [];
        ne = ne === !0 ? {
          entropy: !0
        } : ne || {};
        var se = ee(X(ne.entropy ? [Q, re(T)] : Q === null ? te() : Q, 3), ae), ie = new J(ae), he = function() {
          for (var Pe = ie.g(D), Re = z, ke = 0; Pe < W; )
            Pe = (Pe + ke) * k, Re *= k, ke = ie.g(1);
          for (; Pe >= U; )
            Pe /= 2, Re /= 2, ke >>>= 1;
          return (Pe + ke) / Re;
        };
        return he.int32 = function() {
          return ie.g(4) | 0;
        }, he.quick = function() {
          return ie.g(4) / 4294967296;
        }, he.double = he, ee(re(ie.S), T), (ne.pass || oe || function(xe, Pe, Re, ke) {
          return ke && (ke.S && Z(ke, ie), xe.state = function() {
            return Z(ie, {});
          }), Re ? (S[V] = xe, Pe) : xe;
        })(he, se, "global" in ne ? ne.global : this == S, ne.state);
      }
      S["seed" + V] = Y;
      function J(Q) {
        var ne, oe = Q.length, ae = this, se = 0, ie = ae.i = ae.j = 0, he = ae.S = [];
        for (oe || (Q = [oe++]); se < k; )
          he[se] = se++;
        for (se = 0; se < k; se++)
          he[se] = he[ie = q & ie + Q[se % oe] + (ne = he[se])], he[ie] = ne;
        ae.g = function(xe) {
          for (var Pe, Re = 0, ke = ae.i, Te = ae.j, fe = ae.S; xe--; )
            Pe = fe[ke = q & ke + 1], Re = Re * k + fe[q & (fe[ke] = fe[Te = q & Te + Pe]) + (fe[Te] = Pe)];
          return ae.i = ke, ae.j = Te, Re;
        };
      }
      function Z(Q, ne) {
        return ne.i = Q.i, ne.j = Q.j, ne.S = Q.S.slice(), ne;
      }
      function X(Q, ne) {
        var oe = [], ae = _typeof$2(Q), se;
        if (ne && ae == "object")
          for (se in Q)
            try {
              oe.push(X(Q[se], ne - 1));
            } catch {
            }
        return oe.length ? oe : ae == "string" ? Q : Q + "\0";
      }
      function ee(Q, ne) {
        for (var oe = Q + "", ae, se = 0; se < oe.length; )
          ne[q & se] = q & (ae ^= ne[q & se] * 19) + oe.charCodeAt(se++);
        return re(ne);
      }
      function te() {
        try {
          var Q = new Uint8Array(k);
          return (R.crypto || R.msCrypto).getRandomValues(Q), re(Q);
        } catch {
          var ne = R.navigator, oe = ne && ne.plugins;
          return [+/* @__PURE__ */ new Date(), R, oe, R.screen, re(T)];
        }
      }
      function re(Q) {
        return String.fromCharCode.apply(0, Q);
      }
      ee(S.random(), T);
    }
    function initialize$2(T) {
      seedRandom([], T);
    }
    var propTypes = {
      SHAPE: "shape"
    };
    function _typeof$1(T) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof$1 = function(R) {
        return typeof R;
      } : _typeof$1 = function(R) {
        return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
      }, _typeof$1(T);
    }
    var ExpressionManager = function() {
      var ob = {}, Math = BMMath, window = null, document = null, XMLHttpRequest = null, fetch = null, frames = null, _lottieGlobal = {};
      initialize$2(BMMath);
      function resetFrame() {
        _lottieGlobal = {};
      }
      function $bm_isInstanceOfArray(T) {
        return T.constructor === Array || T.constructor === Float32Array;
      }
      function isNumerable(T, S) {
        return T === "number" || S instanceof Number || T === "boolean" || T === "string";
      }
      function $bm_neg(T) {
        var S = _typeof$1(T);
        if (S === "number" || T instanceof Number || S === "boolean")
          return -T;
        if ($bm_isInstanceOfArray(T)) {
          var R, k = T.length, D = [];
          for (R = 0; R < k; R += 1)
            D[R] = -T[R];
          return D;
        }
        return T.propType ? T.v : -T;
      }
      var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, "easeInOut").get;
      function sum(T, S) {
        var R = _typeof$1(T), k = _typeof$1(S);
        if (isNumerable(R, T) && isNumerable(k, S) || R === "string" || k === "string")
          return T + S;
        if ($bm_isInstanceOfArray(T) && isNumerable(k, S))
          return T = T.slice(0), T[0] += S, T;
        if (isNumerable(R, T) && $bm_isInstanceOfArray(S))
          return S = S.slice(0), S[0] = T + S[0], S;
        if ($bm_isInstanceOfArray(T) && $bm_isInstanceOfArray(S)) {
          for (var D = 0, L = T.length, V = S.length, z = []; D < L || D < V; )
            (typeof T[D] == "number" || T[D] instanceof Number) && (typeof S[D] == "number" || S[D] instanceof Number) ? z[D] = T[D] + S[D] : z[D] = S[D] === void 0 ? T[D] : T[D] || S[D], D += 1;
          return z;
        }
        return 0;
      }
      var add = sum;
      function sub(T, S) {
        var R = _typeof$1(T), k = _typeof$1(S);
        if (isNumerable(R, T) && isNumerable(k, S))
          return R === "string" && (T = parseInt(T, 10)), k === "string" && (S = parseInt(S, 10)), T - S;
        if ($bm_isInstanceOfArray(T) && isNumerable(k, S))
          return T = T.slice(0), T[0] -= S, T;
        if (isNumerable(R, T) && $bm_isInstanceOfArray(S))
          return S = S.slice(0), S[0] = T - S[0], S;
        if ($bm_isInstanceOfArray(T) && $bm_isInstanceOfArray(S)) {
          for (var D = 0, L = T.length, V = S.length, z = []; D < L || D < V; )
            (typeof T[D] == "number" || T[D] instanceof Number) && (typeof S[D] == "number" || S[D] instanceof Number) ? z[D] = T[D] - S[D] : z[D] = S[D] === void 0 ? T[D] : T[D] || S[D], D += 1;
          return z;
        }
        return 0;
      }
      function mul(T, S) {
        var R = _typeof$1(T), k = _typeof$1(S), D;
        if (isNumerable(R, T) && isNumerable(k, S))
          return T * S;
        var L, V;
        if ($bm_isInstanceOfArray(T) && isNumerable(k, S)) {
          for (V = T.length, D = createTypedArray("float32", V), L = 0; L < V; L += 1)
            D[L] = T[L] * S;
          return D;
        }
        if (isNumerable(R, T) && $bm_isInstanceOfArray(S)) {
          for (V = S.length, D = createTypedArray("float32", V), L = 0; L < V; L += 1)
            D[L] = T * S[L];
          return D;
        }
        return 0;
      }
      function div(T, S) {
        var R = _typeof$1(T), k = _typeof$1(S), D;
        if (isNumerable(R, T) && isNumerable(k, S))
          return T / S;
        var L, V;
        if ($bm_isInstanceOfArray(T) && isNumerable(k, S)) {
          for (V = T.length, D = createTypedArray("float32", V), L = 0; L < V; L += 1)
            D[L] = T[L] / S;
          return D;
        }
        if (isNumerable(R, T) && $bm_isInstanceOfArray(S)) {
          for (V = S.length, D = createTypedArray("float32", V), L = 0; L < V; L += 1)
            D[L] = T / S[L];
          return D;
        }
        return 0;
      }
      function mod(T, S) {
        return typeof T == "string" && (T = parseInt(T, 10)), typeof S == "string" && (S = parseInt(S, 10)), T % S;
      }
      var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
      function clamp(T, S, R) {
        if (S > R) {
          var k = R;
          R = S, S = k;
        }
        return Math.min(Math.max(T, S), R);
      }
      function radiansToDegrees(T) {
        return T / degToRads;
      }
      var radians_to_degrees = radiansToDegrees;
      function degreesToRadians(T) {
        return T * degToRads;
      }
      var degrees_to_radians = radiansToDegrees, helperLengthArray = [0, 0, 0, 0, 0, 0];
      function length(T, S) {
        if (typeof T == "number" || T instanceof Number)
          return S = S || 0, Math.abs(T - S);
        S || (S = helperLengthArray);
        var R, k = Math.min(T.length, S.length), D = 0;
        for (R = 0; R < k; R += 1)
          D += Math.pow(S[R] - T[R], 2);
        return Math.sqrt(D);
      }
      function normalize(T) {
        return div(T, length(T));
      }
      function rgbToHsl(T) {
        var S = T[0], R = T[1], k = T[2], D = Math.max(S, R, k), L = Math.min(S, R, k), V, z, W = (D + L) / 2;
        if (D === L)
          V = 0, z = 0;
        else {
          var U = D - L;
          switch (z = W > 0.5 ? U / (2 - D - L) : U / (D + L), D) {
            case S:
              V = (R - k) / U + (R < k ? 6 : 0);
              break;
            case R:
              V = (k - S) / U + 2;
              break;
            case k:
              V = (S - R) / U + 4;
              break;
          }
          V /= 6;
        }
        return [V, z, W, T[3]];
      }
      function hue2rgb(T, S, R) {
        return R < 0 && (R += 1), R > 1 && (R -= 1), R < 1 / 6 ? T + (S - T) * 6 * R : R < 1 / 2 ? S : R < 2 / 3 ? T + (S - T) * (2 / 3 - R) * 6 : T;
      }
      function hslToRgb(T) {
        var S = T[0], R = T[1], k = T[2], D, L, V;
        if (R === 0)
          D = k, V = k, L = k;
        else {
          var z = k < 0.5 ? k * (1 + R) : k + R - k * R, W = 2 * k - z;
          D = hue2rgb(W, z, S + 1 / 3), L = hue2rgb(W, z, S), V = hue2rgb(W, z, S - 1 / 3);
        }
        return [D, L, V, T[3]];
      }
      function linear(T, S, R, k, D) {
        if ((k === void 0 || D === void 0) && (k = S, D = R, S = 0, R = 1), R < S) {
          var L = R;
          R = S, S = L;
        }
        if (T <= S)
          return k;
        if (T >= R)
          return D;
        var V = R === S ? 0 : (T - S) / (R - S);
        if (!k.length)
          return k + (D - k) * V;
        var z, W = k.length, U = createTypedArray("float32", W);
        for (z = 0; z < W; z += 1)
          U[z] = k[z] + (D[z] - k[z]) * V;
        return U;
      }
      function random(T, S) {
        if (S === void 0 && (T === void 0 ? (T = 0, S = 1) : (S = T, T = void 0)), S.length) {
          var R, k = S.length;
          T || (T = createTypedArray("float32", k));
          var D = createTypedArray("float32", k), L = BMMath.random();
          for (R = 0; R < k; R += 1)
            D[R] = T[R] + L * (S[R] - T[R]);
          return D;
        }
        T === void 0 && (T = 0);
        var V = BMMath.random();
        return T + V * (S - T);
      }
      function createPath(T, S, R, k) {
        var D, L = T.length, V = shapePool.newElement();
        V.setPathData(!!k, L);
        var z = [0, 0], W, U;
        for (D = 0; D < L; D += 1)
          W = S && S[D] ? S[D] : z, U = R && R[D] ? R[D] : z, V.setTripleAt(T[D][0], T[D][1], U[0] + T[D][0], U[1] + T[D][1], W[0] + T[D][0], W[1] + T[D][1], D, !0);
        return V;
      }
      function initiateExpression(elem, data, property) {
        function noOp(T) {
          return T;
        }
        if (!elem.globalData.renderConfig.runExpressions)
          return noOp;
        var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = val.indexOf("random") !== -1, elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
        thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
          get: function() {
            return thisProperty.v;
          }
        }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
        var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || this.data.hd !== !0, wiggle = function T(S, R) {
          var k, D, L = this.pv.length ? this.pv.length : 1, V = createTypedArray("float32", L);
          S = 5;
          var z = Math.floor(time * S);
          for (k = 0, D = 0; k < z; ) {
            for (D = 0; D < L; D += 1)
              V[D] += -R + R * 2 * BMMath.random();
            k += 1;
          }
          var W = time * S, U = W - Math.floor(W), q = createTypedArray("float32", L);
          if (L > 1) {
            for (D = 0; D < L; D += 1)
              q[D] = this.pv[D] + V[D] + (-R + R * 2 * BMMath.random()) * U;
            return q;
          }
          return this.pv + V[0] + (-R + R * 2 * BMMath.random()) * U;
        }.bind(this);
        thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty));
        function loopInDuration(T, S) {
          return loopIn(T, S, !0);
        }
        function loopOutDuration(T, S) {
          return loopOut(T, S, !0);
        }
        this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
        function lookAt(T, S) {
          var R = [S[0] - T[0], S[1] - T[1], S[2] - T[2]], k = Math.atan2(R[0], Math.sqrt(R[1] * R[1] + R[2] * R[2])) / degToRads, D = -Math.atan2(R[1], R[2]) / degToRads;
          return [D, k, 0];
        }
        function easeOut(T, S, R, k, D) {
          return applyEase(easeOutBez, T, S, R, k, D);
        }
        function easeIn(T, S, R, k, D) {
          return applyEase(easeInBez, T, S, R, k, D);
        }
        function ease(T, S, R, k, D) {
          return applyEase(easeInOutBez, T, S, R, k, D);
        }
        function applyEase(T, S, R, k, D, L) {
          D === void 0 ? (D = R, L = k) : S = (S - R) / (k - R), S > 1 ? S = 1 : S < 0 && (S = 0);
          var V = T(S);
          if ($bm_isInstanceOfArray(D)) {
            var z, W = D.length, U = createTypedArray("float32", W);
            for (z = 0; z < W; z += 1)
              U[z] = (L[z] - D[z]) * V + D[z];
            return U;
          }
          return (L - D) * V + D;
        }
        function nearestKey(T) {
          var S, R = data.k.length, k, D;
          if (!data.k.length || typeof data.k[0] == "number")
            k = 0, D = 0;
          else if (k = -1, T *= elem.comp.globalData.frameRate, T < data.k[0].t)
            k = 1, D = data.k[0].t;
          else {
            for (S = 0; S < R - 1; S += 1)
              if (T === data.k[S].t) {
                k = S + 1, D = data.k[S].t;
                break;
              } else if (T > data.k[S].t && T < data.k[S + 1].t) {
                T - data.k[S].t > data.k[S + 1].t - T ? (k = S + 2, D = data.k[S + 1].t) : (k = S + 1, D = data.k[S].t);
                break;
              }
            k === -1 && (k = S + 1, D = data.k[S].t);
          }
          var L = {};
          return L.index = k, L.time = D / elem.comp.globalData.frameRate, L;
        }
        function key(T) {
          var S, R, k;
          if (!data.k.length || typeof data.k[0] == "number")
            throw new Error("The property has no keyframe at index " + T);
          T -= 1, S = {
            time: data.k[T].t / elem.comp.globalData.frameRate,
            value: []
          };
          var D = Object.prototype.hasOwnProperty.call(data.k[T], "s") ? data.k[T].s : data.k[T - 1].e;
          for (k = D.length, R = 0; R < k; R += 1)
            S[R] = D[R], S.value[R] = D[R];
          return S;
        }
        function framesToTime(T, S) {
          return S || (S = elem.comp.globalData.frameRate), T / S;
        }
        function timeToFrames(T, S) {
          return !T && T !== 0 && (T = time), S || (S = elem.comp.globalData.frameRate), T * S;
        }
        function seedRandom(T) {
          BMMath.seedrandom(randSeed + T);
        }
        function sourceRectAtTime() {
          return elem.sourceRectAtTime();
        }
        function substring(T, S) {
          return typeof value == "string" ? S === void 0 ? value.substring(T) : value.substring(T, S) : "";
        }
        function substr(T, S) {
          return typeof value == "string" ? S === void 0 ? value.substr(T) : value.substr(T, S) : "";
        }
        function posterizeTime(T) {
          time = T === 0 ? 0 : Math.floor(time * T) / T, value = valueAtTime(time);
        }
        var time, velocity, value, text, textIndex, textTotal, selectorValue, index = elem.data.ind, hasParent = !!(elem.hierarchy && elem.hierarchy.length), parent, randSeed = Math.floor(Math.random() * 1e6), globalData = elem.globalData;
        function executeExpression(T) {
          return value = T, this.frameExpressionId === elem.globalData.frameId && this.propType !== "textSelector" ? value : (this.propType === "textSelector" && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), elemType === 4 && !content && (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), hasParent = !!(elem.hierarchy && elem.hierarchy.length), hasParent && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt, scoped_bm_rt);
        }
        return executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData], executeExpression;
      }
      return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal], ob.resetFrame = resetFrame, ob;
    }(), Expressions = function() {
      var T = {};
      T.initExpressions = S, T.resetFrame = ExpressionManager.resetFrame;
      function S(R) {
        var k = 0, D = [];
        function L() {
          k += 1;
        }
        function V() {
          k -= 1, k === 0 && W();
        }
        function z(U) {
          D.indexOf(U) === -1 && D.push(U);
        }
        function W() {
          var U, q = D.length;
          for (U = 0; U < q; U += 1)
            D[U].release();
          D.length = 0;
        }
        R.renderer.compInterface = CompExpressionInterface(R.renderer), R.renderer.globalData.projectInterface.registerComposition(R.renderer), R.renderer.globalData.pushExpression = L, R.renderer.globalData.popExpression = V, R.renderer.globalData.registerExpressionProperty = z;
      }
      return T;
    }(), MaskManagerInterface = function() {
      function T(R, k) {
        this._mask = R, this._data = k;
      }
      Object.defineProperty(T.prototype, "maskPath", {
        get: function() {
          return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
        }
      }), Object.defineProperty(T.prototype, "maskOpacity", {
        get: function() {
          return this._mask.op.k && this._mask.op.getValue(), this._mask.op.v * 100;
        }
      });
      var S = function(k) {
        var D = createSizedArray(k.viewData.length), L, V = k.viewData.length;
        for (L = 0; L < V; L += 1)
          D[L] = new T(k.viewData[L], k.masksProperties[L]);
        var z = function(U) {
          for (L = 0; L < V; ) {
            if (k.masksProperties[L].nm === U)
              return D[L];
            L += 1;
          }
          return null;
        };
        return z;
      };
      return S;
    }(), ExpressionPropertyInterface = /* @__PURE__ */ function() {
      var T = {
        pv: 0,
        v: 0,
        mult: 1
      }, S = {
        pv: [0, 0, 0],
        v: [0, 0, 0],
        mult: 1
      };
      function R(V, z, W) {
        Object.defineProperty(V, "velocity", {
          get: function() {
            return z.getVelocityAtTime(z.comp.currentFrame);
          }
        }), V.numKeys = z.keyframes ? z.keyframes.length : 0, V.key = function(U) {
          if (!V.numKeys)
            return 0;
          var q = "";
          "s" in z.keyframes[U - 1] ? q = z.keyframes[U - 1].s : "e" in z.keyframes[U - 2] ? q = z.keyframes[U - 2].e : q = z.keyframes[U - 2].s;
          var K = W === "unidimensional" ? new Number(q) : Object.assign({}, q);
          return K.time = z.keyframes[U - 1].t / z.elem.comp.globalData.frameRate, K.value = W === "unidimensional" ? q[0] : q, K;
        }, V.valueAtTime = z.getValueAtTime, V.speedAtTime = z.getSpeedAtTime, V.velocityAtTime = z.getVelocityAtTime, V.propertyGroup = z.propertyGroup;
      }
      function k(V) {
        (!V || !("pv" in V)) && (V = T);
        var z = 1 / V.mult, W = V.pv * z, U = new Number(W);
        return U.value = W, R(U, V, "unidimensional"), function() {
          return V.k && V.getValue(), W = V.v * z, U.value !== W && (U = new Number(W), U.value = W, R(U, V, "unidimensional")), U;
        };
      }
      function D(V) {
        (!V || !("pv" in V)) && (V = S);
        var z = 1 / V.mult, W = V.data && V.data.l || V.pv.length, U = createTypedArray("float32", W), q = createTypedArray("float32", W);
        return U.value = q, R(U, V, "multidimensional"), function() {
          V.k && V.getValue();
          for (var K = 0; K < W; K += 1)
            q[K] = V.v[K] * z, U[K] = q[K];
          return U;
        };
      }
      function L() {
        return T;
      }
      return function(V) {
        return V ? V.propType === "unidimensional" ? k(V) : D(V) : L;
      };
    }(), TransformExpressionInterface = /* @__PURE__ */ function() {
      return function(T) {
        function S(V) {
          switch (V) {
            case "scale":
            case "Scale":
            case "ADBE Scale":
            case 6:
              return S.scale;
            case "rotation":
            case "Rotation":
            case "ADBE Rotation":
            case "ADBE Rotate Z":
            case 10:
              return S.rotation;
            case "ADBE Rotate X":
              return S.xRotation;
            case "ADBE Rotate Y":
              return S.yRotation;
            case "position":
            case "Position":
            case "ADBE Position":
            case 2:
              return S.position;
            case "ADBE Position_0":
              return S.xPosition;
            case "ADBE Position_1":
              return S.yPosition;
            case "ADBE Position_2":
              return S.zPosition;
            case "anchorPoint":
            case "AnchorPoint":
            case "Anchor Point":
            case "ADBE AnchorPoint":
            case 1:
              return S.anchorPoint;
            case "opacity":
            case "Opacity":
            case 11:
              return S.opacity;
            default:
              return null;
          }
        }
        Object.defineProperty(S, "rotation", {
          get: ExpressionPropertyInterface(T.r || T.rz)
        }), Object.defineProperty(S, "zRotation", {
          get: ExpressionPropertyInterface(T.rz || T.r)
        }), Object.defineProperty(S, "xRotation", {
          get: ExpressionPropertyInterface(T.rx)
        }), Object.defineProperty(S, "yRotation", {
          get: ExpressionPropertyInterface(T.ry)
        }), Object.defineProperty(S, "scale", {
          get: ExpressionPropertyInterface(T.s)
        });
        var R, k, D, L;
        return T.p ? L = ExpressionPropertyInterface(T.p) : (R = ExpressionPropertyInterface(T.px), k = ExpressionPropertyInterface(T.py), T.pz && (D = ExpressionPropertyInterface(T.pz))), Object.defineProperty(S, "position", {
          get: function() {
            return T.p ? L() : [R(), k(), D ? D() : 0];
          }
        }), Object.defineProperty(S, "xPosition", {
          get: ExpressionPropertyInterface(T.px)
        }), Object.defineProperty(S, "yPosition", {
          get: ExpressionPropertyInterface(T.py)
        }), Object.defineProperty(S, "zPosition", {
          get: ExpressionPropertyInterface(T.pz)
        }), Object.defineProperty(S, "anchorPoint", {
          get: ExpressionPropertyInterface(T.a)
        }), Object.defineProperty(S, "opacity", {
          get: ExpressionPropertyInterface(T.o)
        }), Object.defineProperty(S, "skew", {
          get: ExpressionPropertyInterface(T.sk)
        }), Object.defineProperty(S, "skewAxis", {
          get: ExpressionPropertyInterface(T.sa)
        }), Object.defineProperty(S, "orientation", {
          get: ExpressionPropertyInterface(T.or)
        }), S;
      };
    }(), LayerExpressionInterface = /* @__PURE__ */ function() {
      function T(U) {
        var q = new Matrix();
        if (U !== void 0) {
          var K = this._elem.finalTransform.mProp.getValueAtTime(U);
          K.clone(q);
        } else {
          var Y = this._elem.finalTransform.mProp;
          Y.applyToMatrix(q);
        }
        return q;
      }
      function S(U, q) {
        var K = this.getMatrix(q);
        return K.props[12] = 0, K.props[13] = 0, K.props[14] = 0, this.applyPoint(K, U);
      }
      function R(U, q) {
        var K = this.getMatrix(q);
        return this.applyPoint(K, U);
      }
      function k(U, q) {
        var K = this.getMatrix(q);
        return K.props[12] = 0, K.props[13] = 0, K.props[14] = 0, this.invertPoint(K, U);
      }
      function D(U, q) {
        var K = this.getMatrix(q);
        return this.invertPoint(K, U);
      }
      function L(U, q) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var K, Y = this._elem.hierarchy.length;
          for (K = 0; K < Y; K += 1)
            this._elem.hierarchy[K].finalTransform.mProp.applyToMatrix(U);
        }
        return U.applyToPointArray(q[0], q[1], q[2] || 0);
      }
      function V(U, q) {
        if (this._elem.hierarchy && this._elem.hierarchy.length) {
          var K, Y = this._elem.hierarchy.length;
          for (K = 0; K < Y; K += 1)
            this._elem.hierarchy[K].finalTransform.mProp.applyToMatrix(U);
        }
        return U.inversePoint(q);
      }
      function z(U) {
        var q = new Matrix();
        if (q.reset(), this._elem.finalTransform.mProp.applyToMatrix(q), this._elem.hierarchy && this._elem.hierarchy.length) {
          var K, Y = this._elem.hierarchy.length;
          for (K = 0; K < Y; K += 1)
            this._elem.hierarchy[K].finalTransform.mProp.applyToMatrix(q);
          return q.inversePoint(U);
        }
        return q.inversePoint(U);
      }
      function W() {
        return [1, 1, 1, 1];
      }
      return function(U) {
        var q;
        function K(X) {
          J.mask = new MaskManagerInterface(X, U);
        }
        function Y(X) {
          J.effect = X;
        }
        function J(X) {
          switch (X) {
            case "ADBE Root Vectors Group":
            case "Contents":
            case 2:
              return J.shapeInterface;
            case 1:
            case 6:
            case "Transform":
            case "transform":
            case "ADBE Transform Group":
              return q;
            case 4:
            case "ADBE Effect Parade":
            case "effects":
            case "Effects":
              return J.effect;
            case "ADBE Text Properties":
              return J.textInterface;
            default:
              return null;
          }
        }
        J.getMatrix = T, J.invertPoint = V, J.applyPoint = L, J.toWorld = R, J.toWorldVec = S, J.fromWorld = D, J.fromWorldVec = k, J.toComp = R, J.fromComp = z, J.sampleImage = W, J.sourceRectAtTime = U.sourceRectAtTime.bind(U), J._elem = U, q = TransformExpressionInterface(U.finalTransform.mProp);
        var Z = getDescriptor(q, "anchorPoint");
        return Object.defineProperties(J, {
          hasParent: {
            get: function() {
              return U.hierarchy.length;
            }
          },
          parent: {
            get: function() {
              return U.hierarchy[0].layerInterface;
            }
          },
          rotation: getDescriptor(q, "rotation"),
          scale: getDescriptor(q, "scale"),
          position: getDescriptor(q, "position"),
          opacity: getDescriptor(q, "opacity"),
          anchorPoint: Z,
          anchor_point: Z,
          transform: {
            get: function() {
              return q;
            }
          },
          active: {
            get: function() {
              return U.isInRange;
            }
          }
        }), J.startTime = U.data.st, J.index = U.data.ind, J.source = U.data.refId, J.height = U.data.ty === 0 ? U.data.h : 100, J.width = U.data.ty === 0 ? U.data.w : 100, J.inPoint = U.data.ip / U.comp.globalData.frameRate, J.outPoint = U.data.op / U.comp.globalData.frameRate, J._name = U.data.nm, J.registerMaskInterface = K, J.registerEffectsInterface = Y, J;
      };
    }(), propertyGroupFactory = /* @__PURE__ */ function() {
      return function(T, S) {
        return function(R) {
          return R = R === void 0 ? 1 : R, R <= 0 ? T : S(R - 1);
        };
      };
    }(), PropertyInterface = /* @__PURE__ */ function() {
      return function(T, S) {
        var R = {
          _name: T
        };
        function k(D) {
          return D = D === void 0 ? 1 : D, D <= 0 ? R : S(D - 1);
        }
        return k;
      };
    }(), EffectsExpressionInterface = /* @__PURE__ */ function() {
      var T = {
        createEffectsInterface: S
      };
      function S(D, L) {
        if (D.effectsManager) {
          var V = [], z = D.data.ef, W, U = D.effectsManager.effectElements.length;
          for (W = 0; W < U; W += 1)
            V.push(R(z[W], D.effectsManager.effectElements[W], L, D));
          var q = D.data.ef || [], K = function(J) {
            for (W = 0, U = q.length; W < U; ) {
              if (J === q[W].nm || J === q[W].mn || J === q[W].ix)
                return V[W];
              W += 1;
            }
            return null;
          };
          return Object.defineProperty(K, "numProperties", {
            get: function() {
              return q.length;
            }
          }), K;
        }
        return null;
      }
      function R(D, L, V, z) {
        function W(J) {
          for (var Z = D.ef, X = 0, ee = Z.length; X < ee; ) {
            if (J === Z[X].nm || J === Z[X].mn || J === Z[X].ix)
              return Z[X].ty === 5 ? q[X] : q[X]();
            X += 1;
          }
          throw new Error();
        }
        var U = propertyGroupFactory(W, V), q = [], K, Y = D.ef.length;
        for (K = 0; K < Y; K += 1)
          D.ef[K].ty === 5 ? q.push(R(D.ef[K], L.effectElements[K], L.effectElements[K].propertyGroup, z)) : q.push(k(L.effectElements[K], D.ef[K].ty, z, U));
        return D.mn === "ADBE Color Control" && Object.defineProperty(W, "color", {
          get: function() {
            return q[0]();
          }
        }), Object.defineProperties(W, {
          numProperties: {
            get: function() {
              return D.np;
            }
          },
          _name: {
            value: D.nm
          },
          propertyGroup: {
            value: U
          }
        }), W.enabled = D.en !== 0, W.active = W.enabled, W;
      }
      function k(D, L, V, z) {
        var W = ExpressionPropertyInterface(D.p);
        function U() {
          return L === 10 ? V.comp.compInterface(D.p.v) : W();
        }
        return D.p.setGroupProperty && D.p.setGroupProperty(PropertyInterface("", z)), U;
      }
      return T;
    }(), ShapePathInterface = /* @__PURE__ */ function() {
      return function(S, R, k) {
        var D = R.sh;
        function L(z) {
          return z === "Shape" || z === "shape" || z === "Path" || z === "path" || z === "ADBE Vector Shape" || z === 2 ? L.path : null;
        }
        var V = propertyGroupFactory(L, k);
        return D.setGroupProperty(PropertyInterface("Path", V)), Object.defineProperties(L, {
          path: {
            get: function() {
              return D.k && D.getValue(), D;
            }
          },
          shape: {
            get: function() {
              return D.k && D.getValue(), D;
            }
          },
          _name: {
            value: S.nm
          },
          ix: {
            value: S.ix
          },
          propertyIndex: {
            value: S.ix
          },
          mn: {
            value: S.mn
          },
          propertyGroup: {
            value: k
          }
        }), L;
      };
    }(), ShapeExpressionInterface = /* @__PURE__ */ function() {
      function T(Z, X, ee) {
        var te = [], re, Q = Z ? Z.length : 0;
        for (re = 0; re < Q; re += 1)
          Z[re].ty === "gr" ? te.push(R(Z[re], X[re], ee)) : Z[re].ty === "fl" ? te.push(k(Z[re], X[re], ee)) : Z[re].ty === "st" ? te.push(V(Z[re], X[re], ee)) : Z[re].ty === "tm" ? te.push(z(Z[re], X[re], ee)) : Z[re].ty === "tr" || (Z[re].ty === "el" ? te.push(U(Z[re], X[re], ee)) : Z[re].ty === "sr" ? te.push(q(Z[re], X[re], ee)) : Z[re].ty === "sh" ? te.push(ShapePathInterface(Z[re], X[re], ee)) : Z[re].ty === "rc" ? te.push(K(Z[re], X[re], ee)) : Z[re].ty === "rd" ? te.push(Y(Z[re], X[re], ee)) : Z[re].ty === "rp" ? te.push(J(Z[re], X[re], ee)) : Z[re].ty === "gf" ? te.push(D(Z[re], X[re], ee)) : te.push(L(Z[re], X[re])));
        return te;
      }
      function S(Z, X, ee) {
        var te, re = function(oe) {
          for (var ae = 0, se = te.length; ae < se; ) {
            if (te[ae]._name === oe || te[ae].mn === oe || te[ae].propertyIndex === oe || te[ae].ix === oe || te[ae].ind === oe)
              return te[ae];
            ae += 1;
          }
          return typeof oe == "number" ? te[oe - 1] : null;
        };
        re.propertyGroup = propertyGroupFactory(re, ee), te = T(Z.it, X.it, re.propertyGroup), re.numProperties = te.length;
        var Q = W(Z.it[Z.it.length - 1], X.it[X.it.length - 1], re.propertyGroup);
        return re.transform = Q, re.propertyIndex = Z.cix, re._name = Z.nm, re;
      }
      function R(Z, X, ee) {
        var te = function(oe) {
          switch (oe) {
            case "ADBE Vectors Group":
            case "Contents":
            case 2:
              return te.content;
            default:
              return te.transform;
          }
        };
        te.propertyGroup = propertyGroupFactory(te, ee);
        var re = S(Z, X, te.propertyGroup), Q = W(Z.it[Z.it.length - 1], X.it[X.it.length - 1], te.propertyGroup);
        return te.content = re, te.transform = Q, Object.defineProperty(te, "_name", {
          get: function() {
            return Z.nm;
          }
        }), te.numProperties = Z.np, te.propertyIndex = Z.ix, te.nm = Z.nm, te.mn = Z.mn, te;
      }
      function k(Z, X, ee) {
        function te(re) {
          return re === "Color" || re === "color" ? te.color : re === "Opacity" || re === "opacity" ? te.opacity : null;
        }
        return Object.defineProperties(te, {
          color: {
            get: ExpressionPropertyInterface(X.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(X.o)
          },
          _name: {
            value: Z.nm
          },
          mn: {
            value: Z.mn
          }
        }), X.c.setGroupProperty(PropertyInterface("Color", ee)), X.o.setGroupProperty(PropertyInterface("Opacity", ee)), te;
      }
      function D(Z, X, ee) {
        function te(re) {
          return re === "Start Point" || re === "start point" ? te.startPoint : re === "End Point" || re === "end point" ? te.endPoint : re === "Opacity" || re === "opacity" ? te.opacity : null;
        }
        return Object.defineProperties(te, {
          startPoint: {
            get: ExpressionPropertyInterface(X.s)
          },
          endPoint: {
            get: ExpressionPropertyInterface(X.e)
          },
          opacity: {
            get: ExpressionPropertyInterface(X.o)
          },
          type: {
            get: function() {
              return "a";
            }
          },
          _name: {
            value: Z.nm
          },
          mn: {
            value: Z.mn
          }
        }), X.s.setGroupProperty(PropertyInterface("Start Point", ee)), X.e.setGroupProperty(PropertyInterface("End Point", ee)), X.o.setGroupProperty(PropertyInterface("Opacity", ee)), te;
      }
      function L() {
        function Z() {
          return null;
        }
        return Z;
      }
      function V(Z, X, ee) {
        var te = propertyGroupFactory(se, ee), re = propertyGroupFactory(ae, te);
        function Q(ie) {
          Object.defineProperty(ae, Z.d[ie].nm, {
            get: ExpressionPropertyInterface(X.d.dataProps[ie].p)
          });
        }
        var ne, oe = Z.d ? Z.d.length : 0, ae = {};
        for (ne = 0; ne < oe; ne += 1)
          Q(ne), X.d.dataProps[ne].p.setGroupProperty(re);
        function se(ie) {
          return ie === "Color" || ie === "color" ? se.color : ie === "Opacity" || ie === "opacity" ? se.opacity : ie === "Stroke Width" || ie === "stroke width" ? se.strokeWidth : null;
        }
        return Object.defineProperties(se, {
          color: {
            get: ExpressionPropertyInterface(X.c)
          },
          opacity: {
            get: ExpressionPropertyInterface(X.o)
          },
          strokeWidth: {
            get: ExpressionPropertyInterface(X.w)
          },
          dash: {
            get: function() {
              return ae;
            }
          },
          _name: {
            value: Z.nm
          },
          mn: {
            value: Z.mn
          }
        }), X.c.setGroupProperty(PropertyInterface("Color", te)), X.o.setGroupProperty(PropertyInterface("Opacity", te)), X.w.setGroupProperty(PropertyInterface("Stroke Width", te)), se;
      }
      function z(Z, X, ee) {
        function te(Q) {
          return Q === Z.e.ix || Q === "End" || Q === "end" ? te.end : Q === Z.s.ix ? te.start : Q === Z.o.ix ? te.offset : null;
        }
        var re = propertyGroupFactory(te, ee);
        return te.propertyIndex = Z.ix, X.s.setGroupProperty(PropertyInterface("Start", re)), X.e.setGroupProperty(PropertyInterface("End", re)), X.o.setGroupProperty(PropertyInterface("Offset", re)), te.propertyIndex = Z.ix, te.propertyGroup = ee, Object.defineProperties(te, {
          start: {
            get: ExpressionPropertyInterface(X.s)
          },
          end: {
            get: ExpressionPropertyInterface(X.e)
          },
          offset: {
            get: ExpressionPropertyInterface(X.o)
          },
          _name: {
            value: Z.nm
          }
        }), te.mn = Z.mn, te;
      }
      function W(Z, X, ee) {
        function te(Q) {
          return Z.a.ix === Q || Q === "Anchor Point" ? te.anchorPoint : Z.o.ix === Q || Q === "Opacity" ? te.opacity : Z.p.ix === Q || Q === "Position" ? te.position : Z.r.ix === Q || Q === "Rotation" || Q === "ADBE Vector Rotation" ? te.rotation : Z.s.ix === Q || Q === "Scale" ? te.scale : Z.sk && Z.sk.ix === Q || Q === "Skew" ? te.skew : Z.sa && Z.sa.ix === Q || Q === "Skew Axis" ? te.skewAxis : null;
        }
        var re = propertyGroupFactory(te, ee);
        return X.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", re)), X.transform.mProps.p.setGroupProperty(PropertyInterface("Position", re)), X.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", re)), X.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", re)), X.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", re)), X.transform.mProps.sk && (X.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", re)), X.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", re))), X.transform.op.setGroupProperty(PropertyInterface("Opacity", re)), Object.defineProperties(te, {
          opacity: {
            get: ExpressionPropertyInterface(X.transform.mProps.o)
          },
          position: {
            get: ExpressionPropertyInterface(X.transform.mProps.p)
          },
          anchorPoint: {
            get: ExpressionPropertyInterface(X.transform.mProps.a)
          },
          scale: {
            get: ExpressionPropertyInterface(X.transform.mProps.s)
          },
          rotation: {
            get: ExpressionPropertyInterface(X.transform.mProps.r)
          },
          skew: {
            get: ExpressionPropertyInterface(X.transform.mProps.sk)
          },
          skewAxis: {
            get: ExpressionPropertyInterface(X.transform.mProps.sa)
          },
          _name: {
            value: Z.nm
          }
        }), te.ty = "tr", te.mn = Z.mn, te.propertyGroup = ee, te;
      }
      function U(Z, X, ee) {
        function te(ne) {
          return Z.p.ix === ne ? te.position : Z.s.ix === ne ? te.size : null;
        }
        var re = propertyGroupFactory(te, ee);
        te.propertyIndex = Z.ix;
        var Q = X.sh.ty === "tm" ? X.sh.prop : X.sh;
        return Q.s.setGroupProperty(PropertyInterface("Size", re)), Q.p.setGroupProperty(PropertyInterface("Position", re)), Object.defineProperties(te, {
          size: {
            get: ExpressionPropertyInterface(Q.s)
          },
          position: {
            get: ExpressionPropertyInterface(Q.p)
          },
          _name: {
            value: Z.nm
          }
        }), te.mn = Z.mn, te;
      }
      function q(Z, X, ee) {
        function te(ne) {
          return Z.p.ix === ne ? te.position : Z.r.ix === ne ? te.rotation : Z.pt.ix === ne ? te.points : Z.or.ix === ne || ne === "ADBE Vector Star Outer Radius" ? te.outerRadius : Z.os.ix === ne ? te.outerRoundness : Z.ir && (Z.ir.ix === ne || ne === "ADBE Vector Star Inner Radius") ? te.innerRadius : Z.is && Z.is.ix === ne ? te.innerRoundness : null;
        }
        var re = propertyGroupFactory(te, ee), Q = X.sh.ty === "tm" ? X.sh.prop : X.sh;
        return te.propertyIndex = Z.ix, Q.or.setGroupProperty(PropertyInterface("Outer Radius", re)), Q.os.setGroupProperty(PropertyInterface("Outer Roundness", re)), Q.pt.setGroupProperty(PropertyInterface("Points", re)), Q.p.setGroupProperty(PropertyInterface("Position", re)), Q.r.setGroupProperty(PropertyInterface("Rotation", re)), Z.ir && (Q.ir.setGroupProperty(PropertyInterface("Inner Radius", re)), Q.is.setGroupProperty(PropertyInterface("Inner Roundness", re))), Object.defineProperties(te, {
          position: {
            get: ExpressionPropertyInterface(Q.p)
          },
          rotation: {
            get: ExpressionPropertyInterface(Q.r)
          },
          points: {
            get: ExpressionPropertyInterface(Q.pt)
          },
          outerRadius: {
            get: ExpressionPropertyInterface(Q.or)
          },
          outerRoundness: {
            get: ExpressionPropertyInterface(Q.os)
          },
          innerRadius: {
            get: ExpressionPropertyInterface(Q.ir)
          },
          innerRoundness: {
            get: ExpressionPropertyInterface(Q.is)
          },
          _name: {
            value: Z.nm
          }
        }), te.mn = Z.mn, te;
      }
      function K(Z, X, ee) {
        function te(ne) {
          return Z.p.ix === ne ? te.position : Z.r.ix === ne ? te.roundness : Z.s.ix === ne || ne === "Size" || ne === "ADBE Vector Rect Size" ? te.size : null;
        }
        var re = propertyGroupFactory(te, ee), Q = X.sh.ty === "tm" ? X.sh.prop : X.sh;
        return te.propertyIndex = Z.ix, Q.p.setGroupProperty(PropertyInterface("Position", re)), Q.s.setGroupProperty(PropertyInterface("Size", re)), Q.r.setGroupProperty(PropertyInterface("Rotation", re)), Object.defineProperties(te, {
          position: {
            get: ExpressionPropertyInterface(Q.p)
          },
          roundness: {
            get: ExpressionPropertyInterface(Q.r)
          },
          size: {
            get: ExpressionPropertyInterface(Q.s)
          },
          _name: {
            value: Z.nm
          }
        }), te.mn = Z.mn, te;
      }
      function Y(Z, X, ee) {
        function te(ne) {
          return Z.r.ix === ne || ne === "Round Corners 1" ? te.radius : null;
        }
        var re = propertyGroupFactory(te, ee), Q = X;
        return te.propertyIndex = Z.ix, Q.rd.setGroupProperty(PropertyInterface("Radius", re)), Object.defineProperties(te, {
          radius: {
            get: ExpressionPropertyInterface(Q.rd)
          },
          _name: {
            value: Z.nm
          }
        }), te.mn = Z.mn, te;
      }
      function J(Z, X, ee) {
        function te(ne) {
          return Z.c.ix === ne || ne === "Copies" ? te.copies : Z.o.ix === ne || ne === "Offset" ? te.offset : null;
        }
        var re = propertyGroupFactory(te, ee), Q = X;
        return te.propertyIndex = Z.ix, Q.c.setGroupProperty(PropertyInterface("Copies", re)), Q.o.setGroupProperty(PropertyInterface("Offset", re)), Object.defineProperties(te, {
          copies: {
            get: ExpressionPropertyInterface(Q.c)
          },
          offset: {
            get: ExpressionPropertyInterface(Q.o)
          },
          _name: {
            value: Z.nm
          }
        }), te.mn = Z.mn, te;
      }
      return function(Z, X, ee) {
        var te;
        function re(ne) {
          if (typeof ne == "number")
            return ne = ne === void 0 ? 1 : ne, ne === 0 ? ee : te[ne - 1];
          for (var oe = 0, ae = te.length; oe < ae; ) {
            if (te[oe]._name === ne)
              return te[oe];
            oe += 1;
          }
          return null;
        }
        function Q() {
          return ee;
        }
        return re.propertyGroup = propertyGroupFactory(re, Q), te = T(Z, X, re.propertyGroup), re.numProperties = te.length, re._name = "Contents", re;
      };
    }(), TextExpressionInterface = /* @__PURE__ */ function() {
      return function(T) {
        var S;
        function R(k) {
          switch (k) {
            case "ADBE Text Document":
              return R.sourceText;
            default:
              return null;
          }
        }
        return Object.defineProperty(R, "sourceText", {
          get: function() {
            T.textProperty.getValue();
            var D = T.textProperty.currentData.t;
            return (!S || D !== S.value) && (S = new String(D), S.value = D || new String(D), Object.defineProperty(S, "style", {
              get: function() {
                return {
                  fillColor: T.textProperty.currentData.fc
                };
              }
            })), S;
          }
        }), R;
      };
    }();
    function _typeof(T) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? _typeof = function(R) {
        return typeof R;
      } : _typeof = function(R) {
        return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
      }, _typeof(T);
    }
    var FootageInterface = /* @__PURE__ */ function() {
      var T = function(k) {
        var D = "", L = k.getFootageData();
        function V() {
          return D = "", L = k.getFootageData(), z;
        }
        function z(W) {
          if (L[W])
            return D = W, L = L[W], _typeof(L) === "object" ? z : L;
          var U = W.indexOf(D);
          if (U !== -1) {
            var q = parseInt(W.substr(U + D.length), 10);
            return L = L[q], _typeof(L) === "object" ? z : L;
          }
          return "";
        }
        return V;
      }, S = function(k) {
        function D(L) {
          return L === "Outline" ? D.outlineInterface() : null;
        }
        return D._name = "Outline", D.outlineInterface = T(k), D;
      };
      return function(R) {
        function k(D) {
          return D === "Data" ? k.dataInterface : null;
        }
        return k._name = "Data", k.dataInterface = S(R), k;
      };
    }(), interfaces = {
      layer: LayerExpressionInterface,
      effects: EffectsExpressionInterface,
      comp: CompExpressionInterface,
      shape: ShapeExpressionInterface,
      text: TextExpressionInterface,
      footage: FootageInterface
    };
    function getInterface(T) {
      return interfaces[T] || null;
    }
    var expressionHelpers = /* @__PURE__ */ function() {
      function T(V, z, W) {
        z.x && (W.k = !0, W.x = !0, W.initiateExpression = ExpressionManager.initiateExpression, W.effectsSequence.push(W.initiateExpression(V, z, W).bind(W)));
      }
      function S(V) {
        return V *= this.elem.globalData.frameRate, V -= this.offsetTime, V !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < V ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(V, this._cachingAtTime), this._cachingAtTime.lastFrame = V), this._cachingAtTime.value;
      }
      function R(V) {
        var z = -0.01, W = this.getValueAtTime(V), U = this.getValueAtTime(V + z), q = 0;
        if (W.length) {
          var K;
          for (K = 0; K < W.length; K += 1)
            q += Math.pow(U[K] - W[K], 2);
          q = Math.sqrt(q) * 100;
        } else
          q = 0;
        return q;
      }
      function k(V) {
        if (this.vel !== void 0)
          return this.vel;
        var z = -1e-3, W = this.getValueAtTime(V), U = this.getValueAtTime(V + z), q;
        if (W.length) {
          q = createTypedArray("float32", W.length);
          var K;
          for (K = 0; K < W.length; K += 1)
            q[K] = (U[K] - W[K]) / z;
        } else
          q = (U - W) / z;
        return q;
      }
      function D() {
        return this.pv;
      }
      function L(V) {
        this.propertyGroup = V;
      }
      return {
        searchExpressions: T,
        getSpeedAtTime: R,
        getVelocityAtTime: k,
        getValueAtTime: S,
        getStaticValueAtTime: D,
        setGroupProperty: L
      };
    }();
    function addPropertyDecorator() {
      function T(Y, J, Z) {
        if (!this.k || !this.keyframes)
          return this.pv;
        Y = Y ? Y.toLowerCase() : "";
        var X = this.comp.renderedFrame, ee = this.keyframes, te = ee[ee.length - 1].t;
        if (X <= te)
          return this.pv;
        var re, Q;
        Z ? (J ? re = Math.abs(te - this.elem.comp.globalData.frameRate * J) : re = Math.max(0, te - this.elem.data.ip), Q = te - re) : ((!J || J > ee.length - 1) && (J = ee.length - 1), Q = ee[ee.length - 1 - J].t, re = te - Q);
        var ne, oe, ae;
        if (Y === "pingpong") {
          var se = Math.floor((X - Q) / re);
          if (se % 2 !== 0)
            return this.getValueAtTime((re - (X - Q) % re + Q) / this.comp.globalData.frameRate, 0);
        } else if (Y === "offset") {
          var ie = this.getValueAtTime(Q / this.comp.globalData.frameRate, 0), he = this.getValueAtTime(te / this.comp.globalData.frameRate, 0), xe = this.getValueAtTime(((X - Q) % re + Q) / this.comp.globalData.frameRate, 0), Pe = Math.floor((X - Q) / re);
          if (this.pv.length) {
            for (ae = new Array(ie.length), oe = ae.length, ne = 0; ne < oe; ne += 1)
              ae[ne] = (he[ne] - ie[ne]) * Pe + xe[ne];
            return ae;
          }
          return (he - ie) * Pe + xe;
        } else if (Y === "continue") {
          var Re = this.getValueAtTime(te / this.comp.globalData.frameRate, 0), ke = this.getValueAtTime((te - 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (ae = new Array(Re.length), oe = ae.length, ne = 0; ne < oe; ne += 1)
              ae[ne] = Re[ne] + (Re[ne] - ke[ne]) * ((X - te) / this.comp.globalData.frameRate) / 5e-4;
            return ae;
          }
          return Re + (Re - ke) * ((X - te) / 1e-3);
        }
        return this.getValueAtTime(((X - Q) % re + Q) / this.comp.globalData.frameRate, 0);
      }
      function S(Y, J, Z) {
        if (!this.k)
          return this.pv;
        Y = Y ? Y.toLowerCase() : "";
        var X = this.comp.renderedFrame, ee = this.keyframes, te = ee[0].t;
        if (X >= te)
          return this.pv;
        var re, Q;
        Z ? (J ? re = Math.abs(this.elem.comp.globalData.frameRate * J) : re = Math.max(0, this.elem.data.op - te), Q = te + re) : ((!J || J > ee.length - 1) && (J = ee.length - 1), Q = ee[J].t, re = Q - te);
        var ne, oe, ae;
        if (Y === "pingpong") {
          var se = Math.floor((te - X) / re);
          if (se % 2 === 0)
            return this.getValueAtTime(((te - X) % re + te) / this.comp.globalData.frameRate, 0);
        } else if (Y === "offset") {
          var ie = this.getValueAtTime(te / this.comp.globalData.frameRate, 0), he = this.getValueAtTime(Q / this.comp.globalData.frameRate, 0), xe = this.getValueAtTime((re - (te - X) % re + te) / this.comp.globalData.frameRate, 0), Pe = Math.floor((te - X) / re) + 1;
          if (this.pv.length) {
            for (ae = new Array(ie.length), oe = ae.length, ne = 0; ne < oe; ne += 1)
              ae[ne] = xe[ne] - (he[ne] - ie[ne]) * Pe;
            return ae;
          }
          return xe - (he - ie) * Pe;
        } else if (Y === "continue") {
          var Re = this.getValueAtTime(te / this.comp.globalData.frameRate, 0), ke = this.getValueAtTime((te + 1e-3) / this.comp.globalData.frameRate, 0);
          if (this.pv.length) {
            for (ae = new Array(Re.length), oe = ae.length, ne = 0; ne < oe; ne += 1)
              ae[ne] = Re[ne] + (Re[ne] - ke[ne]) * (te - X) / 1e-3;
            return ae;
          }
          return Re + (Re - ke) * (te - X) / 1e-3;
        }
        return this.getValueAtTime((re - ((te - X) % re + te)) / this.comp.globalData.frameRate, 0);
      }
      function R(Y, J) {
        if (!this.k)
          return this.pv;
        if (Y = (Y || 0.4) * 0.5, J = Math.floor(J || 5), J <= 1)
          return this.pv;
        var Z = this.comp.renderedFrame / this.comp.globalData.frameRate, X = Z - Y, ee = Z + Y, te = J > 1 ? (ee - X) / (J - 1) : 1, re = 0, Q = 0, ne;
        this.pv.length ? ne = createTypedArray("float32", this.pv.length) : ne = 0;
        for (var oe; re < J; ) {
          if (oe = this.getValueAtTime(X + re * te), this.pv.length)
            for (Q = 0; Q < this.pv.length; Q += 1)
              ne[Q] += oe[Q];
          else
            ne += oe;
          re += 1;
        }
        if (this.pv.length)
          for (Q = 0; Q < this.pv.length; Q += 1)
            ne[Q] /= J;
        else
          ne /= J;
        return ne;
      }
      function k(Y) {
        this._transformCachingAtTime || (this._transformCachingAtTime = {
          v: new Matrix()
        });
        var J = this._transformCachingAtTime.v;
        if (J.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
          var Z = this.a.getValueAtTime(Y);
          J.translate(-Z[0] * this.a.mult, -Z[1] * this.a.mult, Z[2] * this.a.mult);
        }
        if (this.appliedTransformations < 2) {
          var X = this.s.getValueAtTime(Y);
          J.scale(X[0] * this.s.mult, X[1] * this.s.mult, X[2] * this.s.mult);
        }
        if (this.sk && this.appliedTransformations < 3) {
          var ee = this.sk.getValueAtTime(Y), te = this.sa.getValueAtTime(Y);
          J.skewFromAxis(-ee * this.sk.mult, te * this.sa.mult);
        }
        if (this.r && this.appliedTransformations < 4) {
          var re = this.r.getValueAtTime(Y);
          J.rotate(-re * this.r.mult);
        } else if (!this.r && this.appliedTransformations < 4) {
          var Q = this.rz.getValueAtTime(Y), ne = this.ry.getValueAtTime(Y), oe = this.rx.getValueAtTime(Y), ae = this.or.getValueAtTime(Y);
          J.rotateZ(-Q * this.rz.mult).rotateY(ne * this.ry.mult).rotateX(oe * this.rx.mult).rotateZ(-ae[2] * this.or.mult).rotateY(ae[1] * this.or.mult).rotateX(ae[0] * this.or.mult);
        }
        if (this.data.p && this.data.p.s) {
          var se = this.px.getValueAtTime(Y), ie = this.py.getValueAtTime(Y);
          if (this.data.p.z) {
            var he = this.pz.getValueAtTime(Y);
            J.translate(se * this.px.mult, ie * this.py.mult, -he * this.pz.mult);
          } else
            J.translate(se * this.px.mult, ie * this.py.mult, 0);
        } else {
          var xe = this.p.getValueAtTime(Y);
          J.translate(xe[0] * this.p.mult, xe[1] * this.p.mult, -xe[2] * this.p.mult);
        }
        return J;
      }
      function D() {
        return this.v.clone(new Matrix());
      }
      var L = TransformPropertyFactory.getTransformProperty;
      TransformPropertyFactory.getTransformProperty = function(Y, J, Z) {
        var X = L(Y, J, Z);
        return X.dynamicProperties.length ? X.getValueAtTime = k.bind(X) : X.getValueAtTime = D.bind(X), X.setGroupProperty = expressionHelpers.setGroupProperty, X;
      };
      var V = PropertyFactory.getProp;
      PropertyFactory.getProp = function(Y, J, Z, X, ee) {
        var te = V(Y, J, Z, X, ee);
        te.kf ? te.getValueAtTime = expressionHelpers.getValueAtTime.bind(te) : te.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(te), te.setGroupProperty = expressionHelpers.setGroupProperty, te.loopOut = T, te.loopIn = S, te.smooth = R, te.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(te), te.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(te), te.numKeys = J.a === 1 ? J.k.length : 0, te.propertyIndex = J.ix;
        var re = 0;
        return Z !== 0 && (re = createTypedArray("float32", J.a === 1 ? J.k[0].s.length : J.k.length)), te._cachingAtTime = {
          lastFrame: initialDefaultFrame,
          lastIndex: 0,
          value: re
        }, expressionHelpers.searchExpressions(Y, J, te), te.k && ee.addDynamicProperty(te), te;
      };
      function z(Y) {
        return this._cachingAtTime || (this._cachingAtTime = {
          shapeValue: shapePool.clone(this.pv),
          lastIndex: 0,
          lastTime: initialDefaultFrame
        }), Y *= this.elem.globalData.frameRate, Y -= this.offsetTime, Y !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < Y ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = Y, this.interpolateShape(Y, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
      }
      var W = ShapePropertyFactory.getConstructorFunction(), U = ShapePropertyFactory.getKeyframedConstructorFunction();
      function q() {
      }
      q.prototype = {
        vertices: function(J, Z) {
          this.k && this.getValue();
          var X = this.v;
          Z !== void 0 && (X = this.getValueAtTime(Z, 0));
          var ee, te = X._length, re = X[J], Q = X.v, ne = createSizedArray(te);
          for (ee = 0; ee < te; ee += 1)
            J === "i" || J === "o" ? ne[ee] = [re[ee][0] - Q[ee][0], re[ee][1] - Q[ee][1]] : ne[ee] = [re[ee][0], re[ee][1]];
          return ne;
        },
        points: function(J) {
          return this.vertices("v", J);
        },
        inTangents: function(J) {
          return this.vertices("i", J);
        },
        outTangents: function(J) {
          return this.vertices("o", J);
        },
        isClosed: function() {
          return this.v.c;
        },
        pointOnPath: function(J, Z) {
          var X = this.v;
          Z !== void 0 && (X = this.getValueAtTime(Z, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(X));
          for (var ee = this._segmentsLength, te = ee.lengths, re = ee.totalLength * J, Q = 0, ne = te.length, oe = 0, ae; Q < ne; ) {
            if (oe + te[Q].addedLength > re) {
              var se = Q, ie = X.c && Q === ne - 1 ? 0 : Q + 1, he = (re - oe) / te[Q].addedLength;
              ae = bez.getPointInSegment(X.v[se], X.v[ie], X.o[se], X.i[ie], he, te[Q]);
              break;
            } else
              oe += te[Q].addedLength;
            Q += 1;
          }
          return ae || (ae = X.c ? [X.v[0][0], X.v[0][1]] : [X.v[X._length - 1][0], X.v[X._length - 1][1]]), ae;
        },
        vectorOnPath: function(J, Z, X) {
          J == 1 ? J = this.v.c : J == 0 && (J = 0.999);
          var ee = this.pointOnPath(J, Z), te = this.pointOnPath(J + 1e-3, Z), re = te[0] - ee[0], Q = te[1] - ee[1], ne = Math.sqrt(Math.pow(re, 2) + Math.pow(Q, 2));
          if (ne === 0)
            return [0, 0];
          var oe = X === "tangent" ? [re / ne, Q / ne] : [-Q / ne, re / ne];
          return oe;
        },
        tangentOnPath: function(J, Z) {
          return this.vectorOnPath(J, Z, "tangent");
        },
        normalOnPath: function(J, Z) {
          return this.vectorOnPath(J, Z, "normal");
        },
        setGroupProperty: expressionHelpers.setGroupProperty,
        getValueAtTime: expressionHelpers.getStaticValueAtTime
      }, extendPrototype([q], W), extendPrototype([q], U), U.prototype.getValueAtTime = z, U.prototype.initiateExpression = ExpressionManager.initiateExpression;
      var K = ShapePropertyFactory.getShapeProp;
      ShapePropertyFactory.getShapeProp = function(Y, J, Z, X, ee) {
        var te = K(Y, J, Z, X, ee);
        return te.propertyIndex = J.ix, te.lock = !1, Z === 3 ? expressionHelpers.searchExpressions(Y, J.pt, te) : Z === 4 && expressionHelpers.searchExpressions(Y, J.ks, te), te.k && Y.addDynamicProperty(te), te;
      };
    }
    function initialize$1() {
      addPropertyDecorator();
    }
    function addDecorator() {
      function T() {
        return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
      }
      TextProperty.prototype.getExpressionValue = function(S, R) {
        var k = this.calculateExpression(R);
        if (S.t !== k) {
          var D = {};
          return this.copyData(D, S), D.t = k.toString(), D.__complete = !1, D;
        }
        return S;
      }, TextProperty.prototype.searchProperty = function() {
        var S = this.searchKeyframes(), R = this.searchExpressions();
        return this.kf = S || R, this.kf;
      }, TextProperty.prototype.searchExpressions = T;
    }
    function initialize() {
      addDecorator();
    }
    function SVGComposableEffect() {
    }
    SVGComposableEffect.prototype = {
      createMergeNode: function T(S, R) {
        var k = createNS("feMerge");
        k.setAttribute("result", S);
        var D, L;
        for (L = 0; L < R.length; L += 1)
          D = createNS("feMergeNode"), D.setAttribute("in", R[L]), k.appendChild(D), k.appendChild(D);
        return k;
      }
    };
    var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
    function SVGTintFilter(T, S, R, k, D) {
      this.filterManager = S;
      var L = createNS("feColorMatrix");
      L.setAttribute("type", "matrix"), L.setAttribute("color-interpolation-filters", "linearRGB"), L.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = L, L.setAttribute("result", k + "_tint_1"), T.appendChild(L), L = createNS("feColorMatrix"), L.setAttribute("type", "matrix"), L.setAttribute("color-interpolation-filters", "sRGB"), L.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), L.setAttribute("result", k + "_tint_2"), T.appendChild(L), this.matrixFilter = L;
      var V = this.createMergeNode(k, [D, k + "_tint_1", k + "_tint_2"]);
      T.appendChild(V);
    }
    extendPrototype([SVGComposableEffect], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(T) {
      if (T || this.filterManager._mdf) {
        var S = this.filterManager.effectElements[0].p.v, R = this.filterManager.effectElements[1].p.v, k = this.filterManager.effectElements[2].p.v / 100;
        this.linearFilter.setAttribute("values", linearFilterValue + " " + k + " 0"), this.matrixFilter.setAttribute("values", R[0] - S[0] + " 0 0 0 " + S[0] + " " + (R[1] - S[1]) + " 0 0 0 " + S[1] + " " + (R[2] - S[2]) + " 0 0 0 " + S[2] + " 0 0 0 1 0");
      }
    };
    function SVGFillFilter(T, S, R, k) {
      this.filterManager = S;
      var D = createNS("feColorMatrix");
      D.setAttribute("type", "matrix"), D.setAttribute("color-interpolation-filters", "sRGB"), D.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), D.setAttribute("result", k), T.appendChild(D), this.matrixFilter = D;
    }
    SVGFillFilter.prototype.renderFrame = function(T) {
      if (T || this.filterManager._mdf) {
        var S = this.filterManager.effectElements[2].p.v, R = this.filterManager.effectElements[6].p.v;
        this.matrixFilter.setAttribute("values", "0 0 0 0 " + S[0] + " 0 0 0 0 " + S[1] + " 0 0 0 0 " + S[2] + " 0 0 0 " + R + " 0");
      }
    };
    function SVGStrokeEffect(T, S, R) {
      this.initialized = !1, this.filterManager = S, this.elem = R, this.paths = [];
    }
    SVGStrokeEffect.prototype.initialize = function() {
      var T = this.elem.layerElement.children || this.elem.layerElement.childNodes, S, R, k, D;
      for (this.filterManager.effectElements[1].p.v === 1 ? (D = this.elem.maskManager.masksProperties.length, k = 0) : (k = this.filterManager.effectElements[0].p.v - 1, D = k + 1), R = createNS("g"), R.setAttribute("fill", "none"), R.setAttribute("stroke-linecap", "round"), R.setAttribute("stroke-dashoffset", 1), k; k < D; k += 1)
        S = createNS("path"), R.appendChild(S), this.paths.push({
          p: S,
          m: k
        });
      if (this.filterManager.effectElements[10].p.v === 3) {
        var L = createNS("mask"), V = createElementID();
        L.setAttribute("id", V), L.setAttribute("mask-type", "alpha"), L.appendChild(R), this.elem.globalData.defs.appendChild(L);
        var z = createNS("g");
        for (z.setAttribute("mask", "url(" + getLocationHref() + "#" + V + ")"); T[0]; )
          z.appendChild(T[0]);
        this.elem.layerElement.appendChild(z), this.masker = L, R.setAttribute("stroke", "#fff");
      } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
        if (this.filterManager.effectElements[10].p.v === 2)
          for (T = this.elem.layerElement.children || this.elem.layerElement.childNodes; T.length; )
            this.elem.layerElement.removeChild(T[0]);
        this.elem.layerElement.appendChild(R), this.elem.layerElement.removeAttribute("mask"), R.setAttribute("stroke", "#fff");
      }
      this.initialized = !0, this.pathMasker = R;
    }, SVGStrokeEffect.prototype.renderFrame = function(T) {
      this.initialized || this.initialize();
      var S, R = this.paths.length, k, D;
      for (S = 0; S < R; S += 1)
        if (this.paths[S].m !== -1 && (k = this.elem.maskManager.viewData[this.paths[S].m], D = this.paths[S].p, (T || this.filterManager._mdf || k.prop._mdf) && D.setAttribute("d", k.lastPath), T || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || k.prop._mdf)) {
          var L;
          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var V = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, z = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01, W = D.getTotalLength();
            L = "0 0 0 " + W * V + " ";
            var U = W * (z - V), q = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01, K = Math.floor(U / q), Y;
            for (Y = 0; Y < K; Y += 1)
              L += "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + " ";
            L += "0 " + W * 10 + " 0 0";
          } else
            L = "1 " + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          D.setAttribute("stroke-dasharray", L);
        }
      if ((T || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", this.filterManager.effectElements[4].p.v * 2), (T || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) && (T || this.filterManager.effectElements[3].p._mdf)) {
        var J = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(J[0] * 255) + "," + bmFloor(J[1] * 255) + "," + bmFloor(J[2] * 255) + ")");
      }
    };
    function SVGTritoneFilter(T, S, R, k) {
      this.filterManager = S;
      var D = createNS("feColorMatrix");
      D.setAttribute("type", "matrix"), D.setAttribute("color-interpolation-filters", "linearRGB"), D.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), T.appendChild(D);
      var L = createNS("feComponentTransfer");
      L.setAttribute("color-interpolation-filters", "sRGB"), L.setAttribute("result", k), this.matrixFilter = L;
      var V = createNS("feFuncR");
      V.setAttribute("type", "table"), L.appendChild(V), this.feFuncR = V;
      var z = createNS("feFuncG");
      z.setAttribute("type", "table"), L.appendChild(z), this.feFuncG = z;
      var W = createNS("feFuncB");
      W.setAttribute("type", "table"), L.appendChild(W), this.feFuncB = W, T.appendChild(L);
    }
    SVGTritoneFilter.prototype.renderFrame = function(T) {
      if (T || this.filterManager._mdf) {
        var S = this.filterManager.effectElements[0].p.v, R = this.filterManager.effectElements[1].p.v, k = this.filterManager.effectElements[2].p.v, D = k[0] + " " + R[0] + " " + S[0], L = k[1] + " " + R[1] + " " + S[1], V = k[2] + " " + R[2] + " " + S[2];
        this.feFuncR.setAttribute("tableValues", D), this.feFuncG.setAttribute("tableValues", L), this.feFuncB.setAttribute("tableValues", V);
      }
    };
    function SVGProLevelsFilter(T, S, R, k) {
      this.filterManager = S;
      var D = this.filterManager.effectElements, L = createNS("feComponentTransfer");
      (D[10].p.k || D[10].p.v !== 0 || D[11].p.k || D[11].p.v !== 1 || D[12].p.k || D[12].p.v !== 1 || D[13].p.k || D[13].p.v !== 0 || D[14].p.k || D[14].p.v !== 1) && (this.feFuncR = this.createFeFunc("feFuncR", L)), (D[17].p.k || D[17].p.v !== 0 || D[18].p.k || D[18].p.v !== 1 || D[19].p.k || D[19].p.v !== 1 || D[20].p.k || D[20].p.v !== 0 || D[21].p.k || D[21].p.v !== 1) && (this.feFuncG = this.createFeFunc("feFuncG", L)), (D[24].p.k || D[24].p.v !== 0 || D[25].p.k || D[25].p.v !== 1 || D[26].p.k || D[26].p.v !== 1 || D[27].p.k || D[27].p.v !== 0 || D[28].p.k || D[28].p.v !== 1) && (this.feFuncB = this.createFeFunc("feFuncB", L)), (D[31].p.k || D[31].p.v !== 0 || D[32].p.k || D[32].p.v !== 1 || D[33].p.k || D[33].p.v !== 1 || D[34].p.k || D[34].p.v !== 0 || D[35].p.k || D[35].p.v !== 1) && (this.feFuncA = this.createFeFunc("feFuncA", L)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (L.setAttribute("color-interpolation-filters", "sRGB"), T.appendChild(L)), (D[3].p.k || D[3].p.v !== 0 || D[4].p.k || D[4].p.v !== 1 || D[5].p.k || D[5].p.v !== 1 || D[6].p.k || D[6].p.v !== 0 || D[7].p.k || D[7].p.v !== 1) && (L = createNS("feComponentTransfer"), L.setAttribute("color-interpolation-filters", "sRGB"), L.setAttribute("result", k), T.appendChild(L), this.feFuncRComposed = this.createFeFunc("feFuncR", L), this.feFuncGComposed = this.createFeFunc("feFuncG", L), this.feFuncBComposed = this.createFeFunc("feFuncB", L));
    }
    SVGProLevelsFilter.prototype.createFeFunc = function(T, S) {
      var R = createNS(T);
      return R.setAttribute("type", "table"), S.appendChild(R), R;
    }, SVGProLevelsFilter.prototype.getTableValue = function(T, S, R, k, D) {
      for (var L = 0, V = 256, z, W = Math.min(T, S), U = Math.max(T, S), q = Array.call(null, {
        length: V
      }), K, Y = 0, J = D - k, Z = S - T; L <= 256; )
        z = L / 256, z <= W ? K = Z < 0 ? D : k : z >= U ? K = Z < 0 ? k : D : K = k + J * Math.pow((z - T) / Z, 1 / R), q[Y] = K, Y += 1, L += 256 / (V - 1);
      return q.join(" ");
    }, SVGProLevelsFilter.prototype.renderFrame = function(T) {
      if (T || this.filterManager._mdf) {
        var S, R = this.filterManager.effectElements;
        this.feFuncRComposed && (T || R[3].p._mdf || R[4].p._mdf || R[5].p._mdf || R[6].p._mdf || R[7].p._mdf) && (S = this.getTableValue(R[3].p.v, R[4].p.v, R[5].p.v, R[6].p.v, R[7].p.v), this.feFuncRComposed.setAttribute("tableValues", S), this.feFuncGComposed.setAttribute("tableValues", S), this.feFuncBComposed.setAttribute("tableValues", S)), this.feFuncR && (T || R[10].p._mdf || R[11].p._mdf || R[12].p._mdf || R[13].p._mdf || R[14].p._mdf) && (S = this.getTableValue(R[10].p.v, R[11].p.v, R[12].p.v, R[13].p.v, R[14].p.v), this.feFuncR.setAttribute("tableValues", S)), this.feFuncG && (T || R[17].p._mdf || R[18].p._mdf || R[19].p._mdf || R[20].p._mdf || R[21].p._mdf) && (S = this.getTableValue(R[17].p.v, R[18].p.v, R[19].p.v, R[20].p.v, R[21].p.v), this.feFuncG.setAttribute("tableValues", S)), this.feFuncB && (T || R[24].p._mdf || R[25].p._mdf || R[26].p._mdf || R[27].p._mdf || R[28].p._mdf) && (S = this.getTableValue(R[24].p.v, R[25].p.v, R[26].p.v, R[27].p.v, R[28].p.v), this.feFuncB.setAttribute("tableValues", S)), this.feFuncA && (T || R[31].p._mdf || R[32].p._mdf || R[33].p._mdf || R[34].p._mdf || R[35].p._mdf) && (S = this.getTableValue(R[31].p.v, R[32].p.v, R[33].p.v, R[34].p.v, R[35].p.v), this.feFuncA.setAttribute("tableValues", S));
      }
    };
    function SVGDropShadowEffect(T, S, R, k, D) {
      var L = S.container.globalData.renderConfig.filterSize, V = S.data.fs || L;
      T.setAttribute("x", V.x || L.x), T.setAttribute("y", V.y || L.y), T.setAttribute("width", V.width || L.width), T.setAttribute("height", V.height || L.height), this.filterManager = S;
      var z = createNS("feGaussianBlur");
      z.setAttribute("in", "SourceAlpha"), z.setAttribute("result", k + "_drop_shadow_1"), z.setAttribute("stdDeviation", "0"), this.feGaussianBlur = z, T.appendChild(z);
      var W = createNS("feOffset");
      W.setAttribute("dx", "25"), W.setAttribute("dy", "0"), W.setAttribute("in", k + "_drop_shadow_1"), W.setAttribute("result", k + "_drop_shadow_2"), this.feOffset = W, T.appendChild(W);
      var U = createNS("feFlood");
      U.setAttribute("flood-color", "#00ff00"), U.setAttribute("flood-opacity", "1"), U.setAttribute("result", k + "_drop_shadow_3"), this.feFlood = U, T.appendChild(U);
      var q = createNS("feComposite");
      q.setAttribute("in", k + "_drop_shadow_3"), q.setAttribute("in2", k + "_drop_shadow_2"), q.setAttribute("operator", "in"), q.setAttribute("result", k + "_drop_shadow_4"), T.appendChild(q);
      var K = this.createMergeNode(k, [k + "_drop_shadow_4", D]);
      T.appendChild(K);
    }
    extendPrototype([SVGComposableEffect], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(T) {
      if (T || this.filterManager._mdf) {
        if ((T || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), T || this.filterManager.effectElements[0].p._mdf) {
          var S = this.filterManager.effectElements[0].p.v;
          this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(S[0] * 255), Math.round(S[1] * 255), Math.round(S[2] * 255)));
        }
        if ((T || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), T || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
          var R = this.filterManager.effectElements[3].p.v, k = (this.filterManager.effectElements[2].p.v - 90) * degToRads, D = R * Math.cos(k), L = R * Math.sin(k);
          this.feOffset.setAttribute("dx", D), this.feOffset.setAttribute("dy", L);
        }
      }
    };
    var _svgMatteSymbols = [];
    function SVGMatte3Effect(T, S, R) {
      this.initialized = !1, this.filterManager = S, this.filterElem = T, this.elem = R, R.matteElement = createNS("g"), R.matteElement.appendChild(R.layerElement), R.matteElement.appendChild(R.transformedElement), R.baseElement = R.matteElement;
    }
    SVGMatte3Effect.prototype.findSymbol = function(T) {
      for (var S = 0, R = _svgMatteSymbols.length; S < R; ) {
        if (_svgMatteSymbols[S] === T)
          return _svgMatteSymbols[S];
        S += 1;
      }
      return null;
    }, SVGMatte3Effect.prototype.replaceInParent = function(T, S) {
      var R = T.layerElement.parentNode;
      if (R) {
        for (var k = R.children, D = 0, L = k.length; D < L && k[D] !== T.layerElement; )
          D += 1;
        var V;
        D <= L - 2 && (V = k[D + 1]);
        var z = createNS("use");
        z.setAttribute("href", "#" + S), V ? R.insertBefore(z, V) : R.appendChild(z);
      }
    }, SVGMatte3Effect.prototype.setElementAsMask = function(T, S) {
      if (!this.findSymbol(S)) {
        var R = createElementID(), k = createNS("mask");
        k.setAttribute("id", S.layerId), k.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(S);
        var D = T.globalData.defs;
        D.appendChild(k);
        var L = createNS("symbol");
        L.setAttribute("id", R), this.replaceInParent(S, R), L.appendChild(S.layerElement), D.appendChild(L);
        var V = createNS("use");
        V.setAttribute("href", "#" + R), k.appendChild(V), S.data.hd = !1, S.show();
      }
      T.setMatte(S.layerId);
    }, SVGMatte3Effect.prototype.initialize = function() {
      for (var T = this.filterManager.effectElements[0].p.v, S = this.elem.comp.elements, R = 0, k = S.length; R < k; )
        S[R] && S[R].data.ind === T && this.setElementAsMask(this.elem, S[R]), R += 1;
      this.initialized = !0;
    }, SVGMatte3Effect.prototype.renderFrame = function() {
      this.initialized || this.initialize();
    };
    function SVGGaussianBlurEffect(T, S, R, k) {
      T.setAttribute("x", "-100%"), T.setAttribute("y", "-100%"), T.setAttribute("width", "300%"), T.setAttribute("height", "300%"), this.filterManager = S;
      var D = createNS("feGaussianBlur");
      D.setAttribute("result", k), T.appendChild(D), this.feGaussianBlur = D;
    }
    SVGGaussianBlurEffect.prototype.renderFrame = function(T) {
      if (T || this.filterManager._mdf) {
        var S = 0.3, R = this.filterManager.effectElements[0].p.v * S, k = this.filterManager.effectElements[1].p.v, D = k == 3 ? 0 : R, L = k == 2 ? 0 : R;
        this.feGaussianBlur.setAttribute("stdDeviation", D + " " + L);
        var V = this.filterManager.effectElements[2].p.v == 1 ? "wrap" : "duplicate";
        this.feGaussianBlur.setAttribute("edgeMode", V);
      }
    };
    function TransformEffect() {
    }
    TransformEffect.prototype.init = function(T) {
      this.effectsManager = T, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix(), this.opacity = -1, this._mdf = !1, this._opMdf = !1;
    }, TransformEffect.prototype.renderFrame = function(T) {
      if (this._opMdf = !1, this._mdf = !1, T || this.effectsManager._mdf) {
        var S = this.effectsManager.effectElements, R = S[0].p.v, k = S[1].p.v, D = S[2].p.v === 1, L = S[3].p.v, V = D ? L : S[4].p.v, z = S[5].p.v, W = S[6].p.v, U = S[7].p.v;
        this.matrix.reset(), this.matrix.translate(-R[0], -R[1], R[2]), this.matrix.scale(V * 0.01, L * 0.01, 1), this.matrix.rotate(-U * degToRads), this.matrix.skewFromAxis(-z * degToRads, (W + 90) * degToRads), this.matrix.translate(k[0], k[1], 0), this._mdf = !0, this.opacity !== S[8].p.v && (this.opacity = S[8].p.v, this._opMdf = !0);
      }
    };
    function SVGTransformEffect(T, S) {
      this.init(S);
    }
    extendPrototype([TransformEffect], SVGTransformEffect);
    function CVTransformEffect(T) {
      this.init(T);
    }
    return extendPrototype([TransformEffect], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
  });
})(lottie$1, lottie$1.exports);
var lottieExports = lottie$1.exports;
const lottie = /* @__PURE__ */ getDefaultExportFromCjs(lottieExports);
function _iterableToArrayLimit(T, S) {
  var R = T == null ? null : typeof Symbol < "u" && T[Symbol.iterator] || T["@@iterator"];
  if (R != null) {
    var k, D, L, V, z = [], W = !0, U = !1;
    try {
      if (L = (R = R.call(T)).next, S !== 0) for (; !(W = (k = L.call(R)).done) && (z.push(k.value), z.length !== S); W = !0) ;
    } catch (q) {
      U = !0, D = q;
    } finally {
      try {
        if (!W && R.return != null && (V = R.return(), Object(V) !== V)) return;
      } finally {
        if (U) throw D;
      }
    }
    return z;
  }
}
function ownKeys(T, S) {
  var R = Object.keys(T);
  if (Object.getOwnPropertySymbols) {
    var k = Object.getOwnPropertySymbols(T);
    S && (k = k.filter(function(D) {
      return Object.getOwnPropertyDescriptor(T, D).enumerable;
    })), R.push.apply(R, k);
  }
  return R;
}
function _objectSpread2(T) {
  for (var S = 1; S < arguments.length; S++) {
    var R = arguments[S] != null ? arguments[S] : {};
    S % 2 ? ownKeys(Object(R), !0).forEach(function(k) {
      _defineProperty(T, k, R[k]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(T, Object.getOwnPropertyDescriptors(R)) : ownKeys(Object(R)).forEach(function(k) {
      Object.defineProperty(T, k, Object.getOwnPropertyDescriptor(R, k));
    });
  }
  return T;
}
function _defineProperty(T, S, R) {
  return S = _toPropertyKey(S), S in T ? Object.defineProperty(T, S, {
    value: R,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : T[S] = R, T;
}
function _objectWithoutPropertiesLoose(T, S) {
  if (T == null) return {};
  var R = {}, k = Object.keys(T), D, L;
  for (L = 0; L < k.length; L++)
    D = k[L], !(S.indexOf(D) >= 0) && (R[D] = T[D]);
  return R;
}
function _objectWithoutProperties(T, S) {
  if (T == null) return {};
  var R = _objectWithoutPropertiesLoose(T, S), k, D;
  if (Object.getOwnPropertySymbols) {
    var L = Object.getOwnPropertySymbols(T);
    for (D = 0; D < L.length; D++)
      k = L[D], !(S.indexOf(k) >= 0) && Object.prototype.propertyIsEnumerable.call(T, k) && (R[k] = T[k]);
  }
  return R;
}
function _slicedToArray(T, S) {
  return _arrayWithHoles(T) || _iterableToArrayLimit(T, S) || _unsupportedIterableToArray(T, S) || _nonIterableRest();
}
function _arrayWithHoles(T) {
  if (Array.isArray(T)) return T;
}
function _unsupportedIterableToArray(T, S) {
  if (T) {
    if (typeof T == "string") return _arrayLikeToArray(T, S);
    var R = Object.prototype.toString.call(T).slice(8, -1);
    if (R === "Object" && T.constructor && (R = T.constructor.name), R === "Map" || R === "Set") return Array.from(T);
    if (R === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(R)) return _arrayLikeToArray(T, S);
  }
}
function _arrayLikeToArray(T, S) {
  (S == null || S > T.length) && (S = T.length);
  for (var R = 0, k = new Array(S); R < S; R++) k[R] = T[R];
  return k;
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toPrimitive(T, S) {
  if (typeof T != "object" || T === null) return T;
  var R = T[Symbol.toPrimitive];
  if (R !== void 0) {
    var k = R.call(T, S || "default");
    if (typeof k != "object") return k;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (S === "string" ? String : Number)(T);
}
function _toPropertyKey(T) {
  var S = _toPrimitive(T, "string");
  return typeof S == "symbol" ? S : String(S);
}
var _excluded$1 = ["animationData", "loop", "autoplay", "initialSegment", "onComplete", "onLoopComplete", "onEnterFrame", "onSegmentStart", "onConfigReady", "onDataReady", "onDataFailed", "onLoadedImages", "onDOMLoaded", "onDestroy", "lottieRef", "renderer", "name", "assetsPath", "rendererSettings"], useLottie = function T(S, R) {
  var k = S.animationData, D = S.loop, L = S.autoplay, V = S.initialSegment, z = S.onComplete, W = S.onLoopComplete, U = S.onEnterFrame, q = S.onSegmentStart, K = S.onConfigReady, Y = S.onDataReady, J = S.onDataFailed, Z = S.onLoadedImages, X = S.onDOMLoaded, ee = S.onDestroy;
  S.lottieRef, S.renderer, S.name, S.assetsPath, S.rendererSettings;
  var te = _objectWithoutProperties(S, _excluded$1), re = useState$1(!1), Q = _slicedToArray(re, 2), ne = Q[0], oe = Q[1], ae = useRef(), se = useRef(null), ie = function() {
    var Ae;
    (Ae = ae.current) === null || Ae === void 0 || Ae.play();
  }, he = function() {
    var Ae;
    (Ae = ae.current) === null || Ae === void 0 || Ae.stop();
  }, xe = function() {
    var Ae;
    (Ae = ae.current) === null || Ae === void 0 || Ae.pause();
  }, Pe = function(Ae) {
    var Ee;
    (Ee = ae.current) === null || Ee === void 0 || Ee.setSpeed(Ae);
  }, Re = function(Ae, Ee) {
    var ve;
    (ve = ae.current) === null || ve === void 0 || ve.goToAndPlay(Ae, Ee);
  }, ke = function(Ae, Ee) {
    var ve;
    (ve = ae.current) === null || ve === void 0 || ve.goToAndStop(Ae, Ee);
  }, Te = function(Ae) {
    var Ee;
    (Ee = ae.current) === null || Ee === void 0 || Ee.setDirection(Ae);
  }, fe = function(Ae, Ee) {
    var ve;
    (ve = ae.current) === null || ve === void 0 || ve.playSegments(Ae, Ee);
  }, ue = function(Ae) {
    var Ee;
    (Ee = ae.current) === null || Ee === void 0 || Ee.setSubframe(Ae);
  }, Ce = function(Ae) {
    var Ee;
    return (Ee = ae.current) === null || Ee === void 0 ? void 0 : Ee.getDuration(Ae);
  }, ce = function() {
    var Ae;
    (Ae = ae.current) === null || Ae === void 0 || Ae.destroy(), ae.current = void 0;
  }, pe = function() {
    var Ae = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, Ee;
    if (se.current) {
      (Ee = ae.current) === null || Ee === void 0 || Ee.destroy();
      var ve = _objectSpread2(_objectSpread2(_objectSpread2({}, S), Ae), {}, {
        container: se.current
      });
      return ae.current = lottie.loadAnimation(ve), oe(!!ae.current), function() {
        var le;
        (le = ae.current) === null || le === void 0 || le.destroy(), ae.current = void 0;
      };
    }
  };
  useEffect$1(function() {
    var ge = pe();
    return function() {
      return ge?.();
    };
  }, [k, D]), useEffect$1(function() {
    ae.current && (ae.current.autoplay = !!L);
  }, [L]), useEffect$1(function() {
    if (ae.current) {
      if (!V) {
        ae.current.resetSegments(!0);
        return;
      }
      !Array.isArray(V) || !V.length || ((ae.current.currentRawFrame < V[0] || ae.current.currentRawFrame > V[1]) && (ae.current.currentRawFrame = V[0]), ae.current.setSegment(V[0], V[1]));
    }
  }, [V]), useEffect$1(function() {
    var ge = [{
      name: "complete",
      handler: z
    }, {
      name: "loopComplete",
      handler: W
    }, {
      name: "enterFrame",
      handler: U
    }, {
      name: "segmentStart",
      handler: q
    }, {
      name: "config_ready",
      handler: K
    }, {
      name: "data_ready",
      handler: Y
    }, {
      name: "data_failed",
      handler: J
    }, {
      name: "loaded_images",
      handler: Z
    }, {
      name: "DOMLoaded",
      handler: X
    }, {
      name: "destroy",
      handler: ee
    }], Ae = ge.filter(function(ve) {
      return ve.handler != null;
    });
    if (Ae.length) {
      var Ee = Ae.map(
        /**
         * Handle the process of adding an event listener
         * @param {Listener} listener
         * @return {Function} Function that deregister the listener
         */
        function(ve) {
          var le;
          return (le = ae.current) === null || le === void 0 || le.addEventListener(ve.name, ve.handler), function() {
            var me;
            (me = ae.current) === null || me === void 0 || me.removeEventListener(ve.name, ve.handler);
          };
        }
      );
      return function() {
        Ee.forEach(function(ve) {
          return ve();
        });
      };
    }
  }, [z, W, U, q, K, Y, J, Z, X, ee]);
  var _e = /* @__PURE__ */ React__default.createElement("div", _objectSpread2({
    style: R,
    ref: se
  }, te));
  return {
    View: _e,
    play: ie,
    stop: he,
    pause: xe,
    setSpeed: Pe,
    goToAndStop: ke,
    goToAndPlay: Re,
    setDirection: Te,
    playSegments: fe,
    setSubframe: ue,
    getDuration: Ce,
    destroy: ce,
    animationContainerRef: se,
    animationLoaded: ne,
    animationItem: ae.current
  };
};
function getContainerVisibility(T) {
  var S = T.getBoundingClientRect(), R = S.top, k = S.height, D = window.innerHeight - R, L = window.innerHeight + k;
  return D / L;
}
function getContainerCursorPosition(T, S, R) {
  var k = T.getBoundingClientRect(), D = k.top, L = k.left, V = k.width, z = k.height, W = (S - L) / V, U = (R - D) / z;
  return {
    x: W,
    y: U
  };
}
var useInitInteractivity = function T(S) {
  var R = S.wrapperRef, k = S.animationItem, D = S.mode, L = S.actions;
  useEffect$1(function() {
    var V = R.current;
    if (!(!V || !k || !L.length)) {
      k.stop();
      var z = function() {
        var q = null, K = function() {
          var J = getContainerVisibility(V), Z = L.find(function(ee) {
            var te = ee.visibility;
            return te && J >= te[0] && J <= te[1];
          });
          if (Z) {
            if (Z.type === "seek" && Z.visibility && Z.frames.length === 2) {
              var X = Z.frames[0] + Math.ceil((J - Z.visibility[0]) / (Z.visibility[1] - Z.visibility[0]) * Z.frames[1]);
              //! goToAndStop must be relative to the start of the current segment
              k.goToAndStop(X - k.firstFrame - 1, !0);
            }
            Z.type === "loop" && (q === null || q !== Z.frames || k.isPaused) && (k.playSegments(Z.frames, !0), q = Z.frames), Z.type === "play" && k.isPaused && (k.resetSegments(!0), k.play()), Z.type === "stop" && k.goToAndStop(Z.frames[0] - k.firstFrame - 1, !0);
          }
        };
        return document.addEventListener("scroll", K), function() {
          document.removeEventListener("scroll", K);
        };
      }, W = function() {
        var q = function(Z, X) {
          var ee = Z, te = X;
          if (ee !== -1 && te !== -1) {
            var re = getContainerCursorPosition(V, ee, te);
            ee = re.x, te = re.y;
          }
          var Q = L.find(function(ae) {
            var se = ae.position;
            return se && Array.isArray(se.x) && Array.isArray(se.y) ? ee >= se.x[0] && ee <= se.x[1] && te >= se.y[0] && te <= se.y[1] : se && !Number.isNaN(se.x) && !Number.isNaN(se.y) ? ee === se.x && te === se.y : !1;
          });
          if (Q) {
            if (Q.type === "seek" && Q.position && Array.isArray(Q.position.x) && Array.isArray(Q.position.y) && Q.frames.length === 2) {
              var ne = (ee - Q.position.x[0]) / (Q.position.x[1] - Q.position.x[0]), oe = (te - Q.position.y[0]) / (Q.position.y[1] - Q.position.y[0]);
              k.playSegments(Q.frames, !0), k.goToAndStop(Math.ceil((ne + oe) / 2 * (Q.frames[1] - Q.frames[0])), !0);
            }
            Q.type === "loop" && k.playSegments(Q.frames, !0), Q.type === "play" && (k.isPaused && k.resetSegments(!1), k.playSegments(Q.frames)), Q.type === "stop" && k.goToAndStop(Q.frames[0], !0);
          }
        }, K = function(Z) {
          q(Z.clientX, Z.clientY);
        }, Y = function() {
          q(-1, -1);
        };
        return V.addEventListener("mousemove", K), V.addEventListener("mouseout", Y), function() {
          V.removeEventListener("mousemove", K), V.removeEventListener("mouseout", Y);
        };
      };
      switch (D) {
        case "scroll":
          return z();
        case "cursor":
          return W();
      }
    }
  }, [D, k]);
}, useLottieInteractivity = function T(S) {
  var R = S.actions, k = S.mode, D = S.lottieObj, L = D.animationItem, V = D.View, z = D.animationContainerRef;
  return useInitInteractivity({
    actions: R,
    animationItem: L,
    mode: k,
    wrapperRef: z
  }), V;
}, _excluded = ["style", "interactivity"], Lottie$1 = function T(S) {
  var R, k, D, L = S.style, V = S.interactivity, z = _objectWithoutProperties(S, _excluded), W = useLottie(z, L), U = W.View, q = W.play, K = W.stop, Y = W.pause, J = W.setSpeed, Z = W.goToAndStop, X = W.goToAndPlay, ee = W.setDirection, te = W.playSegments, re = W.setSubframe, Q = W.getDuration, ne = W.destroy, oe = W.animationContainerRef, ae = W.animationLoaded, se = W.animationItem;
  return useEffect$1(function() {
    S.lottieRef && (S.lottieRef.current = {
      play: q,
      stop: K,
      pause: Y,
      setSpeed: J,
      goToAndPlay: X,
      goToAndStop: Z,
      setDirection: ee,
      playSegments: te,
      setSubframe: re,
      getDuration: Q,
      destroy: ne,
      animationContainerRef: oe,
      animationLoaded: ae,
      animationItem: se
    });
  }, [(R = S.lottieRef) === null || R === void 0 ? void 0 : R.current]), useLottieInteractivity({
    lottieObj: {
      View: U,
      play: q,
      stop: K,
      pause: Y,
      setSpeed: J,
      goToAndStop: Z,
      goToAndPlay: X,
      setDirection: ee,
      playSegments: te,
      setSubframe: re,
      getDuration: Q,
      destroy: ne,
      animationContainerRef: oe,
      animationLoaded: ae,
      animationItem: se
    },
    actions: (k = V?.actions) !== null && k !== void 0 ? k : [],
    mode: (D = V?.mode) !== null && D !== void 0 ? D : "scroll"
  });
};
const Lottie = Packages.emotion.styled(Lottie$1)(() => ({
  height: "150px"
})), AppTrayLoader = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Lottie, { animationData: animation, loop: !0 });
AppTrayLoader.propTypes = {
  className: Packages.PropTypes.string,
  props: Packages.PropTypes.object
};
const caLogoOrange = "data:image/svg+xml,%3csvg%20width='71'%20height='45'%20viewBox='0%200%2071%2045'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M38.8407%200V14.461L57.3207%2035.4381H38.8407V44.4171H65.2296L70.0574%2035.4381L38.8407%200Z'%20fill='%23FF4F02'/%3e%3cpath%20d='M32.1592%2035.4381H13.6853L32.1592%2014.461V0L29.1321%203.4374L0.942505%2035.4381L5.77637%2044.4171H32.1592V35.4381Z'%20fill='%23FF4F02'/%3e%3c/svg%3e", Typography = Packages.emotion.styled(Packages.Mui.Typography)(() => ({
  color: Packages.Mui.useTheme().colors.neutral[100],
  fontSize: "clamp(1.375rem, 1.195rem + 0.671vw, 2rem)",
  fontWeight: 600,
  lineHeight: "36px",
  margin: 0
})), Stack$2 = Packages.emotion.styled(Packages.Mui.Stack)(() => ({
  alignItems: "center",
  padding: "0.5rem 0rem 2rem 0rem"
})), AppTrayHeader = ({
  isLoading: T,
  appTrayHasApps: S
}) => {
  const {
    Box: R
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack$2, { gap: 3, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(R, { component: "img", src: caLogoOrange, width: "52", alt: "Command Alkon Logo" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, { variant: "h1", children: !T && (S ? "Choose an app to begin" : "You currently do not have access to any Command Alkon software products") })
  ] });
};
AppTrayHeader.propTypes = {
  isLoading: Packages.PropTypes.bool,
  appTrayHasApps: Packages.PropTypes.bool
};
const Stack$1 = Packages.emotion.styled(Packages.Mui.Stack)(() => ({
  alignItems: "center",
  paddingBottom: "1.13rem"
})), AppTraySearchField = ({
  token: T
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Stack$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(GlassTextField$1, { variant: "search", token: T }) });
AppTraySearchField.propTypes = {
  token: Packages.PropTypes.string
};
const dark$2 = (T) => ({
  MuiStack: {
    styleOverrides: {
      root: {
        display: "inline-grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gridGap: "1.25rem",
        justifyItems: "center",
        padding: "0 0.0625rem 6.875rem 0.5rem",
        overflowY: "scroll",
        transition: "all 0.5s ease",
        scrollbarWidth: "thin",
        scrollbarColor: "transparent transparent",
        "&:hover": {
          scrollbarColor: `${T.colors.darkBlue[40]} transparent`,
          "&::-webkit-scrollbar": {
            opacity: 1,
            width: "0.3125rem"
          }
        },
        "&::-webkit-scrollbar": {
          opacity: 0,
          width: "0.3125rem"
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: T.colors.darkBlue[40],
          borderRadius: "0.5rem"
        },
        ...mediaQueries.xs(T),
        ...mediaQueries.sm(T),
        ...mediaQueries.md(T),
        ...mediaQueries.lg(T),
        ...mediaQueries.xl(T)
      }
    }
  }
}), light$2 = (T) => ({
  MuiStack: {
    styleOverrides: {
      root: {
        display: "inline-grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gridGap: "1.25rem",
        justifyItems: "center",
        padding: "0 0.0625rem 6.875rem 0.5rem",
        overflowY: "scroll",
        transition: "all 0.5s ease",
        scrollbarWidth: "thin",
        scrollbarColor: "transparent transparent",
        "&:hover": {
          scrollbarColor: `${T.colors.darkBlue[40]} transparent`,
          "&::-webkit-scrollbar": {
            opacity: 1,
            width: "0.3125rem"
          }
        },
        "&::-webkit-scrollbar": {
          opacity: 0,
          width: "0.3125rem"
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: T.colors.darkBlue[40],
          borderRadius: "0.5rem"
        },
        ...mediaQueries.xs(T),
        ...mediaQueries.sm(T),
        ...mediaQueries.md(T),
        ...mediaQueries.lg(T),
        ...mediaQueries.xl(T)
      }
    }
  }
}), between = () => ({}), lg$1 = () => ({}), md$1 = (T) => ({
  [T.breakpoints.up("md")]: {
    gridTemplateColumns: "repeat(4, 1fr)"
  }
}), sm$1 = (T) => ({
  [T.breakpoints.up("sm")]: {
    maxHeight: "50vh"
  },
  [T.breakpoints.down("sm")]: {
    maxHeight: "72vh"
  }
}), xl$1 = () => ({}), xs$1 = (T) => ({
  [T.breakpoints.down("xs")]: {
    gap: "0.625rem",
    paddingLeft: "0.375rem"
  }
}), mediaQueries = {
  xl: xl$1,
  lg: lg$1,
  md: md$1,
  sm: sm$1,
  xs: xs$1,
  between
}, AppTrayGridThemeConfig = {
  dark: dark$2,
  light: light$2
}, BaseAppTrayGrid = ({
  apps: T = [],
  handleAppChange: S = () => {
  }
}) => {
  const {
    Stack: R
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(R, { children: T?.map?.((k, D) => /* @__PURE__ */ jsxRuntimeExports.jsx(LicenseTile, { variant: k.appRef, name: k.name, onClick: S(k.appRef), icon: k.icon, tilecolor: k.tilecolor }, k.appRef + k.name + D)) });
};
BaseAppTrayGrid.propTypes = {
  apps: Packages.PropTypes.array,
  handleAppChange: Packages.PropTypes.func
};
const AppTrayGrid = withThemeOverrides(BaseAppTrayGrid, AppTrayGridThemeConfig), AppTray = ({
  open: T = !0,
  showSearchField: S = !1,
  apps: R = [],
  isLoading: k,
  handleAppChange: D = () => {
  }
}) => {
  const {
    Box: L
  } = Packages.Mui;
  return T && /* @__PURE__ */ jsxRuntimeExports.jsxs(Layer, { variant: "login-flow", gap: 3, autowidth: !0, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(AppTrayHeader, { isLoading: k, appTrayHasApps: R.length > 0 }),
    S && /* @__PURE__ */ jsxRuntimeExports.jsx(AppTraySearchField, { token: "login_license_input_search" }),
    k ? /* @__PURE__ */ jsxRuntimeExports.jsx(AppTrayLoader, {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: R.length ? /* @__PURE__ */ jsxRuntimeExports.jsx(AppTrayGrid, { apps: R, handleAppChange: D }) : /* @__PURE__ */ jsxRuntimeExports.jsx(L, { component: "p", children: "Please contact your site administrator if you believe there has been an error." }) })
  ] });
};
AppTray.propTypes = {
  open: Packages.PropTypes.bool,
  showSearchField: Packages.PropTypes.bool,
  apps: Packages.PropTypes.array,
  isLoading: Packages.PropTypes.bool,
  handleAppChange: Packages.PropTypes.func
};
const Label = Packages.emotion.styled(Packages.Mui.Box)(() => {
  const T = Packages.Mui.useTheme();
  return `
    display: flex;
    align-items: center;
    gap: 6px;
    color: ${T.validateMode({
    light: T.colors.neutral[40],
    dark: T.colors.neutral[95]
  })};
    font-family: ${T.typography.fontFamily};
    font-size: 16px;
    font-weight: ${T.typography.fontWeightMedium};
    margin-bottom: 6px;
  `;
}), Circle = Packages.emotion.styled(Packages.Mui.Box)((T) => {
  const S = Packages.Mui.useTheme();
  return `
    width: 27px;
    height: 27px;
    border-radius: 50%;
    background-color: ${T.color};
    &.light-color-border{
      border: 1px solid ${S.colors.neutral[0]};
    }
  `;
});
Packages.emotion.styled(Packages.Mui.Box)(() => {
  const T = Packages.Mui.useTheme();
  return `
    border-left: 1px solid ${T.validateMode({
    light: T.colors.neutral[93],
    dark: T.colors.neutral[50]
  })};
    height: 100%;
  `;
});
Packages.emotion.styled(Packages.Mui.Box)(() => {
  const T = Packages.Mui.useTheme();
  return `
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    width: 140px;
    color: ${T.validateMode({
    light: T.colors.neutral[40],
    dark: T.colors.neutral[90]
  })};
    font-size: 20px;
    text-transform: uppercase;
  `;
});
const Wrapper = Packages.emotion.styled(Packages.Mui.Box)(() => `
    .sectioned-layout-content {
      padding-top: 0;
      padding-right: 0;
      padding-left: 0;

      max-width: 100%;
      overflow-x: hidden;
    }
  `), Stack = Packages.emotion.styled(Packages.Mui.Stack)(() => `
    height: 100%;
    min-height: 480px;
    gap: 22px;
  `), SaturationContainer = Packages.emotion.styled(Packages.Mui.Box)(() => `
    float: left;
    width: 100%;
    height: 434px;
    position: relative;
    overflow: hidden;
  `), InnerContainer = Packages.emotion.styled(Packages.Mui.Box)(() => `
    display: flex;
    flex-direction: column;
    gap: 22px;
    padding: 0 32px;
  `), HueContainer = Packages.emotion.styled(Packages.Mui.Box)(() => `
    float: left;
    width: 100%;
    height: 44px;
    position: relative;
    align-self: center;

    overflow: hidden;
    border-radius: 22px;

    .hue-horizontal {
      border-radius: 22px;
    }
  `), SwatchContainer = Packages.emotion.styled(Packages.Mui.Box)(() => `
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-self: center;
    gap: 9px;
  `), MenuSwatchContainer = Packages.emotion.styled(Packages.Mui.Box)(() => `
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-self: center;
    gap: 9px;
  `), EditableInputContainer = Packages.emotion.styled(Packages.Mui.Box)(() => `
    float: left;
    position: relative;
    margin: 14px 0 0 22px;

    display: flex;
    align-items: center;
  `), ColorCircleBox = Packages.emotion.styled(Packages.Mui.Box)(({
  color: T
}) => `
    width: 18px;
    height: 18px;
    border-radius: 9px;
    background-color: ${T};
    left: 26px;
    position: relative;
    margin-top: 12px;
  `), EditableInputStyles = () => {
  const T = Packages.Mui.useTheme();
  return {
    width: "70px",
    height: "40px",
    marginTop: "12px",
    fontSize: "15px",
    color: `${T.validateMode({
      light: T.colors.neutral[40],
      dark: T.colors.neutral[95]
    })}`,
    padding: "0 8px 0 32px",
    outline: "none",
    background: "none",
    border: `1px solid ${T.validateMode({
      light: T.colors.neutral[93],
      dark: T.colors.neutral[95]
    })}`,
    borderRadius: "4px",
    boxSizing: "content-box"
  };
}, EditableInputLabelStyles = () => {
  const T = Packages.Mui.useTheme();
  return {
    fontFamily: T.typography.fontFamily,
    position: "absolute",
    left: "10px",
    fontSize: "12px",
    color: `${T.validateMode({
      light: T.colors.neutral[40],
      dark: T.colors.neutral[95]
    })}`,
    fontWeight: "600",
    top: "3px",
    background: `${T.validateMode({
      light: T.colors.neutral[100],
      dark: T.background(5)
    })}`,
    padding: "0 4px",
    textTransform: "uppercase"
  };
}, Box = Packages.emotion.styled(Packages.Mui.Box)(() => {
  const T = Packages.Mui.useTheme();
  return `
    width: 44px;
    height: 44px;
    border-radius: 22px;
    background: ${T.colors.rgba.white[10]};
    border: 6px solid ${T.validateMode({
    light: T.colors.neutral[100],
    dark: T.colors.purple[90]
  })};
    box-shadow: 0px 2px 4px ${T.colors.rgba.black[10]};
    box-sizing: border-box;
    filter: drop-shadow(0px 2px 2px ${T.colors.rgba.black[10]});

    &.saturation {
      transform: translate(-22px, -22px);
    }

    &.hue {
      transform: translateX(-22px);
    }
  `;
}), SwatchStyles = (T) => {
  const S = Packages.Mui.useTheme();
  return {
    borderRadius: "50%",
    background: "transparent",
    width: "40px",
    height: "40px",
    boxShadow: `inset 0 0 0 ${40 / 2 + 1}px ${T}`,
    transition: "100ms box-shadow ease",
    border: `4px solid ${S.validateMode({
      light: S.colors.neutral[100],
      dark: S.colors.rgba.purple[10]
    })}`,
    filter: `drop-shadow(0px 4px 4px ${S.colors.rgba.black[10]})`,
    boxSizing: "content-box",
    opacity: 0.6
  };
}, SwatchFocusStyle = () => {
  const T = Packages.Mui.useTheme();
  return {
    opacity: 1,
    border: `4px solid ${T.validateMode({
      light: T.colors.darkBlue[10],
      dark: T.colors.blue[90]
    })}`
  };
}, BaseWrapper = Packages.emotion.styled(Packages.Mui.Box)(() => `
    display: flex;
    flex-direction: column;
    width: 100%
  `), isColorLight = (T) => {
  const S = T.replace("#", ""), R = parseInt(S.substring(0, 2), 16), k = parseInt(S.substring(2, 4), 16), D = parseInt(S.substring(4, 6), 16);
  return 0.299 * R + 0.587 * k + 0.114 * D > 186;
}, ButtonColorPicker = ({
  onClick: T,
  color: S,
  tokenButtonLabel: R,
  tokenTooltipLabel: k,
  disabled: D,
  open: L
}) => {
  const {
    FormattedMessage: V
  } = LocalizationProvider(), {
    InputAdornment: z
  } = Packages.Mui, W = isColorLight(S);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    R && /* @__PURE__ */ jsxRuntimeExports.jsxs(Label, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(V, { id: R, defaultMessage: "color_picker" }),
      k && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { token: k, render: () => /* @__PURE__ */ jsxRuntimeExports.jsx(z, { position: "end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "info-outlined" }) }), placement: "right" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ContentActionButton, { ...L && {
      className: "active"
    }, disabled: D, content: {
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Circle, { ...W && {
        className: "light-color-border"
      }, color: S }),
      text: S.toUpperCase()
    }, actionIcons: [{
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "edit-outlined" }),
      onClick: T
    }] })
  ] });
};
ButtonColorPicker.propTypes = {
  onClick: Packages.PropTypes.func,
  color: Packages.PropTypes.string,
  tokenButtonLabel: Packages.PropTypes.string,
  tokenTooltipLabel: Packages.PropTypes.string,
  disabled: Packages.PropTypes.bool,
  open: Packages.PropTypes.bool
};
const SWATCH_COLORS = ["#EA7979", "#E5AA89", "#E9D846", "#87CB31", "#259712", "#14DE89", "#20CD8F", "#44BDE3", "#0A95B4", "#6B88AB", "#9D6D9E", "#8D007F", "#BC0000"], CustomColorPickerContainer = (T) => {
  const {
    Stack: S
  } = Packages.Mui, {
    EditableInput: R,
    Hue: k,
    Saturation: D
  } = Packages["react-color"].components, L = (z) => {
    T.setColor(z);
  }, V = () => {
    T.setHexColor(T.hex), T.handleClose();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Wrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(GridForm.Container, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridForm.Content, { customClassName: "sectioned-layout-content", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(SaturationContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(D, { ...T, onChange: L, pointer: CustomSaturationPointer }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(InnerContainer, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(HueContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(k, { ...T, onChange: L, pointer: CustomHuePointer }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(SwatchContainer, { children: SWATCH_COLORS.map((z) => /* @__PURE__ */ createElement$1(CustomSwatch, { ...T, color: z, handleChange: L, key: z })) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(EditableInputContainer, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ColorCircleBox, { color: T.hex }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(R, { ...T, value: T.hex, onChange: L, label: "hex", style: {
          input: EditableInputStyles(),
          label: EditableInputLabelStyles()
        } })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(GridForm.Footer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(S, { display: "flex", flexDirection: "row", justifyContent: "flex-end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { variant: "primary", token: "general.cai_material.actions.done", onClick: V }) }) })
  ] }) });
}, CustomColorPicker = Packages["react-color"].CustomPicker(CustomColorPickerContainer);
CustomColorPickerContainer.propTypes = {
  handleClose: Packages.PropTypes.func.isRequired,
  setColor: Packages.PropTypes.func.isRequired,
  hex: Packages.PropTypes.string.isRequired,
  setHexColor: Packages.PropTypes.func.isRequired
};
const CustomSwatch = (T) => {
  const {
    Swatch: S
  } = Packages["react-color"].components;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(S, { ...T, style: SwatchStyles(T.color), focusStyle: SwatchFocusStyle(), onClick: T.handleChange });
};
CustomSwatch.propTypes = {
  handleChange: Packages.PropTypes.func.isRequired,
  color: Packages.PropTypes.string.isRequired
};
const CustomSaturationPointer = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { className: "saturation" }), CustomHuePointer = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { className: "hue" }), dark$1 = (T) => ({
  MuiMenu: {
    styleOverrides: {
      paper: {
        marginTop: "10px",
        padding: "20px",
        borderRadius: "20px",
        boxShadow: T.shadow[3],
        maxWidth: "252px",
        width: "fit-content",
        background: T.background[5]
      }
    }
  }
}), light$1 = (T) => ({
  MuiMenu: {
    styleOverrides: {
      paper: {
        marginTop: "10px",
        padding: "20px",
        borderRadius: "20px",
        boxShadow: T.shadow[3],
        maxWidth: "252px",
        width: "fit-content",
        background: T.colors.neutral[100]
      }
    }
  }
}), ColorPickerThemeConfig = {
  dark: dark$1,
  light: light$1
}, ColorPicker$1 = ({
  children: T,
  handleOpen: S,
  hexColor: R,
  tokenButtonLabel: k,
  tokenTooltipLabel: D,
  disabled: L,
  open: V
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(BaseWrapper, { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonColorPicker, { onClick: S, color: R, tokenButtonLabel: k, tokenTooltipLabel: D, disabled: L, open: V }),
  T
] });
ColorPicker$1.propTypes = {
  children: Packages.PropTypes.node.isRequired,
  hexColor: Packages.PropTypes.string.isRequired,
  tokenButtonLabel: Packages.PropTypes.string,
  tokenTooltipLabel: Packages.PropTypes.string,
  disabled: Packages.PropTypes.bool,
  open: Packages.PropTypes.bool,
  rest: Packages.PropTypes.object,
  handleOpen: Packages.PropTypes.func
};
const BaseColorPicker = withThemeOverrides(ColorPicker$1, ColorPickerThemeConfig), MenuColorPicker = ({
  hexColor: T,
  setHexColor: S,
  tokenButtonLabel: R,
  tokenTooltipLabel: k,
  disabled: D,
  ...L
}) => {
  const {
    Menu: V
  } = Packages.Mui, [z, W] = useState$1(null), U = !!z, q = (J) => {
    W(J.currentTarget);
  }, K = () => {
    W(null);
  }, Y = (J) => {
    S(J), K();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseColorPicker, { handleOpen: q, hexColor: T, tokenButtonLabel: R, tokenTooltipLabel: k, disabled: D, open: U, children: /* @__PURE__ */ jsxRuntimeExports.jsx(V, { anchorEl: z, open: U, onClose: K, ...L, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuSwatchContainer, { children: SWATCH_COLORS.map((J) => /* @__PURE__ */ jsxRuntimeExports.jsx(CustomSwatch, { color: J, handleChange: Y }, J)) }) }) });
};
MenuColorPicker.propTypes = {
  hexColor: Packages.PropTypes.string.isRequired,
  setHexColor: Packages.PropTypes.func.isRequired,
  tokenButtonLabel: Packages.PropTypes.string,
  tokenTooltipLabel: Packages.PropTypes.string,
  disabled: Packages.PropTypes.bool,
  rest: Packages.PropTypes.object
};
Packages.emotion.styled(Packages.Mui.Box)`
  & > * {
    flex: 1;
  }
`;
Packages.PropTypes.string.isRequired;
const ModalColorPicker = ({
  hexColor: T,
  setHexColor: S,
  tokenTitleModal: R,
  tokenButtonLabel: k,
  tokenTooltipLabel: D,
  disabled: L
}) => {
  const [V, z] = useState$1(T), [W, U] = useState$1(!1), q = () => U(!0), K = () => U(!1);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseColorPicker, { handleOpen: q, hexColor: T, tokenButtonLabel: k, tokenTooltipLabel: D, disabled: L, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { open: W, headerIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "color-lens-outlined", sx: {
    width: "38px",
    height: "38px"
  } }), token: R, onCloseCallbackFn: K, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CustomColorPicker, { color: V, setColor: z, setHexColor: S, handleClose: K }) }) });
};
ModalColorPicker.propTypes = {
  hexColor: Packages.PropTypes.string.isRequired,
  setHexColor: Packages.PropTypes.func.isRequired,
  tokenTitleModal: Packages.PropTypes.string,
  tokenButtonLabel: Packages.PropTypes.string,
  tokenTooltipLabel: Packages.PropTypes.string,
  disabled: Packages.PropTypes.bool
};
const ColorPicker = ({
  variant: T,
  ...S
}) => {
  switch (T) {
    case "menu":
      return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuColorPicker, { ...S });
    default:
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalColorPicker, { ...S });
  }
};
ColorPicker.propTypes = {
  variant: Packages.PropTypes.oneOf(["menu"])
};
const GlassTextField = Packages.emotion.styled(GlassTextField$1)(() => {
  const T = Packages.Mui.useTheme();
  return {
    ".MuiInput-root": {
      marginTop: 10,
      color: T.validateMode({
        light: T.colors.neutral[20],
        dark: T.colors.neutral[95]
      }),
      border: `1px solid ${T.validateMode({
        light: T.colors.neutral[20],
        dark: T.colors.neutral[95]
      })}`,
      "&:hover": {
        border: `1px solid ${T.validateMode({
          light: T.colors.neutral[20],
          dark: T.colors.neutral[95]
        })}`
      },
      "&.Mui-focused ": {
        border: `2px solid ${T.colors.blue[60]}`
      },
      ".MuiInputAdornment-root": {
        width: "auto"
      },
      svg: {
        color: T.validateMode({
          light: T.colors.neutral[20],
          dark: T.colors.neutral[95]
        })
      }
    }
  };
}), ItemsContainer = Packages.emotion.styled(Packages.Mui.Box)(() => {
  const T = Packages.Mui.useTheme();
  return {
    height: "35vh",
    overflowY: "auto",
    width: "100%",
    scrollbarWidth: "thin",
    marginTop: 20,
    ".item": {
      width: "100%",
      justifySelf: "center"
    },
    "&::-webkit-scrollbar": {
      width: "6px",
      height: "7px"
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: T.colors.darkBlue[70],
      borderRadius: "8px",
      border: "none",
      boxShadow: "inset 0 0 6px rgba(0, 0, 0, 0.3)"
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: T.colors.darkBlue[40],
      borderRadius: "8px"
    }
  };
}), EntityOptionName = Packages.emotion.styled(Packages.Mui.Box)(() => ({
  flex: 1,
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  overflow: "hidden"
})), EntityOption = ({
  entityRef: T,
  name: S,
  handleEntityClick: R,
  isSelected: k
}) => {
  const {
    Button: D
  } = Packages.Mui;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(D, { ...k && {
    className: "isSelected"
  }, onClick: k ? null : R(T), children: [
    k && /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "check-outlined" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "business" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(EntityOptionName, { children: S }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(IconElement, { name: "chevron-right" })
  ] }, T);
};
EntityOption.propTypes = {
  entityRef: Packages.PropTypes.string.isRequired,
  name: Packages.PropTypes.string.isRequired,
  handleEntityClick: Packages.PropTypes.func.isRequired,
  isSelected: Packages.PropTypes.bool
};
const normalizeText = (T) => T.normalize("NFD").replace(/\p{Diacritic}/gu, "").trim().toLowerCase(), getFilteredDataByProperties = ({
  query: T,
  data: S = [],
  properties: R = []
}) => {
  if (T) {
    const k = normalizeText(T);
    return S.filter((D) => R.some((L) => Object.prototype.hasOwnProperty.call(D, L) && D[L] !== null && typeof D[L] < "u" && normalizeText(D[L]).includes(k)));
  }
  return !S || !S?.length ? [] : S;
}, SearchFilter = ({
  onSearchChange: T,
  value: S,
  disabled: R
}) => {
  const k = Packages.lodash.debounce((L) => {
    T(normalizeText(L));
  }, 200), D = (L) => {
    k(L);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlassTextField, { variant: "search", value: S, disabled: R, token: "component.cai_material.entity_switcher.search", inputProps: {
    maxLength: 50
  }, onChange: D });
};
SearchFilter.propTypes = {
  onSearchChange: Packages.PropTypes.func.isRequired,
  value: Packages.PropTypes.string.isRequired,
  disabled: Packages.PropTypes.bool
};
const dark = (T) => ({
  MuiButton: {
    styleOverrides: {
      root: (S) => {
        const {
          className: R
        } = S.ownerState;
        return {
          fontWeight: T.fontWeightSemiBold,
          fontSize: "clamp(0.875rem, 0.803rem + 0.268vw, 1.125rem)",
          width: "100%",
          height: "100%",
          display: "flex",
          padding: 20,
          borderRadius: 20,
          alingItems: "center",
          gap: 10,
          border: `1px solid ${T.colors.neutral[85]}`,
          background: T.colors.rgba.gray[20],
          textAlign: "left",
          color: T.colors.neutral[90],
          textTransform: "none",
          boxShadow: T.shadow(11),
          ...R === "isSelected" && {
            cursor: "not-allowed"
          },
          "&:hover": {
            background: T.colors.rgba.gray[30]
          }
        };
      }
    }
  },
  MuiSvgIcon: {
    styleOverrides: {
      root: (S) => {
        const {
          "data-testid": R
        } = S;
        return {
          ...R === "CheckOutlinedIcon" && {
            color: T.colors.green[60]
          }
        };
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        maxWidth: "56.5vw",
        borderRadius: 20,
        backdropFilter: "blur(20px)",
        background: T.colors.rgba.gray[20],
        border: `1px solid ${T.colors.neutral[60]}`,
        boxShadow: T.shadow(12),
        margin: "auto",
        width: "100%",
        ...breakpoints.sm(T)
      }
    }
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        margin: "0 0 0 auto",
        height: 20
      }
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: "0px 30px 40px"
      }
    }
  },
  MuiGrid: {
    styleOverrides: {
      root: {
        background: "transparent",
        ".logo-img": {
          width: "60px"
        },
        ".items-wrapper": {
          width: "100%",
          margin: "auto"
        }
      }
    }
  },
  MuiTypography: {
    styleOverrides: {
      root: {
        fontSize: "clamp(1.125rem, 0.673rem + 1.684vw, 1.75rem)",
        fontWeight: T.typography.fontWeightMedium,
        color: T.colors.neutral[100]
      }
    }
  }
}), light = (T) => ({
  MuiButton: {
    styleOverrides: {
      root: (S) => {
        const {
          className: R
        } = S.ownerState;
        return {
          fontWeight: T.fontWeightSemiBold,
          fontSize: "clamp(0.875rem, 0.803rem + 0.268vw, 1.125rem)",
          width: "100%",
          height: "100%",
          display: "flex",
          padding: 20,
          borderRadius: 20,
          alignItems: "center",
          gap: 10,
          border: `1px solid ${T.colors.neutral[85]}`,
          background: T.colors.rgba.white[70],
          textAlign: "left",
          color: T.colors.neutral[40],
          textTransform: "none",
          boxShadow: T.shadow(11),
          ...R === "isSelected" && {
            cursor: "not-allowed"
          },
          "&:hover": {
            background: T.colors.rgba.white[80]
          }
        };
      }
    }
  },
  MuiSvgIcon: {
    styleOverrides: {
      root: (S) => {
        const {
          "data-testid": R
        } = S;
        return {
          ...R === "CheckOutlinedIcon" && {
            color: T.colors.green[60]
          }
        };
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        maxWidth: "56.5vw",
        borderRadius: 20,
        backdropFilter: "blur(10px)",
        background: T.colors.rgba.white[90],
        border: `1px solid ${T.colors.neutral[93]}`,
        boxShadow: T.shadow(12),
        margin: "auto",
        width: "100%",
        ...breakpoints.sm(T)
      }
    }
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        margin: "0 0 0 auto",
        height: 20
      }
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: "0px 30px 40px"
      }
    }
  },
  MuiGrid: {
    styleOverrides: {
      root: {
        background: "transparent",
        ".logo-img": {
          width: "60px"
        },
        ".items-wrapper": {
          width: "100%",
          margin: "auto"
        }
      }
    }
  },
  MuiTypography: {
    styleOverrides: {
      root: {
        fontSize: "clamp(1.125rem, 0.673rem + 1.684vw, 1.75rem)",
        fontWeight: T.typography.fontWeightMedium,
        color: T.colors.neutral[40]
      }
    }
  }
}), lg = () => {
}, md = () => {
}, sm = (T) => ({
  [T.breakpoints.down("sm")]: {
    maxWidth: "100%"
  }
}), xl = () => {
}, xs = () => {
}, breakpoints = {
  lg,
  md,
  sm,
  xl,
  xs
}, EntitySwitcherThemeConfig = {
  dark,
  light
}, BaseEntitySwitcher = ({
  onClose: T = () => {
  },
  open: S,
  currentEntityRef: R,
  appEntities: k = [],
  setEntityRef: D = () => {
  }
}) => {
  const {
    Grid: L,
    Dialog: V,
    DialogContent: z,
    Box: W,
    Typography: U,
    DialogTitle: q
  } = Packages.Mui, {
    IconElement: K
  } = Icons, [Y, J] = useState$1(""), Z = useMemo(() => getFilteredDataByProperties({
    data: k,
    query: Y,
    properties: ["name"]
  }), [k, Y]), X = useMemo(() => {
    const ne = Z?.find((ae) => ae.entityRef === R), oe = Z?.filter((ae) => ae.entityRef !== R);
    return ne ? [ne].concat(oe) : oe;
  }, [Z, R]), ee = () => {
    T();
  }, te = (ne, oe) => {
    oe === "escapeKeyDown" && ee();
  }, re = (ne) => () => {
    D(ne), ee();
  }, Q = !!X.length;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(V, { open: S !== void 0 ? S : !0, onClose: te, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(q, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { variant: "glass-modal-header", onClick: ee, icon: /* @__PURE__ */ jsxRuntimeExports.jsx(K, { name: "clear" }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(z, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(L, { direction: "column", spacing: 3, container: !0, alignItems: "center", justifyContent: "center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(L, { item: !0, justifyContent: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(W, { component: "img", src: caLogoOrange, alt: "Command Alkon Logo", className: "logo-img" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(L, { item: !0, justifyContent: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(U, { variant: "h1", children: "Please select a company" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(L, { container: !0, item: !0, alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsx(L, { item: !0, xs: 12, md: 6, className: "search-filter-wrapper", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchFilter, { onSearchChange: J, value: Y }) }) }),
      Q ? /* @__PURE__ */ jsxRuntimeExports.jsx(ItemsContainer, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(L, { item: !0, container: !0, pb: 4, px: 0.4, spacing: 2, className: "items-wrapper", children: X?.map(({
        entityRef: ne,
        name: oe
      }) => /* @__PURE__ */ jsxRuntimeExports.jsx(L, { item: !0, xs: 12, md: 6, className: "item", children: /* @__PURE__ */ jsxRuntimeExports.jsx(EntityOption, { isSelected: ne === R, entityRef: ne, name: oe, handleEntityClick: re }, ne) }, ne)) }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(EmptyState, { mainText: "component.cai_material.entity_switcher.no_results_found", secondaryText: "component.cai_material.entity_switcher.no_match_company" })
    ] }) })
  ] });
};
BaseEntitySwitcher.propTypes = {
  onClose: Packages.PropTypes.func,
  open: Packages.PropTypes.bool,
  currentEntityRef: Packages.PropTypes.string,
  appEntities: Packages.PropTypes.arrayOf(Packages.PropTypes.shape({
    entityRef: Packages.PropTypes.string.isRequired,
    name: Packages.PropTypes.string.isRequired
  })),
  setEntityRef: Packages.PropTypes.func
};
const EntitySwitcher = withThemeOverrides(BaseEntitySwitcher, EntitySwitcherThemeConfig);
export {
  GlassTextField$1 as $,
  DataDenseGrid as A,
  Tooltip as B,
  CAI_MATERIAL as C,
  DebugComponent as D,
  EmptyState as E,
  Form as F,
  Button as G,
  Checkbox as H,
  Icons as I,
  DateField as J,
  DateRangeField as K,
  LocalizationProvider as L,
  MarkupIcon as M,
  Icon as N,
  InternationalAddress as O,
  getInternationalAddressText as P,
  INTL_ADDRESS_FORMATS as Q,
  LicenseTile as R,
  SyntaxHighlighter2$1 as S,
  TooltipNote as T,
  DateTimeField as U,
  RadioButton as V,
  WithToolTipState as W,
  SelectField as X,
  TextField$1 as Y,
  TimeField as Z,
  PhoneNumberField as _,
  supportedLanguages as a,
  AutocompleteField as a0,
  SegmentedButton as a1,
  Fab as a2,
  ContentActionButton as a3,
  GridForm as a4,
  TimePeriodMenu as a5,
  DynamicTimePeriodMenu as a6,
  Breadcrumbs as a7,
  AppTray as a8,
  ColorPicker as a9,
  EntitySwitcher as aa,
  Layer as ab,
  WithTooltipPure as b,
  createCopyToClipboardFunction as c,
  WithTooltip as d,
  index as e,
  Modal as f,
  getDefaultExportFromCjs as g,
  colors as h,
  index$2 as i,
  elevation as j,
  background as k,
  shadow as l,
  memoize$3 as m,
  newStyled as n,
  withThemeOverrides as o,
  useLocalStorage as p,
  useQueryClient as q,
  useWithBaseField as r,
  syntaxhighlighter_default as s,
  throttle$1 as t,
  useFormHandler as u,
  mixins as v,
  withBaseField as w,
  resources as x,
  getGradientBackground as y,
  darkenGradient as z
};
